export class OpenSeaFakeData {
    public static assets = [
        {
            "id": 25679535,
            "token_id": "37430452933329828009181382969899584352567632449099565656987172367495203913729",
            "num_sales": 0,
            "background_color": null,
            "image_url": "https://lh3.googleusercontent.com/AmNCt_QREwOros5FPXEb2X-1DSQIUecbxjgqCL3jhPa_P540qUooQIM8x0vDiQQj6cUP3aYCWzi9ubJ3qbTf7H5CibUlnFg4cxQ",
            "image_preview_url": "https://lh3.googleusercontent.com/AmNCt_QREwOros5FPXEb2X-1DSQIUecbxjgqCL3jhPa_P540qUooQIM8x0vDiQQj6cUP3aYCWzi9ubJ3qbTf7H5CibUlnFg4cxQ=s250",
            "image_thumbnail_url": "https://lh3.googleusercontent.com/AmNCt_QREwOros5FPXEb2X-1DSQIUecbxjgqCL3jhPa_P540qUooQIM8x0vDiQQj6cUP3aYCWzi9ubJ3qbTf7H5CibUlnFg4cxQ=s128",
            "image_original_url": null,
            "animation_url": null,
            "animation_original_url": null,
            "name": "Pretty Crypto Lady #297",
            "description": null,
            "external_link": null,
            "asset_contract": {
                "address": "0x495f947276749ce646f68ac8c248420045cb7b5e",
                "asset_contract_type": "semi-fungible",
                "created_date": "2020-12-02T17:40:53.232025",
                "name": "OpenSea Collection",
                "nft_version": null,
                "opensea_version": "2.0.0",
                "owner": 102384,
                "schema_name": "ERC1155",
                "symbol": "OPENSTORE",
                "total_supply": null,
                "description": null,
                "external_link": null,
                "image_url": null,
                "default_to_fiat": false,
                "dev_buyer_fee_basis_points": 0,
                "dev_seller_fee_basis_points": 0,
                "only_proxied_transfers": false,
                "opensea_buyer_fee_basis_points": 0,
                "opensea_seller_fee_basis_points": 250,
                "buyer_fee_basis_points": 0,
                "seller_fee_basis_points": 250,
                "payout_address": null
            },
            "owner": {
                "user": {
                    "username": "NullAddress"
                },
                "profile_img_url": "https://storage.googleapis.com/opensea-static/opensea-profile/1.png",
                "address": "0x0000000000000000000000000000000000000000",
                "config": "",
                "discord_id": ""
            },
            "permalink": "https://opensea.io/assets/0x495f947276749ce646f68ac8c248420045cb7b5e/37430452933329828009181382969899584352567632449099565656987172367495203913729",
            "collection": {
                "banner_image_url": null,
                "chat_url": null,
                "created_date": "2021-04-27T21:07:28.954779",
                "default_to_fiat": false,
                "description": "All these photos are made by a neural network. So it is not real people. They never exist.\nEvery picture is unique. It could be similar but never the same.\n***Any coincidence with real people, organizations, and events is accidental***\n\nMaybe in the future, when we would be able to order human similar robots you will need to choose their face.\nSo if you will be the owner of some of these NFTs, your robots will have inimitable faces.",
                "dev_buyer_fee_basis_points": "0",
                "dev_seller_fee_basis_points": "500",
                "discord_url": null,
                "display_data": {
                    "card_display_style": "cover"
                },
                "external_url": null,
                "featured": false,
                "featured_image_url": null,
                "hidden": true,
                "safelist_request_status": "not_requested",
                "image_url": "https://lh3.googleusercontent.com/abZyjia1IXPU0RXnS3h-NjGwg1biSIZxF3va_RlR-m2ymdQlFGQiBETQ2kYoQP6JCxuqZKYJLpbTETlkMSoNLNvlNDJ_9kkFfIinQA=s120",
                "is_subject_to_whitelist": false,
                "large_image_url": null,
                "medium_username": null,
                "name": "Pretty Crypto Ladies",
                "only_proxied_transfers": false,
                "opensea_buyer_fee_basis_points": "0",
                "opensea_seller_fee_basis_points": "250",
                "payout_address": "0x52c0e2b66ee82ea1c4dcf66f37fb69926ce864ca",
                "require_email": false,
                "short_description": null,
                "slug": "pretty-crypto-ladies",
                "telegram_url": null,
                "twitter_username": null,
                "instagram_username": null,
                "wiki_url": null
            },
            "decimals": null,
            "token_metadata": null,
            "sell_orders": null,
            "creator": {
                "user": {
                    "username": "Antilames"
                },
                "profile_img_url": "https://storage.googleapis.com/opensea-static/opensea-profile/30.png",
                "address": "0x52c0e2b66ee82ea1c4dcf66f37fb69926ce864ca",
                "config": "",
                "discord_id": ""
            },
            "traits": [],
            "last_sale": null,
            "top_bid": null,
            "listing_date": null,
            "is_presale": true,
            "transfer_fee_payment_token": null,
            "transfer_fee": null
        },
        {
            "id": 25679534,
            "token_id": "67154617034340034456453366385792604942607367955217100128958461001233768382465",
            "num_sales": 0,
            "background_color": null,
            "image_url": "https://lh3.googleusercontent.com/LVSQqsI_RccHE8r6CKW01LYMJ0XlSjUKnsW_JRg1DscNhAKmLg7UrlCElJXWdrUCKwVBFds1jvm58cYwCcC_P0Ew-UjuPxIeUrhk1wQ",
            "image_preview_url": "https://lh3.googleusercontent.com/LVSQqsI_RccHE8r6CKW01LYMJ0XlSjUKnsW_JRg1DscNhAKmLg7UrlCElJXWdrUCKwVBFds1jvm58cYwCcC_P0Ew-UjuPxIeUrhk1wQ=s250",
            "image_thumbnail_url": "https://lh3.googleusercontent.com/LVSQqsI_RccHE8r6CKW01LYMJ0XlSjUKnsW_JRg1DscNhAKmLg7UrlCElJXWdrUCKwVBFds1jvm58cYwCcC_P0Ew-UjuPxIeUrhk1wQ=s128",
            "image_original_url": null,
            "animation_url": null,
            "animation_original_url": null,
            "name": "[TreeR]Falling cherry blossoms #3447",
            "description": "Python turtle draw it.\n\n# 3447 // 719  x  608  px  \n\nFalling cherry blossoms year, you and I met at this moment, hand-yu, like the subtle, ethereal handsome, sophisticated atmosphere, walking in between the cloud water.",
            "external_link": null,
            "asset_contract": {
                "address": "0x495f947276749ce646f68ac8c248420045cb7b5e",
                "asset_contract_type": "semi-fungible",
                "created_date": "2020-12-02T17:40:53.232025",
                "name": "OpenSea Collection",
                "nft_version": null,
                "opensea_version": "2.0.0",
                "owner": 102384,
                "schema_name": "ERC1155",
                "symbol": "OPENSTORE",
                "total_supply": null,
                "description": null,
                "external_link": null,
                "image_url": null,
                "default_to_fiat": false,
                "dev_buyer_fee_basis_points": 0,
                "dev_seller_fee_basis_points": 0,
                "only_proxied_transfers": false,
                "opensea_buyer_fee_basis_points": 0,
                "opensea_seller_fee_basis_points": 250,
                "buyer_fee_basis_points": 0,
                "seller_fee_basis_points": 250,
                "payout_address": null
            },
            "owner": {
                "user": {
                    "username": "NullAddress"
                },
                "profile_img_url": "https://storage.googleapis.com/opensea-static/opensea-profile/1.png",
                "address": "0x0000000000000000000000000000000000000000",
                "config": "",
                "discord_id": ""
            },
            "permalink": "https://opensea.io/assets/0x495f947276749ce646f68ac8c248420045cb7b5e/67154617034340034456453366385792604942607367955217100128958461001233768382465",
            "collection": {
                "banner_image_url": "https://lh3.googleusercontent.com/qAFj1m1OoChD4FcSkSXO0mAQNTCtsDRm1bJu-JLukcZeYU7Zl7KPZsINaBIXBR0STnpSlWsCnjLKtc18eyQo43VhqBi8IPGYJREXjw=s2500",
                "chat_url": null,
                "created_date": "2021-05-22T10:06:08.879127",
                "default_to_fiat": false,
                "description": "Falling cherry blossoms year, you and I met at this moment, hand-yu, like the subtle, ethereal handsome, sophisticated atmosphere, walking in between the cloud water.\n\nPython turtle draw it.",
                "dev_buyer_fee_basis_points": "0",
                "dev_seller_fee_basis_points": "10",
                "discord_url": null,
                "display_data": {
                    "card_display_style": "contain"
                },
                "external_url": null,
                "featured": false,
                "featured_image_url": "https://lh3.googleusercontent.com/yoTPXDtQkkedgY-eHS1c35-CHvY6MiN5FE0fQP3_8LCPV7U3JVLOZliTYqmAxPDPojshQz71dohZZ8LJUCsnxeXEC3u3iTWxPlHhDQ=s300",
                "hidden": true,
                "safelist_request_status": "not_requested",
                "image_url": "https://lh3.googleusercontent.com/NIpY--fl9ykQGtK7l1eeAyQGTcv7Xc83ADkrQVx7Ko32oPvTaup5W6GTwh_jG1yjTweNqC0Zzby5VmIKZ4ZXPaqahWxMtWXnt3PmSA=s120",
                "is_subject_to_whitelist": false,
                "large_image_url": "https://lh3.googleusercontent.com/yoTPXDtQkkedgY-eHS1c35-CHvY6MiN5FE0fQP3_8LCPV7U3JVLOZliTYqmAxPDPojshQz71dohZZ8LJUCsnxeXEC3u3iTWxPlHhDQ=s300",
                "medium_username": null,
                "name": "[TreeR]Falling cherry blossoms",
                "only_proxied_transfers": false,
                "opensea_buyer_fee_basis_points": "0",
                "opensea_seller_fee_basis_points": "250",
                "payout_address": "0x94782a9182217af5861735ba5a2ea1ed8204a08c",
                "require_email": false,
                "short_description": null,
                "slug": "treer-falling-cherry-blossoms",
                "telegram_url": null,
                "twitter_username": null,
                "instagram_username": null,
                "wiki_url": null
            },
            "decimals": null,
            "token_metadata": null,
            "sell_orders": null,
            "creator": {
                "user": {
                    "username": "Suqingyan"
                },
                "profile_img_url": "https://storage.googleapis.com/opensea-static/opensea-profile/25.png",
                "address": "0x94782a9182217af5861735ba5a2ea1ed8204a08c",
                "config": "",
                "discord_id": ""
            },
            "traits": [
                {
                    "trait_type": "Material",
                    "value": "Tree",
                    "display_type": null,
                    "max_value": null,
                    "trait_count": 3456,
                    "order": null
                }
            ],
            "last_sale": null,
            "top_bid": null,
            "listing_date": null,
            "is_presale": true,
            "transfer_fee_payment_token": null,
            "transfer_fee": null
        },
        {
            "id": 25679533,
            "token_id": "1029473",
            "num_sales": 0,
            "background_color": null,
            "image_url": "https://lh3.googleusercontent.com/P6eqlhFlMHtpURsNDrxPdq2Q3yZFH4D_WPyGZHP7ELcrptkrWRnkQC0sHOa7I3WVy2jBE8szQay2udVZSGuVSNKi_x0KzIG9Nn59",
            "image_preview_url": "https://lh3.googleusercontent.com/P6eqlhFlMHtpURsNDrxPdq2Q3yZFH4D_WPyGZHP7ELcrptkrWRnkQC0sHOa7I3WVy2jBE8szQay2udVZSGuVSNKi_x0KzIG9Nn59=s250",
            "image_thumbnail_url": "https://lh3.googleusercontent.com/P6eqlhFlMHtpURsNDrxPdq2Q3yZFH4D_WPyGZHP7ELcrptkrWRnkQC0sHOa7I3WVy2jBE8szQay2udVZSGuVSNKi_x0KzIG9Nn59=s128",
            "image_original_url": "https://ipfs.io/ipfs/QmeCBUFZCfNTvhTirjDQBqh79yCqvi63ARZndWVn8twanb/image.jpeg",
            "animation_url": null,
            "animation_original_url": null,
            "name": "Navana",
            "description": null,
            "external_link": "https://rarible.com/token/0x60f80121c31a0d46b5279700f9df786054aa5ee5:1029473",
            "asset_contract": {
                "address": "0x60f80121c31a0d46b5279700f9df786054aa5ee5",
                "asset_contract_type": "non-fungible",
                "created_date": "2020-05-27T17:06:50.488471",
                "name": "Rarible V2",
                "nft_version": "3.0",
                "opensea_version": null,
                "owner": 1634963,
                "schema_name": "ERC721",
                "symbol": "",
                "total_supply": "1",
                "description": "Create and sell digital collectibles secured with blockchain technology. Rarible is home to thousands of artists and collectors, creating and exchanging immutable art without using code. Trade with RARI token on OpenSea.",
                "external_link": "https://rarible.com/",
                "image_url": "https://lh3.googleusercontent.com/FG0QJ00fN3c_FWuPeUr9-T__iQl63j9hn5d6svW8UqOmia5zp3lKHPkJuHcvhZ0f_Pd6P2COo9tt9zVUvdPxG_9BBw=s60",
                "default_to_fiat": false,
                "dev_buyer_fee_basis_points": 0,
                "dev_seller_fee_basis_points": 0,
                "only_proxied_transfers": false,
                "opensea_buyer_fee_basis_points": 0,
                "opensea_seller_fee_basis_points": 250,
                "buyer_fee_basis_points": 0,
                "seller_fee_basis_points": 250,
                "payout_address": null
            },
            "owner": {
                "user": {
                    "username": "Rami777"
                },
                "profile_img_url": "https://storage.googleapis.com/opensea-static/opensea-profile/33.png",
                "address": "0xb2fbcbcce63e40e659f18c48b135fee1bae4204b",
                "config": "",
                "discord_id": ""
            },
            "permalink": "https://opensea.io/assets/0x60f80121c31a0d46b5279700f9df786054aa5ee5/1029473",
            "collection": {
                "banner_image_url": "https://storage.opensea.io/static/banners/rarible-banner4.png",
                "chat_url": null,
                "created_date": "2020-01-01T13:22:57.777065",
                "default_to_fiat": false,
                "description": "Create and sell digital collectibles secured with blockchain technology. Rarible is home to thousands of artists and collectors, creating and exchanging immutable art without using code. Trade with RARI token on OpenSea.",
                "dev_buyer_fee_basis_points": "0",
                "dev_seller_fee_basis_points": "0",
                "discord_url": null,
                "display_data": {
                    "card_display_style": "contain"
                },
                "external_url": "https://rarible.com/",
                "featured": false,
                "featured_image_url": null,
                "hidden": false,
                "safelist_request_status": "verified",
                "image_url": "https://lh3.googleusercontent.com/FG0QJ00fN3c_FWuPeUr9-T__iQl63j9hn5d6svW8UqOmia5zp3lKHPkJuHcvhZ0f_Pd6P2COo9tt9zVUvdPxG_9BBw=s60",
                "is_subject_to_whitelist": false,
                "large_image_url": "https://lh3.googleusercontent.com/FG0QJ00fN3c_FWuPeUr9-T__iQl63j9hn5d6svW8UqOmia5zp3lKHPkJuHcvhZ0f_Pd6P2COo9tt9zVUvdPxG_9BBw",
                "medium_username": "rarible",
                "name": "Rarible",
                "only_proxied_transfers": false,
                "opensea_buyer_fee_basis_points": "0",
                "opensea_seller_fee_basis_points": "250",
                "payout_address": null,
                "require_email": false,
                "short_description": null,
                "slug": "rarible",
                "telegram_url": "https://t.me/rarible",
                "twitter_username": "rariblecom",
                "instagram_username": null,
                "wiki_url": null
            },
            "decimals": 0,
            "token_metadata": "https://ipfs.io/ipfs/QmcEYJ6otCuCsnB3eeh2RzRQLS45TinctiogGTBGDt4HZz",
            "sell_orders": null,
            "creator": {
                "user": {
                    "username": "Rami777"
                },
                "profile_img_url": "https://storage.googleapis.com/opensea-static/opensea-profile/33.png",
                "address": "0xb2fbcbcce63e40e659f18c48b135fee1bae4204b",
                "config": "",
                "discord_id": ""
            },
            "traits": [],
            "last_sale": null,
            "top_bid": null,
            "listing_date": null,
            "is_presale": false,
            "transfer_fee_payment_token": null,
            "transfer_fee": null
        },
        {
            "id": 25679532,
            "token_id": "2843427144",
            "num_sales": 0,
            "background_color": "ffffff",
            "image_url": "https://lh3.googleusercontent.com/THyaxe3e_Q9ETat6dOSdVtgYPfezqluH6-lKlyVJetMHQ_JrSwnyuxUsrzE3KYJNRubZTJ7ZXx8UnjtD45QpaN-a6LvIIEVfPrP0",
            "image_preview_url": "https://lh3.googleusercontent.com/THyaxe3e_Q9ETat6dOSdVtgYPfezqluH6-lKlyVJetMHQ_JrSwnyuxUsrzE3KYJNRubZTJ7ZXx8UnjtD45QpaN-a6LvIIEVfPrP0=s250",
            "image_thumbnail_url": "https://lh3.googleusercontent.com/THyaxe3e_Q9ETat6dOSdVtgYPfezqluH6-lKlyVJetMHQ_JrSwnyuxUsrzE3KYJNRubZTJ7ZXx8UnjtD45QpaN-a6LvIIEVfPrP0=s128",
            "image_original_url": "https://cdn.krafter.space/0xa97b4148123.jpg",
            "animation_url": null,
            "animation_original_url": null,
            "name": "untitle",
            "description": "untitle",
            "external_link": null,
            "asset_contract": {
                "address": "0x9faccd9f9661dddec3971c1ee146516127c34fc1",
                "asset_contract_type": "non-fungible",
                "created_date": "2021-05-24T03:32:34.283969",
                "name": "KRAFTERSPACE",
                "nft_version": null,
                "opensea_version": null,
                "owner": null,
                "schema_name": "ERC721",
                "symbol": "KS",
                "total_supply": "1",
                "description": null,
                "external_link": null,
                "image_url": null,
                "default_to_fiat": false,
                "dev_buyer_fee_basis_points": 0,
                "dev_seller_fee_basis_points": 0,
                "only_proxied_transfers": false,
                "opensea_buyer_fee_basis_points": 0,
                "opensea_seller_fee_basis_points": 250,
                "buyer_fee_basis_points": 0,
                "seller_fee_basis_points": 250,
                "payout_address": null
            },
            "owner": {
                "user": null,
                "profile_img_url": "https://storage.googleapis.com/opensea-static/opensea-profile/1.png",
                "address": "0x0000000000000000000000000000000000000000",
                "config": "",
                "discord_id": ""
            },
            "permalink": "https://opensea.io/assets/klaytn/0x9faccd9f9661dddec3971c1ee146516127c34fc1/2843427144",
            "collection": {
                "banner_image_url": null,
                "chat_url": null,
                "created_date": "2021-05-24T03:32:34.767460",
                "default_to_fiat": false,
                "description": null,
                "dev_buyer_fee_basis_points": "0",
                "dev_seller_fee_basis_points": "0",
                "discord_url": null,
                "display_data": {
                    "card_display_style": "contain",
                    "images": []
                },
                "external_url": null,
                "featured": false,
                "featured_image_url": null,
                "hidden": true,
                "safelist_request_status": "not_requested",
                "image_url": null,
                "is_subject_to_whitelist": false,
                "large_image_url": null,
                "medium_username": null,
                "name": "KRAFTERSPACE",
                "only_proxied_transfers": false,
                "opensea_buyer_fee_basis_points": "0",
                "opensea_seller_fee_basis_points": "250",
                "payout_address": null,
                "require_email": false,
                "short_description": null,
                "slug": "krafterspace",
                "telegram_url": null,
                "twitter_username": null,
                "instagram_username": null,
                "wiki_url": null
            },
            "decimals": null,
            "token_metadata": "https://cdn.krafter.space/0xa97b4148.json",
            "sell_orders": null,
            "creator": null,
            "traits": [],
            "last_sale": null,
            "top_bid": null,
            "listing_date": null,
            "is_presale": false,
            "transfer_fee_payment_token": null,
            "transfer_fee": null
        },
        {
            "id": 25679531,
            "token_id": "79228162588051876838336082730",
            "num_sales": 0,
            "background_color": null,
            "image_url": "https://lh3.googleusercontent.com/26hvZV1bmBS_iM1M3u2-hjUVDyec_caPrIoDhsbmlmIxvrkm8UJF_Pp09fwS26Z-4xRqq_THBPpVxX4fBCgFFPs",
            "image_preview_url": "https://lh3.googleusercontent.com/26hvZV1bmBS_iM1M3u2-hjUVDyec_caPrIoDhsbmlmIxvrkm8UJF_Pp09fwS26Z-4xRqq_THBPpVxX4fBCgFFPs=s250",
            "image_thumbnail_url": "https://lh3.googleusercontent.com/26hvZV1bmBS_iM1M3u2-hjUVDyec_caPrIoDhsbmlmIxvrkm8UJF_Pp09fwS26Z-4xRqq_THBPpVxX4fBCgFFPs=s128",
            "image_original_url": "https://neon-district-season-one.s3.amazonaws.com/images/ghost-male-thumb.png",
            "animation_url": null,
            "animation_original_url": null,
            "name": "Ghost",
            "description": "Ghosts are assassins and infiltrators. They can cloud/alter the perceptions of others.\n\nA Neon District: Season One game item, playable on https://portal.neondistrict.io.\n\nNeon District is a free-to-play cyberpunk role-playing game. Collect characters and gear, craft and level up teams, and battle against other players through competitive multiplayer and in turn-based combat.",
            "external_link": "https://portal.neondistrict.io/asset/79228162588051876838336082730",
            "asset_contract": {
                "address": "0x7227e371540cf7b8e512544ba6871472031f3335",
                "asset_contract_type": "non-fungible",
                "created_date": "2021-01-04T17:12:08.151181",
                "name": "Neon District Season One Item",
                "nft_version": null,
                "opensea_version": null,
                "owner": 17710883,
                "schema_name": "ERC721",
                "symbol": "NDITEM1",
                "total_supply": "475982",
                "description": "Neon District is a free-to-play cyberpunk role-playing game featuring collectible NFTs on Matic and Ethereum. Players collect characters and gear, craft and level up fully-equipped teams, and battle their teams against other players through the Neon Pizza competitive multiplayer missions or in real-time turn-based combat.",
                "external_link": null,
                "image_url": "https://lh3.googleusercontent.com/xttZf6L3I16h7HSgcfKFWhR7OhCdSO5UW_asXbRfGmQ7-a0QwJRNoPsmh_RlOpw-AFEngLqGYLD77cmjdBv4LCfVc5BxFG2PS1UU=s120",
                "default_to_fiat": false,
                "dev_buyer_fee_basis_points": 0,
                "dev_seller_fee_basis_points": 500,
                "only_proxied_transfers": false,
                "opensea_buyer_fee_basis_points": 0,
                "opensea_seller_fee_basis_points": 250,
                "buyer_fee_basis_points": 0,
                "seller_fee_basis_points": 750,
                "payout_address": "0x08262c33e987ed580b69d8f93134e987f881bdcc"
            },
            "owner": {
                "user": null,
                "profile_img_url": "https://storage.googleapis.com/opensea-static/opensea-profile/1.png",
                "address": "0x0000000000000000000000000000000000000000",
                "config": "",
                "discord_id": ""
            },
            "permalink": "https://opensea.io/assets/matic/0x7227e371540cf7b8e512544ba6871472031f3335/79228162588051876838336082730",
            "collection": {
                "banner_image_url": "https://lh3.googleusercontent.com/vtZXDR51ibkUx6v2XRf3imqsL-bUzy7tALBcjrwx0fNJywcMCqK_bVIfrvdlKQ5sysboHA23kGiwbgsGb5c_6ROGsyzc-SZURrtqRA=s2500",
                "chat_url": null,
                "created_date": "2021-01-04T17:12:08.305423",
                "default_to_fiat": false,
                "description": "Neon District is a free-to-play cyberpunk role-playing game featuring collectible NFTs on Matic and Ethereum. Players collect characters and gear, craft and level up fully-equipped teams, and battle their teams against other players through the Neon Pizza competitive multiplayer missions or in real-time turn-based combat.",
                "dev_buyer_fee_basis_points": "0",
                "dev_seller_fee_basis_points": "500",
                "discord_url": "https://discord.gg/ERu7Zw9YwZ",
                "display_data": {
                    "card_display_style": "contain"
                },
                "external_url": null,
                "featured": false,
                "featured_image_url": "https://lh3.googleusercontent.com/vtZXDR51ibkUx6v2XRf3imqsL-bUzy7tALBcjrwx0fNJywcMCqK_bVIfrvdlKQ5sysboHA23kGiwbgsGb5c_6ROGsyzc-SZURrtqRA=s300",
                "hidden": false,
                "safelist_request_status": "approved",
                "image_url": "https://lh3.googleusercontent.com/xttZf6L3I16h7HSgcfKFWhR7OhCdSO5UW_asXbRfGmQ7-a0QwJRNoPsmh_RlOpw-AFEngLqGYLD77cmjdBv4LCfVc5BxFG2PS1UU=s120",
                "is_subject_to_whitelist": false,
                "large_image_url": "https://lh3.googleusercontent.com/vtZXDR51ibkUx6v2XRf3imqsL-bUzy7tALBcjrwx0fNJywcMCqK_bVIfrvdlKQ5sysboHA23kGiwbgsGb5c_6ROGsyzc-SZURrtqRA=s300",
                "medium_username": "blockadegames",
                "name": "Neon District Season One Item",
                "only_proxied_transfers": false,
                "opensea_buyer_fee_basis_points": "0",
                "opensea_seller_fee_basis_points": "250",
                "payout_address": "0x08262c33e987ed580b69d8f93134e987f881bdcc",
                "require_email": false,
                "short_description": null,
                "slug": "neon-district-season-one-item",
                "telegram_url": null,
                "twitter_username": "neondistrictrpg",
                "instagram_username": null,
                "wiki_url": null
            },
            "decimals": null,
            "token_metadata": "https://portal.neondistrict.io/api/getNft/79228162588051876838336082730",
            "sell_orders": null,
            "creator": null,
            "traits": [
                {
                    "trait_type": "Card",
                    "value": "Stultify",
                    "display_type": null,
                    "max_value": null,
                    "trait_count": 19068,
                    "order": null
                },
                {
                    "trait_type": "Card",
                    "value": "Just a Taste",
                    "display_type": null,
                    "max_value": null,
                    "trait_count": 19130,
                    "order": null
                },
                {
                    "trait_type": "Card",
                    "value": "Blur",
                    "display_type": null,
                    "max_value": null,
                    "trait_count": 19105,
                    "order": null
                },
                {
                    "trait_type": "Card",
                    "value": "Distract",
                    "display_type": null,
                    "max_value": null,
                    "trait_count": 19093,
                    "order": null
                },
                {
                    "trait_type": "type",
                    "value": "Character",
                    "display_type": null,
                    "max_value": null,
                    "trait_count": 78723,
                    "order": null
                },
                {
                    "trait_type": "rarity",
                    "value": "Common",
                    "display_type": null,
                    "max_value": null,
                    "trait_count": 220672,
                    "order": null
                },
                {
                    "trait_type": "level",
                    "value": 1,
                    "display_type": null,
                    "max_value": null,
                    "trait_count": 0,
                    "order": null
                },
                {
                    "trait_type": "Season",
                    "value": 1,
                    "display_type": "number",
                    "max_value": null,
                    "trait_count": 0,
                    "order": null
                },
                {
                    "trait_type": "Mech",
                    "value": 15,
                    "display_type": "boost_number",
                    "max_value": null,
                    "trait_count": 0,
                    "order": null
                },
                {
                    "trait_type": "Nano",
                    "value": 15,
                    "display_type": "boost_number",
                    "max_value": null,
                    "trait_count": 0,
                    "order": null
                },
                {
                    "trait_type": "Attack",
                    "value": 50,
                    "display_type": "boost_number",
                    "max_value": null,
                    "trait_count": 0,
                    "order": null
                },
                {
                    "trait_type": "Health",
                    "value": 500,
                    "display_type": "boost_number",
                    "max_value": null,
                    "trait_count": 0,
                    "order": null
                },
                {
                    "trait_type": "Defense",
                    "value": 35,
                    "display_type": "boost_number",
                    "max_value": null,
                    "trait_count": 0,
                    "order": null
                },
                {
                    "trait_type": "Hacking",
                    "value": 15,
                    "display_type": "boost_number",
                    "max_value": null,
                    "trait_count": 0,
                    "order": null
                },
                {
                    "trait_type": "Stealth",
                    "value": 50,
                    "display_type": "boost_number",
                    "max_value": null,
                    "trait_count": 0,
                    "order": null
                },
                {
                    "trait_type": "Tactics",
                    "value": 15,
                    "display_type": "boost_number",
                    "max_value": null,
                    "trait_count": 0,
                    "order": null
                }
            ],
            "last_sale": null,
            "top_bid": null,
            "listing_date": null,
            "is_presale": false,
            "transfer_fee_payment_token": null,
            "transfer_fee": null
        },
        {
            "id": 25679530,
            "token_id": "37430452933329828009181382969899584352567632449099565656987172366395692285953",
            "num_sales": 0,
            "background_color": null,
            "image_url": "https://lh3.googleusercontent.com/O4IDWhnqfnLKvbGcQskEPsjowb2E7sXiIE6DsVdMct5rp_p8GchjvsfXOquOq5LsFPZSkVMDqt51mYxwrEIRuldxny7fZSBi7ze6VE8",
            "image_preview_url": "https://lh3.googleusercontent.com/O4IDWhnqfnLKvbGcQskEPsjowb2E7sXiIE6DsVdMct5rp_p8GchjvsfXOquOq5LsFPZSkVMDqt51mYxwrEIRuldxny7fZSBi7ze6VE8=s250",
            "image_thumbnail_url": "https://lh3.googleusercontent.com/O4IDWhnqfnLKvbGcQskEPsjowb2E7sXiIE6DsVdMct5rp_p8GchjvsfXOquOq5LsFPZSkVMDqt51mYxwrEIRuldxny7fZSBi7ze6VE8=s128",
            "image_original_url": null,
            "animation_url": null,
            "animation_original_url": null,
            "name": "Pretty Crypto Lady #296",
            "description": null,
            "external_link": null,
            "asset_contract": {
                "address": "0x495f947276749ce646f68ac8c248420045cb7b5e",
                "asset_contract_type": "semi-fungible",
                "created_date": "2020-12-02T17:40:53.232025",
                "name": "OpenSea Collection",
                "nft_version": null,
                "opensea_version": "2.0.0",
                "owner": 102384,
                "schema_name": "ERC1155",
                "symbol": "OPENSTORE",
                "total_supply": null,
                "description": null,
                "external_link": null,
                "image_url": null,
                "default_to_fiat": false,
                "dev_buyer_fee_basis_points": 0,
                "dev_seller_fee_basis_points": 0,
                "only_proxied_transfers": false,
                "opensea_buyer_fee_basis_points": 0,
                "opensea_seller_fee_basis_points": 250,
                "buyer_fee_basis_points": 0,
                "seller_fee_basis_points": 250,
                "payout_address": null
            },
            "owner": {
                "user": {
                    "username": "NullAddress"
                },
                "profile_img_url": "https://storage.googleapis.com/opensea-static/opensea-profile/1.png",
                "address": "0x0000000000000000000000000000000000000000",
                "config": "",
                "discord_id": ""
            },
            "permalink": "https://opensea.io/assets/0x495f947276749ce646f68ac8c248420045cb7b5e/37430452933329828009181382969899584352567632449099565656987172366395692285953",
            "collection": {
                "banner_image_url": null,
                "chat_url": null,
                "created_date": "2021-04-27T21:07:28.954779",
                "default_to_fiat": false,
                "description": "All these photos are made by a neural network. So it is not real people. They never exist.\nEvery picture is unique. It could be similar but never the same.\n***Any coincidence with real people, organizations, and events is accidental***\n\nMaybe in the future, when we would be able to order human similar robots you will need to choose their face.\nSo if you will be the owner of some of these NFTs, your robots will have inimitable faces.",
                "dev_buyer_fee_basis_points": "0",
                "dev_seller_fee_basis_points": "500",
                "discord_url": null,
                "display_data": {
                    "card_display_style": "cover"
                },
                "external_url": null,
                "featured": false,
                "featured_image_url": null,
                "hidden": true,
                "safelist_request_status": "not_requested",
                "image_url": "https://lh3.googleusercontent.com/abZyjia1IXPU0RXnS3h-NjGwg1biSIZxF3va_RlR-m2ymdQlFGQiBETQ2kYoQP6JCxuqZKYJLpbTETlkMSoNLNvlNDJ_9kkFfIinQA=s120",
                "is_subject_to_whitelist": false,
                "large_image_url": null,
                "medium_username": null,
                "name": "Pretty Crypto Ladies",
                "only_proxied_transfers": false,
                "opensea_buyer_fee_basis_points": "0",
                "opensea_seller_fee_basis_points": "250",
                "payout_address": "0x52c0e2b66ee82ea1c4dcf66f37fb69926ce864ca",
                "require_email": false,
                "short_description": null,
                "slug": "pretty-crypto-ladies",
                "telegram_url": null,
                "twitter_username": null,
                "instagram_username": null,
                "wiki_url": null
            },
            "decimals": null,
            "token_metadata": null,
            "sell_orders": [
                {
                    "created_date": "2021-05-26T07:37:49.070677",
                    "closing_date": null,
                    "closing_extendable": false,
                    "expiration_time": 0,
                    "listing_time": 1622014563,
                    "order_hash": "0xd85d29f84d378698e7778a6ffe707fb8e9ea01664ba8ba028b355db0ff98421c",
                    "metadata": {
                        "asset": {
                            "id": "37430452933329828009181382969899584352567632449099565656987172366395692285953",
                            "address": "0x495f947276749ce646f68ac8c248420045cb7b5e",
                            "quantity": "1"
                        },
                        "schema": "ERC1155"
                    },
                    "exchange": "0x7be8076f4ea4a4ad08075c2508e481d6c946d12b",
                    "maker": {
                        "user": 251494,
                        "profile_img_url": "https://storage.googleapis.com/opensea-static/opensea-profile/30.png",
                        "address": "0x52c0e2b66ee82ea1c4dcf66f37fb69926ce864ca",
                        "config": "",
                        "discord_id": ""
                    },
                    "taker": {
                        "user": 1766,
                        "profile_img_url": "https://storage.googleapis.com/opensea-static/opensea-profile/1.png",
                        "address": "0x0000000000000000000000000000000000000000",
                        "config": "",
                        "discord_id": ""
                    },
                    "current_price": "100000000000000000",
                    "current_bounty": "1000000000000000",
                    "bounty_multiple": "0.01",
                    "maker_relayer_fee": "750",
                    "taker_relayer_fee": "0",
                    "maker_protocol_fee": "0",
                    "taker_protocol_fee": "0",
                    "maker_referrer_fee": "0",
                    "fee_recipient": {
                        "user": 3585,
                        "profile_img_url": "https://storage.googleapis.com/opensea-static/opensea-profile/28.png",
                        "address": "0x5b3256965e7c3cf26e11fcaf296dfc8807c01073",
                        "config": "verified",
                        "discord_id": ""
                    },
                    "fee_method": 1,
                    "side": 1,
                    "sale_kind": 0,
                    "target": "0x495f947276749ce646f68ac8c248420045cb7b5e",
                    "how_to_call": 0,
                    "calldata": "0xf242432a00000000000000000000000052c0e2b66ee82ea1c4dcf66f37fb69926ce864ca000000000000000000000000000000000000000000000000000000000000000052c0e2b66ee82ea1c4dcf66f37fb69926ce864ca000000000001350000000001000000000000000000000000000000000000000000000000000000000000000100000000000000000000000000000000000000000000000000000000000000a00000000000000000000000000000000000000000000000000000000000000000",
                    "replacement_pattern": "0x000000000000000000000000000000000000000000000000000000000000000000000000ffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffff0000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000",
                    "static_target": "0x0000000000000000000000000000000000000000",
                    "static_extradata": "0x",
                    "payment_token": "0x0000000000000000000000000000000000000000",
                    "payment_token_contract": {
                        "id": 1,
                        "symbol": "ETH",
                        "address": "0x0000000000000000000000000000000000000000",
                        "image_url": "https://storage.opensea.io/files/6f8e2979d428180222796ff4a33ab929.svg",
                        "name": "Ether",
                        "decimals": 18,
                        "eth_price": "1.000000000000000",
                        "usd_price": "2869.690000000000055000"
                    },
                    "base_price": "100000000000000000",
                    "extra": "0",
                    "quantity": "1",
                    "salt": "73843671066904749346812480268647119777162880467306831206772231981652224680509",
                    "v": 27,
                    "r": "0x0abb3d89a9f63fbfb28661e342906107c565a02abd90c6af45d9411707bdf2a4",
                    "s": "0x5f996ef64febe665d300f341500c3638158b7c465f6256f78f91de2723c41f93",
                    "approved_on_chain": false,
                    "cancelled": false,
                    "finalized": false,
                    "marked_invalid": false,
                    "prefixed_hash": "0xf0c5e7e2ce7873196abb286d0a706393db025d22216d25ec5611c1e4af053db5"
                }
            ],
            "creator": {
                "user": {
                    "username": "Antilames"
                },
                "profile_img_url": "https://storage.googleapis.com/opensea-static/opensea-profile/30.png",
                "address": "0x52c0e2b66ee82ea1c4dcf66f37fb69926ce864ca",
                "config": "",
                "discord_id": ""
            },
            "traits": [],
            "last_sale": null,
            "top_bid": null,
            "listing_date": null,
            "is_presale": true,
            "transfer_fee_payment_token": null,
            "transfer_fee": null
        },
        {
            "id": 25679529,
            "token_id": "32496007455968698945925048330076372926450965754552901123188466506912531218433",
            "num_sales": 0,
            "background_color": null,
            "image_url": "https://lh3.googleusercontent.com/6qKz5Haf5Jdb3zzZTC7_2Hui7ghfZ1G0HX2xVakuugclmoJLjCpkHrUONMiMCk4Gmh1u_MjjeBeN1l8lJU8Z13dlr5XS-zID4vqDNME",
            "image_preview_url": "https://lh3.googleusercontent.com/6qKz5Haf5Jdb3zzZTC7_2Hui7ghfZ1G0HX2xVakuugclmoJLjCpkHrUONMiMCk4Gmh1u_MjjeBeN1l8lJU8Z13dlr5XS-zID4vqDNME=s250",
            "image_thumbnail_url": "https://lh3.googleusercontent.com/6qKz5Haf5Jdb3zzZTC7_2Hui7ghfZ1G0HX2xVakuugclmoJLjCpkHrUONMiMCk4Gmh1u_MjjeBeN1l8lJU8Z13dlr5XS-zID4vqDNME=s128",
            "image_original_url": null,
            "animation_url": null,
            "animation_original_url": null,
            "name": "The leader",
            "description": null,
            "external_link": null,
            "asset_contract": {
                "address": "0x495f947276749ce646f68ac8c248420045cb7b5e",
                "asset_contract_type": "semi-fungible",
                "created_date": "2020-12-02T17:40:53.232025",
                "name": "OpenSea Collection",
                "nft_version": null,
                "opensea_version": "2.0.0",
                "owner": 102384,
                "schema_name": "ERC1155",
                "symbol": "OPENSTORE",
                "total_supply": null,
                "description": null,
                "external_link": null,
                "image_url": null,
                "default_to_fiat": false,
                "dev_buyer_fee_basis_points": 0,
                "dev_seller_fee_basis_points": 0,
                "only_proxied_transfers": false,
                "opensea_buyer_fee_basis_points": 0,
                "opensea_seller_fee_basis_points": 250,
                "buyer_fee_basis_points": 0,
                "seller_fee_basis_points": 250,
                "payout_address": null
            },
            "owner": {
                "user": {
                    "username": "NullAddress"
                },
                "profile_img_url": "https://storage.googleapis.com/opensea-static/opensea-profile/1.png",
                "address": "0x0000000000000000000000000000000000000000",
                "config": "",
                "discord_id": ""
            },
            "permalink": "https://opensea.io/assets/0x495f947276749ce646f68ac8c248420045cb7b5e/32496007455968698945925048330076372926450965754552901123188466506912531218433",
            "collection": {
                "banner_image_url": null,
                "chat_url": null,
                "created_date": "2021-05-26T07:33:51.467411",
                "default_to_fiat": false,
                "description": "",
                "dev_buyer_fee_basis_points": "0",
                "dev_seller_fee_basis_points": "0",
                "discord_url": null,
                "display_data": {
                    "card_display_style": "contain",
                    "images": []
                },
                "external_url": null,
                "featured": false,
                "featured_image_url": null,
                "hidden": true,
                "safelist_request_status": "not_requested",
                "image_url": "https://lh3.googleusercontent.com/IuOar-WtGVdukoJ-1vTMwlEA0H0MOXwpdAK309hQ-a34m_kgiiriTYNRdUhjeqCWKl0SYiOSTz5UvD9AZIvvpk_z8nWdgX1_zAvELQ=s120",
                "is_subject_to_whitelist": false,
                "large_image_url": null,
                "medium_username": null,
                "name": "The leader of curlys",
                "only_proxied_transfers": false,
                "opensea_buyer_fee_basis_points": "0",
                "opensea_seller_fee_basis_points": "250",
                "payout_address": null,
                "require_email": false,
                "short_description": null,
                "slug": "the-leader-of-curlys",
                "telegram_url": null,
                "twitter_username": null,
                "instagram_username": null,
                "wiki_url": null
            },
            "decimals": null,
            "token_metadata": null,
            "sell_orders": null,
            "creator": {
                "user": {
                    "username": "C-na"
                },
                "profile_img_url": "https://storage.googleapis.com/opensea-static/opensea-profile/25.png",
                "address": "0x47d816a348ddc6922f0d305237a72233216fb99c",
                "config": "",
                "discord_id": ""
            },
            "traits": [],
            "last_sale": null,
            "top_bid": null,
            "listing_date": null,
            "is_presale": true,
            "transfer_fee_payment_token": null,
            "transfer_fee": null
        },
        {
            "id": 25679528,
            "token_id": "67154617034340034456453366385792604942607367955217100128958461000134256754689",
            "num_sales": 0,
            "background_color": null,
            "image_url": "https://lh3.googleusercontent.com/HonVFs27linnbjJ7tjxcA06hUBezlB03LPM-gWrM5aa25gapALcYTswIM09k6jKizl8Q4kQr1bYTVCKrqPEyh7aEx-RtEHvYJXzbfFs",
            "image_preview_url": "https://lh3.googleusercontent.com/HonVFs27linnbjJ7tjxcA06hUBezlB03LPM-gWrM5aa25gapALcYTswIM09k6jKizl8Q4kQr1bYTVCKrqPEyh7aEx-RtEHvYJXzbfFs=s250",
            "image_thumbnail_url": "https://lh3.googleusercontent.com/HonVFs27linnbjJ7tjxcA06hUBezlB03LPM-gWrM5aa25gapALcYTswIM09k6jKizl8Q4kQr1bYTVCKrqPEyh7aEx-RtEHvYJXzbfFs=s128",
            "image_original_url": null,
            "animation_url": null,
            "animation_original_url": null,
            "name": "[TreeR]Falling cherry blossoms #3446",
            "description": "Python turtle draw it.\n\n# 3446 // 719  x  608  px  \n\nFalling cherry blossoms year, you and I met at this moment, hand-yu, like the subtle, ethereal handsome, sophisticated atmosphere, walking in between the cloud water.",
            "external_link": null,
            "asset_contract": {
                "address": "0x495f947276749ce646f68ac8c248420045cb7b5e",
                "asset_contract_type": "semi-fungible",
                "created_date": "2020-12-02T17:40:53.232025",
                "name": "OpenSea Collection",
                "nft_version": null,
                "opensea_version": "2.0.0",
                "owner": 102384,
                "schema_name": "ERC1155",
                "symbol": "OPENSTORE",
                "total_supply": null,
                "description": null,
                "external_link": null,
                "image_url": null,
                "default_to_fiat": false,
                "dev_buyer_fee_basis_points": 0,
                "dev_seller_fee_basis_points": 0,
                "only_proxied_transfers": false,
                "opensea_buyer_fee_basis_points": 0,
                "opensea_seller_fee_basis_points": 250,
                "buyer_fee_basis_points": 0,
                "seller_fee_basis_points": 250,
                "payout_address": null
            },
            "owner": {
                "user": {
                    "username": "NullAddress"
                },
                "profile_img_url": "https://storage.googleapis.com/opensea-static/opensea-profile/1.png",
                "address": "0x0000000000000000000000000000000000000000",
                "config": "",
                "discord_id": ""
            },
            "permalink": "https://opensea.io/assets/0x495f947276749ce646f68ac8c248420045cb7b5e/67154617034340034456453366385792604942607367955217100128958461000134256754689",
            "collection": {
                "banner_image_url": "https://lh3.googleusercontent.com/qAFj1m1OoChD4FcSkSXO0mAQNTCtsDRm1bJu-JLukcZeYU7Zl7KPZsINaBIXBR0STnpSlWsCnjLKtc18eyQo43VhqBi8IPGYJREXjw=s2500",
                "chat_url": null,
                "created_date": "2021-05-22T10:06:08.879127",
                "default_to_fiat": false,
                "description": "Falling cherry blossoms year, you and I met at this moment, hand-yu, like the subtle, ethereal handsome, sophisticated atmosphere, walking in between the cloud water.\n\nPython turtle draw it.",
                "dev_buyer_fee_basis_points": "0",
                "dev_seller_fee_basis_points": "10",
                "discord_url": null,
                "display_data": {
                    "card_display_style": "contain"
                },
                "external_url": null,
                "featured": false,
                "featured_image_url": "https://lh3.googleusercontent.com/yoTPXDtQkkedgY-eHS1c35-CHvY6MiN5FE0fQP3_8LCPV7U3JVLOZliTYqmAxPDPojshQz71dohZZ8LJUCsnxeXEC3u3iTWxPlHhDQ=s300",
                "hidden": true,
                "safelist_request_status": "not_requested",
                "image_url": "https://lh3.googleusercontent.com/NIpY--fl9ykQGtK7l1eeAyQGTcv7Xc83ADkrQVx7Ko32oPvTaup5W6GTwh_jG1yjTweNqC0Zzby5VmIKZ4ZXPaqahWxMtWXnt3PmSA=s120",
                "is_subject_to_whitelist": false,
                "large_image_url": "https://lh3.googleusercontent.com/yoTPXDtQkkedgY-eHS1c35-CHvY6MiN5FE0fQP3_8LCPV7U3JVLOZliTYqmAxPDPojshQz71dohZZ8LJUCsnxeXEC3u3iTWxPlHhDQ=s300",
                "medium_username": null,
                "name": "[TreeR]Falling cherry blossoms",
                "only_proxied_transfers": false,
                "opensea_buyer_fee_basis_points": "0",
                "opensea_seller_fee_basis_points": "250",
                "payout_address": "0x94782a9182217af5861735ba5a2ea1ed8204a08c",
                "require_email": false,
                "short_description": null,
                "slug": "treer-falling-cherry-blossoms",
                "telegram_url": null,
                "twitter_username": null,
                "instagram_username": null,
                "wiki_url": null
            },
            "decimals": null,
            "token_metadata": null,
            "sell_orders": [
                {
                    "created_date": "2021-05-26T07:37:45.006205",
                    "closing_date": null,
                    "closing_extendable": false,
                    "expiration_time": 0,
                    "listing_time": 1622014558,
                    "order_hash": "0xc5f66dd03fbd3c7f1e507945a6a218e4e8120b4a86fed17dcd286f244a152a0b",
                    "metadata": {
                        "asset": {
                            "id": "67154617034340034456453366385792604942607367955217100128958461000134256754689",
                            "address": "0x495f947276749ce646f68ac8c248420045cb7b5e",
                            "quantity": "1"
                        },
                        "schema": "ERC1155"
                    },
                    "exchange": "0x7be8076f4ea4a4ad08075c2508e481d6c946d12b",
                    "maker": {
                        "user": 596584,
                        "profile_img_url": "https://storage.googleapis.com/opensea-static/opensea-profile/25.png",
                        "address": "0x94782a9182217af5861735ba5a2ea1ed8204a08c",
                        "config": "",
                        "discord_id": ""
                    },
                    "taker": {
                        "user": 1766,
                        "profile_img_url": "https://storage.googleapis.com/opensea-static/opensea-profile/1.png",
                        "address": "0x0000000000000000000000000000000000000000",
                        "config": "",
                        "discord_id": ""
                    },
                    "current_price": "10000000000000000",
                    "current_bounty": "100000000000000",
                    "bounty_multiple": "0.01",
                    "maker_relayer_fee": "260",
                    "taker_relayer_fee": "0",
                    "maker_protocol_fee": "0",
                    "taker_protocol_fee": "0",
                    "maker_referrer_fee": "0",
                    "fee_recipient": {
                        "user": 3585,
                        "profile_img_url": "https://storage.googleapis.com/opensea-static/opensea-profile/28.png",
                        "address": "0x5b3256965e7c3cf26e11fcaf296dfc8807c01073",
                        "config": "verified",
                        "discord_id": ""
                    },
                    "fee_method": 1,
                    "side": 1,
                    "sale_kind": 0,
                    "target": "0x495f947276749ce646f68ac8c248420045cb7b5e",
                    "how_to_call": 0,
                    "calldata": "0xf242432a00000000000000000000000094782a9182217af5861735ba5a2ea1ed8204a08c000000000000000000000000000000000000000000000000000000000000000094782a9182217af5861735ba5a2ea1ed8204a08c00000000002a930000000001000000000000000000000000000000000000000000000000000000000000000100000000000000000000000000000000000000000000000000000000000000a00000000000000000000000000000000000000000000000000000000000000000",
                    "replacement_pattern": "0x000000000000000000000000000000000000000000000000000000000000000000000000ffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffff0000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000",
                    "static_target": "0x0000000000000000000000000000000000000000",
                    "static_extradata": "0x",
                    "payment_token": "0x0000000000000000000000000000000000000000",
                    "payment_token_contract": {
                        "id": 1,
                        "symbol": "ETH",
                        "address": "0x0000000000000000000000000000000000000000",
                        "image_url": "https://storage.opensea.io/files/6f8e2979d428180222796ff4a33ab929.svg",
                        "name": "Ether",
                        "decimals": 18,
                        "eth_price": "1.000000000000000",
                        "usd_price": "2869.690000000000055000"
                    },
                    "base_price": "10000000000000000",
                    "extra": "0",
                    "quantity": "1",
                    "salt": "63668528032484788273445414960867970874085625166498726088095202617872686445458",
                    "v": 27,
                    "r": "0x6ab3d3955368c6ee76f26e18c0e2e65d517c4471c8538cb3561cad9ed9ebecbc",
                    "s": "0x6d1ff5131abfc89dea795ee3f0cbcfcc25dd93269b3a9a661dda7fc710fdc2ee",
                    "approved_on_chain": false,
                    "cancelled": false,
                    "finalized": false,
                    "marked_invalid": false,
                    "prefixed_hash": "0xffbc4b2f24b14be96855db001ef1c17dfae3bbbb45a011f3c6d1034ba4aafdd3"
                }
            ],
            "creator": {
                "user": {
                    "username": "Suqingyan"
                },
                "profile_img_url": "https://storage.googleapis.com/opensea-static/opensea-profile/25.png",
                "address": "0x94782a9182217af5861735ba5a2ea1ed8204a08c",
                "config": "",
                "discord_id": ""
            },
            "traits": [
                {
                    "trait_type": "Material",
                    "value": "Tree",
                    "display_type": null,
                    "max_value": null,
                    "trait_count": 3456,
                    "order": null
                }
            ],
            "last_sale": null,
            "top_bid": null,
            "listing_date": null,
            "is_presale": true,
            "transfer_fee_payment_token": null,
            "transfer_fee": null
        },
        {
            "id": 25679527,
            "token_id": "43256148759339955833627948903570477792374251613417217355679402460145300537345",
            "num_sales": 0,
            "background_color": null,
            "image_url": "https://lh3.googleusercontent.com/i29p_Sqf2lwrDNT_QjEZTIMuD83fuVDHXiEPanxa4PkP7eVkx05xZ9OXQ0XuvpQXkuaILCSVQwrA81_7NFM7X2OE4eUFFS_y0T8EpAY",
            "image_preview_url": "https://lh3.googleusercontent.com/i29p_Sqf2lwrDNT_QjEZTIMuD83fuVDHXiEPanxa4PkP7eVkx05xZ9OXQ0XuvpQXkuaILCSVQwrA81_7NFM7X2OE4eUFFS_y0T8EpAY=s250",
            "image_thumbnail_url": "https://lh3.googleusercontent.com/i29p_Sqf2lwrDNT_QjEZTIMuD83fuVDHXiEPanxa4PkP7eVkx05xZ9OXQ0XuvpQXkuaILCSVQwrA81_7NFM7X2OE4eUFFS_y0T8EpAY=s128",
            "image_original_url": null,
            "animation_url": null,
            "animation_original_url": null,
            "name": "\"hoo202002260208\" Digital & Acrylic on Digital Paper, Korean Artist Hooranky Bae",
            "description": "hoo202002260208\nArtist : Hooranky Bae\nArtwork : hoo202002260208\nYear : 2020\nDimensions : 37.25 x 78.32cm\nFrame Size : No Frame\nFrame Material : No Frame\nProduct Certificate : Yes\nDamaged Part : N/A\nStyle : Abstract expressionism\nType : Digital & Acrylic on digital paper",
            "external_link": "https://www.ebay.com/itm/124112802718",
            "asset_contract": {
                "address": "0x495f947276749ce646f68ac8c248420045cb7b5e",
                "asset_contract_type": "semi-fungible",
                "created_date": "2020-12-02T17:40:53.232025",
                "name": "OpenSea Collection",
                "nft_version": null,
                "opensea_version": "2.0.0",
                "owner": 102384,
                "schema_name": "ERC1155",
                "symbol": "OPENSTORE",
                "total_supply": null,
                "description": null,
                "external_link": null,
                "image_url": null,
                "default_to_fiat": false,
                "dev_buyer_fee_basis_points": 0,
                "dev_seller_fee_basis_points": 0,
                "only_proxied_transfers": false,
                "opensea_buyer_fee_basis_points": 0,
                "opensea_seller_fee_basis_points": 250,
                "buyer_fee_basis_points": 0,
                "seller_fee_basis_points": 250,
                "payout_address": null
            },
            "owner": {
                "user": {
                    "username": "NullAddress"
                },
                "profile_img_url": "https://storage.googleapis.com/opensea-static/opensea-profile/1.png",
                "address": "0x0000000000000000000000000000000000000000",
                "config": "",
                "discord_id": ""
            },
            "permalink": "https://opensea.io/assets/0x495f947276749ce646f68ac8c248420045cb7b5e/43256148759339955833627948903570477792374251613417217355679402460145300537345",
            "collection": {
                "banner_image_url": null,
                "chat_url": null,
                "created_date": "2021-05-26T06:33:50.533128",
                "default_to_fiat": false,
                "description": "Artist Introduction\nGraduated Occidental Painting, Art Department, Chugye University for the Arts\n\nArt work in Seoul, Beijing, Chiang Mai, Rome, New York, Tokyo, Fukushima Prefecture Iwaki, etc.\n\nThe works of Hooranky Bae belongs to abstract expressionism and the dramtic contrast of non-figurative strange shape and coloring gives strong and unique impression to the viewer.",
                "dev_buyer_fee_basis_points": "0",
                "dev_seller_fee_basis_points": "0",
                "discord_url": null,
                "display_data": {
                    "card_display_style": "contain",
                    "images": []
                },
                "external_url": null,
                "featured": false,
                "featured_image_url": null,
                "hidden": true,
                "safelist_request_status": "not_requested",
                "image_url": "https://lh3.googleusercontent.com/uXBj6TQfCZl0AUaJLsj3sRWn-9yTuwDDyMXAH0EUFiyCIxCuXXYb3bQ-Cn4x7Syleml-J0wbAC2LJ4xdFLvxpb2KX7qi4wH_bKkT1g=s120",
                "is_subject_to_whitelist": false,
                "large_image_url": null,
                "medium_username": null,
                "name": " Digital & Acrylic on Digital Paper by Korean Artist Hooranky Bae",
                "only_proxied_transfers": false,
                "opensea_buyer_fee_basis_points": "0",
                "opensea_seller_fee_basis_points": "250",
                "payout_address": null,
                "require_email": false,
                "short_description": null,
                "slug": "digital-acrylic-on-digital-paper-by-korean-artist",
                "telegram_url": null,
                "twitter_username": null,
                "instagram_username": null,
                "wiki_url": null
            },
            "decimals": null,
            "token_metadata": null,
            "sell_orders": null,
            "creator": {
                "user": {
                    "username": null
                },
                "profile_img_url": "https://storage.googleapis.com/opensea-static/opensea-profile/26.png",
                "address": "0x5fa21cd254f9e989a1e84530a77e7b330eb572c1",
                "config": "",
                "discord_id": ""
            },
            "traits": [
                {
                    "trait_type": "Digital & Acrylic on digital paper",
                    "value": "hoo202002260208",
                    "display_type": null,
                    "max_value": null,
                    "trait_count": 0,
                    "order": null
                }
            ],
            "last_sale": null,
            "top_bid": null,
            "listing_date": null,
            "is_presale": true,
            "transfer_fee_payment_token": null,
            "transfer_fee": null
        },
        {
            "id": 25679526,
            "token_id": "40654",
            "num_sales": 0,
            "background_color": null,
            "image_url": "https://lh3.googleusercontent.com/tmuVhDyafdsu35ZcXq-p7Tyn5IFF3-wZQRDLjJL2p9B5MGDLWjoEvyEFqw0WGVdtaFTu4ALx_UaU4R4sw-aLxcm3q0_ow4sy-ckj9A",
            "image_preview_url": "https://lh3.googleusercontent.com/tmuVhDyafdsu35ZcXq-p7Tyn5IFF3-wZQRDLjJL2p9B5MGDLWjoEvyEFqw0WGVdtaFTu4ALx_UaU4R4sw-aLxcm3q0_ow4sy-ckj9A=s250",
            "image_thumbnail_url": "https://lh3.googleusercontent.com/tmuVhDyafdsu35ZcXq-p7Tyn5IFF3-wZQRDLjJL2p9B5MGDLWjoEvyEFqw0WGVdtaFTu4ALx_UaU4R4sw-aLxcm3q0_ow4sy-ckj9A=s128",
            "image_original_url": "https://ipfs.io/ipfs/QmVqFbhmUA2vsuQ5sQwXx45kscYhZ7vfMMgBKsYLJk5pnY/nft.jpg",
            "animation_url": null,
            "animation_original_url": null,
            "name": "SKULL DOMINATRIX",
            "description": "Dominated by the future",
            "external_link": "https://foundation.app/Abrar_Khan/skull-dominatrix-40654",
            "asset_contract": {
                "address": "0x3b3ee1931dc30c1957379fac9aba94d1c48a5405",
                "asset_contract_type": "non-fungible",
                "created_date": "2021-01-20T21:10:25.832726",
                "name": "FND NFT",
                "nft_version": "3.0",
                "opensea_version": null,
                "owner": null,
                "schema_name": "ERC721",
                "symbol": "FNDNFT",
                "total_supply": "1",
                "description": "Foundation is building the new creative economy. Create, explore & collect digital art NFTs.",
                "external_link": "https://foundation.app/",
                "image_url": "https://lh3.googleusercontent.com/uUdrzISpIJJVRbm_g6mmu-TUaOERBbPJcNA8KeuwI1HNgXy8Kje3c2XhoMIndnPmyono9NUJE8A2_bTd95iqAcjo9pyy-e47flJy=s120",
                "default_to_fiat": false,
                "dev_buyer_fee_basis_points": 0,
                "dev_seller_fee_basis_points": 1000,
                "only_proxied_transfers": false,
                "opensea_buyer_fee_basis_points": 0,
                "opensea_seller_fee_basis_points": 250,
                "buyer_fee_basis_points": 0,
                "seller_fee_basis_points": 1250,
                "payout_address": "0x9d9c46aca6a2c5ff6824a92d521b6381f9f8f1a9"
            },
            "owner": {
                "user": null,
                "profile_img_url": "https://storage.googleapis.com/opensea-static/opensea-profile/31.png",
                "address": "0x3f5872783182989fbf732866c8bafe6b93e822b2",
                "config": "",
                "discord_id": ""
            },
            "permalink": "https://opensea.io/assets/0x3b3ee1931dc30c1957379fac9aba94d1c48a5405/40654",
            "collection": {
                "banner_image_url": "https://lh3.googleusercontent.com/AlryV7Yh-BmKx1Y_4kcr86f-vyeQ6WWP2c0zDICL_Qp6KsYtxDb1yCocxCstmnZq3jacgCyqVxRAFzb6FbHSbflMXwqsWB-6in8C=s2500",
                "chat_url": null,
                "created_date": "2021-01-20T21:10:26.324044",
                "default_to_fiat": false,
                "description": "Foundation is building the new creative economy. Create, explore & collect digital art NFTs.",
                "dev_buyer_fee_basis_points": "0",
                "dev_seller_fee_basis_points": "1000",
                "discord_url": "https://discord.gg/AQ3VtFh",
                "display_data": {
                    "card_display_style": "cover"
                },
                "external_url": "https://foundation.app/",
                "featured": false,
                "featured_image_url": "https://lh3.googleusercontent.com/qWWg_VLDPugD09rVOJuYbwOSNW5pbW13Adc-PiH3tSKvl0JgvmnByeEpcDaQ_JTtDxrXHCyA1rTEp2Kr630IramlmBy6yrc2-oa5Hq4=s300",
                "hidden": false,
                "safelist_request_status": "verified",
                "image_url": "https://lh3.googleusercontent.com/uUdrzISpIJJVRbm_g6mmu-TUaOERBbPJcNA8KeuwI1HNgXy8Kje3c2XhoMIndnPmyono9NUJE8A2_bTd95iqAcjo9pyy-e47flJy=s120",
                "is_subject_to_whitelist": false,
                "large_image_url": "https://lh3.googleusercontent.com/qWWg_VLDPugD09rVOJuYbwOSNW5pbW13Adc-PiH3tSKvl0JgvmnByeEpcDaQ_JTtDxrXHCyA1rTEp2Kr630IramlmBy6yrc2-oa5Hq4=s300",
                "medium_username": null,
                "name": "Foundation (FND)",
                "only_proxied_transfers": false,
                "opensea_buyer_fee_basis_points": "0",
                "opensea_seller_fee_basis_points": "250",
                "payout_address": "0x9d9c46aca6a2c5ff6824a92d521b6381f9f8f1a9",
                "require_email": false,
                "short_description": null,
                "slug": "fnd",
                "telegram_url": null,
                "twitter_username": "withFND",
                "instagram_username": null,
                "wiki_url": null
            },
            "decimals": 0,
            "token_metadata": "https://api.foundation.app/opensea/40654",
            "sell_orders": null,
            "creator": {
                "user": null,
                "profile_img_url": "https://storage.googleapis.com/opensea-static/opensea-profile/31.png",
                "address": "0x3f5872783182989fbf732866c8bafe6b93e822b2",
                "config": "",
                "discord_id": ""
            },
            "traits": [],
            "last_sale": null,
            "top_bid": null,
            "listing_date": null,
            "is_presale": false,
            "transfer_fee_payment_token": null,
            "transfer_fee": null
        },
        {
            "id": 25679525,
            "token_id": "580360",
            "num_sales": 0,
            "background_color": null,
            "image_url": "https://lh3.googleusercontent.com/SqcDGiJb8qZMtv4Cl5uf81FnDoJ3AoMTpZIuGqXpnfwx88RnQmh2FlYZe8lUZRlrY3AVpvtyP7ZrqY1q0iUC13yCnWGSTJuiIFX00A",
            "image_preview_url": "https://lh3.googleusercontent.com/SqcDGiJb8qZMtv4Cl5uf81FnDoJ3AoMTpZIuGqXpnfwx88RnQmh2FlYZe8lUZRlrY3AVpvtyP7ZrqY1q0iUC13yCnWGSTJuiIFX00A=s250",
            "image_thumbnail_url": "https://lh3.googleusercontent.com/SqcDGiJb8qZMtv4Cl5uf81FnDoJ3AoMTpZIuGqXpnfwx88RnQmh2FlYZe8lUZRlrY3AVpvtyP7ZrqY1q0iUC13yCnWGSTJuiIFX00A=s128",
            "image_original_url": "https://ipfs.io/ipfs/QmaA8Z7YyWb1HW3EZeaudEFs93wUUStqLeRVuM5ePVpkdt/image.png",
            "animation_url": null,
            "animation_original_url": null,
            "name": "White",
            "description": "Amaya awoke in a realm of utter desolation.  She frantically scanned the room for help but quickly realized she was alone in the endless, silent void that surrounded her.  As she attempted to gather her senses, a haze of confusion began to cloud Amaya’s mind and numbness crept through her.  Her fingers were frozen in place and when she tried to wiggle her toes, they too betrayed her.  A sinking feeling settled in the pit of her stomach as Amaya realized that the only things she could move were her eyes.  She was trapped, and she was certain she would be trapped forever.",
            "external_link": "https://rarible.com/token/0xd07dc4262bcdbf85190c01c996b4c06a461d2430:580360",
            "asset_contract": {
                "address": "0xd07dc4262bcdbf85190c01c996b4c06a461d2430",
                "asset_contract_type": "semi-fungible",
                "created_date": "2020-05-27T16:53:32.834583",
                "name": "Rarible 1155",
                "nft_version": null,
                "opensea_version": null,
                "owner": 42603523,
                "schema_name": "ERC1155",
                "symbol": "",
                "total_supply": null,
                "description": "Create and sell digital collectibles secured with blockchain technology. Rarible is home to thousands of artists and collectors, creating and exchanging immutable art without using code. Trade with RARI token on OpenSea.",
                "external_link": "https://rarible.com/",
                "image_url": "https://lh3.googleusercontent.com/FG0QJ00fN3c_FWuPeUr9-T__iQl63j9hn5d6svW8UqOmia5zp3lKHPkJuHcvhZ0f_Pd6P2COo9tt9zVUvdPxG_9BBw=s60",
                "default_to_fiat": false,
                "dev_buyer_fee_basis_points": 0,
                "dev_seller_fee_basis_points": 0,
                "only_proxied_transfers": false,
                "opensea_buyer_fee_basis_points": 0,
                "opensea_seller_fee_basis_points": 250,
                "buyer_fee_basis_points": 0,
                "seller_fee_basis_points": 250,
                "payout_address": null
            },
            "owner": {
                "user": {
                    "username": "NullAddress"
                },
                "profile_img_url": "https://storage.googleapis.com/opensea-static/opensea-profile/1.png",
                "address": "0x0000000000000000000000000000000000000000",
                "config": "",
                "discord_id": ""
            },
            "permalink": "https://opensea.io/assets/0xd07dc4262bcdbf85190c01c996b4c06a461d2430/580360",
            "collection": {
                "banner_image_url": "https://storage.opensea.io/static/banners/rarible-banner4.png",
                "chat_url": null,
                "created_date": "2020-01-01T13:22:57.777065",
                "default_to_fiat": false,
                "description": "Create and sell digital collectibles secured with blockchain technology. Rarible is home to thousands of artists and collectors, creating and exchanging immutable art without using code. Trade with RARI token on OpenSea.",
                "dev_buyer_fee_basis_points": "0",
                "dev_seller_fee_basis_points": "0",
                "discord_url": null,
                "display_data": {
                    "card_display_style": "contain"
                },
                "external_url": "https://rarible.com/",
                "featured": false,
                "featured_image_url": null,
                "hidden": false,
                "safelist_request_status": "verified",
                "image_url": "https://lh3.googleusercontent.com/FG0QJ00fN3c_FWuPeUr9-T__iQl63j9hn5d6svW8UqOmia5zp3lKHPkJuHcvhZ0f_Pd6P2COo9tt9zVUvdPxG_9BBw=s60",
                "is_subject_to_whitelist": false,
                "large_image_url": "https://lh3.googleusercontent.com/FG0QJ00fN3c_FWuPeUr9-T__iQl63j9hn5d6svW8UqOmia5zp3lKHPkJuHcvhZ0f_Pd6P2COo9tt9zVUvdPxG_9BBw",
                "medium_username": "rarible",
                "name": "Rarible",
                "only_proxied_transfers": false,
                "opensea_buyer_fee_basis_points": "0",
                "opensea_seller_fee_basis_points": "250",
                "payout_address": null,
                "require_email": false,
                "short_description": null,
                "slug": "rarible",
                "telegram_url": "https://t.me/rarible",
                "twitter_username": "rariblecom",
                "instagram_username": null,
                "wiki_url": null
            },
            "decimals": null,
            "token_metadata": "https://ipfs.io/ipfs/QmbTv2VTgNPDfL7vDRg4s5JB3ZsWzCPB7cCeKPBLgQBgmB",
            "sell_orders": null,
            "creator": {
                "user": {
                    "username": "AOTMV"
                },
                "profile_img_url": "https://storage.googleapis.com/opensea-static/opensea-profile/12.png",
                "address": "0x7e5e7f10af0a8a1597d5d727e50b48c119314116",
                "config": "",
                "discord_id": ""
            },
            "traits": [],
            "last_sale": null,
            "top_bid": null,
            "listing_date": null,
            "is_presale": false,
            "transfer_fee_payment_token": null,
            "transfer_fee": null
        },
        {
            "id": 25679524,
            "token_id": "968970",
            "num_sales": 0,
            "background_color": "FAEDD0",
            "image_url": "https://lh3.googleusercontent.com/zWc7Mcnnupt-snk3cRoqNTdCePZBNKCd9w4Ka38kiiOk2XPpVPJR1sjlZQIyDArct41Iy3kUYIC23PdOIRnwF9A1",
            "image_preview_url": "https://lh3.googleusercontent.com/zWc7Mcnnupt-snk3cRoqNTdCePZBNKCd9w4Ka38kiiOk2XPpVPJR1sjlZQIyDArct41Iy3kUYIC23PdOIRnwF9A1=s250",
            "image_thumbnail_url": "https://lh3.googleusercontent.com/zWc7Mcnnupt-snk3cRoqNTdCePZBNKCd9w4Ka38kiiOk2XPpVPJR1sjlZQIyDArct41Iy3kUYIC23PdOIRnwF9A1=s128",
            "image_original_url": "https://media.klipwallet.com/card_asset/card_welcome_klip.png",
            "animation_url": null,
            "animation_original_url": null,
            "name": "웰컴 카드",
            "description": "Klip의 회원가입 절차를 완료한 사용자만 받을 수 있는 카드. 나중에 어떤 혜택이 찾아올지 모르니 지갑에 보관은 필수!",
            "external_link": null,
            "asset_contract": {
                "address": "0xb26e09db6656b998d2913f13870e06c151c37900",
                "asset_contract_type": "non-fungible",
                "created_date": "2020-12-18T07:40:18.207092",
                "name": null,
                "nft_version": null,
                "opensea_version": null,
                "owner": null,
                "schema_name": "ERC721",
                "symbol": "",
                "total_supply": null,
                "description": null,
                "external_link": null,
                "image_url": "https://lh3.googleusercontent.com/EGCeKommkTYOJir0gMq9VoFm35Zo03wCoBTDmYl-Gb4EBn_d4wa9cdFP4NLrE5enW3ufgCIdhVuBmzaw98VAPfxEHVrJRw20xE22YQ=s120",
                "default_to_fiat": false,
                "dev_buyer_fee_basis_points": 0,
                "dev_seller_fee_basis_points": 0,
                "only_proxied_transfers": false,
                "opensea_buyer_fee_basis_points": 0,
                "opensea_seller_fee_basis_points": 250,
                "buyer_fee_basis_points": 0,
                "seller_fee_basis_points": 250,
                "payout_address": null
            },
            "owner": {
                "user": null,
                "profile_img_url": "https://storage.googleapis.com/opensea-static/opensea-profile/1.png",
                "address": "0x0000000000000000000000000000000000000000",
                "config": "",
                "discord_id": ""
            },
            "permalink": "https://opensea.io/assets/klaytn/0xb26e09db6656b998d2913f13870e06c151c37900/968970",
            "collection": {
                "banner_image_url": null,
                "chat_url": null,
                "created_date": "2020-12-18T07:40:19.294596",
                "default_to_fiat": false,
                "description": null,
                "dev_buyer_fee_basis_points": "0",
                "dev_seller_fee_basis_points": "0",
                "discord_url": null,
                "display_data": {
                    "card_display_style": "contain"
                },
                "external_url": null,
                "featured": false,
                "featured_image_url": null,
                "hidden": true,
                "safelist_request_status": "not_requested",
                "image_url": "https://lh3.googleusercontent.com/EGCeKommkTYOJir0gMq9VoFm35Zo03wCoBTDmYl-Gb4EBn_d4wa9cdFP4NLrE5enW3ufgCIdhVuBmzaw98VAPfxEHVrJRw20xE22YQ=s120",
                "is_subject_to_whitelist": false,
                "large_image_url": null,
                "medium_username": null,
                "name": "Klip",
                "only_proxied_transfers": false,
                "opensea_buyer_fee_basis_points": "0",
                "opensea_seller_fee_basis_points": "250",
                "payout_address": null,
                "require_email": false,
                "short_description": null,
                "slug": "klip",
                "telegram_url": null,
                "twitter_username": null,
                "instagram_username": null,
                "wiki_url": null
            },
            "decimals": null,
            "token_metadata": "https://media.klipwallet.com/card_asset/card_welcome_klip.json",
            "sell_orders": null,
            "creator": null,
            "traits": [
                {
                    "trait_type": "사용 방법",
                    "value": "지갑에 보유하고 있는 것만으로도 Klip이 준비한 깜짝 혜택의 주인공이 될 수 있습니다.",
                    "display_type": null,
                    "max_value": null,
                    "trait_count": 737227,
                    "order": null
                }
            ],
            "last_sale": null,
            "top_bid": null,
            "listing_date": null,
            "is_presale": false,
            "transfer_fee_payment_token": null,
            "transfer_fee": null
        },
        {
            "id": 25679523,
            "token_id": "37430452933329828009181382969899584352567632449099565656987172365296180658177",
            "num_sales": 0,
            "background_color": null,
            "image_url": "https://lh3.googleusercontent.com/wCOsFIvRUuZtH6Byp6GrPp8fDAhr-cH-a3sOu36E7IE6ngO1cn-_ZRARplJVy2FA1PPLIl046wcKxnuf3_BKLYhmDu_qZC0JQuDwvy8",
            "image_preview_url": "https://lh3.googleusercontent.com/wCOsFIvRUuZtH6Byp6GrPp8fDAhr-cH-a3sOu36E7IE6ngO1cn-_ZRARplJVy2FA1PPLIl046wcKxnuf3_BKLYhmDu_qZC0JQuDwvy8=s250",
            "image_thumbnail_url": "https://lh3.googleusercontent.com/wCOsFIvRUuZtH6Byp6GrPp8fDAhr-cH-a3sOu36E7IE6ngO1cn-_ZRARplJVy2FA1PPLIl046wcKxnuf3_BKLYhmDu_qZC0JQuDwvy8=s128",
            "image_original_url": null,
            "animation_url": null,
            "animation_original_url": null,
            "name": "Pretty Crypto Lady #295",
            "description": null,
            "external_link": null,
            "asset_contract": {
                "address": "0x495f947276749ce646f68ac8c248420045cb7b5e",
                "asset_contract_type": "semi-fungible",
                "created_date": "2020-12-02T17:40:53.232025",
                "name": "OpenSea Collection",
                "nft_version": null,
                "opensea_version": "2.0.0",
                "owner": 102384,
                "schema_name": "ERC1155",
                "symbol": "OPENSTORE",
                "total_supply": null,
                "description": null,
                "external_link": null,
                "image_url": null,
                "default_to_fiat": false,
                "dev_buyer_fee_basis_points": 0,
                "dev_seller_fee_basis_points": 0,
                "only_proxied_transfers": false,
                "opensea_buyer_fee_basis_points": 0,
                "opensea_seller_fee_basis_points": 250,
                "buyer_fee_basis_points": 0,
                "seller_fee_basis_points": 250,
                "payout_address": null
            },
            "owner": {
                "user": {
                    "username": "NullAddress"
                },
                "profile_img_url": "https://storage.googleapis.com/opensea-static/opensea-profile/1.png",
                "address": "0x0000000000000000000000000000000000000000",
                "config": "",
                "discord_id": ""
            },
            "permalink": "https://opensea.io/assets/0x495f947276749ce646f68ac8c248420045cb7b5e/37430452933329828009181382969899584352567632449099565656987172365296180658177",
            "collection": {
                "banner_image_url": null,
                "chat_url": null,
                "created_date": "2021-04-27T21:07:28.954779",
                "default_to_fiat": false,
                "description": "All these photos are made by a neural network. So it is not real people. They never exist.\nEvery picture is unique. It could be similar but never the same.\n***Any coincidence with real people, organizations, and events is accidental***\n\nMaybe in the future, when we would be able to order human similar robots you will need to choose their face.\nSo if you will be the owner of some of these NFTs, your robots will have inimitable faces.",
                "dev_buyer_fee_basis_points": "0",
                "dev_seller_fee_basis_points": "500",
                "discord_url": null,
                "display_data": {
                    "card_display_style": "cover"
                },
                "external_url": null,
                "featured": false,
                "featured_image_url": null,
                "hidden": true,
                "safelist_request_status": "not_requested",
                "image_url": "https://lh3.googleusercontent.com/abZyjia1IXPU0RXnS3h-NjGwg1biSIZxF3va_RlR-m2ymdQlFGQiBETQ2kYoQP6JCxuqZKYJLpbTETlkMSoNLNvlNDJ_9kkFfIinQA=s120",
                "is_subject_to_whitelist": false,
                "large_image_url": null,
                "medium_username": null,
                "name": "Pretty Crypto Ladies",
                "only_proxied_transfers": false,
                "opensea_buyer_fee_basis_points": "0",
                "opensea_seller_fee_basis_points": "250",
                "payout_address": "0x52c0e2b66ee82ea1c4dcf66f37fb69926ce864ca",
                "require_email": false,
                "short_description": null,
                "slug": "pretty-crypto-ladies",
                "telegram_url": null,
                "twitter_username": null,
                "instagram_username": null,
                "wiki_url": null
            },
            "decimals": null,
            "token_metadata": null,
            "sell_orders": [
                {
                    "created_date": "2021-05-26T07:37:07.999875",
                    "closing_date": null,
                    "closing_extendable": false,
                    "expiration_time": 0,
                    "listing_time": 1622014522,
                    "order_hash": "0x07dd8786ad8157e216a530fe2f1fb21b95f5687fb956074a2c79095c8070cfff",
                    "metadata": {
                        "asset": {
                            "id": "37430452933329828009181382969899584352567632449099565656987172365296180658177",
                            "address": "0x495f947276749ce646f68ac8c248420045cb7b5e",
                            "quantity": "1"
                        },
                        "schema": "ERC1155"
                    },
                    "exchange": "0x7be8076f4ea4a4ad08075c2508e481d6c946d12b",
                    "maker": {
                        "user": 251494,
                        "profile_img_url": "https://storage.googleapis.com/opensea-static/opensea-profile/30.png",
                        "address": "0x52c0e2b66ee82ea1c4dcf66f37fb69926ce864ca",
                        "config": "",
                        "discord_id": ""
                    },
                    "taker": {
                        "user": 1766,
                        "profile_img_url": "https://storage.googleapis.com/opensea-static/opensea-profile/1.png",
                        "address": "0x0000000000000000000000000000000000000000",
                        "config": "",
                        "discord_id": ""
                    },
                    "current_price": "100000000000000000",
                    "current_bounty": "1000000000000000",
                    "bounty_multiple": "0.01",
                    "maker_relayer_fee": "750",
                    "taker_relayer_fee": "0",
                    "maker_protocol_fee": "0",
                    "taker_protocol_fee": "0",
                    "maker_referrer_fee": "0",
                    "fee_recipient": {
                        "user": 3585,
                        "profile_img_url": "https://storage.googleapis.com/opensea-static/opensea-profile/28.png",
                        "address": "0x5b3256965e7c3cf26e11fcaf296dfc8807c01073",
                        "config": "verified",
                        "discord_id": ""
                    },
                    "fee_method": 1,
                    "side": 1,
                    "sale_kind": 0,
                    "target": "0x495f947276749ce646f68ac8c248420045cb7b5e",
                    "how_to_call": 0,
                    "calldata": "0xf242432a00000000000000000000000052c0e2b66ee82ea1c4dcf66f37fb69926ce864ca000000000000000000000000000000000000000000000000000000000000000052c0e2b66ee82ea1c4dcf66f37fb69926ce864ca000000000001340000000001000000000000000000000000000000000000000000000000000000000000000100000000000000000000000000000000000000000000000000000000000000a00000000000000000000000000000000000000000000000000000000000000000",
                    "replacement_pattern": "0x000000000000000000000000000000000000000000000000000000000000000000000000ffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffff0000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000",
                    "static_target": "0x0000000000000000000000000000000000000000",
                    "static_extradata": "0x",
                    "payment_token": "0x0000000000000000000000000000000000000000",
                    "payment_token_contract": {
                        "id": 1,
                        "symbol": "ETH",
                        "address": "0x0000000000000000000000000000000000000000",
                        "image_url": "https://storage.opensea.io/files/6f8e2979d428180222796ff4a33ab929.svg",
                        "name": "Ether",
                        "decimals": 18,
                        "eth_price": "1.000000000000000",
                        "usd_price": "2869.690000000000055000"
                    },
                    "base_price": "100000000000000000",
                    "extra": "0",
                    "quantity": "1",
                    "salt": "46728529063928772846873226703242887582796217190601788540759420906876729763837",
                    "v": 27,
                    "r": "0xec3dbf04a6b0e9129c741358360ecc7dcc4d63070454cc55f85e1d636d90596a",
                    "s": "0x5fb39b14f0331b76def1c3dcc41f2c4f14e1661ce8cbe27b77fab6b527764b30",
                    "approved_on_chain": false,
                    "cancelled": false,
                    "finalized": false,
                    "marked_invalid": false,
                    "prefixed_hash": "0x9b09057649a3c7d38b9a03971f3380da8b32c54e28a7136310c2f05bfe8c0d31"
                }
            ],
            "creator": {
                "user": {
                    "username": "Antilames"
                },
                "profile_img_url": "https://storage.googleapis.com/opensea-static/opensea-profile/30.png",
                "address": "0x52c0e2b66ee82ea1c4dcf66f37fb69926ce864ca",
                "config": "",
                "discord_id": ""
            },
            "traits": [],
            "last_sale": null,
            "top_bid": null,
            "listing_date": null,
            "is_presale": true,
            "transfer_fee_payment_token": null,
            "transfer_fee": null
        },
        {
            "id": 25679522,
            "token_id": "948030724",
            "num_sales": 0,
            "background_color": "DCE6F0",
            "image_url": "https://lh3.googleusercontent.com/XRdR3sLC8iViwbmi49tEjIewO-BTTp4gVTFzRvO-DKmfcu_y5J--Nf9WQQhIKGnZAvZYEymeUNSwnc2ueHcbjxPfEph3MUU_tqmbvPY",
            "image_preview_url": "https://lh3.googleusercontent.com/XRdR3sLC8iViwbmi49tEjIewO-BTTp4gVTFzRvO-DKmfcu_y5J--Nf9WQQhIKGnZAvZYEymeUNSwnc2ueHcbjxPfEph3MUU_tqmbvPY=s250",
            "image_thumbnail_url": "https://lh3.googleusercontent.com/XRdR3sLC8iViwbmi49tEjIewO-BTTp4gVTFzRvO-DKmfcu_y5J--Nf9WQQhIKGnZAvZYEymeUNSwnc2ueHcbjxPfEph3MUU_tqmbvPY=s128",
            "image_original_url": "https://cdn.krafter.space/0x3881cd04blocknatiion%208888%203.png",
            "animation_url": null,
            "animation_original_url": null,
            "name": "BlockNation (8888, 8888) 3",
            "description": "BlockNation (8888, 8888) 3",
            "external_link": null,
            "asset_contract": {
                "address": "0x9faccd9f9661dddec3971c1ee146516127c34fc1",
                "asset_contract_type": "non-fungible",
                "created_date": "2021-05-24T03:32:34.283969",
                "name": "KRAFTERSPACE",
                "nft_version": null,
                "opensea_version": null,
                "owner": null,
                "schema_name": "ERC721",
                "symbol": "KS",
                "total_supply": "1",
                "description": null,
                "external_link": null,
                "image_url": null,
                "default_to_fiat": false,
                "dev_buyer_fee_basis_points": 0,
                "dev_seller_fee_basis_points": 0,
                "only_proxied_transfers": false,
                "opensea_buyer_fee_basis_points": 0,
                "opensea_seller_fee_basis_points": 250,
                "buyer_fee_basis_points": 0,
                "seller_fee_basis_points": 250,
                "payout_address": null
            },
            "owner": {
                "user": null,
                "profile_img_url": "https://storage.googleapis.com/opensea-static/opensea-profile/1.png",
                "address": "0x0000000000000000000000000000000000000000",
                "config": "",
                "discord_id": ""
            },
            "permalink": "https://opensea.io/assets/klaytn/0x9faccd9f9661dddec3971c1ee146516127c34fc1/948030724",
            "collection": {
                "banner_image_url": null,
                "chat_url": null,
                "created_date": "2021-05-24T03:32:34.767460",
                "default_to_fiat": false,
                "description": null,
                "dev_buyer_fee_basis_points": "0",
                "dev_seller_fee_basis_points": "0",
                "discord_url": null,
                "display_data": {
                    "card_display_style": "contain",
                    "images": []
                },
                "external_url": null,
                "featured": false,
                "featured_image_url": null,
                "hidden": true,
                "safelist_request_status": "not_requested",
                "image_url": null,
                "is_subject_to_whitelist": false,
                "large_image_url": null,
                "medium_username": null,
                "name": "KRAFTERSPACE",
                "only_proxied_transfers": false,
                "opensea_buyer_fee_basis_points": "0",
                "opensea_seller_fee_basis_points": "250",
                "payout_address": null,
                "require_email": false,
                "short_description": null,
                "slug": "krafterspace",
                "telegram_url": null,
                "twitter_username": null,
                "instagram_username": null,
                "wiki_url": null
            },
            "decimals": null,
            "token_metadata": "https://cdn.krafter.space/0x3881cd04.json",
            "sell_orders": null,
            "creator": null,
            "traits": [],
            "last_sale": null,
            "top_bid": null,
            "listing_date": null,
            "is_presale": false,
            "transfer_fee_payment_token": null,
            "transfer_fee": null
        },
        {
            "id": 25679521,
            "token_id": "68297241408723902504380699674093713371179945469439219032891538626010656276481",
            "num_sales": 0,
            "background_color": null,
            "image_url": "https://lh3.googleusercontent.com/oYgHe496q6i7XEhjxrnQeXbg3wkpGoCaswsOhFqOYHZeeuO1KswDw0SPRIdyHM8OOMqoYsoxGHAXtAoT8-GmmCLHTdkBatFHYmUf",
            "image_preview_url": "https://lh3.googleusercontent.com/oYgHe496q6i7XEhjxrnQeXbg3wkpGoCaswsOhFqOYHZeeuO1KswDw0SPRIdyHM8OOMqoYsoxGHAXtAoT8-GmmCLHTdkBatFHYmUf=s250",
            "image_thumbnail_url": "https://lh3.googleusercontent.com/oYgHe496q6i7XEhjxrnQeXbg3wkpGoCaswsOhFqOYHZeeuO1KswDw0SPRIdyHM8OOMqoYsoxGHAXtAoT8-GmmCLHTdkBatFHYmUf=s128",
            "image_original_url": null,
            "animation_url": "https://storage.opensea.io/files/23ee5056502bdc46ab3878ebecf04346.mp4",
            "animation_original_url": "https://storage.opensea.io/files/23ee5056502bdc46ab3878ebecf04346.mp4",
            "name": "Man3333",
            "description": null,
            "external_link": null,
            "asset_contract": {
                "address": "0x495f947276749ce646f68ac8c248420045cb7b5e",
                "asset_contract_type": "semi-fungible",
                "created_date": "2020-12-02T17:40:53.232025",
                "name": "OpenSea Collection",
                "nft_version": null,
                "opensea_version": "2.0.0",
                "owner": 102384,
                "schema_name": "ERC1155",
                "symbol": "OPENSTORE",
                "total_supply": null,
                "description": null,
                "external_link": null,
                "image_url": null,
                "default_to_fiat": false,
                "dev_buyer_fee_basis_points": 0,
                "dev_seller_fee_basis_points": 0,
                "only_proxied_transfers": false,
                "opensea_buyer_fee_basis_points": 0,
                "opensea_seller_fee_basis_points": 250,
                "buyer_fee_basis_points": 0,
                "seller_fee_basis_points": 250,
                "payout_address": null
            },
            "owner": {
                "user": {
                    "username": "NullAddress"
                },
                "profile_img_url": "https://storage.googleapis.com/opensea-static/opensea-profile/1.png",
                "address": "0x0000000000000000000000000000000000000000",
                "config": "",
                "discord_id": ""
            },
            "permalink": "https://opensea.io/assets/0x495f947276749ce646f68ac8c248420045cb7b5e/68297241408723902504380699674093713371179945469439219032891538626010656276481",
            "collection": {
                "banner_image_url": null,
                "chat_url": null,
                "created_date": "2021-05-26T06:55:09.666676",
                "default_to_fiat": false,
                "description": "",
                "dev_buyer_fee_basis_points": "0",
                "dev_seller_fee_basis_points": "0",
                "discord_url": null,
                "display_data": {
                    "card_display_style": "contain",
                    "images": []
                },
                "external_url": null,
                "featured": false,
                "featured_image_url": null,
                "hidden": true,
                "safelist_request_status": "not_requested",
                "image_url": "https://lh3.googleusercontent.com/gQXGAO5l9_EgvznWWYaW-qjM8zAjm2Ns9kM8BYijVpN9FO9K0TBtc6eZP-euipm_zeSLi0JGJ3oP3gTbtiYURkDQozkFye4LVAyPEw=s120",
                "is_subject_to_whitelist": false,
                "large_image_url": null,
                "medium_username": null,
                "name": "wabesd",
                "only_proxied_transfers": false,
                "opensea_buyer_fee_basis_points": "0",
                "opensea_seller_fee_basis_points": "250",
                "payout_address": null,
                "require_email": false,
                "short_description": null,
                "slug": "wabesd",
                "telegram_url": null,
                "twitter_username": null,
                "instagram_username": null,
                "wiki_url": null
            },
            "decimals": null,
            "token_metadata": null,
            "sell_orders": null,
            "creator": {
                "user": {
                    "username": "Cesarrz1002"
                },
                "profile_img_url": "https://storage.googleapis.com/opensea-static/opensea-profile/32.png",
                "address": "0x96fede67150c98f1255429bead583afcc8f1736a",
                "config": "",
                "discord_id": ""
            },
            "traits": [],
            "last_sale": null,
            "top_bid": null,
            "listing_date": null,
            "is_presale": true,
            "transfer_fee_payment_token": null,
            "transfer_fee": null
        },
        {
            "id": 25679520,
            "token_id": "3226",
            "num_sales": 0,
            "background_color": null,
            "image_url": "https://lh3.googleusercontent.com/3G09bcOjSfkbIiCnDTPdcifXndMofduTa9W4fLYcKDu45DoRdLrABJIaa8zFGe9iPTWyAKep2ajzP1wIQ0o5YiWG45xUiPsKgMoogQ",
            "image_preview_url": "https://lh3.googleusercontent.com/3G09bcOjSfkbIiCnDTPdcifXndMofduTa9W4fLYcKDu45DoRdLrABJIaa8zFGe9iPTWyAKep2ajzP1wIQ0o5YiWG45xUiPsKgMoogQ=s250",
            "image_thumbnail_url": "https://lh3.googleusercontent.com/3G09bcOjSfkbIiCnDTPdcifXndMofduTa9W4fLYcKDu45DoRdLrABJIaa8zFGe9iPTWyAKep2ajzP1wIQ0o5YiWG45xUiPsKgMoogQ=s128",
            "image_original_url": "https://embersword.mypinata.cloud/ipfs/QmdbeV27CatL3EddMf2Ek1jGt77amKgb5ghVeHrKWLyz84",
            "animation_url": "https://storage.opensea.io/files/b0cc4d04cbc1f26c66e7511d64cd2d9e.mp4",
            "animation_original_url": "https://embersword.mypinata.cloud/ipfs/QmfKgvFupW1dm9W3UusnrGKrabMT6hTD2DkhG27hAU7Lxx",
            "name": "Land (100,74)",
            "description": "Land plot",
            "external_link": null,
            "asset_contract": {
                "address": "0xe7e16f2da731265778f87cb8d7850e31b84b7b86",
                "asset_contract_type": "non-fungible",
                "created_date": "2021-05-25T13:23:10.895540",
                "name": "Embersword Land",
                "nft_version": null,
                "opensea_version": null,
                "owner": 35978059,
                "schema_name": "ERC721",
                "symbol": "LAND",
                "total_supply": "0",
                "description": null,
                "external_link": "https://embersword.com",
                "image_url": "https://lh3.googleusercontent.com/J7SSCNIDh1ui59aoqyNywPtnUAUB-Q80Cnl1txbxmJOAIKcRJT1bUYidkDPNegOk2W0zyjqVkLbdcI6g6KTYgQCDplCo3DXpDSeaPg=s120",
                "default_to_fiat": false,
                "dev_buyer_fee_basis_points": 0,
                "dev_seller_fee_basis_points": 0,
                "only_proxied_transfers": false,
                "opensea_buyer_fee_basis_points": 0,
                "opensea_seller_fee_basis_points": 250,
                "buyer_fee_basis_points": 0,
                "seller_fee_basis_points": 250,
                "payout_address": null
            },
            "owner": {
                "user": null,
                "profile_img_url": "https://storage.googleapis.com/opensea-static/opensea-profile/1.png",
                "address": "0x0000000000000000000000000000000000000000",
                "config": "",
                "discord_id": ""
            },
            "permalink": "https://opensea.io/assets/matic/0xe7e16f2da731265778f87cb8d7850e31b84b7b86/3226",
            "collection": {
                "banner_image_url": null,
                "chat_url": null,
                "created_date": "2021-05-25T16:51:25.426643",
                "default_to_fiat": false,
                "description": null,
                "dev_buyer_fee_basis_points": "0",
                "dev_seller_fee_basis_points": "0",
                "discord_url": "https://discord.gg/embersword",
                "display_data": {
                    "card_display_style": "contain"
                },
                "external_url": "https://embersword.com",
                "featured": false,
                "featured_image_url": null,
                "hidden": true,
                "safelist_request_status": "not_requested",
                "image_url": "https://lh3.googleusercontent.com/J7SSCNIDh1ui59aoqyNywPtnUAUB-Q80Cnl1txbxmJOAIKcRJT1bUYidkDPNegOk2W0zyjqVkLbdcI6g6KTYgQCDplCo3DXpDSeaPg=s120",
                "is_subject_to_whitelist": false,
                "large_image_url": null,
                "medium_username": "embersword",
                "name": "Ember Sword Land",
                "only_proxied_transfers": false,
                "opensea_buyer_fee_basis_points": "0",
                "opensea_seller_fee_basis_points": "250",
                "payout_address": null,
                "require_email": false,
                "short_description": null,
                "slug": "embersword-land",
                "telegram_url": null,
                "twitter_username": "PlayEmberSword",
                "instagram_username": null,
                "wiki_url": null
            },
            "decimals": null,
            "token_metadata": "https://embersword.mypinata.cloud/ipfs/QmPBvismpsxQHcXSAXnXqZF3DDbyj81ssU1U8nrJ9bUqvf",
            "sell_orders": null,
            "creator": null,
            "traits": [
                {
                    "trait_type": "y-coordinate",
                    "value": 74,
                    "display_type": "number",
                    "max_value": null,
                    "trait_count": 0,
                    "order": null
                },
                {
                    "trait_type": "Type",
                    "value": "Land",
                    "display_type": null,
                    "max_value": null,
                    "trait_count": 2684,
                    "order": null
                },
                {
                    "trait_type": "x-coordinate",
                    "value": 100,
                    "display_type": "number",
                    "max_value": null,
                    "trait_count": 0,
                    "order": null
                }
            ],
            "last_sale": null,
            "top_bid": null,
            "listing_date": null,
            "is_presale": false,
            "transfer_fee_payment_token": null,
            "transfer_fee": null
        },
        {
            "id": 25679519,
            "token_id": "47766366388459299160607693266721037678819595091978348543102894652065149091841",
            "num_sales": 0,
            "background_color": null,
            "image_url": "https://lh3.googleusercontent.com/kCs0GynwrmdJr4xUskAEBJLgj3_LAHj71UO-kf0IncyzUy6pYYyXsih37PLBTHjJ2UeteMcPTu-VmcWSblk9dWCw9VfB_IJJYfEg85k",
            "image_preview_url": "https://lh3.googleusercontent.com/kCs0GynwrmdJr4xUskAEBJLgj3_LAHj71UO-kf0IncyzUy6pYYyXsih37PLBTHjJ2UeteMcPTu-VmcWSblk9dWCw9VfB_IJJYfEg85k=s250",
            "image_thumbnail_url": "https://lh3.googleusercontent.com/kCs0GynwrmdJr4xUskAEBJLgj3_LAHj71UO-kf0IncyzUy6pYYyXsih37PLBTHjJ2UeteMcPTu-VmcWSblk9dWCw9VfB_IJJYfEg85k=s128",
            "image_original_url": null,
            "animation_url": null,
            "animation_original_url": null,
            "name": "Birds",
            "description": null,
            "external_link": "https://www.instagram.com/p/CKB6Mags9kc/",
            "asset_contract": {
                "address": "0x495f947276749ce646f68ac8c248420045cb7b5e",
                "asset_contract_type": "semi-fungible",
                "created_date": "2020-12-02T17:40:53.232025",
                "name": "OpenSea Collection",
                "nft_version": null,
                "opensea_version": "2.0.0",
                "owner": 102384,
                "schema_name": "ERC1155",
                "symbol": "OPENSTORE",
                "total_supply": null,
                "description": null,
                "external_link": null,
                "image_url": null,
                "default_to_fiat": false,
                "dev_buyer_fee_basis_points": 0,
                "dev_seller_fee_basis_points": 0,
                "only_proxied_transfers": false,
                "opensea_buyer_fee_basis_points": 0,
                "opensea_seller_fee_basis_points": 250,
                "buyer_fee_basis_points": 0,
                "seller_fee_basis_points": 250,
                "payout_address": null
            },
            "owner": {
                "user": {
                    "username": "NullAddress"
                },
                "profile_img_url": "https://storage.googleapis.com/opensea-static/opensea-profile/1.png",
                "address": "0x0000000000000000000000000000000000000000",
                "config": "",
                "discord_id": ""
            },
            "permalink": "https://opensea.io/assets/0x495f947276749ce646f68ac8c248420045cb7b5e/47766366388459299160607693266721037678819595091978348543102894652065149091841",
            "collection": {
                "banner_image_url": null,
                "chat_url": null,
                "created_date": "2021-05-26T07:00:53.424909",
                "default_to_fiat": false,
                "description": "",
                "dev_buyer_fee_basis_points": "0",
                "dev_seller_fee_basis_points": "0",
                "discord_url": null,
                "display_data": {
                    "card_display_style": "contain",
                    "images": []
                },
                "external_url": null,
                "featured": false,
                "featured_image_url": null,
                "hidden": true,
                "safelist_request_status": "not_requested",
                "image_url": "https://lh3.googleusercontent.com/iar2XPXL2pi80rAzS98zUhYDnHsvv0ItgbrakhlTtZj4T2kZy_PYpDt38N3ob8CPwRjPg3VcA7gGXK3C-2owv-M6CGTCzEEdIw32lKA=s120",
                "is_subject_to_whitelist": false,
                "large_image_url": null,
                "medium_username": null,
                "name": "Tranquility in loneliness",
                "only_proxied_transfers": false,
                "opensea_buyer_fee_basis_points": "0",
                "opensea_seller_fee_basis_points": "250",
                "payout_address": null,
                "require_email": false,
                "short_description": null,
                "slug": "tranquility-in-loneliness",
                "telegram_url": null,
                "twitter_username": null,
                "instagram_username": null,
                "wiki_url": null
            },
            "decimals": null,
            "token_metadata": null,
            "sell_orders": null,
            "creator": {
                "user": {
                    "username": "AniYor"
                },
                "profile_img_url": "https://storage.googleapis.com/opensea-static/opensea-profile/10.png",
                "address": "0x699ace280a662a8be76f492127cb1d6255ea17da",
                "config": "",
                "discord_id": ""
            },
            "traits": [],
            "last_sale": null,
            "top_bid": null,
            "listing_date": null,
            "is_presale": true,
            "transfer_fee_payment_token": null,
            "transfer_fee": null
        },
        {
            "id": 25679518,
            "token_id": "425",
            "num_sales": 0,
            "background_color": null,
            "image_url": "",
            "image_preview_url": null,
            "image_thumbnail_url": null,
            "image_original_url": null,
            "animation_url": null,
            "animation_original_url": null,
            "name": null,
            "description": null,
            "external_link": null,
            "asset_contract": {
                "address": "0x8b4616926705fb61e9c4eeac07cd946a5d4b0760",
                "asset_contract_type": "non-fungible",
                "created_date": "2021-05-14T03:05:54.391738",
                "name": "Luchadores",
                "nft_version": "3.0",
                "opensea_version": null,
                "owner": 37427192,
                "schema_name": "ERC721",
                "symbol": "LUCHADORES",
                "total_supply": "0",
                "description": "Ethereum NFTs randomly generated using Chainlink VRF with millions of possible combinations and 100% on-chain art and metadata!\n\nOnly 10,000 will ever exist - Lucha!",
                "external_link": "http://luchadores.io",
                "image_url": "https://lh3.googleusercontent.com/1O1QI7IrnsiZNY4xIibiyQkyNJHsbxspPiX520SuIRH1sBpi47q8_KXAKi9R1hrEqlsCz3GRUqa4AsoF__k9lPG15rvnmZy8x7PK7ls=s120",
                "default_to_fiat": false,
                "dev_buyer_fee_basis_points": 0,
                "dev_seller_fee_basis_points": 100,
                "only_proxied_transfers": false,
                "opensea_buyer_fee_basis_points": 0,
                "opensea_seller_fee_basis_points": 250,
                "buyer_fee_basis_points": 0,
                "seller_fee_basis_points": 350,
                "payout_address": "0x147b8869655bc09f226955cc676ff78efe240ca8"
            },
            "owner": {
                "user": {
                    "username": "TweetyPie"
                },
                "profile_img_url": "https://storage.googleapis.com/opensea-static/opensea-profile/9.png",
                "address": "0xee402489d83e2b22d496910f8c810d35a3ad7b25",
                "config": "affiliate",
                "discord_id": ""
            },
            "permalink": "https://opensea.io/assets/0x8b4616926705fb61e9c4eeac07cd946a5d4b0760/425",
            "collection": {
                "banner_image_url": "https://lh3.googleusercontent.com/lVpN53ZCn4i206Q_W6Xi_YBooUgnXLZBSK6v1ovtbMYvTTLrYSpZ8BvMXD2Jr1Rkcw5uInyRMfSC_IYm_FVq5x32f6xYrDc-o8rF=s2500",
                "chat_url": null,
                "created_date": "2021-05-17T06:09:22.042386",
                "default_to_fiat": false,
                "description": "Ethereum NFTs randomly generated using Chainlink VRF with millions of possible combinations and 100% on-chain art and metadata!\n\nOnly 10,000 will ever exist - Lucha!",
                "dev_buyer_fee_basis_points": "0",
                "dev_seller_fee_basis_points": "100",
                "discord_url": "https://discord.gg/ERFgq2yAqc",
                "display_data": {
                    "card_display_style": "contain"
                },
                "external_url": "http://luchadores.io",
                "featured": false,
                "featured_image_url": "https://lh3.googleusercontent.com/H5RHOn1FEugS6u4OgdcQswj05HVb7KKtdYPSOBukQkFKI9WGB9KzUsNaPMw41xY2D74q9U2cGUPD5C4VmwlS4_DCFJcIfzQKd3B6kQ=s300",
                "hidden": true,
                "safelist_request_status": "not_requested",
                "image_url": "https://lh3.googleusercontent.com/1O1QI7IrnsiZNY4xIibiyQkyNJHsbxspPiX520SuIRH1sBpi47q8_KXAKi9R1hrEqlsCz3GRUqa4AsoF__k9lPG15rvnmZy8x7PK7ls=s120",
                "is_subject_to_whitelist": false,
                "large_image_url": "https://lh3.googleusercontent.com/H5RHOn1FEugS6u4OgdcQswj05HVb7KKtdYPSOBukQkFKI9WGB9KzUsNaPMw41xY2D74q9U2cGUPD5C4VmwlS4_DCFJcIfzQKd3B6kQ=s300",
                "medium_username": "LuchadoresNFT",
                "name": "Luchadores.io",
                "only_proxied_transfers": false,
                "opensea_buyer_fee_basis_points": "0",
                "opensea_seller_fee_basis_points": "250",
                "payout_address": "0x147b8869655bc09f226955cc676ff78efe240ca8",
                "require_email": false,
                "short_description": null,
                "slug": "luchadores-io",
                "telegram_url": null,
                "twitter_username": "LuchadoresNFT",
                "instagram_username": null,
                "wiki_url": null
            },
            "decimals": 0,
            "token_metadata": "https://storageapi.fleek.co/luchadores-io-team-bucket/425.json",
            "sell_orders": null,
            "creator": {
                "user": {
                    "username": "TweetyPie"
                },
                "profile_img_url": "https://storage.googleapis.com/opensea-static/opensea-profile/9.png",
                "address": "0xee402489d83e2b22d496910f8c810d35a3ad7b25",
                "config": "affiliate",
                "discord_id": ""
            },
            "traits": [],
            "last_sale": null,
            "top_bid": null,
            "listing_date": null,
            "is_presale": false,
            "transfer_fee_payment_token": null,
            "transfer_fee": null
        },
        {
            "id": 25679517,
            "token_id": "424",
            "num_sales": 0,
            "background_color": null,
            "image_url": "",
            "image_preview_url": null,
            "image_thumbnail_url": null,
            "image_original_url": null,
            "animation_url": null,
            "animation_original_url": null,
            "name": null,
            "description": null,
            "external_link": null,
            "asset_contract": {
                "address": "0x8b4616926705fb61e9c4eeac07cd946a5d4b0760",
                "asset_contract_type": "non-fungible",
                "created_date": "2021-05-14T03:05:54.391738",
                "name": "Luchadores",
                "nft_version": "3.0",
                "opensea_version": null,
                "owner": 37427192,
                "schema_name": "ERC721",
                "symbol": "LUCHADORES",
                "total_supply": "0",
                "description": "Ethereum NFTs randomly generated using Chainlink VRF with millions of possible combinations and 100% on-chain art and metadata!\n\nOnly 10,000 will ever exist - Lucha!",
                "external_link": "http://luchadores.io",
                "image_url": "https://lh3.googleusercontent.com/1O1QI7IrnsiZNY4xIibiyQkyNJHsbxspPiX520SuIRH1sBpi47q8_KXAKi9R1hrEqlsCz3GRUqa4AsoF__k9lPG15rvnmZy8x7PK7ls=s120",
                "default_to_fiat": false,
                "dev_buyer_fee_basis_points": 0,
                "dev_seller_fee_basis_points": 100,
                "only_proxied_transfers": false,
                "opensea_buyer_fee_basis_points": 0,
                "opensea_seller_fee_basis_points": 250,
                "buyer_fee_basis_points": 0,
                "seller_fee_basis_points": 350,
                "payout_address": "0x147b8869655bc09f226955cc676ff78efe240ca8"
            },
            "owner": {
                "user": {
                    "username": "TweetyPie"
                },
                "profile_img_url": "https://storage.googleapis.com/opensea-static/opensea-profile/9.png",
                "address": "0xee402489d83e2b22d496910f8c810d35a3ad7b25",
                "config": "affiliate",
                "discord_id": ""
            },
            "permalink": "https://opensea.io/assets/0x8b4616926705fb61e9c4eeac07cd946a5d4b0760/424",
            "collection": {
                "banner_image_url": "https://lh3.googleusercontent.com/lVpN53ZCn4i206Q_W6Xi_YBooUgnXLZBSK6v1ovtbMYvTTLrYSpZ8BvMXD2Jr1Rkcw5uInyRMfSC_IYm_FVq5x32f6xYrDc-o8rF=s2500",
                "chat_url": null,
                "created_date": "2021-05-17T06:09:22.042386",
                "default_to_fiat": false,
                "description": "Ethereum NFTs randomly generated using Chainlink VRF with millions of possible combinations and 100% on-chain art and metadata!\n\nOnly 10,000 will ever exist - Lucha!",
                "dev_buyer_fee_basis_points": "0",
                "dev_seller_fee_basis_points": "100",
                "discord_url": "https://discord.gg/ERFgq2yAqc",
                "display_data": {
                    "card_display_style": "contain"
                },
                "external_url": "http://luchadores.io",
                "featured": false,
                "featured_image_url": "https://lh3.googleusercontent.com/H5RHOn1FEugS6u4OgdcQswj05HVb7KKtdYPSOBukQkFKI9WGB9KzUsNaPMw41xY2D74q9U2cGUPD5C4VmwlS4_DCFJcIfzQKd3B6kQ=s300",
                "hidden": true,
                "safelist_request_status": "not_requested",
                "image_url": "https://lh3.googleusercontent.com/1O1QI7IrnsiZNY4xIibiyQkyNJHsbxspPiX520SuIRH1sBpi47q8_KXAKi9R1hrEqlsCz3GRUqa4AsoF__k9lPG15rvnmZy8x7PK7ls=s120",
                "is_subject_to_whitelist": false,
                "large_image_url": "https://lh3.googleusercontent.com/H5RHOn1FEugS6u4OgdcQswj05HVb7KKtdYPSOBukQkFKI9WGB9KzUsNaPMw41xY2D74q9U2cGUPD5C4VmwlS4_DCFJcIfzQKd3B6kQ=s300",
                "medium_username": "LuchadoresNFT",
                "name": "Luchadores.io",
                "only_proxied_transfers": false,
                "opensea_buyer_fee_basis_points": "0",
                "opensea_seller_fee_basis_points": "250",
                "payout_address": "0x147b8869655bc09f226955cc676ff78efe240ca8",
                "require_email": false,
                "short_description": null,
                "slug": "luchadores-io",
                "telegram_url": null,
                "twitter_username": "LuchadoresNFT",
                "instagram_username": null,
                "wiki_url": null
            },
            "decimals": 0,
            "token_metadata": "https://storageapi.fleek.co/luchadores-io-team-bucket/424.json",
            "sell_orders": null,
            "creator": {
                "user": {
                    "username": "TweetyPie"
                },
                "profile_img_url": "https://storage.googleapis.com/opensea-static/opensea-profile/9.png",
                "address": "0xee402489d83e2b22d496910f8c810d35a3ad7b25",
                "config": "affiliate",
                "discord_id": ""
            },
            "traits": [],
            "last_sale": null,
            "top_bid": null,
            "listing_date": null,
            "is_presale": false,
            "transfer_fee_payment_token": null,
            "transfer_fee": null
        },
        {
            "id": 25679516,
            "token_id": "423",
            "num_sales": 0,
            "background_color": null,
            "image_url": "",
            "image_preview_url": null,
            "image_thumbnail_url": null,
            "image_original_url": null,
            "animation_url": null,
            "animation_original_url": null,
            "name": null,
            "description": null,
            "external_link": null,
            "asset_contract": {
                "address": "0x8b4616926705fb61e9c4eeac07cd946a5d4b0760",
                "asset_contract_type": "non-fungible",
                "created_date": "2021-05-14T03:05:54.391738",
                "name": "Luchadores",
                "nft_version": "3.0",
                "opensea_version": null,
                "owner": 37427192,
                "schema_name": "ERC721",
                "symbol": "LUCHADORES",
                "total_supply": "0",
                "description": "Ethereum NFTs randomly generated using Chainlink VRF with millions of possible combinations and 100% on-chain art and metadata!\n\nOnly 10,000 will ever exist - Lucha!",
                "external_link": "http://luchadores.io",
                "image_url": "https://lh3.googleusercontent.com/1O1QI7IrnsiZNY4xIibiyQkyNJHsbxspPiX520SuIRH1sBpi47q8_KXAKi9R1hrEqlsCz3GRUqa4AsoF__k9lPG15rvnmZy8x7PK7ls=s120",
                "default_to_fiat": false,
                "dev_buyer_fee_basis_points": 0,
                "dev_seller_fee_basis_points": 100,
                "only_proxied_transfers": false,
                "opensea_buyer_fee_basis_points": 0,
                "opensea_seller_fee_basis_points": 250,
                "buyer_fee_basis_points": 0,
                "seller_fee_basis_points": 350,
                "payout_address": "0x147b8869655bc09f226955cc676ff78efe240ca8"
            },
            "owner": {
                "user": {
                    "username": "TweetyPie"
                },
                "profile_img_url": "https://storage.googleapis.com/opensea-static/opensea-profile/9.png",
                "address": "0xee402489d83e2b22d496910f8c810d35a3ad7b25",
                "config": "affiliate",
                "discord_id": ""
            },
            "permalink": "https://opensea.io/assets/0x8b4616926705fb61e9c4eeac07cd946a5d4b0760/423",
            "collection": {
                "banner_image_url": "https://lh3.googleusercontent.com/lVpN53ZCn4i206Q_W6Xi_YBooUgnXLZBSK6v1ovtbMYvTTLrYSpZ8BvMXD2Jr1Rkcw5uInyRMfSC_IYm_FVq5x32f6xYrDc-o8rF=s2500",
                "chat_url": null,
                "created_date": "2021-05-17T06:09:22.042386",
                "default_to_fiat": false,
                "description": "Ethereum NFTs randomly generated using Chainlink VRF with millions of possible combinations and 100% on-chain art and metadata!\n\nOnly 10,000 will ever exist - Lucha!",
                "dev_buyer_fee_basis_points": "0",
                "dev_seller_fee_basis_points": "100",
                "discord_url": "https://discord.gg/ERFgq2yAqc",
                "display_data": {
                    "card_display_style": "contain"
                },
                "external_url": "http://luchadores.io",
                "featured": false,
                "featured_image_url": "https://lh3.googleusercontent.com/H5RHOn1FEugS6u4OgdcQswj05HVb7KKtdYPSOBukQkFKI9WGB9KzUsNaPMw41xY2D74q9U2cGUPD5C4VmwlS4_DCFJcIfzQKd3B6kQ=s300",
                "hidden": true,
                "safelist_request_status": "not_requested",
                "image_url": "https://lh3.googleusercontent.com/1O1QI7IrnsiZNY4xIibiyQkyNJHsbxspPiX520SuIRH1sBpi47q8_KXAKi9R1hrEqlsCz3GRUqa4AsoF__k9lPG15rvnmZy8x7PK7ls=s120",
                "is_subject_to_whitelist": false,
                "large_image_url": "https://lh3.googleusercontent.com/H5RHOn1FEugS6u4OgdcQswj05HVb7KKtdYPSOBukQkFKI9WGB9KzUsNaPMw41xY2D74q9U2cGUPD5C4VmwlS4_DCFJcIfzQKd3B6kQ=s300",
                "medium_username": "LuchadoresNFT",
                "name": "Luchadores.io",
                "only_proxied_transfers": false,
                "opensea_buyer_fee_basis_points": "0",
                "opensea_seller_fee_basis_points": "250",
                "payout_address": "0x147b8869655bc09f226955cc676ff78efe240ca8",
                "require_email": false,
                "short_description": null,
                "slug": "luchadores-io",
                "telegram_url": null,
                "twitter_username": "LuchadoresNFT",
                "instagram_username": null,
                "wiki_url": null
            },
            "decimals": 0,
            "token_metadata": "https://storageapi.fleek.co/luchadores-io-team-bucket/423.json",
            "sell_orders": null,
            "creator": {
                "user": {
                    "username": "TweetyPie"
                },
                "profile_img_url": "https://storage.googleapis.com/opensea-static/opensea-profile/9.png",
                "address": "0xee402489d83e2b22d496910f8c810d35a3ad7b25",
                "config": "affiliate",
                "discord_id": ""
            },
            "traits": [],
            "last_sale": null,
            "top_bid": null,
            "listing_date": null,
            "is_presale": false,
            "transfer_fee_payment_token": null,
            "transfer_fee": null
        },
        {
            "id": 25679515,
            "token_id": "422",
            "num_sales": 0,
            "background_color": null,
            "image_url": "",
            "image_preview_url": null,
            "image_thumbnail_url": null,
            "image_original_url": null,
            "animation_url": null,
            "animation_original_url": null,
            "name": null,
            "description": null,
            "external_link": null,
            "asset_contract": {
                "address": "0x8b4616926705fb61e9c4eeac07cd946a5d4b0760",
                "asset_contract_type": "non-fungible",
                "created_date": "2021-05-14T03:05:54.391738",
                "name": "Luchadores",
                "nft_version": "3.0",
                "opensea_version": null,
                "owner": 37427192,
                "schema_name": "ERC721",
                "symbol": "LUCHADORES",
                "total_supply": "0",
                "description": "Ethereum NFTs randomly generated using Chainlink VRF with millions of possible combinations and 100% on-chain art and metadata!\n\nOnly 10,000 will ever exist - Lucha!",
                "external_link": "http://luchadores.io",
                "image_url": "https://lh3.googleusercontent.com/1O1QI7IrnsiZNY4xIibiyQkyNJHsbxspPiX520SuIRH1sBpi47q8_KXAKi9R1hrEqlsCz3GRUqa4AsoF__k9lPG15rvnmZy8x7PK7ls=s120",
                "default_to_fiat": false,
                "dev_buyer_fee_basis_points": 0,
                "dev_seller_fee_basis_points": 100,
                "only_proxied_transfers": false,
                "opensea_buyer_fee_basis_points": 0,
                "opensea_seller_fee_basis_points": 250,
                "buyer_fee_basis_points": 0,
                "seller_fee_basis_points": 350,
                "payout_address": "0x147b8869655bc09f226955cc676ff78efe240ca8"
            },
            "owner": {
                "user": {
                    "username": "TweetyPie"
                },
                "profile_img_url": "https://storage.googleapis.com/opensea-static/opensea-profile/9.png",
                "address": "0xee402489d83e2b22d496910f8c810d35a3ad7b25",
                "config": "affiliate",
                "discord_id": ""
            },
            "permalink": "https://opensea.io/assets/0x8b4616926705fb61e9c4eeac07cd946a5d4b0760/422",
            "collection": {
                "banner_image_url": "https://lh3.googleusercontent.com/lVpN53ZCn4i206Q_W6Xi_YBooUgnXLZBSK6v1ovtbMYvTTLrYSpZ8BvMXD2Jr1Rkcw5uInyRMfSC_IYm_FVq5x32f6xYrDc-o8rF=s2500",
                "chat_url": null,
                "created_date": "2021-05-17T06:09:22.042386",
                "default_to_fiat": false,
                "description": "Ethereum NFTs randomly generated using Chainlink VRF with millions of possible combinations and 100% on-chain art and metadata!\n\nOnly 10,000 will ever exist - Lucha!",
                "dev_buyer_fee_basis_points": "0",
                "dev_seller_fee_basis_points": "100",
                "discord_url": "https://discord.gg/ERFgq2yAqc",
                "display_data": {
                    "card_display_style": "contain"
                },
                "external_url": "http://luchadores.io",
                "featured": false,
                "featured_image_url": "https://lh3.googleusercontent.com/H5RHOn1FEugS6u4OgdcQswj05HVb7KKtdYPSOBukQkFKI9WGB9KzUsNaPMw41xY2D74q9U2cGUPD5C4VmwlS4_DCFJcIfzQKd3B6kQ=s300",
                "hidden": true,
                "safelist_request_status": "not_requested",
                "image_url": "https://lh3.googleusercontent.com/1O1QI7IrnsiZNY4xIibiyQkyNJHsbxspPiX520SuIRH1sBpi47q8_KXAKi9R1hrEqlsCz3GRUqa4AsoF__k9lPG15rvnmZy8x7PK7ls=s120",
                "is_subject_to_whitelist": false,
                "large_image_url": "https://lh3.googleusercontent.com/H5RHOn1FEugS6u4OgdcQswj05HVb7KKtdYPSOBukQkFKI9WGB9KzUsNaPMw41xY2D74q9U2cGUPD5C4VmwlS4_DCFJcIfzQKd3B6kQ=s300",
                "medium_username": "LuchadoresNFT",
                "name": "Luchadores.io",
                "only_proxied_transfers": false,
                "opensea_buyer_fee_basis_points": "0",
                "opensea_seller_fee_basis_points": "250",
                "payout_address": "0x147b8869655bc09f226955cc676ff78efe240ca8",
                "require_email": false,
                "short_description": null,
                "slug": "luchadores-io",
                "telegram_url": null,
                "twitter_username": "LuchadoresNFT",
                "instagram_username": null,
                "wiki_url": null
            },
            "decimals": 0,
            "token_metadata": "https://storageapi.fleek.co/luchadores-io-team-bucket/422.json",
            "sell_orders": null,
            "creator": {
                "user": {
                    "username": "TweetyPie"
                },
                "profile_img_url": "https://storage.googleapis.com/opensea-static/opensea-profile/9.png",
                "address": "0xee402489d83e2b22d496910f8c810d35a3ad7b25",
                "config": "affiliate",
                "discord_id": ""
            },
            "traits": [],
            "last_sale": null,
            "top_bid": null,
            "listing_date": null,
            "is_presale": false,
            "transfer_fee_payment_token": null,
            "transfer_fee": null
        },
        {
            "id": 25679514,
            "token_id": "421",
            "num_sales": 0,
            "background_color": null,
            "image_url": "",
            "image_preview_url": null,
            "image_thumbnail_url": null,
            "image_original_url": null,
            "animation_url": null,
            "animation_original_url": null,
            "name": null,
            "description": null,
            "external_link": null,
            "asset_contract": {
                "address": "0x8b4616926705fb61e9c4eeac07cd946a5d4b0760",
                "asset_contract_type": "non-fungible",
                "created_date": "2021-05-14T03:05:54.391738",
                "name": "Luchadores",
                "nft_version": "3.0",
                "opensea_version": null,
                "owner": 37427192,
                "schema_name": "ERC721",
                "symbol": "LUCHADORES",
                "total_supply": "0",
                "description": "Ethereum NFTs randomly generated using Chainlink VRF with millions of possible combinations and 100% on-chain art and metadata!\n\nOnly 10,000 will ever exist - Lucha!",
                "external_link": "http://luchadores.io",
                "image_url": "https://lh3.googleusercontent.com/1O1QI7IrnsiZNY4xIibiyQkyNJHsbxspPiX520SuIRH1sBpi47q8_KXAKi9R1hrEqlsCz3GRUqa4AsoF__k9lPG15rvnmZy8x7PK7ls=s120",
                "default_to_fiat": false,
                "dev_buyer_fee_basis_points": 0,
                "dev_seller_fee_basis_points": 100,
                "only_proxied_transfers": false,
                "opensea_buyer_fee_basis_points": 0,
                "opensea_seller_fee_basis_points": 250,
                "buyer_fee_basis_points": 0,
                "seller_fee_basis_points": 350,
                "payout_address": "0x147b8869655bc09f226955cc676ff78efe240ca8"
            },
            "owner": {
                "user": {
                    "username": "TweetyPie"
                },
                "profile_img_url": "https://storage.googleapis.com/opensea-static/opensea-profile/9.png",
                "address": "0xee402489d83e2b22d496910f8c810d35a3ad7b25",
                "config": "affiliate",
                "discord_id": ""
            },
            "permalink": "https://opensea.io/assets/0x8b4616926705fb61e9c4eeac07cd946a5d4b0760/421",
            "collection": {
                "banner_image_url": "https://lh3.googleusercontent.com/lVpN53ZCn4i206Q_W6Xi_YBooUgnXLZBSK6v1ovtbMYvTTLrYSpZ8BvMXD2Jr1Rkcw5uInyRMfSC_IYm_FVq5x32f6xYrDc-o8rF=s2500",
                "chat_url": null,
                "created_date": "2021-05-17T06:09:22.042386",
                "default_to_fiat": false,
                "description": "Ethereum NFTs randomly generated using Chainlink VRF with millions of possible combinations and 100% on-chain art and metadata!\n\nOnly 10,000 will ever exist - Lucha!",
                "dev_buyer_fee_basis_points": "0",
                "dev_seller_fee_basis_points": "100",
                "discord_url": "https://discord.gg/ERFgq2yAqc",
                "display_data": {
                    "card_display_style": "contain"
                },
                "external_url": "http://luchadores.io",
                "featured": false,
                "featured_image_url": "https://lh3.googleusercontent.com/H5RHOn1FEugS6u4OgdcQswj05HVb7KKtdYPSOBukQkFKI9WGB9KzUsNaPMw41xY2D74q9U2cGUPD5C4VmwlS4_DCFJcIfzQKd3B6kQ=s300",
                "hidden": true,
                "safelist_request_status": "not_requested",
                "image_url": "https://lh3.googleusercontent.com/1O1QI7IrnsiZNY4xIibiyQkyNJHsbxspPiX520SuIRH1sBpi47q8_KXAKi9R1hrEqlsCz3GRUqa4AsoF__k9lPG15rvnmZy8x7PK7ls=s120",
                "is_subject_to_whitelist": false,
                "large_image_url": "https://lh3.googleusercontent.com/H5RHOn1FEugS6u4OgdcQswj05HVb7KKtdYPSOBukQkFKI9WGB9KzUsNaPMw41xY2D74q9U2cGUPD5C4VmwlS4_DCFJcIfzQKd3B6kQ=s300",
                "medium_username": "LuchadoresNFT",
                "name": "Luchadores.io",
                "only_proxied_transfers": false,
                "opensea_buyer_fee_basis_points": "0",
                "opensea_seller_fee_basis_points": "250",
                "payout_address": "0x147b8869655bc09f226955cc676ff78efe240ca8",
                "require_email": false,
                "short_description": null,
                "slug": "luchadores-io",
                "telegram_url": null,
                "twitter_username": "LuchadoresNFT",
                "instagram_username": null,
                "wiki_url": null
            },
            "decimals": 0,
            "token_metadata": "https://storageapi.fleek.co/luchadores-io-team-bucket/421.json",
            "sell_orders": null,
            "creator": {
                "user": {
                    "username": "TweetyPie"
                },
                "profile_img_url": "https://storage.googleapis.com/opensea-static/opensea-profile/9.png",
                "address": "0xee402489d83e2b22d496910f8c810d35a3ad7b25",
                "config": "affiliate",
                "discord_id": ""
            },
            "traits": [],
            "last_sale": null,
            "top_bid": null,
            "listing_date": null,
            "is_presale": false,
            "transfer_fee_payment_token": null,
            "transfer_fee": null
        },
        {
            "id": 25679513,
            "token_id": "420",
            "num_sales": 0,
            "background_color": null,
            "image_url": "",
            "image_preview_url": null,
            "image_thumbnail_url": null,
            "image_original_url": null,
            "animation_url": null,
            "animation_original_url": null,
            "name": null,
            "description": null,
            "external_link": null,
            "asset_contract": {
                "address": "0x8b4616926705fb61e9c4eeac07cd946a5d4b0760",
                "asset_contract_type": "non-fungible",
                "created_date": "2021-05-14T03:05:54.391738",
                "name": "Luchadores",
                "nft_version": "3.0",
                "opensea_version": null,
                "owner": 37427192,
                "schema_name": "ERC721",
                "symbol": "LUCHADORES",
                "total_supply": "0",
                "description": "Ethereum NFTs randomly generated using Chainlink VRF with millions of possible combinations and 100% on-chain art and metadata!\n\nOnly 10,000 will ever exist - Lucha!",
                "external_link": "http://luchadores.io",
                "image_url": "https://lh3.googleusercontent.com/1O1QI7IrnsiZNY4xIibiyQkyNJHsbxspPiX520SuIRH1sBpi47q8_KXAKi9R1hrEqlsCz3GRUqa4AsoF__k9lPG15rvnmZy8x7PK7ls=s120",
                "default_to_fiat": false,
                "dev_buyer_fee_basis_points": 0,
                "dev_seller_fee_basis_points": 100,
                "only_proxied_transfers": false,
                "opensea_buyer_fee_basis_points": 0,
                "opensea_seller_fee_basis_points": 250,
                "buyer_fee_basis_points": 0,
                "seller_fee_basis_points": 350,
                "payout_address": "0x147b8869655bc09f226955cc676ff78efe240ca8"
            },
            "owner": {
                "user": {
                    "username": "TweetyPie"
                },
                "profile_img_url": "https://storage.googleapis.com/opensea-static/opensea-profile/9.png",
                "address": "0xee402489d83e2b22d496910f8c810d35a3ad7b25",
                "config": "affiliate",
                "discord_id": ""
            },
            "permalink": "https://opensea.io/assets/0x8b4616926705fb61e9c4eeac07cd946a5d4b0760/420",
            "collection": {
                "banner_image_url": "https://lh3.googleusercontent.com/lVpN53ZCn4i206Q_W6Xi_YBooUgnXLZBSK6v1ovtbMYvTTLrYSpZ8BvMXD2Jr1Rkcw5uInyRMfSC_IYm_FVq5x32f6xYrDc-o8rF=s2500",
                "chat_url": null,
                "created_date": "2021-05-17T06:09:22.042386",
                "default_to_fiat": false,
                "description": "Ethereum NFTs randomly generated using Chainlink VRF with millions of possible combinations and 100% on-chain art and metadata!\n\nOnly 10,000 will ever exist - Lucha!",
                "dev_buyer_fee_basis_points": "0",
                "dev_seller_fee_basis_points": "100",
                "discord_url": "https://discord.gg/ERFgq2yAqc",
                "display_data": {
                    "card_display_style": "contain"
                },
                "external_url": "http://luchadores.io",
                "featured": false,
                "featured_image_url": "https://lh3.googleusercontent.com/H5RHOn1FEugS6u4OgdcQswj05HVb7KKtdYPSOBukQkFKI9WGB9KzUsNaPMw41xY2D74q9U2cGUPD5C4VmwlS4_DCFJcIfzQKd3B6kQ=s300",
                "hidden": true,
                "safelist_request_status": "not_requested",
                "image_url": "https://lh3.googleusercontent.com/1O1QI7IrnsiZNY4xIibiyQkyNJHsbxspPiX520SuIRH1sBpi47q8_KXAKi9R1hrEqlsCz3GRUqa4AsoF__k9lPG15rvnmZy8x7PK7ls=s120",
                "is_subject_to_whitelist": false,
                "large_image_url": "https://lh3.googleusercontent.com/H5RHOn1FEugS6u4OgdcQswj05HVb7KKtdYPSOBukQkFKI9WGB9KzUsNaPMw41xY2D74q9U2cGUPD5C4VmwlS4_DCFJcIfzQKd3B6kQ=s300",
                "medium_username": "LuchadoresNFT",
                "name": "Luchadores.io",
                "only_proxied_transfers": false,
                "opensea_buyer_fee_basis_points": "0",
                "opensea_seller_fee_basis_points": "250",
                "payout_address": "0x147b8869655bc09f226955cc676ff78efe240ca8",
                "require_email": false,
                "short_description": null,
                "slug": "luchadores-io",
                "telegram_url": null,
                "twitter_username": "LuchadoresNFT",
                "instagram_username": null,
                "wiki_url": null
            },
            "decimals": 0,
            "token_metadata": "https://storageapi.fleek.co/luchadores-io-team-bucket/420.json",
            "sell_orders": null,
            "creator": {
                "user": {
                    "username": "TweetyPie"
                },
                "profile_img_url": "https://storage.googleapis.com/opensea-static/opensea-profile/9.png",
                "address": "0xee402489d83e2b22d496910f8c810d35a3ad7b25",
                "config": "affiliate",
                "discord_id": ""
            },
            "traits": [],
            "last_sale": null,
            "top_bid": null,
            "listing_date": null,
            "is_presale": false,
            "transfer_fee_payment_token": null,
            "transfer_fee": null
        },
        {
            "id": 25679512,
            "token_id": "419",
            "num_sales": 0,
            "background_color": null,
            "image_url": "",
            "image_preview_url": null,
            "image_thumbnail_url": null,
            "image_original_url": null,
            "animation_url": null,
            "animation_original_url": null,
            "name": null,
            "description": null,
            "external_link": null,
            "asset_contract": {
                "address": "0x8b4616926705fb61e9c4eeac07cd946a5d4b0760",
                "asset_contract_type": "non-fungible",
                "created_date": "2021-05-14T03:05:54.391738",
                "name": "Luchadores",
                "nft_version": "3.0",
                "opensea_version": null,
                "owner": 37427192,
                "schema_name": "ERC721",
                "symbol": "LUCHADORES",
                "total_supply": "0",
                "description": "Ethereum NFTs randomly generated using Chainlink VRF with millions of possible combinations and 100% on-chain art and metadata!\n\nOnly 10,000 will ever exist - Lucha!",
                "external_link": "http://luchadores.io",
                "image_url": "https://lh3.googleusercontent.com/1O1QI7IrnsiZNY4xIibiyQkyNJHsbxspPiX520SuIRH1sBpi47q8_KXAKi9R1hrEqlsCz3GRUqa4AsoF__k9lPG15rvnmZy8x7PK7ls=s120",
                "default_to_fiat": false,
                "dev_buyer_fee_basis_points": 0,
                "dev_seller_fee_basis_points": 100,
                "only_proxied_transfers": false,
                "opensea_buyer_fee_basis_points": 0,
                "opensea_seller_fee_basis_points": 250,
                "buyer_fee_basis_points": 0,
                "seller_fee_basis_points": 350,
                "payout_address": "0x147b8869655bc09f226955cc676ff78efe240ca8"
            },
            "owner": {
                "user": {
                    "username": "TweetyPie"
                },
                "profile_img_url": "https://storage.googleapis.com/opensea-static/opensea-profile/9.png",
                "address": "0xee402489d83e2b22d496910f8c810d35a3ad7b25",
                "config": "affiliate",
                "discord_id": ""
            },
            "permalink": "https://opensea.io/assets/0x8b4616926705fb61e9c4eeac07cd946a5d4b0760/419",
            "collection": {
                "banner_image_url": "https://lh3.googleusercontent.com/lVpN53ZCn4i206Q_W6Xi_YBooUgnXLZBSK6v1ovtbMYvTTLrYSpZ8BvMXD2Jr1Rkcw5uInyRMfSC_IYm_FVq5x32f6xYrDc-o8rF=s2500",
                "chat_url": null,
                "created_date": "2021-05-17T06:09:22.042386",
                "default_to_fiat": false,
                "description": "Ethereum NFTs randomly generated using Chainlink VRF with millions of possible combinations and 100% on-chain art and metadata!\n\nOnly 10,000 will ever exist - Lucha!",
                "dev_buyer_fee_basis_points": "0",
                "dev_seller_fee_basis_points": "100",
                "discord_url": "https://discord.gg/ERFgq2yAqc",
                "display_data": {
                    "card_display_style": "contain"
                },
                "external_url": "http://luchadores.io",
                "featured": false,
                "featured_image_url": "https://lh3.googleusercontent.com/H5RHOn1FEugS6u4OgdcQswj05HVb7KKtdYPSOBukQkFKI9WGB9KzUsNaPMw41xY2D74q9U2cGUPD5C4VmwlS4_DCFJcIfzQKd3B6kQ=s300",
                "hidden": true,
                "safelist_request_status": "not_requested",
                "image_url": "https://lh3.googleusercontent.com/1O1QI7IrnsiZNY4xIibiyQkyNJHsbxspPiX520SuIRH1sBpi47q8_KXAKi9R1hrEqlsCz3GRUqa4AsoF__k9lPG15rvnmZy8x7PK7ls=s120",
                "is_subject_to_whitelist": false,
                "large_image_url": "https://lh3.googleusercontent.com/H5RHOn1FEugS6u4OgdcQswj05HVb7KKtdYPSOBukQkFKI9WGB9KzUsNaPMw41xY2D74q9U2cGUPD5C4VmwlS4_DCFJcIfzQKd3B6kQ=s300",
                "medium_username": "LuchadoresNFT",
                "name": "Luchadores.io",
                "only_proxied_transfers": false,
                "opensea_buyer_fee_basis_points": "0",
                "opensea_seller_fee_basis_points": "250",
                "payout_address": "0x147b8869655bc09f226955cc676ff78efe240ca8",
                "require_email": false,
                "short_description": null,
                "slug": "luchadores-io",
                "telegram_url": null,
                "twitter_username": "LuchadoresNFT",
                "instagram_username": null,
                "wiki_url": null
            },
            "decimals": 0,
            "token_metadata": "https://storageapi.fleek.co/luchadores-io-team-bucket/419.json",
            "sell_orders": null,
            "creator": {
                "user": {
                    "username": "TweetyPie"
                },
                "profile_img_url": "https://storage.googleapis.com/opensea-static/opensea-profile/9.png",
                "address": "0xee402489d83e2b22d496910f8c810d35a3ad7b25",
                "config": "affiliate",
                "discord_id": ""
            },
            "traits": [],
            "last_sale": null,
            "top_bid": null,
            "listing_date": null,
            "is_presale": false,
            "transfer_fee_payment_token": null,
            "transfer_fee": null
        },
        {
            "id": 25679511,
            "token_id": "418",
            "num_sales": 0,
            "background_color": null,
            "image_url": "",
            "image_preview_url": null,
            "image_thumbnail_url": null,
            "image_original_url": null,
            "animation_url": null,
            "animation_original_url": null,
            "name": null,
            "description": null,
            "external_link": null,
            "asset_contract": {
                "address": "0x8b4616926705fb61e9c4eeac07cd946a5d4b0760",
                "asset_contract_type": "non-fungible",
                "created_date": "2021-05-14T03:05:54.391738",
                "name": "Luchadores",
                "nft_version": "3.0",
                "opensea_version": null,
                "owner": 37427192,
                "schema_name": "ERC721",
                "symbol": "LUCHADORES",
                "total_supply": "0",
                "description": "Ethereum NFTs randomly generated using Chainlink VRF with millions of possible combinations and 100% on-chain art and metadata!\n\nOnly 10,000 will ever exist - Lucha!",
                "external_link": "http://luchadores.io",
                "image_url": "https://lh3.googleusercontent.com/1O1QI7IrnsiZNY4xIibiyQkyNJHsbxspPiX520SuIRH1sBpi47q8_KXAKi9R1hrEqlsCz3GRUqa4AsoF__k9lPG15rvnmZy8x7PK7ls=s120",
                "default_to_fiat": false,
                "dev_buyer_fee_basis_points": 0,
                "dev_seller_fee_basis_points": 100,
                "only_proxied_transfers": false,
                "opensea_buyer_fee_basis_points": 0,
                "opensea_seller_fee_basis_points": 250,
                "buyer_fee_basis_points": 0,
                "seller_fee_basis_points": 350,
                "payout_address": "0x147b8869655bc09f226955cc676ff78efe240ca8"
            },
            "owner": {
                "user": {
                    "username": "TweetyPie"
                },
                "profile_img_url": "https://storage.googleapis.com/opensea-static/opensea-profile/9.png",
                "address": "0xee402489d83e2b22d496910f8c810d35a3ad7b25",
                "config": "affiliate",
                "discord_id": ""
            },
            "permalink": "https://opensea.io/assets/0x8b4616926705fb61e9c4eeac07cd946a5d4b0760/418",
            "collection": {
                "banner_image_url": "https://lh3.googleusercontent.com/lVpN53ZCn4i206Q_W6Xi_YBooUgnXLZBSK6v1ovtbMYvTTLrYSpZ8BvMXD2Jr1Rkcw5uInyRMfSC_IYm_FVq5x32f6xYrDc-o8rF=s2500",
                "chat_url": null,
                "created_date": "2021-05-17T06:09:22.042386",
                "default_to_fiat": false,
                "description": "Ethereum NFTs randomly generated using Chainlink VRF with millions of possible combinations and 100% on-chain art and metadata!\n\nOnly 10,000 will ever exist - Lucha!",
                "dev_buyer_fee_basis_points": "0",
                "dev_seller_fee_basis_points": "100",
                "discord_url": "https://discord.gg/ERFgq2yAqc",
                "display_data": {
                    "card_display_style": "contain"
                },
                "external_url": "http://luchadores.io",
                "featured": false,
                "featured_image_url": "https://lh3.googleusercontent.com/H5RHOn1FEugS6u4OgdcQswj05HVb7KKtdYPSOBukQkFKI9WGB9KzUsNaPMw41xY2D74q9U2cGUPD5C4VmwlS4_DCFJcIfzQKd3B6kQ=s300",
                "hidden": true,
                "safelist_request_status": "not_requested",
                "image_url": "https://lh3.googleusercontent.com/1O1QI7IrnsiZNY4xIibiyQkyNJHsbxspPiX520SuIRH1sBpi47q8_KXAKi9R1hrEqlsCz3GRUqa4AsoF__k9lPG15rvnmZy8x7PK7ls=s120",
                "is_subject_to_whitelist": false,
                "large_image_url": "https://lh3.googleusercontent.com/H5RHOn1FEugS6u4OgdcQswj05HVb7KKtdYPSOBukQkFKI9WGB9KzUsNaPMw41xY2D74q9U2cGUPD5C4VmwlS4_DCFJcIfzQKd3B6kQ=s300",
                "medium_username": "LuchadoresNFT",
                "name": "Luchadores.io",
                "only_proxied_transfers": false,
                "opensea_buyer_fee_basis_points": "0",
                "opensea_seller_fee_basis_points": "250",
                "payout_address": "0x147b8869655bc09f226955cc676ff78efe240ca8",
                "require_email": false,
                "short_description": null,
                "slug": "luchadores-io",
                "telegram_url": null,
                "twitter_username": "LuchadoresNFT",
                "instagram_username": null,
                "wiki_url": null
            },
            "decimals": 0,
            "token_metadata": "https://storageapi.fleek.co/luchadores-io-team-bucket/418.json",
            "sell_orders": null,
            "creator": {
                "user": {
                    "username": "TweetyPie"
                },
                "profile_img_url": "https://storage.googleapis.com/opensea-static/opensea-profile/9.png",
                "address": "0xee402489d83e2b22d496910f8c810d35a3ad7b25",
                "config": "affiliate",
                "discord_id": ""
            },
            "traits": [],
            "last_sale": null,
            "top_bid": null,
            "listing_date": null,
            "is_presale": false,
            "transfer_fee_payment_token": null,
            "transfer_fee": null
        },
        {
            "id": 25679510,
            "token_id": "3225",
            "num_sales": 0,
            "background_color": null,
            "image_url": "https://lh3.googleusercontent.com/3G09bcOjSfkbIiCnDTPdcifXndMofduTa9W4fLYcKDu45DoRdLrABJIaa8zFGe9iPTWyAKep2ajzP1wIQ0o5YiWG45xUiPsKgMoogQ",
            "image_preview_url": "https://lh3.googleusercontent.com/3G09bcOjSfkbIiCnDTPdcifXndMofduTa9W4fLYcKDu45DoRdLrABJIaa8zFGe9iPTWyAKep2ajzP1wIQ0o5YiWG45xUiPsKgMoogQ=s250",
            "image_thumbnail_url": "https://lh3.googleusercontent.com/3G09bcOjSfkbIiCnDTPdcifXndMofduTa9W4fLYcKDu45DoRdLrABJIaa8zFGe9iPTWyAKep2ajzP1wIQ0o5YiWG45xUiPsKgMoogQ=s128",
            "image_original_url": "https://embersword.mypinata.cloud/ipfs/QmdbeV27CatL3EddMf2Ek1jGt77amKgb5ghVeHrKWLyz84",
            "animation_url": "https://storage.opensea.io/files/b0cc4d04cbc1f26c66e7511d64cd2d9e.mp4",
            "animation_original_url": "https://embersword.mypinata.cloud/ipfs/QmfKgvFupW1dm9W3UusnrGKrabMT6hTD2DkhG27hAU7Lxx",
            "name": "Land (104,75)",
            "description": "Land plot",
            "external_link": null,
            "asset_contract": {
                "address": "0xe7e16f2da731265778f87cb8d7850e31b84b7b86",
                "asset_contract_type": "non-fungible",
                "created_date": "2021-05-25T13:23:10.895540",
                "name": "Embersword Land",
                "nft_version": null,
                "opensea_version": null,
                "owner": 35978059,
                "schema_name": "ERC721",
                "symbol": "LAND",
                "total_supply": "0",
                "description": null,
                "external_link": "https://embersword.com",
                "image_url": "https://lh3.googleusercontent.com/J7SSCNIDh1ui59aoqyNywPtnUAUB-Q80Cnl1txbxmJOAIKcRJT1bUYidkDPNegOk2W0zyjqVkLbdcI6g6KTYgQCDplCo3DXpDSeaPg=s120",
                "default_to_fiat": false,
                "dev_buyer_fee_basis_points": 0,
                "dev_seller_fee_basis_points": 0,
                "only_proxied_transfers": false,
                "opensea_buyer_fee_basis_points": 0,
                "opensea_seller_fee_basis_points": 250,
                "buyer_fee_basis_points": 0,
                "seller_fee_basis_points": 250,
                "payout_address": null
            },
            "owner": {
                "user": null,
                "profile_img_url": "https://storage.googleapis.com/opensea-static/opensea-profile/1.png",
                "address": "0x0000000000000000000000000000000000000000",
                "config": "",
                "discord_id": ""
            },
            "permalink": "https://opensea.io/assets/matic/0xe7e16f2da731265778f87cb8d7850e31b84b7b86/3225",
            "collection": {
                "banner_image_url": null,
                "chat_url": null,
                "created_date": "2021-05-25T16:51:25.426643",
                "default_to_fiat": false,
                "description": null,
                "dev_buyer_fee_basis_points": "0",
                "dev_seller_fee_basis_points": "0",
                "discord_url": "https://discord.gg/embersword",
                "display_data": {
                    "card_display_style": "contain"
                },
                "external_url": "https://embersword.com",
                "featured": false,
                "featured_image_url": null,
                "hidden": true,
                "safelist_request_status": "not_requested",
                "image_url": "https://lh3.googleusercontent.com/J7SSCNIDh1ui59aoqyNywPtnUAUB-Q80Cnl1txbxmJOAIKcRJT1bUYidkDPNegOk2W0zyjqVkLbdcI6g6KTYgQCDplCo3DXpDSeaPg=s120",
                "is_subject_to_whitelist": false,
                "large_image_url": null,
                "medium_username": "embersword",
                "name": "Ember Sword Land",
                "only_proxied_transfers": false,
                "opensea_buyer_fee_basis_points": "0",
                "opensea_seller_fee_basis_points": "250",
                "payout_address": null,
                "require_email": false,
                "short_description": null,
                "slug": "embersword-land",
                "telegram_url": null,
                "twitter_username": "PlayEmberSword",
                "instagram_username": null,
                "wiki_url": null
            },
            "decimals": null,
            "token_metadata": "https://embersword.mypinata.cloud/ipfs/QmVnRcsa3CPG9uZXkAkzjohitgHWGhFqsY3YWVoimqPxmE",
            "sell_orders": null,
            "creator": null,
            "traits": [
                {
                    "trait_type": "x-coordinate",
                    "value": 104,
                    "display_type": "number",
                    "max_value": null,
                    "trait_count": 0,
                    "order": null
                },
                {
                    "trait_type": "Type",
                    "value": "Land",
                    "display_type": null,
                    "max_value": null,
                    "trait_count": 2684,
                    "order": null
                },
                {
                    "trait_type": "y-coordinate",
                    "value": 75,
                    "display_type": "number",
                    "max_value": null,
                    "trait_count": 0,
                    "order": null
                }
            ],
            "last_sale": null,
            "top_bid": null,
            "listing_date": null,
            "is_presale": false,
            "transfer_fee_payment_token": null,
            "transfer_fee": null
        },
        {
            "id": 25679509,
            "token_id": "68381593716562865563152099600931244155486109678084785848427647725289374482433",
            "num_sales": 0,
            "background_color": null,
            "image_url": "https://lh3.googleusercontent.com/hcmlJjvtDYjoPRVLkyruLKWX0FtiKEoUwogxSjcZaclcYgn-Yzqhiq-OWWg-pmp_WxqO1LeUYhW14uwFIGnWjf34W_GV0jfOp07w",
            "image_preview_url": "https://lh3.googleusercontent.com/hcmlJjvtDYjoPRVLkyruLKWX0FtiKEoUwogxSjcZaclcYgn-Yzqhiq-OWWg-pmp_WxqO1LeUYhW14uwFIGnWjf34W_GV0jfOp07w=s250",
            "image_thumbnail_url": "https://lh3.googleusercontent.com/hcmlJjvtDYjoPRVLkyruLKWX0FtiKEoUwogxSjcZaclcYgn-Yzqhiq-OWWg-pmp_WxqO1LeUYhW14uwFIGnWjf34W_GV0jfOp07w=s128",
            "image_original_url": null,
            "animation_url": null,
            "animation_original_url": null,
            "name": "Millennium Album #2",
            "description": "Very cool guys will perform an incendiary village song for you.\n#Sister of Peace #Greenpeace #Cats #The Great Judge #digital arts #art #nft #opensea #old school cats #old school #cat #animals #charity work #space #lesson #friend #teacher #love #world #Emotional support animal #in wonderland #poster #green #peace #song #village #summer #country",
            "external_link": null,
            "asset_contract": {
                "address": "0x495f947276749ce646f68ac8c248420045cb7b5e",
                "asset_contract_type": "semi-fungible",
                "created_date": "2020-12-02T17:40:53.232025",
                "name": "OpenSea Collection",
                "nft_version": null,
                "opensea_version": "2.0.0",
                "owner": 102384,
                "schema_name": "ERC1155",
                "symbol": "OPENSTORE",
                "total_supply": null,
                "description": null,
                "external_link": null,
                "image_url": null,
                "default_to_fiat": false,
                "dev_buyer_fee_basis_points": 0,
                "dev_seller_fee_basis_points": 0,
                "only_proxied_transfers": false,
                "opensea_buyer_fee_basis_points": 0,
                "opensea_seller_fee_basis_points": 250,
                "buyer_fee_basis_points": 0,
                "seller_fee_basis_points": 250,
                "payout_address": null
            },
            "owner": {
                "user": {
                    "username": "NullAddress"
                },
                "profile_img_url": "https://storage.googleapis.com/opensea-static/opensea-profile/1.png",
                "address": "0x0000000000000000000000000000000000000000",
                "config": "",
                "discord_id": ""
            },
            "permalink": "https://opensea.io/assets/0x495f947276749ce646f68ac8c248420045cb7b5e/68381593716562865563152099600931244155486109678084785848427647725289374482433",
            "collection": {
                "banner_image_url": "https://lh3.googleusercontent.com/AaGfVBZocwNbaN0eTJID62Abm8lryH5A9YK0dEoPaYkBF8O76S40xviPTIwISvt_8gGB_neJRG_-CgjvVgEyqOnjItPSFGbOm9DG=s2500",
                "chat_url": null,
                "created_date": "2021-04-11T17:00:14.948242",
                "default_to_fiat": false,
                "description": "Did you really think that love would save the world? In fact, no, the world will only be saved by our furry friends. And alas, most likely, we will no longer be in this world... Straight from a harsh and cold country. The adventures of Feofan and Marusia. The world has never seen such cats...",
                "dev_buyer_fee_basis_points": "0",
                "dev_seller_fee_basis_points": "1000",
                "discord_url": null,
                "display_data": {
                    "card_display_style": "cover"
                },
                "external_url": null,
                "featured": false,
                "featured_image_url": "https://lh3.googleusercontent.com/pfarEveIBlwAxhk9GfOQUY6bQxQwTCpQQ0kMC4pZ_FGqFbUH7RJyKgOpYNr8KpF00JkvVNIhZVEOGjZwh15uuCdnERMqrTlxdCHp=s300",
                "hidden": true,
                "safelist_request_status": "not_requested",
                "image_url": "https://lh3.googleusercontent.com/xLf539sDWYtr86Le9CVt-t8OrWYxYbspEf3Ewg91r4cJH8B6NfF5MBK4gwVdXMH43Be5a9vs9ih8UvXAHJtjelORQYRdyi7wnylP=s120",
                "is_subject_to_whitelist": false,
                "large_image_url": "https://lh3.googleusercontent.com/pfarEveIBlwAxhk9GfOQUY6bQxQwTCpQQ0kMC4pZ_FGqFbUH7RJyKgOpYNr8KpF00JkvVNIhZVEOGjZwh15uuCdnERMqrTlxdCHp=s300",
                "medium_username": null,
                "name": "Old School Cats",
                "only_proxied_transfers": false,
                "opensea_buyer_fee_basis_points": "0",
                "opensea_seller_fee_basis_points": "250",
                "payout_address": "0x972e9c4812a53044a0457a10a9fc973e8804577c",
                "require_email": false,
                "short_description": null,
                "slug": "old-school-cats",
                "telegram_url": null,
                "twitter_username": null,
                "instagram_username": "oldschool_cats",
                "wiki_url": null
            },
            "decimals": null,
            "token_metadata": null,
            "sell_orders": [
                {
                    "created_date": "2021-05-26T07:36:50.472582",
                    "closing_date": null,
                    "closing_extendable": false,
                    "expiration_time": 0,
                    "listing_time": 1622014490,
                    "order_hash": "0x9a6e56d173006fa323bdf13fb18697148b6f3bc1f6452beb62872d81392e8955",
                    "metadata": {
                        "asset": {
                            "id": "68381593716562865563152099600931244155486109678084785848427647725289374482433",
                            "address": "0x495f947276749ce646f68ac8c248420045cb7b5e",
                            "quantity": "1"
                        },
                        "schema": "ERC1155"
                    },
                    "exchange": "0x7be8076f4ea4a4ad08075c2508e481d6c946d12b",
                    "maker": {
                        "user": 547885,
                        "profile_img_url": "https://storage.googleapis.com/opensea-static/opensea-profile/13.png",
                        "address": "0x972e9c4812a53044a0457a10a9fc973e8804577c",
                        "config": "",
                        "discord_id": ""
                    },
                    "taker": {
                        "user": 1766,
                        "profile_img_url": "https://storage.googleapis.com/opensea-static/opensea-profile/1.png",
                        "address": "0x0000000000000000000000000000000000000000",
                        "config": "",
                        "discord_id": ""
                    },
                    "current_price": "61000000000000000",
                    "current_bounty": "610000000000000",
                    "bounty_multiple": "0.01",
                    "maker_relayer_fee": "1250",
                    "taker_relayer_fee": "0",
                    "maker_protocol_fee": "0",
                    "taker_protocol_fee": "0",
                    "maker_referrer_fee": "0",
                    "fee_recipient": {
                        "user": 3585,
                        "profile_img_url": "https://storage.googleapis.com/opensea-static/opensea-profile/28.png",
                        "address": "0x5b3256965e7c3cf26e11fcaf296dfc8807c01073",
                        "config": "verified",
                        "discord_id": ""
                    },
                    "fee_method": 1,
                    "side": 1,
                    "sale_kind": 0,
                    "target": "0x495f947276749ce646f68ac8c248420045cb7b5e",
                    "how_to_call": 0,
                    "calldata": "0xf242432a000000000000000000000000972e9c4812a53044a0457a10a9fc973e8804577c0000000000000000000000000000000000000000000000000000000000000000972e9c4812a53044a0457a10a9fc973e8804577c0000000000006a0000000001000000000000000000000000000000000000000000000000000000000000000100000000000000000000000000000000000000000000000000000000000000a00000000000000000000000000000000000000000000000000000000000000000",
                    "replacement_pattern": "0x000000000000000000000000000000000000000000000000000000000000000000000000ffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffff0000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000",
                    "static_target": "0x0000000000000000000000000000000000000000",
                    "static_extradata": "0x",
                    "payment_token": "0x0000000000000000000000000000000000000000",
                    "payment_token_contract": {
                        "id": 1,
                        "symbol": "ETH",
                        "address": "0x0000000000000000000000000000000000000000",
                        "image_url": "https://storage.opensea.io/files/6f8e2979d428180222796ff4a33ab929.svg",
                        "name": "Ether",
                        "decimals": 18,
                        "eth_price": "1.000000000000000",
                        "usd_price": "2869.690000000000055000"
                    },
                    "base_price": "61000000000000000",
                    "extra": "0",
                    "quantity": "1",
                    "salt": "19250245200554649776499923038412095466636895029240061906979933658284404955916",
                    "v": 28,
                    "r": "0x54e76870225cde94d2591a7ee32ecde015f3d30a530ce519be18f8a84e3039ae",
                    "s": "0x29d7efcf23b276e1ec3243a063c61cdfc90ceb0f2079233e5501297e27e794b9",
                    "approved_on_chain": false,
                    "cancelled": false,
                    "finalized": false,
                    "marked_invalid": false,
                    "prefixed_hash": "0x0b2cd52034e3e89996478eaa653aad652a1ae3c4a01f58096d23ab5d114df57a"
                }
            ],
            "creator": {
                "user": {
                    "username": "oldschool-cats"
                },
                "profile_img_url": "https://storage.googleapis.com/opensea-static/opensea-profile/13.png",
                "address": "0x972e9c4812a53044a0457a10a9fc973e8804577c",
                "config": "",
                "discord_id": ""
            },
            "traits": [],
            "last_sale": null,
            "top_bid": null,
            "listing_date": null,
            "is_presale": true,
            "transfer_fee_payment_token": null,
            "transfer_fee": null
        },
        {
            "id": 25679508,
            "token_id": "92543519409568867879750819370118129134728669630078946162231600106737458216961",
            "num_sales": 0,
            "background_color": null,
            "image_url": "https://lh3.googleusercontent.com/VYid54fkR4F69cdoAMqgig6SVOeNGDWQva0tFiuYU3J69a7WgKhL7aFZIc2zDVV8-FLXZFL_Pup24yRxJOZJVrus2IYM6lbHW-UB",
            "image_preview_url": "https://lh3.googleusercontent.com/VYid54fkR4F69cdoAMqgig6SVOeNGDWQva0tFiuYU3J69a7WgKhL7aFZIc2zDVV8-FLXZFL_Pup24yRxJOZJVrus2IYM6lbHW-UB=s250",
            "image_thumbnail_url": "https://lh3.googleusercontent.com/VYid54fkR4F69cdoAMqgig6SVOeNGDWQva0tFiuYU3J69a7WgKhL7aFZIc2zDVV8-FLXZFL_Pup24yRxJOZJVrus2IYM6lbHW-UB=s128",
            "image_original_url": null,
            "animation_url": null,
            "animation_original_url": null,
            "name": "# 208 Mauricio",
            "description": "NFT collectible. \"Mauri\" es un hipocorístico del nombre Mauricio.",
            "external_link": null,
            "asset_contract": {
                "address": "0x495f947276749ce646f68ac8c248420045cb7b5e",
                "asset_contract_type": "semi-fungible",
                "created_date": "2020-12-02T17:40:53.232025",
                "name": "OpenSea Collection",
                "nft_version": null,
                "opensea_version": "2.0.0",
                "owner": 102384,
                "schema_name": "ERC1155",
                "symbol": "OPENSTORE",
                "total_supply": null,
                "description": null,
                "external_link": null,
                "image_url": null,
                "default_to_fiat": false,
                "dev_buyer_fee_basis_points": 0,
                "dev_seller_fee_basis_points": 0,
                "only_proxied_transfers": false,
                "opensea_buyer_fee_basis_points": 0,
                "opensea_seller_fee_basis_points": 250,
                "buyer_fee_basis_points": 0,
                "seller_fee_basis_points": 250,
                "payout_address": null
            },
            "owner": {
                "user": {
                    "username": "NullAddress"
                },
                "profile_img_url": "https://storage.googleapis.com/opensea-static/opensea-profile/1.png",
                "address": "0x0000000000000000000000000000000000000000",
                "config": "",
                "discord_id": ""
            },
            "permalink": "https://opensea.io/assets/0x495f947276749ce646f68ac8c248420045cb7b5e/92543519409568867879750819370118129134728669630078946162231600106737458216961",
            "collection": {
                "banner_image_url": "https://lh3.googleusercontent.com/uH7yNGevk3Ba9dI976yyWLHLZIIQ2PQICfGT54szB3NaCNNJ08Y_JPjp8pTsNkHOG9fZLmvVU30U0bk1XKf3kCo36eutaDsz2ShwKA=s2500",
                "chat_url": null,
                "created_date": "2021-05-24T12:21:01.195032",
                "default_to_fiat": false,
                "description": "366 hypocoristic real names collectibles.\n366 hipocoristicos de nombres reales coleccionables.",
                "dev_buyer_fee_basis_points": "0",
                "dev_seller_fee_basis_points": "0",
                "discord_url": null,
                "display_data": {
                    "card_display_style": "contain",
                    "images": []
                },
                "external_url": null,
                "featured": false,
                "featured_image_url": null,
                "hidden": true,
                "safelist_request_status": "not_requested",
                "image_url": "https://lh3.googleusercontent.com/hvhK-MCztfhfrTqhlVW5j645b_d9PqbLK5omWQJEwG53anL0YgGud2XZ03wsQxwganJNZK_9K5sirx7ZvKItMentSiP2H6phFJD3=s120",
                "is_subject_to_whitelist": false,
                "large_image_url": null,
                "medium_username": null,
                "name": "Hypocoristic real names.",
                "only_proxied_transfers": false,
                "opensea_buyer_fee_basis_points": "0",
                "opensea_seller_fee_basis_points": "250",
                "payout_address": null,
                "require_email": false,
                "short_description": null,
                "slug": "hypocoristic-real-names",
                "telegram_url": null,
                "twitter_username": null,
                "instagram_username": null,
                "wiki_url": null
            },
            "decimals": null,
            "token_metadata": null,
            "sell_orders": null,
            "creator": {
                "user": {
                    "username": "fitojuan"
                },
                "profile_img_url": "https://storage.googleapis.com/opensea-static/opensea-profile/22.png",
                "address": "0xcc99c69a009918e8ac18d13cbea245902050c4fa",
                "config": "",
                "discord_id": ""
            },
            "traits": [
                {
                    "trait_type": "Moneda",
                    "value": 8,
                    "display_type": null,
                    "max_value": "10",
                    "trait_count": 0,
                    "order": null
                },
                {
                    "trait_type": "Mauri",
                    "value": "Mauricio",
                    "display_type": null,
                    "max_value": null,
                    "trait_count": 0,
                    "order": null
                }
            ],
            "last_sale": null,
            "top_bid": null,
            "listing_date": null,
            "is_presale": true,
            "transfer_fee_payment_token": null,
            "transfer_fee": null
        },
        {
            "id": 25679507,
            "token_id": "31658690390467668128549118582734005429267025138219486530135280900968105902081",
            "num_sales": 0,
            "background_color": null,
            "image_url": "https://lh3.googleusercontent.com/0YfCsyMH6kmkFDAUBN_b5ZiIJ8ALCtkT-FYA4K56rlQdVQJKCLrS9gt1u163UesorcD7dlfdo_c01vBNVQJukTUwUABktrcxHVpM",
            "image_preview_url": "https://lh3.googleusercontent.com/0YfCsyMH6kmkFDAUBN_b5ZiIJ8ALCtkT-FYA4K56rlQdVQJKCLrS9gt1u163UesorcD7dlfdo_c01vBNVQJukTUwUABktrcxHVpM=s250",
            "image_thumbnail_url": "https://lh3.googleusercontent.com/0YfCsyMH6kmkFDAUBN_b5ZiIJ8ALCtkT-FYA4K56rlQdVQJKCLrS9gt1u163UesorcD7dlfdo_c01vBNVQJukTUwUABktrcxHVpM=s128",
            "image_original_url": null,
            "animation_url": null,
            "animation_original_url": null,
            "name": "Confusion No. 3",
            "description": "Confusion\n \nAre you afraid of the dark? \nDo you feel good when you see festival lighting or not?\n \nHow do you feel when two things come together?\n",
            "external_link": null,
            "asset_contract": {
                "address": "0x495f947276749ce646f68ac8c248420045cb7b5e",
                "asset_contract_type": "semi-fungible",
                "created_date": "2020-12-02T17:40:53.232025",
                "name": "OpenSea Collection",
                "nft_version": null,
                "opensea_version": "2.0.0",
                "owner": 102384,
                "schema_name": "ERC1155",
                "symbol": "OPENSTORE",
                "total_supply": null,
                "description": null,
                "external_link": null,
                "image_url": null,
                "default_to_fiat": false,
                "dev_buyer_fee_basis_points": 0,
                "dev_seller_fee_basis_points": 0,
                "only_proxied_transfers": false,
                "opensea_buyer_fee_basis_points": 0,
                "opensea_seller_fee_basis_points": 250,
                "buyer_fee_basis_points": 0,
                "seller_fee_basis_points": 250,
                "payout_address": null
            },
            "owner": {
                "user": {
                    "username": "NullAddress"
                },
                "profile_img_url": "https://storage.googleapis.com/opensea-static/opensea-profile/1.png",
                "address": "0x0000000000000000000000000000000000000000",
                "config": "",
                "discord_id": ""
            },
            "permalink": "https://opensea.io/assets/0x495f947276749ce646f68ac8c248420045cb7b5e/31658690390467668128549118582734005429267025138219486530135280900968105902081",
            "collection": {
                "banner_image_url": null,
                "chat_url": null,
                "created_date": "2021-05-24T16:46:22.370555",
                "default_to_fiat": false,
                "description": "My work when I was a photography student",
                "dev_buyer_fee_basis_points": "0",
                "dev_seller_fee_basis_points": "0",
                "discord_url": null,
                "display_data": {
                    "card_display_style": "contain",
                    "images": []
                },
                "external_url": null,
                "featured": false,
                "featured_image_url": null,
                "hidden": true,
                "safelist_request_status": "not_requested",
                "image_url": "https://lh3.googleusercontent.com/4yzlFyRCx94yG47tmG7YZkX6RUV4tTT4Sp0KamSMalAKjbtdL8xaPw-hmmnAflDBAb9T06HkcP_cEDj-tO_0FUHnQu5sENItCUT-6jM=s120",
                "is_subject_to_whitelist": false,
                "large_image_url": null,
                "medium_username": null,
                "name": "4 years of photography student",
                "only_proxied_transfers": false,
                "opensea_buyer_fee_basis_points": "0",
                "opensea_seller_fee_basis_points": "250",
                "payout_address": null,
                "require_email": false,
                "short_description": null,
                "slug": "4-years-of-photography-student",
                "telegram_url": null,
                "twitter_username": null,
                "instagram_username": null,
                "wiki_url": null
            },
            "decimals": null,
            "token_metadata": null,
            "sell_orders": null,
            "creator": {
                "user": {
                    "username": "earthzquake"
                },
                "profile_img_url": "https://storage.googleapis.com/opensea-static/opensea-profile/29.png",
                "address": "0x45fe2f0b30b8714342674b0e8fbcbd0288682e89",
                "config": "",
                "discord_id": ""
            },
            "traits": [],
            "last_sale": null,
            "top_bid": null,
            "listing_date": null,
            "is_presale": true,
            "transfer_fee_payment_token": null,
            "transfer_fee": null
        },
        {
            "id": 25679506,
            "token_id": "37430452933329828009181382969899584352567632449099565656987172364196669030401",
            "num_sales": 0,
            "background_color": null,
            "image_url": "https://lh3.googleusercontent.com/TV24b6pkADQIIsxOsJWMT3sGdjDbVAhzyeE5V6aK5Vw15HUWsla6CL-w-rKAodgZJd8j-3LE46FKFjPQwGdyfNm6cTp8qj05qyiF4g",
            "image_preview_url": "https://lh3.googleusercontent.com/TV24b6pkADQIIsxOsJWMT3sGdjDbVAhzyeE5V6aK5Vw15HUWsla6CL-w-rKAodgZJd8j-3LE46FKFjPQwGdyfNm6cTp8qj05qyiF4g=s250",
            "image_thumbnail_url": "https://lh3.googleusercontent.com/TV24b6pkADQIIsxOsJWMT3sGdjDbVAhzyeE5V6aK5Vw15HUWsla6CL-w-rKAodgZJd8j-3LE46FKFjPQwGdyfNm6cTp8qj05qyiF4g=s128",
            "image_original_url": null,
            "animation_url": null,
            "animation_original_url": null,
            "name": "Pretty Crypto Lady #294",
            "description": null,
            "external_link": null,
            "asset_contract": {
                "address": "0x495f947276749ce646f68ac8c248420045cb7b5e",
                "asset_contract_type": "semi-fungible",
                "created_date": "2020-12-02T17:40:53.232025",
                "name": "OpenSea Collection",
                "nft_version": null,
                "opensea_version": "2.0.0",
                "owner": 102384,
                "schema_name": "ERC1155",
                "symbol": "OPENSTORE",
                "total_supply": null,
                "description": null,
                "external_link": null,
                "image_url": null,
                "default_to_fiat": false,
                "dev_buyer_fee_basis_points": 0,
                "dev_seller_fee_basis_points": 0,
                "only_proxied_transfers": false,
                "opensea_buyer_fee_basis_points": 0,
                "opensea_seller_fee_basis_points": 250,
                "buyer_fee_basis_points": 0,
                "seller_fee_basis_points": 250,
                "payout_address": null
            },
            "owner": {
                "user": {
                    "username": "NullAddress"
                },
                "profile_img_url": "https://storage.googleapis.com/opensea-static/opensea-profile/1.png",
                "address": "0x0000000000000000000000000000000000000000",
                "config": "",
                "discord_id": ""
            },
            "permalink": "https://opensea.io/assets/0x495f947276749ce646f68ac8c248420045cb7b5e/37430452933329828009181382969899584352567632449099565656987172364196669030401",
            "collection": {
                "banner_image_url": null,
                "chat_url": null,
                "created_date": "2021-04-27T21:07:28.954779",
                "default_to_fiat": false,
                "description": "All these photos are made by a neural network. So it is not real people. They never exist.\nEvery picture is unique. It could be similar but never the same.\n***Any coincidence with real people, organizations, and events is accidental***\n\nMaybe in the future, when we would be able to order human similar robots you will need to choose their face.\nSo if you will be the owner of some of these NFTs, your robots will have inimitable faces.",
                "dev_buyer_fee_basis_points": "0",
                "dev_seller_fee_basis_points": "500",
                "discord_url": null,
                "display_data": {
                    "card_display_style": "cover"
                },
                "external_url": null,
                "featured": false,
                "featured_image_url": null,
                "hidden": true,
                "safelist_request_status": "not_requested",
                "image_url": "https://lh3.googleusercontent.com/abZyjia1IXPU0RXnS3h-NjGwg1biSIZxF3va_RlR-m2ymdQlFGQiBETQ2kYoQP6JCxuqZKYJLpbTETlkMSoNLNvlNDJ_9kkFfIinQA=s120",
                "is_subject_to_whitelist": false,
                "large_image_url": null,
                "medium_username": null,
                "name": "Pretty Crypto Ladies",
                "only_proxied_transfers": false,
                "opensea_buyer_fee_basis_points": "0",
                "opensea_seller_fee_basis_points": "250",
                "payout_address": "0x52c0e2b66ee82ea1c4dcf66f37fb69926ce864ca",
                "require_email": false,
                "short_description": null,
                "slug": "pretty-crypto-ladies",
                "telegram_url": null,
                "twitter_username": null,
                "instagram_username": null,
                "wiki_url": null
            },
            "decimals": null,
            "token_metadata": null,
            "sell_orders": [
                {
                    "created_date": "2021-05-26T07:36:24.520547",
                    "closing_date": null,
                    "closing_extendable": false,
                    "expiration_time": 0,
                    "listing_time": 1622014479,
                    "order_hash": "0xb63f99c58679a3e315205d0b2a6fc9f600e029f3ea24708bbe6f0c2cec17bc28",
                    "metadata": {
                        "asset": {
                            "id": "37430452933329828009181382969899584352567632449099565656987172364196669030401",
                            "address": "0x495f947276749ce646f68ac8c248420045cb7b5e",
                            "quantity": "1"
                        },
                        "schema": "ERC1155"
                    },
                    "exchange": "0x7be8076f4ea4a4ad08075c2508e481d6c946d12b",
                    "maker": {
                        "user": 251494,
                        "profile_img_url": "https://storage.googleapis.com/opensea-static/opensea-profile/30.png",
                        "address": "0x52c0e2b66ee82ea1c4dcf66f37fb69926ce864ca",
                        "config": "",
                        "discord_id": ""
                    },
                    "taker": {
                        "user": 1766,
                        "profile_img_url": "https://storage.googleapis.com/opensea-static/opensea-profile/1.png",
                        "address": "0x0000000000000000000000000000000000000000",
                        "config": "",
                        "discord_id": ""
                    },
                    "current_price": "100000000000000000",
                    "current_bounty": "1000000000000000",
                    "bounty_multiple": "0.01",
                    "maker_relayer_fee": "750",
                    "taker_relayer_fee": "0",
                    "maker_protocol_fee": "0",
                    "taker_protocol_fee": "0",
                    "maker_referrer_fee": "0",
                    "fee_recipient": {
                        "user": 3585,
                        "profile_img_url": "https://storage.googleapis.com/opensea-static/opensea-profile/28.png",
                        "address": "0x5b3256965e7c3cf26e11fcaf296dfc8807c01073",
                        "config": "verified",
                        "discord_id": ""
                    },
                    "fee_method": 1,
                    "side": 1,
                    "sale_kind": 0,
                    "target": "0x495f947276749ce646f68ac8c248420045cb7b5e",
                    "how_to_call": 0,
                    "calldata": "0xf242432a00000000000000000000000052c0e2b66ee82ea1c4dcf66f37fb69926ce864ca000000000000000000000000000000000000000000000000000000000000000052c0e2b66ee82ea1c4dcf66f37fb69926ce864ca000000000001330000000001000000000000000000000000000000000000000000000000000000000000000100000000000000000000000000000000000000000000000000000000000000a00000000000000000000000000000000000000000000000000000000000000000",
                    "replacement_pattern": "0x000000000000000000000000000000000000000000000000000000000000000000000000ffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffff0000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000",
                    "static_target": "0x0000000000000000000000000000000000000000",
                    "static_extradata": "0x",
                    "payment_token": "0x0000000000000000000000000000000000000000",
                    "payment_token_contract": {
                        "id": 1,
                        "symbol": "ETH",
                        "address": "0x0000000000000000000000000000000000000000",
                        "image_url": "https://storage.opensea.io/files/6f8e2979d428180222796ff4a33ab929.svg",
                        "name": "Ether",
                        "decimals": 18,
                        "eth_price": "1.000000000000000",
                        "usd_price": "2869.690000000000055000"
                    },
                    "base_price": "100000000000000000",
                    "extra": "0",
                    "quantity": "1",
                    "salt": "65727013028892760304955601608772966534412642668303552962022361171000304178762",
                    "v": 28,
                    "r": "0x0cbed22f7457519ba2e42aa3ef22034b512a9387dc0c813e14a9c1aea6705376",
                    "s": "0x2608792782e08feef4e79346316da945903980b1acd4a1b1c11a7cdf110f0ac3",
                    "approved_on_chain": false,
                    "cancelled": false,
                    "finalized": false,
                    "marked_invalid": false,
                    "prefixed_hash": "0x6ae999cae0c3078480f415f9c0d971c22830d6b5578ee72de2fc4e71f74e2e20"
                }
            ],
            "creator": {
                "user": {
                    "username": "Antilames"
                },
                "profile_img_url": "https://storage.googleapis.com/opensea-static/opensea-profile/30.png",
                "address": "0x52c0e2b66ee82ea1c4dcf66f37fb69926ce864ca",
                "config": "",
                "discord_id": ""
            },
            "traits": [],
            "last_sale": null,
            "top_bid": null,
            "listing_date": null,
            "is_presale": true,
            "transfer_fee_payment_token": null,
            "transfer_fee": null
        },
        {
            "id": 25679505,
            "token_id": "3224",
            "num_sales": 0,
            "background_color": null,
            "image_url": "https://lh3.googleusercontent.com/3G09bcOjSfkbIiCnDTPdcifXndMofduTa9W4fLYcKDu45DoRdLrABJIaa8zFGe9iPTWyAKep2ajzP1wIQ0o5YiWG45xUiPsKgMoogQ",
            "image_preview_url": "https://lh3.googleusercontent.com/3G09bcOjSfkbIiCnDTPdcifXndMofduTa9W4fLYcKDu45DoRdLrABJIaa8zFGe9iPTWyAKep2ajzP1wIQ0o5YiWG45xUiPsKgMoogQ=s250",
            "image_thumbnail_url": "https://lh3.googleusercontent.com/3G09bcOjSfkbIiCnDTPdcifXndMofduTa9W4fLYcKDu45DoRdLrABJIaa8zFGe9iPTWyAKep2ajzP1wIQ0o5YiWG45xUiPsKgMoogQ=s128",
            "image_original_url": "https://embersword.mypinata.cloud/ipfs/QmdbeV27CatL3EddMf2Ek1jGt77amKgb5ghVeHrKWLyz84",
            "animation_url": "https://storage.opensea.io/files/b0cc4d04cbc1f26c66e7511d64cd2d9e.mp4",
            "animation_original_url": "https://embersword.mypinata.cloud/ipfs/QmfKgvFupW1dm9W3UusnrGKrabMT6hTD2DkhG27hAU7Lxx",
            "name": "Land (104,76)",
            "description": "Land plot",
            "external_link": null,
            "asset_contract": {
                "address": "0xe7e16f2da731265778f87cb8d7850e31b84b7b86",
                "asset_contract_type": "non-fungible",
                "created_date": "2021-05-25T13:23:10.895540",
                "name": "Embersword Land",
                "nft_version": null,
                "opensea_version": null,
                "owner": 35978059,
                "schema_name": "ERC721",
                "symbol": "LAND",
                "total_supply": "0",
                "description": null,
                "external_link": "https://embersword.com",
                "image_url": "https://lh3.googleusercontent.com/J7SSCNIDh1ui59aoqyNywPtnUAUB-Q80Cnl1txbxmJOAIKcRJT1bUYidkDPNegOk2W0zyjqVkLbdcI6g6KTYgQCDplCo3DXpDSeaPg=s120",
                "default_to_fiat": false,
                "dev_buyer_fee_basis_points": 0,
                "dev_seller_fee_basis_points": 0,
                "only_proxied_transfers": false,
                "opensea_buyer_fee_basis_points": 0,
                "opensea_seller_fee_basis_points": 250,
                "buyer_fee_basis_points": 0,
                "seller_fee_basis_points": 250,
                "payout_address": null
            },
            "owner": {
                "user": null,
                "profile_img_url": "https://storage.googleapis.com/opensea-static/opensea-profile/1.png",
                "address": "0x0000000000000000000000000000000000000000",
                "config": "",
                "discord_id": ""
            },
            "permalink": "https://opensea.io/assets/matic/0xe7e16f2da731265778f87cb8d7850e31b84b7b86/3224",
            "collection": {
                "banner_image_url": null,
                "chat_url": null,
                "created_date": "2021-05-25T16:51:25.426643",
                "default_to_fiat": false,
                "description": null,
                "dev_buyer_fee_basis_points": "0",
                "dev_seller_fee_basis_points": "0",
                "discord_url": "https://discord.gg/embersword",
                "display_data": {
                    "card_display_style": "contain"
                },
                "external_url": "https://embersword.com",
                "featured": false,
                "featured_image_url": null,
                "hidden": true,
                "safelist_request_status": "not_requested",
                "image_url": "https://lh3.googleusercontent.com/J7SSCNIDh1ui59aoqyNywPtnUAUB-Q80Cnl1txbxmJOAIKcRJT1bUYidkDPNegOk2W0zyjqVkLbdcI6g6KTYgQCDplCo3DXpDSeaPg=s120",
                "is_subject_to_whitelist": false,
                "large_image_url": null,
                "medium_username": "embersword",
                "name": "Ember Sword Land",
                "only_proxied_transfers": false,
                "opensea_buyer_fee_basis_points": "0",
                "opensea_seller_fee_basis_points": "250",
                "payout_address": null,
                "require_email": false,
                "short_description": null,
                "slug": "embersword-land",
                "telegram_url": null,
                "twitter_username": "PlayEmberSword",
                "instagram_username": null,
                "wiki_url": null
            },
            "decimals": null,
            "token_metadata": "https://embersword.mypinata.cloud/ipfs/QmPTABCmA46Jz7QWrucofkHNYiaL4eZTw8xuPA5VB7buba",
            "sell_orders": null,
            "creator": null,
            "traits": [
                {
                    "trait_type": "x-coordinate",
                    "value": 104,
                    "display_type": "number",
                    "max_value": null,
                    "trait_count": 0,
                    "order": null
                },
                {
                    "trait_type": "Type",
                    "value": "Land",
                    "display_type": null,
                    "max_value": null,
                    "trait_count": 2684,
                    "order": null
                },
                {
                    "trait_type": "y-coordinate",
                    "value": 76,
                    "display_type": "number",
                    "max_value": null,
                    "trait_count": 0,
                    "order": null
                }
            ],
            "last_sale": null,
            "top_bid": null,
            "listing_date": null,
            "is_presale": false,
            "transfer_fee_payment_token": null,
            "transfer_fee": null
        },
        {
            "id": 25679504,
            "token_id": "79228162606498620912045634344",
            "num_sales": 0,
            "background_color": null,
            "image_url": "https://lh3.googleusercontent.com/wqaiSQAHW_d1rHS9nTiybg0xDslqQtGVjwnlLnU3IGM4hh5NHDbZetF25OJCCw46Pjy1yOU6JpyHv7tPDdGL7zA",
            "image_preview_url": "https://lh3.googleusercontent.com/wqaiSQAHW_d1rHS9nTiybg0xDslqQtGVjwnlLnU3IGM4hh5NHDbZetF25OJCCw46Pjy1yOU6JpyHv7tPDdGL7zA=s250",
            "image_thumbnail_url": "https://lh3.googleusercontent.com/wqaiSQAHW_d1rHS9nTiybg0xDslqQtGVjwnlLnU3IGM4hh5NHDbZetF25OJCCw46Pjy1yOU6JpyHv7tPDdGL7zA=s128",
            "image_original_url": "https://neon-district-season-one.s3.amazonaws.com/images/heavy-female-thumb.png",
            "animation_url": null,
            "animation_original_url": null,
            "name": "Heavy",
            "description": "Heavies are extremely strong and sturdy, and can affect the emotions of others.\n\nA Neon District: Season One game item, playable on https://portal.neondistrict.io.\n\nNeon District is a free-to-play cyberpunk role-playing game. Collect characters and gear, craft and level up teams, and battle against other players through competitive multiplayer and in turn-based combat.",
            "external_link": "https://portal.neondistrict.io/asset/79228162606498620912045634344",
            "asset_contract": {
                "address": "0x7227e371540cf7b8e512544ba6871472031f3335",
                "asset_contract_type": "non-fungible",
                "created_date": "2021-01-04T17:12:08.151181",
                "name": "Neon District Season One Item",
                "nft_version": null,
                "opensea_version": null,
                "owner": 17710883,
                "schema_name": "ERC721",
                "symbol": "NDITEM1",
                "total_supply": "475982",
                "description": "Neon District is a free-to-play cyberpunk role-playing game featuring collectible NFTs on Matic and Ethereum. Players collect characters and gear, craft and level up fully-equipped teams, and battle their teams against other players through the Neon Pizza competitive multiplayer missions or in real-time turn-based combat.",
                "external_link": null,
                "image_url": "https://lh3.googleusercontent.com/xttZf6L3I16h7HSgcfKFWhR7OhCdSO5UW_asXbRfGmQ7-a0QwJRNoPsmh_RlOpw-AFEngLqGYLD77cmjdBv4LCfVc5BxFG2PS1UU=s120",
                "default_to_fiat": false,
                "dev_buyer_fee_basis_points": 0,
                "dev_seller_fee_basis_points": 500,
                "only_proxied_transfers": false,
                "opensea_buyer_fee_basis_points": 0,
                "opensea_seller_fee_basis_points": 250,
                "buyer_fee_basis_points": 0,
                "seller_fee_basis_points": 750,
                "payout_address": "0x08262c33e987ed580b69d8f93134e987f881bdcc"
            },
            "owner": {
                "user": null,
                "profile_img_url": "https://storage.googleapis.com/opensea-static/opensea-profile/1.png",
                "address": "0x0000000000000000000000000000000000000000",
                "config": "",
                "discord_id": ""
            },
            "permalink": "https://opensea.io/assets/matic/0x7227e371540cf7b8e512544ba6871472031f3335/79228162606498620912045634344",
            "collection": {
                "banner_image_url": "https://lh3.googleusercontent.com/vtZXDR51ibkUx6v2XRf3imqsL-bUzy7tALBcjrwx0fNJywcMCqK_bVIfrvdlKQ5sysboHA23kGiwbgsGb5c_6ROGsyzc-SZURrtqRA=s2500",
                "chat_url": null,
                "created_date": "2021-01-04T17:12:08.305423",
                "default_to_fiat": false,
                "description": "Neon District is a free-to-play cyberpunk role-playing game featuring collectible NFTs on Matic and Ethereum. Players collect characters and gear, craft and level up fully-equipped teams, and battle their teams against other players through the Neon Pizza competitive multiplayer missions or in real-time turn-based combat.",
                "dev_buyer_fee_basis_points": "0",
                "dev_seller_fee_basis_points": "500",
                "discord_url": "https://discord.gg/ERu7Zw9YwZ",
                "display_data": {
                    "card_display_style": "contain"
                },
                "external_url": null,
                "featured": false,
                "featured_image_url": "https://lh3.googleusercontent.com/vtZXDR51ibkUx6v2XRf3imqsL-bUzy7tALBcjrwx0fNJywcMCqK_bVIfrvdlKQ5sysboHA23kGiwbgsGb5c_6ROGsyzc-SZURrtqRA=s300",
                "hidden": false,
                "safelist_request_status": "approved",
                "image_url": "https://lh3.googleusercontent.com/xttZf6L3I16h7HSgcfKFWhR7OhCdSO5UW_asXbRfGmQ7-a0QwJRNoPsmh_RlOpw-AFEngLqGYLD77cmjdBv4LCfVc5BxFG2PS1UU=s120",
                "is_subject_to_whitelist": false,
                "large_image_url": "https://lh3.googleusercontent.com/vtZXDR51ibkUx6v2XRf3imqsL-bUzy7tALBcjrwx0fNJywcMCqK_bVIfrvdlKQ5sysboHA23kGiwbgsGb5c_6ROGsyzc-SZURrtqRA=s300",
                "medium_username": "blockadegames",
                "name": "Neon District Season One Item",
                "only_proxied_transfers": false,
                "opensea_buyer_fee_basis_points": "0",
                "opensea_seller_fee_basis_points": "250",
                "payout_address": "0x08262c33e987ed580b69d8f93134e987f881bdcc",
                "require_email": false,
                "short_description": null,
                "slug": "neon-district-season-one-item",
                "telegram_url": null,
                "twitter_username": "neondistrictrpg",
                "instagram_username": null,
                "wiki_url": null
            },
            "decimals": null,
            "token_metadata": "https://portal.neondistrict.io/api/getNft/79228162606498620912045634344",
            "sell_orders": null,
            "creator": null,
            "traits": [
                {
                    "trait_type": "Attack",
                    "value": 35,
                    "display_type": "boost_number",
                    "max_value": null,
                    "trait_count": 0,
                    "order": null
                },
                {
                    "trait_type": "Defense",
                    "value": 100,
                    "display_type": "boost_number",
                    "max_value": null,
                    "trait_count": 0,
                    "order": null
                },
                {
                    "trait_type": "type",
                    "value": "Character",
                    "display_type": null,
                    "max_value": null,
                    "trait_count": 78723,
                    "order": null
                },
                {
                    "trait_type": "rarity",
                    "value": "Common",
                    "display_type": null,
                    "max_value": null,
                    "trait_count": 220672,
                    "order": null
                },
                {
                    "trait_type": "level",
                    "value": 1,
                    "display_type": null,
                    "max_value": null,
                    "trait_count": 0,
                    "order": null
                },
                {
                    "trait_type": "Season",
                    "value": 1,
                    "display_type": "number",
                    "max_value": null,
                    "trait_count": 0,
                    "order": null
                },
                {
                    "trait_type": "Mech",
                    "value": 15,
                    "display_type": "boost_number",
                    "max_value": null,
                    "trait_count": 0,
                    "order": null
                },
                {
                    "trait_type": "Nano",
                    "value": 15,
                    "display_type": "boost_number",
                    "max_value": null,
                    "trait_count": 0,
                    "order": null
                },
                {
                    "trait_type": "Stealth",
                    "value": 15,
                    "display_type": "boost_number",
                    "max_value": null,
                    "trait_count": 0,
                    "order": null
                },
                {
                    "trait_type": "Health",
                    "value": 500,
                    "display_type": "boost_number",
                    "max_value": null,
                    "trait_count": 0,
                    "order": null
                },
                {
                    "trait_type": "Tactics",
                    "value": 25,
                    "display_type": "boost_number",
                    "max_value": null,
                    "trait_count": 0,
                    "order": null
                },
                {
                    "trait_type": "Hacking",
                    "value": 15,
                    "display_type": "boost_number",
                    "max_value": null,
                    "trait_count": 0,
                    "order": null
                },
                {
                    "trait_type": "Card",
                    "value": "Self Care",
                    "display_type": null,
                    "max_value": null,
                    "trait_count": 11716,
                    "order": null
                },
                {
                    "trait_type": "Card",
                    "value": "Feeling It",
                    "display_type": null,
                    "max_value": null,
                    "trait_count": 11694,
                    "order": null
                },
                {
                    "trait_type": "Card",
                    "value": "Yeah You, Buddy!",
                    "display_type": null,
                    "max_value": null,
                    "trait_count": 11694,
                    "order": null
                },
                {
                    "trait_type": "Card",
                    "value": "Thick",
                    "display_type": null,
                    "max_value": null,
                    "trait_count": 11698,
                    "order": null
                }
            ],
            "last_sale": null,
            "top_bid": null,
            "listing_date": null,
            "is_presale": false,
            "transfer_fee_payment_token": null,
            "transfer_fee": null
        },
        {
            "id": 25679503,
            "token_id": "79228162532711644617207427881",
            "num_sales": 0,
            "background_color": null,
            "image_url": "https://lh3.googleusercontent.com/QSBwd0xAshRdMe1-ByrqeW1zEOV3FAPyHnJ6ESyKJS5P3Ipz9jD6NHf1HURWRrlAnbNFyOvvigJvj5_rljGnv_I",
            "image_preview_url": "https://lh3.googleusercontent.com/QSBwd0xAshRdMe1-ByrqeW1zEOV3FAPyHnJ6ESyKJS5P3Ipz9jD6NHf1HURWRrlAnbNFyOvvigJvj5_rljGnv_I=s250",
            "image_thumbnail_url": "https://lh3.googleusercontent.com/QSBwd0xAshRdMe1-ByrqeW1zEOV3FAPyHnJ6ESyKJS5P3Ipz9jD6NHf1HURWRrlAnbNFyOvvigJvj5_rljGnv_I=s128",
            "image_original_url": "https://neon-district-season-one.s3.amazonaws.com/images/demon-female-thumb.png",
            "animation_url": null,
            "animation_original_url": null,
            "name": "Demon",
            "description": "Demons are combat specialists who physically are gifted with incredible speed and dexterity.\n\nA Neon District: Season One game item, playable on https://portal.neondistrict.io.\n\nNeon District is a free-to-play cyberpunk role-playing game. Collect characters and gear, craft and level up teams, and battle against other players through competitive multiplayer and in turn-based combat.",
            "external_link": "https://portal.neondistrict.io/asset/79228162532711644617207427881",
            "asset_contract": {
                "address": "0x7227e371540cf7b8e512544ba6871472031f3335",
                "asset_contract_type": "non-fungible",
                "created_date": "2021-01-04T17:12:08.151181",
                "name": "Neon District Season One Item",
                "nft_version": null,
                "opensea_version": null,
                "owner": 17710883,
                "schema_name": "ERC721",
                "symbol": "NDITEM1",
                "total_supply": "475982",
                "description": "Neon District is a free-to-play cyberpunk role-playing game featuring collectible NFTs on Matic and Ethereum. Players collect characters and gear, craft and level up fully-equipped teams, and battle their teams against other players through the Neon Pizza competitive multiplayer missions or in real-time turn-based combat.",
                "external_link": null,
                "image_url": "https://lh3.googleusercontent.com/xttZf6L3I16h7HSgcfKFWhR7OhCdSO5UW_asXbRfGmQ7-a0QwJRNoPsmh_RlOpw-AFEngLqGYLD77cmjdBv4LCfVc5BxFG2PS1UU=s120",
                "default_to_fiat": false,
                "dev_buyer_fee_basis_points": 0,
                "dev_seller_fee_basis_points": 500,
                "only_proxied_transfers": false,
                "opensea_buyer_fee_basis_points": 0,
                "opensea_seller_fee_basis_points": 250,
                "buyer_fee_basis_points": 0,
                "seller_fee_basis_points": 750,
                "payout_address": "0x08262c33e987ed580b69d8f93134e987f881bdcc"
            },
            "owner": {
                "user": null,
                "profile_img_url": "https://storage.googleapis.com/opensea-static/opensea-profile/1.png",
                "address": "0x0000000000000000000000000000000000000000",
                "config": "",
                "discord_id": ""
            },
            "permalink": "https://opensea.io/assets/matic/0x7227e371540cf7b8e512544ba6871472031f3335/79228162532711644617207427881",
            "collection": {
                "banner_image_url": "https://lh3.googleusercontent.com/vtZXDR51ibkUx6v2XRf3imqsL-bUzy7tALBcjrwx0fNJywcMCqK_bVIfrvdlKQ5sysboHA23kGiwbgsGb5c_6ROGsyzc-SZURrtqRA=s2500",
                "chat_url": null,
                "created_date": "2021-01-04T17:12:08.305423",
                "default_to_fiat": false,
                "description": "Neon District is a free-to-play cyberpunk role-playing game featuring collectible NFTs on Matic and Ethereum. Players collect characters and gear, craft and level up fully-equipped teams, and battle their teams against other players through the Neon Pizza competitive multiplayer missions or in real-time turn-based combat.",
                "dev_buyer_fee_basis_points": "0",
                "dev_seller_fee_basis_points": "500",
                "discord_url": "https://discord.gg/ERu7Zw9YwZ",
                "display_data": {
                    "card_display_style": "contain"
                },
                "external_url": null,
                "featured": false,
                "featured_image_url": "https://lh3.googleusercontent.com/vtZXDR51ibkUx6v2XRf3imqsL-bUzy7tALBcjrwx0fNJywcMCqK_bVIfrvdlKQ5sysboHA23kGiwbgsGb5c_6ROGsyzc-SZURrtqRA=s300",
                "hidden": false,
                "safelist_request_status": "approved",
                "image_url": "https://lh3.googleusercontent.com/xttZf6L3I16h7HSgcfKFWhR7OhCdSO5UW_asXbRfGmQ7-a0QwJRNoPsmh_RlOpw-AFEngLqGYLD77cmjdBv4LCfVc5BxFG2PS1UU=s120",
                "is_subject_to_whitelist": false,
                "large_image_url": "https://lh3.googleusercontent.com/vtZXDR51ibkUx6v2XRf3imqsL-bUzy7tALBcjrwx0fNJywcMCqK_bVIfrvdlKQ5sysboHA23kGiwbgsGb5c_6ROGsyzc-SZURrtqRA=s300",
                "medium_username": "blockadegames",
                "name": "Neon District Season One Item",
                "only_proxied_transfers": false,
                "opensea_buyer_fee_basis_points": "0",
                "opensea_seller_fee_basis_points": "250",
                "payout_address": "0x08262c33e987ed580b69d8f93134e987f881bdcc",
                "require_email": false,
                "short_description": null,
                "slug": "neon-district-season-one-item",
                "telegram_url": null,
                "twitter_username": "neondistrictrpg",
                "instagram_username": null,
                "wiki_url": null
            },
            "decimals": null,
            "token_metadata": "https://portal.neondistrict.io/api/getNft/79228162532711644617207427881",
            "sell_orders": null,
            "creator": null,
            "traits": [
                {
                    "trait_type": "Card",
                    "value": "Juke",
                    "display_type": null,
                    "max_value": null,
                    "trait_count": 13588,
                    "order": null
                },
                {
                    "trait_type": "Card",
                    "value": "Leadership",
                    "display_type": null,
                    "max_value": null,
                    "trait_count": 13597,
                    "order": null
                },
                {
                    "trait_type": "Card",
                    "value": "Aggression",
                    "display_type": null,
                    "max_value": null,
                    "trait_count": 13604,
                    "order": null
                },
                {
                    "trait_type": "Attack",
                    "value": 100,
                    "display_type": "boost_number",
                    "max_value": null,
                    "trait_count": 0,
                    "order": null
                },
                {
                    "trait_type": "Stealth",
                    "value": 15,
                    "display_type": "boost_number",
                    "max_value": null,
                    "trait_count": 0,
                    "order": null
                },
                {
                    "trait_type": "type",
                    "value": "Character",
                    "display_type": null,
                    "max_value": null,
                    "trait_count": 78723,
                    "order": null
                },
                {
                    "trait_type": "rarity",
                    "value": "Common",
                    "display_type": null,
                    "max_value": null,
                    "trait_count": 220672,
                    "order": null
                },
                {
                    "trait_type": "level",
                    "value": 1,
                    "display_type": null,
                    "max_value": null,
                    "trait_count": 0,
                    "order": null
                },
                {
                    "trait_type": "Season",
                    "value": 1,
                    "display_type": "number",
                    "max_value": null,
                    "trait_count": 0,
                    "order": null
                },
                {
                    "trait_type": "Mech",
                    "value": 15,
                    "display_type": "boost_number",
                    "max_value": null,
                    "trait_count": 0,
                    "order": null
                },
                {
                    "trait_type": "Nano",
                    "value": 15,
                    "display_type": "boost_number",
                    "max_value": null,
                    "trait_count": 0,
                    "order": null
                },
                {
                    "trait_type": "Tactics",
                    "value": 25,
                    "display_type": "boost_number",
                    "max_value": null,
                    "trait_count": 0,
                    "order": null
                },
                {
                    "trait_type": "Health",
                    "value": 500,
                    "display_type": "boost_number",
                    "max_value": null,
                    "trait_count": 0,
                    "order": null
                },
                {
                    "trait_type": "Defense",
                    "value": 35,
                    "display_type": "boost_number",
                    "max_value": null,
                    "trait_count": 0,
                    "order": null
                },
                {
                    "trait_type": "Hacking",
                    "value": 15,
                    "display_type": "boost_number",
                    "max_value": null,
                    "trait_count": 0,
                    "order": null
                },
                {
                    "trait_type": "Card",
                    "value": "Quicken",
                    "display_type": null,
                    "max_value": null,
                    "trait_count": 13603,
                    "order": null
                }
            ],
            "last_sale": null,
            "top_bid": null,
            "listing_date": null,
            "is_presale": false,
            "transfer_fee_payment_token": null,
            "transfer_fee": null
        },
        {
            "id": 25679502,
            "token_id": "79228162606498620912045634343",
            "num_sales": 0,
            "background_color": null,
            "image_url": "https://lh3.googleusercontent.com/wqaiSQAHW_d1rHS9nTiybg0xDslqQtGVjwnlLnU3IGM4hh5NHDbZetF25OJCCw46Pjy1yOU6JpyHv7tPDdGL7zA",
            "image_preview_url": "https://lh3.googleusercontent.com/wqaiSQAHW_d1rHS9nTiybg0xDslqQtGVjwnlLnU3IGM4hh5NHDbZetF25OJCCw46Pjy1yOU6JpyHv7tPDdGL7zA=s250",
            "image_thumbnail_url": "https://lh3.googleusercontent.com/wqaiSQAHW_d1rHS9nTiybg0xDslqQtGVjwnlLnU3IGM4hh5NHDbZetF25OJCCw46Pjy1yOU6JpyHv7tPDdGL7zA=s128",
            "image_original_url": "https://neon-district-season-one.s3.amazonaws.com/images/heavy-female-thumb.png",
            "animation_url": null,
            "animation_original_url": null,
            "name": "Heavy",
            "description": "Heavies are extremely strong and sturdy, and can affect the emotions of others.\n\nA Neon District: Season One game item, playable on https://portal.neondistrict.io.\n\nNeon District is a free-to-play cyberpunk role-playing game. Collect characters and gear, craft and level up teams, and battle against other players through competitive multiplayer and in turn-based combat.",
            "external_link": "https://portal.neondistrict.io/asset/79228162606498620912045634343",
            "asset_contract": {
                "address": "0x7227e371540cf7b8e512544ba6871472031f3335",
                "asset_contract_type": "non-fungible",
                "created_date": "2021-01-04T17:12:08.151181",
                "name": "Neon District Season One Item",
                "nft_version": null,
                "opensea_version": null,
                "owner": 17710883,
                "schema_name": "ERC721",
                "symbol": "NDITEM1",
                "total_supply": "475982",
                "description": "Neon District is a free-to-play cyberpunk role-playing game featuring collectible NFTs on Matic and Ethereum. Players collect characters and gear, craft and level up fully-equipped teams, and battle their teams against other players through the Neon Pizza competitive multiplayer missions or in real-time turn-based combat.",
                "external_link": null,
                "image_url": "https://lh3.googleusercontent.com/xttZf6L3I16h7HSgcfKFWhR7OhCdSO5UW_asXbRfGmQ7-a0QwJRNoPsmh_RlOpw-AFEngLqGYLD77cmjdBv4LCfVc5BxFG2PS1UU=s120",
                "default_to_fiat": false,
                "dev_buyer_fee_basis_points": 0,
                "dev_seller_fee_basis_points": 500,
                "only_proxied_transfers": false,
                "opensea_buyer_fee_basis_points": 0,
                "opensea_seller_fee_basis_points": 250,
                "buyer_fee_basis_points": 0,
                "seller_fee_basis_points": 750,
                "payout_address": "0x08262c33e987ed580b69d8f93134e987f881bdcc"
            },
            "owner": {
                "user": null,
                "profile_img_url": "https://storage.googleapis.com/opensea-static/opensea-profile/1.png",
                "address": "0x0000000000000000000000000000000000000000",
                "config": "",
                "discord_id": ""
            },
            "permalink": "https://opensea.io/assets/matic/0x7227e371540cf7b8e512544ba6871472031f3335/79228162606498620912045634343",
            "collection": {
                "banner_image_url": "https://lh3.googleusercontent.com/vtZXDR51ibkUx6v2XRf3imqsL-bUzy7tALBcjrwx0fNJywcMCqK_bVIfrvdlKQ5sysboHA23kGiwbgsGb5c_6ROGsyzc-SZURrtqRA=s2500",
                "chat_url": null,
                "created_date": "2021-01-04T17:12:08.305423",
                "default_to_fiat": false,
                "description": "Neon District is a free-to-play cyberpunk role-playing game featuring collectible NFTs on Matic and Ethereum. Players collect characters and gear, craft and level up fully-equipped teams, and battle their teams against other players through the Neon Pizza competitive multiplayer missions or in real-time turn-based combat.",
                "dev_buyer_fee_basis_points": "0",
                "dev_seller_fee_basis_points": "500",
                "discord_url": "https://discord.gg/ERu7Zw9YwZ",
                "display_data": {
                    "card_display_style": "contain"
                },
                "external_url": null,
                "featured": false,
                "featured_image_url": "https://lh3.googleusercontent.com/vtZXDR51ibkUx6v2XRf3imqsL-bUzy7tALBcjrwx0fNJywcMCqK_bVIfrvdlKQ5sysboHA23kGiwbgsGb5c_6ROGsyzc-SZURrtqRA=s300",
                "hidden": false,
                "safelist_request_status": "approved",
                "image_url": "https://lh3.googleusercontent.com/xttZf6L3I16h7HSgcfKFWhR7OhCdSO5UW_asXbRfGmQ7-a0QwJRNoPsmh_RlOpw-AFEngLqGYLD77cmjdBv4LCfVc5BxFG2PS1UU=s120",
                "is_subject_to_whitelist": false,
                "large_image_url": "https://lh3.googleusercontent.com/vtZXDR51ibkUx6v2XRf3imqsL-bUzy7tALBcjrwx0fNJywcMCqK_bVIfrvdlKQ5sysboHA23kGiwbgsGb5c_6ROGsyzc-SZURrtqRA=s300",
                "medium_username": "blockadegames",
                "name": "Neon District Season One Item",
                "only_proxied_transfers": false,
                "opensea_buyer_fee_basis_points": "0",
                "opensea_seller_fee_basis_points": "250",
                "payout_address": "0x08262c33e987ed580b69d8f93134e987f881bdcc",
                "require_email": false,
                "short_description": null,
                "slug": "neon-district-season-one-item",
                "telegram_url": null,
                "twitter_username": "neondistrictrpg",
                "instagram_username": null,
                "wiki_url": null
            },
            "decimals": null,
            "token_metadata": "https://portal.neondistrict.io/api/getNft/79228162606498620912045634343",
            "sell_orders": null,
            "creator": null,
            "traits": [
                {
                    "trait_type": "Attack",
                    "value": 35,
                    "display_type": "boost_number",
                    "max_value": null,
                    "trait_count": 0,
                    "order": null
                },
                {
                    "trait_type": "Defense",
                    "value": 100,
                    "display_type": "boost_number",
                    "max_value": null,
                    "trait_count": 0,
                    "order": null
                },
                {
                    "trait_type": "type",
                    "value": "Character",
                    "display_type": null,
                    "max_value": null,
                    "trait_count": 78723,
                    "order": null
                },
                {
                    "trait_type": "rarity",
                    "value": "Common",
                    "display_type": null,
                    "max_value": null,
                    "trait_count": 220672,
                    "order": null
                },
                {
                    "trait_type": "level",
                    "value": 1,
                    "display_type": null,
                    "max_value": null,
                    "trait_count": 0,
                    "order": null
                },
                {
                    "trait_type": "Season",
                    "value": 1,
                    "display_type": "number",
                    "max_value": null,
                    "trait_count": 0,
                    "order": null
                },
                {
                    "trait_type": "Mech",
                    "value": 15,
                    "display_type": "boost_number",
                    "max_value": null,
                    "trait_count": 0,
                    "order": null
                },
                {
                    "trait_type": "Nano",
                    "value": 15,
                    "display_type": "boost_number",
                    "max_value": null,
                    "trait_count": 0,
                    "order": null
                },
                {
                    "trait_type": "Stealth",
                    "value": 15,
                    "display_type": "boost_number",
                    "max_value": null,
                    "trait_count": 0,
                    "order": null
                },
                {
                    "trait_type": "Health",
                    "value": 500,
                    "display_type": "boost_number",
                    "max_value": null,
                    "trait_count": 0,
                    "order": null
                },
                {
                    "trait_type": "Tactics",
                    "value": 25,
                    "display_type": "boost_number",
                    "max_value": null,
                    "trait_count": 0,
                    "order": null
                },
                {
                    "trait_type": "Hacking",
                    "value": 15,
                    "display_type": "boost_number",
                    "max_value": null,
                    "trait_count": 0,
                    "order": null
                },
                {
                    "trait_type": "Card",
                    "value": "Self Care",
                    "display_type": null,
                    "max_value": null,
                    "trait_count": 11716,
                    "order": null
                },
                {
                    "trait_type": "Card",
                    "value": "Feeling It",
                    "display_type": null,
                    "max_value": null,
                    "trait_count": 11694,
                    "order": null
                },
                {
                    "trait_type": "Card",
                    "value": "Yeah You, Buddy!",
                    "display_type": null,
                    "max_value": null,
                    "trait_count": 11694,
                    "order": null
                },
                {
                    "trait_type": "Card",
                    "value": "Thick",
                    "display_type": null,
                    "max_value": null,
                    "trait_count": 11698,
                    "order": null
                }
            ],
            "last_sale": null,
            "top_bid": null,
            "listing_date": null,
            "is_presale": false,
            "transfer_fee_payment_token": null,
            "transfer_fee": null
        },
        {
            "id": 25679501,
            "token_id": "79228162588051876838336082726",
            "num_sales": 0,
            "background_color": null,
            "image_url": "https://lh3.googleusercontent.com/26hvZV1bmBS_iM1M3u2-hjUVDyec_caPrIoDhsbmlmIxvrkm8UJF_Pp09fwS26Z-4xRqq_THBPpVxX4fBCgFFPs",
            "image_preview_url": "https://lh3.googleusercontent.com/26hvZV1bmBS_iM1M3u2-hjUVDyec_caPrIoDhsbmlmIxvrkm8UJF_Pp09fwS26Z-4xRqq_THBPpVxX4fBCgFFPs=s250",
            "image_thumbnail_url": "https://lh3.googleusercontent.com/26hvZV1bmBS_iM1M3u2-hjUVDyec_caPrIoDhsbmlmIxvrkm8UJF_Pp09fwS26Z-4xRqq_THBPpVxX4fBCgFFPs=s128",
            "image_original_url": "https://neon-district-season-one.s3.amazonaws.com/images/ghost-male-thumb.png",
            "animation_url": null,
            "animation_original_url": null,
            "name": "Ghost",
            "description": "Ghosts are assassins and infiltrators. They can cloud/alter the perceptions of others.\n\nA Neon District: Season One game item, playable on https://portal.neondistrict.io.\n\nNeon District is a free-to-play cyberpunk role-playing game. Collect characters and gear, craft and level up teams, and battle against other players through competitive multiplayer and in turn-based combat.",
            "external_link": "https://portal.neondistrict.io/asset/79228162588051876838336082726",
            "asset_contract": {
                "address": "0x7227e371540cf7b8e512544ba6871472031f3335",
                "asset_contract_type": "non-fungible",
                "created_date": "2021-01-04T17:12:08.151181",
                "name": "Neon District Season One Item",
                "nft_version": null,
                "opensea_version": null,
                "owner": 17710883,
                "schema_name": "ERC721",
                "symbol": "NDITEM1",
                "total_supply": "475982",
                "description": "Neon District is a free-to-play cyberpunk role-playing game featuring collectible NFTs on Matic and Ethereum. Players collect characters and gear, craft and level up fully-equipped teams, and battle their teams against other players through the Neon Pizza competitive multiplayer missions or in real-time turn-based combat.",
                "external_link": null,
                "image_url": "https://lh3.googleusercontent.com/xttZf6L3I16h7HSgcfKFWhR7OhCdSO5UW_asXbRfGmQ7-a0QwJRNoPsmh_RlOpw-AFEngLqGYLD77cmjdBv4LCfVc5BxFG2PS1UU=s120",
                "default_to_fiat": false,
                "dev_buyer_fee_basis_points": 0,
                "dev_seller_fee_basis_points": 500,
                "only_proxied_transfers": false,
                "opensea_buyer_fee_basis_points": 0,
                "opensea_seller_fee_basis_points": 250,
                "buyer_fee_basis_points": 0,
                "seller_fee_basis_points": 750,
                "payout_address": "0x08262c33e987ed580b69d8f93134e987f881bdcc"
            },
            "owner": {
                "user": null,
                "profile_img_url": "https://storage.googleapis.com/opensea-static/opensea-profile/1.png",
                "address": "0x0000000000000000000000000000000000000000",
                "config": "",
                "discord_id": ""
            },
            "permalink": "https://opensea.io/assets/matic/0x7227e371540cf7b8e512544ba6871472031f3335/79228162588051876838336082726",
            "collection": {
                "banner_image_url": "https://lh3.googleusercontent.com/vtZXDR51ibkUx6v2XRf3imqsL-bUzy7tALBcjrwx0fNJywcMCqK_bVIfrvdlKQ5sysboHA23kGiwbgsGb5c_6ROGsyzc-SZURrtqRA=s2500",
                "chat_url": null,
                "created_date": "2021-01-04T17:12:08.305423",
                "default_to_fiat": false,
                "description": "Neon District is a free-to-play cyberpunk role-playing game featuring collectible NFTs on Matic and Ethereum. Players collect characters and gear, craft and level up fully-equipped teams, and battle their teams against other players through the Neon Pizza competitive multiplayer missions or in real-time turn-based combat.",
                "dev_buyer_fee_basis_points": "0",
                "dev_seller_fee_basis_points": "500",
                "discord_url": "https://discord.gg/ERu7Zw9YwZ",
                "display_data": {
                    "card_display_style": "contain"
                },
                "external_url": null,
                "featured": false,
                "featured_image_url": "https://lh3.googleusercontent.com/vtZXDR51ibkUx6v2XRf3imqsL-bUzy7tALBcjrwx0fNJywcMCqK_bVIfrvdlKQ5sysboHA23kGiwbgsGb5c_6ROGsyzc-SZURrtqRA=s300",
                "hidden": false,
                "safelist_request_status": "approved",
                "image_url": "https://lh3.googleusercontent.com/xttZf6L3I16h7HSgcfKFWhR7OhCdSO5UW_asXbRfGmQ7-a0QwJRNoPsmh_RlOpw-AFEngLqGYLD77cmjdBv4LCfVc5BxFG2PS1UU=s120",
                "is_subject_to_whitelist": false,
                "large_image_url": "https://lh3.googleusercontent.com/vtZXDR51ibkUx6v2XRf3imqsL-bUzy7tALBcjrwx0fNJywcMCqK_bVIfrvdlKQ5sysboHA23kGiwbgsGb5c_6ROGsyzc-SZURrtqRA=s300",
                "medium_username": "blockadegames",
                "name": "Neon District Season One Item",
                "only_proxied_transfers": false,
                "opensea_buyer_fee_basis_points": "0",
                "opensea_seller_fee_basis_points": "250",
                "payout_address": "0x08262c33e987ed580b69d8f93134e987f881bdcc",
                "require_email": false,
                "short_description": null,
                "slug": "neon-district-season-one-item",
                "telegram_url": null,
                "twitter_username": "neondistrictrpg",
                "instagram_username": null,
                "wiki_url": null
            },
            "decimals": null,
            "token_metadata": "https://portal.neondistrict.io/api/getNft/79228162588051876838336082726",
            "sell_orders": null,
            "creator": null,
            "traits": [
                {
                    "trait_type": "Card",
                    "value": "Stultify",
                    "display_type": null,
                    "max_value": null,
                    "trait_count": 19068,
                    "order": null
                },
                {
                    "trait_type": "Card",
                    "value": "Just a Taste",
                    "display_type": null,
                    "max_value": null,
                    "trait_count": 19130,
                    "order": null
                },
                {
                    "trait_type": "Card",
                    "value": "Blur",
                    "display_type": null,
                    "max_value": null,
                    "trait_count": 19105,
                    "order": null
                },
                {
                    "trait_type": "Card",
                    "value": "Distract",
                    "display_type": null,
                    "max_value": null,
                    "trait_count": 19093,
                    "order": null
                },
                {
                    "trait_type": "type",
                    "value": "Character",
                    "display_type": null,
                    "max_value": null,
                    "trait_count": 78723,
                    "order": null
                },
                {
                    "trait_type": "rarity",
                    "value": "Common",
                    "display_type": null,
                    "max_value": null,
                    "trait_count": 220672,
                    "order": null
                },
                {
                    "trait_type": "level",
                    "value": 1,
                    "display_type": null,
                    "max_value": null,
                    "trait_count": 0,
                    "order": null
                },
                {
                    "trait_type": "Season",
                    "value": 1,
                    "display_type": "number",
                    "max_value": null,
                    "trait_count": 0,
                    "order": null
                },
                {
                    "trait_type": "Mech",
                    "value": 15,
                    "display_type": "boost_number",
                    "max_value": null,
                    "trait_count": 0,
                    "order": null
                },
                {
                    "trait_type": "Nano",
                    "value": 15,
                    "display_type": "boost_number",
                    "max_value": null,
                    "trait_count": 0,
                    "order": null
                },
                {
                    "trait_type": "Attack",
                    "value": 50,
                    "display_type": "boost_number",
                    "max_value": null,
                    "trait_count": 0,
                    "order": null
                },
                {
                    "trait_type": "Health",
                    "value": 500,
                    "display_type": "boost_number",
                    "max_value": null,
                    "trait_count": 0,
                    "order": null
                },
                {
                    "trait_type": "Defense",
                    "value": 35,
                    "display_type": "boost_number",
                    "max_value": null,
                    "trait_count": 0,
                    "order": null
                },
                {
                    "trait_type": "Hacking",
                    "value": 15,
                    "display_type": "boost_number",
                    "max_value": null,
                    "trait_count": 0,
                    "order": null
                },
                {
                    "trait_type": "Stealth",
                    "value": 50,
                    "display_type": "boost_number",
                    "max_value": null,
                    "trait_count": 0,
                    "order": null
                },
                {
                    "trait_type": "Tactics",
                    "value": 15,
                    "display_type": "boost_number",
                    "max_value": null,
                    "trait_count": 0,
                    "order": null
                }
            ],
            "last_sale": null,
            "top_bid": null,
            "listing_date": null,
            "is_presale": false,
            "transfer_fee_payment_token": null,
            "transfer_fee": null
        },
        {
            "id": 25679500,
            "token_id": "22231253355797529257366893060948550748457659112317213898500220351037539614721",
            "num_sales": 0,
            "background_color": null,
            "image_url": "https://lh3.googleusercontent.com/pWkmF-v3Zkhp3kRqV954L3yso11h-_ITrjn5Lw_WnOJHK1beuPx0XQJMLVYnItIGbX1w46A0UHPpv_a_NyyVG-k00poGnVk6aXFY-vk",
            "image_preview_url": "https://lh3.googleusercontent.com/pWkmF-v3Zkhp3kRqV954L3yso11h-_ITrjn5Lw_WnOJHK1beuPx0XQJMLVYnItIGbX1w46A0UHPpv_a_NyyVG-k00poGnVk6aXFY-vk=s250",
            "image_thumbnail_url": "https://lh3.googleusercontent.com/pWkmF-v3Zkhp3kRqV954L3yso11h-_ITrjn5Lw_WnOJHK1beuPx0XQJMLVYnItIGbX1w46A0UHPpv_a_NyyVG-k00poGnVk6aXFY-vk=s128",
            "image_original_url": null,
            "animation_url": "https://storage.opensea.io/files/c1da656c555056904e6b07ef176c7f5c.mp3",
            "animation_original_url": "https://storage.opensea.io/files/c1da656c555056904e6b07ef176c7f5c.mp3",
            "name": "Deep In My Soul",
            "description": null,
            "external_link": "https://mariuszchodorek.bandcamp.com/track/deep-in-my-soul",
            "asset_contract": {
                "address": "0x495f947276749ce646f68ac8c248420045cb7b5e",
                "asset_contract_type": "semi-fungible",
                "created_date": "2020-12-02T17:40:53.232025",
                "name": "OpenSea Collection",
                "nft_version": null,
                "opensea_version": "2.0.0",
                "owner": 102384,
                "schema_name": "ERC1155",
                "symbol": "OPENSTORE",
                "total_supply": null,
                "description": null,
                "external_link": null,
                "image_url": null,
                "default_to_fiat": false,
                "dev_buyer_fee_basis_points": 0,
                "dev_seller_fee_basis_points": 0,
                "only_proxied_transfers": false,
                "opensea_buyer_fee_basis_points": 0,
                "opensea_seller_fee_basis_points": 250,
                "buyer_fee_basis_points": 0,
                "seller_fee_basis_points": 250,
                "payout_address": null
            },
            "owner": {
                "user": {
                    "username": "NullAddress"
                },
                "profile_img_url": "https://storage.googleapis.com/opensea-static/opensea-profile/1.png",
                "address": "0x0000000000000000000000000000000000000000",
                "config": "",
                "discord_id": ""
            },
            "permalink": "https://opensea.io/assets/0x495f947276749ce646f68ac8c248420045cb7b5e/22231253355797529257366893060948550748457659112317213898500220351037539614721",
            "collection": {
                "banner_image_url": null,
                "chat_url": null,
                "created_date": "2021-05-26T06:36:28.660898",
                "default_to_fiat": false,
                "description": "Electronic / Trance / Progressive / Deep / Chillout / Techno / Experimental",
                "dev_buyer_fee_basis_points": "0",
                "dev_seller_fee_basis_points": "0",
                "discord_url": null,
                "display_data": {
                    "card_display_style": "contain",
                    "images": []
                },
                "external_url": null,
                "featured": false,
                "featured_image_url": null,
                "hidden": true,
                "safelist_request_status": "not_requested",
                "image_url": "https://lh3.googleusercontent.com/QstFPmrbYQ8WE32hRRnaA1_v-K40Ujn-_fwG8GaGmowQDlav6ZyeG8W5n3g2Xz32Mztrr-fARpTVUmup40eAADwWDwCMogY_-TV_c9w=s120",
                "is_subject_to_whitelist": false,
                "large_image_url": null,
                "medium_username": null,
                "name": "Music by Mariusz Chodorek",
                "only_proxied_transfers": false,
                "opensea_buyer_fee_basis_points": "0",
                "opensea_seller_fee_basis_points": "250",
                "payout_address": null,
                "require_email": false,
                "short_description": null,
                "slug": "music-by-mariusz-chodorek",
                "telegram_url": null,
                "twitter_username": null,
                "instagram_username": null,
                "wiki_url": null
            },
            "decimals": null,
            "token_metadata": null,
            "sell_orders": null,
            "creator": {
                "user": {
                    "username": "mariusz_chodorek"
                },
                "profile_img_url": "https://storage.googleapis.com/opensea-static/opensea-profile/3.png",
                "address": "0x31267188d920140e3015fe285f81ba163262042f",
                "config": "",
                "discord_id": ""
            },
            "traits": [],
            "last_sale": null,
            "top_bid": null,
            "listing_date": null,
            "is_presale": true,
            "transfer_fee_payment_token": null,
            "transfer_fee": null
        },
        {
            "id": 25679499,
            "token_id": "20481607965030952854761425679462123951057317320181018772818573496711318077441",
            "num_sales": 0,
            "background_color": null,
            "image_url": "https://lh3.googleusercontent.com/R54x15xaSYx7RQLb6bWyQPwGAnOrnPawG-Z4Qz41Ue1jxGDJo8qeZOQBt7uETBzZb31HUMYzL8Mjufbp3B-r6jhTeaXq1DuwJBy52Q",
            "image_preview_url": "https://lh3.googleusercontent.com/R54x15xaSYx7RQLb6bWyQPwGAnOrnPawG-Z4Qz41Ue1jxGDJo8qeZOQBt7uETBzZb31HUMYzL8Mjufbp3B-r6jhTeaXq1DuwJBy52Q=s250",
            "image_thumbnail_url": "https://lh3.googleusercontent.com/R54x15xaSYx7RQLb6bWyQPwGAnOrnPawG-Z4Qz41Ue1jxGDJo8qeZOQBt7uETBzZb31HUMYzL8Mjufbp3B-r6jhTeaXq1DuwJBy52Q=s128",
            "image_original_url": null,
            "animation_url": null,
            "animation_original_url": null,
            "name": "Mijn mooie muze I",
            "description": "Original art paint work on cardboard and the technique I used in this piece is airbrushing ,spray and acrylic .",
            "external_link": null,
            "asset_contract": {
                "address": "0x495f947276749ce646f68ac8c248420045cb7b5e",
                "asset_contract_type": "semi-fungible",
                "created_date": "2020-12-02T17:40:53.232025",
                "name": "OpenSea Collection",
                "nft_version": null,
                "opensea_version": "2.0.0",
                "owner": 102384,
                "schema_name": "ERC1155",
                "symbol": "OPENSTORE",
                "total_supply": null,
                "description": null,
                "external_link": null,
                "image_url": null,
                "default_to_fiat": false,
                "dev_buyer_fee_basis_points": 0,
                "dev_seller_fee_basis_points": 0,
                "only_proxied_transfers": false,
                "opensea_buyer_fee_basis_points": 0,
                "opensea_seller_fee_basis_points": 250,
                "buyer_fee_basis_points": 0,
                "seller_fee_basis_points": 250,
                "payout_address": null
            },
            "owner": {
                "user": {
                    "username": "NullAddress"
                },
                "profile_img_url": "https://storage.googleapis.com/opensea-static/opensea-profile/1.png",
                "address": "0x0000000000000000000000000000000000000000",
                "config": "",
                "discord_id": ""
            },
            "permalink": "https://opensea.io/assets/0x495f947276749ce646f68ac8c248420045cb7b5e/20481607965030952854761425679462123951057317320181018772818573496711318077441",
            "collection": {
                "banner_image_url": null,
                "chat_url": null,
                "created_date": "2021-05-03T12:17:40.646280",
                "default_to_fiat": false,
                "description": "    Creativity comes naturally in my being ,incessantly visions ,sounds ,colors and shapes becoming materialised ,being only the instrument of its cosmic manifestation ,you are welcome to my journey .",
                "dev_buyer_fee_basis_points": "0",
                "dev_seller_fee_basis_points": "1000",
                "discord_url": null,
                "display_data": {
                    "card_display_style": "contain"
                },
                "external_url": "http://artdzefont.com",
                "featured": false,
                "featured_image_url": "https://lh3.googleusercontent.com/EyCoywcx2l4ul5Fn7Z8HBFyveAFoWEh4mXLnwh-UNB1xp8tHwCtOSJu31fkXALG6kA8mOjM3Yh2P_HoE-8SuLkuQhabwAkp77d-UOQ=s300",
                "hidden": true,
                "safelist_request_status": "not_requested",
                "image_url": "https://lh3.googleusercontent.com/EyCoywcx2l4ul5Fn7Z8HBFyveAFoWEh4mXLnwh-UNB1xp8tHwCtOSJu31fkXALG6kA8mOjM3Yh2P_HoE-8SuLkuQhabwAkp77d-UOQ=s120",
                "is_subject_to_whitelist": false,
                "large_image_url": "https://lh3.googleusercontent.com/EyCoywcx2l4ul5Fn7Z8HBFyveAFoWEh4mXLnwh-UNB1xp8tHwCtOSJu31fkXALG6kA8mOjM3Yh2P_HoE-8SuLkuQhabwAkp77d-UOQ=s300",
                "medium_username": null,
                "name": "Arkematix",
                "only_proxied_transfers": false,
                "opensea_buyer_fee_basis_points": "0",
                "opensea_seller_fee_basis_points": "250",
                "payout_address": "0x2d482de6660b7ed2f8ef20f572b488ab5620c258",
                "require_email": false,
                "short_description": null,
                "slug": "cosmic-dance-4",
                "telegram_url": null,
                "twitter_username": null,
                "instagram_username": "artdzefont",
                "wiki_url": null
            },
            "decimals": null,
            "token_metadata": null,
            "sell_orders": [
                {
                    "created_date": "2021-05-26T07:36:20.631233",
                    "closing_date": "2021-05-31T07:35:59",
                    "closing_extendable": true,
                    "expiration_time": 1623051359,
                    "listing_time": 1622446559,
                    "order_hash": "0xa9bb5a9921b44b01c69049a77455cbc1c5852d02722bef37c289aa6ebf7a7aeb",
                    "metadata": {
                        "asset": {
                            "id": "20481607965030952854761425679462123951057317320181018772818573496711318077441",
                            "address": "0x495f947276749ce646f68ac8c248420045cb7b5e",
                            "quantity": "1"
                        },
                        "schema": "ERC1155"
                    },
                    "exchange": "0x7be8076f4ea4a4ad08075c2508e481d6c946d12b",
                    "maker": {
                        "user": 733397,
                        "profile_img_url": "https://storage.googleapis.com/opensea-static/opensea-profile/6.png",
                        "address": "0x2d482de6660b7ed2f8ef20f572b488ab5620c258",
                        "config": "",
                        "discord_id": ""
                    },
                    "taker": {
                        "user": 1766,
                        "profile_img_url": "https://storage.googleapis.com/opensea-static/opensea-profile/1.png",
                        "address": "0x0000000000000000000000000000000000000000",
                        "config": "",
                        "discord_id": ""
                    },
                    "current_price": "690000000000000000.0000000000",
                    "current_bounty": "6900000000000000",
                    "bounty_multiple": "0.01",
                    "maker_relayer_fee": "0",
                    "taker_relayer_fee": "1250",
                    "maker_protocol_fee": "0",
                    "taker_protocol_fee": "0",
                    "maker_referrer_fee": "0",
                    "fee_recipient": {
                        "user": 1766,
                        "profile_img_url": "https://storage.googleapis.com/opensea-static/opensea-profile/1.png",
                        "address": "0x0000000000000000000000000000000000000000",
                        "config": "",
                        "discord_id": ""
                    },
                    "fee_method": 1,
                    "side": 1,
                    "sale_kind": 0,
                    "target": "0x495f947276749ce646f68ac8c248420045cb7b5e",
                    "how_to_call": 0,
                    "calldata": "0xf242432a0000000000000000000000002d482de6660b7ed2f8ef20f572b488ab5620c25800000000000000000000000000000000000000000000000000000000000000002d482de6660b7ed2f8ef20f572b488ab5620c2580000000000008b0000000001000000000000000000000000000000000000000000000000000000000000000100000000000000000000000000000000000000000000000000000000000000a00000000000000000000000000000000000000000000000000000000000000000",
                    "replacement_pattern": "0x000000000000000000000000000000000000000000000000000000000000000000000000ffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffff0000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000",
                    "static_target": "0xbff6ade67e3717101dd8d0a7f3de1bf6623a2ba8",
                    "static_extradata": "0x589ad31c",
                    "payment_token": "0xc02aaa39b223fe8d0a0e5c4f27ead9083c756cc2",
                    "payment_token_contract": {
                        "id": 2,
                        "symbol": "WETH",
                        "address": "0xc02aaa39b223fe8d0a0e5c4f27ead9083c756cc2",
                        "image_url": "https://storage.opensea.io/files/accae6b6fb3888cbff27a013729c22dc.svg",
                        "name": "Wrapped Ether",
                        "decimals": 18,
                        "eth_price": "1.000000000000000",
                        "usd_price": "2868.630000000000109000"
                    },
                    "base_price": "690000000000000000",
                    "extra": "0",
                    "quantity": "1",
                    "salt": "68949186862510745434287309708204051956461257446328103978957297644142289778995",
                    "v": null,
                    "r": null,
                    "s": null,
                    "approved_on_chain": false,
                    "cancelled": false,
                    "finalized": false,
                    "marked_invalid": false,
                    "prefixed_hash": "0xa9977e801cf3fe37011d2a428f0f2457cc09bcd2cc34bbe1cb6964b99e706b23"
                }
            ],
            "creator": {
                "user": {
                    "username": "Arkematix"
                },
                "profile_img_url": "https://storage.googleapis.com/opensea-static/opensea-profile/6.png",
                "address": "0x2d482de6660b7ed2f8ef20f572b488ab5620c258",
                "config": "",
                "discord_id": ""
            },
            "traits": [
                {
                    "trait_type": "Art",
                    "value": "Airbrushing-spray-acrylic",
                    "display_type": null,
                    "max_value": null,
                    "trait_count": 41,
                    "order": null
                },
                {
                    "trait_type": "Original",
                    "value": "Mix-technique",
                    "display_type": null,
                    "max_value": null,
                    "trait_count": 28,
                    "order": null
                }
            ],
            "last_sale": null,
            "top_bid": null,
            "listing_date": null,
            "is_presale": true,
            "transfer_fee_payment_token": null,
            "transfer_fee": null
        },
        {
            "id": 25679498,
            "token_id": "1029508",
            "num_sales": 0,
            "background_color": null,
            "image_url": "https://lh3.googleusercontent.com/W0q-vFT1RDWngotIeKdoHu0dp4EtBWvs6Sljux5OMdUcLeedvC0gVY-Xg38DQAN9f0jsrpfRzlAOCwPpCpFuRPR7lrgpyIQ6xAYBSA",
            "image_preview_url": "https://lh3.googleusercontent.com/W0q-vFT1RDWngotIeKdoHu0dp4EtBWvs6Sljux5OMdUcLeedvC0gVY-Xg38DQAN9f0jsrpfRzlAOCwPpCpFuRPR7lrgpyIQ6xAYBSA=s250",
            "image_thumbnail_url": "https://lh3.googleusercontent.com/W0q-vFT1RDWngotIeKdoHu0dp4EtBWvs6Sljux5OMdUcLeedvC0gVY-Xg38DQAN9f0jsrpfRzlAOCwPpCpFuRPR7lrgpyIQ6xAYBSA=s128",
            "image_original_url": "https://ipfs.io/ipfs/QmQ2cv5fSrdS5P217eKitPaPdJuuZJsPKjZpu5f7AC581b/image.png",
            "animation_url": null,
            "animation_original_url": null,
            "name": "#001 Lil Macaw",
            "description": "This is lil Macaw - he is kind of suspicious...    After Purchase i can send you File in 120x120 and 2 other ratios wich you can choose up to 4080x4080",
            "external_link": "https://rarible.com/token/0x60f80121c31a0d46b5279700f9df786054aa5ee5:1029508",
            "asset_contract": {
                "address": "0x60f80121c31a0d46b5279700f9df786054aa5ee5",
                "asset_contract_type": "non-fungible",
                "created_date": "2020-05-27T17:06:50.488471",
                "name": "Rarible V2",
                "nft_version": "3.0",
                "opensea_version": null,
                "owner": 1634963,
                "schema_name": "ERC721",
                "symbol": "",
                "total_supply": "1",
                "description": "Create and sell digital collectibles secured with blockchain technology. Rarible is home to thousands of artists and collectors, creating and exchanging immutable art without using code. Trade with RARI token on OpenSea.",
                "external_link": "https://rarible.com/",
                "image_url": "https://lh3.googleusercontent.com/FG0QJ00fN3c_FWuPeUr9-T__iQl63j9hn5d6svW8UqOmia5zp3lKHPkJuHcvhZ0f_Pd6P2COo9tt9zVUvdPxG_9BBw=s60",
                "default_to_fiat": false,
                "dev_buyer_fee_basis_points": 0,
                "dev_seller_fee_basis_points": 0,
                "only_proxied_transfers": false,
                "opensea_buyer_fee_basis_points": 0,
                "opensea_seller_fee_basis_points": 250,
                "buyer_fee_basis_points": 0,
                "seller_fee_basis_points": 250,
                "payout_address": null
            },
            "owner": {
                "user": null,
                "profile_img_url": "https://storage.googleapis.com/opensea-static/opensea-profile/8.png",
                "address": "0x5ad775df3dd9e64687b279fc12e5e2e6902f8616",
                "config": "",
                "discord_id": ""
            },
            "permalink": "https://opensea.io/assets/0x60f80121c31a0d46b5279700f9df786054aa5ee5/1029508",
            "collection": {
                "banner_image_url": "https://storage.opensea.io/static/banners/rarible-banner4.png",
                "chat_url": null,
                "created_date": "2020-01-01T13:22:57.777065",
                "default_to_fiat": false,
                "description": "Create and sell digital collectibles secured with blockchain technology. Rarible is home to thousands of artists and collectors, creating and exchanging immutable art without using code. Trade with RARI token on OpenSea.",
                "dev_buyer_fee_basis_points": "0",
                "dev_seller_fee_basis_points": "0",
                "discord_url": null,
                "display_data": {
                    "card_display_style": "contain"
                },
                "external_url": "https://rarible.com/",
                "featured": false,
                "featured_image_url": null,
                "hidden": false,
                "safelist_request_status": "verified",
                "image_url": "https://lh3.googleusercontent.com/FG0QJ00fN3c_FWuPeUr9-T__iQl63j9hn5d6svW8UqOmia5zp3lKHPkJuHcvhZ0f_Pd6P2COo9tt9zVUvdPxG_9BBw=s60",
                "is_subject_to_whitelist": false,
                "large_image_url": "https://lh3.googleusercontent.com/FG0QJ00fN3c_FWuPeUr9-T__iQl63j9hn5d6svW8UqOmia5zp3lKHPkJuHcvhZ0f_Pd6P2COo9tt9zVUvdPxG_9BBw",
                "medium_username": "rarible",
                "name": "Rarible",
                "only_proxied_transfers": false,
                "opensea_buyer_fee_basis_points": "0",
                "opensea_seller_fee_basis_points": "250",
                "payout_address": null,
                "require_email": false,
                "short_description": null,
                "slug": "rarible",
                "telegram_url": "https://t.me/rarible",
                "twitter_username": "rariblecom",
                "instagram_username": null,
                "wiki_url": null
            },
            "decimals": 0,
            "token_metadata": "https://ipfs.io/ipfs/QmaNMyMWHayaZ4XejFe8zQGZeNTgkrV3vDZsDNx4uAzsbN",
            "sell_orders": null,
            "creator": {
                "user": null,
                "profile_img_url": "https://storage.googleapis.com/opensea-static/opensea-profile/8.png",
                "address": "0x5ad775df3dd9e64687b279fc12e5e2e6902f8616",
                "config": "",
                "discord_id": ""
            },
            "traits": [],
            "last_sale": null,
            "top_bid": null,
            "listing_date": null,
            "is_presale": false,
            "transfer_fee_payment_token": null,
            "transfer_fee": null
        },
        {
            "id": 25679497,
            "token_id": "3223",
            "num_sales": 0,
            "background_color": null,
            "image_url": "https://lh3.googleusercontent.com/3G09bcOjSfkbIiCnDTPdcifXndMofduTa9W4fLYcKDu45DoRdLrABJIaa8zFGe9iPTWyAKep2ajzP1wIQ0o5YiWG45xUiPsKgMoogQ",
            "image_preview_url": "https://lh3.googleusercontent.com/3G09bcOjSfkbIiCnDTPdcifXndMofduTa9W4fLYcKDu45DoRdLrABJIaa8zFGe9iPTWyAKep2ajzP1wIQ0o5YiWG45xUiPsKgMoogQ=s250",
            "image_thumbnail_url": "https://lh3.googleusercontent.com/3G09bcOjSfkbIiCnDTPdcifXndMofduTa9W4fLYcKDu45DoRdLrABJIaa8zFGe9iPTWyAKep2ajzP1wIQ0o5YiWG45xUiPsKgMoogQ=s128",
            "image_original_url": "https://embersword.mypinata.cloud/ipfs/QmdbeV27CatL3EddMf2Ek1jGt77amKgb5ghVeHrKWLyz84",
            "animation_url": "https://storage.opensea.io/files/b0cc4d04cbc1f26c66e7511d64cd2d9e.mp4",
            "animation_original_url": "https://embersword.mypinata.cloud/ipfs/QmfKgvFupW1dm9W3UusnrGKrabMT6hTD2DkhG27hAU7Lxx",
            "name": "Land (104,77)",
            "description": "Land plot",
            "external_link": null,
            "asset_contract": {
                "address": "0xe7e16f2da731265778f87cb8d7850e31b84b7b86",
                "asset_contract_type": "non-fungible",
                "created_date": "2021-05-25T13:23:10.895540",
                "name": "Embersword Land",
                "nft_version": null,
                "opensea_version": null,
                "owner": 35978059,
                "schema_name": "ERC721",
                "symbol": "LAND",
                "total_supply": "0",
                "description": null,
                "external_link": "https://embersword.com",
                "image_url": "https://lh3.googleusercontent.com/J7SSCNIDh1ui59aoqyNywPtnUAUB-Q80Cnl1txbxmJOAIKcRJT1bUYidkDPNegOk2W0zyjqVkLbdcI6g6KTYgQCDplCo3DXpDSeaPg=s120",
                "default_to_fiat": false,
                "dev_buyer_fee_basis_points": 0,
                "dev_seller_fee_basis_points": 0,
                "only_proxied_transfers": false,
                "opensea_buyer_fee_basis_points": 0,
                "opensea_seller_fee_basis_points": 250,
                "buyer_fee_basis_points": 0,
                "seller_fee_basis_points": 250,
                "payout_address": null
            },
            "owner": {
                "user": null,
                "profile_img_url": "https://storage.googleapis.com/opensea-static/opensea-profile/1.png",
                "address": "0x0000000000000000000000000000000000000000",
                "config": "",
                "discord_id": ""
            },
            "permalink": "https://opensea.io/assets/matic/0xe7e16f2da731265778f87cb8d7850e31b84b7b86/3223",
            "collection": {
                "banner_image_url": null,
                "chat_url": null,
                "created_date": "2021-05-25T16:51:25.426643",
                "default_to_fiat": false,
                "description": null,
                "dev_buyer_fee_basis_points": "0",
                "dev_seller_fee_basis_points": "0",
                "discord_url": "https://discord.gg/embersword",
                "display_data": {
                    "card_display_style": "contain"
                },
                "external_url": "https://embersword.com",
                "featured": false,
                "featured_image_url": null,
                "hidden": true,
                "safelist_request_status": "not_requested",
                "image_url": "https://lh3.googleusercontent.com/J7SSCNIDh1ui59aoqyNywPtnUAUB-Q80Cnl1txbxmJOAIKcRJT1bUYidkDPNegOk2W0zyjqVkLbdcI6g6KTYgQCDplCo3DXpDSeaPg=s120",
                "is_subject_to_whitelist": false,
                "large_image_url": null,
                "medium_username": "embersword",
                "name": "Ember Sword Land",
                "only_proxied_transfers": false,
                "opensea_buyer_fee_basis_points": "0",
                "opensea_seller_fee_basis_points": "250",
                "payout_address": null,
                "require_email": false,
                "short_description": null,
                "slug": "embersword-land",
                "telegram_url": null,
                "twitter_username": "PlayEmberSword",
                "instagram_username": null,
                "wiki_url": null
            },
            "decimals": null,
            "token_metadata": "https://embersword.mypinata.cloud/ipfs/QmVnk56HqXSpd3qziCg5rje3Fv4tdXy111XLNrEDso2U2H",
            "sell_orders": null,
            "creator": null,
            "traits": [
                {
                    "trait_type": "x-coordinate",
                    "value": 104,
                    "display_type": "number",
                    "max_value": null,
                    "trait_count": 0,
                    "order": null
                },
                {
                    "trait_type": "Type",
                    "value": "Land",
                    "display_type": null,
                    "max_value": null,
                    "trait_count": 2684,
                    "order": null
                },
                {
                    "trait_type": "y-coordinate",
                    "value": 77,
                    "display_type": "number",
                    "max_value": null,
                    "trait_count": 0,
                    "order": null
                }
            ],
            "last_sale": null,
            "top_bid": null,
            "listing_date": null,
            "is_presale": false,
            "transfer_fee_payment_token": null,
            "transfer_fee": null
        },
        {
            "id": 25679496,
            "token_id": "158456341796619601139024245541",
            "num_sales": 0,
            "background_color": null,
            "image_url": "https://lh3.googleusercontent.com/E9Ch3tbHtu6QVOrgdJ-bfwOYSjkMIUpr9fH3jNt3r0ucTYiE3v0wQvctNbAfQD8ye-tQGHxh2OlIM0b6HhAeVpKBz6wjBlFx1HoQPs0",
            "image_preview_url": "https://lh3.googleusercontent.com/E9Ch3tbHtu6QVOrgdJ-bfwOYSjkMIUpr9fH3jNt3r0ucTYiE3v0wQvctNbAfQD8ye-tQGHxh2OlIM0b6HhAeVpKBz6wjBlFx1HoQPs0=s250",
            "image_thumbnail_url": "https://lh3.googleusercontent.com/E9Ch3tbHtu6QVOrgdJ-bfwOYSjkMIUpr9fH3jNt3r0ucTYiE3v0wQvctNbAfQD8ye-tQGHxh2OlIM0b6HhAeVpKBz6wjBlFx1HoQPs0=s128",
            "image_original_url": "https://neon-district-season-one.s3.amazonaws.com/images/zenoautomatorp-uncommon-arms-female-thumb.png",
            "animation_url": null,
            "animation_original_url": null,
            "name": "Zeno Automator: Paragon",
            "description": "Armor found within Neon District.\n\nA Neon District: Season One game item, playable on https://portal.neondistrict.io.\n\nNeon District is a free-to-play cyberpunk role-playing game. Collect characters and gear, craft and level up teams, and battle against other players through competitive multiplayer and in turn-based combat.",
            "external_link": "https://portal.neondistrict.io/asset/158456341796619601139024245541",
            "asset_contract": {
                "address": "0x7227e371540cf7b8e512544ba6871472031f3335",
                "asset_contract_type": "non-fungible",
                "created_date": "2021-01-04T17:12:08.151181",
                "name": "Neon District Season One Item",
                "nft_version": null,
                "opensea_version": null,
                "owner": 17710883,
                "schema_name": "ERC721",
                "symbol": "NDITEM1",
                "total_supply": "475982",
                "description": "Neon District is a free-to-play cyberpunk role-playing game featuring collectible NFTs on Matic and Ethereum. Players collect characters and gear, craft and level up fully-equipped teams, and battle their teams against other players through the Neon Pizza competitive multiplayer missions or in real-time turn-based combat.",
                "external_link": null,
                "image_url": "https://lh3.googleusercontent.com/xttZf6L3I16h7HSgcfKFWhR7OhCdSO5UW_asXbRfGmQ7-a0QwJRNoPsmh_RlOpw-AFEngLqGYLD77cmjdBv4LCfVc5BxFG2PS1UU=s120",
                "default_to_fiat": false,
                "dev_buyer_fee_basis_points": 0,
                "dev_seller_fee_basis_points": 500,
                "only_proxied_transfers": false,
                "opensea_buyer_fee_basis_points": 0,
                "opensea_seller_fee_basis_points": 250,
                "buyer_fee_basis_points": 0,
                "seller_fee_basis_points": 750,
                "payout_address": "0x08262c33e987ed580b69d8f93134e987f881bdcc"
            },
            "owner": {
                "user": null,
                "profile_img_url": "https://storage.googleapis.com/opensea-static/opensea-profile/1.png",
                "address": "0x0000000000000000000000000000000000000000",
                "config": "",
                "discord_id": ""
            },
            "permalink": "https://opensea.io/assets/matic/0x7227e371540cf7b8e512544ba6871472031f3335/158456341796619601139024245541",
            "collection": {
                "banner_image_url": "https://lh3.googleusercontent.com/vtZXDR51ibkUx6v2XRf3imqsL-bUzy7tALBcjrwx0fNJywcMCqK_bVIfrvdlKQ5sysboHA23kGiwbgsGb5c_6ROGsyzc-SZURrtqRA=s2500",
                "chat_url": null,
                "created_date": "2021-01-04T17:12:08.305423",
                "default_to_fiat": false,
                "description": "Neon District is a free-to-play cyberpunk role-playing game featuring collectible NFTs on Matic and Ethereum. Players collect characters and gear, craft and level up fully-equipped teams, and battle their teams against other players through the Neon Pizza competitive multiplayer missions or in real-time turn-based combat.",
                "dev_buyer_fee_basis_points": "0",
                "dev_seller_fee_basis_points": "500",
                "discord_url": "https://discord.gg/ERu7Zw9YwZ",
                "display_data": {
                    "card_display_style": "contain"
                },
                "external_url": null,
                "featured": false,
                "featured_image_url": "https://lh3.googleusercontent.com/vtZXDR51ibkUx6v2XRf3imqsL-bUzy7tALBcjrwx0fNJywcMCqK_bVIfrvdlKQ5sysboHA23kGiwbgsGb5c_6ROGsyzc-SZURrtqRA=s300",
                "hidden": false,
                "safelist_request_status": "approved",
                "image_url": "https://lh3.googleusercontent.com/xttZf6L3I16h7HSgcfKFWhR7OhCdSO5UW_asXbRfGmQ7-a0QwJRNoPsmh_RlOpw-AFEngLqGYLD77cmjdBv4LCfVc5BxFG2PS1UU=s120",
                "is_subject_to_whitelist": false,
                "large_image_url": "https://lh3.googleusercontent.com/vtZXDR51ibkUx6v2XRf3imqsL-bUzy7tALBcjrwx0fNJywcMCqK_bVIfrvdlKQ5sysboHA23kGiwbgsGb5c_6ROGsyzc-SZURrtqRA=s300",
                "medium_username": "blockadegames",
                "name": "Neon District Season One Item",
                "only_proxied_transfers": false,
                "opensea_buyer_fee_basis_points": "0",
                "opensea_seller_fee_basis_points": "250",
                "payout_address": "0x08262c33e987ed580b69d8f93134e987f881bdcc",
                "require_email": false,
                "short_description": null,
                "slug": "neon-district-season-one-item",
                "telegram_url": null,
                "twitter_username": "neondistrictrpg",
                "instagram_username": null,
                "wiki_url": null
            },
            "decimals": null,
            "token_metadata": "https://portal.neondistrict.io/api/getNft/158456341796619601139024245541",
            "sell_orders": null,
            "creator": null,
            "traits": [
                {
                    "trait_type": "rarity",
                    "value": "Uncommon",
                    "display_type": null,
                    "max_value": null,
                    "trait_count": 99349,
                    "order": null
                },
                {
                    "trait_type": "level",
                    "value": 2,
                    "display_type": null,
                    "max_value": null,
                    "trait_count": 0,
                    "order": null
                },
                {
                    "trait_type": "Nano",
                    "value": 0,
                    "display_type": "boost_number",
                    "max_value": null,
                    "trait_count": 0,
                    "order": null
                },
                {
                    "trait_type": "Health",
                    "value": 10,
                    "display_type": "boost_number",
                    "max_value": null,
                    "trait_count": 0,
                    "order": null
                },
                {
                    "trait_type": "Defense",
                    "value": 21,
                    "display_type": "boost_number",
                    "max_value": null,
                    "trait_count": 0,
                    "order": null
                },
                {
                    "trait_type": "Mech",
                    "value": 5,
                    "display_type": "boost_number",
                    "max_value": null,
                    "trait_count": 0,
                    "order": null
                },
                {
                    "trait_type": "Season",
                    "value": 1,
                    "display_type": "number",
                    "max_value": null,
                    "trait_count": 0,
                    "order": null
                },
                {
                    "trait_type": "Tactics",
                    "value": 10,
                    "display_type": "boost_number",
                    "max_value": null,
                    "trait_count": 0,
                    "order": null
                },
                {
                    "trait_type": "type",
                    "value": "Armor",
                    "display_type": null,
                    "max_value": null,
                    "trait_count": 323031,
                    "order": null
                },
                {
                    "trait_type": "Attack",
                    "value": 10,
                    "display_type": "boost_number",
                    "max_value": null,
                    "trait_count": 0,
                    "order": null
                },
                {
                    "trait_type": "Hacking",
                    "value": 0,
                    "display_type": "boost_number",
                    "max_value": null,
                    "trait_count": 0,
                    "order": null
                },
                {
                    "trait_type": "Stealth",
                    "value": 0,
                    "display_type": "boost_number",
                    "max_value": null,
                    "trait_count": 0,
                    "order": null
                },
                {
                    "trait_type": "Armor Slot",
                    "value": "Arms",
                    "display_type": null,
                    "max_value": null,
                    "trait_count": 80724,
                    "order": null
                }
            ],
            "last_sale": null,
            "top_bid": null,
            "listing_date": null,
            "is_presale": false,
            "transfer_fee_payment_token": null,
            "transfer_fee": null
        },
        {
            "id": 25679495,
            "token_id": "158456327684860384751217259300",
            "num_sales": 0,
            "background_color": null,
            "image_url": "https://lh3.googleusercontent.com/PfpC3K4ZiaXlQ_F3XVuhN08u7Eq1quRUehWXypjhIX3bsqOAU3aznvQ6vRPyOMlaJSixrF9k0LuqtRomPfuaieWUU_uaKdy91CDh",
            "image_preview_url": "https://lh3.googleusercontent.com/PfpC3K4ZiaXlQ_F3XVuhN08u7Eq1quRUehWXypjhIX3bsqOAU3aznvQ6vRPyOMlaJSixrF9k0LuqtRomPfuaieWUU_uaKdy91CDh=s250",
            "image_thumbnail_url": "https://lh3.googleusercontent.com/PfpC3K4ZiaXlQ_F3XVuhN08u7Eq1quRUehWXypjhIX3bsqOAU3aznvQ6vRPyOMlaJSixrF9k0LuqtRomPfuaieWUU_uaKdy91CDh=s128",
            "image_original_url": "https://neon-district-season-one.s3.amazonaws.com/images/blkoriginwristbox-uncommon-console-sml-thumb.png",
            "animation_url": null,
            "animation_original_url": null,
            "name": "Wristbox",
            "description": "A weapon found within Neon District.\n\nA Neon District: Season One game item, playable on https://portal.neondistrict.io.\n\nNeon District is a free-to-play cyberpunk role-playing game. Collect characters and gear, craft and level up teams, and battle against other players through competitive multiplayer and in turn-based combat.",
            "external_link": "https://portal.neondistrict.io/asset/158456327684860384751217259300",
            "asset_contract": {
                "address": "0x7227e371540cf7b8e512544ba6871472031f3335",
                "asset_contract_type": "non-fungible",
                "created_date": "2021-01-04T17:12:08.151181",
                "name": "Neon District Season One Item",
                "nft_version": null,
                "opensea_version": null,
                "owner": 17710883,
                "schema_name": "ERC721",
                "symbol": "NDITEM1",
                "total_supply": "475982",
                "description": "Neon District is a free-to-play cyberpunk role-playing game featuring collectible NFTs on Matic and Ethereum. Players collect characters and gear, craft and level up fully-equipped teams, and battle their teams against other players through the Neon Pizza competitive multiplayer missions or in real-time turn-based combat.",
                "external_link": null,
                "image_url": "https://lh3.googleusercontent.com/xttZf6L3I16h7HSgcfKFWhR7OhCdSO5UW_asXbRfGmQ7-a0QwJRNoPsmh_RlOpw-AFEngLqGYLD77cmjdBv4LCfVc5BxFG2PS1UU=s120",
                "default_to_fiat": false,
                "dev_buyer_fee_basis_points": 0,
                "dev_seller_fee_basis_points": 500,
                "only_proxied_transfers": false,
                "opensea_buyer_fee_basis_points": 0,
                "opensea_seller_fee_basis_points": 250,
                "buyer_fee_basis_points": 0,
                "seller_fee_basis_points": 750,
                "payout_address": "0x08262c33e987ed580b69d8f93134e987f881bdcc"
            },
            "owner": {
                "user": null,
                "profile_img_url": "https://storage.googleapis.com/opensea-static/opensea-profile/1.png",
                "address": "0x0000000000000000000000000000000000000000",
                "config": "",
                "discord_id": ""
            },
            "permalink": "https://opensea.io/assets/matic/0x7227e371540cf7b8e512544ba6871472031f3335/158456327684860384751217259300",
            "collection": {
                "banner_image_url": "https://lh3.googleusercontent.com/vtZXDR51ibkUx6v2XRf3imqsL-bUzy7tALBcjrwx0fNJywcMCqK_bVIfrvdlKQ5sysboHA23kGiwbgsGb5c_6ROGsyzc-SZURrtqRA=s2500",
                "chat_url": null,
                "created_date": "2021-01-04T17:12:08.305423",
                "default_to_fiat": false,
                "description": "Neon District is a free-to-play cyberpunk role-playing game featuring collectible NFTs on Matic and Ethereum. Players collect characters and gear, craft and level up fully-equipped teams, and battle their teams against other players through the Neon Pizza competitive multiplayer missions or in real-time turn-based combat.",
                "dev_buyer_fee_basis_points": "0",
                "dev_seller_fee_basis_points": "500",
                "discord_url": "https://discord.gg/ERu7Zw9YwZ",
                "display_data": {
                    "card_display_style": "contain"
                },
                "external_url": null,
                "featured": false,
                "featured_image_url": "https://lh3.googleusercontent.com/vtZXDR51ibkUx6v2XRf3imqsL-bUzy7tALBcjrwx0fNJywcMCqK_bVIfrvdlKQ5sysboHA23kGiwbgsGb5c_6ROGsyzc-SZURrtqRA=s300",
                "hidden": false,
                "safelist_request_status": "approved",
                "image_url": "https://lh3.googleusercontent.com/xttZf6L3I16h7HSgcfKFWhR7OhCdSO5UW_asXbRfGmQ7-a0QwJRNoPsmh_RlOpw-AFEngLqGYLD77cmjdBv4LCfVc5BxFG2PS1UU=s120",
                "is_subject_to_whitelist": false,
                "large_image_url": "https://lh3.googleusercontent.com/vtZXDR51ibkUx6v2XRf3imqsL-bUzy7tALBcjrwx0fNJywcMCqK_bVIfrvdlKQ5sysboHA23kGiwbgsGb5c_6ROGsyzc-SZURrtqRA=s300",
                "medium_username": "blockadegames",
                "name": "Neon District Season One Item",
                "only_proxied_transfers": false,
                "opensea_buyer_fee_basis_points": "0",
                "opensea_seller_fee_basis_points": "250",
                "payout_address": "0x08262c33e987ed580b69d8f93134e987f881bdcc",
                "require_email": false,
                "short_description": null,
                "slug": "neon-district-season-one-item",
                "telegram_url": null,
                "twitter_username": "neondistrictrpg",
                "instagram_username": null,
                "wiki_url": null
            },
            "decimals": null,
            "token_metadata": "https://portal.neondistrict.io/api/getNft/158456327684860384751217259300",
            "sell_orders": null,
            "creator": null,
            "traits": [
                {
                    "trait_type": "rarity",
                    "value": "Uncommon",
                    "display_type": null,
                    "max_value": null,
                    "trait_count": 99349,
                    "order": null
                },
                {
                    "trait_type": "level",
                    "value": 2,
                    "display_type": null,
                    "max_value": null,
                    "trait_count": 0,
                    "order": null
                },
                {
                    "trait_type": "Defense",
                    "value": 10,
                    "display_type": "boost_number",
                    "max_value": null,
                    "trait_count": 0,
                    "order": null
                },
                {
                    "trait_type": "type",
                    "value": "Weapon",
                    "display_type": null,
                    "max_value": null,
                    "trait_count": 55075,
                    "order": null
                },
                {
                    "trait_type": "Mech",
                    "value": 5,
                    "display_type": "boost_number",
                    "max_value": null,
                    "trait_count": 0,
                    "order": null
                },
                {
                    "trait_type": "Card",
                    "value": "Version 2.0",
                    "display_type": null,
                    "max_value": null,
                    "trait_count": 207,
                    "order": null
                },
                {
                    "trait_type": "Season",
                    "value": 1,
                    "display_type": "number",
                    "max_value": null,
                    "trait_count": 0,
                    "order": null
                },
                {
                    "trait_type": "Stealth",
                    "value": 5,
                    "display_type": "boost_number",
                    "max_value": null,
                    "trait_count": 0,
                    "order": null
                },
                {
                    "trait_type": "Nano",
                    "value": 15,
                    "display_type": "boost_number",
                    "max_value": null,
                    "trait_count": 0,
                    "order": null
                },
                {
                    "trait_type": "Attack",
                    "value": 10,
                    "display_type": "boost_number",
                    "max_value": null,
                    "trait_count": 0,
                    "order": null
                },
                {
                    "trait_type": "Tactics",
                    "value": 5,
                    "display_type": "boost_number",
                    "max_value": null,
                    "trait_count": 0,
                    "order": null
                },
                {
                    "trait_type": "Health",
                    "value": 100,
                    "display_type": "boost_number",
                    "max_value": null,
                    "trait_count": 0,
                    "order": null
                },
                {
                    "trait_type": "Hacking",
                    "value": 25,
                    "display_type": "boost_number",
                    "max_value": null,
                    "trait_count": 0,
                    "order": null
                },
                {
                    "trait_type": "Card",
                    "value": "Touch of a Button",
                    "display_type": null,
                    "max_value": null,
                    "trait_count": 5093,
                    "order": null
                },
                {
                    "trait_type": "Card",
                    "value": "Quick Hack",
                    "display_type": null,
                    "max_value": null,
                    "trait_count": 5088,
                    "order": null
                },
                {
                    "trait_type": "Card",
                    "value": "Factor",
                    "display_type": null,
                    "max_value": null,
                    "trait_count": 5067,
                    "order": null
                },
                {
                    "trait_type": "Card",
                    "value": "Firewall",
                    "display_type": null,
                    "max_value": null,
                    "trait_count": 5086,
                    "order": null
                }
            ],
            "last_sale": null,
            "top_bid": null,
            "listing_date": null,
            "is_presale": false,
            "transfer_fee_payment_token": null,
            "transfer_fee": null
        },
        {
            "id": 25679494,
            "token_id": "158456341464578207812252316451",
            "num_sales": 0,
            "background_color": null,
            "image_url": "https://lh3.googleusercontent.com/AWcM1zjbhkDyk9_eHn8XVECxVh5oN8VcKRAdslRwc4xXk5pE7nQ1B4qUHojbbcBaf9ZRFuAT_2041220D5rWJb6UetJS-74YeYsh1w",
            "image_preview_url": "https://lh3.googleusercontent.com/AWcM1zjbhkDyk9_eHn8XVECxVh5oN8VcKRAdslRwc4xXk5pE7nQ1B4qUHojbbcBaf9ZRFuAT_2041220D5rWJb6UetJS-74YeYsh1w=s250",
            "image_thumbnail_url": "https://lh3.googleusercontent.com/AWcM1zjbhkDyk9_eHn8XVECxVh5oN8VcKRAdslRwc4xXk5pE7nQ1B4qUHojbbcBaf9ZRFuAT_2041220D5rWJb6UetJS-74YeYsh1w=s128",
            "image_original_url": "https://neon-district-season-one.s3.amazonaws.com/images/zenotechnicianr-rare-head-male-thumb.png",
            "animation_url": null,
            "animation_original_url": null,
            "name": "Zeno Technician: Renegade",
            "description": "Armor found within Neon District.\n\nA Neon District: Season One game item, playable on https://portal.neondistrict.io.\n\nNeon District is a free-to-play cyberpunk role-playing game. Collect characters and gear, craft and level up teams, and battle against other players through competitive multiplayer and in turn-based combat.",
            "external_link": "https://portal.neondistrict.io/asset/158456341464578207812252316451",
            "asset_contract": {
                "address": "0x7227e371540cf7b8e512544ba6871472031f3335",
                "asset_contract_type": "non-fungible",
                "created_date": "2021-01-04T17:12:08.151181",
                "name": "Neon District Season One Item",
                "nft_version": null,
                "opensea_version": null,
                "owner": 17710883,
                "schema_name": "ERC721",
                "symbol": "NDITEM1",
                "total_supply": "475982",
                "description": "Neon District is a free-to-play cyberpunk role-playing game featuring collectible NFTs on Matic and Ethereum. Players collect characters and gear, craft and level up fully-equipped teams, and battle their teams against other players through the Neon Pizza competitive multiplayer missions or in real-time turn-based combat.",
                "external_link": null,
                "image_url": "https://lh3.googleusercontent.com/xttZf6L3I16h7HSgcfKFWhR7OhCdSO5UW_asXbRfGmQ7-a0QwJRNoPsmh_RlOpw-AFEngLqGYLD77cmjdBv4LCfVc5BxFG2PS1UU=s120",
                "default_to_fiat": false,
                "dev_buyer_fee_basis_points": 0,
                "dev_seller_fee_basis_points": 500,
                "only_proxied_transfers": false,
                "opensea_buyer_fee_basis_points": 0,
                "opensea_seller_fee_basis_points": 250,
                "buyer_fee_basis_points": 0,
                "seller_fee_basis_points": 750,
                "payout_address": "0x08262c33e987ed580b69d8f93134e987f881bdcc"
            },
            "owner": {
                "user": null,
                "profile_img_url": "https://storage.googleapis.com/opensea-static/opensea-profile/1.png",
                "address": "0x0000000000000000000000000000000000000000",
                "config": "",
                "discord_id": ""
            },
            "permalink": "https://opensea.io/assets/matic/0x7227e371540cf7b8e512544ba6871472031f3335/158456341464578207812252316451",
            "collection": {
                "banner_image_url": "https://lh3.googleusercontent.com/vtZXDR51ibkUx6v2XRf3imqsL-bUzy7tALBcjrwx0fNJywcMCqK_bVIfrvdlKQ5sysboHA23kGiwbgsGb5c_6ROGsyzc-SZURrtqRA=s2500",
                "chat_url": null,
                "created_date": "2021-01-04T17:12:08.305423",
                "default_to_fiat": false,
                "description": "Neon District is a free-to-play cyberpunk role-playing game featuring collectible NFTs on Matic and Ethereum. Players collect characters and gear, craft and level up fully-equipped teams, and battle their teams against other players through the Neon Pizza competitive multiplayer missions or in real-time turn-based combat.",
                "dev_buyer_fee_basis_points": "0",
                "dev_seller_fee_basis_points": "500",
                "discord_url": "https://discord.gg/ERu7Zw9YwZ",
                "display_data": {
                    "card_display_style": "contain"
                },
                "external_url": null,
                "featured": false,
                "featured_image_url": "https://lh3.googleusercontent.com/vtZXDR51ibkUx6v2XRf3imqsL-bUzy7tALBcjrwx0fNJywcMCqK_bVIfrvdlKQ5sysboHA23kGiwbgsGb5c_6ROGsyzc-SZURrtqRA=s300",
                "hidden": false,
                "safelist_request_status": "approved",
                "image_url": "https://lh3.googleusercontent.com/xttZf6L3I16h7HSgcfKFWhR7OhCdSO5UW_asXbRfGmQ7-a0QwJRNoPsmh_RlOpw-AFEngLqGYLD77cmjdBv4LCfVc5BxFG2PS1UU=s120",
                "is_subject_to_whitelist": false,
                "large_image_url": "https://lh3.googleusercontent.com/vtZXDR51ibkUx6v2XRf3imqsL-bUzy7tALBcjrwx0fNJywcMCqK_bVIfrvdlKQ5sysboHA23kGiwbgsGb5c_6ROGsyzc-SZURrtqRA=s300",
                "medium_username": "blockadegames",
                "name": "Neon District Season One Item",
                "only_proxied_transfers": false,
                "opensea_buyer_fee_basis_points": "0",
                "opensea_seller_fee_basis_points": "250",
                "payout_address": "0x08262c33e987ed580b69d8f93134e987f881bdcc",
                "require_email": false,
                "short_description": null,
                "slug": "neon-district-season-one-item",
                "telegram_url": null,
                "twitter_username": "neondistrictrpg",
                "instagram_username": null,
                "wiki_url": null
            },
            "decimals": null,
            "token_metadata": "https://portal.neondistrict.io/api/getNft/158456341464578207812252316451",
            "sell_orders": null,
            "creator": null,
            "traits": [
                {
                    "trait_type": "Hacking",
                    "value": 32,
                    "display_type": "boost_number",
                    "max_value": null,
                    "trait_count": 0,
                    "order": null
                },
                {
                    "trait_type": "Nano",
                    "value": 0,
                    "display_type": "boost_number",
                    "max_value": null,
                    "trait_count": 0,
                    "order": null
                },
                {
                    "trait_type": "rarity",
                    "value": "Rare",
                    "display_type": null,
                    "max_value": null,
                    "trait_count": 82322,
                    "order": null
                },
                {
                    "trait_type": "level",
                    "value": 3,
                    "display_type": null,
                    "max_value": null,
                    "trait_count": 0,
                    "order": null
                },
                {
                    "trait_type": "Season",
                    "value": 1,
                    "display_type": "number",
                    "max_value": null,
                    "trait_count": 0,
                    "order": null
                },
                {
                    "trait_type": "Tactics",
                    "value": 5,
                    "display_type": "boost_number",
                    "max_value": null,
                    "trait_count": 0,
                    "order": null
                },
                {
                    "trait_type": "type",
                    "value": "Armor",
                    "display_type": null,
                    "max_value": null,
                    "trait_count": 323031,
                    "order": null
                },
                {
                    "trait_type": "Mech",
                    "value": 3,
                    "display_type": "boost_number",
                    "max_value": null,
                    "trait_count": 0,
                    "order": null
                },
                {
                    "trait_type": "Stealth",
                    "value": 0,
                    "display_type": "boost_number",
                    "max_value": null,
                    "trait_count": 0,
                    "order": null
                },
                {
                    "trait_type": "Armor Slot",
                    "value": "Head",
                    "display_type": null,
                    "max_value": null,
                    "trait_count": 80428,
                    "order": null
                },
                {
                    "trait_type": "Attack",
                    "value": 4,
                    "display_type": "boost_number",
                    "max_value": null,
                    "trait_count": 0,
                    "order": null
                },
                {
                    "trait_type": "Health",
                    "value": 65,
                    "display_type": "boost_number",
                    "max_value": null,
                    "trait_count": 0,
                    "order": null
                },
                {
                    "trait_type": "Defense",
                    "value": 14,
                    "display_type": "boost_number",
                    "max_value": null,
                    "trait_count": 0,
                    "order": null
                }
            ],
            "last_sale": null,
            "top_bid": null,
            "listing_date": null,
            "is_presale": false,
            "transfer_fee_payment_token": null,
            "transfer_fee": null
        },
        {
            "id": 25679493,
            "token_id": "158456336281043123099868312354",
            "num_sales": 0,
            "background_color": null,
            "image_url": "https://lh3.googleusercontent.com/5dUEgrlAUWiMt-vN1rd9QDp7PgU1db42L21iY_uxP1E34gVfOG27A433q5a58Vt_JI48ZaUfO5TeHVioZYtIGB7DhjPCnyJ7iQ5gJHA",
            "image_preview_url": "https://lh3.googleusercontent.com/5dUEgrlAUWiMt-vN1rd9QDp7PgU1db42L21iY_uxP1E34gVfOG27A433q5a58Vt_JI48ZaUfO5TeHVioZYtIGB7DhjPCnyJ7iQ5gJHA=s250",
            "image_thumbnail_url": "https://lh3.googleusercontent.com/5dUEgrlAUWiMt-vN1rd9QDp7PgU1db42L21iY_uxP1E34gVfOG27A433q5a58Vt_JI48ZaUfO5TeHVioZYtIGB7DhjPCnyJ7iQ5gJHA=s128",
            "image_original_url": "https://neon-district-season-one.s3.amazonaws.com/images/factorbuilderp-ultrarare-head-female-thumb.png",
            "animation_url": null,
            "animation_original_url": null,
            "name": "Factor Builder: Paragon",
            "description": "Armor found within Neon District.\n\nA Neon District: Season One game item, playable on https://portal.neondistrict.io.\n\nNeon District is a free-to-play cyberpunk role-playing game. Collect characters and gear, craft and level up teams, and battle against other players through competitive multiplayer and in turn-based combat.",
            "external_link": "https://portal.neondistrict.io/asset/158456336281043123099868312354",
            "asset_contract": {
                "address": "0x7227e371540cf7b8e512544ba6871472031f3335",
                "asset_contract_type": "non-fungible",
                "created_date": "2021-01-04T17:12:08.151181",
                "name": "Neon District Season One Item",
                "nft_version": null,
                "opensea_version": null,
                "owner": 17710883,
                "schema_name": "ERC721",
                "symbol": "NDITEM1",
                "total_supply": "475982",
                "description": "Neon District is a free-to-play cyberpunk role-playing game featuring collectible NFTs on Matic and Ethereum. Players collect characters and gear, craft and level up fully-equipped teams, and battle their teams against other players through the Neon Pizza competitive multiplayer missions or in real-time turn-based combat.",
                "external_link": null,
                "image_url": "https://lh3.googleusercontent.com/xttZf6L3I16h7HSgcfKFWhR7OhCdSO5UW_asXbRfGmQ7-a0QwJRNoPsmh_RlOpw-AFEngLqGYLD77cmjdBv4LCfVc5BxFG2PS1UU=s120",
                "default_to_fiat": false,
                "dev_buyer_fee_basis_points": 0,
                "dev_seller_fee_basis_points": 500,
                "only_proxied_transfers": false,
                "opensea_buyer_fee_basis_points": 0,
                "opensea_seller_fee_basis_points": 250,
                "buyer_fee_basis_points": 0,
                "seller_fee_basis_points": 750,
                "payout_address": "0x08262c33e987ed580b69d8f93134e987f881bdcc"
            },
            "owner": {
                "user": null,
                "profile_img_url": "https://storage.googleapis.com/opensea-static/opensea-profile/1.png",
                "address": "0x0000000000000000000000000000000000000000",
                "config": "",
                "discord_id": ""
            },
            "permalink": "https://opensea.io/assets/matic/0x7227e371540cf7b8e512544ba6871472031f3335/158456336281043123099868312354",
            "collection": {
                "banner_image_url": "https://lh3.googleusercontent.com/vtZXDR51ibkUx6v2XRf3imqsL-bUzy7tALBcjrwx0fNJywcMCqK_bVIfrvdlKQ5sysboHA23kGiwbgsGb5c_6ROGsyzc-SZURrtqRA=s2500",
                "chat_url": null,
                "created_date": "2021-01-04T17:12:08.305423",
                "default_to_fiat": false,
                "description": "Neon District is a free-to-play cyberpunk role-playing game featuring collectible NFTs on Matic and Ethereum. Players collect characters and gear, craft and level up fully-equipped teams, and battle their teams against other players through the Neon Pizza competitive multiplayer missions or in real-time turn-based combat.",
                "dev_buyer_fee_basis_points": "0",
                "dev_seller_fee_basis_points": "500",
                "discord_url": "https://discord.gg/ERu7Zw9YwZ",
                "display_data": {
                    "card_display_style": "contain"
                },
                "external_url": null,
                "featured": false,
                "featured_image_url": "https://lh3.googleusercontent.com/vtZXDR51ibkUx6v2XRf3imqsL-bUzy7tALBcjrwx0fNJywcMCqK_bVIfrvdlKQ5sysboHA23kGiwbgsGb5c_6ROGsyzc-SZURrtqRA=s300",
                "hidden": false,
                "safelist_request_status": "approved",
                "image_url": "https://lh3.googleusercontent.com/xttZf6L3I16h7HSgcfKFWhR7OhCdSO5UW_asXbRfGmQ7-a0QwJRNoPsmh_RlOpw-AFEngLqGYLD77cmjdBv4LCfVc5BxFG2PS1UU=s120",
                "is_subject_to_whitelist": false,
                "large_image_url": "https://lh3.googleusercontent.com/vtZXDR51ibkUx6v2XRf3imqsL-bUzy7tALBcjrwx0fNJywcMCqK_bVIfrvdlKQ5sysboHA23kGiwbgsGb5c_6ROGsyzc-SZURrtqRA=s300",
                "medium_username": "blockadegames",
                "name": "Neon District Season One Item",
                "only_proxied_transfers": false,
                "opensea_buyer_fee_basis_points": "0",
                "opensea_seller_fee_basis_points": "250",
                "payout_address": "0x08262c33e987ed580b69d8f93134e987f881bdcc",
                "require_email": false,
                "short_description": null,
                "slug": "neon-district-season-one-item",
                "telegram_url": null,
                "twitter_username": "neondistrictrpg",
                "instagram_username": null,
                "wiki_url": null
            },
            "decimals": null,
            "token_metadata": "https://portal.neondistrict.io/api/getNft/158456336281043123099868312354",
            "sell_orders": null,
            "creator": null,
            "traits": [
                {
                    "trait_type": "level",
                    "value": 4,
                    "display_type": null,
                    "max_value": null,
                    "trait_count": 0,
                    "order": null
                },
                {
                    "trait_type": "Mech",
                    "value": 37,
                    "display_type": "boost_number",
                    "max_value": null,
                    "trait_count": 0,
                    "order": null
                },
                {
                    "trait_type": "Nano",
                    "value": 5,
                    "display_type": "boost_number",
                    "max_value": null,
                    "trait_count": 0,
                    "order": null
                },
                {
                    "trait_type": "Hacking",
                    "value": 19,
                    "display_type": "boost_number",
                    "max_value": null,
                    "trait_count": 0,
                    "order": null
                },
                {
                    "trait_type": "Season",
                    "value": 1,
                    "display_type": "number",
                    "max_value": null,
                    "trait_count": 0,
                    "order": null
                },
                {
                    "trait_type": "Defense",
                    "value": 9,
                    "display_type": "boost_number",
                    "max_value": null,
                    "trait_count": 0,
                    "order": null
                },
                {
                    "trait_type": "type",
                    "value": "Armor",
                    "display_type": null,
                    "max_value": null,
                    "trait_count": 323031,
                    "order": null
                },
                {
                    "trait_type": "Attack",
                    "value": 9,
                    "display_type": "boost_number",
                    "max_value": null,
                    "trait_count": 0,
                    "order": null
                },
                {
                    "trait_type": "Stealth",
                    "value": 0,
                    "display_type": "boost_number",
                    "max_value": null,
                    "trait_count": 0,
                    "order": null
                },
                {
                    "trait_type": "rarity",
                    "value": "Ultra Rare",
                    "display_type": null,
                    "max_value": null,
                    "trait_count": 42712,
                    "order": null
                },
                {
                    "trait_type": "Armor Slot",
                    "value": "Head",
                    "display_type": null,
                    "max_value": null,
                    "trait_count": 80428,
                    "order": null
                },
                {
                    "trait_type": "Tactics",
                    "value": 0,
                    "display_type": "boost_number",
                    "max_value": null,
                    "trait_count": 0,
                    "order": null
                },
                {
                    "trait_type": "Health",
                    "value": 69,
                    "display_type": "boost_number",
                    "max_value": null,
                    "trait_count": 0,
                    "order": null
                }
            ],
            "last_sale": null,
            "top_bid": null,
            "listing_date": null,
            "is_presale": false,
            "transfer_fee_payment_token": null,
            "transfer_fee": null
        },
        {
            "id": 25679492,
            "token_id": "3222",
            "num_sales": 0,
            "background_color": null,
            "image_url": "https://lh3.googleusercontent.com/3G09bcOjSfkbIiCnDTPdcifXndMofduTa9W4fLYcKDu45DoRdLrABJIaa8zFGe9iPTWyAKep2ajzP1wIQ0o5YiWG45xUiPsKgMoogQ",
            "image_preview_url": "https://lh3.googleusercontent.com/3G09bcOjSfkbIiCnDTPdcifXndMofduTa9W4fLYcKDu45DoRdLrABJIaa8zFGe9iPTWyAKep2ajzP1wIQ0o5YiWG45xUiPsKgMoogQ=s250",
            "image_thumbnail_url": "https://lh3.googleusercontent.com/3G09bcOjSfkbIiCnDTPdcifXndMofduTa9W4fLYcKDu45DoRdLrABJIaa8zFGe9iPTWyAKep2ajzP1wIQ0o5YiWG45xUiPsKgMoogQ=s128",
            "image_original_url": "https://embersword.mypinata.cloud/ipfs/QmdbeV27CatL3EddMf2Ek1jGt77amKgb5ghVeHrKWLyz84",
            "animation_url": "https://storage.opensea.io/files/b0cc4d04cbc1f26c66e7511d64cd2d9e.mp4",
            "animation_original_url": "https://embersword.mypinata.cloud/ipfs/QmfKgvFupW1dm9W3UusnrGKrabMT6hTD2DkhG27hAU7Lxx",
            "name": "Land (104,78)",
            "description": "Land plot",
            "external_link": null,
            "asset_contract": {
                "address": "0xe7e16f2da731265778f87cb8d7850e31b84b7b86",
                "asset_contract_type": "non-fungible",
                "created_date": "2021-05-25T13:23:10.895540",
                "name": "Embersword Land",
                "nft_version": null,
                "opensea_version": null,
                "owner": 35978059,
                "schema_name": "ERC721",
                "symbol": "LAND",
                "total_supply": "0",
                "description": null,
                "external_link": "https://embersword.com",
                "image_url": "https://lh3.googleusercontent.com/J7SSCNIDh1ui59aoqyNywPtnUAUB-Q80Cnl1txbxmJOAIKcRJT1bUYidkDPNegOk2W0zyjqVkLbdcI6g6KTYgQCDplCo3DXpDSeaPg=s120",
                "default_to_fiat": false,
                "dev_buyer_fee_basis_points": 0,
                "dev_seller_fee_basis_points": 0,
                "only_proxied_transfers": false,
                "opensea_buyer_fee_basis_points": 0,
                "opensea_seller_fee_basis_points": 250,
                "buyer_fee_basis_points": 0,
                "seller_fee_basis_points": 250,
                "payout_address": null
            },
            "owner": {
                "user": null,
                "profile_img_url": "https://storage.googleapis.com/opensea-static/opensea-profile/1.png",
                "address": "0x0000000000000000000000000000000000000000",
                "config": "",
                "discord_id": ""
            },
            "permalink": "https://opensea.io/assets/matic/0xe7e16f2da731265778f87cb8d7850e31b84b7b86/3222",
            "collection": {
                "banner_image_url": null,
                "chat_url": null,
                "created_date": "2021-05-25T16:51:25.426643",
                "default_to_fiat": false,
                "description": null,
                "dev_buyer_fee_basis_points": "0",
                "dev_seller_fee_basis_points": "0",
                "discord_url": "https://discord.gg/embersword",
                "display_data": {
                    "card_display_style": "contain"
                },
                "external_url": "https://embersword.com",
                "featured": false,
                "featured_image_url": null,
                "hidden": true,
                "safelist_request_status": "not_requested",
                "image_url": "https://lh3.googleusercontent.com/J7SSCNIDh1ui59aoqyNywPtnUAUB-Q80Cnl1txbxmJOAIKcRJT1bUYidkDPNegOk2W0zyjqVkLbdcI6g6KTYgQCDplCo3DXpDSeaPg=s120",
                "is_subject_to_whitelist": false,
                "large_image_url": null,
                "medium_username": "embersword",
                "name": "Ember Sword Land",
                "only_proxied_transfers": false,
                "opensea_buyer_fee_basis_points": "0",
                "opensea_seller_fee_basis_points": "250",
                "payout_address": null,
                "require_email": false,
                "short_description": null,
                "slug": "embersword-land",
                "telegram_url": null,
                "twitter_username": "PlayEmberSword",
                "instagram_username": null,
                "wiki_url": null
            },
            "decimals": null,
            "token_metadata": "https://embersword.mypinata.cloud/ipfs/Qmac6fqDvGUebATGRHiPY8bisEBw8BWLc9uhced2tag4dN",
            "sell_orders": null,
            "creator": null,
            "traits": [
                {
                    "trait_type": "y-coordinate",
                    "value": 78,
                    "display_type": "number",
                    "max_value": null,
                    "trait_count": 0,
                    "order": null
                },
                {
                    "trait_type": "x-coordinate",
                    "value": 104,
                    "display_type": "number",
                    "max_value": null,
                    "trait_count": 0,
                    "order": null
                },
                {
                    "trait_type": "Type",
                    "value": "Land",
                    "display_type": null,
                    "max_value": null,
                    "trait_count": 2684,
                    "order": null
                }
            ],
            "last_sale": null,
            "top_bid": null,
            "listing_date": null,
            "is_presale": false,
            "transfer_fee_payment_token": null,
            "transfer_fee": null
        },
        {
            "id": 25679491,
            "token_id": "47766366388459299160607693266721037678819595091978348543102894650965637464065",
            "num_sales": 0,
            "background_color": null,
            "image_url": "https://lh3.googleusercontent.com/qTJCTtNBkDUgrGVhnEWuXxCCmQA2SZ8FHMT-A0IfC9jMriwxDqXwXQDrXRctFz3cFHAy_VNzxgB-34Uiyd9tPV2x8bo-z9BkuqG50w",
            "image_preview_url": "https://lh3.googleusercontent.com/qTJCTtNBkDUgrGVhnEWuXxCCmQA2SZ8FHMT-A0IfC9jMriwxDqXwXQDrXRctFz3cFHAy_VNzxgB-34Uiyd9tPV2x8bo-z9BkuqG50w=s250",
            "image_thumbnail_url": "https://lh3.googleusercontent.com/qTJCTtNBkDUgrGVhnEWuXxCCmQA2SZ8FHMT-A0IfC9jMriwxDqXwXQDrXRctFz3cFHAy_VNzxgB-34Uiyd9tPV2x8bo-z9BkuqG50w=s128",
            "image_original_url": null,
            "animation_url": null,
            "animation_original_url": null,
            "name": "Alone in the winter storm",
            "description": null,
            "external_link": null,
            "asset_contract": {
                "address": "0x495f947276749ce646f68ac8c248420045cb7b5e",
                "asset_contract_type": "semi-fungible",
                "created_date": "2020-12-02T17:40:53.232025",
                "name": "OpenSea Collection",
                "nft_version": null,
                "opensea_version": "2.0.0",
                "owner": 102384,
                "schema_name": "ERC1155",
                "symbol": "OPENSTORE",
                "total_supply": null,
                "description": null,
                "external_link": null,
                "image_url": null,
                "default_to_fiat": false,
                "dev_buyer_fee_basis_points": 0,
                "dev_seller_fee_basis_points": 0,
                "only_proxied_transfers": false,
                "opensea_buyer_fee_basis_points": 0,
                "opensea_seller_fee_basis_points": 250,
                "buyer_fee_basis_points": 0,
                "seller_fee_basis_points": 250,
                "payout_address": null
            },
            "owner": {
                "user": {
                    "username": "NullAddress"
                },
                "profile_img_url": "https://storage.googleapis.com/opensea-static/opensea-profile/1.png",
                "address": "0x0000000000000000000000000000000000000000",
                "config": "",
                "discord_id": ""
            },
            "permalink": "https://opensea.io/assets/0x495f947276749ce646f68ac8c248420045cb7b5e/47766366388459299160607693266721037678819595091978348543102894650965637464065",
            "collection": {
                "banner_image_url": null,
                "chat_url": null,
                "created_date": "2021-05-26T07:00:53.424909",
                "default_to_fiat": false,
                "description": "",
                "dev_buyer_fee_basis_points": "0",
                "dev_seller_fee_basis_points": "0",
                "discord_url": null,
                "display_data": {
                    "card_display_style": "contain",
                    "images": []
                },
                "external_url": null,
                "featured": false,
                "featured_image_url": null,
                "hidden": true,
                "safelist_request_status": "not_requested",
                "image_url": "https://lh3.googleusercontent.com/iar2XPXL2pi80rAzS98zUhYDnHsvv0ItgbrakhlTtZj4T2kZy_PYpDt38N3ob8CPwRjPg3VcA7gGXK3C-2owv-M6CGTCzEEdIw32lKA=s120",
                "is_subject_to_whitelist": false,
                "large_image_url": null,
                "medium_username": null,
                "name": "Tranquility in loneliness",
                "only_proxied_transfers": false,
                "opensea_buyer_fee_basis_points": "0",
                "opensea_seller_fee_basis_points": "250",
                "payout_address": null,
                "require_email": false,
                "short_description": null,
                "slug": "tranquility-in-loneliness",
                "telegram_url": null,
                "twitter_username": null,
                "instagram_username": null,
                "wiki_url": null
            },
            "decimals": null,
            "token_metadata": null,
            "sell_orders": null,
            "creator": {
                "user": {
                    "username": "AniYor"
                },
                "profile_img_url": "https://storage.googleapis.com/opensea-static/opensea-profile/10.png",
                "address": "0x699ace280a662a8be76f492127cb1d6255ea17da",
                "config": "",
                "discord_id": ""
            },
            "traits": [],
            "last_sale": null,
            "top_bid": null,
            "listing_date": null,
            "is_presale": true,
            "transfer_fee_payment_token": null,
            "transfer_fee": null
        },
        {
            "id": 25679490,
            "token_id": "3544",
            "num_sales": 0,
            "background_color": "000000",
            "image_url": "https://lh3.googleusercontent.com/fRv9QWNqrSxkcpbe9KTtDEXt886fJbG42aOAku0_FMjM7YSNpKvWQDc3OkYyWGtnFY82ytJT8A-XNMyRcyNgN6B8",
            "image_preview_url": "https://lh3.googleusercontent.com/fRv9QWNqrSxkcpbe9KTtDEXt886fJbG42aOAku0_FMjM7YSNpKvWQDc3OkYyWGtnFY82ytJT8A-XNMyRcyNgN6B8=s250",
            "image_thumbnail_url": "https://lh3.googleusercontent.com/fRv9QWNqrSxkcpbe9KTtDEXt886fJbG42aOAku0_FMjM7YSNpKvWQDc3OkYyWGtnFY82ytJT8A-XNMyRcyNgN6B8=s128",
            "image_original_url": "https://play.0xuniverse.com/planets/3544.png",
            "animation_url": null,
            "animation_original_url": null,
            "name": "Planet 3544",
            "description": null,
            "external_link": "https://play.0xuniverse.com/?planet=3544",
            "asset_contract": {
                "address": "0x2bbd787c23b62ecb0173d850cc406e4d2a03b02c",
                "asset_contract_type": "non-fungible",
                "created_date": "2021-03-31T16:12:28.576253",
                "name": "0xUniverse",
                "nft_version": null,
                "opensea_version": null,
                "owner": 37755849,
                "schema_name": "ERC721",
                "symbol": "PLANET",
                "total_supply": "3032",
                "description": "0xUniverse is the next generation blockchain game where players can build spaceships, explore the galaxy, and colonize planets. The discoverers will extract resources and carry out research that allows them to conquer the remotest corners of the galaxy. In addition, players can jointly contribute to the story and unravel the mystery of the universe.",
                "external_link": "https://0xuniverse.com",
                "image_url": "https://lh3.googleusercontent.com/We2mw2ZWt7wDiZ_knnFA1BICJ9_sQRdWn2FM3XWZPakfDbGnDiXuyflEqNlRPZKxiEo8fzfkptKu9beHD7iSCde9QMh4lhoqQTzRb48=s120",
                "default_to_fiat": false,
                "dev_buyer_fee_basis_points": 0,
                "dev_seller_fee_basis_points": 0,
                "only_proxied_transfers": false,
                "opensea_buyer_fee_basis_points": 0,
                "opensea_seller_fee_basis_points": 250,
                "buyer_fee_basis_points": 0,
                "seller_fee_basis_points": 250,
                "payout_address": null
            },
            "owner": {
                "user": null,
                "profile_img_url": "https://storage.googleapis.com/opensea-static/opensea-profile/1.png",
                "address": "0x0000000000000000000000000000000000000000",
                "config": "",
                "discord_id": ""
            },
            "permalink": "https://opensea.io/assets/matic/0x2bbd787c23b62ecb0173d850cc406e4d2a03b02c/3544",
            "collection": {
                "banner_image_url": "https://lh3.googleusercontent.com/xTMVZ9068E5AeySzCF3IjdMvWWal8DqXK5RzPVhCI0k6Eu6HuLD2V9hnu2RY5-tnuHpgj62kovuY0KexryI1SHg56MNsgGCJt1ZB=s2500",
                "chat_url": null,
                "created_date": "2021-03-31T16:12:30.831418",
                "default_to_fiat": false,
                "description": "0xUniverse is the next generation blockchain game where players can build spaceships, explore the galaxy, and colonize planets. The discoverers will extract resources and carry out research that allows them to conquer the remotest corners of the galaxy. In addition, players can jointly contribute to the story and unravel the mystery of the universe.",
                "dev_buyer_fee_basis_points": "0",
                "dev_seller_fee_basis_points": "0",
                "discord_url": "https://discord.gg/R8fwEPC",
                "display_data": {
                    "card_display_style": "cover"
                },
                "external_url": "https://0xuniverse.com",
                "featured": false,
                "featured_image_url": "https://lh3.googleusercontent.com/NKpERysJoaSPjRHewYtAu0p5HHxzbhra1mwzN8i6Nuv6K17kUco7De-iJUUmVgmlJSKMCuovdTHx13n2RUOrAXWRNNaC3iW6uyB7jA=s300",
                "hidden": true,
                "safelist_request_status": "not_requested",
                "image_url": "https://lh3.googleusercontent.com/We2mw2ZWt7wDiZ_knnFA1BICJ9_sQRdWn2FM3XWZPakfDbGnDiXuyflEqNlRPZKxiEo8fzfkptKu9beHD7iSCde9QMh4lhoqQTzRb48=s120",
                "is_subject_to_whitelist": false,
                "large_image_url": "https://lh3.googleusercontent.com/NKpERysJoaSPjRHewYtAu0p5HHxzbhra1mwzN8i6Nuv6K17kUco7De-iJUUmVgmlJSKMCuovdTHx13n2RUOrAXWRNNaC3iW6uyB7jA=s300",
                "medium_username": null,
                "name": "0xUniverse: Galaxy Novel (Matic)",
                "only_proxied_transfers": false,
                "opensea_buyer_fee_basis_points": "0",
                "opensea_seller_fee_basis_points": "250",
                "payout_address": null,
                "require_email": false,
                "short_description": null,
                "slug": "0xuniverse-novel-matic",
                "telegram_url": null,
                "twitter_username": "0xUniverse",
                "instagram_username": null,
                "wiki_url": null
            },
            "decimals": null,
            "token_metadata": "https://prod.0xuniverse.com/universe-server/planets/3544",
            "sell_orders": null,
            "creator": null,
            "traits": [
                {
                    "trait_type": "rarity",
                    "value": "Common",
                    "display_type": null,
                    "max_value": null,
                    "trait_count": 2168,
                    "order": null
                },
                {
                    "trait_type": "people",
                    "value": 25,
                    "display_type": null,
                    "max_value": null,
                    "trait_count": 0,
                    "order": null
                },
                {
                    "trait_type": "price",
                    "value": 0.0,
                    "display_type": null,
                    "max_value": null,
                    "trait_count": 0,
                    "order": null
                },
                {
                    "trait_type": "people_current",
                    "value": 5000,
                    "display_type": null,
                    "max_value": null,
                    "trait_count": 0,
                    "order": null
                },
                {
                    "trait_type": "sector_y",
                    "value": 3,
                    "display_type": null,
                    "max_value": null,
                    "trait_count": 0,
                    "order": null
                },
                {
                    "trait_type": "sector_x",
                    "value": 16,
                    "display_type": null,
                    "max_value": null,
                    "trait_count": 0,
                    "order": null
                },
                {
                    "trait_type": "nickel",
                    "value": 34,
                    "display_type": null,
                    "max_value": null,
                    "trait_count": 0,
                    "order": null
                },
                {
                    "trait_type": "nickel_current",
                    "value": 6800,
                    "display_type": null,
                    "max_value": null,
                    "trait_count": 0,
                    "order": null
                },
                {
                    "trait_type": "tungsten",
                    "value": 31,
                    "display_type": null,
                    "max_value": null,
                    "trait_count": 0,
                    "order": null
                },
                {
                    "trait_type": "tungsten_current",
                    "value": 6200,
                    "display_type": null,
                    "max_value": null,
                    "trait_count": 0,
                    "order": null
                },
                {
                    "trait_type": "copper",
                    "value": 27,
                    "display_type": null,
                    "max_value": null,
                    "trait_count": 0,
                    "order": null
                },
                {
                    "trait_type": "copper_current",
                    "value": 5400,
                    "display_type": null,
                    "max_value": null,
                    "trait_count": 0,
                    "order": null
                },
                {
                    "trait_type": "galaxy",
                    "value": 0,
                    "display_type": null,
                    "max_value": null,
                    "trait_count": 0,
                    "order": null
                }
            ],
            "last_sale": null,
            "top_bid": null,
            "listing_date": null,
            "is_presale": false,
            "transfer_fee_payment_token": null,
            "transfer_fee": null
        },
        {
            "id": 25679489,
            "token_id": "79228162532711644617207427873",
            "num_sales": 0,
            "background_color": null,
            "image_url": "https://lh3.googleusercontent.com/QSBwd0xAshRdMe1-ByrqeW1zEOV3FAPyHnJ6ESyKJS5P3Ipz9jD6NHf1HURWRrlAnbNFyOvvigJvj5_rljGnv_I",
            "image_preview_url": "https://lh3.googleusercontent.com/QSBwd0xAshRdMe1-ByrqeW1zEOV3FAPyHnJ6ESyKJS5P3Ipz9jD6NHf1HURWRrlAnbNFyOvvigJvj5_rljGnv_I=s250",
            "image_thumbnail_url": "https://lh3.googleusercontent.com/QSBwd0xAshRdMe1-ByrqeW1zEOV3FAPyHnJ6ESyKJS5P3Ipz9jD6NHf1HURWRrlAnbNFyOvvigJvj5_rljGnv_I=s128",
            "image_original_url": "https://neon-district-season-one.s3.amazonaws.com/images/demon-female-thumb.png",
            "animation_url": null,
            "animation_original_url": null,
            "name": "Demon",
            "description": "Demons are combat specialists who physically are gifted with incredible speed and dexterity.\n\nA Neon District: Season One game item, playable on https://portal.neondistrict.io.\n\nNeon District is a free-to-play cyberpunk role-playing game. Collect characters and gear, craft and level up teams, and battle against other players through competitive multiplayer and in turn-based combat.",
            "external_link": "https://portal.neondistrict.io/asset/79228162532711644617207427873",
            "asset_contract": {
                "address": "0x7227e371540cf7b8e512544ba6871472031f3335",
                "asset_contract_type": "non-fungible",
                "created_date": "2021-01-04T17:12:08.151181",
                "name": "Neon District Season One Item",
                "nft_version": null,
                "opensea_version": null,
                "owner": 17710883,
                "schema_name": "ERC721",
                "symbol": "NDITEM1",
                "total_supply": "475982",
                "description": "Neon District is a free-to-play cyberpunk role-playing game featuring collectible NFTs on Matic and Ethereum. Players collect characters and gear, craft and level up fully-equipped teams, and battle their teams against other players through the Neon Pizza competitive multiplayer missions or in real-time turn-based combat.",
                "external_link": null,
                "image_url": "https://lh3.googleusercontent.com/xttZf6L3I16h7HSgcfKFWhR7OhCdSO5UW_asXbRfGmQ7-a0QwJRNoPsmh_RlOpw-AFEngLqGYLD77cmjdBv4LCfVc5BxFG2PS1UU=s120",
                "default_to_fiat": false,
                "dev_buyer_fee_basis_points": 0,
                "dev_seller_fee_basis_points": 500,
                "only_proxied_transfers": false,
                "opensea_buyer_fee_basis_points": 0,
                "opensea_seller_fee_basis_points": 250,
                "buyer_fee_basis_points": 0,
                "seller_fee_basis_points": 750,
                "payout_address": "0x08262c33e987ed580b69d8f93134e987f881bdcc"
            },
            "owner": {
                "user": null,
                "profile_img_url": "https://storage.googleapis.com/opensea-static/opensea-profile/1.png",
                "address": "0x0000000000000000000000000000000000000000",
                "config": "",
                "discord_id": ""
            },
            "permalink": "https://opensea.io/assets/matic/0x7227e371540cf7b8e512544ba6871472031f3335/79228162532711644617207427873",
            "collection": {
                "banner_image_url": "https://lh3.googleusercontent.com/vtZXDR51ibkUx6v2XRf3imqsL-bUzy7tALBcjrwx0fNJywcMCqK_bVIfrvdlKQ5sysboHA23kGiwbgsGb5c_6ROGsyzc-SZURrtqRA=s2500",
                "chat_url": null,
                "created_date": "2021-01-04T17:12:08.305423",
                "default_to_fiat": false,
                "description": "Neon District is a free-to-play cyberpunk role-playing game featuring collectible NFTs on Matic and Ethereum. Players collect characters and gear, craft and level up fully-equipped teams, and battle their teams against other players through the Neon Pizza competitive multiplayer missions or in real-time turn-based combat.",
                "dev_buyer_fee_basis_points": "0",
                "dev_seller_fee_basis_points": "500",
                "discord_url": "https://discord.gg/ERu7Zw9YwZ",
                "display_data": {
                    "card_display_style": "contain"
                },
                "external_url": null,
                "featured": false,
                "featured_image_url": "https://lh3.googleusercontent.com/vtZXDR51ibkUx6v2XRf3imqsL-bUzy7tALBcjrwx0fNJywcMCqK_bVIfrvdlKQ5sysboHA23kGiwbgsGb5c_6ROGsyzc-SZURrtqRA=s300",
                "hidden": false,
                "safelist_request_status": "approved",
                "image_url": "https://lh3.googleusercontent.com/xttZf6L3I16h7HSgcfKFWhR7OhCdSO5UW_asXbRfGmQ7-a0QwJRNoPsmh_RlOpw-AFEngLqGYLD77cmjdBv4LCfVc5BxFG2PS1UU=s120",
                "is_subject_to_whitelist": false,
                "large_image_url": "https://lh3.googleusercontent.com/vtZXDR51ibkUx6v2XRf3imqsL-bUzy7tALBcjrwx0fNJywcMCqK_bVIfrvdlKQ5sysboHA23kGiwbgsGb5c_6ROGsyzc-SZURrtqRA=s300",
                "medium_username": "blockadegames",
                "name": "Neon District Season One Item",
                "only_proxied_transfers": false,
                "opensea_buyer_fee_basis_points": "0",
                "opensea_seller_fee_basis_points": "250",
                "payout_address": "0x08262c33e987ed580b69d8f93134e987f881bdcc",
                "require_email": false,
                "short_description": null,
                "slug": "neon-district-season-one-item",
                "telegram_url": null,
                "twitter_username": "neondistrictrpg",
                "instagram_username": null,
                "wiki_url": null
            },
            "decimals": null,
            "token_metadata": "https://portal.neondistrict.io/api/getNft/79228162532711644617207427873",
            "sell_orders": null,
            "creator": null,
            "traits": [
                {
                    "trait_type": "Card",
                    "value": "Juke",
                    "display_type": null,
                    "max_value": null,
                    "trait_count": 13588,
                    "order": null
                },
                {
                    "trait_type": "Card",
                    "value": "Leadership",
                    "display_type": null,
                    "max_value": null,
                    "trait_count": 13597,
                    "order": null
                },
                {
                    "trait_type": "Card",
                    "value": "Aggression",
                    "display_type": null,
                    "max_value": null,
                    "trait_count": 13604,
                    "order": null
                },
                {
                    "trait_type": "Attack",
                    "value": 100,
                    "display_type": "boost_number",
                    "max_value": null,
                    "trait_count": 0,
                    "order": null
                },
                {
                    "trait_type": "Stealth",
                    "value": 15,
                    "display_type": "boost_number",
                    "max_value": null,
                    "trait_count": 0,
                    "order": null
                },
                {
                    "trait_type": "type",
                    "value": "Character",
                    "display_type": null,
                    "max_value": null,
                    "trait_count": 78723,
                    "order": null
                },
                {
                    "trait_type": "rarity",
                    "value": "Common",
                    "display_type": null,
                    "max_value": null,
                    "trait_count": 220672,
                    "order": null
                },
                {
                    "trait_type": "level",
                    "value": 1,
                    "display_type": null,
                    "max_value": null,
                    "trait_count": 0,
                    "order": null
                },
                {
                    "trait_type": "Season",
                    "value": 1,
                    "display_type": "number",
                    "max_value": null,
                    "trait_count": 0,
                    "order": null
                },
                {
                    "trait_type": "Mech",
                    "value": 15,
                    "display_type": "boost_number",
                    "max_value": null,
                    "trait_count": 0,
                    "order": null
                },
                {
                    "trait_type": "Nano",
                    "value": 15,
                    "display_type": "boost_number",
                    "max_value": null,
                    "trait_count": 0,
                    "order": null
                },
                {
                    "trait_type": "Tactics",
                    "value": 25,
                    "display_type": "boost_number",
                    "max_value": null,
                    "trait_count": 0,
                    "order": null
                },
                {
                    "trait_type": "Health",
                    "value": 500,
                    "display_type": "boost_number",
                    "max_value": null,
                    "trait_count": 0,
                    "order": null
                },
                {
                    "trait_type": "Defense",
                    "value": 35,
                    "display_type": "boost_number",
                    "max_value": null,
                    "trait_count": 0,
                    "order": null
                },
                {
                    "trait_type": "Hacking",
                    "value": 15,
                    "display_type": "boost_number",
                    "max_value": null,
                    "trait_count": 0,
                    "order": null
                },
                {
                    "trait_type": "Card",
                    "value": "Quicken",
                    "display_type": null,
                    "max_value": null,
                    "trait_count": 13603,
                    "order": null
                }
            ],
            "last_sale": null,
            "top_bid": null,
            "listing_date": null,
            "is_presale": false,
            "transfer_fee_payment_token": null,
            "transfer_fee": null
        },
        {
            "id": 25679488,
            "token_id": "158456334657729644613427770144",
            "num_sales": 0,
            "background_color": null,
            "image_url": "https://lh3.googleusercontent.com/NTzFy8n4Xueo69Wv588gvcp8u_VM9Z6VaQ6MC74VG0A932_r3d08fNsEwbp9EIBCaL7xxL-bN-6yfJVtUwlnB8QY5Qn-vKETW8pu1Mk",
            "image_preview_url": "https://lh3.googleusercontent.com/NTzFy8n4Xueo69Wv588gvcp8u_VM9Z6VaQ6MC74VG0A932_r3d08fNsEwbp9EIBCaL7xxL-bN-6yfJVtUwlnB8QY5Qn-vKETW8pu1Mk=s250",
            "image_thumbnail_url": "https://lh3.googleusercontent.com/NTzFy8n4Xueo69Wv588gvcp8u_VM9Z6VaQ6MC74VG0A932_r3d08fNsEwbp9EIBCaL7xxL-bN-6yfJVtUwlnB8QY5Qn-vKETW8pu1Mk=s128",
            "image_original_url": "https://neon-district-season-one.s3.amazonaws.com/images/yumecommanderr-uncommon-head-female-thumb.png",
            "animation_url": null,
            "animation_original_url": null,
            "name": "Yume Commander: Renegade",
            "description": "Armor found within Neon District.\n\nA Neon District: Season One game item, playable on https://portal.neondistrict.io.\n\nNeon District is a free-to-play cyberpunk role-playing game. Collect characters and gear, craft and level up teams, and battle against other players through competitive multiplayer and in turn-based combat.",
            "external_link": "https://portal.neondistrict.io/asset/158456334657729644613427770144",
            "asset_contract": {
                "address": "0x7227e371540cf7b8e512544ba6871472031f3335",
                "asset_contract_type": "non-fungible",
                "created_date": "2021-01-04T17:12:08.151181",
                "name": "Neon District Season One Item",
                "nft_version": null,
                "opensea_version": null,
                "owner": 17710883,
                "schema_name": "ERC721",
                "symbol": "NDITEM1",
                "total_supply": "475982",
                "description": "Neon District is a free-to-play cyberpunk role-playing game featuring collectible NFTs on Matic and Ethereum. Players collect characters and gear, craft and level up fully-equipped teams, and battle their teams against other players through the Neon Pizza competitive multiplayer missions or in real-time turn-based combat.",
                "external_link": null,
                "image_url": "https://lh3.googleusercontent.com/xttZf6L3I16h7HSgcfKFWhR7OhCdSO5UW_asXbRfGmQ7-a0QwJRNoPsmh_RlOpw-AFEngLqGYLD77cmjdBv4LCfVc5BxFG2PS1UU=s120",
                "default_to_fiat": false,
                "dev_buyer_fee_basis_points": 0,
                "dev_seller_fee_basis_points": 500,
                "only_proxied_transfers": false,
                "opensea_buyer_fee_basis_points": 0,
                "opensea_seller_fee_basis_points": 250,
                "buyer_fee_basis_points": 0,
                "seller_fee_basis_points": 750,
                "payout_address": "0x08262c33e987ed580b69d8f93134e987f881bdcc"
            },
            "owner": {
                "user": null,
                "profile_img_url": "https://storage.googleapis.com/opensea-static/opensea-profile/1.png",
                "address": "0x0000000000000000000000000000000000000000",
                "config": "",
                "discord_id": ""
            },
            "permalink": "https://opensea.io/assets/matic/0x7227e371540cf7b8e512544ba6871472031f3335/158456334657729644613427770144",
            "collection": {
                "banner_image_url": "https://lh3.googleusercontent.com/vtZXDR51ibkUx6v2XRf3imqsL-bUzy7tALBcjrwx0fNJywcMCqK_bVIfrvdlKQ5sysboHA23kGiwbgsGb5c_6ROGsyzc-SZURrtqRA=s2500",
                "chat_url": null,
                "created_date": "2021-01-04T17:12:08.305423",
                "default_to_fiat": false,
                "description": "Neon District is a free-to-play cyberpunk role-playing game featuring collectible NFTs on Matic and Ethereum. Players collect characters and gear, craft and level up fully-equipped teams, and battle their teams against other players through the Neon Pizza competitive multiplayer missions or in real-time turn-based combat.",
                "dev_buyer_fee_basis_points": "0",
                "dev_seller_fee_basis_points": "500",
                "discord_url": "https://discord.gg/ERu7Zw9YwZ",
                "display_data": {
                    "card_display_style": "contain"
                },
                "external_url": null,
                "featured": false,
                "featured_image_url": "https://lh3.googleusercontent.com/vtZXDR51ibkUx6v2XRf3imqsL-bUzy7tALBcjrwx0fNJywcMCqK_bVIfrvdlKQ5sysboHA23kGiwbgsGb5c_6ROGsyzc-SZURrtqRA=s300",
                "hidden": false,
                "safelist_request_status": "approved",
                "image_url": "https://lh3.googleusercontent.com/xttZf6L3I16h7HSgcfKFWhR7OhCdSO5UW_asXbRfGmQ7-a0QwJRNoPsmh_RlOpw-AFEngLqGYLD77cmjdBv4LCfVc5BxFG2PS1UU=s120",
                "is_subject_to_whitelist": false,
                "large_image_url": "https://lh3.googleusercontent.com/vtZXDR51ibkUx6v2XRf3imqsL-bUzy7tALBcjrwx0fNJywcMCqK_bVIfrvdlKQ5sysboHA23kGiwbgsGb5c_6ROGsyzc-SZURrtqRA=s300",
                "medium_username": "blockadegames",
                "name": "Neon District Season One Item",
                "only_proxied_transfers": false,
                "opensea_buyer_fee_basis_points": "0",
                "opensea_seller_fee_basis_points": "250",
                "payout_address": "0x08262c33e987ed580b69d8f93134e987f881bdcc",
                "require_email": false,
                "short_description": null,
                "slug": "neon-district-season-one-item",
                "telegram_url": null,
                "twitter_username": "neondistrictrpg",
                "instagram_username": null,
                "wiki_url": null
            },
            "decimals": null,
            "token_metadata": "https://portal.neondistrict.io/api/getNft/158456334657729644613427770144",
            "sell_orders": null,
            "creator": null,
            "traits": [
                {
                    "trait_type": "Health",
                    "value": 55,
                    "display_type": "boost_number",
                    "max_value": null,
                    "trait_count": 0,
                    "order": null
                },
                {
                    "trait_type": "rarity",
                    "value": "Uncommon",
                    "display_type": null,
                    "max_value": null,
                    "trait_count": 99349,
                    "order": null
                },
                {
                    "trait_type": "level",
                    "value": 2,
                    "display_type": null,
                    "max_value": null,
                    "trait_count": 0,
                    "order": null
                },
                {
                    "trait_type": "Tactics",
                    "value": 13,
                    "display_type": "boost_number",
                    "max_value": null,
                    "trait_count": 0,
                    "order": null
                },
                {
                    "trait_type": "Nano",
                    "value": 5,
                    "display_type": "boost_number",
                    "max_value": null,
                    "trait_count": 0,
                    "order": null
                },
                {
                    "trait_type": "Season",
                    "value": 1,
                    "display_type": "number",
                    "max_value": null,
                    "trait_count": 0,
                    "order": null
                },
                {
                    "trait_type": "Stealth",
                    "value": 5,
                    "display_type": "boost_number",
                    "max_value": null,
                    "trait_count": 0,
                    "order": null
                },
                {
                    "trait_type": "type",
                    "value": "Armor",
                    "display_type": null,
                    "max_value": null,
                    "trait_count": 323031,
                    "order": null
                },
                {
                    "trait_type": "Mech",
                    "value": 3,
                    "display_type": "boost_number",
                    "max_value": null,
                    "trait_count": 0,
                    "order": null
                },
                {
                    "trait_type": "Hacking",
                    "value": 0,
                    "display_type": "boost_number",
                    "max_value": null,
                    "trait_count": 0,
                    "order": null
                },
                {
                    "trait_type": "Armor Slot",
                    "value": "Head",
                    "display_type": null,
                    "max_value": null,
                    "trait_count": 80428,
                    "order": null
                },
                {
                    "trait_type": "Attack",
                    "value": 19,
                    "display_type": "boost_number",
                    "max_value": null,
                    "trait_count": 0,
                    "order": null
                },
                {
                    "trait_type": "Defense",
                    "value": 14,
                    "display_type": "boost_number",
                    "max_value": null,
                    "trait_count": 0,
                    "order": null
                }
            ],
            "last_sale": null,
            "top_bid": null,
            "listing_date": null,
            "is_presale": false,
            "transfer_fee_payment_token": null,
            "transfer_fee": null
        },
        {
            "id": 25679487,
            "token_id": "158456327611073408456379052831",
            "num_sales": 0,
            "background_color": null,
            "image_url": "https://lh3.googleusercontent.com/J08osH0OZqTG7CPtUfSBEC1NLMQV-WvGFx5ELf46UTlkX_OMuD-cb6s0AF9IqDhm8_BdNPQcuyqhfX7UirQHORIL",
            "image_preview_url": "https://lh3.googleusercontent.com/J08osH0OZqTG7CPtUfSBEC1NLMQV-WvGFx5ELf46UTlkX_OMuD-cb6s0AF9IqDhm8_BdNPQcuyqhfX7UirQHORIL=s250",
            "image_thumbnail_url": "https://lh3.googleusercontent.com/J08osH0OZqTG7CPtUfSBEC1NLMQV-WvGFx5ELf46UTlkX_OMuD-cb6s0AF9IqDhm8_BdNPQcuyqhfX7UirQHORIL=s128",
            "image_original_url": "https://neon-district-season-one.s3.amazonaws.com/images/blkoriginnightsticks-rare-dualmelee-med-thumb.png",
            "animation_url": null,
            "animation_original_url": null,
            "name": "Nightsticks",
            "description": "A weapon found within Neon District.\n\nA Neon District: Season One game item, playable on https://portal.neondistrict.io.\n\nNeon District is a free-to-play cyberpunk role-playing game. Collect characters and gear, craft and level up teams, and battle against other players through competitive multiplayer and in turn-based combat.",
            "external_link": "https://portal.neondistrict.io/asset/158456327611073408456379052831",
            "asset_contract": {
                "address": "0x7227e371540cf7b8e512544ba6871472031f3335",
                "asset_contract_type": "non-fungible",
                "created_date": "2021-01-04T17:12:08.151181",
                "name": "Neon District Season One Item",
                "nft_version": null,
                "opensea_version": null,
                "owner": 17710883,
                "schema_name": "ERC721",
                "symbol": "NDITEM1",
                "total_supply": "475982",
                "description": "Neon District is a free-to-play cyberpunk role-playing game featuring collectible NFTs on Matic and Ethereum. Players collect characters and gear, craft and level up fully-equipped teams, and battle their teams against other players through the Neon Pizza competitive multiplayer missions or in real-time turn-based combat.",
                "external_link": null,
                "image_url": "https://lh3.googleusercontent.com/xttZf6L3I16h7HSgcfKFWhR7OhCdSO5UW_asXbRfGmQ7-a0QwJRNoPsmh_RlOpw-AFEngLqGYLD77cmjdBv4LCfVc5BxFG2PS1UU=s120",
                "default_to_fiat": false,
                "dev_buyer_fee_basis_points": 0,
                "dev_seller_fee_basis_points": 500,
                "only_proxied_transfers": false,
                "opensea_buyer_fee_basis_points": 0,
                "opensea_seller_fee_basis_points": 250,
                "buyer_fee_basis_points": 0,
                "seller_fee_basis_points": 750,
                "payout_address": "0x08262c33e987ed580b69d8f93134e987f881bdcc"
            },
            "owner": {
                "user": null,
                "profile_img_url": "https://storage.googleapis.com/opensea-static/opensea-profile/1.png",
                "address": "0x0000000000000000000000000000000000000000",
                "config": "",
                "discord_id": ""
            },
            "permalink": "https://opensea.io/assets/matic/0x7227e371540cf7b8e512544ba6871472031f3335/158456327611073408456379052831",
            "collection": {
                "banner_image_url": "https://lh3.googleusercontent.com/vtZXDR51ibkUx6v2XRf3imqsL-bUzy7tALBcjrwx0fNJywcMCqK_bVIfrvdlKQ5sysboHA23kGiwbgsGb5c_6ROGsyzc-SZURrtqRA=s2500",
                "chat_url": null,
                "created_date": "2021-01-04T17:12:08.305423",
                "default_to_fiat": false,
                "description": "Neon District is a free-to-play cyberpunk role-playing game featuring collectible NFTs on Matic and Ethereum. Players collect characters and gear, craft and level up fully-equipped teams, and battle their teams against other players through the Neon Pizza competitive multiplayer missions or in real-time turn-based combat.",
                "dev_buyer_fee_basis_points": "0",
                "dev_seller_fee_basis_points": "500",
                "discord_url": "https://discord.gg/ERu7Zw9YwZ",
                "display_data": {
                    "card_display_style": "contain"
                },
                "external_url": null,
                "featured": false,
                "featured_image_url": "https://lh3.googleusercontent.com/vtZXDR51ibkUx6v2XRf3imqsL-bUzy7tALBcjrwx0fNJywcMCqK_bVIfrvdlKQ5sysboHA23kGiwbgsGb5c_6ROGsyzc-SZURrtqRA=s300",
                "hidden": false,
                "safelist_request_status": "approved",
                "image_url": "https://lh3.googleusercontent.com/xttZf6L3I16h7HSgcfKFWhR7OhCdSO5UW_asXbRfGmQ7-a0QwJRNoPsmh_RlOpw-AFEngLqGYLD77cmjdBv4LCfVc5BxFG2PS1UU=s120",
                "is_subject_to_whitelist": false,
                "large_image_url": "https://lh3.googleusercontent.com/vtZXDR51ibkUx6v2XRf3imqsL-bUzy7tALBcjrwx0fNJywcMCqK_bVIfrvdlKQ5sysboHA23kGiwbgsGb5c_6ROGsyzc-SZURrtqRA=s300",
                "medium_username": "blockadegames",
                "name": "Neon District Season One Item",
                "only_proxied_transfers": false,
                "opensea_buyer_fee_basis_points": "0",
                "opensea_seller_fee_basis_points": "250",
                "payout_address": "0x08262c33e987ed580b69d8f93134e987f881bdcc",
                "require_email": false,
                "short_description": null,
                "slug": "neon-district-season-one-item",
                "telegram_url": null,
                "twitter_username": "neondistrictrpg",
                "instagram_username": null,
                "wiki_url": null
            },
            "decimals": null,
            "token_metadata": "https://portal.neondistrict.io/api/getNft/158456327611073408456379052831",
            "sell_orders": null,
            "creator": null,
            "traits": [
                {
                    "trait_type": "type",
                    "value": "Weapon",
                    "display_type": null,
                    "max_value": null,
                    "trait_count": 55075,
                    "order": null
                },
                {
                    "trait_type": "rarity",
                    "value": "Rare",
                    "display_type": null,
                    "max_value": null,
                    "trait_count": 82322,
                    "order": null
                },
                {
                    "trait_type": "level",
                    "value": 3,
                    "display_type": null,
                    "max_value": null,
                    "trait_count": 0,
                    "order": null
                },
                {
                    "trait_type": "Nano",
                    "value": 5,
                    "display_type": "boost_number",
                    "max_value": null,
                    "trait_count": 0,
                    "order": null
                },
                {
                    "trait_type": "Mech",
                    "value": 5,
                    "display_type": "boost_number",
                    "max_value": null,
                    "trait_count": 0,
                    "order": null
                },
                {
                    "trait_type": "Attack",
                    "value": 25,
                    "display_type": "boost_number",
                    "max_value": null,
                    "trait_count": 0,
                    "order": null
                },
                {
                    "trait_type": "Season",
                    "value": 1,
                    "display_type": "number",
                    "max_value": null,
                    "trait_count": 0,
                    "order": null
                },
                {
                    "trait_type": "Health",
                    "value": 50,
                    "display_type": "boost_number",
                    "max_value": null,
                    "trait_count": 0,
                    "order": null
                },
                {
                    "trait_type": "Defense",
                    "value": 25,
                    "display_type": "boost_number",
                    "max_value": null,
                    "trait_count": 0,
                    "order": null
                },
                {
                    "trait_type": "Hacking",
                    "value": 5,
                    "display_type": "boost_number",
                    "max_value": null,
                    "trait_count": 0,
                    "order": null
                },
                {
                    "trait_type": "Stealth",
                    "value": 5,
                    "display_type": "boost_number",
                    "max_value": null,
                    "trait_count": 0,
                    "order": null
                },
                {
                    "trait_type": "Tactics",
                    "value": 25,
                    "display_type": "boost_number",
                    "max_value": null,
                    "trait_count": 0,
                    "order": null
                },
                {
                    "trait_type": "Card",
                    "value": "Outmanuever",
                    "display_type": null,
                    "max_value": null,
                    "trait_count": 358,
                    "order": null
                },
                {
                    "trait_type": "Card",
                    "value": "Don't Try This At Home",
                    "display_type": null,
                    "max_value": null,
                    "trait_count": 241,
                    "order": null
                },
                {
                    "trait_type": "Card",
                    "value": "Lay Open",
                    "display_type": null,
                    "max_value": null,
                    "trait_count": 4982,
                    "order": null
                },
                {
                    "trait_type": "Card",
                    "value": "Too Fast!",
                    "display_type": null,
                    "max_value": null,
                    "trait_count": 4964,
                    "order": null
                },
                {
                    "trait_type": "Card",
                    "value": "With Finesse",
                    "display_type": null,
                    "max_value": null,
                    "trait_count": 4969,
                    "order": null
                }
            ],
            "last_sale": null,
            "top_bid": null,
            "listing_date": null,
            "is_presale": false,
            "transfer_fee_payment_token": null,
            "transfer_fee": null
        },
        {
            "id": 25679486,
            "token_id": "75634946384268441532532271373464139516746776729384591995766756705265065656321",
            "num_sales": 0,
            "background_color": null,
            "image_url": "https://lh3.googleusercontent.com/HhYu9tojRcctJji5W00xzApwU_VrVjccPelPIpzWJAF-u04WKTrYAihe0zYMw1j5WrxvSk-k1Gtk6rzaz7NuEcWPnQ5wc1DDg-FaYw",
            "image_preview_url": "https://lh3.googleusercontent.com/HhYu9tojRcctJji5W00xzApwU_VrVjccPelPIpzWJAF-u04WKTrYAihe0zYMw1j5WrxvSk-k1Gtk6rzaz7NuEcWPnQ5wc1DDg-FaYw=s250",
            "image_thumbnail_url": "https://lh3.googleusercontent.com/HhYu9tojRcctJji5W00xzApwU_VrVjccPelPIpzWJAF-u04WKTrYAihe0zYMw1j5WrxvSk-k1Gtk6rzaz7NuEcWPnQ5wc1DDg-FaYw=s128",
            "image_original_url": null,
            "animation_url": null,
            "animation_original_url": null,
            "name": "Pure bug sci-fly no.6",
            "description": "My bug sci-fi (vol1) from nature and imagine. Buyers will receive an image file size 4200x4200px (14x14inc). For collecting Given as a decorative gift, but not for commercial use. Thank you.",
            "external_link": "https://www.instagram.com/makapa27/",
            "asset_contract": {
                "address": "0x495f947276749ce646f68ac8c248420045cb7b5e",
                "asset_contract_type": "semi-fungible",
                "created_date": "2020-12-02T17:40:53.232025",
                "name": "OpenSea Collection",
                "nft_version": null,
                "opensea_version": "2.0.0",
                "owner": 102384,
                "schema_name": "ERC1155",
                "symbol": "OPENSTORE",
                "total_supply": null,
                "description": null,
                "external_link": null,
                "image_url": null,
                "default_to_fiat": false,
                "dev_buyer_fee_basis_points": 0,
                "dev_seller_fee_basis_points": 0,
                "only_proxied_transfers": false,
                "opensea_buyer_fee_basis_points": 0,
                "opensea_seller_fee_basis_points": 250,
                "buyer_fee_basis_points": 0,
                "seller_fee_basis_points": 250,
                "payout_address": null
            },
            "owner": {
                "user": {
                    "username": "NullAddress"
                },
                "profile_img_url": "https://storage.googleapis.com/opensea-static/opensea-profile/1.png",
                "address": "0x0000000000000000000000000000000000000000",
                "config": "",
                "discord_id": ""
            },
            "permalink": "https://opensea.io/assets/0x495f947276749ce646f68ac8c248420045cb7b5e/75634946384268441532532271373464139516746776729384591995766756705265065656321",
            "collection": {
                "banner_image_url": null,
                "chat_url": null,
                "created_date": "2021-05-23T08:43:18.952299",
                "default_to_fiat": false,
                "description": "This is my artwork sci-fi project.",
                "dev_buyer_fee_basis_points": "0",
                "dev_seller_fee_basis_points": "0",
                "discord_url": null,
                "display_data": {
                    "card_display_style": "contain",
                    "images": []
                },
                "external_url": null,
                "featured": false,
                "featured_image_url": null,
                "hidden": true,
                "safelist_request_status": "not_requested",
                "image_url": "https://lh3.googleusercontent.com/6NYCgtuXcKm5AHTqpUBZZJ3h4_BJDRPfZTn1zPOQ8b2P0v_kwOvwnmbstKJAbW8nqoqSIR4cWilQ5x58O5yw6Y5e_3ONcE88R2YrvA=s120",
                "is_subject_to_whitelist": false,
                "large_image_url": null,
                "medium_username": null,
                "name": "sci-fly",
                "only_proxied_transfers": false,
                "opensea_buyer_fee_basis_points": "0",
                "opensea_seller_fee_basis_points": "250",
                "payout_address": null,
                "require_email": false,
                "short_description": null,
                "slug": "sci-fly",
                "telegram_url": null,
                "twitter_username": null,
                "instagram_username": null,
                "wiki_url": null
            },
            "decimals": null,
            "token_metadata": null,
            "sell_orders": [
                {
                    "created_date": "2021-05-26T07:36:44.624741",
                    "closing_date": null,
                    "closing_extendable": false,
                    "expiration_time": 0,
                    "listing_time": 1622014490,
                    "order_hash": "0x1ad67b21e256b1211010abc0bc9339f61fb221d90d9a2928a5f875cdae7d7d85",
                    "metadata": {
                        "asset": {
                            "id": "75634946384268441532532271373464139516746776729384591995766756705265065656321",
                            "address": "0x495f947276749ce646f68ac8c248420045cb7b5e",
                            "quantity": "1"
                        },
                        "schema": "ERC1155"
                    },
                    "exchange": "0x7be8076f4ea4a4ad08075c2508e481d6c946d12b",
                    "maker": {
                        "user": 840486,
                        "profile_img_url": "https://storage.googleapis.com/opensea-static/opensea-profile/7.png",
                        "address": "0xa737dcd35abb2b18f5f20939c62b1e2e1bb85227",
                        "config": "",
                        "discord_id": ""
                    },
                    "taker": {
                        "user": 1766,
                        "profile_img_url": "https://storage.googleapis.com/opensea-static/opensea-profile/1.png",
                        "address": "0x0000000000000000000000000000000000000000",
                        "config": "",
                        "discord_id": ""
                    },
                    "current_price": "27000000000000000",
                    "current_bounty": "270000000000000",
                    "bounty_multiple": "0.01",
                    "maker_relayer_fee": "250",
                    "taker_relayer_fee": "0",
                    "maker_protocol_fee": "0",
                    "taker_protocol_fee": "0",
                    "maker_referrer_fee": "0",
                    "fee_recipient": {
                        "user": 3585,
                        "profile_img_url": "https://storage.googleapis.com/opensea-static/opensea-profile/28.png",
                        "address": "0x5b3256965e7c3cf26e11fcaf296dfc8807c01073",
                        "config": "verified",
                        "discord_id": ""
                    },
                    "fee_method": 1,
                    "side": 1,
                    "sale_kind": 0,
                    "target": "0x495f947276749ce646f68ac8c248420045cb7b5e",
                    "how_to_call": 0,
                    "calldata": "0xf242432a000000000000000000000000a737dcd35abb2b18f5f20939c62b1e2e1bb852270000000000000000000000000000000000000000000000000000000000000000a737dcd35abb2b18f5f20939c62b1e2e1bb85227000000000000060000000001000000000000000000000000000000000000000000000000000000000000000100000000000000000000000000000000000000000000000000000000000000a00000000000000000000000000000000000000000000000000000000000000000",
                    "replacement_pattern": "0x000000000000000000000000000000000000000000000000000000000000000000000000ffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffff0000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000",
                    "static_target": "0x0000000000000000000000000000000000000000",
                    "static_extradata": "0x",
                    "payment_token": "0x0000000000000000000000000000000000000000",
                    "payment_token_contract": {
                        "id": 1,
                        "symbol": "ETH",
                        "address": "0x0000000000000000000000000000000000000000",
                        "image_url": "https://storage.opensea.io/files/6f8e2979d428180222796ff4a33ab929.svg",
                        "name": "Ether",
                        "decimals": 18,
                        "eth_price": "1.000000000000000",
                        "usd_price": "2869.690000000000055000"
                    },
                    "base_price": "27000000000000000",
                    "extra": "0",
                    "quantity": "1",
                    "salt": "7070498312280771005806897662981135893920866530533242876088731284785629194900",
                    "v": 27,
                    "r": "0x4f9f7484dd1b8f8d9bb75af56726b0036b56bba98fe81af2abe999e5e94e928b",
                    "s": "0x3bf339f436cb6189f94581f37f6d8517ef19076e55bbcc967dea5b650c2df1bc",
                    "approved_on_chain": false,
                    "cancelled": false,
                    "finalized": false,
                    "marked_invalid": false,
                    "prefixed_hash": "0xef6036b7b2f520d40ed723876095ddba3510bd905d38f4c645fccf308c6b4d8a"
                }
            ],
            "creator": {
                "user": {
                    "username": "makapa27"
                },
                "profile_img_url": "https://storage.googleapis.com/opensea-static/opensea-profile/7.png",
                "address": "0xa737dcd35abb2b18f5f20939c62b1e2e1bb85227",
                "config": "",
                "discord_id": ""
            },
            "traits": [],
            "last_sale": null,
            "top_bid": null,
            "listing_date": null,
            "is_presale": true,
            "transfer_fee_payment_token": null,
            "transfer_fee": null
        },
        {
            "id": 25665499,
            "token_id": "23295",
            "num_sales": 0,
            "background_color": null,
            "image_url": "https://storage.opensea.io/files/589bd360069955cf51e996a59df0158c.svg",
            "image_preview_url": "https://storage.opensea.io/files/589bd360069955cf51e996a59df0158c.svg",
            "image_thumbnail_url": "https://storage.opensea.io/files/589bd360069955cf51e996a59df0158c.svg",
            "image_original_url": null,
            "animation_url": null,
            "animation_original_url": null,
            "name": "Uniswap - 0.3% - USDC/WETH - 99.900<>10016",
            "description": "This NFT represents a liquidity position in a Uniswap V3 USDC-WETH pool. The owner of this NFT can modify or redeem the position.\n\nPool Address: 0x8ad599c3a0ff1de082011efddc58f1908eb6e6d8\nUSDC Address: 0xa0b86991c6218b36c1d19d4a2e9eb0ce3606eb48\nWETH Address: 0xc02aaa39b223fe8d0a0e5c4f27ead9083c756cc2\nFee Tier: 0.3%\nToken ID: 23295\n\n⚠️ DISCLAIMER: Due diligence is imperative when assessing this NFT. Make sure token addresses match the expected tokens, as token symbols may be imitated.",
            "external_link": null,
            "asset_contract": {
                "address": "0xc36442b4a4522e871399cd717abdd847ab11fe88",
                "asset_contract_type": "non-fungible",
                "created_date": "2021-05-04T19:53:14.975423",
                "name": "Uniswap V3 Positions NFT-V1",
                "nft_version": "unsupported",
                "opensea_version": null,
                "owner": null,
                "schema_name": "ERC721",
                "symbol": "UNI-V3-POS",
                "total_supply": "1",
                "description": "",
                "external_link": "https://uniswap.org/",
                "image_url": "https://lh3.googleusercontent.com/8My7rmWHJCAi35QSp2IMf50NRNIRJelpEdassqIxiL6Q_m2SE2qG7QKIT_1wfXH2afDcACiWVGrt2jkfHqHKlElttUTdL6dmC9G0Mpk=s120",
                "default_to_fiat": false,
                "dev_buyer_fee_basis_points": 0,
                "dev_seller_fee_basis_points": 0,
                "only_proxied_transfers": false,
                "opensea_buyer_fee_basis_points": 0,
                "opensea_seller_fee_basis_points": 250,
                "buyer_fee_basis_points": 0,
                "seller_fee_basis_points": 250,
                "payout_address": null
            },
            "owner": {
                "user": null,
                "profile_img_url": "https://storage.googleapis.com/opensea-static/opensea-profile/29.png",
                "address": "0x04b36a0ec99715a2a22a588ca14c416e92eaf0d8",
                "config": "",
                "discord_id": ""
            },
            "permalink": "https://opensea.io/assets/0xc36442b4a4522e871399cd717abdd847ab11fe88/23295",
            "collection": {
                "banner_image_url": "https://lh3.googleusercontent.com/Xq98abLTjlFfzdIxsXNL0sVE2W-3FGcJ2TFUkphz9dh9wEH4rcUesMhE7RzEh_ivPCdL5KxkNVfyE5gb870OgqOLQnBP6sIL54-G0A=s2500",
                "chat_url": null,
                "created_date": "2021-05-04T19:53:16.930034",
                "default_to_fiat": false,
                "description": "",
                "dev_buyer_fee_basis_points": "0",
                "dev_seller_fee_basis_points": "0",
                "discord_url": "https://discord.gg/FCfyBSbCU5",
                "display_data": {
                    "card_display_style": "contain"
                },
                "external_url": "https://uniswap.org/",
                "featured": false,
                "featured_image_url": "https://lh3.googleusercontent.com/cnVFmcBCIreYJxfaZ2ba62kEdC9ocuP7vawwcfZx9QIOVNlisuJTV2f19D48hg2NSUxPFX6peemTKaYshJvs-vIcy_3Kv3nCiF7t9g=s300",
                "hidden": false,
                "safelist_request_status": "verified",
                "image_url": "https://lh3.googleusercontent.com/8My7rmWHJCAi35QSp2IMf50NRNIRJelpEdassqIxiL6Q_m2SE2qG7QKIT_1wfXH2afDcACiWVGrt2jkfHqHKlElttUTdL6dmC9G0Mpk=s120",
                "is_subject_to_whitelist": false,
                "large_image_url": "https://lh3.googleusercontent.com/cnVFmcBCIreYJxfaZ2ba62kEdC9ocuP7vawwcfZx9QIOVNlisuJTV2f19D48hg2NSUxPFX6peemTKaYshJvs-vIcy_3Kv3nCiF7t9g=s300",
                "medium_username": null,
                "name": "Uniswap V3 Positions",
                "only_proxied_transfers": false,
                "opensea_buyer_fee_basis_points": "0",
                "opensea_seller_fee_basis_points": "250",
                "payout_address": null,
                "require_email": false,
                "short_description": null,
                "slug": "uniswap-v3-positions",
                "telegram_url": null,
                "twitter_username": "@Uniswap",
                "instagram_username": null,
                "wiki_url": null
            },
            "decimals": null,
            "token_metadata": null,
            "sell_orders": null,
            "creator": {
                "user": null,
                "profile_img_url": "https://storage.googleapis.com/opensea-static/opensea-profile/29.png",
                "address": "0x04b36a0ec99715a2a22a588ca14c416e92eaf0d8",
                "config": "",
                "discord_id": ""
            },
            "traits": [],
            "last_sale": null,
            "top_bid": null,
            "listing_date": null,
            "is_presale": false,
            "transfer_fee_payment_token": null,
            "transfer_fee": null
        },
        {
            "id": 25665498,
            "token_id": "101252083778151641423831800880398356849809162001436389574999047517755498561537",
            "num_sales": 0,
            "background_color": null,
            "image_url": "https://lh3.googleusercontent.com/AnuFKnCPn5V1Rz1JX7ea1ckfy1522j2AZK_zNmdtlTKqlxa8r7q-w7z8O-Kd5wSdeOHBu7UJSLmKFRgowU63F86KcKdL1jl3s81FUg",
            "image_preview_url": "https://lh3.googleusercontent.com/AnuFKnCPn5V1Rz1JX7ea1ckfy1522j2AZK_zNmdtlTKqlxa8r7q-w7z8O-Kd5wSdeOHBu7UJSLmKFRgowU63F86KcKdL1jl3s81FUg=s250",
            "image_thumbnail_url": "https://lh3.googleusercontent.com/AnuFKnCPn5V1Rz1JX7ea1ckfy1522j2AZK_zNmdtlTKqlxa8r7q-w7z8O-Kd5wSdeOHBu7UJSLmKFRgowU63F86KcKdL1jl3s81FUg=s128",
            "image_original_url": null,
            "animation_url": null,
            "animation_original_url": null,
            "name": "Akou - Cryptoneum #00042",
            "description": "There will be a unique Space Gang member card whenever a new planet is visited . Intergalactic travel will distract and slow down Space Mercenaries.",
            "external_link": null,
            "asset_contract": {
                "address": "0x495f947276749ce646f68ac8c248420045cb7b5e",
                "asset_contract_type": "semi-fungible",
                "created_date": "2020-12-02T17:40:53.232025",
                "name": "OpenSea Collection",
                "nft_version": null,
                "opensea_version": "2.0.0",
                "owner": 102384,
                "schema_name": "ERC1155",
                "symbol": "OPENSTORE",
                "total_supply": null,
                "description": null,
                "external_link": null,
                "image_url": null,
                "default_to_fiat": false,
                "dev_buyer_fee_basis_points": 0,
                "dev_seller_fee_basis_points": 0,
                "only_proxied_transfers": false,
                "opensea_buyer_fee_basis_points": 0,
                "opensea_seller_fee_basis_points": 250,
                "buyer_fee_basis_points": 0,
                "seller_fee_basis_points": 250,
                "payout_address": null
            },
            "owner": {
                "user": {
                    "username": "NullAddress"
                },
                "profile_img_url": "https://storage.googleapis.com/opensea-static/opensea-profile/1.png",
                "address": "0x0000000000000000000000000000000000000000",
                "config": "",
                "discord_id": ""
            },
            "permalink": "https://opensea.io/assets/0x495f947276749ce646f68ac8c248420045cb7b5e/101252083778151641423831800880398356849809162001436389574999047517755498561537",
            "collection": {
                "banner_image_url": "https://lh3.googleusercontent.com/q_6CD6ksFrUzlPO_3mMnJbcf5_JjNNmMGLU9HTxnnAerviTL3Fpj6fdJXGpOZymMD0hioSybKHDhJfPGVVNuDbFS1lsgNWWcDC1MjQ=s2500",
                "chat_url": null,
                "created_date": "2021-05-20T21:29:24.229752",
                "default_to_fiat": false,
                "description": "60 Space Gang members, 14 Space Mercenaries, 5 Evil Board members and God knows how many planets and galaxies this space hunt will impact. Join the FusionOps community and help saving our brave Space Gang.",
                "dev_buyer_fee_basis_points": "0",
                "dev_seller_fee_basis_points": "1000",
                "discord_url": null,
                "display_data": {
                    "card_display_style": "contain"
                },
                "external_url": null,
                "featured": false,
                "featured_image_url": "https://lh3.googleusercontent.com/Rnqw0Y8SY5CykHv0icv-Rlgf88t7i3PTsOdCr184yn_BFCRO6W7LKL_Om_h8lB9u7oNG0tSK1w7TNB0H6OS2Tp8y5dVqaISvZZ4rDw=s300",
                "hidden": true,
                "safelist_request_status": "not_requested",
                "image_url": "https://lh3.googleusercontent.com/lyfsf6monb3FSa9ELmisAovb8cGTqJTJs6iqx4SHjhVY4kCEIgl-0ZuP4dV59NAyRvyZHhW92Xx4aawH0z08KQcwmjMVAecr0Hql=s120",
                "is_subject_to_whitelist": false,
                "large_image_url": "https://lh3.googleusercontent.com/Rnqw0Y8SY5CykHv0icv-Rlgf88t7i3PTsOdCr184yn_BFCRO6W7LKL_Om_h8lB9u7oNG0tSK1w7TNB0H6OS2Tp8y5dVqaISvZZ4rDw=s300",
                "medium_username": null,
                "name": "FusionOps",
                "only_proxied_transfers": false,
                "opensea_buyer_fee_basis_points": "0",
                "opensea_seller_fee_basis_points": "250",
                "payout_address": "0xdfdaa60732c9219166c2e3c824edcf47c8d9d2a1",
                "require_email": false,
                "short_description": null,
                "slug": "fusionops",
                "telegram_url": null,
                "twitter_username": "SpaceGangClub",
                "instagram_username": null,
                "wiki_url": null
            },
            "decimals": null,
            "token_metadata": null,
            "sell_orders": null,
            "creator": {
                "user": {
                    "username": "Born_InSpace"
                },
                "profile_img_url": "https://storage.googleapis.com/opensea-static/opensea-profile/25.png",
                "address": "0xdfdaa60732c9219166c2e3c824edcf47c8d9d2a1",
                "config": "",
                "discord_id": ""
            },
            "traits": [
                {
                    "trait_type": "Planet",
                    "value": "Cryptoneum",
                    "display_type": null,
                    "max_value": null,
                    "trait_count": 26,
                    "order": null
                },
                {
                    "trait_type": "Name",
                    "value": "Akou",
                    "display_type": null,
                    "max_value": null,
                    "trait_count": 0,
                    "order": null
                },
                {
                    "trait_type": "Rank",
                    "value": "Member",
                    "display_type": null,
                    "max_value": null,
                    "trait_count": 21,
                    "order": null
                },
                {
                    "trait_type": "Set",
                    "value": "Space Gang",
                    "display_type": null,
                    "max_value": null,
                    "trait_count": 26,
                    "order": null
                }
            ],
            "last_sale": null,
            "top_bid": null,
            "listing_date": null,
            "is_presale": true,
            "transfer_fee_payment_token": null,
            "transfer_fee": null
        },
        {
            "id": 25665497,
            "token_id": "62665",
            "num_sales": 0,
            "background_color": null,
            "image_url": "",
            "image_preview_url": null,
            "image_thumbnail_url": null,
            "image_original_url": null,
            "animation_url": null,
            "animation_original_url": null,
            "name": null,
            "description": null,
            "external_link": null,
            "asset_contract": {
                "address": "0xf556faf23fc2feefa33ee6db2d1ee4c70e534513",
                "asset_contract_type": "non-fungible",
                "created_date": "2021-01-04T16:26:23.390626",
                "name": "0xUniverse",
                "nft_version": null,
                "opensea_version": null,
                "owner": 37755849,
                "schema_name": "ERC721",
                "symbol": "PLANET",
                "total_supply": "61667",
                "description": "0xUniverse is the next generation blockchain game where players can build spaceships, explore the galaxy, and colonize planets. The discoverers will extract resources and carry out research that allows them to conquer the remotest corners of the galaxy. In addition, players can jointly contribute to the story and unravel the mystery of the universe.",
                "external_link": "https://0xuniverse.com",
                "image_url": "https://lh3.googleusercontent.com/WcGfdbwJ5EcLj-_q7kIsyzhNOo6Wb8C5ZjZFJxUQEgwYbQ5eMVkpDHwbti8G0cFvXPQJbUfekwbCSZANhyuIzRys094NIoCkuGOm=s120",
                "default_to_fiat": false,
                "dev_buyer_fee_basis_points": 0,
                "dev_seller_fee_basis_points": 0,
                "only_proxied_transfers": false,
                "opensea_buyer_fee_basis_points": 0,
                "opensea_seller_fee_basis_points": 250,
                "buyer_fee_basis_points": 0,
                "seller_fee_basis_points": 250,
                "payout_address": null
            },
            "owner": {
                "user": null,
                "profile_img_url": "https://storage.googleapis.com/opensea-static/opensea-profile/1.png",
                "address": "0x0000000000000000000000000000000000000000",
                "config": "",
                "discord_id": ""
            },
            "permalink": "https://opensea.io/assets/matic/0xf556faf23fc2feefa33ee6db2d1ee4c70e534513/62665",
            "collection": {
                "banner_image_url": "https://lh3.googleusercontent.com/xTMVZ9068E5AeySzCF3IjdMvWWal8DqXK5RzPVhCI0k6Eu6HuLD2V9hnu2RY5-tnuHpgj62kovuY0KexryI1SHg56MNsgGCJt1ZB=s2500",
                "chat_url": null,
                "created_date": "2021-01-04T16:26:23.654821",
                "default_to_fiat": false,
                "description": "0xUniverse is the next generation blockchain game where players can build spaceships, explore the galaxy, and colonize planets. The discoverers will extract resources and carry out research that allows them to conquer the remotest corners of the galaxy. In addition, players can jointly contribute to the story and unravel the mystery of the universe.",
                "dev_buyer_fee_basis_points": "0",
                "dev_seller_fee_basis_points": "0",
                "discord_url": "https://discord.gg/R8fwEPC",
                "display_data": {
                    "card_display_style": "cover"
                },
                "external_url": "https://0xuniverse.com",
                "featured": false,
                "featured_image_url": "https://lh3.googleusercontent.com/NKpERysJoaSPjRHewYtAu0p5HHxzbhra1mwzN8i6Nuv6K17kUco7De-iJUUmVgmlJSKMCuovdTHx13n2RUOrAXWRNNaC3iW6uyB7jA=s300",
                "hidden": true,
                "safelist_request_status": "not_requested",
                "image_url": "https://lh3.googleusercontent.com/WcGfdbwJ5EcLj-_q7kIsyzhNOo6Wb8C5ZjZFJxUQEgwYbQ5eMVkpDHwbti8G0cFvXPQJbUfekwbCSZANhyuIzRys094NIoCkuGOm=s120",
                "is_subject_to_whitelist": false,
                "large_image_url": "https://lh3.googleusercontent.com/NKpERysJoaSPjRHewYtAu0p5HHxzbhra1mwzN8i6Nuv6K17kUco7De-iJUUmVgmlJSKMCuovdTHx13n2RUOrAXWRNNaC3iW6uyB7jA=s300",
                "medium_username": null,
                "name": "0xUniverse: Galaxy Edge (Matic)",
                "only_proxied_transfers": false,
                "opensea_buyer_fee_basis_points": "0",
                "opensea_seller_fee_basis_points": "250",
                "payout_address": null,
                "require_email": false,
                "short_description": null,
                "slug": "0xuniverse-edge-matic",
                "telegram_url": null,
                "twitter_username": "0xUniverse",
                "instagram_username": null,
                "wiki_url": null
            },
            "decimals": null,
            "token_metadata": "https://prod.0xuniverse.com/universe-server/planets/1/62665",
            "sell_orders": null,
            "creator": null,
            "traits": [],
            "last_sale": null,
            "top_bid": null,
            "listing_date": null,
            "is_presale": false,
            "transfer_fee_payment_token": null,
            "transfer_fee": null
        },
        {
            "id": 25665496,
            "token_id": "1263",
            "num_sales": 0,
            "background_color": null,
            "image_url": "",
            "image_preview_url": null,
            "image_thumbnail_url": null,
            "image_original_url": null,
            "animation_url": null,
            "animation_original_url": null,
            "name": null,
            "description": null,
            "external_link": null,
            "asset_contract": {
                "address": "0xe7e16f2da731265778f87cb8d7850e31b84b7b86",
                "asset_contract_type": "non-fungible",
                "created_date": "2021-05-25T13:23:10.895540",
                "name": "Embersword Land",
                "nft_version": null,
                "opensea_version": null,
                "owner": 35978059,
                "schema_name": "ERC721",
                "symbol": "LAND",
                "total_supply": "0",
                "description": null,
                "external_link": "https://embersword.com",
                "image_url": "https://lh3.googleusercontent.com/J7SSCNIDh1ui59aoqyNywPtnUAUB-Q80Cnl1txbxmJOAIKcRJT1bUYidkDPNegOk2W0zyjqVkLbdcI6g6KTYgQCDplCo3DXpDSeaPg=s120",
                "default_to_fiat": false,
                "dev_buyer_fee_basis_points": 0,
                "dev_seller_fee_basis_points": 0,
                "only_proxied_transfers": false,
                "opensea_buyer_fee_basis_points": 0,
                "opensea_seller_fee_basis_points": 250,
                "buyer_fee_basis_points": 0,
                "seller_fee_basis_points": 250,
                "payout_address": null
            },
            "owner": {
                "user": null,
                "profile_img_url": "https://storage.googleapis.com/opensea-static/opensea-profile/1.png",
                "address": "0x0000000000000000000000000000000000000000",
                "config": "",
                "discord_id": ""
            },
            "permalink": "https://opensea.io/assets/matic/0xe7e16f2da731265778f87cb8d7850e31b84b7b86/1263",
            "collection": {
                "banner_image_url": null,
                "chat_url": null,
                "created_date": "2021-05-25T16:51:25.426643",
                "default_to_fiat": false,
                "description": null,
                "dev_buyer_fee_basis_points": "0",
                "dev_seller_fee_basis_points": "0",
                "discord_url": "https://discord.gg/embersword",
                "display_data": {
                    "card_display_style": "contain"
                },
                "external_url": "https://embersword.com",
                "featured": false,
                "featured_image_url": null,
                "hidden": true,
                "safelist_request_status": "not_requested",
                "image_url": "https://lh3.googleusercontent.com/J7SSCNIDh1ui59aoqyNywPtnUAUB-Q80Cnl1txbxmJOAIKcRJT1bUYidkDPNegOk2W0zyjqVkLbdcI6g6KTYgQCDplCo3DXpDSeaPg=s120",
                "is_subject_to_whitelist": false,
                "large_image_url": null,
                "medium_username": "embersword",
                "name": "Ember Sword Land",
                "only_proxied_transfers": false,
                "opensea_buyer_fee_basis_points": "0",
                "opensea_seller_fee_basis_points": "250",
                "payout_address": null,
                "require_email": false,
                "short_description": null,
                "slug": "embersword-land",
                "telegram_url": null,
                "twitter_username": "PlayEmberSword",
                "instagram_username": null,
                "wiki_url": null
            },
            "decimals": null,
            "token_metadata": null,
            "sell_orders": null,
            "creator": null,
            "traits": [],
            "last_sale": null,
            "top_bid": null,
            "listing_date": null,
            "is_presale": false,
            "transfer_fee_payment_token": null,
            "transfer_fee": null
        },
        {
            "id": 25665495,
            "token_id": "6051118",
            "num_sales": 0,
            "background_color": null,
            "image_url": "",
            "image_preview_url": null,
            "image_thumbnail_url": null,
            "image_original_url": null,
            "animation_url": null,
            "animation_original_url": null,
            "name": null,
            "description": null,
            "external_link": null,
            "asset_contract": {
                "address": "0x8a320ce7ce2c0c592f33e05d14b00bf6d58660f9",
                "asset_contract_type": "non-fungible",
                "created_date": "2021-04-17T23:21:38.732684",
                "name": "Doge Colors",
                "nft_version": null,
                "opensea_version": null,
                "owner": null,
                "schema_name": "ERC721",
                "symbol": "DC",
                "total_supply": "37630",
                "description": null,
                "external_link": null,
                "image_url": null,
                "default_to_fiat": false,
                "dev_buyer_fee_basis_points": 0,
                "dev_seller_fee_basis_points": 0,
                "only_proxied_transfers": false,
                "opensea_buyer_fee_basis_points": 0,
                "opensea_seller_fee_basis_points": 250,
                "buyer_fee_basis_points": 0,
                "seller_fee_basis_points": 250,
                "payout_address": null
            },
            "owner": {
                "user": null,
                "profile_img_url": "https://storage.googleapis.com/opensea-static/opensea-profile/1.png",
                "address": "0x0000000000000000000000000000000000000000",
                "config": "",
                "discord_id": ""
            },
            "permalink": "https://opensea.io/assets/matic/0x8a320ce7ce2c0c592f33e05d14b00bf6d58660f9/6051118",
            "collection": {
                "banner_image_url": null,
                "chat_url": null,
                "created_date": "2021-04-17T23:21:39.303087",
                "default_to_fiat": false,
                "description": null,
                "dev_buyer_fee_basis_points": "0",
                "dev_seller_fee_basis_points": "0",
                "discord_url": null,
                "display_data": {
                    "card_display_style": "contain",
                    "images": []
                },
                "external_url": null,
                "featured": false,
                "featured_image_url": null,
                "hidden": true,
                "safelist_request_status": "not_requested",
                "image_url": null,
                "is_subject_to_whitelist": false,
                "large_image_url": null,
                "medium_username": null,
                "name": "Doge Colors V2",
                "only_proxied_transfers": false,
                "opensea_buyer_fee_basis_points": "0",
                "opensea_seller_fee_basis_points": "250",
                "payout_address": null,
                "require_email": false,
                "short_description": null,
                "slug": "doge-colors-v2",
                "telegram_url": null,
                "twitter_username": null,
                "instagram_username": null,
                "wiki_url": null
            },
            "decimals": null,
            "token_metadata": null,
            "sell_orders": null,
            "creator": null,
            "traits": [],
            "last_sale": null,
            "top_bid": null,
            "listing_date": null,
            "is_presale": false,
            "transfer_fee_payment_token": null,
            "transfer_fee": null
        },
        {
            "id": 25665494,
            "token_id": "1262",
            "num_sales": 0,
            "background_color": null,
            "image_url": "",
            "image_preview_url": null,
            "image_thumbnail_url": null,
            "image_original_url": null,
            "animation_url": null,
            "animation_original_url": null,
            "name": null,
            "description": null,
            "external_link": null,
            "asset_contract": {
                "address": "0xe7e16f2da731265778f87cb8d7850e31b84b7b86",
                "asset_contract_type": "non-fungible",
                "created_date": "2021-05-25T13:23:10.895540",
                "name": "Embersword Land",
                "nft_version": null,
                "opensea_version": null,
                "owner": 35978059,
                "schema_name": "ERC721",
                "symbol": "LAND",
                "total_supply": "0",
                "description": null,
                "external_link": "https://embersword.com",
                "image_url": "https://lh3.googleusercontent.com/J7SSCNIDh1ui59aoqyNywPtnUAUB-Q80Cnl1txbxmJOAIKcRJT1bUYidkDPNegOk2W0zyjqVkLbdcI6g6KTYgQCDplCo3DXpDSeaPg=s120",
                "default_to_fiat": false,
                "dev_buyer_fee_basis_points": 0,
                "dev_seller_fee_basis_points": 0,
                "only_proxied_transfers": false,
                "opensea_buyer_fee_basis_points": 0,
                "opensea_seller_fee_basis_points": 250,
                "buyer_fee_basis_points": 0,
                "seller_fee_basis_points": 250,
                "payout_address": null
            },
            "owner": {
                "user": null,
                "profile_img_url": "https://storage.googleapis.com/opensea-static/opensea-profile/1.png",
                "address": "0x0000000000000000000000000000000000000000",
                "config": "",
                "discord_id": ""
            },
            "permalink": "https://opensea.io/assets/matic/0xe7e16f2da731265778f87cb8d7850e31b84b7b86/1262",
            "collection": {
                "banner_image_url": null,
                "chat_url": null,
                "created_date": "2021-05-25T16:51:25.426643",
                "default_to_fiat": false,
                "description": null,
                "dev_buyer_fee_basis_points": "0",
                "dev_seller_fee_basis_points": "0",
                "discord_url": "https://discord.gg/embersword",
                "display_data": {
                    "card_display_style": "contain"
                },
                "external_url": "https://embersword.com",
                "featured": false,
                "featured_image_url": null,
                "hidden": true,
                "safelist_request_status": "not_requested",
                "image_url": "https://lh3.googleusercontent.com/J7SSCNIDh1ui59aoqyNywPtnUAUB-Q80Cnl1txbxmJOAIKcRJT1bUYidkDPNegOk2W0zyjqVkLbdcI6g6KTYgQCDplCo3DXpDSeaPg=s120",
                "is_subject_to_whitelist": false,
                "large_image_url": null,
                "medium_username": "embersword",
                "name": "Ember Sword Land",
                "only_proxied_transfers": false,
                "opensea_buyer_fee_basis_points": "0",
                "opensea_seller_fee_basis_points": "250",
                "payout_address": null,
                "require_email": false,
                "short_description": null,
                "slug": "embersword-land",
                "telegram_url": null,
                "twitter_username": "PlayEmberSword",
                "instagram_username": null,
                "wiki_url": null
            },
            "decimals": null,
            "token_metadata": null,
            "sell_orders": null,
            "creator": null,
            "traits": [],
            "last_sale": null,
            "top_bid": null,
            "listing_date": null,
            "is_presale": false,
            "transfer_fee_payment_token": null,
            "transfer_fee": null
        },
        {
            "id": 25665493,
            "token_id": "410369",
            "num_sales": 0,
            "background_color": null,
            "image_url": "",
            "image_preview_url": null,
            "image_thumbnail_url": null,
            "image_original_url": null,
            "animation_url": null,
            "animation_original_url": null,
            "name": null,
            "description": null,
            "external_link": null,
            "asset_contract": {
                "address": "0x8a320ce7ce2c0c592f33e05d14b00bf6d58660f9",
                "asset_contract_type": "non-fungible",
                "created_date": "2021-04-17T23:21:38.732684",
                "name": "Doge Colors",
                "nft_version": null,
                "opensea_version": null,
                "owner": null,
                "schema_name": "ERC721",
                "symbol": "DC",
                "total_supply": "37630",
                "description": null,
                "external_link": null,
                "image_url": null,
                "default_to_fiat": false,
                "dev_buyer_fee_basis_points": 0,
                "dev_seller_fee_basis_points": 0,
                "only_proxied_transfers": false,
                "opensea_buyer_fee_basis_points": 0,
                "opensea_seller_fee_basis_points": 250,
                "buyer_fee_basis_points": 0,
                "seller_fee_basis_points": 250,
                "payout_address": null
            },
            "owner": {
                "user": null,
                "profile_img_url": "https://storage.googleapis.com/opensea-static/opensea-profile/1.png",
                "address": "0x0000000000000000000000000000000000000000",
                "config": "",
                "discord_id": ""
            },
            "permalink": "https://opensea.io/assets/matic/0x8a320ce7ce2c0c592f33e05d14b00bf6d58660f9/410369",
            "collection": {
                "banner_image_url": null,
                "chat_url": null,
                "created_date": "2021-04-17T23:21:39.303087",
                "default_to_fiat": false,
                "description": null,
                "dev_buyer_fee_basis_points": "0",
                "dev_seller_fee_basis_points": "0",
                "discord_url": null,
                "display_data": {
                    "card_display_style": "contain",
                    "images": []
                },
                "external_url": null,
                "featured": false,
                "featured_image_url": null,
                "hidden": true,
                "safelist_request_status": "not_requested",
                "image_url": null,
                "is_subject_to_whitelist": false,
                "large_image_url": null,
                "medium_username": null,
                "name": "Doge Colors V2",
                "only_proxied_transfers": false,
                "opensea_buyer_fee_basis_points": "0",
                "opensea_seller_fee_basis_points": "250",
                "payout_address": null,
                "require_email": false,
                "short_description": null,
                "slug": "doge-colors-v2",
                "telegram_url": null,
                "twitter_username": null,
                "instagram_username": null,
                "wiki_url": null
            },
            "decimals": null,
            "token_metadata": null,
            "sell_orders": null,
            "creator": null,
            "traits": [],
            "last_sale": null,
            "top_bid": null,
            "listing_date": null,
            "is_presale": false,
            "transfer_fee_payment_token": null,
            "transfer_fee": null
        },
        {
            "id": 25665492,
            "token_id": "36290130404719748568119145735575727865855420748188833993790868424342579970049",
            "num_sales": 0,
            "background_color": null,
            "image_url": "https://lh3.googleusercontent.com/UgSK9vjbVPUiX9nn14rNhNroXt0WdLKBYAqcQ1U5Nk1QszCmaCp722C1p07_uzMWtV8a58YEw9ImjZdTO51D8ETfiarKhrdHwPczug",
            "image_preview_url": "https://lh3.googleusercontent.com/UgSK9vjbVPUiX9nn14rNhNroXt0WdLKBYAqcQ1U5Nk1QszCmaCp722C1p07_uzMWtV8a58YEw9ImjZdTO51D8ETfiarKhrdHwPczug=s250",
            "image_thumbnail_url": "https://lh3.googleusercontent.com/UgSK9vjbVPUiX9nn14rNhNroXt0WdLKBYAqcQ1U5Nk1QszCmaCp722C1p07_uzMWtV8a58YEw9ImjZdTO51D8ETfiarKhrdHwPczug=s128",
            "image_original_url": null,
            "animation_url": null,
            "animation_original_url": null,
            "name": "The route to meet us",
            "description": "\nPhoto by artist Martin Cornejo, taken at Camino del Cuadrado Salsipuedes, Cordoba, Argentina.\n\nAfter my car stopped due to an inconvenience, I decided to walk a little and I found this image. Undoubtedly the best thing that could have happened to me that day was that my car stopped in that place.",
            "external_link": null,
            "asset_contract": {
                "address": "0x495f947276749ce646f68ac8c248420045cb7b5e",
                "asset_contract_type": "semi-fungible",
                "created_date": "2020-12-02T17:40:53.232025",
                "name": "OpenSea Collection",
                "nft_version": null,
                "opensea_version": "2.0.0",
                "owner": 102384,
                "schema_name": "ERC1155",
                "symbol": "OPENSTORE",
                "total_supply": null,
                "description": null,
                "external_link": null,
                "image_url": null,
                "default_to_fiat": false,
                "dev_buyer_fee_basis_points": 0,
                "dev_seller_fee_basis_points": 0,
                "only_proxied_transfers": false,
                "opensea_buyer_fee_basis_points": 0,
                "opensea_seller_fee_basis_points": 250,
                "buyer_fee_basis_points": 0,
                "seller_fee_basis_points": 250,
                "payout_address": null
            },
            "owner": {
                "user": {
                    "username": "NullAddress"
                },
                "profile_img_url": "https://storage.googleapis.com/opensea-static/opensea-profile/1.png",
                "address": "0x0000000000000000000000000000000000000000",
                "config": "",
                "discord_id": ""
            },
            "permalink": "https://opensea.io/assets/0x495f947276749ce646f68ac8c248420045cb7b5e/36290130404719748568119145735575727865855420748188833993790868424342579970049",
            "collection": {
                "banner_image_url": null,
                "chat_url": null,
                "created_date": "2021-05-25T21:53:40.102871",
                "default_to_fiat": false,
                "description": "Argentine Digital Artist and Photographer",
                "dev_buyer_fee_basis_points": "0",
                "dev_seller_fee_basis_points": "0",
                "discord_url": null,
                "display_data": {
                    "card_display_style": "contain",
                    "images": []
                },
                "external_url": null,
                "featured": false,
                "featured_image_url": null,
                "hidden": true,
                "safelist_request_status": "not_requested",
                "image_url": "https://lh3.googleusercontent.com/_vAUn5syWyLbIISgQ13mNtMoQlqDYFJ9r0iQ8Vx4ttTgTQJfS-JJ0RK-XTl3TZnw6tDfO5Khs5KIml-bNX1AsOYbaqCVDqMz6GffGA=s120",
                "is_subject_to_whitelist": false,
                "large_image_url": null,
                "medium_username": null,
                "name": "Martin Cornejo FotoRock",
                "only_proxied_transfers": false,
                "opensea_buyer_fee_basis_points": "0",
                "opensea_seller_fee_basis_points": "250",
                "payout_address": null,
                "require_email": false,
                "short_description": null,
                "slug": "martin-cornejo-fotorock",
                "telegram_url": null,
                "twitter_username": null,
                "instagram_username": null,
                "wiki_url": null
            },
            "decimals": null,
            "token_metadata": null,
            "sell_orders": null,
            "creator": {
                "user": {
                    "username": null
                },
                "profile_img_url": "https://storage.googleapis.com/opensea-static/opensea-profile/9.png",
                "address": "0x503b7c6510794d4f2913c52f650201e29ae234df",
                "config": "",
                "discord_id": ""
            },
            "traits": [],
            "last_sale": null,
            "top_bid": null,
            "listing_date": null,
            "is_presale": true,
            "transfer_fee_payment_token": null,
            "transfer_fee": null
        },
        {
            "id": 25665491,
            "token_id": "8396146",
            "num_sales": 0,
            "background_color": null,
            "image_url": "",
            "image_preview_url": null,
            "image_thumbnail_url": null,
            "image_original_url": null,
            "animation_url": null,
            "animation_original_url": null,
            "name": null,
            "description": null,
            "external_link": null,
            "asset_contract": {
                "address": "0x8a320ce7ce2c0c592f33e05d14b00bf6d58660f9",
                "asset_contract_type": "non-fungible",
                "created_date": "2021-04-17T23:21:38.732684",
                "name": "Doge Colors",
                "nft_version": null,
                "opensea_version": null,
                "owner": null,
                "schema_name": "ERC721",
                "symbol": "DC",
                "total_supply": "37630",
                "description": null,
                "external_link": null,
                "image_url": null,
                "default_to_fiat": false,
                "dev_buyer_fee_basis_points": 0,
                "dev_seller_fee_basis_points": 0,
                "only_proxied_transfers": false,
                "opensea_buyer_fee_basis_points": 0,
                "opensea_seller_fee_basis_points": 250,
                "buyer_fee_basis_points": 0,
                "seller_fee_basis_points": 250,
                "payout_address": null
            },
            "owner": {
                "user": null,
                "profile_img_url": "https://storage.googleapis.com/opensea-static/opensea-profile/1.png",
                "address": "0x0000000000000000000000000000000000000000",
                "config": "",
                "discord_id": ""
            },
            "permalink": "https://opensea.io/assets/matic/0x8a320ce7ce2c0c592f33e05d14b00bf6d58660f9/8396146",
            "collection": {
                "banner_image_url": null,
                "chat_url": null,
                "created_date": "2021-04-17T23:21:39.303087",
                "default_to_fiat": false,
                "description": null,
                "dev_buyer_fee_basis_points": "0",
                "dev_seller_fee_basis_points": "0",
                "discord_url": null,
                "display_data": {
                    "card_display_style": "contain",
                    "images": []
                },
                "external_url": null,
                "featured": false,
                "featured_image_url": null,
                "hidden": true,
                "safelist_request_status": "not_requested",
                "image_url": null,
                "is_subject_to_whitelist": false,
                "large_image_url": null,
                "medium_username": null,
                "name": "Doge Colors V2",
                "only_proxied_transfers": false,
                "opensea_buyer_fee_basis_points": "0",
                "opensea_seller_fee_basis_points": "250",
                "payout_address": null,
                "require_email": false,
                "short_description": null,
                "slug": "doge-colors-v2",
                "telegram_url": null,
                "twitter_username": null,
                "instagram_username": null,
                "wiki_url": null
            },
            "decimals": null,
            "token_metadata": null,
            "sell_orders": null,
            "creator": null,
            "traits": [],
            "last_sale": null,
            "top_bid": null,
            "listing_date": null,
            "is_presale": false,
            "transfer_fee_payment_token": null,
            "transfer_fee": null
        },
        {
            "id": 25665490,
            "token_id": "525331",
            "num_sales": 0,
            "background_color": null,
            "image_url": "",
            "image_preview_url": null,
            "image_thumbnail_url": null,
            "image_original_url": null,
            "animation_url": null,
            "animation_original_url": null,
            "name": null,
            "description": null,
            "external_link": null,
            "asset_contract": {
                "address": "0x8a320ce7ce2c0c592f33e05d14b00bf6d58660f9",
                "asset_contract_type": "non-fungible",
                "created_date": "2021-04-17T23:21:38.732684",
                "name": "Doge Colors",
                "nft_version": null,
                "opensea_version": null,
                "owner": null,
                "schema_name": "ERC721",
                "symbol": "DC",
                "total_supply": "37630",
                "description": null,
                "external_link": null,
                "image_url": null,
                "default_to_fiat": false,
                "dev_buyer_fee_basis_points": 0,
                "dev_seller_fee_basis_points": 0,
                "only_proxied_transfers": false,
                "opensea_buyer_fee_basis_points": 0,
                "opensea_seller_fee_basis_points": 250,
                "buyer_fee_basis_points": 0,
                "seller_fee_basis_points": 250,
                "payout_address": null
            },
            "owner": {
                "user": null,
                "profile_img_url": "https://storage.googleapis.com/opensea-static/opensea-profile/1.png",
                "address": "0x0000000000000000000000000000000000000000",
                "config": "",
                "discord_id": ""
            },
            "permalink": "https://opensea.io/assets/matic/0x8a320ce7ce2c0c592f33e05d14b00bf6d58660f9/525331",
            "collection": {
                "banner_image_url": null,
                "chat_url": null,
                "created_date": "2021-04-17T23:21:39.303087",
                "default_to_fiat": false,
                "description": null,
                "dev_buyer_fee_basis_points": "0",
                "dev_seller_fee_basis_points": "0",
                "discord_url": null,
                "display_data": {
                    "card_display_style": "contain",
                    "images": []
                },
                "external_url": null,
                "featured": false,
                "featured_image_url": null,
                "hidden": true,
                "safelist_request_status": "not_requested",
                "image_url": null,
                "is_subject_to_whitelist": false,
                "large_image_url": null,
                "medium_username": null,
                "name": "Doge Colors V2",
                "only_proxied_transfers": false,
                "opensea_buyer_fee_basis_points": "0",
                "opensea_seller_fee_basis_points": "250",
                "payout_address": null,
                "require_email": false,
                "short_description": null,
                "slug": "doge-colors-v2",
                "telegram_url": null,
                "twitter_username": null,
                "instagram_username": null,
                "wiki_url": null
            },
            "decimals": null,
            "token_metadata": null,
            "sell_orders": null,
            "creator": null,
            "traits": [],
            "last_sale": null,
            "top_bid": null,
            "listing_date": null,
            "is_presale": false,
            "transfer_fee_payment_token": null,
            "transfer_fee": null
        },
        {
            "id": 25665489,
            "token_id": "114735020019161692095051113089976497045262832457918814971796358071724084822017",
            "num_sales": 0,
            "background_color": null,
            "image_url": "https://lh3.googleusercontent.com/99i0IDVzk6ZA6z3NkqJ5DbpVNAUoAWS89xlLKZTxTKmptWOGCTLjgvMUR3B76Vw54nzII_EXXKVCpRCoCkHUWqIS5XKOWbSbKhgw",
            "image_preview_url": "https://lh3.googleusercontent.com/99i0IDVzk6ZA6z3NkqJ5DbpVNAUoAWS89xlLKZTxTKmptWOGCTLjgvMUR3B76Vw54nzII_EXXKVCpRCoCkHUWqIS5XKOWbSbKhgw=s250",
            "image_thumbnail_url": "https://lh3.googleusercontent.com/99i0IDVzk6ZA6z3NkqJ5DbpVNAUoAWS89xlLKZTxTKmptWOGCTLjgvMUR3B76Vw54nzII_EXXKVCpRCoCkHUWqIS5XKOWbSbKhgw=s128",
            "image_original_url": null,
            "animation_url": null,
            "animation_original_url": null,
            "name": "ColorStone #639",
            "description": null,
            "external_link": "https://www.facet.us",
            "asset_contract": {
                "address": "0x495f947276749ce646f68ac8c248420045cb7b5e",
                "asset_contract_type": "semi-fungible",
                "created_date": "2020-12-02T17:40:53.232025",
                "name": "OpenSea Collection",
                "nft_version": null,
                "opensea_version": "2.0.0",
                "owner": 102384,
                "schema_name": "ERC1155",
                "symbol": "OPENSTORE",
                "total_supply": null,
                "description": null,
                "external_link": null,
                "image_url": null,
                "default_to_fiat": false,
                "dev_buyer_fee_basis_points": 0,
                "dev_seller_fee_basis_points": 0,
                "only_proxied_transfers": false,
                "opensea_buyer_fee_basis_points": 0,
                "opensea_seller_fee_basis_points": 250,
                "buyer_fee_basis_points": 0,
                "seller_fee_basis_points": 250,
                "payout_address": null
            },
            "owner": {
                "user": {
                    "username": "NullAddress"
                },
                "profile_img_url": "https://storage.googleapis.com/opensea-static/opensea-profile/1.png",
                "address": "0x0000000000000000000000000000000000000000",
                "config": "",
                "discord_id": ""
            },
            "permalink": "https://opensea.io/assets/0x495f947276749ce646f68ac8c248420045cb7b5e/114735020019161692095051113089976497045262832457918814971796358071724084822017",
            "collection": {
                "banner_image_url": null,
                "chat_url": null,
                "created_date": "2021-05-24T20:56:06.886548",
                "default_to_fiat": false,
                "description": "ColorStones is the NFT collection from Facet Labs Inc.\n\nColorStones are digitally painted images of three unique gemstone shapes. The rarest gemstone shape in the collection is the Pear shape, followed by the Emerald cut, followed by the classic Round cut. Each of the three gemstone shapes was minted in 9 colors, also of varying rarity.  Each ColorStone NFT has one of 36 HEX-denominated background colors.  A full description of the collection is available on the NFT page of facet.us.   The project includes 1,620 ColorStones, and proof of ownership is stored on the Ethereum blockchain. \n",
                "dev_buyer_fee_basis_points": "0",
                "dev_seller_fee_basis_points": "0",
                "discord_url": null,
                "display_data": {
                    "card_display_style": "contain"
                },
                "external_url": null,
                "featured": false,
                "featured_image_url": null,
                "hidden": true,
                "safelist_request_status": "not_requested",
                "image_url": "https://lh3.googleusercontent.com/yXGhHWPXisfgrTQOg6h2hdqMZTJib-xbz7cPoHiuysu57WgvpHeY7rK2X7VSq903EmPuQY8UJ_8pT7BgzTMFUiBLsXZ_WmHj1XzVsA=s120",
                "is_subject_to_whitelist": false,
                "large_image_url": null,
                "medium_username": null,
                "name": "ColorStones",
                "only_proxied_transfers": false,
                "opensea_buyer_fee_basis_points": "0",
                "opensea_seller_fee_basis_points": "250",
                "payout_address": null,
                "require_email": false,
                "short_description": null,
                "slug": "colorstones",
                "telegram_url": null,
                "twitter_username": null,
                "instagram_username": null,
                "wiki_url": null
            },
            "decimals": null,
            "token_metadata": null,
            "sell_orders": null,
            "creator": {
                "user": {
                    "username": "FacetLabs"
                },
                "profile_img_url": "https://storage.googleapis.com/opensea-static/opensea-profile/25.png",
                "address": "0xfda9b8538b0e7b5d6b4843aa936e0532ddf9b877",
                "config": "",
                "discord_id": ""
            },
            "traits": [
                {
                    "trait_type": "background",
                    "value": "#203764",
                    "display_type": null,
                    "max_value": null,
                    "trait_count": 26,
                    "order": null
                },
                {
                    "trait_type": "color",
                    "value": "yellow",
                    "display_type": null,
                    "max_value": null,
                    "trait_count": 0,
                    "order": null
                },
                {
                    "trait_type": "shape",
                    "value": "round",
                    "display_type": null,
                    "max_value": null,
                    "trait_count": 500,
                    "order": null
                },
                {
                    "trait_type": "minted",
                    "value": 2,
                    "display_type": "number",
                    "max_value": "5",
                    "trait_count": 0,
                    "order": null
                }
            ],
            "last_sale": null,
            "top_bid": null,
            "listing_date": null,
            "is_presale": true,
            "transfer_fee_payment_token": null,
            "transfer_fee": null
        },
        {
            "id": 25665488,
            "token_id": "1737",
            "num_sales": 0,
            "background_color": null,
            "image_url": "https://lh3.googleusercontent.com/Nzr9A9s35_a2nF0CHTfHcjR3dd7AqWHZevM0nfa9J3xPn7gwGCjaVjxtjC0ok62uZNLc6tKff0QMqq3jxmSqK3Bz2yUGmgwVk7VdRwI",
            "image_preview_url": "https://lh3.googleusercontent.com/Nzr9A9s35_a2nF0CHTfHcjR3dd7AqWHZevM0nfa9J3xPn7gwGCjaVjxtjC0ok62uZNLc6tKff0QMqq3jxmSqK3Bz2yUGmgwVk7VdRwI=s250",
            "image_thumbnail_url": "https://lh3.googleusercontent.com/Nzr9A9s35_a2nF0CHTfHcjR3dd7AqWHZevM0nfa9J3xPn7gwGCjaVjxtjC0ok62uZNLc6tKff0QMqq3jxmSqK3Bz2yUGmgwVk7VdRwI=s128",
            "image_original_url": "https://ipfs.io/ipfs/QmfTAHy4Co9rcyoSsKjPgzjggLh1XZfMFkhP9HV3ZyHY2Z",
            "animation_url": null,
            "animation_original_url": null,
            "name": "PUNK GRADIENT 086 SE #5",
            "description": "to be viewed on screen SPECIAL EDITION #4 Original collector will receive 10 unreleased demo traxx via Instagram or Twitter dm 🎲🎲",
            "external_link": null,
            "asset_contract": {
                "address": "0x2452d8049f04d54ca779257678a691ee4a413267",
                "asset_contract_type": "non-fungible",
                "created_date": "2021-04-28T21:18:35.930652",
                "name": "MyGallery",
                "nft_version": null,
                "opensea_version": null,
                "owner": 30199464,
                "schema_name": "ERC721",
                "symbol": "MG",
                "total_supply": "1075",
                "description": null,
                "external_link": null,
                "image_url": null,
                "default_to_fiat": false,
                "dev_buyer_fee_basis_points": 0,
                "dev_seller_fee_basis_points": 0,
                "only_proxied_transfers": false,
                "opensea_buyer_fee_basis_points": 0,
                "opensea_seller_fee_basis_points": 250,
                "buyer_fee_basis_points": 0,
                "seller_fee_basis_points": 250,
                "payout_address": null
            },
            "owner": {
                "user": null,
                "profile_img_url": "https://storage.googleapis.com/opensea-static/opensea-profile/1.png",
                "address": "0x0000000000000000000000000000000000000000",
                "config": "",
                "discord_id": ""
            },
            "permalink": "https://opensea.io/assets/matic/0x2452d8049f04d54ca779257678a691ee4a413267/1737",
            "collection": {
                "banner_image_url": null,
                "chat_url": null,
                "created_date": "2021-04-28T21:18:36.536005",
                "default_to_fiat": false,
                "description": null,
                "dev_buyer_fee_basis_points": "0",
                "dev_seller_fee_basis_points": "0",
                "discord_url": null,
                "display_data": {
                    "card_display_style": "contain",
                    "images": []
                },
                "external_url": null,
                "featured": false,
                "featured_image_url": null,
                "hidden": true,
                "safelist_request_status": "not_requested",
                "image_url": null,
                "is_subject_to_whitelist": false,
                "large_image_url": null,
                "medium_username": null,
                "name": "MyGallery V3",
                "only_proxied_transfers": false,
                "opensea_buyer_fee_basis_points": "0",
                "opensea_seller_fee_basis_points": "250",
                "payout_address": null,
                "require_email": false,
                "short_description": null,
                "slug": "mygallery-v3",
                "telegram_url": null,
                "twitter_username": null,
                "instagram_username": null,
                "wiki_url": null
            },
            "decimals": null,
            "token_metadata": "https://ipfs.io/ipfs/QmPen4KG3fnyySRmdCZQk9XqHP9qXwnPrqNrZqFCBvXmKP",
            "sell_orders": null,
            "creator": null,
            "traits": [],
            "last_sale": null,
            "top_bid": null,
            "listing_date": null,
            "is_presale": false,
            "transfer_fee_payment_token": null,
            "transfer_fee": null
        },
        {
            "id": 25665487,
            "token_id": "111947432917840273637579905546902051336412020995403260629355602703326302437377",
            "num_sales": 0,
            "background_color": null,
            "image_url": "https://lh3.googleusercontent.com/G0dJj7UWTVj-WvkL6EevXkIZtSxkMNgrxPgnMfukT_J6YWj4C3lj9AEnXMcNWGCy6lAZOloXmMrHokyncJaju8ZJSLt0vP_hiOVV",
            "image_preview_url": "https://lh3.googleusercontent.com/G0dJj7UWTVj-WvkL6EevXkIZtSxkMNgrxPgnMfukT_J6YWj4C3lj9AEnXMcNWGCy6lAZOloXmMrHokyncJaju8ZJSLt0vP_hiOVV=s250",
            "image_thumbnail_url": "https://lh3.googleusercontent.com/G0dJj7UWTVj-WvkL6EevXkIZtSxkMNgrxPgnMfukT_J6YWj4C3lj9AEnXMcNWGCy6lAZOloXmMrHokyncJaju8ZJSLt0vP_hiOVV=s128",
            "image_original_url": null,
            "animation_url": null,
            "animation_original_url": null,
            "name": "Les mauvaises langues ♯2.",
            "description": "HORSCHAMPS is inspired by the current global health crisis, how humans are capable of dematerialising themselves and tend to a numeric humanisation as HOMO NUMERICUS.\n\nPublished on Art From Future. https://artfromfuture.com/",
            "external_link": "https://www.laurama.net/portfolio/nftart",
            "asset_contract": {
                "address": "0x495f947276749ce646f68ac8c248420045cb7b5e",
                "asset_contract_type": "semi-fungible",
                "created_date": "2020-12-02T17:40:53.232025",
                "name": "OpenSea Collection",
                "nft_version": null,
                "opensea_version": "2.0.0",
                "owner": 102384,
                "schema_name": "ERC1155",
                "symbol": "OPENSTORE",
                "total_supply": null,
                "description": null,
                "external_link": null,
                "image_url": null,
                "default_to_fiat": false,
                "dev_buyer_fee_basis_points": 0,
                "dev_seller_fee_basis_points": 0,
                "only_proxied_transfers": false,
                "opensea_buyer_fee_basis_points": 0,
                "opensea_seller_fee_basis_points": 250,
                "buyer_fee_basis_points": 0,
                "seller_fee_basis_points": 250,
                "payout_address": null
            },
            "owner": {
                "user": {
                    "username": "NullAddress"
                },
                "profile_img_url": "https://storage.googleapis.com/opensea-static/opensea-profile/1.png",
                "address": "0x0000000000000000000000000000000000000000",
                "config": "",
                "discord_id": ""
            },
            "permalink": "https://opensea.io/assets/0x495f947276749ce646f68ac8c248420045cb7b5e/111947432917840273637579905546902051336412020995403260629355602703326302437377",
            "collection": {
                "banner_image_url": "https://lh3.googleusercontent.com/ygylrd2Ow57P1qbffsdNParZe82YWzkrdE5bA4b7_drS2s2yLjG4Niz0ja642JIa-7EbdxkMIOW6igCFvHVEpNxyuWPyvy8ibLvZjjk=s2500",
                "chat_url": null,
                "created_date": "2021-05-25T14:18:07.104599",
                "default_to_fiat": false,
                "description": "HORSCHAMPS  is inspired by the current global health crisis, how humans are capable of dematerialising themselves and tend to a numeric humanisation as HOMO NUMERICUS. \nPublished on Art From Future.\nhttps://artfromfuture.com/",
                "dev_buyer_fee_basis_points": "0",
                "dev_seller_fee_basis_points": "1000",
                "discord_url": null,
                "display_data": {
                    "card_display_style": "contain"
                },
                "external_url": "https://www.laurama.net/",
                "featured": false,
                "featured_image_url": "https://lh3.googleusercontent.com/_pACuTQk02RsAv1RGqxpEgDAJGBHpN8bxNg8dQrTbsrDkCTB2qMKisKMrwsahwcokad1S9HNvli8ByWYYNjQ_UbOaaMP3GXNN1-3mF0=s300",
                "hidden": true,
                "safelist_request_status": "not_requested",
                "image_url": "https://lh3.googleusercontent.com/ZB1EYXHFq4pS4BjbR6iDrxcJV6QmBgeR2vLaMtda3zV4aI4u0BSmA-yIbHVESMohZ6sJ4Gb-5uKCbw5-1JeNyt1D4Y12NBjq9g1req4=s120",
                "is_subject_to_whitelist": false,
                "large_image_url": "https://lh3.googleusercontent.com/_pACuTQk02RsAv1RGqxpEgDAJGBHpN8bxNg8dQrTbsrDkCTB2qMKisKMrwsahwcokad1S9HNvli8ByWYYNjQ_UbOaaMP3GXNN1-3mF0=s300",
                "medium_username": null,
                "name": "HORSCHAMPS",
                "only_proxied_transfers": false,
                "opensea_buyer_fee_basis_points": "0",
                "opensea_seller_fee_basis_points": "250",
                "payout_address": "0xf780006b5340bb37f4c22b085d89d4864417afb9",
                "require_email": false,
                "short_description": null,
                "slug": "horschamps-1",
                "telegram_url": null,
                "twitter_username": "goldysucci",
                "instagram_username": "studiolaurama",
                "wiki_url": null
            },
            "decimals": null,
            "token_metadata": null,
            "sell_orders": [
                {
                    "created_date": "2021-05-25T22:50:40.385400",
                    "closing_date": null,
                    "closing_extendable": false,
                    "expiration_time": 0,
                    "listing_time": 1621982955,
                    "order_hash": "0x2147163dd93a2cd0b038963c8902f37703b26a9fa9e534a6f10b2631343befd4",
                    "metadata": {
                        "asset": {
                            "id": "111947432917840273637579905546902051336412020995403260629355602703326302437377",
                            "address": "0x495f947276749ce646f68ac8c248420045cb7b5e",
                            "quantity": "1"
                        },
                        "schema": "ERC1155"
                    },
                    "exchange": "0x7be8076f4ea4a4ad08075c2508e481d6c946d12b",
                    "maker": {
                        "user": 519054,
                        "profile_img_url": "https://storage.googleapis.com/opensea-static/opensea-profile/3.png",
                        "address": "0xf780006b5340bb37f4c22b085d89d4864417afb9",
                        "config": "",
                        "discord_id": ""
                    },
                    "taker": {
                        "user": 1766,
                        "profile_img_url": "https://storage.googleapis.com/opensea-static/opensea-profile/1.png",
                        "address": "0x0000000000000000000000000000000000000000",
                        "config": "",
                        "discord_id": ""
                    },
                    "current_price": "660000000000000000",
                    "current_bounty": "6600000000000000",
                    "bounty_multiple": "0.01",
                    "maker_relayer_fee": "1250",
                    "taker_relayer_fee": "0",
                    "maker_protocol_fee": "0",
                    "taker_protocol_fee": "0",
                    "maker_referrer_fee": "0",
                    "fee_recipient": {
                        "user": 3585,
                        "profile_img_url": "https://storage.googleapis.com/opensea-static/opensea-profile/28.png",
                        "address": "0x5b3256965e7c3cf26e11fcaf296dfc8807c01073",
                        "config": "verified",
                        "discord_id": ""
                    },
                    "fee_method": 1,
                    "side": 1,
                    "sale_kind": 0,
                    "target": "0x495f947276749ce646f68ac8c248420045cb7b5e",
                    "how_to_call": 0,
                    "calldata": "0xf242432a000000000000000000000000f780006b5340bb37f4c22b085d89d4864417afb90000000000000000000000000000000000000000000000000000000000000000f780006b5340bb37f4c22b085d89d4864417afb9000000000000130000000001000000000000000000000000000000000000000000000000000000000000000100000000000000000000000000000000000000000000000000000000000000a00000000000000000000000000000000000000000000000000000000000000000",
                    "replacement_pattern": "0x000000000000000000000000000000000000000000000000000000000000000000000000ffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffff0000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000",
                    "static_target": "0x0000000000000000000000000000000000000000",
                    "static_extradata": "0x",
                    "payment_token": "0xc02aaa39b223fe8d0a0e5c4f27ead9083c756cc2",
                    "payment_token_contract": {
                        "id": 2,
                        "symbol": "WETH",
                        "address": "0xc02aaa39b223fe8d0a0e5c4f27ead9083c756cc2",
                        "image_url": "https://storage.opensea.io/files/accae6b6fb3888cbff27a013729c22dc.svg",
                        "name": "Wrapped Ether",
                        "decimals": 18,
                        "eth_price": "1.000000000000000",
                        "usd_price": "2613.559999999999945000"
                    },
                    "base_price": "660000000000000000",
                    "extra": "0",
                    "quantity": "1",
                    "salt": "2301497611488048902619902908210161802772471097427285474939919055959981971410",
                    "v": 28,
                    "r": "0x9442eb68851e1f30aa435f16f1f58c1a5bc45dd573d8ae13274253d5c2a67fac",
                    "s": "0x0c08d448cbe93d41bb6fde8ab38b29b09a348711312d01d1ffb84a28521dd4e9",
                    "approved_on_chain": false,
                    "cancelled": false,
                    "finalized": false,
                    "marked_invalid": false,
                    "prefixed_hash": "0xf0fb6835ce138c4b25c505baac7794a28a7ead1b31a992fc6550f5a52db82720"
                }
            ],
            "creator": {
                "user": {
                    "username": "goldysucci"
                },
                "profile_img_url": "https://storage.googleapis.com/opensea-static/opensea-profile/3.png",
                "address": "0xf780006b5340bb37f4c22b085d89d4864417afb9",
                "config": "",
                "discord_id": ""
            },
            "traits": [],
            "last_sale": null,
            "top_bid": null,
            "listing_date": null,
            "is_presale": true,
            "transfer_fee_payment_token": null,
            "transfer_fee": null
        },
        {
            "id": 25665486,
            "token_id": "1397320045622173699",
            "num_sales": 0,
            "background_color": null,
            "image_url": "https://lh3.googleusercontent.com/V3GA9wBpmRirCV2YSjw5clo9bEuMEqL-ki4eY5ENjyRaV6UQ_UWLgHJN7OidSxgZsEzgeeHiGkt1vkgaiVsYWx2ZmR9_6wphkcwGEQ",
            "image_preview_url": "https://lh3.googleusercontent.com/V3GA9wBpmRirCV2YSjw5clo9bEuMEqL-ki4eY5ENjyRaV6UQ_UWLgHJN7OidSxgZsEzgeeHiGkt1vkgaiVsYWx2ZmR9_6wphkcwGEQ=s250",
            "image_thumbnail_url": "https://lh3.googleusercontent.com/V3GA9wBpmRirCV2YSjw5clo9bEuMEqL-ki4eY5ENjyRaV6UQ_UWLgHJN7OidSxgZsEzgeeHiGkt1vkgaiVsYWx2ZmR9_6wphkcwGEQ=s128",
            "image_original_url": "https://v.cent.co/data/tweet/media/1397320045622173699",
            "animation_url": null,
            "animation_original_url": null,
            "name": "@RoosBrews 2021-05-25 22:33:54",
            "description": "All because I have Hammocks with holes in them for sale🤷‍♂️💩 https://t.co/3spyU2myIb",
            "external_link": "https://twitter.com/RoosBrews/status/1397320045622173699",
            "asset_contract": {
                "address": "0x28009881f0ffe85c90725b8b02be55773647c64a",
                "asset_contract_type": "non-fungible",
                "created_date": "2021-01-04T17:17:19.596504",
                "name": "Tweets",
                "nft_version": null,
                "opensea_version": null,
                "owner": null,
                "schema_name": "ERC721",
                "symbol": "TWEET",
                "total_supply": "14175",
                "description": "",
                "external_link": "https://v.cent.co",
                "image_url": "https://lh3.googleusercontent.com/rJuONeLDI55n19fmZapz3zpzqKOIuM6qQsBDSEq3vyMBBdASPhlS2m8xc7XRT6YhFwRKHrfQOp4E9QUU34PwcD4S6CBXsjJ9TzAslg=s120",
                "default_to_fiat": false,
                "dev_buyer_fee_basis_points": 0,
                "dev_seller_fee_basis_points": 1000,
                "only_proxied_transfers": false,
                "opensea_buyer_fee_basis_points": 0,
                "opensea_seller_fee_basis_points": 250,
                "buyer_fee_basis_points": 0,
                "seller_fee_basis_points": 1250,
                "payout_address": "0x925ed2034a30d54333beab3593956bc0e6fc9c62"
            },
            "owner": {
                "user": null,
                "profile_img_url": "https://storage.googleapis.com/opensea-static/opensea-profile/1.png",
                "address": "0x0000000000000000000000000000000000000000",
                "config": "",
                "discord_id": ""
            },
            "permalink": "https://opensea.io/assets/matic/0x28009881f0ffe85c90725b8b02be55773647c64a/1397320045622173699",
            "collection": {
                "banner_image_url": null,
                "chat_url": null,
                "created_date": "2021-01-04T17:17:19.729052",
                "default_to_fiat": false,
                "description": "",
                "dev_buyer_fee_basis_points": "0",
                "dev_seller_fee_basis_points": "1000",
                "discord_url": "https://discord.gg/6RCYJPAHJs",
                "display_data": {
                    "card_display_style": "contain"
                },
                "external_url": "https://v.cent.co",
                "featured": false,
                "featured_image_url": null,
                "hidden": false,
                "safelist_request_status": "verified",
                "image_url": "https://lh3.googleusercontent.com/rJuONeLDI55n19fmZapz3zpzqKOIuM6qQsBDSEq3vyMBBdASPhlS2m8xc7XRT6YhFwRKHrfQOp4E9QUU34PwcD4S6CBXsjJ9TzAslg=s120",
                "is_subject_to_whitelist": false,
                "large_image_url": null,
                "medium_username": null,
                "name": "Tweets",
                "only_proxied_transfers": false,
                "opensea_buyer_fee_basis_points": "0",
                "opensea_seller_fee_basis_points": "250",
                "payout_address": "0x925ed2034a30d54333beab3593956bc0e6fc9c62",
                "require_email": false,
                "short_description": null,
                "slug": "tweets",
                "telegram_url": null,
                "twitter_username": "Cent",
                "instagram_username": null,
                "wiki_url": null
            },
            "decimals": null,
            "token_metadata": "https://v.cent.co/data/token?m=eyJuYW1lIjoiQFJvb3NCcmV3cyAyMDIxLTA1LTI1IDIyOjMzOjU0IiwiZGVzY3JpcHRpb24iOiJBbGwgYmVjYXVzZSBJIGhhdmUgSGFtbW9ja3Mgd2l0aCBob2xlcyBpbiB0aGVtIGZvciBzYWxl8J+kt+KAjeKZgu+4j/CfkqkgaHR0cHM6Ly90LmNvLzNzcHlVMm15SWIiLCJhdHRyaWJ1dGVzIjp7ImlkIjoiMTM5NzMyMDA0NTYyMjE3MzY5OSIsImF1dGhvciI6IkBSb29zQnJld3MiLCJhdXRob3JfaWQiOiI4NTg5MzkxMjIiLCJ0aW1lc3RhbXAiOiIxNjIxOTgyMDM0IiwibWVzc2FnZSI6IlNpZ25lZCBvbiBWYWx1YWJsZXM6XG5cbkBSb29zQnJld3MgMjAyMS0wNS0yNSAyMjozMzo1NFxuQWxsIGJlY2F1c2UgSSBoYXZlIEhhbW1vY2tzIHdpdGggaG9sZXMgaW4gdGhlbSBmb3Igc2FsZfCfpLfigI3imYLvuI/wn5KpIGh0dHBzOi8vdC5jby8zc3B5VTJteUliIiwic2lnbmVyIjoiMHgxQ0ZCMzNjRjc5QmYwRTY5NjFhNkQwOTc5YjZlZTdhNTlBMTAxQ2FGIiwic2lnbmF0dXJlIjoiMHhlNDlmYWNhNGNiNzQxOGQwZjk1NDUzMmE4MzE5NDI4M2Q3NGZlMmNjM2ZkYWExZWU4Mjk1OWYwOGQ3M2ZmZDQ2NWI3NjdmMWE4ODM5MGExNjJmZjY0ZTlhYmY2OTIxOTQzMGEwZTg0ODU5ZTYzMzBmYjBhMzY4MTZjYjM5ODExOTFjIn0sImV4dGVybmFsX3VybCI6Imh0dHBzOi8vdHdpdHRlci5jb20vUm9vc0JyZXdzL3N0YXR1cy8xMzk3MzIwMDQ1NjIyMTczNjk5IiwiaW1hZ2UiOiJodHRwczovL3YuY2VudC5jby9kYXRhL3R3ZWV0L21lZGlhLzEzOTczMjAwNDU2MjIxNzM2OTkifQ==",
            "sell_orders": null,
            "creator": null,
            "traits": [
                {
                    "trait_type": "timestamp",
                    "value": "1621982034",
                    "display_type": null,
                    "max_value": null,
                    "trait_count": 0,
                    "order": null
                },
                {
                    "trait_type": "message",
                    "value": "Signed on Valuables:\n\n@RoosBrews 2021-05-25 22:33:54\nAll because I have Hammocks with holes in them for sale🤷‍♂️💩 https://t.co/3spyU2myIb",
                    "display_type": null,
                    "max_value": null,
                    "trait_count": 0,
                    "order": null
                },
                {
                    "trait_type": "signature",
                    "value": "0xe49faca4cb7418d0f954532a83194283d74fe2cc3fdaa1ee82959f08d73ffd465b767f1a88390a162ff64e9abf69219430a0e84859e6330fb0a36816cb3981191c",
                    "display_type": null,
                    "max_value": null,
                    "trait_count": 0,
                    "order": null
                },
                {
                    "trait_type": "author",
                    "value": "@RoosBrews",
                    "display_type": null,
                    "max_value": null,
                    "trait_count": 1,
                    "order": null
                },
                {
                    "trait_type": "author_id",
                    "value": "858939122",
                    "display_type": null,
                    "max_value": null,
                    "trait_count": 1,
                    "order": null
                },
                {
                    "trait_type": "signer",
                    "value": "0x1CFB33cF79Bf0E6961a6D0979b6ee7a59A101CaF",
                    "display_type": null,
                    "max_value": null,
                    "trait_count": 1,
                    "order": null
                },
                {
                    "trait_type": "id",
                    "value": "1397320045622173699",
                    "display_type": null,
                    "max_value": null,
                    "trait_count": 0,
                    "order": null
                }
            ],
            "last_sale": null,
            "top_bid": null,
            "listing_date": null,
            "is_presale": false,
            "transfer_fee_payment_token": null,
            "transfer_fee": null
        },
        {
            "id": 25665485,
            "token_id": "20779687020901315104817932847033512423599216699667133632923091507559637450753",
            "num_sales": 0,
            "background_color": null,
            "image_url": "https://lh3.googleusercontent.com/RZJQOHtWDsa17j205lJhEXzPfqSbRxvWZlb0Fi0ejyeW-v08ADzz94zN7emxXGYU63xHh-JaH-XGY4uKlveU2xCxpKgf37W0YMt6Dw",
            "image_preview_url": "https://lh3.googleusercontent.com/RZJQOHtWDsa17j205lJhEXzPfqSbRxvWZlb0Fi0ejyeW-v08ADzz94zN7emxXGYU63xHh-JaH-XGY4uKlveU2xCxpKgf37W0YMt6Dw=s250",
            "image_thumbnail_url": "https://lh3.googleusercontent.com/RZJQOHtWDsa17j205lJhEXzPfqSbRxvWZlb0Fi0ejyeW-v08ADzz94zN7emxXGYU63xHh-JaH-XGY4uKlveU2xCxpKgf37W0YMt6Dw=s128",
            "image_original_url": null,
            "animation_url": "https://storage.opensea.io/files/efcf46d57cfeb3197ed3ab8e4cf9773a.mp4",
            "animation_original_url": "https://storage.opensea.io/files/efcf46d57cfeb3197ed3ab8e4cf9773a.mp4",
            "name": "Cublitz #1684",
            "description": null,
            "external_link": null,
            "asset_contract": {
                "address": "0x495f947276749ce646f68ac8c248420045cb7b5e",
                "asset_contract_type": "semi-fungible",
                "created_date": "2020-12-02T17:40:53.232025",
                "name": "OpenSea Collection",
                "nft_version": null,
                "opensea_version": "2.0.0",
                "owner": 102384,
                "schema_name": "ERC1155",
                "symbol": "OPENSTORE",
                "total_supply": null,
                "description": null,
                "external_link": null,
                "image_url": null,
                "default_to_fiat": false,
                "dev_buyer_fee_basis_points": 0,
                "dev_seller_fee_basis_points": 0,
                "only_proxied_transfers": false,
                "opensea_buyer_fee_basis_points": 0,
                "opensea_seller_fee_basis_points": 250,
                "buyer_fee_basis_points": 0,
                "seller_fee_basis_points": 250,
                "payout_address": null
            },
            "owner": {
                "user": {
                    "username": "NullAddress"
                },
                "profile_img_url": "https://storage.googleapis.com/opensea-static/opensea-profile/1.png",
                "address": "0x0000000000000000000000000000000000000000",
                "config": "",
                "discord_id": ""
            },
            "permalink": "https://opensea.io/assets/0x495f947276749ce646f68ac8c248420045cb7b5e/20779687020901315104817932847033512423599216699667133632923091507559637450753",
            "collection": {
                "banner_image_url": "https://lh3.googleusercontent.com/gFpU2HWWO4G53qKLkonFjlhLvkOyrnuC_PFMLHghOQwr6ZbL4YTQGwYQFjG703JYfreeicn_Q9qtFIGvOqT_3qq0J1m_NYYM8DlO0yY=s2500",
                "chat_url": null,
                "created_date": "2021-05-15T17:29:16.297787",
                "default_to_fiat": false,
                "description": "10,000 randomly generated animated NFT's. 3D rendered dancing blockheads with over 15 million possible combinations of species, professions, colors, and accessories.",
                "dev_buyer_fee_basis_points": "0",
                "dev_seller_fee_basis_points": "500",
                "discord_url": "https://discord.gg/gY4fQwR59E",
                "display_data": {
                    "card_display_style": "contain"
                },
                "external_url": null,
                "featured": false,
                "featured_image_url": "https://lh3.googleusercontent.com/DUQIBKJCZqkIueysZ-vf8Xh1bqTDin3rSBWz87slZ0Ttqg7cJtcmizTpGBJQKB230YJjbHkenjkNICcXsME9jy6FNUPECQsbntECLA=s300",
                "hidden": true,
                "safelist_request_status": "not_requested",
                "image_url": "https://lh3.googleusercontent.com/JKzgo-XGir844sKoqbj3wca19WSGfTca54E2txRIk4XUVUCd-bnY0bVlmBS7IYr5_fs-3T2rPlnKQIKJQgWSKBrKuEmitX8zBGl0Cg=s120",
                "is_subject_to_whitelist": false,
                "large_image_url": "https://lh3.googleusercontent.com/DUQIBKJCZqkIueysZ-vf8Xh1bqTDin3rSBWz87slZ0Ttqg7cJtcmizTpGBJQKB230YJjbHkenjkNICcXsME9jy6FNUPECQsbntECLA=s300",
                "medium_username": null,
                "name": "Cublitz",
                "only_proxied_transfers": false,
                "opensea_buyer_fee_basis_points": "0",
                "opensea_seller_fee_basis_points": "250",
                "payout_address": "0x2df0e2d512a76fbc761a7df0811ecb2f3556a8a4",
                "require_email": false,
                "short_description": null,
                "slug": "cublitz",
                "telegram_url": null,
                "twitter_username": "cublitz",
                "instagram_username": null,
                "wiki_url": null
            },
            "decimals": null,
            "token_metadata": null,
            "sell_orders": null,
            "creator": {
                "user": {
                    "username": "DedRedArt"
                },
                "profile_img_url": "https://storage.googleapis.com/opensea-static/opensea-profile/30.png",
                "address": "0x2df0e2d512a76fbc761a7df0811ecb2f3556a8a4",
                "config": "",
                "discord_id": ""
            },
            "traits": [
                {
                    "trait_type": "Class",
                    "value": "Knight",
                    "display_type": null,
                    "max_value": null,
                    "trait_count": 196,
                    "order": null
                },
                {
                    "trait_type": "Background",
                    "value": "Red",
                    "display_type": null,
                    "max_value": null,
                    "trait_count": 185,
                    "order": null
                },
                {
                    "trait_type": "Race Color",
                    "value": "Color 1",
                    "display_type": null,
                    "max_value": null,
                    "trait_count": 1468,
                    "order": null
                },
                {
                    "trait_type": "Class Color",
                    "value": "Color 1",
                    "display_type": null,
                    "max_value": null,
                    "trait_count": 1198,
                    "order": null
                },
                {
                    "trait_type": "Race",
                    "value": "Goblin",
                    "display_type": null,
                    "max_value": null,
                    "trait_count": 67,
                    "order": null
                },
                {
                    "trait_type": "Eyes",
                    "value": "Dot",
                    "display_type": null,
                    "max_value": null,
                    "trait_count": 42,
                    "order": null
                }
            ],
            "last_sale": null,
            "top_bid": null,
            "listing_date": null,
            "is_presale": true,
            "transfer_fee_payment_token": null,
            "transfer_fee": null
        },
        {
            "id": 25665484,
            "token_id": "82929854535027773191997849200963293268345242110903440991364488639076202708993",
            "num_sales": 0,
            "background_color": null,
            "image_url": "https://lh3.googleusercontent.com/S4EJ1lEyoMu31cMmdt24N9PdqWreqcAVmd6YOV_VsIT7b6FAEC-f7ef9Q_KvRBP9GlAWpEqxGoHPG77BY_m32XwdNChm3XvhCXyl",
            "image_preview_url": "https://lh3.googleusercontent.com/S4EJ1lEyoMu31cMmdt24N9PdqWreqcAVmd6YOV_VsIT7b6FAEC-f7ef9Q_KvRBP9GlAWpEqxGoHPG77BY_m32XwdNChm3XvhCXyl=s250",
            "image_thumbnail_url": "https://lh3.googleusercontent.com/S4EJ1lEyoMu31cMmdt24N9PdqWreqcAVmd6YOV_VsIT7b6FAEC-f7ef9Q_KvRBP9GlAWpEqxGoHPG77BY_m32XwdNChm3XvhCXyl=s128",
            "image_original_url": null,
            "animation_url": null,
            "animation_original_url": null,
            "name": "Windmills at Kinderdijk #1",
            "description": "Windmills at Kinderdijk\n\nI would try to describe this picture if I thought my words would be adequate.\n\nLimited Edition 1 of 3\n",
            "external_link": null,
            "asset_contract": {
                "address": "0x495f947276749ce646f68ac8c248420045cb7b5e",
                "asset_contract_type": "semi-fungible",
                "created_date": "2020-12-02T17:40:53.232025",
                "name": "OpenSea Collection",
                "nft_version": null,
                "opensea_version": "2.0.0",
                "owner": 102384,
                "schema_name": "ERC1155",
                "symbol": "OPENSTORE",
                "total_supply": null,
                "description": null,
                "external_link": null,
                "image_url": null,
                "default_to_fiat": false,
                "dev_buyer_fee_basis_points": 0,
                "dev_seller_fee_basis_points": 0,
                "only_proxied_transfers": false,
                "opensea_buyer_fee_basis_points": 0,
                "opensea_seller_fee_basis_points": 250,
                "buyer_fee_basis_points": 0,
                "seller_fee_basis_points": 250,
                "payout_address": null
            },
            "owner": {
                "user": {
                    "username": "NullAddress"
                },
                "profile_img_url": "https://storage.googleapis.com/opensea-static/opensea-profile/1.png",
                "address": "0x0000000000000000000000000000000000000000",
                "config": "",
                "discord_id": ""
            },
            "permalink": "https://opensea.io/assets/0x495f947276749ce646f68ac8c248420045cb7b5e/82929854535027773191997849200963293268345242110903440991364488639076202708993",
            "collection": {
                "banner_image_url": "https://lh3.googleusercontent.com/S4EJ1lEyoMu31cMmdt24N9PdqWreqcAVmd6YOV_VsIT7b6FAEC-f7ef9Q_KvRBP9GlAWpEqxGoHPG77BY_m32XwdNChm3XvhCXyl=s2500",
                "chat_url": null,
                "created_date": "2021-05-25T16:40:13.290502",
                "default_to_fiat": false,
                "description": "Holistic art and photography.\n\nThe Debut Collection",
                "dev_buyer_fee_basis_points": "0",
                "dev_seller_fee_basis_points": "10",
                "discord_url": null,
                "display_data": {
                    "card_display_style": "contain"
                },
                "external_url": null,
                "featured": false,
                "featured_image_url": "https://lh3.googleusercontent.com/w3TehIlS-rscYjaeEIfwfdXT638axIHybBa4ou5aFB4GGkUoiW-ZD3ho9pfDN-1BIYaYOey0yMlAmOxgRCpbFASETtPozvCzzG_ffA=s300",
                "hidden": true,
                "safelist_request_status": "not_requested",
                "image_url": "https://lh3.googleusercontent.com/-Gb7kcvLyP-0tsiRI-3xR1T2T6Fm1y-CJFxAwOGPAM4iMDwVe_aH5dQTmESTMTyXiQYuRk-XL2DgN1wJTyO4j6gDbE3lktbPAqzk6g=s120",
                "is_subject_to_whitelist": false,
                "large_image_url": "https://lh3.googleusercontent.com/w3TehIlS-rscYjaeEIfwfdXT638axIHybBa4ou5aFB4GGkUoiW-ZD3ho9pfDN-1BIYaYOey0yMlAmOxgRCpbFASETtPozvCzzG_ffA=s300",
                "medium_username": null,
                "name": "LazyPotato",
                "only_proxied_transfers": false,
                "opensea_buyer_fee_basis_points": "0",
                "opensea_seller_fee_basis_points": "250",
                "payout_address": "0xb758a2612b5c9811ef6db1b202ab0dad55134558",
                "require_email": false,
                "short_description": null,
                "slug": "lazypotato",
                "telegram_url": null,
                "twitter_username": null,
                "instagram_username": null,
                "wiki_url": null
            },
            "decimals": null,
            "token_metadata": null,
            "sell_orders": null,
            "creator": {
                "user": {
                    "username": "LazyPotato"
                },
                "profile_img_url": "https://storage.googleapis.com/opensea-static/opensea-profile/19.png",
                "address": "0xb758a2612b5c9811ef6db1b202ab0dad55134558",
                "config": "",
                "discord_id": ""
            },
            "traits": [],
            "last_sale": null,
            "top_bid": null,
            "listing_date": null,
            "is_presale": true,
            "transfer_fee_payment_token": null,
            "transfer_fee": null
        },
        {
            "id": 25665483,
            "token_id": "23294",
            "num_sales": 0,
            "background_color": null,
            "image_url": "https://storage.opensea.io/files/c912737fc8b8d79af7cd1e69303f2fff.svg",
            "image_preview_url": "https://storage.opensea.io/files/c912737fc8b8d79af7cd1e69303f2fff.svg",
            "image_thumbnail_url": "https://storage.opensea.io/files/c912737fc8b8d79af7cd1e69303f2fff.svg",
            "image_original_url": null,
            "animation_url": null,
            "animation_original_url": null,
            "name": "Uniswap - 0.3% - WETH/WBTC - 9.5533<>24.949",
            "description": "This NFT represents a liquidity position in a Uniswap V3 WETH-WBTC pool. The owner of this NFT can modify or redeem the position.\n\nPool Address: 0xcbcdf9626bc03e24f779434178a73a0b4bad62ed\nWETH Address: 0xc02aaa39b223fe8d0a0e5c4f27ead9083c756cc2\nWBTC Address: 0x2260fac5e5542a773aa44fbcfedf7c193bc2c599\nFee Tier: 0.3%\nToken ID: 23294\n\n⚠️ DISCLAIMER: Due diligence is imperative when assessing this NFT. Make sure token addresses match the expected tokens, as token symbols may be imitated.",
            "external_link": null,
            "asset_contract": {
                "address": "0xc36442b4a4522e871399cd717abdd847ab11fe88",
                "asset_contract_type": "non-fungible",
                "created_date": "2021-05-04T19:53:14.975423",
                "name": "Uniswap V3 Positions NFT-V1",
                "nft_version": "unsupported",
                "opensea_version": null,
                "owner": null,
                "schema_name": "ERC721",
                "symbol": "UNI-V3-POS",
                "total_supply": "1",
                "description": "",
                "external_link": "https://uniswap.org/",
                "image_url": "https://lh3.googleusercontent.com/8My7rmWHJCAi35QSp2IMf50NRNIRJelpEdassqIxiL6Q_m2SE2qG7QKIT_1wfXH2afDcACiWVGrt2jkfHqHKlElttUTdL6dmC9G0Mpk=s120",
                "default_to_fiat": false,
                "dev_buyer_fee_basis_points": 0,
                "dev_seller_fee_basis_points": 0,
                "only_proxied_transfers": false,
                "opensea_buyer_fee_basis_points": 0,
                "opensea_seller_fee_basis_points": 250,
                "buyer_fee_basis_points": 0,
                "seller_fee_basis_points": 250,
                "payout_address": null
            },
            "owner": {
                "user": null,
                "profile_img_url": "https://storage.googleapis.com/opensea-static/opensea-profile/28.png",
                "address": "0x30d53bb9b353f382290d2adea92ddf4dfb6694e6",
                "config": "",
                "discord_id": ""
            },
            "permalink": "https://opensea.io/assets/0xc36442b4a4522e871399cd717abdd847ab11fe88/23294",
            "collection": {
                "banner_image_url": "https://lh3.googleusercontent.com/Xq98abLTjlFfzdIxsXNL0sVE2W-3FGcJ2TFUkphz9dh9wEH4rcUesMhE7RzEh_ivPCdL5KxkNVfyE5gb870OgqOLQnBP6sIL54-G0A=s2500",
                "chat_url": null,
                "created_date": "2021-05-04T19:53:16.930034",
                "default_to_fiat": false,
                "description": "",
                "dev_buyer_fee_basis_points": "0",
                "dev_seller_fee_basis_points": "0",
                "discord_url": "https://discord.gg/FCfyBSbCU5",
                "display_data": {
                    "card_display_style": "contain"
                },
                "external_url": "https://uniswap.org/",
                "featured": false,
                "featured_image_url": "https://lh3.googleusercontent.com/cnVFmcBCIreYJxfaZ2ba62kEdC9ocuP7vawwcfZx9QIOVNlisuJTV2f19D48hg2NSUxPFX6peemTKaYshJvs-vIcy_3Kv3nCiF7t9g=s300",
                "hidden": false,
                "safelist_request_status": "verified",
                "image_url": "https://lh3.googleusercontent.com/8My7rmWHJCAi35QSp2IMf50NRNIRJelpEdassqIxiL6Q_m2SE2qG7QKIT_1wfXH2afDcACiWVGrt2jkfHqHKlElttUTdL6dmC9G0Mpk=s120",
                "is_subject_to_whitelist": false,
                "large_image_url": "https://lh3.googleusercontent.com/cnVFmcBCIreYJxfaZ2ba62kEdC9ocuP7vawwcfZx9QIOVNlisuJTV2f19D48hg2NSUxPFX6peemTKaYshJvs-vIcy_3Kv3nCiF7t9g=s300",
                "medium_username": null,
                "name": "Uniswap V3 Positions",
                "only_proxied_transfers": false,
                "opensea_buyer_fee_basis_points": "0",
                "opensea_seller_fee_basis_points": "250",
                "payout_address": null,
                "require_email": false,
                "short_description": null,
                "slug": "uniswap-v3-positions",
                "telegram_url": null,
                "twitter_username": "@Uniswap",
                "instagram_username": null,
                "wiki_url": null
            },
            "decimals": null,
            "token_metadata": null,
            "sell_orders": null,
            "creator": {
                "user": null,
                "profile_img_url": "https://storage.googleapis.com/opensea-static/opensea-profile/28.png",
                "address": "0x30d53bb9b353f382290d2adea92ddf4dfb6694e6",
                "config": "",
                "discord_id": ""
            },
            "traits": [],
            "last_sale": null,
            "top_bid": null,
            "listing_date": null,
            "is_presale": false,
            "transfer_fee_payment_token": null,
            "transfer_fee": null
        },
        {
            "id": 25665482,
            "token_id": "101252083778151641423831800880398356849809162001436389574999047516655986933761",
            "num_sales": 0,
            "background_color": null,
            "image_url": "https://lh3.googleusercontent.com/iKLBNuoROTTjLGLs6B4kB_GnpgNZO0Bp6Ta11VdLJWX4azx9WstgnU2K4iCZIBZgGb-Sr2ZonH4vmYmS2JnlJjESjuT8_DVeSMlU8A",
            "image_preview_url": "https://lh3.googleusercontent.com/iKLBNuoROTTjLGLs6B4kB_GnpgNZO0Bp6Ta11VdLJWX4azx9WstgnU2K4iCZIBZgGb-Sr2ZonH4vmYmS2JnlJjESjuT8_DVeSMlU8A=s250",
            "image_thumbnail_url": "https://lh3.googleusercontent.com/iKLBNuoROTTjLGLs6B4kB_GnpgNZO0Bp6Ta11VdLJWX4azx9WstgnU2K4iCZIBZgGb-Sr2ZonH4vmYmS2JnlJjESjuT8_DVeSMlU8A=s128",
            "image_original_url": null,
            "animation_url": null,
            "animation_original_url": null,
            "name": "Crast - Cryptoneum #00041",
            "description": "There will be a unique Space Gang member card whenever a new planet is visited . Intergalactic travel will distract and slow down Space Mercenaries.",
            "external_link": null,
            "asset_contract": {
                "address": "0x495f947276749ce646f68ac8c248420045cb7b5e",
                "asset_contract_type": "semi-fungible",
                "created_date": "2020-12-02T17:40:53.232025",
                "name": "OpenSea Collection",
                "nft_version": null,
                "opensea_version": "2.0.0",
                "owner": 102384,
                "schema_name": "ERC1155",
                "symbol": "OPENSTORE",
                "total_supply": null,
                "description": null,
                "external_link": null,
                "image_url": null,
                "default_to_fiat": false,
                "dev_buyer_fee_basis_points": 0,
                "dev_seller_fee_basis_points": 0,
                "only_proxied_transfers": false,
                "opensea_buyer_fee_basis_points": 0,
                "opensea_seller_fee_basis_points": 250,
                "buyer_fee_basis_points": 0,
                "seller_fee_basis_points": 250,
                "payout_address": null
            },
            "owner": {
                "user": {
                    "username": "NullAddress"
                },
                "profile_img_url": "https://storage.googleapis.com/opensea-static/opensea-profile/1.png",
                "address": "0x0000000000000000000000000000000000000000",
                "config": "",
                "discord_id": ""
            },
            "permalink": "https://opensea.io/assets/0x495f947276749ce646f68ac8c248420045cb7b5e/101252083778151641423831800880398356849809162001436389574999047516655986933761",
            "collection": {
                "banner_image_url": "https://lh3.googleusercontent.com/q_6CD6ksFrUzlPO_3mMnJbcf5_JjNNmMGLU9HTxnnAerviTL3Fpj6fdJXGpOZymMD0hioSybKHDhJfPGVVNuDbFS1lsgNWWcDC1MjQ=s2500",
                "chat_url": null,
                "created_date": "2021-05-20T21:29:24.229752",
                "default_to_fiat": false,
                "description": "60 Space Gang members, 14 Space Mercenaries, 5 Evil Board members and God knows how many planets and galaxies this space hunt will impact. Join the FusionOps community and help saving our brave Space Gang.",
                "dev_buyer_fee_basis_points": "0",
                "dev_seller_fee_basis_points": "1000",
                "discord_url": null,
                "display_data": {
                    "card_display_style": "contain"
                },
                "external_url": null,
                "featured": false,
                "featured_image_url": "https://lh3.googleusercontent.com/Rnqw0Y8SY5CykHv0icv-Rlgf88t7i3PTsOdCr184yn_BFCRO6W7LKL_Om_h8lB9u7oNG0tSK1w7TNB0H6OS2Tp8y5dVqaISvZZ4rDw=s300",
                "hidden": true,
                "safelist_request_status": "not_requested",
                "image_url": "https://lh3.googleusercontent.com/lyfsf6monb3FSa9ELmisAovb8cGTqJTJs6iqx4SHjhVY4kCEIgl-0ZuP4dV59NAyRvyZHhW92Xx4aawH0z08KQcwmjMVAecr0Hql=s120",
                "is_subject_to_whitelist": false,
                "large_image_url": "https://lh3.googleusercontent.com/Rnqw0Y8SY5CykHv0icv-Rlgf88t7i3PTsOdCr184yn_BFCRO6W7LKL_Om_h8lB9u7oNG0tSK1w7TNB0H6OS2Tp8y5dVqaISvZZ4rDw=s300",
                "medium_username": null,
                "name": "FusionOps",
                "only_proxied_transfers": false,
                "opensea_buyer_fee_basis_points": "0",
                "opensea_seller_fee_basis_points": "250",
                "payout_address": "0xdfdaa60732c9219166c2e3c824edcf47c8d9d2a1",
                "require_email": false,
                "short_description": null,
                "slug": "fusionops",
                "telegram_url": null,
                "twitter_username": "SpaceGangClub",
                "instagram_username": null,
                "wiki_url": null
            },
            "decimals": null,
            "token_metadata": null,
            "sell_orders": null,
            "creator": {
                "user": {
                    "username": "Born_InSpace"
                },
                "profile_img_url": "https://storage.googleapis.com/opensea-static/opensea-profile/25.png",
                "address": "0xdfdaa60732c9219166c2e3c824edcf47c8d9d2a1",
                "config": "",
                "discord_id": ""
            },
            "traits": [
                {
                    "trait_type": "Planet",
                    "value": "Cryptoneum",
                    "display_type": null,
                    "max_value": null,
                    "trait_count": 26,
                    "order": null
                },
                {
                    "trait_type": "Set",
                    "value": "Space Gang",
                    "display_type": null,
                    "max_value": null,
                    "trait_count": 26,
                    "order": null
                },
                {
                    "trait_type": "Rank",
                    "value": "Member",
                    "display_type": null,
                    "max_value": null,
                    "trait_count": 21,
                    "order": null
                },
                {
                    "trait_type": "Name",
                    "value": "Crast",
                    "display_type": null,
                    "max_value": null,
                    "trait_count": 0,
                    "order": null
                }
            ],
            "last_sale": null,
            "top_bid": null,
            "listing_date": null,
            "is_presale": true,
            "transfer_fee_payment_token": null,
            "transfer_fee": null
        },
        {
            "id": 25665481,
            "token_id": "319228749994134296502770487353647450375700795558379806399582914023954317313",
            "num_sales": 0,
            "background_color": null,
            "image_url": "https://lh3.googleusercontent.com/Ijoa3GCPptKGXH22IrIp3bccpgjSMk6a9WeYEB8nGdBqNhUYGThZiNoLNA8XVa3sbFqGQk6tIedVe-gZyU95iAiFF-3GcJQVovJy",
            "image_preview_url": "https://lh3.googleusercontent.com/Ijoa3GCPptKGXH22IrIp3bccpgjSMk6a9WeYEB8nGdBqNhUYGThZiNoLNA8XVa3sbFqGQk6tIedVe-gZyU95iAiFF-3GcJQVovJy=s250",
            "image_thumbnail_url": "https://lh3.googleusercontent.com/Ijoa3GCPptKGXH22IrIp3bccpgjSMk6a9WeYEB8nGdBqNhUYGThZiNoLNA8XVa3sbFqGQk6tIedVe-gZyU95iAiFF-3GcJQVovJy=s128",
            "image_original_url": null,
            "animation_url": null,
            "animation_original_url": null,
            "name": "INVEST",
            "description": "This is the 1st verifiable instance of the word INVEST being made into an NFT.",
            "external_link": "https://RareNFTnames.com/",
            "asset_contract": {
                "address": "0x495f947276749ce646f68ac8c248420045cb7b5e",
                "asset_contract_type": "semi-fungible",
                "created_date": "2020-12-02T17:40:53.232025",
                "name": "OpenSea Collection",
                "nft_version": null,
                "opensea_version": "2.0.0",
                "owner": 102384,
                "schema_name": "ERC1155",
                "symbol": "OPENSTORE",
                "total_supply": null,
                "description": null,
                "external_link": null,
                "image_url": null,
                "default_to_fiat": false,
                "dev_buyer_fee_basis_points": 0,
                "dev_seller_fee_basis_points": 0,
                "only_proxied_transfers": false,
                "opensea_buyer_fee_basis_points": 0,
                "opensea_seller_fee_basis_points": 250,
                "buyer_fee_basis_points": 0,
                "seller_fee_basis_points": 250,
                "payout_address": null
            },
            "owner": {
                "user": {
                    "username": "NullAddress"
                },
                "profile_img_url": "https://storage.googleapis.com/opensea-static/opensea-profile/1.png",
                "address": "0x0000000000000000000000000000000000000000",
                "config": "",
                "discord_id": ""
            },
            "permalink": "https://opensea.io/assets/0x495f947276749ce646f68ac8c248420045cb7b5e/319228749994134296502770487353647450375700795558379806399582914023954317313",
            "collection": {
                "banner_image_url": null,
                "chat_url": null,
                "created_date": "2021-05-10T19:23:23.998003",
                "default_to_fiat": false,
                "description": "Coming Soon",
                "dev_buyer_fee_basis_points": "0",
                "dev_seller_fee_basis_points": "0",
                "discord_url": null,
                "display_data": {
                    "card_display_style": "padded"
                },
                "external_url": null,
                "featured": false,
                "featured_image_url": null,
                "hidden": true,
                "safelist_request_status": "not_requested",
                "image_url": "https://lh3.googleusercontent.com/9OQ7lx1ygjnIPh_w-mrFHLSB9Ww7PvfD8ZWIdQ0nhOl-QGokmLQ5Fl6RZ0NOAbEfOQrdiuKyHX9QAyz0fBVfvxAdYIjjBvAhdhnv6g=s120",
                "is_subject_to_whitelist": false,
                "large_image_url": null,
                "medium_username": null,
                "name": "1st NFT Names, Numbers & Words",
                "only_proxied_transfers": false,
                "opensea_buyer_fee_basis_points": "0",
                "opensea_seller_fee_basis_points": "250",
                "payout_address": null,
                "require_email": false,
                "short_description": null,
                "slug": "1st-nft-names-number-words",
                "telegram_url": null,
                "twitter_username": null,
                "instagram_username": null,
                "wiki_url": null
            },
            "decimals": null,
            "token_metadata": null,
            "sell_orders": null,
            "creator": {
                "user": {
                    "username": "Pippies"
                },
                "profile_img_url": "https://storage.googleapis.com/opensea-static/opensea-profile/18.png",
                "address": "0x00b4ad546df6a94200ec3a5d3eff6659b0e9595d",
                "config": "",
                "discord_id": ""
            },
            "traits": [
                {
                    "trait_type": "created",
                    "value": "25th May 2021",
                    "display_type": null,
                    "max_value": null,
                    "trait_count": 48,
                    "order": null
                }
            ],
            "last_sale": null,
            "top_bid": null,
            "listing_date": null,
            "is_presale": true,
            "transfer_fee_payment_token": null,
            "transfer_fee": null
        },
        {
            "id": 25665480,
            "token_id": "20779687020901315104817932847033512423599216699667133632923091506460125822977",
            "num_sales": 0,
            "background_color": null,
            "image_url": "https://lh3.googleusercontent.com/UcKWIeofxF4qPqpRkFulnUgod_tpQ8u_YSeu7MutihPuZrsiJq7F4QobHBsFESilpgq3K22MxCVZWESHEASx4CIkFRwoSng_uPW4sQ",
            "image_preview_url": "https://lh3.googleusercontent.com/UcKWIeofxF4qPqpRkFulnUgod_tpQ8u_YSeu7MutihPuZrsiJq7F4QobHBsFESilpgq3K22MxCVZWESHEASx4CIkFRwoSng_uPW4sQ=s250",
            "image_thumbnail_url": "https://lh3.googleusercontent.com/UcKWIeofxF4qPqpRkFulnUgod_tpQ8u_YSeu7MutihPuZrsiJq7F4QobHBsFESilpgq3K22MxCVZWESHEASx4CIkFRwoSng_uPW4sQ=s128",
            "image_original_url": null,
            "animation_url": "https://storage.opensea.io/files/6c55b4297ae1e4add09d44ccb70fa3c7.mp4",
            "animation_original_url": "https://storage.opensea.io/files/6c55b4297ae1e4add09d44ccb70fa3c7.mp4",
            "name": "Cublitz #1683",
            "description": null,
            "external_link": null,
            "asset_contract": {
                "address": "0x495f947276749ce646f68ac8c248420045cb7b5e",
                "asset_contract_type": "semi-fungible",
                "created_date": "2020-12-02T17:40:53.232025",
                "name": "OpenSea Collection",
                "nft_version": null,
                "opensea_version": "2.0.0",
                "owner": 102384,
                "schema_name": "ERC1155",
                "symbol": "OPENSTORE",
                "total_supply": null,
                "description": null,
                "external_link": null,
                "image_url": null,
                "default_to_fiat": false,
                "dev_buyer_fee_basis_points": 0,
                "dev_seller_fee_basis_points": 0,
                "only_proxied_transfers": false,
                "opensea_buyer_fee_basis_points": 0,
                "opensea_seller_fee_basis_points": 250,
                "buyer_fee_basis_points": 0,
                "seller_fee_basis_points": 250,
                "payout_address": null
            },
            "owner": {
                "user": {
                    "username": "NullAddress"
                },
                "profile_img_url": "https://storage.googleapis.com/opensea-static/opensea-profile/1.png",
                "address": "0x0000000000000000000000000000000000000000",
                "config": "",
                "discord_id": ""
            },
            "permalink": "https://opensea.io/assets/0x495f947276749ce646f68ac8c248420045cb7b5e/20779687020901315104817932847033512423599216699667133632923091506460125822977",
            "collection": {
                "banner_image_url": "https://lh3.googleusercontent.com/gFpU2HWWO4G53qKLkonFjlhLvkOyrnuC_PFMLHghOQwr6ZbL4YTQGwYQFjG703JYfreeicn_Q9qtFIGvOqT_3qq0J1m_NYYM8DlO0yY=s2500",
                "chat_url": null,
                "created_date": "2021-05-15T17:29:16.297787",
                "default_to_fiat": false,
                "description": "10,000 randomly generated animated NFT's. 3D rendered dancing blockheads with over 15 million possible combinations of species, professions, colors, and accessories.",
                "dev_buyer_fee_basis_points": "0",
                "dev_seller_fee_basis_points": "500",
                "discord_url": "https://discord.gg/gY4fQwR59E",
                "display_data": {
                    "card_display_style": "contain"
                },
                "external_url": null,
                "featured": false,
                "featured_image_url": "https://lh3.googleusercontent.com/DUQIBKJCZqkIueysZ-vf8Xh1bqTDin3rSBWz87slZ0Ttqg7cJtcmizTpGBJQKB230YJjbHkenjkNICcXsME9jy6FNUPECQsbntECLA=s300",
                "hidden": true,
                "safelist_request_status": "not_requested",
                "image_url": "https://lh3.googleusercontent.com/JKzgo-XGir844sKoqbj3wca19WSGfTca54E2txRIk4XUVUCd-bnY0bVlmBS7IYr5_fs-3T2rPlnKQIKJQgWSKBrKuEmitX8zBGl0Cg=s120",
                "is_subject_to_whitelist": false,
                "large_image_url": "https://lh3.googleusercontent.com/DUQIBKJCZqkIueysZ-vf8Xh1bqTDin3rSBWz87slZ0Ttqg7cJtcmizTpGBJQKB230YJjbHkenjkNICcXsME9jy6FNUPECQsbntECLA=s300",
                "medium_username": null,
                "name": "Cublitz",
                "only_proxied_transfers": false,
                "opensea_buyer_fee_basis_points": "0",
                "opensea_seller_fee_basis_points": "250",
                "payout_address": "0x2df0e2d512a76fbc761a7df0811ecb2f3556a8a4",
                "require_email": false,
                "short_description": null,
                "slug": "cublitz",
                "telegram_url": null,
                "twitter_username": "cublitz",
                "instagram_username": null,
                "wiki_url": null
            },
            "decimals": null,
            "token_metadata": null,
            "sell_orders": null,
            "creator": {
                "user": {
                    "username": "DedRedArt"
                },
                "profile_img_url": "https://storage.googleapis.com/opensea-static/opensea-profile/30.png",
                "address": "0x2df0e2d512a76fbc761a7df0811ecb2f3556a8a4",
                "config": "",
                "discord_id": ""
            },
            "traits": [
                {
                    "trait_type": "Class",
                    "value": "Cowboy",
                    "display_type": null,
                    "max_value": null,
                    "trait_count": 204,
                    "order": null
                },
                {
                    "trait_type": "Race",
                    "value": "Demon",
                    "display_type": null,
                    "max_value": null,
                    "trait_count": 35,
                    "order": null
                },
                {
                    "trait_type": "Eyes",
                    "value": "Stare",
                    "display_type": null,
                    "max_value": null,
                    "trait_count": 147,
                    "order": null
                },
                {
                    "trait_type": "Race Color",
                    "value": "Color 1",
                    "display_type": null,
                    "max_value": null,
                    "trait_count": 1468,
                    "order": null
                },
                {
                    "trait_type": "Class Color",
                    "value": "Color 1",
                    "display_type": null,
                    "max_value": null,
                    "trait_count": 1198,
                    "order": null
                },
                {
                    "trait_type": "Background",
                    "value": "Moon",
                    "display_type": null,
                    "max_value": null,
                    "trait_count": 26,
                    "order": null
                }
            ],
            "last_sale": null,
            "top_bid": null,
            "listing_date": null,
            "is_presale": true,
            "transfer_fee_payment_token": null,
            "transfer_fee": null
        },
        {
            "id": 25665479,
            "token_id": "5131662734593380122495570034016160114053769713600505378309056882906085982209",
            "num_sales": 0,
            "background_color": null,
            "image_url": "https://lh3.googleusercontent.com/wiov6xtFazPdUARnIuVJDn5H2G8JnBCnlzv6v_widxrvBS_48bMigc0Alrnedsg89X9ZYIyaY938N9kJuIqf-NkBnFuzrLuVHi5FLA",
            "image_preview_url": "https://lh3.googleusercontent.com/wiov6xtFazPdUARnIuVJDn5H2G8JnBCnlzv6v_widxrvBS_48bMigc0Alrnedsg89X9ZYIyaY938N9kJuIqf-NkBnFuzrLuVHi5FLA=s250",
            "image_thumbnail_url": "https://lh3.googleusercontent.com/wiov6xtFazPdUARnIuVJDn5H2G8JnBCnlzv6v_widxrvBS_48bMigc0Alrnedsg89X9ZYIyaY938N9kJuIqf-NkBnFuzrLuVHi5FLA=s128",
            "image_original_url": null,
            "animation_url": null,
            "animation_original_url": null,
            "name": "Symbols#1 mi 2020 puzzle bottom right 9/9",
            "description": "Bottom right piece of the puzzle\n\n■■■\n\nI make a cup of coffee. The sun is shining. I love feel ink on my skin and live with my draw all the summer day. A single day. Only one. And i have to say \"good bye\" when i take a shower. Ephemeral art ... hum I need to explore to stay awake. Do you know this symbols ? They whisper something... My first NFT project 🥳",
            "external_link": "https://miplayer.one/nft-art.html#1",
            "asset_contract": {
                "address": "0x495f947276749ce646f68ac8c248420045cb7b5e",
                "asset_contract_type": "semi-fungible",
                "created_date": "2020-12-02T17:40:53.232025",
                "name": "OpenSea Collection",
                "nft_version": null,
                "opensea_version": "2.0.0",
                "owner": 102384,
                "schema_name": "ERC1155",
                "symbol": "OPENSTORE",
                "total_supply": null,
                "description": null,
                "external_link": null,
                "image_url": null,
                "default_to_fiat": false,
                "dev_buyer_fee_basis_points": 0,
                "dev_seller_fee_basis_points": 0,
                "only_proxied_transfers": false,
                "opensea_buyer_fee_basis_points": 0,
                "opensea_seller_fee_basis_points": 250,
                "buyer_fee_basis_points": 0,
                "seller_fee_basis_points": 250,
                "payout_address": null
            },
            "owner": {
                "user": {
                    "username": "NullAddress"
                },
                "profile_img_url": "https://storage.googleapis.com/opensea-static/opensea-profile/1.png",
                "address": "0x0000000000000000000000000000000000000000",
                "config": "",
                "discord_id": ""
            },
            "permalink": "https://opensea.io/assets/0x495f947276749ce646f68ac8c248420045cb7b5e/5131662734593380122495570034016160114053769713600505378309056882906085982209",
            "collection": {
                "banner_image_url": "https://lh3.googleusercontent.com/VCTTMkoQFATehbQcwoLshlEr65neSifpGJVLTGlbLYKxThteVSijvGt8VGnco5bMWr673psSWRTpqufJPtwUBRyIwdjIwzSWC1FK2A=s2500",
                "chat_url": null,
                "created_date": "2021-05-12T14:45:06.112814",
                "default_to_fiat": false,
                "description": "I make a cup of coffee. The sun is shining. I love feel ink on my skin and live with my draw all the summer day.\nA single day.\nOnly one.\nAnd i have to say \"good bye\" when i take a shower. Ephemeral art ... hum\nI need to explore to stay awake. Do you know this symbols ? They whisper something... My first NFT project.\n\n■■■\n\nSince my first contact with code in primary school (I'm from the Logos generation, from the 80s), I haven't stopped exploring it. Through the web as a UX designer and front-end developer, as a trainer in digital culture and in an artistic and exploratory approach as a creative coder.\n\n■■■\n",
                "dev_buyer_fee_basis_points": "0",
                "dev_seller_fee_basis_points": "500",
                "discord_url": "https://discord.gg/Miplayer1#2446",
                "display_data": {
                    "card_display_style": "cover"
                },
                "external_url": "http://miplayer.one",
                "featured": false,
                "featured_image_url": "https://lh3.googleusercontent.com/r4AmHDEYFFOFUFEh89u0FAl-r06K6Fv7PpLaN_hDoB_npswSioaBgR3bsDkSYauBDEBY-uSOPilAX9P15nl-hFOsAodfWx9rJ7l_sg=s300",
                "hidden": true,
                "safelist_request_status": "not_requested",
                "image_url": "https://lh3.googleusercontent.com/UW4lRbB9xk_kzjuULK4wj-j0-GE9nAifh7yBXZOEDSi1FL97dcOfsOlo1x222d9aHSm2YyjmIZBIS7bVv7Ru4Wf4BbO8dt-sXdanox0=s120",
                "is_subject_to_whitelist": false,
                "large_image_url": "https://lh3.googleusercontent.com/r4AmHDEYFFOFUFEh89u0FAl-r06K6Fv7PpLaN_hDoB_npswSioaBgR3bsDkSYauBDEBY-uSOPilAX9P15nl-hFOsAodfWx9rJ7l_sg=s300",
                "medium_username": null,
                "name": "Symbols#1 -mi- 2020",
                "only_proxied_transfers": false,
                "opensea_buyer_fee_basis_points": "0",
                "opensea_seller_fee_basis_points": "250",
                "payout_address": "0x0b586b0dc8b8f0f824c9b1b2825b8193e52f7bed",
                "require_email": false,
                "short_description": null,
                "slug": "symbols-1-mi-2020",
                "telegram_url": null,
                "twitter_username": "mi_player1",
                "instagram_username": "mi_player1",
                "wiki_url": null
            },
            "decimals": null,
            "token_metadata": null,
            "sell_orders": null,
            "creator": {
                "user": {
                    "username": "Miplayer1"
                },
                "profile_img_url": "https://storage.googleapis.com/opensea-static/opensea-profile/18.png",
                "address": "0x0b586b0dc8b8f0f824c9b1b2825b8193e52f7bed",
                "config": "",
                "discord_id": ""
            },
            "traits": [
                {
                    "trait_type": "Medium",
                    "value": "Skin and ink",
                    "display_type": null,
                    "max_value": null,
                    "trait_count": 11,
                    "order": null
                },
                {
                    "trait_type": "Symbol",
                    "value": "Alchemy",
                    "display_type": null,
                    "max_value": null,
                    "trait_count": 13,
                    "order": null
                },
                {
                    "trait_type": "Style",
                    "value": "Ephemeral",
                    "display_type": null,
                    "max_value": null,
                    "trait_count": 11,
                    "order": null
                },
                {
                    "trait_type": "Author",
                    "value": "mi",
                    "display_type": null,
                    "max_value": null,
                    "trait_count": 13,
                    "order": null
                }
            ],
            "last_sale": null,
            "top_bid": null,
            "listing_date": null,
            "is_presale": true,
            "transfer_fee_payment_token": null,
            "transfer_fee": null
        },
        {
            "id": 25665478,
            "token_id": "17236544732499630413850167768792368099013830303415426705225681718134444130305",
            "num_sales": 0,
            "background_color": null,
            "image_url": "https://lh3.googleusercontent.com/LlVSyxm21-xKT0D8wJUxiED-RYC3HGQ6cmhJw7cAxkgI_EtZJlXDej6SSAkcg5VvB7cxzWRhruxz94kTRnEi1lqg6b1PdEZZne3HG9I",
            "image_preview_url": "https://lh3.googleusercontent.com/LlVSyxm21-xKT0D8wJUxiED-RYC3HGQ6cmhJw7cAxkgI_EtZJlXDej6SSAkcg5VvB7cxzWRhruxz94kTRnEi1lqg6b1PdEZZne3HG9I=s250",
            "image_thumbnail_url": "https://lh3.googleusercontent.com/LlVSyxm21-xKT0D8wJUxiED-RYC3HGQ6cmhJw7cAxkgI_EtZJlXDej6SSAkcg5VvB7cxzWRhruxz94kTRnEi1lqg6b1PdEZZne3HG9I=s128",
            "image_original_url": null,
            "animation_url": null,
            "animation_original_url": null,
            "name": "CryptoPunx01",
            "description": "CryptoPunx01 is the first of 25 CryptoPunx that will ever be created. \n\nA limited set of 25 CryptoPunks style characters, all 1/1 editions.\n\nAll images are 2000x2000 px.\n\nThe owner has full commercial rights to the images.\n\nThis project is not affiliated with Larva Labs.",
            "external_link": null,
            "asset_contract": {
                "address": "0x495f947276749ce646f68ac8c248420045cb7b5e",
                "asset_contract_type": "semi-fungible",
                "created_date": "2020-12-02T17:40:53.232025",
                "name": "OpenSea Collection",
                "nft_version": null,
                "opensea_version": "2.0.0",
                "owner": 102384,
                "schema_name": "ERC1155",
                "symbol": "OPENSTORE",
                "total_supply": null,
                "description": null,
                "external_link": null,
                "image_url": null,
                "default_to_fiat": false,
                "dev_buyer_fee_basis_points": 0,
                "dev_seller_fee_basis_points": 0,
                "only_proxied_transfers": false,
                "opensea_buyer_fee_basis_points": 0,
                "opensea_seller_fee_basis_points": 250,
                "buyer_fee_basis_points": 0,
                "seller_fee_basis_points": 250,
                "payout_address": null
            },
            "owner": {
                "user": {
                    "username": "NullAddress"
                },
                "profile_img_url": "https://storage.googleapis.com/opensea-static/opensea-profile/1.png",
                "address": "0x0000000000000000000000000000000000000000",
                "config": "",
                "discord_id": ""
            },
            "permalink": "https://opensea.io/assets/0x495f947276749ce646f68ac8c248420045cb7b5e/17236544732499630413850167768792368099013830303415426705225681718134444130305",
            "collection": {
                "banner_image_url": null,
                "chat_url": null,
                "created_date": "2021-05-25T22:45:16.165963",
                "default_to_fiat": false,
                "description": "A limited set of 25 CryptoPunks style characters, all 1/1 editions. \n\nAll images are 2000x2000 px. \n\nThe owner has full commercial rights to the images. \n\nThis project is not affiliated with Larva Labs.",
                "dev_buyer_fee_basis_points": "0",
                "dev_seller_fee_basis_points": "0",
                "discord_url": null,
                "display_data": {
                    "card_display_style": "contain",
                    "images": []
                },
                "external_url": null,
                "featured": false,
                "featured_image_url": null,
                "hidden": true,
                "safelist_request_status": "not_requested",
                "image_url": "https://lh3.googleusercontent.com/LlVSyxm21-xKT0D8wJUxiED-RYC3HGQ6cmhJw7cAxkgI_EtZJlXDej6SSAkcg5VvB7cxzWRhruxz94kTRnEi1lqg6b1PdEZZne3HG9I=s120",
                "is_subject_to_whitelist": false,
                "large_image_url": null,
                "medium_username": null,
                "name": "CryptoPunx",
                "only_proxied_transfers": false,
                "opensea_buyer_fee_basis_points": "0",
                "opensea_seller_fee_basis_points": "250",
                "payout_address": null,
                "require_email": false,
                "short_description": null,
                "slug": "cryptopunx",
                "telegram_url": null,
                "twitter_username": null,
                "instagram_username": null,
                "wiki_url": null
            },
            "decimals": null,
            "token_metadata": null,
            "sell_orders": [
                {
                    "created_date": "2021-05-25T22:50:38.467874",
                    "closing_date": null,
                    "closing_extendable": false,
                    "expiration_time": 0,
                    "listing_time": 1621982933,
                    "order_hash": "0x5a82c4a3fe6c5b95220110cf829228089c348f568250123c30310264f793e612",
                    "metadata": {
                        "asset": {
                            "id": "17236544732499630413850167768792368099013830303415426705225681718134444130305",
                            "address": "0x495f947276749ce646f68ac8c248420045cb7b5e",
                            "quantity": "1"
                        },
                        "schema": "ERC1155"
                    },
                    "exchange": "0x7be8076f4ea4a4ad08075c2508e481d6c946d12b",
                    "maker": {
                        "user": 680852,
                        "profile_img_url": "https://storage.googleapis.com/opensea-static/opensea-profile/27.png",
                        "address": "0x261b89e16244fa9a1288e75d06544992a7d63768",
                        "config": "",
                        "discord_id": ""
                    },
                    "taker": {
                        "user": 1766,
                        "profile_img_url": "https://storage.googleapis.com/opensea-static/opensea-profile/1.png",
                        "address": "0x0000000000000000000000000000000000000000",
                        "config": "",
                        "discord_id": ""
                    },
                    "current_price": "100000000000000000",
                    "current_bounty": "1000000000000000",
                    "bounty_multiple": "0.01",
                    "maker_relayer_fee": "250",
                    "taker_relayer_fee": "0",
                    "maker_protocol_fee": "0",
                    "taker_protocol_fee": "0",
                    "maker_referrer_fee": "0",
                    "fee_recipient": {
                        "user": 3585,
                        "profile_img_url": "https://storage.googleapis.com/opensea-static/opensea-profile/28.png",
                        "address": "0x5b3256965e7c3cf26e11fcaf296dfc8807c01073",
                        "config": "verified",
                        "discord_id": ""
                    },
                    "fee_method": 1,
                    "side": 1,
                    "sale_kind": 0,
                    "target": "0x495f947276749ce646f68ac8c248420045cb7b5e",
                    "how_to_call": 0,
                    "calldata": "0xf242432a000000000000000000000000261b89e16244fa9a1288e75d06544992a7d637680000000000000000000000000000000000000000000000000000000000000000261b89e16244fa9a1288e75d06544992a7d63768000000000000050000000001000000000000000000000000000000000000000000000000000000000000000100000000000000000000000000000000000000000000000000000000000000a00000000000000000000000000000000000000000000000000000000000000000",
                    "replacement_pattern": "0x000000000000000000000000000000000000000000000000000000000000000000000000ffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffff0000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000",
                    "static_target": "0x0000000000000000000000000000000000000000",
                    "static_extradata": "0x",
                    "payment_token": "0x0000000000000000000000000000000000000000",
                    "payment_token_contract": {
                        "id": 1,
                        "symbol": "ETH",
                        "address": "0x0000000000000000000000000000000000000000",
                        "image_url": "https://storage.opensea.io/files/6f8e2979d428180222796ff4a33ab929.svg",
                        "name": "Ether",
                        "decimals": 18,
                        "eth_price": "1.000000000000000",
                        "usd_price": "2625.730000000000018000"
                    },
                    "base_price": "100000000000000000",
                    "extra": "0",
                    "quantity": "1",
                    "salt": "5126417118177762620590110411545907141351967009569669734335389843472467276464",
                    "v": 28,
                    "r": "0x8d48ff7f648bf5ec385dae981e66ca28a2e8636b54fc53e9ed3381a5323ab28e",
                    "s": "0x2260ebad647c6414e436d351fc56de2d8bbb59dec499c31bdbbf3c217a54fe3b",
                    "approved_on_chain": false,
                    "cancelled": false,
                    "finalized": false,
                    "marked_invalid": false,
                    "prefixed_hash": "0x2413cf69d09b7260d6d234dbf01ac36355215809c2d0f1f7e5eb1bc3dbe18a3e"
                }
            ],
            "creator": {
                "user": {
                    "username": "ByKellyMcD"
                },
                "profile_img_url": "https://storage.googleapis.com/opensea-static/opensea-profile/27.png",
                "address": "0x261b89e16244fa9a1288e75d06544992a7d63768",
                "config": "",
                "discord_id": ""
            },
            "traits": [
                {
                    "trait_type": "Character",
                    "value": "Male",
                    "display_type": null,
                    "max_value": null,
                    "trait_count": 0,
                    "order": null
                },
                {
                    "trait_type": "Accessory",
                    "value": "Hat",
                    "display_type": null,
                    "max_value": null,
                    "trait_count": 0,
                    "order": null
                },
                {
                    "trait_type": "Accessory",
                    "value": "Blue Eyes",
                    "display_type": null,
                    "max_value": null,
                    "trait_count": 0,
                    "order": null
                }
            ],
            "last_sale": null,
            "top_bid": null,
            "listing_date": null,
            "is_presale": true,
            "transfer_fee_payment_token": null,
            "transfer_fee": null
        },
        {
            "id": 25665477,
            "token_id": "1261",
            "num_sales": 0,
            "background_color": null,
            "image_url": "https://lh3.googleusercontent.com/3G09bcOjSfkbIiCnDTPdcifXndMofduTa9W4fLYcKDu45DoRdLrABJIaa8zFGe9iPTWyAKep2ajzP1wIQ0o5YiWG45xUiPsKgMoogQ",
            "image_preview_url": "https://lh3.googleusercontent.com/3G09bcOjSfkbIiCnDTPdcifXndMofduTa9W4fLYcKDu45DoRdLrABJIaa8zFGe9iPTWyAKep2ajzP1wIQ0o5YiWG45xUiPsKgMoogQ=s250",
            "image_thumbnail_url": "https://lh3.googleusercontent.com/3G09bcOjSfkbIiCnDTPdcifXndMofduTa9W4fLYcKDu45DoRdLrABJIaa8zFGe9iPTWyAKep2ajzP1wIQ0o5YiWG45xUiPsKgMoogQ=s128",
            "image_original_url": "https://embersword.mypinata.cloud/ipfs/QmdbeV27CatL3EddMf2Ek1jGt77amKgb5ghVeHrKWLyz84",
            "animation_url": "https://storage.opensea.io/files/b0cc4d04cbc1f26c66e7511d64cd2d9e.mp4",
            "animation_original_url": "https://embersword.mypinata.cloud/ipfs/QmfKgvFupW1dm9W3UusnrGKrabMT6hTD2DkhG27hAU7Lxx",
            "name": "Land (42,46)",
            "description": "Land plot",
            "external_link": null,
            "asset_contract": {
                "address": "0xe7e16f2da731265778f87cb8d7850e31b84b7b86",
                "asset_contract_type": "non-fungible",
                "created_date": "2021-05-25T13:23:10.895540",
                "name": "Embersword Land",
                "nft_version": null,
                "opensea_version": null,
                "owner": 35978059,
                "schema_name": "ERC721",
                "symbol": "LAND",
                "total_supply": "0",
                "description": null,
                "external_link": "https://embersword.com",
                "image_url": "https://lh3.googleusercontent.com/J7SSCNIDh1ui59aoqyNywPtnUAUB-Q80Cnl1txbxmJOAIKcRJT1bUYidkDPNegOk2W0zyjqVkLbdcI6g6KTYgQCDplCo3DXpDSeaPg=s120",
                "default_to_fiat": false,
                "dev_buyer_fee_basis_points": 0,
                "dev_seller_fee_basis_points": 0,
                "only_proxied_transfers": false,
                "opensea_buyer_fee_basis_points": 0,
                "opensea_seller_fee_basis_points": 250,
                "buyer_fee_basis_points": 0,
                "seller_fee_basis_points": 250,
                "payout_address": null
            },
            "owner": {
                "user": null,
                "profile_img_url": "https://storage.googleapis.com/opensea-static/opensea-profile/1.png",
                "address": "0x0000000000000000000000000000000000000000",
                "config": "",
                "discord_id": ""
            },
            "permalink": "https://opensea.io/assets/matic/0xe7e16f2da731265778f87cb8d7850e31b84b7b86/1261",
            "collection": {
                "banner_image_url": null,
                "chat_url": null,
                "created_date": "2021-05-25T16:51:25.426643",
                "default_to_fiat": false,
                "description": null,
                "dev_buyer_fee_basis_points": "0",
                "dev_seller_fee_basis_points": "0",
                "discord_url": "https://discord.gg/embersword",
                "display_data": {
                    "card_display_style": "contain"
                },
                "external_url": "https://embersword.com",
                "featured": false,
                "featured_image_url": null,
                "hidden": true,
                "safelist_request_status": "not_requested",
                "image_url": "https://lh3.googleusercontent.com/J7SSCNIDh1ui59aoqyNywPtnUAUB-Q80Cnl1txbxmJOAIKcRJT1bUYidkDPNegOk2W0zyjqVkLbdcI6g6KTYgQCDplCo3DXpDSeaPg=s120",
                "is_subject_to_whitelist": false,
                "large_image_url": null,
                "medium_username": "embersword",
                "name": "Ember Sword Land",
                "only_proxied_transfers": false,
                "opensea_buyer_fee_basis_points": "0",
                "opensea_seller_fee_basis_points": "250",
                "payout_address": null,
                "require_email": false,
                "short_description": null,
                "slug": "embersword-land",
                "telegram_url": null,
                "twitter_username": "PlayEmberSword",
                "instagram_username": null,
                "wiki_url": null
            },
            "decimals": null,
            "token_metadata": "https://embersword.mypinata.cloud/ipfs/Qmf1JopB1FXrjLiN6Q44dCFLt2wUUEp16tzRWLbhhAvUq7",
            "sell_orders": null,
            "creator": null,
            "traits": [
                {
                    "trait_type": "x-coordinate",
                    "value": 42,
                    "display_type": "number",
                    "max_value": null,
                    "trait_count": 0,
                    "order": null
                },
                {
                    "trait_type": "Type",
                    "value": "Land",
                    "display_type": null,
                    "max_value": null,
                    "trait_count": 692,
                    "order": null
                },
                {
                    "trait_type": "y-coordinate",
                    "value": 46,
                    "display_type": "number",
                    "max_value": null,
                    "trait_count": 0,
                    "order": null
                }
            ],
            "last_sale": null,
            "top_bid": null,
            "listing_date": null,
            "is_presale": false,
            "transfer_fee_payment_token": null,
            "transfer_fee": null
        },
        {
            "id": 25665476,
            "token_id": "62664",
            "num_sales": 0,
            "background_color": null,
            "image_url": "",
            "image_preview_url": null,
            "image_thumbnail_url": null,
            "image_original_url": null,
            "animation_url": null,
            "animation_original_url": null,
            "name": null,
            "description": null,
            "external_link": null,
            "asset_contract": {
                "address": "0xf556faf23fc2feefa33ee6db2d1ee4c70e534513",
                "asset_contract_type": "non-fungible",
                "created_date": "2021-01-04T16:26:23.390626",
                "name": "0xUniverse",
                "nft_version": null,
                "opensea_version": null,
                "owner": 37755849,
                "schema_name": "ERC721",
                "symbol": "PLANET",
                "total_supply": "61667",
                "description": "0xUniverse is the next generation blockchain game where players can build spaceships, explore the galaxy, and colonize planets. The discoverers will extract resources and carry out research that allows them to conquer the remotest corners of the galaxy. In addition, players can jointly contribute to the story and unravel the mystery of the universe.",
                "external_link": "https://0xuniverse.com",
                "image_url": "https://lh3.googleusercontent.com/WcGfdbwJ5EcLj-_q7kIsyzhNOo6Wb8C5ZjZFJxUQEgwYbQ5eMVkpDHwbti8G0cFvXPQJbUfekwbCSZANhyuIzRys094NIoCkuGOm=s120",
                "default_to_fiat": false,
                "dev_buyer_fee_basis_points": 0,
                "dev_seller_fee_basis_points": 0,
                "only_proxied_transfers": false,
                "opensea_buyer_fee_basis_points": 0,
                "opensea_seller_fee_basis_points": 250,
                "buyer_fee_basis_points": 0,
                "seller_fee_basis_points": 250,
                "payout_address": null
            },
            "owner": {
                "user": null,
                "profile_img_url": "https://storage.googleapis.com/opensea-static/opensea-profile/1.png",
                "address": "0x0000000000000000000000000000000000000000",
                "config": "",
                "discord_id": ""
            },
            "permalink": "https://opensea.io/assets/matic/0xf556faf23fc2feefa33ee6db2d1ee4c70e534513/62664",
            "collection": {
                "banner_image_url": "https://lh3.googleusercontent.com/xTMVZ9068E5AeySzCF3IjdMvWWal8DqXK5RzPVhCI0k6Eu6HuLD2V9hnu2RY5-tnuHpgj62kovuY0KexryI1SHg56MNsgGCJt1ZB=s2500",
                "chat_url": null,
                "created_date": "2021-01-04T16:26:23.654821",
                "default_to_fiat": false,
                "description": "0xUniverse is the next generation blockchain game where players can build spaceships, explore the galaxy, and colonize planets. The discoverers will extract resources and carry out research that allows them to conquer the remotest corners of the galaxy. In addition, players can jointly contribute to the story and unravel the mystery of the universe.",
                "dev_buyer_fee_basis_points": "0",
                "dev_seller_fee_basis_points": "0",
                "discord_url": "https://discord.gg/R8fwEPC",
                "display_data": {
                    "card_display_style": "cover"
                },
                "external_url": "https://0xuniverse.com",
                "featured": false,
                "featured_image_url": "https://lh3.googleusercontent.com/NKpERysJoaSPjRHewYtAu0p5HHxzbhra1mwzN8i6Nuv6K17kUco7De-iJUUmVgmlJSKMCuovdTHx13n2RUOrAXWRNNaC3iW6uyB7jA=s300",
                "hidden": true,
                "safelist_request_status": "not_requested",
                "image_url": "https://lh3.googleusercontent.com/WcGfdbwJ5EcLj-_q7kIsyzhNOo6Wb8C5ZjZFJxUQEgwYbQ5eMVkpDHwbti8G0cFvXPQJbUfekwbCSZANhyuIzRys094NIoCkuGOm=s120",
                "is_subject_to_whitelist": false,
                "large_image_url": "https://lh3.googleusercontent.com/NKpERysJoaSPjRHewYtAu0p5HHxzbhra1mwzN8i6Nuv6K17kUco7De-iJUUmVgmlJSKMCuovdTHx13n2RUOrAXWRNNaC3iW6uyB7jA=s300",
                "medium_username": null,
                "name": "0xUniverse: Galaxy Edge (Matic)",
                "only_proxied_transfers": false,
                "opensea_buyer_fee_basis_points": "0",
                "opensea_seller_fee_basis_points": "250",
                "payout_address": null,
                "require_email": false,
                "short_description": null,
                "slug": "0xuniverse-edge-matic",
                "telegram_url": null,
                "twitter_username": "0xUniverse",
                "instagram_username": null,
                "wiki_url": null
            },
            "decimals": null,
            "token_metadata": "https://prod.0xuniverse.com/universe-server/planets/1/62664",
            "sell_orders": null,
            "creator": null,
            "traits": [],
            "last_sale": null,
            "top_bid": null,
            "listing_date": null,
            "is_presale": false,
            "transfer_fee_payment_token": null,
            "transfer_fee": null
        },
        {
            "id": 25665475,
            "token_id": "74006586352960825675180634876782533674650799765435174401439632235821803765761",
            "num_sales": 0,
            "background_color": null,
            "image_url": "https://lh3.googleusercontent.com/S9HEzmzv0GXFnSPGR3Aw9V-5IxP2UsM2_IxtSgRRyomR7UFuTKpoveXKkIaXqEFem4-rRU9J5-YQqosG19j9CPnXUJKSxylkry3Ekg",
            "image_preview_url": "https://lh3.googleusercontent.com/S9HEzmzv0GXFnSPGR3Aw9V-5IxP2UsM2_IxtSgRRyomR7UFuTKpoveXKkIaXqEFem4-rRU9J5-YQqosG19j9CPnXUJKSxylkry3Ekg=s250",
            "image_thumbnail_url": "https://lh3.googleusercontent.com/S9HEzmzv0GXFnSPGR3Aw9V-5IxP2UsM2_IxtSgRRyomR7UFuTKpoveXKkIaXqEFem4-rRU9J5-YQqosG19j9CPnXUJKSxylkry3Ekg=s128",
            "image_original_url": null,
            "animation_url": null,
            "animation_original_url": null,
            "name": "The Greatest Chart Ever",
            "description": null,
            "external_link": null,
            "asset_contract": {
                "address": "0x495f947276749ce646f68ac8c248420045cb7b5e",
                "asset_contract_type": "semi-fungible",
                "created_date": "2020-12-02T17:40:53.232025",
                "name": "OpenSea Collection",
                "nft_version": null,
                "opensea_version": "2.0.0",
                "owner": 102384,
                "schema_name": "ERC1155",
                "symbol": "OPENSTORE",
                "total_supply": null,
                "description": null,
                "external_link": null,
                "image_url": null,
                "default_to_fiat": false,
                "dev_buyer_fee_basis_points": 0,
                "dev_seller_fee_basis_points": 0,
                "only_proxied_transfers": false,
                "opensea_buyer_fee_basis_points": 0,
                "opensea_seller_fee_basis_points": 250,
                "buyer_fee_basis_points": 0,
                "seller_fee_basis_points": 250,
                "payout_address": null
            },
            "owner": {
                "user": {
                    "username": "NullAddress"
                },
                "profile_img_url": "https://storage.googleapis.com/opensea-static/opensea-profile/1.png",
                "address": "0x0000000000000000000000000000000000000000",
                "config": "",
                "discord_id": ""
            },
            "permalink": "https://opensea.io/assets/0x495f947276749ce646f68ac8c248420045cb7b5e/74006586352960825675180634876782533674650799765435174401439632235821803765761",
            "collection": {
                "banner_image_url": null,
                "chat_url": null,
                "created_date": "2021-05-19T17:15:29.093359",
                "default_to_fiat": false,
                "description": "Remembering some great moments in trading history.",
                "dev_buyer_fee_basis_points": "0",
                "dev_seller_fee_basis_points": "250",
                "discord_url": null,
                "display_data": {
                    "card_display_style": "contain"
                },
                "external_url": null,
                "featured": false,
                "featured_image_url": null,
                "hidden": true,
                "safelist_request_status": "not_requested",
                "image_url": "https://lh3.googleusercontent.com/S9HEzmzv0GXFnSPGR3Aw9V-5IxP2UsM2_IxtSgRRyomR7UFuTKpoveXKkIaXqEFem4-rRU9J5-YQqosG19j9CPnXUJKSxylkry3Ekg=s120",
                "is_subject_to_whitelist": false,
                "large_image_url": null,
                "medium_username": null,
                "name": "Debacle Charts",
                "only_proxied_transfers": false,
                "opensea_buyer_fee_basis_points": "0",
                "opensea_seller_fee_basis_points": "250",
                "payout_address": "0xa39e3e54eaf64d0c0f3ebb4d46dac6c2985de5a2",
                "require_email": false,
                "short_description": null,
                "slug": "debacle-charts",
                "telegram_url": null,
                "twitter_username": null,
                "instagram_username": null,
                "wiki_url": null
            },
            "decimals": null,
            "token_metadata": null,
            "sell_orders": [
                {
                    "created_date": "2021-05-25T22:50:46.817683",
                    "closing_date": null,
                    "closing_extendable": false,
                    "expiration_time": 0,
                    "listing_time": 1621982941,
                    "order_hash": "0x3d2911204af3cc048e1179fdd2552a981242064b7fc4cab23d3a31633a5624a7",
                    "metadata": {
                        "asset": {
                            "id": "74006586352960825675180634876782533674650799765435174401439632235821803765761",
                            "address": "0x495f947276749ce646f68ac8c248420045cb7b5e",
                            "quantity": "1"
                        },
                        "schema": "ERC1155"
                    },
                    "exchange": "0x7be8076f4ea4a4ad08075c2508e481d6c946d12b",
                    "maker": {
                        "user": 179505,
                        "profile_img_url": "https://storage.googleapis.com/opensea-static/opensea-profile/30.png",
                        "address": "0xa39e3e54eaf64d0c0f3ebb4d46dac6c2985de5a2",
                        "config": "",
                        "discord_id": ""
                    },
                    "taker": {
                        "user": 1766,
                        "profile_img_url": "https://storage.googleapis.com/opensea-static/opensea-profile/1.png",
                        "address": "0x0000000000000000000000000000000000000000",
                        "config": "",
                        "discord_id": ""
                    },
                    "current_price": "10000000000000000",
                    "current_bounty": "100000000000000",
                    "bounty_multiple": "0.01",
                    "maker_relayer_fee": "500",
                    "taker_relayer_fee": "0",
                    "maker_protocol_fee": "0",
                    "taker_protocol_fee": "0",
                    "maker_referrer_fee": "0",
                    "fee_recipient": {
                        "user": 3585,
                        "profile_img_url": "https://storage.googleapis.com/opensea-static/opensea-profile/28.png",
                        "address": "0x5b3256965e7c3cf26e11fcaf296dfc8807c01073",
                        "config": "verified",
                        "discord_id": ""
                    },
                    "fee_method": 1,
                    "side": 1,
                    "sale_kind": 0,
                    "target": "0x495f947276749ce646f68ac8c248420045cb7b5e",
                    "how_to_call": 0,
                    "calldata": "0xf242432a000000000000000000000000a39e3e54eaf64d0c0f3ebb4d46dac6c2985de5a20000000000000000000000000000000000000000000000000000000000000000a39e3e54eaf64d0c0f3ebb4d46dac6c2985de5a2000000000000020000000001000000000000000000000000000000000000000000000000000000000000000100000000000000000000000000000000000000000000000000000000000000a00000000000000000000000000000000000000000000000000000000000000000",
                    "replacement_pattern": "0x000000000000000000000000000000000000000000000000000000000000000000000000ffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffff0000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000",
                    "static_target": "0x0000000000000000000000000000000000000000",
                    "static_extradata": "0x",
                    "payment_token": "0x0000000000000000000000000000000000000000",
                    "payment_token_contract": {
                        "id": 1,
                        "symbol": "ETH",
                        "address": "0x0000000000000000000000000000000000000000",
                        "image_url": "https://storage.opensea.io/files/6f8e2979d428180222796ff4a33ab929.svg",
                        "name": "Ether",
                        "decimals": 18,
                        "eth_price": "1.000000000000000",
                        "usd_price": "2625.730000000000018000"
                    },
                    "base_price": "10000000000000000",
                    "extra": "0",
                    "quantity": "1",
                    "salt": "33927507610784057554770755280855347481360200031086993604881363407107506330454",
                    "v": 28,
                    "r": "0xbd7736f62a76e3f65c4a1bbeed7342459932bab3092ea6b3171f3d817703c363",
                    "s": "0x2dfdcc333fbe219f67b35b32b31041bcb054764398ce7bb6c31037fdf7e3f82c",
                    "approved_on_chain": false,
                    "cancelled": false,
                    "finalized": false,
                    "marked_invalid": false,
                    "prefixed_hash": "0x5ccedbef38bf0107de2a4b68a3581fab1d5cca95c304fe9b34b856c6309b008f"
                }
            ],
            "creator": {
                "user": {
                    "username": "ChadChandles"
                },
                "profile_img_url": "https://storage.googleapis.com/opensea-static/opensea-profile/30.png",
                "address": "0xa39e3e54eaf64d0c0f3ebb4d46dac6c2985de5a2",
                "config": "",
                "discord_id": ""
            },
            "traits": [],
            "last_sale": null,
            "top_bid": null,
            "listing_date": null,
            "is_presale": true,
            "transfer_fee_payment_token": null,
            "transfer_fee": null
        },
        {
            "id": 25665474,
            "token_id": "20779687020901315104817932847033512423599216699667133632923091505360614195201",
            "num_sales": 0,
            "background_color": null,
            "image_url": "https://lh3.googleusercontent.com/XomPAhBIsli_1fi3RCPUUNhB9P0RXKv4RenjM70O88F1Y539hVJqm0H_CAgn4okGlkyFB853TDR9NUPWxSLI04QD_RXq6hChIgVJstk",
            "image_preview_url": "https://lh3.googleusercontent.com/XomPAhBIsli_1fi3RCPUUNhB9P0RXKv4RenjM70O88F1Y539hVJqm0H_CAgn4okGlkyFB853TDR9NUPWxSLI04QD_RXq6hChIgVJstk=s250",
            "image_thumbnail_url": "https://lh3.googleusercontent.com/XomPAhBIsli_1fi3RCPUUNhB9P0RXKv4RenjM70O88F1Y539hVJqm0H_CAgn4okGlkyFB853TDR9NUPWxSLI04QD_RXq6hChIgVJstk=s128",
            "image_original_url": null,
            "animation_url": "https://storage.opensea.io/files/f375bf6b7656ac19624b67504f447ac6.mp4",
            "animation_original_url": "https://storage.opensea.io/files/f375bf6b7656ac19624b67504f447ac6.mp4",
            "name": "Cublitz #1682",
            "description": null,
            "external_link": null,
            "asset_contract": {
                "address": "0x495f947276749ce646f68ac8c248420045cb7b5e",
                "asset_contract_type": "semi-fungible",
                "created_date": "2020-12-02T17:40:53.232025",
                "name": "OpenSea Collection",
                "nft_version": null,
                "opensea_version": "2.0.0",
                "owner": 102384,
                "schema_name": "ERC1155",
                "symbol": "OPENSTORE",
                "total_supply": null,
                "description": null,
                "external_link": null,
                "image_url": null,
                "default_to_fiat": false,
                "dev_buyer_fee_basis_points": 0,
                "dev_seller_fee_basis_points": 0,
                "only_proxied_transfers": false,
                "opensea_buyer_fee_basis_points": 0,
                "opensea_seller_fee_basis_points": 250,
                "buyer_fee_basis_points": 0,
                "seller_fee_basis_points": 250,
                "payout_address": null
            },
            "owner": {
                "user": {
                    "username": "NullAddress"
                },
                "profile_img_url": "https://storage.googleapis.com/opensea-static/opensea-profile/1.png",
                "address": "0x0000000000000000000000000000000000000000",
                "config": "",
                "discord_id": ""
            },
            "permalink": "https://opensea.io/assets/0x495f947276749ce646f68ac8c248420045cb7b5e/20779687020901315104817932847033512423599216699667133632923091505360614195201",
            "collection": {
                "banner_image_url": "https://lh3.googleusercontent.com/gFpU2HWWO4G53qKLkonFjlhLvkOyrnuC_PFMLHghOQwr6ZbL4YTQGwYQFjG703JYfreeicn_Q9qtFIGvOqT_3qq0J1m_NYYM8DlO0yY=s2500",
                "chat_url": null,
                "created_date": "2021-05-15T17:29:16.297787",
                "default_to_fiat": false,
                "description": "10,000 randomly generated animated NFT's. 3D rendered dancing blockheads with over 15 million possible combinations of species, professions, colors, and accessories.",
                "dev_buyer_fee_basis_points": "0",
                "dev_seller_fee_basis_points": "500",
                "discord_url": "https://discord.gg/gY4fQwR59E",
                "display_data": {
                    "card_display_style": "contain"
                },
                "external_url": null,
                "featured": false,
                "featured_image_url": "https://lh3.googleusercontent.com/DUQIBKJCZqkIueysZ-vf8Xh1bqTDin3rSBWz87slZ0Ttqg7cJtcmizTpGBJQKB230YJjbHkenjkNICcXsME9jy6FNUPECQsbntECLA=s300",
                "hidden": true,
                "safelist_request_status": "not_requested",
                "image_url": "https://lh3.googleusercontent.com/JKzgo-XGir844sKoqbj3wca19WSGfTca54E2txRIk4XUVUCd-bnY0bVlmBS7IYr5_fs-3T2rPlnKQIKJQgWSKBrKuEmitX8zBGl0Cg=s120",
                "is_subject_to_whitelist": false,
                "large_image_url": "https://lh3.googleusercontent.com/DUQIBKJCZqkIueysZ-vf8Xh1bqTDin3rSBWz87slZ0Ttqg7cJtcmizTpGBJQKB230YJjbHkenjkNICcXsME9jy6FNUPECQsbntECLA=s300",
                "medium_username": null,
                "name": "Cublitz",
                "only_proxied_transfers": false,
                "opensea_buyer_fee_basis_points": "0",
                "opensea_seller_fee_basis_points": "250",
                "payout_address": "0x2df0e2d512a76fbc761a7df0811ecb2f3556a8a4",
                "require_email": false,
                "short_description": null,
                "slug": "cublitz",
                "telegram_url": null,
                "twitter_username": "cublitz",
                "instagram_username": null,
                "wiki_url": null
            },
            "decimals": null,
            "token_metadata": null,
            "sell_orders": null,
            "creator": {
                "user": {
                    "username": "DedRedArt"
                },
                "profile_img_url": "https://storage.googleapis.com/opensea-static/opensea-profile/30.png",
                "address": "0x2df0e2d512a76fbc761a7df0811ecb2f3556a8a4",
                "config": "",
                "discord_id": ""
            },
            "traits": [
                {
                    "trait_type": "Class",
                    "value": "Soldier",
                    "display_type": null,
                    "max_value": null,
                    "trait_count": 110,
                    "order": null
                },
                {
                    "trait_type": "Race",
                    "value": "Cat",
                    "display_type": null,
                    "max_value": null,
                    "trait_count": 225,
                    "order": null
                },
                {
                    "trait_type": "Eyes",
                    "value": "Oh",
                    "display_type": null,
                    "max_value": null,
                    "trait_count": 123,
                    "order": null
                },
                {
                    "trait_type": "Race Color",
                    "value": "Color 1",
                    "display_type": null,
                    "max_value": null,
                    "trait_count": 1468,
                    "order": null
                },
                {
                    "trait_type": "Background",
                    "value": "Desert",
                    "display_type": null,
                    "max_value": null,
                    "trait_count": 62,
                    "order": null
                },
                {
                    "trait_type": "Class Color",
                    "value": "Color 1",
                    "display_type": null,
                    "max_value": null,
                    "trait_count": 1198,
                    "order": null
                },
                {
                    "trait_type": "Head Accessory",
                    "value": "Cowboy Hat",
                    "display_type": null,
                    "max_value": null,
                    "trait_count": 130,
                    "order": null
                }
            ],
            "last_sale": null,
            "top_bid": null,
            "listing_date": null,
            "is_presale": true,
            "transfer_fee_payment_token": null,
            "transfer_fee": null
        },
        {
            "id": 25665473,
            "token_id": "114735020019161692095051113089976497045262832457918814971796358070624573194241",
            "num_sales": 0,
            "background_color": null,
            "image_url": "https://lh3.googleusercontent.com/99i0IDVzk6ZA6z3NkqJ5DbpVNAUoAWS89xlLKZTxTKmptWOGCTLjgvMUR3B76Vw54nzII_EXXKVCpRCoCkHUWqIS5XKOWbSbKhgw",
            "image_preview_url": "https://lh3.googleusercontent.com/99i0IDVzk6ZA6z3NkqJ5DbpVNAUoAWS89xlLKZTxTKmptWOGCTLjgvMUR3B76Vw54nzII_EXXKVCpRCoCkHUWqIS5XKOWbSbKhgw=s250",
            "image_thumbnail_url": "https://lh3.googleusercontent.com/99i0IDVzk6ZA6z3NkqJ5DbpVNAUoAWS89xlLKZTxTKmptWOGCTLjgvMUR3B76Vw54nzII_EXXKVCpRCoCkHUWqIS5XKOWbSbKhgw=s128",
            "image_original_url": null,
            "animation_url": null,
            "animation_original_url": null,
            "name": "ColorStone #842",
            "description": null,
            "external_link": "https://www.facet.us",
            "asset_contract": {
                "address": "0x495f947276749ce646f68ac8c248420045cb7b5e",
                "asset_contract_type": "semi-fungible",
                "created_date": "2020-12-02T17:40:53.232025",
                "name": "OpenSea Collection",
                "nft_version": null,
                "opensea_version": "2.0.0",
                "owner": 102384,
                "schema_name": "ERC1155",
                "symbol": "OPENSTORE",
                "total_supply": null,
                "description": null,
                "external_link": null,
                "image_url": null,
                "default_to_fiat": false,
                "dev_buyer_fee_basis_points": 0,
                "dev_seller_fee_basis_points": 0,
                "only_proxied_transfers": false,
                "opensea_buyer_fee_basis_points": 0,
                "opensea_seller_fee_basis_points": 250,
                "buyer_fee_basis_points": 0,
                "seller_fee_basis_points": 250,
                "payout_address": null
            },
            "owner": {
                "user": {
                    "username": "NullAddress"
                },
                "profile_img_url": "https://storage.googleapis.com/opensea-static/opensea-profile/1.png",
                "address": "0x0000000000000000000000000000000000000000",
                "config": "",
                "discord_id": ""
            },
            "permalink": "https://opensea.io/assets/0x495f947276749ce646f68ac8c248420045cb7b5e/114735020019161692095051113089976497045262832457918814971796358070624573194241",
            "collection": {
                "banner_image_url": null,
                "chat_url": null,
                "created_date": "2021-05-24T20:56:06.886548",
                "default_to_fiat": false,
                "description": "ColorStones is the NFT collection from Facet Labs Inc.\n\nColorStones are digitally painted images of three unique gemstone shapes. The rarest gemstone shape in the collection is the Pear shape, followed by the Emerald cut, followed by the classic Round cut. Each of the three gemstone shapes was minted in 9 colors, also of varying rarity.  Each ColorStone NFT has one of 36 HEX-denominated background colors.  A full description of the collection is available on the NFT page of facet.us.   The project includes 1,620 ColorStones, and proof of ownership is stored on the Ethereum blockchain. \n",
                "dev_buyer_fee_basis_points": "0",
                "dev_seller_fee_basis_points": "0",
                "discord_url": null,
                "display_data": {
                    "card_display_style": "contain"
                },
                "external_url": null,
                "featured": false,
                "featured_image_url": null,
                "hidden": true,
                "safelist_request_status": "not_requested",
                "image_url": "https://lh3.googleusercontent.com/yXGhHWPXisfgrTQOg6h2hdqMZTJib-xbz7cPoHiuysu57WgvpHeY7rK2X7VSq903EmPuQY8UJ_8pT7BgzTMFUiBLsXZ_WmHj1XzVsA=s120",
                "is_subject_to_whitelist": false,
                "large_image_url": null,
                "medium_username": null,
                "name": "ColorStones",
                "only_proxied_transfers": false,
                "opensea_buyer_fee_basis_points": "0",
                "opensea_seller_fee_basis_points": "250",
                "payout_address": null,
                "require_email": false,
                "short_description": null,
                "slug": "colorstones",
                "telegram_url": null,
                "twitter_username": null,
                "instagram_username": null,
                "wiki_url": null
            },
            "decimals": null,
            "token_metadata": null,
            "sell_orders": null,
            "creator": {
                "user": {
                    "username": "FacetLabs"
                },
                "profile_img_url": "https://storage.googleapis.com/opensea-static/opensea-profile/25.png",
                "address": "0xfda9b8538b0e7b5d6b4843aa936e0532ddf9b877",
                "config": "",
                "discord_id": ""
            },
            "traits": [
                {
                    "trait_type": "background",
                    "value": "#203764",
                    "display_type": null,
                    "max_value": null,
                    "trait_count": 26,
                    "order": null
                },
                {
                    "trait_type": "color",
                    "value": "yellow",
                    "display_type": null,
                    "max_value": null,
                    "trait_count": 0,
                    "order": null
                },
                {
                    "trait_type": "minted",
                    "value": 1,
                    "display_type": "number",
                    "max_value": "5",
                    "trait_count": 0,
                    "order": null
                },
                {
                    "trait_type": "shape",
                    "value": "round",
                    "display_type": null,
                    "max_value": null,
                    "trait_count": 500,
                    "order": null
                }
            ],
            "last_sale": null,
            "top_bid": null,
            "listing_date": null,
            "is_presale": true,
            "transfer_fee_payment_token": null,
            "transfer_fee": null
        },
        {
            "id": 25665472,
            "token_id": "1260",
            "num_sales": 0,
            "background_color": null,
            "image_url": "https://lh3.googleusercontent.com/3G09bcOjSfkbIiCnDTPdcifXndMofduTa9W4fLYcKDu45DoRdLrABJIaa8zFGe9iPTWyAKep2ajzP1wIQ0o5YiWG45xUiPsKgMoogQ",
            "image_preview_url": "https://lh3.googleusercontent.com/3G09bcOjSfkbIiCnDTPdcifXndMofduTa9W4fLYcKDu45DoRdLrABJIaa8zFGe9iPTWyAKep2ajzP1wIQ0o5YiWG45xUiPsKgMoogQ=s250",
            "image_thumbnail_url": "https://lh3.googleusercontent.com/3G09bcOjSfkbIiCnDTPdcifXndMofduTa9W4fLYcKDu45DoRdLrABJIaa8zFGe9iPTWyAKep2ajzP1wIQ0o5YiWG45xUiPsKgMoogQ=s128",
            "image_original_url": "https://embersword.mypinata.cloud/ipfs/QmdbeV27CatL3EddMf2Ek1jGt77amKgb5ghVeHrKWLyz84",
            "animation_url": "https://storage.opensea.io/files/b0cc4d04cbc1f26c66e7511d64cd2d9e.mp4",
            "animation_original_url": "https://embersword.mypinata.cloud/ipfs/QmfKgvFupW1dm9W3UusnrGKrabMT6hTD2DkhG27hAU7Lxx",
            "name": "Land (42,47)",
            "description": "Land plot",
            "external_link": null,
            "asset_contract": {
                "address": "0xe7e16f2da731265778f87cb8d7850e31b84b7b86",
                "asset_contract_type": "non-fungible",
                "created_date": "2021-05-25T13:23:10.895540",
                "name": "Embersword Land",
                "nft_version": null,
                "opensea_version": null,
                "owner": 35978059,
                "schema_name": "ERC721",
                "symbol": "LAND",
                "total_supply": "0",
                "description": null,
                "external_link": "https://embersword.com",
                "image_url": "https://lh3.googleusercontent.com/J7SSCNIDh1ui59aoqyNywPtnUAUB-Q80Cnl1txbxmJOAIKcRJT1bUYidkDPNegOk2W0zyjqVkLbdcI6g6KTYgQCDplCo3DXpDSeaPg=s120",
                "default_to_fiat": false,
                "dev_buyer_fee_basis_points": 0,
                "dev_seller_fee_basis_points": 0,
                "only_proxied_transfers": false,
                "opensea_buyer_fee_basis_points": 0,
                "opensea_seller_fee_basis_points": 250,
                "buyer_fee_basis_points": 0,
                "seller_fee_basis_points": 250,
                "payout_address": null
            },
            "owner": {
                "user": null,
                "profile_img_url": "https://storage.googleapis.com/opensea-static/opensea-profile/1.png",
                "address": "0x0000000000000000000000000000000000000000",
                "config": "",
                "discord_id": ""
            },
            "permalink": "https://opensea.io/assets/matic/0xe7e16f2da731265778f87cb8d7850e31b84b7b86/1260",
            "collection": {
                "banner_image_url": null,
                "chat_url": null,
                "created_date": "2021-05-25T16:51:25.426643",
                "default_to_fiat": false,
                "description": null,
                "dev_buyer_fee_basis_points": "0",
                "dev_seller_fee_basis_points": "0",
                "discord_url": "https://discord.gg/embersword",
                "display_data": {
                    "card_display_style": "contain"
                },
                "external_url": "https://embersword.com",
                "featured": false,
                "featured_image_url": null,
                "hidden": true,
                "safelist_request_status": "not_requested",
                "image_url": "https://lh3.googleusercontent.com/J7SSCNIDh1ui59aoqyNywPtnUAUB-Q80Cnl1txbxmJOAIKcRJT1bUYidkDPNegOk2W0zyjqVkLbdcI6g6KTYgQCDplCo3DXpDSeaPg=s120",
                "is_subject_to_whitelist": false,
                "large_image_url": null,
                "medium_username": "embersword",
                "name": "Ember Sword Land",
                "only_proxied_transfers": false,
                "opensea_buyer_fee_basis_points": "0",
                "opensea_seller_fee_basis_points": "250",
                "payout_address": null,
                "require_email": false,
                "short_description": null,
                "slug": "embersword-land",
                "telegram_url": null,
                "twitter_username": "PlayEmberSword",
                "instagram_username": null,
                "wiki_url": null
            },
            "decimals": null,
            "token_metadata": "https://embersword.mypinata.cloud/ipfs/QmaieNoXmgVgymBb1qNpdxBVKJtwJCUePkJHBAvGAdqEuA",
            "sell_orders": null,
            "creator": null,
            "traits": [
                {
                    "trait_type": "x-coordinate",
                    "value": 42,
                    "display_type": "number",
                    "max_value": null,
                    "trait_count": 0,
                    "order": null
                },
                {
                    "trait_type": "y-coordinate",
                    "value": 47,
                    "display_type": "number",
                    "max_value": null,
                    "trait_count": 0,
                    "order": null
                },
                {
                    "trait_type": "Type",
                    "value": "Land",
                    "display_type": null,
                    "max_value": null,
                    "trait_count": 692,
                    "order": null
                }
            ],
            "last_sale": null,
            "top_bid": null,
            "listing_date": null,
            "is_presale": false,
            "transfer_fee_payment_token": null,
            "transfer_fee": null
        },
        {
            "id": 25665471,
            "token_id": "40545805530391503049949814629283154909091438426243153402829216426302908661761",
            "num_sales": 0,
            "background_color": null,
            "image_url": "https://lh3.googleusercontent.com/qnMzWKSsdWaMQSfPVH4ZQRs8gjmDjD7SnMCbE0H2n-ltnaZh1_l7hAaRC2TkKSX20umnBiMoMH8IzYPuI7ZWUPAz3B4UtgnzO_7R",
            "image_preview_url": "https://lh3.googleusercontent.com/qnMzWKSsdWaMQSfPVH4ZQRs8gjmDjD7SnMCbE0H2n-ltnaZh1_l7hAaRC2TkKSX20umnBiMoMH8IzYPuI7ZWUPAz3B4UtgnzO_7R=s250",
            "image_thumbnail_url": "https://lh3.googleusercontent.com/qnMzWKSsdWaMQSfPVH4ZQRs8gjmDjD7SnMCbE0H2n-ltnaZh1_l7hAaRC2TkKSX20umnBiMoMH8IzYPuI7ZWUPAz3B4UtgnzO_7R=s128",
            "image_original_url": null,
            "animation_url": null,
            "animation_original_url": null,
            "name": "Urchin 2-9b",
            "description": "Endangered veriform. Cycles 2.4min",
            "external_link": null,
            "asset_contract": {
                "address": "0x495f947276749ce646f68ac8c248420045cb7b5e",
                "asset_contract_type": "semi-fungible",
                "created_date": "2020-12-02T17:40:53.232025",
                "name": "OpenSea Collection",
                "nft_version": null,
                "opensea_version": "2.0.0",
                "owner": 102384,
                "schema_name": "ERC1155",
                "symbol": "OPENSTORE",
                "total_supply": null,
                "description": null,
                "external_link": null,
                "image_url": null,
                "default_to_fiat": false,
                "dev_buyer_fee_basis_points": 0,
                "dev_seller_fee_basis_points": 0,
                "only_proxied_transfers": false,
                "opensea_buyer_fee_basis_points": 0,
                "opensea_seller_fee_basis_points": 250,
                "buyer_fee_basis_points": 0,
                "seller_fee_basis_points": 250,
                "payout_address": null
            },
            "owner": {
                "user": {
                    "username": "NullAddress"
                },
                "profile_img_url": "https://storage.googleapis.com/opensea-static/opensea-profile/1.png",
                "address": "0x0000000000000000000000000000000000000000",
                "config": "",
                "discord_id": ""
            },
            "permalink": "https://opensea.io/assets/0x495f947276749ce646f68ac8c248420045cb7b5e/40545805530391503049949814629283154909091438426243153402829216426302908661761",
            "collection": {
                "banner_image_url": null,
                "chat_url": null,
                "created_date": "2021-05-25T22:46:53.594263",
                "default_to_fiat": false,
                "description": "Rarified 3D assets",
                "dev_buyer_fee_basis_points": "0",
                "dev_seller_fee_basis_points": "0",
                "discord_url": null,
                "display_data": {
                    "card_display_style": "contain",
                    "images": []
                },
                "external_url": null,
                "featured": false,
                "featured_image_url": null,
                "hidden": true,
                "safelist_request_status": "not_requested",
                "image_url": "https://lh3.googleusercontent.com/qnMzWKSsdWaMQSfPVH4ZQRs8gjmDjD7SnMCbE0H2n-ltnaZh1_l7hAaRC2TkKSX20umnBiMoMH8IzYPuI7ZWUPAz3B4UtgnzO_7R=s120",
                "is_subject_to_whitelist": false,
                "large_image_url": null,
                "medium_username": null,
                "name": "3d Labs inc.",
                "only_proxied_transfers": false,
                "opensea_buyer_fee_basis_points": "0",
                "opensea_seller_fee_basis_points": "250",
                "payout_address": null,
                "require_email": false,
                "short_description": null,
                "slug": "3d-labs-inc",
                "telegram_url": null,
                "twitter_username": null,
                "instagram_username": null,
                "wiki_url": null
            },
            "decimals": null,
            "token_metadata": null,
            "sell_orders": null,
            "creator": {
                "user": {
                    "username": null
                },
                "profile_img_url": "https://storage.googleapis.com/opensea-static/opensea-profile/3.png",
                "address": "0x59a41cd8943c1d8bd9058555f9cfe62e30b4d5b7",
                "config": "",
                "discord_id": ""
            },
            "traits": [
                {
                    "trait_type": "object",
                    "value": "androdgynous ",
                    "display_type": null,
                    "max_value": null,
                    "trait_count": 0,
                    "order": null
                }
            ],
            "last_sale": null,
            "top_bid": null,
            "listing_date": null,
            "is_presale": true,
            "transfer_fee_payment_token": null,
            "transfer_fee": null
        },
        {
            "id": 25665470,
            "token_id": "1674",
            "num_sales": 0,
            "background_color": null,
            "image_url": "https://lh3.googleusercontent.com/rifyot7gufIwLeUWOIvMpVUa9FSOjvM1HxlGcBZVELLJXqu0ZS44xwBfBdyFrpYlT-xRckaYzOHZJRpI9kxllKC-m9n7yA0l6qHUzw",
            "image_preview_url": "https://lh3.googleusercontent.com/rifyot7gufIwLeUWOIvMpVUa9FSOjvM1HxlGcBZVELLJXqu0ZS44xwBfBdyFrpYlT-xRckaYzOHZJRpI9kxllKC-m9n7yA0l6qHUzw=s250",
            "image_thumbnail_url": "https://lh3.googleusercontent.com/rifyot7gufIwLeUWOIvMpVUa9FSOjvM1HxlGcBZVELLJXqu0ZS44xwBfBdyFrpYlT-xRckaYzOHZJRpI9kxllKC-m9n7yA0l6qHUzw=s128",
            "image_original_url": "https://cdn.veefriends.com/f6pXbdBrDkgJjmSV-_XTrDCsS97-QXp2H6Yu0fLSCB0/975.png",
            "animation_url": null,
            "animation_original_url": null,
            "name": "Caring Camel",
            "description": "This token is verifiable for admission to VeeCon 2022, 2023, 2024\n\nThis token is a collectible that lives on the Ethereum blockchain\n\nAdditional Content:\n\n- [Character Vector](https://cdn.veefriends.com/f6pXbdBrDkgJjmSV-_XTrDCsS97-QXp2H6Yu0fLSCB0/3184.svg)\n- [Character Image](https://cdn.veefriends.com/f6pXbdBrDkgJjmSV-_XTrDCsS97-QXp2H6Yu0fLSCB0/2708.png) \n- [Character Creation Video](https://cdn.veefriends.com/f6pXbdBrDkgJjmSV-_XTrDCsS97-QXp2H6Yu0fLSCB0/961.mp4)\n- [Character with Gary Vaynerchuk](https://cdn.veefriends.com/f6pXbdBrDkgJjmSV-_XTrDCsS97-QXp2H6Yu0fLSCB0/509.jpg)",
            "external_link": null,
            "asset_contract": {
                "address": "0xa3aee8bce55beea1951ef834b99f3ac60d1abeeb",
                "asset_contract_type": "non-fungible",
                "created_date": "2021-05-11T17:30:01.380820",
                "name": "VeeFriends",
                "nft_version": "3.0",
                "opensea_version": null,
                "owner": 41520829,
                "schema_name": "ERC721",
                "symbol": "VFT",
                "total_supply": "0",
                "description": "A Gary Vaynerchuk NFT project around meaningful intellectual property and an extraordinary community.",
                "external_link": "https://veefriends.com/",
                "image_url": "https://lh3.googleusercontent.com/5y-UCAXiNOFXH551w5bWdZEYOCdHPwbqmcKb-xa3uVQEjQgxvih3HtZWSmzqDqd0uk7kIqFrZhw32Gt6xPBFg4t_n9BKhpou-dwnOg=s120",
                "default_to_fiat": false,
                "dev_buyer_fee_basis_points": 0,
                "dev_seller_fee_basis_points": 1000,
                "only_proxied_transfers": false,
                "opensea_buyer_fee_basis_points": 0,
                "opensea_seller_fee_basis_points": 250,
                "buyer_fee_basis_points": 0,
                "seller_fee_basis_points": 1250,
                "payout_address": "0x263a1c688c4426eede9b57e741ffb2b9cadcca94"
            },
            "owner": {
                "user": null,
                "profile_img_url": "https://storage.googleapis.com/opensea-static/opensea-profile/22.png",
                "address": "0x48a89359c9caf5d952fd01aa9d8f176d7cdc4346",
                "config": "",
                "discord_id": ""
            },
            "permalink": "https://opensea.io/assets/0xa3aee8bce55beea1951ef834b99f3ac60d1abeeb/1674",
            "collection": {
                "banner_image_url": "https://lh3.googleusercontent.com/4RYeNt3ET75VLMoCZz-fsOhXg8AW8qlkHfgkbA0FfEayNpsHvOZROygyy9IhY4LwrnJUXqkeDjBZBr8bCf0Ng_xUiRZqWRGng3sc=s2500",
                "chat_url": null,
                "created_date": "2021-05-11T18:22:19.398578",
                "default_to_fiat": false,
                "description": "A Gary Vaynerchuk NFT project around meaningful intellectual property and an extraordinary community.",
                "dev_buyer_fee_basis_points": "0",
                "dev_seller_fee_basis_points": "1000",
                "discord_url": null,
                "display_data": {
                    "card_display_style": "cover"
                },
                "external_url": "https://veefriends.com/",
                "featured": false,
                "featured_image_url": "https://lh3.googleusercontent.com/4aSYyyyW-c2Vmh_-OSG4W5szSXF6dIjGuFkbp99DqE7f4liwytRHKfBiZ1zyXKI8RTCAvBVRfZL06IO7V-AY7LMTOnZaBx0S60X92g=s300",
                "hidden": false,
                "safelist_request_status": "verified",
                "image_url": "https://lh3.googleusercontent.com/5y-UCAXiNOFXH551w5bWdZEYOCdHPwbqmcKb-xa3uVQEjQgxvih3HtZWSmzqDqd0uk7kIqFrZhw32Gt6xPBFg4t_n9BKhpou-dwnOg=s120",
                "is_subject_to_whitelist": false,
                "large_image_url": "https://lh3.googleusercontent.com/4aSYyyyW-c2Vmh_-OSG4W5szSXF6dIjGuFkbp99DqE7f4liwytRHKfBiZ1zyXKI8RTCAvBVRfZL06IO7V-AY7LMTOnZaBx0S60X92g=s300",
                "medium_username": null,
                "name": "VeeFriends",
                "only_proxied_transfers": false,
                "opensea_buyer_fee_basis_points": "0",
                "opensea_seller_fee_basis_points": "250",
                "payout_address": "0x263a1c688c4426eede9b57e741ffb2b9cadcca94",
                "require_email": false,
                "short_description": null,
                "slug": "veefriends",
                "telegram_url": null,
                "twitter_username": "veefriends",
                "instagram_username": "veefriends",
                "wiki_url": null
            },
            "decimals": 0,
            "token_metadata": "https://erc721.veefriends.com/api/metadata/0xa3aee8bce55beea1951ef834b99f3ac60d1abeeb/1674",
            "sell_orders": null,
            "creator": {
                "user": null,
                "profile_img_url": "https://storage.googleapis.com/opensea-static/opensea-profile/22.png",
                "address": "0x48a89359c9caf5d952fd01aa9d8f176d7cdc4346",
                "config": "",
                "discord_id": ""
            },
            "traits": [
                {
                    "trait_type": "adjective",
                    "value": "Caring",
                    "display_type": null,
                    "max_value": null,
                    "trait_count": 38,
                    "order": null
                },
                {
                    "trait_type": "animal",
                    "value": "Camel",
                    "display_type": null,
                    "max_value": null,
                    "trait_count": 38,
                    "order": null
                },
                {
                    "trait_type": "group",
                    "value": "Admission",
                    "display_type": null,
                    "max_value": null,
                    "trait_count": 8542,
                    "order": null
                },
                {
                    "trait_type": "conference",
                    "value": "Limited",
                    "display_type": null,
                    "max_value": null,
                    "trait_count": 3842,
                    "order": null
                },
                {
                    "trait_type": "creator",
                    "value": "VeeFriends",
                    "display_type": null,
                    "max_value": null,
                    "trait_count": 9371,
                    "order": null
                },
                {
                    "trait_type": "Edition #",
                    "value": "1",
                    "display_type": null,
                    "max_value": null,
                    "trait_count": 1708,
                    "order": null
                },
                {
                    "trait_type": "Editions",
                    "value": "1 of 1",
                    "display_type": null,
                    "max_value": null,
                    "trait_count": 900,
                    "order": null
                },
                {
                    "trait_type": "OG Buyer",
                    "value": "0x48A89359c9CAF5d952fd01aa9D8f176D7cdc4346",
                    "display_type": null,
                    "max_value": null,
                    "trait_count": 34,
                    "order": null
                },
                {
                    "trait_type": "rarity",
                    "value": "Spectacular",
                    "display_type": null,
                    "max_value": null,
                    "trait_count": 835,
                    "order": null
                },
                {
                    "trait_type": "OG Price",
                    "value": "3 Ξ",
                    "display_type": null,
                    "max_value": null,
                    "trait_count": 762,
                    "order": null
                },
                {
                    "trait_type": "spectacular",
                    "value": "Gold",
                    "display_type": null,
                    "max_value": null,
                    "trait_count": 152,
                    "order": null
                },
                {
                    "trait_type": "category",
                    "value": "Mammal",
                    "display_type": null,
                    "max_value": null,
                    "trait_count": 4102,
                    "order": null
                },
                {
                    "trait_type": "property",
                    "value": "1 of 1 Art",
                    "display_type": null,
                    "max_value": null,
                    "trait_count": 895,
                    "order": null
                },
                {
                    "trait_type": "Birthday",
                    "value": 1621982913.0,
                    "display_type": "date",
                    "max_value": null,
                    "trait_count": 0,
                    "order": null
                }
            ],
            "last_sale": null,
            "top_bid": null,
            "listing_date": null,
            "is_presale": false,
            "transfer_fee_payment_token": null,
            "transfer_fee": null
        },
        {
            "id": 25665469,
            "token_id": "2115362",
            "num_sales": 0,
            "background_color": null,
            "image_url": "https://lh3.googleusercontent.com/LGqq945PgeJ6VMCXMoIHAI4g_nz_D6_YwJr9qHoo2te019hif45JdPlAo2bl83pofL-F2q4RyXF4Mubfw0bWwieoasO539W_j20M",
            "image_preview_url": "https://lh3.googleusercontent.com/LGqq945PgeJ6VMCXMoIHAI4g_nz_D6_YwJr9qHoo2te019hif45JdPlAo2bl83pofL-F2q4RyXF4Mubfw0bWwieoasO539W_j20M=s250",
            "image_thumbnail_url": "https://lh3.googleusercontent.com/LGqq945PgeJ6VMCXMoIHAI4g_nz_D6_YwJr9qHoo2te019hif45JdPlAo2bl83pofL-F2q4RyXF4Mubfw0bWwieoasO539W_j20M=s128",
            "image_original_url": "https://patch.krtd.kakaogames.com/img/202105/2115362.png",
            "animation_url": null,
            "animation_original_url": null,
            "name": "Ny",
            "description": "전투에서 이탈한 드래곤을 부활시킵니다.",
            "external_link": null,
            "asset_contract": {
                "address": "0x0eaddf500c9a07746e068aea73fac7f85749c5e3",
                "asset_contract_type": "non-fungible",
                "created_date": "2020-12-18T07:44:50.910827",
                "name": null,
                "nft_version": null,
                "opensea_version": null,
                "owner": null,
                "schema_name": "ERC721",
                "symbol": "",
                "total_supply": null,
                "description": "Collect dragons using blockchain technology, Win the battlefield through strategic battles!",
                "external_link": null,
                "image_url": "https://lh3.googleusercontent.com/K6Pu6tSxu1sOj1xT4gue9-NqHr5J533TCmsOAQ_J9_4PYz5FGAij2my20bvRJmRwB7yYfI-_ry2-9tdOyPFa5ppFkunPUZTApmP7=s120",
                "default_to_fiat": false,
                "dev_buyer_fee_basis_points": 0,
                "dev_seller_fee_basis_points": 0,
                "only_proxied_transfers": false,
                "opensea_buyer_fee_basis_points": 0,
                "opensea_seller_fee_basis_points": 250,
                "buyer_fee_basis_points": 0,
                "seller_fee_basis_points": 250,
                "payout_address": null
            },
            "owner": {
                "user": null,
                "profile_img_url": "https://storage.googleapis.com/opensea-static/opensea-profile/1.png",
                "address": "0x0000000000000000000000000000000000000000",
                "config": "",
                "discord_id": ""
            },
            "permalink": "https://opensea.io/assets/klaytn/0x0eaddf500c9a07746e068aea73fac7f85749c5e3/2115362",
            "collection": {
                "banner_image_url": null,
                "chat_url": null,
                "created_date": "2020-12-18T07:44:51.844271",
                "default_to_fiat": false,
                "description": "Collect dragons using blockchain technology, Win the battlefield through strategic battles!",
                "dev_buyer_fee_basis_points": "0",
                "dev_seller_fee_basis_points": "0",
                "discord_url": null,
                "display_data": {
                    "card_display_style": "contain"
                },
                "external_url": null,
                "featured": false,
                "featured_image_url": null,
                "hidden": true,
                "safelist_request_status": "not_requested",
                "image_url": "https://lh3.googleusercontent.com/K6Pu6tSxu1sOj1xT4gue9-NqHr5J533TCmsOAQ_J9_4PYz5FGAij2my20bvRJmRwB7yYfI-_ry2-9tdOyPFa5ppFkunPUZTApmP7=s120",
                "is_subject_to_whitelist": false,
                "large_image_url": null,
                "medium_username": null,
                "name": "CryptoDragons",
                "only_proxied_transfers": false,
                "opensea_buyer_fee_basis_points": "0",
                "opensea_seller_fee_basis_points": "250",
                "payout_address": null,
                "require_email": false,
                "short_description": null,
                "slug": "cryptodragons-klatyn",
                "telegram_url": null,
                "twitter_username": null,
                "instagram_username": null,
                "wiki_url": null
            },
            "decimals": null,
            "token_metadata": "https://patch.krtd.kakaogames.com/img/json/2115362",
            "sell_orders": null,
            "creator": null,
            "traits": [
                {
                    "trait_type": "세대",
                    "value": "26",
                    "display_type": null,
                    "max_value": null,
                    "trait_count": 33,
                    "order": null
                },
                {
                    "trait_type": "역할",
                    "value": "지원형",
                    "display_type": null,
                    "max_value": null,
                    "trait_count": 4459,
                    "order": null
                },
                {
                    "trait_type": "속성",
                    "value": "독",
                    "display_type": null,
                    "max_value": null,
                    "trait_count": 2641,
                    "order": null
                },
                {
                    "trait_type": "교배능력",
                    "value": "매우 느림",
                    "display_type": null,
                    "max_value": null,
                    "trait_count": 897,
                    "order": null
                },
                {
                    "trait_type": "방어력",
                    "value": "500",
                    "display_type": null,
                    "max_value": null,
                    "trait_count": 9191,
                    "order": null
                },
                {
                    "trait_type": "스킬레벨",
                    "value": "1 / 58",
                    "display_type": null,
                    "max_value": null,
                    "trait_count": 98,
                    "order": null
                },
                {
                    "trait_type": "체력",
                    "value": "4200",
                    "display_type": null,
                    "max_value": null,
                    "trait_count": 2197,
                    "order": null
                },
                {
                    "trait_type": "공격력",
                    "value": "840",
                    "display_type": null,
                    "max_value": null,
                    "trait_count": 1150,
                    "order": null
                },
                {
                    "trait_type": "스킬",
                    "value": "부활",
                    "display_type": null,
                    "max_value": null,
                    "trait_count": 386,
                    "order": null
                },
                {
                    "trait_type": "레어도",
                    "value": "1성",
                    "display_type": null,
                    "max_value": null,
                    "trait_count": 3389,
                    "order": null
                },
                {
                    "trait_type": "레벨",
                    "value": "1 / 15",
                    "display_type": null,
                    "max_value": null,
                    "trait_count": 2932,
                    "order": null
                },
                {
                    "trait_type": "최초 생성일",
                    "value": "2021. 5. 26",
                    "display_type": null,
                    "max_value": null,
                    "trait_count": 0,
                    "order": null
                }
            ],
            "last_sale": null,
            "top_bid": null,
            "listing_date": null,
            "is_presale": false,
            "transfer_fee_payment_token": null,
            "transfer_fee": null
        },
        {
            "id": 25665468,
            "token_id": "6",
            "num_sales": 0,
            "background_color": null,
            "image_url": "https://lh3.googleusercontent.com/vBpjgGDK2F6JWNqWwq-XPvNzbJZhEpwVlk1SEew5YiGSwOWWPQ516oG7Qtd6XCj-0eAlDasGdUHFIoMtKoJlfKpUnEB8lYZVBR1G",
            "image_preview_url": "https://lh3.googleusercontent.com/vBpjgGDK2F6JWNqWwq-XPvNzbJZhEpwVlk1SEew5YiGSwOWWPQ516oG7Qtd6XCj-0eAlDasGdUHFIoMtKoJlfKpUnEB8lYZVBR1G=s250",
            "image_thumbnail_url": "https://lh3.googleusercontent.com/vBpjgGDK2F6JWNqWwq-XPvNzbJZhEpwVlk1SEew5YiGSwOWWPQ516oG7Qtd6XCj-0eAlDasGdUHFIoMtKoJlfKpUnEB8lYZVBR1G=s128",
            "image_original_url": "https://ipfs.io/ipfs/QmWVbJHNWSmPTGD2GHk56BKheYBP4z3ehnMH1Tjeg4DKPe/image.gif",
            "animation_url": "https://storage.opensea.io/files/3e46a2e3d37b1c945d8ae1b5abade6c9.mp4",
            "animation_original_url": "https://ipfs.io/ipfs/QmWVbJHNWSmPTGD2GHk56BKheYBP4z3ehnMH1Tjeg4DKPe/animation.mp4",
            "name": "PRYZ Inner Circle #3",
            "description": "PRYZ Inner Circle #3 NFT",
            "external_link": "https://rarible.com/token/0x738eac460d6736b05998d9569b37ec224e58dc3e:6",
            "asset_contract": {
                "address": "0x738eac460d6736b05998d9569b37ec224e58dc3e",
                "asset_contract_type": "non-fungible",
                "created_date": "2021-05-25T22:37:28.106613",
                "name": "PRYZ Inner Circle #2 - #100",
                "nft_version": "3.0",
                "opensea_version": null,
                "owner": 38237349,
                "schema_name": "ERC721",
                "symbol": "PRYZ",
                "total_supply": "0",
                "description": "PRYZ Inner Circle NFT Collection",
                "external_link": "https://app.rarible.com/collection/0x738eac460d6736b05998d9569b37ec224e58dc3e",
                "image_url": "https://lh3.googleusercontent.com/3_3uJL4DC0ORZLrScedqqs7S7Lz6DRCEa05I7CPrx919ZSzjVCbuvPDC_71Mt9xAle_8RhvGD6u7BaAIzt1MstwD29V_sC7bcxDn=s120",
                "default_to_fiat": false,
                "dev_buyer_fee_basis_points": 0,
                "dev_seller_fee_basis_points": 0,
                "only_proxied_transfers": false,
                "opensea_buyer_fee_basis_points": 0,
                "opensea_seller_fee_basis_points": 250,
                "buyer_fee_basis_points": 0,
                "seller_fee_basis_points": 250,
                "payout_address": null
            },
            "owner": {
                "user": {
                    "username": "PryzTeam"
                },
                "profile_img_url": "https://storage.googleapis.com/opensea-static/opensea-profile/32.png",
                "address": "0x076e6410e3e3616ea030a9a79390db7d6d83d324",
                "config": "",
                "discord_id": ""
            },
            "permalink": "https://opensea.io/assets/0x738eac460d6736b05998d9569b37ec224e58dc3e/6",
            "collection": {
                "banner_image_url": null,
                "chat_url": null,
                "created_date": "2021-05-25T22:39:05.641291",
                "default_to_fiat": false,
                "description": "PRYZ Inner Circle NFT Collection",
                "dev_buyer_fee_basis_points": "0",
                "dev_seller_fee_basis_points": "0",
                "discord_url": null,
                "display_data": {
                    "card_display_style": "contain"
                },
                "external_url": "https://app.rarible.com/collection/0x738eac460d6736b05998d9569b37ec224e58dc3e",
                "featured": false,
                "featured_image_url": null,
                "hidden": true,
                "safelist_request_status": "not_requested",
                "image_url": "https://lh3.googleusercontent.com/3_3uJL4DC0ORZLrScedqqs7S7Lz6DRCEa05I7CPrx919ZSzjVCbuvPDC_71Mt9xAle_8RhvGD6u7BaAIzt1MstwD29V_sC7bcxDn=s120",
                "is_subject_to_whitelist": false,
                "large_image_url": "https://lh3.googleusercontent.com/3_3uJL4DC0ORZLrScedqqs7S7Lz6DRCEa05I7CPrx919ZSzjVCbuvPDC_71Mt9xAle_8RhvGD6u7BaAIzt1MstwD29V_sC7bcxDn",
                "medium_username": null,
                "name": "PRYZ Inner Circle #2 - #100",
                "only_proxied_transfers": false,
                "opensea_buyer_fee_basis_points": "0",
                "opensea_seller_fee_basis_points": "250",
                "payout_address": null,
                "require_email": false,
                "short_description": null,
                "slug": "pryz-inner-circle-2-100",
                "telegram_url": null,
                "twitter_username": null,
                "instagram_username": null,
                "wiki_url": null
            },
            "decimals": 0,
            "token_metadata": "https://ipfs.io/ipfs/QmZrEVX4HNrNRVtS9QPyCxvBJq12rGsKMkH13MDNMmPWpK",
            "sell_orders": [
                {
                    "created_date": "2021-05-25T22:49:35.074542",
                    "closing_date": null,
                    "closing_extendable": false,
                    "expiration_time": 0,
                    "listing_time": 1621982870,
                    "order_hash": "0xb4e79415f1633d404cba746a4d1cbd27a19fe6312f3c02e06321a3e0660e08b9",
                    "metadata": {
                        "asset": {
                            "id": "6",
                            "address": "0x738eac460d6736b05998d9569b37ec224e58dc3e"
                        },
                        "schema": "ERC721"
                    },
                    "exchange": "0x7be8076f4ea4a4ad08075c2508e481d6c946d12b",
                    "maker": {
                        "user": 847905,
                        "profile_img_url": "https://storage.googleapis.com/opensea-static/opensea-profile/32.png",
                        "address": "0x076e6410e3e3616ea030a9a79390db7d6d83d324",
                        "config": "",
                        "discord_id": ""
                    },
                    "taker": {
                        "user": 1766,
                        "profile_img_url": "https://storage.googleapis.com/opensea-static/opensea-profile/1.png",
                        "address": "0x0000000000000000000000000000000000000000",
                        "config": "",
                        "discord_id": ""
                    },
                    "current_price": "2500000000",
                    "current_bounty": "25000000",
                    "bounty_multiple": "0.01",
                    "maker_relayer_fee": "250",
                    "taker_relayer_fee": "0",
                    "maker_protocol_fee": "0",
                    "taker_protocol_fee": "0",
                    "maker_referrer_fee": "0",
                    "fee_recipient": {
                        "user": 3585,
                        "profile_img_url": "https://storage.googleapis.com/opensea-static/opensea-profile/28.png",
                        "address": "0x5b3256965e7c3cf26e11fcaf296dfc8807c01073",
                        "config": "verified",
                        "discord_id": ""
                    },
                    "fee_method": 1,
                    "side": 1,
                    "sale_kind": 0,
                    "target": "0x738eac460d6736b05998d9569b37ec224e58dc3e",
                    "how_to_call": 0,
                    "calldata": "0x23b872dd000000000000000000000000076e6410e3e3616ea030a9a79390db7d6d83d32400000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000006",
                    "replacement_pattern": "0x000000000000000000000000000000000000000000000000000000000000000000000000ffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffff0000000000000000000000000000000000000000000000000000000000000000",
                    "static_target": "0x0000000000000000000000000000000000000000",
                    "static_extradata": "0x",
                    "payment_token": "0xa0b86991c6218b36c1d19d4a2e9eb0ce3606eb48",
                    "payment_token_contract": {
                        "id": 7,
                        "symbol": "USDC",
                        "address": "0xa0b86991c6218b36c1d19d4a2e9eb0ce3606eb48",
                        "image_url": "https://lh3.googleusercontent.com/PxC_K0Y22A1Xs0CeVknf4YUSxSqH_1bPCG0a4uD7WRkwbbtinqryjDEvoTYSbBFDXXTliuyo38-Y_ecNUEj0fMimQA",
                        "name": "USD Coin",
                        "decimals": 6,
                        "eth_price": "0.000389076293970",
                        "usd_price": "1.000000000000000000"
                    },
                    "base_price": "2500000000",
                    "extra": "0",
                    "quantity": "1",
                    "salt": "47205588936218046207972882326843048324811229990269957330200433567982142956436",
                    "v": 28,
                    "r": "0xc869609c9269d8f9a938c4de96158c1b2a71341ab39f1f5dad6e3cb54c153ca5",
                    "s": "0x66e26563f580fac0f4833a925854902acc27495fb2657fd1ceea25e01ada3258",
                    "approved_on_chain": false,
                    "cancelled": false,
                    "finalized": false,
                    "marked_invalid": false,
                    "prefixed_hash": "0x4f5eff7a1d037814e729f0a98a2ee35b9a2bc777f0895004f8798bd834072e5d"
                }
            ],
            "creator": {
                "user": {
                    "username": "PryzTeam"
                },
                "profile_img_url": "https://storage.googleapis.com/opensea-static/opensea-profile/32.png",
                "address": "0x076e6410e3e3616ea030a9a79390db7d6d83d324",
                "config": "",
                "discord_id": ""
            },
            "traits": [],
            "last_sale": null,
            "top_bid": null,
            "listing_date": null,
            "is_presale": false,
            "transfer_fee_payment_token": null,
            "transfer_fee": null
        },
        {
            "id": 25665467,
            "token_id": "1259",
            "num_sales": 0,
            "background_color": null,
            "image_url": "https://lh3.googleusercontent.com/3G09bcOjSfkbIiCnDTPdcifXndMofduTa9W4fLYcKDu45DoRdLrABJIaa8zFGe9iPTWyAKep2ajzP1wIQ0o5YiWG45xUiPsKgMoogQ",
            "image_preview_url": "https://lh3.googleusercontent.com/3G09bcOjSfkbIiCnDTPdcifXndMofduTa9W4fLYcKDu45DoRdLrABJIaa8zFGe9iPTWyAKep2ajzP1wIQ0o5YiWG45xUiPsKgMoogQ=s250",
            "image_thumbnail_url": "https://lh3.googleusercontent.com/3G09bcOjSfkbIiCnDTPdcifXndMofduTa9W4fLYcKDu45DoRdLrABJIaa8zFGe9iPTWyAKep2ajzP1wIQ0o5YiWG45xUiPsKgMoogQ=s128",
            "image_original_url": "https://embersword.mypinata.cloud/ipfs/QmdbeV27CatL3EddMf2Ek1jGt77amKgb5ghVeHrKWLyz84",
            "animation_url": "https://storage.opensea.io/files/b0cc4d04cbc1f26c66e7511d64cd2d9e.mp4",
            "animation_original_url": "https://embersword.mypinata.cloud/ipfs/QmfKgvFupW1dm9W3UusnrGKrabMT6hTD2DkhG27hAU7Lxx",
            "name": "Land (42,48)",
            "description": "Land plot",
            "external_link": null,
            "asset_contract": {
                "address": "0xe7e16f2da731265778f87cb8d7850e31b84b7b86",
                "asset_contract_type": "non-fungible",
                "created_date": "2021-05-25T13:23:10.895540",
                "name": "Embersword Land",
                "nft_version": null,
                "opensea_version": null,
                "owner": 35978059,
                "schema_name": "ERC721",
                "symbol": "LAND",
                "total_supply": "0",
                "description": null,
                "external_link": "https://embersword.com",
                "image_url": "https://lh3.googleusercontent.com/J7SSCNIDh1ui59aoqyNywPtnUAUB-Q80Cnl1txbxmJOAIKcRJT1bUYidkDPNegOk2W0zyjqVkLbdcI6g6KTYgQCDplCo3DXpDSeaPg=s120",
                "default_to_fiat": false,
                "dev_buyer_fee_basis_points": 0,
                "dev_seller_fee_basis_points": 0,
                "only_proxied_transfers": false,
                "opensea_buyer_fee_basis_points": 0,
                "opensea_seller_fee_basis_points": 250,
                "buyer_fee_basis_points": 0,
                "seller_fee_basis_points": 250,
                "payout_address": null
            },
            "owner": {
                "user": null,
                "profile_img_url": "https://storage.googleapis.com/opensea-static/opensea-profile/1.png",
                "address": "0x0000000000000000000000000000000000000000",
                "config": "",
                "discord_id": ""
            },
            "permalink": "https://opensea.io/assets/matic/0xe7e16f2da731265778f87cb8d7850e31b84b7b86/1259",
            "collection": {
                "banner_image_url": null,
                "chat_url": null,
                "created_date": "2021-05-25T16:51:25.426643",
                "default_to_fiat": false,
                "description": null,
                "dev_buyer_fee_basis_points": "0",
                "dev_seller_fee_basis_points": "0",
                "discord_url": "https://discord.gg/embersword",
                "display_data": {
                    "card_display_style": "contain"
                },
                "external_url": "https://embersword.com",
                "featured": false,
                "featured_image_url": null,
                "hidden": true,
                "safelist_request_status": "not_requested",
                "image_url": "https://lh3.googleusercontent.com/J7SSCNIDh1ui59aoqyNywPtnUAUB-Q80Cnl1txbxmJOAIKcRJT1bUYidkDPNegOk2W0zyjqVkLbdcI6g6KTYgQCDplCo3DXpDSeaPg=s120",
                "is_subject_to_whitelist": false,
                "large_image_url": null,
                "medium_username": "embersword",
                "name": "Ember Sword Land",
                "only_proxied_transfers": false,
                "opensea_buyer_fee_basis_points": "0",
                "opensea_seller_fee_basis_points": "250",
                "payout_address": null,
                "require_email": false,
                "short_description": null,
                "slug": "embersword-land",
                "telegram_url": null,
                "twitter_username": "PlayEmberSword",
                "instagram_username": null,
                "wiki_url": null
            },
            "decimals": null,
            "token_metadata": "https://embersword.mypinata.cloud/ipfs/QmboUtKEJ1sr9oXsLooLzPntGxfoifrGddAwDRTzLJ5rJc",
            "sell_orders": null,
            "creator": null,
            "traits": [
                {
                    "trait_type": "x-coordinate",
                    "value": 42,
                    "display_type": "number",
                    "max_value": null,
                    "trait_count": 0,
                    "order": null
                },
                {
                    "trait_type": "Type",
                    "value": "Land",
                    "display_type": null,
                    "max_value": null,
                    "trait_count": 692,
                    "order": null
                },
                {
                    "trait_type": "y-coordinate",
                    "value": 48,
                    "display_type": "number",
                    "max_value": null,
                    "trait_count": 0,
                    "order": null
                }
            ],
            "last_sale": null,
            "top_bid": null,
            "listing_date": null,
            "is_presale": false,
            "transfer_fee_payment_token": null,
            "transfer_fee": null
        },
        {
            "id": 25665466,
            "token_id": "20779687020901315104817932847033512423599216699667133632923091504261102567425",
            "num_sales": 0,
            "background_color": null,
            "image_url": "https://lh3.googleusercontent.com/FE1u-Ib9Jz5B1bgHjd2B07MD10vBg5KSJd6IH3FA9ceqybgbT3vP__FqI94r4GXaRmto1DV8zvEHvecrLwzLzDEOkAhQv2GgGyyy88U",
            "image_preview_url": "https://lh3.googleusercontent.com/FE1u-Ib9Jz5B1bgHjd2B07MD10vBg5KSJd6IH3FA9ceqybgbT3vP__FqI94r4GXaRmto1DV8zvEHvecrLwzLzDEOkAhQv2GgGyyy88U=s250",
            "image_thumbnail_url": "https://lh3.googleusercontent.com/FE1u-Ib9Jz5B1bgHjd2B07MD10vBg5KSJd6IH3FA9ceqybgbT3vP__FqI94r4GXaRmto1DV8zvEHvecrLwzLzDEOkAhQv2GgGyyy88U=s128",
            "image_original_url": null,
            "animation_url": "https://storage.opensea.io/files/5dfc087563d699176659aebc8ce83389.mp4",
            "animation_original_url": "https://storage.opensea.io/files/5dfc087563d699176659aebc8ce83389.mp4",
            "name": "Cublitz #1681",
            "description": null,
            "external_link": null,
            "asset_contract": {
                "address": "0x495f947276749ce646f68ac8c248420045cb7b5e",
                "asset_contract_type": "semi-fungible",
                "created_date": "2020-12-02T17:40:53.232025",
                "name": "OpenSea Collection",
                "nft_version": null,
                "opensea_version": "2.0.0",
                "owner": 102384,
                "schema_name": "ERC1155",
                "symbol": "OPENSTORE",
                "total_supply": null,
                "description": null,
                "external_link": null,
                "image_url": null,
                "default_to_fiat": false,
                "dev_buyer_fee_basis_points": 0,
                "dev_seller_fee_basis_points": 0,
                "only_proxied_transfers": false,
                "opensea_buyer_fee_basis_points": 0,
                "opensea_seller_fee_basis_points": 250,
                "buyer_fee_basis_points": 0,
                "seller_fee_basis_points": 250,
                "payout_address": null
            },
            "owner": {
                "user": {
                    "username": "NullAddress"
                },
                "profile_img_url": "https://storage.googleapis.com/opensea-static/opensea-profile/1.png",
                "address": "0x0000000000000000000000000000000000000000",
                "config": "",
                "discord_id": ""
            },
            "permalink": "https://opensea.io/assets/0x495f947276749ce646f68ac8c248420045cb7b5e/20779687020901315104817932847033512423599216699667133632923091504261102567425",
            "collection": {
                "banner_image_url": "https://lh3.googleusercontent.com/gFpU2HWWO4G53qKLkonFjlhLvkOyrnuC_PFMLHghOQwr6ZbL4YTQGwYQFjG703JYfreeicn_Q9qtFIGvOqT_3qq0J1m_NYYM8DlO0yY=s2500",
                "chat_url": null,
                "created_date": "2021-05-15T17:29:16.297787",
                "default_to_fiat": false,
                "description": "10,000 randomly generated animated NFT's. 3D rendered dancing blockheads with over 15 million possible combinations of species, professions, colors, and accessories.",
                "dev_buyer_fee_basis_points": "0",
                "dev_seller_fee_basis_points": "500",
                "discord_url": "https://discord.gg/gY4fQwR59E",
                "display_data": {
                    "card_display_style": "contain"
                },
                "external_url": null,
                "featured": false,
                "featured_image_url": "https://lh3.googleusercontent.com/DUQIBKJCZqkIueysZ-vf8Xh1bqTDin3rSBWz87slZ0Ttqg7cJtcmizTpGBJQKB230YJjbHkenjkNICcXsME9jy6FNUPECQsbntECLA=s300",
                "hidden": true,
                "safelist_request_status": "not_requested",
                "image_url": "https://lh3.googleusercontent.com/JKzgo-XGir844sKoqbj3wca19WSGfTca54E2txRIk4XUVUCd-bnY0bVlmBS7IYr5_fs-3T2rPlnKQIKJQgWSKBrKuEmitX8zBGl0Cg=s120",
                "is_subject_to_whitelist": false,
                "large_image_url": "https://lh3.googleusercontent.com/DUQIBKJCZqkIueysZ-vf8Xh1bqTDin3rSBWz87slZ0Ttqg7cJtcmizTpGBJQKB230YJjbHkenjkNICcXsME9jy6FNUPECQsbntECLA=s300",
                "medium_username": null,
                "name": "Cublitz",
                "only_proxied_transfers": false,
                "opensea_buyer_fee_basis_points": "0",
                "opensea_seller_fee_basis_points": "250",
                "payout_address": "0x2df0e2d512a76fbc761a7df0811ecb2f3556a8a4",
                "require_email": false,
                "short_description": null,
                "slug": "cublitz",
                "telegram_url": null,
                "twitter_username": "cublitz",
                "instagram_username": null,
                "wiki_url": null
            },
            "decimals": null,
            "token_metadata": null,
            "sell_orders": null,
            "creator": {
                "user": {
                    "username": "DedRedArt"
                },
                "profile_img_url": "https://storage.googleapis.com/opensea-static/opensea-profile/30.png",
                "address": "0x2df0e2d512a76fbc761a7df0811ecb2f3556a8a4",
                "config": "",
                "discord_id": ""
            },
            "traits": [
                {
                    "trait_type": "Race",
                    "value": "Dog",
                    "display_type": null,
                    "max_value": null,
                    "trait_count": 224,
                    "order": null
                },
                {
                    "trait_type": "Eyes",
                    "value": "Squinty",
                    "display_type": null,
                    "max_value": null,
                    "trait_count": 151,
                    "order": null
                },
                {
                    "trait_type": "Class",
                    "value": "Caveman",
                    "display_type": null,
                    "max_value": null,
                    "trait_count": 95,
                    "order": null
                },
                {
                    "trait_type": "Race Color",
                    "value": "Color 1",
                    "display_type": null,
                    "max_value": null,
                    "trait_count": 1468,
                    "order": null
                },
                {
                    "trait_type": "Head Accessory",
                    "value": "Beanie",
                    "display_type": null,
                    "max_value": null,
                    "trait_count": 85,
                    "order": null
                },
                {
                    "trait_type": "Class Color",
                    "value": "Color 1",
                    "display_type": null,
                    "max_value": null,
                    "trait_count": 1198,
                    "order": null
                },
                {
                    "trait_type": "Background",
                    "value": "Orange",
                    "display_type": null,
                    "max_value": null,
                    "trait_count": 188,
                    "order": null
                }
            ],
            "last_sale": null,
            "top_bid": null,
            "listing_date": null,
            "is_presale": true,
            "transfer_fee_payment_token": null,
            "transfer_fee": null
        },
        {
            "id": 25665465,
            "token_id": "319228749994134296502770487353647450375700795558379806399582912924442689537",
            "num_sales": 0,
            "background_color": null,
            "image_url": "https://lh3.googleusercontent.com/gr-GeoC6npsyfEuGH4-MN8K9jBt9x4YHzfZqWVPCBwrfx52Gie80BcMTKU2mifasG3Pc-vmjnpLEWz7yBg185hwcIhGo1MUPm01UyQ",
            "image_preview_url": "https://lh3.googleusercontent.com/gr-GeoC6npsyfEuGH4-MN8K9jBt9x4YHzfZqWVPCBwrfx52Gie80BcMTKU2mifasG3Pc-vmjnpLEWz7yBg185hwcIhGo1MUPm01UyQ=s250",
            "image_thumbnail_url": "https://lh3.googleusercontent.com/gr-GeoC6npsyfEuGH4-MN8K9jBt9x4YHzfZqWVPCBwrfx52Gie80BcMTKU2mifasG3Pc-vmjnpLEWz7yBg185hwcIhGo1MUPm01UyQ=s128",
            "image_original_url": null,
            "animation_url": null,
            "animation_original_url": null,
            "name": "INVENTOR",
            "description": "This is the 1st verifiable instance of the word INVENTOR being made into an NFT.",
            "external_link": "https://RareNFTnames.com/",
            "asset_contract": {
                "address": "0x495f947276749ce646f68ac8c248420045cb7b5e",
                "asset_contract_type": "semi-fungible",
                "created_date": "2020-12-02T17:40:53.232025",
                "name": "OpenSea Collection",
                "nft_version": null,
                "opensea_version": "2.0.0",
                "owner": 102384,
                "schema_name": "ERC1155",
                "symbol": "OPENSTORE",
                "total_supply": null,
                "description": null,
                "external_link": null,
                "image_url": null,
                "default_to_fiat": false,
                "dev_buyer_fee_basis_points": 0,
                "dev_seller_fee_basis_points": 0,
                "only_proxied_transfers": false,
                "opensea_buyer_fee_basis_points": 0,
                "opensea_seller_fee_basis_points": 250,
                "buyer_fee_basis_points": 0,
                "seller_fee_basis_points": 250,
                "payout_address": null
            },
            "owner": {
                "user": {
                    "username": "NullAddress"
                },
                "profile_img_url": "https://storage.googleapis.com/opensea-static/opensea-profile/1.png",
                "address": "0x0000000000000000000000000000000000000000",
                "config": "",
                "discord_id": ""
            },
            "permalink": "https://opensea.io/assets/0x495f947276749ce646f68ac8c248420045cb7b5e/319228749994134296502770487353647450375700795558379806399582912924442689537",
            "collection": {
                "banner_image_url": null,
                "chat_url": null,
                "created_date": "2021-05-10T19:23:23.998003",
                "default_to_fiat": false,
                "description": "Coming Soon",
                "dev_buyer_fee_basis_points": "0",
                "dev_seller_fee_basis_points": "0",
                "discord_url": null,
                "display_data": {
                    "card_display_style": "padded"
                },
                "external_url": null,
                "featured": false,
                "featured_image_url": null,
                "hidden": true,
                "safelist_request_status": "not_requested",
                "image_url": "https://lh3.googleusercontent.com/9OQ7lx1ygjnIPh_w-mrFHLSB9Ww7PvfD8ZWIdQ0nhOl-QGokmLQ5Fl6RZ0NOAbEfOQrdiuKyHX9QAyz0fBVfvxAdYIjjBvAhdhnv6g=s120",
                "is_subject_to_whitelist": false,
                "large_image_url": null,
                "medium_username": null,
                "name": "1st NFT Names, Numbers & Words",
                "only_proxied_transfers": false,
                "opensea_buyer_fee_basis_points": "0",
                "opensea_seller_fee_basis_points": "250",
                "payout_address": null,
                "require_email": false,
                "short_description": null,
                "slug": "1st-nft-names-number-words",
                "telegram_url": null,
                "twitter_username": null,
                "instagram_username": null,
                "wiki_url": null
            },
            "decimals": null,
            "token_metadata": null,
            "sell_orders": null,
            "creator": {
                "user": {
                    "username": "Pippies"
                },
                "profile_img_url": "https://storage.googleapis.com/opensea-static/opensea-profile/18.png",
                "address": "0x00b4ad546df6a94200ec3a5d3eff6659b0e9595d",
                "config": "",
                "discord_id": ""
            },
            "traits": [
                {
                    "trait_type": "Created",
                    "value": "25th May 2021",
                    "display_type": null,
                    "max_value": null,
                    "trait_count": 19,
                    "order": null
                }
            ],
            "last_sale": null,
            "top_bid": null,
            "listing_date": null,
            "is_presale": true,
            "transfer_fee_payment_token": null,
            "transfer_fee": null
        },
        {
            "id": 25665464,
            "token_id": "82929854535027773191997849200963293268345242110903440991364488637976691081217",
            "num_sales": 0,
            "background_color": null,
            "image_url": "https://lh3.googleusercontent.com/S4EJ1lEyoMu31cMmdt24N9PdqWreqcAVmd6YOV_VsIT7b6FAEC-f7ef9Q_KvRBP9GlAWpEqxGoHPG77BY_m32XwdNChm3XvhCXyl",
            "image_preview_url": "https://lh3.googleusercontent.com/S4EJ1lEyoMu31cMmdt24N9PdqWreqcAVmd6YOV_VsIT7b6FAEC-f7ef9Q_KvRBP9GlAWpEqxGoHPG77BY_m32XwdNChm3XvhCXyl=s250",
            "image_thumbnail_url": "https://lh3.googleusercontent.com/S4EJ1lEyoMu31cMmdt24N9PdqWreqcAVmd6YOV_VsIT7b6FAEC-f7ef9Q_KvRBP9GlAWpEqxGoHPG77BY_m32XwdNChm3XvhCXyl=s128",
            "image_original_url": null,
            "animation_url": null,
            "animation_original_url": null,
            "name": "Windmills at Kinderdijk #2",
            "description": "Windmills at Kinderdijk\n\nI would try to describe this picture if I thought the words would be adequate.\n\nLimited Edition 2 of 3",
            "external_link": null,
            "asset_contract": {
                "address": "0x495f947276749ce646f68ac8c248420045cb7b5e",
                "asset_contract_type": "semi-fungible",
                "created_date": "2020-12-02T17:40:53.232025",
                "name": "OpenSea Collection",
                "nft_version": null,
                "opensea_version": "2.0.0",
                "owner": 102384,
                "schema_name": "ERC1155",
                "symbol": "OPENSTORE",
                "total_supply": null,
                "description": null,
                "external_link": null,
                "image_url": null,
                "default_to_fiat": false,
                "dev_buyer_fee_basis_points": 0,
                "dev_seller_fee_basis_points": 0,
                "only_proxied_transfers": false,
                "opensea_buyer_fee_basis_points": 0,
                "opensea_seller_fee_basis_points": 250,
                "buyer_fee_basis_points": 0,
                "seller_fee_basis_points": 250,
                "payout_address": null
            },
            "owner": {
                "user": {
                    "username": "NullAddress"
                },
                "profile_img_url": "https://storage.googleapis.com/opensea-static/opensea-profile/1.png",
                "address": "0x0000000000000000000000000000000000000000",
                "config": "",
                "discord_id": ""
            },
            "permalink": "https://opensea.io/assets/0x495f947276749ce646f68ac8c248420045cb7b5e/82929854535027773191997849200963293268345242110903440991364488637976691081217",
            "collection": {
                "banner_image_url": "https://lh3.googleusercontent.com/S4EJ1lEyoMu31cMmdt24N9PdqWreqcAVmd6YOV_VsIT7b6FAEC-f7ef9Q_KvRBP9GlAWpEqxGoHPG77BY_m32XwdNChm3XvhCXyl=s2500",
                "chat_url": null,
                "created_date": "2021-05-25T16:40:13.290502",
                "default_to_fiat": false,
                "description": "Holistic art and photography.\n\nThe Debut Collection",
                "dev_buyer_fee_basis_points": "0",
                "dev_seller_fee_basis_points": "10",
                "discord_url": null,
                "display_data": {
                    "card_display_style": "contain"
                },
                "external_url": null,
                "featured": false,
                "featured_image_url": "https://lh3.googleusercontent.com/w3TehIlS-rscYjaeEIfwfdXT638axIHybBa4ou5aFB4GGkUoiW-ZD3ho9pfDN-1BIYaYOey0yMlAmOxgRCpbFASETtPozvCzzG_ffA=s300",
                "hidden": true,
                "safelist_request_status": "not_requested",
                "image_url": "https://lh3.googleusercontent.com/-Gb7kcvLyP-0tsiRI-3xR1T2T6Fm1y-CJFxAwOGPAM4iMDwVe_aH5dQTmESTMTyXiQYuRk-XL2DgN1wJTyO4j6gDbE3lktbPAqzk6g=s120",
                "is_subject_to_whitelist": false,
                "large_image_url": "https://lh3.googleusercontent.com/w3TehIlS-rscYjaeEIfwfdXT638axIHybBa4ou5aFB4GGkUoiW-ZD3ho9pfDN-1BIYaYOey0yMlAmOxgRCpbFASETtPozvCzzG_ffA=s300",
                "medium_username": null,
                "name": "LazyPotato",
                "only_proxied_transfers": false,
                "opensea_buyer_fee_basis_points": "0",
                "opensea_seller_fee_basis_points": "250",
                "payout_address": "0xb758a2612b5c9811ef6db1b202ab0dad55134558",
                "require_email": false,
                "short_description": null,
                "slug": "lazypotato",
                "telegram_url": null,
                "twitter_username": null,
                "instagram_username": null,
                "wiki_url": null
            },
            "decimals": null,
            "token_metadata": null,
            "sell_orders": [
                {
                    "created_date": "2021-05-25T22:49:04.933182",
                    "closing_date": "2021-05-30T22:48:48",
                    "closing_extendable": true,
                    "expiration_time": 1623019728,
                    "listing_time": 1622414928,
                    "order_hash": "0xc3dd33941cc28f06521d9398d3189a87468740752918cf3b4b310fc504b35c95",
                    "metadata": {
                        "asset": {
                            "id": "82929854535027773191997849200963293268345242110903440991364488637976691081217",
                            "address": "0x495f947276749ce646f68ac8c248420045cb7b5e",
                            "quantity": "1"
                        },
                        "schema": "ERC1155"
                    },
                    "exchange": "0x7be8076f4ea4a4ad08075c2508e481d6c946d12b",
                    "maker": {
                        "user": 850898,
                        "profile_img_url": "https://storage.googleapis.com/opensea-static/opensea-profile/19.png",
                        "address": "0xb758a2612b5c9811ef6db1b202ab0dad55134558",
                        "config": "",
                        "discord_id": ""
                    },
                    "taker": {
                        "user": 1766,
                        "profile_img_url": "https://storage.googleapis.com/opensea-static/opensea-profile/1.png",
                        "address": "0x0000000000000000000000000000000000000000",
                        "config": "",
                        "discord_id": ""
                    },
                    "current_price": "800000000000000000.0000000000",
                    "current_bounty": "8000000000000000",
                    "bounty_multiple": "0.01",
                    "maker_relayer_fee": "0",
                    "taker_relayer_fee": "260",
                    "maker_protocol_fee": "0",
                    "taker_protocol_fee": "0",
                    "maker_referrer_fee": "0",
                    "fee_recipient": {
                        "user": 1766,
                        "profile_img_url": "https://storage.googleapis.com/opensea-static/opensea-profile/1.png",
                        "address": "0x0000000000000000000000000000000000000000",
                        "config": "",
                        "discord_id": ""
                    },
                    "fee_method": 1,
                    "side": 1,
                    "sale_kind": 0,
                    "target": "0x495f947276749ce646f68ac8c248420045cb7b5e",
                    "how_to_call": 0,
                    "calldata": "0xf242432a000000000000000000000000b758a2612b5c9811ef6db1b202ab0dad551345580000000000000000000000000000000000000000000000000000000000000000b758a2612b5c9811ef6db1b202ab0dad551345580000000000000e0000000001000000000000000000000000000000000000000000000000000000000000000100000000000000000000000000000000000000000000000000000000000000a00000000000000000000000000000000000000000000000000000000000000000",
                    "replacement_pattern": "0x000000000000000000000000000000000000000000000000000000000000000000000000ffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffff0000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000",
                    "static_target": "0xbff6ade67e3717101dd8d0a7f3de1bf6623a2ba8",
                    "static_extradata": "0x589ad31c",
                    "payment_token": "0xc02aaa39b223fe8d0a0e5c4f27ead9083c756cc2",
                    "payment_token_contract": {
                        "id": 2,
                        "symbol": "WETH",
                        "address": "0xc02aaa39b223fe8d0a0e5c4f27ead9083c756cc2",
                        "image_url": "https://storage.opensea.io/files/accae6b6fb3888cbff27a013729c22dc.svg",
                        "name": "Wrapped Ether",
                        "decimals": 18,
                        "eth_price": "1.000000000000000",
                        "usd_price": "2613.559999999999945000"
                    },
                    "base_price": "800000000000000000",
                    "extra": "0",
                    "quantity": "1",
                    "salt": "30641279196116150001358696224444167965312097040401045874275735260799103612525",
                    "v": null,
                    "r": null,
                    "s": null,
                    "approved_on_chain": false,
                    "cancelled": false,
                    "finalized": false,
                    "marked_invalid": false,
                    "prefixed_hash": "0x7830b96877e381d34a901c038ff8ad2a34d95ae34c181eeca3d8d5a907a311fe"
                }
            ],
            "creator": {
                "user": {
                    "username": "LazyPotato"
                },
                "profile_img_url": "https://storage.googleapis.com/opensea-static/opensea-profile/19.png",
                "address": "0xb758a2612b5c9811ef6db1b202ab0dad55134558",
                "config": "",
                "discord_id": ""
            },
            "traits": [],
            "last_sale": null,
            "top_bid": null,
            "listing_date": null,
            "is_presale": true,
            "transfer_fee_payment_token": null,
            "transfer_fee": null
        },
        {
            "id": 25665463,
            "token_id": "57124830429581407560204282384407541915263222877884187177766534289684892221441",
            "num_sales": 0,
            "background_color": null,
            "image_url": "https://lh3.googleusercontent.com/GHfxdnCjgS6ArQfKXGDVFwPiwKRXHeQvZwIp0Rmot7ty4rkUFahDnaQw-nyjlEnV5HmDDnIsI8iOTnV0v0KiXNBW-i68kS7pqTbj",
            "image_preview_url": "https://lh3.googleusercontent.com/GHfxdnCjgS6ArQfKXGDVFwPiwKRXHeQvZwIp0Rmot7ty4rkUFahDnaQw-nyjlEnV5HmDDnIsI8iOTnV0v0KiXNBW-i68kS7pqTbj=s250",
            "image_thumbnail_url": "https://lh3.googleusercontent.com/GHfxdnCjgS6ArQfKXGDVFwPiwKRXHeQvZwIp0Rmot7ty4rkUFahDnaQw-nyjlEnV5HmDDnIsI8iOTnV0v0KiXNBW-i68kS7pqTbj=s128",
            "image_original_url": null,
            "animation_url": null,
            "animation_original_url": null,
            "name": "Axolotl #019",
            "description": "Axolotl #019 is the Piebald Princess & is the 1st piebald type to be listed for adoption. She is identified by her splotchy pigmentation which gives her 2 dominant colors. The Princess wears a crown to show her royalty. ",
            "external_link": "http://twitter.com/strayaxolotls",
            "asset_contract": {
                "address": "0x495f947276749ce646f68ac8c248420045cb7b5e",
                "asset_contract_type": "semi-fungible",
                "created_date": "2020-12-02T17:40:53.232025",
                "name": "OpenSea Collection",
                "nft_version": null,
                "opensea_version": "2.0.0",
                "owner": 102384,
                "schema_name": "ERC1155",
                "symbol": "OPENSTORE",
                "total_supply": null,
                "description": null,
                "external_link": null,
                "image_url": null,
                "default_to_fiat": false,
                "dev_buyer_fee_basis_points": 0,
                "dev_seller_fee_basis_points": 0,
                "only_proxied_transfers": false,
                "opensea_buyer_fee_basis_points": 0,
                "opensea_seller_fee_basis_points": 250,
                "buyer_fee_basis_points": 0,
                "seller_fee_basis_points": 250,
                "payout_address": null
            },
            "owner": {
                "user": {
                    "username": "NullAddress"
                },
                "profile_img_url": "https://storage.googleapis.com/opensea-static/opensea-profile/1.png",
                "address": "0x0000000000000000000000000000000000000000",
                "config": "",
                "discord_id": ""
            },
            "permalink": "https://opensea.io/assets/0x495f947276749ce646f68ac8c248420045cb7b5e/57124830429581407560204282384407541915263222877884187177766534289684892221441",
            "collection": {
                "banner_image_url": null,
                "chat_url": null,
                "created_date": "2021-04-30T07:01:13.940756",
                "default_to_fiat": false,
                "description": "Stray Axolotls are handmade creations looking for a loving home on the Blockchain. Each Stray is identified by morph type, dominant color, genetics, background, & objects present. \n\n300 Axolotls will be released. Price floor for new releases will increase by .005 for every 30 adoptions.\n",
                "dev_buyer_fee_basis_points": "0",
                "dev_seller_fee_basis_points": "1000",
                "discord_url": null,
                "display_data": {
                    "card_display_style": "cover"
                },
                "external_url": null,
                "featured": false,
                "featured_image_url": "https://lh3.googleusercontent.com/V3xHlzhXcM3Eo2ypKlcqnL25gexOQppTbqM85a6E52EI0CKaLZ-mhtLAX9LsD5UbgMIFcZj5LJMEhZVB0ZsxRs_2-IK9H4CQcXxbtA=s300",
                "hidden": true,
                "safelist_request_status": "not_requested",
                "image_url": "https://lh3.googleusercontent.com/V3xHlzhXcM3Eo2ypKlcqnL25gexOQppTbqM85a6E52EI0CKaLZ-mhtLAX9LsD5UbgMIFcZj5LJMEhZVB0ZsxRs_2-IK9H4CQcXxbtA=s120",
                "is_subject_to_whitelist": false,
                "large_image_url": "https://lh3.googleusercontent.com/V3xHlzhXcM3Eo2ypKlcqnL25gexOQppTbqM85a6E52EI0CKaLZ-mhtLAX9LsD5UbgMIFcZj5LJMEhZVB0ZsxRs_2-IK9H4CQcXxbtA=s300",
                "medium_username": null,
                "name": "Stray Axolotls",
                "only_proxied_transfers": false,
                "opensea_buyer_fee_basis_points": "0",
                "opensea_seller_fee_basis_points": "250",
                "payout_address": "0x7e4b821bdd218e988b5373952d49b9f4d68047a2",
                "require_email": false,
                "short_description": null,
                "slug": "strayaxolotls",
                "telegram_url": null,
                "twitter_username": null,
                "instagram_username": null,
                "wiki_url": null
            },
            "decimals": null,
            "token_metadata": null,
            "sell_orders": null,
            "creator": {
                "user": {
                    "username": "StrayNFTs"
                },
                "profile_img_url": "https://storage.googleapis.com/opensea-static/opensea-profile/1.png",
                "address": "0x7e4b821bdd218e988b5373952d49b9f4d68047a2",
                "config": "",
                "discord_id": ""
            },
            "traits": [
                {
                    "trait_type": "Type",
                    "value": "Piebald",
                    "display_type": null,
                    "max_value": null,
                    "trait_count": 0,
                    "order": null
                },
                {
                    "trait_type": "Lighting",
                    "value": "Pink",
                    "display_type": null,
                    "max_value": null,
                    "trait_count": 0,
                    "order": null
                },
                {
                    "trait_type": "Dominant Color",
                    "value": "Dark Gray",
                    "display_type": null,
                    "max_value": null,
                    "trait_count": 1,
                    "order": null
                },
                {
                    "trait_type": "Background",
                    "value": "Water",
                    "display_type": null,
                    "max_value": null,
                    "trait_count": 14,
                    "order": null
                },
                {
                    "trait_type": "Genetics",
                    "value": "Female",
                    "display_type": null,
                    "max_value": null,
                    "trait_count": 8,
                    "order": null
                },
                {
                    "trait_type": "Dominant Color",
                    "value": "Pink",
                    "display_type": null,
                    "max_value": null,
                    "trait_count": 4,
                    "order": null
                },
                {
                    "trait_type": "Object",
                    "value": "Crown",
                    "display_type": null,
                    "max_value": null,
                    "trait_count": 2,
                    "order": null
                }
            ],
            "last_sale": null,
            "top_bid": null,
            "listing_date": null,
            "is_presale": true,
            "transfer_fee_payment_token": null,
            "transfer_fee": null
        },
        {
            "id": 25665462,
            "token_id": "1258",
            "num_sales": 0,
            "background_color": null,
            "image_url": "https://lh3.googleusercontent.com/3G09bcOjSfkbIiCnDTPdcifXndMofduTa9W4fLYcKDu45DoRdLrABJIaa8zFGe9iPTWyAKep2ajzP1wIQ0o5YiWG45xUiPsKgMoogQ",
            "image_preview_url": "https://lh3.googleusercontent.com/3G09bcOjSfkbIiCnDTPdcifXndMofduTa9W4fLYcKDu45DoRdLrABJIaa8zFGe9iPTWyAKep2ajzP1wIQ0o5YiWG45xUiPsKgMoogQ=s250",
            "image_thumbnail_url": "https://lh3.googleusercontent.com/3G09bcOjSfkbIiCnDTPdcifXndMofduTa9W4fLYcKDu45DoRdLrABJIaa8zFGe9iPTWyAKep2ajzP1wIQ0o5YiWG45xUiPsKgMoogQ=s128",
            "image_original_url": "https://embersword.mypinata.cloud/ipfs/QmdbeV27CatL3EddMf2Ek1jGt77amKgb5ghVeHrKWLyz84",
            "animation_url": "https://storage.opensea.io/files/b0cc4d04cbc1f26c66e7511d64cd2d9e.mp4",
            "animation_original_url": "https://embersword.mypinata.cloud/ipfs/QmfKgvFupW1dm9W3UusnrGKrabMT6hTD2DkhG27hAU7Lxx",
            "name": "Land (42,49)",
            "description": "Land plot",
            "external_link": null,
            "asset_contract": {
                "address": "0xe7e16f2da731265778f87cb8d7850e31b84b7b86",
                "asset_contract_type": "non-fungible",
                "created_date": "2021-05-25T13:23:10.895540",
                "name": "Embersword Land",
                "nft_version": null,
                "opensea_version": null,
                "owner": 35978059,
                "schema_name": "ERC721",
                "symbol": "LAND",
                "total_supply": "0",
                "description": null,
                "external_link": "https://embersword.com",
                "image_url": "https://lh3.googleusercontent.com/J7SSCNIDh1ui59aoqyNywPtnUAUB-Q80Cnl1txbxmJOAIKcRJT1bUYidkDPNegOk2W0zyjqVkLbdcI6g6KTYgQCDplCo3DXpDSeaPg=s120",
                "default_to_fiat": false,
                "dev_buyer_fee_basis_points": 0,
                "dev_seller_fee_basis_points": 0,
                "only_proxied_transfers": false,
                "opensea_buyer_fee_basis_points": 0,
                "opensea_seller_fee_basis_points": 250,
                "buyer_fee_basis_points": 0,
                "seller_fee_basis_points": 250,
                "payout_address": null
            },
            "owner": {
                "user": null,
                "profile_img_url": "https://storage.googleapis.com/opensea-static/opensea-profile/1.png",
                "address": "0x0000000000000000000000000000000000000000",
                "config": "",
                "discord_id": ""
            },
            "permalink": "https://opensea.io/assets/matic/0xe7e16f2da731265778f87cb8d7850e31b84b7b86/1258",
            "collection": {
                "banner_image_url": null,
                "chat_url": null,
                "created_date": "2021-05-25T16:51:25.426643",
                "default_to_fiat": false,
                "description": null,
                "dev_buyer_fee_basis_points": "0",
                "dev_seller_fee_basis_points": "0",
                "discord_url": "https://discord.gg/embersword",
                "display_data": {
                    "card_display_style": "contain"
                },
                "external_url": "https://embersword.com",
                "featured": false,
                "featured_image_url": null,
                "hidden": true,
                "safelist_request_status": "not_requested",
                "image_url": "https://lh3.googleusercontent.com/J7SSCNIDh1ui59aoqyNywPtnUAUB-Q80Cnl1txbxmJOAIKcRJT1bUYidkDPNegOk2W0zyjqVkLbdcI6g6KTYgQCDplCo3DXpDSeaPg=s120",
                "is_subject_to_whitelist": false,
                "large_image_url": null,
                "medium_username": "embersword",
                "name": "Ember Sword Land",
                "only_proxied_transfers": false,
                "opensea_buyer_fee_basis_points": "0",
                "opensea_seller_fee_basis_points": "250",
                "payout_address": null,
                "require_email": false,
                "short_description": null,
                "slug": "embersword-land",
                "telegram_url": null,
                "twitter_username": "PlayEmberSword",
                "instagram_username": null,
                "wiki_url": null
            },
            "decimals": null,
            "token_metadata": "https://embersword.mypinata.cloud/ipfs/QmTM52AchiQQ9UyCEWHv2XJxtt34DRx7VJS86EqDd3rGBw",
            "sell_orders": null,
            "creator": null,
            "traits": [
                {
                    "trait_type": "x-coordinate",
                    "value": 42,
                    "display_type": "number",
                    "max_value": null,
                    "trait_count": 0,
                    "order": null
                },
                {
                    "trait_type": "Type",
                    "value": "Land",
                    "display_type": null,
                    "max_value": null,
                    "trait_count": 692,
                    "order": null
                },
                {
                    "trait_type": "y-coordinate",
                    "value": 49,
                    "display_type": "number",
                    "max_value": null,
                    "trait_count": 0,
                    "order": null
                }
            ],
            "last_sale": null,
            "top_bid": null,
            "listing_date": null,
            "is_presale": false,
            "transfer_fee_payment_token": null,
            "transfer_fee": null
        },
        {
            "id": 25665461,
            "token_id": "20779687020901315104817932847033512423599216699667133632923091503161590939649",
            "num_sales": 0,
            "background_color": null,
            "image_url": "https://lh3.googleusercontent.com/gw586tAzH3dwFNC3P3vUDsOVEl4bieNv7xcSrWRX5BH1GCuamsBTpfI9VMWJRC5ht4jU3LUPYH-09wXTg41tV1qOEcSSM8qlOXm3xg",
            "image_preview_url": "https://lh3.googleusercontent.com/gw586tAzH3dwFNC3P3vUDsOVEl4bieNv7xcSrWRX5BH1GCuamsBTpfI9VMWJRC5ht4jU3LUPYH-09wXTg41tV1qOEcSSM8qlOXm3xg=s250",
            "image_thumbnail_url": "https://lh3.googleusercontent.com/gw586tAzH3dwFNC3P3vUDsOVEl4bieNv7xcSrWRX5BH1GCuamsBTpfI9VMWJRC5ht4jU3LUPYH-09wXTg41tV1qOEcSSM8qlOXm3xg=s128",
            "image_original_url": null,
            "animation_url": "https://storage.opensea.io/files/8852857235eb9f4b4e8f1118e3ce4e78.mp4",
            "animation_original_url": "https://storage.opensea.io/files/8852857235eb9f4b4e8f1118e3ce4e78.mp4",
            "name": "Cublitz #1680",
            "description": null,
            "external_link": null,
            "asset_contract": {
                "address": "0x495f947276749ce646f68ac8c248420045cb7b5e",
                "asset_contract_type": "semi-fungible",
                "created_date": "2020-12-02T17:40:53.232025",
                "name": "OpenSea Collection",
                "nft_version": null,
                "opensea_version": "2.0.0",
                "owner": 102384,
                "schema_name": "ERC1155",
                "symbol": "OPENSTORE",
                "total_supply": null,
                "description": null,
                "external_link": null,
                "image_url": null,
                "default_to_fiat": false,
                "dev_buyer_fee_basis_points": 0,
                "dev_seller_fee_basis_points": 0,
                "only_proxied_transfers": false,
                "opensea_buyer_fee_basis_points": 0,
                "opensea_seller_fee_basis_points": 250,
                "buyer_fee_basis_points": 0,
                "seller_fee_basis_points": 250,
                "payout_address": null
            },
            "owner": {
                "user": {
                    "username": "NullAddress"
                },
                "profile_img_url": "https://storage.googleapis.com/opensea-static/opensea-profile/1.png",
                "address": "0x0000000000000000000000000000000000000000",
                "config": "",
                "discord_id": ""
            },
            "permalink": "https://opensea.io/assets/0x495f947276749ce646f68ac8c248420045cb7b5e/20779687020901315104817932847033512423599216699667133632923091503161590939649",
            "collection": {
                "banner_image_url": "https://lh3.googleusercontent.com/gFpU2HWWO4G53qKLkonFjlhLvkOyrnuC_PFMLHghOQwr6ZbL4YTQGwYQFjG703JYfreeicn_Q9qtFIGvOqT_3qq0J1m_NYYM8DlO0yY=s2500",
                "chat_url": null,
                "created_date": "2021-05-15T17:29:16.297787",
                "default_to_fiat": false,
                "description": "10,000 randomly generated animated NFT's. 3D rendered dancing blockheads with over 15 million possible combinations of species, professions, colors, and accessories.",
                "dev_buyer_fee_basis_points": "0",
                "dev_seller_fee_basis_points": "500",
                "discord_url": "https://discord.gg/gY4fQwR59E",
                "display_data": {
                    "card_display_style": "contain"
                },
                "external_url": null,
                "featured": false,
                "featured_image_url": "https://lh3.googleusercontent.com/DUQIBKJCZqkIueysZ-vf8Xh1bqTDin3rSBWz87slZ0Ttqg7cJtcmizTpGBJQKB230YJjbHkenjkNICcXsME9jy6FNUPECQsbntECLA=s300",
                "hidden": true,
                "safelist_request_status": "not_requested",
                "image_url": "https://lh3.googleusercontent.com/JKzgo-XGir844sKoqbj3wca19WSGfTca54E2txRIk4XUVUCd-bnY0bVlmBS7IYr5_fs-3T2rPlnKQIKJQgWSKBrKuEmitX8zBGl0Cg=s120",
                "is_subject_to_whitelist": false,
                "large_image_url": "https://lh3.googleusercontent.com/DUQIBKJCZqkIueysZ-vf8Xh1bqTDin3rSBWz87slZ0Ttqg7cJtcmizTpGBJQKB230YJjbHkenjkNICcXsME9jy6FNUPECQsbntECLA=s300",
                "medium_username": null,
                "name": "Cublitz",
                "only_proxied_transfers": false,
                "opensea_buyer_fee_basis_points": "0",
                "opensea_seller_fee_basis_points": "250",
                "payout_address": "0x2df0e2d512a76fbc761a7df0811ecb2f3556a8a4",
                "require_email": false,
                "short_description": null,
                "slug": "cublitz",
                "telegram_url": null,
                "twitter_username": "cublitz",
                "instagram_username": null,
                "wiki_url": null
            },
            "decimals": null,
            "token_metadata": null,
            "sell_orders": null,
            "creator": {
                "user": {
                    "username": "DedRedArt"
                },
                "profile_img_url": "https://storage.googleapis.com/opensea-static/opensea-profile/30.png",
                "address": "0x2df0e2d512a76fbc761a7df0811ecb2f3556a8a4",
                "config": "",
                "discord_id": ""
            },
            "traits": [
                {
                    "trait_type": "Race",
                    "value": "Cat",
                    "display_type": null,
                    "max_value": null,
                    "trait_count": 225,
                    "order": null
                },
                {
                    "trait_type": "Eyes",
                    "value": "Squinty",
                    "display_type": null,
                    "max_value": null,
                    "trait_count": 151,
                    "order": null
                },
                {
                    "trait_type": "Class",
                    "value": "Gamer",
                    "display_type": null,
                    "max_value": null,
                    "trait_count": 252,
                    "order": null
                },
                {
                    "trait_type": "Race Color",
                    "value": "Color 1",
                    "display_type": null,
                    "max_value": null,
                    "trait_count": 1468,
                    "order": null
                },
                {
                    "trait_type": "Class Color",
                    "value": "Color 1",
                    "display_type": null,
                    "max_value": null,
                    "trait_count": 1198,
                    "order": null
                },
                {
                    "trait_type": "Background",
                    "value": "Green",
                    "display_type": null,
                    "max_value": null,
                    "trait_count": 207,
                    "order": null
                }
            ],
            "last_sale": null,
            "top_bid": null,
            "listing_date": null,
            "is_presale": true,
            "transfer_fee_payment_token": null,
            "transfer_fee": null
        },
        {
            "id": 25665458,
            "token_id": "101252083778151641423831800880398356849809162001436389574999047515556475305985",
            "num_sales": 0,
            "background_color": null,
            "image_url": "https://lh3.googleusercontent.com/2ISZs_pnOkDIKTA2yRbo6WUpBQhJVJs0Li7u6iluJ2-IzGq4jRUo1y1tq97Rl59Xm7THl1GXWV7IlD3j4JE_negXcd4cAWJCafuXIw",
            "image_preview_url": "https://lh3.googleusercontent.com/2ISZs_pnOkDIKTA2yRbo6WUpBQhJVJs0Li7u6iluJ2-IzGq4jRUo1y1tq97Rl59Xm7THl1GXWV7IlD3j4JE_negXcd4cAWJCafuXIw=s250",
            "image_thumbnail_url": "https://lh3.googleusercontent.com/2ISZs_pnOkDIKTA2yRbo6WUpBQhJVJs0Li7u6iluJ2-IzGq4jRUo1y1tq97Rl59Xm7THl1GXWV7IlD3j4JE_negXcd4cAWJCafuXIw=s128",
            "image_original_url": null,
            "animation_url": null,
            "animation_original_url": null,
            "name": "Rakit - Cryptoneum #00040",
            "description": "There will be a unique Space Gang member card whenever a new planet is visited . Intergalactic travel will distract and slow down Space Mercenaries.",
            "external_link": null,
            "asset_contract": {
                "address": "0x495f947276749ce646f68ac8c248420045cb7b5e",
                "asset_contract_type": "semi-fungible",
                "created_date": "2020-12-02T17:40:53.232025",
                "name": "OpenSea Collection",
                "nft_version": null,
                "opensea_version": "2.0.0",
                "owner": 102384,
                "schema_name": "ERC1155",
                "symbol": "OPENSTORE",
                "total_supply": null,
                "description": null,
                "external_link": null,
                "image_url": null,
                "default_to_fiat": false,
                "dev_buyer_fee_basis_points": 0,
                "dev_seller_fee_basis_points": 0,
                "only_proxied_transfers": false,
                "opensea_buyer_fee_basis_points": 0,
                "opensea_seller_fee_basis_points": 250,
                "buyer_fee_basis_points": 0,
                "seller_fee_basis_points": 250,
                "payout_address": null
            },
            "owner": {
                "user": {
                    "username": "NullAddress"
                },
                "profile_img_url": "https://storage.googleapis.com/opensea-static/opensea-profile/1.png",
                "address": "0x0000000000000000000000000000000000000000",
                "config": "",
                "discord_id": ""
            },
            "permalink": "https://opensea.io/assets/0x495f947276749ce646f68ac8c248420045cb7b5e/101252083778151641423831800880398356849809162001436389574999047515556475305985",
            "collection": {
                "banner_image_url": "https://lh3.googleusercontent.com/q_6CD6ksFrUzlPO_3mMnJbcf5_JjNNmMGLU9HTxnnAerviTL3Fpj6fdJXGpOZymMD0hioSybKHDhJfPGVVNuDbFS1lsgNWWcDC1MjQ=s2500",
                "chat_url": null,
                "created_date": "2021-05-20T21:29:24.229752",
                "default_to_fiat": false,
                "description": "60 Space Gang members, 14 Space Mercenaries, 5 Evil Board members and God knows how many planets and galaxies this space hunt will impact. Join the FusionOps community and help saving our brave Space Gang.",
                "dev_buyer_fee_basis_points": "0",
                "dev_seller_fee_basis_points": "1000",
                "discord_url": null,
                "display_data": {
                    "card_display_style": "contain"
                },
                "external_url": null,
                "featured": false,
                "featured_image_url": "https://lh3.googleusercontent.com/Rnqw0Y8SY5CykHv0icv-Rlgf88t7i3PTsOdCr184yn_BFCRO6W7LKL_Om_h8lB9u7oNG0tSK1w7TNB0H6OS2Tp8y5dVqaISvZZ4rDw=s300",
                "hidden": true,
                "safelist_request_status": "not_requested",
                "image_url": "https://lh3.googleusercontent.com/lyfsf6monb3FSa9ELmisAovb8cGTqJTJs6iqx4SHjhVY4kCEIgl-0ZuP4dV59NAyRvyZHhW92Xx4aawH0z08KQcwmjMVAecr0Hql=s120",
                "is_subject_to_whitelist": false,
                "large_image_url": "https://lh3.googleusercontent.com/Rnqw0Y8SY5CykHv0icv-Rlgf88t7i3PTsOdCr184yn_BFCRO6W7LKL_Om_h8lB9u7oNG0tSK1w7TNB0H6OS2Tp8y5dVqaISvZZ4rDw=s300",
                "medium_username": null,
                "name": "FusionOps",
                "only_proxied_transfers": false,
                "opensea_buyer_fee_basis_points": "0",
                "opensea_seller_fee_basis_points": "250",
                "payout_address": "0xdfdaa60732c9219166c2e3c824edcf47c8d9d2a1",
                "require_email": false,
                "short_description": null,
                "slug": "fusionops",
                "telegram_url": null,
                "twitter_username": "SpaceGangClub",
                "instagram_username": null,
                "wiki_url": null
            },
            "decimals": null,
            "token_metadata": null,
            "sell_orders": null,
            "creator": {
                "user": {
                    "username": "Born_InSpace"
                },
                "profile_img_url": "https://storage.googleapis.com/opensea-static/opensea-profile/25.png",
                "address": "0xdfdaa60732c9219166c2e3c824edcf47c8d9d2a1",
                "config": "",
                "discord_id": ""
            },
            "traits": [
                {
                    "trait_type": "Planet",
                    "value": "Cryptoneum",
                    "display_type": null,
                    "max_value": null,
                    "trait_count": 26,
                    "order": null
                },
                {
                    "trait_type": "Set",
                    "value": "Space Gang",
                    "display_type": null,
                    "max_value": null,
                    "trait_count": 26,
                    "order": null
                },
                {
                    "trait_type": "Rank",
                    "value": "Member",
                    "display_type": null,
                    "max_value": null,
                    "trait_count": 21,
                    "order": null
                },
                {
                    "trait_type": "Name",
                    "value": "Rakit",
                    "display_type": null,
                    "max_value": null,
                    "trait_count": 0,
                    "order": null
                }
            ],
            "last_sale": null,
            "top_bid": null,
            "listing_date": null,
            "is_presale": true,
            "transfer_fee_payment_token": null,
            "transfer_fee": null
        },
        {
            "id": 25665455,
            "token_id": "20779687020901315104817932847033512423599216699667133632923091502062079311873",
            "num_sales": 0,
            "background_color": null,
            "image_url": "https://lh3.googleusercontent.com/9xgDr85nT0Nc1qHKjhzJJd7AObGlBam7TYUzrGHFEyg4xhkTxniLL8EPsxZx6spnutyXKDC0kTC8HrLwvk0F0JTgXg03QQlKmyseXg",
            "image_preview_url": "https://lh3.googleusercontent.com/9xgDr85nT0Nc1qHKjhzJJd7AObGlBam7TYUzrGHFEyg4xhkTxniLL8EPsxZx6spnutyXKDC0kTC8HrLwvk0F0JTgXg03QQlKmyseXg=s250",
            "image_thumbnail_url": "https://lh3.googleusercontent.com/9xgDr85nT0Nc1qHKjhzJJd7AObGlBam7TYUzrGHFEyg4xhkTxniLL8EPsxZx6spnutyXKDC0kTC8HrLwvk0F0JTgXg03QQlKmyseXg=s128",
            "image_original_url": null,
            "animation_url": "https://storage.opensea.io/files/e2547c278321d04c81a798259bafb004.mp4",
            "animation_original_url": "https://storage.opensea.io/files/e2547c278321d04c81a798259bafb004.mp4",
            "name": "Cublitz #1679",
            "description": null,
            "external_link": null,
            "asset_contract": {
                "address": "0x495f947276749ce646f68ac8c248420045cb7b5e",
                "asset_contract_type": "semi-fungible",
                "created_date": "2020-12-02T17:40:53.232025",
                "name": "OpenSea Collection",
                "nft_version": null,
                "opensea_version": "2.0.0",
                "owner": 102384,
                "schema_name": "ERC1155",
                "symbol": "OPENSTORE",
                "total_supply": null,
                "description": null,
                "external_link": null,
                "image_url": null,
                "default_to_fiat": false,
                "dev_buyer_fee_basis_points": 0,
                "dev_seller_fee_basis_points": 0,
                "only_proxied_transfers": false,
                "opensea_buyer_fee_basis_points": 0,
                "opensea_seller_fee_basis_points": 250,
                "buyer_fee_basis_points": 0,
                "seller_fee_basis_points": 250,
                "payout_address": null
            },
            "owner": {
                "user": {
                    "username": "NullAddress"
                },
                "profile_img_url": "https://storage.googleapis.com/opensea-static/opensea-profile/1.png",
                "address": "0x0000000000000000000000000000000000000000",
                "config": "",
                "discord_id": ""
            },
            "permalink": "https://opensea.io/assets/0x495f947276749ce646f68ac8c248420045cb7b5e/20779687020901315104817932847033512423599216699667133632923091502062079311873",
            "collection": {
                "banner_image_url": "https://lh3.googleusercontent.com/gFpU2HWWO4G53qKLkonFjlhLvkOyrnuC_PFMLHghOQwr6ZbL4YTQGwYQFjG703JYfreeicn_Q9qtFIGvOqT_3qq0J1m_NYYM8DlO0yY=s2500",
                "chat_url": null,
                "created_date": "2021-05-15T17:29:16.297787",
                "default_to_fiat": false,
                "description": "10,000 randomly generated animated NFT's. 3D rendered dancing blockheads with over 15 million possible combinations of species, professions, colors, and accessories.",
                "dev_buyer_fee_basis_points": "0",
                "dev_seller_fee_basis_points": "500",
                "discord_url": "https://discord.gg/gY4fQwR59E",
                "display_data": {
                    "card_display_style": "contain"
                },
                "external_url": null,
                "featured": false,
                "featured_image_url": "https://lh3.googleusercontent.com/DUQIBKJCZqkIueysZ-vf8Xh1bqTDin3rSBWz87slZ0Ttqg7cJtcmizTpGBJQKB230YJjbHkenjkNICcXsME9jy6FNUPECQsbntECLA=s300",
                "hidden": true,
                "safelist_request_status": "not_requested",
                "image_url": "https://lh3.googleusercontent.com/JKzgo-XGir844sKoqbj3wca19WSGfTca54E2txRIk4XUVUCd-bnY0bVlmBS7IYr5_fs-3T2rPlnKQIKJQgWSKBrKuEmitX8zBGl0Cg=s120",
                "is_subject_to_whitelist": false,
                "large_image_url": "https://lh3.googleusercontent.com/DUQIBKJCZqkIueysZ-vf8Xh1bqTDin3rSBWz87slZ0Ttqg7cJtcmizTpGBJQKB230YJjbHkenjkNICcXsME9jy6FNUPECQsbntECLA=s300",
                "medium_username": null,
                "name": "Cublitz",
                "only_proxied_transfers": false,
                "opensea_buyer_fee_basis_points": "0",
                "opensea_seller_fee_basis_points": "250",
                "payout_address": "0x2df0e2d512a76fbc761a7df0811ecb2f3556a8a4",
                "require_email": false,
                "short_description": null,
                "slug": "cublitz",
                "telegram_url": null,
                "twitter_username": "cublitz",
                "instagram_username": null,
                "wiki_url": null
            },
            "decimals": null,
            "token_metadata": null,
            "sell_orders": null,
            "creator": {
                "user": {
                    "username": "DedRedArt"
                },
                "profile_img_url": "https://storage.googleapis.com/opensea-static/opensea-profile/30.png",
                "address": "0x2df0e2d512a76fbc761a7df0811ecb2f3556a8a4",
                "config": "",
                "discord_id": ""
            },
            "traits": [
                {
                    "trait_type": "Class",
                    "value": "Knight",
                    "display_type": null,
                    "max_value": null,
                    "trait_count": 196,
                    "order": null
                },
                {
                    "trait_type": "Background",
                    "value": "Blue",
                    "display_type": null,
                    "max_value": null,
                    "trait_count": 190,
                    "order": null
                },
                {
                    "trait_type": "Eyes",
                    "value": "Squeezed",
                    "display_type": null,
                    "max_value": null,
                    "trait_count": 128,
                    "order": null
                },
                {
                    "trait_type": "Race",
                    "value": "Girl",
                    "display_type": null,
                    "max_value": null,
                    "trait_count": 283,
                    "order": null
                },
                {
                    "trait_type": "Class Color",
                    "value": "Color 2",
                    "display_type": null,
                    "max_value": null,
                    "trait_count": 331,
                    "order": null
                },
                {
                    "trait_type": "Race Color",
                    "value": "Color 1",
                    "display_type": null,
                    "max_value": null,
                    "trait_count": 1468,
                    "order": null
                },
                {
                    "trait_type": "Head Accessory",
                    "value": "Cowboy Hat",
                    "display_type": null,
                    "max_value": null,
                    "trait_count": 130,
                    "order": null
                }
            ],
            "last_sale": null,
            "top_bid": null,
            "listing_date": null,
            "is_presale": true,
            "transfer_fee_payment_token": null,
            "transfer_fee": null
        },
        {
            "id": 25665451,
            "token_id": "1708",
            "num_sales": 0,
            "background_color": null,
            "image_url": "https://lh3.googleusercontent.com/2VX6fFg7YQjfzIMV7LhzmYz4gAgsJvE5kw6BwySRgYFC4iY0F9NM39yFyl_DPo4IfURbOTFWzFUX-GQbczTLNsjHk2Bl9I3tITone0I",
            "image_preview_url": "https://lh3.googleusercontent.com/2VX6fFg7YQjfzIMV7LhzmYz4gAgsJvE5kw6BwySRgYFC4iY0F9NM39yFyl_DPo4IfURbOTFWzFUX-GQbczTLNsjHk2Bl9I3tITone0I=s250",
            "image_thumbnail_url": "https://lh3.googleusercontent.com/2VX6fFg7YQjfzIMV7LhzmYz4gAgsJvE5kw6BwySRgYFC4iY0F9NM39yFyl_DPo4IfURbOTFWzFUX-GQbczTLNsjHk2Bl9I3tITone0I=s128",
            "image_original_url": "https://cdn.veefriends.com/f6pXbdBrDkgJjmSV-_XTrDCsS97-QXp2H6Yu0fLSCB0/927.png",
            "animation_url": null,
            "animation_original_url": null,
            "name": "Charismatic Chameleon",
            "description": "This token is verifiable for admission to VeeCon 2022, 2023, 2024\n\nThis token is a collectible that lives on the Ethereum blockchain\n\nAdditional Content:\n\n- [Character Vector](https://cdn.veefriends.com/f6pXbdBrDkgJjmSV-_XTrDCsS97-QXp2H6Yu0fLSCB0/3141.svg)\n- [Character Image](https://cdn.veefriends.com/f6pXbdBrDkgJjmSV-_XTrDCsS97-QXp2H6Yu0fLSCB0/4013.png) \n- [Character Creation Video](https://cdn.veefriends.com/f6pXbdBrDkgJjmSV-_XTrDCsS97-QXp2H6Yu0fLSCB0/950.mp4)\n- [Character with Gary Vaynerchuk](https://cdn.veefriends.com/f6pXbdBrDkgJjmSV-_XTrDCsS97-QXp2H6Yu0fLSCB0/974.jpg)",
            "external_link": null,
            "asset_contract": {
                "address": "0xa3aee8bce55beea1951ef834b99f3ac60d1abeeb",
                "asset_contract_type": "non-fungible",
                "created_date": "2021-05-11T17:30:01.380820",
                "name": "VeeFriends",
                "nft_version": "3.0",
                "opensea_version": null,
                "owner": 41520829,
                "schema_name": "ERC721",
                "symbol": "VFT",
                "total_supply": "0",
                "description": "A Gary Vaynerchuk NFT project around meaningful intellectual property and an extraordinary community.",
                "external_link": "https://veefriends.com/",
                "image_url": "https://lh3.googleusercontent.com/5y-UCAXiNOFXH551w5bWdZEYOCdHPwbqmcKb-xa3uVQEjQgxvih3HtZWSmzqDqd0uk7kIqFrZhw32Gt6xPBFg4t_n9BKhpou-dwnOg=s120",
                "default_to_fiat": false,
                "dev_buyer_fee_basis_points": 0,
                "dev_seller_fee_basis_points": 1000,
                "only_proxied_transfers": false,
                "opensea_buyer_fee_basis_points": 0,
                "opensea_seller_fee_basis_points": 250,
                "buyer_fee_basis_points": 0,
                "seller_fee_basis_points": 1250,
                "payout_address": "0x263a1c688c4426eede9b57e741ffb2b9cadcca94"
            },
            "owner": {
                "user": {
                    "username": "TheJocker"
                },
                "profile_img_url": "https://storage.googleapis.com/opensea-static/opensea-profile/32.png",
                "address": "0xa33ec50ab06ae30adace80e6c63ca398eb1a4019",
                "config": "",
                "discord_id": ""
            },
            "permalink": "https://opensea.io/assets/0xa3aee8bce55beea1951ef834b99f3ac60d1abeeb/1708",
            "collection": {
                "banner_image_url": "https://lh3.googleusercontent.com/4RYeNt3ET75VLMoCZz-fsOhXg8AW8qlkHfgkbA0FfEayNpsHvOZROygyy9IhY4LwrnJUXqkeDjBZBr8bCf0Ng_xUiRZqWRGng3sc=s2500",
                "chat_url": null,
                "created_date": "2021-05-11T18:22:19.398578",
                "default_to_fiat": false,
                "description": "A Gary Vaynerchuk NFT project around meaningful intellectual property and an extraordinary community.",
                "dev_buyer_fee_basis_points": "0",
                "dev_seller_fee_basis_points": "1000",
                "discord_url": null,
                "display_data": {
                    "card_display_style": "cover"
                },
                "external_url": "https://veefriends.com/",
                "featured": false,
                "featured_image_url": "https://lh3.googleusercontent.com/4aSYyyyW-c2Vmh_-OSG4W5szSXF6dIjGuFkbp99DqE7f4liwytRHKfBiZ1zyXKI8RTCAvBVRfZL06IO7V-AY7LMTOnZaBx0S60X92g=s300",
                "hidden": false,
                "safelist_request_status": "verified",
                "image_url": "https://lh3.googleusercontent.com/5y-UCAXiNOFXH551w5bWdZEYOCdHPwbqmcKb-xa3uVQEjQgxvih3HtZWSmzqDqd0uk7kIqFrZhw32Gt6xPBFg4t_n9BKhpou-dwnOg=s120",
                "is_subject_to_whitelist": false,
                "large_image_url": "https://lh3.googleusercontent.com/4aSYyyyW-c2Vmh_-OSG4W5szSXF6dIjGuFkbp99DqE7f4liwytRHKfBiZ1zyXKI8RTCAvBVRfZL06IO7V-AY7LMTOnZaBx0S60X92g=s300",
                "medium_username": null,
                "name": "VeeFriends",
                "only_proxied_transfers": false,
                "opensea_buyer_fee_basis_points": "0",
                "opensea_seller_fee_basis_points": "250",
                "payout_address": "0x263a1c688c4426eede9b57e741ffb2b9cadcca94",
                "require_email": false,
                "short_description": null,
                "slug": "veefriends",
                "telegram_url": null,
                "twitter_username": "veefriends",
                "instagram_username": "veefriends",
                "wiki_url": null
            },
            "decimals": 0,
            "token_metadata": "https://erc721.veefriends.com/api/metadata/0xa3aee8bce55beea1951ef834b99f3ac60d1abeeb/1708",
            "sell_orders": null,
            "creator": {
                "user": {
                    "username": "TheJocker"
                },
                "profile_img_url": "https://storage.googleapis.com/opensea-static/opensea-profile/32.png",
                "address": "0xa33ec50ab06ae30adace80e6c63ca398eb1a4019",
                "config": "",
                "discord_id": ""
            },
            "traits": [
                {
                    "trait_type": "group",
                    "value": "Admission",
                    "display_type": null,
                    "max_value": null,
                    "trait_count": 8542,
                    "order": null
                },
                {
                    "trait_type": "adjective",
                    "value": "Charismatic",
                    "display_type": null,
                    "max_value": null,
                    "trait_count": 33,
                    "order": null
                },
                {
                    "trait_type": "animal",
                    "value": "Chameleon",
                    "display_type": null,
                    "max_value": null,
                    "trait_count": 33,
                    "order": null
                },
                {
                    "trait_type": "conference",
                    "value": "Limited",
                    "display_type": null,
                    "max_value": null,
                    "trait_count": 3842,
                    "order": null
                },
                {
                    "trait_type": "OG Price",
                    "value": "1.5 Ξ",
                    "display_type": null,
                    "max_value": null,
                    "trait_count": 587,
                    "order": null
                },
                {
                    "trait_type": "creator",
                    "value": "VeeFriends",
                    "display_type": null,
                    "max_value": null,
                    "trait_count": 9371,
                    "order": null
                },
                {
                    "trait_type": "Edition #",
                    "value": "5",
                    "display_type": null,
                    "max_value": null,
                    "trait_count": 660,
                    "order": null
                },
                {
                    "trait_type": "Birthday",
                    "value": 1621982863.0,
                    "display_type": "date",
                    "max_value": null,
                    "trait_count": 0,
                    "order": null
                },
                {
                    "trait_type": "property",
                    "value": "Jungle",
                    "display_type": null,
                    "max_value": null,
                    "trait_count": 1018,
                    "order": null
                },
                {
                    "trait_type": "Editions",
                    "value": "1 of 5",
                    "display_type": null,
                    "max_value": null,
                    "trait_count": 874,
                    "order": null
                },
                {
                    "trait_type": "rarity",
                    "value": "Very Rare",
                    "display_type": null,
                    "max_value": null,
                    "trait_count": 874,
                    "order": null
                },
                {
                    "trait_type": "OG Buyer",
                    "value": "0xA33Ec50AB06Ae30aDAcE80E6c63CA398eB1A4019",
                    "display_type": null,
                    "max_value": null,
                    "trait_count": 2,
                    "order": null
                },
                {
                    "trait_type": "category",
                    "value": "Reptile",
                    "display_type": null,
                    "max_value": null,
                    "trait_count": 368,
                    "order": null
                }
            ],
            "last_sale": null,
            "top_bid": null,
            "listing_date": null,
            "is_presale": false,
            "transfer_fee_payment_token": null,
            "transfer_fee": null
        },
        {
            "id": 25665450,
            "token_id": "1028548",
            "num_sales": 0,
            "background_color": null,
            "image_url": "https://lh3.googleusercontent.com/C8sJjzJZDJ_kwBJh8uu5Oldgy92HXbmflw4YE7p2HHqcgxRF42XeWy60PJVcFm6ZOYCw9ZGoBVBmkHwuBu2GiT3j4wQGoJLc62CIYFA",
            "image_preview_url": "https://lh3.googleusercontent.com/C8sJjzJZDJ_kwBJh8uu5Oldgy92HXbmflw4YE7p2HHqcgxRF42XeWy60PJVcFm6ZOYCw9ZGoBVBmkHwuBu2GiT3j4wQGoJLc62CIYFA=s250",
            "image_thumbnail_url": "https://lh3.googleusercontent.com/C8sJjzJZDJ_kwBJh8uu5Oldgy92HXbmflw4YE7p2HHqcgxRF42XeWy60PJVcFm6ZOYCw9ZGoBVBmkHwuBu2GiT3j4wQGoJLc62CIYFA=s128",
            "image_original_url": "https://ipfs.io/ipfs/QmZbbNVyAxFtUj69qR1QKaSXHy6NFg8hpvir9BvKi6sYZJ/image.png",
            "animation_url": null,
            "animation_original_url": null,
            "name": "Life",
            "description": "Even some negative events can lead to something positive. Every experience, encounter or memory makes us who we are and should be cherished.",
            "external_link": "https://rarible.com/token/0x60f80121c31a0d46b5279700f9df786054aa5ee5:1028548",
            "asset_contract": {
                "address": "0x60f80121c31a0d46b5279700f9df786054aa5ee5",
                "asset_contract_type": "non-fungible",
                "created_date": "2020-05-27T17:06:50.488471",
                "name": "Rarible V2",
                "nft_version": "3.0",
                "opensea_version": null,
                "owner": 1634963,
                "schema_name": "ERC721",
                "symbol": "",
                "total_supply": "1",
                "description": "Create and sell digital collectibles secured with blockchain technology. Rarible is home to thousands of artists and collectors, creating and exchanging immutable art without using code. Trade with RARI token on OpenSea.",
                "external_link": "https://rarible.com/",
                "image_url": "https://lh3.googleusercontent.com/FG0QJ00fN3c_FWuPeUr9-T__iQl63j9hn5d6svW8UqOmia5zp3lKHPkJuHcvhZ0f_Pd6P2COo9tt9zVUvdPxG_9BBw=s60",
                "default_to_fiat": false,
                "dev_buyer_fee_basis_points": 0,
                "dev_seller_fee_basis_points": 0,
                "only_proxied_transfers": false,
                "opensea_buyer_fee_basis_points": 0,
                "opensea_seller_fee_basis_points": 250,
                "buyer_fee_basis_points": 0,
                "seller_fee_basis_points": 250,
                "payout_address": null
            },
            "owner": {
                "user": {
                    "username": "BekaRios"
                },
                "profile_img_url": "https://storage.googleapis.com/opensea-static/opensea-profile/11.png",
                "address": "0x734b5ce55f0e08ba02d1956eef689d20fbdcd4df",
                "config": "",
                "discord_id": ""
            },
            "permalink": "https://opensea.io/assets/0x60f80121c31a0d46b5279700f9df786054aa5ee5/1028548",
            "collection": {
                "banner_image_url": "https://storage.opensea.io/static/banners/rarible-banner4.png",
                "chat_url": null,
                "created_date": "2020-01-01T13:22:57.777065",
                "default_to_fiat": false,
                "description": "Create and sell digital collectibles secured with blockchain technology. Rarible is home to thousands of artists and collectors, creating and exchanging immutable art without using code. Trade with RARI token on OpenSea.",
                "dev_buyer_fee_basis_points": "0",
                "dev_seller_fee_basis_points": "0",
                "discord_url": null,
                "display_data": {
                    "card_display_style": "contain"
                },
                "external_url": "https://rarible.com/",
                "featured": false,
                "featured_image_url": null,
                "hidden": false,
                "safelist_request_status": "verified",
                "image_url": "https://lh3.googleusercontent.com/FG0QJ00fN3c_FWuPeUr9-T__iQl63j9hn5d6svW8UqOmia5zp3lKHPkJuHcvhZ0f_Pd6P2COo9tt9zVUvdPxG_9BBw=s60",
                "is_subject_to_whitelist": false,
                "large_image_url": "https://lh3.googleusercontent.com/FG0QJ00fN3c_FWuPeUr9-T__iQl63j9hn5d6svW8UqOmia5zp3lKHPkJuHcvhZ0f_Pd6P2COo9tt9zVUvdPxG_9BBw",
                "medium_username": "rarible",
                "name": "Rarible",
                "only_proxied_transfers": false,
                "opensea_buyer_fee_basis_points": "0",
                "opensea_seller_fee_basis_points": "250",
                "payout_address": null,
                "require_email": false,
                "short_description": null,
                "slug": "rarible",
                "telegram_url": "https://t.me/rarible",
                "twitter_username": "rariblecom",
                "instagram_username": null,
                "wiki_url": null
            },
            "decimals": 0,
            "token_metadata": "https://ipfs.io/ipfs/QmUHzqQtQ4H5FeAdtC5XZy3npjFJAJzD5kwC8YBRB6VBwz",
            "sell_orders": null,
            "creator": {
                "user": {
                    "username": "BekaRios"
                },
                "profile_img_url": "https://storage.googleapis.com/opensea-static/opensea-profile/11.png",
                "address": "0x734b5ce55f0e08ba02d1956eef689d20fbdcd4df",
                "config": "",
                "discord_id": ""
            },
            "traits": [
                {
                    "trait_type": "4888x6602",
                    "value": "38 MB",
                    "display_type": null,
                    "max_value": null,
                    "trait_count": 0,
                    "order": null
                }
            ],
            "last_sale": null,
            "top_bid": null,
            "listing_date": null,
            "is_presale": false,
            "transfer_fee_payment_token": null,
            "transfer_fee": null
        },
        {
            "id": 25665449,
            "token_id": "1027",
            "num_sales": 0,
            "background_color": null,
            "image_url": "https://lh3.googleusercontent.com/pbgSLXg7qjYUjdReJl3ZdyBxzcac9QmLyIhZTM2n8YRHaaf6v1y1Auivt3gO2VTWp5d5E-FTDCOBgu2W4i8dCqoDMM7Dm2ibstPjzdI",
            "image_preview_url": "https://lh3.googleusercontent.com/pbgSLXg7qjYUjdReJl3ZdyBxzcac9QmLyIhZTM2n8YRHaaf6v1y1Auivt3gO2VTWp5d5E-FTDCOBgu2W4i8dCqoDMM7Dm2ibstPjzdI=s250",
            "image_thumbnail_url": "https://lh3.googleusercontent.com/pbgSLXg7qjYUjdReJl3ZdyBxzcac9QmLyIhZTM2n8YRHaaf6v1y1Auivt3gO2VTWp5d5E-FTDCOBgu2W4i8dCqoDMM7Dm2ibstPjzdI=s128",
            "image_original_url": "https://cdn.veefriends.com/f6pXbdBrDkgJjmSV-_XTrDCsS97-QXp2H6Yu0fLSCB0/327.png",
            "animation_url": null,
            "animation_original_url": null,
            "name": "Befuddled Burglar",
            "description": "This token is verifiable for admission to VeeCon 2022, 2023, 2024\n\nThis token is a collectible that lives on the Ethereum blockchain\n\nAdditional Content:\n\n- [Character Vector](https://cdn.veefriends.com/f6pXbdBrDkgJjmSV-_XTrDCsS97-QXp2H6Yu0fLSCB0/3293.svg)\n- [Character Image](https://cdn.veefriends.com/f6pXbdBrDkgJjmSV-_XTrDCsS97-QXp2H6Yu0fLSCB0/2534.png) \n- [Character Creation Video](https://cdn.veefriends.com/f6pXbdBrDkgJjmSV-_XTrDCsS97-QXp2H6Yu0fLSCB0/290.mp4)\n- [Character with Gary Vaynerchuk](https://cdn.veefriends.com/f6pXbdBrDkgJjmSV-_XTrDCsS97-QXp2H6Yu0fLSCB0/291.jpg)",
            "external_link": null,
            "asset_contract": {
                "address": "0xa3aee8bce55beea1951ef834b99f3ac60d1abeeb",
                "asset_contract_type": "non-fungible",
                "created_date": "2021-05-11T17:30:01.380820",
                "name": "VeeFriends",
                "nft_version": "3.0",
                "opensea_version": null,
                "owner": 41520829,
                "schema_name": "ERC721",
                "symbol": "VFT",
                "total_supply": "0",
                "description": "A Gary Vaynerchuk NFT project around meaningful intellectual property and an extraordinary community.",
                "external_link": "https://veefriends.com/",
                "image_url": "https://lh3.googleusercontent.com/5y-UCAXiNOFXH551w5bWdZEYOCdHPwbqmcKb-xa3uVQEjQgxvih3HtZWSmzqDqd0uk7kIqFrZhw32Gt6xPBFg4t_n9BKhpou-dwnOg=s120",
                "default_to_fiat": false,
                "dev_buyer_fee_basis_points": 0,
                "dev_seller_fee_basis_points": 1000,
                "only_proxied_transfers": false,
                "opensea_buyer_fee_basis_points": 0,
                "opensea_seller_fee_basis_points": 250,
                "buyer_fee_basis_points": 0,
                "seller_fee_basis_points": 1250,
                "payout_address": "0x263a1c688c4426eede9b57e741ffb2b9cadcca94"
            },
            "owner": {
                "user": {
                    "username": null
                },
                "profile_img_url": "https://storage.googleapis.com/opensea-static/opensea-profile/21.png",
                "address": "0x30b133841c6ec175b57a629efccadaf3510d9a46",
                "config": "",
                "discord_id": ""
            },
            "permalink": "https://opensea.io/assets/0xa3aee8bce55beea1951ef834b99f3ac60d1abeeb/1027",
            "collection": {
                "banner_image_url": "https://lh3.googleusercontent.com/4RYeNt3ET75VLMoCZz-fsOhXg8AW8qlkHfgkbA0FfEayNpsHvOZROygyy9IhY4LwrnJUXqkeDjBZBr8bCf0Ng_xUiRZqWRGng3sc=s2500",
                "chat_url": null,
                "created_date": "2021-05-11T18:22:19.398578",
                "default_to_fiat": false,
                "description": "A Gary Vaynerchuk NFT project around meaningful intellectual property and an extraordinary community.",
                "dev_buyer_fee_basis_points": "0",
                "dev_seller_fee_basis_points": "1000",
                "discord_url": null,
                "display_data": {
                    "card_display_style": "cover"
                },
                "external_url": "https://veefriends.com/",
                "featured": false,
                "featured_image_url": "https://lh3.googleusercontent.com/4aSYyyyW-c2Vmh_-OSG4W5szSXF6dIjGuFkbp99DqE7f4liwytRHKfBiZ1zyXKI8RTCAvBVRfZL06IO7V-AY7LMTOnZaBx0S60X92g=s300",
                "hidden": false,
                "safelist_request_status": "verified",
                "image_url": "https://lh3.googleusercontent.com/5y-UCAXiNOFXH551w5bWdZEYOCdHPwbqmcKb-xa3uVQEjQgxvih3HtZWSmzqDqd0uk7kIqFrZhw32Gt6xPBFg4t_n9BKhpou-dwnOg=s120",
                "is_subject_to_whitelist": false,
                "large_image_url": "https://lh3.googleusercontent.com/4aSYyyyW-c2Vmh_-OSG4W5szSXF6dIjGuFkbp99DqE7f4liwytRHKfBiZ1zyXKI8RTCAvBVRfZL06IO7V-AY7LMTOnZaBx0S60X92g=s300",
                "medium_username": null,
                "name": "VeeFriends",
                "only_proxied_transfers": false,
                "opensea_buyer_fee_basis_points": "0",
                "opensea_seller_fee_basis_points": "250",
                "payout_address": "0x263a1c688c4426eede9b57e741ffb2b9cadcca94",
                "require_email": false,
                "short_description": null,
                "slug": "veefriends",
                "telegram_url": null,
                "twitter_username": "veefriends",
                "instagram_username": "veefriends",
                "wiki_url": null
            },
            "decimals": 0,
            "token_metadata": "https://erc721.veefriends.com/api/metadata/0xa3aee8bce55beea1951ef834b99f3ac60d1abeeb/1027",
            "sell_orders": null,
            "creator": {
                "user": {
                    "username": null
                },
                "profile_img_url": "https://storage.googleapis.com/opensea-static/opensea-profile/21.png",
                "address": "0x30b133841c6ec175b57a629efccadaf3510d9a46",
                "config": "",
                "discord_id": ""
            },
            "traits": [
                {
                    "trait_type": "group",
                    "value": "Admission",
                    "display_type": null,
                    "max_value": null,
                    "trait_count": 8542,
                    "order": null
                },
                {
                    "trait_type": "conference",
                    "value": "Limited",
                    "display_type": null,
                    "max_value": null,
                    "trait_count": 3842,
                    "order": null
                },
                {
                    "trait_type": "creator",
                    "value": "VeeFriends",
                    "display_type": null,
                    "max_value": null,
                    "trait_count": 9371,
                    "order": null
                },
                {
                    "trait_type": "category",
                    "value": "Human",
                    "display_type": null,
                    "max_value": null,
                    "trait_count": 318,
                    "order": null
                },
                {
                    "trait_type": "Edition #",
                    "value": "1",
                    "display_type": null,
                    "max_value": null,
                    "trait_count": 1708,
                    "order": null
                },
                {
                    "trait_type": "Birthday",
                    "value": 1621982846.0,
                    "display_type": "date",
                    "max_value": null,
                    "trait_count": 0,
                    "order": null
                },
                {
                    "trait_type": "OG Price",
                    "value": "2.5 Ξ",
                    "display_type": null,
                    "max_value": null,
                    "trait_count": 172,
                    "order": null
                },
                {
                    "trait_type": "adjective",
                    "value": "Befuddled",
                    "display_type": null,
                    "max_value": null,
                    "trait_count": 38,
                    "order": null
                },
                {
                    "trait_type": "animal",
                    "value": "Burglar",
                    "display_type": null,
                    "max_value": null,
                    "trait_count": 38,
                    "order": null
                },
                {
                    "trait_type": "Editions",
                    "value": "1 of 2",
                    "display_type": null,
                    "max_value": null,
                    "trait_count": 253,
                    "order": null
                },
                {
                    "trait_type": "OG Buyer",
                    "value": "0x30b133841c6ec175B57A629EfCCADAf3510d9a46",
                    "display_type": null,
                    "max_value": null,
                    "trait_count": 111,
                    "order": null
                },
                {
                    "trait_type": "rarity",
                    "value": "Epic",
                    "display_type": null,
                    "max_value": null,
                    "trait_count": 253,
                    "order": null
                }
            ],
            "last_sale": null,
            "top_bid": null,
            "listing_date": null,
            "is_presale": false,
            "transfer_fee_payment_token": null,
            "transfer_fee": null
        },
        {
            "id": 25665443,
            "token_id": "158456335137344990529876110560",
            "num_sales": 0,
            "background_color": null,
            "image_url": "https://lh3.googleusercontent.com/Kg_TgkSSdlYBeCCUkUhEB_fMs-559KD5jsTS24yAceMNMSObFDPjzYXjroTV7ZLdHP1EPWtMWsPpUFtNrGdFQy4hEb23w5b8tQO3",
            "image_preview_url": "https://lh3.googleusercontent.com/Kg_TgkSSdlYBeCCUkUhEB_fMs-559KD5jsTS24yAceMNMSObFDPjzYXjroTV7ZLdHP1EPWtMWsPpUFtNrGdFQy4hEb23w5b8tQO3=s250",
            "image_thumbnail_url": "https://lh3.googleusercontent.com/Kg_TgkSSdlYBeCCUkUhEB_fMs-559KD5jsTS24yAceMNMSObFDPjzYXjroTV7ZLdHP1EPWtMWsPpUFtNrGdFQy4hEb23w5b8tQO3=s128",
            "image_original_url": "https://neon-district-season-one.s3.amazonaws.com/images/yumeriveterp-rare-arms-female-thumb.png",
            "animation_url": null,
            "animation_original_url": null,
            "name": "Yume Riveter: Paragon",
            "description": "Armor found within Neon District.\n\nA Neon District: Season One game item, playable on https://portal.neondistrict.io.\n\nNeon District is a free-to-play cyberpunk role-playing game. Collect characters and gear, craft and level up teams, and battle against other players through competitive multiplayer and in turn-based combat.",
            "external_link": "https://portal.neondistrict.io/asset/158456335137344990529876110560",
            "asset_contract": {
                "address": "0x7227e371540cf7b8e512544ba6871472031f3335",
                "asset_contract_type": "non-fungible",
                "created_date": "2021-01-04T17:12:08.151181",
                "name": "Neon District Season One Item",
                "nft_version": null,
                "opensea_version": null,
                "owner": 17710883,
                "schema_name": "ERC721",
                "symbol": "NDITEM1",
                "total_supply": "475982",
                "description": "Neon District is a free-to-play cyberpunk role-playing game featuring collectible NFTs on Matic and Ethereum. Players collect characters and gear, craft and level up fully-equipped teams, and battle their teams against other players through the Neon Pizza competitive multiplayer missions or in real-time turn-based combat.",
                "external_link": null,
                "image_url": "https://lh3.googleusercontent.com/xttZf6L3I16h7HSgcfKFWhR7OhCdSO5UW_asXbRfGmQ7-a0QwJRNoPsmh_RlOpw-AFEngLqGYLD77cmjdBv4LCfVc5BxFG2PS1UU=s120",
                "default_to_fiat": false,
                "dev_buyer_fee_basis_points": 0,
                "dev_seller_fee_basis_points": 500,
                "only_proxied_transfers": false,
                "opensea_buyer_fee_basis_points": 0,
                "opensea_seller_fee_basis_points": 250,
                "buyer_fee_basis_points": 0,
                "seller_fee_basis_points": 750,
                "payout_address": "0x08262c33e987ed580b69d8f93134e987f881bdcc"
            },
            "owner": {
                "user": null,
                "profile_img_url": "https://storage.googleapis.com/opensea-static/opensea-profile/1.png",
                "address": "0x0000000000000000000000000000000000000000",
                "config": "",
                "discord_id": ""
            },
            "permalink": "https://opensea.io/assets/matic/0x7227e371540cf7b8e512544ba6871472031f3335/158456335137344990529876110560",
            "collection": {
                "banner_image_url": "https://lh3.googleusercontent.com/vtZXDR51ibkUx6v2XRf3imqsL-bUzy7tALBcjrwx0fNJywcMCqK_bVIfrvdlKQ5sysboHA23kGiwbgsGb5c_6ROGsyzc-SZURrtqRA=s2500",
                "chat_url": null,
                "created_date": "2021-01-04T17:12:08.305423",
                "default_to_fiat": false,
                "description": "Neon District is a free-to-play cyberpunk role-playing game featuring collectible NFTs on Matic and Ethereum. Players collect characters and gear, craft and level up fully-equipped teams, and battle their teams against other players through the Neon Pizza competitive multiplayer missions or in real-time turn-based combat.",
                "dev_buyer_fee_basis_points": "0",
                "dev_seller_fee_basis_points": "500",
                "discord_url": "https://discord.gg/ERu7Zw9YwZ",
                "display_data": {
                    "card_display_style": "contain"
                },
                "external_url": null,
                "featured": false,
                "featured_image_url": "https://lh3.googleusercontent.com/vtZXDR51ibkUx6v2XRf3imqsL-bUzy7tALBcjrwx0fNJywcMCqK_bVIfrvdlKQ5sysboHA23kGiwbgsGb5c_6ROGsyzc-SZURrtqRA=s300",
                "hidden": false,
                "safelist_request_status": "approved",
                "image_url": "https://lh3.googleusercontent.com/xttZf6L3I16h7HSgcfKFWhR7OhCdSO5UW_asXbRfGmQ7-a0QwJRNoPsmh_RlOpw-AFEngLqGYLD77cmjdBv4LCfVc5BxFG2PS1UU=s120",
                "is_subject_to_whitelist": false,
                "large_image_url": "https://lh3.googleusercontent.com/vtZXDR51ibkUx6v2XRf3imqsL-bUzy7tALBcjrwx0fNJywcMCqK_bVIfrvdlKQ5sysboHA23kGiwbgsGb5c_6ROGsyzc-SZURrtqRA=s300",
                "medium_username": "blockadegames",
                "name": "Neon District Season One Item",
                "only_proxied_transfers": false,
                "opensea_buyer_fee_basis_points": "0",
                "opensea_seller_fee_basis_points": "250",
                "payout_address": "0x08262c33e987ed580b69d8f93134e987f881bdcc",
                "require_email": false,
                "short_description": null,
                "slug": "neon-district-season-one-item",
                "telegram_url": null,
                "twitter_username": "neondistrictrpg",
                "instagram_username": null,
                "wiki_url": null
            },
            "decimals": null,
            "token_metadata": "https://portal.neondistrict.io/api/getNft/158456335137344990529876110560",
            "sell_orders": null,
            "creator": null,
            "traits": [
                {
                    "trait_type": "Tactics",
                    "value": 3,
                    "display_type": "boost_number",
                    "max_value": null,
                    "trait_count": 0,
                    "order": null
                },
                {
                    "trait_type": "Nano",
                    "value": 0,
                    "display_type": "boost_number",
                    "max_value": null,
                    "trait_count": 0,
                    "order": null
                },
                {
                    "trait_type": "Attack",
                    "value": 28,
                    "display_type": "boost_number",
                    "max_value": null,
                    "trait_count": 0,
                    "order": null
                },
                {
                    "trait_type": "rarity",
                    "value": "Rare",
                    "display_type": null,
                    "max_value": null,
                    "trait_count": 82125,
                    "order": null
                },
                {
                    "trait_type": "level",
                    "value": 3,
                    "display_type": null,
                    "max_value": null,
                    "trait_count": 0,
                    "order": null
                },
                {
                    "trait_type": "Season",
                    "value": 1,
                    "display_type": "number",
                    "max_value": null,
                    "trait_count": 0,
                    "order": null
                },
                {
                    "trait_type": "Mech",
                    "value": 8,
                    "display_type": "boost_number",
                    "max_value": null,
                    "trait_count": 0,
                    "order": null
                },
                {
                    "trait_type": "type",
                    "value": "Armor",
                    "display_type": null,
                    "max_value": null,
                    "trait_count": 321945,
                    "order": null
                },
                {
                    "trait_type": "Stealth",
                    "value": 5,
                    "display_type": "boost_number",
                    "max_value": null,
                    "trait_count": 0,
                    "order": null
                },
                {
                    "trait_type": "Defense",
                    "value": 6,
                    "display_type": "boost_number",
                    "max_value": null,
                    "trait_count": 0,
                    "order": null
                },
                {
                    "trait_type": "Hacking",
                    "value": 0,
                    "display_type": "boost_number",
                    "max_value": null,
                    "trait_count": 0,
                    "order": null
                },
                {
                    "trait_type": "Armor Slot",
                    "value": "Arms",
                    "display_type": null,
                    "max_value": null,
                    "trait_count": 80466,
                    "order": null
                },
                {
                    "trait_type": "Health",
                    "value": 81,
                    "display_type": "boost_number",
                    "max_value": null,
                    "trait_count": 0,
                    "order": null
                }
            ],
            "last_sale": null,
            "top_bid": null,
            "listing_date": null,
            "is_presale": false,
            "transfer_fee_payment_token": null,
            "transfer_fee": null
        },
        {
            "id": 25665442,
            "token_id": "158456338347078459355338091743",
            "num_sales": 0,
            "background_color": null,
            "image_url": "https://lh3.googleusercontent.com/2L3qRhgb7mzq7H4EujAoRL0UgB7eAosyQgGf6MzoP7dQSFbnyUZkhHa8hI0is_5Lt-7ZLsQXsEHx9vIiOnd9hXchDQVs6_frj9fO_w",
            "image_preview_url": "https://lh3.googleusercontent.com/2L3qRhgb7mzq7H4EujAoRL0UgB7eAosyQgGf6MzoP7dQSFbnyUZkhHa8hI0is_5Lt-7ZLsQXsEHx9vIiOnd9hXchDQVs6_frj9fO_w=s250",
            "image_thumbnail_url": "https://lh3.googleusercontent.com/2L3qRhgb7mzq7H4EujAoRL0UgB7eAosyQgGf6MzoP7dQSFbnyUZkhHa8hI0is_5Lt-7ZLsQXsEHx9vIiOnd9hXchDQVs6_frj9fO_w=s128",
            "image_original_url": "https://neon-district-season-one.s3.amazonaws.com/images/blkprotectionorb-common-drone-sml-thumb.png",
            "animation_url": null,
            "animation_original_url": null,
            "name": "Protection Orb",
            "description": "A weapon found within Neon District.\n\nA Neon District: Season One game item, playable on https://portal.neondistrict.io.\n\nNeon District is a free-to-play cyberpunk role-playing game. Collect characters and gear, craft and level up teams, and battle against other players through competitive multiplayer and in turn-based combat.",
            "external_link": "https://portal.neondistrict.io/asset/158456338347078459355338091743",
            "asset_contract": {
                "address": "0x7227e371540cf7b8e512544ba6871472031f3335",
                "asset_contract_type": "non-fungible",
                "created_date": "2021-01-04T17:12:08.151181",
                "name": "Neon District Season One Item",
                "nft_version": null,
                "opensea_version": null,
                "owner": 17710883,
                "schema_name": "ERC721",
                "symbol": "NDITEM1",
                "total_supply": "475982",
                "description": "Neon District is a free-to-play cyberpunk role-playing game featuring collectible NFTs on Matic and Ethereum. Players collect characters and gear, craft and level up fully-equipped teams, and battle their teams against other players through the Neon Pizza competitive multiplayer missions or in real-time turn-based combat.",
                "external_link": null,
                "image_url": "https://lh3.googleusercontent.com/xttZf6L3I16h7HSgcfKFWhR7OhCdSO5UW_asXbRfGmQ7-a0QwJRNoPsmh_RlOpw-AFEngLqGYLD77cmjdBv4LCfVc5BxFG2PS1UU=s120",
                "default_to_fiat": false,
                "dev_buyer_fee_basis_points": 0,
                "dev_seller_fee_basis_points": 500,
                "only_proxied_transfers": false,
                "opensea_buyer_fee_basis_points": 0,
                "opensea_seller_fee_basis_points": 250,
                "buyer_fee_basis_points": 0,
                "seller_fee_basis_points": 750,
                "payout_address": "0x08262c33e987ed580b69d8f93134e987f881bdcc"
            },
            "owner": {
                "user": null,
                "profile_img_url": "https://storage.googleapis.com/opensea-static/opensea-profile/1.png",
                "address": "0x0000000000000000000000000000000000000000",
                "config": "",
                "discord_id": ""
            },
            "permalink": "https://opensea.io/assets/matic/0x7227e371540cf7b8e512544ba6871472031f3335/158456338347078459355338091743",
            "collection": {
                "banner_image_url": "https://lh3.googleusercontent.com/vtZXDR51ibkUx6v2XRf3imqsL-bUzy7tALBcjrwx0fNJywcMCqK_bVIfrvdlKQ5sysboHA23kGiwbgsGb5c_6ROGsyzc-SZURrtqRA=s2500",
                "chat_url": null,
                "created_date": "2021-01-04T17:12:08.305423",
                "default_to_fiat": false,
                "description": "Neon District is a free-to-play cyberpunk role-playing game featuring collectible NFTs on Matic and Ethereum. Players collect characters and gear, craft and level up fully-equipped teams, and battle their teams against other players through the Neon Pizza competitive multiplayer missions or in real-time turn-based combat.",
                "dev_buyer_fee_basis_points": "0",
                "dev_seller_fee_basis_points": "500",
                "discord_url": "https://discord.gg/ERu7Zw9YwZ",
                "display_data": {
                    "card_display_style": "contain"
                },
                "external_url": null,
                "featured": false,
                "featured_image_url": "https://lh3.googleusercontent.com/vtZXDR51ibkUx6v2XRf3imqsL-bUzy7tALBcjrwx0fNJywcMCqK_bVIfrvdlKQ5sysboHA23kGiwbgsGb5c_6ROGsyzc-SZURrtqRA=s300",
                "hidden": false,
                "safelist_request_status": "approved",
                "image_url": "https://lh3.googleusercontent.com/xttZf6L3I16h7HSgcfKFWhR7OhCdSO5UW_asXbRfGmQ7-a0QwJRNoPsmh_RlOpw-AFEngLqGYLD77cmjdBv4LCfVc5BxFG2PS1UU=s120",
                "is_subject_to_whitelist": false,
                "large_image_url": "https://lh3.googleusercontent.com/vtZXDR51ibkUx6v2XRf3imqsL-bUzy7tALBcjrwx0fNJywcMCqK_bVIfrvdlKQ5sysboHA23kGiwbgsGb5c_6ROGsyzc-SZURrtqRA=s300",
                "medium_username": "blockadegames",
                "name": "Neon District Season One Item",
                "only_proxied_transfers": false,
                "opensea_buyer_fee_basis_points": "0",
                "opensea_seller_fee_basis_points": "250",
                "payout_address": "0x08262c33e987ed580b69d8f93134e987f881bdcc",
                "require_email": false,
                "short_description": null,
                "slug": "neon-district-season-one-item",
                "telegram_url": null,
                "twitter_username": "neondistrictrpg",
                "instagram_username": null,
                "wiki_url": null
            },
            "decimals": null,
            "token_metadata": "https://portal.neondistrict.io/api/getNft/158456338347078459355338091743",
            "sell_orders": null,
            "creator": null,
            "traits": [
                {
                    "trait_type": "Card",
                    "value": "Multi-task",
                    "display_type": null,
                    "max_value": null,
                    "trait_count": 3317,
                    "order": null
                },
                {
                    "trait_type": "Card",
                    "value": "Atomic Cement",
                    "display_type": null,
                    "max_value": null,
                    "trait_count": 3346,
                    "order": null
                },
                {
                    "trait_type": "Card",
                    "value": "Launch Tracking Missiles!",
                    "display_type": null,
                    "max_value": null,
                    "trait_count": 3284,
                    "order": null
                },
                {
                    "trait_type": "Card",
                    "value": "Rectify",
                    "display_type": null,
                    "max_value": null,
                    "trait_count": 3287,
                    "order": null
                },
                {
                    "trait_type": "type",
                    "value": "Weapon",
                    "display_type": null,
                    "max_value": null,
                    "trait_count": 54897,
                    "order": null
                },
                {
                    "trait_type": "rarity",
                    "value": "Common",
                    "display_type": null,
                    "max_value": null,
                    "trait_count": 219643,
                    "order": null
                },
                {
                    "trait_type": "level",
                    "value": 1,
                    "display_type": null,
                    "max_value": null,
                    "trait_count": 0,
                    "order": null
                },
                {
                    "trait_type": "Season",
                    "value": 1,
                    "display_type": "number",
                    "max_value": null,
                    "trait_count": 0,
                    "order": null
                },
                {
                    "trait_type": "Defense",
                    "value": 25,
                    "display_type": "boost_number",
                    "max_value": null,
                    "trait_count": 0,
                    "order": null
                },
                {
                    "trait_type": "Nano",
                    "value": 15,
                    "display_type": "boost_number",
                    "max_value": null,
                    "trait_count": 0,
                    "order": null
                },
                {
                    "trait_type": "Attack",
                    "value": 10,
                    "display_type": "boost_number",
                    "max_value": null,
                    "trait_count": 0,
                    "order": null
                },
                {
                    "trait_type": "Hacking",
                    "value": 5,
                    "display_type": "boost_number",
                    "max_value": null,
                    "trait_count": 0,
                    "order": null
                },
                {
                    "trait_type": "Health",
                    "value": 100,
                    "display_type": "boost_number",
                    "max_value": null,
                    "trait_count": 0,
                    "order": null
                },
                {
                    "trait_type": "Stealth",
                    "value": 5,
                    "display_type": "boost_number",
                    "max_value": null,
                    "trait_count": 0,
                    "order": null
                },
                {
                    "trait_type": "Tactics",
                    "value": 5,
                    "display_type": "boost_number",
                    "max_value": null,
                    "trait_count": 0,
                    "order": null
                },
                {
                    "trait_type": "Mech",
                    "value": 25,
                    "display_type": "boost_number",
                    "max_value": null,
                    "trait_count": 0,
                    "order": null
                }
            ],
            "last_sale": null,
            "top_bid": null,
            "listing_date": null,
            "is_presale": false,
            "transfer_fee_payment_token": null,
            "transfer_fee": null
        },
        {
            "id": 25665441,
            "token_id": "158456338771353573050657778910",
            "num_sales": 0,
            "background_color": null,
            "image_url": "https://lh3.googleusercontent.com/6HnaZKplTXd9h4aa3cHnWShNIFYJ1vahfrxIWbXAJoj4276LlzsYvuYepa9QoFJLr0VQKFhsZ65TcdNIvvapHsaB0n28LcWYlKx5WQ",
            "image_preview_url": "https://lh3.googleusercontent.com/6HnaZKplTXd9h4aa3cHnWShNIFYJ1vahfrxIWbXAJoj4276LlzsYvuYepa9QoFJLr0VQKFhsZ65TcdNIvvapHsaB0n28LcWYlKx5WQ=s250",
            "image_thumbnail_url": "https://lh3.googleusercontent.com/6HnaZKplTXd9h4aa3cHnWShNIFYJ1vahfrxIWbXAJoj4276LlzsYvuYepa9QoFJLr0VQKFhsZ65TcdNIvvapHsaB0n28LcWYlKx5WQ=s128",
            "image_original_url": "https://neon-district-season-one.s3.amazonaws.com/images/blissmanipulatorp-common-legs-female-thumb.png",
            "animation_url": null,
            "animation_original_url": null,
            "name": "Bliss Manipulator: Paragon",
            "description": "Armor found within Neon District.\n\nA Neon District: Season One game item, playable on https://portal.neondistrict.io.\n\nNeon District is a free-to-play cyberpunk role-playing game. Collect characters and gear, craft and level up teams, and battle against other players through competitive multiplayer and in turn-based combat.",
            "external_link": "https://portal.neondistrict.io/asset/158456338771353573050657778910",
            "asset_contract": {
                "address": "0x7227e371540cf7b8e512544ba6871472031f3335",
                "asset_contract_type": "non-fungible",
                "created_date": "2021-01-04T17:12:08.151181",
                "name": "Neon District Season One Item",
                "nft_version": null,
                "opensea_version": null,
                "owner": 17710883,
                "schema_name": "ERC721",
                "symbol": "NDITEM1",
                "total_supply": "475982",
                "description": "Neon District is a free-to-play cyberpunk role-playing game featuring collectible NFTs on Matic and Ethereum. Players collect characters and gear, craft and level up fully-equipped teams, and battle their teams against other players through the Neon Pizza competitive multiplayer missions or in real-time turn-based combat.",
                "external_link": null,
                "image_url": "https://lh3.googleusercontent.com/xttZf6L3I16h7HSgcfKFWhR7OhCdSO5UW_asXbRfGmQ7-a0QwJRNoPsmh_RlOpw-AFEngLqGYLD77cmjdBv4LCfVc5BxFG2PS1UU=s120",
                "default_to_fiat": false,
                "dev_buyer_fee_basis_points": 0,
                "dev_seller_fee_basis_points": 500,
                "only_proxied_transfers": false,
                "opensea_buyer_fee_basis_points": 0,
                "opensea_seller_fee_basis_points": 250,
                "buyer_fee_basis_points": 0,
                "seller_fee_basis_points": 750,
                "payout_address": "0x08262c33e987ed580b69d8f93134e987f881bdcc"
            },
            "owner": {
                "user": null,
                "profile_img_url": "https://storage.googleapis.com/opensea-static/opensea-profile/1.png",
                "address": "0x0000000000000000000000000000000000000000",
                "config": "",
                "discord_id": ""
            },
            "permalink": "https://opensea.io/assets/matic/0x7227e371540cf7b8e512544ba6871472031f3335/158456338771353573050657778910",
            "collection": {
                "banner_image_url": "https://lh3.googleusercontent.com/vtZXDR51ibkUx6v2XRf3imqsL-bUzy7tALBcjrwx0fNJywcMCqK_bVIfrvdlKQ5sysboHA23kGiwbgsGb5c_6ROGsyzc-SZURrtqRA=s2500",
                "chat_url": null,
                "created_date": "2021-01-04T17:12:08.305423",
                "default_to_fiat": false,
                "description": "Neon District is a free-to-play cyberpunk role-playing game featuring collectible NFTs on Matic and Ethereum. Players collect characters and gear, craft and level up fully-equipped teams, and battle their teams against other players through the Neon Pizza competitive multiplayer missions or in real-time turn-based combat.",
                "dev_buyer_fee_basis_points": "0",
                "dev_seller_fee_basis_points": "500",
                "discord_url": "https://discord.gg/ERu7Zw9YwZ",
                "display_data": {
                    "card_display_style": "contain"
                },
                "external_url": null,
                "featured": false,
                "featured_image_url": "https://lh3.googleusercontent.com/vtZXDR51ibkUx6v2XRf3imqsL-bUzy7tALBcjrwx0fNJywcMCqK_bVIfrvdlKQ5sysboHA23kGiwbgsGb5c_6ROGsyzc-SZURrtqRA=s300",
                "hidden": false,
                "safelist_request_status": "approved",
                "image_url": "https://lh3.googleusercontent.com/xttZf6L3I16h7HSgcfKFWhR7OhCdSO5UW_asXbRfGmQ7-a0QwJRNoPsmh_RlOpw-AFEngLqGYLD77cmjdBv4LCfVc5BxFG2PS1UU=s120",
                "is_subject_to_whitelist": false,
                "large_image_url": "https://lh3.googleusercontent.com/vtZXDR51ibkUx6v2XRf3imqsL-bUzy7tALBcjrwx0fNJywcMCqK_bVIfrvdlKQ5sysboHA23kGiwbgsGb5c_6ROGsyzc-SZURrtqRA=s300",
                "medium_username": "blockadegames",
                "name": "Neon District Season One Item",
                "only_proxied_transfers": false,
                "opensea_buyer_fee_basis_points": "0",
                "opensea_seller_fee_basis_points": "250",
                "payout_address": "0x08262c33e987ed580b69d8f93134e987f881bdcc",
                "require_email": false,
                "short_description": null,
                "slug": "neon-district-season-one-item",
                "telegram_url": null,
                "twitter_username": "neondistrictrpg",
                "instagram_username": null,
                "wiki_url": null
            },
            "decimals": null,
            "token_metadata": "https://portal.neondistrict.io/api/getNft/158456338771353573050657778910",
            "sell_orders": null,
            "creator": null,
            "traits": [
                {
                    "trait_type": "Nano",
                    "value": 0,
                    "display_type": "boost_number",
                    "max_value": null,
                    "trait_count": 0,
                    "order": null
                },
                {
                    "trait_type": "Health",
                    "value": 15,
                    "display_type": "boost_number",
                    "max_value": null,
                    "trait_count": 0,
                    "order": null
                },
                {
                    "trait_type": "rarity",
                    "value": "Common",
                    "display_type": null,
                    "max_value": null,
                    "trait_count": 219643,
                    "order": null
                },
                {
                    "trait_type": "level",
                    "value": 1,
                    "display_type": null,
                    "max_value": null,
                    "trait_count": 0,
                    "order": null
                },
                {
                    "trait_type": "Season",
                    "value": 1,
                    "display_type": "number",
                    "max_value": null,
                    "trait_count": 0,
                    "order": null
                },
                {
                    "trait_type": "Mech",
                    "value": 5,
                    "display_type": "boost_number",
                    "max_value": null,
                    "trait_count": 0,
                    "order": null
                },
                {
                    "trait_type": "type",
                    "value": "Armor",
                    "display_type": null,
                    "max_value": null,
                    "trait_count": 321945,
                    "order": null
                },
                {
                    "trait_type": "Armor Slot",
                    "value": "Legs",
                    "display_type": null,
                    "max_value": null,
                    "trait_count": 80895,
                    "order": null
                },
                {
                    "trait_type": "Hacking",
                    "value": 5,
                    "display_type": "boost_number",
                    "max_value": null,
                    "trait_count": 0,
                    "order": null
                },
                {
                    "trait_type": "Attack",
                    "value": 5,
                    "display_type": "boost_number",
                    "max_value": null,
                    "trait_count": 0,
                    "order": null
                },
                {
                    "trait_type": "Defense",
                    "value": 5,
                    "display_type": "boost_number",
                    "max_value": null,
                    "trait_count": 0,
                    "order": null
                },
                {
                    "trait_type": "Stealth",
                    "value": 5,
                    "display_type": "boost_number",
                    "max_value": null,
                    "trait_count": 0,
                    "order": null
                },
                {
                    "trait_type": "Tactics",
                    "value": 0,
                    "display_type": "boost_number",
                    "max_value": null,
                    "trait_count": 0,
                    "order": null
                }
            ],
            "last_sale": null,
            "top_bid": null,
            "listing_date": null,
            "is_presale": false,
            "transfer_fee_payment_token": null,
            "transfer_fee": null
        },
        {
            "id": 25665440,
            "token_id": "158456343161678662593531063517",
            "num_sales": 0,
            "background_color": null,
            "image_url": "https://lh3.googleusercontent.com/TmNdmUnu_NIE0OyWgumZw4gHT1KK0OYuCST9-bCRi3f855Nj8vHDuQdIMxzPXyEdFOd78u_CgPylIHLxY_m_oX38oRtjS-8aVVnJmQ",
            "image_preview_url": "https://lh3.googleusercontent.com/TmNdmUnu_NIE0OyWgumZw4gHT1KK0OYuCST9-bCRi3f855Nj8vHDuQdIMxzPXyEdFOd78u_CgPylIHLxY_m_oX38oRtjS-8aVVnJmQ=s250",
            "image_thumbnail_url": "https://lh3.googleusercontent.com/TmNdmUnu_NIE0OyWgumZw4gHT1KK0OYuCST9-bCRi3f855Nj8vHDuQdIMxzPXyEdFOd78u_CgPylIHLxY_m_oX38oRtjS-8aVVnJmQ=s128",
            "image_original_url": "https://neon-district-season-one.s3.amazonaws.com/images/cerespreserverp-common-head-female-thumb.png",
            "animation_url": null,
            "animation_original_url": null,
            "name": "Ceres Preserver: Paragon",
            "description": "Armor found within Neon District.\n\nA Neon District: Season One game item, playable on https://portal.neondistrict.io.\n\nNeon District is a free-to-play cyberpunk role-playing game. Collect characters and gear, craft and level up teams, and battle against other players through competitive multiplayer and in turn-based combat.",
            "external_link": "https://portal.neondistrict.io/asset/158456343161678662593531063517",
            "asset_contract": {
                "address": "0x7227e371540cf7b8e512544ba6871472031f3335",
                "asset_contract_type": "non-fungible",
                "created_date": "2021-01-04T17:12:08.151181",
                "name": "Neon District Season One Item",
                "nft_version": null,
                "opensea_version": null,
                "owner": 17710883,
                "schema_name": "ERC721",
                "symbol": "NDITEM1",
                "total_supply": "475982",
                "description": "Neon District is a free-to-play cyberpunk role-playing game featuring collectible NFTs on Matic and Ethereum. Players collect characters and gear, craft and level up fully-equipped teams, and battle their teams against other players through the Neon Pizza competitive multiplayer missions or in real-time turn-based combat.",
                "external_link": null,
                "image_url": "https://lh3.googleusercontent.com/xttZf6L3I16h7HSgcfKFWhR7OhCdSO5UW_asXbRfGmQ7-a0QwJRNoPsmh_RlOpw-AFEngLqGYLD77cmjdBv4LCfVc5BxFG2PS1UU=s120",
                "default_to_fiat": false,
                "dev_buyer_fee_basis_points": 0,
                "dev_seller_fee_basis_points": 500,
                "only_proxied_transfers": false,
                "opensea_buyer_fee_basis_points": 0,
                "opensea_seller_fee_basis_points": 250,
                "buyer_fee_basis_points": 0,
                "seller_fee_basis_points": 750,
                "payout_address": "0x08262c33e987ed580b69d8f93134e987f881bdcc"
            },
            "owner": {
                "user": null,
                "profile_img_url": "https://storage.googleapis.com/opensea-static/opensea-profile/1.png",
                "address": "0x0000000000000000000000000000000000000000",
                "config": "",
                "discord_id": ""
            },
            "permalink": "https://opensea.io/assets/matic/0x7227e371540cf7b8e512544ba6871472031f3335/158456343161678662593531063517",
            "collection": {
                "banner_image_url": "https://lh3.googleusercontent.com/vtZXDR51ibkUx6v2XRf3imqsL-bUzy7tALBcjrwx0fNJywcMCqK_bVIfrvdlKQ5sysboHA23kGiwbgsGb5c_6ROGsyzc-SZURrtqRA=s2500",
                "chat_url": null,
                "created_date": "2021-01-04T17:12:08.305423",
                "default_to_fiat": false,
                "description": "Neon District is a free-to-play cyberpunk role-playing game featuring collectible NFTs on Matic and Ethereum. Players collect characters and gear, craft and level up fully-equipped teams, and battle their teams against other players through the Neon Pizza competitive multiplayer missions or in real-time turn-based combat.",
                "dev_buyer_fee_basis_points": "0",
                "dev_seller_fee_basis_points": "500",
                "discord_url": "https://discord.gg/ERu7Zw9YwZ",
                "display_data": {
                    "card_display_style": "contain"
                },
                "external_url": null,
                "featured": false,
                "featured_image_url": "https://lh3.googleusercontent.com/vtZXDR51ibkUx6v2XRf3imqsL-bUzy7tALBcjrwx0fNJywcMCqK_bVIfrvdlKQ5sysboHA23kGiwbgsGb5c_6ROGsyzc-SZURrtqRA=s300",
                "hidden": false,
                "safelist_request_status": "approved",
                "image_url": "https://lh3.googleusercontent.com/xttZf6L3I16h7HSgcfKFWhR7OhCdSO5UW_asXbRfGmQ7-a0QwJRNoPsmh_RlOpw-AFEngLqGYLD77cmjdBv4LCfVc5BxFG2PS1UU=s120",
                "is_subject_to_whitelist": false,
                "large_image_url": "https://lh3.googleusercontent.com/vtZXDR51ibkUx6v2XRf3imqsL-bUzy7tALBcjrwx0fNJywcMCqK_bVIfrvdlKQ5sysboHA23kGiwbgsGb5c_6ROGsyzc-SZURrtqRA=s300",
                "medium_username": "blockadegames",
                "name": "Neon District Season One Item",
                "only_proxied_transfers": false,
                "opensea_buyer_fee_basis_points": "0",
                "opensea_seller_fee_basis_points": "250",
                "payout_address": "0x08262c33e987ed580b69d8f93134e987f881bdcc",
                "require_email": false,
                "short_description": null,
                "slug": "neon-district-season-one-item",
                "telegram_url": null,
                "twitter_username": "neondistrictrpg",
                "instagram_username": null,
                "wiki_url": null
            },
            "decimals": null,
            "token_metadata": "https://portal.neondistrict.io/api/getNft/158456343161678662593531063517",
            "sell_orders": null,
            "creator": null,
            "traits": [
                {
                    "trait_type": "Defense",
                    "value": 10,
                    "display_type": "boost_number",
                    "max_value": null,
                    "trait_count": 0,
                    "order": null
                },
                {
                    "trait_type": "rarity",
                    "value": "Common",
                    "display_type": null,
                    "max_value": null,
                    "trait_count": 219643,
                    "order": null
                },
                {
                    "trait_type": "level",
                    "value": 1,
                    "display_type": null,
                    "max_value": null,
                    "trait_count": 0,
                    "order": null
                },
                {
                    "trait_type": "Season",
                    "value": 1,
                    "display_type": "number",
                    "max_value": null,
                    "trait_count": 0,
                    "order": null
                },
                {
                    "trait_type": "Mech",
                    "value": 5,
                    "display_type": "boost_number",
                    "max_value": null,
                    "trait_count": 0,
                    "order": null
                },
                {
                    "trait_type": "type",
                    "value": "Armor",
                    "display_type": null,
                    "max_value": null,
                    "trait_count": 321945,
                    "order": null
                },
                {
                    "trait_type": "Hacking",
                    "value": 5,
                    "display_type": "boost_number",
                    "max_value": null,
                    "trait_count": 0,
                    "order": null
                },
                {
                    "trait_type": "Nano",
                    "value": 20,
                    "display_type": "boost_number",
                    "max_value": null,
                    "trait_count": 0,
                    "order": null
                },
                {
                    "trait_type": "Stealth",
                    "value": 0,
                    "display_type": "boost_number",
                    "max_value": null,
                    "trait_count": 0,
                    "order": null
                },
                {
                    "trait_type": "Tactics",
                    "value": 0,
                    "display_type": "boost_number",
                    "max_value": null,
                    "trait_count": 0,
                    "order": null
                },
                {
                    "trait_type": "Armor Slot",
                    "value": "Head",
                    "display_type": null,
                    "max_value": null,
                    "trait_count": 80145,
                    "order": null
                },
                {
                    "trait_type": "Health",
                    "value": 25,
                    "display_type": "boost_number",
                    "max_value": null,
                    "trait_count": 0,
                    "order": null
                },
                {
                    "trait_type": "Attack",
                    "value": 0,
                    "display_type": "boost_number",
                    "max_value": null,
                    "trait_count": 0,
                    "order": null
                }
            ],
            "last_sale": null,
            "top_bid": null,
            "listing_date": null,
            "is_presale": false,
            "transfer_fee_payment_token": null,
            "transfer_fee": null
        }
    ];

    public static collections = [
        {
            "primary_asset_contracts": [],
            "traits": {},
            "stats": {
                "seven_day_volume": 0,
                "total_volume": 0,
                "seven_day_change": 0,
                "seven_day_sales": 0,
                "total_sales": 0,
                "total_supply": 0,
                "count": 0,
                "num_owners": 0,
                "seven_day_average_price": 0,
                "average_price": 0,
                "num_reports": 0,
                "market_cap": 0
            },
            "banner_image_url": "https://lh3.googleusercontent.com/Vd-SQSXnDyyX5RKl1eCCMsD7NAQULv5bYmQd8GaeoyBUfETOLuuECcEoQY5D05UnCNVUOd_NGmR0Yy7gXiP4OJhT8Hcnlwv2zolnDfY=s2500",
            "chat_url": null,
            "created_date": "2021-05-25T22:45:53.704582",
            "default_to_fiat": false,
            "description": "The One-Eyed Tulips by artist D. Lammie- Hanson is a series of paintings created by the artist between 2008 - 2015 in NYC, Atlanta, and New Orleans.",
            "dev_buyer_fee_basis_points": "0",
            "dev_seller_fee_basis_points": "0",
            "discord_url": null,
            "display_data": {
                "card_display_style": "contain",
                "images": []
            },
            "external_url": null,
            "featured": false,
            "featured_image_url": null,
            "hidden": true,
            "safelist_request_status": "not_requested",
            "image_url": "https://lh3.googleusercontent.com/8E0lItPbLXRZTxHo5lngGXOvgGFTfhscpLGx8LG13Bh9JbTVLzRpUjUXqnBmm-4YBa4GPZEM_A45JaU2b9sxoQwtChB6lTplcdx91w=s120",
            "is_subject_to_whitelist": false,
            "large_image_url": null,
            "medium_username": null,
            "name": "The One Eyed Tulips by D. Lammie-Hanson",
            "only_proxied_transfers": false,
            "opensea_buyer_fee_basis_points": "0",
            "opensea_seller_fee_basis_points": "250",
            "payout_address": null,
            "require_email": false,
            "short_description": null,
            "slug": "the-one-eyed-tulips-by-d-lammie-hanson",
            "telegram_url": null,
            "twitter_username": null,
            "instagram_username": null,
            "wiki_url": null
        },
        {
            "primary_asset_contracts": [],
            "traits": {},
            "stats": {
                "seven_day_volume": 0,
                "total_volume": 0,
                "seven_day_change": 0,
                "seven_day_sales": 0,
                "total_sales": 0,
                "total_supply": 0,
                "count": 0,
                "num_owners": 0,
                "seven_day_average_price": 0,
                "average_price": 0,
                "num_reports": 0,
                "market_cap": 0
            },
            "banner_image_url": "https://lh3.googleusercontent.com/l8khSiOAPW8ewm8G47mdCka4gx9A8yMLKArKnAwtDh6PtLXe8uGpusizCrGc3Zcqq6H1QUJ5pvYlWrhoTUqyUc8zr4BKwoAJHY6o=s2500",
            "chat_url": null,
            "created_date": "2021-05-25T22:43:35.733784",
            "default_to_fiat": false,
            "description": "A collection of ocean photography!",
            "dev_buyer_fee_basis_points": "0",
            "dev_seller_fee_basis_points": "500",
            "discord_url": null,
            "display_data": {
                "card_display_style": "contain"
            },
            "external_url": null,
            "featured": false,
            "featured_image_url": null,
            "hidden": true,
            "safelist_request_status": "not_requested",
            "image_url": "https://lh3.googleusercontent.com/rsIh-h1-_Hy44tkfo8u8lB6ZN0tEIlByoxuC6aWTva0kunpcf6QV-30urjEgJY2xiI0uMTH9C5RRQQODH-Bvf2eN1uO5AXjCPUrnwA=s120",
            "is_subject_to_whitelist": false,
            "large_image_url": null,
            "medium_username": null,
            "name": "Photos of the Ocean",
            "only_proxied_transfers": false,
            "opensea_buyer_fee_basis_points": "0",
            "opensea_seller_fee_basis_points": "250",
            "payout_address": "0xc5de485b240a0decce48bc529ad5f744ce8aea04",
            "require_email": false,
            "short_description": null,
            "slug": "photos-of-the-ocean",
            "telegram_url": null,
            "twitter_username": null,
            "instagram_username": null,
            "wiki_url": null
        },
        {
            "primary_asset_contracts": [],
            "traits": {},
            "stats": {
                "seven_day_volume": 0,
                "total_volume": 0,
                "seven_day_change": 0,
                "seven_day_sales": 0,
                "total_sales": 0,
                "total_supply": 0,
                "count": 0,
                "num_owners": 0,
                "seven_day_average_price": 0,
                "average_price": 0,
                "num_reports": 0,
                "market_cap": 0
            },
            "banner_image_url": "https://lh3.googleusercontent.com/FRt2cUvKGykIh4KYxx8my6iU914QIOfHCiEr_ujIeuz56JuQMxXOPNYUfpWfqXd7iGB3v2IcrpW-A5ppxkhNye63HpyHo82aLqjT-Q=s2500",
            "chat_url": null,
            "created_date": "2021-05-25T22:34:20.651919",
            "default_to_fiat": false,
            "description": "",
            "dev_buyer_fee_basis_points": "0",
            "dev_seller_fee_basis_points": "0",
            "discord_url": null,
            "display_data": {
                "card_display_style": "contain",
                "images": []
            },
            "external_url": null,
            "featured": false,
            "featured_image_url": null,
            "hidden": true,
            "safelist_request_status": "not_requested",
            "image_url": "https://lh3.googleusercontent.com/2A9_qExoQy8Xge6hCD5LmAdR-ksYwqEVJhqeCvPyOuSYSgDqeG7BlAbLt2_zZz_anH746_uy3Jsoa76Ll6QfkER0d5YaD5F6qsPz=s120",
            "is_subject_to_whitelist": false,
            "large_image_url": null,
            "medium_username": null,
            "name": "Natalie",
            "only_proxied_transfers": false,
            "opensea_buyer_fee_basis_points": "0",
            "opensea_seller_fee_basis_points": "250",
            "payout_address": null,
            "require_email": false,
            "short_description": null,
            "slug": "natalie-3",
            "telegram_url": null,
            "twitter_username": null,
            "instagram_username": null,
            "wiki_url": null
        },
        {
            "primary_asset_contracts": [],
            "traits": {},
            "stats": {
                "seven_day_volume": 0,
                "total_volume": 0,
                "seven_day_change": 0,
                "seven_day_sales": 0,
                "total_sales": 0,
                "total_supply": 0,
                "count": 0,
                "num_owners": 0,
                "seven_day_average_price": 0,
                "average_price": 0,
                "num_reports": 0,
                "market_cap": 0
            },
            "banner_image_url": "https://lh3.googleusercontent.com/27oNvUJhB51OzO5I0R7d-0g5qR50eGvi7l15PZpGpf7R3Yb6xmaK7buGMAlY-T5KSE_YgJ6JWXxrlj40_bypgjaxbWOkh4h-otmw=s2500",
            "chat_url": null,
            "created_date": "2021-05-25T22:33:58.933074",
            "default_to_fiat": false,
            "description": "",
            "dev_buyer_fee_basis_points": "0",
            "dev_seller_fee_basis_points": "0",
            "discord_url": null,
            "display_data": {
                "card_display_style": "contain"
            },
            "external_url": null,
            "featured": false,
            "featured_image_url": "https://lh3.googleusercontent.com/27oNvUJhB51OzO5I0R7d-0g5qR50eGvi7l15PZpGpf7R3Yb6xmaK7buGMAlY-T5KSE_YgJ6JWXxrlj40_bypgjaxbWOkh4h-otmw=s300",
            "hidden": true,
            "safelist_request_status": "not_requested",
            "image_url": "https://lh3.googleusercontent.com/FfOnVRB8I515Q9TrjXpamxiYa_V_4BoXRL2sSsAoBbsqRChF3Dfe--mZIbbJXSAnudlVxu6cgPFMzKLwU1-AVAhIF0XOyVxfhIXXoII=s120",
            "is_subject_to_whitelist": false,
            "large_image_url": "https://lh3.googleusercontent.com/27oNvUJhB51OzO5I0R7d-0g5qR50eGvi7l15PZpGpf7R3Yb6xmaK7buGMAlY-T5KSE_YgJ6JWXxrlj40_bypgjaxbWOkh4h-otmw=s300",
            "medium_username": null,
            "name": "HashStars",
            "only_proxied_transfers": false,
            "opensea_buyer_fee_basis_points": "0",
            "opensea_seller_fee_basis_points": "250",
            "payout_address": null,
            "require_email": false,
            "short_description": null,
            "slug": "hash-stars",
            "telegram_url": null,
            "twitter_username": null,
            "instagram_username": null,
            "wiki_url": null
        },
        {
            "primary_asset_contracts": [],
            "traits": {},
            "stats": {
                "seven_day_volume": 0,
                "total_volume": 0,
                "seven_day_change": 0,
                "seven_day_sales": 0,
                "total_sales": 0,
                "total_supply": 0,
                "count": 0,
                "num_owners": 0,
                "seven_day_average_price": 0,
                "average_price": 0,
                "num_reports": 0,
                "market_cap": 0
            },
            "banner_image_url": "https://lh3.googleusercontent.com/F_k-Jb8Uqf96P9LGFuj3gbOhr9KwJZ8JN_ZkTJ_em1NQzSoq65qvn7LHBytAsIsXiM81_leKmC7-l2yzE4kL1wDOkwZAFDAawgdxJg=s2500",
            "chat_url": null,
            "created_date": "2021-05-25T22:32:39.311544",
            "default_to_fiat": false,
            "description": "Sky blue authentic drizzy. Take off with the favourite take off in his young and purest form. ",
            "dev_buyer_fee_basis_points": "0",
            "dev_seller_fee_basis_points": "0",
            "discord_url": null,
            "display_data": {
                "card_display_style": "contain"
            },
            "external_url": null,
            "featured": false,
            "featured_image_url": null,
            "hidden": true,
            "safelist_request_status": "not_requested",
            "image_url": "https://lh3.googleusercontent.com/F_k-Jb8Uqf96P9LGFuj3gbOhr9KwJZ8JN_ZkTJ_em1NQzSoq65qvn7LHBytAsIsXiM81_leKmC7-l2yzE4kL1wDOkwZAFDAawgdxJg=s120",
            "is_subject_to_whitelist": false,
            "large_image_url": null,
            "medium_username": null,
            "name": "Drake: The Origin",
            "only_proxied_transfers": false,
            "opensea_buyer_fee_basis_points": "0",
            "opensea_seller_fee_basis_points": "250",
            "payout_address": null,
            "require_email": false,
            "short_description": null,
            "slug": "drake-the-origin",
            "telegram_url": null,
            "twitter_username": null,
            "instagram_username": null,
            "wiki_url": null
        },
        {
            "primary_asset_contracts": [],
            "traits": {},
            "stats": {
                "seven_day_volume": 0,
                "total_volume": 0,
                "seven_day_change": 0,
                "seven_day_sales": 0,
                "total_sales": 0,
                "total_supply": 0,
                "count": 0,
                "num_owners": 0,
                "seven_day_average_price": 0,
                "average_price": 0,
                "num_reports": 0,
                "market_cap": 0
            },
            "banner_image_url": "https://lh3.googleusercontent.com/EtjSzLabL6PnjETeeyA42CXdWrBX0Oe8V8gasFpcBx1dJC8Gef_QEbs1xaTxCyagzZgcgKMb0UOwYR-IWkEogM0-pIZmPVFFQyBb=s2500",
            "chat_url": null,
            "created_date": "2021-05-25T22:32:02.408081",
            "default_to_fiat": false,
            "description": "The social Experiment. ",
            "dev_buyer_fee_basis_points": "0",
            "dev_seller_fee_basis_points": "0",
            "discord_url": null,
            "display_data": {
                "card_display_style": "contain",
                "images": []
            },
            "external_url": null,
            "featured": false,
            "featured_image_url": null,
            "hidden": true,
            "safelist_request_status": "not_requested",
            "image_url": "https://lh3.googleusercontent.com/tq-y6xDdY7fkxkX1K0yxKjfgJHJjsHs9XRBEl-tjfbt0-boWwJ-ceCZZO6ODcibvINLma3DHgNS4EobrPVPte5fxhUOg59M2uE19pw=s120",
            "is_subject_to_whitelist": false,
            "large_image_url": null,
            "medium_username": null,
            "name": "Pixelexpression",
            "only_proxied_transfers": false,
            "opensea_buyer_fee_basis_points": "0",
            "opensea_seller_fee_basis_points": "250",
            "payout_address": null,
            "require_email": false,
            "short_description": null,
            "slug": "pixelexpression",
            "telegram_url": null,
            "twitter_username": null,
            "instagram_username": null,
            "wiki_url": null
        },
        {
            "primary_asset_contracts": [],
            "traits": {},
            "stats": {
                "seven_day_volume": 0,
                "total_volume": 0,
                "seven_day_change": 0,
                "seven_day_sales": 0,
                "total_sales": 0,
                "total_supply": 0,
                "count": 0,
                "num_owners": 0,
                "seven_day_average_price": 0,
                "average_price": 0,
                "num_reports": 0,
                "market_cap": 0
            },
            "banner_image_url": "https://lh3.googleusercontent.com/FRt2cUvKGykIh4KYxx8my6iU914QIOfHCiEr_ujIeuz56JuQMxXOPNYUfpWfqXd7iGB3v2IcrpW-A5ppxkhNye63HpyHo82aLqjT-Q=s2500",
            "chat_url": null,
            "created_date": "2021-05-25T22:30:11.601443",
            "default_to_fiat": false,
            "description": "",
            "dev_buyer_fee_basis_points": "0",
            "dev_seller_fee_basis_points": "1000",
            "discord_url": "https://discord.gg/trigner9580",
            "display_data": {
                "card_display_style": "contain"
            },
            "external_url": "http://trigner.com",
            "featured": false,
            "featured_image_url": null,
            "hidden": true,
            "safelist_request_status": "not_requested",
            "image_url": "https://lh3.googleusercontent.com/2A9_qExoQy8Xge6hCD5LmAdR-ksYwqEVJhqeCvPyOuSYSgDqeG7BlAbLt2_zZz_anH746_uy3Jsoa76Ll6QfkER0d5YaD5F6qsPz=s120",
            "is_subject_to_whitelist": false,
            "large_image_url": null,
            "medium_username": "trigner",
            "name": "Donovan",
            "only_proxied_transfers": false,
            "opensea_buyer_fee_basis_points": "0",
            "opensea_seller_fee_basis_points": "250",
            "payout_address": "0x7dff32e72a08f99669ac23372c07f2432fe27298",
            "require_email": false,
            "short_description": null,
            "slug": "donovan",
            "telegram_url": null,
            "twitter_username": null,
            "instagram_username": null,
            "wiki_url": null
        },
        {
            "primary_asset_contracts": [],
            "traits": {},
            "stats": {
                "seven_day_volume": 0,
                "total_volume": 0,
                "seven_day_change": 0,
                "seven_day_sales": 0,
                "total_sales": 0,
                "total_supply": 0,
                "count": 0,
                "num_owners": 0,
                "seven_day_average_price": 0,
                "average_price": 0,
                "num_reports": 0,
                "market_cap": 0
            },
            "banner_image_url": "https://lh3.googleusercontent.com/pdZcggF6liMblxbEz8NBsQuQcy-MTKfanX94wti9L6-einIe2j37IwIMeYZsOJbaCQ5a59FulR0gzmXiWw7joMz7hvNlCjSC0A5W1Q=s2500",
            "chat_url": null,
            "created_date": "2021-05-25T22:28:50.504795",
            "default_to_fiat": false,
            "description": "Collection",
            "dev_buyer_fee_basis_points": "0",
            "dev_seller_fee_basis_points": "0",
            "discord_url": null,
            "display_data": {
                "card_display_style": "contain",
                "images": []
            },
            "external_url": null,
            "featured": false,
            "featured_image_url": null,
            "hidden": true,
            "safelist_request_status": "not_requested",
            "image_url": "https://lh3.googleusercontent.com/Z-wo1qyIFOqfEbOZt_odu2KuTMMCDelkCI5yynzAPAyESU3aaHRdr3LKJB4Oe6HW_fH1glcAOw05WBJxBNkRn3dB-cjmDFmlrjvj=s120",
            "is_subject_to_whitelist": false,
            "large_image_url": null,
            "medium_username": null,
            "name": "Political Painting Pictures",
            "only_proxied_transfers": false,
            "opensea_buyer_fee_basis_points": "0",
            "opensea_seller_fee_basis_points": "250",
            "payout_address": null,
            "require_email": false,
            "short_description": null,
            "slug": "political-painting-pictures",
            "telegram_url": null,
            "twitter_username": null,
            "instagram_username": null,
            "wiki_url": null
        },
        {
            "primary_asset_contracts": [],
            "traits": {},
            "stats": {
                "seven_day_volume": 0,
                "total_volume": 0,
                "seven_day_change": 0,
                "seven_day_sales": 0,
                "total_sales": 0,
                "total_supply": 0,
                "count": 0,
                "num_owners": 0,
                "seven_day_average_price": 0,
                "average_price": 0,
                "num_reports": 0,
                "market_cap": 0
            },
            "banner_image_url": "https://lh3.googleusercontent.com/FRt2cUvKGykIh4KYxx8my6iU914QIOfHCiEr_ujIeuz56JuQMxXOPNYUfpWfqXd7iGB3v2IcrpW-A5ppxkhNye63HpyHo82aLqjT-Q=s2500",
            "chat_url": null,
            "created_date": "2021-05-25T22:27:52.425516",
            "default_to_fiat": false,
            "description": "",
            "dev_buyer_fee_basis_points": "0",
            "dev_seller_fee_basis_points": "1000",
            "discord_url": "https://discord.gg/trigner9580",
            "display_data": {
                "card_display_style": "contain"
            },
            "external_url": "http://trigner.com",
            "featured": false,
            "featured_image_url": null,
            "hidden": true,
            "safelist_request_status": "not_requested",
            "image_url": "https://lh3.googleusercontent.com/2A9_qExoQy8Xge6hCD5LmAdR-ksYwqEVJhqeCvPyOuSYSgDqeG7BlAbLt2_zZz_anH746_uy3Jsoa76Ll6QfkER0d5YaD5F6qsPz=s120",
            "is_subject_to_whitelist": false,
            "large_image_url": null,
            "medium_username": "trigner",
            "name": "Jalen",
            "only_proxied_transfers": false,
            "opensea_buyer_fee_basis_points": "0",
            "opensea_seller_fee_basis_points": "250",
            "payout_address": "0x7dff32e72a08f99669ac23372c07f2432fe27298",
            "require_email": false,
            "short_description": null,
            "slug": "jalen",
            "telegram_url": null,
            "twitter_username": null,
            "instagram_username": null,
            "wiki_url": null
        },
        {
            "primary_asset_contracts": [],
            "traits": {},
            "stats": {
                "seven_day_volume": 0,
                "total_volume": 0,
                "seven_day_change": 0,
                "seven_day_sales": 0,
                "total_sales": 0,
                "total_supply": 0,
                "count": 0,
                "num_owners": 0,
                "seven_day_average_price": 0,
                "average_price": 0,
                "num_reports": 0,
                "market_cap": 0
            },
            "banner_image_url": "https://lh3.googleusercontent.com/YDyCl95GlhutYzU_iLxCakBqaLU_C902aUCIT1pJPfLhyN0Z-o7T5QVd_LKaAZEpMRyrSzTL5hOupfNlUgqbXepYAIUPu0tYMui9vw=s2500",
            "chat_url": null,
            "created_date": "2021-05-25T22:26:35.941603",
            "default_to_fiat": false,
            "description": "JAVVANI | Ting J.\n\n• Year of creation: 2021 • Original resolution: 6000x6000 • Tools used: Illustrator ",
            "dev_buyer_fee_basis_points": "0",
            "dev_seller_fee_basis_points": "0",
            "discord_url": "https://discord.gg/Javvani#7664",
            "display_data": {
                "card_display_style": "cover"
            },
            "external_url": null,
            "featured": false,
            "featured_image_url": "https://lh3.googleusercontent.com/pqinY7o1GppF_foo8qh_uj_4mxZO1IVfN-8jgjyiSpbZdl8PZX3D1wGB7YLnIADHSOheasXUyAz1YE0cljIiRZ--zw56FJpOE69nPA=s300",
            "hidden": true,
            "safelist_request_status": "not_requested",
            "image_url": "https://lh3.googleusercontent.com/_oQXovORZkUXE-oCUBrGE6CE0i6CAAYYitlT34ZCKH3fcjlkC7yiSEHsRZSfGniFrycLt-9SBina7F-9dGyQY7rP9ApnvYQKmNmNig=s120",
            "is_subject_to_whitelist": false,
            "large_image_url": "https://lh3.googleusercontent.com/pqinY7o1GppF_foo8qh_uj_4mxZO1IVfN-8jgjyiSpbZdl8PZX3D1wGB7YLnIADHSOheasXUyAz1YE0cljIiRZ--zw56FJpOE69nPA=s300",
            "medium_username": null,
            "name": "Ting J.",
            "only_proxied_transfers": false,
            "opensea_buyer_fee_basis_points": "0",
            "opensea_seller_fee_basis_points": "250",
            "payout_address": null,
            "require_email": false,
            "short_description": null,
            "slug": "ting-j",
            "telegram_url": "https://t.me/javvani_vector",
            "twitter_username": "JavvaniArt",
            "instagram_username": "javvani.vector/",
            "wiki_url": null
        },
        {
            "primary_asset_contracts": [],
            "traits": {},
            "stats": {
                "seven_day_volume": 0,
                "total_volume": 0,
                "seven_day_change": 0,
                "seven_day_sales": 0,
                "total_sales": 0,
                "total_supply": 0,
                "count": 0,
                "num_owners": 0,
                "seven_day_average_price": 0,
                "average_price": 0,
                "num_reports": 0,
                "market_cap": 0
            },
            "banner_image_url": "https://lh3.googleusercontent.com/FRt2cUvKGykIh4KYxx8my6iU914QIOfHCiEr_ujIeuz56JuQMxXOPNYUfpWfqXd7iGB3v2IcrpW-A5ppxkhNye63HpyHo82aLqjT-Q=s2500",
            "chat_url": null,
            "created_date": "2021-05-25T22:24:35.359461",
            "default_to_fiat": false,
            "description": "",
            "dev_buyer_fee_basis_points": "0",
            "dev_seller_fee_basis_points": "1000",
            "discord_url": "https://discord.gg/trigner9580",
            "display_data": {
                "card_display_style": "contain"
            },
            "external_url": "http://trigner.com",
            "featured": false,
            "featured_image_url": null,
            "hidden": true,
            "safelist_request_status": "not_requested",
            "image_url": "https://lh3.googleusercontent.com/2A9_qExoQy8Xge6hCD5LmAdR-ksYwqEVJhqeCvPyOuSYSgDqeG7BlAbLt2_zZz_anH746_uy3Jsoa76Ll6QfkER0d5YaD5F6qsPz=s120",
            "is_subject_to_whitelist": false,
            "large_image_url": null,
            "medium_username": "trigner",
            "name": "Emanuela",
            "only_proxied_transfers": false,
            "opensea_buyer_fee_basis_points": "0",
            "opensea_seller_fee_basis_points": "250",
            "payout_address": "0x7dff32e72a08f99669ac23372c07f2432fe27298",
            "require_email": false,
            "short_description": null,
            "slug": "emanuela",
            "telegram_url": null,
            "twitter_username": null,
            "instagram_username": null,
            "wiki_url": null
        },
        {
            "primary_asset_contracts": [],
            "traits": {},
            "stats": {
                "seven_day_volume": 0,
                "total_volume": 0,
                "seven_day_change": 0,
                "seven_day_sales": 0,
                "total_sales": 0,
                "total_supply": 0,
                "count": 0,
                "num_owners": 0,
                "seven_day_average_price": 0,
                "average_price": 0,
                "num_reports": 0,
                "market_cap": 0
            },
            "banner_image_url": "https://lh3.googleusercontent.com/waV_HUTCVLpuO7qusWNLXubqd4zzELp0sxLn1QnWtuvYs_Q7qB4yHZOpN96Lb6n6wk2HrEniSB2iCMN-mu6vqNxnr65jjcGDW3ls89Q=s2500",
            "chat_url": null,
            "created_date": "2021-05-25T22:23:27.842716",
            "default_to_fiat": false,
            "description": "",
            "dev_buyer_fee_basis_points": "0",
            "dev_seller_fee_basis_points": "10",
            "discord_url": null,
            "display_data": {
                "card_display_style": "contain"
            },
            "external_url": null,
            "featured": false,
            "featured_image_url": null,
            "hidden": true,
            "safelist_request_status": "not_requested",
            "image_url": "https://lh3.googleusercontent.com/waV_HUTCVLpuO7qusWNLXubqd4zzELp0sxLn1QnWtuvYs_Q7qB4yHZOpN96Lb6n6wk2HrEniSB2iCMN-mu6vqNxnr65jjcGDW3ls89Q=s120",
            "is_subject_to_whitelist": false,
            "large_image_url": null,
            "medium_username": null,
            "name": "Turning Star",
            "only_proxied_transfers": false,
            "opensea_buyer_fee_basis_points": "0",
            "opensea_seller_fee_basis_points": "250",
            "payout_address": "0x6225b86bb812b697e636b0e3e8e0330f70e45b07",
            "require_email": false,
            "short_description": null,
            "slug": "turning-star",
            "telegram_url": null,
            "twitter_username": null,
            "instagram_username": null,
            "wiki_url": null
        },
        {
            "primary_asset_contracts": [],
            "traits": {},
            "stats": {
                "seven_day_volume": 0,
                "total_volume": 0,
                "seven_day_change": 0,
                "seven_day_sales": 0,
                "total_sales": 0,
                "total_supply": 0,
                "count": 0,
                "num_owners": 0,
                "seven_day_average_price": 0,
                "average_price": 0,
                "num_reports": 0,
                "market_cap": 0
            },
            "banner_image_url": "https://lh3.googleusercontent.com/FRt2cUvKGykIh4KYxx8my6iU914QIOfHCiEr_ujIeuz56JuQMxXOPNYUfpWfqXd7iGB3v2IcrpW-A5ppxkhNye63HpyHo82aLqjT-Q=s2500",
            "chat_url": null,
            "created_date": "2021-05-25T22:22:58.087282",
            "default_to_fiat": false,
            "description": "",
            "dev_buyer_fee_basis_points": "0",
            "dev_seller_fee_basis_points": "1000",
            "discord_url": "https://discord.gg/trigner9580",
            "display_data": {
                "card_display_style": "contain"
            },
            "external_url": "http://trigner.com",
            "featured": false,
            "featured_image_url": null,
            "hidden": true,
            "safelist_request_status": "not_requested",
            "image_url": "https://lh3.googleusercontent.com/2A9_qExoQy8Xge6hCD5LmAdR-ksYwqEVJhqeCvPyOuSYSgDqeG7BlAbLt2_zZz_anH746_uy3Jsoa76Ll6QfkER0d5YaD5F6qsPz=s120",
            "is_subject_to_whitelist": false,
            "large_image_url": null,
            "medium_username": "trigner",
            "name": "Emmanuella",
            "only_proxied_transfers": false,
            "opensea_buyer_fee_basis_points": "0",
            "opensea_seller_fee_basis_points": "250",
            "payout_address": "0x7dff32e72a08f99669ac23372c07f2432fe27298",
            "require_email": false,
            "short_description": null,
            "slug": "emmanuella",
            "telegram_url": null,
            "twitter_username": null,
            "instagram_username": null,
            "wiki_url": null
        },
        {
            "primary_asset_contracts": [],
            "traits": {},
            "stats": {
                "seven_day_volume": 0,
                "total_volume": 0,
                "seven_day_change": 0,
                "seven_day_sales": 0,
                "total_sales": 0,
                "total_supply": 0,
                "count": 0,
                "num_owners": 0,
                "seven_day_average_price": 0,
                "average_price": 0,
                "num_reports": 0,
                "market_cap": 0
            },
            "banner_image_url": "https://lh3.googleusercontent.com/tjZ-n0mmck7LHkwGYyoJ_fKZ7SY9rldkVZHRK3KpFDislE9MHPk8xmg0BOOf0m46voD7rQyCMYxnCZfBpQYcZsiMULdfoSuNKYCq=s2500",
            "chat_url": null,
            "created_date": "2021-05-25T22:22:21.606959",
            "default_to_fiat": false,
            "description": "Only 100 YEAHBUT will be minted. \nGrab your YEAHBUT while they're hot.",
            "dev_buyer_fee_basis_points": "0",
            "dev_seller_fee_basis_points": "1000",
            "discord_url": null,
            "display_data": {
                "card_display_style": "padded"
            },
            "external_url": null,
            "featured": false,
            "featured_image_url": "https://lh3.googleusercontent.com/o7JA4v-c79oPi9yo0FwAM5QgCO1-y4bDtJQbcZ6lBohfhfO4xqYCNboJBxd9Q1pMhZ4UmvQE-ZT-19n7Yn_2HlqXb4J9zDAbE9vgxl8=s300",
            "hidden": true,
            "safelist_request_status": "not_requested",
            "image_url": "https://lh3.googleusercontent.com/a-tsJUi6PDWoNB8WTcuz2tz2lHTAznMHjaB77qR40qKtmHkfOJ_GDCErbbGMvBiQjX-oY7rEj2lLJCbAPrZN6O70uZ6ysqHEowzteg=s120",
            "is_subject_to_whitelist": false,
            "large_image_url": "https://lh3.googleusercontent.com/o7JA4v-c79oPi9yo0FwAM5QgCO1-y4bDtJQbcZ6lBohfhfO4xqYCNboJBxd9Q1pMhZ4UmvQE-ZT-19n7Yn_2HlqXb4J9zDAbE9vgxl8=s300",
            "medium_username": null,
            "name": "YEAHBUT",
            "only_proxied_transfers": false,
            "opensea_buyer_fee_basis_points": "0",
            "opensea_seller_fee_basis_points": "250",
            "payout_address": "0x2c0f8293f8c116737b5bf1f41dd4761c183d4cbf",
            "require_email": false,
            "short_description": null,
            "slug": "yeahbut",
            "telegram_url": null,
            "twitter_username": null,
            "instagram_username": null,
            "wiki_url": null
        },
        {
            "primary_asset_contracts": [],
            "traits": {},
            "stats": {
                "seven_day_volume": 0,
                "total_volume": 0,
                "seven_day_change": 0,
                "seven_day_sales": 0,
                "total_sales": 0,
                "total_supply": 0,
                "count": 0,
                "num_owners": 0,
                "seven_day_average_price": 0,
                "average_price": 0,
                "num_reports": 0,
                "market_cap": 0
            },
            "banner_image_url": "https://lh3.googleusercontent.com/FRt2cUvKGykIh4KYxx8my6iU914QIOfHCiEr_ujIeuz56JuQMxXOPNYUfpWfqXd7iGB3v2IcrpW-A5ppxkhNye63HpyHo82aLqjT-Q=s2500",
            "chat_url": null,
            "created_date": "2021-05-25T22:19:10.468741",
            "default_to_fiat": false,
            "description": "",
            "dev_buyer_fee_basis_points": "0",
            "dev_seller_fee_basis_points": "1000",
            "discord_url": "https://discord.gg/trigner9580",
            "display_data": {
                "card_display_style": "contain"
            },
            "external_url": "http://trigner.com",
            "featured": false,
            "featured_image_url": null,
            "hidden": true,
            "safelist_request_status": "not_requested",
            "image_url": "https://lh3.googleusercontent.com/c8OBUj1zM-Csc6Kwt7oJ28R9kDjU0kRAdqNw6nz1DJkLAUM-ME3PJ2Ew1m8pycSQzeRokTRwqwu3r1CXH6rW-y2xDk-4hd6x5Tsp=s120",
            "is_subject_to_whitelist": false,
            "large_image_url": null,
            "medium_username": "trigner",
            "name": "Anders",
            "only_proxied_transfers": false,
            "opensea_buyer_fee_basis_points": "0",
            "opensea_seller_fee_basis_points": "250",
            "payout_address": "0x7dff32e72a08f99669ac23372c07f2432fe27298",
            "require_email": false,
            "short_description": null,
            "slug": "anders",
            "telegram_url": null,
            "twitter_username": null,
            "instagram_username": null,
            "wiki_url": null
        },
        {
            "primary_asset_contracts": [],
            "traits": {},
            "stats": {
                "seven_day_volume": 0,
                "total_volume": 0,
                "seven_day_change": 0,
                "seven_day_sales": 0,
                "total_sales": 0,
                "total_supply": 0,
                "count": 0,
                "num_owners": 0,
                "seven_day_average_price": 0,
                "average_price": 0,
                "num_reports": 0,
                "market_cap": 0
            },
            "banner_image_url": "https://lh3.googleusercontent.com/FRt2cUvKGykIh4KYxx8my6iU914QIOfHCiEr_ujIeuz56JuQMxXOPNYUfpWfqXd7iGB3v2IcrpW-A5ppxkhNye63HpyHo82aLqjT-Q=s2500",
            "chat_url": null,
            "created_date": "2021-05-25T22:16:17.091508",
            "default_to_fiat": false,
            "description": "",
            "dev_buyer_fee_basis_points": "0",
            "dev_seller_fee_basis_points": "1000",
            "discord_url": "https://discord.gg/trigner9580",
            "display_data": {
                "card_display_style": "contain"
            },
            "external_url": "http://trigner.com",
            "featured": false,
            "featured_image_url": null,
            "hidden": true,
            "safelist_request_status": "not_requested",
            "image_url": "https://lh3.googleusercontent.com/2A9_qExoQy8Xge6hCD5LmAdR-ksYwqEVJhqeCvPyOuSYSgDqeG7BlAbLt2_zZz_anH746_uy3Jsoa76Ll6QfkER0d5YaD5F6qsPz=s120",
            "is_subject_to_whitelist": false,
            "large_image_url": null,
            "medium_username": "trigner",
            "name": "Conner",
            "only_proxied_transfers": false,
            "opensea_buyer_fee_basis_points": "0",
            "opensea_seller_fee_basis_points": "250",
            "payout_address": "0x7dff32e72a08f99669ac23372c07f2432fe27298",
            "require_email": false,
            "short_description": null,
            "slug": "conner",
            "telegram_url": null,
            "twitter_username": null,
            "instagram_username": null,
            "wiki_url": null
        },
        {
            "primary_asset_contracts": [],
            "traits": {},
            "stats": {
                "seven_day_volume": 0,
                "total_volume": 0,
                "seven_day_change": 0,
                "seven_day_sales": 0,
                "total_sales": 0,
                "total_supply": 0,
                "count": 0,
                "num_owners": 0,
                "seven_day_average_price": 0,
                "average_price": 0,
                "num_reports": 0,
                "market_cap": 0
            },
            "banner_image_url": "https://lh3.googleusercontent.com/YSgv-RqUPqcwhuZqTDNlC3e6-8TuMJcaqf_bB32spdD7F3FJDUBSpPXx76ap2aDrgwTLxQL8IQhtIEjWy0j-CPrYer4jPPXCjRkCWQ=s2500",
            "chat_url": null,
            "created_date": "2021-05-25T22:15:36.635837",
            "default_to_fiat": false,
            "description": "Modern man is like a duck in thunderstorm",
            "dev_buyer_fee_basis_points": "0",
            "dev_seller_fee_basis_points": "0",
            "discord_url": null,
            "display_data": {
                "card_display_style": "contain",
                "images": []
            },
            "external_url": null,
            "featured": false,
            "featured_image_url": null,
            "hidden": true,
            "safelist_request_status": "not_requested",
            "image_url": "https://lh3.googleusercontent.com/2K_71i_vf-09lfom5DoV8nRxOPMYPDqYP_v0Gvs73QUkTQlMHwYdudZNW0i41EkA1jL01JU4k62LA41DwoidNK1pKgx9Cw2ZTvQJ3A=s120",
            "is_subject_to_whitelist": false,
            "large_image_url": null,
            "medium_username": null,
            "name": "Lords",
            "only_proxied_transfers": false,
            "opensea_buyer_fee_basis_points": "0",
            "opensea_seller_fee_basis_points": "250",
            "payout_address": null,
            "require_email": false,
            "short_description": null,
            "slug": "lords-1",
            "telegram_url": null,
            "twitter_username": null,
            "instagram_username": null,
            "wiki_url": null
        },
        {
            "primary_asset_contracts": [],
            "traits": {},
            "stats": {
                "seven_day_volume": 0,
                "total_volume": 0,
                "seven_day_change": 0,
                "seven_day_sales": 0,
                "total_sales": 0,
                "total_supply": 0,
                "count": 0,
                "num_owners": 0,
                "seven_day_average_price": 0,
                "average_price": 0,
                "num_reports": 0,
                "market_cap": 0
            },
            "banner_image_url": "https://lh3.googleusercontent.com/RyRiF9jqvOnbN-2xBi522jiSB_b8wZlugQsHHuFh7luvRC_vTt4keVqM1jo004YNfI-8C_x10GinsfltazoZONlV2_mLLr_ct3neCLI=s2500",
            "chat_url": null,
            "created_date": "2021-05-25T22:14:41.038832",
            "default_to_fiat": false,
            "description": "A collection of alien style abstractions",
            "dev_buyer_fee_basis_points": "0",
            "dev_seller_fee_basis_points": "1000",
            "discord_url": null,
            "display_data": {
                "card_display_style": "contain"
            },
            "external_url": null,
            "featured": false,
            "featured_image_url": "https://lh3.googleusercontent.com/kgRpSj3YypHjO7yEj_IYBEouPS09iOyov7INqM0JkxMSzYdG9jy_mURMIVOmLbJsk6fFkzC4RqeMV21BYu7QvaENnY5kDJBVajDfQQ=s300",
            "hidden": true,
            "safelist_request_status": "not_requested",
            "image_url": "https://lh3.googleusercontent.com/UJO7P10v3V5n-2XeXA4QiucF3HkvYlwgP2PpD5dyVQmIRQsiQuLOkKXRHwu0abKtKIS4zCl1lcKQ5rwAmJ-AbwddqtrLa6rQcII0HKI=s120",
            "is_subject_to_whitelist": false,
            "large_image_url": "https://lh3.googleusercontent.com/kgRpSj3YypHjO7yEj_IYBEouPS09iOyov7INqM0JkxMSzYdG9jy_mURMIVOmLbJsk6fFkzC4RqeMV21BYu7QvaENnY5kDJBVajDfQQ=s300",
            "medium_username": null,
            "name": "Alien Faces",
            "only_proxied_transfers": false,
            "opensea_buyer_fee_basis_points": "0",
            "opensea_seller_fee_basis_points": "250",
            "payout_address": "0xe4977fba512e2ee6c0ff98e2019515dbe7369d98",
            "require_email": false,
            "short_description": null,
            "slug": "alien-faces",
            "telegram_url": null,
            "twitter_username": null,
            "instagram_username": null,
            "wiki_url": null
        },
        {
            "primary_asset_contracts": [],
            "traits": {},
            "stats": {
                "seven_day_volume": 0,
                "total_volume": 0,
                "seven_day_change": 0,
                "seven_day_sales": 0,
                "total_sales": 0,
                "total_supply": 0,
                "count": 0,
                "num_owners": 0,
                "seven_day_average_price": 0,
                "average_price": 0,
                "num_reports": 0,
                "market_cap": 0
            },
            "banner_image_url": "https://lh3.googleusercontent.com/3vBtg4BhGL3lTOASJb5unFVwLNLUyaNlpcVDioL6q3n-cDltEovS75OJ9_YZTJzraw3xuo5eroKParRfZQ-mq4wH0_QeUjkwDvF2Cg=s2500",
            "chat_url": null,
            "created_date": "2021-05-25T22:13:21.754992",
            "default_to_fiat": false,
            "description": "NIGHT EMPERORS is a series of eight high-realistic yet fantastical illustrations about nightlife that I created during COVID. Each artwork is a nocturnal scene showcasing bartenders, club owners, patrons, artists, promoters, performers, musicians, consumers, and all the hopeless insomniacs that make the Manhattan nightlife so special. During four months of quarantine, I created more than 350 hand-drawings. At night. This tremendous work was a huge challenge, but also a therapeutic way to escape the heavy reality: for the first time in our lives, we have seen the city that never sleeps, asleep. Millions of New Yorkers. No more people in the streets. No more hugs. No more smiles. No more parties. No more disco. Still. Memories, art, and hope. This is an ode to nightlife when it does not exist anymore, for all the night owls that we miss. THEY ARE THE NIGHT EMPERORS. The clubs highlighted are Lola, Le Bain, Paul’s Baby Grand, Soho Grand, China Chalet, Et Al, Casablanca, and The Box. ",
            "dev_buyer_fee_basis_points": "0",
            "dev_seller_fee_basis_points": "0",
            "discord_url": null,
            "display_data": {
                "card_display_style": "contain"
            },
            "external_url": "https://www.rachelvandernacht.com/",
            "featured": false,
            "featured_image_url": "https://lh3.googleusercontent.com/AFQcYqm_aoVRXWNGtErCAovmOOQl__M_4_VU8SBfQc3QdD57t1GOdDihDrW_QnrxhuvhkQcm3p94iZud3KYg8kXBh6VRUlvAYdCe=s300",
            "hidden": true,
            "safelist_request_status": "not_requested",
            "image_url": "https://lh3.googleusercontent.com/sPSgdUxxhL9hoAPvpaMDBijg2qprO6G8uWo50KDlmDR2HANsHp_W5009O0zWGLMRpm-paKM-9ULMdrU_cZLckpFlRUQY-j8Vg_0zLHs=s120",
            "is_subject_to_whitelist": false,
            "large_image_url": "https://lh3.googleusercontent.com/AFQcYqm_aoVRXWNGtErCAovmOOQl__M_4_VU8SBfQc3QdD57t1GOdDihDrW_QnrxhuvhkQcm3p94iZud3KYg8kXBh6VRUlvAYdCe=s300",
            "medium_username": null,
            "name": "THE NIGHT EMPERORS by RACHEL VAN DER NACHT",
            "only_proxied_transfers": false,
            "opensea_buyer_fee_basis_points": "0",
            "opensea_seller_fee_basis_points": "250",
            "payout_address": null,
            "require_email": false,
            "short_description": null,
            "slug": "night-emperors",
            "telegram_url": null,
            "twitter_username": null,
            "instagram_username": "rachelvandernacht",
            "wiki_url": null
        },
        {
            "primary_asset_contracts": [],
            "traits": {},
            "stats": {
                "seven_day_volume": 0,
                "total_volume": 0,
                "seven_day_change": 0,
                "seven_day_sales": 0,
                "total_sales": 0,
                "total_supply": 0,
                "count": 0,
                "num_owners": 0,
                "seven_day_average_price": 0,
                "average_price": 0,
                "num_reports": 0,
                "market_cap": 0
            },
            "banner_image_url": "https://lh3.googleusercontent.com/FRt2cUvKGykIh4KYxx8my6iU914QIOfHCiEr_ujIeuz56JuQMxXOPNYUfpWfqXd7iGB3v2IcrpW-A5ppxkhNye63HpyHo82aLqjT-Q=s2500",
            "chat_url": null,
            "created_date": "2021-05-25T22:13:15.308457",
            "default_to_fiat": false,
            "description": "",
            "dev_buyer_fee_basis_points": "0",
            "dev_seller_fee_basis_points": "1000",
            "discord_url": "https://discord.gg/trigner9580",
            "display_data": {
                "card_display_style": "contain"
            },
            "external_url": "http://trigner.com",
            "featured": false,
            "featured_image_url": null,
            "hidden": true,
            "safelist_request_status": "not_requested",
            "image_url": "https://lh3.googleusercontent.com/2A9_qExoQy8Xge6hCD5LmAdR-ksYwqEVJhqeCvPyOuSYSgDqeG7BlAbLt2_zZz_anH746_uy3Jsoa76Ll6QfkER0d5YaD5F6qsPz=s120",
            "is_subject_to_whitelist": false,
            "large_image_url": null,
            "medium_username": "trigner",
            "name": "Alfonso",
            "only_proxied_transfers": false,
            "opensea_buyer_fee_basis_points": "0",
            "opensea_seller_fee_basis_points": "250",
            "payout_address": "0x7dff32e72a08f99669ac23372c07f2432fe27298",
            "require_email": false,
            "short_description": null,
            "slug": "alfonso",
            "telegram_url": null,
            "twitter_username": null,
            "instagram_username": null,
            "wiki_url": null
        },
        {
            "primary_asset_contracts": [],
            "traits": {},
            "stats": {
                "seven_day_volume": 0,
                "total_volume": 0,
                "seven_day_change": 0,
                "seven_day_sales": 0,
                "total_sales": 0,
                "total_supply": 0,
                "count": 0,
                "num_owners": 0,
                "seven_day_average_price": 0,
                "average_price": 0,
                "num_reports": 0,
                "market_cap": 0
            },
            "banner_image_url": "https://lh3.googleusercontent.com/H4M-cDEb_oy5_fPDqm6naCFiEFd3nqM-cksdFgrYes6LiHmUyw5u4GnefDDe6mbMrvoNcyjQTjNV4K7KvpHgDjSntcSON4p6gfG-ITQ=s2500",
            "chat_url": null,
            "created_date": "2021-05-25T22:11:53.362240",
            "default_to_fiat": false,
            "description": "",
            "dev_buyer_fee_basis_points": "0",
            "dev_seller_fee_basis_points": "1000",
            "discord_url": null,
            "display_data": {
                "card_display_style": "cover"
            },
            "external_url": null,
            "featured": false,
            "featured_image_url": "https://lh3.googleusercontent.com/Qe8YnI4znqcwPr45LZxrK1YeEMNhnVXONxJmklKYhzHclRqp7uzPAILhr0KN1_7FOHQKr-UZPxYWGj0M_UOmhIHGFdO8pUxj9yWK=s300",
            "hidden": true,
            "safelist_request_status": "not_requested",
            "image_url": "https://lh3.googleusercontent.com/I73x2lATUbd-_blZJ_aPmy1_XXifZzvyEK5JUr2leQFWlBlYN8Lq4Wzn9C79muWpT-FzuzcmJksRpNg9VFYh4VdVsi9GMyYNzypamAQ=s120",
            "is_subject_to_whitelist": false,
            "large_image_url": "https://lh3.googleusercontent.com/Qe8YnI4znqcwPr45LZxrK1YeEMNhnVXONxJmklKYhzHclRqp7uzPAILhr0KN1_7FOHQKr-UZPxYWGj0M_UOmhIHGFdO8pUxj9yWK=s300",
            "medium_username": null,
            "name": "Tent City",
            "only_proxied_transfers": false,
            "opensea_buyer_fee_basis_points": "0",
            "opensea_seller_fee_basis_points": "250",
            "payout_address": "0xbdb46f17cd19d86132c501288bee6eea1ea3e39f",
            "require_email": false,
            "short_description": null,
            "slug": "in-tent-city",
            "telegram_url": null,
            "twitter_username": "BindleStudios",
            "instagram_username": "bindlestudios",
            "wiki_url": null
        },
        {
            "primary_asset_contracts": [],
            "traits": {},
            "stats": {
                "seven_day_volume": 0,
                "total_volume": 0,
                "seven_day_change": 0,
                "seven_day_sales": 0,
                "total_sales": 0,
                "total_supply": 0,
                "count": 0,
                "num_owners": 0,
                "seven_day_average_price": 0,
                "average_price": 0,
                "num_reports": 0,
                "market_cap": 0
            },
            "banner_image_url": "https://lh3.googleusercontent.com/FRt2cUvKGykIh4KYxx8my6iU914QIOfHCiEr_ujIeuz56JuQMxXOPNYUfpWfqXd7iGB3v2IcrpW-A5ppxkhNye63HpyHo82aLqjT-Q=s2500",
            "chat_url": null,
            "created_date": "2021-05-25T22:11:50.939421",
            "default_to_fiat": false,
            "description": "",
            "dev_buyer_fee_basis_points": "0",
            "dev_seller_fee_basis_points": "1000",
            "discord_url": "https://discord.gg/trigner9580",
            "display_data": {
                "card_display_style": "contain"
            },
            "external_url": "http://trigner.com",
            "featured": false,
            "featured_image_url": null,
            "hidden": true,
            "safelist_request_status": "not_requested",
            "image_url": "https://lh3.googleusercontent.com/2A9_qExoQy8Xge6hCD5LmAdR-ksYwqEVJhqeCvPyOuSYSgDqeG7BlAbLt2_zZz_anH746_uy3Jsoa76Ll6QfkER0d5YaD5F6qsPz=s120",
            "is_subject_to_whitelist": false,
            "large_image_url": null,
            "medium_username": "trigner",
            "name": "Marek",
            "only_proxied_transfers": false,
            "opensea_buyer_fee_basis_points": "0",
            "opensea_seller_fee_basis_points": "250",
            "payout_address": "0x7dff32e72a08f99669ac23372c07f2432fe27298",
            "require_email": false,
            "short_description": null,
            "slug": "marek",
            "telegram_url": null,
            "twitter_username": null,
            "instagram_username": null,
            "wiki_url": null
        },
        {
            "primary_asset_contracts": [],
            "traits": {},
            "stats": {
                "seven_day_volume": 0,
                "total_volume": 0,
                "seven_day_change": 0,
                "seven_day_sales": 0,
                "total_sales": 0,
                "total_supply": 0,
                "count": 0,
                "num_owners": 0,
                "seven_day_average_price": 0,
                "average_price": 0,
                "num_reports": 0,
                "market_cap": 0
            },
            "banner_image_url": "https://lh3.googleusercontent.com/zeyWBnG15I0gix12hVmlfpK4NZCAhTDGHerW8l2EB1XDGBHMcoCzUmnzbi7OTemC3au6HzJOmRPX1JPUe0l2NiHy69AkoqqNJKNyug=s2500",
            "chat_url": null,
            "created_date": "2021-05-25T22:11:15.167366",
            "default_to_fiat": false,
            "description": "",
            "dev_buyer_fee_basis_points": "0",
            "dev_seller_fee_basis_points": "0",
            "discord_url": null,
            "display_data": {
                "card_display_style": "contain",
                "images": []
            },
            "external_url": null,
            "featured": false,
            "featured_image_url": null,
            "hidden": true,
            "safelist_request_status": "not_requested",
            "image_url": "https://lh3.googleusercontent.com/zeyWBnG15I0gix12hVmlfpK4NZCAhTDGHerW8l2EB1XDGBHMcoCzUmnzbi7OTemC3au6HzJOmRPX1JPUe0l2NiHy69AkoqqNJKNyug=s120",
            "is_subject_to_whitelist": false,
            "large_image_url": null,
            "medium_username": null,
            "name": "ODESSA POSKOT",
            "only_proxied_transfers": false,
            "opensea_buyer_fee_basis_points": "0",
            "opensea_seller_fee_basis_points": "250",
            "payout_address": null,
            "require_email": false,
            "short_description": null,
            "slug": "odessa-poskot",
            "telegram_url": null,
            "twitter_username": null,
            "instagram_username": null,
            "wiki_url": null
        },
        {
            "primary_asset_contracts": [],
            "traits": {},
            "stats": {
                "seven_day_volume": 0,
                "total_volume": 0,
                "seven_day_change": 0,
                "seven_day_sales": 0,
                "total_sales": 0,
                "total_supply": 0,
                "count": 0,
                "num_owners": 0,
                "seven_day_average_price": 0,
                "average_price": 0,
                "num_reports": 0,
                "market_cap": 0
            },
            "banner_image_url": "https://lh3.googleusercontent.com/FRt2cUvKGykIh4KYxx8my6iU914QIOfHCiEr_ujIeuz56JuQMxXOPNYUfpWfqXd7iGB3v2IcrpW-A5ppxkhNye63HpyHo82aLqjT-Q=s2500",
            "chat_url": null,
            "created_date": "2021-05-25T22:09:00.655326",
            "default_to_fiat": false,
            "description": "",
            "dev_buyer_fee_basis_points": "0",
            "dev_seller_fee_basis_points": "1000",
            "discord_url": "https://discord.gg/trigner9580",
            "display_data": {
                "card_display_style": "contain"
            },
            "external_url": "http://trigner.com",
            "featured": false,
            "featured_image_url": null,
            "hidden": true,
            "safelist_request_status": "not_requested",
            "image_url": "https://lh3.googleusercontent.com/2A9_qExoQy8Xge6hCD5LmAdR-ksYwqEVJhqeCvPyOuSYSgDqeG7BlAbLt2_zZz_anH746_uy3Jsoa76Ll6QfkER0d5YaD5F6qsPz=s120",
            "is_subject_to_whitelist": false,
            "large_image_url": null,
            "medium_username": "trigner",
            "name": "Collin",
            "only_proxied_transfers": false,
            "opensea_buyer_fee_basis_points": "0",
            "opensea_seller_fee_basis_points": "250",
            "payout_address": "0x7dff32e72a08f99669ac23372c07f2432fe27298",
            "require_email": false,
            "short_description": null,
            "slug": "collin",
            "telegram_url": null,
            "twitter_username": null,
            "instagram_username": null,
            "wiki_url": null
        },
        {
            "primary_asset_contracts": [],
            "traits": {},
            "stats": {
                "seven_day_volume": 0,
                "total_volume": 0,
                "seven_day_change": 0,
                "seven_day_sales": 0,
                "total_sales": 0,
                "total_supply": 0,
                "count": 0,
                "num_owners": 0,
                "seven_day_average_price": 0,
                "average_price": 0,
                "num_reports": 0,
                "market_cap": 0
            },
            "banner_image_url": "https://lh3.googleusercontent.com/vw2S7fp3NS0GIeK3-6fqJ0dxdgFAX-m-KIM2nTeprbyTgRlUkBt9dB1cQDh1_zG05kIZOJO9Yoc4lf9bF7Wy_aQSNOEPnVyzbyS4Nw=s2500",
            "chat_url": null,
            "created_date": "2021-05-25T22:08:38.501349",
            "default_to_fiat": false,
            "description": "Official Celebrity trading cards 'Chef Edition'  By One Love Trading Card Co.  \n*\n*\nGet your official celebrity trading cards! Limited edition runs! Limited number of cards available! \nYour trading card will Include:\nDetails about favorite celebrity (Birthday, Height, Weight Ect.)\nCustom digital artwork\nFun facts!\nUnique power ups\n*\n*\nCOLLECT, TRADE, BATTLE! Who will become victorious? Own your piece of custom digital art and the future of trading cards. \nCan you collect them all?\nMany other sets are scheduled for release check back frequently for updates. \n",
            "dev_buyer_fee_basis_points": "0",
            "dev_seller_fee_basis_points": "0",
            "discord_url": null,
            "display_data": {
                "card_display_style": "contain",
                "images": []
            },
            "external_url": null,
            "featured": false,
            "featured_image_url": null,
            "hidden": true,
            "safelist_request_status": "not_requested",
            "image_url": "https://lh3.googleusercontent.com/2Xy4StihAwPyyiWXbmZKiBfXBfARUICaCCx9fnUZkB9m741wnZdSXrP0O9moB2o0TydjwHCng2OMzn48CQ159lYHUGGr_AzHob3npQ=s120",
            "is_subject_to_whitelist": false,
            "large_image_url": null,
            "medium_username": null,
            "name": "Offical O.L.T.C. | 'Chef Edition' (Trading Cards)",
            "only_proxied_transfers": false,
            "opensea_buyer_fee_basis_points": "0",
            "opensea_seller_fee_basis_points": "250",
            "payout_address": null,
            "require_email": false,
            "short_description": null,
            "slug": "offical-o-l-t-c-chef-edition-trading-cards",
            "telegram_url": null,
            "twitter_username": null,
            "instagram_username": null,
            "wiki_url": null
        },
        {
            "primary_asset_contracts": [],
            "traits": {},
            "stats": {
                "seven_day_volume": 0,
                "total_volume": 0,
                "seven_day_change": 0,
                "seven_day_sales": 0,
                "total_sales": 0,
                "total_supply": 0,
                "count": 0,
                "num_owners": 0,
                "seven_day_average_price": 0,
                "average_price": 0,
                "num_reports": 0,
                "market_cap": 0
            },
            "banner_image_url": "https://lh3.googleusercontent.com/HQhWtXaFRNWAvfMWYfcb-LY9pmRyuv_HEnqhCa_n3fLK66AiEQ38-T07afMcitnG_Rcot_QYk8HhgIx6Ww4Ft5xCAJ7AQSbnXhsNMPY=s2500",
            "chat_url": null,
            "created_date": "2021-05-25T22:08:32.842837",
            "default_to_fiat": false,
            "description": "Cryptolvidos es una colección de Cryptopoemas en español. La idea es sencilla pero apasionante, una imagen que evoca olvido, soledad, aislamiento, tranquilidad, recogimiento, y un poema de seis versos que despierte todos sus secretos.\n\nNFT con alma.   :-)",
            "dev_buyer_fee_basis_points": "0",
            "dev_seller_fee_basis_points": "0",
            "discord_url": null,
            "display_data": {
                "card_display_style": "contain",
                "images": []
            },
            "external_url": null,
            "featured": false,
            "featured_image_url": null,
            "hidden": true,
            "safelist_request_status": "not_requested",
            "image_url": "https://lh3.googleusercontent.com/KbKbLDxRYZYMmfLF-8UvmfqVYj5tw6CbdAEgnZMvQqcrAJKLtuvsIQL80hjxvXxdzHOIwAf2BR1qaEuQVkCkrDaxTOKclz9rhqzP=s120",
            "is_subject_to_whitelist": false,
            "large_image_url": null,
            "medium_username": null,
            "name": "CRYPTOLVIDOS",
            "only_proxied_transfers": false,
            "opensea_buyer_fee_basis_points": "0",
            "opensea_seller_fee_basis_points": "250",
            "payout_address": null,
            "require_email": false,
            "short_description": null,
            "slug": "cryptolvidos",
            "telegram_url": null,
            "twitter_username": null,
            "instagram_username": null,
            "wiki_url": null
        },
        {
            "primary_asset_contracts": [],
            "traits": {},
            "stats": {
                "seven_day_volume": 0,
                "total_volume": 0,
                "seven_day_change": 0,
                "seven_day_sales": 0,
                "total_sales": 0,
                "total_supply": 0,
                "count": 0,
                "num_owners": 0,
                "seven_day_average_price": 0,
                "average_price": 0,
                "num_reports": 0,
                "market_cap": 0
            },
            "banner_image_url": "https://lh3.googleusercontent.com/FRt2cUvKGykIh4KYxx8my6iU914QIOfHCiEr_ujIeuz56JuQMxXOPNYUfpWfqXd7iGB3v2IcrpW-A5ppxkhNye63HpyHo82aLqjT-Q=s2500",
            "chat_url": null,
            "created_date": "2021-05-25T22:06:51.067488",
            "default_to_fiat": false,
            "description": "",
            "dev_buyer_fee_basis_points": "0",
            "dev_seller_fee_basis_points": "1000",
            "discord_url": "https://discord.gg/trigner9580",
            "display_data": {
                "card_display_style": "contain"
            },
            "external_url": "http://trigner.com",
            "featured": false,
            "featured_image_url": null,
            "hidden": true,
            "safelist_request_status": "not_requested",
            "image_url": "https://lh3.googleusercontent.com/2A9_qExoQy8Xge6hCD5LmAdR-ksYwqEVJhqeCvPyOuSYSgDqeG7BlAbLt2_zZz_anH746_uy3Jsoa76Ll6QfkER0d5YaD5F6qsPz=s120",
            "is_subject_to_whitelist": false,
            "large_image_url": null,
            "medium_username": "trigner",
            "name": "Kadaffi",
            "only_proxied_transfers": false,
            "opensea_buyer_fee_basis_points": "0",
            "opensea_seller_fee_basis_points": "250",
            "payout_address": "0x7dff32e72a08f99669ac23372c07f2432fe27298",
            "require_email": false,
            "short_description": null,
            "slug": "kadaffi",
            "telegram_url": null,
            "twitter_username": null,
            "instagram_username": null,
            "wiki_url": null
        },
        {
            "primary_asset_contracts": [],
            "traits": {},
            "stats": {
                "seven_day_volume": 0,
                "total_volume": 0,
                "seven_day_change": 0,
                "seven_day_sales": 0,
                "total_sales": 0,
                "total_supply": 0,
                "count": 0,
                "num_owners": 0,
                "seven_day_average_price": 0,
                "average_price": 0,
                "num_reports": 0,
                "market_cap": 0
            },
            "banner_image_url": "https://lh3.googleusercontent.com/FRt2cUvKGykIh4KYxx8my6iU914QIOfHCiEr_ujIeuz56JuQMxXOPNYUfpWfqXd7iGB3v2IcrpW-A5ppxkhNye63HpyHo82aLqjT-Q=s2500",
            "chat_url": null,
            "created_date": "2021-05-25T22:05:07.928125",
            "default_to_fiat": false,
            "description": "",
            "dev_buyer_fee_basis_points": "0",
            "dev_seller_fee_basis_points": "1000",
            "discord_url": "https://discord.gg/trigner9580",
            "display_data": {
                "card_display_style": "contain"
            },
            "external_url": "http://trigner.com",
            "featured": false,
            "featured_image_url": null,
            "hidden": true,
            "safelist_request_status": "not_requested",
            "image_url": "https://lh3.googleusercontent.com/2A9_qExoQy8Xge6hCD5LmAdR-ksYwqEVJhqeCvPyOuSYSgDqeG7BlAbLt2_zZz_anH746_uy3Jsoa76Ll6QfkER0d5YaD5F6qsPz=s120",
            "is_subject_to_whitelist": false,
            "large_image_url": null,
            "medium_username": "trigner",
            "name": "Muammar",
            "only_proxied_transfers": false,
            "opensea_buyer_fee_basis_points": "0",
            "opensea_seller_fee_basis_points": "250",
            "payout_address": "0x7dff32e72a08f99669ac23372c07f2432fe27298",
            "require_email": false,
            "short_description": null,
            "slug": "muammar",
            "telegram_url": null,
            "twitter_username": null,
            "instagram_username": null,
            "wiki_url": null
        },
        {
            "primary_asset_contracts": [],
            "traits": {},
            "stats": {
                "seven_day_volume": 0,
                "total_volume": 0,
                "seven_day_change": 0,
                "seven_day_sales": 0,
                "total_sales": 0,
                "total_supply": 0,
                "count": 0,
                "num_owners": 0,
                "seven_day_average_price": 0,
                "average_price": 0,
                "num_reports": 0,
                "market_cap": 0
            },
            "banner_image_url": "https://lh3.googleusercontent.com/FRt2cUvKGykIh4KYxx8my6iU914QIOfHCiEr_ujIeuz56JuQMxXOPNYUfpWfqXd7iGB3v2IcrpW-A5ppxkhNye63HpyHo82aLqjT-Q=s2500",
            "chat_url": null,
            "created_date": "2021-05-25T22:00:45.648105",
            "default_to_fiat": false,
            "description": "",
            "dev_buyer_fee_basis_points": "0",
            "dev_seller_fee_basis_points": "1000",
            "discord_url": "https://discord.gg/trigner9580",
            "display_data": {
                "card_display_style": "contain"
            },
            "external_url": "http://trigner.com",
            "featured": false,
            "featured_image_url": null,
            "hidden": true,
            "safelist_request_status": "not_requested",
            "image_url": "https://lh3.googleusercontent.com/2A9_qExoQy8Xge6hCD5LmAdR-ksYwqEVJhqeCvPyOuSYSgDqeG7BlAbLt2_zZz_anH746_uy3Jsoa76Ll6QfkER0d5YaD5F6qsPz=s120",
            "is_subject_to_whitelist": false,
            "large_image_url": null,
            "medium_username": "trigner",
            "name": "Tanner",
            "only_proxied_transfers": false,
            "opensea_buyer_fee_basis_points": "0",
            "opensea_seller_fee_basis_points": "250",
            "payout_address": "0x7dff32e72a08f99669ac23372c07f2432fe27298",
            "require_email": false,
            "short_description": null,
            "slug": "tanner",
            "telegram_url": null,
            "twitter_username": null,
            "instagram_username": null,
            "wiki_url": null
        },
        {
            "primary_asset_contracts": [],
            "traits": {},
            "stats": {
                "seven_day_volume": 0,
                "total_volume": 0,
                "seven_day_change": 0,
                "seven_day_sales": 0,
                "total_sales": 0,
                "total_supply": 0,
                "count": 0,
                "num_owners": 0,
                "seven_day_average_price": 0,
                "average_price": 0,
                "num_reports": 0,
                "market_cap": 0
            },
            "banner_image_url": "https://lh3.googleusercontent.com/FRt2cUvKGykIh4KYxx8my6iU914QIOfHCiEr_ujIeuz56JuQMxXOPNYUfpWfqXd7iGB3v2IcrpW-A5ppxkhNye63HpyHo82aLqjT-Q=s2500",
            "chat_url": null,
            "created_date": "2021-05-25T21:57:45.275276",
            "default_to_fiat": false,
            "description": "",
            "dev_buyer_fee_basis_points": "0",
            "dev_seller_fee_basis_points": "1000",
            "discord_url": "https://discord.gg/trigner9580",
            "display_data": {
                "card_display_style": "contain"
            },
            "external_url": "http://trigner.com",
            "featured": false,
            "featured_image_url": null,
            "hidden": true,
            "safelist_request_status": "not_requested",
            "image_url": "https://lh3.googleusercontent.com/2A9_qExoQy8Xge6hCD5LmAdR-ksYwqEVJhqeCvPyOuSYSgDqeG7BlAbLt2_zZz_anH746_uy3Jsoa76Ll6QfkER0d5YaD5F6qsPz=s120",
            "is_subject_to_whitelist": false,
            "large_image_url": null,
            "medium_username": "trigner",
            "name": "Bale",
            "only_proxied_transfers": false,
            "opensea_buyer_fee_basis_points": "0",
            "opensea_seller_fee_basis_points": "250",
            "payout_address": "0x7dff32e72a08f99669ac23372c07f2432fe27298",
            "require_email": false,
            "short_description": null,
            "slug": "bale",
            "telegram_url": null,
            "twitter_username": null,
            "instagram_username": null,
            "wiki_url": null
        },
        {
            "primary_asset_contracts": [],
            "traits": {},
            "stats": {
                "seven_day_volume": 0,
                "total_volume": 0,
                "seven_day_change": 0,
                "seven_day_sales": 0,
                "total_sales": 0,
                "total_supply": 0,
                "count": 0,
                "num_owners": 0,
                "seven_day_average_price": 0,
                "average_price": 0,
                "num_reports": 0,
                "market_cap": 0
            },
            "banner_image_url": "https://lh3.googleusercontent.com/Qxb4YO_lPsaTKIsa0FZJ-paLewoOGswJ1aHWQLHGXgWxwhtEjfMtyD5CZc4Pt6OG-u2LS2HtZL1slTqtmjhFUVNFhPebjWaAaenPEQ=s2500",
            "chat_url": null,
            "created_date": "2021-05-25T21:56:51.519774",
            "default_to_fiat": false,
            "description": "Ken Chapman is a singer / songwriter from Cornwall who performs rocky, upbeat acoustic music",
            "dev_buyer_fee_basis_points": "0",
            "dev_seller_fee_basis_points": "1000",
            "discord_url": null,
            "display_data": {
                "card_display_style": "contain"
            },
            "external_url": "http://facebook.com/kenchapmanmusic",
            "featured": false,
            "featured_image_url": "https://lh3.googleusercontent.com/hJbQaTimsY5irdpaG3dVV3GGInkEVYQKyUojZjlKalUsrbsusz_eVqGHziLWDLgXVJODV7_QTihtBTGA9gMP1zHvCzR9jimrpBKf=s300",
            "hidden": true,
            "safelist_request_status": "not_requested",
            "image_url": "https://lh3.googleusercontent.com/M3le9EMKdpJ-PFRuCTViygwNcU3e9PIGUU6uiAJa2klPgAJfxiFoey9Mr6CWfet7ZHOoBek6crOhNmAFLgPHqBvxJ7xtrCkdmOmVeQ=s120",
            "is_subject_to_whitelist": false,
            "large_image_url": "https://lh3.googleusercontent.com/hJbQaTimsY5irdpaG3dVV3GGInkEVYQKyUojZjlKalUsrbsusz_eVqGHziLWDLgXVJODV7_QTihtBTGA9gMP1zHvCzR9jimrpBKf=s300",
            "medium_username": null,
            "name": "Ken Chapman Music",
            "only_proxied_transfers": false,
            "opensea_buyer_fee_basis_points": "0",
            "opensea_seller_fee_basis_points": "250",
            "payout_address": "0x48c46ad078dfd5f0fdd4f672b4aa24cedef7ad6e",
            "require_email": false,
            "short_description": null,
            "slug": "kenchapmanmusic",
            "telegram_url": null,
            "twitter_username": null,
            "instagram_username": "kenchapmanmusic",
            "wiki_url": null
        },
        {
            "primary_asset_contracts": [],
            "traits": {},
            "stats": {
                "seven_day_volume": 0,
                "total_volume": 0,
                "seven_day_change": 0,
                "seven_day_sales": 0,
                "total_sales": 0,
                "total_supply": 0,
                "count": 0,
                "num_owners": 0,
                "seven_day_average_price": 0,
                "average_price": 0,
                "num_reports": 0,
                "market_cap": 0
            },
            "banner_image_url": "https://lh3.googleusercontent.com/FRt2cUvKGykIh4KYxx8my6iU914QIOfHCiEr_ujIeuz56JuQMxXOPNYUfpWfqXd7iGB3v2IcrpW-A5ppxkhNye63HpyHo82aLqjT-Q=s2500",
            "chat_url": null,
            "created_date": "2021-05-25T21:56:39.779650",
            "default_to_fiat": false,
            "description": "",
            "dev_buyer_fee_basis_points": "0",
            "dev_seller_fee_basis_points": "1000",
            "discord_url": "https://discord.gg/trigner9580",
            "display_data": {
                "card_display_style": "contain"
            },
            "external_url": "http://trigner.com",
            "featured": false,
            "featured_image_url": null,
            "hidden": true,
            "safelist_request_status": "not_requested",
            "image_url": "https://lh3.googleusercontent.com/2A9_qExoQy8Xge6hCD5LmAdR-ksYwqEVJhqeCvPyOuSYSgDqeG7BlAbLt2_zZz_anH746_uy3Jsoa76Ll6QfkER0d5YaD5F6qsPz=s120",
            "is_subject_to_whitelist": false,
            "large_image_url": null,
            "medium_username": "trigner",
            "name": "Gareth",
            "only_proxied_transfers": false,
            "opensea_buyer_fee_basis_points": "0",
            "opensea_seller_fee_basis_points": "250",
            "payout_address": "0x7dff32e72a08f99669ac23372c07f2432fe27298",
            "require_email": false,
            "short_description": null,
            "slug": "gareth",
            "telegram_url": null,
            "twitter_username": null,
            "instagram_username": null,
            "wiki_url": null
        },
        {
            "primary_asset_contracts": [],
            "traits": {},
            "stats": {
                "seven_day_volume": 0,
                "total_volume": 0,
                "seven_day_change": 0,
                "seven_day_sales": 0,
                "total_sales": 0,
                "total_supply": 0,
                "count": 0,
                "num_owners": 0,
                "seven_day_average_price": 0,
                "average_price": 0,
                "num_reports": 0,
                "market_cap": 0
            },
            "banner_image_url": "https://lh3.googleusercontent.com/x_HGj_5ixJAnITfefULY1s1k5i1HuCD3qBoDH6PQ4HNsVI_o_QsWJTTSxPggqoGUNiPk-7Mr5gZacVHYgWbP8--YskUge8n6dJ-l=s2500",
            "chat_url": null,
            "created_date": "2021-05-25T21:52:44.598323",
            "default_to_fiat": false,
            "description": "",
            "dev_buyer_fee_basis_points": "0",
            "dev_seller_fee_basis_points": "0",
            "discord_url": null,
            "display_data": {
                "card_display_style": "contain",
                "images": []
            },
            "external_url": null,
            "featured": false,
            "featured_image_url": null,
            "hidden": true,
            "safelist_request_status": "not_requested",
            "image_url": "https://lh3.googleusercontent.com/czIom0PJaFnnfAaHnTOO2wR-IIVljvFQWsAy9gPGMe7s_UQfkNQmviI3kRSHBEI05tXUVyklJugJg56uH_e0H20zSdex1hHtz2gu=s120",
            "is_subject_to_whitelist": false,
            "large_image_url": null,
            "medium_username": null,
            "name": "coffee to go",
            "only_proxied_transfers": false,
            "opensea_buyer_fee_basis_points": "0",
            "opensea_seller_fee_basis_points": "250",
            "payout_address": null,
            "require_email": false,
            "short_description": null,
            "slug": "coffee-to-go",
            "telegram_url": null,
            "twitter_username": null,
            "instagram_username": null,
            "wiki_url": null
        },
        {
            "primary_asset_contracts": [],
            "traits": {},
            "stats": {
                "seven_day_volume": 0,
                "total_volume": 0,
                "seven_day_change": 0,
                "seven_day_sales": 0,
                "total_sales": 0,
                "total_supply": 0,
                "count": 0,
                "num_owners": 0,
                "seven_day_average_price": 0,
                "average_price": 0,
                "num_reports": 0,
                "market_cap": 0
            },
            "banner_image_url": "https://lh3.googleusercontent.com/dp_xcEuAvXrts2ixJgSrQWjCJrvzBQs-vj-YVgXPNneLM_hoHFemh2TipppQ1CH46lVMzE6FfV3p9ip7NoZS4-6yNrr3AiB8cM_oDA=s2500",
            "chat_url": null,
            "created_date": "2021-05-25T21:51:42.740707",
            "default_to_fiat": false,
            "description": "This collection was created using an AI algorithm, trained on different art datasets with different genres and styles. The main goal of my work is to show that the main value of AI not to copy and imitate some human creations, but to analyze our experience and generate some new ideas, concepts which we will be able to expand our own boundaries of imagination and knowledge. ",
            "dev_buyer_fee_basis_points": "0",
            "dev_seller_fee_basis_points": "850",
            "discord_url": null,
            "display_data": {
                "card_display_style": "contain"
            },
            "external_url": null,
            "featured": false,
            "featured_image_url": "https://lh3.googleusercontent.com/kAqNYlXyJ0vSMsqtLBiZK9XTmHowlQWCtqjih4eYb-CM7sBCh5ZOtrJDlduUcD7DunvV_J5pdeaaI9OYNG_8orPR6kfmQm_6tRGm99o=s300",
            "hidden": true,
            "safelist_request_status": "not_requested",
            "image_url": "https://lh3.googleusercontent.com/piaf_IQ52U0ng5w4XGzWjOPKBejWSmgJAi7Gkkm55NUVYNkTkxKdiC9Mm2Eh8FG9Ng0ruVn0ZxJYG_NTCsjxBZ8Wc-F8IPkm42EX=s120",
            "is_subject_to_whitelist": false,
            "large_image_url": "https://lh3.googleusercontent.com/kAqNYlXyJ0vSMsqtLBiZK9XTmHowlQWCtqjih4eYb-CM7sBCh5ZOtrJDlduUcD7DunvV_J5pdeaaI9OYNG_8orPR6kfmQm_6tRGm99o=s300",
            "medium_username": null,
            "name": "Surrealistic inferences",
            "only_proxied_transfers": false,
            "opensea_buyer_fee_basis_points": "0",
            "opensea_seller_fee_basis_points": "250",
            "payout_address": "0x54f5b9e54108e9f959da4c0903c2b7da0cbcc954",
            "require_email": false,
            "short_description": null,
            "slug": "surrealistic-inferences",
            "telegram_url": null,
            "twitter_username": null,
            "instagram_username": "b.t._ai_art",
            "wiki_url": null
        },
        {
            "primary_asset_contracts": [],
            "traits": {},
            "stats": {
                "seven_day_volume": 0,
                "total_volume": 0,
                "seven_day_change": 0,
                "seven_day_sales": 0,
                "total_sales": 0,
                "total_supply": 0,
                "count": 0,
                "num_owners": 0,
                "seven_day_average_price": 0,
                "average_price": 0,
                "num_reports": 0,
                "market_cap": 0
            },
            "banner_image_url": "https://lh3.googleusercontent.com/FRt2cUvKGykIh4KYxx8my6iU914QIOfHCiEr_ujIeuz56JuQMxXOPNYUfpWfqXd7iGB3v2IcrpW-A5ppxkhNye63HpyHo82aLqjT-Q=s2500",
            "chat_url": null,
            "created_date": "2021-05-25T21:50:45.738118",
            "default_to_fiat": false,
            "description": "",
            "dev_buyer_fee_basis_points": "0",
            "dev_seller_fee_basis_points": "1000",
            "discord_url": "https://discord.gg/trigner9580",
            "display_data": {
                "card_display_style": "contain"
            },
            "external_url": "http://trigner.com",
            "featured": false,
            "featured_image_url": null,
            "hidden": true,
            "safelist_request_status": "not_requested",
            "image_url": "https://lh3.googleusercontent.com/2A9_qExoQy8Xge6hCD5LmAdR-ksYwqEVJhqeCvPyOuSYSgDqeG7BlAbLt2_zZz_anH746_uy3Jsoa76Ll6QfkER0d5YaD5F6qsPz=s120",
            "is_subject_to_whitelist": false,
            "large_image_url": null,
            "medium_username": "trigner",
            "name": "Jared",
            "only_proxied_transfers": false,
            "opensea_buyer_fee_basis_points": "0",
            "opensea_seller_fee_basis_points": "250",
            "payout_address": "0x7dff32e72a08f99669ac23372c07f2432fe27298",
            "require_email": false,
            "short_description": null,
            "slug": "jared",
            "telegram_url": null,
            "twitter_username": null,
            "instagram_username": null,
            "wiki_url": null
        },
        {
            "primary_asset_contracts": [],
            "traits": {},
            "stats": {
                "seven_day_volume": 0,
                "total_volume": 0,
                "seven_day_change": 0,
                "seven_day_sales": 0,
                "total_sales": 0,
                "total_supply": 0,
                "count": 0,
                "num_owners": 0,
                "seven_day_average_price": 0,
                "average_price": 0,
                "num_reports": 0,
                "market_cap": 0
            },
            "banner_image_url": "https://lh3.googleusercontent.com/FRt2cUvKGykIh4KYxx8my6iU914QIOfHCiEr_ujIeuz56JuQMxXOPNYUfpWfqXd7iGB3v2IcrpW-A5ppxkhNye63HpyHo82aLqjT-Q=s2500",
            "chat_url": null,
            "created_date": "2021-05-25T21:48:48.483761",
            "default_to_fiat": false,
            "description": "",
            "dev_buyer_fee_basis_points": "0",
            "dev_seller_fee_basis_points": "1000",
            "discord_url": "https://discord.gg/trigner9580",
            "display_data": {
                "card_display_style": "contain"
            },
            "external_url": "http://trigner.com",
            "featured": false,
            "featured_image_url": null,
            "hidden": true,
            "safelist_request_status": "not_requested",
            "image_url": "https://lh3.googleusercontent.com/2A9_qExoQy8Xge6hCD5LmAdR-ksYwqEVJhqeCvPyOuSYSgDqeG7BlAbLt2_zZz_anH746_uy3Jsoa76Ll6QfkER0d5YaD5F6qsPz=s120",
            "is_subject_to_whitelist": false,
            "large_image_url": null,
            "medium_username": "trigner",
            "name": "Loca",
            "only_proxied_transfers": false,
            "opensea_buyer_fee_basis_points": "0",
            "opensea_seller_fee_basis_points": "250",
            "payout_address": "0x7dff32e72a08f99669ac23372c07f2432fe27298",
            "require_email": false,
            "short_description": null,
            "slug": "loca",
            "telegram_url": null,
            "twitter_username": null,
            "instagram_username": null,
            "wiki_url": null
        },
        {
            "primary_asset_contracts": [],
            "traits": {},
            "stats": {
                "seven_day_volume": 0,
                "total_volume": 0,
                "seven_day_change": 0,
                "seven_day_sales": 0,
                "total_sales": 0,
                "total_supply": 0,
                "count": 0,
                "num_owners": 0,
                "seven_day_average_price": 0,
                "average_price": 0,
                "num_reports": 0,
                "market_cap": 0
            },
            "banner_image_url": "https://lh3.googleusercontent.com/a_ZbCxQFdLxorf1zTZdxltlhnccACdQofaUwoNwakQ2fMyyOcvOsUzA0TGnMbH8eFWTSgg905e_YrnOXa-3ukSWFBQ0hekQn1-w9ysQ=s2500",
            "chat_url": null,
            "created_date": "2021-05-25T21:47:47.725094",
            "default_to_fiat": false,
            "description": "Random photos and videos from our vacations.",
            "dev_buyer_fee_basis_points": "0",
            "dev_seller_fee_basis_points": "500",
            "discord_url": null,
            "display_data": {
                "card_display_style": "contain"
            },
            "external_url": null,
            "featured": false,
            "featured_image_url": "https://lh3.googleusercontent.com/XfkMapckBt7_YFzJoq6ASEEqvgLS587Wak8yvdcTyVk1y5HxBzHQMVhBlA3U9ING-BBKBRdRD9rBj4_xYQRtmZK2f-ccZa_XMRQ2=s300",
            "hidden": true,
            "safelist_request_status": "not_requested",
            "image_url": "https://lh3.googleusercontent.com/2q9riXKLdxyy-t6FZdmOrsQGfyVSyUn9li0TdHXVk2QkNxdZLO_AO91aMkVzOh_WHcEJQ78uzuooIiHDJZfuWnxZEJV4NE-Z4xNJOSo=s120",
            "is_subject_to_whitelist": false,
            "large_image_url": "https://lh3.googleusercontent.com/XfkMapckBt7_YFzJoq6ASEEqvgLS587Wak8yvdcTyVk1y5HxBzHQMVhBlA3U9ING-BBKBRdRD9rBj4_xYQRtmZK2f-ccZa_XMRQ2=s300",
            "medium_username": null,
            "name": "Puerto Rico; una trabajar del arte",
            "only_proxied_transfers": false,
            "opensea_buyer_fee_basis_points": "0",
            "opensea_seller_fee_basis_points": "250",
            "payout_address": "0xcccfcce90cd4f0cdc9c2b91d3940ed2d4b589ed9",
            "require_email": false,
            "short_description": null,
            "slug": "wild-horses-in-puerto-rico",
            "telegram_url": null,
            "twitter_username": null,
            "instagram_username": null,
            "wiki_url": null
        },
        {
            "primary_asset_contracts": [],
            "traits": {},
            "stats": {
                "seven_day_volume": 0,
                "total_volume": 0,
                "seven_day_change": 0,
                "seven_day_sales": 0,
                "total_sales": 0,
                "total_supply": 0,
                "count": 0,
                "num_owners": 0,
                "seven_day_average_price": 0,
                "average_price": 0,
                "num_reports": 0,
                "market_cap": 0
            },
            "banner_image_url": "https://lh3.googleusercontent.com/i1cedlL7cRQtTcEkl2ozIA-6ZP_ZiZPysBncNm1-9nY5UkJf-DLonT_vGSjvFy01NcAF6p3gm9Teolwq-F08NJ2pNB3SyDgznKtj=s2500",
            "chat_url": null,
            "created_date": "2021-05-25T21:47:46.465752",
            "default_to_fiat": false,
            "description": "The DoodlePunk NFT are the first set of 1000 limited DoodlePunk units, which were designed and created. They are registered day by day on the Ethereum Blockchain (ERC-721 standard) and available for verified trading.",
            "dev_buyer_fee_basis_points": "0",
            "dev_seller_fee_basis_points": "375",
            "discord_url": null,
            "display_data": {
                "card_display_style": "padded"
            },
            "external_url": null,
            "featured": false,
            "featured_image_url": "https://lh3.googleusercontent.com/G8Gj_21eZeSIKzVmUWfqco99_32YUEgX6Um866hgcSpIjmyUV9XffMf218gPx2yVXzIXraWmmyjKJxPDGq8_FxPMtLFBlcjq3RDsDQ=s300",
            "hidden": true,
            "safelist_request_status": "not_requested",
            "image_url": "https://lh3.googleusercontent.com/G8Gj_21eZeSIKzVmUWfqco99_32YUEgX6Um866hgcSpIjmyUV9XffMf218gPx2yVXzIXraWmmyjKJxPDGq8_FxPMtLFBlcjq3RDsDQ=s120",
            "is_subject_to_whitelist": false,
            "large_image_url": "https://lh3.googleusercontent.com/G8Gj_21eZeSIKzVmUWfqco99_32YUEgX6Um866hgcSpIjmyUV9XffMf218gPx2yVXzIXraWmmyjKJxPDGq8_FxPMtLFBlcjq3RDsDQ=s300",
            "medium_username": null,
            "name": "DoodlePunk",
            "only_proxied_transfers": false,
            "opensea_buyer_fee_basis_points": "0",
            "opensea_seller_fee_basis_points": "250",
            "payout_address": "0xda3232059ac4e704e7d55b97e82a10107c75398a",
            "require_email": false,
            "short_description": null,
            "slug": "doodlepunk",
            "telegram_url": null,
            "twitter_username": null,
            "instagram_username": null,
            "wiki_url": null
        },
        {
            "primary_asset_contracts": [],
            "traits": {},
            "stats": {
                "seven_day_volume": 0,
                "total_volume": 0,
                "seven_day_change": 0,
                "seven_day_sales": 0,
                "total_sales": 0,
                "total_supply": 0,
                "count": 0,
                "num_owners": 0,
                "seven_day_average_price": 0,
                "average_price": 0,
                "num_reports": 0,
                "market_cap": 0
            },
            "banner_image_url": "https://lh3.googleusercontent.com/8UTaYNPB5tRFhS10MSVG-bZyeUU2YSfmdM6eOgMDpjjcJBQEsKRfeg0IDZffHJwUpsetT76cXvref2z7G10cZBFyhmmb5uChfV-Fe_I=s2500",
            "chat_url": null,
            "created_date": "2021-05-25T21:46:55.583052",
            "default_to_fiat": false,
            "description": "Banners for Lukso OGs",
            "dev_buyer_fee_basis_points": "0",
            "dev_seller_fee_basis_points": "100",
            "discord_url": null,
            "display_data": {
                "card_display_style": "contain"
            },
            "external_url": null,
            "featured": false,
            "featured_image_url": "https://lh3.googleusercontent.com/8UTaYNPB5tRFhS10MSVG-bZyeUU2YSfmdM6eOgMDpjjcJBQEsKRfeg0IDZffHJwUpsetT76cXvref2z7G10cZBFyhmmb5uChfV-Fe_I=s300",
            "hidden": true,
            "safelist_request_status": "not_requested",
            "image_url": "https://lh3.googleusercontent.com/8UTaYNPB5tRFhS10MSVG-bZyeUU2YSfmdM6eOgMDpjjcJBQEsKRfeg0IDZffHJwUpsetT76cXvref2z7G10cZBFyhmmb5uChfV-Fe_I=s120",
            "is_subject_to_whitelist": false,
            "large_image_url": "https://lh3.googleusercontent.com/8UTaYNPB5tRFhS10MSVG-bZyeUU2YSfmdM6eOgMDpjjcJBQEsKRfeg0IDZffHJwUpsetT76cXvref2z7G10cZBFyhmmb5uChfV-Fe_I=s300",
            "medium_username": null,
            "name": "LuksOG Banners",
            "only_proxied_transfers": false,
            "opensea_buyer_fee_basis_points": "0",
            "opensea_seller_fee_basis_points": "250",
            "payout_address": "0x2f7f6485353742e459f67bbe957ff8fb6c8943e9",
            "require_email": false,
            "short_description": null,
            "slug": "luksog-banners",
            "telegram_url": null,
            "twitter_username": "Alts_Anonymous",
            "instagram_username": null,
            "wiki_url": null
        },
        {
            "primary_asset_contracts": [],
            "traits": {},
            "stats": {
                "seven_day_volume": 0,
                "total_volume": 0,
                "seven_day_change": 0,
                "seven_day_sales": 0,
                "total_sales": 0,
                "total_supply": 0,
                "count": 0,
                "num_owners": 0,
                "seven_day_average_price": 0,
                "average_price": 0,
                "num_reports": 0,
                "market_cap": 0
            },
            "banner_image_url": "https://lh3.googleusercontent.com/FRt2cUvKGykIh4KYxx8my6iU914QIOfHCiEr_ujIeuz56JuQMxXOPNYUfpWfqXd7iGB3v2IcrpW-A5ppxkhNye63HpyHo82aLqjT-Q=s2500",
            "chat_url": null,
            "created_date": "2021-05-25T21:45:10.308656",
            "default_to_fiat": false,
            "description": "",
            "dev_buyer_fee_basis_points": "0",
            "dev_seller_fee_basis_points": "1000",
            "discord_url": "https://discord.gg/trigner9580",
            "display_data": {
                "card_display_style": "contain"
            },
            "external_url": "http://trigner.com",
            "featured": false,
            "featured_image_url": null,
            "hidden": true,
            "safelist_request_status": "not_requested",
            "image_url": "https://lh3.googleusercontent.com/2A9_qExoQy8Xge6hCD5LmAdR-ksYwqEVJhqeCvPyOuSYSgDqeG7BlAbLt2_zZz_anH746_uy3Jsoa76Ll6QfkER0d5YaD5F6qsPz=s120",
            "is_subject_to_whitelist": false,
            "large_image_url": null,
            "medium_username": "trigner",
            "name": "Devin",
            "only_proxied_transfers": false,
            "opensea_buyer_fee_basis_points": "0",
            "opensea_seller_fee_basis_points": "250",
            "payout_address": "0x7dff32e72a08f99669ac23372c07f2432fe27298",
            "require_email": false,
            "short_description": null,
            "slug": "devin",
            "telegram_url": null,
            "twitter_username": null,
            "instagram_username": null,
            "wiki_url": null
        },
        {
            "primary_asset_contracts": [],
            "traits": {},
            "stats": {
                "seven_day_volume": 0,
                "total_volume": 0,
                "seven_day_change": 0,
                "seven_day_sales": 0,
                "total_sales": 0,
                "total_supply": 0,
                "count": 0,
                "num_owners": 0,
                "seven_day_average_price": 0,
                "average_price": 0,
                "num_reports": 0,
                "market_cap": 0
            },
            "banner_image_url": "https://lh3.googleusercontent.com/ESfXDTbNgp6nRK8aqBIUVK6HSl_dWvXAwU0o8lYOzb_BphEqsoqlwzVJGtpqefbeIECgiGH6cfnLrj0ewBnWPNzRa4zAB-f_0D7g3g=s2500",
            "chat_url": null,
            "created_date": "2021-05-25T21:44:36.219808",
            "default_to_fiat": false,
            "description": "In this Duality collection 27Kasukabe plays with the viewer, for the latter expects no movement in a QR code, yet no stillness will be found. Scanning with a smartphone any of the works included in this collection will not lead to any website, which, according to 27Kasukabe, means that not finding what one expects in life is not something negative, but an opportunity to delve in the randomness of life and to luxuriate in observing life's continuous but caothic beauty.\n\n27Kasukabe chose two words to create his imagery, to replace each detail of his works, so that in end effect, there was not a static scenery anymore, but rather a moveable feast performed on a computer. It requires an acutely skillful eye to look at his combinations and to detect and critically appraise each artwork. What the artist does here is using as a spectrum of expression the vast, but nonetheless finite digital RGB multi-colored range, the very hermetic quality of which demands constant reinterpretation.",
            "dev_buyer_fee_basis_points": "0",
            "dev_seller_fee_basis_points": "300",
            "discord_url": null,
            "display_data": {
                "card_display_style": "cover"
            },
            "external_url": "http://nosocialmedia.stayindependent",
            "featured": false,
            "featured_image_url": null,
            "hidden": true,
            "safelist_request_status": "not_requested",
            "image_url": "https://lh3.googleusercontent.com/BqtfIX2gHic7B_tmvkrKbhgZ197eLen3q4J2yPt4YsFdbl7n2lGlPtjzy3H-o2wcx5J_j5IUVwkeEtD4ogZxHcirpED3lf5ffNY6Yg=s120",
            "is_subject_to_whitelist": false,
            "large_image_url": null,
            "medium_username": null,
            "name": "Duality by 27Kasukabe",
            "only_proxied_transfers": false,
            "opensea_buyer_fee_basis_points": "0",
            "opensea_seller_fee_basis_points": "250",
            "payout_address": "0xa8dd408f0835c624f0e4ad239e0b7c4fe09eaf1f",
            "require_email": false,
            "short_description": null,
            "slug": "duality-by-27kasukabe",
            "telegram_url": null,
            "twitter_username": null,
            "instagram_username": null,
            "wiki_url": null
        },
        {
            "primary_asset_contracts": [],
            "traits": {},
            "stats": {
                "seven_day_volume": 0,
                "total_volume": 0,
                "seven_day_change": 0,
                "seven_day_sales": 0,
                "total_sales": 0,
                "total_supply": 0,
                "count": 0,
                "num_owners": 0,
                "seven_day_average_price": 0,
                "average_price": 0,
                "num_reports": 0,
                "market_cap": 0
            },
            "banner_image_url": "https://lh3.googleusercontent.com/FRt2cUvKGykIh4KYxx8my6iU914QIOfHCiEr_ujIeuz56JuQMxXOPNYUfpWfqXd7iGB3v2IcrpW-A5ppxkhNye63HpyHo82aLqjT-Q=s2500",
            "chat_url": null,
            "created_date": "2021-05-25T21:40:51.675926",
            "default_to_fiat": false,
            "description": "",
            "dev_buyer_fee_basis_points": "0",
            "dev_seller_fee_basis_points": "1000",
            "discord_url": "https://discord.gg/trigner9580",
            "display_data": {
                "card_display_style": "contain"
            },
            "external_url": "http://trigner.com",
            "featured": false,
            "featured_image_url": null,
            "hidden": true,
            "safelist_request_status": "not_requested",
            "image_url": "https://lh3.googleusercontent.com/2A9_qExoQy8Xge6hCD5LmAdR-ksYwqEVJhqeCvPyOuSYSgDqeG7BlAbLt2_zZz_anH746_uy3Jsoa76Ll6QfkER0d5YaD5F6qsPz=s120",
            "is_subject_to_whitelist": false,
            "large_image_url": null,
            "medium_username": "trigner",
            "name": "MarcoPolo",
            "only_proxied_transfers": false,
            "opensea_buyer_fee_basis_points": "0",
            "opensea_seller_fee_basis_points": "250",
            "payout_address": "0x7dff32e72a08f99669ac23372c07f2432fe27298",
            "require_email": false,
            "short_description": null,
            "slug": "marcopolo",
            "telegram_url": null,
            "twitter_username": null,
            "instagram_username": null,
            "wiki_url": null
        },
        {
            "primary_asset_contracts": [],
            "traits": {},
            "stats": {
                "seven_day_volume": 0,
                "total_volume": 0,
                "seven_day_change": 0,
                "seven_day_sales": 0,
                "total_sales": 0,
                "total_supply": 0,
                "count": 0,
                "num_owners": 0,
                "seven_day_average_price": 0,
                "average_price": 0,
                "num_reports": 0,
                "market_cap": 0
            },
            "banner_image_url": "https://lh3.googleusercontent.com/m8B5jG03FW8iexHKMmAiuyFuIZPLdJ1m5ioLhRtg7ZyA8e_-nF9Ww5yEApJvJUiwy79YfWy48hQEd2R0qsmEDkhQ3s_qRKRRWqCiSg=s2500",
            "chat_url": null,
            "created_date": "2021-05-25T21:40:21.336690",
            "default_to_fiat": false,
            "description": "Album Cover From RickGotEmHatin's \"Jet Set Swag\"\nInfluenced by the Classic Game \"Jet Set Radio\"",
            "dev_buyer_fee_basis_points": "0",
            "dev_seller_fee_basis_points": "1000",
            "discord_url": null,
            "display_data": {
                "card_display_style": "contain"
            },
            "external_url": null,
            "featured": false,
            "featured_image_url": "https://lh3.googleusercontent.com/m8B5jG03FW8iexHKMmAiuyFuIZPLdJ1m5ioLhRtg7ZyA8e_-nF9Ww5yEApJvJUiwy79YfWy48hQEd2R0qsmEDkhQ3s_qRKRRWqCiSg=s300",
            "hidden": true,
            "safelist_request_status": "not_requested",
            "image_url": "https://lh3.googleusercontent.com/m8B5jG03FW8iexHKMmAiuyFuIZPLdJ1m5ioLhRtg7ZyA8e_-nF9Ww5yEApJvJUiwy79YfWy48hQEd2R0qsmEDkhQ3s_qRKRRWqCiSg=s120",
            "is_subject_to_whitelist": false,
            "large_image_url": "https://lh3.googleusercontent.com/m8B5jG03FW8iexHKMmAiuyFuIZPLdJ1m5ioLhRtg7ZyA8e_-nF9Ww5yEApJvJUiwy79YfWy48hQEd2R0qsmEDkhQ3s_qRKRRWqCiSg=s300",
            "medium_username": null,
            "name": "Jet Set Swag",
            "only_proxied_transfers": false,
            "opensea_buyer_fee_basis_points": "0",
            "opensea_seller_fee_basis_points": "250",
            "payout_address": "0xaef2fc9765a45324b3d154dd9bfeff25e1744c83",
            "require_email": false,
            "short_description": null,
            "slug": "jet-set-swag",
            "telegram_url": null,
            "twitter_username": "RickGotEmHatin",
            "instagram_username": "RickGotEmHatin",
            "wiki_url": null
        },
        {
            "primary_asset_contracts": [],
            "traits": {},
            "stats": {
                "seven_day_volume": 0,
                "total_volume": 0,
                "seven_day_change": 0,
                "seven_day_sales": 0,
                "total_sales": 0,
                "total_supply": 0,
                "count": 0,
                "num_owners": 0,
                "seven_day_average_price": 0,
                "average_price": 0,
                "num_reports": 0,
                "market_cap": 0
            },
            "banner_image_url": "https://lh3.googleusercontent.com/ylUR7tvPDT07RH3pHdZpiOFUtxI9Zjgb8f0UuuG7hJjsigSSa6VitVgr_oKLbvgxEs7e35pNrWxO2vmWpo_7G_tP0lr5quqocGuv=s2500",
            "chat_url": null,
            "created_date": "2021-05-25T21:38:22.627136",
            "default_to_fiat": false,
            "description": "Hip Hop Straight Off the Blockchain.\nA Collection of NFT Hip Hop Art Collectibles by Graphic Artist Metaphorsy.",
            "dev_buyer_fee_basis_points": "0",
            "dev_seller_fee_basis_points": "700",
            "discord_url": null,
            "display_data": {
                "card_display_style": "cover"
            },
            "external_url": null,
            "featured": false,
            "featured_image_url": "https://lh3.googleusercontent.com/sNKBht8OCJbR2EeSaOXvl8Xf11KcPZrGX8viTQk3FPZVu80Ljc_T1jY0vS8X5OPqwtcPAOxWImJEkhh5lDL9I2BU594L2icJadjrog=s300",
            "hidden": true,
            "safelist_request_status": "not_requested",
            "image_url": "https://lh3.googleusercontent.com/B97EcTvNhujXehz8C-jPUoZVKP6aG_LBLCG4Au3YMb3SPdutA6szxIYdKfQ74ljx5ehibLy-sV3fK8fqYBXLpE8FkYzs5PnWpLv1yQ=s120",
            "is_subject_to_whitelist": false,
            "large_image_url": "https://lh3.googleusercontent.com/sNKBht8OCJbR2EeSaOXvl8Xf11KcPZrGX8viTQk3FPZVu80Ljc_T1jY0vS8X5OPqwtcPAOxWImJEkhh5lDL9I2BU594L2icJadjrog=s300",
            "medium_username": null,
            "name": "The Hiphopsons",
            "only_proxied_transfers": false,
            "opensea_buyer_fee_basis_points": "0",
            "opensea_seller_fee_basis_points": "250",
            "payout_address": "0x6d9a6bc8fd99be52959c2ecd79ac3d2314620f3e",
            "require_email": false,
            "short_description": null,
            "slug": "thehiphopsons",
            "telegram_url": null,
            "twitter_username": "metaphorsy",
            "instagram_username": "metaphorsy",
            "wiki_url": null
        },
        {
            "primary_asset_contracts": [],
            "traits": {},
            "stats": {
                "seven_day_volume": 0,
                "total_volume": 0,
                "seven_day_change": 0,
                "seven_day_sales": 0,
                "total_sales": 0,
                "total_supply": 0,
                "count": 0,
                "num_owners": 0,
                "seven_day_average_price": 0,
                "average_price": 0,
                "num_reports": 0,
                "market_cap": 0
            },
            "banner_image_url": "https://lh3.googleusercontent.com/z51gy3sj1t3Qavke1uWKla2yl9t0eONyVuN8UQRVVsL--meIQDiS0gw-oAQEiU-C3x_KK5QzBfCNex2JqZWKHQmAlDOT5rvVR7CLoQ=s2500",
            "chat_url": null,
            "created_date": "2021-05-25T21:37:16.938629",
            "default_to_fiat": false,
            "description": "A limited collection of Irish trading cards. Each one features a historic Irish landmark in the Irish capital city of Dublin.",
            "dev_buyer_fee_basis_points": "0",
            "dev_seller_fee_basis_points": "0",
            "discord_url": null,
            "display_data": {
                "card_display_style": "contain",
                "images": []
            },
            "external_url": null,
            "featured": false,
            "featured_image_url": null,
            "hidden": true,
            "safelist_request_status": "not_requested",
            "image_url": "https://lh3.googleusercontent.com/CUBlkfufR8BtCFQ31DyE8KZqTAA2zFbUHsYE49TLXMMbQkJ2gDZ-Mex8WtCJa0scYXeG-0MWB9mD4rUu07JbKv5TgPOqUcsQ4I_63Q=s120",
            "is_subject_to_whitelist": false,
            "large_image_url": null,
            "medium_username": null,
            "name": "Irish collection",
            "only_proxied_transfers": false,
            "opensea_buyer_fee_basis_points": "0",
            "opensea_seller_fee_basis_points": "250",
            "payout_address": null,
            "require_email": false,
            "short_description": null,
            "slug": "irish-collection",
            "telegram_url": null,
            "twitter_username": null,
            "instagram_username": null,
            "wiki_url": null
        },
        {
            "primary_asset_contracts": [],
            "traits": {},
            "stats": {
                "seven_day_volume": 0,
                "total_volume": 0,
                "seven_day_change": 0,
                "seven_day_sales": 0,
                "total_sales": 0,
                "total_supply": 0,
                "count": 0,
                "num_owners": 0,
                "seven_day_average_price": 0,
                "average_price": 0,
                "num_reports": 0,
                "market_cap": 0
            },
            "banner_image_url": "https://lh3.googleusercontent.com/jnwDtvUHqw9q82ipzs2qLb5LZx_WafaU_ZhaaEQLAhSNNH90IRkOA3ZwJ_EdkZlfdIJV80aO-LEg3mzMkH-l_Q5OZ4oXKdcvjgc3=s2500",
            "chat_url": null,
            "created_date": "2021-05-25T21:37:05.301822",
            "default_to_fiat": false,
            "description": "A father expects his son to grow up and be a useful person. This picture also shows the sacrifice of a father. Happy fathers day’s",
            "dev_buyer_fee_basis_points": "0",
            "dev_seller_fee_basis_points": "10",
            "discord_url": null,
            "display_data": {
                "card_display_style": "contain"
            },
            "external_url": null,
            "featured": false,
            "featured_image_url": "https://lh3.googleusercontent.com/jnwDtvUHqw9q82ipzs2qLb5LZx_WafaU_ZhaaEQLAhSNNH90IRkOA3ZwJ_EdkZlfdIJV80aO-LEg3mzMkH-l_Q5OZ4oXKdcvjgc3=s300",
            "hidden": true,
            "safelist_request_status": "not_requested",
            "image_url": "https://lh3.googleusercontent.com/jnwDtvUHqw9q82ipzs2qLb5LZx_WafaU_ZhaaEQLAhSNNH90IRkOA3ZwJ_EdkZlfdIJV80aO-LEg3mzMkH-l_Q5OZ4oXKdcvjgc3=s120",
            "is_subject_to_whitelist": false,
            "large_image_url": "https://lh3.googleusercontent.com/jnwDtvUHqw9q82ipzs2qLb5LZx_WafaU_ZhaaEQLAhSNNH90IRkOA3ZwJ_EdkZlfdIJV80aO-LEg3mzMkH-l_Q5OZ4oXKdcvjgc3=s300",
            "medium_username": null,
            "name": "1992 Father",
            "only_proxied_transfers": false,
            "opensea_buyer_fee_basis_points": "0",
            "opensea_seller_fee_basis_points": "250",
            "payout_address": "0x8f6c63af669572e3c59a9a1129d1418e3f97254f",
            "require_email": false,
            "short_description": null,
            "slug": "1992-father",
            "telegram_url": "https://t.me/remizhafizie",
            "twitter_username": "remixxstunt",
            "instagram_username": "remixhafizie",
            "wiki_url": null
        },
        {
            "primary_asset_contracts": [],
            "traits": {},
            "stats": {
                "seven_day_volume": 0,
                "total_volume": 0,
                "seven_day_change": 0,
                "seven_day_sales": 0,
                "total_sales": 0,
                "total_supply": 0,
                "count": 0,
                "num_owners": 0,
                "seven_day_average_price": 0,
                "average_price": 0,
                "num_reports": 0,
                "market_cap": 0
            },
            "banner_image_url": "https://lh3.googleusercontent.com/kb3_VnTdb3Kh69oSdCZcCZA3ib0uWSVCmWzxuCKDtRH9bk4I_uLCoSpw1Ff0ItHKtIHB2csobVEc8-W-IN7ijbwYfAJD9FCweQSrcA=s2500",
            "chat_url": null,
            "created_date": "2021-05-25T21:36:47.720554",
            "default_to_fiat": false,
            "description": "EXCLUSIVE FOOTAGE FILMED AT ADRIAN'S KICKBACK.\nMAY 22, 2021. HUNTINGTON BEACH, CA.\n\nNO ILLEGAL ACTIVITY WAS PERFORMED BY ME AT THIS EVENT. \nI DID HOWEVER PUT A TAB OF ACID IN THE CARD SLOT OF MY CAMERA. THIS IS WHAT HE SAW.\nI DO NOT CONDONE THIS KIND OF ACTIVITY, HOWEVER AFTER REALIZING THAT SOCIAL MEDIA WAS BANNING PEOPLE'S POSTS ABOUT THE EVENT, I MADE IT A POINT TO DOCUMENT THE EVENT FIRST HAND. SO. MUCH. RAGE.\n\n\nShot in 4k on Black Magic Pocket Cinema Camera Pro.\nDesigned in Blender. Edited in Adobe After Effects and Premiere Pro.\nBy TrippyxCrypto.\n\nMore footage and editions to come. Welcome to the rage. Pandemics over.\n",
            "dev_buyer_fee_basis_points": "0",
            "dev_seller_fee_basis_points": "1000",
            "discord_url": null,
            "display_data": {
                "card_display_style": "contain"
            },
            "external_url": null,
            "featured": false,
            "featured_image_url": "https://lh3.googleusercontent.com/C0nPLhCoIxhXmcBY3iB68ddJOLMdqtUc8UBz-hJbVxtF6zymduDgV8geyflC2L6jKqTn4jx6sncywa2I5RB_nywrJNDs0b8BXm5Z6QQ=s300",
            "hidden": true,
            "safelist_request_status": "not_requested",
            "image_url": "https://lh3.googleusercontent.com/C0nPLhCoIxhXmcBY3iB68ddJOLMdqtUc8UBz-hJbVxtF6zymduDgV8geyflC2L6jKqTn4jx6sncywa2I5RB_nywrJNDs0b8BXm5Z6QQ=s120",
            "is_subject_to_whitelist": false,
            "large_image_url": "https://lh3.googleusercontent.com/C0nPLhCoIxhXmcBY3iB68ddJOLMdqtUc8UBz-hJbVxtF6zymduDgV8geyflC2L6jKqTn4jx6sncywa2I5RB_nywrJNDs0b8BXm5Z6QQ=s300",
            "medium_username": null,
            "name": "DUDE IM A DROID - ADRIAN'S KICKBACK / HUNTINGTON BEACH 2021",
            "only_proxied_transfers": false,
            "opensea_buyer_fee_basis_points": "0",
            "opensea_seller_fee_basis_points": "250",
            "payout_address": "0x4186abe7e9888cb2132021c6cee5e62a23681c4a",
            "require_email": false,
            "short_description": null,
            "slug": "dude-im-a-droid-adrian-s-kickback-huntington-beach",
            "telegram_url": null,
            "twitter_username": null,
            "instagram_username": null,
            "wiki_url": null
        },
        {
            "primary_asset_contracts": [],
            "traits": {},
            "stats": {
                "seven_day_volume": 0,
                "total_volume": 0,
                "seven_day_change": 0,
                "seven_day_sales": 0,
                "total_sales": 0,
                "total_supply": 0,
                "count": 0,
                "num_owners": 0,
                "seven_day_average_price": 0,
                "average_price": 0,
                "num_reports": 0,
                "market_cap": 0
            },
            "banner_image_url": "https://lh3.googleusercontent.com/FRt2cUvKGykIh4KYxx8my6iU914QIOfHCiEr_ujIeuz56JuQMxXOPNYUfpWfqXd7iGB3v2IcrpW-A5ppxkhNye63HpyHo82aLqjT-Q=s2500",
            "chat_url": null,
            "created_date": "2021-05-25T21:36:03.474386",
            "default_to_fiat": false,
            "description": "",
            "dev_buyer_fee_basis_points": "0",
            "dev_seller_fee_basis_points": "1000",
            "discord_url": "https://discord.gg/trigner9580",
            "display_data": {
                "card_display_style": "contain"
            },
            "external_url": "http://trigner.com",
            "featured": false,
            "featured_image_url": null,
            "hidden": true,
            "safelist_request_status": "not_requested",
            "image_url": "https://lh3.googleusercontent.com/2A9_qExoQy8Xge6hCD5LmAdR-ksYwqEVJhqeCvPyOuSYSgDqeG7BlAbLt2_zZz_anH746_uy3Jsoa76Ll6QfkER0d5YaD5F6qsPz=s120",
            "is_subject_to_whitelist": false,
            "large_image_url": null,
            "medium_username": "trigner",
            "name": "Petro",
            "only_proxied_transfers": false,
            "opensea_buyer_fee_basis_points": "0",
            "opensea_seller_fee_basis_points": "250",
            "payout_address": "0x7dff32e72a08f99669ac23372c07f2432fe27298",
            "require_email": false,
            "short_description": null,
            "slug": "petro",
            "telegram_url": null,
            "twitter_username": null,
            "instagram_username": null,
            "wiki_url": null
        },
        {
            "primary_asset_contracts": [],
            "traits": {},
            "stats": {
                "seven_day_volume": 0,
                "total_volume": 0,
                "seven_day_change": 0,
                "seven_day_sales": 0,
                "total_sales": 0,
                "total_supply": 0,
                "count": 0,
                "num_owners": 0,
                "seven_day_average_price": 0,
                "average_price": 0,
                "num_reports": 0,
                "market_cap": 0
            },
            "banner_image_url": "https://lh3.googleusercontent.com/FRt2cUvKGykIh4KYxx8my6iU914QIOfHCiEr_ujIeuz56JuQMxXOPNYUfpWfqXd7iGB3v2IcrpW-A5ppxkhNye63HpyHo82aLqjT-Q=s2500",
            "chat_url": null,
            "created_date": "2021-05-25T21:30:51.416745",
            "default_to_fiat": false,
            "description": "",
            "dev_buyer_fee_basis_points": "0",
            "dev_seller_fee_basis_points": "1000",
            "discord_url": "https://discord.gg/trigner9580",
            "display_data": {
                "card_display_style": "contain"
            },
            "external_url": "http://trigner.com",
            "featured": false,
            "featured_image_url": null,
            "hidden": true,
            "safelist_request_status": "not_requested",
            "image_url": "https://lh3.googleusercontent.com/2A9_qExoQy8Xge6hCD5LmAdR-ksYwqEVJhqeCvPyOuSYSgDqeG7BlAbLt2_zZz_anH746_uy3Jsoa76Ll6QfkER0d5YaD5F6qsPz=s120",
            "is_subject_to_whitelist": false,
            "large_image_url": null,
            "medium_username": "trigner",
            "name": "Adriano",
            "only_proxied_transfers": false,
            "opensea_buyer_fee_basis_points": "0",
            "opensea_seller_fee_basis_points": "250",
            "payout_address": "0x7dff32e72a08f99669ac23372c07f2432fe27298",
            "require_email": false,
            "short_description": null,
            "slug": "adriano",
            "telegram_url": null,
            "twitter_username": null,
            "instagram_username": null,
            "wiki_url": null
        },
        {
            "primary_asset_contracts": [],
            "traits": {},
            "stats": {
                "seven_day_volume": 0,
                "total_volume": 0,
                "seven_day_change": 0,
                "seven_day_sales": 0,
                "total_sales": 0,
                "total_supply": 0,
                "count": 0,
                "num_owners": 0,
                "seven_day_average_price": 0,
                "average_price": 0,
                "num_reports": 0,
                "market_cap": 0
            },
            "banner_image_url": "https://lh3.googleusercontent.com/PB389yh7YD3pCuzTKPeQDGKSuFsdpUzoGWk5KVV-xPqdhY_ZR1nzuYqtpSJB4P-M1s2y-ty9wYtbWvEcjJNFmzFl1oquelScBKTe=s2500",
            "chat_url": null,
            "created_date": "2021-05-25T21:30:43.932342",
            "default_to_fiat": false,
            "description": "A collection of my digital work. I've been having fun experimenting with 2D animation.\nAs a multidisciplinary artist, I use anything from one of my film cameras to many digital programs like after effects, photoshop, and more.",
            "dev_buyer_fee_basis_points": "0",
            "dev_seller_fee_basis_points": "1000",
            "discord_url": null,
            "display_data": {
                "card_display_style": "contain"
            },
            "external_url": null,
            "featured": false,
            "featured_image_url": "https://lh3.googleusercontent.com/PB389yh7YD3pCuzTKPeQDGKSuFsdpUzoGWk5KVV-xPqdhY_ZR1nzuYqtpSJB4P-M1s2y-ty9wYtbWvEcjJNFmzFl1oquelScBKTe=s300",
            "hidden": true,
            "safelist_request_status": "not_requested",
            "image_url": "https://lh3.googleusercontent.com/t-orIRlC1CDSjrbxv9vuKZ3am_exakxTK2X28Kz2IfWl_aZaJO_sWIDTAzzeHYIuT2qjZGDH02AGZh4_CkvYpeRdyaOsUcBx5dV5Kow=s120",
            "is_subject_to_whitelist": false,
            "large_image_url": "https://lh3.googleusercontent.com/PB389yh7YD3pCuzTKPeQDGKSuFsdpUzoGWk5KVV-xPqdhY_ZR1nzuYqtpSJB4P-M1s2y-ty9wYtbWvEcjJNFmzFl1oquelScBKTe=s300",
            "medium_username": null,
            "name": "Jordi Mora Digital",
            "only_proxied_transfers": false,
            "opensea_buyer_fee_basis_points": "0",
            "opensea_seller_fee_basis_points": "250",
            "payout_address": "0x35f2b7e795cfeac5606a3e658467834549e5f240",
            "require_email": false,
            "short_description": null,
            "slug": "jordi-mora-digital",
            "telegram_url": null,
            "twitter_username": "JordiMoraNFT",
            "instagram_username": "JordiMora.cr2",
            "wiki_url": null
        },
        {
            "primary_asset_contracts": [],
            "traits": {},
            "stats": {
                "seven_day_volume": 0,
                "total_volume": 0,
                "seven_day_change": 0,
                "seven_day_sales": 0,
                "total_sales": 0,
                "total_supply": 0,
                "count": 0,
                "num_owners": 0,
                "seven_day_average_price": 0,
                "average_price": 0,
                "num_reports": 0,
                "market_cap": 0
            },
            "banner_image_url": "https://lh3.googleusercontent.com/vMDuYNUEPcp_QrOkJXJiG9LUNO9vcQ24sTmklK6EQ6IbzLOekir-uH9O-gPFXEXPn1Q-DxNAxgiWTpX9RN00kOMQoavRkDdnoGoW=s2500",
            "chat_url": null,
            "created_date": "2021-05-25T21:30:03.251138",
            "default_to_fiat": false,
            "description": "Everyday moment caught ",
            "dev_buyer_fee_basis_points": "0",
            "dev_seller_fee_basis_points": "0",
            "discord_url": null,
            "display_data": {
                "card_display_style": "contain",
                "images": []
            },
            "external_url": null,
            "featured": false,
            "featured_image_url": null,
            "hidden": true,
            "safelist_request_status": "not_requested",
            "image_url": "https://lh3.googleusercontent.com/z5_DY-yLoArf-pGt8A88bQjNddo_ivyNoQsqPavtFF34XoE2vQ1L76tiMX7NQOzQ29w1BNzQEKsoB4OA-CCsi4ycg5VipNgKkR7Yxw=s120",
            "is_subject_to_whitelist": false,
            "large_image_url": null,
            "medium_username": null,
            "name": "Sunset Relaxation",
            "only_proxied_transfers": false,
            "opensea_buyer_fee_basis_points": "0",
            "opensea_seller_fee_basis_points": "250",
            "payout_address": null,
            "require_email": false,
            "short_description": null,
            "slug": "sunset-relaxation",
            "telegram_url": null,
            "twitter_username": null,
            "instagram_username": null,
            "wiki_url": null
        },
        {
            "primary_asset_contracts": [],
            "traits": {},
            "stats": {
                "seven_day_volume": 0,
                "total_volume": 0,
                "seven_day_change": 0,
                "seven_day_sales": 0,
                "total_sales": 0,
                "total_supply": 0,
                "count": 0,
                "num_owners": 0,
                "seven_day_average_price": 0,
                "average_price": 0,
                "num_reports": 0,
                "market_cap": 0
            },
            "banner_image_url": "https://lh3.googleusercontent.com/8a5gC23hnSUm9eXjcoN8y2SbWZqlEwHP20lAq9OdqlzEFzcGST8DBW6Cim-pGJnvQHdFOZliEzrW7R9ERadRNa9dY3GI-T25JQSb0DU=s2500",
            "chat_url": null,
            "created_date": "2021-05-25T21:29:45.336398",
            "default_to_fiat": false,
            "description": "The _Black Pepes_ is the name given to a limited collection of Rare Pepes created by Vitsnude Rex. \n\nThey portray intense, haunting themes, reflective of Pepe's fear of insanity and his bleak outlook on humanity.",
            "dev_buyer_fee_basis_points": "0",
            "dev_seller_fee_basis_points": "1000",
            "discord_url": null,
            "display_data": {
                "card_display_style": "cover"
            },
            "external_url": null,
            "featured": false,
            "featured_image_url": "https://lh3.googleusercontent.com/1v3mURFF0egwQgPK3mL2qEGz9kZ7aHPeEcKMAlOE-gdUalSOre7ezy2UocoyR4CQGBq6i5OXkAZf5L3KFAlud-HxHWNuUK_1DnLf=s300",
            "hidden": true,
            "safelist_request_status": "not_requested",
            "image_url": "https://lh3.googleusercontent.com/1v3mURFF0egwQgPK3mL2qEGz9kZ7aHPeEcKMAlOE-gdUalSOre7ezy2UocoyR4CQGBq6i5OXkAZf5L3KFAlud-HxHWNuUK_1DnLf=s120",
            "is_subject_to_whitelist": false,
            "large_image_url": "https://lh3.googleusercontent.com/1v3mURFF0egwQgPK3mL2qEGz9kZ7aHPeEcKMAlOE-gdUalSOre7ezy2UocoyR4CQGBq6i5OXkAZf5L3KFAlud-HxHWNuUK_1DnLf=s300",
            "medium_username": null,
            "name": "Black Pepes",
            "only_proxied_transfers": false,
            "opensea_buyer_fee_basis_points": "0",
            "opensea_seller_fee_basis_points": "250",
            "payout_address": "0x2b6c49568c9aa5d65d10505b768aa9818c318ac5",
            "require_email": false,
            "short_description": null,
            "slug": "black-pepe",
            "telegram_url": null,
            "twitter_username": null,
            "instagram_username": null,
            "wiki_url": null
        },
        {
            "primary_asset_contracts": [],
            "traits": {},
            "stats": {
                "seven_day_volume": 0,
                "total_volume": 0,
                "seven_day_change": 0,
                "seven_day_sales": 0,
                "total_sales": 0,
                "total_supply": 0,
                "count": 0,
                "num_owners": 0,
                "seven_day_average_price": 0,
                "average_price": 0,
                "num_reports": 0,
                "market_cap": 0
            },
            "banner_image_url": "https://lh3.googleusercontent.com/4FSwPq7_yqe9R6y0k9Qnt_FoRmIm4nKJdE-ZMqJQhqxCXMb4r9Kv3MsIGbFzeM2b1NUWrDYrOrte42YDOlGkJeHZHxUoon1fnj66=s2500",
            "chat_url": null,
            "created_date": "2021-05-25T21:29:32.196534",
            "default_to_fiat": false,
            "description": "Eat, Sleep, Dream about...\nNFTs & Crypto\nEnough said?",
            "dev_buyer_fee_basis_points": "0",
            "dev_seller_fee_basis_points": "10",
            "discord_url": null,
            "display_data": {
                "card_display_style": "contain"
            },
            "external_url": null,
            "featured": false,
            "featured_image_url": "https://lh3.googleusercontent.com/4FSwPq7_yqe9R6y0k9Qnt_FoRmIm4nKJdE-ZMqJQhqxCXMb4r9Kv3MsIGbFzeM2b1NUWrDYrOrte42YDOlGkJeHZHxUoon1fnj66=s300",
            "hidden": true,
            "safelist_request_status": "not_requested",
            "image_url": "https://lh3.googleusercontent.com/5oZq87Cb-x_gi-GvLFKyY1WBR7JcX5efik5bqflOjnV09STvgpVIpmB5v1w90t2CkxDNlfndDTDe3rsotQiHfYAAEE00SHDTSdFJPA=s120",
            "is_subject_to_whitelist": false,
            "large_image_url": "https://lh3.googleusercontent.com/4FSwPq7_yqe9R6y0k9Qnt_FoRmIm4nKJdE-ZMqJQhqxCXMb4r9Kv3MsIGbFzeM2b1NUWrDYrOrte42YDOlGkJeHZHxUoon1fnj66=s300",
            "medium_username": null,
            "name": "Crypto On My Mind",
            "only_proxied_transfers": false,
            "opensea_buyer_fee_basis_points": "0",
            "opensea_seller_fee_basis_points": "250",
            "payout_address": "0x2feb7702c846e822a00dea8e85ce2166c59c54f8",
            "require_email": false,
            "short_description": null,
            "slug": "crypto-on-my-mind",
            "telegram_url": null,
            "twitter_username": null,
            "instagram_username": null,
            "wiki_url": null
        },
        {
            "primary_asset_contracts": [],
            "traits": {},
            "stats": {
                "seven_day_volume": 0,
                "total_volume": 0,
                "seven_day_change": 0,
                "seven_day_sales": 0,
                "total_sales": 0,
                "total_supply": 0,
                "count": 0,
                "num_owners": 0,
                "seven_day_average_price": 0,
                "average_price": 0,
                "num_reports": 0,
                "market_cap": 0
            },
            "banner_image_url": "https://lh3.googleusercontent.com/FRt2cUvKGykIh4KYxx8my6iU914QIOfHCiEr_ujIeuz56JuQMxXOPNYUfpWfqXd7iGB3v2IcrpW-A5ppxkhNye63HpyHo82aLqjT-Q=s2500",
            "chat_url": null,
            "created_date": "2021-05-25T21:29:24.682070",
            "default_to_fiat": false,
            "description": "",
            "dev_buyer_fee_basis_points": "0",
            "dev_seller_fee_basis_points": "1000",
            "discord_url": "https://discord.gg/trigner9580",
            "display_data": {
                "card_display_style": "contain"
            },
            "external_url": "http://trigner.com",
            "featured": false,
            "featured_image_url": null,
            "hidden": true,
            "safelist_request_status": "not_requested",
            "image_url": "https://lh3.googleusercontent.com/2A9_qExoQy8Xge6hCD5LmAdR-ksYwqEVJhqeCvPyOuSYSgDqeG7BlAbLt2_zZz_anH746_uy3Jsoa76Ll6QfkER0d5YaD5F6qsPz=s120",
            "is_subject_to_whitelist": false,
            "large_image_url": null,
            "medium_username": "trigner",
            "name": "Alexandro",
            "only_proxied_transfers": false,
            "opensea_buyer_fee_basis_points": "0",
            "opensea_seller_fee_basis_points": "250",
            "payout_address": "0x7dff32e72a08f99669ac23372c07f2432fe27298",
            "require_email": false,
            "short_description": null,
            "slug": "alexandro",
            "telegram_url": null,
            "twitter_username": null,
            "instagram_username": null,
            "wiki_url": null
        },
        {
            "primary_asset_contracts": [],
            "traits": {},
            "stats": {
                "seven_day_volume": 0,
                "total_volume": 0,
                "seven_day_change": 0,
                "seven_day_sales": 0,
                "total_sales": 0,
                "total_supply": 0,
                "count": 0,
                "num_owners": 0,
                "seven_day_average_price": 0,
                "average_price": 0,
                "num_reports": 0,
                "market_cap": 0
            },
            "banner_image_url": "https://lh3.googleusercontent.com/PR8bxK9ZJgcFTCKvOeAJ2WhCheFHIfAEWte_mgHGlSRFshVwewR00-twuK1LdR8QRDMO9uUbZ1yxm1jjCJoP_8cJk67S0rZEpaiv=s2500",
            "chat_url": null,
            "created_date": "2021-05-25T21:28:27.502350",
            "default_to_fiat": false,
            "description": "Digital artist, hobbiest. Political and social reactions",
            "dev_buyer_fee_basis_points": "0",
            "dev_seller_fee_basis_points": "0",
            "discord_url": null,
            "display_data": {
                "card_display_style": "contain",
                "images": []
            },
            "external_url": null,
            "featured": false,
            "featured_image_url": null,
            "hidden": true,
            "safelist_request_status": "not_requested",
            "image_url": "https://lh3.googleusercontent.com/dLvKeB9MMeY5jqvsflYHF1ohTC-e_Ue5T6XkkAa0wSwAoa9hvXd2HJRdURCtpk_aQDxqU-86T6PvUefoRFUdAHQsL4Duv71cMzFWfg=s120",
            "is_subject_to_whitelist": false,
            "large_image_url": null,
            "medium_username": null,
            "name": "Peaceful Greek",
            "only_proxied_transfers": false,
            "opensea_buyer_fee_basis_points": "0",
            "opensea_seller_fee_basis_points": "250",
            "payout_address": null,
            "require_email": false,
            "short_description": null,
            "slug": "peaceful-greek",
            "telegram_url": null,
            "twitter_username": null,
            "instagram_username": null,
            "wiki_url": null
        },
        {
            "primary_asset_contracts": [],
            "traits": {},
            "stats": {
                "seven_day_volume": 0,
                "total_volume": 0,
                "seven_day_change": 0,
                "seven_day_sales": 0,
                "total_sales": 0,
                "total_supply": 0,
                "count": 0,
                "num_owners": 0,
                "seven_day_average_price": 0,
                "average_price": 0,
                "num_reports": 0,
                "market_cap": 0
            },
            "banner_image_url": "https://lh3.googleusercontent.com/FRt2cUvKGykIh4KYxx8my6iU914QIOfHCiEr_ujIeuz56JuQMxXOPNYUfpWfqXd7iGB3v2IcrpW-A5ppxkhNye63HpyHo82aLqjT-Q=s2500",
            "chat_url": null,
            "created_date": "2021-05-25T21:27:11.429877",
            "default_to_fiat": false,
            "description": "",
            "dev_buyer_fee_basis_points": "0",
            "dev_seller_fee_basis_points": "1000",
            "discord_url": "https://discord.gg/trigner9580",
            "display_data": {
                "card_display_style": "contain"
            },
            "external_url": "http://trigner.com",
            "featured": false,
            "featured_image_url": null,
            "hidden": true,
            "safelist_request_status": "not_requested",
            "image_url": "https://lh3.googleusercontent.com/2A9_qExoQy8Xge6hCD5LmAdR-ksYwqEVJhqeCvPyOuSYSgDqeG7BlAbLt2_zZz_anH746_uy3Jsoa76Ll6QfkER0d5YaD5F6qsPz=s120",
            "is_subject_to_whitelist": false,
            "large_image_url": null,
            "medium_username": "trigner",
            "name": "Andris",
            "only_proxied_transfers": false,
            "opensea_buyer_fee_basis_points": "0",
            "opensea_seller_fee_basis_points": "250",
            "payout_address": "0x7dff32e72a08f99669ac23372c07f2432fe27298",
            "require_email": false,
            "short_description": null,
            "slug": "andris",
            "telegram_url": null,
            "twitter_username": null,
            "instagram_username": null,
            "wiki_url": null
        },
        {
            "primary_asset_contracts": [],
            "traits": {},
            "stats": {
                "seven_day_volume": 0,
                "total_volume": 0,
                "seven_day_change": 0,
                "seven_day_sales": 0,
                "total_sales": 0,
                "total_supply": 0,
                "count": 0,
                "num_owners": 0,
                "seven_day_average_price": 0,
                "average_price": 0,
                "num_reports": 0,
                "market_cap": 0
            },
            "banner_image_url": "https://lh3.googleusercontent.com/XRYtWrReFBRsMp5euTZst5f5tT6LF4HNgBMwUHVsZxfgR8uG1geZyPGl8zsxkOpt3kUvY85908zEiRVNgpO8cI6zLdDiz-FHT1A3=s2500",
            "chat_url": null,
            "created_date": "2021-05-25T21:27:01.294940",
            "default_to_fiat": false,
            "description": "digital photography; Cradle of Light is an exploration into the figure \"0\" and the alchemical meaning behind a conscious void.",
            "dev_buyer_fee_basis_points": "0",
            "dev_seller_fee_basis_points": "1000",
            "discord_url": null,
            "display_data": {
                "card_display_style": "cover"
            },
            "external_url": null,
            "featured": false,
            "featured_image_url": "https://lh3.googleusercontent.com/pP2fTCL1B6MLfCIVH-cH9AgfQ993ktQGpRy9HwrHGBkkKnMnTImuQQzCPdiiMKwDbkMe_Ifw2JQmKrPBuvtvuorWxhRABD8E--RSnw=s300",
            "hidden": true,
            "safelist_request_status": "not_requested",
            "image_url": "https://lh3.googleusercontent.com/IYdl5dmjVlxMiE7RFQr7ZwnBq1cPSUKuS4_862y7FbLpwwmYqyMEgLzDa4-WKFpMPXJbC0MxOS1wjBbF90pTjGQaREnwkB47f_mHMQ=s120",
            "is_subject_to_whitelist": false,
            "large_image_url": "https://lh3.googleusercontent.com/pP2fTCL1B6MLfCIVH-cH9AgfQ993ktQGpRy9HwrHGBkkKnMnTImuQQzCPdiiMKwDbkMe_Ifw2JQmKrPBuvtvuorWxhRABD8E--RSnw=s300",
            "medium_username": null,
            "name": "cradle of light",
            "only_proxied_transfers": false,
            "opensea_buyer_fee_basis_points": "0",
            "opensea_seller_fee_basis_points": "250",
            "payout_address": "0x55009c6cc735ce2410c04774b7a478d61f4bbdde",
            "require_email": false,
            "short_description": null,
            "slug": "cradle-of-light",
            "telegram_url": null,
            "twitter_username": null,
            "instagram_username": "j.a.wo.od",
            "wiki_url": null
        },
        {
            "primary_asset_contracts": [],
            "traits": {},
            "stats": {
                "seven_day_volume": 0,
                "total_volume": 0,
                "seven_day_change": 0,
                "seven_day_sales": 0,
                "total_sales": 0,
                "total_supply": 0,
                "count": 0,
                "num_owners": 0,
                "seven_day_average_price": 0,
                "average_price": 0,
                "num_reports": 0,
                "market_cap": 0
            },
            "banner_image_url": "https://storage.opensea.io/files/69290ac16d1af645760ec4390549f4ad.svg",
            "chat_url": null,
            "created_date": "2021-05-25T21:25:12.979000",
            "default_to_fiat": false,
            "description": "",
            "dev_buyer_fee_basis_points": "0",
            "dev_seller_fee_basis_points": "0",
            "discord_url": null,
            "display_data": {
                "card_display_style": "contain"
            },
            "external_url": null,
            "featured": false,
            "featured_image_url": null,
            "hidden": true,
            "safelist_request_status": "not_requested",
            "image_url": "https://storage.opensea.io/files/6e8b13742fd2ef2d14313c5a1bf66f4b.svg",
            "is_subject_to_whitelist": false,
            "large_image_url": null,
            "medium_username": null,
            "name": "Kick drum collection",
            "only_proxied_transfers": false,
            "opensea_buyer_fee_basis_points": "0",
            "opensea_seller_fee_basis_points": "250",
            "payout_address": null,
            "require_email": false,
            "short_description": null,
            "slug": "kickdrumcollection",
            "telegram_url": null,
            "twitter_username": null,
            "instagram_username": null,
            "wiki_url": null
        },
        {
            "primary_asset_contracts": [],
            "traits": {},
            "stats": {
                "seven_day_volume": 0,
                "total_volume": 0,
                "seven_day_change": 0,
                "seven_day_sales": 0,
                "total_sales": 0,
                "total_supply": 0,
                "count": 0,
                "num_owners": 0,
                "seven_day_average_price": 0,
                "average_price": 0,
                "num_reports": 0,
                "market_cap": 0
            },
            "banner_image_url": "https://lh3.googleusercontent.com/S1NPWg3HB7PwVDkrvbOiKEAHdb_OIUsUWdKoRe_xLLLjcTPNwLKBculGzH8Ofp7Q1LW5CJQ1EunHw5P9x2ld1NWymJjFyJhNxTuUEn4=s2500",
            "chat_url": null,
            "created_date": "2021-05-25T21:24:34.776645",
            "default_to_fiat": false,
            "description": "This is photo graph clicked at very important time of this earth \nDuring dawn \nThis shows \nWith every rise there is a dawn \n😇😇",
            "dev_buyer_fee_basis_points": "0",
            "dev_seller_fee_basis_points": "0",
            "discord_url": null,
            "display_data": {
                "card_display_style": "contain",
                "images": []
            },
            "external_url": null,
            "featured": false,
            "featured_image_url": null,
            "hidden": true,
            "safelist_request_status": "not_requested",
            "image_url": "https://lh3.googleusercontent.com/21O_npM2ofmCLUGU3ATDbACKHsPUd70a37iPMMWMjTbK1RZHfprFs2WuZMZiOW34QvgoSSDjiqJXR4DzxUQqkyKJOv4uXIgy_U2yLg=s120",
            "is_subject_to_whitelist": false,
            "large_image_url": null,
            "medium_username": null,
            "name": "future is the new present",
            "only_proxied_transfers": false,
            "opensea_buyer_fee_basis_points": "0",
            "opensea_seller_fee_basis_points": "250",
            "payout_address": null,
            "require_email": false,
            "short_description": null,
            "slug": "future-is-the-new-present",
            "telegram_url": null,
            "twitter_username": null,
            "instagram_username": null,
            "wiki_url": null
        },
        {
            "primary_asset_contracts": [],
            "traits": {},
            "stats": {
                "seven_day_volume": 0,
                "total_volume": 0,
                "seven_day_change": 0,
                "seven_day_sales": 0,
                "total_sales": 0,
                "total_supply": 0,
                "count": 0,
                "num_owners": 0,
                "seven_day_average_price": 0,
                "average_price": 0,
                "num_reports": 0,
                "market_cap": 0
            },
            "banner_image_url": "https://lh3.googleusercontent.com/TfTmzBhmJ6u58avIbc-zr9bJfJdWGKx4zV2DEv_nGVWI1bE8EWwUYhm0lZhaqLDbuRyI5V3U8tYoglKip6SxxX4Zgff2JnO94TvW=s2500",
            "chat_url": null,
            "created_date": "2021-05-25T21:23:14.616404",
            "default_to_fiat": false,
            "description": "Each NFT video is a riddle. With each its own answer. ",
            "dev_buyer_fee_basis_points": "0",
            "dev_seller_fee_basis_points": "500",
            "discord_url": null,
            "display_data": {
                "card_display_style": "contain"
            },
            "external_url": null,
            "featured": false,
            "featured_image_url": "https://lh3.googleusercontent.com/a_K1dR9WchJb7YFDhKw1TjkfoE2blN7lnzAal5-a2hk6RIAVV5K_Z1euoBwu3KrMdm7msdq8YQkUlpMnYZrlW4QAvPMc_dNByEsNNA=s300",
            "hidden": true,
            "safelist_request_status": "not_requested",
            "image_url": "https://lh3.googleusercontent.com/3u4OlA_m69aMsqT4RBGS-Ugyk4wv6Z34FzBab7NLDMqZSUFHyZ345bhJ6m8kg7ayrpv7j0JxBB8HQ-rnUdF3pnP-BnRnP4x-AzlZrQ=s120",
            "is_subject_to_whitelist": false,
            "large_image_url": "https://lh3.googleusercontent.com/a_K1dR9WchJb7YFDhKw1TjkfoE2blN7lnzAal5-a2hk6RIAVV5K_Z1euoBwu3KrMdm7msdq8YQkUlpMnYZrlW4QAvPMc_dNByEsNNA=s300",
            "medium_username": null,
            "name": "NFT Riddles",
            "only_proxied_transfers": false,
            "opensea_buyer_fee_basis_points": "0",
            "opensea_seller_fee_basis_points": "250",
            "payout_address": "0x2de56fae554a13b08daea82447eaa4f2a4c7a988",
            "require_email": false,
            "short_description": null,
            "slug": "nft-riddles",
            "telegram_url": null,
            "twitter_username": null,
            "instagram_username": null,
            "wiki_url": null
        },
        {
            "primary_asset_contracts": [],
            "traits": {},
            "stats": {
                "seven_day_volume": 0,
                "total_volume": 0,
                "seven_day_change": 0,
                "seven_day_sales": 0,
                "total_sales": 0,
                "total_supply": 0,
                "count": 0,
                "num_owners": 0,
                "seven_day_average_price": 0,
                "average_price": 0,
                "num_reports": 0,
                "market_cap": 0
            },
            "banner_image_url": "https://lh3.googleusercontent.com/FRt2cUvKGykIh4KYxx8my6iU914QIOfHCiEr_ujIeuz56JuQMxXOPNYUfpWfqXd7iGB3v2IcrpW-A5ppxkhNye63HpyHo82aLqjT-Q=s2500",
            "chat_url": null,
            "created_date": "2021-05-25T21:23:05.213404",
            "default_to_fiat": false,
            "description": "",
            "dev_buyer_fee_basis_points": "0",
            "dev_seller_fee_basis_points": "1000",
            "discord_url": "https://discord.gg/trigner9580",
            "display_data": {
                "card_display_style": "contain"
            },
            "external_url": "http://trigner.com",
            "featured": false,
            "featured_image_url": null,
            "hidden": true,
            "safelist_request_status": "not_requested",
            "image_url": "https://lh3.googleusercontent.com/2A9_qExoQy8Xge6hCD5LmAdR-ksYwqEVJhqeCvPyOuSYSgDqeG7BlAbLt2_zZz_anH746_uy3Jsoa76Ll6QfkER0d5YaD5F6qsPz=s120",
            "is_subject_to_whitelist": false,
            "large_image_url": null,
            "medium_username": "trigner",
            "name": "Shirley",
            "only_proxied_transfers": false,
            "opensea_buyer_fee_basis_points": "0",
            "opensea_seller_fee_basis_points": "250",
            "payout_address": "0x7dff32e72a08f99669ac23372c07f2432fe27298",
            "require_email": false,
            "short_description": null,
            "slug": "shirley",
            "telegram_url": null,
            "twitter_username": null,
            "instagram_username": null,
            "wiki_url": null
        },
        {
            "primary_asset_contracts": [],
            "traits": {},
            "stats": {
                "seven_day_volume": 0,
                "total_volume": 0,
                "seven_day_change": 0,
                "seven_day_sales": 0,
                "total_sales": 0,
                "total_supply": 0,
                "count": 0,
                "num_owners": 0,
                "seven_day_average_price": 0,
                "average_price": 0,
                "num_reports": 0,
                "market_cap": 0
            },
            "banner_image_url": "https://lh3.googleusercontent.com/FRt2cUvKGykIh4KYxx8my6iU914QIOfHCiEr_ujIeuz56JuQMxXOPNYUfpWfqXd7iGB3v2IcrpW-A5ppxkhNye63HpyHo82aLqjT-Q=s2500",
            "chat_url": null,
            "created_date": "2021-05-25T21:20:59.355236",
            "default_to_fiat": false,
            "description": "",
            "dev_buyer_fee_basis_points": "0",
            "dev_seller_fee_basis_points": "1000",
            "discord_url": "https://discord.gg/trigner9580",
            "display_data": {
                "card_display_style": "contain"
            },
            "external_url": "http://trigner.com",
            "featured": false,
            "featured_image_url": null,
            "hidden": true,
            "safelist_request_status": "not_requested",
            "image_url": "https://lh3.googleusercontent.com/2A9_qExoQy8Xge6hCD5LmAdR-ksYwqEVJhqeCvPyOuSYSgDqeG7BlAbLt2_zZz_anH746_uy3Jsoa76Ll6QfkER0d5YaD5F6qsPz=s120",
            "is_subject_to_whitelist": false,
            "large_image_url": null,
            "medium_username": "trigner",
            "name": "Deborah",
            "only_proxied_transfers": false,
            "opensea_buyer_fee_basis_points": "0",
            "opensea_seller_fee_basis_points": "250",
            "payout_address": "0x7dff32e72a08f99669ac23372c07f2432fe27298",
            "require_email": false,
            "short_description": null,
            "slug": "deborah",
            "telegram_url": null,
            "twitter_username": null,
            "instagram_username": null,
            "wiki_url": null
        },
        {
            "primary_asset_contracts": [],
            "traits": {},
            "stats": {
                "seven_day_volume": 0,
                "total_volume": 0,
                "seven_day_change": 0,
                "seven_day_sales": 0,
                "total_sales": 0,
                "total_supply": 0,
                "count": 0,
                "num_owners": 0,
                "seven_day_average_price": 0,
                "average_price": 0,
                "num_reports": 0,
                "market_cap": 0
            },
            "banner_image_url": "https://lh3.googleusercontent.com/cGlsApQDgqdZu3Q6Y1B_-x1cfHxVXicdTPQdagGDhE3oEC5b6QOQHrLxHzdmHm1l7ytO9rEyAef__VlOY-MGMvPCmjkn-qmDGhFbHA=s2500",
            "chat_url": null,
            "created_date": "2021-05-25T21:20:38.248104",
            "default_to_fiat": false,
            "description": "Worthington Galleries® provides a wide range of fine art and collectibles in most categories and genres.  A portion of this collection is on display at several gallery locations, as well as on loan at several well-known galleries and museums. A portion of the Worthington collection can also be found on all of the major art platforms. Worthington works of art have been bought and sold at major auction houses throughout the world. ",
            "dev_buyer_fee_basis_points": "0",
            "dev_seller_fee_basis_points": "0",
            "discord_url": null,
            "display_data": {
                "card_display_style": "contain",
                "images": []
            },
            "external_url": null,
            "featured": false,
            "featured_image_url": null,
            "hidden": true,
            "safelist_request_status": "not_requested",
            "image_url": "https://lh3.googleusercontent.com/iboGxPmGYgNhQbPs-IB3YPLMz0QXLs1hrvumQHj6tKa5BQ6Kw0zEqpJnK8-pPXbW4oJFPIpG4Sn7fHXcZ9mqBmGps251n81Ah5iD=s120",
            "is_subject_to_whitelist": false,
            "large_image_url": null,
            "medium_username": null,
            "name": "Worthington Galleries",
            "only_proxied_transfers": false,
            "opensea_buyer_fee_basis_points": "0",
            "opensea_seller_fee_basis_points": "250",
            "payout_address": null,
            "require_email": false,
            "short_description": null,
            "slug": "worthington-galleries",
            "telegram_url": null,
            "twitter_username": null,
            "instagram_username": null,
            "wiki_url": null
        },
        {
            "primary_asset_contracts": [],
            "traits": {},
            "stats": {
                "seven_day_volume": 0,
                "total_volume": 0,
                "seven_day_change": 0,
                "seven_day_sales": 0,
                "total_sales": 0,
                "total_supply": 0,
                "count": 0,
                "num_owners": 0,
                "seven_day_average_price": 0,
                "average_price": 0,
                "num_reports": 0,
                "market_cap": 0
            },
            "banner_image_url": "https://lh3.googleusercontent.com/FRt2cUvKGykIh4KYxx8my6iU914QIOfHCiEr_ujIeuz56JuQMxXOPNYUfpWfqXd7iGB3v2IcrpW-A5ppxkhNye63HpyHo82aLqjT-Q=s2500",
            "chat_url": null,
            "created_date": "2021-05-25T21:19:52.335800",
            "default_to_fiat": false,
            "description": "",
            "dev_buyer_fee_basis_points": "0",
            "dev_seller_fee_basis_points": "1000",
            "discord_url": "https://discord.gg/trigner9580",
            "display_data": {
                "card_display_style": "contain"
            },
            "external_url": "http://trigner.com",
            "featured": false,
            "featured_image_url": null,
            "hidden": true,
            "safelist_request_status": "not_requested",
            "image_url": "https://lh3.googleusercontent.com/2A9_qExoQy8Xge6hCD5LmAdR-ksYwqEVJhqeCvPyOuSYSgDqeG7BlAbLt2_zZz_anH746_uy3Jsoa76Ll6QfkER0d5YaD5F6qsPz=s120",
            "is_subject_to_whitelist": false,
            "large_image_url": null,
            "medium_username": "trigner",
            "name": "Debra",
            "only_proxied_transfers": false,
            "opensea_buyer_fee_basis_points": "0",
            "opensea_seller_fee_basis_points": "250",
            "payout_address": "0x7dff32e72a08f99669ac23372c07f2432fe27298",
            "require_email": false,
            "short_description": null,
            "slug": "debra",
            "telegram_url": null,
            "twitter_username": null,
            "instagram_username": null,
            "wiki_url": null
        },
        {
            "primary_asset_contracts": [],
            "traits": {},
            "stats": {
                "seven_day_volume": 0,
                "total_volume": 0,
                "seven_day_change": 0,
                "seven_day_sales": 0,
                "total_sales": 0,
                "total_supply": 0,
                "count": 0,
                "num_owners": 0,
                "seven_day_average_price": 0,
                "average_price": 0,
                "num_reports": 0,
                "market_cap": 0
            },
            "banner_image_url": "https://lh3.googleusercontent.com/FRt2cUvKGykIh4KYxx8my6iU914QIOfHCiEr_ujIeuz56JuQMxXOPNYUfpWfqXd7iGB3v2IcrpW-A5ppxkhNye63HpyHo82aLqjT-Q=s2500",
            "chat_url": null,
            "created_date": "2021-05-25T21:11:17.590560",
            "default_to_fiat": false,
            "description": "",
            "dev_buyer_fee_basis_points": "0",
            "dev_seller_fee_basis_points": "1000",
            "discord_url": "https://discord.gg/trigner9580",
            "display_data": {
                "card_display_style": "contain"
            },
            "external_url": "http://trigner.com",
            "featured": false,
            "featured_image_url": null,
            "hidden": true,
            "safelist_request_status": "not_requested",
            "image_url": "https://lh3.googleusercontent.com/2A9_qExoQy8Xge6hCD5LmAdR-ksYwqEVJhqeCvPyOuSYSgDqeG7BlAbLt2_zZz_anH746_uy3Jsoa76Ll6QfkER0d5YaD5F6qsPz=s120",
            "is_subject_to_whitelist": false,
            "large_image_url": null,
            "medium_username": "trigner",
            "name": "Melissa",
            "only_proxied_transfers": false,
            "opensea_buyer_fee_basis_points": "0",
            "opensea_seller_fee_basis_points": "250",
            "payout_address": "0x7dff32e72a08f99669ac23372c07f2432fe27298",
            "require_email": false,
            "short_description": null,
            "slug": "melissa",
            "telegram_url": null,
            "twitter_username": null,
            "instagram_username": null,
            "wiki_url": null
        },
        {
            "primary_asset_contracts": [],
            "traits": {},
            "stats": {
                "seven_day_volume": 0,
                "total_volume": 0,
                "seven_day_change": 0,
                "seven_day_sales": 0,
                "total_sales": 0,
                "total_supply": 0,
                "count": 0,
                "num_owners": 0,
                "seven_day_average_price": 0,
                "average_price": 0,
                "num_reports": 0,
                "market_cap": 0
            },
            "banner_image_url": "https://lh3.googleusercontent.com/jdIeFnuYufOqRr9SxDyX9rru6nTL8rF0XUi1A8ETaTchJUfdooqJeakrjzpLXppxqzovnDI7XTwrJkZM52CEWJk82OohyIDs_10J7A=s2500",
            "chat_url": null,
            "created_date": "2021-05-25T21:10:10.238827",
            "default_to_fiat": false,
            "description": "Are we the last generation of humans? Is humanity merging incrementally with artificial intelligence? Are we being sucked into the abyss through our devices. Maybe the simulation hypothesis is real? Am I just a character in a game? Do we actually have free will or is this just humanitys destiny? The clock is ticking and the singularity is coming...",
            "dev_buyer_fee_basis_points": "0",
            "dev_seller_fee_basis_points": "0",
            "discord_url": null,
            "display_data": {
                "card_display_style": "contain"
            },
            "external_url": "https://tobysillence.com",
            "featured": false,
            "featured_image_url": null,
            "hidden": true,
            "safelist_request_status": "not_requested",
            "image_url": "https://lh3.googleusercontent.com/kGXV-aPZZzktsNOpYTsTq_jkD5ySeqVP9MjAQkwmxvcfX1ajuh_YAUe_-csE0xyOYsRYJKjweODGz4uF04O-UuJq3MJAQ7KjweMctQ=s120",
            "is_subject_to_whitelist": false,
            "large_image_url": null,
            "medium_username": null,
            "name": "Unfiltered Disruption",
            "only_proxied_transfers": false,
            "opensea_buyer_fee_basis_points": "0",
            "opensea_seller_fee_basis_points": "250",
            "payout_address": null,
            "require_email": false,
            "short_description": null,
            "slug": "unfiltered-disruption",
            "telegram_url": null,
            "twitter_username": "https://twitter.com/sillencetoby",
            "instagram_username": "https://www.instagram.com/tobysillence/",
            "wiki_url": null
        },
        {
            "primary_asset_contracts": [],
            "traits": {},
            "stats": {
                "seven_day_volume": 0,
                "total_volume": 0,
                "seven_day_change": 0,
                "seven_day_sales": 0,
                "total_sales": 0,
                "total_supply": 0,
                "count": 0,
                "num_owners": 0,
                "seven_day_average_price": 0,
                "average_price": 0,
                "num_reports": 0,
                "market_cap": 0
            },
            "banner_image_url": "https://lh3.googleusercontent.com/90HyKU8bBdDvOYegAaSBFfMDkRIRbquGiOaT-DZnwtpepBA6kCpqweApkr1fGpIFdpLVSkjzmpXFiwdTcBuVOB6si_pBuwKxEamBxA=s2500",
            "chat_url": null,
            "created_date": "2021-05-25T21:09:45.780453",
            "default_to_fiat": false,
            "description": "Graphical design of my photography, not my finest piece of art.",
            "dev_buyer_fee_basis_points": "0",
            "dev_seller_fee_basis_points": "0",
            "discord_url": null,
            "display_data": {
                "card_display_style": "contain",
                "images": []
            },
            "external_url": null,
            "featured": false,
            "featured_image_url": null,
            "hidden": true,
            "safelist_request_status": "not_requested",
            "image_url": "https://lh3.googleusercontent.com/90HyKU8bBdDvOYegAaSBFfMDkRIRbquGiOaT-DZnwtpepBA6kCpqweApkr1fGpIFdpLVSkjzmpXFiwdTcBuVOB6si_pBuwKxEamBxA=s120",
            "is_subject_to_whitelist": false,
            "large_image_url": null,
            "medium_username": null,
            "name": "C0L0UR!",
            "only_proxied_transfers": false,
            "opensea_buyer_fee_basis_points": "0",
            "opensea_seller_fee_basis_points": "250",
            "payout_address": null,
            "require_email": false,
            "short_description": null,
            "slug": "c0l0ur-2",
            "telegram_url": null,
            "twitter_username": null,
            "instagram_username": null,
            "wiki_url": null
        },
        {
            "primary_asset_contracts": [],
            "traits": {},
            "stats": {
                "seven_day_volume": 0,
                "total_volume": 0,
                "seven_day_change": 0,
                "seven_day_sales": 0,
                "total_sales": 0,
                "total_supply": 0,
                "count": 0,
                "num_owners": 0,
                "seven_day_average_price": 0,
                "average_price": 0,
                "num_reports": 0,
                "market_cap": 0
            },
            "banner_image_url": "https://lh3.googleusercontent.com/bgc4pIZ_ZTwS74FYVJEFVro4-ZoCYwk7cjz0tFhy6f8-qO7jyzvKMpe-cpWbyFsO2sMWM05JePF4eoqSjIeS_BcUVW2SYCEAqqnQ=s2500",
            "chat_url": null,
            "created_date": "2021-05-25T21:08:46.854844",
            "default_to_fiat": false,
            "description": "Collect Jah Version's exlusive and rare material.",
            "dev_buyer_fee_basis_points": "0",
            "dev_seller_fee_basis_points": "0",
            "discord_url": null,
            "display_data": {
                "card_display_style": "contain",
                "images": []
            },
            "external_url": null,
            "featured": false,
            "featured_image_url": null,
            "hidden": true,
            "safelist_request_status": "not_requested",
            "image_url": "https://lh3.googleusercontent.com/TdulsYubGAYq75KVRdm4FPneysiMZWnwo-IAzNDxg721uVoDlO61jyAifKIK-fp8HG4CdWCHbG3ziijyC5W7dlJ3tBSbZn4ldv7ksw=s120",
            "is_subject_to_whitelist": false,
            "large_image_url": null,
            "medium_username": null,
            "name": "JV Collectables",
            "only_proxied_transfers": false,
            "opensea_buyer_fee_basis_points": "0",
            "opensea_seller_fee_basis_points": "250",
            "payout_address": null,
            "require_email": false,
            "short_description": null,
            "slug": "jv-collectables",
            "telegram_url": null,
            "twitter_username": null,
            "instagram_username": null,
            "wiki_url": null
        },
        {
            "primary_asset_contracts": [],
            "traits": {},
            "stats": {
                "seven_day_volume": 0,
                "total_volume": 0,
                "seven_day_change": 0,
                "seven_day_sales": 0,
                "total_sales": 0,
                "total_supply": 0,
                "count": 0,
                "num_owners": 0,
                "seven_day_average_price": 0,
                "average_price": 0,
                "num_reports": 0,
                "market_cap": 0
            },
            "banner_image_url": "https://lh3.googleusercontent.com/1epy8DSBoTw-LV_MJJG5xFOiuMVf_5FV8UsHvBVeDxx6pC1bGmo0_LEdI0Qq0odkb1kP0cv46oBABF2atP2TiyoM6LWPMz5yznJ-=s2500",
            "chat_url": null,
            "created_date": "2021-05-25T21:04:44.813375",
            "default_to_fiat": false,
            "description": "snail in art collection ..... in all its essences",
            "dev_buyer_fee_basis_points": "0",
            "dev_seller_fee_basis_points": "100",
            "discord_url": null,
            "display_data": {
                "card_display_style": "contain"
            },
            "external_url": null,
            "featured": false,
            "featured_image_url": null,
            "hidden": true,
            "safelist_request_status": "not_requested",
            "image_url": "https://lh3.googleusercontent.com/G3AQwEe2ZQ6O4XB_hfES5VO--ZwoTDu-_dfsoi63aoSH4WtA3oVZjfF1cZFEV1ItGByRCJA__vUYpdeoddxYTgPifSLjGMkmfBTUBg=s120",
            "is_subject_to_whitelist": false,
            "large_image_url": null,
            "medium_username": null,
            "name": "green snail",
            "only_proxied_transfers": false,
            "opensea_buyer_fee_basis_points": "0",
            "opensea_seller_fee_basis_points": "250",
            "payout_address": "0x972f8b06489c07cee503b5a12e5b0be74e6eda41",
            "require_email": false,
            "short_description": null,
            "slug": "green-snail",
            "telegram_url": null,
            "twitter_username": null,
            "instagram_username": null,
            "wiki_url": null
        },
        {
            "primary_asset_contracts": [],
            "traits": {},
            "stats": {
                "seven_day_volume": 0,
                "total_volume": 0,
                "seven_day_change": 0,
                "seven_day_sales": 0,
                "total_sales": 0,
                "total_supply": 0,
                "count": 0,
                "num_owners": 0,
                "seven_day_average_price": 0,
                "average_price": 0,
                "num_reports": 0,
                "market_cap": 0
            },
            "banner_image_url": "https://lh3.googleusercontent.com/1aBVdv6qRDGNko5I5vitC4QMiodCqB7D9BSPISkDc_v_gukyXeru5oRbADl8W4WfDrPXayx2sfLKM4tzPwv5wZurCisCOHgmALmf8A=s2500",
            "chat_url": null,
            "created_date": "2021-05-25T21:04:06.517003",
            "default_to_fiat": false,
            "description": "Dutch artist Gert-jan Woudstra  created this.\n",
            "dev_buyer_fee_basis_points": "0",
            "dev_seller_fee_basis_points": "0",
            "discord_url": null,
            "display_data": {
                "card_display_style": "contain",
                "images": []
            },
            "external_url": null,
            "featured": false,
            "featured_image_url": null,
            "hidden": true,
            "safelist_request_status": "not_requested",
            "image_url": "https://lh3.googleusercontent.com/1aBVdv6qRDGNko5I5vitC4QMiodCqB7D9BSPISkDc_v_gukyXeru5oRbADl8W4WfDrPXayx2sfLKM4tzPwv5wZurCisCOHgmALmf8A=s120",
            "is_subject_to_whitelist": false,
            "large_image_url": null,
            "medium_username": null,
            "name": "my life is a mesh",
            "only_proxied_transfers": false,
            "opensea_buyer_fee_basis_points": "0",
            "opensea_seller_fee_basis_points": "250",
            "payout_address": null,
            "require_email": false,
            "short_description": null,
            "slug": "my-life-is-a-mesh",
            "telegram_url": null,
            "twitter_username": null,
            "instagram_username": null,
            "wiki_url": null
        }
    ];

    public static bundles = [
        {
            "maker": {
                "user": {
                    "username": "MiningHabit"
                },
                "profile_img_url": "https://storage.googleapis.com/opensea-static/opensea-profile/31.png",
                "address": "0x6b4331048c411795a89d54484e3653107d58a64e",
                "config": "",
                "discord_id": ""
            },
            "slug": "5-eggs-at-mkt-bottom-price-rPd",
            "assets": [
                {
                    "id": 22898168,
                    "token_id": "3757",
                    "num_sales": 0,
                    "background_color": null,
                    "image_url": "https://lh3.googleusercontent.com/OczK0hD5U7fiOg6nUWITdsG6lbhO80wIojGpzXkGUhZyTYldtfVjPV-8twXQjh1xJyPvUg84AqFOMMijGstUCB0diwwjWMqW7NJ_vms",
                    "image_preview_url": "https://lh3.googleusercontent.com/OczK0hD5U7fiOg6nUWITdsG6lbhO80wIojGpzXkGUhZyTYldtfVjPV-8twXQjh1xJyPvUg84AqFOMMijGstUCB0diwwjWMqW7NJ_vms=s250",
                    "image_thumbnail_url": "https://lh3.googleusercontent.com/OczK0hD5U7fiOg6nUWITdsG6lbhO80wIojGpzXkGUhZyTYldtfVjPV-8twXQjh1xJyPvUg84AqFOMMijGstUCB0diwwjWMqW7NJ_vms=s128",
                    "image_original_url": "https://arweave.net/n7GP4OtnaIWN3aEq-lRURANO88rdN2A_4zBWq5AQlko",
                    "animation_url": null,
                    "animation_original_url": null,
                    "name": "Genesis Egg #3757",
                    "description": "Apymon is a collection of 6400 creatures created by AI which are contained in procedurally designed eggs. What makes these Genesis Eggs special is that they can hold other NFTs, ERC20 and ERC1155 tokens, making them function as your personal vault. No two Apymon creatures or Genesis Eggs are the same, each one is unique and crafted with love.",
                    "external_link": "https://apymon.com",
                    "asset_contract": {
                        "address": "0x9c008a22d71b6182029b694b0311486e4c0e53db",
                        "asset_contract_type": "non-fungible",
                        "created_date": "2021-04-13T22:14:12.881973",
                        "name": "Apymon",
                        "nft_version": "3.0",
                        "opensea_version": null,
                        "owner": 30104721,
                        "schema_name": "ERC721",
                        "symbol": "APYMON",
                        "total_supply": "0",
                        "description": "Apymon is a collection of 6400 creatures created by AI which are contained in procedurally designed eggs. What makes these Genesis Eggs special is that they can hold other NFTs, ERC20 and ERC1155 tokens, making them function as your personal vault. No two Apymon creatures or  Genesis Eggs are the same, each one is unique and crafted with love.\nMint your Genesis Egg at https://apymon.com\nFollow our Twitter (https://twitter.com/ApymonOfficial) for the latest news and join our Discord (https://discord.gg/apymon) to chat with the community",
                        "external_link": "https://apymon.com/",
                        "image_url": "https://lh3.googleusercontent.com/8OogKrYF_3kTL3w_8J_TwEWTn6E4OS_SP5EVdeAJnw7GycEJJy36uZYkLKoMnrX-ObWNYlMpEIu5fGoRMtJrkL8HRnVz4gY8jrD2Cw=s120",
                        "default_to_fiat": false,
                        "dev_buyer_fee_basis_points": 0,
                        "dev_seller_fee_basis_points": 0,
                        "only_proxied_transfers": false,
                        "opensea_buyer_fee_basis_points": 0,
                        "opensea_seller_fee_basis_points": 250,
                        "buyer_fee_basis_points": 0,
                        "seller_fee_basis_points": 250,
                        "payout_address": null
                    },
                    "owner": {
                        "user": {
                            "username": "MiningHabit"
                        },
                        "profile_img_url": "https://storage.googleapis.com/opensea-static/opensea-profile/31.png",
                        "address": "0x6b4331048c411795a89d54484e3653107d58a64e",
                        "config": "",
                        "discord_id": ""
                    },
                    "permalink": "https://opensea.io/assets/0x9c008a22d71b6182029b694b0311486e4c0e53db/3757",
                    "collection": {
                        "banner_image_url": "https://lh3.googleusercontent.com/fdO2dxomM3FxkZiO7B8c-ie6Dj3VfhOlmYy-VgHsjkaFpjvfyd3a4wmglM9fLdpc4n9_s_bY_6MAzOmHacl5LApQ4agG4YEtCboMMd4=s2500",
                        "chat_url": null,
                        "created_date": "2021-04-13T23:45:21.662101",
                        "default_to_fiat": false,
                        "description": "Apymon is a collection of 6400 creatures created by AI which are contained in procedurally designed eggs. What makes these Genesis Eggs special is that they can hold other NFTs, ERC20 and ERC1155 tokens, making them function as your personal vault. No two Apymon creatures or  Genesis Eggs are the same, each one is unique and crafted with love.\nMint your Genesis Egg at https://apymon.com\nFollow our Twitter (https://twitter.com/ApymonOfficial) for the latest news and join our Discord (https://discord.gg/apymon) to chat with the community",
                        "dev_buyer_fee_basis_points": "0",
                        "dev_seller_fee_basis_points": "0",
                        "discord_url": "https://discord.gg/K2PQnsJR7h",
                        "display_data": {
                            "card_display_style": "contain"
                        },
                        "external_url": "https://apymon.com/",
                        "featured": false,
                        "featured_image_url": "https://lh3.googleusercontent.com/tr5SJmi42FEob8GHgBZj4CG1w-J_b2jK2TwjguvUrSZDWsTQDM9er-jdTfHnv7rfAbHy6wpkwOXVYz1HvS1M7u-QgkOj5rrv-jk8zw=s300",
                        "hidden": false,
                        "safelist_request_status": "approved",
                        "image_url": "https://lh3.googleusercontent.com/8OogKrYF_3kTL3w_8J_TwEWTn6E4OS_SP5EVdeAJnw7GycEJJy36uZYkLKoMnrX-ObWNYlMpEIu5fGoRMtJrkL8HRnVz4gY8jrD2Cw=s120",
                        "is_subject_to_whitelist": false,
                        "large_image_url": "https://lh3.googleusercontent.com/tr5SJmi42FEob8GHgBZj4CG1w-J_b2jK2TwjguvUrSZDWsTQDM9er-jdTfHnv7rfAbHy6wpkwOXVYz1HvS1M7u-QgkOj5rrv-jk8zw=s300",
                        "medium_username": "apymon",
                        "name": "Apymon",
                        "only_proxied_transfers": false,
                        "opensea_buyer_fee_basis_points": "0",
                        "opensea_seller_fee_basis_points": "250",
                        "payout_address": null,
                        "require_email": false,
                        "short_description": null,
                        "slug": "apymon",
                        "telegram_url": null,
                        "twitter_username": "ApymonOfficial",
                        "instagram_username": null,
                        "wiki_url": null
                    },
                    "decimals": 0,
                    "token_metadata": "https://gateway.pinata.cloud/ipfs/QmbbsQmfaoX41xKh2g3Ng563WMQ1BmeaQC2BnoaUkT7DHQ/3757"
                },
                {
                    "id": 22898172,
                    "token_id": "3758",
                    "num_sales": 0,
                    "background_color": null,
                    "image_url": "https://lh3.googleusercontent.com/uOhVQ6vfgSapj9oC2uQtIdM2b_8HD77n3m8sHAFHxj3pneVcPniZAI_YS6BtqcPPXNokfK3Dvizrw46xv4nvqV2WeFZTOx1R_nm3XFI",
                    "image_preview_url": "https://lh3.googleusercontent.com/uOhVQ6vfgSapj9oC2uQtIdM2b_8HD77n3m8sHAFHxj3pneVcPniZAI_YS6BtqcPPXNokfK3Dvizrw46xv4nvqV2WeFZTOx1R_nm3XFI=s250",
                    "image_thumbnail_url": "https://lh3.googleusercontent.com/uOhVQ6vfgSapj9oC2uQtIdM2b_8HD77n3m8sHAFHxj3pneVcPniZAI_YS6BtqcPPXNokfK3Dvizrw46xv4nvqV2WeFZTOx1R_nm3XFI=s128",
                    "image_original_url": "https://arweave.net/Zwb4xI0EXCStIKlK9TVRSVcOeZvfpDm7Xfy6nJyngpY",
                    "animation_url": null,
                    "animation_original_url": null,
                    "name": "Genesis Egg #3758",
                    "description": "Apymon is a collection of 6400 creatures created by AI which are contained in procedurally designed eggs. What makes these Genesis Eggs special is that they can hold other NFTs, ERC20 and ERC1155 tokens, making them function as your personal vault. No two Apymon creatures or Genesis Eggs are the same, each one is unique and crafted with love.",
                    "external_link": "https://apymon.com",
                    "asset_contract": {
                        "address": "0x9c008a22d71b6182029b694b0311486e4c0e53db",
                        "asset_contract_type": "non-fungible",
                        "created_date": "2021-04-13T22:14:12.881973",
                        "name": "Apymon",
                        "nft_version": "3.0",
                        "opensea_version": null,
                        "owner": 30104721,
                        "schema_name": "ERC721",
                        "symbol": "APYMON",
                        "total_supply": "0",
                        "description": "Apymon is a collection of 6400 creatures created by AI which are contained in procedurally designed eggs. What makes these Genesis Eggs special is that they can hold other NFTs, ERC20 and ERC1155 tokens, making them function as your personal vault. No two Apymon creatures or  Genesis Eggs are the same, each one is unique and crafted with love.\nMint your Genesis Egg at https://apymon.com\nFollow our Twitter (https://twitter.com/ApymonOfficial) for the latest news and join our Discord (https://discord.gg/apymon) to chat with the community",
                        "external_link": "https://apymon.com/",
                        "image_url": "https://lh3.googleusercontent.com/8OogKrYF_3kTL3w_8J_TwEWTn6E4OS_SP5EVdeAJnw7GycEJJy36uZYkLKoMnrX-ObWNYlMpEIu5fGoRMtJrkL8HRnVz4gY8jrD2Cw=s120",
                        "default_to_fiat": false,
                        "dev_buyer_fee_basis_points": 0,
                        "dev_seller_fee_basis_points": 0,
                        "only_proxied_transfers": false,
                        "opensea_buyer_fee_basis_points": 0,
                        "opensea_seller_fee_basis_points": 250,
                        "buyer_fee_basis_points": 0,
                        "seller_fee_basis_points": 250,
                        "payout_address": null
                    },
                    "owner": {
                        "user": {
                            "username": "MiningHabit"
                        },
                        "profile_img_url": "https://storage.googleapis.com/opensea-static/opensea-profile/31.png",
                        "address": "0x6b4331048c411795a89d54484e3653107d58a64e",
                        "config": "",
                        "discord_id": ""
                    },
                    "permalink": "https://opensea.io/assets/0x9c008a22d71b6182029b694b0311486e4c0e53db/3758",
                    "collection": {
                        "banner_image_url": "https://lh3.googleusercontent.com/fdO2dxomM3FxkZiO7B8c-ie6Dj3VfhOlmYy-VgHsjkaFpjvfyd3a4wmglM9fLdpc4n9_s_bY_6MAzOmHacl5LApQ4agG4YEtCboMMd4=s2500",
                        "chat_url": null,
                        "created_date": "2021-04-13T23:45:21.662101",
                        "default_to_fiat": false,
                        "description": "Apymon is a collection of 6400 creatures created by AI which are contained in procedurally designed eggs. What makes these Genesis Eggs special is that they can hold other NFTs, ERC20 and ERC1155 tokens, making them function as your personal vault. No two Apymon creatures or  Genesis Eggs are the same, each one is unique and crafted with love.\nMint your Genesis Egg at https://apymon.com\nFollow our Twitter (https://twitter.com/ApymonOfficial) for the latest news and join our Discord (https://discord.gg/apymon) to chat with the community",
                        "dev_buyer_fee_basis_points": "0",
                        "dev_seller_fee_basis_points": "0",
                        "discord_url": "https://discord.gg/K2PQnsJR7h",
                        "display_data": {
                            "card_display_style": "contain"
                        },
                        "external_url": "https://apymon.com/",
                        "featured": false,
                        "featured_image_url": "https://lh3.googleusercontent.com/tr5SJmi42FEob8GHgBZj4CG1w-J_b2jK2TwjguvUrSZDWsTQDM9er-jdTfHnv7rfAbHy6wpkwOXVYz1HvS1M7u-QgkOj5rrv-jk8zw=s300",
                        "hidden": false,
                        "safelist_request_status": "approved",
                        "image_url": "https://lh3.googleusercontent.com/8OogKrYF_3kTL3w_8J_TwEWTn6E4OS_SP5EVdeAJnw7GycEJJy36uZYkLKoMnrX-ObWNYlMpEIu5fGoRMtJrkL8HRnVz4gY8jrD2Cw=s120",
                        "is_subject_to_whitelist": false,
                        "large_image_url": "https://lh3.googleusercontent.com/tr5SJmi42FEob8GHgBZj4CG1w-J_b2jK2TwjguvUrSZDWsTQDM9er-jdTfHnv7rfAbHy6wpkwOXVYz1HvS1M7u-QgkOj5rrv-jk8zw=s300",
                        "medium_username": "apymon",
                        "name": "Apymon",
                        "only_proxied_transfers": false,
                        "opensea_buyer_fee_basis_points": "0",
                        "opensea_seller_fee_basis_points": "250",
                        "payout_address": null,
                        "require_email": false,
                        "short_description": null,
                        "slug": "apymon",
                        "telegram_url": null,
                        "twitter_username": "ApymonOfficial",
                        "instagram_username": null,
                        "wiki_url": null
                    },
                    "decimals": 0,
                    "token_metadata": "https://gateway.pinata.cloud/ipfs/QmbbsQmfaoX41xKh2g3Ng563WMQ1BmeaQC2BnoaUkT7DHQ/3758"
                },
                {
                    "id": 22898175,
                    "token_id": "3759",
                    "num_sales": 0,
                    "background_color": null,
                    "image_url": "https://lh3.googleusercontent.com/YchfmEY8E7l6O_iSfq9YMJE6sjM-kgAcoa2FqZjltX_sYUtTFVszbWJzPMihr3WHdWi_VU81Z-ZvxATFj79KjqYyEXd3Zklv0Tgq",
                    "image_preview_url": "https://lh3.googleusercontent.com/YchfmEY8E7l6O_iSfq9YMJE6sjM-kgAcoa2FqZjltX_sYUtTFVszbWJzPMihr3WHdWi_VU81Z-ZvxATFj79KjqYyEXd3Zklv0Tgq=s250",
                    "image_thumbnail_url": "https://lh3.googleusercontent.com/YchfmEY8E7l6O_iSfq9YMJE6sjM-kgAcoa2FqZjltX_sYUtTFVszbWJzPMihr3WHdWi_VU81Z-ZvxATFj79KjqYyEXd3Zklv0Tgq=s128",
                    "image_original_url": "https://arweave.net/sH6XzzGznckvp2nfT6H_CYZEZG26ZkKkRDbF660xPJ0",
                    "animation_url": null,
                    "animation_original_url": null,
                    "name": "Genesis Egg #3759",
                    "description": "Apymon is a collection of 6400 creatures created by AI which are contained in procedurally designed eggs. What makes these Genesis Eggs special is that they can hold other NFTs, ERC20 and ERC1155 tokens, making them function as your personal vault. No two Apymon creatures or Genesis Eggs are the same, each one is unique and crafted with love.",
                    "external_link": "https://apymon.com",
                    "asset_contract": {
                        "address": "0x9c008a22d71b6182029b694b0311486e4c0e53db",
                        "asset_contract_type": "non-fungible",
                        "created_date": "2021-04-13T22:14:12.881973",
                        "name": "Apymon",
                        "nft_version": "3.0",
                        "opensea_version": null,
                        "owner": 30104721,
                        "schema_name": "ERC721",
                        "symbol": "APYMON",
                        "total_supply": "0",
                        "description": "Apymon is a collection of 6400 creatures created by AI which are contained in procedurally designed eggs. What makes these Genesis Eggs special is that they can hold other NFTs, ERC20 and ERC1155 tokens, making them function as your personal vault. No two Apymon creatures or  Genesis Eggs are the same, each one is unique and crafted with love.\nMint your Genesis Egg at https://apymon.com\nFollow our Twitter (https://twitter.com/ApymonOfficial) for the latest news and join our Discord (https://discord.gg/apymon) to chat with the community",
                        "external_link": "https://apymon.com/",
                        "image_url": "https://lh3.googleusercontent.com/8OogKrYF_3kTL3w_8J_TwEWTn6E4OS_SP5EVdeAJnw7GycEJJy36uZYkLKoMnrX-ObWNYlMpEIu5fGoRMtJrkL8HRnVz4gY8jrD2Cw=s120",
                        "default_to_fiat": false,
                        "dev_buyer_fee_basis_points": 0,
                        "dev_seller_fee_basis_points": 0,
                        "only_proxied_transfers": false,
                        "opensea_buyer_fee_basis_points": 0,
                        "opensea_seller_fee_basis_points": 250,
                        "buyer_fee_basis_points": 0,
                        "seller_fee_basis_points": 250,
                        "payout_address": null
                    },
                    "owner": {
                        "user": {
                            "username": "MiningHabit"
                        },
                        "profile_img_url": "https://storage.googleapis.com/opensea-static/opensea-profile/31.png",
                        "address": "0x6b4331048c411795a89d54484e3653107d58a64e",
                        "config": "",
                        "discord_id": ""
                    },
                    "permalink": "https://opensea.io/assets/0x9c008a22d71b6182029b694b0311486e4c0e53db/3759",
                    "collection": {
                        "banner_image_url": "https://lh3.googleusercontent.com/fdO2dxomM3FxkZiO7B8c-ie6Dj3VfhOlmYy-VgHsjkaFpjvfyd3a4wmglM9fLdpc4n9_s_bY_6MAzOmHacl5LApQ4agG4YEtCboMMd4=s2500",
                        "chat_url": null,
                        "created_date": "2021-04-13T23:45:21.662101",
                        "default_to_fiat": false,
                        "description": "Apymon is a collection of 6400 creatures created by AI which are contained in procedurally designed eggs. What makes these Genesis Eggs special is that they can hold other NFTs, ERC20 and ERC1155 tokens, making them function as your personal vault. No two Apymon creatures or  Genesis Eggs are the same, each one is unique and crafted with love.\nMint your Genesis Egg at https://apymon.com\nFollow our Twitter (https://twitter.com/ApymonOfficial) for the latest news and join our Discord (https://discord.gg/apymon) to chat with the community",
                        "dev_buyer_fee_basis_points": "0",
                        "dev_seller_fee_basis_points": "0",
                        "discord_url": "https://discord.gg/K2PQnsJR7h",
                        "display_data": {
                            "card_display_style": "contain"
                        },
                        "external_url": "https://apymon.com/",
                        "featured": false,
                        "featured_image_url": "https://lh3.googleusercontent.com/tr5SJmi42FEob8GHgBZj4CG1w-J_b2jK2TwjguvUrSZDWsTQDM9er-jdTfHnv7rfAbHy6wpkwOXVYz1HvS1M7u-QgkOj5rrv-jk8zw=s300",
                        "hidden": false,
                        "safelist_request_status": "approved",
                        "image_url": "https://lh3.googleusercontent.com/8OogKrYF_3kTL3w_8J_TwEWTn6E4OS_SP5EVdeAJnw7GycEJJy36uZYkLKoMnrX-ObWNYlMpEIu5fGoRMtJrkL8HRnVz4gY8jrD2Cw=s120",
                        "is_subject_to_whitelist": false,
                        "large_image_url": "https://lh3.googleusercontent.com/tr5SJmi42FEob8GHgBZj4CG1w-J_b2jK2TwjguvUrSZDWsTQDM9er-jdTfHnv7rfAbHy6wpkwOXVYz1HvS1M7u-QgkOj5rrv-jk8zw=s300",
                        "medium_username": "apymon",
                        "name": "Apymon",
                        "only_proxied_transfers": false,
                        "opensea_buyer_fee_basis_points": "0",
                        "opensea_seller_fee_basis_points": "250",
                        "payout_address": null,
                        "require_email": false,
                        "short_description": null,
                        "slug": "apymon",
                        "telegram_url": null,
                        "twitter_username": "ApymonOfficial",
                        "instagram_username": null,
                        "wiki_url": null
                    },
                    "decimals": 0,
                    "token_metadata": "https://gateway.pinata.cloud/ipfs/QmbbsQmfaoX41xKh2g3Ng563WMQ1BmeaQC2BnoaUkT7DHQ/3759"
                },
                {
                    "id": 22898178,
                    "token_id": "3760",
                    "num_sales": 0,
                    "background_color": null,
                    "image_url": "https://lh3.googleusercontent.com/JxZt3Ew5TFpZjO90-MgyvbX-9BhoZGyGx0OXL_2a5cmq90RzpgIMiPNA7BXtml9dgjQxolWU0ju95ykQT3_1aRkb3z5ZZTJp9rsJ",
                    "image_preview_url": "https://lh3.googleusercontent.com/JxZt3Ew5TFpZjO90-MgyvbX-9BhoZGyGx0OXL_2a5cmq90RzpgIMiPNA7BXtml9dgjQxolWU0ju95ykQT3_1aRkb3z5ZZTJp9rsJ=s250",
                    "image_thumbnail_url": "https://lh3.googleusercontent.com/JxZt3Ew5TFpZjO90-MgyvbX-9BhoZGyGx0OXL_2a5cmq90RzpgIMiPNA7BXtml9dgjQxolWU0ju95ykQT3_1aRkb3z5ZZTJp9rsJ=s128",
                    "image_original_url": "https://arweave.net/m71uvmSlEWv0eTXgs9g3xjIjcvo1avXDSbHLPQJM-p8",
                    "animation_url": null,
                    "animation_original_url": null,
                    "name": "Genesis Egg #3760",
                    "description": "Apymon is a collection of 6400 creatures created by AI which are contained in procedurally designed eggs. What makes these Genesis Eggs special is that they can hold other NFTs, ERC20 and ERC1155 tokens, making them function as your personal vault. No two Apymon creatures or Genesis Eggs are the same, each one is unique and crafted with love.",
                    "external_link": "https://apymon.com",
                    "asset_contract": {
                        "address": "0x9c008a22d71b6182029b694b0311486e4c0e53db",
                        "asset_contract_type": "non-fungible",
                        "created_date": "2021-04-13T22:14:12.881973",
                        "name": "Apymon",
                        "nft_version": "3.0",
                        "opensea_version": null,
                        "owner": 30104721,
                        "schema_name": "ERC721",
                        "symbol": "APYMON",
                        "total_supply": "0",
                        "description": "Apymon is a collection of 6400 creatures created by AI which are contained in procedurally designed eggs. What makes these Genesis Eggs special is that they can hold other NFTs, ERC20 and ERC1155 tokens, making them function as your personal vault. No two Apymon creatures or  Genesis Eggs are the same, each one is unique and crafted with love.\nMint your Genesis Egg at https://apymon.com\nFollow our Twitter (https://twitter.com/ApymonOfficial) for the latest news and join our Discord (https://discord.gg/apymon) to chat with the community",
                        "external_link": "https://apymon.com/",
                        "image_url": "https://lh3.googleusercontent.com/8OogKrYF_3kTL3w_8J_TwEWTn6E4OS_SP5EVdeAJnw7GycEJJy36uZYkLKoMnrX-ObWNYlMpEIu5fGoRMtJrkL8HRnVz4gY8jrD2Cw=s120",
                        "default_to_fiat": false,
                        "dev_buyer_fee_basis_points": 0,
                        "dev_seller_fee_basis_points": 0,
                        "only_proxied_transfers": false,
                        "opensea_buyer_fee_basis_points": 0,
                        "opensea_seller_fee_basis_points": 250,
                        "buyer_fee_basis_points": 0,
                        "seller_fee_basis_points": 250,
                        "payout_address": null
                    },
                    "owner": {
                        "user": {
                            "username": "MiningHabit"
                        },
                        "profile_img_url": "https://storage.googleapis.com/opensea-static/opensea-profile/31.png",
                        "address": "0x6b4331048c411795a89d54484e3653107d58a64e",
                        "config": "",
                        "discord_id": ""
                    },
                    "permalink": "https://opensea.io/assets/0x9c008a22d71b6182029b694b0311486e4c0e53db/3760",
                    "collection": {
                        "banner_image_url": "https://lh3.googleusercontent.com/fdO2dxomM3FxkZiO7B8c-ie6Dj3VfhOlmYy-VgHsjkaFpjvfyd3a4wmglM9fLdpc4n9_s_bY_6MAzOmHacl5LApQ4agG4YEtCboMMd4=s2500",
                        "chat_url": null,
                        "created_date": "2021-04-13T23:45:21.662101",
                        "default_to_fiat": false,
                        "description": "Apymon is a collection of 6400 creatures created by AI which are contained in procedurally designed eggs. What makes these Genesis Eggs special is that they can hold other NFTs, ERC20 and ERC1155 tokens, making them function as your personal vault. No two Apymon creatures or  Genesis Eggs are the same, each one is unique and crafted with love.\nMint your Genesis Egg at https://apymon.com\nFollow our Twitter (https://twitter.com/ApymonOfficial) for the latest news and join our Discord (https://discord.gg/apymon) to chat with the community",
                        "dev_buyer_fee_basis_points": "0",
                        "dev_seller_fee_basis_points": "0",
                        "discord_url": "https://discord.gg/K2PQnsJR7h",
                        "display_data": {
                            "card_display_style": "contain"
                        },
                        "external_url": "https://apymon.com/",
                        "featured": false,
                        "featured_image_url": "https://lh3.googleusercontent.com/tr5SJmi42FEob8GHgBZj4CG1w-J_b2jK2TwjguvUrSZDWsTQDM9er-jdTfHnv7rfAbHy6wpkwOXVYz1HvS1M7u-QgkOj5rrv-jk8zw=s300",
                        "hidden": false,
                        "safelist_request_status": "approved",
                        "image_url": "https://lh3.googleusercontent.com/8OogKrYF_3kTL3w_8J_TwEWTn6E4OS_SP5EVdeAJnw7GycEJJy36uZYkLKoMnrX-ObWNYlMpEIu5fGoRMtJrkL8HRnVz4gY8jrD2Cw=s120",
                        "is_subject_to_whitelist": false,
                        "large_image_url": "https://lh3.googleusercontent.com/tr5SJmi42FEob8GHgBZj4CG1w-J_b2jK2TwjguvUrSZDWsTQDM9er-jdTfHnv7rfAbHy6wpkwOXVYz1HvS1M7u-QgkOj5rrv-jk8zw=s300",
                        "medium_username": "apymon",
                        "name": "Apymon",
                        "only_proxied_transfers": false,
                        "opensea_buyer_fee_basis_points": "0",
                        "opensea_seller_fee_basis_points": "250",
                        "payout_address": null,
                        "require_email": false,
                        "short_description": null,
                        "slug": "apymon",
                        "telegram_url": null,
                        "twitter_username": "ApymonOfficial",
                        "instagram_username": null,
                        "wiki_url": null
                    },
                    "decimals": 0,
                    "token_metadata": "https://gateway.pinata.cloud/ipfs/QmbbsQmfaoX41xKh2g3Ng563WMQ1BmeaQC2BnoaUkT7DHQ/3760"
                },
                {
                    "id": 22898181,
                    "token_id": "3761",
                    "num_sales": 0,
                    "background_color": null,
                    "image_url": "https://lh3.googleusercontent.com/Yga5ppHhRkzF6SLKrFInkk0nvx4JbUCTY6je3CAybG_Cyp_22mP02x2lUApabGyw6NO9ClBueSu4zGQl78R5LAM8k10MUGUAEkVU3I8",
                    "image_preview_url": "https://lh3.googleusercontent.com/Yga5ppHhRkzF6SLKrFInkk0nvx4JbUCTY6je3CAybG_Cyp_22mP02x2lUApabGyw6NO9ClBueSu4zGQl78R5LAM8k10MUGUAEkVU3I8=s250",
                    "image_thumbnail_url": "https://lh3.googleusercontent.com/Yga5ppHhRkzF6SLKrFInkk0nvx4JbUCTY6je3CAybG_Cyp_22mP02x2lUApabGyw6NO9ClBueSu4zGQl78R5LAM8k10MUGUAEkVU3I8=s128",
                    "image_original_url": "https://arweave.net/NKW53y8lMB48W6ayPNGr73bDwWcZX0xUDMbOb03wCl0",
                    "animation_url": null,
                    "animation_original_url": null,
                    "name": "Genesis Egg #3761",
                    "description": "Apymon is a collection of 6400 creatures created by AI which are contained in procedurally designed eggs. What makes these Genesis Eggs special is that they can hold other NFTs, ERC20 and ERC1155 tokens, making them function as your personal vault. No two Apymon creatures or Genesis Eggs are the same, each one is unique and crafted with love.",
                    "external_link": "https://apymon.com",
                    "asset_contract": {
                        "address": "0x9c008a22d71b6182029b694b0311486e4c0e53db",
                        "asset_contract_type": "non-fungible",
                        "created_date": "2021-04-13T22:14:12.881973",
                        "name": "Apymon",
                        "nft_version": "3.0",
                        "opensea_version": null,
                        "owner": 30104721,
                        "schema_name": "ERC721",
                        "symbol": "APYMON",
                        "total_supply": "0",
                        "description": "Apymon is a collection of 6400 creatures created by AI which are contained in procedurally designed eggs. What makes these Genesis Eggs special is that they can hold other NFTs, ERC20 and ERC1155 tokens, making them function as your personal vault. No two Apymon creatures or  Genesis Eggs are the same, each one is unique and crafted with love.\nMint your Genesis Egg at https://apymon.com\nFollow our Twitter (https://twitter.com/ApymonOfficial) for the latest news and join our Discord (https://discord.gg/apymon) to chat with the community",
                        "external_link": "https://apymon.com/",
                        "image_url": "https://lh3.googleusercontent.com/8OogKrYF_3kTL3w_8J_TwEWTn6E4OS_SP5EVdeAJnw7GycEJJy36uZYkLKoMnrX-ObWNYlMpEIu5fGoRMtJrkL8HRnVz4gY8jrD2Cw=s120",
                        "default_to_fiat": false,
                        "dev_buyer_fee_basis_points": 0,
                        "dev_seller_fee_basis_points": 0,
                        "only_proxied_transfers": false,
                        "opensea_buyer_fee_basis_points": 0,
                        "opensea_seller_fee_basis_points": 250,
                        "buyer_fee_basis_points": 0,
                        "seller_fee_basis_points": 250,
                        "payout_address": null
                    },
                    "owner": {
                        "user": {
                            "username": "MiningHabit"
                        },
                        "profile_img_url": "https://storage.googleapis.com/opensea-static/opensea-profile/31.png",
                        "address": "0x6b4331048c411795a89d54484e3653107d58a64e",
                        "config": "",
                        "discord_id": ""
                    },
                    "permalink": "https://opensea.io/assets/0x9c008a22d71b6182029b694b0311486e4c0e53db/3761",
                    "collection": {
                        "banner_image_url": "https://lh3.googleusercontent.com/fdO2dxomM3FxkZiO7B8c-ie6Dj3VfhOlmYy-VgHsjkaFpjvfyd3a4wmglM9fLdpc4n9_s_bY_6MAzOmHacl5LApQ4agG4YEtCboMMd4=s2500",
                        "chat_url": null,
                        "created_date": "2021-04-13T23:45:21.662101",
                        "default_to_fiat": false,
                        "description": "Apymon is a collection of 6400 creatures created by AI which are contained in procedurally designed eggs. What makes these Genesis Eggs special is that they can hold other NFTs, ERC20 and ERC1155 tokens, making them function as your personal vault. No two Apymon creatures or  Genesis Eggs are the same, each one is unique and crafted with love.\nMint your Genesis Egg at https://apymon.com\nFollow our Twitter (https://twitter.com/ApymonOfficial) for the latest news and join our Discord (https://discord.gg/apymon) to chat with the community",
                        "dev_buyer_fee_basis_points": "0",
                        "dev_seller_fee_basis_points": "0",
                        "discord_url": "https://discord.gg/K2PQnsJR7h",
                        "display_data": {
                            "card_display_style": "contain"
                        },
                        "external_url": "https://apymon.com/",
                        "featured": false,
                        "featured_image_url": "https://lh3.googleusercontent.com/tr5SJmi42FEob8GHgBZj4CG1w-J_b2jK2TwjguvUrSZDWsTQDM9er-jdTfHnv7rfAbHy6wpkwOXVYz1HvS1M7u-QgkOj5rrv-jk8zw=s300",
                        "hidden": false,
                        "safelist_request_status": "approved",
                        "image_url": "https://lh3.googleusercontent.com/8OogKrYF_3kTL3w_8J_TwEWTn6E4OS_SP5EVdeAJnw7GycEJJy36uZYkLKoMnrX-ObWNYlMpEIu5fGoRMtJrkL8HRnVz4gY8jrD2Cw=s120",
                        "is_subject_to_whitelist": false,
                        "large_image_url": "https://lh3.googleusercontent.com/tr5SJmi42FEob8GHgBZj4CG1w-J_b2jK2TwjguvUrSZDWsTQDM9er-jdTfHnv7rfAbHy6wpkwOXVYz1HvS1M7u-QgkOj5rrv-jk8zw=s300",
                        "medium_username": "apymon",
                        "name": "Apymon",
                        "only_proxied_transfers": false,
                        "opensea_buyer_fee_basis_points": "0",
                        "opensea_seller_fee_basis_points": "250",
                        "payout_address": null,
                        "require_email": false,
                        "short_description": null,
                        "slug": "apymon",
                        "telegram_url": null,
                        "twitter_username": "ApymonOfficial",
                        "instagram_username": null,
                        "wiki_url": null
                    },
                    "decimals": 0,
                    "token_metadata": "https://gateway.pinata.cloud/ipfs/QmbbsQmfaoX41xKh2g3Ng563WMQ1BmeaQC2BnoaUkT7DHQ/3761"
                },
                {
                    "id": 22898657,
                    "token_id": "3948",
                    "num_sales": 0,
                    "background_color": null,
                    "image_url": "https://lh3.googleusercontent.com/i6PchVCb6rN7A6E97BvrzlX03pGN-3EvzJ8QukhE9Wlq-Rsns-yJEQvrMPjBnwj0W9u1HVGQ-iktdm971wrM1xbsesDNfw_zIsQ4Ag",
                    "image_preview_url": "https://lh3.googleusercontent.com/i6PchVCb6rN7A6E97BvrzlX03pGN-3EvzJ8QukhE9Wlq-Rsns-yJEQvrMPjBnwj0W9u1HVGQ-iktdm971wrM1xbsesDNfw_zIsQ4Ag=s250",
                    "image_thumbnail_url": "https://lh3.googleusercontent.com/i6PchVCb6rN7A6E97BvrzlX03pGN-3EvzJ8QukhE9Wlq-Rsns-yJEQvrMPjBnwj0W9u1HVGQ-iktdm971wrM1xbsesDNfw_zIsQ4Ag=s128",
                    "image_original_url": "https://arweave.net/sFxjR0mawVSQNKyPdvvsUxt5FDn9jXIov2yPGU23fjo",
                    "animation_url": null,
                    "animation_original_url": null,
                    "name": "Genesis Egg #3948",
                    "description": "Apymon is a collection of 6400 creatures created by AI which are contained in procedurally designed eggs. What makes these Genesis Eggs special is that they can hold other NFTs, ERC20 and ERC1155 tokens, making them function as your personal vault. No two Apymon creatures or Genesis Eggs are the same, each one is unique and crafted with love.",
                    "external_link": "https://apymon.com",
                    "asset_contract": {
                        "address": "0x9c008a22d71b6182029b694b0311486e4c0e53db",
                        "asset_contract_type": "non-fungible",
                        "created_date": "2021-04-13T22:14:12.881973",
                        "name": "Apymon",
                        "nft_version": "3.0",
                        "opensea_version": null,
                        "owner": 30104721,
                        "schema_name": "ERC721",
                        "symbol": "APYMON",
                        "total_supply": "0",
                        "description": "Apymon is a collection of 6400 creatures created by AI which are contained in procedurally designed eggs. What makes these Genesis Eggs special is that they can hold other NFTs, ERC20 and ERC1155 tokens, making them function as your personal vault. No two Apymon creatures or  Genesis Eggs are the same, each one is unique and crafted with love.\nMint your Genesis Egg at https://apymon.com\nFollow our Twitter (https://twitter.com/ApymonOfficial) for the latest news and join our Discord (https://discord.gg/apymon) to chat with the community",
                        "external_link": "https://apymon.com/",
                        "image_url": "https://lh3.googleusercontent.com/8OogKrYF_3kTL3w_8J_TwEWTn6E4OS_SP5EVdeAJnw7GycEJJy36uZYkLKoMnrX-ObWNYlMpEIu5fGoRMtJrkL8HRnVz4gY8jrD2Cw=s120",
                        "default_to_fiat": false,
                        "dev_buyer_fee_basis_points": 0,
                        "dev_seller_fee_basis_points": 0,
                        "only_proxied_transfers": false,
                        "opensea_buyer_fee_basis_points": 0,
                        "opensea_seller_fee_basis_points": 250,
                        "buyer_fee_basis_points": 0,
                        "seller_fee_basis_points": 250,
                        "payout_address": null
                    },
                    "owner": {
                        "user": {
                            "username": "MiningHabit"
                        },
                        "profile_img_url": "https://storage.googleapis.com/opensea-static/opensea-profile/31.png",
                        "address": "0x6b4331048c411795a89d54484e3653107d58a64e",
                        "config": "",
                        "discord_id": ""
                    },
                    "permalink": "https://opensea.io/assets/0x9c008a22d71b6182029b694b0311486e4c0e53db/3948",
                    "collection": {
                        "banner_image_url": "https://lh3.googleusercontent.com/fdO2dxomM3FxkZiO7B8c-ie6Dj3VfhOlmYy-VgHsjkaFpjvfyd3a4wmglM9fLdpc4n9_s_bY_6MAzOmHacl5LApQ4agG4YEtCboMMd4=s2500",
                        "chat_url": null,
                        "created_date": "2021-04-13T23:45:21.662101",
                        "default_to_fiat": false,
                        "description": "Apymon is a collection of 6400 creatures created by AI which are contained in procedurally designed eggs. What makes these Genesis Eggs special is that they can hold other NFTs, ERC20 and ERC1155 tokens, making them function as your personal vault. No two Apymon creatures or  Genesis Eggs are the same, each one is unique and crafted with love.\nMint your Genesis Egg at https://apymon.com\nFollow our Twitter (https://twitter.com/ApymonOfficial) for the latest news and join our Discord (https://discord.gg/apymon) to chat with the community",
                        "dev_buyer_fee_basis_points": "0",
                        "dev_seller_fee_basis_points": "0",
                        "discord_url": "https://discord.gg/K2PQnsJR7h",
                        "display_data": {
                            "card_display_style": "contain"
                        },
                        "external_url": "https://apymon.com/",
                        "featured": false,
                        "featured_image_url": "https://lh3.googleusercontent.com/tr5SJmi42FEob8GHgBZj4CG1w-J_b2jK2TwjguvUrSZDWsTQDM9er-jdTfHnv7rfAbHy6wpkwOXVYz1HvS1M7u-QgkOj5rrv-jk8zw=s300",
                        "hidden": false,
                        "safelist_request_status": "approved",
                        "image_url": "https://lh3.googleusercontent.com/8OogKrYF_3kTL3w_8J_TwEWTn6E4OS_SP5EVdeAJnw7GycEJJy36uZYkLKoMnrX-ObWNYlMpEIu5fGoRMtJrkL8HRnVz4gY8jrD2Cw=s120",
                        "is_subject_to_whitelist": false,
                        "large_image_url": "https://lh3.googleusercontent.com/tr5SJmi42FEob8GHgBZj4CG1w-J_b2jK2TwjguvUrSZDWsTQDM9er-jdTfHnv7rfAbHy6wpkwOXVYz1HvS1M7u-QgkOj5rrv-jk8zw=s300",
                        "medium_username": "apymon",
                        "name": "Apymon",
                        "only_proxied_transfers": false,
                        "opensea_buyer_fee_basis_points": "0",
                        "opensea_seller_fee_basis_points": "250",
                        "payout_address": null,
                        "require_email": false,
                        "short_description": null,
                        "slug": "apymon",
                        "telegram_url": null,
                        "twitter_username": "ApymonOfficial",
                        "instagram_username": null,
                        "wiki_url": null
                    },
                    "decimals": 0,
                    "token_metadata": "https://gateway.pinata.cloud/ipfs/QmbbsQmfaoX41xKh2g3Ng563WMQ1BmeaQC2BnoaUkT7DHQ/3948"
                }
            ],
            "name": "5 Eggs at Mkt Bottom Price",
            "description": "",
            "external_link": "",
            "asset_contract": {
                "collection": {
                    "banner_image_url": "https://lh3.googleusercontent.com/fdO2dxomM3FxkZiO7B8c-ie6Dj3VfhOlmYy-VgHsjkaFpjvfyd3a4wmglM9fLdpc4n9_s_bY_6MAzOmHacl5LApQ4agG4YEtCboMMd4=s2500",
                    "chat_url": null,
                    "created_date": "2021-04-13T23:45:21.662101",
                    "default_to_fiat": false,
                    "description": "Apymon is a collection of 6400 creatures created by AI which are contained in procedurally designed eggs. What makes these Genesis Eggs special is that they can hold other NFTs, ERC20 and ERC1155 tokens, making them function as your personal vault. No two Apymon creatures or  Genesis Eggs are the same, each one is unique and crafted with love.\nMint your Genesis Egg at https://apymon.com\nFollow our Twitter (https://twitter.com/ApymonOfficial) for the latest news and join our Discord (https://discord.gg/apymon) to chat with the community",
                    "dev_buyer_fee_basis_points": "0",
                    "dev_seller_fee_basis_points": "0",
                    "discord_url": "https://discord.gg/K2PQnsJR7h",
                    "display_data": {
                        "card_display_style": "contain"
                    },
                    "external_url": "https://apymon.com/",
                    "featured": false,
                    "featured_image_url": "https://lh3.googleusercontent.com/tr5SJmi42FEob8GHgBZj4CG1w-J_b2jK2TwjguvUrSZDWsTQDM9er-jdTfHnv7rfAbHy6wpkwOXVYz1HvS1M7u-QgkOj5rrv-jk8zw=s300",
                    "hidden": false,
                    "safelist_request_status": "approved",
                    "image_url": "https://lh3.googleusercontent.com/8OogKrYF_3kTL3w_8J_TwEWTn6E4OS_SP5EVdeAJnw7GycEJJy36uZYkLKoMnrX-ObWNYlMpEIu5fGoRMtJrkL8HRnVz4gY8jrD2Cw=s120",
                    "is_subject_to_whitelist": false,
                    "large_image_url": "https://lh3.googleusercontent.com/tr5SJmi42FEob8GHgBZj4CG1w-J_b2jK2TwjguvUrSZDWsTQDM9er-jdTfHnv7rfAbHy6wpkwOXVYz1HvS1M7u-QgkOj5rrv-jk8zw=s300",
                    "medium_username": "apymon",
                    "name": "Apymon",
                    "only_proxied_transfers": false,
                    "opensea_buyer_fee_basis_points": "0",
                    "opensea_seller_fee_basis_points": "250",
                    "payout_address": null,
                    "require_email": false,
                    "short_description": null,
                    "slug": "apymon",
                    "telegram_url": null,
                    "twitter_username": "ApymonOfficial",
                    "instagram_username": null,
                    "wiki_url": null
                },
                "address": "0x9c008a22d71b6182029b694b0311486e4c0e53db",
                "asset_contract_type": "non-fungible",
                "created_date": "2021-04-13T22:14:12.881973",
                "name": "Apymon",
                "nft_version": "3.0",
                "opensea_version": null,
                "owner": 30104721,
                "schema_name": "ERC721",
                "symbol": "APYMON",
                "total_supply": "0",
                "description": "Apymon is a collection of 6400 creatures created by AI which are contained in procedurally designed eggs. What makes these Genesis Eggs special is that they can hold other NFTs, ERC20 and ERC1155 tokens, making them function as your personal vault. No two Apymon creatures or  Genesis Eggs are the same, each one is unique and crafted with love.\nMint your Genesis Egg at https://apymon.com\nFollow our Twitter (https://twitter.com/ApymonOfficial) for the latest news and join our Discord (https://discord.gg/apymon) to chat with the community",
                "external_link": "https://apymon.com/",
                "image_url": "https://lh3.googleusercontent.com/8OogKrYF_3kTL3w_8J_TwEWTn6E4OS_SP5EVdeAJnw7GycEJJy36uZYkLKoMnrX-ObWNYlMpEIu5fGoRMtJrkL8HRnVz4gY8jrD2Cw=s120",
                "default_to_fiat": false,
                "dev_buyer_fee_basis_points": 0,
                "dev_seller_fee_basis_points": 0,
                "only_proxied_transfers": false,
                "opensea_buyer_fee_basis_points": 0,
                "opensea_seller_fee_basis_points": 250,
                "buyer_fee_basis_points": 0,
                "seller_fee_basis_points": 250,
                "payout_address": null
            },
            "permalink": "https://opensea.io/bundles/5-eggs-at-mkt-bottom-price-rPd",
            "sell_orders": [
                {
                    "created_date": "2021-05-25T23:01:24.674911",
                    "closing_date": null,
                    "closing_extendable": false,
                    "expiration_time": 0,
                    "listing_time": 1621983561,
                    "order_hash": "0x9ff08f75cfa19f149934438377b7944aa5c42edd358623cab26b432bfba05152",
                    "metadata": {
                        "bundle": {
                            "assets": [
                                {
                                    "id": "3757",
                                    "address": "0x9c008a22d71b6182029b694b0311486e4c0e53db"
                                },
                                {
                                    "id": "3758",
                                    "address": "0x9c008a22d71b6182029b694b0311486e4c0e53db"
                                },
                                {
                                    "id": "3759",
                                    "address": "0x9c008a22d71b6182029b694b0311486e4c0e53db"
                                },
                                {
                                    "id": "3760",
                                    "address": "0x9c008a22d71b6182029b694b0311486e4c0e53db"
                                },
                                {
                                    "id": "3761",
                                    "address": "0x9c008a22d71b6182029b694b0311486e4c0e53db"
                                },
                                {
                                    "id": "3948",
                                    "address": "0x9c008a22d71b6182029b694b0311486e4c0e53db"
                                }
                            ],
                            "schemas": [
                                "ERC721",
                                "ERC721",
                                "ERC721",
                                "ERC721",
                                "ERC721",
                                "ERC721"
                            ],
                            "name": "5 Eggs at Mkt Bottom Price",
                            "description": "",
                            "external_link": ""
                        }
                    },
                    "exchange": "0x7be8076f4ea4a4ad08075c2508e481d6c946d12b",
                    "maker": {
                        "user": 550073,
                        "profile_img_url": "https://storage.googleapis.com/opensea-static/opensea-profile/31.png",
                        "address": "0x6b4331048c411795a89d54484e3653107d58a64e",
                        "config": "",
                        "discord_id": ""
                    },
                    "taker": {
                        "user": 1766,
                        "profile_img_url": "https://storage.googleapis.com/opensea-static/opensea-profile/1.png",
                        "address": "0x0000000000000000000000000000000000000000",
                        "config": "",
                        "discord_id": ""
                    },
                    "current_price": "299000000000000000",
                    "current_bounty": "2990000000000000",
                    "bounty_multiple": "0.01",
                    "maker_relayer_fee": "250",
                    "taker_relayer_fee": "0",
                    "maker_protocol_fee": "0",
                    "taker_protocol_fee": "0",
                    "maker_referrer_fee": "0",
                    "fee_recipient": {
                        "user": 3585,
                        "profile_img_url": "https://storage.googleapis.com/opensea-static/opensea-profile/28.png",
                        "address": "0x5b3256965e7c3cf26e11fcaf296dfc8807c01073",
                        "config": "verified",
                        "discord_id": ""
                    },
                    "fee_method": 1,
                    "side": 1,
                    "sale_kind": 0,
                    "target": "0xc99f70bfd82fb7c8f8191fdfbfb735606b15e5c5",
                    "how_to_call": 1,
                    "calldata": "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",
                    "replacement_pattern": "0x0000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000ffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffff0000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000ffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffff0000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000ffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffff0000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000ffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffff0000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000ffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffff0000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000ffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffff00000000000000000000000000000000000000000000000000000000000000000000000000000000",
                    "static_target": "0x0000000000000000000000000000000000000000",
                    "static_extradata": "0x",
                    "payment_token": "0x0000000000000000000000000000000000000000",
                    "payment_token_contract": {
                        "id": 1,
                        "symbol": "ETH",
                        "address": "0x0000000000000000000000000000000000000000",
                        "image_url": "https://storage.opensea.io/files/6f8e2979d428180222796ff4a33ab929.svg",
                        "name": "Ether",
                        "decimals": 18,
                        "eth_price": "1.000000000000000",
                        "usd_price": "2625.730000000000018000"
                    },
                    "base_price": "299000000000000000",
                    "extra": "0",
                    "quantity": "1",
                    "salt": "78670633769898862807983557743486287922800065557293707284257155503220666401422",
                    "v": 28,
                    "r": "0x32b5ac747e6326afefb211f8cd9ee13874649c374f78ff67fb57447e203de75d",
                    "s": "0x2a16dc5c6376f889101fcdabee016f0c81c59f82a4c2d2cdce00e37304283b72",
                    "approved_on_chain": false,
                    "cancelled": false,
                    "finalized": false,
                    "marked_invalid": false,
                    "prefixed_hash": "0x9bff380957ea1e85b43fc066648dac885ea90c082bb996f87153b32ca928bdff"
                }
            ]
        },
        {
            "maker": {
                "user": {
                    "username": null
                },
                "profile_img_url": "https://storage.googleapis.com/opensea-static/opensea-profile/15.png",
                "address": "0x40c839b831c90173dc7fbce49a25274a4688ddd9",
                "config": "",
                "discord_id": ""
            },
            "slug": "meebits-10x-fl7",
            "assets": [
                {
                    "id": 23304562,
                    "token_id": "12791",
                    "num_sales": 0,
                    "background_color": null,
                    "image_url": "https://lh3.googleusercontent.com/zgbmCPBNIuBaKu1IegZkp_Pd4jQavxS4Ze1aqeT2874bu5milDel5qbm55IZTK7kltWj8ITFT4y0f0vvCKut7VDs2vy53xg7r51ueA",
                    "image_preview_url": "https://lh3.googleusercontent.com/zgbmCPBNIuBaKu1IegZkp_Pd4jQavxS4Ze1aqeT2874bu5milDel5qbm55IZTK7kltWj8ITFT4y0f0vvCKut7VDs2vy53xg7r51ueA=s250",
                    "image_thumbnail_url": "https://lh3.googleusercontent.com/zgbmCPBNIuBaKu1IegZkp_Pd4jQavxS4Ze1aqeT2874bu5milDel5qbm55IZTK7kltWj8ITFT4y0f0vvCKut7VDs2vy53xg7r51ueA=s128",
                    "image_original_url": "http://meebits.larvalabs.com/meebitimages/characterimage?index=12791&type=full&imageType=jpg",
                    "animation_url": null,
                    "animation_original_url": null,
                    "name": "Meebit #12791",
                    "description": "Meebit #12791",
                    "external_link": null,
                    "asset_contract": {
                        "address": "0x7bd29408f11d2bfc23c34f18275bbf23bb716bc7",
                        "asset_contract_type": "non-fungible",
                        "created_date": "2021-05-03T01:32:40.414383",
                        "name": "Meebits",
                        "nft_version": "3.0",
                        "opensea_version": null,
                        "owner": null,
                        "schema_name": "ERC721",
                        "symbol": "⚇",
                        "total_supply": "1",
                        "description": "The Meebits are 20,000 unique 3D voxel characters, created by a custom generative algorithm, then registered on the Ethereum blockchain.",
                        "external_link": null,
                        "image_url": "https://lh3.googleusercontent.com/d784iHHbqQFVH1XYD6HoT4u3y_Fsu_9FZUltWjnOzoYv7qqB5dLUqpGyHBd8Gq3h4mykK5Enj8pxqOUorgD2PfIWcVj9ugvu8l0=s120",
                        "default_to_fiat": false,
                        "dev_buyer_fee_basis_points": 0,
                        "dev_seller_fee_basis_points": 0,
                        "only_proxied_transfers": false,
                        "opensea_buyer_fee_basis_points": 0,
                        "opensea_seller_fee_basis_points": 250,
                        "buyer_fee_basis_points": 0,
                        "seller_fee_basis_points": 250,
                        "payout_address": null
                    },
                    "owner": {
                        "user": {
                            "username": null
                        },
                        "profile_img_url": "https://storage.googleapis.com/opensea-static/opensea-profile/15.png",
                        "address": "0x40c839b831c90173dc7fbce49a25274a4688ddd9",
                        "config": "",
                        "discord_id": ""
                    },
                    "permalink": "https://opensea.io/assets/0x7bd29408f11d2bfc23c34f18275bbf23bb716bc7/12791",
                    "collection": {
                        "banner_image_url": "https://lh3.googleusercontent.com/qwnNTSRrf9CVq4LGawMcg7i2KZhD9I5LHA4uSNnB43-UAniBBgpNMSIz013HCKtrB9KFjrJUIRwpGbTzzNA4srJV39t3LnW3vaugmB8=s2500",
                        "chat_url": null,
                        "created_date": "2021-05-03T01:32:41.897161",
                        "default_to_fiat": false,
                        "description": "The Meebits are 20,000 unique 3D voxel characters, created by a custom generative algorithm, then registered on the Ethereum blockchain.",
                        "dev_buyer_fee_basis_points": "0",
                        "dev_seller_fee_basis_points": "0",
                        "discord_url": null,
                        "display_data": {
                            "card_display_style": "contain"
                        },
                        "external_url": null,
                        "featured": false,
                        "featured_image_url": null,
                        "hidden": false,
                        "safelist_request_status": "verified",
                        "image_url": "https://lh3.googleusercontent.com/d784iHHbqQFVH1XYD6HoT4u3y_Fsu_9FZUltWjnOzoYv7qqB5dLUqpGyHBd8Gq3h4mykK5Enj8pxqOUorgD2PfIWcVj9ugvu8l0=s120",
                        "is_subject_to_whitelist": false,
                        "large_image_url": null,
                        "medium_username": null,
                        "name": "Meebits",
                        "only_proxied_transfers": false,
                        "opensea_buyer_fee_basis_points": "0",
                        "opensea_seller_fee_basis_points": "250",
                        "payout_address": null,
                        "require_email": false,
                        "short_description": null,
                        "slug": "meebits",
                        "telegram_url": null,
                        "twitter_username": null,
                        "instagram_username": null,
                        "wiki_url": null
                    },
                    "decimals": 0,
                    "token_metadata": "https://meebits.larvalabs.com/meebit/12791"
                },
                {
                    "id": 23306161,
                    "token_id": "2291",
                    "num_sales": 0,
                    "background_color": null,
                    "image_url": "https://lh3.googleusercontent.com/XqtFwZlG8J1gHEm23HLoK9tNARtvhjm_-XEhG_D9cZSrFb4_ntH5Ad8X44L393IvhfeP5t50YySCDor-OqUzRZwVY4DgPODPe_VK",
                    "image_preview_url": "https://lh3.googleusercontent.com/XqtFwZlG8J1gHEm23HLoK9tNARtvhjm_-XEhG_D9cZSrFb4_ntH5Ad8X44L393IvhfeP5t50YySCDor-OqUzRZwVY4DgPODPe_VK=s250",
                    "image_thumbnail_url": "https://lh3.googleusercontent.com/XqtFwZlG8J1gHEm23HLoK9tNARtvhjm_-XEhG_D9cZSrFb4_ntH5Ad8X44L393IvhfeP5t50YySCDor-OqUzRZwVY4DgPODPe_VK=s128",
                    "image_original_url": "http://meebits.larvalabs.com/meebitimages/characterimage?index=2291&type=full&imageType=jpg",
                    "animation_url": null,
                    "animation_original_url": null,
                    "name": "Meebit #2291",
                    "description": "Meebit #2291",
                    "external_link": null,
                    "asset_contract": {
                        "address": "0x7bd29408f11d2bfc23c34f18275bbf23bb716bc7",
                        "asset_contract_type": "non-fungible",
                        "created_date": "2021-05-03T01:32:40.414383",
                        "name": "Meebits",
                        "nft_version": "3.0",
                        "opensea_version": null,
                        "owner": null,
                        "schema_name": "ERC721",
                        "symbol": "⚇",
                        "total_supply": "1",
                        "description": "The Meebits are 20,000 unique 3D voxel characters, created by a custom generative algorithm, then registered on the Ethereum blockchain.",
                        "external_link": null,
                        "image_url": "https://lh3.googleusercontent.com/d784iHHbqQFVH1XYD6HoT4u3y_Fsu_9FZUltWjnOzoYv7qqB5dLUqpGyHBd8Gq3h4mykK5Enj8pxqOUorgD2PfIWcVj9ugvu8l0=s120",
                        "default_to_fiat": false,
                        "dev_buyer_fee_basis_points": 0,
                        "dev_seller_fee_basis_points": 0,
                        "only_proxied_transfers": false,
                        "opensea_buyer_fee_basis_points": 0,
                        "opensea_seller_fee_basis_points": 250,
                        "buyer_fee_basis_points": 0,
                        "seller_fee_basis_points": 250,
                        "payout_address": null
                    },
                    "owner": {
                        "user": {
                            "username": null
                        },
                        "profile_img_url": "https://storage.googleapis.com/opensea-static/opensea-profile/15.png",
                        "address": "0x40c839b831c90173dc7fbce49a25274a4688ddd9",
                        "config": "",
                        "discord_id": ""
                    },
                    "permalink": "https://opensea.io/assets/0x7bd29408f11d2bfc23c34f18275bbf23bb716bc7/2291",
                    "collection": {
                        "banner_image_url": "https://lh3.googleusercontent.com/qwnNTSRrf9CVq4LGawMcg7i2KZhD9I5LHA4uSNnB43-UAniBBgpNMSIz013HCKtrB9KFjrJUIRwpGbTzzNA4srJV39t3LnW3vaugmB8=s2500",
                        "chat_url": null,
                        "created_date": "2021-05-03T01:32:41.897161",
                        "default_to_fiat": false,
                        "description": "The Meebits are 20,000 unique 3D voxel characters, created by a custom generative algorithm, then registered on the Ethereum blockchain.",
                        "dev_buyer_fee_basis_points": "0",
                        "dev_seller_fee_basis_points": "0",
                        "discord_url": null,
                        "display_data": {
                            "card_display_style": "contain"
                        },
                        "external_url": null,
                        "featured": false,
                        "featured_image_url": null,
                        "hidden": false,
                        "safelist_request_status": "verified",
                        "image_url": "https://lh3.googleusercontent.com/d784iHHbqQFVH1XYD6HoT4u3y_Fsu_9FZUltWjnOzoYv7qqB5dLUqpGyHBd8Gq3h4mykK5Enj8pxqOUorgD2PfIWcVj9ugvu8l0=s120",
                        "is_subject_to_whitelist": false,
                        "large_image_url": null,
                        "medium_username": null,
                        "name": "Meebits",
                        "only_proxied_transfers": false,
                        "opensea_buyer_fee_basis_points": "0",
                        "opensea_seller_fee_basis_points": "250",
                        "payout_address": null,
                        "require_email": false,
                        "short_description": null,
                        "slug": "meebits",
                        "telegram_url": null,
                        "twitter_username": null,
                        "instagram_username": null,
                        "wiki_url": null
                    },
                    "decimals": 0,
                    "token_metadata": "https://meebits.larvalabs.com/meebit/2291"
                },
                {
                    "id": 23306265,
                    "token_id": "17473",
                    "num_sales": 0,
                    "background_color": null,
                    "image_url": "https://lh3.googleusercontent.com/2hNYw1JyACTKTN8dHAyXoCq8FR02R-3OBi7l05js4GxXCUcfxdUJpmRO53_03yVS2o_cWtj4CX9j24bxu6u-F2DKLh41OU9NPtWi",
                    "image_preview_url": "https://lh3.googleusercontent.com/2hNYw1JyACTKTN8dHAyXoCq8FR02R-3OBi7l05js4GxXCUcfxdUJpmRO53_03yVS2o_cWtj4CX9j24bxu6u-F2DKLh41OU9NPtWi=s250",
                    "image_thumbnail_url": "https://lh3.googleusercontent.com/2hNYw1JyACTKTN8dHAyXoCq8FR02R-3OBi7l05js4GxXCUcfxdUJpmRO53_03yVS2o_cWtj4CX9j24bxu6u-F2DKLh41OU9NPtWi=s128",
                    "image_original_url": "http://meebits.larvalabs.com/meebitimages/characterimage?index=17473&type=full&imageType=jpg",
                    "animation_url": null,
                    "animation_original_url": null,
                    "name": "Meebit #17473",
                    "description": "Meebit #17473",
                    "external_link": null,
                    "asset_contract": {
                        "address": "0x7bd29408f11d2bfc23c34f18275bbf23bb716bc7",
                        "asset_contract_type": "non-fungible",
                        "created_date": "2021-05-03T01:32:40.414383",
                        "name": "Meebits",
                        "nft_version": "3.0",
                        "opensea_version": null,
                        "owner": null,
                        "schema_name": "ERC721",
                        "symbol": "⚇",
                        "total_supply": "1",
                        "description": "The Meebits are 20,000 unique 3D voxel characters, created by a custom generative algorithm, then registered on the Ethereum blockchain.",
                        "external_link": null,
                        "image_url": "https://lh3.googleusercontent.com/d784iHHbqQFVH1XYD6HoT4u3y_Fsu_9FZUltWjnOzoYv7qqB5dLUqpGyHBd8Gq3h4mykK5Enj8pxqOUorgD2PfIWcVj9ugvu8l0=s120",
                        "default_to_fiat": false,
                        "dev_buyer_fee_basis_points": 0,
                        "dev_seller_fee_basis_points": 0,
                        "only_proxied_transfers": false,
                        "opensea_buyer_fee_basis_points": 0,
                        "opensea_seller_fee_basis_points": 250,
                        "buyer_fee_basis_points": 0,
                        "seller_fee_basis_points": 250,
                        "payout_address": null
                    },
                    "owner": {
                        "user": {
                            "username": null
                        },
                        "profile_img_url": "https://storage.googleapis.com/opensea-static/opensea-profile/15.png",
                        "address": "0x40c839b831c90173dc7fbce49a25274a4688ddd9",
                        "config": "",
                        "discord_id": ""
                    },
                    "permalink": "https://opensea.io/assets/0x7bd29408f11d2bfc23c34f18275bbf23bb716bc7/17473",
                    "collection": {
                        "banner_image_url": "https://lh3.googleusercontent.com/qwnNTSRrf9CVq4LGawMcg7i2KZhD9I5LHA4uSNnB43-UAniBBgpNMSIz013HCKtrB9KFjrJUIRwpGbTzzNA4srJV39t3LnW3vaugmB8=s2500",
                        "chat_url": null,
                        "created_date": "2021-05-03T01:32:41.897161",
                        "default_to_fiat": false,
                        "description": "The Meebits are 20,000 unique 3D voxel characters, created by a custom generative algorithm, then registered on the Ethereum blockchain.",
                        "dev_buyer_fee_basis_points": "0",
                        "dev_seller_fee_basis_points": "0",
                        "discord_url": null,
                        "display_data": {
                            "card_display_style": "contain"
                        },
                        "external_url": null,
                        "featured": false,
                        "featured_image_url": null,
                        "hidden": false,
                        "safelist_request_status": "verified",
                        "image_url": "https://lh3.googleusercontent.com/d784iHHbqQFVH1XYD6HoT4u3y_Fsu_9FZUltWjnOzoYv7qqB5dLUqpGyHBd8Gq3h4mykK5Enj8pxqOUorgD2PfIWcVj9ugvu8l0=s120",
                        "is_subject_to_whitelist": false,
                        "large_image_url": null,
                        "medium_username": null,
                        "name": "Meebits",
                        "only_proxied_transfers": false,
                        "opensea_buyer_fee_basis_points": "0",
                        "opensea_seller_fee_basis_points": "250",
                        "payout_address": null,
                        "require_email": false,
                        "short_description": null,
                        "slug": "meebits",
                        "telegram_url": null,
                        "twitter_username": null,
                        "instagram_username": null,
                        "wiki_url": null
                    },
                    "decimals": 0,
                    "token_metadata": "https://meebits.larvalabs.com/meebit/17473"
                },
                {
                    "id": 23306890,
                    "token_id": "7463",
                    "num_sales": 0,
                    "background_color": null,
                    "image_url": "https://lh3.googleusercontent.com/uzQjep14gUExwcmTcrKAwg2ZDRV-w5sjeWfsyIJczQ_G42yygSLGRQhcjgi2CTdU3LOOp_JyGLwEuuxyhmqur0iyrcmMkxg5BC-etw",
                    "image_preview_url": "https://lh3.googleusercontent.com/uzQjep14gUExwcmTcrKAwg2ZDRV-w5sjeWfsyIJczQ_G42yygSLGRQhcjgi2CTdU3LOOp_JyGLwEuuxyhmqur0iyrcmMkxg5BC-etw=s250",
                    "image_thumbnail_url": "https://lh3.googleusercontent.com/uzQjep14gUExwcmTcrKAwg2ZDRV-w5sjeWfsyIJczQ_G42yygSLGRQhcjgi2CTdU3LOOp_JyGLwEuuxyhmqur0iyrcmMkxg5BC-etw=s128",
                    "image_original_url": "http://meebits.larvalabs.com/meebitimages/characterimage?index=7463&type=full&imageType=jpg",
                    "animation_url": null,
                    "animation_original_url": null,
                    "name": "Meebit #7463",
                    "description": "Meebit #7463",
                    "external_link": null,
                    "asset_contract": {
                        "address": "0x7bd29408f11d2bfc23c34f18275bbf23bb716bc7",
                        "asset_contract_type": "non-fungible",
                        "created_date": "2021-05-03T01:32:40.414383",
                        "name": "Meebits",
                        "nft_version": "3.0",
                        "opensea_version": null,
                        "owner": null,
                        "schema_name": "ERC721",
                        "symbol": "⚇",
                        "total_supply": "1",
                        "description": "The Meebits are 20,000 unique 3D voxel characters, created by a custom generative algorithm, then registered on the Ethereum blockchain.",
                        "external_link": null,
                        "image_url": "https://lh3.googleusercontent.com/d784iHHbqQFVH1XYD6HoT4u3y_Fsu_9FZUltWjnOzoYv7qqB5dLUqpGyHBd8Gq3h4mykK5Enj8pxqOUorgD2PfIWcVj9ugvu8l0=s120",
                        "default_to_fiat": false,
                        "dev_buyer_fee_basis_points": 0,
                        "dev_seller_fee_basis_points": 0,
                        "only_proxied_transfers": false,
                        "opensea_buyer_fee_basis_points": 0,
                        "opensea_seller_fee_basis_points": 250,
                        "buyer_fee_basis_points": 0,
                        "seller_fee_basis_points": 250,
                        "payout_address": null
                    },
                    "owner": {
                        "user": {
                            "username": null
                        },
                        "profile_img_url": "https://storage.googleapis.com/opensea-static/opensea-profile/15.png",
                        "address": "0x40c839b831c90173dc7fbce49a25274a4688ddd9",
                        "config": "",
                        "discord_id": ""
                    },
                    "permalink": "https://opensea.io/assets/0x7bd29408f11d2bfc23c34f18275bbf23bb716bc7/7463",
                    "collection": {
                        "banner_image_url": "https://lh3.googleusercontent.com/qwnNTSRrf9CVq4LGawMcg7i2KZhD9I5LHA4uSNnB43-UAniBBgpNMSIz013HCKtrB9KFjrJUIRwpGbTzzNA4srJV39t3LnW3vaugmB8=s2500",
                        "chat_url": null,
                        "created_date": "2021-05-03T01:32:41.897161",
                        "default_to_fiat": false,
                        "description": "The Meebits are 20,000 unique 3D voxel characters, created by a custom generative algorithm, then registered on the Ethereum blockchain.",
                        "dev_buyer_fee_basis_points": "0",
                        "dev_seller_fee_basis_points": "0",
                        "discord_url": null,
                        "display_data": {
                            "card_display_style": "contain"
                        },
                        "external_url": null,
                        "featured": false,
                        "featured_image_url": null,
                        "hidden": false,
                        "safelist_request_status": "verified",
                        "image_url": "https://lh3.googleusercontent.com/d784iHHbqQFVH1XYD6HoT4u3y_Fsu_9FZUltWjnOzoYv7qqB5dLUqpGyHBd8Gq3h4mykK5Enj8pxqOUorgD2PfIWcVj9ugvu8l0=s120",
                        "is_subject_to_whitelist": false,
                        "large_image_url": null,
                        "medium_username": null,
                        "name": "Meebits",
                        "only_proxied_transfers": false,
                        "opensea_buyer_fee_basis_points": "0",
                        "opensea_seller_fee_basis_points": "250",
                        "payout_address": null,
                        "require_email": false,
                        "short_description": null,
                        "slug": "meebits",
                        "telegram_url": null,
                        "twitter_username": null,
                        "instagram_username": null,
                        "wiki_url": null
                    },
                    "decimals": 0,
                    "token_metadata": "https://meebits.larvalabs.com/meebit/7463"
                },
                {
                    "id": 23308434,
                    "token_id": "2324",
                    "num_sales": 0,
                    "background_color": null,
                    "image_url": "https://lh3.googleusercontent.com/S6sGWAEUgNUnwf33lGDg0koFTNO-V0NDOSsO8luODK3ZhZ9ccRGf6rHP_kj1R1gzEuoV0yufiS8TaIAW7g8J4k9LaNXXOI_Xs-mYfg",
                    "image_preview_url": "https://lh3.googleusercontent.com/S6sGWAEUgNUnwf33lGDg0koFTNO-V0NDOSsO8luODK3ZhZ9ccRGf6rHP_kj1R1gzEuoV0yufiS8TaIAW7g8J4k9LaNXXOI_Xs-mYfg=s250",
                    "image_thumbnail_url": "https://lh3.googleusercontent.com/S6sGWAEUgNUnwf33lGDg0koFTNO-V0NDOSsO8luODK3ZhZ9ccRGf6rHP_kj1R1gzEuoV0yufiS8TaIAW7g8J4k9LaNXXOI_Xs-mYfg=s128",
                    "image_original_url": "http://meebits.larvalabs.com/meebitimages/characterimage?index=2324&type=full&imageType=jpg",
                    "animation_url": null,
                    "animation_original_url": null,
                    "name": "Meebit #2324",
                    "description": "Meebit #2324",
                    "external_link": null,
                    "asset_contract": {
                        "address": "0x7bd29408f11d2bfc23c34f18275bbf23bb716bc7",
                        "asset_contract_type": "non-fungible",
                        "created_date": "2021-05-03T01:32:40.414383",
                        "name": "Meebits",
                        "nft_version": "3.0",
                        "opensea_version": null,
                        "owner": null,
                        "schema_name": "ERC721",
                        "symbol": "⚇",
                        "total_supply": "1",
                        "description": "The Meebits are 20,000 unique 3D voxel characters, created by a custom generative algorithm, then registered on the Ethereum blockchain.",
                        "external_link": null,
                        "image_url": "https://lh3.googleusercontent.com/d784iHHbqQFVH1XYD6HoT4u3y_Fsu_9FZUltWjnOzoYv7qqB5dLUqpGyHBd8Gq3h4mykK5Enj8pxqOUorgD2PfIWcVj9ugvu8l0=s120",
                        "default_to_fiat": false,
                        "dev_buyer_fee_basis_points": 0,
                        "dev_seller_fee_basis_points": 0,
                        "only_proxied_transfers": false,
                        "opensea_buyer_fee_basis_points": 0,
                        "opensea_seller_fee_basis_points": 250,
                        "buyer_fee_basis_points": 0,
                        "seller_fee_basis_points": 250,
                        "payout_address": null
                    },
                    "owner": {
                        "user": {
                            "username": null
                        },
                        "profile_img_url": "https://storage.googleapis.com/opensea-static/opensea-profile/15.png",
                        "address": "0x40c839b831c90173dc7fbce49a25274a4688ddd9",
                        "config": "",
                        "discord_id": ""
                    },
                    "permalink": "https://opensea.io/assets/0x7bd29408f11d2bfc23c34f18275bbf23bb716bc7/2324",
                    "collection": {
                        "banner_image_url": "https://lh3.googleusercontent.com/qwnNTSRrf9CVq4LGawMcg7i2KZhD9I5LHA4uSNnB43-UAniBBgpNMSIz013HCKtrB9KFjrJUIRwpGbTzzNA4srJV39t3LnW3vaugmB8=s2500",
                        "chat_url": null,
                        "created_date": "2021-05-03T01:32:41.897161",
                        "default_to_fiat": false,
                        "description": "The Meebits are 20,000 unique 3D voxel characters, created by a custom generative algorithm, then registered on the Ethereum blockchain.",
                        "dev_buyer_fee_basis_points": "0",
                        "dev_seller_fee_basis_points": "0",
                        "discord_url": null,
                        "display_data": {
                            "card_display_style": "contain"
                        },
                        "external_url": null,
                        "featured": false,
                        "featured_image_url": null,
                        "hidden": false,
                        "safelist_request_status": "verified",
                        "image_url": "https://lh3.googleusercontent.com/d784iHHbqQFVH1XYD6HoT4u3y_Fsu_9FZUltWjnOzoYv7qqB5dLUqpGyHBd8Gq3h4mykK5Enj8pxqOUorgD2PfIWcVj9ugvu8l0=s120",
                        "is_subject_to_whitelist": false,
                        "large_image_url": null,
                        "medium_username": null,
                        "name": "Meebits",
                        "only_proxied_transfers": false,
                        "opensea_buyer_fee_basis_points": "0",
                        "opensea_seller_fee_basis_points": "250",
                        "payout_address": null,
                        "require_email": false,
                        "short_description": null,
                        "slug": "meebits",
                        "telegram_url": null,
                        "twitter_username": null,
                        "instagram_username": null,
                        "wiki_url": null
                    },
                    "decimals": 0,
                    "token_metadata": "https://meebits.larvalabs.com/meebit/2324"
                },
                {
                    "id": 23310477,
                    "token_id": "10635",
                    "num_sales": 0,
                    "background_color": null,
                    "image_url": "https://lh3.googleusercontent.com/WWVoRHVlD5kj9Pz0GsipLryxyBfxyUFc8vYESeQLjv05-Li4GsjiN-e7OkzyRLUJRgvMsH3AO694LSoqmVexOobLNIwIHfJk8xsckCA",
                    "image_preview_url": "https://lh3.googleusercontent.com/WWVoRHVlD5kj9Pz0GsipLryxyBfxyUFc8vYESeQLjv05-Li4GsjiN-e7OkzyRLUJRgvMsH3AO694LSoqmVexOobLNIwIHfJk8xsckCA=s250",
                    "image_thumbnail_url": "https://lh3.googleusercontent.com/WWVoRHVlD5kj9Pz0GsipLryxyBfxyUFc8vYESeQLjv05-Li4GsjiN-e7OkzyRLUJRgvMsH3AO694LSoqmVexOobLNIwIHfJk8xsckCA=s128",
                    "image_original_url": "http://meebits.larvalabs.com/meebitimages/characterimage?index=10635&type=full&imageType=jpg",
                    "animation_url": null,
                    "animation_original_url": null,
                    "name": "Meebit #10635",
                    "description": "Meebit #10635",
                    "external_link": null,
                    "asset_contract": {
                        "address": "0x7bd29408f11d2bfc23c34f18275bbf23bb716bc7",
                        "asset_contract_type": "non-fungible",
                        "created_date": "2021-05-03T01:32:40.414383",
                        "name": "Meebits",
                        "nft_version": "3.0",
                        "opensea_version": null,
                        "owner": null,
                        "schema_name": "ERC721",
                        "symbol": "⚇",
                        "total_supply": "1",
                        "description": "The Meebits are 20,000 unique 3D voxel characters, created by a custom generative algorithm, then registered on the Ethereum blockchain.",
                        "external_link": null,
                        "image_url": "https://lh3.googleusercontent.com/d784iHHbqQFVH1XYD6HoT4u3y_Fsu_9FZUltWjnOzoYv7qqB5dLUqpGyHBd8Gq3h4mykK5Enj8pxqOUorgD2PfIWcVj9ugvu8l0=s120",
                        "default_to_fiat": false,
                        "dev_buyer_fee_basis_points": 0,
                        "dev_seller_fee_basis_points": 0,
                        "only_proxied_transfers": false,
                        "opensea_buyer_fee_basis_points": 0,
                        "opensea_seller_fee_basis_points": 250,
                        "buyer_fee_basis_points": 0,
                        "seller_fee_basis_points": 250,
                        "payout_address": null
                    },
                    "owner": {
                        "user": {
                            "username": null
                        },
                        "profile_img_url": "https://storage.googleapis.com/opensea-static/opensea-profile/15.png",
                        "address": "0x40c839b831c90173dc7fbce49a25274a4688ddd9",
                        "config": "",
                        "discord_id": ""
                    },
                    "permalink": "https://opensea.io/assets/0x7bd29408f11d2bfc23c34f18275bbf23bb716bc7/10635",
                    "collection": {
                        "banner_image_url": "https://lh3.googleusercontent.com/qwnNTSRrf9CVq4LGawMcg7i2KZhD9I5LHA4uSNnB43-UAniBBgpNMSIz013HCKtrB9KFjrJUIRwpGbTzzNA4srJV39t3LnW3vaugmB8=s2500",
                        "chat_url": null,
                        "created_date": "2021-05-03T01:32:41.897161",
                        "default_to_fiat": false,
                        "description": "The Meebits are 20,000 unique 3D voxel characters, created by a custom generative algorithm, then registered on the Ethereum blockchain.",
                        "dev_buyer_fee_basis_points": "0",
                        "dev_seller_fee_basis_points": "0",
                        "discord_url": null,
                        "display_data": {
                            "card_display_style": "contain"
                        },
                        "external_url": null,
                        "featured": false,
                        "featured_image_url": null,
                        "hidden": false,
                        "safelist_request_status": "verified",
                        "image_url": "https://lh3.googleusercontent.com/d784iHHbqQFVH1XYD6HoT4u3y_Fsu_9FZUltWjnOzoYv7qqB5dLUqpGyHBd8Gq3h4mykK5Enj8pxqOUorgD2PfIWcVj9ugvu8l0=s120",
                        "is_subject_to_whitelist": false,
                        "large_image_url": null,
                        "medium_username": null,
                        "name": "Meebits",
                        "only_proxied_transfers": false,
                        "opensea_buyer_fee_basis_points": "0",
                        "opensea_seller_fee_basis_points": "250",
                        "payout_address": null,
                        "require_email": false,
                        "short_description": null,
                        "slug": "meebits",
                        "telegram_url": null,
                        "twitter_username": null,
                        "instagram_username": null,
                        "wiki_url": null
                    },
                    "decimals": 0,
                    "token_metadata": "https://meebits.larvalabs.com/meebit/10635"
                },
                {
                    "id": 23310831,
                    "token_id": "4825",
                    "num_sales": 0,
                    "background_color": null,
                    "image_url": "https://lh3.googleusercontent.com/Y5WIZ718fh4ncLBl0_Gqo1zyS4l8o5kS6HIQH9LMMgg0VUrRaxpLJozCtItU-sApkXgbaHXe1Qc_RYs5wcMp1nGY2oKqyijWqCvgtHo",
                    "image_preview_url": "https://lh3.googleusercontent.com/Y5WIZ718fh4ncLBl0_Gqo1zyS4l8o5kS6HIQH9LMMgg0VUrRaxpLJozCtItU-sApkXgbaHXe1Qc_RYs5wcMp1nGY2oKqyijWqCvgtHo=s250",
                    "image_thumbnail_url": "https://lh3.googleusercontent.com/Y5WIZ718fh4ncLBl0_Gqo1zyS4l8o5kS6HIQH9LMMgg0VUrRaxpLJozCtItU-sApkXgbaHXe1Qc_RYs5wcMp1nGY2oKqyijWqCvgtHo=s128",
                    "image_original_url": "http://meebits.larvalabs.com/meebitimages/characterimage?index=4825&type=full&imageType=jpg",
                    "animation_url": null,
                    "animation_original_url": null,
                    "name": "Meebit #4825",
                    "description": "Meebit #4825",
                    "external_link": null,
                    "asset_contract": {
                        "address": "0x7bd29408f11d2bfc23c34f18275bbf23bb716bc7",
                        "asset_contract_type": "non-fungible",
                        "created_date": "2021-05-03T01:32:40.414383",
                        "name": "Meebits",
                        "nft_version": "3.0",
                        "opensea_version": null,
                        "owner": null,
                        "schema_name": "ERC721",
                        "symbol": "⚇",
                        "total_supply": "1",
                        "description": "The Meebits are 20,000 unique 3D voxel characters, created by a custom generative algorithm, then registered on the Ethereum blockchain.",
                        "external_link": null,
                        "image_url": "https://lh3.googleusercontent.com/d784iHHbqQFVH1XYD6HoT4u3y_Fsu_9FZUltWjnOzoYv7qqB5dLUqpGyHBd8Gq3h4mykK5Enj8pxqOUorgD2PfIWcVj9ugvu8l0=s120",
                        "default_to_fiat": false,
                        "dev_buyer_fee_basis_points": 0,
                        "dev_seller_fee_basis_points": 0,
                        "only_proxied_transfers": false,
                        "opensea_buyer_fee_basis_points": 0,
                        "opensea_seller_fee_basis_points": 250,
                        "buyer_fee_basis_points": 0,
                        "seller_fee_basis_points": 250,
                        "payout_address": null
                    },
                    "owner": {
                        "user": {
                            "username": null
                        },
                        "profile_img_url": "https://storage.googleapis.com/opensea-static/opensea-profile/15.png",
                        "address": "0x40c839b831c90173dc7fbce49a25274a4688ddd9",
                        "config": "",
                        "discord_id": ""
                    },
                    "permalink": "https://opensea.io/assets/0x7bd29408f11d2bfc23c34f18275bbf23bb716bc7/4825",
                    "collection": {
                        "banner_image_url": "https://lh3.googleusercontent.com/qwnNTSRrf9CVq4LGawMcg7i2KZhD9I5LHA4uSNnB43-UAniBBgpNMSIz013HCKtrB9KFjrJUIRwpGbTzzNA4srJV39t3LnW3vaugmB8=s2500",
                        "chat_url": null,
                        "created_date": "2021-05-03T01:32:41.897161",
                        "default_to_fiat": false,
                        "description": "The Meebits are 20,000 unique 3D voxel characters, created by a custom generative algorithm, then registered on the Ethereum blockchain.",
                        "dev_buyer_fee_basis_points": "0",
                        "dev_seller_fee_basis_points": "0",
                        "discord_url": null,
                        "display_data": {
                            "card_display_style": "contain"
                        },
                        "external_url": null,
                        "featured": false,
                        "featured_image_url": null,
                        "hidden": false,
                        "safelist_request_status": "verified",
                        "image_url": "https://lh3.googleusercontent.com/d784iHHbqQFVH1XYD6HoT4u3y_Fsu_9FZUltWjnOzoYv7qqB5dLUqpGyHBd8Gq3h4mykK5Enj8pxqOUorgD2PfIWcVj9ugvu8l0=s120",
                        "is_subject_to_whitelist": false,
                        "large_image_url": null,
                        "medium_username": null,
                        "name": "Meebits",
                        "only_proxied_transfers": false,
                        "opensea_buyer_fee_basis_points": "0",
                        "opensea_seller_fee_basis_points": "250",
                        "payout_address": null,
                        "require_email": false,
                        "short_description": null,
                        "slug": "meebits",
                        "telegram_url": null,
                        "twitter_username": null,
                        "instagram_username": null,
                        "wiki_url": null
                    },
                    "decimals": 0,
                    "token_metadata": "https://meebits.larvalabs.com/meebit/4825"
                },
                {
                    "id": 23311808,
                    "token_id": "6260",
                    "num_sales": 0,
                    "background_color": null,
                    "image_url": "https://lh3.googleusercontent.com/MyYUvI4t1oICBt3RmW7QXQw6VVz5JgPu46KnOWaQ_dJFYjjJeuSXztDva7pliJgcPJh6KIi6XZ23jcj1m0_GQErVy13vek42255RbQ",
                    "image_preview_url": "https://lh3.googleusercontent.com/MyYUvI4t1oICBt3RmW7QXQw6VVz5JgPu46KnOWaQ_dJFYjjJeuSXztDva7pliJgcPJh6KIi6XZ23jcj1m0_GQErVy13vek42255RbQ=s250",
                    "image_thumbnail_url": "https://lh3.googleusercontent.com/MyYUvI4t1oICBt3RmW7QXQw6VVz5JgPu46KnOWaQ_dJFYjjJeuSXztDva7pliJgcPJh6KIi6XZ23jcj1m0_GQErVy13vek42255RbQ=s128",
                    "image_original_url": "http://meebits.larvalabs.com/meebitimages/characterimage?index=6260&type=full&imageType=jpg",
                    "animation_url": null,
                    "animation_original_url": null,
                    "name": "Meebit #6260",
                    "description": "Meebit #6260",
                    "external_link": null,
                    "asset_contract": {
                        "address": "0x7bd29408f11d2bfc23c34f18275bbf23bb716bc7",
                        "asset_contract_type": "non-fungible",
                        "created_date": "2021-05-03T01:32:40.414383",
                        "name": "Meebits",
                        "nft_version": "3.0",
                        "opensea_version": null,
                        "owner": null,
                        "schema_name": "ERC721",
                        "symbol": "⚇",
                        "total_supply": "1",
                        "description": "The Meebits are 20,000 unique 3D voxel characters, created by a custom generative algorithm, then registered on the Ethereum blockchain.",
                        "external_link": null,
                        "image_url": "https://lh3.googleusercontent.com/d784iHHbqQFVH1XYD6HoT4u3y_Fsu_9FZUltWjnOzoYv7qqB5dLUqpGyHBd8Gq3h4mykK5Enj8pxqOUorgD2PfIWcVj9ugvu8l0=s120",
                        "default_to_fiat": false,
                        "dev_buyer_fee_basis_points": 0,
                        "dev_seller_fee_basis_points": 0,
                        "only_proxied_transfers": false,
                        "opensea_buyer_fee_basis_points": 0,
                        "opensea_seller_fee_basis_points": 250,
                        "buyer_fee_basis_points": 0,
                        "seller_fee_basis_points": 250,
                        "payout_address": null
                    },
                    "owner": {
                        "user": {
                            "username": null
                        },
                        "profile_img_url": "https://storage.googleapis.com/opensea-static/opensea-profile/15.png",
                        "address": "0x40c839b831c90173dc7fbce49a25274a4688ddd9",
                        "config": "",
                        "discord_id": ""
                    },
                    "permalink": "https://opensea.io/assets/0x7bd29408f11d2bfc23c34f18275bbf23bb716bc7/6260",
                    "collection": {
                        "banner_image_url": "https://lh3.googleusercontent.com/qwnNTSRrf9CVq4LGawMcg7i2KZhD9I5LHA4uSNnB43-UAniBBgpNMSIz013HCKtrB9KFjrJUIRwpGbTzzNA4srJV39t3LnW3vaugmB8=s2500",
                        "chat_url": null,
                        "created_date": "2021-05-03T01:32:41.897161",
                        "default_to_fiat": false,
                        "description": "The Meebits are 20,000 unique 3D voxel characters, created by a custom generative algorithm, then registered on the Ethereum blockchain.",
                        "dev_buyer_fee_basis_points": "0",
                        "dev_seller_fee_basis_points": "0",
                        "discord_url": null,
                        "display_data": {
                            "card_display_style": "contain"
                        },
                        "external_url": null,
                        "featured": false,
                        "featured_image_url": null,
                        "hidden": false,
                        "safelist_request_status": "verified",
                        "image_url": "https://lh3.googleusercontent.com/d784iHHbqQFVH1XYD6HoT4u3y_Fsu_9FZUltWjnOzoYv7qqB5dLUqpGyHBd8Gq3h4mykK5Enj8pxqOUorgD2PfIWcVj9ugvu8l0=s120",
                        "is_subject_to_whitelist": false,
                        "large_image_url": null,
                        "medium_username": null,
                        "name": "Meebits",
                        "only_proxied_transfers": false,
                        "opensea_buyer_fee_basis_points": "0",
                        "opensea_seller_fee_basis_points": "250",
                        "payout_address": null,
                        "require_email": false,
                        "short_description": null,
                        "slug": "meebits",
                        "telegram_url": null,
                        "twitter_username": null,
                        "instagram_username": null,
                        "wiki_url": null
                    },
                    "decimals": 0,
                    "token_metadata": "https://meebits.larvalabs.com/meebit/6260"
                },
                {
                    "id": 23312004,
                    "token_id": "8723",
                    "num_sales": 0,
                    "background_color": null,
                    "image_url": "https://lh3.googleusercontent.com/YRILpZ7VIPS4_jb4hFInAmOHRzhQEdHK6fk89AHJfw7jJigAf7ao1yzN8Dtl0Pz5ndTswcBxiZYDk2swYzTOsj52l2NhzyJ1V8tZhGE",
                    "image_preview_url": "https://lh3.googleusercontent.com/YRILpZ7VIPS4_jb4hFInAmOHRzhQEdHK6fk89AHJfw7jJigAf7ao1yzN8Dtl0Pz5ndTswcBxiZYDk2swYzTOsj52l2NhzyJ1V8tZhGE=s250",
                    "image_thumbnail_url": "https://lh3.googleusercontent.com/YRILpZ7VIPS4_jb4hFInAmOHRzhQEdHK6fk89AHJfw7jJigAf7ao1yzN8Dtl0Pz5ndTswcBxiZYDk2swYzTOsj52l2NhzyJ1V8tZhGE=s128",
                    "image_original_url": "http://meebits.larvalabs.com/meebitimages/characterimage?index=8723&type=full&imageType=jpg",
                    "animation_url": null,
                    "animation_original_url": null,
                    "name": "Meebit #8723",
                    "description": "Meebit #8723",
                    "external_link": null,
                    "asset_contract": {
                        "address": "0x7bd29408f11d2bfc23c34f18275bbf23bb716bc7",
                        "asset_contract_type": "non-fungible",
                        "created_date": "2021-05-03T01:32:40.414383",
                        "name": "Meebits",
                        "nft_version": "3.0",
                        "opensea_version": null,
                        "owner": null,
                        "schema_name": "ERC721",
                        "symbol": "⚇",
                        "total_supply": "1",
                        "description": "The Meebits are 20,000 unique 3D voxel characters, created by a custom generative algorithm, then registered on the Ethereum blockchain.",
                        "external_link": null,
                        "image_url": "https://lh3.googleusercontent.com/d784iHHbqQFVH1XYD6HoT4u3y_Fsu_9FZUltWjnOzoYv7qqB5dLUqpGyHBd8Gq3h4mykK5Enj8pxqOUorgD2PfIWcVj9ugvu8l0=s120",
                        "default_to_fiat": false,
                        "dev_buyer_fee_basis_points": 0,
                        "dev_seller_fee_basis_points": 0,
                        "only_proxied_transfers": false,
                        "opensea_buyer_fee_basis_points": 0,
                        "opensea_seller_fee_basis_points": 250,
                        "buyer_fee_basis_points": 0,
                        "seller_fee_basis_points": 250,
                        "payout_address": null
                    },
                    "owner": {
                        "user": {
                            "username": null
                        },
                        "profile_img_url": "https://storage.googleapis.com/opensea-static/opensea-profile/15.png",
                        "address": "0x40c839b831c90173dc7fbce49a25274a4688ddd9",
                        "config": "",
                        "discord_id": ""
                    },
                    "permalink": "https://opensea.io/assets/0x7bd29408f11d2bfc23c34f18275bbf23bb716bc7/8723",
                    "collection": {
                        "banner_image_url": "https://lh3.googleusercontent.com/qwnNTSRrf9CVq4LGawMcg7i2KZhD9I5LHA4uSNnB43-UAniBBgpNMSIz013HCKtrB9KFjrJUIRwpGbTzzNA4srJV39t3LnW3vaugmB8=s2500",
                        "chat_url": null,
                        "created_date": "2021-05-03T01:32:41.897161",
                        "default_to_fiat": false,
                        "description": "The Meebits are 20,000 unique 3D voxel characters, created by a custom generative algorithm, then registered on the Ethereum blockchain.",
                        "dev_buyer_fee_basis_points": "0",
                        "dev_seller_fee_basis_points": "0",
                        "discord_url": null,
                        "display_data": {
                            "card_display_style": "contain"
                        },
                        "external_url": null,
                        "featured": false,
                        "featured_image_url": null,
                        "hidden": false,
                        "safelist_request_status": "verified",
                        "image_url": "https://lh3.googleusercontent.com/d784iHHbqQFVH1XYD6HoT4u3y_Fsu_9FZUltWjnOzoYv7qqB5dLUqpGyHBd8Gq3h4mykK5Enj8pxqOUorgD2PfIWcVj9ugvu8l0=s120",
                        "is_subject_to_whitelist": false,
                        "large_image_url": null,
                        "medium_username": null,
                        "name": "Meebits",
                        "only_proxied_transfers": false,
                        "opensea_buyer_fee_basis_points": "0",
                        "opensea_seller_fee_basis_points": "250",
                        "payout_address": null,
                        "require_email": false,
                        "short_description": null,
                        "slug": "meebits",
                        "telegram_url": null,
                        "twitter_username": null,
                        "instagram_username": null,
                        "wiki_url": null
                    },
                    "decimals": 0,
                    "token_metadata": "https://meebits.larvalabs.com/meebit/8723"
                },
                {
                    "id": 23312483,
                    "token_id": "17348",
                    "num_sales": 0,
                    "background_color": null,
                    "image_url": "https://lh3.googleusercontent.com/aRtJ0M-Qz8rWxdLlQ4Jx5vgI-KXLidIRPxqS2RJwX8TXjUyY9xyXWOg-LUmnE9mWWWt845mUjTW8iNQiKywJSh6w2EFnHMTrMGJoow",
                    "image_preview_url": "https://lh3.googleusercontent.com/aRtJ0M-Qz8rWxdLlQ4Jx5vgI-KXLidIRPxqS2RJwX8TXjUyY9xyXWOg-LUmnE9mWWWt845mUjTW8iNQiKywJSh6w2EFnHMTrMGJoow=s250",
                    "image_thumbnail_url": "https://lh3.googleusercontent.com/aRtJ0M-Qz8rWxdLlQ4Jx5vgI-KXLidIRPxqS2RJwX8TXjUyY9xyXWOg-LUmnE9mWWWt845mUjTW8iNQiKywJSh6w2EFnHMTrMGJoow=s128",
                    "image_original_url": "http://meebits.larvalabs.com/meebitimages/characterimage?index=17348&type=full&imageType=jpg",
                    "animation_url": null,
                    "animation_original_url": null,
                    "name": "Meebit #17348",
                    "description": "Meebit #17348",
                    "external_link": null,
                    "asset_contract": {
                        "address": "0x7bd29408f11d2bfc23c34f18275bbf23bb716bc7",
                        "asset_contract_type": "non-fungible",
                        "created_date": "2021-05-03T01:32:40.414383",
                        "name": "Meebits",
                        "nft_version": "3.0",
                        "opensea_version": null,
                        "owner": null,
                        "schema_name": "ERC721",
                        "symbol": "⚇",
                        "total_supply": "1",
                        "description": "The Meebits are 20,000 unique 3D voxel characters, created by a custom generative algorithm, then registered on the Ethereum blockchain.",
                        "external_link": null,
                        "image_url": "https://lh3.googleusercontent.com/d784iHHbqQFVH1XYD6HoT4u3y_Fsu_9FZUltWjnOzoYv7qqB5dLUqpGyHBd8Gq3h4mykK5Enj8pxqOUorgD2PfIWcVj9ugvu8l0=s120",
                        "default_to_fiat": false,
                        "dev_buyer_fee_basis_points": 0,
                        "dev_seller_fee_basis_points": 0,
                        "only_proxied_transfers": false,
                        "opensea_buyer_fee_basis_points": 0,
                        "opensea_seller_fee_basis_points": 250,
                        "buyer_fee_basis_points": 0,
                        "seller_fee_basis_points": 250,
                        "payout_address": null
                    },
                    "owner": {
                        "user": {
                            "username": null
                        },
                        "profile_img_url": "https://storage.googleapis.com/opensea-static/opensea-profile/15.png",
                        "address": "0x40c839b831c90173dc7fbce49a25274a4688ddd9",
                        "config": "",
                        "discord_id": ""
                    },
                    "permalink": "https://opensea.io/assets/0x7bd29408f11d2bfc23c34f18275bbf23bb716bc7/17348",
                    "collection": {
                        "banner_image_url": "https://lh3.googleusercontent.com/qwnNTSRrf9CVq4LGawMcg7i2KZhD9I5LHA4uSNnB43-UAniBBgpNMSIz013HCKtrB9KFjrJUIRwpGbTzzNA4srJV39t3LnW3vaugmB8=s2500",
                        "chat_url": null,
                        "created_date": "2021-05-03T01:32:41.897161",
                        "default_to_fiat": false,
                        "description": "The Meebits are 20,000 unique 3D voxel characters, created by a custom generative algorithm, then registered on the Ethereum blockchain.",
                        "dev_buyer_fee_basis_points": "0",
                        "dev_seller_fee_basis_points": "0",
                        "discord_url": null,
                        "display_data": {
                            "card_display_style": "contain"
                        },
                        "external_url": null,
                        "featured": false,
                        "featured_image_url": null,
                        "hidden": false,
                        "safelist_request_status": "verified",
                        "image_url": "https://lh3.googleusercontent.com/d784iHHbqQFVH1XYD6HoT4u3y_Fsu_9FZUltWjnOzoYv7qqB5dLUqpGyHBd8Gq3h4mykK5Enj8pxqOUorgD2PfIWcVj9ugvu8l0=s120",
                        "is_subject_to_whitelist": false,
                        "large_image_url": null,
                        "medium_username": null,
                        "name": "Meebits",
                        "only_proxied_transfers": false,
                        "opensea_buyer_fee_basis_points": "0",
                        "opensea_seller_fee_basis_points": "250",
                        "payout_address": null,
                        "require_email": false,
                        "short_description": null,
                        "slug": "meebits",
                        "telegram_url": null,
                        "twitter_username": null,
                        "instagram_username": null,
                        "wiki_url": null
                    },
                    "decimals": 0,
                    "token_metadata": "https://meebits.larvalabs.com/meebit/17348"
                }
            ],
            "name": "Meebits 10x",
            "description": "Just 10 meebits!",
            "external_link": "",
            "asset_contract": {
                "collection": {
                    "banner_image_url": "https://lh3.googleusercontent.com/qwnNTSRrf9CVq4LGawMcg7i2KZhD9I5LHA4uSNnB43-UAniBBgpNMSIz013HCKtrB9KFjrJUIRwpGbTzzNA4srJV39t3LnW3vaugmB8=s2500",
                    "chat_url": null,
                    "created_date": "2021-05-03T01:32:41.897161",
                    "default_to_fiat": false,
                    "description": "The Meebits are 20,000 unique 3D voxel characters, created by a custom generative algorithm, then registered on the Ethereum blockchain.",
                    "dev_buyer_fee_basis_points": "0",
                    "dev_seller_fee_basis_points": "0",
                    "discord_url": null,
                    "display_data": {
                        "card_display_style": "contain"
                    },
                    "external_url": null,
                    "featured": false,
                    "featured_image_url": null,
                    "hidden": false,
                    "safelist_request_status": "verified",
                    "image_url": "https://lh3.googleusercontent.com/d784iHHbqQFVH1XYD6HoT4u3y_Fsu_9FZUltWjnOzoYv7qqB5dLUqpGyHBd8Gq3h4mykK5Enj8pxqOUorgD2PfIWcVj9ugvu8l0=s120",
                    "is_subject_to_whitelist": false,
                    "large_image_url": null,
                    "medium_username": null,
                    "name": "Meebits",
                    "only_proxied_transfers": false,
                    "opensea_buyer_fee_basis_points": "0",
                    "opensea_seller_fee_basis_points": "250",
                    "payout_address": null,
                    "require_email": false,
                    "short_description": null,
                    "slug": "meebits",
                    "telegram_url": null,
                    "twitter_username": null,
                    "instagram_username": null,
                    "wiki_url": null
                },
                "address": "0x7bd29408f11d2bfc23c34f18275bbf23bb716bc7",
                "asset_contract_type": "non-fungible",
                "created_date": "2021-05-03T01:32:40.414383",
                "name": "Meebits",
                "nft_version": "3.0",
                "opensea_version": null,
                "owner": null,
                "schema_name": "ERC721",
                "symbol": "⚇",
                "total_supply": "1",
                "description": "The Meebits are 20,000 unique 3D voxel characters, created by a custom generative algorithm, then registered on the Ethereum blockchain.",
                "external_link": null,
                "image_url": "https://lh3.googleusercontent.com/d784iHHbqQFVH1XYD6HoT4u3y_Fsu_9FZUltWjnOzoYv7qqB5dLUqpGyHBd8Gq3h4mykK5Enj8pxqOUorgD2PfIWcVj9ugvu8l0=s120",
                "default_to_fiat": false,
                "dev_buyer_fee_basis_points": 0,
                "dev_seller_fee_basis_points": 0,
                "only_proxied_transfers": false,
                "opensea_buyer_fee_basis_points": 0,
                "opensea_seller_fee_basis_points": 250,
                "buyer_fee_basis_points": 0,
                "seller_fee_basis_points": 250,
                "payout_address": null
            },
            "permalink": "https://opensea.io/bundles/meebits-10x-fl7",
            "sell_orders": [
                {
                    "created_date": "2021-05-25T22:39:34.501819",
                    "closing_date": null,
                    "closing_extendable": false,
                    "expiration_time": 0,
                    "listing_time": 1621982270,
                    "order_hash": "0x206d8d1fe134d98fd4de386527098805d71d37e67f7080527da9c05864bf3518",
                    "metadata": {
                        "bundle": {
                            "assets": [
                                {
                                    "id": "10635",
                                    "address": "0x7bd29408f11d2bfc23c34f18275bbf23bb716bc7"
                                },
                                {
                                    "id": "12791",
                                    "address": "0x7bd29408f11d2bfc23c34f18275bbf23bb716bc7"
                                },
                                {
                                    "id": "17348",
                                    "address": "0x7bd29408f11d2bfc23c34f18275bbf23bb716bc7"
                                },
                                {
                                    "id": "17473",
                                    "address": "0x7bd29408f11d2bfc23c34f18275bbf23bb716bc7"
                                },
                                {
                                    "id": "2291",
                                    "address": "0x7bd29408f11d2bfc23c34f18275bbf23bb716bc7"
                                },
                                {
                                    "id": "2324",
                                    "address": "0x7bd29408f11d2bfc23c34f18275bbf23bb716bc7"
                                },
                                {
                                    "id": "4825",
                                    "address": "0x7bd29408f11d2bfc23c34f18275bbf23bb716bc7"
                                },
                                {
                                    "id": "6260",
                                    "address": "0x7bd29408f11d2bfc23c34f18275bbf23bb716bc7"
                                },
                                {
                                    "id": "7463",
                                    "address": "0x7bd29408f11d2bfc23c34f18275bbf23bb716bc7"
                                },
                                {
                                    "id": "8723",
                                    "address": "0x7bd29408f11d2bfc23c34f18275bbf23bb716bc7"
                                }
                            ],
                            "schemas": [
                                "ERC721",
                                "ERC721",
                                "ERC721",
                                "ERC721",
                                "ERC721",
                                "ERC721",
                                "ERC721",
                                "ERC721",
                                "ERC721",
                                "ERC721"
                            ],
                            "name": "Meebits 10x",
                            "description": "Just 10 meebits!",
                            "external_link": ""
                        }
                    },
                    "exchange": "0x7be8076f4ea4a4ad08075c2508e481d6c946d12b",
                    "maker": {
                        "user": 851956,
                        "profile_img_url": "https://storage.googleapis.com/opensea-static/opensea-profile/15.png",
                        "address": "0x40c839b831c90173dc7fbce49a25274a4688ddd9",
                        "config": "",
                        "discord_id": ""
                    },
                    "taker": {
                        "user": 1766,
                        "profile_img_url": "https://storage.googleapis.com/opensea-static/opensea-profile/1.png",
                        "address": "0x0000000000000000000000000000000000000000",
                        "config": "",
                        "discord_id": ""
                    },
                    "current_price": "8800000000000000000",
                    "current_bounty": "88000000000000000",
                    "bounty_multiple": "0.01",
                    "maker_relayer_fee": "250",
                    "taker_relayer_fee": "0",
                    "maker_protocol_fee": "0",
                    "taker_protocol_fee": "0",
                    "maker_referrer_fee": "0",
                    "fee_recipient": {
                        "user": 3585,
                        "profile_img_url": "https://storage.googleapis.com/opensea-static/opensea-profile/28.png",
                        "address": "0x5b3256965e7c3cf26e11fcaf296dfc8807c01073",
                        "config": "verified",
                        "discord_id": ""
                    },
                    "fee_method": 1,
                    "side": 1,
                    "sale_kind": 0,
                    "target": "0xc99f70bfd82fb7c8f8191fdfbfb735606b15e5c5",
                    "how_to_call": 1,
                    "calldata": "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",
                    "replacement_pattern": "0x0000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000ffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffff0000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000ffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffff0000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000ffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffff0000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000ffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffff0000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000ffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffff0000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000ffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffff0000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000ffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffff0000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000ffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffff0000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000ffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffff0000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000ffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffff0000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000",
                    "static_target": "0x0000000000000000000000000000000000000000",
                    "static_extradata": "0x",
                    "payment_token": "0x0000000000000000000000000000000000000000",
                    "payment_token_contract": {
                        "id": 1,
                        "symbol": "ETH",
                        "address": "0x0000000000000000000000000000000000000000",
                        "image_url": "https://storage.opensea.io/files/6f8e2979d428180222796ff4a33ab929.svg",
                        "name": "Ether",
                        "decimals": 18,
                        "eth_price": "1.000000000000000",
                        "usd_price": "2625.730000000000018000"
                    },
                    "base_price": "8800000000000000000",
                    "extra": "0",
                    "quantity": "1",
                    "salt": "47578236587592098370540339586259146824877494692450489172826742858167472027669",
                    "v": 28,
                    "r": "0x9a74e9b21d972d68b89020ef190d48a62bf593534b3b235cdd966064e88734a8",
                    "s": "0x28d1842b9e6a377211f7272f60982b65cccd9107fc55ae4db0fefaa5e0cd3f38",
                    "approved_on_chain": false,
                    "cancelled": false,
                    "finalized": false,
                    "marked_invalid": false,
                    "prefixed_hash": "0xccdf50f506c0afa0f372abb92fdd3c736816354f9bc7c96ee23ef0a0cd93122a"
                }
            ]
        },
        {
            "maker": {
                "user": {
                    "username": "ZENvisions"
                },
                "profile_img_url": "https://storage.googleapis.com/opensea-static/opensea-profile/33.png",
                "address": "0xb58ebf756775dcd449a34fa867df6aa03ded3f94",
                "config": "",
                "discord_id": ""
            },
            "slug": "lego-mentality-f7t",
            "assets": [
                {
                    "id": 23024651,
                    "token_id": "82120839275531395833764694533983684021726846386359939202480226177088481132545",
                    "num_sales": 0,
                    "background_color": null,
                    "image_url": "https://lh3.googleusercontent.com/GEsTqZmYqe9RvZwfcoDHvNeHAAhWJ61WM8uSNVWjITlAdDbd9k0BiwEb0UFLdx0Vmofti5ZXD8f8E3aPvUpNqUh2fqdT3XzLo7VuWw",
                    "image_preview_url": "https://lh3.googleusercontent.com/GEsTqZmYqe9RvZwfcoDHvNeHAAhWJ61WM8uSNVWjITlAdDbd9k0BiwEb0UFLdx0Vmofti5ZXD8f8E3aPvUpNqUh2fqdT3XzLo7VuWw=s250",
                    "image_thumbnail_url": "https://lh3.googleusercontent.com/GEsTqZmYqe9RvZwfcoDHvNeHAAhWJ61WM8uSNVWjITlAdDbd9k0BiwEb0UFLdx0Vmofti5ZXD8f8E3aPvUpNqUh2fqdT3XzLo7VuWw=s128",
                    "image_original_url": null,
                    "animation_url": null,
                    "animation_original_url": null,
                    "name": "LEGO prospective",
                    "description": "Overlayed creation of LEGO world.. 3 layer for 3 stories!!!",
                    "external_link": null,
                    "asset_contract": {
                        "address": "0x495f947276749ce646f68ac8c248420045cb7b5e",
                        "asset_contract_type": "semi-fungible",
                        "created_date": "2020-12-02T17:40:53.232025",
                        "name": "OpenSea Collection",
                        "nft_version": null,
                        "opensea_version": "2.0.0",
                        "owner": 102384,
                        "schema_name": "ERC1155",
                        "symbol": "OPENSTORE",
                        "total_supply": null,
                        "description": null,
                        "external_link": null,
                        "image_url": null,
                        "default_to_fiat": false,
                        "dev_buyer_fee_basis_points": 0,
                        "dev_seller_fee_basis_points": 0,
                        "only_proxied_transfers": false,
                        "opensea_buyer_fee_basis_points": 0,
                        "opensea_seller_fee_basis_points": 250,
                        "buyer_fee_basis_points": 0,
                        "seller_fee_basis_points": 250,
                        "payout_address": null
                    },
                    "owner": {
                        "user": {
                            "username": "NullAddress"
                        },
                        "profile_img_url": "https://storage.googleapis.com/opensea-static/opensea-profile/1.png",
                        "address": "0x0000000000000000000000000000000000000000",
                        "config": "",
                        "discord_id": ""
                    },
                    "permalink": "https://opensea.io/assets/0x495f947276749ce646f68ac8c248420045cb7b5e/82120839275531395833764694533983684021726846386359939202480226177088481132545",
                    "collection": {
                        "banner_image_url": "https://lh3.googleusercontent.com/B6Jd_XJ5JEA8bdwoRZHmVbHuSwJHE2LXg2zBKqhTTHBOpaTBb8PrQD-Y_-x_Az7SDeNwKWuaR61LgCAm5Es1bv0ys6TA2lJayUMQ=s2500",
                        "chat_url": null,
                        "created_date": "2021-04-25T22:21:22.565345",
                        "default_to_fiat": false,
                        "description": " Inside this collection you will find a wide selection of black and white NFTs .. there are only unique pieces .. they are all fabulous pieces, see is believe .. stay connected, ZENvision is here",
                        "dev_buyer_fee_basis_points": "0",
                        "dev_seller_fee_basis_points": "0",
                        "discord_url": null,
                        "display_data": {
                            "card_display_style": "contain",
                            "images": []
                        },
                        "external_url": null,
                        "featured": false,
                        "featured_image_url": null,
                        "hidden": true,
                        "safelist_request_status": "not_requested",
                        "image_url": "https://lh3.googleusercontent.com/o6Dg98eBGhK6JcoubCcce4-EJxP_0XQy4MwavZtWTe22k4OZNDRDyyCIeQblYziT39vC9lC2gCWEjgx1f40xWRnjzzEAML4KvjGA6g=s120",
                        "is_subject_to_whitelist": false,
                        "large_image_url": null,
                        "medium_username": null,
                        "name": "the white(&black)week",
                        "only_proxied_transfers": false,
                        "opensea_buyer_fee_basis_points": "0",
                        "opensea_seller_fee_basis_points": "250",
                        "payout_address": null,
                        "require_email": false,
                        "short_description": null,
                        "slug": "the-white-black-week",
                        "telegram_url": null,
                        "twitter_username": null,
                        "instagram_username": null,
                        "wiki_url": null
                    },
                    "decimals": null,
                    "token_metadata": null
                },
                {
                    "id": 23024856,
                    "token_id": "82120839275531395833764694533983684021726846386359939202480226178187992760321",
                    "num_sales": 0,
                    "background_color": null,
                    "image_url": "https://lh3.googleusercontent.com/kmVefKUGtweej6SR2fHVQWzLxfZgz_6uGQLFyYShuHLqb60fD6Wmd5Mx_IMdS2GCQ9SL_dbKIfHuYC6gvx66Bnc7NkujCHnxUOxWZg",
                    "image_preview_url": "https://lh3.googleusercontent.com/kmVefKUGtweej6SR2fHVQWzLxfZgz_6uGQLFyYShuHLqb60fD6Wmd5Mx_IMdS2GCQ9SL_dbKIfHuYC6gvx66Bnc7NkujCHnxUOxWZg=s250",
                    "image_thumbnail_url": "https://lh3.googleusercontent.com/kmVefKUGtweej6SR2fHVQWzLxfZgz_6uGQLFyYShuHLqb60fD6Wmd5Mx_IMdS2GCQ9SL_dbKIfHuYC6gvx66Bnc7NkujCHnxUOxWZg=s128",
                    "image_original_url": null,
                    "animation_url": null,
                    "animation_original_url": null,
                    "name": "LEGO prospectives (PART#2)",
                    "description": "3 point of view of my LEGO world.. \n3 different Moment for \n3dimension lifestyle ",
                    "external_link": null,
                    "asset_contract": {
                        "address": "0x495f947276749ce646f68ac8c248420045cb7b5e",
                        "asset_contract_type": "semi-fungible",
                        "created_date": "2020-12-02T17:40:53.232025",
                        "name": "OpenSea Collection",
                        "nft_version": null,
                        "opensea_version": "2.0.0",
                        "owner": 102384,
                        "schema_name": "ERC1155",
                        "symbol": "OPENSTORE",
                        "total_supply": null,
                        "description": null,
                        "external_link": null,
                        "image_url": null,
                        "default_to_fiat": false,
                        "dev_buyer_fee_basis_points": 0,
                        "dev_seller_fee_basis_points": 0,
                        "only_proxied_transfers": false,
                        "opensea_buyer_fee_basis_points": 0,
                        "opensea_seller_fee_basis_points": 250,
                        "buyer_fee_basis_points": 0,
                        "seller_fee_basis_points": 250,
                        "payout_address": null
                    },
                    "owner": {
                        "user": {
                            "username": "NullAddress"
                        },
                        "profile_img_url": "https://storage.googleapis.com/opensea-static/opensea-profile/1.png",
                        "address": "0x0000000000000000000000000000000000000000",
                        "config": "",
                        "discord_id": ""
                    },
                    "permalink": "https://opensea.io/assets/0x495f947276749ce646f68ac8c248420045cb7b5e/82120839275531395833764694533983684021726846386359939202480226178187992760321",
                    "collection": {
                        "banner_image_url": "https://lh3.googleusercontent.com/B6Jd_XJ5JEA8bdwoRZHmVbHuSwJHE2LXg2zBKqhTTHBOpaTBb8PrQD-Y_-x_Az7SDeNwKWuaR61LgCAm5Es1bv0ys6TA2lJayUMQ=s2500",
                        "chat_url": null,
                        "created_date": "2021-04-25T22:21:22.565345",
                        "default_to_fiat": false,
                        "description": " Inside this collection you will find a wide selection of black and white NFTs .. there are only unique pieces .. they are all fabulous pieces, see is believe .. stay connected, ZENvision is here",
                        "dev_buyer_fee_basis_points": "0",
                        "dev_seller_fee_basis_points": "0",
                        "discord_url": null,
                        "display_data": {
                            "card_display_style": "contain",
                            "images": []
                        },
                        "external_url": null,
                        "featured": false,
                        "featured_image_url": null,
                        "hidden": true,
                        "safelist_request_status": "not_requested",
                        "image_url": "https://lh3.googleusercontent.com/o6Dg98eBGhK6JcoubCcce4-EJxP_0XQy4MwavZtWTe22k4OZNDRDyyCIeQblYziT39vC9lC2gCWEjgx1f40xWRnjzzEAML4KvjGA6g=s120",
                        "is_subject_to_whitelist": false,
                        "large_image_url": null,
                        "medium_username": null,
                        "name": "the white(&black)week",
                        "only_proxied_transfers": false,
                        "opensea_buyer_fee_basis_points": "0",
                        "opensea_seller_fee_basis_points": "250",
                        "payout_address": null,
                        "require_email": false,
                        "short_description": null,
                        "slug": "the-white-black-week",
                        "telegram_url": null,
                        "twitter_username": null,
                        "instagram_username": null,
                        "wiki_url": null
                    },
                    "decimals": null,
                    "token_metadata": null
                },
                {
                    "id": 23025126,
                    "token_id": "82120839275531395833764694533983684021726846386359939202480226179287504388097",
                    "num_sales": 0,
                    "background_color": null,
                    "image_url": "https://lh3.googleusercontent.com/BGbbWIAQsDcp8KGy5AGGSLJKeJ5bELwn45XBbHLcEEwr6oqI6L_TcMBfEU-wrAIcP9Art75-XQsh4myURTKkCOYHkVka2Mc2zVsL7Q",
                    "image_preview_url": "https://lh3.googleusercontent.com/BGbbWIAQsDcp8KGy5AGGSLJKeJ5bELwn45XBbHLcEEwr6oqI6L_TcMBfEU-wrAIcP9Art75-XQsh4myURTKkCOYHkVka2Mc2zVsL7Q=s250",
                    "image_thumbnail_url": "https://lh3.googleusercontent.com/BGbbWIAQsDcp8KGy5AGGSLJKeJ5bELwn45XBbHLcEEwr6oqI6L_TcMBfEU-wrAIcP9Art75-XQsh4myURTKkCOYHkVka2Mc2zVsL7Q=s128",
                    "image_original_url": null,
                    "animation_url": null,
                    "animation_original_url": null,
                    "name": "LEGO mentality",
                    "description": "LEGO works hard, but if it stays humble and dreams big… it will live a spectacular life!!!\n\nInside EVERYLEGO  we can find a lot of work .. but his life is marked by the goal of the palm tree .. where he enjoy the fruit of his constructions",
                    "external_link": null,
                    "asset_contract": {
                        "address": "0x495f947276749ce646f68ac8c248420045cb7b5e",
                        "asset_contract_type": "semi-fungible",
                        "created_date": "2020-12-02T17:40:53.232025",
                        "name": "OpenSea Collection",
                        "nft_version": null,
                        "opensea_version": "2.0.0",
                        "owner": 102384,
                        "schema_name": "ERC1155",
                        "symbol": "OPENSTORE",
                        "total_supply": null,
                        "description": null,
                        "external_link": null,
                        "image_url": null,
                        "default_to_fiat": false,
                        "dev_buyer_fee_basis_points": 0,
                        "dev_seller_fee_basis_points": 0,
                        "only_proxied_transfers": false,
                        "opensea_buyer_fee_basis_points": 0,
                        "opensea_seller_fee_basis_points": 250,
                        "buyer_fee_basis_points": 0,
                        "seller_fee_basis_points": 250,
                        "payout_address": null
                    },
                    "owner": {
                        "user": {
                            "username": "NullAddress"
                        },
                        "profile_img_url": "https://storage.googleapis.com/opensea-static/opensea-profile/1.png",
                        "address": "0x0000000000000000000000000000000000000000",
                        "config": "",
                        "discord_id": ""
                    },
                    "permalink": "https://opensea.io/assets/0x495f947276749ce646f68ac8c248420045cb7b5e/82120839275531395833764694533983684021726846386359939202480226179287504388097",
                    "collection": {
                        "banner_image_url": "https://lh3.googleusercontent.com/B6Jd_XJ5JEA8bdwoRZHmVbHuSwJHE2LXg2zBKqhTTHBOpaTBb8PrQD-Y_-x_Az7SDeNwKWuaR61LgCAm5Es1bv0ys6TA2lJayUMQ=s2500",
                        "chat_url": null,
                        "created_date": "2021-04-25T22:21:22.565345",
                        "default_to_fiat": false,
                        "description": " Inside this collection you will find a wide selection of black and white NFTs .. there are only unique pieces .. they are all fabulous pieces, see is believe .. stay connected, ZENvision is here",
                        "dev_buyer_fee_basis_points": "0",
                        "dev_seller_fee_basis_points": "0",
                        "discord_url": null,
                        "display_data": {
                            "card_display_style": "contain",
                            "images": []
                        },
                        "external_url": null,
                        "featured": false,
                        "featured_image_url": null,
                        "hidden": true,
                        "safelist_request_status": "not_requested",
                        "image_url": "https://lh3.googleusercontent.com/o6Dg98eBGhK6JcoubCcce4-EJxP_0XQy4MwavZtWTe22k4OZNDRDyyCIeQblYziT39vC9lC2gCWEjgx1f40xWRnjzzEAML4KvjGA6g=s120",
                        "is_subject_to_whitelist": false,
                        "large_image_url": null,
                        "medium_username": null,
                        "name": "the white(&black)week",
                        "only_proxied_transfers": false,
                        "opensea_buyer_fee_basis_points": "0",
                        "opensea_seller_fee_basis_points": "250",
                        "payout_address": null,
                        "require_email": false,
                        "short_description": null,
                        "slug": "the-white-black-week",
                        "telegram_url": null,
                        "twitter_username": null,
                        "instagram_username": null,
                        "wiki_url": null
                    },
                    "decimals": null,
                    "token_metadata": null
                }
            ],
            "name": "LEGO MENTALITY",
            "description": "amazing part of legostyle.. ENJOY",
            "external_link": "",
            "asset_contract": {
                "collection": {
                    "banner_image_url": null,
                    "chat_url": null,
                    "created_date": "2020-12-02T17:40:53.507540",
                    "default_to_fiat": false,
                    "description": null,
                    "dev_buyer_fee_basis_points": "0",
                    "dev_seller_fee_basis_points": "0",
                    "discord_url": null,
                    "display_data": {
                        "card_display_style": "contain",
                        "images": []
                    },
                    "external_url": null,
                    "featured": false,
                    "featured_image_url": null,
                    "hidden": true,
                    "safelist_request_status": "not_requested",
                    "image_url": null,
                    "is_subject_to_whitelist": false,
                    "large_image_url": null,
                    "medium_username": null,
                    "name": "OpenSea Shared Storefront V2",
                    "only_proxied_transfers": false,
                    "opensea_buyer_fee_basis_points": "0",
                    "opensea_seller_fee_basis_points": "250",
                    "payout_address": null,
                    "require_email": false,
                    "short_description": null,
                    "slug": "opensea-shared-storefront-v2",
                    "telegram_url": null,
                    "twitter_username": null,
                    "instagram_username": null,
                    "wiki_url": null
                },
                "address": "0x495f947276749ce646f68ac8c248420045cb7b5e",
                "asset_contract_type": "semi-fungible",
                "created_date": "2020-12-02T17:40:53.232025",
                "name": "OpenSea Collection",
                "nft_version": null,
                "opensea_version": "2.0.0",
                "owner": 102384,
                "schema_name": "ERC1155",
                "symbol": "OPENSTORE",
                "total_supply": null,
                "description": null,
                "external_link": null,
                "image_url": null,
                "default_to_fiat": false,
                "dev_buyer_fee_basis_points": 0,
                "dev_seller_fee_basis_points": 0,
                "only_proxied_transfers": false,
                "opensea_buyer_fee_basis_points": 0,
                "opensea_seller_fee_basis_points": 250,
                "buyer_fee_basis_points": 0,
                "seller_fee_basis_points": 250,
                "payout_address": null
            },
            "permalink": "https://opensea.io/bundles/lego-mentality-f7t",
            "sell_orders": [
                {
                    "created_date": "2021-05-25T22:35:32.621216",
                    "closing_date": null,
                    "closing_extendable": false,
                    "expiration_time": 0,
                    "listing_time": 1621982026,
                    "order_hash": "0x87f2680b2ebae2e3c345a85f840a2ee26db4d28f5d1998bbe34c57e78e8ae3b0",
                    "metadata": {
                        "bundle": {
                            "assets": [
                                {
                                    "id": "82120839275531395833764694533983684021726846386359939202480226177088481132545",
                                    "address": "0x495f947276749ce646f68ac8c248420045cb7b5e",
                                    "quantity": "1"
                                },
                                {
                                    "id": "82120839275531395833764694533983684021726846386359939202480226178187992760321",
                                    "address": "0x495f947276749ce646f68ac8c248420045cb7b5e",
                                    "quantity": "1"
                                },
                                {
                                    "id": "82120839275531395833764694533983684021726846386359939202480226179287504388097",
                                    "address": "0x495f947276749ce646f68ac8c248420045cb7b5e",
                                    "quantity": "1"
                                }
                            ],
                            "schemas": [
                                "ERC1155",
                                "ERC1155",
                                "ERC1155"
                            ],
                            "name": "LEGO MENTALITY",
                            "description": "amazing part of legostyle.. ENJOY",
                            "external_link": ""
                        }
                    },
                    "exchange": "0x7be8076f4ea4a4ad08075c2508e481d6c946d12b",
                    "maker": {
                        "user": 555234,
                        "profile_img_url": "https://storage.googleapis.com/opensea-static/opensea-profile/33.png",
                        "address": "0xb58ebf756775dcd449a34fa867df6aa03ded3f94",
                        "config": "",
                        "discord_id": ""
                    },
                    "taker": {
                        "user": 1766,
                        "profile_img_url": "https://storage.googleapis.com/opensea-static/opensea-profile/1.png",
                        "address": "0x0000000000000000000000000000000000000000",
                        "config": "",
                        "discord_id": ""
                    },
                    "current_price": "4000000000000000000",
                    "current_bounty": "40000000000000000",
                    "bounty_multiple": "0.01",
                    "maker_relayer_fee": "250",
                    "taker_relayer_fee": "0",
                    "maker_protocol_fee": "0",
                    "taker_protocol_fee": "0",
                    "maker_referrer_fee": "0",
                    "fee_recipient": {
                        "user": 3585,
                        "profile_img_url": "https://storage.googleapis.com/opensea-static/opensea-profile/28.png",
                        "address": "0x5b3256965e7c3cf26e11fcaf296dfc8807c01073",
                        "config": "verified",
                        "discord_id": ""
                    },
                    "fee_method": 1,
                    "side": 1,
                    "sale_kind": 0,
                    "target": "0xc99f70bfd82fb7c8f8191fdfbfb735606b15e5c5",
                    "how_to_call": 1,
                    "calldata": "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",
                    "replacement_pattern": "0x0000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000ffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffff0000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000ffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffff0000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000ffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffff00000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000",
                    "static_target": "0x0000000000000000000000000000000000000000",
                    "static_extradata": "0x",
                    "payment_token": "0x0000000000000000000000000000000000000000",
                    "payment_token_contract": {
                        "id": 1,
                        "symbol": "ETH",
                        "address": "0x0000000000000000000000000000000000000000",
                        "image_url": "https://storage.opensea.io/files/6f8e2979d428180222796ff4a33ab929.svg",
                        "name": "Ether",
                        "decimals": 18,
                        "eth_price": "1.000000000000000",
                        "usd_price": "2625.730000000000018000"
                    },
                    "base_price": "4000000000000000000",
                    "extra": "0",
                    "quantity": "1",
                    "salt": "24084751554314045014589438920750284731372194171185446029671921923765041978525",
                    "v": 27,
                    "r": "0x346c11b7034307946a083361efc10461e25bb15da9c5c365aa4668b97e2e639b",
                    "s": "0x026d8e99ceab2df96cf3996b999b22f5d95e47838d7b7f472ee0c51edcd2e14f",
                    "approved_on_chain": false,
                    "cancelled": false,
                    "finalized": false,
                    "marked_invalid": false,
                    "prefixed_hash": "0xc4358b7d501bec540c90a5534f5bfc5794ccf6cdc2193ef07dba3856e1d15c32"
                }
            ]
        },
        {
            "maker": {
                "user": {
                    "username": "Barabas"
                },
                "profile_img_url": "https://storage.googleapis.com/opensea-static/opensea-profile/8.png",
                "address": "0xf92b6edd0d62e12f718a5a442d10981c1f6537cf",
                "config": "",
                "discord_id": ""
            },
            "slug": "high-end-lambo-kit-with-6-high-end-weapons-DoH",
            "assets": [
                {
                    "id": 1328208,
                    "token_id": "10094051931033639806",
                    "num_sales": 0,
                    "background_color": "0b0c22",
                    "image_url": "https://lh3.googleusercontent.com/LEo5FtnGONM9eBiDka-DppKNWzLjjN2LKqJUhbjKKdunhme-NviMPvGdTItag-GGcIw_ghOkRUFFUKEZLIC8Qmnf2Dr11d_8q5o6UQ",
                    "image_preview_url": "https://lh3.googleusercontent.com/LEo5FtnGONM9eBiDka-DppKNWzLjjN2LKqJUhbjKKdunhme-NviMPvGdTItag-GGcIw_ghOkRUFFUKEZLIC8Qmnf2Dr11d_8q5o6UQ=s250",
                    "image_thumbnail_url": "https://lh3.googleusercontent.com/LEo5FtnGONM9eBiDka-DppKNWzLjjN2LKqJUhbjKKdunhme-NviMPvGdTItag-GGcIw_ghOkRUFFUKEZLIC8Qmnf2Dr11d_8q5o6UQ=s128",
                    "image_original_url": "https://storage.googleapis.com/warriders/Lambo87.png",
                    "animation_url": null,
                    "animation_original_url": null,
                    "name": "War Lambo Kit",
                    "description": "The War Lambo is a speedy beast on customized sand-adapted suspension. With this vehicle kit, players will be able to build their own war machine from scratch with customized logos and messaging.",
                    "external_link": "https://app.warriders.com/garage/10094051931033639806",
                    "asset_contract": {
                        "address": "0x5caebd3b32e210e85ce3e9d51638b9c445481567",
                        "asset_contract_type": "non-fungible",
                        "created_date": "2018-08-20T21:55:26.654083",
                        "name": "War Riders",
                        "nft_version": "3.0",
                        "opensea_version": null,
                        "owner": 167080,
                        "schema_name": "ERC721",
                        "symbol": "WR",
                        "total_supply": null,
                        "description": "Are you ready for a real apocalypse on the blockchain? If so, then fill up your tank and buckle up! War Riders can build their own war vehicles from scratch with customized logos and messaging. Use your vehicle to mine and attack enemies for Benzene.",
                        "external_link": "https://warriders.com/",
                        "image_url": "https://lh3.googleusercontent.com/81HmSa05kDXmVKwLTh47ZiYchJIf4lVRtQcVoNF2TPjBOd1kPA07cABHsTId8gFEM6oPffqKbLxZcOfDG-3lsDTg=s60",
                        "default_to_fiat": false,
                        "dev_buyer_fee_basis_points": 0,
                        "dev_seller_fee_basis_points": 250,
                        "only_proxied_transfers": false,
                        "opensea_buyer_fee_basis_points": 0,
                        "opensea_seller_fee_basis_points": 250,
                        "buyer_fee_basis_points": 0,
                        "seller_fee_basis_points": 500,
                        "payout_address": "0xfcc60e3ba8e753f131032f26b0179bac332551c9"
                    },
                    "owner": {
                        "user": {
                            "username": "Barabas"
                        },
                        "profile_img_url": "https://storage.googleapis.com/opensea-static/opensea-profile/8.png",
                        "address": "0xf92b6edd0d62e12f718a5a442d10981c1f6537cf",
                        "config": "",
                        "discord_id": ""
                    },
                    "permalink": "https://opensea.io/assets/0x5caebd3b32e210e85ce3e9d51638b9c445481567/10094051931033639806",
                    "collection": {
                        "banner_image_url": "https://lh3.googleusercontent.com/vo_KmiLpxgRzwuJ6VfRDB5vVTEojHIzpyRANC17n1cWU-wCp9lW5LdzhDDIJdaawwel1qDXiPeIingcuCSNv9S-uswU5WCSe06l73w=s2500",
                        "chat_url": null,
                        "created_date": "2019-04-26T22:13:09.996309",
                        "default_to_fiat": false,
                        "description": "Are you ready for a real apocalypse on the blockchain? If so, then fill up your tank and buckle up! War Riders can build their own war vehicles from scratch with customized logos and messaging. Use your vehicle to mine and attack enemies for Benzene.",
                        "dev_buyer_fee_basis_points": "0",
                        "dev_seller_fee_basis_points": "250",
                        "discord_url": "https://discord.gg/trxvDBr",
                        "display_data": {
                            "card_display_style": "cover"
                        },
                        "external_url": "https://warriders.com/",
                        "featured": true,
                        "featured_image_url": "https://storage.opensea.io/0x5caebd3b32e210e85ce3e9d51638b9c445481567-featured-1556589453.png",
                        "hidden": false,
                        "safelist_request_status": "verified",
                        "image_url": "https://lh3.googleusercontent.com/81HmSa05kDXmVKwLTh47ZiYchJIf4lVRtQcVoNF2TPjBOd1kPA07cABHsTId8gFEM6oPffqKbLxZcOfDG-3lsDTg=s60",
                        "is_subject_to_whitelist": false,
                        "large_image_url": "https://lh3.googleusercontent.com/81HmSa05kDXmVKwLTh47ZiYchJIf4lVRtQcVoNF2TPjBOd1kPA07cABHsTId8gFEM6oPffqKbLxZcOfDG-3lsDTg",
                        "medium_username": "vladddy",
                        "name": "War Riders",
                        "only_proxied_transfers": false,
                        "opensea_buyer_fee_basis_points": "0",
                        "opensea_seller_fee_basis_points": "250",
                        "payout_address": "0xfcc60e3ba8e753f131032f26b0179bac332551c9",
                        "require_email": false,
                        "short_description": null,
                        "slug": "war-riders",
                        "telegram_url": "https://t.me/warriders",
                        "twitter_username": "warriders",
                        "instagram_username": null,
                        "wiki_url": null
                    },
                    "decimals": 0,
                    "token_metadata": "https://vault.warriders.com/10094051931033639806.json"
                },
                {
                    "id": 13449999,
                    "token_id": "2652012",
                    "num_sales": 0,
                    "background_color": "0b0c22",
                    "image_url": "https://lh3.googleusercontent.com/rD3dh4dVKR0k5wj2OQPWc1yXXJzyLciOmueDmj469VxhMn_QL16K2BUSkQzjXlFVsqNQl8iAdLkj08nyS4y3Hdd2ew",
                    "image_preview_url": "https://lh3.googleusercontent.com/rD3dh4dVKR0k5wj2OQPWc1yXXJzyLciOmueDmj469VxhMn_QL16K2BUSkQzjXlFVsqNQl8iAdLkj08nyS4y3Hdd2ew=s250",
                    "image_thumbnail_url": "https://lh3.googleusercontent.com/rD3dh4dVKR0k5wj2OQPWc1yXXJzyLciOmueDmj469VxhMn_QL16K2BUSkQzjXlFVsqNQl8iAdLkj08nyS4y3Hdd2ew=s128",
                    "image_original_url": "https://storage.googleapis.com/warriders/guns/306a7f1f8b85ef4d6ee83c37647924b75e7945e.png",
                    "animation_url": null,
                    "animation_original_url": null,
                    "name": "Carbon M5 MAAWS",
                    "description": "The M5 MAAWS is the next generation recoilless anti-tank weapon with extended barrels for maximum effective range. Modified with an autoloader, this gun features continuous firing with no need for manual reloading. Three portable computer units with power supplies provide the weapon with necessary power and logic for fully automated firing.",
                    "external_link": "https://app.warriders.com/guns/midgrade/825",
                    "asset_contract": {
                        "address": "0x2d6e10561b320c4f31a903bf0fa92a1ed58637c0",
                        "asset_contract_type": "non-fungible",
                        "created_date": "2019-10-18T01:20:55.714142",
                        "name": "War Riders Gun",
                        "nft_version": "3.0",
                        "opensea_version": null,
                        "owner": 113102,
                        "schema_name": "ERC721",
                        "symbol": "",
                        "total_supply": "70",
                        "description": "Are you ready for a real apocalypse on the blockchain? If so, then fill up your tank and buckle up! War Riders can build their own war vehicles from scratch with customized logos and messaging. Use your vehicle to mine and attack enemies for Benzene.",
                        "external_link": "https://warriders.com/",
                        "image_url": "https://lh3.googleusercontent.com/81HmSa05kDXmVKwLTh47ZiYchJIf4lVRtQcVoNF2TPjBOd1kPA07cABHsTId8gFEM6oPffqKbLxZcOfDG-3lsDTg=s60",
                        "default_to_fiat": false,
                        "dev_buyer_fee_basis_points": 0,
                        "dev_seller_fee_basis_points": 250,
                        "only_proxied_transfers": false,
                        "opensea_buyer_fee_basis_points": 0,
                        "opensea_seller_fee_basis_points": 250,
                        "buyer_fee_basis_points": 0,
                        "seller_fee_basis_points": 500,
                        "payout_address": "0xfcc60e3ba8e753f131032f26b0179bac332551c9"
                    },
                    "owner": {
                        "user": {
                            "username": "Barabas"
                        },
                        "profile_img_url": "https://storage.googleapis.com/opensea-static/opensea-profile/8.png",
                        "address": "0xf92b6edd0d62e12f718a5a442d10981c1f6537cf",
                        "config": "",
                        "discord_id": ""
                    },
                    "permalink": "https://opensea.io/assets/0x2d6e10561b320c4f31a903bf0fa92a1ed58637c0/2652012",
                    "collection": {
                        "banner_image_url": "https://lh3.googleusercontent.com/vo_KmiLpxgRzwuJ6VfRDB5vVTEojHIzpyRANC17n1cWU-wCp9lW5LdzhDDIJdaawwel1qDXiPeIingcuCSNv9S-uswU5WCSe06l73w=s2500",
                        "chat_url": null,
                        "created_date": "2019-04-26T22:13:09.996309",
                        "default_to_fiat": false,
                        "description": "Are you ready for a real apocalypse on the blockchain? If so, then fill up your tank and buckle up! War Riders can build their own war vehicles from scratch with customized logos and messaging. Use your vehicle to mine and attack enemies for Benzene.",
                        "dev_buyer_fee_basis_points": "0",
                        "dev_seller_fee_basis_points": "250",
                        "discord_url": "https://discord.gg/trxvDBr",
                        "display_data": {
                            "card_display_style": "cover"
                        },
                        "external_url": "https://warriders.com/",
                        "featured": true,
                        "featured_image_url": "https://storage.opensea.io/0x5caebd3b32e210e85ce3e9d51638b9c445481567-featured-1556589453.png",
                        "hidden": false,
                        "safelist_request_status": "verified",
                        "image_url": "https://lh3.googleusercontent.com/81HmSa05kDXmVKwLTh47ZiYchJIf4lVRtQcVoNF2TPjBOd1kPA07cABHsTId8gFEM6oPffqKbLxZcOfDG-3lsDTg=s60",
                        "is_subject_to_whitelist": false,
                        "large_image_url": "https://lh3.googleusercontent.com/81HmSa05kDXmVKwLTh47ZiYchJIf4lVRtQcVoNF2TPjBOd1kPA07cABHsTId8gFEM6oPffqKbLxZcOfDG-3lsDTg",
                        "medium_username": "vladddy",
                        "name": "War Riders",
                        "only_proxied_transfers": false,
                        "opensea_buyer_fee_basis_points": "0",
                        "opensea_seller_fee_basis_points": "250",
                        "payout_address": "0xfcc60e3ba8e753f131032f26b0179bac332551c9",
                        "require_email": false,
                        "short_description": null,
                        "slug": "war-riders",
                        "telegram_url": "https://t.me/warriders",
                        "twitter_username": "warriders",
                        "instagram_username": null,
                        "wiki_url": null
                    },
                    "decimals": 0,
                    "token_metadata": "https://vault.warriders.com/guns/2/825.json"
                },
                {
                    "id": 13450053,
                    "token_id": "2652054",
                    "num_sales": 0,
                    "background_color": "0b0c22",
                    "image_url": "https://lh3.googleusercontent.com/HBXIda9Wdh0llhIdUbjbm4B767H7UyrIyQMSRG5fqGTpK-2hEJMjlBGxbUDRD8Ox1THB55KCa_dHkcx6y-s1cTU",
                    "image_preview_url": "https://lh3.googleusercontent.com/HBXIda9Wdh0llhIdUbjbm4B767H7UyrIyQMSRG5fqGTpK-2hEJMjlBGxbUDRD8Ox1THB55KCa_dHkcx6y-s1cTU=s250",
                    "image_thumbnail_url": "https://lh3.googleusercontent.com/HBXIda9Wdh0llhIdUbjbm4B767H7UyrIyQMSRG5fqGTpK-2hEJMjlBGxbUDRD8Ox1THB55KCa_dHkcx6y-s1cTU=s128",
                    "image_original_url": "https://storage.googleapis.com/warriders/guns/8759089922b404bdbec277ee083c79f754c7d03.png",
                    "animation_url": null,
                    "animation_original_url": null,
                    "name": "Carbon M2c Browning",
                    "description": "The M2c Browning is a computer-controlled version of an automatic, recoil operated, air-cooled machine gun with disintegrating metallic link-belt that is used to feed the ammunition into the weapon. Traditional spade grips and trigger were replaced with a digital trigger that is controlled by a small, single-board computer.",
                    "external_link": "https://app.warriders.com/guns/midgrade/867",
                    "asset_contract": {
                        "address": "0x2d6e10561b320c4f31a903bf0fa92a1ed58637c0",
                        "asset_contract_type": "non-fungible",
                        "created_date": "2019-10-18T01:20:55.714142",
                        "name": "War Riders Gun",
                        "nft_version": "3.0",
                        "opensea_version": null,
                        "owner": 113102,
                        "schema_name": "ERC721",
                        "symbol": "",
                        "total_supply": "70",
                        "description": "Are you ready for a real apocalypse on the blockchain? If so, then fill up your tank and buckle up! War Riders can build their own war vehicles from scratch with customized logos and messaging. Use your vehicle to mine and attack enemies for Benzene.",
                        "external_link": "https://warriders.com/",
                        "image_url": "https://lh3.googleusercontent.com/81HmSa05kDXmVKwLTh47ZiYchJIf4lVRtQcVoNF2TPjBOd1kPA07cABHsTId8gFEM6oPffqKbLxZcOfDG-3lsDTg=s60",
                        "default_to_fiat": false,
                        "dev_buyer_fee_basis_points": 0,
                        "dev_seller_fee_basis_points": 250,
                        "only_proxied_transfers": false,
                        "opensea_buyer_fee_basis_points": 0,
                        "opensea_seller_fee_basis_points": 250,
                        "buyer_fee_basis_points": 0,
                        "seller_fee_basis_points": 500,
                        "payout_address": "0xfcc60e3ba8e753f131032f26b0179bac332551c9"
                    },
                    "owner": {
                        "user": {
                            "username": "Barabas"
                        },
                        "profile_img_url": "https://storage.googleapis.com/opensea-static/opensea-profile/8.png",
                        "address": "0xf92b6edd0d62e12f718a5a442d10981c1f6537cf",
                        "config": "",
                        "discord_id": ""
                    },
                    "permalink": "https://opensea.io/assets/0x2d6e10561b320c4f31a903bf0fa92a1ed58637c0/2652054",
                    "collection": {
                        "banner_image_url": "https://lh3.googleusercontent.com/vo_KmiLpxgRzwuJ6VfRDB5vVTEojHIzpyRANC17n1cWU-wCp9lW5LdzhDDIJdaawwel1qDXiPeIingcuCSNv9S-uswU5WCSe06l73w=s2500",
                        "chat_url": null,
                        "created_date": "2019-04-26T22:13:09.996309",
                        "default_to_fiat": false,
                        "description": "Are you ready for a real apocalypse on the blockchain? If so, then fill up your tank and buckle up! War Riders can build their own war vehicles from scratch with customized logos and messaging. Use your vehicle to mine and attack enemies for Benzene.",
                        "dev_buyer_fee_basis_points": "0",
                        "dev_seller_fee_basis_points": "250",
                        "discord_url": "https://discord.gg/trxvDBr",
                        "display_data": {
                            "card_display_style": "cover"
                        },
                        "external_url": "https://warriders.com/",
                        "featured": true,
                        "featured_image_url": "https://storage.opensea.io/0x5caebd3b32e210e85ce3e9d51638b9c445481567-featured-1556589453.png",
                        "hidden": false,
                        "safelist_request_status": "verified",
                        "image_url": "https://lh3.googleusercontent.com/81HmSa05kDXmVKwLTh47ZiYchJIf4lVRtQcVoNF2TPjBOd1kPA07cABHsTId8gFEM6oPffqKbLxZcOfDG-3lsDTg=s60",
                        "is_subject_to_whitelist": false,
                        "large_image_url": "https://lh3.googleusercontent.com/81HmSa05kDXmVKwLTh47ZiYchJIf4lVRtQcVoNF2TPjBOd1kPA07cABHsTId8gFEM6oPffqKbLxZcOfDG-3lsDTg",
                        "medium_username": "vladddy",
                        "name": "War Riders",
                        "only_proxied_transfers": false,
                        "opensea_buyer_fee_basis_points": "0",
                        "opensea_seller_fee_basis_points": "250",
                        "payout_address": "0xfcc60e3ba8e753f131032f26b0179bac332551c9",
                        "require_email": false,
                        "short_description": null,
                        "slug": "war-riders",
                        "telegram_url": "https://t.me/warriders",
                        "twitter_username": "warriders",
                        "instagram_username": null,
                        "wiki_url": null
                    },
                    "decimals": 0,
                    "token_metadata": "https://vault.warriders.com/guns/2/867.json"
                },
                {
                    "id": 13450207,
                    "token_id": "2652190",
                    "num_sales": 0,
                    "background_color": "0b0c22",
                    "image_url": "https://lh3.googleusercontent.com/spfm1c29pfniN5i5j6meMAH1BPRDdTMF96HpzJjRTTybnNp8OX0WFlGOVxfk3SkKUhS1BuP-dmCBI2xjSB5QSK8m",
                    "image_preview_url": "https://lh3.googleusercontent.com/spfm1c29pfniN5i5j6meMAH1BPRDdTMF96HpzJjRTTybnNp8OX0WFlGOVxfk3SkKUhS1BuP-dmCBI2xjSB5QSK8m=s250",
                    "image_thumbnail_url": "https://lh3.googleusercontent.com/spfm1c29pfniN5i5j6meMAH1BPRDdTMF96HpzJjRTTybnNp8OX0WFlGOVxfk3SkKUhS1BuP-dmCBI2xjSB5QSK8m=s128",
                    "image_original_url": "https://storage.googleapis.com/warriders/guns/90ff874d2cfb8c8728420aefb616165b089b68d.png",
                    "animation_url": null,
                    "animation_original_url": null,
                    "name": "Platinum M134C Minigun",
                    "description": "The M134C Minigun is a crypto-version of the classic six-barrel rotary machine gun with a high, sustained rate of fire. It features a Gatling-style rotating barrel with electric motor and an old cryptocurrency miner that controls the rotation and automatic firing.",
                    "external_link": "https://app.warriders.com/guns/midgrade/1003",
                    "asset_contract": {
                        "address": "0x2d6e10561b320c4f31a903bf0fa92a1ed58637c0",
                        "asset_contract_type": "non-fungible",
                        "created_date": "2019-10-18T01:20:55.714142",
                        "name": "War Riders Gun",
                        "nft_version": "3.0",
                        "opensea_version": null,
                        "owner": 113102,
                        "schema_name": "ERC721",
                        "symbol": "",
                        "total_supply": "70",
                        "description": "Are you ready for a real apocalypse on the blockchain? If so, then fill up your tank and buckle up! War Riders can build their own war vehicles from scratch with customized logos and messaging. Use your vehicle to mine and attack enemies for Benzene.",
                        "external_link": "https://warriders.com/",
                        "image_url": "https://lh3.googleusercontent.com/81HmSa05kDXmVKwLTh47ZiYchJIf4lVRtQcVoNF2TPjBOd1kPA07cABHsTId8gFEM6oPffqKbLxZcOfDG-3lsDTg=s60",
                        "default_to_fiat": false,
                        "dev_buyer_fee_basis_points": 0,
                        "dev_seller_fee_basis_points": 250,
                        "only_proxied_transfers": false,
                        "opensea_buyer_fee_basis_points": 0,
                        "opensea_seller_fee_basis_points": 250,
                        "buyer_fee_basis_points": 0,
                        "seller_fee_basis_points": 500,
                        "payout_address": "0xfcc60e3ba8e753f131032f26b0179bac332551c9"
                    },
                    "owner": {
                        "user": {
                            "username": "Barabas"
                        },
                        "profile_img_url": "https://storage.googleapis.com/opensea-static/opensea-profile/8.png",
                        "address": "0xf92b6edd0d62e12f718a5a442d10981c1f6537cf",
                        "config": "",
                        "discord_id": ""
                    },
                    "permalink": "https://opensea.io/assets/0x2d6e10561b320c4f31a903bf0fa92a1ed58637c0/2652190",
                    "collection": {
                        "banner_image_url": "https://lh3.googleusercontent.com/vo_KmiLpxgRzwuJ6VfRDB5vVTEojHIzpyRANC17n1cWU-wCp9lW5LdzhDDIJdaawwel1qDXiPeIingcuCSNv9S-uswU5WCSe06l73w=s2500",
                        "chat_url": null,
                        "created_date": "2019-04-26T22:13:09.996309",
                        "default_to_fiat": false,
                        "description": "Are you ready for a real apocalypse on the blockchain? If so, then fill up your tank and buckle up! War Riders can build their own war vehicles from scratch with customized logos and messaging. Use your vehicle to mine and attack enemies for Benzene.",
                        "dev_buyer_fee_basis_points": "0",
                        "dev_seller_fee_basis_points": "250",
                        "discord_url": "https://discord.gg/trxvDBr",
                        "display_data": {
                            "card_display_style": "cover"
                        },
                        "external_url": "https://warriders.com/",
                        "featured": true,
                        "featured_image_url": "https://storage.opensea.io/0x5caebd3b32e210e85ce3e9d51638b9c445481567-featured-1556589453.png",
                        "hidden": false,
                        "safelist_request_status": "verified",
                        "image_url": "https://lh3.googleusercontent.com/81HmSa05kDXmVKwLTh47ZiYchJIf4lVRtQcVoNF2TPjBOd1kPA07cABHsTId8gFEM6oPffqKbLxZcOfDG-3lsDTg=s60",
                        "is_subject_to_whitelist": false,
                        "large_image_url": "https://lh3.googleusercontent.com/81HmSa05kDXmVKwLTh47ZiYchJIf4lVRtQcVoNF2TPjBOd1kPA07cABHsTId8gFEM6oPffqKbLxZcOfDG-3lsDTg",
                        "medium_username": "vladddy",
                        "name": "War Riders",
                        "only_proxied_transfers": false,
                        "opensea_buyer_fee_basis_points": "0",
                        "opensea_seller_fee_basis_points": "250",
                        "payout_address": "0xfcc60e3ba8e753f131032f26b0179bac332551c9",
                        "require_email": false,
                        "short_description": null,
                        "slug": "war-riders",
                        "telegram_url": "https://t.me/warriders",
                        "twitter_username": "warriders",
                        "instagram_username": null,
                        "wiki_url": null
                    },
                    "decimals": 0,
                    "token_metadata": "https://vault.warriders.com/guns/2/1003.json"
                },
                {
                    "id": 13450431,
                    "token_id": "2656020",
                    "num_sales": 0,
                    "background_color": "0b0c22",
                    "image_url": "https://lh3.googleusercontent.com/R829OMY6aaDnaIMZs5IyKJVHVn6XGb8ObeP831itlRp_4X5LzIZpC5icLIwNoim0u7PdNmhGhEf2499unDKU4mlW",
                    "image_preview_url": "https://lh3.googleusercontent.com/R829OMY6aaDnaIMZs5IyKJVHVn6XGb8ObeP831itlRp_4X5LzIZpC5icLIwNoim0u7PdNmhGhEf2499unDKU4mlW=s250",
                    "image_thumbnail_url": "https://lh3.googleusercontent.com/R829OMY6aaDnaIMZs5IyKJVHVn6XGb8ObeP831itlRp_4X5LzIZpC5icLIwNoim0u7PdNmhGhEf2499unDKU4mlW=s128",
                    "image_original_url": "https://storage.googleapis.com/warriders/guns/20df26b03d1016c4b2010d535c8e262ee89be0f.png",
                    "animation_url": null,
                    "animation_original_url": null,
                    "name": "APOLLO Platinum M2c Browning",
                    "description": "The M2c Browning is a computer-controlled version of an automatic, recoil operated, air-cooled machine gun with disintegrating metallic link-belt that is used to feed the ammunition into the weapon. Traditional spade grips and trigger were replaced with a digital trigger that is controlled by a small, single-board computer.",
                    "external_link": "https://app.warriders.com/guns/premium/1721",
                    "asset_contract": {
                        "address": "0x2d6e10561b320c4f31a903bf0fa92a1ed58637c0",
                        "asset_contract_type": "non-fungible",
                        "created_date": "2019-10-18T01:20:55.714142",
                        "name": "War Riders Gun",
                        "nft_version": "3.0",
                        "opensea_version": null,
                        "owner": 113102,
                        "schema_name": "ERC721",
                        "symbol": "",
                        "total_supply": "70",
                        "description": "Are you ready for a real apocalypse on the blockchain? If so, then fill up your tank and buckle up! War Riders can build their own war vehicles from scratch with customized logos and messaging. Use your vehicle to mine and attack enemies for Benzene.",
                        "external_link": "https://warriders.com/",
                        "image_url": "https://lh3.googleusercontent.com/81HmSa05kDXmVKwLTh47ZiYchJIf4lVRtQcVoNF2TPjBOd1kPA07cABHsTId8gFEM6oPffqKbLxZcOfDG-3lsDTg=s60",
                        "default_to_fiat": false,
                        "dev_buyer_fee_basis_points": 0,
                        "dev_seller_fee_basis_points": 250,
                        "only_proxied_transfers": false,
                        "opensea_buyer_fee_basis_points": 0,
                        "opensea_seller_fee_basis_points": 250,
                        "buyer_fee_basis_points": 0,
                        "seller_fee_basis_points": 500,
                        "payout_address": "0xfcc60e3ba8e753f131032f26b0179bac332551c9"
                    },
                    "owner": {
                        "user": {
                            "username": "Barabas"
                        },
                        "profile_img_url": "https://storage.googleapis.com/opensea-static/opensea-profile/8.png",
                        "address": "0xf92b6edd0d62e12f718a5a442d10981c1f6537cf",
                        "config": "",
                        "discord_id": ""
                    },
                    "permalink": "https://opensea.io/assets/0x2d6e10561b320c4f31a903bf0fa92a1ed58637c0/2656020",
                    "collection": {
                        "banner_image_url": "https://lh3.googleusercontent.com/vo_KmiLpxgRzwuJ6VfRDB5vVTEojHIzpyRANC17n1cWU-wCp9lW5LdzhDDIJdaawwel1qDXiPeIingcuCSNv9S-uswU5WCSe06l73w=s2500",
                        "chat_url": null,
                        "created_date": "2019-04-26T22:13:09.996309",
                        "default_to_fiat": false,
                        "description": "Are you ready for a real apocalypse on the blockchain? If so, then fill up your tank and buckle up! War Riders can build their own war vehicles from scratch with customized logos and messaging. Use your vehicle to mine and attack enemies for Benzene.",
                        "dev_buyer_fee_basis_points": "0",
                        "dev_seller_fee_basis_points": "250",
                        "discord_url": "https://discord.gg/trxvDBr",
                        "display_data": {
                            "card_display_style": "cover"
                        },
                        "external_url": "https://warriders.com/",
                        "featured": true,
                        "featured_image_url": "https://storage.opensea.io/0x5caebd3b32e210e85ce3e9d51638b9c445481567-featured-1556589453.png",
                        "hidden": false,
                        "safelist_request_status": "verified",
                        "image_url": "https://lh3.googleusercontent.com/81HmSa05kDXmVKwLTh47ZiYchJIf4lVRtQcVoNF2TPjBOd1kPA07cABHsTId8gFEM6oPffqKbLxZcOfDG-3lsDTg=s60",
                        "is_subject_to_whitelist": false,
                        "large_image_url": "https://lh3.googleusercontent.com/81HmSa05kDXmVKwLTh47ZiYchJIf4lVRtQcVoNF2TPjBOd1kPA07cABHsTId8gFEM6oPffqKbLxZcOfDG-3lsDTg",
                        "medium_username": "vladddy",
                        "name": "War Riders",
                        "only_proxied_transfers": false,
                        "opensea_buyer_fee_basis_points": "0",
                        "opensea_seller_fee_basis_points": "250",
                        "payout_address": "0xfcc60e3ba8e753f131032f26b0179bac332551c9",
                        "require_email": false,
                        "short_description": null,
                        "slug": "war-riders",
                        "telegram_url": "https://t.me/warriders",
                        "twitter_username": "warriders",
                        "instagram_username": null,
                        "wiki_url": null
                    },
                    "decimals": 0,
                    "token_metadata": "https://vault.warriders.com/guns/1/1721.json"
                },
                {
                    "id": 13450462,
                    "token_id": "2656048",
                    "num_sales": 0,
                    "background_color": "0b0c22",
                    "image_url": "https://lh3.googleusercontent.com/DBeG7IDfvkmATLEtaQ3DU4QnZ4QuAS6uc14VRRRiZhxhQsfeZjjgQK_DhSAJ7MDQEgNroOgh1R3aCnC2K7TfFnYfUw",
                    "image_preview_url": "https://lh3.googleusercontent.com/DBeG7IDfvkmATLEtaQ3DU4QnZ4QuAS6uc14VRRRiZhxhQsfeZjjgQK_DhSAJ7MDQEgNroOgh1R3aCnC2K7TfFnYfUw=s250",
                    "image_thumbnail_url": "https://lh3.googleusercontent.com/DBeG7IDfvkmATLEtaQ3DU4QnZ4QuAS6uc14VRRRiZhxhQsfeZjjgQK_DhSAJ7MDQEgNroOgh1R3aCnC2K7TfFnYfUw=s128",
                    "image_original_url": "https://storage.googleapis.com/warriders/guns/3b1bc2460b1c4e1d43344294b8960c609990db2.png",
                    "animation_url": null,
                    "animation_original_url": null,
                    "name": "DEATH Platinum M134C Minigun",
                    "description": "The M134C Minigun is a crypto-version of the classic six-barrel rotary machine gun with a high, sustained rate of fire. It features a Gatling-style rotating barrel with electric motor and an old cryptocurrency miner that controls the rotation and automatic firing.",
                    "external_link": "https://app.warriders.com/guns/premium/1749",
                    "asset_contract": {
                        "address": "0x2d6e10561b320c4f31a903bf0fa92a1ed58637c0",
                        "asset_contract_type": "non-fungible",
                        "created_date": "2019-10-18T01:20:55.714142",
                        "name": "War Riders Gun",
                        "nft_version": "3.0",
                        "opensea_version": null,
                        "owner": 113102,
                        "schema_name": "ERC721",
                        "symbol": "",
                        "total_supply": "70",
                        "description": "Are you ready for a real apocalypse on the blockchain? If so, then fill up your tank and buckle up! War Riders can build their own war vehicles from scratch with customized logos and messaging. Use your vehicle to mine and attack enemies for Benzene.",
                        "external_link": "https://warriders.com/",
                        "image_url": "https://lh3.googleusercontent.com/81HmSa05kDXmVKwLTh47ZiYchJIf4lVRtQcVoNF2TPjBOd1kPA07cABHsTId8gFEM6oPffqKbLxZcOfDG-3lsDTg=s60",
                        "default_to_fiat": false,
                        "dev_buyer_fee_basis_points": 0,
                        "dev_seller_fee_basis_points": 250,
                        "only_proxied_transfers": false,
                        "opensea_buyer_fee_basis_points": 0,
                        "opensea_seller_fee_basis_points": 250,
                        "buyer_fee_basis_points": 0,
                        "seller_fee_basis_points": 500,
                        "payout_address": "0xfcc60e3ba8e753f131032f26b0179bac332551c9"
                    },
                    "owner": {
                        "user": {
                            "username": "Barabas"
                        },
                        "profile_img_url": "https://storage.googleapis.com/opensea-static/opensea-profile/8.png",
                        "address": "0xf92b6edd0d62e12f718a5a442d10981c1f6537cf",
                        "config": "",
                        "discord_id": ""
                    },
                    "permalink": "https://opensea.io/assets/0x2d6e10561b320c4f31a903bf0fa92a1ed58637c0/2656048",
                    "collection": {
                        "banner_image_url": "https://lh3.googleusercontent.com/vo_KmiLpxgRzwuJ6VfRDB5vVTEojHIzpyRANC17n1cWU-wCp9lW5LdzhDDIJdaawwel1qDXiPeIingcuCSNv9S-uswU5WCSe06l73w=s2500",
                        "chat_url": null,
                        "created_date": "2019-04-26T22:13:09.996309",
                        "default_to_fiat": false,
                        "description": "Are you ready for a real apocalypse on the blockchain? If so, then fill up your tank and buckle up! War Riders can build their own war vehicles from scratch with customized logos and messaging. Use your vehicle to mine and attack enemies for Benzene.",
                        "dev_buyer_fee_basis_points": "0",
                        "dev_seller_fee_basis_points": "250",
                        "discord_url": "https://discord.gg/trxvDBr",
                        "display_data": {
                            "card_display_style": "cover"
                        },
                        "external_url": "https://warriders.com/",
                        "featured": true,
                        "featured_image_url": "https://storage.opensea.io/0x5caebd3b32e210e85ce3e9d51638b9c445481567-featured-1556589453.png",
                        "hidden": false,
                        "safelist_request_status": "verified",
                        "image_url": "https://lh3.googleusercontent.com/81HmSa05kDXmVKwLTh47ZiYchJIf4lVRtQcVoNF2TPjBOd1kPA07cABHsTId8gFEM6oPffqKbLxZcOfDG-3lsDTg=s60",
                        "is_subject_to_whitelist": false,
                        "large_image_url": "https://lh3.googleusercontent.com/81HmSa05kDXmVKwLTh47ZiYchJIf4lVRtQcVoNF2TPjBOd1kPA07cABHsTId8gFEM6oPffqKbLxZcOfDG-3lsDTg",
                        "medium_username": "vladddy",
                        "name": "War Riders",
                        "only_proxied_transfers": false,
                        "opensea_buyer_fee_basis_points": "0",
                        "opensea_seller_fee_basis_points": "250",
                        "payout_address": "0xfcc60e3ba8e753f131032f26b0179bac332551c9",
                        "require_email": false,
                        "short_description": null,
                        "slug": "war-riders",
                        "telegram_url": "https://t.me/warriders",
                        "twitter_username": "warriders",
                        "instagram_username": null,
                        "wiki_url": null
                    },
                    "decimals": 0,
                    "token_metadata": "https://vault.warriders.com/guns/1/1749.json"
                },
                {
                    "id": 13450620,
                    "token_id": "2660017",
                    "num_sales": 0,
                    "background_color": "0b0c22",
                    "image_url": "https://lh3.googleusercontent.com/le9PjJ5v4fgipeeOFmtogZO68Nq6o7B4BczsfwXpnsRi_LXhZBqKUQKQ1LXfXRntVLlfHN1jAeqHLaHyGzaEjp0",
                    "image_preview_url": "https://lh3.googleusercontent.com/le9PjJ5v4fgipeeOFmtogZO68Nq6o7B4BczsfwXpnsRi_LXhZBqKUQKQ1LXfXRntVLlfHN1jAeqHLaHyGzaEjp0=s250",
                    "image_thumbnail_url": "https://lh3.googleusercontent.com/le9PjJ5v4fgipeeOFmtogZO68Nq6o7B4BczsfwXpnsRi_LXhZBqKUQKQ1LXfXRntVLlfHN1jAeqHLaHyGzaEjp0=s128",
                    "image_original_url": "https://storage.googleapis.com/warriders/guns/523c15f468cb368acd64883ac327c5383facb5e.png",
                    "animation_url": null,
                    "animation_original_url": null,
                    "name": "UKRAINE Carbon M5 MAAWS",
                    "description": "The M5 MAAWS is the next generation recoilless anti-tank weapon with extended barrels for maximum effective range. Modified with an autoloader, this gun features continuous firing with no need for manual reloading. Three portable computer units with power supplies provide the weapon with necessary power and logic for fully automated firing.",
                    "external_link": "https://app.warriders.com/guns/premium/1768",
                    "asset_contract": {
                        "address": "0x2d6e10561b320c4f31a903bf0fa92a1ed58637c0",
                        "asset_contract_type": "non-fungible",
                        "created_date": "2019-10-18T01:20:55.714142",
                        "name": "War Riders Gun",
                        "nft_version": "3.0",
                        "opensea_version": null,
                        "owner": 113102,
                        "schema_name": "ERC721",
                        "symbol": "",
                        "total_supply": "70",
                        "description": "Are you ready for a real apocalypse on the blockchain? If so, then fill up your tank and buckle up! War Riders can build their own war vehicles from scratch with customized logos and messaging. Use your vehicle to mine and attack enemies for Benzene.",
                        "external_link": "https://warriders.com/",
                        "image_url": "https://lh3.googleusercontent.com/81HmSa05kDXmVKwLTh47ZiYchJIf4lVRtQcVoNF2TPjBOd1kPA07cABHsTId8gFEM6oPffqKbLxZcOfDG-3lsDTg=s60",
                        "default_to_fiat": false,
                        "dev_buyer_fee_basis_points": 0,
                        "dev_seller_fee_basis_points": 250,
                        "only_proxied_transfers": false,
                        "opensea_buyer_fee_basis_points": 0,
                        "opensea_seller_fee_basis_points": 250,
                        "buyer_fee_basis_points": 0,
                        "seller_fee_basis_points": 500,
                        "payout_address": "0xfcc60e3ba8e753f131032f26b0179bac332551c9"
                    },
                    "owner": {
                        "user": {
                            "username": "Barabas"
                        },
                        "profile_img_url": "https://storage.googleapis.com/opensea-static/opensea-profile/8.png",
                        "address": "0xf92b6edd0d62e12f718a5a442d10981c1f6537cf",
                        "config": "",
                        "discord_id": ""
                    },
                    "permalink": "https://opensea.io/assets/0x2d6e10561b320c4f31a903bf0fa92a1ed58637c0/2660017",
                    "collection": {
                        "banner_image_url": "https://lh3.googleusercontent.com/vo_KmiLpxgRzwuJ6VfRDB5vVTEojHIzpyRANC17n1cWU-wCp9lW5LdzhDDIJdaawwel1qDXiPeIingcuCSNv9S-uswU5WCSe06l73w=s2500",
                        "chat_url": null,
                        "created_date": "2019-04-26T22:13:09.996309",
                        "default_to_fiat": false,
                        "description": "Are you ready for a real apocalypse on the blockchain? If so, then fill up your tank and buckle up! War Riders can build their own war vehicles from scratch with customized logos and messaging. Use your vehicle to mine and attack enemies for Benzene.",
                        "dev_buyer_fee_basis_points": "0",
                        "dev_seller_fee_basis_points": "250",
                        "discord_url": "https://discord.gg/trxvDBr",
                        "display_data": {
                            "card_display_style": "cover"
                        },
                        "external_url": "https://warriders.com/",
                        "featured": true,
                        "featured_image_url": "https://storage.opensea.io/0x5caebd3b32e210e85ce3e9d51638b9c445481567-featured-1556589453.png",
                        "hidden": false,
                        "safelist_request_status": "verified",
                        "image_url": "https://lh3.googleusercontent.com/81HmSa05kDXmVKwLTh47ZiYchJIf4lVRtQcVoNF2TPjBOd1kPA07cABHsTId8gFEM6oPffqKbLxZcOfDG-3lsDTg=s60",
                        "is_subject_to_whitelist": false,
                        "large_image_url": "https://lh3.googleusercontent.com/81HmSa05kDXmVKwLTh47ZiYchJIf4lVRtQcVoNF2TPjBOd1kPA07cABHsTId8gFEM6oPffqKbLxZcOfDG-3lsDTg",
                        "medium_username": "vladddy",
                        "name": "War Riders",
                        "only_proxied_transfers": false,
                        "opensea_buyer_fee_basis_points": "0",
                        "opensea_seller_fee_basis_points": "250",
                        "payout_address": "0xfcc60e3ba8e753f131032f26b0179bac332551c9",
                        "require_email": false,
                        "short_description": null,
                        "slug": "war-riders",
                        "telegram_url": "https://t.me/warriders",
                        "twitter_username": "warriders",
                        "instagram_username": null,
                        "wiki_url": null
                    },
                    "decimals": 0,
                    "token_metadata": "https://vault.warriders.com/guns/1/1768.json"
                }
            ],
            "name": "High end Lambo kit with 6 high end weapons",
            "description": "High end Lambo complete with 6 top tier weapons from each catagory. Price will gradually decrease over 5 days to 3.8 minimum.",
            "external_link": "",
            "asset_contract": null,
            "permalink": "https://opensea.io/bundles/high-end-lambo-kit-with-6-high-end-weapons-DoH",
            "sell_orders": [
                {
                    "created_date": "2021-05-25T22:30:43.905454",
                    "closing_date": "2021-05-30T22:30:15",
                    "closing_extendable": false,
                    "expiration_time": 1622413815,
                    "listing_time": 1621981736,
                    "order_hash": "0x31b66e3aba23882cf71c9d22b244a5005f7e416fe236591453af7f4279424bb4",
                    "metadata": {
                        "bundle": {
                            "assets": [
                                {
                                    "id": "2652012",
                                    "address": "0x2d6e10561b320c4f31a903bf0fa92a1ed58637c0"
                                },
                                {
                                    "id": "2652054",
                                    "address": "0x2d6e10561b320c4f31a903bf0fa92a1ed58637c0"
                                },
                                {
                                    "id": "2652190",
                                    "address": "0x2d6e10561b320c4f31a903bf0fa92a1ed58637c0"
                                },
                                {
                                    "id": "2656020",
                                    "address": "0x2d6e10561b320c4f31a903bf0fa92a1ed58637c0"
                                },
                                {
                                    "id": "2656048",
                                    "address": "0x2d6e10561b320c4f31a903bf0fa92a1ed58637c0"
                                },
                                {
                                    "id": "2660017",
                                    "address": "0x2d6e10561b320c4f31a903bf0fa92a1ed58637c0"
                                },
                                {
                                    "id": "10094051931033639806",
                                    "address": "0x5caebd3b32e210e85ce3e9d51638b9c445481567"
                                }
                            ],
                            "schemas": [
                                "ERC721",
                                "ERC721",
                                "ERC721",
                                "ERC721",
                                "ERC721",
                                "ERC721",
                                "ERC721"
                            ],
                            "name": "High end Lambo kit with 6 high end weapons",
                            "description": "High end Lambo complete with 6 top tier weapons from each catagory. Price will gradually decrease over 5 days to 3.8 minimum.",
                            "external_link": ""
                        }
                    },
                    "exchange": "0x7be8076f4ea4a4ad08075c2508e481d6c946d12b",
                    "maker": {
                        "user": 2660,
                        "profile_img_url": "https://storage.googleapis.com/opensea-static/opensea-profile/8.png",
                        "address": "0xf92b6edd0d62e12f718a5a442d10981c1f6537cf",
                        "config": "",
                        "discord_id": ""
                    },
                    "taker": {
                        "user": 1766,
                        "profile_img_url": "https://storage.googleapis.com/opensea-static/opensea-profile/1.png",
                        "address": "0x0000000000000000000000000000000000000000",
                        "config": "",
                        "discord_id": ""
                    },
                    "current_price": "4793632619636801230.000000000",
                    "current_bounty": "47936326193151053",
                    "bounty_multiple": "0.01",
                    "maker_relayer_fee": "500",
                    "taker_relayer_fee": "0",
                    "maker_protocol_fee": "0",
                    "taker_protocol_fee": "0",
                    "maker_referrer_fee": "0",
                    "fee_recipient": {
                        "user": 3585,
                        "profile_img_url": "https://storage.googleapis.com/opensea-static/opensea-profile/28.png",
                        "address": "0x5b3256965e7c3cf26e11fcaf296dfc8807c01073",
                        "config": "verified",
                        "discord_id": ""
                    },
                    "fee_method": 1,
                    "side": 1,
                    "sale_kind": 1,
                    "target": "0xc99f70bfd82fb7c8f8191fdfbfb735606b15e5c5",
                    "how_to_call": 1,
                    "calldata": "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",
                    "replacement_pattern": "0x0000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000ffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffff0000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000ffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffff0000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000ffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffff0000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000ffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffff0000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000ffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffff0000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000ffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffff0000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000ffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffff000000000000000000000000000000000000000000000000000000000000000000000000",
                    "static_target": "0x0000000000000000000000000000000000000000",
                    "static_extradata": "0x",
                    "payment_token": "0x0000000000000000000000000000000000000000",
                    "payment_token_contract": {
                        "id": 1,
                        "symbol": "ETH",
                        "address": "0x0000000000000000000000000000000000000000",
                        "image_url": "https://storage.opensea.io/files/6f8e2979d428180222796ff4a33ab929.svg",
                        "name": "Ether",
                        "decimals": 18,
                        "eth_price": "1.000000000000000",
                        "usd_price": "2625.730000000000018000"
                    },
                    "base_price": "4800000000000000000",
                    "extra": "1000000000000000000",
                    "quantity": "1",
                    "salt": "6952947488186066071715132687338334074098869596858669124932570097519800584402",
                    "v": 28,
                    "r": "0x5270aaadd4c46586529652a22b4ab561904c29ffb24adc7ee36965d2d740e5ba",
                    "s": "0x23c27437c238d7650fc4fce10f309fe9cea2401e7f3082b54f840c409b0831c2",
                    "approved_on_chain": false,
                    "cancelled": false,
                    "finalized": false,
                    "marked_invalid": false,
                    "prefixed_hash": "0x15128534e953f269194af673065359f5a0ae9940da4a88b73ead61e1467ffe73"
                }
            ]
        },
        {
            "maker": {
                "user": {
                    "username": "Freakygreenfish"
                },
                "profile_img_url": "https://storage.googleapis.com/opensea-static/opensea-profile/12.png",
                "address": "0x54971aae489ded02ee99b0cf6b8707377df97739",
                "config": "",
                "discord_id": ""
            },
            "slug": "digital-frame-pt-1-x1C",
            "assets": [
                {
                    "id": 25596031,
                    "token_id": "38261257331859101212728236245963608895893132356697203263818570157458720817153",
                    "num_sales": 0,
                    "background_color": null,
                    "image_url": "https://lh3.googleusercontent.com/dhO2ewct0oUHJOi9_X8f8vual477L9oyjx375FyvDQ_l8DZsZwMwQROxDuvaYntO6-BS7hNWYMNwMZHeWMVGX5aHn_8GHXDZz6IV8Q",
                    "image_preview_url": "https://lh3.googleusercontent.com/dhO2ewct0oUHJOi9_X8f8vual477L9oyjx375FyvDQ_l8DZsZwMwQROxDuvaYntO6-BS7hNWYMNwMZHeWMVGX5aHn_8GHXDZz6IV8Q=s250",
                    "image_thumbnail_url": "https://lh3.googleusercontent.com/dhO2ewct0oUHJOi9_X8f8vual477L9oyjx375FyvDQ_l8DZsZwMwQROxDuvaYntO6-BS7hNWYMNwMZHeWMVGX5aHn_8GHXDZz6IV8Q=s128",
                    "image_original_url": null,
                    "animation_url": "https://storage.opensea.io/files/22a8f71a6c620003d9df328cd1d12bd9.mp4",
                    "animation_original_url": "https://storage.opensea.io/files/22a8f71a6c620003d9df328cd1d12bd9.mp4",
                    "name": "Digital Frame Title",
                    "description": "Digitalisierung im künstlerischen Rahmen.\n\nDas Projekt „Digital Frame pt.1“ von @freakygreenfish (Luca Mussnig)wird von der Galerie AA Collection auf der Kunstmesse “Parallele Editions” von 26.5-30.5. im Semperdepot in Wien präsentiert. Wie schon bei seinen bisherigen Projekten nutzt Freakygreenfish erneut Social Media als Vermittlungs Kanal seiner Kunst. Dieses mal übernimmt er den digitalen Ausstellungsraum der AA Collection, welcher auf der Plattform TikTok stattfinden soll. \n\nEin breites Vokabular von Techniken wird verwendet um die Thematiken zu bearbeiten. Videos werden über den digitalen Ausstellungsraum der AA Collection veröffentlicht. Musik wird produziert in Kooperation mit A.K.O.R.(Sebastian Pfeifhofer). 3D Animationen werden erstellt und durch Live-Performances, welche vorort stattfinden werden, entkommt das digitale Projekt in die Analoge Welt. \n\n Ein Digital Frame kann die Schnittstelle zwischen der Wirklichkeit und virtueller Realität sein. Was nimmt man aus den verschiedenen Welten mit? Was wird reproduziert?\nMit einem Rahmen verbindet man aber auch das Präsentieren, dies findet auch in digitalen Räumen wie auf Social Media statt. Auf diesen Plattformen werden Likes und Followers zur Selbstlegitimierung/Selbstbestimmung. Während den Lockdowns war das für viele die einzige Möglichkeit von anderen wahrgenommen zu werden. Das Projekt.behandelt genau dieses Spiel mit den Erwartungen für Content Creator, Selbstdarstellung und die Flucht ins die virtuelle Welt durch den digital Frame. \n\n“Dadurch dass meine Generation in einer digitalisierten und viel schnelleren Welt groß geworden ist braucht es neue Konzepte unseren Zeitgeist aufzufangen und Kunst zu vermitteln.” -@freakygreenfish\n",
                    "external_link": "https://www.instagram.com/freakygreenfish/",
                    "asset_contract": {
                        "address": "0x495f947276749ce646f68ac8c248420045cb7b5e",
                        "asset_contract_type": "semi-fungible",
                        "created_date": "2020-12-02T17:40:53.232025",
                        "name": "OpenSea Collection",
                        "nft_version": null,
                        "opensea_version": "2.0.0",
                        "owner": 102384,
                        "schema_name": "ERC1155",
                        "symbol": "OPENSTORE",
                        "total_supply": null,
                        "description": null,
                        "external_link": null,
                        "image_url": null,
                        "default_to_fiat": false,
                        "dev_buyer_fee_basis_points": 0,
                        "dev_seller_fee_basis_points": 0,
                        "only_proxied_transfers": false,
                        "opensea_buyer_fee_basis_points": 0,
                        "opensea_seller_fee_basis_points": 250,
                        "buyer_fee_basis_points": 0,
                        "seller_fee_basis_points": 250,
                        "payout_address": null
                    },
                    "owner": {
                        "user": {
                            "username": "NullAddress"
                        },
                        "profile_img_url": "https://storage.googleapis.com/opensea-static/opensea-profile/1.png",
                        "address": "0x0000000000000000000000000000000000000000",
                        "config": "",
                        "discord_id": ""
                    },
                    "permalink": "https://opensea.io/assets/0x495f947276749ce646f68ac8c248420045cb7b5e/38261257331859101212728236245963608895893132356697203263818570157458720817153",
                    "collection": {
                        "banner_image_url": "https://lh3.googleusercontent.com/dhO2ewct0oUHJOi9_X8f8vual477L9oyjx375FyvDQ_l8DZsZwMwQROxDuvaYntO6-BS7hNWYMNwMZHeWMVGX5aHn_8GHXDZz6IV8Q=s2500",
                        "chat_url": null,
                        "created_date": "2021-05-24T16:30:46.792706",
                        "default_to_fiat": false,
                        "description": "This is the Nft collection of a multimedia Project from the Artist Freakygreenfish. The Pieces were made for the first Part of the Performance Digital Frame, which takes place at the art fair Parallel Editions 2021 in vienna. The young artist is presenting his art on  Social media in a way it hasn´t been done  before.  ",
                        "dev_buyer_fee_basis_points": "0",
                        "dev_seller_fee_basis_points": "0",
                        "discord_url": null,
                        "display_data": {
                            "card_display_style": "contain",
                            "images": []
                        },
                        "external_url": null,
                        "featured": false,
                        "featured_image_url": null,
                        "hidden": true,
                        "safelist_request_status": "not_requested",
                        "image_url": "https://lh3.googleusercontent.com/QdQVTLTkg_tfd-_Amse_REaFkaTxiwtXO7ZjXAMLfw-o3XwadX3kGL_0XGSPxctIkkNvdyXvXTq7FlkwJ4ITU8OC4KJccTAhgaBY=s120",
                        "is_subject_to_whitelist": false,
                        "large_image_url": null,
                        "medium_username": null,
                        "name": "Digital Frame pt.1.",
                        "only_proxied_transfers": false,
                        "opensea_buyer_fee_basis_points": "0",
                        "opensea_seller_fee_basis_points": "250",
                        "payout_address": null,
                        "require_email": false,
                        "short_description": null,
                        "slug": "digital-frame-pt-1",
                        "telegram_url": null,
                        "twitter_username": null,
                        "instagram_username": null,
                        "wiki_url": null
                    },
                    "decimals": null,
                    "token_metadata": null
                },
                {
                    "id": 25662744,
                    "token_id": "38261257331859101212728236245963608895893132356697203263818570158558232444929",
                    "num_sales": 0,
                    "background_color": null,
                    "image_url": "https://lh3.googleusercontent.com/8wqTTmq8Tcd0e5WP4MG6YtkoabHFPuYVaCjrkp81R55P2v65rL3KFZzCPC4Su9jfF-dYv-3ibInBZsYf9g-VU2LW2NQ-VGkFqFpUvg",
                    "image_preview_url": "https://lh3.googleusercontent.com/8wqTTmq8Tcd0e5WP4MG6YtkoabHFPuYVaCjrkp81R55P2v65rL3KFZzCPC4Su9jfF-dYv-3ibInBZsYf9g-VU2LW2NQ-VGkFqFpUvg=s250",
                    "image_thumbnail_url": "https://lh3.googleusercontent.com/8wqTTmq8Tcd0e5WP4MG6YtkoabHFPuYVaCjrkp81R55P2v65rL3KFZzCPC4Su9jfF-dYv-3ibInBZsYf9g-VU2LW2NQ-VGkFqFpUvg=s128",
                    "image_original_url": null,
                    "animation_url": "https://storage.opensea.io/files/4e8c611ba6fc298a59db62fb57ed8f7d.mp4",
                    "animation_original_url": "https://storage.opensea.io/files/4e8c611ba6fc298a59db62fb57ed8f7d.mp4",
                    "name": "Digital Frame Banner",
                    "description": "This Item is the Banner of the Project Digital Frame",
                    "external_link": null,
                    "asset_contract": {
                        "address": "0x495f947276749ce646f68ac8c248420045cb7b5e",
                        "asset_contract_type": "semi-fungible",
                        "created_date": "2020-12-02T17:40:53.232025",
                        "name": "OpenSea Collection",
                        "nft_version": null,
                        "opensea_version": "2.0.0",
                        "owner": 102384,
                        "schema_name": "ERC1155",
                        "symbol": "OPENSTORE",
                        "total_supply": null,
                        "description": null,
                        "external_link": null,
                        "image_url": null,
                        "default_to_fiat": false,
                        "dev_buyer_fee_basis_points": 0,
                        "dev_seller_fee_basis_points": 0,
                        "only_proxied_transfers": false,
                        "opensea_buyer_fee_basis_points": 0,
                        "opensea_seller_fee_basis_points": 250,
                        "buyer_fee_basis_points": 0,
                        "seller_fee_basis_points": 250,
                        "payout_address": null
                    },
                    "owner": {
                        "user": {
                            "username": "NullAddress"
                        },
                        "profile_img_url": "https://storage.googleapis.com/opensea-static/opensea-profile/1.png",
                        "address": "0x0000000000000000000000000000000000000000",
                        "config": "",
                        "discord_id": ""
                    },
                    "permalink": "https://opensea.io/assets/0x495f947276749ce646f68ac8c248420045cb7b5e/38261257331859101212728236245963608895893132356697203263818570158558232444929",
                    "collection": {
                        "banner_image_url": "https://lh3.googleusercontent.com/dhO2ewct0oUHJOi9_X8f8vual477L9oyjx375FyvDQ_l8DZsZwMwQROxDuvaYntO6-BS7hNWYMNwMZHeWMVGX5aHn_8GHXDZz6IV8Q=s2500",
                        "chat_url": null,
                        "created_date": "2021-05-24T16:30:46.792706",
                        "default_to_fiat": false,
                        "description": "This is the Nft collection of a multimedia Project from the Artist Freakygreenfish. The Pieces were made for the first Part of the Performance Digital Frame, which takes place at the art fair Parallel Editions 2021 in vienna. The young artist is presenting his art on  Social media in a way it hasn´t been done  before.  ",
                        "dev_buyer_fee_basis_points": "0",
                        "dev_seller_fee_basis_points": "0",
                        "discord_url": null,
                        "display_data": {
                            "card_display_style": "contain",
                            "images": []
                        },
                        "external_url": null,
                        "featured": false,
                        "featured_image_url": null,
                        "hidden": true,
                        "safelist_request_status": "not_requested",
                        "image_url": "https://lh3.googleusercontent.com/QdQVTLTkg_tfd-_Amse_REaFkaTxiwtXO7ZjXAMLfw-o3XwadX3kGL_0XGSPxctIkkNvdyXvXTq7FlkwJ4ITU8OC4KJccTAhgaBY=s120",
                        "is_subject_to_whitelist": false,
                        "large_image_url": null,
                        "medium_username": null,
                        "name": "Digital Frame pt.1.",
                        "only_proxied_transfers": false,
                        "opensea_buyer_fee_basis_points": "0",
                        "opensea_seller_fee_basis_points": "250",
                        "payout_address": null,
                        "require_email": false,
                        "short_description": null,
                        "slug": "digital-frame-pt-1",
                        "telegram_url": null,
                        "twitter_username": null,
                        "instagram_username": null,
                        "wiki_url": null
                    },
                    "decimals": null,
                    "token_metadata": null
                },
                {
                    "id": 25663627,
                    "token_id": "38261257331859101212728236245963608895893132356697203263818570159657744072705",
                    "num_sales": 0,
                    "background_color": null,
                    "image_url": "https://lh3.googleusercontent.com/qBqKg_cavzCGiJgS3clQQg1TWy7HEhjUC6Lrv_rjtXlcqKVHfrzKua8tYdZblKzdLr-EyUYu6Dgj8M6wBsYKiWyYFByPoRRW-a033w",
                    "image_preview_url": "https://lh3.googleusercontent.com/qBqKg_cavzCGiJgS3clQQg1TWy7HEhjUC6Lrv_rjtXlcqKVHfrzKua8tYdZblKzdLr-EyUYu6Dgj8M6wBsYKiWyYFByPoRRW-a033w=s250",
                    "image_thumbnail_url": "https://lh3.googleusercontent.com/qBqKg_cavzCGiJgS3clQQg1TWy7HEhjUC6Lrv_rjtXlcqKVHfrzKua8tYdZblKzdLr-EyUYu6Dgj8M6wBsYKiWyYFByPoRRW-a033w=s128",
                    "image_original_url": null,
                    "animation_url": "https://storage.opensea.io/files/5ede8c1a5aab656f0dfe995d5b4688d2.mp4",
                    "animation_original_url": "https://storage.opensea.io/files/5ede8c1a5aab656f0dfe995d5b4688d2.mp4",
                    "name": "AngryMuscle",
                    "description": "This special character ist part of the \"Digital Frame\" cast. His name Is Angry muscle.",
                    "external_link": null,
                    "asset_contract": {
                        "address": "0x495f947276749ce646f68ac8c248420045cb7b5e",
                        "asset_contract_type": "semi-fungible",
                        "created_date": "2020-12-02T17:40:53.232025",
                        "name": "OpenSea Collection",
                        "nft_version": null,
                        "opensea_version": "2.0.0",
                        "owner": 102384,
                        "schema_name": "ERC1155",
                        "symbol": "OPENSTORE",
                        "total_supply": null,
                        "description": null,
                        "external_link": null,
                        "image_url": null,
                        "default_to_fiat": false,
                        "dev_buyer_fee_basis_points": 0,
                        "dev_seller_fee_basis_points": 0,
                        "only_proxied_transfers": false,
                        "opensea_buyer_fee_basis_points": 0,
                        "opensea_seller_fee_basis_points": 250,
                        "buyer_fee_basis_points": 0,
                        "seller_fee_basis_points": 250,
                        "payout_address": null
                    },
                    "owner": {
                        "user": {
                            "username": "NullAddress"
                        },
                        "profile_img_url": "https://storage.googleapis.com/opensea-static/opensea-profile/1.png",
                        "address": "0x0000000000000000000000000000000000000000",
                        "config": "",
                        "discord_id": ""
                    },
                    "permalink": "https://opensea.io/assets/0x495f947276749ce646f68ac8c248420045cb7b5e/38261257331859101212728236245963608895893132356697203263818570159657744072705",
                    "collection": {
                        "banner_image_url": "https://lh3.googleusercontent.com/dhO2ewct0oUHJOi9_X8f8vual477L9oyjx375FyvDQ_l8DZsZwMwQROxDuvaYntO6-BS7hNWYMNwMZHeWMVGX5aHn_8GHXDZz6IV8Q=s2500",
                        "chat_url": null,
                        "created_date": "2021-05-24T16:30:46.792706",
                        "default_to_fiat": false,
                        "description": "This is the Nft collection of a multimedia Project from the Artist Freakygreenfish. The Pieces were made for the first Part of the Performance Digital Frame, which takes place at the art fair Parallel Editions 2021 in vienna. The young artist is presenting his art on  Social media in a way it hasn´t been done  before.  ",
                        "dev_buyer_fee_basis_points": "0",
                        "dev_seller_fee_basis_points": "0",
                        "discord_url": null,
                        "display_data": {
                            "card_display_style": "contain",
                            "images": []
                        },
                        "external_url": null,
                        "featured": false,
                        "featured_image_url": null,
                        "hidden": true,
                        "safelist_request_status": "not_requested",
                        "image_url": "https://lh3.googleusercontent.com/QdQVTLTkg_tfd-_Amse_REaFkaTxiwtXO7ZjXAMLfw-o3XwadX3kGL_0XGSPxctIkkNvdyXvXTq7FlkwJ4ITU8OC4KJccTAhgaBY=s120",
                        "is_subject_to_whitelist": false,
                        "large_image_url": null,
                        "medium_username": null,
                        "name": "Digital Frame pt.1.",
                        "only_proxied_transfers": false,
                        "opensea_buyer_fee_basis_points": "0",
                        "opensea_seller_fee_basis_points": "250",
                        "payout_address": null,
                        "require_email": false,
                        "short_description": null,
                        "slug": "digital-frame-pt-1",
                        "telegram_url": null,
                        "twitter_username": null,
                        "instagram_username": null,
                        "wiki_url": null
                    },
                    "decimals": null,
                    "token_metadata": null
                },
                {
                    "id": 25663757,
                    "token_id": "38261257331859101212728236245963608895893132356697203263818570160757255700481",
                    "num_sales": 0,
                    "background_color": null,
                    "image_url": "https://lh3.googleusercontent.com/as6pHMDbCQp9A-P3taqvP_kJX9OIGF_hY1AQ7azYVnCSkl0bNTVqQCjAwrWvrDYnv9gF_gWhp9QmkTm9YFHME6US7VEuaK1GnvPQWgg",
                    "image_preview_url": "https://lh3.googleusercontent.com/as6pHMDbCQp9A-P3taqvP_kJX9OIGF_hY1AQ7azYVnCSkl0bNTVqQCjAwrWvrDYnv9gF_gWhp9QmkTm9YFHME6US7VEuaK1GnvPQWgg=s250",
                    "image_thumbnail_url": "https://lh3.googleusercontent.com/as6pHMDbCQp9A-P3taqvP_kJX9OIGF_hY1AQ7azYVnCSkl0bNTVqQCjAwrWvrDYnv9gF_gWhp9QmkTm9YFHME6US7VEuaK1GnvPQWgg=s128",
                    "image_original_url": null,
                    "animation_url": "https://storage.opensea.io/files/938cce49566bea5869230c59d19c1de9.mp4",
                    "animation_original_url": "https://storage.opensea.io/files/938cce49566bea5869230c59d19c1de9.mp4",
                    "name": "Supermanstrainer",
                    "description": "This special character is part of the \"Digital Frame\" cast. He retired from beeing Supermans Trainer and now he is doing TikTok dances. ",
                    "external_link": null,
                    "asset_contract": {
                        "address": "0x495f947276749ce646f68ac8c248420045cb7b5e",
                        "asset_contract_type": "semi-fungible",
                        "created_date": "2020-12-02T17:40:53.232025",
                        "name": "OpenSea Collection",
                        "nft_version": null,
                        "opensea_version": "2.0.0",
                        "owner": 102384,
                        "schema_name": "ERC1155",
                        "symbol": "OPENSTORE",
                        "total_supply": null,
                        "description": null,
                        "external_link": null,
                        "image_url": null,
                        "default_to_fiat": false,
                        "dev_buyer_fee_basis_points": 0,
                        "dev_seller_fee_basis_points": 0,
                        "only_proxied_transfers": false,
                        "opensea_buyer_fee_basis_points": 0,
                        "opensea_seller_fee_basis_points": 250,
                        "buyer_fee_basis_points": 0,
                        "seller_fee_basis_points": 250,
                        "payout_address": null
                    },
                    "owner": {
                        "user": {
                            "username": "NullAddress"
                        },
                        "profile_img_url": "https://storage.googleapis.com/opensea-static/opensea-profile/1.png",
                        "address": "0x0000000000000000000000000000000000000000",
                        "config": "",
                        "discord_id": ""
                    },
                    "permalink": "https://opensea.io/assets/0x495f947276749ce646f68ac8c248420045cb7b5e/38261257331859101212728236245963608895893132356697203263818570160757255700481",
                    "collection": {
                        "banner_image_url": "https://lh3.googleusercontent.com/dhO2ewct0oUHJOi9_X8f8vual477L9oyjx375FyvDQ_l8DZsZwMwQROxDuvaYntO6-BS7hNWYMNwMZHeWMVGX5aHn_8GHXDZz6IV8Q=s2500",
                        "chat_url": null,
                        "created_date": "2021-05-24T16:30:46.792706",
                        "default_to_fiat": false,
                        "description": "This is the Nft collection of a multimedia Project from the Artist Freakygreenfish. The Pieces were made for the first Part of the Performance Digital Frame, which takes place at the art fair Parallel Editions 2021 in vienna. The young artist is presenting his art on  Social media in a way it hasn´t been done  before.  ",
                        "dev_buyer_fee_basis_points": "0",
                        "dev_seller_fee_basis_points": "0",
                        "discord_url": null,
                        "display_data": {
                            "card_display_style": "contain",
                            "images": []
                        },
                        "external_url": null,
                        "featured": false,
                        "featured_image_url": null,
                        "hidden": true,
                        "safelist_request_status": "not_requested",
                        "image_url": "https://lh3.googleusercontent.com/QdQVTLTkg_tfd-_Amse_REaFkaTxiwtXO7ZjXAMLfw-o3XwadX3kGL_0XGSPxctIkkNvdyXvXTq7FlkwJ4ITU8OC4KJccTAhgaBY=s120",
                        "is_subject_to_whitelist": false,
                        "large_image_url": null,
                        "medium_username": null,
                        "name": "Digital Frame pt.1.",
                        "only_proxied_transfers": false,
                        "opensea_buyer_fee_basis_points": "0",
                        "opensea_seller_fee_basis_points": "250",
                        "payout_address": null,
                        "require_email": false,
                        "short_description": null,
                        "slug": "digital-frame-pt-1",
                        "telegram_url": null,
                        "twitter_username": null,
                        "instagram_username": null,
                        "wiki_url": null
                    },
                    "decimals": null,
                    "token_metadata": null
                },
                {
                    "id": 25664060,
                    "token_id": "38261257331859101212728236245963608895893132356697203263818570161856767328257",
                    "num_sales": 0,
                    "background_color": null,
                    "image_url": "https://lh3.googleusercontent.com/73dA4Lp2pD-n_-0vD0HZCFkZEE6a4OtXUliN7CVnAQcmRYIiBkIvsJ7GT70eLoV_RSQkh4MOIeIdiBC0czPtqO3VygeRTbhpsarIwl0",
                    "image_preview_url": "https://lh3.googleusercontent.com/73dA4Lp2pD-n_-0vD0HZCFkZEE6a4OtXUliN7CVnAQcmRYIiBkIvsJ7GT70eLoV_RSQkh4MOIeIdiBC0czPtqO3VygeRTbhpsarIwl0=s250",
                    "image_thumbnail_url": "https://lh3.googleusercontent.com/73dA4Lp2pD-n_-0vD0HZCFkZEE6a4OtXUliN7CVnAQcmRYIiBkIvsJ7GT70eLoV_RSQkh4MOIeIdiBC0czPtqO3VygeRTbhpsarIwl0=s128",
                    "image_original_url": null,
                    "animation_url": "https://storage.opensea.io/files/da4ad8c5eed8a61be5ec3b3b6892986f.mp4",
                    "animation_original_url": "https://storage.opensea.io/files/da4ad8c5eed8a61be5ec3b3b6892986f.mp4",
                    "name": "Holy Algorithm",
                    "description": "This is the Holy Algorithm. Pray.",
                    "external_link": null,
                    "asset_contract": {
                        "address": "0x495f947276749ce646f68ac8c248420045cb7b5e",
                        "asset_contract_type": "semi-fungible",
                        "created_date": "2020-12-02T17:40:53.232025",
                        "name": "OpenSea Collection",
                        "nft_version": null,
                        "opensea_version": "2.0.0",
                        "owner": 102384,
                        "schema_name": "ERC1155",
                        "symbol": "OPENSTORE",
                        "total_supply": null,
                        "description": null,
                        "external_link": null,
                        "image_url": null,
                        "default_to_fiat": false,
                        "dev_buyer_fee_basis_points": 0,
                        "dev_seller_fee_basis_points": 0,
                        "only_proxied_transfers": false,
                        "opensea_buyer_fee_basis_points": 0,
                        "opensea_seller_fee_basis_points": 250,
                        "buyer_fee_basis_points": 0,
                        "seller_fee_basis_points": 250,
                        "payout_address": null
                    },
                    "owner": {
                        "user": {
                            "username": "NullAddress"
                        },
                        "profile_img_url": "https://storage.googleapis.com/opensea-static/opensea-profile/1.png",
                        "address": "0x0000000000000000000000000000000000000000",
                        "config": "",
                        "discord_id": ""
                    },
                    "permalink": "https://opensea.io/assets/0x495f947276749ce646f68ac8c248420045cb7b5e/38261257331859101212728236245963608895893132356697203263818570161856767328257",
                    "collection": {
                        "banner_image_url": "https://lh3.googleusercontent.com/dhO2ewct0oUHJOi9_X8f8vual477L9oyjx375FyvDQ_l8DZsZwMwQROxDuvaYntO6-BS7hNWYMNwMZHeWMVGX5aHn_8GHXDZz6IV8Q=s2500",
                        "chat_url": null,
                        "created_date": "2021-05-24T16:30:46.792706",
                        "default_to_fiat": false,
                        "description": "This is the Nft collection of a multimedia Project from the Artist Freakygreenfish. The Pieces were made for the first Part of the Performance Digital Frame, which takes place at the art fair Parallel Editions 2021 in vienna. The young artist is presenting his art on  Social media in a way it hasn´t been done  before.  ",
                        "dev_buyer_fee_basis_points": "0",
                        "dev_seller_fee_basis_points": "0",
                        "discord_url": null,
                        "display_data": {
                            "card_display_style": "contain",
                            "images": []
                        },
                        "external_url": null,
                        "featured": false,
                        "featured_image_url": null,
                        "hidden": true,
                        "safelist_request_status": "not_requested",
                        "image_url": "https://lh3.googleusercontent.com/QdQVTLTkg_tfd-_Amse_REaFkaTxiwtXO7ZjXAMLfw-o3XwadX3kGL_0XGSPxctIkkNvdyXvXTq7FlkwJ4ITU8OC4KJccTAhgaBY=s120",
                        "is_subject_to_whitelist": false,
                        "large_image_url": null,
                        "medium_username": null,
                        "name": "Digital Frame pt.1.",
                        "only_proxied_transfers": false,
                        "opensea_buyer_fee_basis_points": "0",
                        "opensea_seller_fee_basis_points": "250",
                        "payout_address": null,
                        "require_email": false,
                        "short_description": null,
                        "slug": "digital-frame-pt-1",
                        "telegram_url": null,
                        "twitter_username": null,
                        "instagram_username": null,
                        "wiki_url": null
                    },
                    "decimals": null,
                    "token_metadata": null
                }
            ],
            "name": "Digital Frame pt.1.",
            "description": "This Bundle includes all charakters and two Information from the online performance \"Digital Frames pt.1.\"",
            "external_link": "",
            "asset_contract": {
                "collection": {
                    "banner_image_url": null,
                    "chat_url": null,
                    "created_date": "2020-12-02T17:40:53.507540",
                    "default_to_fiat": false,
                    "description": null,
                    "dev_buyer_fee_basis_points": "0",
                    "dev_seller_fee_basis_points": "0",
                    "discord_url": null,
                    "display_data": {
                        "card_display_style": "contain",
                        "images": []
                    },
                    "external_url": null,
                    "featured": false,
                    "featured_image_url": null,
                    "hidden": true,
                    "safelist_request_status": "not_requested",
                    "image_url": null,
                    "is_subject_to_whitelist": false,
                    "large_image_url": null,
                    "medium_username": null,
                    "name": "OpenSea Shared Storefront V2",
                    "only_proxied_transfers": false,
                    "opensea_buyer_fee_basis_points": "0",
                    "opensea_seller_fee_basis_points": "250",
                    "payout_address": null,
                    "require_email": false,
                    "short_description": null,
                    "slug": "opensea-shared-storefront-v2",
                    "telegram_url": null,
                    "twitter_username": null,
                    "instagram_username": null,
                    "wiki_url": null
                },
                "address": "0x495f947276749ce646f68ac8c248420045cb7b5e",
                "asset_contract_type": "semi-fungible",
                "created_date": "2020-12-02T17:40:53.232025",
                "name": "OpenSea Collection",
                "nft_version": null,
                "opensea_version": "2.0.0",
                "owner": 102384,
                "schema_name": "ERC1155",
                "symbol": "OPENSTORE",
                "total_supply": null,
                "description": null,
                "external_link": null,
                "image_url": null,
                "default_to_fiat": false,
                "dev_buyer_fee_basis_points": 0,
                "dev_seller_fee_basis_points": 0,
                "only_proxied_transfers": false,
                "opensea_buyer_fee_basis_points": 0,
                "opensea_seller_fee_basis_points": 250,
                "buyer_fee_basis_points": 0,
                "seller_fee_basis_points": 250,
                "payout_address": null
            },
            "permalink": "https://opensea.io/bundles/digital-frame-pt-1-x1C",
            "sell_orders": [
                {
                    "created_date": "2021-05-25T22:26:13.888739",
                    "closing_date": null,
                    "closing_extendable": false,
                    "expiration_time": 0,
                    "listing_time": 1621981404,
                    "order_hash": "0xda94b663809151e80020d509d9d8d8f5611c0410403f232e761af1fe0cfd75a9",
                    "metadata": {
                        "bundle": {
                            "assets": [
                                {
                                    "id": "38261257331859101212728236245963608895893132356697203263818570157458720817153",
                                    "address": "0x495f947276749ce646f68ac8c248420045cb7b5e",
                                    "quantity": "1"
                                },
                                {
                                    "id": "38261257331859101212728236245963608895893132356697203263818570158558232444929",
                                    "address": "0x495f947276749ce646f68ac8c248420045cb7b5e",
                                    "quantity": "1"
                                },
                                {
                                    "id": "38261257331859101212728236245963608895893132356697203263818570159657744072705",
                                    "address": "0x495f947276749ce646f68ac8c248420045cb7b5e",
                                    "quantity": "1"
                                },
                                {
                                    "id": "38261257331859101212728236245963608895893132356697203263818570160757255700481",
                                    "address": "0x495f947276749ce646f68ac8c248420045cb7b5e",
                                    "quantity": "1"
                                },
                                {
                                    "id": "38261257331859101212728236245963608895893132356697203263818570161856767328257",
                                    "address": "0x495f947276749ce646f68ac8c248420045cb7b5e",
                                    "quantity": "1"
                                }
                            ],
                            "schemas": [
                                "ERC1155",
                                "ERC1155",
                                "ERC1155",
                                "ERC1155",
                                "ERC1155"
                            ],
                            "name": "Digital Frame pt.1.",
                            "description": "This Bundle includes all charakters and two Information from the online performance \"Digital Frames pt.1.\"",
                            "external_link": ""
                        }
                    },
                    "exchange": "0x7be8076f4ea4a4ad08075c2508e481d6c946d12b",
                    "maker": {
                        "user": 720780,
                        "profile_img_url": "https://storage.googleapis.com/opensea-static/opensea-profile/12.png",
                        "address": "0x54971aae489ded02ee99b0cf6b8707377df97739",
                        "config": "",
                        "discord_id": ""
                    },
                    "taker": {
                        "user": 1766,
                        "profile_img_url": "https://storage.googleapis.com/opensea-static/opensea-profile/1.png",
                        "address": "0x0000000000000000000000000000000000000000",
                        "config": "",
                        "discord_id": ""
                    },
                    "current_price": "2000000000",
                    "current_bounty": "20000000",
                    "bounty_multiple": "0.01",
                    "maker_relayer_fee": "250",
                    "taker_relayer_fee": "0",
                    "maker_protocol_fee": "0",
                    "taker_protocol_fee": "0",
                    "maker_referrer_fee": "0",
                    "fee_recipient": {
                        "user": 3585,
                        "profile_img_url": "https://storage.googleapis.com/opensea-static/opensea-profile/28.png",
                        "address": "0x5b3256965e7c3cf26e11fcaf296dfc8807c01073",
                        "config": "verified",
                        "discord_id": ""
                    },
                    "fee_method": 1,
                    "side": 1,
                    "sale_kind": 0,
                    "target": "0xc99f70bfd82fb7c8f8191fdfbfb735606b15e5c5",
                    "how_to_call": 1,
                    "calldata": "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",
                    "replacement_pattern": "0x0000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000ffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffff0000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000ffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffff0000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000ffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffff0000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000ffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffff0000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000ffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffff0000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000",
                    "static_target": "0x0000000000000000000000000000000000000000",
                    "static_extradata": "0x",
                    "payment_token": "0xa0b86991c6218b36c1d19d4a2e9eb0ce3606eb48",
                    "payment_token_contract": {
                        "id": 7,
                        "symbol": "USDC",
                        "address": "0xa0b86991c6218b36c1d19d4a2e9eb0ce3606eb48",
                        "image_url": "https://lh3.googleusercontent.com/PxC_K0Y22A1Xs0CeVknf4YUSxSqH_1bPCG0a4uD7WRkwbbtinqryjDEvoTYSbBFDXXTliuyo38-Y_ecNUEj0fMimQA",
                        "name": "USD Coin",
                        "decimals": 6,
                        "eth_price": "0.000389076293970",
                        "usd_price": "1.000000000000000000"
                    },
                    "base_price": "2000000000",
                    "extra": "0",
                    "quantity": "1",
                    "salt": "42928178025160755096728062108169864127421052573333204058790321636210689797101",
                    "v": 28,
                    "r": "0x959639f3b28127d0de4528a91b01fcdd72ad450df49897209842df6143fa9e87",
                    "s": "0x1dfa82f052ff8cd51181ef4fadfd6ad25083d85c0b0667529d2a916e71566829",
                    "approved_on_chain": false,
                    "cancelled": false,
                    "finalized": false,
                    "marked_invalid": false,
                    "prefixed_hash": "0x268097a93dedff286c6f2f94300645dde8312eef3aa90ad06fd72bf3f2ecabe4"
                }
            ]
        },
        {
            "maker": {
                "user": {
                    "username": null
                },
                "profile_img_url": "https://storage.googleapis.com/opensea-static/opensea-profile/6.png",
                "address": "0x54e069893032ae2196ab02fe7d013069dd6f3416",
                "config": "",
                "discord_id": ""
            },
            "slug": "cry2m1cr0nfts-92C",
            "assets": [
                {
                    "id": 25663953,
                    "token_id": "38390781405459679747136907948379193480062007280636129664739814624590974418945",
                    "num_sales": 0,
                    "background_color": null,
                    "image_url": "https://lh3.googleusercontent.com/cIAat2h_-o7fU4xtxG5OhsVS3IClpspOwQPR5qh7q_lKfurT7jVKF9vRbkg4VL8Ny0QNwtydmpbtM_PiYRdIjn6oNuvoGZj1B6Xc",
                    "image_preview_url": "https://lh3.googleusercontent.com/cIAat2h_-o7fU4xtxG5OhsVS3IClpspOwQPR5qh7q_lKfurT7jVKF9vRbkg4VL8Ny0QNwtydmpbtM_PiYRdIjn6oNuvoGZj1B6Xc=s250",
                    "image_thumbnail_url": "https://lh3.googleusercontent.com/cIAat2h_-o7fU4xtxG5OhsVS3IClpspOwQPR5qh7q_lKfurT7jVKF9vRbkg4VL8Ny0QNwtydmpbtM_PiYRdIjn6oNuvoGZj1B6Xc=s128",
                    "image_original_url": null,
                    "animation_url": null,
                    "animation_original_url": null,
                    "name": "microscópica #001",
                    "description": null,
                    "external_link": null,
                    "asset_contract": {
                        "address": "0x495f947276749ce646f68ac8c248420045cb7b5e",
                        "asset_contract_type": "semi-fungible",
                        "created_date": "2020-12-02T17:40:53.232025",
                        "name": "OpenSea Collection",
                        "nft_version": null,
                        "opensea_version": "2.0.0",
                        "owner": 102384,
                        "schema_name": "ERC1155",
                        "symbol": "OPENSTORE",
                        "total_supply": null,
                        "description": null,
                        "external_link": null,
                        "image_url": null,
                        "default_to_fiat": false,
                        "dev_buyer_fee_basis_points": 0,
                        "dev_seller_fee_basis_points": 0,
                        "only_proxied_transfers": false,
                        "opensea_buyer_fee_basis_points": 0,
                        "opensea_seller_fee_basis_points": 250,
                        "buyer_fee_basis_points": 0,
                        "seller_fee_basis_points": 250,
                        "payout_address": null
                    },
                    "owner": {
                        "user": {
                            "username": "NullAddress"
                        },
                        "profile_img_url": "https://storage.googleapis.com/opensea-static/opensea-profile/1.png",
                        "address": "0x0000000000000000000000000000000000000000",
                        "config": "",
                        "discord_id": ""
                    },
                    "permalink": "https://opensea.io/assets/0x495f947276749ce646f68ac8c248420045cb7b5e/38390781405459679747136907948379193480062007280636129664739814624590974418945",
                    "collection": {
                        "banner_image_url": "https://lh3.googleusercontent.com/78ftZhfatp1AGbNG4tqE1nSXCM-gcPfW1uQ94vgUqwH-XP2WY0oI353JisaXQxHYHedV2dDuhpfdY1reAxioWDiRSqhivdjru272TA=s2500",
                        "chat_url": null,
                        "created_date": "2021-05-21T12:58:18.829273",
                        "default_to_fiat": false,
                        "description": "De todo un poco",
                        "dev_buyer_fee_basis_points": "0",
                        "dev_seller_fee_basis_points": "0",
                        "discord_url": null,
                        "display_data": {
                            "card_display_style": "contain"
                        },
                        "external_url": null,
                        "featured": false,
                        "featured_image_url": null,
                        "hidden": true,
                        "safelist_request_status": "not_requested",
                        "image_url": "https://lh3.googleusercontent.com/9PK3i5j_U_KHlBuX9lDq9Satf_GhWS7rSNJ9RNo85Yhf_vCQnXCXsVoigMa5cQv9Pd-qOWJDI952XXz9ZReashwEnEoLkG2SnoAQa8U=s120",
                        "is_subject_to_whitelist": false,
                        "large_image_url": null,
                        "medium_username": null,
                        "name": "galaxia 7",
                        "only_proxied_transfers": false,
                        "opensea_buyer_fee_basis_points": "0",
                        "opensea_seller_fee_basis_points": "250",
                        "payout_address": null,
                        "require_email": false,
                        "short_description": null,
                        "slug": "galaxy-calix",
                        "telegram_url": null,
                        "twitter_username": null,
                        "instagram_username": null,
                        "wiki_url": null
                    },
                    "decimals": null,
                    "token_metadata": null
                },
                {
                    "id": 25663978,
                    "token_id": "38390781405459679747136907948379193480062007280636129664739814625690486046721",
                    "num_sales": 0,
                    "background_color": null,
                    "image_url": "https://lh3.googleusercontent.com/qhLBbcFzK1mwI79-2foTXpl2tEKlOv_LILvL63pVYo3PDbTrNU-QPQ9Y9kx3w01AT1t-T34M6_NzHmwToZLli3nal3jAxPB7pVQBKw",
                    "image_preview_url": "https://lh3.googleusercontent.com/qhLBbcFzK1mwI79-2foTXpl2tEKlOv_LILvL63pVYo3PDbTrNU-QPQ9Y9kx3w01AT1t-T34M6_NzHmwToZLli3nal3jAxPB7pVQBKw=s250",
                    "image_thumbnail_url": "https://lh3.googleusercontent.com/qhLBbcFzK1mwI79-2foTXpl2tEKlOv_LILvL63pVYo3PDbTrNU-QPQ9Y9kx3w01AT1t-T34M6_NzHmwToZLli3nal3jAxPB7pVQBKw=s128",
                    "image_original_url": null,
                    "animation_url": null,
                    "animation_original_url": null,
                    "name": "microscópica #002",
                    "description": null,
                    "external_link": null,
                    "asset_contract": {
                        "address": "0x495f947276749ce646f68ac8c248420045cb7b5e",
                        "asset_contract_type": "semi-fungible",
                        "created_date": "2020-12-02T17:40:53.232025",
                        "name": "OpenSea Collection",
                        "nft_version": null,
                        "opensea_version": "2.0.0",
                        "owner": 102384,
                        "schema_name": "ERC1155",
                        "symbol": "OPENSTORE",
                        "total_supply": null,
                        "description": null,
                        "external_link": null,
                        "image_url": null,
                        "default_to_fiat": false,
                        "dev_buyer_fee_basis_points": 0,
                        "dev_seller_fee_basis_points": 0,
                        "only_proxied_transfers": false,
                        "opensea_buyer_fee_basis_points": 0,
                        "opensea_seller_fee_basis_points": 250,
                        "buyer_fee_basis_points": 0,
                        "seller_fee_basis_points": 250,
                        "payout_address": null
                    },
                    "owner": {
                        "user": {
                            "username": "NullAddress"
                        },
                        "profile_img_url": "https://storage.googleapis.com/opensea-static/opensea-profile/1.png",
                        "address": "0x0000000000000000000000000000000000000000",
                        "config": "",
                        "discord_id": ""
                    },
                    "permalink": "https://opensea.io/assets/0x495f947276749ce646f68ac8c248420045cb7b5e/38390781405459679747136907948379193480062007280636129664739814625690486046721",
                    "collection": {
                        "banner_image_url": "https://lh3.googleusercontent.com/78ftZhfatp1AGbNG4tqE1nSXCM-gcPfW1uQ94vgUqwH-XP2WY0oI353JisaXQxHYHedV2dDuhpfdY1reAxioWDiRSqhivdjru272TA=s2500",
                        "chat_url": null,
                        "created_date": "2021-05-21T12:58:18.829273",
                        "default_to_fiat": false,
                        "description": "De todo un poco",
                        "dev_buyer_fee_basis_points": "0",
                        "dev_seller_fee_basis_points": "0",
                        "discord_url": null,
                        "display_data": {
                            "card_display_style": "contain"
                        },
                        "external_url": null,
                        "featured": false,
                        "featured_image_url": null,
                        "hidden": true,
                        "safelist_request_status": "not_requested",
                        "image_url": "https://lh3.googleusercontent.com/9PK3i5j_U_KHlBuX9lDq9Satf_GhWS7rSNJ9RNo85Yhf_vCQnXCXsVoigMa5cQv9Pd-qOWJDI952XXz9ZReashwEnEoLkG2SnoAQa8U=s120",
                        "is_subject_to_whitelist": false,
                        "large_image_url": null,
                        "medium_username": null,
                        "name": "galaxia 7",
                        "only_proxied_transfers": false,
                        "opensea_buyer_fee_basis_points": "0",
                        "opensea_seller_fee_basis_points": "250",
                        "payout_address": null,
                        "require_email": false,
                        "short_description": null,
                        "slug": "galaxy-calix",
                        "telegram_url": null,
                        "twitter_username": null,
                        "instagram_username": null,
                        "wiki_url": null
                    },
                    "decimals": null,
                    "token_metadata": null
                }
            ],
            "name": "Cry2m1cr0nfts",
            "description": "",
            "external_link": "",
            "asset_contract": {
                "collection": {
                    "banner_image_url": null,
                    "chat_url": null,
                    "created_date": "2020-12-02T17:40:53.507540",
                    "default_to_fiat": false,
                    "description": null,
                    "dev_buyer_fee_basis_points": "0",
                    "dev_seller_fee_basis_points": "0",
                    "discord_url": null,
                    "display_data": {
                        "card_display_style": "contain",
                        "images": []
                    },
                    "external_url": null,
                    "featured": false,
                    "featured_image_url": null,
                    "hidden": true,
                    "safelist_request_status": "not_requested",
                    "image_url": null,
                    "is_subject_to_whitelist": false,
                    "large_image_url": null,
                    "medium_username": null,
                    "name": "OpenSea Shared Storefront V2",
                    "only_proxied_transfers": false,
                    "opensea_buyer_fee_basis_points": "0",
                    "opensea_seller_fee_basis_points": "250",
                    "payout_address": null,
                    "require_email": false,
                    "short_description": null,
                    "slug": "opensea-shared-storefront-v2",
                    "telegram_url": null,
                    "twitter_username": null,
                    "instagram_username": null,
                    "wiki_url": null
                },
                "address": "0x495f947276749ce646f68ac8c248420045cb7b5e",
                "asset_contract_type": "semi-fungible",
                "created_date": "2020-12-02T17:40:53.232025",
                "name": "OpenSea Collection",
                "nft_version": null,
                "opensea_version": "2.0.0",
                "owner": 102384,
                "schema_name": "ERC1155",
                "symbol": "OPENSTORE",
                "total_supply": null,
                "description": null,
                "external_link": null,
                "image_url": null,
                "default_to_fiat": false,
                "dev_buyer_fee_basis_points": 0,
                "dev_seller_fee_basis_points": 0,
                "only_proxied_transfers": false,
                "opensea_buyer_fee_basis_points": 0,
                "opensea_seller_fee_basis_points": 250,
                "buyer_fee_basis_points": 0,
                "seller_fee_basis_points": 250,
                "payout_address": null
            },
            "permalink": "https://opensea.io/bundles/cry2m1cr0nfts-92C",
            "sell_orders": [
                {
                    "created_date": "2021-05-25T22:22:58.428385",
                    "closing_date": "2021-06-01T22:22:15",
                    "closing_extendable": false,
                    "expiration_time": 1622586135,
                    "listing_time": 1621981271,
                    "order_hash": "0xd114cc5cac804eaa8a8dda054201f63ad33e4b869f4ce970f1271097e800eaff",
                    "metadata": {
                        "bundle": {
                            "assets": [
                                {
                                    "id": "38390781405459679747136907948379193480062007280636129664739814624590974418945",
                                    "address": "0x495f947276749ce646f68ac8c248420045cb7b5e",
                                    "quantity": "1"
                                },
                                {
                                    "id": "38390781405459679747136907948379193480062007280636129664739814625690486046721",
                                    "address": "0x495f947276749ce646f68ac8c248420045cb7b5e",
                                    "quantity": "1"
                                }
                            ],
                            "schemas": [
                                "ERC1155",
                                "ERC1155"
                            ],
                            "name": "Cry2m1cr0nfts",
                            "description": "",
                            "external_link": ""
                        }
                    },
                    "exchange": "0x7be8076f4ea4a4ad08075c2508e481d6c946d12b",
                    "maker": {
                        "user": 833525,
                        "profile_img_url": "https://storage.googleapis.com/opensea-static/opensea-profile/6.png",
                        "address": "0x54e069893032ae2196ab02fe7d013069dd6f3416",
                        "config": "",
                        "discord_id": ""
                    },
                    "taker": {
                        "user": 1766,
                        "profile_img_url": "https://storage.googleapis.com/opensea-static/opensea-profile/1.png",
                        "address": "0x0000000000000000000000000000000000000000",
                        "config": "",
                        "discord_id": ""
                    },
                    "current_price": "1005782653722258778.000000000",
                    "current_bounty": "10057826535137434",
                    "bounty_multiple": "0.01",
                    "maker_relayer_fee": "250",
                    "taker_relayer_fee": "0",
                    "maker_protocol_fee": "0",
                    "taker_protocol_fee": "0",
                    "maker_referrer_fee": "0",
                    "fee_recipient": {
                        "user": 3585,
                        "profile_img_url": "https://storage.googleapis.com/opensea-static/opensea-profile/28.png",
                        "address": "0x5b3256965e7c3cf26e11fcaf296dfc8807c01073",
                        "config": "verified",
                        "discord_id": ""
                    },
                    "fee_method": 1,
                    "side": 1,
                    "sale_kind": 1,
                    "target": "0xc99f70bfd82fb7c8f8191fdfbfb735606b15e5c5",
                    "how_to_call": 1,
                    "calldata": "0x68f0bcaa000000000000000000000000000000000000000000000000000000000000008000000000000000000000000000000000000000000000000000000000000000e0000000000000000000000000000000000000000000000000000000000000014000000000000000000000000000000000000000000000000000000000000001a00000000000000000000000000000000000000000000000000000000000000002000000000000000000000000495f947276749ce646f68ac8c248420045cb7b5e000000000000000000000000495f947276749ce646f68ac8c248420045cb7b5e000000000000000000000000000000000000000000000000000000000000000200000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000200000000000000000000000000000000000000000000000000000000000000c400000000000000000000000000000000000000000000000000000000000000c40000000000000000000000000000000000000000000000000000000000000188f242432a00000000000000000000000054e069893032ae2196ab02fe7d013069dd6f3416000000000000000000000000000000000000000000000000000000000000000054e069893032ae2196ab02fe7d013069dd6f34160000000000004d0000000001000000000000000000000000000000000000000000000000000000000000000100000000000000000000000000000000000000000000000000000000000000a00000000000000000000000000000000000000000000000000000000000000000f242432a00000000000000000000000054e069893032ae2196ab02fe7d013069dd6f3416000000000000000000000000000000000000000000000000000000000000000054e069893032ae2196ab02fe7d013069dd6f34160000000000004e0000000001000000000000000000000000000000000000000000000000000000000000000100000000000000000000000000000000000000000000000000000000000000a00000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000",
                    "replacement_pattern": "0x0000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000ffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffff0000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000ffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffff0000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000",
                    "static_target": "0x0000000000000000000000000000000000000000",
                    "static_extradata": "0x",
                    "payment_token": "0x0000000000000000000000000000000000000000",
                    "payment_token_contract": {
                        "id": 1,
                        "symbol": "ETH",
                        "address": "0x0000000000000000000000000000000000000000",
                        "image_url": "https://storage.opensea.io/files/6f8e2979d428180222796ff4a33ab929.svg",
                        "name": "Ether",
                        "decimals": 18,
                        "eth_price": "1.000000000000000",
                        "usd_price": "2625.730000000000018000"
                    },
                    "base_price": "1011100000000000000",
                    "extra": "1000000000000000000",
                    "quantity": "1",
                    "salt": "72951820501486517087907239205049839077108214632113881542017283248925728655078",
                    "v": 28,
                    "r": "0x4e64092da77ad4907789c8fb086d4b2ff5af0b7b078d8445eca9069a65b2fdd1",
                    "s": "0x4cf44093d03835143006df303b71040bbcb9a86530f5e51c884ddb924bc434ea",
                    "approved_on_chain": false,
                    "cancelled": false,
                    "finalized": false,
                    "marked_invalid": false,
                    "prefixed_hash": "0xcceb78c1e915f6359fc31b63ddd731f24db70a5d667746692ec47bdbcf1f4ff5"
                }
            ]
        },
        {
            "maker": {
                "user": {
                    "username": null
                },
                "profile_img_url": "https://storage.googleapis.com/opensea-static/opensea-profile/6.png",
                "address": "0x54e069893032ae2196ab02fe7d013069dd6f3416",
                "config": "",
                "discord_id": ""
            },
            "slug": "cry3nfts-0vt",
            "assets": [
                {
                    "id": 25663799,
                    "token_id": "38390781405459679747136907948379193480062007280636129664739814621292439535617",
                    "num_sales": 0,
                    "background_color": null,
                    "image_url": "https://lh3.googleusercontent.com/fAXFi8T6p8ejqN7f9-XKB0nGgZSL4dyh0LFBFHn7a_gAXKm2hPhOyYc11Wnm-4l5iUUqSJCAL511_OuxizFr9iJ9WhMOz6_knG6a",
                    "image_preview_url": "https://lh3.googleusercontent.com/fAXFi8T6p8ejqN7f9-XKB0nGgZSL4dyh0LFBFHn7a_gAXKm2hPhOyYc11Wnm-4l5iUUqSJCAL511_OuxizFr9iJ9WhMOz6_knG6a=s250",
                    "image_thumbnail_url": "https://lh3.googleusercontent.com/fAXFi8T6p8ejqN7f9-XKB0nGgZSL4dyh0LFBFHn7a_gAXKm2hPhOyYc11Wnm-4l5iUUqSJCAL511_OuxizFr9iJ9WhMOz6_knG6a=s128",
                    "image_original_url": null,
                    "animation_url": null,
                    "animation_original_url": null,
                    "name": "atardece arte #001",
                    "description": null,
                    "external_link": null,
                    "asset_contract": {
                        "address": "0x495f947276749ce646f68ac8c248420045cb7b5e",
                        "asset_contract_type": "semi-fungible",
                        "created_date": "2020-12-02T17:40:53.232025",
                        "name": "OpenSea Collection",
                        "nft_version": null,
                        "opensea_version": "2.0.0",
                        "owner": 102384,
                        "schema_name": "ERC1155",
                        "symbol": "OPENSTORE",
                        "total_supply": null,
                        "description": null,
                        "external_link": null,
                        "image_url": null,
                        "default_to_fiat": false,
                        "dev_buyer_fee_basis_points": 0,
                        "dev_seller_fee_basis_points": 0,
                        "only_proxied_transfers": false,
                        "opensea_buyer_fee_basis_points": 0,
                        "opensea_seller_fee_basis_points": 250,
                        "buyer_fee_basis_points": 0,
                        "seller_fee_basis_points": 250,
                        "payout_address": null
                    },
                    "owner": {
                        "user": {
                            "username": "NullAddress"
                        },
                        "profile_img_url": "https://storage.googleapis.com/opensea-static/opensea-profile/1.png",
                        "address": "0x0000000000000000000000000000000000000000",
                        "config": "",
                        "discord_id": ""
                    },
                    "permalink": "https://opensea.io/assets/0x495f947276749ce646f68ac8c248420045cb7b5e/38390781405459679747136907948379193480062007280636129664739814621292439535617",
                    "collection": {
                        "banner_image_url": "https://lh3.googleusercontent.com/78ftZhfatp1AGbNG4tqE1nSXCM-gcPfW1uQ94vgUqwH-XP2WY0oI353JisaXQxHYHedV2dDuhpfdY1reAxioWDiRSqhivdjru272TA=s2500",
                        "chat_url": null,
                        "created_date": "2021-05-21T12:58:18.829273",
                        "default_to_fiat": false,
                        "description": "De todo un poco",
                        "dev_buyer_fee_basis_points": "0",
                        "dev_seller_fee_basis_points": "0",
                        "discord_url": null,
                        "display_data": {
                            "card_display_style": "contain"
                        },
                        "external_url": null,
                        "featured": false,
                        "featured_image_url": null,
                        "hidden": true,
                        "safelist_request_status": "not_requested",
                        "image_url": "https://lh3.googleusercontent.com/9PK3i5j_U_KHlBuX9lDq9Satf_GhWS7rSNJ9RNo85Yhf_vCQnXCXsVoigMa5cQv9Pd-qOWJDI952XXz9ZReashwEnEoLkG2SnoAQa8U=s120",
                        "is_subject_to_whitelist": false,
                        "large_image_url": null,
                        "medium_username": null,
                        "name": "galaxia 7",
                        "only_proxied_transfers": false,
                        "opensea_buyer_fee_basis_points": "0",
                        "opensea_seller_fee_basis_points": "250",
                        "payout_address": null,
                        "require_email": false,
                        "short_description": null,
                        "slug": "galaxy-calix",
                        "telegram_url": null,
                        "twitter_username": null,
                        "instagram_username": null,
                        "wiki_url": null
                    },
                    "decimals": null,
                    "token_metadata": null
                },
                {
                    "id": 25663833,
                    "token_id": "38390781405459679747136907948379193480062007280636129664739814622391951163393",
                    "num_sales": 0,
                    "background_color": null,
                    "image_url": "https://lh3.googleusercontent.com/UoTnkY9nBJ92R4fSyHBN_NVECCw3SQZzGwlvFGMAuCzWQoQGAIM19a9zELDvcftEZnRaAFqssJnAnmu6sYC3ZxiXSmYAFzdpNkWn",
                    "image_preview_url": "https://lh3.googleusercontent.com/UoTnkY9nBJ92R4fSyHBN_NVECCw3SQZzGwlvFGMAuCzWQoQGAIM19a9zELDvcftEZnRaAFqssJnAnmu6sYC3ZxiXSmYAFzdpNkWn=s250",
                    "image_thumbnail_url": "https://lh3.googleusercontent.com/UoTnkY9nBJ92R4fSyHBN_NVECCw3SQZzGwlvFGMAuCzWQoQGAIM19a9zELDvcftEZnRaAFqssJnAnmu6sYC3ZxiXSmYAFzdpNkWn=s128",
                    "image_original_url": null,
                    "animation_url": null,
                    "animation_original_url": null,
                    "name": "atardece arte #002",
                    "description": null,
                    "external_link": null,
                    "asset_contract": {
                        "address": "0x495f947276749ce646f68ac8c248420045cb7b5e",
                        "asset_contract_type": "semi-fungible",
                        "created_date": "2020-12-02T17:40:53.232025",
                        "name": "OpenSea Collection",
                        "nft_version": null,
                        "opensea_version": "2.0.0",
                        "owner": 102384,
                        "schema_name": "ERC1155",
                        "symbol": "OPENSTORE",
                        "total_supply": null,
                        "description": null,
                        "external_link": null,
                        "image_url": null,
                        "default_to_fiat": false,
                        "dev_buyer_fee_basis_points": 0,
                        "dev_seller_fee_basis_points": 0,
                        "only_proxied_transfers": false,
                        "opensea_buyer_fee_basis_points": 0,
                        "opensea_seller_fee_basis_points": 250,
                        "buyer_fee_basis_points": 0,
                        "seller_fee_basis_points": 250,
                        "payout_address": null
                    },
                    "owner": {
                        "user": {
                            "username": "NullAddress"
                        },
                        "profile_img_url": "https://storage.googleapis.com/opensea-static/opensea-profile/1.png",
                        "address": "0x0000000000000000000000000000000000000000",
                        "config": "",
                        "discord_id": ""
                    },
                    "permalink": "https://opensea.io/assets/0x495f947276749ce646f68ac8c248420045cb7b5e/38390781405459679747136907948379193480062007280636129664739814622391951163393",
                    "collection": {
                        "banner_image_url": "https://lh3.googleusercontent.com/78ftZhfatp1AGbNG4tqE1nSXCM-gcPfW1uQ94vgUqwH-XP2WY0oI353JisaXQxHYHedV2dDuhpfdY1reAxioWDiRSqhivdjru272TA=s2500",
                        "chat_url": null,
                        "created_date": "2021-05-21T12:58:18.829273",
                        "default_to_fiat": false,
                        "description": "De todo un poco",
                        "dev_buyer_fee_basis_points": "0",
                        "dev_seller_fee_basis_points": "0",
                        "discord_url": null,
                        "display_data": {
                            "card_display_style": "contain"
                        },
                        "external_url": null,
                        "featured": false,
                        "featured_image_url": null,
                        "hidden": true,
                        "safelist_request_status": "not_requested",
                        "image_url": "https://lh3.googleusercontent.com/9PK3i5j_U_KHlBuX9lDq9Satf_GhWS7rSNJ9RNo85Yhf_vCQnXCXsVoigMa5cQv9Pd-qOWJDI952XXz9ZReashwEnEoLkG2SnoAQa8U=s120",
                        "is_subject_to_whitelist": false,
                        "large_image_url": null,
                        "medium_username": null,
                        "name": "galaxia 7",
                        "only_proxied_transfers": false,
                        "opensea_buyer_fee_basis_points": "0",
                        "opensea_seller_fee_basis_points": "250",
                        "payout_address": null,
                        "require_email": false,
                        "short_description": null,
                        "slug": "galaxy-calix",
                        "telegram_url": null,
                        "twitter_username": null,
                        "instagram_username": null,
                        "wiki_url": null
                    },
                    "decimals": null,
                    "token_metadata": null
                },
                {
                    "id": 25663885,
                    "token_id": "38390781405459679747136907948379193480062007280636129664739814623491462791169",
                    "num_sales": 0,
                    "background_color": null,
                    "image_url": "https://lh3.googleusercontent.com/KRKQ9tWWX1cT_Fec7Zw6c-JbyPupdyNSa2x5rWVddCB4LDKPh-lui5PyBTlkGVmx7ZQw8yET7Zfclq_4mEZ7YtOF11HtQwP7T1mPDg",
                    "image_preview_url": "https://lh3.googleusercontent.com/KRKQ9tWWX1cT_Fec7Zw6c-JbyPupdyNSa2x5rWVddCB4LDKPh-lui5PyBTlkGVmx7ZQw8yET7Zfclq_4mEZ7YtOF11HtQwP7T1mPDg=s250",
                    "image_thumbnail_url": "https://lh3.googleusercontent.com/KRKQ9tWWX1cT_Fec7Zw6c-JbyPupdyNSa2x5rWVddCB4LDKPh-lui5PyBTlkGVmx7ZQw8yET7Zfclq_4mEZ7YtOF11HtQwP7T1mPDg=s128",
                    "image_original_url": null,
                    "animation_url": null,
                    "animation_original_url": null,
                    "name": "atardece arte #003",
                    "description": null,
                    "external_link": null,
                    "asset_contract": {
                        "address": "0x495f947276749ce646f68ac8c248420045cb7b5e",
                        "asset_contract_type": "semi-fungible",
                        "created_date": "2020-12-02T17:40:53.232025",
                        "name": "OpenSea Collection",
                        "nft_version": null,
                        "opensea_version": "2.0.0",
                        "owner": 102384,
                        "schema_name": "ERC1155",
                        "symbol": "OPENSTORE",
                        "total_supply": null,
                        "description": null,
                        "external_link": null,
                        "image_url": null,
                        "default_to_fiat": false,
                        "dev_buyer_fee_basis_points": 0,
                        "dev_seller_fee_basis_points": 0,
                        "only_proxied_transfers": false,
                        "opensea_buyer_fee_basis_points": 0,
                        "opensea_seller_fee_basis_points": 250,
                        "buyer_fee_basis_points": 0,
                        "seller_fee_basis_points": 250,
                        "payout_address": null
                    },
                    "owner": {
                        "user": {
                            "username": "NullAddress"
                        },
                        "profile_img_url": "https://storage.googleapis.com/opensea-static/opensea-profile/1.png",
                        "address": "0x0000000000000000000000000000000000000000",
                        "config": "",
                        "discord_id": ""
                    },
                    "permalink": "https://opensea.io/assets/0x495f947276749ce646f68ac8c248420045cb7b5e/38390781405459679747136907948379193480062007280636129664739814623491462791169",
                    "collection": {
                        "banner_image_url": "https://lh3.googleusercontent.com/78ftZhfatp1AGbNG4tqE1nSXCM-gcPfW1uQ94vgUqwH-XP2WY0oI353JisaXQxHYHedV2dDuhpfdY1reAxioWDiRSqhivdjru272TA=s2500",
                        "chat_url": null,
                        "created_date": "2021-05-21T12:58:18.829273",
                        "default_to_fiat": false,
                        "description": "De todo un poco",
                        "dev_buyer_fee_basis_points": "0",
                        "dev_seller_fee_basis_points": "0",
                        "discord_url": null,
                        "display_data": {
                            "card_display_style": "contain"
                        },
                        "external_url": null,
                        "featured": false,
                        "featured_image_url": null,
                        "hidden": true,
                        "safelist_request_status": "not_requested",
                        "image_url": "https://lh3.googleusercontent.com/9PK3i5j_U_KHlBuX9lDq9Satf_GhWS7rSNJ9RNo85Yhf_vCQnXCXsVoigMa5cQv9Pd-qOWJDI952XXz9ZReashwEnEoLkG2SnoAQa8U=s120",
                        "is_subject_to_whitelist": false,
                        "large_image_url": null,
                        "medium_username": null,
                        "name": "galaxia 7",
                        "only_proxied_transfers": false,
                        "opensea_buyer_fee_basis_points": "0",
                        "opensea_seller_fee_basis_points": "250",
                        "payout_address": null,
                        "require_email": false,
                        "short_description": null,
                        "slug": "galaxy-calix",
                        "telegram_url": null,
                        "twitter_username": null,
                        "instagram_username": null,
                        "wiki_url": null
                    },
                    "decimals": null,
                    "token_metadata": null
                }
            ],
            "name": "Cry3Nfts",
            "description": "",
            "external_link": "",
            "asset_contract": {
                "collection": {
                    "banner_image_url": null,
                    "chat_url": null,
                    "created_date": "2020-12-02T17:40:53.507540",
                    "default_to_fiat": false,
                    "description": null,
                    "dev_buyer_fee_basis_points": "0",
                    "dev_seller_fee_basis_points": "0",
                    "discord_url": null,
                    "display_data": {
                        "card_display_style": "contain",
                        "images": []
                    },
                    "external_url": null,
                    "featured": false,
                    "featured_image_url": null,
                    "hidden": true,
                    "safelist_request_status": "not_requested",
                    "image_url": null,
                    "is_subject_to_whitelist": false,
                    "large_image_url": null,
                    "medium_username": null,
                    "name": "OpenSea Shared Storefront V2",
                    "only_proxied_transfers": false,
                    "opensea_buyer_fee_basis_points": "0",
                    "opensea_seller_fee_basis_points": "250",
                    "payout_address": null,
                    "require_email": false,
                    "short_description": null,
                    "slug": "opensea-shared-storefront-v2",
                    "telegram_url": null,
                    "twitter_username": null,
                    "instagram_username": null,
                    "wiki_url": null
                },
                "address": "0x495f947276749ce646f68ac8c248420045cb7b5e",
                "asset_contract_type": "semi-fungible",
                "created_date": "2020-12-02T17:40:53.232025",
                "name": "OpenSea Collection",
                "nft_version": null,
                "opensea_version": "2.0.0",
                "owner": 102384,
                "schema_name": "ERC1155",
                "symbol": "OPENSTORE",
                "total_supply": null,
                "description": null,
                "external_link": null,
                "image_url": null,
                "default_to_fiat": false,
                "dev_buyer_fee_basis_points": 0,
                "dev_seller_fee_basis_points": 0,
                "only_proxied_transfers": false,
                "opensea_buyer_fee_basis_points": 0,
                "opensea_seller_fee_basis_points": 250,
                "buyer_fee_basis_points": 0,
                "seller_fee_basis_points": 250,
                "payout_address": null
            },
            "permalink": "https://opensea.io/bundles/cry3nfts-0vt",
            "sell_orders": [
                {
                    "created_date": "2021-05-25T22:12:32.154645",
                    "closing_date": "2021-06-01T22:10:46",
                    "closing_extendable": false,
                    "expiration_time": 1622585446,
                    "listing_time": 1621980645,
                    "order_hash": "0x8e95a73f73b274d2d80d0dd128e0f62ee89a6d97628532b541282163a0eebcc1",
                    "metadata": {
                        "bundle": {
                            "assets": [
                                {
                                    "id": "38390781405459679747136907948379193480062007280636129664739814621292439535617",
                                    "address": "0x495f947276749ce646f68ac8c248420045cb7b5e",
                                    "quantity": "1"
                                },
                                {
                                    "id": "38390781405459679747136907948379193480062007280636129664739814622391951163393",
                                    "address": "0x495f947276749ce646f68ac8c248420045cb7b5e",
                                    "quantity": "1"
                                },
                                {
                                    "id": "38390781405459679747136907948379193480062007280636129664739814623491462791169",
                                    "address": "0x495f947276749ce646f68ac8c248420045cb7b5e",
                                    "quantity": "1"
                                }
                            ],
                            "schemas": [
                                "ERC1155",
                                "ERC1155",
                                "ERC1155"
                            ],
                            "name": "Cry3Nfts",
                            "description": "",
                            "external_link": ""
                        }
                    },
                    "exchange": "0x7be8076f4ea4a4ad08075c2508e481d6c946d12b",
                    "maker": {
                        "user": 833525,
                        "profile_img_url": "https://storage.googleapis.com/opensea-static/opensea-profile/6.png",
                        "address": "0x54e069893032ae2196ab02fe7d013069dd6f3416",
                        "config": "",
                        "discord_id": ""
                    },
                    "taker": {
                        "user": 1766,
                        "profile_img_url": "https://storage.googleapis.com/opensea-static/opensea-profile/1.png",
                        "address": "0x0000000000000000000000000000000000000000",
                        "config": "",
                        "discord_id": ""
                    },
                    "current_price": "3300028781871254830.653000000",
                    "current_bounty": "33000287810579504",
                    "bounty_multiple": "0.01",
                    "maker_relayer_fee": "250",
                    "taker_relayer_fee": "0",
                    "maker_protocol_fee": "0",
                    "taker_protocol_fee": "0",
                    "maker_referrer_fee": "0",
                    "fee_recipient": {
                        "user": 3585,
                        "profile_img_url": "https://storage.googleapis.com/opensea-static/opensea-profile/28.png",
                        "address": "0x5b3256965e7c3cf26e11fcaf296dfc8807c01073",
                        "config": "verified",
                        "discord_id": ""
                    },
                    "fee_method": 1,
                    "side": 1,
                    "sale_kind": 1,
                    "target": "0xc99f70bfd82fb7c8f8191fdfbfb735606b15e5c5",
                    "how_to_call": 1,
                    "calldata": "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",
                    "replacement_pattern": "0x0000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000ffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffff0000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000ffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffff0000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000ffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffff00000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000",
                    "static_target": "0x0000000000000000000000000000000000000000",
                    "static_extradata": "0x",
                    "payment_token": "0x0000000000000000000000000000000000000000",
                    "payment_token_contract": {
                        "id": 1,
                        "symbol": "ETH",
                        "address": "0x0000000000000000000000000000000000000000",
                        "image_url": "https://storage.opensea.io/files/6f8e2979d428180222796ff4a33ab929.svg",
                        "name": "Ether",
                        "decimals": 18,
                        "eth_price": "1.000000000000000",
                        "usd_price": "2625.730000000000018000"
                    },
                    "base_price": "3321000000000000000",
                    "extra": "3301000000000000000",
                    "quantity": "1",
                    "salt": "59317374032324468352185040321168746734936613716016387810807282100235886514528",
                    "v": 27,
                    "r": "0x4d4f98e845000d8fa4f4bc4e60511359b725e71835bef306003570286a160344",
                    "s": "0x1c1977a14398f68fe79ec70b3de11608bb1aed6758ffb4ea2de70369f89c9ba6",
                    "approved_on_chain": false,
                    "cancelled": false,
                    "finalized": false,
                    "marked_invalid": false,
                    "prefixed_hash": "0xebf71c9766f52d89b2d699c0d4255ea053c68142cf4ff87d0a4f8e19f5e7b5e0"
                }
            ]
        },
        {
            "maker": {
                "user": {
                    "username": "REVOLT"
                },
                "profile_img_url": "https://storage.googleapis.com/opensea-static/opensea-profile/25.png",
                "address": "0xb6d820e80a2a7c49f94c9d6c8ea08dccedc9ce4c",
                "config": "",
                "discord_id": ""
            },
            "slug": "small-estate-9-lands-EU4",
            "assets": [
                {
                    "id": 14407257,
                    "token_id": "115263",
                    "num_sales": 0,
                    "background_color": null,
                    "image_url": "https://storage.opensea.io/files/3faa959fa75531ac7913a9c9f8361b58.png",
                    "image_preview_url": "https://lh3.googleusercontent.com/17vU_UNWeMOVi4XOAwo4nvAXpeg1dnKPBk8VnAhJcFHOFZ9UBBvSL5Spj0ytvyfII3rdp4gHMY0mMvbnSzjdOZ0=s250",
                    "image_thumbnail_url": "https://lh3.googleusercontent.com/17vU_UNWeMOVi4XOAwo4nvAXpeg1dnKPBk8VnAhJcFHOFZ9UBBvSL5Spj0ytvyfII3rdp4gHMY0mMvbnSzjdOZ0=s128",
                    "image_original_url": "https://storage.googleapis.com/opensea-static/custom-fetcher-images/sandbox/land/sandbox-land.png",
                    "animation_url": null,
                    "animation_original_url": null,
                    "name": "LAND (3, 78)",
                    "description": "A LAND is a digital piece of real estate in The Sandbox metaverse that players can buy to build experiences on top of. Once you own a LAND, you will be able to populate it with Games and Assets. Each LAND is a unique (non-fungible) token lying on the public Ethereum blockchain (ERC-721).",
                    "external_link": "https://www.sandbox.game/en/map/?x=3&y=78",
                    "asset_contract": {
                        "address": "0x50f5474724e0ee42d9a4e711ccfb275809fd6d4a",
                        "asset_contract_type": "non-fungible",
                        "created_date": "2019-12-04T10:58:28.892990",
                        "name": "Sandbox's LANDs",
                        "nft_version": "3.0",
                        "opensea_version": null,
                        "owner": null,
                        "schema_name": "ERC721",
                        "symbol": "",
                        "total_supply": null,
                        "description": "The Sandbox is a community-driven platform where creators can monetize voxel assets and gaming experiences on the blockchain. The Sandbox metaverse comprises a map made up of 166,464 LANDS.  LAND owners can host contests and events, stake SAND to earn and customize assets, monetize assets and experiences, vote in the metaverse governance, play games that you or others create, and more! Trade the collection and keep your eyes peeled for future drops.",
                        "external_link": "https://www.sandbox.game/",
                        "image_url": "https://lh3.googleusercontent.com/SXH8tW1siikB80rwCRnjm1a5xM_MwTg9Xl9Db6mioIk9HIlDM09pVoSR7GKJgS6ulSUpgW9BDtMk_ePX_NKgO9A=s60",
                        "default_to_fiat": false,
                        "dev_buyer_fee_basis_points": 0,
                        "dev_seller_fee_basis_points": 500,
                        "only_proxied_transfers": false,
                        "opensea_buyer_fee_basis_points": 0,
                        "opensea_seller_fee_basis_points": 250,
                        "buyer_fee_basis_points": 0,
                        "seller_fee_basis_points": 750,
                        "payout_address": "0x7a9fe22691c811ea339d9b73150e6911a5343dca"
                    },
                    "owner": {
                        "user": {
                            "username": "REVOLT"
                        },
                        "profile_img_url": "https://storage.googleapis.com/opensea-static/opensea-profile/25.png",
                        "address": "0xb6d820e80a2a7c49f94c9d6c8ea08dccedc9ce4c",
                        "config": "",
                        "discord_id": ""
                    },
                    "permalink": "https://opensea.io/assets/0x50f5474724e0ee42d9a4e711ccfb275809fd6d4a/115263",
                    "collection": {
                        "banner_image_url": "https://lh3.googleusercontent.com/4NQIRoGmzXeXQN4mjuhWuuDZSNW7_BqRXux5upd4Nn_A-bfsGxCnPF8qn98Y6MyHRDPGXIlgfZADcSOe6M2DyrDKXdbdaTgkZN5l=s2500",
                        "chat_url": null,
                        "created_date": "2019-12-04T10:58:29.069907",
                        "default_to_fiat": false,
                        "description": "The Sandbox is a community-driven platform where creators can monetize voxel assets and gaming experiences on the blockchain. The Sandbox metaverse comprises a map made up of 166,464 LANDS.  LAND owners can host contests and events, stake SAND to earn and customize assets, monetize assets and experiences, vote in the metaverse governance, play games that you or others create, and more! Trade the collection and keep your eyes peeled for future drops.",
                        "dev_buyer_fee_basis_points": "0",
                        "dev_seller_fee_basis_points": "500",
                        "discord_url": "https://discord.gg/vAe4zvY",
                        "display_data": {
                            "card_display_style": "contain"
                        },
                        "external_url": "https://www.sandbox.game/",
                        "featured": false,
                        "featured_image_url": "https://storage.googleapis.com/opensea-static/featured-images/sandbox-featured.png",
                        "hidden": false,
                        "safelist_request_status": "verified",
                        "image_url": "https://lh3.googleusercontent.com/SXH8tW1siikB80rwCRnjm1a5xM_MwTg9Xl9Db6mioIk9HIlDM09pVoSR7GKJgS6ulSUpgW9BDtMk_ePX_NKgO9A=s60",
                        "is_subject_to_whitelist": false,
                        "large_image_url": "https://lh3.googleusercontent.com/SXH8tW1siikB80rwCRnjm1a5xM_MwTg9Xl9Db6mioIk9HIlDM09pVoSR7GKJgS6ulSUpgW9BDtMk_ePX_NKgO9A",
                        "medium_username": "sandbox-game",
                        "name": "The Sandbox",
                        "only_proxied_transfers": false,
                        "opensea_buyer_fee_basis_points": "0",
                        "opensea_seller_fee_basis_points": "250",
                        "payout_address": "0x7a9fe22691c811ea339d9b73150e6911a5343dca",
                        "require_email": false,
                        "short_description": null,
                        "slug": "sandbox",
                        "telegram_url": "https://t.me/sandboxgame",
                        "twitter_username": "thesandboxgame",
                        "instagram_username": null,
                        "wiki_url": null
                    },
                    "decimals": null,
                    "token_metadata": null
                },
                {
                    "id": 14407276,
                    "token_id": "115264",
                    "num_sales": 0,
                    "background_color": null,
                    "image_url": "https://lh3.googleusercontent.com/17vU_UNWeMOVi4XOAwo4nvAXpeg1dnKPBk8VnAhJcFHOFZ9UBBvSL5Spj0ytvyfII3rdp4gHMY0mMvbnSzjdOZ0",
                    "image_preview_url": "https://lh3.googleusercontent.com/17vU_UNWeMOVi4XOAwo4nvAXpeg1dnKPBk8VnAhJcFHOFZ9UBBvSL5Spj0ytvyfII3rdp4gHMY0mMvbnSzjdOZ0=s250",
                    "image_thumbnail_url": "https://lh3.googleusercontent.com/17vU_UNWeMOVi4XOAwo4nvAXpeg1dnKPBk8VnAhJcFHOFZ9UBBvSL5Spj0ytvyfII3rdp4gHMY0mMvbnSzjdOZ0=s128",
                    "image_original_url": "https://storage.googleapis.com/opensea-static/custom-fetcher-images/sandbox/land/sandbox-land.png",
                    "animation_url": null,
                    "animation_original_url": null,
                    "name": "LAND (4, 78)",
                    "description": "A LAND is a digital piece of real estate in The Sandbox metaverse that players can buy to build experiences on top of. Once you own a LAND, you will be able to populate it with Games and Assets. Each LAND is a unique (non-fungible) token lying on the public Ethereum blockchain (ERC-721).",
                    "external_link": "https://www.sandbox.game/en/map/?x=4&y=78",
                    "asset_contract": {
                        "address": "0x50f5474724e0ee42d9a4e711ccfb275809fd6d4a",
                        "asset_contract_type": "non-fungible",
                        "created_date": "2019-12-04T10:58:28.892990",
                        "name": "Sandbox's LANDs",
                        "nft_version": "3.0",
                        "opensea_version": null,
                        "owner": null,
                        "schema_name": "ERC721",
                        "symbol": "",
                        "total_supply": null,
                        "description": "The Sandbox is a community-driven platform where creators can monetize voxel assets and gaming experiences on the blockchain. The Sandbox metaverse comprises a map made up of 166,464 LANDS.  LAND owners can host contests and events, stake SAND to earn and customize assets, monetize assets and experiences, vote in the metaverse governance, play games that you or others create, and more! Trade the collection and keep your eyes peeled for future drops.",
                        "external_link": "https://www.sandbox.game/",
                        "image_url": "https://lh3.googleusercontent.com/SXH8tW1siikB80rwCRnjm1a5xM_MwTg9Xl9Db6mioIk9HIlDM09pVoSR7GKJgS6ulSUpgW9BDtMk_ePX_NKgO9A=s60",
                        "default_to_fiat": false,
                        "dev_buyer_fee_basis_points": 0,
                        "dev_seller_fee_basis_points": 500,
                        "only_proxied_transfers": false,
                        "opensea_buyer_fee_basis_points": 0,
                        "opensea_seller_fee_basis_points": 250,
                        "buyer_fee_basis_points": 0,
                        "seller_fee_basis_points": 750,
                        "payout_address": "0x7a9fe22691c811ea339d9b73150e6911a5343dca"
                    },
                    "owner": {
                        "user": {
                            "username": "REVOLT"
                        },
                        "profile_img_url": "https://storage.googleapis.com/opensea-static/opensea-profile/25.png",
                        "address": "0xb6d820e80a2a7c49f94c9d6c8ea08dccedc9ce4c",
                        "config": "",
                        "discord_id": ""
                    },
                    "permalink": "https://opensea.io/assets/0x50f5474724e0ee42d9a4e711ccfb275809fd6d4a/115264",
                    "collection": {
                        "banner_image_url": "https://lh3.googleusercontent.com/4NQIRoGmzXeXQN4mjuhWuuDZSNW7_BqRXux5upd4Nn_A-bfsGxCnPF8qn98Y6MyHRDPGXIlgfZADcSOe6M2DyrDKXdbdaTgkZN5l=s2500",
                        "chat_url": null,
                        "created_date": "2019-12-04T10:58:29.069907",
                        "default_to_fiat": false,
                        "description": "The Sandbox is a community-driven platform where creators can monetize voxel assets and gaming experiences on the blockchain. The Sandbox metaverse comprises a map made up of 166,464 LANDS.  LAND owners can host contests and events, stake SAND to earn and customize assets, monetize assets and experiences, vote in the metaverse governance, play games that you or others create, and more! Trade the collection and keep your eyes peeled for future drops.",
                        "dev_buyer_fee_basis_points": "0",
                        "dev_seller_fee_basis_points": "500",
                        "discord_url": "https://discord.gg/vAe4zvY",
                        "display_data": {
                            "card_display_style": "contain"
                        },
                        "external_url": "https://www.sandbox.game/",
                        "featured": false,
                        "featured_image_url": "https://storage.googleapis.com/opensea-static/featured-images/sandbox-featured.png",
                        "hidden": false,
                        "safelist_request_status": "verified",
                        "image_url": "https://lh3.googleusercontent.com/SXH8tW1siikB80rwCRnjm1a5xM_MwTg9Xl9Db6mioIk9HIlDM09pVoSR7GKJgS6ulSUpgW9BDtMk_ePX_NKgO9A=s60",
                        "is_subject_to_whitelist": false,
                        "large_image_url": "https://lh3.googleusercontent.com/SXH8tW1siikB80rwCRnjm1a5xM_MwTg9Xl9Db6mioIk9HIlDM09pVoSR7GKJgS6ulSUpgW9BDtMk_ePX_NKgO9A",
                        "medium_username": "sandbox-game",
                        "name": "The Sandbox",
                        "only_proxied_transfers": false,
                        "opensea_buyer_fee_basis_points": "0",
                        "opensea_seller_fee_basis_points": "250",
                        "payout_address": "0x7a9fe22691c811ea339d9b73150e6911a5343dca",
                        "require_email": false,
                        "short_description": null,
                        "slug": "sandbox",
                        "telegram_url": "https://t.me/sandboxgame",
                        "twitter_username": "thesandboxgame",
                        "instagram_username": null,
                        "wiki_url": null
                    },
                    "decimals": null,
                    "token_metadata": null
                },
                {
                    "id": 14407286,
                    "token_id": "115265",
                    "num_sales": 0,
                    "background_color": null,
                    "image_url": "https://lh3.googleusercontent.com/17vU_UNWeMOVi4XOAwo4nvAXpeg1dnKPBk8VnAhJcFHOFZ9UBBvSL5Spj0ytvyfII3rdp4gHMY0mMvbnSzjdOZ0",
                    "image_preview_url": "https://lh3.googleusercontent.com/17vU_UNWeMOVi4XOAwo4nvAXpeg1dnKPBk8VnAhJcFHOFZ9UBBvSL5Spj0ytvyfII3rdp4gHMY0mMvbnSzjdOZ0=s250",
                    "image_thumbnail_url": "https://lh3.googleusercontent.com/17vU_UNWeMOVi4XOAwo4nvAXpeg1dnKPBk8VnAhJcFHOFZ9UBBvSL5Spj0ytvyfII3rdp4gHMY0mMvbnSzjdOZ0=s128",
                    "image_original_url": "https://storage.googleapis.com/opensea-static/custom-fetcher-images/sandbox/land/sandbox-land.png",
                    "animation_url": null,
                    "animation_original_url": null,
                    "name": "LAND (5, 78)",
                    "description": "A LAND is a digital piece of real estate in The Sandbox metaverse that players can buy to build experiences on top of. Once you own a LAND, you will be able to populate it with Games and Assets. Each LAND is a unique (non-fungible) token lying on the public Ethereum blockchain (ERC-721).",
                    "external_link": "https://www.sandbox.game/en/map/?x=5&y=78",
                    "asset_contract": {
                        "address": "0x50f5474724e0ee42d9a4e711ccfb275809fd6d4a",
                        "asset_contract_type": "non-fungible",
                        "created_date": "2019-12-04T10:58:28.892990",
                        "name": "Sandbox's LANDs",
                        "nft_version": "3.0",
                        "opensea_version": null,
                        "owner": null,
                        "schema_name": "ERC721",
                        "symbol": "",
                        "total_supply": null,
                        "description": "The Sandbox is a community-driven platform where creators can monetize voxel assets and gaming experiences on the blockchain. The Sandbox metaverse comprises a map made up of 166,464 LANDS.  LAND owners can host contests and events, stake SAND to earn and customize assets, monetize assets and experiences, vote in the metaverse governance, play games that you or others create, and more! Trade the collection and keep your eyes peeled for future drops.",
                        "external_link": "https://www.sandbox.game/",
                        "image_url": "https://lh3.googleusercontent.com/SXH8tW1siikB80rwCRnjm1a5xM_MwTg9Xl9Db6mioIk9HIlDM09pVoSR7GKJgS6ulSUpgW9BDtMk_ePX_NKgO9A=s60",
                        "default_to_fiat": false,
                        "dev_buyer_fee_basis_points": 0,
                        "dev_seller_fee_basis_points": 500,
                        "only_proxied_transfers": false,
                        "opensea_buyer_fee_basis_points": 0,
                        "opensea_seller_fee_basis_points": 250,
                        "buyer_fee_basis_points": 0,
                        "seller_fee_basis_points": 750,
                        "payout_address": "0x7a9fe22691c811ea339d9b73150e6911a5343dca"
                    },
                    "owner": {
                        "user": {
                            "username": "REVOLT"
                        },
                        "profile_img_url": "https://storage.googleapis.com/opensea-static/opensea-profile/25.png",
                        "address": "0xb6d820e80a2a7c49f94c9d6c8ea08dccedc9ce4c",
                        "config": "",
                        "discord_id": ""
                    },
                    "permalink": "https://opensea.io/assets/0x50f5474724e0ee42d9a4e711ccfb275809fd6d4a/115265",
                    "collection": {
                        "banner_image_url": "https://lh3.googleusercontent.com/4NQIRoGmzXeXQN4mjuhWuuDZSNW7_BqRXux5upd4Nn_A-bfsGxCnPF8qn98Y6MyHRDPGXIlgfZADcSOe6M2DyrDKXdbdaTgkZN5l=s2500",
                        "chat_url": null,
                        "created_date": "2019-12-04T10:58:29.069907",
                        "default_to_fiat": false,
                        "description": "The Sandbox is a community-driven platform where creators can monetize voxel assets and gaming experiences on the blockchain. The Sandbox metaverse comprises a map made up of 166,464 LANDS.  LAND owners can host contests and events, stake SAND to earn and customize assets, monetize assets and experiences, vote in the metaverse governance, play games that you or others create, and more! Trade the collection and keep your eyes peeled for future drops.",
                        "dev_buyer_fee_basis_points": "0",
                        "dev_seller_fee_basis_points": "500",
                        "discord_url": "https://discord.gg/vAe4zvY",
                        "display_data": {
                            "card_display_style": "contain"
                        },
                        "external_url": "https://www.sandbox.game/",
                        "featured": false,
                        "featured_image_url": "https://storage.googleapis.com/opensea-static/featured-images/sandbox-featured.png",
                        "hidden": false,
                        "safelist_request_status": "verified",
                        "image_url": "https://lh3.googleusercontent.com/SXH8tW1siikB80rwCRnjm1a5xM_MwTg9Xl9Db6mioIk9HIlDM09pVoSR7GKJgS6ulSUpgW9BDtMk_ePX_NKgO9A=s60",
                        "is_subject_to_whitelist": false,
                        "large_image_url": "https://lh3.googleusercontent.com/SXH8tW1siikB80rwCRnjm1a5xM_MwTg9Xl9Db6mioIk9HIlDM09pVoSR7GKJgS6ulSUpgW9BDtMk_ePX_NKgO9A",
                        "medium_username": "sandbox-game",
                        "name": "The Sandbox",
                        "only_proxied_transfers": false,
                        "opensea_buyer_fee_basis_points": "0",
                        "opensea_seller_fee_basis_points": "250",
                        "payout_address": "0x7a9fe22691c811ea339d9b73150e6911a5343dca",
                        "require_email": false,
                        "short_description": null,
                        "slug": "sandbox",
                        "telegram_url": "https://t.me/sandboxgame",
                        "twitter_username": "thesandboxgame",
                        "instagram_username": null,
                        "wiki_url": null
                    },
                    "decimals": null,
                    "token_metadata": null
                },
                {
                    "id": 14407296,
                    "token_id": "115673",
                    "num_sales": 0,
                    "background_color": null,
                    "image_url": "https://lh3.googleusercontent.com/17vU_UNWeMOVi4XOAwo4nvAXpeg1dnKPBk8VnAhJcFHOFZ9UBBvSL5Spj0ytvyfII3rdp4gHMY0mMvbnSzjdOZ0",
                    "image_preview_url": "https://lh3.googleusercontent.com/17vU_UNWeMOVi4XOAwo4nvAXpeg1dnKPBk8VnAhJcFHOFZ9UBBvSL5Spj0ytvyfII3rdp4gHMY0mMvbnSzjdOZ0=s250",
                    "image_thumbnail_url": "https://lh3.googleusercontent.com/17vU_UNWeMOVi4XOAwo4nvAXpeg1dnKPBk8VnAhJcFHOFZ9UBBvSL5Spj0ytvyfII3rdp4gHMY0mMvbnSzjdOZ0=s128",
                    "image_original_url": "https://storage.googleapis.com/opensea-static/custom-fetcher-images/sandbox/land/sandbox-land.png",
                    "animation_url": null,
                    "animation_original_url": null,
                    "name": "LAND (5, 79)",
                    "description": "A LAND is a digital piece of real estate in The Sandbox metaverse that players can buy to build experiences on top of. Once you own a LAND, you will be able to populate it with Games and Assets. Each LAND is a unique (non-fungible) token lying on the public Ethereum blockchain (ERC-721).",
                    "external_link": "https://www.sandbox.game/en/map/?x=5&y=79",
                    "asset_contract": {
                        "address": "0x50f5474724e0ee42d9a4e711ccfb275809fd6d4a",
                        "asset_contract_type": "non-fungible",
                        "created_date": "2019-12-04T10:58:28.892990",
                        "name": "Sandbox's LANDs",
                        "nft_version": "3.0",
                        "opensea_version": null,
                        "owner": null,
                        "schema_name": "ERC721",
                        "symbol": "",
                        "total_supply": null,
                        "description": "The Sandbox is a community-driven platform where creators can monetize voxel assets and gaming experiences on the blockchain. The Sandbox metaverse comprises a map made up of 166,464 LANDS.  LAND owners can host contests and events, stake SAND to earn and customize assets, monetize assets and experiences, vote in the metaverse governance, play games that you or others create, and more! Trade the collection and keep your eyes peeled for future drops.",
                        "external_link": "https://www.sandbox.game/",
                        "image_url": "https://lh3.googleusercontent.com/SXH8tW1siikB80rwCRnjm1a5xM_MwTg9Xl9Db6mioIk9HIlDM09pVoSR7GKJgS6ulSUpgW9BDtMk_ePX_NKgO9A=s60",
                        "default_to_fiat": false,
                        "dev_buyer_fee_basis_points": 0,
                        "dev_seller_fee_basis_points": 500,
                        "only_proxied_transfers": false,
                        "opensea_buyer_fee_basis_points": 0,
                        "opensea_seller_fee_basis_points": 250,
                        "buyer_fee_basis_points": 0,
                        "seller_fee_basis_points": 750,
                        "payout_address": "0x7a9fe22691c811ea339d9b73150e6911a5343dca"
                    },
                    "owner": {
                        "user": {
                            "username": "REVOLT"
                        },
                        "profile_img_url": "https://storage.googleapis.com/opensea-static/opensea-profile/25.png",
                        "address": "0xb6d820e80a2a7c49f94c9d6c8ea08dccedc9ce4c",
                        "config": "",
                        "discord_id": ""
                    },
                    "permalink": "https://opensea.io/assets/0x50f5474724e0ee42d9a4e711ccfb275809fd6d4a/115673",
                    "collection": {
                        "banner_image_url": "https://lh3.googleusercontent.com/4NQIRoGmzXeXQN4mjuhWuuDZSNW7_BqRXux5upd4Nn_A-bfsGxCnPF8qn98Y6MyHRDPGXIlgfZADcSOe6M2DyrDKXdbdaTgkZN5l=s2500",
                        "chat_url": null,
                        "created_date": "2019-12-04T10:58:29.069907",
                        "default_to_fiat": false,
                        "description": "The Sandbox is a community-driven platform where creators can monetize voxel assets and gaming experiences on the blockchain. The Sandbox metaverse comprises a map made up of 166,464 LANDS.  LAND owners can host contests and events, stake SAND to earn and customize assets, monetize assets and experiences, vote in the metaverse governance, play games that you or others create, and more! Trade the collection and keep your eyes peeled for future drops.",
                        "dev_buyer_fee_basis_points": "0",
                        "dev_seller_fee_basis_points": "500",
                        "discord_url": "https://discord.gg/vAe4zvY",
                        "display_data": {
                            "card_display_style": "contain"
                        },
                        "external_url": "https://www.sandbox.game/",
                        "featured": false,
                        "featured_image_url": "https://storage.googleapis.com/opensea-static/featured-images/sandbox-featured.png",
                        "hidden": false,
                        "safelist_request_status": "verified",
                        "image_url": "https://lh3.googleusercontent.com/SXH8tW1siikB80rwCRnjm1a5xM_MwTg9Xl9Db6mioIk9HIlDM09pVoSR7GKJgS6ulSUpgW9BDtMk_ePX_NKgO9A=s60",
                        "is_subject_to_whitelist": false,
                        "large_image_url": "https://lh3.googleusercontent.com/SXH8tW1siikB80rwCRnjm1a5xM_MwTg9Xl9Db6mioIk9HIlDM09pVoSR7GKJgS6ulSUpgW9BDtMk_ePX_NKgO9A",
                        "medium_username": "sandbox-game",
                        "name": "The Sandbox",
                        "only_proxied_transfers": false,
                        "opensea_buyer_fee_basis_points": "0",
                        "opensea_seller_fee_basis_points": "250",
                        "payout_address": "0x7a9fe22691c811ea339d9b73150e6911a5343dca",
                        "require_email": false,
                        "short_description": null,
                        "slug": "sandbox",
                        "telegram_url": "https://t.me/sandboxgame",
                        "twitter_username": "thesandboxgame",
                        "instagram_username": null,
                        "wiki_url": null
                    },
                    "decimals": null,
                    "token_metadata": null
                },
                {
                    "id": 14407307,
                    "token_id": "115672",
                    "num_sales": 0,
                    "background_color": null,
                    "image_url": "https://storage.opensea.io/files/3faa959fa75531ac7913a9c9f8361b58.png",
                    "image_preview_url": "https://lh3.googleusercontent.com/17vU_UNWeMOVi4XOAwo4nvAXpeg1dnKPBk8VnAhJcFHOFZ9UBBvSL5Spj0ytvyfII3rdp4gHMY0mMvbnSzjdOZ0=s250",
                    "image_thumbnail_url": "https://lh3.googleusercontent.com/17vU_UNWeMOVi4XOAwo4nvAXpeg1dnKPBk8VnAhJcFHOFZ9UBBvSL5Spj0ytvyfII3rdp4gHMY0mMvbnSzjdOZ0=s128",
                    "image_original_url": "https://storage.googleapis.com/opensea-static/custom-fetcher-images/sandbox/land/sandbox-land.png",
                    "animation_url": null,
                    "animation_original_url": null,
                    "name": "LAND (4, 79)",
                    "description": "A LAND is a digital piece of real estate in The Sandbox metaverse that players can buy to build experiences on top of. Once you own a LAND, you will be able to populate it with Games and Assets. Each LAND is a unique (non-fungible) token lying on the public Ethereum blockchain (ERC-721).",
                    "external_link": "https://www.sandbox.game/en/map/?x=4&y=79",
                    "asset_contract": {
                        "address": "0x50f5474724e0ee42d9a4e711ccfb275809fd6d4a",
                        "asset_contract_type": "non-fungible",
                        "created_date": "2019-12-04T10:58:28.892990",
                        "name": "Sandbox's LANDs",
                        "nft_version": "3.0",
                        "opensea_version": null,
                        "owner": null,
                        "schema_name": "ERC721",
                        "symbol": "",
                        "total_supply": null,
                        "description": "The Sandbox is a community-driven platform where creators can monetize voxel assets and gaming experiences on the blockchain. The Sandbox metaverse comprises a map made up of 166,464 LANDS.  LAND owners can host contests and events, stake SAND to earn and customize assets, monetize assets and experiences, vote in the metaverse governance, play games that you or others create, and more! Trade the collection and keep your eyes peeled for future drops.",
                        "external_link": "https://www.sandbox.game/",
                        "image_url": "https://lh3.googleusercontent.com/SXH8tW1siikB80rwCRnjm1a5xM_MwTg9Xl9Db6mioIk9HIlDM09pVoSR7GKJgS6ulSUpgW9BDtMk_ePX_NKgO9A=s60",
                        "default_to_fiat": false,
                        "dev_buyer_fee_basis_points": 0,
                        "dev_seller_fee_basis_points": 500,
                        "only_proxied_transfers": false,
                        "opensea_buyer_fee_basis_points": 0,
                        "opensea_seller_fee_basis_points": 250,
                        "buyer_fee_basis_points": 0,
                        "seller_fee_basis_points": 750,
                        "payout_address": "0x7a9fe22691c811ea339d9b73150e6911a5343dca"
                    },
                    "owner": {
                        "user": {
                            "username": "REVOLT"
                        },
                        "profile_img_url": "https://storage.googleapis.com/opensea-static/opensea-profile/25.png",
                        "address": "0xb6d820e80a2a7c49f94c9d6c8ea08dccedc9ce4c",
                        "config": "",
                        "discord_id": ""
                    },
                    "permalink": "https://opensea.io/assets/0x50f5474724e0ee42d9a4e711ccfb275809fd6d4a/115672",
                    "collection": {
                        "banner_image_url": "https://lh3.googleusercontent.com/4NQIRoGmzXeXQN4mjuhWuuDZSNW7_BqRXux5upd4Nn_A-bfsGxCnPF8qn98Y6MyHRDPGXIlgfZADcSOe6M2DyrDKXdbdaTgkZN5l=s2500",
                        "chat_url": null,
                        "created_date": "2019-12-04T10:58:29.069907",
                        "default_to_fiat": false,
                        "description": "The Sandbox is a community-driven platform where creators can monetize voxel assets and gaming experiences on the blockchain. The Sandbox metaverse comprises a map made up of 166,464 LANDS.  LAND owners can host contests and events, stake SAND to earn and customize assets, monetize assets and experiences, vote in the metaverse governance, play games that you or others create, and more! Trade the collection and keep your eyes peeled for future drops.",
                        "dev_buyer_fee_basis_points": "0",
                        "dev_seller_fee_basis_points": "500",
                        "discord_url": "https://discord.gg/vAe4zvY",
                        "display_data": {
                            "card_display_style": "contain"
                        },
                        "external_url": "https://www.sandbox.game/",
                        "featured": false,
                        "featured_image_url": "https://storage.googleapis.com/opensea-static/featured-images/sandbox-featured.png",
                        "hidden": false,
                        "safelist_request_status": "verified",
                        "image_url": "https://lh3.googleusercontent.com/SXH8tW1siikB80rwCRnjm1a5xM_MwTg9Xl9Db6mioIk9HIlDM09pVoSR7GKJgS6ulSUpgW9BDtMk_ePX_NKgO9A=s60",
                        "is_subject_to_whitelist": false,
                        "large_image_url": "https://lh3.googleusercontent.com/SXH8tW1siikB80rwCRnjm1a5xM_MwTg9Xl9Db6mioIk9HIlDM09pVoSR7GKJgS6ulSUpgW9BDtMk_ePX_NKgO9A",
                        "medium_username": "sandbox-game",
                        "name": "The Sandbox",
                        "only_proxied_transfers": false,
                        "opensea_buyer_fee_basis_points": "0",
                        "opensea_seller_fee_basis_points": "250",
                        "payout_address": "0x7a9fe22691c811ea339d9b73150e6911a5343dca",
                        "require_email": false,
                        "short_description": null,
                        "slug": "sandbox",
                        "telegram_url": "https://t.me/sandboxgame",
                        "twitter_username": "thesandboxgame",
                        "instagram_username": null,
                        "wiki_url": null
                    },
                    "decimals": null,
                    "token_metadata": null
                },
                {
                    "id": 14407317,
                    "token_id": "115671",
                    "num_sales": 0,
                    "background_color": null,
                    "image_url": "https://storage.opensea.io/files/3faa959fa75531ac7913a9c9f8361b58.png",
                    "image_preview_url": "https://lh3.googleusercontent.com/17vU_UNWeMOVi4XOAwo4nvAXpeg1dnKPBk8VnAhJcFHOFZ9UBBvSL5Spj0ytvyfII3rdp4gHMY0mMvbnSzjdOZ0=s250",
                    "image_thumbnail_url": "https://lh3.googleusercontent.com/17vU_UNWeMOVi4XOAwo4nvAXpeg1dnKPBk8VnAhJcFHOFZ9UBBvSL5Spj0ytvyfII3rdp4gHMY0mMvbnSzjdOZ0=s128",
                    "image_original_url": "https://storage.googleapis.com/opensea-static/custom-fetcher-images/sandbox/land/sandbox-land.png",
                    "animation_url": null,
                    "animation_original_url": null,
                    "name": "LAND (3, 79)",
                    "description": "A LAND is a digital piece of real estate in The Sandbox metaverse that players can buy to build experiences on top of. Once you own a LAND, you will be able to populate it with Games and Assets. Each LAND is a unique (non-fungible) token lying on the public Ethereum blockchain (ERC-721).",
                    "external_link": "https://www.sandbox.game/en/map/?x=3&y=79",
                    "asset_contract": {
                        "address": "0x50f5474724e0ee42d9a4e711ccfb275809fd6d4a",
                        "asset_contract_type": "non-fungible",
                        "created_date": "2019-12-04T10:58:28.892990",
                        "name": "Sandbox's LANDs",
                        "nft_version": "3.0",
                        "opensea_version": null,
                        "owner": null,
                        "schema_name": "ERC721",
                        "symbol": "",
                        "total_supply": null,
                        "description": "The Sandbox is a community-driven platform where creators can monetize voxel assets and gaming experiences on the blockchain. The Sandbox metaverse comprises a map made up of 166,464 LANDS.  LAND owners can host contests and events, stake SAND to earn and customize assets, monetize assets and experiences, vote in the metaverse governance, play games that you or others create, and more! Trade the collection and keep your eyes peeled for future drops.",
                        "external_link": "https://www.sandbox.game/",
                        "image_url": "https://lh3.googleusercontent.com/SXH8tW1siikB80rwCRnjm1a5xM_MwTg9Xl9Db6mioIk9HIlDM09pVoSR7GKJgS6ulSUpgW9BDtMk_ePX_NKgO9A=s60",
                        "default_to_fiat": false,
                        "dev_buyer_fee_basis_points": 0,
                        "dev_seller_fee_basis_points": 500,
                        "only_proxied_transfers": false,
                        "opensea_buyer_fee_basis_points": 0,
                        "opensea_seller_fee_basis_points": 250,
                        "buyer_fee_basis_points": 0,
                        "seller_fee_basis_points": 750,
                        "payout_address": "0x7a9fe22691c811ea339d9b73150e6911a5343dca"
                    },
                    "owner": {
                        "user": {
                            "username": "REVOLT"
                        },
                        "profile_img_url": "https://storage.googleapis.com/opensea-static/opensea-profile/25.png",
                        "address": "0xb6d820e80a2a7c49f94c9d6c8ea08dccedc9ce4c",
                        "config": "",
                        "discord_id": ""
                    },
                    "permalink": "https://opensea.io/assets/0x50f5474724e0ee42d9a4e711ccfb275809fd6d4a/115671",
                    "collection": {
                        "banner_image_url": "https://lh3.googleusercontent.com/4NQIRoGmzXeXQN4mjuhWuuDZSNW7_BqRXux5upd4Nn_A-bfsGxCnPF8qn98Y6MyHRDPGXIlgfZADcSOe6M2DyrDKXdbdaTgkZN5l=s2500",
                        "chat_url": null,
                        "created_date": "2019-12-04T10:58:29.069907",
                        "default_to_fiat": false,
                        "description": "The Sandbox is a community-driven platform where creators can monetize voxel assets and gaming experiences on the blockchain. The Sandbox metaverse comprises a map made up of 166,464 LANDS.  LAND owners can host contests and events, stake SAND to earn and customize assets, monetize assets and experiences, vote in the metaverse governance, play games that you or others create, and more! Trade the collection and keep your eyes peeled for future drops.",
                        "dev_buyer_fee_basis_points": "0",
                        "dev_seller_fee_basis_points": "500",
                        "discord_url": "https://discord.gg/vAe4zvY",
                        "display_data": {
                            "card_display_style": "contain"
                        },
                        "external_url": "https://www.sandbox.game/",
                        "featured": false,
                        "featured_image_url": "https://storage.googleapis.com/opensea-static/featured-images/sandbox-featured.png",
                        "hidden": false,
                        "safelist_request_status": "verified",
                        "image_url": "https://lh3.googleusercontent.com/SXH8tW1siikB80rwCRnjm1a5xM_MwTg9Xl9Db6mioIk9HIlDM09pVoSR7GKJgS6ulSUpgW9BDtMk_ePX_NKgO9A=s60",
                        "is_subject_to_whitelist": false,
                        "large_image_url": "https://lh3.googleusercontent.com/SXH8tW1siikB80rwCRnjm1a5xM_MwTg9Xl9Db6mioIk9HIlDM09pVoSR7GKJgS6ulSUpgW9BDtMk_ePX_NKgO9A",
                        "medium_username": "sandbox-game",
                        "name": "The Sandbox",
                        "only_proxied_transfers": false,
                        "opensea_buyer_fee_basis_points": "0",
                        "opensea_seller_fee_basis_points": "250",
                        "payout_address": "0x7a9fe22691c811ea339d9b73150e6911a5343dca",
                        "require_email": false,
                        "short_description": null,
                        "slug": "sandbox",
                        "telegram_url": "https://t.me/sandboxgame",
                        "twitter_username": "thesandboxgame",
                        "instagram_username": null,
                        "wiki_url": null
                    },
                    "decimals": null,
                    "token_metadata": null
                },
                {
                    "id": 14407328,
                    "token_id": "116079",
                    "num_sales": 0,
                    "background_color": null,
                    "image_url": "https://lh3.googleusercontent.com/17vU_UNWeMOVi4XOAwo4nvAXpeg1dnKPBk8VnAhJcFHOFZ9UBBvSL5Spj0ytvyfII3rdp4gHMY0mMvbnSzjdOZ0",
                    "image_preview_url": "https://lh3.googleusercontent.com/17vU_UNWeMOVi4XOAwo4nvAXpeg1dnKPBk8VnAhJcFHOFZ9UBBvSL5Spj0ytvyfII3rdp4gHMY0mMvbnSzjdOZ0=s250",
                    "image_thumbnail_url": "https://lh3.googleusercontent.com/17vU_UNWeMOVi4XOAwo4nvAXpeg1dnKPBk8VnAhJcFHOFZ9UBBvSL5Spj0ytvyfII3rdp4gHMY0mMvbnSzjdOZ0=s128",
                    "image_original_url": "https://storage.googleapis.com/opensea-static/custom-fetcher-images/sandbox/land/sandbox-land.png",
                    "animation_url": null,
                    "animation_original_url": null,
                    "name": "LAND (3, 80)",
                    "description": "A LAND is a digital piece of real estate in The Sandbox metaverse that players can buy to build experiences on top of. Once you own a LAND, you will be able to populate it with Games and Assets. Each LAND is a unique (non-fungible) token lying on the public Ethereum blockchain (ERC-721).",
                    "external_link": "https://www.sandbox.game/en/map/?x=3&y=80",
                    "asset_contract": {
                        "address": "0x50f5474724e0ee42d9a4e711ccfb275809fd6d4a",
                        "asset_contract_type": "non-fungible",
                        "created_date": "2019-12-04T10:58:28.892990",
                        "name": "Sandbox's LANDs",
                        "nft_version": "3.0",
                        "opensea_version": null,
                        "owner": null,
                        "schema_name": "ERC721",
                        "symbol": "",
                        "total_supply": null,
                        "description": "The Sandbox is a community-driven platform where creators can monetize voxel assets and gaming experiences on the blockchain. The Sandbox metaverse comprises a map made up of 166,464 LANDS.  LAND owners can host contests and events, stake SAND to earn and customize assets, monetize assets and experiences, vote in the metaverse governance, play games that you or others create, and more! Trade the collection and keep your eyes peeled for future drops.",
                        "external_link": "https://www.sandbox.game/",
                        "image_url": "https://lh3.googleusercontent.com/SXH8tW1siikB80rwCRnjm1a5xM_MwTg9Xl9Db6mioIk9HIlDM09pVoSR7GKJgS6ulSUpgW9BDtMk_ePX_NKgO9A=s60",
                        "default_to_fiat": false,
                        "dev_buyer_fee_basis_points": 0,
                        "dev_seller_fee_basis_points": 500,
                        "only_proxied_transfers": false,
                        "opensea_buyer_fee_basis_points": 0,
                        "opensea_seller_fee_basis_points": 250,
                        "buyer_fee_basis_points": 0,
                        "seller_fee_basis_points": 750,
                        "payout_address": "0x7a9fe22691c811ea339d9b73150e6911a5343dca"
                    },
                    "owner": {
                        "user": {
                            "username": "REVOLT"
                        },
                        "profile_img_url": "https://storage.googleapis.com/opensea-static/opensea-profile/25.png",
                        "address": "0xb6d820e80a2a7c49f94c9d6c8ea08dccedc9ce4c",
                        "config": "",
                        "discord_id": ""
                    },
                    "permalink": "https://opensea.io/assets/0x50f5474724e0ee42d9a4e711ccfb275809fd6d4a/116079",
                    "collection": {
                        "banner_image_url": "https://lh3.googleusercontent.com/4NQIRoGmzXeXQN4mjuhWuuDZSNW7_BqRXux5upd4Nn_A-bfsGxCnPF8qn98Y6MyHRDPGXIlgfZADcSOe6M2DyrDKXdbdaTgkZN5l=s2500",
                        "chat_url": null,
                        "created_date": "2019-12-04T10:58:29.069907",
                        "default_to_fiat": false,
                        "description": "The Sandbox is a community-driven platform where creators can monetize voxel assets and gaming experiences on the blockchain. The Sandbox metaverse comprises a map made up of 166,464 LANDS.  LAND owners can host contests and events, stake SAND to earn and customize assets, monetize assets and experiences, vote in the metaverse governance, play games that you or others create, and more! Trade the collection and keep your eyes peeled for future drops.",
                        "dev_buyer_fee_basis_points": "0",
                        "dev_seller_fee_basis_points": "500",
                        "discord_url": "https://discord.gg/vAe4zvY",
                        "display_data": {
                            "card_display_style": "contain"
                        },
                        "external_url": "https://www.sandbox.game/",
                        "featured": false,
                        "featured_image_url": "https://storage.googleapis.com/opensea-static/featured-images/sandbox-featured.png",
                        "hidden": false,
                        "safelist_request_status": "verified",
                        "image_url": "https://lh3.googleusercontent.com/SXH8tW1siikB80rwCRnjm1a5xM_MwTg9Xl9Db6mioIk9HIlDM09pVoSR7GKJgS6ulSUpgW9BDtMk_ePX_NKgO9A=s60",
                        "is_subject_to_whitelist": false,
                        "large_image_url": "https://lh3.googleusercontent.com/SXH8tW1siikB80rwCRnjm1a5xM_MwTg9Xl9Db6mioIk9HIlDM09pVoSR7GKJgS6ulSUpgW9BDtMk_ePX_NKgO9A",
                        "medium_username": "sandbox-game",
                        "name": "The Sandbox",
                        "only_proxied_transfers": false,
                        "opensea_buyer_fee_basis_points": "0",
                        "opensea_seller_fee_basis_points": "250",
                        "payout_address": "0x7a9fe22691c811ea339d9b73150e6911a5343dca",
                        "require_email": false,
                        "short_description": null,
                        "slug": "sandbox",
                        "telegram_url": "https://t.me/sandboxgame",
                        "twitter_username": "thesandboxgame",
                        "instagram_username": null,
                        "wiki_url": null
                    },
                    "decimals": null,
                    "token_metadata": null
                },
                {
                    "id": 14407337,
                    "token_id": "116080",
                    "num_sales": 0,
                    "background_color": null,
                    "image_url": "https://lh3.googleusercontent.com/17vU_UNWeMOVi4XOAwo4nvAXpeg1dnKPBk8VnAhJcFHOFZ9UBBvSL5Spj0ytvyfII3rdp4gHMY0mMvbnSzjdOZ0",
                    "image_preview_url": "https://lh3.googleusercontent.com/17vU_UNWeMOVi4XOAwo4nvAXpeg1dnKPBk8VnAhJcFHOFZ9UBBvSL5Spj0ytvyfII3rdp4gHMY0mMvbnSzjdOZ0=s250",
                    "image_thumbnail_url": "https://lh3.googleusercontent.com/17vU_UNWeMOVi4XOAwo4nvAXpeg1dnKPBk8VnAhJcFHOFZ9UBBvSL5Spj0ytvyfII3rdp4gHMY0mMvbnSzjdOZ0=s128",
                    "image_original_url": "https://storage.googleapis.com/opensea-static/custom-fetcher-images/sandbox/land/sandbox-land.png",
                    "animation_url": null,
                    "animation_original_url": null,
                    "name": "LAND (4, 80)",
                    "description": "A LAND is a digital piece of real estate in The Sandbox metaverse that players can buy to build experiences on top of. Once you own a LAND, you will be able to populate it with Games and Assets. Each LAND is a unique (non-fungible) token lying on the public Ethereum blockchain (ERC-721).",
                    "external_link": "https://www.sandbox.game/en/map/?x=4&y=80",
                    "asset_contract": {
                        "address": "0x50f5474724e0ee42d9a4e711ccfb275809fd6d4a",
                        "asset_contract_type": "non-fungible",
                        "created_date": "2019-12-04T10:58:28.892990",
                        "name": "Sandbox's LANDs",
                        "nft_version": "3.0",
                        "opensea_version": null,
                        "owner": null,
                        "schema_name": "ERC721",
                        "symbol": "",
                        "total_supply": null,
                        "description": "The Sandbox is a community-driven platform where creators can monetize voxel assets and gaming experiences on the blockchain. The Sandbox metaverse comprises a map made up of 166,464 LANDS.  LAND owners can host contests and events, stake SAND to earn and customize assets, monetize assets and experiences, vote in the metaverse governance, play games that you or others create, and more! Trade the collection and keep your eyes peeled for future drops.",
                        "external_link": "https://www.sandbox.game/",
                        "image_url": "https://lh3.googleusercontent.com/SXH8tW1siikB80rwCRnjm1a5xM_MwTg9Xl9Db6mioIk9HIlDM09pVoSR7GKJgS6ulSUpgW9BDtMk_ePX_NKgO9A=s60",
                        "default_to_fiat": false,
                        "dev_buyer_fee_basis_points": 0,
                        "dev_seller_fee_basis_points": 500,
                        "only_proxied_transfers": false,
                        "opensea_buyer_fee_basis_points": 0,
                        "opensea_seller_fee_basis_points": 250,
                        "buyer_fee_basis_points": 0,
                        "seller_fee_basis_points": 750,
                        "payout_address": "0x7a9fe22691c811ea339d9b73150e6911a5343dca"
                    },
                    "owner": {
                        "user": {
                            "username": "REVOLT"
                        },
                        "profile_img_url": "https://storage.googleapis.com/opensea-static/opensea-profile/25.png",
                        "address": "0xb6d820e80a2a7c49f94c9d6c8ea08dccedc9ce4c",
                        "config": "",
                        "discord_id": ""
                    },
                    "permalink": "https://opensea.io/assets/0x50f5474724e0ee42d9a4e711ccfb275809fd6d4a/116080",
                    "collection": {
                        "banner_image_url": "https://lh3.googleusercontent.com/4NQIRoGmzXeXQN4mjuhWuuDZSNW7_BqRXux5upd4Nn_A-bfsGxCnPF8qn98Y6MyHRDPGXIlgfZADcSOe6M2DyrDKXdbdaTgkZN5l=s2500",
                        "chat_url": null,
                        "created_date": "2019-12-04T10:58:29.069907",
                        "default_to_fiat": false,
                        "description": "The Sandbox is a community-driven platform where creators can monetize voxel assets and gaming experiences on the blockchain. The Sandbox metaverse comprises a map made up of 166,464 LANDS.  LAND owners can host contests and events, stake SAND to earn and customize assets, monetize assets and experiences, vote in the metaverse governance, play games that you or others create, and more! Trade the collection and keep your eyes peeled for future drops.",
                        "dev_buyer_fee_basis_points": "0",
                        "dev_seller_fee_basis_points": "500",
                        "discord_url": "https://discord.gg/vAe4zvY",
                        "display_data": {
                            "card_display_style": "contain"
                        },
                        "external_url": "https://www.sandbox.game/",
                        "featured": false,
                        "featured_image_url": "https://storage.googleapis.com/opensea-static/featured-images/sandbox-featured.png",
                        "hidden": false,
                        "safelist_request_status": "verified",
                        "image_url": "https://lh3.googleusercontent.com/SXH8tW1siikB80rwCRnjm1a5xM_MwTg9Xl9Db6mioIk9HIlDM09pVoSR7GKJgS6ulSUpgW9BDtMk_ePX_NKgO9A=s60",
                        "is_subject_to_whitelist": false,
                        "large_image_url": "https://lh3.googleusercontent.com/SXH8tW1siikB80rwCRnjm1a5xM_MwTg9Xl9Db6mioIk9HIlDM09pVoSR7GKJgS6ulSUpgW9BDtMk_ePX_NKgO9A",
                        "medium_username": "sandbox-game",
                        "name": "The Sandbox",
                        "only_proxied_transfers": false,
                        "opensea_buyer_fee_basis_points": "0",
                        "opensea_seller_fee_basis_points": "250",
                        "payout_address": "0x7a9fe22691c811ea339d9b73150e6911a5343dca",
                        "require_email": false,
                        "short_description": null,
                        "slug": "sandbox",
                        "telegram_url": "https://t.me/sandboxgame",
                        "twitter_username": "thesandboxgame",
                        "instagram_username": null,
                        "wiki_url": null
                    },
                    "decimals": null,
                    "token_metadata": null
                },
                {
                    "id": 14407347,
                    "token_id": "116081",
                    "num_sales": 0,
                    "background_color": null,
                    "image_url": "https://lh3.googleusercontent.com/17vU_UNWeMOVi4XOAwo4nvAXpeg1dnKPBk8VnAhJcFHOFZ9UBBvSL5Spj0ytvyfII3rdp4gHMY0mMvbnSzjdOZ0",
                    "image_preview_url": "https://lh3.googleusercontent.com/17vU_UNWeMOVi4XOAwo4nvAXpeg1dnKPBk8VnAhJcFHOFZ9UBBvSL5Spj0ytvyfII3rdp4gHMY0mMvbnSzjdOZ0=s250",
                    "image_thumbnail_url": "https://lh3.googleusercontent.com/17vU_UNWeMOVi4XOAwo4nvAXpeg1dnKPBk8VnAhJcFHOFZ9UBBvSL5Spj0ytvyfII3rdp4gHMY0mMvbnSzjdOZ0=s128",
                    "image_original_url": "https://storage.googleapis.com/opensea-static/custom-fetcher-images/sandbox/land/sandbox-land.png",
                    "animation_url": null,
                    "animation_original_url": null,
                    "name": "LAND (5, 80)",
                    "description": "A LAND is a digital piece of real estate in The Sandbox metaverse that players can buy to build experiences on top of. Once you own a LAND, you will be able to populate it with Games and Assets. Each LAND is a unique (non-fungible) token lying on the public Ethereum blockchain (ERC-721).",
                    "external_link": "https://www.sandbox.game/en/map/?x=5&y=80",
                    "asset_contract": {
                        "address": "0x50f5474724e0ee42d9a4e711ccfb275809fd6d4a",
                        "asset_contract_type": "non-fungible",
                        "created_date": "2019-12-04T10:58:28.892990",
                        "name": "Sandbox's LANDs",
                        "nft_version": "3.0",
                        "opensea_version": null,
                        "owner": null,
                        "schema_name": "ERC721",
                        "symbol": "",
                        "total_supply": null,
                        "description": "The Sandbox is a community-driven platform where creators can monetize voxel assets and gaming experiences on the blockchain. The Sandbox metaverse comprises a map made up of 166,464 LANDS.  LAND owners can host contests and events, stake SAND to earn and customize assets, monetize assets and experiences, vote in the metaverse governance, play games that you or others create, and more! Trade the collection and keep your eyes peeled for future drops.",
                        "external_link": "https://www.sandbox.game/",
                        "image_url": "https://lh3.googleusercontent.com/SXH8tW1siikB80rwCRnjm1a5xM_MwTg9Xl9Db6mioIk9HIlDM09pVoSR7GKJgS6ulSUpgW9BDtMk_ePX_NKgO9A=s60",
                        "default_to_fiat": false,
                        "dev_buyer_fee_basis_points": 0,
                        "dev_seller_fee_basis_points": 500,
                        "only_proxied_transfers": false,
                        "opensea_buyer_fee_basis_points": 0,
                        "opensea_seller_fee_basis_points": 250,
                        "buyer_fee_basis_points": 0,
                        "seller_fee_basis_points": 750,
                        "payout_address": "0x7a9fe22691c811ea339d9b73150e6911a5343dca"
                    },
                    "owner": {
                        "user": {
                            "username": "REVOLT"
                        },
                        "profile_img_url": "https://storage.googleapis.com/opensea-static/opensea-profile/25.png",
                        "address": "0xb6d820e80a2a7c49f94c9d6c8ea08dccedc9ce4c",
                        "config": "",
                        "discord_id": ""
                    },
                    "permalink": "https://opensea.io/assets/0x50f5474724e0ee42d9a4e711ccfb275809fd6d4a/116081",
                    "collection": {
                        "banner_image_url": "https://lh3.googleusercontent.com/4NQIRoGmzXeXQN4mjuhWuuDZSNW7_BqRXux5upd4Nn_A-bfsGxCnPF8qn98Y6MyHRDPGXIlgfZADcSOe6M2DyrDKXdbdaTgkZN5l=s2500",
                        "chat_url": null,
                        "created_date": "2019-12-04T10:58:29.069907",
                        "default_to_fiat": false,
                        "description": "The Sandbox is a community-driven platform where creators can monetize voxel assets and gaming experiences on the blockchain. The Sandbox metaverse comprises a map made up of 166,464 LANDS.  LAND owners can host contests and events, stake SAND to earn and customize assets, monetize assets and experiences, vote in the metaverse governance, play games that you or others create, and more! Trade the collection and keep your eyes peeled for future drops.",
                        "dev_buyer_fee_basis_points": "0",
                        "dev_seller_fee_basis_points": "500",
                        "discord_url": "https://discord.gg/vAe4zvY",
                        "display_data": {
                            "card_display_style": "contain"
                        },
                        "external_url": "https://www.sandbox.game/",
                        "featured": false,
                        "featured_image_url": "https://storage.googleapis.com/opensea-static/featured-images/sandbox-featured.png",
                        "hidden": false,
                        "safelist_request_status": "verified",
                        "image_url": "https://lh3.googleusercontent.com/SXH8tW1siikB80rwCRnjm1a5xM_MwTg9Xl9Db6mioIk9HIlDM09pVoSR7GKJgS6ulSUpgW9BDtMk_ePX_NKgO9A=s60",
                        "is_subject_to_whitelist": false,
                        "large_image_url": "https://lh3.googleusercontent.com/SXH8tW1siikB80rwCRnjm1a5xM_MwTg9Xl9Db6mioIk9HIlDM09pVoSR7GKJgS6ulSUpgW9BDtMk_ePX_NKgO9A",
                        "medium_username": "sandbox-game",
                        "name": "The Sandbox",
                        "only_proxied_transfers": false,
                        "opensea_buyer_fee_basis_points": "0",
                        "opensea_seller_fee_basis_points": "250",
                        "payout_address": "0x7a9fe22691c811ea339d9b73150e6911a5343dca",
                        "require_email": false,
                        "short_description": null,
                        "slug": "sandbox",
                        "telegram_url": "https://t.me/sandboxgame",
                        "twitter_username": "thesandboxgame",
                        "instagram_username": null,
                        "wiki_url": null
                    },
                    "decimals": null,
                    "token_metadata": null
                }
            ],
            "name": "Small estate (9 lands)",
            "description": "Yes, you can afford it :o))",
            "external_link": "",
            "asset_contract": {
                "collection": {
                    "banner_image_url": "https://lh3.googleusercontent.com/4NQIRoGmzXeXQN4mjuhWuuDZSNW7_BqRXux5upd4Nn_A-bfsGxCnPF8qn98Y6MyHRDPGXIlgfZADcSOe6M2DyrDKXdbdaTgkZN5l=s2500",
                    "chat_url": null,
                    "created_date": "2019-12-04T10:58:29.069907",
                    "default_to_fiat": false,
                    "description": "The Sandbox is a community-driven platform where creators can monetize voxel assets and gaming experiences on the blockchain. The Sandbox metaverse comprises a map made up of 166,464 LANDS.  LAND owners can host contests and events, stake SAND to earn and customize assets, monetize assets and experiences, vote in the metaverse governance, play games that you or others create, and more! Trade the collection and keep your eyes peeled for future drops.",
                    "dev_buyer_fee_basis_points": "0",
                    "dev_seller_fee_basis_points": "500",
                    "discord_url": "https://discord.gg/vAe4zvY",
                    "display_data": {
                        "card_display_style": "contain"
                    },
                    "external_url": "https://www.sandbox.game/",
                    "featured": false,
                    "featured_image_url": "https://storage.googleapis.com/opensea-static/featured-images/sandbox-featured.png",
                    "hidden": false,
                    "safelist_request_status": "verified",
                    "image_url": "https://lh3.googleusercontent.com/SXH8tW1siikB80rwCRnjm1a5xM_MwTg9Xl9Db6mioIk9HIlDM09pVoSR7GKJgS6ulSUpgW9BDtMk_ePX_NKgO9A=s60",
                    "is_subject_to_whitelist": false,
                    "large_image_url": "https://lh3.googleusercontent.com/SXH8tW1siikB80rwCRnjm1a5xM_MwTg9Xl9Db6mioIk9HIlDM09pVoSR7GKJgS6ulSUpgW9BDtMk_ePX_NKgO9A",
                    "medium_username": "sandbox-game",
                    "name": "The Sandbox",
                    "only_proxied_transfers": false,
                    "opensea_buyer_fee_basis_points": "0",
                    "opensea_seller_fee_basis_points": "250",
                    "payout_address": "0x7a9fe22691c811ea339d9b73150e6911a5343dca",
                    "require_email": false,
                    "short_description": null,
                    "slug": "sandbox",
                    "telegram_url": "https://t.me/sandboxgame",
                    "twitter_username": "thesandboxgame",
                    "instagram_username": null,
                    "wiki_url": null
                },
                "address": "0x50f5474724e0ee42d9a4e711ccfb275809fd6d4a",
                "asset_contract_type": "non-fungible",
                "created_date": "2019-12-04T10:58:28.892990",
                "name": "Sandbox's LANDs",
                "nft_version": "3.0",
                "opensea_version": null,
                "owner": null,
                "schema_name": "ERC721",
                "symbol": "",
                "total_supply": null,
                "description": "The Sandbox is a community-driven platform where creators can monetize voxel assets and gaming experiences on the blockchain. The Sandbox metaverse comprises a map made up of 166,464 LANDS.  LAND owners can host contests and events, stake SAND to earn and customize assets, monetize assets and experiences, vote in the metaverse governance, play games that you or others create, and more! Trade the collection and keep your eyes peeled for future drops.",
                "external_link": "https://www.sandbox.game/",
                "image_url": "https://lh3.googleusercontent.com/SXH8tW1siikB80rwCRnjm1a5xM_MwTg9Xl9Db6mioIk9HIlDM09pVoSR7GKJgS6ulSUpgW9BDtMk_ePX_NKgO9A=s60",
                "default_to_fiat": false,
                "dev_buyer_fee_basis_points": 0,
                "dev_seller_fee_basis_points": 500,
                "only_proxied_transfers": false,
                "opensea_buyer_fee_basis_points": 0,
                "opensea_seller_fee_basis_points": 250,
                "buyer_fee_basis_points": 0,
                "seller_fee_basis_points": 750,
                "payout_address": "0x7a9fe22691c811ea339d9b73150e6911a5343dca"
            },
            "permalink": "https://opensea.io/bundles/small-estate-9-lands-EU4",
            "sell_orders": [
                {
                    "created_date": "2021-05-25T22:07:59.674464",
                    "closing_date": null,
                    "closing_extendable": false,
                    "expiration_time": 0,
                    "listing_time": 1621980372,
                    "order_hash": "0x99288cca5297a5532f2bb150609911da6a444fa0251deef585e0391a9dc12e37",
                    "metadata": {
                        "bundle": {
                            "assets": [
                                {
                                    "id": "115263",
                                    "address": "0x50f5474724e0ee42d9a4e711ccfb275809fd6d4a"
                                },
                                {
                                    "id": "115264",
                                    "address": "0x50f5474724e0ee42d9a4e711ccfb275809fd6d4a"
                                },
                                {
                                    "id": "115265",
                                    "address": "0x50f5474724e0ee42d9a4e711ccfb275809fd6d4a"
                                },
                                {
                                    "id": "115671",
                                    "address": "0x50f5474724e0ee42d9a4e711ccfb275809fd6d4a"
                                },
                                {
                                    "id": "115672",
                                    "address": "0x50f5474724e0ee42d9a4e711ccfb275809fd6d4a"
                                },
                                {
                                    "id": "115673",
                                    "address": "0x50f5474724e0ee42d9a4e711ccfb275809fd6d4a"
                                },
                                {
                                    "id": "116079",
                                    "address": "0x50f5474724e0ee42d9a4e711ccfb275809fd6d4a"
                                },
                                {
                                    "id": "116080",
                                    "address": "0x50f5474724e0ee42d9a4e711ccfb275809fd6d4a"
                                },
                                {
                                    "id": "116081",
                                    "address": "0x50f5474724e0ee42d9a4e711ccfb275809fd6d4a"
                                }
                            ],
                            "schemas": [
                                "ERC721",
                                "ERC721",
                                "ERC721",
                                "ERC721",
                                "ERC721",
                                "ERC721",
                                "ERC721",
                                "ERC721",
                                "ERC721"
                            ],
                            "name": "Small estate (9 lands)",
                            "description": "Yes, you can afford it :o))",
                            "external_link": ""
                        }
                    },
                    "exchange": "0x7be8076f4ea4a4ad08075c2508e481d6c946d12b",
                    "maker": {
                        "user": 3797,
                        "profile_img_url": "https://storage.googleapis.com/opensea-static/opensea-profile/25.png",
                        "address": "0xb6d820e80a2a7c49f94c9d6c8ea08dccedc9ce4c",
                        "config": "",
                        "discord_id": ""
                    },
                    "taker": {
                        "user": 1766,
                        "profile_img_url": "https://storage.googleapis.com/opensea-static/opensea-profile/1.png",
                        "address": "0x0000000000000000000000000000000000000000",
                        "config": "",
                        "discord_id": ""
                    },
                    "current_price": "135000000000000000000",
                    "current_bounty": "1350000000000000000",
                    "bounty_multiple": "0.01",
                    "maker_relayer_fee": "750",
                    "taker_relayer_fee": "0",
                    "maker_protocol_fee": "0",
                    "taker_protocol_fee": "0",
                    "maker_referrer_fee": "0",
                    "fee_recipient": {
                        "user": 3585,
                        "profile_img_url": "https://storage.googleapis.com/opensea-static/opensea-profile/28.png",
                        "address": "0x5b3256965e7c3cf26e11fcaf296dfc8807c01073",
                        "config": "verified",
                        "discord_id": ""
                    },
                    "fee_method": 1,
                    "side": 1,
                    "sale_kind": 0,
                    "target": "0xc99f70bfd82fb7c8f8191fdfbfb735606b15e5c5",
                    "how_to_call": 1,
                    "calldata": "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",
                    "replacement_pattern": "0x0000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000ffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffff0000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000ffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffff0000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000ffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffff0000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000ffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffff0000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000ffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffff0000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000ffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffff0000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000ffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffff0000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000ffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffff0000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000ffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffff000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000",
                    "static_target": "0x0000000000000000000000000000000000000000",
                    "static_extradata": "0x",
                    "payment_token": "0x0000000000000000000000000000000000000000",
                    "payment_token_contract": {
                        "id": 1,
                        "symbol": "ETH",
                        "address": "0x0000000000000000000000000000000000000000",
                        "image_url": "https://storage.opensea.io/files/6f8e2979d428180222796ff4a33ab929.svg",
                        "name": "Ether",
                        "decimals": 18,
                        "eth_price": "1.000000000000000",
                        "usd_price": "2625.730000000000018000"
                    },
                    "base_price": "135000000000000000000",
                    "extra": "0",
                    "quantity": "1",
                    "salt": "4255315184918880698833742807849502286321864648645238542528813835344567915800",
                    "v": 27,
                    "r": "0x9d748632d51bbd38bd5909b713d018a85c8da891a7dc63e5938c7175ab933117",
                    "s": "0x26f009e6a6ca0c34ceca06910a86a6a7c7e29375c12e03d9c77095cf0d84392d",
                    "approved_on_chain": false,
                    "cancelled": false,
                    "finalized": false,
                    "marked_invalid": false,
                    "prefixed_hash": "0xb770a7d8ae4da87af25b1391ab57bacf2dd25fc47c5a84128cc60af6282b01b4"
                }
            ]
        },
        {
            "maker": {
                "user": {
                    "username": "REVOLT"
                },
                "profile_img_url": "https://storage.googleapis.com/opensea-static/opensea-profile/25.png",
                "address": "0xb6d820e80a2a7c49f94c9d6c8ea08dccedc9ce4c",
                "config": "",
                "discord_id": ""
            },
            "slug": "small-estate-9-lands-LQN",
            "assets": [
                {
                    "id": 14407371,
                    "token_id": "115260",
                    "num_sales": 0,
                    "background_color": null,
                    "image_url": "https://lh3.googleusercontent.com/17vU_UNWeMOVi4XOAwo4nvAXpeg1dnKPBk8VnAhJcFHOFZ9UBBvSL5Spj0ytvyfII3rdp4gHMY0mMvbnSzjdOZ0",
                    "image_preview_url": "https://lh3.googleusercontent.com/17vU_UNWeMOVi4XOAwo4nvAXpeg1dnKPBk8VnAhJcFHOFZ9UBBvSL5Spj0ytvyfII3rdp4gHMY0mMvbnSzjdOZ0=s250",
                    "image_thumbnail_url": "https://lh3.googleusercontent.com/17vU_UNWeMOVi4XOAwo4nvAXpeg1dnKPBk8VnAhJcFHOFZ9UBBvSL5Spj0ytvyfII3rdp4gHMY0mMvbnSzjdOZ0=s128",
                    "image_original_url": "https://storage.googleapis.com/opensea-static/custom-fetcher-images/sandbox/land/sandbox-land.png",
                    "animation_url": null,
                    "animation_original_url": null,
                    "name": "LAND (0, 78)",
                    "description": "A LAND is a digital piece of real estate in The Sandbox metaverse that players can buy to build experiences on top of. Once you own a LAND, you will be able to populate it with Games and Assets. Each LAND is a unique (non-fungible) token lying on the public Ethereum blockchain (ERC-721).",
                    "external_link": "https://www.sandbox.game/en/map/?x=0&y=78",
                    "asset_contract": {
                        "address": "0x50f5474724e0ee42d9a4e711ccfb275809fd6d4a",
                        "asset_contract_type": "non-fungible",
                        "created_date": "2019-12-04T10:58:28.892990",
                        "name": "Sandbox's LANDs",
                        "nft_version": "3.0",
                        "opensea_version": null,
                        "owner": null,
                        "schema_name": "ERC721",
                        "symbol": "",
                        "total_supply": null,
                        "description": "The Sandbox is a community-driven platform where creators can monetize voxel assets and gaming experiences on the blockchain. The Sandbox metaverse comprises a map made up of 166,464 LANDS.  LAND owners can host contests and events, stake SAND to earn and customize assets, monetize assets and experiences, vote in the metaverse governance, play games that you or others create, and more! Trade the collection and keep your eyes peeled for future drops.",
                        "external_link": "https://www.sandbox.game/",
                        "image_url": "https://lh3.googleusercontent.com/SXH8tW1siikB80rwCRnjm1a5xM_MwTg9Xl9Db6mioIk9HIlDM09pVoSR7GKJgS6ulSUpgW9BDtMk_ePX_NKgO9A=s60",
                        "default_to_fiat": false,
                        "dev_buyer_fee_basis_points": 0,
                        "dev_seller_fee_basis_points": 500,
                        "only_proxied_transfers": false,
                        "opensea_buyer_fee_basis_points": 0,
                        "opensea_seller_fee_basis_points": 250,
                        "buyer_fee_basis_points": 0,
                        "seller_fee_basis_points": 750,
                        "payout_address": "0x7a9fe22691c811ea339d9b73150e6911a5343dca"
                    },
                    "owner": {
                        "user": {
                            "username": "REVOLT"
                        },
                        "profile_img_url": "https://storage.googleapis.com/opensea-static/opensea-profile/25.png",
                        "address": "0xb6d820e80a2a7c49f94c9d6c8ea08dccedc9ce4c",
                        "config": "",
                        "discord_id": ""
                    },
                    "permalink": "https://opensea.io/assets/0x50f5474724e0ee42d9a4e711ccfb275809fd6d4a/115260",
                    "collection": {
                        "banner_image_url": "https://lh3.googleusercontent.com/4NQIRoGmzXeXQN4mjuhWuuDZSNW7_BqRXux5upd4Nn_A-bfsGxCnPF8qn98Y6MyHRDPGXIlgfZADcSOe6M2DyrDKXdbdaTgkZN5l=s2500",
                        "chat_url": null,
                        "created_date": "2019-12-04T10:58:29.069907",
                        "default_to_fiat": false,
                        "description": "The Sandbox is a community-driven platform where creators can monetize voxel assets and gaming experiences on the blockchain. The Sandbox metaverse comprises a map made up of 166,464 LANDS.  LAND owners can host contests and events, stake SAND to earn and customize assets, monetize assets and experiences, vote in the metaverse governance, play games that you or others create, and more! Trade the collection and keep your eyes peeled for future drops.",
                        "dev_buyer_fee_basis_points": "0",
                        "dev_seller_fee_basis_points": "500",
                        "discord_url": "https://discord.gg/vAe4zvY",
                        "display_data": {
                            "card_display_style": "contain"
                        },
                        "external_url": "https://www.sandbox.game/",
                        "featured": false,
                        "featured_image_url": "https://storage.googleapis.com/opensea-static/featured-images/sandbox-featured.png",
                        "hidden": false,
                        "safelist_request_status": "verified",
                        "image_url": "https://lh3.googleusercontent.com/SXH8tW1siikB80rwCRnjm1a5xM_MwTg9Xl9Db6mioIk9HIlDM09pVoSR7GKJgS6ulSUpgW9BDtMk_ePX_NKgO9A=s60",
                        "is_subject_to_whitelist": false,
                        "large_image_url": "https://lh3.googleusercontent.com/SXH8tW1siikB80rwCRnjm1a5xM_MwTg9Xl9Db6mioIk9HIlDM09pVoSR7GKJgS6ulSUpgW9BDtMk_ePX_NKgO9A",
                        "medium_username": "sandbox-game",
                        "name": "The Sandbox",
                        "only_proxied_transfers": false,
                        "opensea_buyer_fee_basis_points": "0",
                        "opensea_seller_fee_basis_points": "250",
                        "payout_address": "0x7a9fe22691c811ea339d9b73150e6911a5343dca",
                        "require_email": false,
                        "short_description": null,
                        "slug": "sandbox",
                        "telegram_url": "https://t.me/sandboxgame",
                        "twitter_username": "thesandboxgame",
                        "instagram_username": null,
                        "wiki_url": null
                    },
                    "decimals": null,
                    "token_metadata": null
                },
                {
                    "id": 14407387,
                    "token_id": "115261",
                    "num_sales": 0,
                    "background_color": null,
                    "image_url": "https://lh3.googleusercontent.com/17vU_UNWeMOVi4XOAwo4nvAXpeg1dnKPBk8VnAhJcFHOFZ9UBBvSL5Spj0ytvyfII3rdp4gHMY0mMvbnSzjdOZ0",
                    "image_preview_url": "https://lh3.googleusercontent.com/17vU_UNWeMOVi4XOAwo4nvAXpeg1dnKPBk8VnAhJcFHOFZ9UBBvSL5Spj0ytvyfII3rdp4gHMY0mMvbnSzjdOZ0=s250",
                    "image_thumbnail_url": "https://lh3.googleusercontent.com/17vU_UNWeMOVi4XOAwo4nvAXpeg1dnKPBk8VnAhJcFHOFZ9UBBvSL5Spj0ytvyfII3rdp4gHMY0mMvbnSzjdOZ0=s128",
                    "image_original_url": "https://storage.googleapis.com/opensea-static/custom-fetcher-images/sandbox/land/sandbox-land.png",
                    "animation_url": null,
                    "animation_original_url": null,
                    "name": "LAND (1, 78)",
                    "description": "A LAND is a digital piece of real estate in The Sandbox metaverse that players can buy to build experiences on top of. Once you own a LAND, you will be able to populate it with Games and Assets. Each LAND is a unique (non-fungible) token lying on the public Ethereum blockchain (ERC-721).",
                    "external_link": "https://www.sandbox.game/en/map/?x=1&y=78",
                    "asset_contract": {
                        "address": "0x50f5474724e0ee42d9a4e711ccfb275809fd6d4a",
                        "asset_contract_type": "non-fungible",
                        "created_date": "2019-12-04T10:58:28.892990",
                        "name": "Sandbox's LANDs",
                        "nft_version": "3.0",
                        "opensea_version": null,
                        "owner": null,
                        "schema_name": "ERC721",
                        "symbol": "",
                        "total_supply": null,
                        "description": "The Sandbox is a community-driven platform where creators can monetize voxel assets and gaming experiences on the blockchain. The Sandbox metaverse comprises a map made up of 166,464 LANDS.  LAND owners can host contests and events, stake SAND to earn and customize assets, monetize assets and experiences, vote in the metaverse governance, play games that you or others create, and more! Trade the collection and keep your eyes peeled for future drops.",
                        "external_link": "https://www.sandbox.game/",
                        "image_url": "https://lh3.googleusercontent.com/SXH8tW1siikB80rwCRnjm1a5xM_MwTg9Xl9Db6mioIk9HIlDM09pVoSR7GKJgS6ulSUpgW9BDtMk_ePX_NKgO9A=s60",
                        "default_to_fiat": false,
                        "dev_buyer_fee_basis_points": 0,
                        "dev_seller_fee_basis_points": 500,
                        "only_proxied_transfers": false,
                        "opensea_buyer_fee_basis_points": 0,
                        "opensea_seller_fee_basis_points": 250,
                        "buyer_fee_basis_points": 0,
                        "seller_fee_basis_points": 750,
                        "payout_address": "0x7a9fe22691c811ea339d9b73150e6911a5343dca"
                    },
                    "owner": {
                        "user": {
                            "username": "REVOLT"
                        },
                        "profile_img_url": "https://storage.googleapis.com/opensea-static/opensea-profile/25.png",
                        "address": "0xb6d820e80a2a7c49f94c9d6c8ea08dccedc9ce4c",
                        "config": "",
                        "discord_id": ""
                    },
                    "permalink": "https://opensea.io/assets/0x50f5474724e0ee42d9a4e711ccfb275809fd6d4a/115261",
                    "collection": {
                        "banner_image_url": "https://lh3.googleusercontent.com/4NQIRoGmzXeXQN4mjuhWuuDZSNW7_BqRXux5upd4Nn_A-bfsGxCnPF8qn98Y6MyHRDPGXIlgfZADcSOe6M2DyrDKXdbdaTgkZN5l=s2500",
                        "chat_url": null,
                        "created_date": "2019-12-04T10:58:29.069907",
                        "default_to_fiat": false,
                        "description": "The Sandbox is a community-driven platform where creators can monetize voxel assets and gaming experiences on the blockchain. The Sandbox metaverse comprises a map made up of 166,464 LANDS.  LAND owners can host contests and events, stake SAND to earn and customize assets, monetize assets and experiences, vote in the metaverse governance, play games that you or others create, and more! Trade the collection and keep your eyes peeled for future drops.",
                        "dev_buyer_fee_basis_points": "0",
                        "dev_seller_fee_basis_points": "500",
                        "discord_url": "https://discord.gg/vAe4zvY",
                        "display_data": {
                            "card_display_style": "contain"
                        },
                        "external_url": "https://www.sandbox.game/",
                        "featured": false,
                        "featured_image_url": "https://storage.googleapis.com/opensea-static/featured-images/sandbox-featured.png",
                        "hidden": false,
                        "safelist_request_status": "verified",
                        "image_url": "https://lh3.googleusercontent.com/SXH8tW1siikB80rwCRnjm1a5xM_MwTg9Xl9Db6mioIk9HIlDM09pVoSR7GKJgS6ulSUpgW9BDtMk_ePX_NKgO9A=s60",
                        "is_subject_to_whitelist": false,
                        "large_image_url": "https://lh3.googleusercontent.com/SXH8tW1siikB80rwCRnjm1a5xM_MwTg9Xl9Db6mioIk9HIlDM09pVoSR7GKJgS6ulSUpgW9BDtMk_ePX_NKgO9A",
                        "medium_username": "sandbox-game",
                        "name": "The Sandbox",
                        "only_proxied_transfers": false,
                        "opensea_buyer_fee_basis_points": "0",
                        "opensea_seller_fee_basis_points": "250",
                        "payout_address": "0x7a9fe22691c811ea339d9b73150e6911a5343dca",
                        "require_email": false,
                        "short_description": null,
                        "slug": "sandbox",
                        "telegram_url": "https://t.me/sandboxgame",
                        "twitter_username": "thesandboxgame",
                        "instagram_username": null,
                        "wiki_url": null
                    },
                    "decimals": null,
                    "token_metadata": null
                },
                {
                    "id": 14407396,
                    "token_id": "115262",
                    "num_sales": 0,
                    "background_color": null,
                    "image_url": "https://lh3.googleusercontent.com/17vU_UNWeMOVi4XOAwo4nvAXpeg1dnKPBk8VnAhJcFHOFZ9UBBvSL5Spj0ytvyfII3rdp4gHMY0mMvbnSzjdOZ0",
                    "image_preview_url": "https://lh3.googleusercontent.com/17vU_UNWeMOVi4XOAwo4nvAXpeg1dnKPBk8VnAhJcFHOFZ9UBBvSL5Spj0ytvyfII3rdp4gHMY0mMvbnSzjdOZ0=s250",
                    "image_thumbnail_url": "https://lh3.googleusercontent.com/17vU_UNWeMOVi4XOAwo4nvAXpeg1dnKPBk8VnAhJcFHOFZ9UBBvSL5Spj0ytvyfII3rdp4gHMY0mMvbnSzjdOZ0=s128",
                    "image_original_url": "https://storage.googleapis.com/opensea-static/custom-fetcher-images/sandbox/land/sandbox-land.png",
                    "animation_url": null,
                    "animation_original_url": null,
                    "name": "LAND (2, 78)",
                    "description": "A LAND is a digital piece of real estate in The Sandbox metaverse that players can buy to build experiences on top of. Once you own a LAND, you will be able to populate it with Games and Assets. Each LAND is a unique (non-fungible) token lying on the public Ethereum blockchain (ERC-721).",
                    "external_link": "https://www.sandbox.game/en/map/?x=2&y=78",
                    "asset_contract": {
                        "address": "0x50f5474724e0ee42d9a4e711ccfb275809fd6d4a",
                        "asset_contract_type": "non-fungible",
                        "created_date": "2019-12-04T10:58:28.892990",
                        "name": "Sandbox's LANDs",
                        "nft_version": "3.0",
                        "opensea_version": null,
                        "owner": null,
                        "schema_name": "ERC721",
                        "symbol": "",
                        "total_supply": null,
                        "description": "The Sandbox is a community-driven platform where creators can monetize voxel assets and gaming experiences on the blockchain. The Sandbox metaverse comprises a map made up of 166,464 LANDS.  LAND owners can host contests and events, stake SAND to earn and customize assets, monetize assets and experiences, vote in the metaverse governance, play games that you or others create, and more! Trade the collection and keep your eyes peeled for future drops.",
                        "external_link": "https://www.sandbox.game/",
                        "image_url": "https://lh3.googleusercontent.com/SXH8tW1siikB80rwCRnjm1a5xM_MwTg9Xl9Db6mioIk9HIlDM09pVoSR7GKJgS6ulSUpgW9BDtMk_ePX_NKgO9A=s60",
                        "default_to_fiat": false,
                        "dev_buyer_fee_basis_points": 0,
                        "dev_seller_fee_basis_points": 500,
                        "only_proxied_transfers": false,
                        "opensea_buyer_fee_basis_points": 0,
                        "opensea_seller_fee_basis_points": 250,
                        "buyer_fee_basis_points": 0,
                        "seller_fee_basis_points": 750,
                        "payout_address": "0x7a9fe22691c811ea339d9b73150e6911a5343dca"
                    },
                    "owner": {
                        "user": {
                            "username": "REVOLT"
                        },
                        "profile_img_url": "https://storage.googleapis.com/opensea-static/opensea-profile/25.png",
                        "address": "0xb6d820e80a2a7c49f94c9d6c8ea08dccedc9ce4c",
                        "config": "",
                        "discord_id": ""
                    },
                    "permalink": "https://opensea.io/assets/0x50f5474724e0ee42d9a4e711ccfb275809fd6d4a/115262",
                    "collection": {
                        "banner_image_url": "https://lh3.googleusercontent.com/4NQIRoGmzXeXQN4mjuhWuuDZSNW7_BqRXux5upd4Nn_A-bfsGxCnPF8qn98Y6MyHRDPGXIlgfZADcSOe6M2DyrDKXdbdaTgkZN5l=s2500",
                        "chat_url": null,
                        "created_date": "2019-12-04T10:58:29.069907",
                        "default_to_fiat": false,
                        "description": "The Sandbox is a community-driven platform where creators can monetize voxel assets and gaming experiences on the blockchain. The Sandbox metaverse comprises a map made up of 166,464 LANDS.  LAND owners can host contests and events, stake SAND to earn and customize assets, monetize assets and experiences, vote in the metaverse governance, play games that you or others create, and more! Trade the collection and keep your eyes peeled for future drops.",
                        "dev_buyer_fee_basis_points": "0",
                        "dev_seller_fee_basis_points": "500",
                        "discord_url": "https://discord.gg/vAe4zvY",
                        "display_data": {
                            "card_display_style": "contain"
                        },
                        "external_url": "https://www.sandbox.game/",
                        "featured": false,
                        "featured_image_url": "https://storage.googleapis.com/opensea-static/featured-images/sandbox-featured.png",
                        "hidden": false,
                        "safelist_request_status": "verified",
                        "image_url": "https://lh3.googleusercontent.com/SXH8tW1siikB80rwCRnjm1a5xM_MwTg9Xl9Db6mioIk9HIlDM09pVoSR7GKJgS6ulSUpgW9BDtMk_ePX_NKgO9A=s60",
                        "is_subject_to_whitelist": false,
                        "large_image_url": "https://lh3.googleusercontent.com/SXH8tW1siikB80rwCRnjm1a5xM_MwTg9Xl9Db6mioIk9HIlDM09pVoSR7GKJgS6ulSUpgW9BDtMk_ePX_NKgO9A",
                        "medium_username": "sandbox-game",
                        "name": "The Sandbox",
                        "only_proxied_transfers": false,
                        "opensea_buyer_fee_basis_points": "0",
                        "opensea_seller_fee_basis_points": "250",
                        "payout_address": "0x7a9fe22691c811ea339d9b73150e6911a5343dca",
                        "require_email": false,
                        "short_description": null,
                        "slug": "sandbox",
                        "telegram_url": "https://t.me/sandboxgame",
                        "twitter_username": "thesandboxgame",
                        "instagram_username": null,
                        "wiki_url": null
                    },
                    "decimals": null,
                    "token_metadata": null
                },
                {
                    "id": 14407405,
                    "token_id": "115670",
                    "num_sales": 0,
                    "background_color": null,
                    "image_url": "https://lh3.googleusercontent.com/17vU_UNWeMOVi4XOAwo4nvAXpeg1dnKPBk8VnAhJcFHOFZ9UBBvSL5Spj0ytvyfII3rdp4gHMY0mMvbnSzjdOZ0",
                    "image_preview_url": "https://lh3.googleusercontent.com/17vU_UNWeMOVi4XOAwo4nvAXpeg1dnKPBk8VnAhJcFHOFZ9UBBvSL5Spj0ytvyfII3rdp4gHMY0mMvbnSzjdOZ0=s250",
                    "image_thumbnail_url": "https://lh3.googleusercontent.com/17vU_UNWeMOVi4XOAwo4nvAXpeg1dnKPBk8VnAhJcFHOFZ9UBBvSL5Spj0ytvyfII3rdp4gHMY0mMvbnSzjdOZ0=s128",
                    "image_original_url": "https://storage.googleapis.com/opensea-static/custom-fetcher-images/sandbox/land/sandbox-land.png",
                    "animation_url": null,
                    "animation_original_url": null,
                    "name": "LAND (2, 79)",
                    "description": "A LAND is a digital piece of real estate in The Sandbox metaverse that players can buy to build experiences on top of. Once you own a LAND, you will be able to populate it with Games and Assets. Each LAND is a unique (non-fungible) token lying on the public Ethereum blockchain (ERC-721).",
                    "external_link": "https://www.sandbox.game/en/map/?x=2&y=79",
                    "asset_contract": {
                        "address": "0x50f5474724e0ee42d9a4e711ccfb275809fd6d4a",
                        "asset_contract_type": "non-fungible",
                        "created_date": "2019-12-04T10:58:28.892990",
                        "name": "Sandbox's LANDs",
                        "nft_version": "3.0",
                        "opensea_version": null,
                        "owner": null,
                        "schema_name": "ERC721",
                        "symbol": "",
                        "total_supply": null,
                        "description": "The Sandbox is a community-driven platform where creators can monetize voxel assets and gaming experiences on the blockchain. The Sandbox metaverse comprises a map made up of 166,464 LANDS.  LAND owners can host contests and events, stake SAND to earn and customize assets, monetize assets and experiences, vote in the metaverse governance, play games that you or others create, and more! Trade the collection and keep your eyes peeled for future drops.",
                        "external_link": "https://www.sandbox.game/",
                        "image_url": "https://lh3.googleusercontent.com/SXH8tW1siikB80rwCRnjm1a5xM_MwTg9Xl9Db6mioIk9HIlDM09pVoSR7GKJgS6ulSUpgW9BDtMk_ePX_NKgO9A=s60",
                        "default_to_fiat": false,
                        "dev_buyer_fee_basis_points": 0,
                        "dev_seller_fee_basis_points": 500,
                        "only_proxied_transfers": false,
                        "opensea_buyer_fee_basis_points": 0,
                        "opensea_seller_fee_basis_points": 250,
                        "buyer_fee_basis_points": 0,
                        "seller_fee_basis_points": 750,
                        "payout_address": "0x7a9fe22691c811ea339d9b73150e6911a5343dca"
                    },
                    "owner": {
                        "user": {
                            "username": "REVOLT"
                        },
                        "profile_img_url": "https://storage.googleapis.com/opensea-static/opensea-profile/25.png",
                        "address": "0xb6d820e80a2a7c49f94c9d6c8ea08dccedc9ce4c",
                        "config": "",
                        "discord_id": ""
                    },
                    "permalink": "https://opensea.io/assets/0x50f5474724e0ee42d9a4e711ccfb275809fd6d4a/115670",
                    "collection": {
                        "banner_image_url": "https://lh3.googleusercontent.com/4NQIRoGmzXeXQN4mjuhWuuDZSNW7_BqRXux5upd4Nn_A-bfsGxCnPF8qn98Y6MyHRDPGXIlgfZADcSOe6M2DyrDKXdbdaTgkZN5l=s2500",
                        "chat_url": null,
                        "created_date": "2019-12-04T10:58:29.069907",
                        "default_to_fiat": false,
                        "description": "The Sandbox is a community-driven platform where creators can monetize voxel assets and gaming experiences on the blockchain. The Sandbox metaverse comprises a map made up of 166,464 LANDS.  LAND owners can host contests and events, stake SAND to earn and customize assets, monetize assets and experiences, vote in the metaverse governance, play games that you or others create, and more! Trade the collection and keep your eyes peeled for future drops.",
                        "dev_buyer_fee_basis_points": "0",
                        "dev_seller_fee_basis_points": "500",
                        "discord_url": "https://discord.gg/vAe4zvY",
                        "display_data": {
                            "card_display_style": "contain"
                        },
                        "external_url": "https://www.sandbox.game/",
                        "featured": false,
                        "featured_image_url": "https://storage.googleapis.com/opensea-static/featured-images/sandbox-featured.png",
                        "hidden": false,
                        "safelist_request_status": "verified",
                        "image_url": "https://lh3.googleusercontent.com/SXH8tW1siikB80rwCRnjm1a5xM_MwTg9Xl9Db6mioIk9HIlDM09pVoSR7GKJgS6ulSUpgW9BDtMk_ePX_NKgO9A=s60",
                        "is_subject_to_whitelist": false,
                        "large_image_url": "https://lh3.googleusercontent.com/SXH8tW1siikB80rwCRnjm1a5xM_MwTg9Xl9Db6mioIk9HIlDM09pVoSR7GKJgS6ulSUpgW9BDtMk_ePX_NKgO9A",
                        "medium_username": "sandbox-game",
                        "name": "The Sandbox",
                        "only_proxied_transfers": false,
                        "opensea_buyer_fee_basis_points": "0",
                        "opensea_seller_fee_basis_points": "250",
                        "payout_address": "0x7a9fe22691c811ea339d9b73150e6911a5343dca",
                        "require_email": false,
                        "short_description": null,
                        "slug": "sandbox",
                        "telegram_url": "https://t.me/sandboxgame",
                        "twitter_username": "thesandboxgame",
                        "instagram_username": null,
                        "wiki_url": null
                    },
                    "decimals": null,
                    "token_metadata": null
                },
                {
                    "id": 14407414,
                    "token_id": "115669",
                    "num_sales": 0,
                    "background_color": null,
                    "image_url": "https://storage.opensea.io/files/3faa959fa75531ac7913a9c9f8361b58.png",
                    "image_preview_url": "https://lh3.googleusercontent.com/17vU_UNWeMOVi4XOAwo4nvAXpeg1dnKPBk8VnAhJcFHOFZ9UBBvSL5Spj0ytvyfII3rdp4gHMY0mMvbnSzjdOZ0=s250",
                    "image_thumbnail_url": "https://lh3.googleusercontent.com/17vU_UNWeMOVi4XOAwo4nvAXpeg1dnKPBk8VnAhJcFHOFZ9UBBvSL5Spj0ytvyfII3rdp4gHMY0mMvbnSzjdOZ0=s128",
                    "image_original_url": "https://storage.googleapis.com/opensea-static/custom-fetcher-images/sandbox/land/sandbox-land.png",
                    "animation_url": null,
                    "animation_original_url": null,
                    "name": "LAND (1, 79)",
                    "description": "A LAND is a digital piece of real estate in The Sandbox metaverse that players can buy to build experiences on top of. Once you own a LAND, you will be able to populate it with Games and Assets. Each LAND is a unique (non-fungible) token lying on the public Ethereum blockchain (ERC-721).",
                    "external_link": "https://www.sandbox.game/en/map/?x=1&y=79",
                    "asset_contract": {
                        "address": "0x50f5474724e0ee42d9a4e711ccfb275809fd6d4a",
                        "asset_contract_type": "non-fungible",
                        "created_date": "2019-12-04T10:58:28.892990",
                        "name": "Sandbox's LANDs",
                        "nft_version": "3.0",
                        "opensea_version": null,
                        "owner": null,
                        "schema_name": "ERC721",
                        "symbol": "",
                        "total_supply": null,
                        "description": "The Sandbox is a community-driven platform where creators can monetize voxel assets and gaming experiences on the blockchain. The Sandbox metaverse comprises a map made up of 166,464 LANDS.  LAND owners can host contests and events, stake SAND to earn and customize assets, monetize assets and experiences, vote in the metaverse governance, play games that you or others create, and more! Trade the collection and keep your eyes peeled for future drops.",
                        "external_link": "https://www.sandbox.game/",
                        "image_url": "https://lh3.googleusercontent.com/SXH8tW1siikB80rwCRnjm1a5xM_MwTg9Xl9Db6mioIk9HIlDM09pVoSR7GKJgS6ulSUpgW9BDtMk_ePX_NKgO9A=s60",
                        "default_to_fiat": false,
                        "dev_buyer_fee_basis_points": 0,
                        "dev_seller_fee_basis_points": 500,
                        "only_proxied_transfers": false,
                        "opensea_buyer_fee_basis_points": 0,
                        "opensea_seller_fee_basis_points": 250,
                        "buyer_fee_basis_points": 0,
                        "seller_fee_basis_points": 750,
                        "payout_address": "0x7a9fe22691c811ea339d9b73150e6911a5343dca"
                    },
                    "owner": {
                        "user": {
                            "username": "REVOLT"
                        },
                        "profile_img_url": "https://storage.googleapis.com/opensea-static/opensea-profile/25.png",
                        "address": "0xb6d820e80a2a7c49f94c9d6c8ea08dccedc9ce4c",
                        "config": "",
                        "discord_id": ""
                    },
                    "permalink": "https://opensea.io/assets/0x50f5474724e0ee42d9a4e711ccfb275809fd6d4a/115669",
                    "collection": {
                        "banner_image_url": "https://lh3.googleusercontent.com/4NQIRoGmzXeXQN4mjuhWuuDZSNW7_BqRXux5upd4Nn_A-bfsGxCnPF8qn98Y6MyHRDPGXIlgfZADcSOe6M2DyrDKXdbdaTgkZN5l=s2500",
                        "chat_url": null,
                        "created_date": "2019-12-04T10:58:29.069907",
                        "default_to_fiat": false,
                        "description": "The Sandbox is a community-driven platform where creators can monetize voxel assets and gaming experiences on the blockchain. The Sandbox metaverse comprises a map made up of 166,464 LANDS.  LAND owners can host contests and events, stake SAND to earn and customize assets, monetize assets and experiences, vote in the metaverse governance, play games that you or others create, and more! Trade the collection and keep your eyes peeled for future drops.",
                        "dev_buyer_fee_basis_points": "0",
                        "dev_seller_fee_basis_points": "500",
                        "discord_url": "https://discord.gg/vAe4zvY",
                        "display_data": {
                            "card_display_style": "contain"
                        },
                        "external_url": "https://www.sandbox.game/",
                        "featured": false,
                        "featured_image_url": "https://storage.googleapis.com/opensea-static/featured-images/sandbox-featured.png",
                        "hidden": false,
                        "safelist_request_status": "verified",
                        "image_url": "https://lh3.googleusercontent.com/SXH8tW1siikB80rwCRnjm1a5xM_MwTg9Xl9Db6mioIk9HIlDM09pVoSR7GKJgS6ulSUpgW9BDtMk_ePX_NKgO9A=s60",
                        "is_subject_to_whitelist": false,
                        "large_image_url": "https://lh3.googleusercontent.com/SXH8tW1siikB80rwCRnjm1a5xM_MwTg9Xl9Db6mioIk9HIlDM09pVoSR7GKJgS6ulSUpgW9BDtMk_ePX_NKgO9A",
                        "medium_username": "sandbox-game",
                        "name": "The Sandbox",
                        "only_proxied_transfers": false,
                        "opensea_buyer_fee_basis_points": "0",
                        "opensea_seller_fee_basis_points": "250",
                        "payout_address": "0x7a9fe22691c811ea339d9b73150e6911a5343dca",
                        "require_email": false,
                        "short_description": null,
                        "slug": "sandbox",
                        "telegram_url": "https://t.me/sandboxgame",
                        "twitter_username": "thesandboxgame",
                        "instagram_username": null,
                        "wiki_url": null
                    },
                    "decimals": null,
                    "token_metadata": null
                },
                {
                    "id": 14407420,
                    "token_id": "115668",
                    "num_sales": 0,
                    "background_color": null,
                    "image_url": "https://lh3.googleusercontent.com/17vU_UNWeMOVi4XOAwo4nvAXpeg1dnKPBk8VnAhJcFHOFZ9UBBvSL5Spj0ytvyfII3rdp4gHMY0mMvbnSzjdOZ0",
                    "image_preview_url": "https://lh3.googleusercontent.com/17vU_UNWeMOVi4XOAwo4nvAXpeg1dnKPBk8VnAhJcFHOFZ9UBBvSL5Spj0ytvyfII3rdp4gHMY0mMvbnSzjdOZ0=s250",
                    "image_thumbnail_url": "https://lh3.googleusercontent.com/17vU_UNWeMOVi4XOAwo4nvAXpeg1dnKPBk8VnAhJcFHOFZ9UBBvSL5Spj0ytvyfII3rdp4gHMY0mMvbnSzjdOZ0=s128",
                    "image_original_url": "https://storage.googleapis.com/opensea-static/custom-fetcher-images/sandbox/land/sandbox-land.png",
                    "animation_url": null,
                    "animation_original_url": null,
                    "name": "LAND (0, 79)",
                    "description": "A LAND is a digital piece of real estate in The Sandbox metaverse that players can buy to build experiences on top of. Once you own a LAND, you will be able to populate it with Games and Assets. Each LAND is a unique (non-fungible) token lying on the public Ethereum blockchain (ERC-721).",
                    "external_link": "https://www.sandbox.game/en/map/?x=0&y=79",
                    "asset_contract": {
                        "address": "0x50f5474724e0ee42d9a4e711ccfb275809fd6d4a",
                        "asset_contract_type": "non-fungible",
                        "created_date": "2019-12-04T10:58:28.892990",
                        "name": "Sandbox's LANDs",
                        "nft_version": "3.0",
                        "opensea_version": null,
                        "owner": null,
                        "schema_name": "ERC721",
                        "symbol": "",
                        "total_supply": null,
                        "description": "The Sandbox is a community-driven platform where creators can monetize voxel assets and gaming experiences on the blockchain. The Sandbox metaverse comprises a map made up of 166,464 LANDS.  LAND owners can host contests and events, stake SAND to earn and customize assets, monetize assets and experiences, vote in the metaverse governance, play games that you or others create, and more! Trade the collection and keep your eyes peeled for future drops.",
                        "external_link": "https://www.sandbox.game/",
                        "image_url": "https://lh3.googleusercontent.com/SXH8tW1siikB80rwCRnjm1a5xM_MwTg9Xl9Db6mioIk9HIlDM09pVoSR7GKJgS6ulSUpgW9BDtMk_ePX_NKgO9A=s60",
                        "default_to_fiat": false,
                        "dev_buyer_fee_basis_points": 0,
                        "dev_seller_fee_basis_points": 500,
                        "only_proxied_transfers": false,
                        "opensea_buyer_fee_basis_points": 0,
                        "opensea_seller_fee_basis_points": 250,
                        "buyer_fee_basis_points": 0,
                        "seller_fee_basis_points": 750,
                        "payout_address": "0x7a9fe22691c811ea339d9b73150e6911a5343dca"
                    },
                    "owner": {
                        "user": {
                            "username": "REVOLT"
                        },
                        "profile_img_url": "https://storage.googleapis.com/opensea-static/opensea-profile/25.png",
                        "address": "0xb6d820e80a2a7c49f94c9d6c8ea08dccedc9ce4c",
                        "config": "",
                        "discord_id": ""
                    },
                    "permalink": "https://opensea.io/assets/0x50f5474724e0ee42d9a4e711ccfb275809fd6d4a/115668",
                    "collection": {
                        "banner_image_url": "https://lh3.googleusercontent.com/4NQIRoGmzXeXQN4mjuhWuuDZSNW7_BqRXux5upd4Nn_A-bfsGxCnPF8qn98Y6MyHRDPGXIlgfZADcSOe6M2DyrDKXdbdaTgkZN5l=s2500",
                        "chat_url": null,
                        "created_date": "2019-12-04T10:58:29.069907",
                        "default_to_fiat": false,
                        "description": "The Sandbox is a community-driven platform where creators can monetize voxel assets and gaming experiences on the blockchain. The Sandbox metaverse comprises a map made up of 166,464 LANDS.  LAND owners can host contests and events, stake SAND to earn and customize assets, monetize assets and experiences, vote in the metaverse governance, play games that you or others create, and more! Trade the collection and keep your eyes peeled for future drops.",
                        "dev_buyer_fee_basis_points": "0",
                        "dev_seller_fee_basis_points": "500",
                        "discord_url": "https://discord.gg/vAe4zvY",
                        "display_data": {
                            "card_display_style": "contain"
                        },
                        "external_url": "https://www.sandbox.game/",
                        "featured": false,
                        "featured_image_url": "https://storage.googleapis.com/opensea-static/featured-images/sandbox-featured.png",
                        "hidden": false,
                        "safelist_request_status": "verified",
                        "image_url": "https://lh3.googleusercontent.com/SXH8tW1siikB80rwCRnjm1a5xM_MwTg9Xl9Db6mioIk9HIlDM09pVoSR7GKJgS6ulSUpgW9BDtMk_ePX_NKgO9A=s60",
                        "is_subject_to_whitelist": false,
                        "large_image_url": "https://lh3.googleusercontent.com/SXH8tW1siikB80rwCRnjm1a5xM_MwTg9Xl9Db6mioIk9HIlDM09pVoSR7GKJgS6ulSUpgW9BDtMk_ePX_NKgO9A",
                        "medium_username": "sandbox-game",
                        "name": "The Sandbox",
                        "only_proxied_transfers": false,
                        "opensea_buyer_fee_basis_points": "0",
                        "opensea_seller_fee_basis_points": "250",
                        "payout_address": "0x7a9fe22691c811ea339d9b73150e6911a5343dca",
                        "require_email": false,
                        "short_description": null,
                        "slug": "sandbox",
                        "telegram_url": "https://t.me/sandboxgame",
                        "twitter_username": "thesandboxgame",
                        "instagram_username": null,
                        "wiki_url": null
                    },
                    "decimals": null,
                    "token_metadata": null
                },
                {
                    "id": 14407427,
                    "token_id": "116076",
                    "num_sales": 0,
                    "background_color": null,
                    "image_url": "https://storage.opensea.io/files/3faa959fa75531ac7913a9c9f8361b58.png",
                    "image_preview_url": "https://lh3.googleusercontent.com/17vU_UNWeMOVi4XOAwo4nvAXpeg1dnKPBk8VnAhJcFHOFZ9UBBvSL5Spj0ytvyfII3rdp4gHMY0mMvbnSzjdOZ0=s250",
                    "image_thumbnail_url": "https://lh3.googleusercontent.com/17vU_UNWeMOVi4XOAwo4nvAXpeg1dnKPBk8VnAhJcFHOFZ9UBBvSL5Spj0ytvyfII3rdp4gHMY0mMvbnSzjdOZ0=s128",
                    "image_original_url": "https://storage.googleapis.com/opensea-static/custom-fetcher-images/sandbox/land/sandbox-land.png",
                    "animation_url": null,
                    "animation_original_url": null,
                    "name": "LAND (0, 80)",
                    "description": "A LAND is a digital piece of real estate in The Sandbox metaverse that players can buy to build experiences on top of. Once you own a LAND, you will be able to populate it with Games and Assets. Each LAND is a unique (non-fungible) token lying on the public Ethereum blockchain (ERC-721).",
                    "external_link": "https://www.sandbox.game/en/map/?x=0&y=80",
                    "asset_contract": {
                        "address": "0x50f5474724e0ee42d9a4e711ccfb275809fd6d4a",
                        "asset_contract_type": "non-fungible",
                        "created_date": "2019-12-04T10:58:28.892990",
                        "name": "Sandbox's LANDs",
                        "nft_version": "3.0",
                        "opensea_version": null,
                        "owner": null,
                        "schema_name": "ERC721",
                        "symbol": "",
                        "total_supply": null,
                        "description": "The Sandbox is a community-driven platform where creators can monetize voxel assets and gaming experiences on the blockchain. The Sandbox metaverse comprises a map made up of 166,464 LANDS.  LAND owners can host contests and events, stake SAND to earn and customize assets, monetize assets and experiences, vote in the metaverse governance, play games that you or others create, and more! Trade the collection and keep your eyes peeled for future drops.",
                        "external_link": "https://www.sandbox.game/",
                        "image_url": "https://lh3.googleusercontent.com/SXH8tW1siikB80rwCRnjm1a5xM_MwTg9Xl9Db6mioIk9HIlDM09pVoSR7GKJgS6ulSUpgW9BDtMk_ePX_NKgO9A=s60",
                        "default_to_fiat": false,
                        "dev_buyer_fee_basis_points": 0,
                        "dev_seller_fee_basis_points": 500,
                        "only_proxied_transfers": false,
                        "opensea_buyer_fee_basis_points": 0,
                        "opensea_seller_fee_basis_points": 250,
                        "buyer_fee_basis_points": 0,
                        "seller_fee_basis_points": 750,
                        "payout_address": "0x7a9fe22691c811ea339d9b73150e6911a5343dca"
                    },
                    "owner": {
                        "user": {
                            "username": "REVOLT"
                        },
                        "profile_img_url": "https://storage.googleapis.com/opensea-static/opensea-profile/25.png",
                        "address": "0xb6d820e80a2a7c49f94c9d6c8ea08dccedc9ce4c",
                        "config": "",
                        "discord_id": ""
                    },
                    "permalink": "https://opensea.io/assets/0x50f5474724e0ee42d9a4e711ccfb275809fd6d4a/116076",
                    "collection": {
                        "banner_image_url": "https://lh3.googleusercontent.com/4NQIRoGmzXeXQN4mjuhWuuDZSNW7_BqRXux5upd4Nn_A-bfsGxCnPF8qn98Y6MyHRDPGXIlgfZADcSOe6M2DyrDKXdbdaTgkZN5l=s2500",
                        "chat_url": null,
                        "created_date": "2019-12-04T10:58:29.069907",
                        "default_to_fiat": false,
                        "description": "The Sandbox is a community-driven platform where creators can monetize voxel assets and gaming experiences on the blockchain. The Sandbox metaverse comprises a map made up of 166,464 LANDS.  LAND owners can host contests and events, stake SAND to earn and customize assets, monetize assets and experiences, vote in the metaverse governance, play games that you or others create, and more! Trade the collection and keep your eyes peeled for future drops.",
                        "dev_buyer_fee_basis_points": "0",
                        "dev_seller_fee_basis_points": "500",
                        "discord_url": "https://discord.gg/vAe4zvY",
                        "display_data": {
                            "card_display_style": "contain"
                        },
                        "external_url": "https://www.sandbox.game/",
                        "featured": false,
                        "featured_image_url": "https://storage.googleapis.com/opensea-static/featured-images/sandbox-featured.png",
                        "hidden": false,
                        "safelist_request_status": "verified",
                        "image_url": "https://lh3.googleusercontent.com/SXH8tW1siikB80rwCRnjm1a5xM_MwTg9Xl9Db6mioIk9HIlDM09pVoSR7GKJgS6ulSUpgW9BDtMk_ePX_NKgO9A=s60",
                        "is_subject_to_whitelist": false,
                        "large_image_url": "https://lh3.googleusercontent.com/SXH8tW1siikB80rwCRnjm1a5xM_MwTg9Xl9Db6mioIk9HIlDM09pVoSR7GKJgS6ulSUpgW9BDtMk_ePX_NKgO9A",
                        "medium_username": "sandbox-game",
                        "name": "The Sandbox",
                        "only_proxied_transfers": false,
                        "opensea_buyer_fee_basis_points": "0",
                        "opensea_seller_fee_basis_points": "250",
                        "payout_address": "0x7a9fe22691c811ea339d9b73150e6911a5343dca",
                        "require_email": false,
                        "short_description": null,
                        "slug": "sandbox",
                        "telegram_url": "https://t.me/sandboxgame",
                        "twitter_username": "thesandboxgame",
                        "instagram_username": null,
                        "wiki_url": null
                    },
                    "decimals": null,
                    "token_metadata": null
                },
                {
                    "id": 14407440,
                    "token_id": "116077",
                    "num_sales": 0,
                    "background_color": null,
                    "image_url": "https://lh3.googleusercontent.com/17vU_UNWeMOVi4XOAwo4nvAXpeg1dnKPBk8VnAhJcFHOFZ9UBBvSL5Spj0ytvyfII3rdp4gHMY0mMvbnSzjdOZ0",
                    "image_preview_url": "https://lh3.googleusercontent.com/17vU_UNWeMOVi4XOAwo4nvAXpeg1dnKPBk8VnAhJcFHOFZ9UBBvSL5Spj0ytvyfII3rdp4gHMY0mMvbnSzjdOZ0=s250",
                    "image_thumbnail_url": "https://lh3.googleusercontent.com/17vU_UNWeMOVi4XOAwo4nvAXpeg1dnKPBk8VnAhJcFHOFZ9UBBvSL5Spj0ytvyfII3rdp4gHMY0mMvbnSzjdOZ0=s128",
                    "image_original_url": "https://storage.googleapis.com/opensea-static/custom-fetcher-images/sandbox/land/sandbox-land.png",
                    "animation_url": null,
                    "animation_original_url": null,
                    "name": "LAND (1, 80)",
                    "description": "A LAND is a digital piece of real estate in The Sandbox metaverse that players can buy to build experiences on top of. Once you own a LAND, you will be able to populate it with Games and Assets. Each LAND is a unique (non-fungible) token lying on the public Ethereum blockchain (ERC-721).",
                    "external_link": "https://www.sandbox.game/en/map/?x=1&y=80",
                    "asset_contract": {
                        "address": "0x50f5474724e0ee42d9a4e711ccfb275809fd6d4a",
                        "asset_contract_type": "non-fungible",
                        "created_date": "2019-12-04T10:58:28.892990",
                        "name": "Sandbox's LANDs",
                        "nft_version": "3.0",
                        "opensea_version": null,
                        "owner": null,
                        "schema_name": "ERC721",
                        "symbol": "",
                        "total_supply": null,
                        "description": "The Sandbox is a community-driven platform where creators can monetize voxel assets and gaming experiences on the blockchain. The Sandbox metaverse comprises a map made up of 166,464 LANDS.  LAND owners can host contests and events, stake SAND to earn and customize assets, monetize assets and experiences, vote in the metaverse governance, play games that you or others create, and more! Trade the collection and keep your eyes peeled for future drops.",
                        "external_link": "https://www.sandbox.game/",
                        "image_url": "https://lh3.googleusercontent.com/SXH8tW1siikB80rwCRnjm1a5xM_MwTg9Xl9Db6mioIk9HIlDM09pVoSR7GKJgS6ulSUpgW9BDtMk_ePX_NKgO9A=s60",
                        "default_to_fiat": false,
                        "dev_buyer_fee_basis_points": 0,
                        "dev_seller_fee_basis_points": 500,
                        "only_proxied_transfers": false,
                        "opensea_buyer_fee_basis_points": 0,
                        "opensea_seller_fee_basis_points": 250,
                        "buyer_fee_basis_points": 0,
                        "seller_fee_basis_points": 750,
                        "payout_address": "0x7a9fe22691c811ea339d9b73150e6911a5343dca"
                    },
                    "owner": {
                        "user": {
                            "username": "REVOLT"
                        },
                        "profile_img_url": "https://storage.googleapis.com/opensea-static/opensea-profile/25.png",
                        "address": "0xb6d820e80a2a7c49f94c9d6c8ea08dccedc9ce4c",
                        "config": "",
                        "discord_id": ""
                    },
                    "permalink": "https://opensea.io/assets/0x50f5474724e0ee42d9a4e711ccfb275809fd6d4a/116077",
                    "collection": {
                        "banner_image_url": "https://lh3.googleusercontent.com/4NQIRoGmzXeXQN4mjuhWuuDZSNW7_BqRXux5upd4Nn_A-bfsGxCnPF8qn98Y6MyHRDPGXIlgfZADcSOe6M2DyrDKXdbdaTgkZN5l=s2500",
                        "chat_url": null,
                        "created_date": "2019-12-04T10:58:29.069907",
                        "default_to_fiat": false,
                        "description": "The Sandbox is a community-driven platform where creators can monetize voxel assets and gaming experiences on the blockchain. The Sandbox metaverse comprises a map made up of 166,464 LANDS.  LAND owners can host contests and events, stake SAND to earn and customize assets, monetize assets and experiences, vote in the metaverse governance, play games that you or others create, and more! Trade the collection and keep your eyes peeled for future drops.",
                        "dev_buyer_fee_basis_points": "0",
                        "dev_seller_fee_basis_points": "500",
                        "discord_url": "https://discord.gg/vAe4zvY",
                        "display_data": {
                            "card_display_style": "contain"
                        },
                        "external_url": "https://www.sandbox.game/",
                        "featured": false,
                        "featured_image_url": "https://storage.googleapis.com/opensea-static/featured-images/sandbox-featured.png",
                        "hidden": false,
                        "safelist_request_status": "verified",
                        "image_url": "https://lh3.googleusercontent.com/SXH8tW1siikB80rwCRnjm1a5xM_MwTg9Xl9Db6mioIk9HIlDM09pVoSR7GKJgS6ulSUpgW9BDtMk_ePX_NKgO9A=s60",
                        "is_subject_to_whitelist": false,
                        "large_image_url": "https://lh3.googleusercontent.com/SXH8tW1siikB80rwCRnjm1a5xM_MwTg9Xl9Db6mioIk9HIlDM09pVoSR7GKJgS6ulSUpgW9BDtMk_ePX_NKgO9A",
                        "medium_username": "sandbox-game",
                        "name": "The Sandbox",
                        "only_proxied_transfers": false,
                        "opensea_buyer_fee_basis_points": "0",
                        "opensea_seller_fee_basis_points": "250",
                        "payout_address": "0x7a9fe22691c811ea339d9b73150e6911a5343dca",
                        "require_email": false,
                        "short_description": null,
                        "slug": "sandbox",
                        "telegram_url": "https://t.me/sandboxgame",
                        "twitter_username": "thesandboxgame",
                        "instagram_username": null,
                        "wiki_url": null
                    },
                    "decimals": null,
                    "token_metadata": null
                },
                {
                    "id": 14407459,
                    "token_id": "116078",
                    "num_sales": 0,
                    "background_color": null,
                    "image_url": "https://lh3.googleusercontent.com/17vU_UNWeMOVi4XOAwo4nvAXpeg1dnKPBk8VnAhJcFHOFZ9UBBvSL5Spj0ytvyfII3rdp4gHMY0mMvbnSzjdOZ0",
                    "image_preview_url": "https://lh3.googleusercontent.com/17vU_UNWeMOVi4XOAwo4nvAXpeg1dnKPBk8VnAhJcFHOFZ9UBBvSL5Spj0ytvyfII3rdp4gHMY0mMvbnSzjdOZ0=s250",
                    "image_thumbnail_url": "https://lh3.googleusercontent.com/17vU_UNWeMOVi4XOAwo4nvAXpeg1dnKPBk8VnAhJcFHOFZ9UBBvSL5Spj0ytvyfII3rdp4gHMY0mMvbnSzjdOZ0=s128",
                    "image_original_url": "https://storage.googleapis.com/opensea-static/custom-fetcher-images/sandbox/land/sandbox-land.png",
                    "animation_url": null,
                    "animation_original_url": null,
                    "name": "LAND (2, 80)",
                    "description": "A LAND is a digital piece of real estate in The Sandbox metaverse that players can buy to build experiences on top of. Once you own a LAND, you will be able to populate it with Games and Assets. Each LAND is a unique (non-fungible) token lying on the public Ethereum blockchain (ERC-721).",
                    "external_link": "https://www.sandbox.game/en/map/?x=2&y=80",
                    "asset_contract": {
                        "address": "0x50f5474724e0ee42d9a4e711ccfb275809fd6d4a",
                        "asset_contract_type": "non-fungible",
                        "created_date": "2019-12-04T10:58:28.892990",
                        "name": "Sandbox's LANDs",
                        "nft_version": "3.0",
                        "opensea_version": null,
                        "owner": null,
                        "schema_name": "ERC721",
                        "symbol": "",
                        "total_supply": null,
                        "description": "The Sandbox is a community-driven platform where creators can monetize voxel assets and gaming experiences on the blockchain. The Sandbox metaverse comprises a map made up of 166,464 LANDS.  LAND owners can host contests and events, stake SAND to earn and customize assets, monetize assets and experiences, vote in the metaverse governance, play games that you or others create, and more! Trade the collection and keep your eyes peeled for future drops.",
                        "external_link": "https://www.sandbox.game/",
                        "image_url": "https://lh3.googleusercontent.com/SXH8tW1siikB80rwCRnjm1a5xM_MwTg9Xl9Db6mioIk9HIlDM09pVoSR7GKJgS6ulSUpgW9BDtMk_ePX_NKgO9A=s60",
                        "default_to_fiat": false,
                        "dev_buyer_fee_basis_points": 0,
                        "dev_seller_fee_basis_points": 500,
                        "only_proxied_transfers": false,
                        "opensea_buyer_fee_basis_points": 0,
                        "opensea_seller_fee_basis_points": 250,
                        "buyer_fee_basis_points": 0,
                        "seller_fee_basis_points": 750,
                        "payout_address": "0x7a9fe22691c811ea339d9b73150e6911a5343dca"
                    },
                    "owner": {
                        "user": {
                            "username": "REVOLT"
                        },
                        "profile_img_url": "https://storage.googleapis.com/opensea-static/opensea-profile/25.png",
                        "address": "0xb6d820e80a2a7c49f94c9d6c8ea08dccedc9ce4c",
                        "config": "",
                        "discord_id": ""
                    },
                    "permalink": "https://opensea.io/assets/0x50f5474724e0ee42d9a4e711ccfb275809fd6d4a/116078",
                    "collection": {
                        "banner_image_url": "https://lh3.googleusercontent.com/4NQIRoGmzXeXQN4mjuhWuuDZSNW7_BqRXux5upd4Nn_A-bfsGxCnPF8qn98Y6MyHRDPGXIlgfZADcSOe6M2DyrDKXdbdaTgkZN5l=s2500",
                        "chat_url": null,
                        "created_date": "2019-12-04T10:58:29.069907",
                        "default_to_fiat": false,
                        "description": "The Sandbox is a community-driven platform where creators can monetize voxel assets and gaming experiences on the blockchain. The Sandbox metaverse comprises a map made up of 166,464 LANDS.  LAND owners can host contests and events, stake SAND to earn and customize assets, monetize assets and experiences, vote in the metaverse governance, play games that you or others create, and more! Trade the collection and keep your eyes peeled for future drops.",
                        "dev_buyer_fee_basis_points": "0",
                        "dev_seller_fee_basis_points": "500",
                        "discord_url": "https://discord.gg/vAe4zvY",
                        "display_data": {
                            "card_display_style": "contain"
                        },
                        "external_url": "https://www.sandbox.game/",
                        "featured": false,
                        "featured_image_url": "https://storage.googleapis.com/opensea-static/featured-images/sandbox-featured.png",
                        "hidden": false,
                        "safelist_request_status": "verified",
                        "image_url": "https://lh3.googleusercontent.com/SXH8tW1siikB80rwCRnjm1a5xM_MwTg9Xl9Db6mioIk9HIlDM09pVoSR7GKJgS6ulSUpgW9BDtMk_ePX_NKgO9A=s60",
                        "is_subject_to_whitelist": false,
                        "large_image_url": "https://lh3.googleusercontent.com/SXH8tW1siikB80rwCRnjm1a5xM_MwTg9Xl9Db6mioIk9HIlDM09pVoSR7GKJgS6ulSUpgW9BDtMk_ePX_NKgO9A",
                        "medium_username": "sandbox-game",
                        "name": "The Sandbox",
                        "only_proxied_transfers": false,
                        "opensea_buyer_fee_basis_points": "0",
                        "opensea_seller_fee_basis_points": "250",
                        "payout_address": "0x7a9fe22691c811ea339d9b73150e6911a5343dca",
                        "require_email": false,
                        "short_description": null,
                        "slug": "sandbox",
                        "telegram_url": "https://t.me/sandboxgame",
                        "twitter_username": "thesandboxgame",
                        "instagram_username": null,
                        "wiki_url": null
                    },
                    "decimals": null,
                    "token_metadata": null
                }
            ],
            "name": "Small estate (9 lands)",
            "description": "Yes, you can afford it :o))",
            "external_link": "",
            "asset_contract": {
                "collection": {
                    "banner_image_url": "https://lh3.googleusercontent.com/4NQIRoGmzXeXQN4mjuhWuuDZSNW7_BqRXux5upd4Nn_A-bfsGxCnPF8qn98Y6MyHRDPGXIlgfZADcSOe6M2DyrDKXdbdaTgkZN5l=s2500",
                    "chat_url": null,
                    "created_date": "2019-12-04T10:58:29.069907",
                    "default_to_fiat": false,
                    "description": "The Sandbox is a community-driven platform where creators can monetize voxel assets and gaming experiences on the blockchain. The Sandbox metaverse comprises a map made up of 166,464 LANDS.  LAND owners can host contests and events, stake SAND to earn and customize assets, monetize assets and experiences, vote in the metaverse governance, play games that you or others create, and more! Trade the collection and keep your eyes peeled for future drops.",
                    "dev_buyer_fee_basis_points": "0",
                    "dev_seller_fee_basis_points": "500",
                    "discord_url": "https://discord.gg/vAe4zvY",
                    "display_data": {
                        "card_display_style": "contain"
                    },
                    "external_url": "https://www.sandbox.game/",
                    "featured": false,
                    "featured_image_url": "https://storage.googleapis.com/opensea-static/featured-images/sandbox-featured.png",
                    "hidden": false,
                    "safelist_request_status": "verified",
                    "image_url": "https://lh3.googleusercontent.com/SXH8tW1siikB80rwCRnjm1a5xM_MwTg9Xl9Db6mioIk9HIlDM09pVoSR7GKJgS6ulSUpgW9BDtMk_ePX_NKgO9A=s60",
                    "is_subject_to_whitelist": false,
                    "large_image_url": "https://lh3.googleusercontent.com/SXH8tW1siikB80rwCRnjm1a5xM_MwTg9Xl9Db6mioIk9HIlDM09pVoSR7GKJgS6ulSUpgW9BDtMk_ePX_NKgO9A",
                    "medium_username": "sandbox-game",
                    "name": "The Sandbox",
                    "only_proxied_transfers": false,
                    "opensea_buyer_fee_basis_points": "0",
                    "opensea_seller_fee_basis_points": "250",
                    "payout_address": "0x7a9fe22691c811ea339d9b73150e6911a5343dca",
                    "require_email": false,
                    "short_description": null,
                    "slug": "sandbox",
                    "telegram_url": "https://t.me/sandboxgame",
                    "twitter_username": "thesandboxgame",
                    "instagram_username": null,
                    "wiki_url": null
                },
                "address": "0x50f5474724e0ee42d9a4e711ccfb275809fd6d4a",
                "asset_contract_type": "non-fungible",
                "created_date": "2019-12-04T10:58:28.892990",
                "name": "Sandbox's LANDs",
                "nft_version": "3.0",
                "opensea_version": null,
                "owner": null,
                "schema_name": "ERC721",
                "symbol": "",
                "total_supply": null,
                "description": "The Sandbox is a community-driven platform where creators can monetize voxel assets and gaming experiences on the blockchain. The Sandbox metaverse comprises a map made up of 166,464 LANDS.  LAND owners can host contests and events, stake SAND to earn and customize assets, monetize assets and experiences, vote in the metaverse governance, play games that you or others create, and more! Trade the collection and keep your eyes peeled for future drops.",
                "external_link": "https://www.sandbox.game/",
                "image_url": "https://lh3.googleusercontent.com/SXH8tW1siikB80rwCRnjm1a5xM_MwTg9Xl9Db6mioIk9HIlDM09pVoSR7GKJgS6ulSUpgW9BDtMk_ePX_NKgO9A=s60",
                "default_to_fiat": false,
                "dev_buyer_fee_basis_points": 0,
                "dev_seller_fee_basis_points": 500,
                "only_proxied_transfers": false,
                "opensea_buyer_fee_basis_points": 0,
                "opensea_seller_fee_basis_points": 250,
                "buyer_fee_basis_points": 0,
                "seller_fee_basis_points": 750,
                "payout_address": "0x7a9fe22691c811ea339d9b73150e6911a5343dca"
            },
            "permalink": "https://opensea.io/bundles/small-estate-9-lands-LQN",
            "sell_orders": [
                {
                    "created_date": "2021-05-25T22:03:30.064731",
                    "closing_date": null,
                    "closing_extendable": false,
                    "expiration_time": 0,
                    "listing_time": 1621980104,
                    "order_hash": "0x010079a3db3c9a7fe5fbdd92ab73390c42fff7af43e044916c4c66e927a0fe73",
                    "metadata": {
                        "bundle": {
                            "assets": [
                                {
                                    "id": "115260",
                                    "address": "0x50f5474724e0ee42d9a4e711ccfb275809fd6d4a"
                                },
                                {
                                    "id": "115261",
                                    "address": "0x50f5474724e0ee42d9a4e711ccfb275809fd6d4a"
                                },
                                {
                                    "id": "115262",
                                    "address": "0x50f5474724e0ee42d9a4e711ccfb275809fd6d4a"
                                },
                                {
                                    "id": "115668",
                                    "address": "0x50f5474724e0ee42d9a4e711ccfb275809fd6d4a"
                                },
                                {
                                    "id": "115669",
                                    "address": "0x50f5474724e0ee42d9a4e711ccfb275809fd6d4a"
                                },
                                {
                                    "id": "115670",
                                    "address": "0x50f5474724e0ee42d9a4e711ccfb275809fd6d4a"
                                },
                                {
                                    "id": "116076",
                                    "address": "0x50f5474724e0ee42d9a4e711ccfb275809fd6d4a"
                                },
                                {
                                    "id": "116077",
                                    "address": "0x50f5474724e0ee42d9a4e711ccfb275809fd6d4a"
                                },
                                {
                                    "id": "116078",
                                    "address": "0x50f5474724e0ee42d9a4e711ccfb275809fd6d4a"
                                }
                            ],
                            "schemas": [
                                "ERC721",
                                "ERC721",
                                "ERC721",
                                "ERC721",
                                "ERC721",
                                "ERC721",
                                "ERC721",
                                "ERC721",
                                "ERC721"
                            ],
                            "name": "Small estate (9 lands)",
                            "description": "Yes, you can afford it :o))",
                            "external_link": ""
                        }
                    },
                    "exchange": "0x7be8076f4ea4a4ad08075c2508e481d6c946d12b",
                    "maker": {
                        "user": 3797,
                        "profile_img_url": "https://storage.googleapis.com/opensea-static/opensea-profile/25.png",
                        "address": "0xb6d820e80a2a7c49f94c9d6c8ea08dccedc9ce4c",
                        "config": "",
                        "discord_id": ""
                    },
                    "taker": {
                        "user": 1766,
                        "profile_img_url": "https://storage.googleapis.com/opensea-static/opensea-profile/1.png",
                        "address": "0x0000000000000000000000000000000000000000",
                        "config": "",
                        "discord_id": ""
                    },
                    "current_price": "135000000000000000000",
                    "current_bounty": "1350000000000000000",
                    "bounty_multiple": "0.01",
                    "maker_relayer_fee": "750",
                    "taker_relayer_fee": "0",
                    "maker_protocol_fee": "0",
                    "taker_protocol_fee": "0",
                    "maker_referrer_fee": "0",
                    "fee_recipient": {
                        "user": 3585,
                        "profile_img_url": "https://storage.googleapis.com/opensea-static/opensea-profile/28.png",
                        "address": "0x5b3256965e7c3cf26e11fcaf296dfc8807c01073",
                        "config": "verified",
                        "discord_id": ""
                    },
                    "fee_method": 1,
                    "side": 1,
                    "sale_kind": 0,
                    "target": "0xc99f70bfd82fb7c8f8191fdfbfb735606b15e5c5",
                    "how_to_call": 1,
                    "calldata": "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",
                    "replacement_pattern": "0x0000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000ffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffff0000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000ffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffff0000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000ffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffff0000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000ffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffff0000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000ffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffff0000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000ffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffff0000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000ffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffff0000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000ffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffff0000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000ffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffff000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000",
                    "static_target": "0x0000000000000000000000000000000000000000",
                    "static_extradata": "0x",
                    "payment_token": "0x0000000000000000000000000000000000000000",
                    "payment_token_contract": {
                        "id": 1,
                        "symbol": "ETH",
                        "address": "0x0000000000000000000000000000000000000000",
                        "image_url": "https://storage.opensea.io/files/6f8e2979d428180222796ff4a33ab929.svg",
                        "name": "Ether",
                        "decimals": 18,
                        "eth_price": "1.000000000000000",
                        "usd_price": "2625.730000000000018000"
                    },
                    "base_price": "135000000000000000000",
                    "extra": "0",
                    "quantity": "1",
                    "salt": "69980316108926683346961471203482963507357071602024752812626180162206127347756",
                    "v": 27,
                    "r": "0x8ffedfd084857267c74acd246e8dc9de68fbb0b3bb4fac7e276b09caffb2c147",
                    "s": "0x62e23b53083356d9a3cdbad4743027be7e10e283833a4ec3517a8ba8681a1597",
                    "approved_on_chain": false,
                    "cancelled": false,
                    "finalized": false,
                    "marked_invalid": false,
                    "prefixed_hash": "0x427e8ea373234590854faa3692f40441b50ce2a33f3d2b2bb79a3a2418c95cf2"
                }
            ]
        },
        {
            "maker": {
                "user": {
                    "username": "REVOLT"
                },
                "profile_img_url": "https://storage.googleapis.com/opensea-static/opensea-profile/25.png",
                "address": "0xb6d820e80a2a7c49f94c9d6c8ea08dccedc9ce4c",
                "config": "",
                "discord_id": ""
            },
            "slug": "small-estate-9-lands-nPR",
            "assets": [
                {
                    "id": 15816029,
                    "token_id": "78669",
                    "num_sales": 0,
                    "background_color": null,
                    "image_url": "https://lh3.googleusercontent.com/17vU_UNWeMOVi4XOAwo4nvAXpeg1dnKPBk8VnAhJcFHOFZ9UBBvSL5Spj0ytvyfII3rdp4gHMY0mMvbnSzjdOZ0",
                    "image_preview_url": "https://lh3.googleusercontent.com/17vU_UNWeMOVi4XOAwo4nvAXpeg1dnKPBk8VnAhJcFHOFZ9UBBvSL5Spj0ytvyfII3rdp4gHMY0mMvbnSzjdOZ0=s250",
                    "image_thumbnail_url": "https://lh3.googleusercontent.com/17vU_UNWeMOVi4XOAwo4nvAXpeg1dnKPBk8VnAhJcFHOFZ9UBBvSL5Spj0ytvyfII3rdp4gHMY0mMvbnSzjdOZ0=s128",
                    "image_original_url": "https://storage.googleapis.com/opensea-static/custom-fetcher-images/sandbox/land/sandbox-land.png",
                    "animation_url": null,
                    "animation_original_url": null,
                    "name": "LAND (129, -12)",
                    "description": "A LAND is a digital piece of real estate in The Sandbox metaverse that players can buy to build experiences on top of. Once you own a LAND, you will be able to populate it with Games and Assets. Each LAND is a unique (non-fungible) token lying on the public Ethereum blockchain (ERC-721).",
                    "external_link": "https://www.sandbox.game/en/map/?x=129&y=-12",
                    "asset_contract": {
                        "address": "0x50f5474724e0ee42d9a4e711ccfb275809fd6d4a",
                        "asset_contract_type": "non-fungible",
                        "created_date": "2019-12-04T10:58:28.892990",
                        "name": "Sandbox's LANDs",
                        "nft_version": "3.0",
                        "opensea_version": null,
                        "owner": null,
                        "schema_name": "ERC721",
                        "symbol": "",
                        "total_supply": null,
                        "description": "The Sandbox is a community-driven platform where creators can monetize voxel assets and gaming experiences on the blockchain. The Sandbox metaverse comprises a map made up of 166,464 LANDS.  LAND owners can host contests and events, stake SAND to earn and customize assets, monetize assets and experiences, vote in the metaverse governance, play games that you or others create, and more! Trade the collection and keep your eyes peeled for future drops.",
                        "external_link": "https://www.sandbox.game/",
                        "image_url": "https://lh3.googleusercontent.com/SXH8tW1siikB80rwCRnjm1a5xM_MwTg9Xl9Db6mioIk9HIlDM09pVoSR7GKJgS6ulSUpgW9BDtMk_ePX_NKgO9A=s60",
                        "default_to_fiat": false,
                        "dev_buyer_fee_basis_points": 0,
                        "dev_seller_fee_basis_points": 500,
                        "only_proxied_transfers": false,
                        "opensea_buyer_fee_basis_points": 0,
                        "opensea_seller_fee_basis_points": 250,
                        "buyer_fee_basis_points": 0,
                        "seller_fee_basis_points": 750,
                        "payout_address": "0x7a9fe22691c811ea339d9b73150e6911a5343dca"
                    },
                    "owner": {
                        "user": {
                            "username": "REVOLT"
                        },
                        "profile_img_url": "https://storage.googleapis.com/opensea-static/opensea-profile/25.png",
                        "address": "0xb6d820e80a2a7c49f94c9d6c8ea08dccedc9ce4c",
                        "config": "",
                        "discord_id": ""
                    },
                    "permalink": "https://opensea.io/assets/0x50f5474724e0ee42d9a4e711ccfb275809fd6d4a/78669",
                    "collection": {
                        "banner_image_url": "https://lh3.googleusercontent.com/4NQIRoGmzXeXQN4mjuhWuuDZSNW7_BqRXux5upd4Nn_A-bfsGxCnPF8qn98Y6MyHRDPGXIlgfZADcSOe6M2DyrDKXdbdaTgkZN5l=s2500",
                        "chat_url": null,
                        "created_date": "2019-12-04T10:58:29.069907",
                        "default_to_fiat": false,
                        "description": "The Sandbox is a community-driven platform where creators can monetize voxel assets and gaming experiences on the blockchain. The Sandbox metaverse comprises a map made up of 166,464 LANDS.  LAND owners can host contests and events, stake SAND to earn and customize assets, monetize assets and experiences, vote in the metaverse governance, play games that you or others create, and more! Trade the collection and keep your eyes peeled for future drops.",
                        "dev_buyer_fee_basis_points": "0",
                        "dev_seller_fee_basis_points": "500",
                        "discord_url": "https://discord.gg/vAe4zvY",
                        "display_data": {
                            "card_display_style": "contain"
                        },
                        "external_url": "https://www.sandbox.game/",
                        "featured": false,
                        "featured_image_url": "https://storage.googleapis.com/opensea-static/featured-images/sandbox-featured.png",
                        "hidden": false,
                        "safelist_request_status": "verified",
                        "image_url": "https://lh3.googleusercontent.com/SXH8tW1siikB80rwCRnjm1a5xM_MwTg9Xl9Db6mioIk9HIlDM09pVoSR7GKJgS6ulSUpgW9BDtMk_ePX_NKgO9A=s60",
                        "is_subject_to_whitelist": false,
                        "large_image_url": "https://lh3.googleusercontent.com/SXH8tW1siikB80rwCRnjm1a5xM_MwTg9Xl9Db6mioIk9HIlDM09pVoSR7GKJgS6ulSUpgW9BDtMk_ePX_NKgO9A",
                        "medium_username": "sandbox-game",
                        "name": "The Sandbox",
                        "only_proxied_transfers": false,
                        "opensea_buyer_fee_basis_points": "0",
                        "opensea_seller_fee_basis_points": "250",
                        "payout_address": "0x7a9fe22691c811ea339d9b73150e6911a5343dca",
                        "require_email": false,
                        "short_description": null,
                        "slug": "sandbox",
                        "telegram_url": "https://t.me/sandboxgame",
                        "twitter_username": "thesandboxgame",
                        "instagram_username": null,
                        "wiki_url": null
                    },
                    "decimals": null,
                    "token_metadata": null
                },
                {
                    "id": 15816064,
                    "token_id": "78670",
                    "num_sales": 0,
                    "background_color": null,
                    "image_url": "https://storage.opensea.io/files/3faa959fa75531ac7913a9c9f8361b58.png",
                    "image_preview_url": "https://lh3.googleusercontent.com/17vU_UNWeMOVi4XOAwo4nvAXpeg1dnKPBk8VnAhJcFHOFZ9UBBvSL5Spj0ytvyfII3rdp4gHMY0mMvbnSzjdOZ0=s250",
                    "image_thumbnail_url": "https://lh3.googleusercontent.com/17vU_UNWeMOVi4XOAwo4nvAXpeg1dnKPBk8VnAhJcFHOFZ9UBBvSL5Spj0ytvyfII3rdp4gHMY0mMvbnSzjdOZ0=s128",
                    "image_original_url": "https://storage.googleapis.com/opensea-static/custom-fetcher-images/sandbox/land/sandbox-land.png",
                    "animation_url": null,
                    "animation_original_url": null,
                    "name": "LAND (130, -12)",
                    "description": "A LAND is a digital piece of real estate in The Sandbox metaverse that players can buy to build experiences on top of. Once you own a LAND, you will be able to populate it with Games and Assets. Each LAND is a unique (non-fungible) token lying on the public Ethereum blockchain (ERC-721).",
                    "external_link": "https://www.sandbox.game/en/map/?x=130&y=-12",
                    "asset_contract": {
                        "address": "0x50f5474724e0ee42d9a4e711ccfb275809fd6d4a",
                        "asset_contract_type": "non-fungible",
                        "created_date": "2019-12-04T10:58:28.892990",
                        "name": "Sandbox's LANDs",
                        "nft_version": "3.0",
                        "opensea_version": null,
                        "owner": null,
                        "schema_name": "ERC721",
                        "symbol": "",
                        "total_supply": null,
                        "description": "The Sandbox is a community-driven platform where creators can monetize voxel assets and gaming experiences on the blockchain. The Sandbox metaverse comprises a map made up of 166,464 LANDS.  LAND owners can host contests and events, stake SAND to earn and customize assets, monetize assets and experiences, vote in the metaverse governance, play games that you or others create, and more! Trade the collection and keep your eyes peeled for future drops.",
                        "external_link": "https://www.sandbox.game/",
                        "image_url": "https://lh3.googleusercontent.com/SXH8tW1siikB80rwCRnjm1a5xM_MwTg9Xl9Db6mioIk9HIlDM09pVoSR7GKJgS6ulSUpgW9BDtMk_ePX_NKgO9A=s60",
                        "default_to_fiat": false,
                        "dev_buyer_fee_basis_points": 0,
                        "dev_seller_fee_basis_points": 500,
                        "only_proxied_transfers": false,
                        "opensea_buyer_fee_basis_points": 0,
                        "opensea_seller_fee_basis_points": 250,
                        "buyer_fee_basis_points": 0,
                        "seller_fee_basis_points": 750,
                        "payout_address": "0x7a9fe22691c811ea339d9b73150e6911a5343dca"
                    },
                    "owner": {
                        "user": {
                            "username": "REVOLT"
                        },
                        "profile_img_url": "https://storage.googleapis.com/opensea-static/opensea-profile/25.png",
                        "address": "0xb6d820e80a2a7c49f94c9d6c8ea08dccedc9ce4c",
                        "config": "",
                        "discord_id": ""
                    },
                    "permalink": "https://opensea.io/assets/0x50f5474724e0ee42d9a4e711ccfb275809fd6d4a/78670",
                    "collection": {
                        "banner_image_url": "https://lh3.googleusercontent.com/4NQIRoGmzXeXQN4mjuhWuuDZSNW7_BqRXux5upd4Nn_A-bfsGxCnPF8qn98Y6MyHRDPGXIlgfZADcSOe6M2DyrDKXdbdaTgkZN5l=s2500",
                        "chat_url": null,
                        "created_date": "2019-12-04T10:58:29.069907",
                        "default_to_fiat": false,
                        "description": "The Sandbox is a community-driven platform where creators can monetize voxel assets and gaming experiences on the blockchain. The Sandbox metaverse comprises a map made up of 166,464 LANDS.  LAND owners can host contests and events, stake SAND to earn and customize assets, monetize assets and experiences, vote in the metaverse governance, play games that you or others create, and more! Trade the collection and keep your eyes peeled for future drops.",
                        "dev_buyer_fee_basis_points": "0",
                        "dev_seller_fee_basis_points": "500",
                        "discord_url": "https://discord.gg/vAe4zvY",
                        "display_data": {
                            "card_display_style": "contain"
                        },
                        "external_url": "https://www.sandbox.game/",
                        "featured": false,
                        "featured_image_url": "https://storage.googleapis.com/opensea-static/featured-images/sandbox-featured.png",
                        "hidden": false,
                        "safelist_request_status": "verified",
                        "image_url": "https://lh3.googleusercontent.com/SXH8tW1siikB80rwCRnjm1a5xM_MwTg9Xl9Db6mioIk9HIlDM09pVoSR7GKJgS6ulSUpgW9BDtMk_ePX_NKgO9A=s60",
                        "is_subject_to_whitelist": false,
                        "large_image_url": "https://lh3.googleusercontent.com/SXH8tW1siikB80rwCRnjm1a5xM_MwTg9Xl9Db6mioIk9HIlDM09pVoSR7GKJgS6ulSUpgW9BDtMk_ePX_NKgO9A",
                        "medium_username": "sandbox-game",
                        "name": "The Sandbox",
                        "only_proxied_transfers": false,
                        "opensea_buyer_fee_basis_points": "0",
                        "opensea_seller_fee_basis_points": "250",
                        "payout_address": "0x7a9fe22691c811ea339d9b73150e6911a5343dca",
                        "require_email": false,
                        "short_description": null,
                        "slug": "sandbox",
                        "telegram_url": "https://t.me/sandboxgame",
                        "twitter_username": "thesandboxgame",
                        "instagram_username": null,
                        "wiki_url": null
                    },
                    "decimals": null,
                    "token_metadata": null
                },
                {
                    "id": 15816084,
                    "token_id": "78671",
                    "num_sales": 0,
                    "background_color": null,
                    "image_url": "https://lh3.googleusercontent.com/17vU_UNWeMOVi4XOAwo4nvAXpeg1dnKPBk8VnAhJcFHOFZ9UBBvSL5Spj0ytvyfII3rdp4gHMY0mMvbnSzjdOZ0",
                    "image_preview_url": "https://lh3.googleusercontent.com/17vU_UNWeMOVi4XOAwo4nvAXpeg1dnKPBk8VnAhJcFHOFZ9UBBvSL5Spj0ytvyfII3rdp4gHMY0mMvbnSzjdOZ0=s250",
                    "image_thumbnail_url": "https://lh3.googleusercontent.com/17vU_UNWeMOVi4XOAwo4nvAXpeg1dnKPBk8VnAhJcFHOFZ9UBBvSL5Spj0ytvyfII3rdp4gHMY0mMvbnSzjdOZ0=s128",
                    "image_original_url": "https://storage.googleapis.com/opensea-static/custom-fetcher-images/sandbox/land/sandbox-land.png",
                    "animation_url": null,
                    "animation_original_url": null,
                    "name": "LAND (131, -12)",
                    "description": "A LAND is a digital piece of real estate in The Sandbox metaverse that players can buy to build experiences on top of. Once you own a LAND, you will be able to populate it with Games and Assets. Each LAND is a unique (non-fungible) token lying on the public Ethereum blockchain (ERC-721).",
                    "external_link": "https://www.sandbox.game/en/map/?x=131&y=-12",
                    "asset_contract": {
                        "address": "0x50f5474724e0ee42d9a4e711ccfb275809fd6d4a",
                        "asset_contract_type": "non-fungible",
                        "created_date": "2019-12-04T10:58:28.892990",
                        "name": "Sandbox's LANDs",
                        "nft_version": "3.0",
                        "opensea_version": null,
                        "owner": null,
                        "schema_name": "ERC721",
                        "symbol": "",
                        "total_supply": null,
                        "description": "The Sandbox is a community-driven platform where creators can monetize voxel assets and gaming experiences on the blockchain. The Sandbox metaverse comprises a map made up of 166,464 LANDS.  LAND owners can host contests and events, stake SAND to earn and customize assets, monetize assets and experiences, vote in the metaverse governance, play games that you or others create, and more! Trade the collection and keep your eyes peeled for future drops.",
                        "external_link": "https://www.sandbox.game/",
                        "image_url": "https://lh3.googleusercontent.com/SXH8tW1siikB80rwCRnjm1a5xM_MwTg9Xl9Db6mioIk9HIlDM09pVoSR7GKJgS6ulSUpgW9BDtMk_ePX_NKgO9A=s60",
                        "default_to_fiat": false,
                        "dev_buyer_fee_basis_points": 0,
                        "dev_seller_fee_basis_points": 500,
                        "only_proxied_transfers": false,
                        "opensea_buyer_fee_basis_points": 0,
                        "opensea_seller_fee_basis_points": 250,
                        "buyer_fee_basis_points": 0,
                        "seller_fee_basis_points": 750,
                        "payout_address": "0x7a9fe22691c811ea339d9b73150e6911a5343dca"
                    },
                    "owner": {
                        "user": {
                            "username": "REVOLT"
                        },
                        "profile_img_url": "https://storage.googleapis.com/opensea-static/opensea-profile/25.png",
                        "address": "0xb6d820e80a2a7c49f94c9d6c8ea08dccedc9ce4c",
                        "config": "",
                        "discord_id": ""
                    },
                    "permalink": "https://opensea.io/assets/0x50f5474724e0ee42d9a4e711ccfb275809fd6d4a/78671",
                    "collection": {
                        "banner_image_url": "https://lh3.googleusercontent.com/4NQIRoGmzXeXQN4mjuhWuuDZSNW7_BqRXux5upd4Nn_A-bfsGxCnPF8qn98Y6MyHRDPGXIlgfZADcSOe6M2DyrDKXdbdaTgkZN5l=s2500",
                        "chat_url": null,
                        "created_date": "2019-12-04T10:58:29.069907",
                        "default_to_fiat": false,
                        "description": "The Sandbox is a community-driven platform where creators can monetize voxel assets and gaming experiences on the blockchain. The Sandbox metaverse comprises a map made up of 166,464 LANDS.  LAND owners can host contests and events, stake SAND to earn and customize assets, monetize assets and experiences, vote in the metaverse governance, play games that you or others create, and more! Trade the collection and keep your eyes peeled for future drops.",
                        "dev_buyer_fee_basis_points": "0",
                        "dev_seller_fee_basis_points": "500",
                        "discord_url": "https://discord.gg/vAe4zvY",
                        "display_data": {
                            "card_display_style": "contain"
                        },
                        "external_url": "https://www.sandbox.game/",
                        "featured": false,
                        "featured_image_url": "https://storage.googleapis.com/opensea-static/featured-images/sandbox-featured.png",
                        "hidden": false,
                        "safelist_request_status": "verified",
                        "image_url": "https://lh3.googleusercontent.com/SXH8tW1siikB80rwCRnjm1a5xM_MwTg9Xl9Db6mioIk9HIlDM09pVoSR7GKJgS6ulSUpgW9BDtMk_ePX_NKgO9A=s60",
                        "is_subject_to_whitelist": false,
                        "large_image_url": "https://lh3.googleusercontent.com/SXH8tW1siikB80rwCRnjm1a5xM_MwTg9Xl9Db6mioIk9HIlDM09pVoSR7GKJgS6ulSUpgW9BDtMk_ePX_NKgO9A",
                        "medium_username": "sandbox-game",
                        "name": "The Sandbox",
                        "only_proxied_transfers": false,
                        "opensea_buyer_fee_basis_points": "0",
                        "opensea_seller_fee_basis_points": "250",
                        "payout_address": "0x7a9fe22691c811ea339d9b73150e6911a5343dca",
                        "require_email": false,
                        "short_description": null,
                        "slug": "sandbox",
                        "telegram_url": "https://t.me/sandboxgame",
                        "twitter_username": "thesandboxgame",
                        "instagram_username": null,
                        "wiki_url": null
                    },
                    "decimals": null,
                    "token_metadata": null
                },
                {
                    "id": 15816100,
                    "token_id": "79079",
                    "num_sales": 0,
                    "background_color": null,
                    "image_url": "https://storage.opensea.io/files/3faa959fa75531ac7913a9c9f8361b58.png",
                    "image_preview_url": "https://lh3.googleusercontent.com/17vU_UNWeMOVi4XOAwo4nvAXpeg1dnKPBk8VnAhJcFHOFZ9UBBvSL5Spj0ytvyfII3rdp4gHMY0mMvbnSzjdOZ0=s250",
                    "image_thumbnail_url": "https://lh3.googleusercontent.com/17vU_UNWeMOVi4XOAwo4nvAXpeg1dnKPBk8VnAhJcFHOFZ9UBBvSL5Spj0ytvyfII3rdp4gHMY0mMvbnSzjdOZ0=s128",
                    "image_original_url": "https://storage.googleapis.com/opensea-static/custom-fetcher-images/sandbox/land/sandbox-land.png",
                    "animation_url": null,
                    "animation_original_url": null,
                    "name": "LAND (131, -11)",
                    "description": "A LAND is a digital piece of real estate in The Sandbox metaverse that players can buy to build experiences on top of. Once you own a LAND, you will be able to populate it with Games and Assets. Each LAND is a unique (non-fungible) token lying on the public Ethereum blockchain (ERC-721).",
                    "external_link": "https://www.sandbox.game/en/map/?x=131&y=-11",
                    "asset_contract": {
                        "address": "0x50f5474724e0ee42d9a4e711ccfb275809fd6d4a",
                        "asset_contract_type": "non-fungible",
                        "created_date": "2019-12-04T10:58:28.892990",
                        "name": "Sandbox's LANDs",
                        "nft_version": "3.0",
                        "opensea_version": null,
                        "owner": null,
                        "schema_name": "ERC721",
                        "symbol": "",
                        "total_supply": null,
                        "description": "The Sandbox is a community-driven platform where creators can monetize voxel assets and gaming experiences on the blockchain. The Sandbox metaverse comprises a map made up of 166,464 LANDS.  LAND owners can host contests and events, stake SAND to earn and customize assets, monetize assets and experiences, vote in the metaverse governance, play games that you or others create, and more! Trade the collection and keep your eyes peeled for future drops.",
                        "external_link": "https://www.sandbox.game/",
                        "image_url": "https://lh3.googleusercontent.com/SXH8tW1siikB80rwCRnjm1a5xM_MwTg9Xl9Db6mioIk9HIlDM09pVoSR7GKJgS6ulSUpgW9BDtMk_ePX_NKgO9A=s60",
                        "default_to_fiat": false,
                        "dev_buyer_fee_basis_points": 0,
                        "dev_seller_fee_basis_points": 500,
                        "only_proxied_transfers": false,
                        "opensea_buyer_fee_basis_points": 0,
                        "opensea_seller_fee_basis_points": 250,
                        "buyer_fee_basis_points": 0,
                        "seller_fee_basis_points": 750,
                        "payout_address": "0x7a9fe22691c811ea339d9b73150e6911a5343dca"
                    },
                    "owner": {
                        "user": {
                            "username": "REVOLT"
                        },
                        "profile_img_url": "https://storage.googleapis.com/opensea-static/opensea-profile/25.png",
                        "address": "0xb6d820e80a2a7c49f94c9d6c8ea08dccedc9ce4c",
                        "config": "",
                        "discord_id": ""
                    },
                    "permalink": "https://opensea.io/assets/0x50f5474724e0ee42d9a4e711ccfb275809fd6d4a/79079",
                    "collection": {
                        "banner_image_url": "https://lh3.googleusercontent.com/4NQIRoGmzXeXQN4mjuhWuuDZSNW7_BqRXux5upd4Nn_A-bfsGxCnPF8qn98Y6MyHRDPGXIlgfZADcSOe6M2DyrDKXdbdaTgkZN5l=s2500",
                        "chat_url": null,
                        "created_date": "2019-12-04T10:58:29.069907",
                        "default_to_fiat": false,
                        "description": "The Sandbox is a community-driven platform where creators can monetize voxel assets and gaming experiences on the blockchain. The Sandbox metaverse comprises a map made up of 166,464 LANDS.  LAND owners can host contests and events, stake SAND to earn and customize assets, monetize assets and experiences, vote in the metaverse governance, play games that you or others create, and more! Trade the collection and keep your eyes peeled for future drops.",
                        "dev_buyer_fee_basis_points": "0",
                        "dev_seller_fee_basis_points": "500",
                        "discord_url": "https://discord.gg/vAe4zvY",
                        "display_data": {
                            "card_display_style": "contain"
                        },
                        "external_url": "https://www.sandbox.game/",
                        "featured": false,
                        "featured_image_url": "https://storage.googleapis.com/opensea-static/featured-images/sandbox-featured.png",
                        "hidden": false,
                        "safelist_request_status": "verified",
                        "image_url": "https://lh3.googleusercontent.com/SXH8tW1siikB80rwCRnjm1a5xM_MwTg9Xl9Db6mioIk9HIlDM09pVoSR7GKJgS6ulSUpgW9BDtMk_ePX_NKgO9A=s60",
                        "is_subject_to_whitelist": false,
                        "large_image_url": "https://lh3.googleusercontent.com/SXH8tW1siikB80rwCRnjm1a5xM_MwTg9Xl9Db6mioIk9HIlDM09pVoSR7GKJgS6ulSUpgW9BDtMk_ePX_NKgO9A",
                        "medium_username": "sandbox-game",
                        "name": "The Sandbox",
                        "only_proxied_transfers": false,
                        "opensea_buyer_fee_basis_points": "0",
                        "opensea_seller_fee_basis_points": "250",
                        "payout_address": "0x7a9fe22691c811ea339d9b73150e6911a5343dca",
                        "require_email": false,
                        "short_description": null,
                        "slug": "sandbox",
                        "telegram_url": "https://t.me/sandboxgame",
                        "twitter_username": "thesandboxgame",
                        "instagram_username": null,
                        "wiki_url": null
                    },
                    "decimals": null,
                    "token_metadata": null
                },
                {
                    "id": 15816125,
                    "token_id": "79078",
                    "num_sales": 0,
                    "background_color": null,
                    "image_url": "https://lh3.googleusercontent.com/17vU_UNWeMOVi4XOAwo4nvAXpeg1dnKPBk8VnAhJcFHOFZ9UBBvSL5Spj0ytvyfII3rdp4gHMY0mMvbnSzjdOZ0",
                    "image_preview_url": "https://lh3.googleusercontent.com/17vU_UNWeMOVi4XOAwo4nvAXpeg1dnKPBk8VnAhJcFHOFZ9UBBvSL5Spj0ytvyfII3rdp4gHMY0mMvbnSzjdOZ0=s250",
                    "image_thumbnail_url": "https://lh3.googleusercontent.com/17vU_UNWeMOVi4XOAwo4nvAXpeg1dnKPBk8VnAhJcFHOFZ9UBBvSL5Spj0ytvyfII3rdp4gHMY0mMvbnSzjdOZ0=s128",
                    "image_original_url": "https://storage.googleapis.com/opensea-static/custom-fetcher-images/sandbox/land/sandbox-land.png",
                    "animation_url": null,
                    "animation_original_url": null,
                    "name": "LAND (130, -11)",
                    "description": "A LAND is a digital piece of real estate in The Sandbox metaverse that players can buy to build experiences on top of. Once you own a LAND, you will be able to populate it with Games and Assets. Each LAND is a unique (non-fungible) token lying on the public Ethereum blockchain (ERC-721).",
                    "external_link": "https://www.sandbox.game/en/map/?x=130&y=-11",
                    "asset_contract": {
                        "address": "0x50f5474724e0ee42d9a4e711ccfb275809fd6d4a",
                        "asset_contract_type": "non-fungible",
                        "created_date": "2019-12-04T10:58:28.892990",
                        "name": "Sandbox's LANDs",
                        "nft_version": "3.0",
                        "opensea_version": null,
                        "owner": null,
                        "schema_name": "ERC721",
                        "symbol": "",
                        "total_supply": null,
                        "description": "The Sandbox is a community-driven platform where creators can monetize voxel assets and gaming experiences on the blockchain. The Sandbox metaverse comprises a map made up of 166,464 LANDS.  LAND owners can host contests and events, stake SAND to earn and customize assets, monetize assets and experiences, vote in the metaverse governance, play games that you or others create, and more! Trade the collection and keep your eyes peeled for future drops.",
                        "external_link": "https://www.sandbox.game/",
                        "image_url": "https://lh3.googleusercontent.com/SXH8tW1siikB80rwCRnjm1a5xM_MwTg9Xl9Db6mioIk9HIlDM09pVoSR7GKJgS6ulSUpgW9BDtMk_ePX_NKgO9A=s60",
                        "default_to_fiat": false,
                        "dev_buyer_fee_basis_points": 0,
                        "dev_seller_fee_basis_points": 500,
                        "only_proxied_transfers": false,
                        "opensea_buyer_fee_basis_points": 0,
                        "opensea_seller_fee_basis_points": 250,
                        "buyer_fee_basis_points": 0,
                        "seller_fee_basis_points": 750,
                        "payout_address": "0x7a9fe22691c811ea339d9b73150e6911a5343dca"
                    },
                    "owner": {
                        "user": {
                            "username": "REVOLT"
                        },
                        "profile_img_url": "https://storage.googleapis.com/opensea-static/opensea-profile/25.png",
                        "address": "0xb6d820e80a2a7c49f94c9d6c8ea08dccedc9ce4c",
                        "config": "",
                        "discord_id": ""
                    },
                    "permalink": "https://opensea.io/assets/0x50f5474724e0ee42d9a4e711ccfb275809fd6d4a/79078",
                    "collection": {
                        "banner_image_url": "https://lh3.googleusercontent.com/4NQIRoGmzXeXQN4mjuhWuuDZSNW7_BqRXux5upd4Nn_A-bfsGxCnPF8qn98Y6MyHRDPGXIlgfZADcSOe6M2DyrDKXdbdaTgkZN5l=s2500",
                        "chat_url": null,
                        "created_date": "2019-12-04T10:58:29.069907",
                        "default_to_fiat": false,
                        "description": "The Sandbox is a community-driven platform where creators can monetize voxel assets and gaming experiences on the blockchain. The Sandbox metaverse comprises a map made up of 166,464 LANDS.  LAND owners can host contests and events, stake SAND to earn and customize assets, monetize assets and experiences, vote in the metaverse governance, play games that you or others create, and more! Trade the collection and keep your eyes peeled for future drops.",
                        "dev_buyer_fee_basis_points": "0",
                        "dev_seller_fee_basis_points": "500",
                        "discord_url": "https://discord.gg/vAe4zvY",
                        "display_data": {
                            "card_display_style": "contain"
                        },
                        "external_url": "https://www.sandbox.game/",
                        "featured": false,
                        "featured_image_url": "https://storage.googleapis.com/opensea-static/featured-images/sandbox-featured.png",
                        "hidden": false,
                        "safelist_request_status": "verified",
                        "image_url": "https://lh3.googleusercontent.com/SXH8tW1siikB80rwCRnjm1a5xM_MwTg9Xl9Db6mioIk9HIlDM09pVoSR7GKJgS6ulSUpgW9BDtMk_ePX_NKgO9A=s60",
                        "is_subject_to_whitelist": false,
                        "large_image_url": "https://lh3.googleusercontent.com/SXH8tW1siikB80rwCRnjm1a5xM_MwTg9Xl9Db6mioIk9HIlDM09pVoSR7GKJgS6ulSUpgW9BDtMk_ePX_NKgO9A",
                        "medium_username": "sandbox-game",
                        "name": "The Sandbox",
                        "only_proxied_transfers": false,
                        "opensea_buyer_fee_basis_points": "0",
                        "opensea_seller_fee_basis_points": "250",
                        "payout_address": "0x7a9fe22691c811ea339d9b73150e6911a5343dca",
                        "require_email": false,
                        "short_description": null,
                        "slug": "sandbox",
                        "telegram_url": "https://t.me/sandboxgame",
                        "twitter_username": "thesandboxgame",
                        "instagram_username": null,
                        "wiki_url": null
                    },
                    "decimals": null,
                    "token_metadata": null
                },
                {
                    "id": 15816143,
                    "token_id": "79077",
                    "num_sales": 0,
                    "background_color": null,
                    "image_url": "https://lh3.googleusercontent.com/17vU_UNWeMOVi4XOAwo4nvAXpeg1dnKPBk8VnAhJcFHOFZ9UBBvSL5Spj0ytvyfII3rdp4gHMY0mMvbnSzjdOZ0",
                    "image_preview_url": "https://lh3.googleusercontent.com/17vU_UNWeMOVi4XOAwo4nvAXpeg1dnKPBk8VnAhJcFHOFZ9UBBvSL5Spj0ytvyfII3rdp4gHMY0mMvbnSzjdOZ0=s250",
                    "image_thumbnail_url": "https://lh3.googleusercontent.com/17vU_UNWeMOVi4XOAwo4nvAXpeg1dnKPBk8VnAhJcFHOFZ9UBBvSL5Spj0ytvyfII3rdp4gHMY0mMvbnSzjdOZ0=s128",
                    "image_original_url": "https://storage.googleapis.com/opensea-static/custom-fetcher-images/sandbox/land/sandbox-land.png",
                    "animation_url": null,
                    "animation_original_url": null,
                    "name": "LAND (129, -11)",
                    "description": "A LAND is a digital piece of real estate in The Sandbox metaverse that players can buy to build experiences on top of. Once you own a LAND, you will be able to populate it with Games and Assets. Each LAND is a unique (non-fungible) token lying on the public Ethereum blockchain (ERC-721).",
                    "external_link": "https://www.sandbox.game/en/map/?x=129&y=-11",
                    "asset_contract": {
                        "address": "0x50f5474724e0ee42d9a4e711ccfb275809fd6d4a",
                        "asset_contract_type": "non-fungible",
                        "created_date": "2019-12-04T10:58:28.892990",
                        "name": "Sandbox's LANDs",
                        "nft_version": "3.0",
                        "opensea_version": null,
                        "owner": null,
                        "schema_name": "ERC721",
                        "symbol": "",
                        "total_supply": null,
                        "description": "The Sandbox is a community-driven platform where creators can monetize voxel assets and gaming experiences on the blockchain. The Sandbox metaverse comprises a map made up of 166,464 LANDS.  LAND owners can host contests and events, stake SAND to earn and customize assets, monetize assets and experiences, vote in the metaverse governance, play games that you or others create, and more! Trade the collection and keep your eyes peeled for future drops.",
                        "external_link": "https://www.sandbox.game/",
                        "image_url": "https://lh3.googleusercontent.com/SXH8tW1siikB80rwCRnjm1a5xM_MwTg9Xl9Db6mioIk9HIlDM09pVoSR7GKJgS6ulSUpgW9BDtMk_ePX_NKgO9A=s60",
                        "default_to_fiat": false,
                        "dev_buyer_fee_basis_points": 0,
                        "dev_seller_fee_basis_points": 500,
                        "only_proxied_transfers": false,
                        "opensea_buyer_fee_basis_points": 0,
                        "opensea_seller_fee_basis_points": 250,
                        "buyer_fee_basis_points": 0,
                        "seller_fee_basis_points": 750,
                        "payout_address": "0x7a9fe22691c811ea339d9b73150e6911a5343dca"
                    },
                    "owner": {
                        "user": {
                            "username": "REVOLT"
                        },
                        "profile_img_url": "https://storage.googleapis.com/opensea-static/opensea-profile/25.png",
                        "address": "0xb6d820e80a2a7c49f94c9d6c8ea08dccedc9ce4c",
                        "config": "",
                        "discord_id": ""
                    },
                    "permalink": "https://opensea.io/assets/0x50f5474724e0ee42d9a4e711ccfb275809fd6d4a/79077",
                    "collection": {
                        "banner_image_url": "https://lh3.googleusercontent.com/4NQIRoGmzXeXQN4mjuhWuuDZSNW7_BqRXux5upd4Nn_A-bfsGxCnPF8qn98Y6MyHRDPGXIlgfZADcSOe6M2DyrDKXdbdaTgkZN5l=s2500",
                        "chat_url": null,
                        "created_date": "2019-12-04T10:58:29.069907",
                        "default_to_fiat": false,
                        "description": "The Sandbox is a community-driven platform where creators can monetize voxel assets and gaming experiences on the blockchain. The Sandbox metaverse comprises a map made up of 166,464 LANDS.  LAND owners can host contests and events, stake SAND to earn and customize assets, monetize assets and experiences, vote in the metaverse governance, play games that you or others create, and more! Trade the collection and keep your eyes peeled for future drops.",
                        "dev_buyer_fee_basis_points": "0",
                        "dev_seller_fee_basis_points": "500",
                        "discord_url": "https://discord.gg/vAe4zvY",
                        "display_data": {
                            "card_display_style": "contain"
                        },
                        "external_url": "https://www.sandbox.game/",
                        "featured": false,
                        "featured_image_url": "https://storage.googleapis.com/opensea-static/featured-images/sandbox-featured.png",
                        "hidden": false,
                        "safelist_request_status": "verified",
                        "image_url": "https://lh3.googleusercontent.com/SXH8tW1siikB80rwCRnjm1a5xM_MwTg9Xl9Db6mioIk9HIlDM09pVoSR7GKJgS6ulSUpgW9BDtMk_ePX_NKgO9A=s60",
                        "is_subject_to_whitelist": false,
                        "large_image_url": "https://lh3.googleusercontent.com/SXH8tW1siikB80rwCRnjm1a5xM_MwTg9Xl9Db6mioIk9HIlDM09pVoSR7GKJgS6ulSUpgW9BDtMk_ePX_NKgO9A",
                        "medium_username": "sandbox-game",
                        "name": "The Sandbox",
                        "only_proxied_transfers": false,
                        "opensea_buyer_fee_basis_points": "0",
                        "opensea_seller_fee_basis_points": "250",
                        "payout_address": "0x7a9fe22691c811ea339d9b73150e6911a5343dca",
                        "require_email": false,
                        "short_description": null,
                        "slug": "sandbox",
                        "telegram_url": "https://t.me/sandboxgame",
                        "twitter_username": "thesandboxgame",
                        "instagram_username": null,
                        "wiki_url": null
                    },
                    "decimals": null,
                    "token_metadata": null
                },
                {
                    "id": 15816162,
                    "token_id": "79485",
                    "num_sales": 0,
                    "background_color": null,
                    "image_url": "https://storage.opensea.io/files/3faa959fa75531ac7913a9c9f8361b58.png",
                    "image_preview_url": "https://lh3.googleusercontent.com/17vU_UNWeMOVi4XOAwo4nvAXpeg1dnKPBk8VnAhJcFHOFZ9UBBvSL5Spj0ytvyfII3rdp4gHMY0mMvbnSzjdOZ0=s250",
                    "image_thumbnail_url": "https://lh3.googleusercontent.com/17vU_UNWeMOVi4XOAwo4nvAXpeg1dnKPBk8VnAhJcFHOFZ9UBBvSL5Spj0ytvyfII3rdp4gHMY0mMvbnSzjdOZ0=s128",
                    "image_original_url": "https://storage.googleapis.com/opensea-static/custom-fetcher-images/sandbox/land/sandbox-land.png",
                    "animation_url": null,
                    "animation_original_url": null,
                    "name": "LAND (129, -10)",
                    "description": "A LAND is a digital piece of real estate in The Sandbox metaverse that players can buy to build experiences on top of. Once you own a LAND, you will be able to populate it with Games and Assets. Each LAND is a unique (non-fungible) token lying on the public Ethereum blockchain (ERC-721).",
                    "external_link": "https://www.sandbox.game/en/map/?x=129&y=-10",
                    "asset_contract": {
                        "address": "0x50f5474724e0ee42d9a4e711ccfb275809fd6d4a",
                        "asset_contract_type": "non-fungible",
                        "created_date": "2019-12-04T10:58:28.892990",
                        "name": "Sandbox's LANDs",
                        "nft_version": "3.0",
                        "opensea_version": null,
                        "owner": null,
                        "schema_name": "ERC721",
                        "symbol": "",
                        "total_supply": null,
                        "description": "The Sandbox is a community-driven platform where creators can monetize voxel assets and gaming experiences on the blockchain. The Sandbox metaverse comprises a map made up of 166,464 LANDS.  LAND owners can host contests and events, stake SAND to earn and customize assets, monetize assets and experiences, vote in the metaverse governance, play games that you or others create, and more! Trade the collection and keep your eyes peeled for future drops.",
                        "external_link": "https://www.sandbox.game/",
                        "image_url": "https://lh3.googleusercontent.com/SXH8tW1siikB80rwCRnjm1a5xM_MwTg9Xl9Db6mioIk9HIlDM09pVoSR7GKJgS6ulSUpgW9BDtMk_ePX_NKgO9A=s60",
                        "default_to_fiat": false,
                        "dev_buyer_fee_basis_points": 0,
                        "dev_seller_fee_basis_points": 500,
                        "only_proxied_transfers": false,
                        "opensea_buyer_fee_basis_points": 0,
                        "opensea_seller_fee_basis_points": 250,
                        "buyer_fee_basis_points": 0,
                        "seller_fee_basis_points": 750,
                        "payout_address": "0x7a9fe22691c811ea339d9b73150e6911a5343dca"
                    },
                    "owner": {
                        "user": {
                            "username": "REVOLT"
                        },
                        "profile_img_url": "https://storage.googleapis.com/opensea-static/opensea-profile/25.png",
                        "address": "0xb6d820e80a2a7c49f94c9d6c8ea08dccedc9ce4c",
                        "config": "",
                        "discord_id": ""
                    },
                    "permalink": "https://opensea.io/assets/0x50f5474724e0ee42d9a4e711ccfb275809fd6d4a/79485",
                    "collection": {
                        "banner_image_url": "https://lh3.googleusercontent.com/4NQIRoGmzXeXQN4mjuhWuuDZSNW7_BqRXux5upd4Nn_A-bfsGxCnPF8qn98Y6MyHRDPGXIlgfZADcSOe6M2DyrDKXdbdaTgkZN5l=s2500",
                        "chat_url": null,
                        "created_date": "2019-12-04T10:58:29.069907",
                        "default_to_fiat": false,
                        "description": "The Sandbox is a community-driven platform where creators can monetize voxel assets and gaming experiences on the blockchain. The Sandbox metaverse comprises a map made up of 166,464 LANDS.  LAND owners can host contests and events, stake SAND to earn and customize assets, monetize assets and experiences, vote in the metaverse governance, play games that you or others create, and more! Trade the collection and keep your eyes peeled for future drops.",
                        "dev_buyer_fee_basis_points": "0",
                        "dev_seller_fee_basis_points": "500",
                        "discord_url": "https://discord.gg/vAe4zvY",
                        "display_data": {
                            "card_display_style": "contain"
                        },
                        "external_url": "https://www.sandbox.game/",
                        "featured": false,
                        "featured_image_url": "https://storage.googleapis.com/opensea-static/featured-images/sandbox-featured.png",
                        "hidden": false,
                        "safelist_request_status": "verified",
                        "image_url": "https://lh3.googleusercontent.com/SXH8tW1siikB80rwCRnjm1a5xM_MwTg9Xl9Db6mioIk9HIlDM09pVoSR7GKJgS6ulSUpgW9BDtMk_ePX_NKgO9A=s60",
                        "is_subject_to_whitelist": false,
                        "large_image_url": "https://lh3.googleusercontent.com/SXH8tW1siikB80rwCRnjm1a5xM_MwTg9Xl9Db6mioIk9HIlDM09pVoSR7GKJgS6ulSUpgW9BDtMk_ePX_NKgO9A",
                        "medium_username": "sandbox-game",
                        "name": "The Sandbox",
                        "only_proxied_transfers": false,
                        "opensea_buyer_fee_basis_points": "0",
                        "opensea_seller_fee_basis_points": "250",
                        "payout_address": "0x7a9fe22691c811ea339d9b73150e6911a5343dca",
                        "require_email": false,
                        "short_description": null,
                        "slug": "sandbox",
                        "telegram_url": "https://t.me/sandboxgame",
                        "twitter_username": "thesandboxgame",
                        "instagram_username": null,
                        "wiki_url": null
                    },
                    "decimals": null,
                    "token_metadata": null
                },
                {
                    "id": 15816180,
                    "token_id": "79486",
                    "num_sales": 0,
                    "background_color": null,
                    "image_url": "https://storage.opensea.io/files/3faa959fa75531ac7913a9c9f8361b58.png",
                    "image_preview_url": "https://lh3.googleusercontent.com/17vU_UNWeMOVi4XOAwo4nvAXpeg1dnKPBk8VnAhJcFHOFZ9UBBvSL5Spj0ytvyfII3rdp4gHMY0mMvbnSzjdOZ0=s250",
                    "image_thumbnail_url": "https://lh3.googleusercontent.com/17vU_UNWeMOVi4XOAwo4nvAXpeg1dnKPBk8VnAhJcFHOFZ9UBBvSL5Spj0ytvyfII3rdp4gHMY0mMvbnSzjdOZ0=s128",
                    "image_original_url": "https://storage.googleapis.com/opensea-static/custom-fetcher-images/sandbox/land/sandbox-land.png",
                    "animation_url": null,
                    "animation_original_url": null,
                    "name": "LAND (130, -10)",
                    "description": "A LAND is a digital piece of real estate in The Sandbox metaverse that players can buy to build experiences on top of. Once you own a LAND, you will be able to populate it with Games and Assets. Each LAND is a unique (non-fungible) token lying on the public Ethereum blockchain (ERC-721).",
                    "external_link": "https://www.sandbox.game/en/map/?x=130&y=-10",
                    "asset_contract": {
                        "address": "0x50f5474724e0ee42d9a4e711ccfb275809fd6d4a",
                        "asset_contract_type": "non-fungible",
                        "created_date": "2019-12-04T10:58:28.892990",
                        "name": "Sandbox's LANDs",
                        "nft_version": "3.0",
                        "opensea_version": null,
                        "owner": null,
                        "schema_name": "ERC721",
                        "symbol": "",
                        "total_supply": null,
                        "description": "The Sandbox is a community-driven platform where creators can monetize voxel assets and gaming experiences on the blockchain. The Sandbox metaverse comprises a map made up of 166,464 LANDS.  LAND owners can host contests and events, stake SAND to earn and customize assets, monetize assets and experiences, vote in the metaverse governance, play games that you or others create, and more! Trade the collection and keep your eyes peeled for future drops.",
                        "external_link": "https://www.sandbox.game/",
                        "image_url": "https://lh3.googleusercontent.com/SXH8tW1siikB80rwCRnjm1a5xM_MwTg9Xl9Db6mioIk9HIlDM09pVoSR7GKJgS6ulSUpgW9BDtMk_ePX_NKgO9A=s60",
                        "default_to_fiat": false,
                        "dev_buyer_fee_basis_points": 0,
                        "dev_seller_fee_basis_points": 500,
                        "only_proxied_transfers": false,
                        "opensea_buyer_fee_basis_points": 0,
                        "opensea_seller_fee_basis_points": 250,
                        "buyer_fee_basis_points": 0,
                        "seller_fee_basis_points": 750,
                        "payout_address": "0x7a9fe22691c811ea339d9b73150e6911a5343dca"
                    },
                    "owner": {
                        "user": {
                            "username": "REVOLT"
                        },
                        "profile_img_url": "https://storage.googleapis.com/opensea-static/opensea-profile/25.png",
                        "address": "0xb6d820e80a2a7c49f94c9d6c8ea08dccedc9ce4c",
                        "config": "",
                        "discord_id": ""
                    },
                    "permalink": "https://opensea.io/assets/0x50f5474724e0ee42d9a4e711ccfb275809fd6d4a/79486",
                    "collection": {
                        "banner_image_url": "https://lh3.googleusercontent.com/4NQIRoGmzXeXQN4mjuhWuuDZSNW7_BqRXux5upd4Nn_A-bfsGxCnPF8qn98Y6MyHRDPGXIlgfZADcSOe6M2DyrDKXdbdaTgkZN5l=s2500",
                        "chat_url": null,
                        "created_date": "2019-12-04T10:58:29.069907",
                        "default_to_fiat": false,
                        "description": "The Sandbox is a community-driven platform where creators can monetize voxel assets and gaming experiences on the blockchain. The Sandbox metaverse comprises a map made up of 166,464 LANDS.  LAND owners can host contests and events, stake SAND to earn and customize assets, monetize assets and experiences, vote in the metaverse governance, play games that you or others create, and more! Trade the collection and keep your eyes peeled for future drops.",
                        "dev_buyer_fee_basis_points": "0",
                        "dev_seller_fee_basis_points": "500",
                        "discord_url": "https://discord.gg/vAe4zvY",
                        "display_data": {
                            "card_display_style": "contain"
                        },
                        "external_url": "https://www.sandbox.game/",
                        "featured": false,
                        "featured_image_url": "https://storage.googleapis.com/opensea-static/featured-images/sandbox-featured.png",
                        "hidden": false,
                        "safelist_request_status": "verified",
                        "image_url": "https://lh3.googleusercontent.com/SXH8tW1siikB80rwCRnjm1a5xM_MwTg9Xl9Db6mioIk9HIlDM09pVoSR7GKJgS6ulSUpgW9BDtMk_ePX_NKgO9A=s60",
                        "is_subject_to_whitelist": false,
                        "large_image_url": "https://lh3.googleusercontent.com/SXH8tW1siikB80rwCRnjm1a5xM_MwTg9Xl9Db6mioIk9HIlDM09pVoSR7GKJgS6ulSUpgW9BDtMk_ePX_NKgO9A",
                        "medium_username": "sandbox-game",
                        "name": "The Sandbox",
                        "only_proxied_transfers": false,
                        "opensea_buyer_fee_basis_points": "0",
                        "opensea_seller_fee_basis_points": "250",
                        "payout_address": "0x7a9fe22691c811ea339d9b73150e6911a5343dca",
                        "require_email": false,
                        "short_description": null,
                        "slug": "sandbox",
                        "telegram_url": "https://t.me/sandboxgame",
                        "twitter_username": "thesandboxgame",
                        "instagram_username": null,
                        "wiki_url": null
                    },
                    "decimals": null,
                    "token_metadata": null
                },
                {
                    "id": 15816205,
                    "token_id": "79487",
                    "num_sales": 0,
                    "background_color": null,
                    "image_url": "https://lh3.googleusercontent.com/17vU_UNWeMOVi4XOAwo4nvAXpeg1dnKPBk8VnAhJcFHOFZ9UBBvSL5Spj0ytvyfII3rdp4gHMY0mMvbnSzjdOZ0",
                    "image_preview_url": "https://lh3.googleusercontent.com/17vU_UNWeMOVi4XOAwo4nvAXpeg1dnKPBk8VnAhJcFHOFZ9UBBvSL5Spj0ytvyfII3rdp4gHMY0mMvbnSzjdOZ0=s250",
                    "image_thumbnail_url": "https://lh3.googleusercontent.com/17vU_UNWeMOVi4XOAwo4nvAXpeg1dnKPBk8VnAhJcFHOFZ9UBBvSL5Spj0ytvyfII3rdp4gHMY0mMvbnSzjdOZ0=s128",
                    "image_original_url": "https://storage.googleapis.com/opensea-static/custom-fetcher-images/sandbox/land/sandbox-land.png",
                    "animation_url": null,
                    "animation_original_url": null,
                    "name": "LAND (131, -10)",
                    "description": "A LAND is a digital piece of real estate in The Sandbox metaverse that players can buy to build experiences on top of. Once you own a LAND, you will be able to populate it with Games and Assets. Each LAND is a unique (non-fungible) token lying on the public Ethereum blockchain (ERC-721).",
                    "external_link": "https://www.sandbox.game/en/map/?x=131&y=-10",
                    "asset_contract": {
                        "address": "0x50f5474724e0ee42d9a4e711ccfb275809fd6d4a",
                        "asset_contract_type": "non-fungible",
                        "created_date": "2019-12-04T10:58:28.892990",
                        "name": "Sandbox's LANDs",
                        "nft_version": "3.0",
                        "opensea_version": null,
                        "owner": null,
                        "schema_name": "ERC721",
                        "symbol": "",
                        "total_supply": null,
                        "description": "The Sandbox is a community-driven platform where creators can monetize voxel assets and gaming experiences on the blockchain. The Sandbox metaverse comprises a map made up of 166,464 LANDS.  LAND owners can host contests and events, stake SAND to earn and customize assets, monetize assets and experiences, vote in the metaverse governance, play games that you or others create, and more! Trade the collection and keep your eyes peeled for future drops.",
                        "external_link": "https://www.sandbox.game/",
                        "image_url": "https://lh3.googleusercontent.com/SXH8tW1siikB80rwCRnjm1a5xM_MwTg9Xl9Db6mioIk9HIlDM09pVoSR7GKJgS6ulSUpgW9BDtMk_ePX_NKgO9A=s60",
                        "default_to_fiat": false,
                        "dev_buyer_fee_basis_points": 0,
                        "dev_seller_fee_basis_points": 500,
                        "only_proxied_transfers": false,
                        "opensea_buyer_fee_basis_points": 0,
                        "opensea_seller_fee_basis_points": 250,
                        "buyer_fee_basis_points": 0,
                        "seller_fee_basis_points": 750,
                        "payout_address": "0x7a9fe22691c811ea339d9b73150e6911a5343dca"
                    },
                    "owner": {
                        "user": {
                            "username": "REVOLT"
                        },
                        "profile_img_url": "https://storage.googleapis.com/opensea-static/opensea-profile/25.png",
                        "address": "0xb6d820e80a2a7c49f94c9d6c8ea08dccedc9ce4c",
                        "config": "",
                        "discord_id": ""
                    },
                    "permalink": "https://opensea.io/assets/0x50f5474724e0ee42d9a4e711ccfb275809fd6d4a/79487",
                    "collection": {
                        "banner_image_url": "https://lh3.googleusercontent.com/4NQIRoGmzXeXQN4mjuhWuuDZSNW7_BqRXux5upd4Nn_A-bfsGxCnPF8qn98Y6MyHRDPGXIlgfZADcSOe6M2DyrDKXdbdaTgkZN5l=s2500",
                        "chat_url": null,
                        "created_date": "2019-12-04T10:58:29.069907",
                        "default_to_fiat": false,
                        "description": "The Sandbox is a community-driven platform where creators can monetize voxel assets and gaming experiences on the blockchain. The Sandbox metaverse comprises a map made up of 166,464 LANDS.  LAND owners can host contests and events, stake SAND to earn and customize assets, monetize assets and experiences, vote in the metaverse governance, play games that you or others create, and more! Trade the collection and keep your eyes peeled for future drops.",
                        "dev_buyer_fee_basis_points": "0",
                        "dev_seller_fee_basis_points": "500",
                        "discord_url": "https://discord.gg/vAe4zvY",
                        "display_data": {
                            "card_display_style": "contain"
                        },
                        "external_url": "https://www.sandbox.game/",
                        "featured": false,
                        "featured_image_url": "https://storage.googleapis.com/opensea-static/featured-images/sandbox-featured.png",
                        "hidden": false,
                        "safelist_request_status": "verified",
                        "image_url": "https://lh3.googleusercontent.com/SXH8tW1siikB80rwCRnjm1a5xM_MwTg9Xl9Db6mioIk9HIlDM09pVoSR7GKJgS6ulSUpgW9BDtMk_ePX_NKgO9A=s60",
                        "is_subject_to_whitelist": false,
                        "large_image_url": "https://lh3.googleusercontent.com/SXH8tW1siikB80rwCRnjm1a5xM_MwTg9Xl9Db6mioIk9HIlDM09pVoSR7GKJgS6ulSUpgW9BDtMk_ePX_NKgO9A",
                        "medium_username": "sandbox-game",
                        "name": "The Sandbox",
                        "only_proxied_transfers": false,
                        "opensea_buyer_fee_basis_points": "0",
                        "opensea_seller_fee_basis_points": "250",
                        "payout_address": "0x7a9fe22691c811ea339d9b73150e6911a5343dca",
                        "require_email": false,
                        "short_description": null,
                        "slug": "sandbox",
                        "telegram_url": "https://t.me/sandboxgame",
                        "twitter_username": "thesandboxgame",
                        "instagram_username": null,
                        "wiki_url": null
                    },
                    "decimals": null,
                    "token_metadata": null
                }
            ],
            "name": "Small estate (9 lands)",
            "description": "Yes, you can afford it :o))",
            "external_link": "",
            "asset_contract": {
                "collection": {
                    "banner_image_url": "https://lh3.googleusercontent.com/4NQIRoGmzXeXQN4mjuhWuuDZSNW7_BqRXux5upd4Nn_A-bfsGxCnPF8qn98Y6MyHRDPGXIlgfZADcSOe6M2DyrDKXdbdaTgkZN5l=s2500",
                    "chat_url": null,
                    "created_date": "2019-12-04T10:58:29.069907",
                    "default_to_fiat": false,
                    "description": "The Sandbox is a community-driven platform where creators can monetize voxel assets and gaming experiences on the blockchain. The Sandbox metaverse comprises a map made up of 166,464 LANDS.  LAND owners can host contests and events, stake SAND to earn and customize assets, monetize assets and experiences, vote in the metaverse governance, play games that you or others create, and more! Trade the collection and keep your eyes peeled for future drops.",
                    "dev_buyer_fee_basis_points": "0",
                    "dev_seller_fee_basis_points": "500",
                    "discord_url": "https://discord.gg/vAe4zvY",
                    "display_data": {
                        "card_display_style": "contain"
                    },
                    "external_url": "https://www.sandbox.game/",
                    "featured": false,
                    "featured_image_url": "https://storage.googleapis.com/opensea-static/featured-images/sandbox-featured.png",
                    "hidden": false,
                    "safelist_request_status": "verified",
                    "image_url": "https://lh3.googleusercontent.com/SXH8tW1siikB80rwCRnjm1a5xM_MwTg9Xl9Db6mioIk9HIlDM09pVoSR7GKJgS6ulSUpgW9BDtMk_ePX_NKgO9A=s60",
                    "is_subject_to_whitelist": false,
                    "large_image_url": "https://lh3.googleusercontent.com/SXH8tW1siikB80rwCRnjm1a5xM_MwTg9Xl9Db6mioIk9HIlDM09pVoSR7GKJgS6ulSUpgW9BDtMk_ePX_NKgO9A",
                    "medium_username": "sandbox-game",
                    "name": "The Sandbox",
                    "only_proxied_transfers": false,
                    "opensea_buyer_fee_basis_points": "0",
                    "opensea_seller_fee_basis_points": "250",
                    "payout_address": "0x7a9fe22691c811ea339d9b73150e6911a5343dca",
                    "require_email": false,
                    "short_description": null,
                    "slug": "sandbox",
                    "telegram_url": "https://t.me/sandboxgame",
                    "twitter_username": "thesandboxgame",
                    "instagram_username": null,
                    "wiki_url": null
                },
                "address": "0x50f5474724e0ee42d9a4e711ccfb275809fd6d4a",
                "asset_contract_type": "non-fungible",
                "created_date": "2019-12-04T10:58:28.892990",
                "name": "Sandbox's LANDs",
                "nft_version": "3.0",
                "opensea_version": null,
                "owner": null,
                "schema_name": "ERC721",
                "symbol": "",
                "total_supply": null,
                "description": "The Sandbox is a community-driven platform where creators can monetize voxel assets and gaming experiences on the blockchain. The Sandbox metaverse comprises a map made up of 166,464 LANDS.  LAND owners can host contests and events, stake SAND to earn and customize assets, monetize assets and experiences, vote in the metaverse governance, play games that you or others create, and more! Trade the collection and keep your eyes peeled for future drops.",
                "external_link": "https://www.sandbox.game/",
                "image_url": "https://lh3.googleusercontent.com/SXH8tW1siikB80rwCRnjm1a5xM_MwTg9Xl9Db6mioIk9HIlDM09pVoSR7GKJgS6ulSUpgW9BDtMk_ePX_NKgO9A=s60",
                "default_to_fiat": false,
                "dev_buyer_fee_basis_points": 0,
                "dev_seller_fee_basis_points": 500,
                "only_proxied_transfers": false,
                "opensea_buyer_fee_basis_points": 0,
                "opensea_seller_fee_basis_points": 250,
                "buyer_fee_basis_points": 0,
                "seller_fee_basis_points": 750,
                "payout_address": "0x7a9fe22691c811ea339d9b73150e6911a5343dca"
            },
            "permalink": "https://opensea.io/bundles/small-estate-9-lands-nPR",
            "sell_orders": [
                {
                    "created_date": "2021-05-25T21:58:49.110858",
                    "closing_date": null,
                    "closing_extendable": false,
                    "expiration_time": 0,
                    "listing_time": 1621979823,
                    "order_hash": "0x37090851f37106bb3d5dbad776b199a523fb4da7177f45aed1222d0f7c1ab4db",
                    "metadata": {
                        "bundle": {
                            "assets": [
                                {
                                    "id": "78669",
                                    "address": "0x50f5474724e0ee42d9a4e711ccfb275809fd6d4a"
                                },
                                {
                                    "id": "78670",
                                    "address": "0x50f5474724e0ee42d9a4e711ccfb275809fd6d4a"
                                },
                                {
                                    "id": "78671",
                                    "address": "0x50f5474724e0ee42d9a4e711ccfb275809fd6d4a"
                                },
                                {
                                    "id": "79077",
                                    "address": "0x50f5474724e0ee42d9a4e711ccfb275809fd6d4a"
                                },
                                {
                                    "id": "79078",
                                    "address": "0x50f5474724e0ee42d9a4e711ccfb275809fd6d4a"
                                },
                                {
                                    "id": "79079",
                                    "address": "0x50f5474724e0ee42d9a4e711ccfb275809fd6d4a"
                                },
                                {
                                    "id": "79485",
                                    "address": "0x50f5474724e0ee42d9a4e711ccfb275809fd6d4a"
                                },
                                {
                                    "id": "79486",
                                    "address": "0x50f5474724e0ee42d9a4e711ccfb275809fd6d4a"
                                },
                                {
                                    "id": "79487",
                                    "address": "0x50f5474724e0ee42d9a4e711ccfb275809fd6d4a"
                                }
                            ],
                            "schemas": [
                                "ERC721",
                                "ERC721",
                                "ERC721",
                                "ERC721",
                                "ERC721",
                                "ERC721",
                                "ERC721",
                                "ERC721",
                                "ERC721"
                            ],
                            "name": "Small estate (9 lands)",
                            "description": "Yes, you can afford it :o))",
                            "external_link": ""
                        }
                    },
                    "exchange": "0x7be8076f4ea4a4ad08075c2508e481d6c946d12b",
                    "maker": {
                        "user": 3797,
                        "profile_img_url": "https://storage.googleapis.com/opensea-static/opensea-profile/25.png",
                        "address": "0xb6d820e80a2a7c49f94c9d6c8ea08dccedc9ce4c",
                        "config": "",
                        "discord_id": ""
                    },
                    "taker": {
                        "user": 1766,
                        "profile_img_url": "https://storage.googleapis.com/opensea-static/opensea-profile/1.png",
                        "address": "0x0000000000000000000000000000000000000000",
                        "config": "",
                        "discord_id": ""
                    },
                    "current_price": "135000000000000000000",
                    "current_bounty": "1350000000000000000",
                    "bounty_multiple": "0.01",
                    "maker_relayer_fee": "750",
                    "taker_relayer_fee": "0",
                    "maker_protocol_fee": "0",
                    "taker_protocol_fee": "0",
                    "maker_referrer_fee": "0",
                    "fee_recipient": {
                        "user": 3585,
                        "profile_img_url": "https://storage.googleapis.com/opensea-static/opensea-profile/28.png",
                        "address": "0x5b3256965e7c3cf26e11fcaf296dfc8807c01073",
                        "config": "verified",
                        "discord_id": ""
                    },
                    "fee_method": 1,
                    "side": 1,
                    "sale_kind": 0,
                    "target": "0xc99f70bfd82fb7c8f8191fdfbfb735606b15e5c5",
                    "how_to_call": 1,
                    "calldata": "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",
                    "replacement_pattern": "0x0000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000ffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffff0000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000ffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffff0000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000ffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffff0000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000ffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffff0000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000ffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffff0000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000ffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffff0000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000ffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffff0000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000ffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffff0000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000ffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffff000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000",
                    "static_target": "0x0000000000000000000000000000000000000000",
                    "static_extradata": "0x",
                    "payment_token": "0x0000000000000000000000000000000000000000",
                    "payment_token_contract": {
                        "id": 1,
                        "symbol": "ETH",
                        "address": "0x0000000000000000000000000000000000000000",
                        "image_url": "https://storage.opensea.io/files/6f8e2979d428180222796ff4a33ab929.svg",
                        "name": "Ether",
                        "decimals": 18,
                        "eth_price": "1.000000000000000",
                        "usd_price": "2625.730000000000018000"
                    },
                    "base_price": "135000000000000000000",
                    "extra": "0",
                    "quantity": "1",
                    "salt": "62800900807006212321066508600418535886256898269168420278218553121036263122204",
                    "v": 28,
                    "r": "0xc751413c16ac2c2f45e209742ac7f5d15f6ecf7e166d4c46640d1ff3f427f3b1",
                    "s": "0x12744dc64405424357be024a21e0bbe3dc483db76eb1abc451148da78b9a110c",
                    "approved_on_chain": false,
                    "cancelled": false,
                    "finalized": false,
                    "marked_invalid": false,
                    "prefixed_hash": "0x1950c54d8ea3edbb7a8d1f758c4c60c339fb9d2d2785e88f812ed8e31246c1d2"
                }
            ]
        },
        {
            "maker": {
                "user": {
                    "username": "technoutopian"
                },
                "profile_img_url": "https://storage.googleapis.com/opensea-static/opensea-profile/10.png",
                "address": "0xfb42a0604abb3d0f9816599726b3a83ee3157080",
                "config": "",
                "discord_id": ""
            },
            "slug": "2-rare-2-unique-1-of-a-kind-2-common-custom-fr-p4i",
            "assets": [
                {
                    "id": 19696780,
                    "token_id": "113648243776115738426758665575596648452024402290209527738771755340345156567045",
                    "num_sales": 0,
                    "background_color": null,
                    "image_url": "https://lh3.googleusercontent.com/VbSJfyzP80wmpRd9nmUpdnhnB_XfgE6L5MYB6zM167v7mzTpsU729fbj2duJT-RZfB9xKUDMUViWpzcycJxY9VbWKzQf4k9AXvuhzw",
                    "image_preview_url": "https://lh3.googleusercontent.com/VbSJfyzP80wmpRd9nmUpdnhnB_XfgE6L5MYB6zM167v7mzTpsU729fbj2duJT-RZfB9xKUDMUViWpzcycJxY9VbWKzQf4k9AXvuhzw=s250",
                    "image_thumbnail_url": "https://lh3.googleusercontent.com/VbSJfyzP80wmpRd9nmUpdnhnB_XfgE6L5MYB6zM167v7mzTpsU729fbj2duJT-RZfB9xKUDMUViWpzcycJxY9VbWKzQf4k9AXvuhzw=s128",
                    "image_original_url": null,
                    "animation_url": null,
                    "animation_original_url": null,
                    "name": "Dmntn",
                    "description": "Creative yet subtle awesomeness.",
                    "external_link": null,
                    "asset_contract": {
                        "address": "0x495f947276749ce646f68ac8c248420045cb7b5e",
                        "asset_contract_type": "semi-fungible",
                        "created_date": "2020-12-02T17:40:53.232025",
                        "name": "OpenSea Collection",
                        "nft_version": null,
                        "opensea_version": "2.0.0",
                        "owner": 102384,
                        "schema_name": "ERC1155",
                        "symbol": "OPENSTORE",
                        "total_supply": null,
                        "description": null,
                        "external_link": null,
                        "image_url": null,
                        "default_to_fiat": false,
                        "dev_buyer_fee_basis_points": 0,
                        "dev_seller_fee_basis_points": 0,
                        "only_proxied_transfers": false,
                        "opensea_buyer_fee_basis_points": 0,
                        "opensea_seller_fee_basis_points": 250,
                        "buyer_fee_basis_points": 0,
                        "seller_fee_basis_points": 250,
                        "payout_address": null
                    },
                    "owner": {
                        "user": {
                            "username": "NullAddress"
                        },
                        "profile_img_url": "https://storage.googleapis.com/opensea-static/opensea-profile/1.png",
                        "address": "0x0000000000000000000000000000000000000000",
                        "config": "",
                        "discord_id": ""
                    },
                    "permalink": "https://opensea.io/assets/0x495f947276749ce646f68ac8c248420045cb7b5e/113648243776115738426758665575596648452024402290209527738771755340345156567045",
                    "collection": {
                        "banner_image_url": "https://lh3.googleusercontent.com/L-xLG0HdPyOGviXrpRlEgwRAowLhugK9quRi17XUTvSYGilzzTIbVeVVs9K-kvmSs71_A0rD_mFCs1EtDUkhSZUeuBJvJvHGtSK6ag=s2500",
                        "chat_url": null,
                        "created_date": "2021-03-15T23:32:58.619445",
                        "default_to_fiat": false,
                        "description": "",
                        "dev_buyer_fee_basis_points": "0",
                        "dev_seller_fee_basis_points": "500",
                        "discord_url": null,
                        "display_data": {
                            "card_display_style": "contain"
                        },
                        "external_url": null,
                        "featured": false,
                        "featured_image_url": "https://lh3.googleusercontent.com/56JQcU5rn8LqorIhmoxBdf7xTvl6qNNA1aEnDnisJB5wxa18kF6P4YrUtYKGjH2arIUlYNHYgEK7XVNlFtxCIF72UL46zc2BCuY=s300",
                        "hidden": true,
                        "safelist_request_status": "not_requested",
                        "image_url": "https://lh3.googleusercontent.com/56JQcU5rn8LqorIhmoxBdf7xTvl6qNNA1aEnDnisJB5wxa18kF6P4YrUtYKGjH2arIUlYNHYgEK7XVNlFtxCIF72UL46zc2BCuY=s120",
                        "is_subject_to_whitelist": false,
                        "large_image_url": "https://lh3.googleusercontent.com/56JQcU5rn8LqorIhmoxBdf7xTvl6qNNA1aEnDnisJB5wxa18kF6P4YrUtYKGjH2arIUlYNHYgEK7XVNlFtxCIF72UL46zc2BCuY=s300",
                        "medium_username": null,
                        "name": "CoolZer0",
                        "only_proxied_transfers": false,
                        "opensea_buyer_fee_basis_points": "0",
                        "opensea_seller_fee_basis_points": "250",
                        "payout_address": "0xfb42a0604abb3d0f9816599726b3a83ee3157080",
                        "require_email": false,
                        "short_description": null,
                        "slug": "coolzer0",
                        "telegram_url": null,
                        "twitter_username": null,
                        "instagram_username": null,
                        "wiki_url": null
                    },
                    "decimals": null,
                    "token_metadata": null
                },
                {
                    "id": 19702791,
                    "token_id": "113648243776115738426758665575596648452024402290209527738771755341444668194817",
                    "num_sales": 0,
                    "background_color": null,
                    "image_url": "https://lh3.googleusercontent.com/56JQcU5rn8LqorIhmoxBdf7xTvl6qNNA1aEnDnisJB5wxa18kF6P4YrUtYKGjH2arIUlYNHYgEK7XVNlFtxCIF72UL46zc2BCuY",
                    "image_preview_url": "https://lh3.googleusercontent.com/56JQcU5rn8LqorIhmoxBdf7xTvl6qNNA1aEnDnisJB5wxa18kF6P4YrUtYKGjH2arIUlYNHYgEK7XVNlFtxCIF72UL46zc2BCuY=s250",
                    "image_thumbnail_url": "https://lh3.googleusercontent.com/56JQcU5rn8LqorIhmoxBdf7xTvl6qNNA1aEnDnisJB5wxa18kF6P4YrUtYKGjH2arIUlYNHYgEK7XVNlFtxCIF72UL46zc2BCuY=s128",
                    "image_original_url": null,
                    "animation_url": null,
                    "animation_original_url": null,
                    "name": "Flight",
                    "description": "A flower? A bird? Jellyfish? We've heard everything. It is whatever you decide it is. One of a Kind. ",
                    "external_link": null,
                    "asset_contract": {
                        "address": "0x495f947276749ce646f68ac8c248420045cb7b5e",
                        "asset_contract_type": "semi-fungible",
                        "created_date": "2020-12-02T17:40:53.232025",
                        "name": "OpenSea Collection",
                        "nft_version": null,
                        "opensea_version": "2.0.0",
                        "owner": 102384,
                        "schema_name": "ERC1155",
                        "symbol": "OPENSTORE",
                        "total_supply": null,
                        "description": null,
                        "external_link": null,
                        "image_url": null,
                        "default_to_fiat": false,
                        "dev_buyer_fee_basis_points": 0,
                        "dev_seller_fee_basis_points": 0,
                        "only_proxied_transfers": false,
                        "opensea_buyer_fee_basis_points": 0,
                        "opensea_seller_fee_basis_points": 250,
                        "buyer_fee_basis_points": 0,
                        "seller_fee_basis_points": 250,
                        "payout_address": null
                    },
                    "owner": {
                        "user": {
                            "username": "NullAddress"
                        },
                        "profile_img_url": "https://storage.googleapis.com/opensea-static/opensea-profile/1.png",
                        "address": "0x0000000000000000000000000000000000000000",
                        "config": "",
                        "discord_id": ""
                    },
                    "permalink": "https://opensea.io/assets/0x495f947276749ce646f68ac8c248420045cb7b5e/113648243776115738426758665575596648452024402290209527738771755341444668194817",
                    "collection": {
                        "banner_image_url": "https://lh3.googleusercontent.com/L-xLG0HdPyOGviXrpRlEgwRAowLhugK9quRi17XUTvSYGilzzTIbVeVVs9K-kvmSs71_A0rD_mFCs1EtDUkhSZUeuBJvJvHGtSK6ag=s2500",
                        "chat_url": null,
                        "created_date": "2021-03-15T23:32:58.619445",
                        "default_to_fiat": false,
                        "description": "",
                        "dev_buyer_fee_basis_points": "0",
                        "dev_seller_fee_basis_points": "500",
                        "discord_url": null,
                        "display_data": {
                            "card_display_style": "contain"
                        },
                        "external_url": null,
                        "featured": false,
                        "featured_image_url": "https://lh3.googleusercontent.com/56JQcU5rn8LqorIhmoxBdf7xTvl6qNNA1aEnDnisJB5wxa18kF6P4YrUtYKGjH2arIUlYNHYgEK7XVNlFtxCIF72UL46zc2BCuY=s300",
                        "hidden": true,
                        "safelist_request_status": "not_requested",
                        "image_url": "https://lh3.googleusercontent.com/56JQcU5rn8LqorIhmoxBdf7xTvl6qNNA1aEnDnisJB5wxa18kF6P4YrUtYKGjH2arIUlYNHYgEK7XVNlFtxCIF72UL46zc2BCuY=s120",
                        "is_subject_to_whitelist": false,
                        "large_image_url": "https://lh3.googleusercontent.com/56JQcU5rn8LqorIhmoxBdf7xTvl6qNNA1aEnDnisJB5wxa18kF6P4YrUtYKGjH2arIUlYNHYgEK7XVNlFtxCIF72UL46zc2BCuY=s300",
                        "medium_username": null,
                        "name": "CoolZer0",
                        "only_proxied_transfers": false,
                        "opensea_buyer_fee_basis_points": "0",
                        "opensea_seller_fee_basis_points": "250",
                        "payout_address": "0xfb42a0604abb3d0f9816599726b3a83ee3157080",
                        "require_email": false,
                        "short_description": null,
                        "slug": "coolzer0",
                        "telegram_url": null,
                        "twitter_username": null,
                        "instagram_username": null,
                        "wiki_url": null
                    },
                    "decimals": null,
                    "token_metadata": null
                },
                {
                    "id": 19703831,
                    "token_id": "113648243776115738426758665575596648452024402290209527738771755342544179822602",
                    "num_sales": 0,
                    "background_color": null,
                    "image_url": "https://lh3.googleusercontent.com/aaZy08Ik5MDrRijdyO4kgGhy_FOlpJkL2X0QKXn0IZSaF4kLOpsgXlOFdUhwMfRSzwjXbxCzrq5AY_-vC3Ql0DCVP_8HQxdJ5gMf",
                    "image_preview_url": "https://lh3.googleusercontent.com/aaZy08Ik5MDrRijdyO4kgGhy_FOlpJkL2X0QKXn0IZSaF4kLOpsgXlOFdUhwMfRSzwjXbxCzrq5AY_-vC3Ql0DCVP_8HQxdJ5gMf=s250",
                    "image_thumbnail_url": "https://lh3.googleusercontent.com/aaZy08Ik5MDrRijdyO4kgGhy_FOlpJkL2X0QKXn0IZSaF4kLOpsgXlOFdUhwMfRSzwjXbxCzrq5AY_-vC3Ql0DCVP_8HQxdJ5gMf=s128",
                    "image_original_url": null,
                    "animation_url": null,
                    "animation_original_url": null,
                    "name": "Surfant",
                    "description": "My ship took me to an alien terrain. Are we welcome here?",
                    "external_link": null,
                    "asset_contract": {
                        "address": "0x495f947276749ce646f68ac8c248420045cb7b5e",
                        "asset_contract_type": "semi-fungible",
                        "created_date": "2020-12-02T17:40:53.232025",
                        "name": "OpenSea Collection",
                        "nft_version": null,
                        "opensea_version": "2.0.0",
                        "owner": 102384,
                        "schema_name": "ERC1155",
                        "symbol": "OPENSTORE",
                        "total_supply": null,
                        "description": null,
                        "external_link": null,
                        "image_url": null,
                        "default_to_fiat": false,
                        "dev_buyer_fee_basis_points": 0,
                        "dev_seller_fee_basis_points": 0,
                        "only_proxied_transfers": false,
                        "opensea_buyer_fee_basis_points": 0,
                        "opensea_seller_fee_basis_points": 250,
                        "buyer_fee_basis_points": 0,
                        "seller_fee_basis_points": 250,
                        "payout_address": null
                    },
                    "owner": {
                        "user": {
                            "username": "NullAddress"
                        },
                        "profile_img_url": "https://storage.googleapis.com/opensea-static/opensea-profile/1.png",
                        "address": "0x0000000000000000000000000000000000000000",
                        "config": "",
                        "discord_id": ""
                    },
                    "permalink": "https://opensea.io/assets/0x495f947276749ce646f68ac8c248420045cb7b5e/113648243776115738426758665575596648452024402290209527738771755342544179822602",
                    "collection": {
                        "banner_image_url": "https://lh3.googleusercontent.com/L-xLG0HdPyOGviXrpRlEgwRAowLhugK9quRi17XUTvSYGilzzTIbVeVVs9K-kvmSs71_A0rD_mFCs1EtDUkhSZUeuBJvJvHGtSK6ag=s2500",
                        "chat_url": null,
                        "created_date": "2021-03-15T23:32:58.619445",
                        "default_to_fiat": false,
                        "description": "",
                        "dev_buyer_fee_basis_points": "0",
                        "dev_seller_fee_basis_points": "500",
                        "discord_url": null,
                        "display_data": {
                            "card_display_style": "contain"
                        },
                        "external_url": null,
                        "featured": false,
                        "featured_image_url": "https://lh3.googleusercontent.com/56JQcU5rn8LqorIhmoxBdf7xTvl6qNNA1aEnDnisJB5wxa18kF6P4YrUtYKGjH2arIUlYNHYgEK7XVNlFtxCIF72UL46zc2BCuY=s300",
                        "hidden": true,
                        "safelist_request_status": "not_requested",
                        "image_url": "https://lh3.googleusercontent.com/56JQcU5rn8LqorIhmoxBdf7xTvl6qNNA1aEnDnisJB5wxa18kF6P4YrUtYKGjH2arIUlYNHYgEK7XVNlFtxCIF72UL46zc2BCuY=s120",
                        "is_subject_to_whitelist": false,
                        "large_image_url": "https://lh3.googleusercontent.com/56JQcU5rn8LqorIhmoxBdf7xTvl6qNNA1aEnDnisJB5wxa18kF6P4YrUtYKGjH2arIUlYNHYgEK7XVNlFtxCIF72UL46zc2BCuY=s300",
                        "medium_username": null,
                        "name": "CoolZer0",
                        "only_proxied_transfers": false,
                        "opensea_buyer_fee_basis_points": "0",
                        "opensea_seller_fee_basis_points": "250",
                        "payout_address": "0xfb42a0604abb3d0f9816599726b3a83ee3157080",
                        "require_email": false,
                        "short_description": null,
                        "slug": "coolzer0",
                        "telegram_url": null,
                        "twitter_username": null,
                        "instagram_username": null,
                        "wiki_url": null
                    },
                    "decimals": null,
                    "token_metadata": null
                },
                {
                    "id": 19704966,
                    "token_id": "113648243776115738426758665575596648452024402290209527738771755343643691450371",
                    "num_sales": 0,
                    "background_color": null,
                    "image_url": "https://lh3.googleusercontent.com/U4A41UB0OlJxejhBVUTFPf2jDFrN44O2a7jqRfAuxDFNDGbTfEhBIazGkuv2XOrUdnjPM_BaGtGxKZpDS8xOMRQBMltN-AFfSJqVKA",
                    "image_preview_url": "https://lh3.googleusercontent.com/U4A41UB0OlJxejhBVUTFPf2jDFrN44O2a7jqRfAuxDFNDGbTfEhBIazGkuv2XOrUdnjPM_BaGtGxKZpDS8xOMRQBMltN-AFfSJqVKA=s250",
                    "image_thumbnail_url": "https://lh3.googleusercontent.com/U4A41UB0OlJxejhBVUTFPf2jDFrN44O2a7jqRfAuxDFNDGbTfEhBIazGkuv2XOrUdnjPM_BaGtGxKZpDS8xOMRQBMltN-AFfSJqVKA=s128",
                    "image_original_url": null,
                    "animation_url": null,
                    "animation_original_url": null,
                    "name": "The Walled City",
                    "description": "A city within.",
                    "external_link": null,
                    "asset_contract": {
                        "address": "0x495f947276749ce646f68ac8c248420045cb7b5e",
                        "asset_contract_type": "semi-fungible",
                        "created_date": "2020-12-02T17:40:53.232025",
                        "name": "OpenSea Collection",
                        "nft_version": null,
                        "opensea_version": "2.0.0",
                        "owner": 102384,
                        "schema_name": "ERC1155",
                        "symbol": "OPENSTORE",
                        "total_supply": null,
                        "description": null,
                        "external_link": null,
                        "image_url": null,
                        "default_to_fiat": false,
                        "dev_buyer_fee_basis_points": 0,
                        "dev_seller_fee_basis_points": 0,
                        "only_proxied_transfers": false,
                        "opensea_buyer_fee_basis_points": 0,
                        "opensea_seller_fee_basis_points": 250,
                        "buyer_fee_basis_points": 0,
                        "seller_fee_basis_points": 250,
                        "payout_address": null
                    },
                    "owner": {
                        "user": {
                            "username": "NullAddress"
                        },
                        "profile_img_url": "https://storage.googleapis.com/opensea-static/opensea-profile/1.png",
                        "address": "0x0000000000000000000000000000000000000000",
                        "config": "",
                        "discord_id": ""
                    },
                    "permalink": "https://opensea.io/assets/0x495f947276749ce646f68ac8c248420045cb7b5e/113648243776115738426758665575596648452024402290209527738771755343643691450371",
                    "collection": {
                        "banner_image_url": "https://lh3.googleusercontent.com/L-xLG0HdPyOGviXrpRlEgwRAowLhugK9quRi17XUTvSYGilzzTIbVeVVs9K-kvmSs71_A0rD_mFCs1EtDUkhSZUeuBJvJvHGtSK6ag=s2500",
                        "chat_url": null,
                        "created_date": "2021-03-15T23:32:58.619445",
                        "default_to_fiat": false,
                        "description": "",
                        "dev_buyer_fee_basis_points": "0",
                        "dev_seller_fee_basis_points": "500",
                        "discord_url": null,
                        "display_data": {
                            "card_display_style": "contain"
                        },
                        "external_url": null,
                        "featured": false,
                        "featured_image_url": "https://lh3.googleusercontent.com/56JQcU5rn8LqorIhmoxBdf7xTvl6qNNA1aEnDnisJB5wxa18kF6P4YrUtYKGjH2arIUlYNHYgEK7XVNlFtxCIF72UL46zc2BCuY=s300",
                        "hidden": true,
                        "safelist_request_status": "not_requested",
                        "image_url": "https://lh3.googleusercontent.com/56JQcU5rn8LqorIhmoxBdf7xTvl6qNNA1aEnDnisJB5wxa18kF6P4YrUtYKGjH2arIUlYNHYgEK7XVNlFtxCIF72UL46zc2BCuY=s120",
                        "is_subject_to_whitelist": false,
                        "large_image_url": "https://lh3.googleusercontent.com/56JQcU5rn8LqorIhmoxBdf7xTvl6qNNA1aEnDnisJB5wxa18kF6P4YrUtYKGjH2arIUlYNHYgEK7XVNlFtxCIF72UL46zc2BCuY=s300",
                        "medium_username": null,
                        "name": "CoolZer0",
                        "only_proxied_transfers": false,
                        "opensea_buyer_fee_basis_points": "0",
                        "opensea_seller_fee_basis_points": "250",
                        "payout_address": "0xfb42a0604abb3d0f9816599726b3a83ee3157080",
                        "require_email": false,
                        "short_description": null,
                        "slug": "coolzer0",
                        "telegram_url": null,
                        "twitter_username": null,
                        "instagram_username": null,
                        "wiki_url": null
                    },
                    "decimals": null,
                    "token_metadata": null
                },
                {
                    "id": 19706264,
                    "token_id": "113648243776115738426758665575596648452024402290209527738771755344743203078145",
                    "num_sales": 0,
                    "background_color": null,
                    "image_url": "https://lh3.googleusercontent.com/h6EESftPdz0G5SxdHaPBbwZJ1WeGn-UpWoANsBwtS1_UQ3mZeN8HKwI9PW6P7MOwx80pjNhlVrvAj_qmJPCi2cQyIbZuJyAX4LJ0",
                    "image_preview_url": "https://lh3.googleusercontent.com/h6EESftPdz0G5SxdHaPBbwZJ1WeGn-UpWoANsBwtS1_UQ3mZeN8HKwI9PW6P7MOwx80pjNhlVrvAj_qmJPCi2cQyIbZuJyAX4LJ0=s250",
                    "image_thumbnail_url": "https://lh3.googleusercontent.com/h6EESftPdz0G5SxdHaPBbwZJ1WeGn-UpWoANsBwtS1_UQ3mZeN8HKwI9PW6P7MOwx80pjNhlVrvAj_qmJPCi2cQyIbZuJyAX4LJ0=s128",
                    "image_original_url": null,
                    "animation_url": null,
                    "animation_original_url": null,
                    "name": "Bling Ball",
                    "description": "Gold, it's the old way, but still so $$$$$.",
                    "external_link": null,
                    "asset_contract": {
                        "address": "0x495f947276749ce646f68ac8c248420045cb7b5e",
                        "asset_contract_type": "semi-fungible",
                        "created_date": "2020-12-02T17:40:53.232025",
                        "name": "OpenSea Collection",
                        "nft_version": null,
                        "opensea_version": "2.0.0",
                        "owner": 102384,
                        "schema_name": "ERC1155",
                        "symbol": "OPENSTORE",
                        "total_supply": null,
                        "description": null,
                        "external_link": null,
                        "image_url": null,
                        "default_to_fiat": false,
                        "dev_buyer_fee_basis_points": 0,
                        "dev_seller_fee_basis_points": 0,
                        "only_proxied_transfers": false,
                        "opensea_buyer_fee_basis_points": 0,
                        "opensea_seller_fee_basis_points": 250,
                        "buyer_fee_basis_points": 0,
                        "seller_fee_basis_points": 250,
                        "payout_address": null
                    },
                    "owner": {
                        "user": {
                            "username": "NullAddress"
                        },
                        "profile_img_url": "https://storage.googleapis.com/opensea-static/opensea-profile/1.png",
                        "address": "0x0000000000000000000000000000000000000000",
                        "config": "",
                        "discord_id": ""
                    },
                    "permalink": "https://opensea.io/assets/0x495f947276749ce646f68ac8c248420045cb7b5e/113648243776115738426758665575596648452024402290209527738771755344743203078145",
                    "collection": {
                        "banner_image_url": "https://lh3.googleusercontent.com/L-xLG0HdPyOGviXrpRlEgwRAowLhugK9quRi17XUTvSYGilzzTIbVeVVs9K-kvmSs71_A0rD_mFCs1EtDUkhSZUeuBJvJvHGtSK6ag=s2500",
                        "chat_url": null,
                        "created_date": "2021-03-15T23:32:58.619445",
                        "default_to_fiat": false,
                        "description": "",
                        "dev_buyer_fee_basis_points": "0",
                        "dev_seller_fee_basis_points": "500",
                        "discord_url": null,
                        "display_data": {
                            "card_display_style": "contain"
                        },
                        "external_url": null,
                        "featured": false,
                        "featured_image_url": "https://lh3.googleusercontent.com/56JQcU5rn8LqorIhmoxBdf7xTvl6qNNA1aEnDnisJB5wxa18kF6P4YrUtYKGjH2arIUlYNHYgEK7XVNlFtxCIF72UL46zc2BCuY=s300",
                        "hidden": true,
                        "safelist_request_status": "not_requested",
                        "image_url": "https://lh3.googleusercontent.com/56JQcU5rn8LqorIhmoxBdf7xTvl6qNNA1aEnDnisJB5wxa18kF6P4YrUtYKGjH2arIUlYNHYgEK7XVNlFtxCIF72UL46zc2BCuY=s120",
                        "is_subject_to_whitelist": false,
                        "large_image_url": "https://lh3.googleusercontent.com/56JQcU5rn8LqorIhmoxBdf7xTvl6qNNA1aEnDnisJB5wxa18kF6P4YrUtYKGjH2arIUlYNHYgEK7XVNlFtxCIF72UL46zc2BCuY=s300",
                        "medium_username": null,
                        "name": "CoolZer0",
                        "only_proxied_transfers": false,
                        "opensea_buyer_fee_basis_points": "0",
                        "opensea_seller_fee_basis_points": "250",
                        "payout_address": "0xfb42a0604abb3d0f9816599726b3a83ee3157080",
                        "require_email": false,
                        "short_description": null,
                        "slug": "coolzer0",
                        "telegram_url": null,
                        "twitter_username": null,
                        "instagram_username": null,
                        "wiki_url": null
                    },
                    "decimals": null,
                    "token_metadata": null
                },
                {
                    "id": 19868764,
                    "token_id": "113648243776115738426758665575596648452024402290209527738771755345842714706020",
                    "num_sales": 0,
                    "background_color": null,
                    "image_url": "https://lh3.googleusercontent.com/D9HlNNyf1lHD4l3EMjCcBng1v3uXjBW5s6ex9WkpD6OhE35DAkgyipuw_HVO_VXPSXG0zAOA3j01fpKxr7cYkVfUizaj4F5K2MFmmh4",
                    "image_preview_url": "https://lh3.googleusercontent.com/D9HlNNyf1lHD4l3EMjCcBng1v3uXjBW5s6ex9WkpD6OhE35DAkgyipuw_HVO_VXPSXG0zAOA3j01fpKxr7cYkVfUizaj4F5K2MFmmh4=s250",
                    "image_thumbnail_url": "https://lh3.googleusercontent.com/D9HlNNyf1lHD4l3EMjCcBng1v3uXjBW5s6ex9WkpD6OhE35DAkgyipuw_HVO_VXPSXG0zAOA3j01fpKxr7cYkVfUizaj4F5K2MFmmh4=s128",
                    "image_original_url": null,
                    "animation_url": null,
                    "animation_original_url": null,
                    "name": "White Blood Cells",
                    "description": "Let's hack the virus!",
                    "external_link": null,
                    "asset_contract": {
                        "address": "0x495f947276749ce646f68ac8c248420045cb7b5e",
                        "asset_contract_type": "semi-fungible",
                        "created_date": "2020-12-02T17:40:53.232025",
                        "name": "OpenSea Collection",
                        "nft_version": null,
                        "opensea_version": "2.0.0",
                        "owner": 102384,
                        "schema_name": "ERC1155",
                        "symbol": "OPENSTORE",
                        "total_supply": null,
                        "description": null,
                        "external_link": null,
                        "image_url": null,
                        "default_to_fiat": false,
                        "dev_buyer_fee_basis_points": 0,
                        "dev_seller_fee_basis_points": 0,
                        "only_proxied_transfers": false,
                        "opensea_buyer_fee_basis_points": 0,
                        "opensea_seller_fee_basis_points": 250,
                        "buyer_fee_basis_points": 0,
                        "seller_fee_basis_points": 250,
                        "payout_address": null
                    },
                    "owner": {
                        "user": {
                            "username": "NullAddress"
                        },
                        "profile_img_url": "https://storage.googleapis.com/opensea-static/opensea-profile/1.png",
                        "address": "0x0000000000000000000000000000000000000000",
                        "config": "",
                        "discord_id": ""
                    },
                    "permalink": "https://opensea.io/assets/0x495f947276749ce646f68ac8c248420045cb7b5e/113648243776115738426758665575596648452024402290209527738771755345842714706020",
                    "collection": {
                        "banner_image_url": "https://lh3.googleusercontent.com/L-xLG0HdPyOGviXrpRlEgwRAowLhugK9quRi17XUTvSYGilzzTIbVeVVs9K-kvmSs71_A0rD_mFCs1EtDUkhSZUeuBJvJvHGtSK6ag=s2500",
                        "chat_url": null,
                        "created_date": "2021-03-15T23:32:58.619445",
                        "default_to_fiat": false,
                        "description": "",
                        "dev_buyer_fee_basis_points": "0",
                        "dev_seller_fee_basis_points": "500",
                        "discord_url": null,
                        "display_data": {
                            "card_display_style": "contain"
                        },
                        "external_url": null,
                        "featured": false,
                        "featured_image_url": "https://lh3.googleusercontent.com/56JQcU5rn8LqorIhmoxBdf7xTvl6qNNA1aEnDnisJB5wxa18kF6P4YrUtYKGjH2arIUlYNHYgEK7XVNlFtxCIF72UL46zc2BCuY=s300",
                        "hidden": true,
                        "safelist_request_status": "not_requested",
                        "image_url": "https://lh3.googleusercontent.com/56JQcU5rn8LqorIhmoxBdf7xTvl6qNNA1aEnDnisJB5wxa18kF6P4YrUtYKGjH2arIUlYNHYgEK7XVNlFtxCIF72UL46zc2BCuY=s120",
                        "is_subject_to_whitelist": false,
                        "large_image_url": "https://lh3.googleusercontent.com/56JQcU5rn8LqorIhmoxBdf7xTvl6qNNA1aEnDnisJB5wxa18kF6P4YrUtYKGjH2arIUlYNHYgEK7XVNlFtxCIF72UL46zc2BCuY=s300",
                        "medium_username": null,
                        "name": "CoolZer0",
                        "only_proxied_transfers": false,
                        "opensea_buyer_fee_basis_points": "0",
                        "opensea_seller_fee_basis_points": "250",
                        "payout_address": "0xfb42a0604abb3d0f9816599726b3a83ee3157080",
                        "require_email": false,
                        "short_description": null,
                        "slug": "coolzer0",
                        "telegram_url": null,
                        "twitter_username": null,
                        "instagram_username": null,
                        "wiki_url": null
                    },
                    "decimals": null,
                    "token_metadata": null
                }
            ],
            "name": "2 Rare, 2 Unique (1 of a kind) + 2 Common custom Fractal NFTs.",
            "description": "Custom created fractal NFTs. Includes 2 Unique, 2 Rare, and 2 Common NFTs.",
            "external_link": "",
            "asset_contract": {
                "collection": {
                    "banner_image_url": null,
                    "chat_url": null,
                    "created_date": "2020-12-02T17:40:53.507540",
                    "default_to_fiat": false,
                    "description": null,
                    "dev_buyer_fee_basis_points": "0",
                    "dev_seller_fee_basis_points": "0",
                    "discord_url": null,
                    "display_data": {
                        "card_display_style": "contain",
                        "images": []
                    },
                    "external_url": null,
                    "featured": false,
                    "featured_image_url": null,
                    "hidden": true,
                    "safelist_request_status": "not_requested",
                    "image_url": null,
                    "is_subject_to_whitelist": false,
                    "large_image_url": null,
                    "medium_username": null,
                    "name": "OpenSea Shared Storefront V2",
                    "only_proxied_transfers": false,
                    "opensea_buyer_fee_basis_points": "0",
                    "opensea_seller_fee_basis_points": "250",
                    "payout_address": null,
                    "require_email": false,
                    "short_description": null,
                    "slug": "opensea-shared-storefront-v2",
                    "telegram_url": null,
                    "twitter_username": null,
                    "instagram_username": null,
                    "wiki_url": null
                },
                "address": "0x495f947276749ce646f68ac8c248420045cb7b5e",
                "asset_contract_type": "semi-fungible",
                "created_date": "2020-12-02T17:40:53.232025",
                "name": "OpenSea Collection",
                "nft_version": null,
                "opensea_version": "2.0.0",
                "owner": 102384,
                "schema_name": "ERC1155",
                "symbol": "OPENSTORE",
                "total_supply": null,
                "description": null,
                "external_link": null,
                "image_url": null,
                "default_to_fiat": false,
                "dev_buyer_fee_basis_points": 0,
                "dev_seller_fee_basis_points": 0,
                "only_proxied_transfers": false,
                "opensea_buyer_fee_basis_points": 0,
                "opensea_seller_fee_basis_points": 250,
                "buyer_fee_basis_points": 0,
                "seller_fee_basis_points": 250,
                "payout_address": null
            },
            "permalink": "https://opensea.io/bundles/2-rare-2-unique-1-of-a-kind-2-common-custom-fr-p4i",
            "sell_orders": [
                {
                    "created_date": "2021-05-25T21:56:59.183513",
                    "closing_date": "2021-06-25T21:55:29",
                    "closing_extendable": false,
                    "expiration_time": 1624658129,
                    "listing_time": 1621979692,
                    "order_hash": "0x6c9ad03dcce2aa2842f9a8b1dd9146d89935d10d63d0c7bac2dd09ec49f74c88",
                    "metadata": {
                        "bundle": {
                            "assets": [
                                {
                                    "id": "113648243776115738426758665575596648452024402290209527738771755340345156567045",
                                    "address": "0x495f947276749ce646f68ac8c248420045cb7b5e",
                                    "quantity": "1"
                                },
                                {
                                    "id": "113648243776115738426758665575596648452024402290209527738771755341444668194817",
                                    "address": "0x495f947276749ce646f68ac8c248420045cb7b5e",
                                    "quantity": "1"
                                },
                                {
                                    "id": "113648243776115738426758665575596648452024402290209527738771755342544179822602",
                                    "address": "0x495f947276749ce646f68ac8c248420045cb7b5e",
                                    "quantity": "1"
                                },
                                {
                                    "id": "113648243776115738426758665575596648452024402290209527738771755343643691450371",
                                    "address": "0x495f947276749ce646f68ac8c248420045cb7b5e",
                                    "quantity": "1"
                                },
                                {
                                    "id": "113648243776115738426758665575596648452024402290209527738771755344743203078145",
                                    "address": "0x495f947276749ce646f68ac8c248420045cb7b5e",
                                    "quantity": "1"
                                },
                                {
                                    "id": "113648243776115738426758665575596648452024402290209527738771755345842714706020",
                                    "address": "0x495f947276749ce646f68ac8c248420045cb7b5e",
                                    "quantity": "1"
                                }
                            ],
                            "schemas": [
                                "ERC1155",
                                "ERC1155",
                                "ERC1155",
                                "ERC1155",
                                "ERC1155",
                                "ERC1155"
                            ],
                            "name": "2 Rare, 2 Unique (1 of a kind) + 2 Common custom Fractal NFTs.",
                            "description": "Custom created fractal NFTs. Includes 2 Unique, 2 Rare, and 2 Common NFTs.",
                            "external_link": ""
                        }
                    },
                    "exchange": "0x7be8076f4ea4a4ad08075c2508e481d6c946d12b",
                    "maker": {
                        "user": 356871,
                        "profile_img_url": "https://storage.googleapis.com/opensea-static/opensea-profile/10.png",
                        "address": "0xfb42a0604abb3d0f9816599726b3a83ee3157080",
                        "config": "",
                        "discord_id": ""
                    },
                    "taker": {
                        "user": 1766,
                        "profile_img_url": "https://storage.googleapis.com/opensea-static/opensea-profile/1.png",
                        "address": "0x0000000000000000000000000000000000000000",
                        "config": "",
                        "discord_id": ""
                    },
                    "current_price": "1000000000000000000.000000000",
                    "current_bounty": "25000000000000000",
                    "bounty_multiple": "0.025",
                    "maker_relayer_fee": "750",
                    "taker_relayer_fee": "0",
                    "maker_protocol_fee": "0",
                    "taker_protocol_fee": "0",
                    "maker_referrer_fee": "150",
                    "fee_recipient": {
                        "user": 3585,
                        "profile_img_url": "https://storage.googleapis.com/opensea-static/opensea-profile/28.png",
                        "address": "0x5b3256965e7c3cf26e11fcaf296dfc8807c01073",
                        "config": "verified",
                        "discord_id": ""
                    },
                    "fee_method": 1,
                    "side": 1,
                    "sale_kind": 0,
                    "target": "0xc99f70bfd82fb7c8f8191fdfbfb735606b15e5c5",
                    "how_to_call": 1,
                    "calldata": "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",
                    "replacement_pattern": "0x0000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000ffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffff0000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000ffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffff0000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000ffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffff0000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000ffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffff0000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000ffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffff0000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000ffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffff00000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000",
                    "static_target": "0x0000000000000000000000000000000000000000",
                    "static_extradata": "0x",
                    "payment_token": "0x0000000000000000000000000000000000000000",
                    "payment_token_contract": {
                        "id": 1,
                        "symbol": "ETH",
                        "address": "0x0000000000000000000000000000000000000000",
                        "image_url": "https://storage.opensea.io/files/6f8e2979d428180222796ff4a33ab929.svg",
                        "name": "Ether",
                        "decimals": 18,
                        "eth_price": "1.000000000000000",
                        "usd_price": "2625.730000000000018000"
                    },
                    "base_price": "1000000000000000000",
                    "extra": "0",
                    "quantity": "1",
                    "salt": "13445954241724962826412105841520710188621233959215999034559080873647547288772",
                    "v": 28,
                    "r": "0x9c4bf364497c01ff6d4e9ce8a3fa4879e431c880c9e600bde84ca0ed749e8802",
                    "s": "0x502d9e3b715c91ab8d7787fe2d02fdfb1254552b5fdf385a87317f278cc631ce",
                    "approved_on_chain": false,
                    "cancelled": false,
                    "finalized": false,
                    "marked_invalid": false,
                    "prefixed_hash": "0xc55ccd4b611d274e16b2d39e62259bcfcc4936f4d69693de4c0372490190d09a"
                }
            ]
        },
        {
            "maker": {
                "user": {
                    "username": null
                },
                "profile_img_url": "https://storage.googleapis.com/opensea-static/opensea-profile/5.png",
                "address": "0xe289a24fc2859fa9fb4b5acc97de7d4d6f0dc831",
                "config": "",
                "discord_id": ""
            },
            "slug": "hidef-launch-press-release-Hhm",
            "assets": [
                {
                    "id": 20422670,
                    "token_id": "70479185245472823933799012500856922265354379340922944019462782637806087831553",
                    "num_sales": 0,
                    "background_color": null,
                    "image_url": "https://lh3.googleusercontent.com/d--0RQJiGduT6-8KKUSalaAcpzvzX3q812XObJ7sPb5iYszWulXadZhQYvZGP_ZUC-hZUbFxARQlNbg_qWIcylMo-xqP3sGag6erGA",
                    "image_preview_url": "https://lh3.googleusercontent.com/d--0RQJiGduT6-8KKUSalaAcpzvzX3q812XObJ7sPb5iYszWulXadZhQYvZGP_ZUC-hZUbFxARQlNbg_qWIcylMo-xqP3sGag6erGA=s250",
                    "image_thumbnail_url": "https://lh3.googleusercontent.com/d--0RQJiGduT6-8KKUSalaAcpzvzX3q812XObJ7sPb5iYszWulXadZhQYvZGP_ZUC-hZUbFxARQlNbg_qWIcylMo-xqP3sGag6erGA=s128",
                    "image_original_url": null,
                    "animation_url": null,
                    "animation_original_url": null,
                    "name": "HiDef Launch Press Release",
                    "description": "Official Press Release 1 of 10",
                    "external_link": "https://hidef.com/",
                    "asset_contract": {
                        "address": "0x495f947276749ce646f68ac8c248420045cb7b5e",
                        "asset_contract_type": "semi-fungible",
                        "created_date": "2020-12-02T17:40:53.232025",
                        "name": "OpenSea Collection",
                        "nft_version": null,
                        "opensea_version": "2.0.0",
                        "owner": 102384,
                        "schema_name": "ERC1155",
                        "symbol": "OPENSTORE",
                        "total_supply": null,
                        "description": null,
                        "external_link": null,
                        "image_url": null,
                        "default_to_fiat": false,
                        "dev_buyer_fee_basis_points": 0,
                        "dev_seller_fee_basis_points": 0,
                        "only_proxied_transfers": false,
                        "opensea_buyer_fee_basis_points": 0,
                        "opensea_seller_fee_basis_points": 250,
                        "buyer_fee_basis_points": 0,
                        "seller_fee_basis_points": 250,
                        "payout_address": null
                    },
                    "owner": {
                        "user": {
                            "username": "NullAddress"
                        },
                        "profile_img_url": "https://storage.googleapis.com/opensea-static/opensea-profile/1.png",
                        "address": "0x0000000000000000000000000000000000000000",
                        "config": "",
                        "discord_id": ""
                    },
                    "permalink": "https://opensea.io/assets/0x495f947276749ce646f68ac8c248420045cb7b5e/70479185245472823933799012500856922265354379340922944019462782637806087831553",
                    "collection": {
                        "banner_image_url": "https://lh3.googleusercontent.com/i1dLTD9hXZSzeMGz02l202fkMjd3QQrZ2fCQ2TZt-ajo3L931rN_TRGeqU9IvTfm166GIvs5DWaWCKbnuxKq5JmMHLOXioRyCuMxNQ=s2500",
                        "chat_url": null,
                        "created_date": "2021-03-24T00:31:54.219565",
                        "default_to_fiat": false,
                        "description": "",
                        "dev_buyer_fee_basis_points": "0",
                        "dev_seller_fee_basis_points": "0",
                        "discord_url": null,
                        "display_data": {
                            "card_display_style": "contain",
                            "images": []
                        },
                        "external_url": null,
                        "featured": false,
                        "featured_image_url": null,
                        "hidden": true,
                        "safelist_request_status": "not_requested",
                        "image_url": "https://lh3.googleusercontent.com/qZRiTQMHRe5EswI1syqlf0Sf3sfY8bnZjtVhjn89Kh_RxfqZ1WBWTJBnyvnB-gJWsvr6-DsACvVxrPBsj5pSlecxj63iAcVfQTkD=s120",
                        "is_subject_to_whitelist": false,
                        "large_image_url": null,
                        "medium_username": null,
                        "name": "HiDef",
                        "only_proxied_transfers": false,
                        "opensea_buyer_fee_basis_points": "0",
                        "opensea_seller_fee_basis_points": "250",
                        "payout_address": null,
                        "require_email": false,
                        "short_description": null,
                        "slug": "hidef",
                        "telegram_url": null,
                        "twitter_username": null,
                        "instagram_username": null,
                        "wiki_url": null
                    },
                    "decimals": null,
                    "token_metadata": null
                },
                {
                    "id": 20423026,
                    "token_id": "70479185245472823933799012500856922265354379340922944019462782638905599459329",
                    "num_sales": 0,
                    "background_color": null,
                    "image_url": "https://lh3.googleusercontent.com/d--0RQJiGduT6-8KKUSalaAcpzvzX3q812XObJ7sPb5iYszWulXadZhQYvZGP_ZUC-hZUbFxARQlNbg_qWIcylMo-xqP3sGag6erGA",
                    "image_preview_url": "https://lh3.googleusercontent.com/d--0RQJiGduT6-8KKUSalaAcpzvzX3q812XObJ7sPb5iYszWulXadZhQYvZGP_ZUC-hZUbFxARQlNbg_qWIcylMo-xqP3sGag6erGA=s250",
                    "image_thumbnail_url": "https://lh3.googleusercontent.com/d--0RQJiGduT6-8KKUSalaAcpzvzX3q812XObJ7sPb5iYszWulXadZhQYvZGP_ZUC-hZUbFxARQlNbg_qWIcylMo-xqP3sGag6erGA=s128",
                    "image_original_url": null,
                    "animation_url": null,
                    "animation_original_url": null,
                    "name": "HiDef Launch Press Release",
                    "description": "Official Press Release 2 of 10",
                    "external_link": "https://hidef.com/",
                    "asset_contract": {
                        "address": "0x495f947276749ce646f68ac8c248420045cb7b5e",
                        "asset_contract_type": "semi-fungible",
                        "created_date": "2020-12-02T17:40:53.232025",
                        "name": "OpenSea Collection",
                        "nft_version": null,
                        "opensea_version": "2.0.0",
                        "owner": 102384,
                        "schema_name": "ERC1155",
                        "symbol": "OPENSTORE",
                        "total_supply": null,
                        "description": null,
                        "external_link": null,
                        "image_url": null,
                        "default_to_fiat": false,
                        "dev_buyer_fee_basis_points": 0,
                        "dev_seller_fee_basis_points": 0,
                        "only_proxied_transfers": false,
                        "opensea_buyer_fee_basis_points": 0,
                        "opensea_seller_fee_basis_points": 250,
                        "buyer_fee_basis_points": 0,
                        "seller_fee_basis_points": 250,
                        "payout_address": null
                    },
                    "owner": {
                        "user": {
                            "username": "NullAddress"
                        },
                        "profile_img_url": "https://storage.googleapis.com/opensea-static/opensea-profile/1.png",
                        "address": "0x0000000000000000000000000000000000000000",
                        "config": "",
                        "discord_id": ""
                    },
                    "permalink": "https://opensea.io/assets/0x495f947276749ce646f68ac8c248420045cb7b5e/70479185245472823933799012500856922265354379340922944019462782638905599459329",
                    "collection": {
                        "banner_image_url": "https://lh3.googleusercontent.com/i1dLTD9hXZSzeMGz02l202fkMjd3QQrZ2fCQ2TZt-ajo3L931rN_TRGeqU9IvTfm166GIvs5DWaWCKbnuxKq5JmMHLOXioRyCuMxNQ=s2500",
                        "chat_url": null,
                        "created_date": "2021-03-24T00:31:54.219565",
                        "default_to_fiat": false,
                        "description": "",
                        "dev_buyer_fee_basis_points": "0",
                        "dev_seller_fee_basis_points": "0",
                        "discord_url": null,
                        "display_data": {
                            "card_display_style": "contain",
                            "images": []
                        },
                        "external_url": null,
                        "featured": false,
                        "featured_image_url": null,
                        "hidden": true,
                        "safelist_request_status": "not_requested",
                        "image_url": "https://lh3.googleusercontent.com/qZRiTQMHRe5EswI1syqlf0Sf3sfY8bnZjtVhjn89Kh_RxfqZ1WBWTJBnyvnB-gJWsvr6-DsACvVxrPBsj5pSlecxj63iAcVfQTkD=s120",
                        "is_subject_to_whitelist": false,
                        "large_image_url": null,
                        "medium_username": null,
                        "name": "HiDef",
                        "only_proxied_transfers": false,
                        "opensea_buyer_fee_basis_points": "0",
                        "opensea_seller_fee_basis_points": "250",
                        "payout_address": null,
                        "require_email": false,
                        "short_description": null,
                        "slug": "hidef",
                        "telegram_url": null,
                        "twitter_username": null,
                        "instagram_username": null,
                        "wiki_url": null
                    },
                    "decimals": null,
                    "token_metadata": null
                },
                {
                    "id": 20423215,
                    "token_id": "70479185245472823933799012500856922265354379340922944019462782640005111087105",
                    "num_sales": 0,
                    "background_color": null,
                    "image_url": "https://lh3.googleusercontent.com/d--0RQJiGduT6-8KKUSalaAcpzvzX3q812XObJ7sPb5iYszWulXadZhQYvZGP_ZUC-hZUbFxARQlNbg_qWIcylMo-xqP3sGag6erGA",
                    "image_preview_url": "https://lh3.googleusercontent.com/d--0RQJiGduT6-8KKUSalaAcpzvzX3q812XObJ7sPb5iYszWulXadZhQYvZGP_ZUC-hZUbFxARQlNbg_qWIcylMo-xqP3sGag6erGA=s250",
                    "image_thumbnail_url": "https://lh3.googleusercontent.com/d--0RQJiGduT6-8KKUSalaAcpzvzX3q812XObJ7sPb5iYszWulXadZhQYvZGP_ZUC-hZUbFxARQlNbg_qWIcylMo-xqP3sGag6erGA=s128",
                    "image_original_url": null,
                    "animation_url": null,
                    "animation_original_url": null,
                    "name": "HiDef Launch Press Release",
                    "description": "Official Press Release 3 of 10",
                    "external_link": "https://hidef.com/",
                    "asset_contract": {
                        "address": "0x495f947276749ce646f68ac8c248420045cb7b5e",
                        "asset_contract_type": "semi-fungible",
                        "created_date": "2020-12-02T17:40:53.232025",
                        "name": "OpenSea Collection",
                        "nft_version": null,
                        "opensea_version": "2.0.0",
                        "owner": 102384,
                        "schema_name": "ERC1155",
                        "symbol": "OPENSTORE",
                        "total_supply": null,
                        "description": null,
                        "external_link": null,
                        "image_url": null,
                        "default_to_fiat": false,
                        "dev_buyer_fee_basis_points": 0,
                        "dev_seller_fee_basis_points": 0,
                        "only_proxied_transfers": false,
                        "opensea_buyer_fee_basis_points": 0,
                        "opensea_seller_fee_basis_points": 250,
                        "buyer_fee_basis_points": 0,
                        "seller_fee_basis_points": 250,
                        "payout_address": null
                    },
                    "owner": {
                        "user": {
                            "username": "NullAddress"
                        },
                        "profile_img_url": "https://storage.googleapis.com/opensea-static/opensea-profile/1.png",
                        "address": "0x0000000000000000000000000000000000000000",
                        "config": "",
                        "discord_id": ""
                    },
                    "permalink": "https://opensea.io/assets/0x495f947276749ce646f68ac8c248420045cb7b5e/70479185245472823933799012500856922265354379340922944019462782640005111087105",
                    "collection": {
                        "banner_image_url": "https://lh3.googleusercontent.com/i1dLTD9hXZSzeMGz02l202fkMjd3QQrZ2fCQ2TZt-ajo3L931rN_TRGeqU9IvTfm166GIvs5DWaWCKbnuxKq5JmMHLOXioRyCuMxNQ=s2500",
                        "chat_url": null,
                        "created_date": "2021-03-24T00:31:54.219565",
                        "default_to_fiat": false,
                        "description": "",
                        "dev_buyer_fee_basis_points": "0",
                        "dev_seller_fee_basis_points": "0",
                        "discord_url": null,
                        "display_data": {
                            "card_display_style": "contain",
                            "images": []
                        },
                        "external_url": null,
                        "featured": false,
                        "featured_image_url": null,
                        "hidden": true,
                        "safelist_request_status": "not_requested",
                        "image_url": "https://lh3.googleusercontent.com/qZRiTQMHRe5EswI1syqlf0Sf3sfY8bnZjtVhjn89Kh_RxfqZ1WBWTJBnyvnB-gJWsvr6-DsACvVxrPBsj5pSlecxj63iAcVfQTkD=s120",
                        "is_subject_to_whitelist": false,
                        "large_image_url": null,
                        "medium_username": null,
                        "name": "HiDef",
                        "only_proxied_transfers": false,
                        "opensea_buyer_fee_basis_points": "0",
                        "opensea_seller_fee_basis_points": "250",
                        "payout_address": null,
                        "require_email": false,
                        "short_description": null,
                        "slug": "hidef",
                        "telegram_url": null,
                        "twitter_username": null,
                        "instagram_username": null,
                        "wiki_url": null
                    },
                    "decimals": null,
                    "token_metadata": null
                },
                {
                    "id": 20423324,
                    "token_id": "70479185245472823933799012500856922265354379340922944019462782641104622714881",
                    "num_sales": 0,
                    "background_color": null,
                    "image_url": "https://lh3.googleusercontent.com/d--0RQJiGduT6-8KKUSalaAcpzvzX3q812XObJ7sPb5iYszWulXadZhQYvZGP_ZUC-hZUbFxARQlNbg_qWIcylMo-xqP3sGag6erGA",
                    "image_preview_url": "https://lh3.googleusercontent.com/d--0RQJiGduT6-8KKUSalaAcpzvzX3q812XObJ7sPb5iYszWulXadZhQYvZGP_ZUC-hZUbFxARQlNbg_qWIcylMo-xqP3sGag6erGA=s250",
                    "image_thumbnail_url": "https://lh3.googleusercontent.com/d--0RQJiGduT6-8KKUSalaAcpzvzX3q812XObJ7sPb5iYszWulXadZhQYvZGP_ZUC-hZUbFxARQlNbg_qWIcylMo-xqP3sGag6erGA=s128",
                    "image_original_url": null,
                    "animation_url": null,
                    "animation_original_url": null,
                    "name": "HiDef Launch Press Release",
                    "description": "Official Press Release 4 of 10",
                    "external_link": "https://hidef.com/",
                    "asset_contract": {
                        "address": "0x495f947276749ce646f68ac8c248420045cb7b5e",
                        "asset_contract_type": "semi-fungible",
                        "created_date": "2020-12-02T17:40:53.232025",
                        "name": "OpenSea Collection",
                        "nft_version": null,
                        "opensea_version": "2.0.0",
                        "owner": 102384,
                        "schema_name": "ERC1155",
                        "symbol": "OPENSTORE",
                        "total_supply": null,
                        "description": null,
                        "external_link": null,
                        "image_url": null,
                        "default_to_fiat": false,
                        "dev_buyer_fee_basis_points": 0,
                        "dev_seller_fee_basis_points": 0,
                        "only_proxied_transfers": false,
                        "opensea_buyer_fee_basis_points": 0,
                        "opensea_seller_fee_basis_points": 250,
                        "buyer_fee_basis_points": 0,
                        "seller_fee_basis_points": 250,
                        "payout_address": null
                    },
                    "owner": {
                        "user": {
                            "username": "NullAddress"
                        },
                        "profile_img_url": "https://storage.googleapis.com/opensea-static/opensea-profile/1.png",
                        "address": "0x0000000000000000000000000000000000000000",
                        "config": "",
                        "discord_id": ""
                    },
                    "permalink": "https://opensea.io/assets/0x495f947276749ce646f68ac8c248420045cb7b5e/70479185245472823933799012500856922265354379340922944019462782641104622714881",
                    "collection": {
                        "banner_image_url": "https://lh3.googleusercontent.com/i1dLTD9hXZSzeMGz02l202fkMjd3QQrZ2fCQ2TZt-ajo3L931rN_TRGeqU9IvTfm166GIvs5DWaWCKbnuxKq5JmMHLOXioRyCuMxNQ=s2500",
                        "chat_url": null,
                        "created_date": "2021-03-24T00:31:54.219565",
                        "default_to_fiat": false,
                        "description": "",
                        "dev_buyer_fee_basis_points": "0",
                        "dev_seller_fee_basis_points": "0",
                        "discord_url": null,
                        "display_data": {
                            "card_display_style": "contain",
                            "images": []
                        },
                        "external_url": null,
                        "featured": false,
                        "featured_image_url": null,
                        "hidden": true,
                        "safelist_request_status": "not_requested",
                        "image_url": "https://lh3.googleusercontent.com/qZRiTQMHRe5EswI1syqlf0Sf3sfY8bnZjtVhjn89Kh_RxfqZ1WBWTJBnyvnB-gJWsvr6-DsACvVxrPBsj5pSlecxj63iAcVfQTkD=s120",
                        "is_subject_to_whitelist": false,
                        "large_image_url": null,
                        "medium_username": null,
                        "name": "HiDef",
                        "only_proxied_transfers": false,
                        "opensea_buyer_fee_basis_points": "0",
                        "opensea_seller_fee_basis_points": "250",
                        "payout_address": null,
                        "require_email": false,
                        "short_description": null,
                        "slug": "hidef",
                        "telegram_url": null,
                        "twitter_username": null,
                        "instagram_username": null,
                        "wiki_url": null
                    },
                    "decimals": null,
                    "token_metadata": null
                },
                {
                    "id": 20423484,
                    "token_id": "70479185245472823933799012500856922265354379340922944019462782642204134342657",
                    "num_sales": 0,
                    "background_color": null,
                    "image_url": "https://lh3.googleusercontent.com/d--0RQJiGduT6-8KKUSalaAcpzvzX3q812XObJ7sPb5iYszWulXadZhQYvZGP_ZUC-hZUbFxARQlNbg_qWIcylMo-xqP3sGag6erGA",
                    "image_preview_url": "https://lh3.googleusercontent.com/d--0RQJiGduT6-8KKUSalaAcpzvzX3q812XObJ7sPb5iYszWulXadZhQYvZGP_ZUC-hZUbFxARQlNbg_qWIcylMo-xqP3sGag6erGA=s250",
                    "image_thumbnail_url": "https://lh3.googleusercontent.com/d--0RQJiGduT6-8KKUSalaAcpzvzX3q812XObJ7sPb5iYszWulXadZhQYvZGP_ZUC-hZUbFxARQlNbg_qWIcylMo-xqP3sGag6erGA=s128",
                    "image_original_url": null,
                    "animation_url": null,
                    "animation_original_url": null,
                    "name": "HiDef Launch Press Release",
                    "description": "Official Press Release 5 of 10",
                    "external_link": "https://hidef.com/",
                    "asset_contract": {
                        "address": "0x495f947276749ce646f68ac8c248420045cb7b5e",
                        "asset_contract_type": "semi-fungible",
                        "created_date": "2020-12-02T17:40:53.232025",
                        "name": "OpenSea Collection",
                        "nft_version": null,
                        "opensea_version": "2.0.0",
                        "owner": 102384,
                        "schema_name": "ERC1155",
                        "symbol": "OPENSTORE",
                        "total_supply": null,
                        "description": null,
                        "external_link": null,
                        "image_url": null,
                        "default_to_fiat": false,
                        "dev_buyer_fee_basis_points": 0,
                        "dev_seller_fee_basis_points": 0,
                        "only_proxied_transfers": false,
                        "opensea_buyer_fee_basis_points": 0,
                        "opensea_seller_fee_basis_points": 250,
                        "buyer_fee_basis_points": 0,
                        "seller_fee_basis_points": 250,
                        "payout_address": null
                    },
                    "owner": {
                        "user": {
                            "username": "NullAddress"
                        },
                        "profile_img_url": "https://storage.googleapis.com/opensea-static/opensea-profile/1.png",
                        "address": "0x0000000000000000000000000000000000000000",
                        "config": "",
                        "discord_id": ""
                    },
                    "permalink": "https://opensea.io/assets/0x495f947276749ce646f68ac8c248420045cb7b5e/70479185245472823933799012500856922265354379340922944019462782642204134342657",
                    "collection": {
                        "banner_image_url": "https://lh3.googleusercontent.com/i1dLTD9hXZSzeMGz02l202fkMjd3QQrZ2fCQ2TZt-ajo3L931rN_TRGeqU9IvTfm166GIvs5DWaWCKbnuxKq5JmMHLOXioRyCuMxNQ=s2500",
                        "chat_url": null,
                        "created_date": "2021-03-24T00:31:54.219565",
                        "default_to_fiat": false,
                        "description": "",
                        "dev_buyer_fee_basis_points": "0",
                        "dev_seller_fee_basis_points": "0",
                        "discord_url": null,
                        "display_data": {
                            "card_display_style": "contain",
                            "images": []
                        },
                        "external_url": null,
                        "featured": false,
                        "featured_image_url": null,
                        "hidden": true,
                        "safelist_request_status": "not_requested",
                        "image_url": "https://lh3.googleusercontent.com/qZRiTQMHRe5EswI1syqlf0Sf3sfY8bnZjtVhjn89Kh_RxfqZ1WBWTJBnyvnB-gJWsvr6-DsACvVxrPBsj5pSlecxj63iAcVfQTkD=s120",
                        "is_subject_to_whitelist": false,
                        "large_image_url": null,
                        "medium_username": null,
                        "name": "HiDef",
                        "only_proxied_transfers": false,
                        "opensea_buyer_fee_basis_points": "0",
                        "opensea_seller_fee_basis_points": "250",
                        "payout_address": null,
                        "require_email": false,
                        "short_description": null,
                        "slug": "hidef",
                        "telegram_url": null,
                        "twitter_username": null,
                        "instagram_username": null,
                        "wiki_url": null
                    },
                    "decimals": null,
                    "token_metadata": null
                },
                {
                    "id": 20423752,
                    "token_id": "70479185245472823933799012500856922265354379340922944019462782643303645970433",
                    "num_sales": 0,
                    "background_color": null,
                    "image_url": "https://lh3.googleusercontent.com/d--0RQJiGduT6-8KKUSalaAcpzvzX3q812XObJ7sPb5iYszWulXadZhQYvZGP_ZUC-hZUbFxARQlNbg_qWIcylMo-xqP3sGag6erGA",
                    "image_preview_url": "https://lh3.googleusercontent.com/d--0RQJiGduT6-8KKUSalaAcpzvzX3q812XObJ7sPb5iYszWulXadZhQYvZGP_ZUC-hZUbFxARQlNbg_qWIcylMo-xqP3sGag6erGA=s250",
                    "image_thumbnail_url": "https://lh3.googleusercontent.com/d--0RQJiGduT6-8KKUSalaAcpzvzX3q812XObJ7sPb5iYszWulXadZhQYvZGP_ZUC-hZUbFxARQlNbg_qWIcylMo-xqP3sGag6erGA=s128",
                    "image_original_url": null,
                    "animation_url": null,
                    "animation_original_url": null,
                    "name": "HiDef Launch Press Release",
                    "description": "Official Press Release 6 of 10",
                    "external_link": "https://hidef.com/",
                    "asset_contract": {
                        "address": "0x495f947276749ce646f68ac8c248420045cb7b5e",
                        "asset_contract_type": "semi-fungible",
                        "created_date": "2020-12-02T17:40:53.232025",
                        "name": "OpenSea Collection",
                        "nft_version": null,
                        "opensea_version": "2.0.0",
                        "owner": 102384,
                        "schema_name": "ERC1155",
                        "symbol": "OPENSTORE",
                        "total_supply": null,
                        "description": null,
                        "external_link": null,
                        "image_url": null,
                        "default_to_fiat": false,
                        "dev_buyer_fee_basis_points": 0,
                        "dev_seller_fee_basis_points": 0,
                        "only_proxied_transfers": false,
                        "opensea_buyer_fee_basis_points": 0,
                        "opensea_seller_fee_basis_points": 250,
                        "buyer_fee_basis_points": 0,
                        "seller_fee_basis_points": 250,
                        "payout_address": null
                    },
                    "owner": {
                        "user": {
                            "username": "NullAddress"
                        },
                        "profile_img_url": "https://storage.googleapis.com/opensea-static/opensea-profile/1.png",
                        "address": "0x0000000000000000000000000000000000000000",
                        "config": "",
                        "discord_id": ""
                    },
                    "permalink": "https://opensea.io/assets/0x495f947276749ce646f68ac8c248420045cb7b5e/70479185245472823933799012500856922265354379340922944019462782643303645970433",
                    "collection": {
                        "banner_image_url": "https://lh3.googleusercontent.com/i1dLTD9hXZSzeMGz02l202fkMjd3QQrZ2fCQ2TZt-ajo3L931rN_TRGeqU9IvTfm166GIvs5DWaWCKbnuxKq5JmMHLOXioRyCuMxNQ=s2500",
                        "chat_url": null,
                        "created_date": "2021-03-24T00:31:54.219565",
                        "default_to_fiat": false,
                        "description": "",
                        "dev_buyer_fee_basis_points": "0",
                        "dev_seller_fee_basis_points": "0",
                        "discord_url": null,
                        "display_data": {
                            "card_display_style": "contain",
                            "images": []
                        },
                        "external_url": null,
                        "featured": false,
                        "featured_image_url": null,
                        "hidden": true,
                        "safelist_request_status": "not_requested",
                        "image_url": "https://lh3.googleusercontent.com/qZRiTQMHRe5EswI1syqlf0Sf3sfY8bnZjtVhjn89Kh_RxfqZ1WBWTJBnyvnB-gJWsvr6-DsACvVxrPBsj5pSlecxj63iAcVfQTkD=s120",
                        "is_subject_to_whitelist": false,
                        "large_image_url": null,
                        "medium_username": null,
                        "name": "HiDef",
                        "only_proxied_transfers": false,
                        "opensea_buyer_fee_basis_points": "0",
                        "opensea_seller_fee_basis_points": "250",
                        "payout_address": null,
                        "require_email": false,
                        "short_description": null,
                        "slug": "hidef",
                        "telegram_url": null,
                        "twitter_username": null,
                        "instagram_username": null,
                        "wiki_url": null
                    },
                    "decimals": null,
                    "token_metadata": null
                },
                {
                    "id": 20423801,
                    "token_id": "70479185245472823933799012500856922265354379340922944019462782644403157598209",
                    "num_sales": 0,
                    "background_color": null,
                    "image_url": "https://lh3.googleusercontent.com/d--0RQJiGduT6-8KKUSalaAcpzvzX3q812XObJ7sPb5iYszWulXadZhQYvZGP_ZUC-hZUbFxARQlNbg_qWIcylMo-xqP3sGag6erGA",
                    "image_preview_url": "https://lh3.googleusercontent.com/d--0RQJiGduT6-8KKUSalaAcpzvzX3q812XObJ7sPb5iYszWulXadZhQYvZGP_ZUC-hZUbFxARQlNbg_qWIcylMo-xqP3sGag6erGA=s250",
                    "image_thumbnail_url": "https://lh3.googleusercontent.com/d--0RQJiGduT6-8KKUSalaAcpzvzX3q812XObJ7sPb5iYszWulXadZhQYvZGP_ZUC-hZUbFxARQlNbg_qWIcylMo-xqP3sGag6erGA=s128",
                    "image_original_url": null,
                    "animation_url": null,
                    "animation_original_url": null,
                    "name": "HiDef Launch Press Release",
                    "description": "Official Press Release 7 of 10",
                    "external_link": "https://hidef.com/",
                    "asset_contract": {
                        "address": "0x495f947276749ce646f68ac8c248420045cb7b5e",
                        "asset_contract_type": "semi-fungible",
                        "created_date": "2020-12-02T17:40:53.232025",
                        "name": "OpenSea Collection",
                        "nft_version": null,
                        "opensea_version": "2.0.0",
                        "owner": 102384,
                        "schema_name": "ERC1155",
                        "symbol": "OPENSTORE",
                        "total_supply": null,
                        "description": null,
                        "external_link": null,
                        "image_url": null,
                        "default_to_fiat": false,
                        "dev_buyer_fee_basis_points": 0,
                        "dev_seller_fee_basis_points": 0,
                        "only_proxied_transfers": false,
                        "opensea_buyer_fee_basis_points": 0,
                        "opensea_seller_fee_basis_points": 250,
                        "buyer_fee_basis_points": 0,
                        "seller_fee_basis_points": 250,
                        "payout_address": null
                    },
                    "owner": {
                        "user": {
                            "username": "NullAddress"
                        },
                        "profile_img_url": "https://storage.googleapis.com/opensea-static/opensea-profile/1.png",
                        "address": "0x0000000000000000000000000000000000000000",
                        "config": "",
                        "discord_id": ""
                    },
                    "permalink": "https://opensea.io/assets/0x495f947276749ce646f68ac8c248420045cb7b5e/70479185245472823933799012500856922265354379340922944019462782644403157598209",
                    "collection": {
                        "banner_image_url": "https://lh3.googleusercontent.com/i1dLTD9hXZSzeMGz02l202fkMjd3QQrZ2fCQ2TZt-ajo3L931rN_TRGeqU9IvTfm166GIvs5DWaWCKbnuxKq5JmMHLOXioRyCuMxNQ=s2500",
                        "chat_url": null,
                        "created_date": "2021-03-24T00:31:54.219565",
                        "default_to_fiat": false,
                        "description": "",
                        "dev_buyer_fee_basis_points": "0",
                        "dev_seller_fee_basis_points": "0",
                        "discord_url": null,
                        "display_data": {
                            "card_display_style": "contain",
                            "images": []
                        },
                        "external_url": null,
                        "featured": false,
                        "featured_image_url": null,
                        "hidden": true,
                        "safelist_request_status": "not_requested",
                        "image_url": "https://lh3.googleusercontent.com/qZRiTQMHRe5EswI1syqlf0Sf3sfY8bnZjtVhjn89Kh_RxfqZ1WBWTJBnyvnB-gJWsvr6-DsACvVxrPBsj5pSlecxj63iAcVfQTkD=s120",
                        "is_subject_to_whitelist": false,
                        "large_image_url": null,
                        "medium_username": null,
                        "name": "HiDef",
                        "only_proxied_transfers": false,
                        "opensea_buyer_fee_basis_points": "0",
                        "opensea_seller_fee_basis_points": "250",
                        "payout_address": null,
                        "require_email": false,
                        "short_description": null,
                        "slug": "hidef",
                        "telegram_url": null,
                        "twitter_username": null,
                        "instagram_username": null,
                        "wiki_url": null
                    },
                    "decimals": null,
                    "token_metadata": null
                },
                {
                    "id": 20423835,
                    "token_id": "70479185245472823933799012500856922265354379340922944019462782645502669225985",
                    "num_sales": 0,
                    "background_color": null,
                    "image_url": "https://lh3.googleusercontent.com/d--0RQJiGduT6-8KKUSalaAcpzvzX3q812XObJ7sPb5iYszWulXadZhQYvZGP_ZUC-hZUbFxARQlNbg_qWIcylMo-xqP3sGag6erGA",
                    "image_preview_url": "https://lh3.googleusercontent.com/d--0RQJiGduT6-8KKUSalaAcpzvzX3q812XObJ7sPb5iYszWulXadZhQYvZGP_ZUC-hZUbFxARQlNbg_qWIcylMo-xqP3sGag6erGA=s250",
                    "image_thumbnail_url": "https://lh3.googleusercontent.com/d--0RQJiGduT6-8KKUSalaAcpzvzX3q812XObJ7sPb5iYszWulXadZhQYvZGP_ZUC-hZUbFxARQlNbg_qWIcylMo-xqP3sGag6erGA=s128",
                    "image_original_url": null,
                    "animation_url": null,
                    "animation_original_url": null,
                    "name": "HiDef Launch Press Release",
                    "description": "Official Press Release 8 of 10",
                    "external_link": "https://hidef.com/",
                    "asset_contract": {
                        "address": "0x495f947276749ce646f68ac8c248420045cb7b5e",
                        "asset_contract_type": "semi-fungible",
                        "created_date": "2020-12-02T17:40:53.232025",
                        "name": "OpenSea Collection",
                        "nft_version": null,
                        "opensea_version": "2.0.0",
                        "owner": 102384,
                        "schema_name": "ERC1155",
                        "symbol": "OPENSTORE",
                        "total_supply": null,
                        "description": null,
                        "external_link": null,
                        "image_url": null,
                        "default_to_fiat": false,
                        "dev_buyer_fee_basis_points": 0,
                        "dev_seller_fee_basis_points": 0,
                        "only_proxied_transfers": false,
                        "opensea_buyer_fee_basis_points": 0,
                        "opensea_seller_fee_basis_points": 250,
                        "buyer_fee_basis_points": 0,
                        "seller_fee_basis_points": 250,
                        "payout_address": null
                    },
                    "owner": {
                        "user": {
                            "username": "NullAddress"
                        },
                        "profile_img_url": "https://storage.googleapis.com/opensea-static/opensea-profile/1.png",
                        "address": "0x0000000000000000000000000000000000000000",
                        "config": "",
                        "discord_id": ""
                    },
                    "permalink": "https://opensea.io/assets/0x495f947276749ce646f68ac8c248420045cb7b5e/70479185245472823933799012500856922265354379340922944019462782645502669225985",
                    "collection": {
                        "banner_image_url": "https://lh3.googleusercontent.com/i1dLTD9hXZSzeMGz02l202fkMjd3QQrZ2fCQ2TZt-ajo3L931rN_TRGeqU9IvTfm166GIvs5DWaWCKbnuxKq5JmMHLOXioRyCuMxNQ=s2500",
                        "chat_url": null,
                        "created_date": "2021-03-24T00:31:54.219565",
                        "default_to_fiat": false,
                        "description": "",
                        "dev_buyer_fee_basis_points": "0",
                        "dev_seller_fee_basis_points": "0",
                        "discord_url": null,
                        "display_data": {
                            "card_display_style": "contain",
                            "images": []
                        },
                        "external_url": null,
                        "featured": false,
                        "featured_image_url": null,
                        "hidden": true,
                        "safelist_request_status": "not_requested",
                        "image_url": "https://lh3.googleusercontent.com/qZRiTQMHRe5EswI1syqlf0Sf3sfY8bnZjtVhjn89Kh_RxfqZ1WBWTJBnyvnB-gJWsvr6-DsACvVxrPBsj5pSlecxj63iAcVfQTkD=s120",
                        "is_subject_to_whitelist": false,
                        "large_image_url": null,
                        "medium_username": null,
                        "name": "HiDef",
                        "only_proxied_transfers": false,
                        "opensea_buyer_fee_basis_points": "0",
                        "opensea_seller_fee_basis_points": "250",
                        "payout_address": null,
                        "require_email": false,
                        "short_description": null,
                        "slug": "hidef",
                        "telegram_url": null,
                        "twitter_username": null,
                        "instagram_username": null,
                        "wiki_url": null
                    },
                    "decimals": null,
                    "token_metadata": null
                },
                {
                    "id": 20423885,
                    "token_id": "70479185245472823933799012500856922265354379340922944019462782646602180853761",
                    "num_sales": 0,
                    "background_color": null,
                    "image_url": "https://lh3.googleusercontent.com/d--0RQJiGduT6-8KKUSalaAcpzvzX3q812XObJ7sPb5iYszWulXadZhQYvZGP_ZUC-hZUbFxARQlNbg_qWIcylMo-xqP3sGag6erGA",
                    "image_preview_url": "https://lh3.googleusercontent.com/d--0RQJiGduT6-8KKUSalaAcpzvzX3q812XObJ7sPb5iYszWulXadZhQYvZGP_ZUC-hZUbFxARQlNbg_qWIcylMo-xqP3sGag6erGA=s250",
                    "image_thumbnail_url": "https://lh3.googleusercontent.com/d--0RQJiGduT6-8KKUSalaAcpzvzX3q812XObJ7sPb5iYszWulXadZhQYvZGP_ZUC-hZUbFxARQlNbg_qWIcylMo-xqP3sGag6erGA=s128",
                    "image_original_url": null,
                    "animation_url": null,
                    "animation_original_url": null,
                    "name": "HiDef Launch Press Release",
                    "description": "Official Press Release 9 of 10",
                    "external_link": "https://hidef.com/",
                    "asset_contract": {
                        "address": "0x495f947276749ce646f68ac8c248420045cb7b5e",
                        "asset_contract_type": "semi-fungible",
                        "created_date": "2020-12-02T17:40:53.232025",
                        "name": "OpenSea Collection",
                        "nft_version": null,
                        "opensea_version": "2.0.0",
                        "owner": 102384,
                        "schema_name": "ERC1155",
                        "symbol": "OPENSTORE",
                        "total_supply": null,
                        "description": null,
                        "external_link": null,
                        "image_url": null,
                        "default_to_fiat": false,
                        "dev_buyer_fee_basis_points": 0,
                        "dev_seller_fee_basis_points": 0,
                        "only_proxied_transfers": false,
                        "opensea_buyer_fee_basis_points": 0,
                        "opensea_seller_fee_basis_points": 250,
                        "buyer_fee_basis_points": 0,
                        "seller_fee_basis_points": 250,
                        "payout_address": null
                    },
                    "owner": {
                        "user": {
                            "username": "NullAddress"
                        },
                        "profile_img_url": "https://storage.googleapis.com/opensea-static/opensea-profile/1.png",
                        "address": "0x0000000000000000000000000000000000000000",
                        "config": "",
                        "discord_id": ""
                    },
                    "permalink": "https://opensea.io/assets/0x495f947276749ce646f68ac8c248420045cb7b5e/70479185245472823933799012500856922265354379340922944019462782646602180853761",
                    "collection": {
                        "banner_image_url": "https://lh3.googleusercontent.com/i1dLTD9hXZSzeMGz02l202fkMjd3QQrZ2fCQ2TZt-ajo3L931rN_TRGeqU9IvTfm166GIvs5DWaWCKbnuxKq5JmMHLOXioRyCuMxNQ=s2500",
                        "chat_url": null,
                        "created_date": "2021-03-24T00:31:54.219565",
                        "default_to_fiat": false,
                        "description": "",
                        "dev_buyer_fee_basis_points": "0",
                        "dev_seller_fee_basis_points": "0",
                        "discord_url": null,
                        "display_data": {
                            "card_display_style": "contain",
                            "images": []
                        },
                        "external_url": null,
                        "featured": false,
                        "featured_image_url": null,
                        "hidden": true,
                        "safelist_request_status": "not_requested",
                        "image_url": "https://lh3.googleusercontent.com/qZRiTQMHRe5EswI1syqlf0Sf3sfY8bnZjtVhjn89Kh_RxfqZ1WBWTJBnyvnB-gJWsvr6-DsACvVxrPBsj5pSlecxj63iAcVfQTkD=s120",
                        "is_subject_to_whitelist": false,
                        "large_image_url": null,
                        "medium_username": null,
                        "name": "HiDef",
                        "only_proxied_transfers": false,
                        "opensea_buyer_fee_basis_points": "0",
                        "opensea_seller_fee_basis_points": "250",
                        "payout_address": null,
                        "require_email": false,
                        "short_description": null,
                        "slug": "hidef",
                        "telegram_url": null,
                        "twitter_username": null,
                        "instagram_username": null,
                        "wiki_url": null
                    },
                    "decimals": null,
                    "token_metadata": null
                },
                {
                    "id": 20423917,
                    "token_id": "70479185245472823933799012500856922265354379340922944019462782647701692481537",
                    "num_sales": 0,
                    "background_color": null,
                    "image_url": "https://lh3.googleusercontent.com/d--0RQJiGduT6-8KKUSalaAcpzvzX3q812XObJ7sPb5iYszWulXadZhQYvZGP_ZUC-hZUbFxARQlNbg_qWIcylMo-xqP3sGag6erGA",
                    "image_preview_url": "https://lh3.googleusercontent.com/d--0RQJiGduT6-8KKUSalaAcpzvzX3q812XObJ7sPb5iYszWulXadZhQYvZGP_ZUC-hZUbFxARQlNbg_qWIcylMo-xqP3sGag6erGA=s250",
                    "image_thumbnail_url": "https://lh3.googleusercontent.com/d--0RQJiGduT6-8KKUSalaAcpzvzX3q812XObJ7sPb5iYszWulXadZhQYvZGP_ZUC-hZUbFxARQlNbg_qWIcylMo-xqP3sGag6erGA=s128",
                    "image_original_url": null,
                    "animation_url": null,
                    "animation_original_url": null,
                    "name": "HiDef Launch Press Release",
                    "description": "Official Press Release 10 of 10",
                    "external_link": "https://hidef.com/",
                    "asset_contract": {
                        "address": "0x495f947276749ce646f68ac8c248420045cb7b5e",
                        "asset_contract_type": "semi-fungible",
                        "created_date": "2020-12-02T17:40:53.232025",
                        "name": "OpenSea Collection",
                        "nft_version": null,
                        "opensea_version": "2.0.0",
                        "owner": 102384,
                        "schema_name": "ERC1155",
                        "symbol": "OPENSTORE",
                        "total_supply": null,
                        "description": null,
                        "external_link": null,
                        "image_url": null,
                        "default_to_fiat": false,
                        "dev_buyer_fee_basis_points": 0,
                        "dev_seller_fee_basis_points": 0,
                        "only_proxied_transfers": false,
                        "opensea_buyer_fee_basis_points": 0,
                        "opensea_seller_fee_basis_points": 250,
                        "buyer_fee_basis_points": 0,
                        "seller_fee_basis_points": 250,
                        "payout_address": null
                    },
                    "owner": {
                        "user": {
                            "username": "NullAddress"
                        },
                        "profile_img_url": "https://storage.googleapis.com/opensea-static/opensea-profile/1.png",
                        "address": "0x0000000000000000000000000000000000000000",
                        "config": "",
                        "discord_id": ""
                    },
                    "permalink": "https://opensea.io/assets/0x495f947276749ce646f68ac8c248420045cb7b5e/70479185245472823933799012500856922265354379340922944019462782647701692481537",
                    "collection": {
                        "banner_image_url": "https://lh3.googleusercontent.com/i1dLTD9hXZSzeMGz02l202fkMjd3QQrZ2fCQ2TZt-ajo3L931rN_TRGeqU9IvTfm166GIvs5DWaWCKbnuxKq5JmMHLOXioRyCuMxNQ=s2500",
                        "chat_url": null,
                        "created_date": "2021-03-24T00:31:54.219565",
                        "default_to_fiat": false,
                        "description": "",
                        "dev_buyer_fee_basis_points": "0",
                        "dev_seller_fee_basis_points": "0",
                        "discord_url": null,
                        "display_data": {
                            "card_display_style": "contain",
                            "images": []
                        },
                        "external_url": null,
                        "featured": false,
                        "featured_image_url": null,
                        "hidden": true,
                        "safelist_request_status": "not_requested",
                        "image_url": "https://lh3.googleusercontent.com/qZRiTQMHRe5EswI1syqlf0Sf3sfY8bnZjtVhjn89Kh_RxfqZ1WBWTJBnyvnB-gJWsvr6-DsACvVxrPBsj5pSlecxj63iAcVfQTkD=s120",
                        "is_subject_to_whitelist": false,
                        "large_image_url": null,
                        "medium_username": null,
                        "name": "HiDef",
                        "only_proxied_transfers": false,
                        "opensea_buyer_fee_basis_points": "0",
                        "opensea_seller_fee_basis_points": "250",
                        "payout_address": null,
                        "require_email": false,
                        "short_description": null,
                        "slug": "hidef",
                        "telegram_url": null,
                        "twitter_username": null,
                        "instagram_username": null,
                        "wiki_url": null
                    },
                    "decimals": null,
                    "token_metadata": null
                }
            ],
            "name": "HiDef Launch Press Release",
            "description": "",
            "external_link": "",
            "asset_contract": {
                "collection": {
                    "banner_image_url": null,
                    "chat_url": null,
                    "created_date": "2020-12-02T17:40:53.507540",
                    "default_to_fiat": false,
                    "description": null,
                    "dev_buyer_fee_basis_points": "0",
                    "dev_seller_fee_basis_points": "0",
                    "discord_url": null,
                    "display_data": {
                        "card_display_style": "contain",
                        "images": []
                    },
                    "external_url": null,
                    "featured": false,
                    "featured_image_url": null,
                    "hidden": true,
                    "safelist_request_status": "not_requested",
                    "image_url": null,
                    "is_subject_to_whitelist": false,
                    "large_image_url": null,
                    "medium_username": null,
                    "name": "OpenSea Shared Storefront V2",
                    "only_proxied_transfers": false,
                    "opensea_buyer_fee_basis_points": "0",
                    "opensea_seller_fee_basis_points": "250",
                    "payout_address": null,
                    "require_email": false,
                    "short_description": null,
                    "slug": "opensea-shared-storefront-v2",
                    "telegram_url": null,
                    "twitter_username": null,
                    "instagram_username": null,
                    "wiki_url": null
                },
                "address": "0x495f947276749ce646f68ac8c248420045cb7b5e",
                "asset_contract_type": "semi-fungible",
                "created_date": "2020-12-02T17:40:53.232025",
                "name": "OpenSea Collection",
                "nft_version": null,
                "opensea_version": "2.0.0",
                "owner": 102384,
                "schema_name": "ERC1155",
                "symbol": "OPENSTORE",
                "total_supply": null,
                "description": null,
                "external_link": null,
                "image_url": null,
                "default_to_fiat": false,
                "dev_buyer_fee_basis_points": 0,
                "dev_seller_fee_basis_points": 0,
                "only_proxied_transfers": false,
                "opensea_buyer_fee_basis_points": 0,
                "opensea_seller_fee_basis_points": 250,
                "buyer_fee_basis_points": 0,
                "seller_fee_basis_points": 250,
                "payout_address": null
            },
            "permalink": "https://opensea.io/bundles/hidef-launch-press-release-Hhm",
            "sell_orders": []
        },
        {
            "maker": {
                "user": {
                    "username": "REVOLT"
                },
                "profile_img_url": "https://storage.googleapis.com/opensea-static/opensea-profile/25.png",
                "address": "0xb6d820e80a2a7c49f94c9d6c8ea08dccedc9ce4c",
                "config": "",
                "discord_id": ""
            },
            "slug": "small-estate-9-lands-8WN",
            "assets": [
                {
                    "id": 15816009,
                    "token_id": "79893",
                    "num_sales": 0,
                    "background_color": null,
                    "image_url": "https://lh3.googleusercontent.com/17vU_UNWeMOVi4XOAwo4nvAXpeg1dnKPBk8VnAhJcFHOFZ9UBBvSL5Spj0ytvyfII3rdp4gHMY0mMvbnSzjdOZ0",
                    "image_preview_url": "https://lh3.googleusercontent.com/17vU_UNWeMOVi4XOAwo4nvAXpeg1dnKPBk8VnAhJcFHOFZ9UBBvSL5Spj0ytvyfII3rdp4gHMY0mMvbnSzjdOZ0=s250",
                    "image_thumbnail_url": "https://lh3.googleusercontent.com/17vU_UNWeMOVi4XOAwo4nvAXpeg1dnKPBk8VnAhJcFHOFZ9UBBvSL5Spj0ytvyfII3rdp4gHMY0mMvbnSzjdOZ0=s128",
                    "image_original_url": "https://storage.googleapis.com/opensea-static/custom-fetcher-images/sandbox/land/sandbox-land.png",
                    "animation_url": null,
                    "animation_original_url": null,
                    "name": "LAND (129, -9)",
                    "description": "A LAND is a digital piece of real estate in The Sandbox metaverse that players can buy to build experiences on top of. Once you own a LAND, you will be able to populate it with Games and Assets. Each LAND is a unique (non-fungible) token lying on the public Ethereum blockchain (ERC-721).",
                    "external_link": "https://www.sandbox.game/en/map/?x=129&y=-9",
                    "asset_contract": {
                        "address": "0x50f5474724e0ee42d9a4e711ccfb275809fd6d4a",
                        "asset_contract_type": "non-fungible",
                        "created_date": "2019-12-04T10:58:28.892990",
                        "name": "Sandbox's LANDs",
                        "nft_version": "3.0",
                        "opensea_version": null,
                        "owner": null,
                        "schema_name": "ERC721",
                        "symbol": "",
                        "total_supply": null,
                        "description": "The Sandbox is a community-driven platform where creators can monetize voxel assets and gaming experiences on the blockchain. The Sandbox metaverse comprises a map made up of 166,464 LANDS.  LAND owners can host contests and events, stake SAND to earn and customize assets, monetize assets and experiences, vote in the metaverse governance, play games that you or others create, and more! Trade the collection and keep your eyes peeled for future drops.",
                        "external_link": "https://www.sandbox.game/",
                        "image_url": "https://lh3.googleusercontent.com/SXH8tW1siikB80rwCRnjm1a5xM_MwTg9Xl9Db6mioIk9HIlDM09pVoSR7GKJgS6ulSUpgW9BDtMk_ePX_NKgO9A=s60",
                        "default_to_fiat": false,
                        "dev_buyer_fee_basis_points": 0,
                        "dev_seller_fee_basis_points": 500,
                        "only_proxied_transfers": false,
                        "opensea_buyer_fee_basis_points": 0,
                        "opensea_seller_fee_basis_points": 250,
                        "buyer_fee_basis_points": 0,
                        "seller_fee_basis_points": 750,
                        "payout_address": "0x7a9fe22691c811ea339d9b73150e6911a5343dca"
                    },
                    "owner": {
                        "user": {
                            "username": "REVOLT"
                        },
                        "profile_img_url": "https://storage.googleapis.com/opensea-static/opensea-profile/25.png",
                        "address": "0xb6d820e80a2a7c49f94c9d6c8ea08dccedc9ce4c",
                        "config": "",
                        "discord_id": ""
                    },
                    "permalink": "https://opensea.io/assets/0x50f5474724e0ee42d9a4e711ccfb275809fd6d4a/79893",
                    "collection": {
                        "banner_image_url": "https://lh3.googleusercontent.com/4NQIRoGmzXeXQN4mjuhWuuDZSNW7_BqRXux5upd4Nn_A-bfsGxCnPF8qn98Y6MyHRDPGXIlgfZADcSOe6M2DyrDKXdbdaTgkZN5l=s2500",
                        "chat_url": null,
                        "created_date": "2019-12-04T10:58:29.069907",
                        "default_to_fiat": false,
                        "description": "The Sandbox is a community-driven platform where creators can monetize voxel assets and gaming experiences on the blockchain. The Sandbox metaverse comprises a map made up of 166,464 LANDS.  LAND owners can host contests and events, stake SAND to earn and customize assets, monetize assets and experiences, vote in the metaverse governance, play games that you or others create, and more! Trade the collection and keep your eyes peeled for future drops.",
                        "dev_buyer_fee_basis_points": "0",
                        "dev_seller_fee_basis_points": "500",
                        "discord_url": "https://discord.gg/vAe4zvY",
                        "display_data": {
                            "card_display_style": "contain"
                        },
                        "external_url": "https://www.sandbox.game/",
                        "featured": false,
                        "featured_image_url": "https://storage.googleapis.com/opensea-static/featured-images/sandbox-featured.png",
                        "hidden": false,
                        "safelist_request_status": "verified",
                        "image_url": "https://lh3.googleusercontent.com/SXH8tW1siikB80rwCRnjm1a5xM_MwTg9Xl9Db6mioIk9HIlDM09pVoSR7GKJgS6ulSUpgW9BDtMk_ePX_NKgO9A=s60",
                        "is_subject_to_whitelist": false,
                        "large_image_url": "https://lh3.googleusercontent.com/SXH8tW1siikB80rwCRnjm1a5xM_MwTg9Xl9Db6mioIk9HIlDM09pVoSR7GKJgS6ulSUpgW9BDtMk_ePX_NKgO9A",
                        "medium_username": "sandbox-game",
                        "name": "The Sandbox",
                        "only_proxied_transfers": false,
                        "opensea_buyer_fee_basis_points": "0",
                        "opensea_seller_fee_basis_points": "250",
                        "payout_address": "0x7a9fe22691c811ea339d9b73150e6911a5343dca",
                        "require_email": false,
                        "short_description": null,
                        "slug": "sandbox",
                        "telegram_url": "https://t.me/sandboxgame",
                        "twitter_username": "thesandboxgame",
                        "instagram_username": null,
                        "wiki_url": null
                    },
                    "decimals": null,
                    "token_metadata": null
                },
                {
                    "id": 15816040,
                    "token_id": "79894",
                    "num_sales": 0,
                    "background_color": null,
                    "image_url": "https://storage.opensea.io/files/3faa959fa75531ac7913a9c9f8361b58.png",
                    "image_preview_url": "https://lh3.googleusercontent.com/17vU_UNWeMOVi4XOAwo4nvAXpeg1dnKPBk8VnAhJcFHOFZ9UBBvSL5Spj0ytvyfII3rdp4gHMY0mMvbnSzjdOZ0=s250",
                    "image_thumbnail_url": "https://lh3.googleusercontent.com/17vU_UNWeMOVi4XOAwo4nvAXpeg1dnKPBk8VnAhJcFHOFZ9UBBvSL5Spj0ytvyfII3rdp4gHMY0mMvbnSzjdOZ0=s128",
                    "image_original_url": "https://storage.googleapis.com/opensea-static/custom-fetcher-images/sandbox/land/sandbox-land.png",
                    "animation_url": null,
                    "animation_original_url": null,
                    "name": "LAND (130, -9)",
                    "description": "A LAND is a digital piece of real estate in The Sandbox metaverse that players can buy to build experiences on top of. Once you own a LAND, you will be able to populate it with Games and Assets. Each LAND is a unique (non-fungible) token lying on the public Ethereum blockchain (ERC-721).",
                    "external_link": "https://www.sandbox.game/en/map/?x=130&y=-9",
                    "asset_contract": {
                        "address": "0x50f5474724e0ee42d9a4e711ccfb275809fd6d4a",
                        "asset_contract_type": "non-fungible",
                        "created_date": "2019-12-04T10:58:28.892990",
                        "name": "Sandbox's LANDs",
                        "nft_version": "3.0",
                        "opensea_version": null,
                        "owner": null,
                        "schema_name": "ERC721",
                        "symbol": "",
                        "total_supply": null,
                        "description": "The Sandbox is a community-driven platform where creators can monetize voxel assets and gaming experiences on the blockchain. The Sandbox metaverse comprises a map made up of 166,464 LANDS.  LAND owners can host contests and events, stake SAND to earn and customize assets, monetize assets and experiences, vote in the metaverse governance, play games that you or others create, and more! Trade the collection and keep your eyes peeled for future drops.",
                        "external_link": "https://www.sandbox.game/",
                        "image_url": "https://lh3.googleusercontent.com/SXH8tW1siikB80rwCRnjm1a5xM_MwTg9Xl9Db6mioIk9HIlDM09pVoSR7GKJgS6ulSUpgW9BDtMk_ePX_NKgO9A=s60",
                        "default_to_fiat": false,
                        "dev_buyer_fee_basis_points": 0,
                        "dev_seller_fee_basis_points": 500,
                        "only_proxied_transfers": false,
                        "opensea_buyer_fee_basis_points": 0,
                        "opensea_seller_fee_basis_points": 250,
                        "buyer_fee_basis_points": 0,
                        "seller_fee_basis_points": 750,
                        "payout_address": "0x7a9fe22691c811ea339d9b73150e6911a5343dca"
                    },
                    "owner": {
                        "user": {
                            "username": "REVOLT"
                        },
                        "profile_img_url": "https://storage.googleapis.com/opensea-static/opensea-profile/25.png",
                        "address": "0xb6d820e80a2a7c49f94c9d6c8ea08dccedc9ce4c",
                        "config": "",
                        "discord_id": ""
                    },
                    "permalink": "https://opensea.io/assets/0x50f5474724e0ee42d9a4e711ccfb275809fd6d4a/79894",
                    "collection": {
                        "banner_image_url": "https://lh3.googleusercontent.com/4NQIRoGmzXeXQN4mjuhWuuDZSNW7_BqRXux5upd4Nn_A-bfsGxCnPF8qn98Y6MyHRDPGXIlgfZADcSOe6M2DyrDKXdbdaTgkZN5l=s2500",
                        "chat_url": null,
                        "created_date": "2019-12-04T10:58:29.069907",
                        "default_to_fiat": false,
                        "description": "The Sandbox is a community-driven platform where creators can monetize voxel assets and gaming experiences on the blockchain. The Sandbox metaverse comprises a map made up of 166,464 LANDS.  LAND owners can host contests and events, stake SAND to earn and customize assets, monetize assets and experiences, vote in the metaverse governance, play games that you or others create, and more! Trade the collection and keep your eyes peeled for future drops.",
                        "dev_buyer_fee_basis_points": "0",
                        "dev_seller_fee_basis_points": "500",
                        "discord_url": "https://discord.gg/vAe4zvY",
                        "display_data": {
                            "card_display_style": "contain"
                        },
                        "external_url": "https://www.sandbox.game/",
                        "featured": false,
                        "featured_image_url": "https://storage.googleapis.com/opensea-static/featured-images/sandbox-featured.png",
                        "hidden": false,
                        "safelist_request_status": "verified",
                        "image_url": "https://lh3.googleusercontent.com/SXH8tW1siikB80rwCRnjm1a5xM_MwTg9Xl9Db6mioIk9HIlDM09pVoSR7GKJgS6ulSUpgW9BDtMk_ePX_NKgO9A=s60",
                        "is_subject_to_whitelist": false,
                        "large_image_url": "https://lh3.googleusercontent.com/SXH8tW1siikB80rwCRnjm1a5xM_MwTg9Xl9Db6mioIk9HIlDM09pVoSR7GKJgS6ulSUpgW9BDtMk_ePX_NKgO9A",
                        "medium_username": "sandbox-game",
                        "name": "The Sandbox",
                        "only_proxied_transfers": false,
                        "opensea_buyer_fee_basis_points": "0",
                        "opensea_seller_fee_basis_points": "250",
                        "payout_address": "0x7a9fe22691c811ea339d9b73150e6911a5343dca",
                        "require_email": false,
                        "short_description": null,
                        "slug": "sandbox",
                        "telegram_url": "https://t.me/sandboxgame",
                        "twitter_username": "thesandboxgame",
                        "instagram_username": null,
                        "wiki_url": null
                    },
                    "decimals": null,
                    "token_metadata": null
                },
                {
                    "id": 15816067,
                    "token_id": "79895",
                    "num_sales": 0,
                    "background_color": null,
                    "image_url": "https://storage.opensea.io/files/3faa959fa75531ac7913a9c9f8361b58.png",
                    "image_preview_url": "https://lh3.googleusercontent.com/17vU_UNWeMOVi4XOAwo4nvAXpeg1dnKPBk8VnAhJcFHOFZ9UBBvSL5Spj0ytvyfII3rdp4gHMY0mMvbnSzjdOZ0=s250",
                    "image_thumbnail_url": "https://lh3.googleusercontent.com/17vU_UNWeMOVi4XOAwo4nvAXpeg1dnKPBk8VnAhJcFHOFZ9UBBvSL5Spj0ytvyfII3rdp4gHMY0mMvbnSzjdOZ0=s128",
                    "image_original_url": "https://storage.googleapis.com/opensea-static/custom-fetcher-images/sandbox/land/sandbox-land.png",
                    "animation_url": null,
                    "animation_original_url": null,
                    "name": "LAND (131, -9)",
                    "description": "A LAND is a digital piece of real estate in The Sandbox metaverse that players can buy to build experiences on top of. Once you own a LAND, you will be able to populate it with Games and Assets. Each LAND is a unique (non-fungible) token lying on the public Ethereum blockchain (ERC-721).",
                    "external_link": "https://www.sandbox.game/en/map/?x=131&y=-9",
                    "asset_contract": {
                        "address": "0x50f5474724e0ee42d9a4e711ccfb275809fd6d4a",
                        "asset_contract_type": "non-fungible",
                        "created_date": "2019-12-04T10:58:28.892990",
                        "name": "Sandbox's LANDs",
                        "nft_version": "3.0",
                        "opensea_version": null,
                        "owner": null,
                        "schema_name": "ERC721",
                        "symbol": "",
                        "total_supply": null,
                        "description": "The Sandbox is a community-driven platform where creators can monetize voxel assets and gaming experiences on the blockchain. The Sandbox metaverse comprises a map made up of 166,464 LANDS.  LAND owners can host contests and events, stake SAND to earn and customize assets, monetize assets and experiences, vote in the metaverse governance, play games that you or others create, and more! Trade the collection and keep your eyes peeled for future drops.",
                        "external_link": "https://www.sandbox.game/",
                        "image_url": "https://lh3.googleusercontent.com/SXH8tW1siikB80rwCRnjm1a5xM_MwTg9Xl9Db6mioIk9HIlDM09pVoSR7GKJgS6ulSUpgW9BDtMk_ePX_NKgO9A=s60",
                        "default_to_fiat": false,
                        "dev_buyer_fee_basis_points": 0,
                        "dev_seller_fee_basis_points": 500,
                        "only_proxied_transfers": false,
                        "opensea_buyer_fee_basis_points": 0,
                        "opensea_seller_fee_basis_points": 250,
                        "buyer_fee_basis_points": 0,
                        "seller_fee_basis_points": 750,
                        "payout_address": "0x7a9fe22691c811ea339d9b73150e6911a5343dca"
                    },
                    "owner": {
                        "user": {
                            "username": "REVOLT"
                        },
                        "profile_img_url": "https://storage.googleapis.com/opensea-static/opensea-profile/25.png",
                        "address": "0xb6d820e80a2a7c49f94c9d6c8ea08dccedc9ce4c",
                        "config": "",
                        "discord_id": ""
                    },
                    "permalink": "https://opensea.io/assets/0x50f5474724e0ee42d9a4e711ccfb275809fd6d4a/79895",
                    "collection": {
                        "banner_image_url": "https://lh3.googleusercontent.com/4NQIRoGmzXeXQN4mjuhWuuDZSNW7_BqRXux5upd4Nn_A-bfsGxCnPF8qn98Y6MyHRDPGXIlgfZADcSOe6M2DyrDKXdbdaTgkZN5l=s2500",
                        "chat_url": null,
                        "created_date": "2019-12-04T10:58:29.069907",
                        "default_to_fiat": false,
                        "description": "The Sandbox is a community-driven platform where creators can monetize voxel assets and gaming experiences on the blockchain. The Sandbox metaverse comprises a map made up of 166,464 LANDS.  LAND owners can host contests and events, stake SAND to earn and customize assets, monetize assets and experiences, vote in the metaverse governance, play games that you or others create, and more! Trade the collection and keep your eyes peeled for future drops.",
                        "dev_buyer_fee_basis_points": "0",
                        "dev_seller_fee_basis_points": "500",
                        "discord_url": "https://discord.gg/vAe4zvY",
                        "display_data": {
                            "card_display_style": "contain"
                        },
                        "external_url": "https://www.sandbox.game/",
                        "featured": false,
                        "featured_image_url": "https://storage.googleapis.com/opensea-static/featured-images/sandbox-featured.png",
                        "hidden": false,
                        "safelist_request_status": "verified",
                        "image_url": "https://lh3.googleusercontent.com/SXH8tW1siikB80rwCRnjm1a5xM_MwTg9Xl9Db6mioIk9HIlDM09pVoSR7GKJgS6ulSUpgW9BDtMk_ePX_NKgO9A=s60",
                        "is_subject_to_whitelist": false,
                        "large_image_url": "https://lh3.googleusercontent.com/SXH8tW1siikB80rwCRnjm1a5xM_MwTg9Xl9Db6mioIk9HIlDM09pVoSR7GKJgS6ulSUpgW9BDtMk_ePX_NKgO9A",
                        "medium_username": "sandbox-game",
                        "name": "The Sandbox",
                        "only_proxied_transfers": false,
                        "opensea_buyer_fee_basis_points": "0",
                        "opensea_seller_fee_basis_points": "250",
                        "payout_address": "0x7a9fe22691c811ea339d9b73150e6911a5343dca",
                        "require_email": false,
                        "short_description": null,
                        "slug": "sandbox",
                        "telegram_url": "https://t.me/sandboxgame",
                        "twitter_username": "thesandboxgame",
                        "instagram_username": null,
                        "wiki_url": null
                    },
                    "decimals": null,
                    "token_metadata": null
                },
                {
                    "id": 15816086,
                    "token_id": "80303",
                    "num_sales": 0,
                    "background_color": null,
                    "image_url": "https://storage.opensea.io/files/3faa959fa75531ac7913a9c9f8361b58.png",
                    "image_preview_url": "https://lh3.googleusercontent.com/17vU_UNWeMOVi4XOAwo4nvAXpeg1dnKPBk8VnAhJcFHOFZ9UBBvSL5Spj0ytvyfII3rdp4gHMY0mMvbnSzjdOZ0=s250",
                    "image_thumbnail_url": "https://lh3.googleusercontent.com/17vU_UNWeMOVi4XOAwo4nvAXpeg1dnKPBk8VnAhJcFHOFZ9UBBvSL5Spj0ytvyfII3rdp4gHMY0mMvbnSzjdOZ0=s128",
                    "image_original_url": "https://storage.googleapis.com/opensea-static/custom-fetcher-images/sandbox/land/sandbox-land.png",
                    "animation_url": null,
                    "animation_original_url": null,
                    "name": "LAND (131, -8)",
                    "description": "A LAND is a digital piece of real estate in The Sandbox metaverse that players can buy to build experiences on top of. Once you own a LAND, you will be able to populate it with Games and Assets. Each LAND is a unique (non-fungible) token lying on the public Ethereum blockchain (ERC-721).",
                    "external_link": "https://www.sandbox.game/en/map/?x=131&y=-8",
                    "asset_contract": {
                        "address": "0x50f5474724e0ee42d9a4e711ccfb275809fd6d4a",
                        "asset_contract_type": "non-fungible",
                        "created_date": "2019-12-04T10:58:28.892990",
                        "name": "Sandbox's LANDs",
                        "nft_version": "3.0",
                        "opensea_version": null,
                        "owner": null,
                        "schema_name": "ERC721",
                        "symbol": "",
                        "total_supply": null,
                        "description": "The Sandbox is a community-driven platform where creators can monetize voxel assets and gaming experiences on the blockchain. The Sandbox metaverse comprises a map made up of 166,464 LANDS.  LAND owners can host contests and events, stake SAND to earn and customize assets, monetize assets and experiences, vote in the metaverse governance, play games that you or others create, and more! Trade the collection and keep your eyes peeled for future drops.",
                        "external_link": "https://www.sandbox.game/",
                        "image_url": "https://lh3.googleusercontent.com/SXH8tW1siikB80rwCRnjm1a5xM_MwTg9Xl9Db6mioIk9HIlDM09pVoSR7GKJgS6ulSUpgW9BDtMk_ePX_NKgO9A=s60",
                        "default_to_fiat": false,
                        "dev_buyer_fee_basis_points": 0,
                        "dev_seller_fee_basis_points": 500,
                        "only_proxied_transfers": false,
                        "opensea_buyer_fee_basis_points": 0,
                        "opensea_seller_fee_basis_points": 250,
                        "buyer_fee_basis_points": 0,
                        "seller_fee_basis_points": 750,
                        "payout_address": "0x7a9fe22691c811ea339d9b73150e6911a5343dca"
                    },
                    "owner": {
                        "user": {
                            "username": "REVOLT"
                        },
                        "profile_img_url": "https://storage.googleapis.com/opensea-static/opensea-profile/25.png",
                        "address": "0xb6d820e80a2a7c49f94c9d6c8ea08dccedc9ce4c",
                        "config": "",
                        "discord_id": ""
                    },
                    "permalink": "https://opensea.io/assets/0x50f5474724e0ee42d9a4e711ccfb275809fd6d4a/80303",
                    "collection": {
                        "banner_image_url": "https://lh3.googleusercontent.com/4NQIRoGmzXeXQN4mjuhWuuDZSNW7_BqRXux5upd4Nn_A-bfsGxCnPF8qn98Y6MyHRDPGXIlgfZADcSOe6M2DyrDKXdbdaTgkZN5l=s2500",
                        "chat_url": null,
                        "created_date": "2019-12-04T10:58:29.069907",
                        "default_to_fiat": false,
                        "description": "The Sandbox is a community-driven platform where creators can monetize voxel assets and gaming experiences on the blockchain. The Sandbox metaverse comprises a map made up of 166,464 LANDS.  LAND owners can host contests and events, stake SAND to earn and customize assets, monetize assets and experiences, vote in the metaverse governance, play games that you or others create, and more! Trade the collection and keep your eyes peeled for future drops.",
                        "dev_buyer_fee_basis_points": "0",
                        "dev_seller_fee_basis_points": "500",
                        "discord_url": "https://discord.gg/vAe4zvY",
                        "display_data": {
                            "card_display_style": "contain"
                        },
                        "external_url": "https://www.sandbox.game/",
                        "featured": false,
                        "featured_image_url": "https://storage.googleapis.com/opensea-static/featured-images/sandbox-featured.png",
                        "hidden": false,
                        "safelist_request_status": "verified",
                        "image_url": "https://lh3.googleusercontent.com/SXH8tW1siikB80rwCRnjm1a5xM_MwTg9Xl9Db6mioIk9HIlDM09pVoSR7GKJgS6ulSUpgW9BDtMk_ePX_NKgO9A=s60",
                        "is_subject_to_whitelist": false,
                        "large_image_url": "https://lh3.googleusercontent.com/SXH8tW1siikB80rwCRnjm1a5xM_MwTg9Xl9Db6mioIk9HIlDM09pVoSR7GKJgS6ulSUpgW9BDtMk_ePX_NKgO9A",
                        "medium_username": "sandbox-game",
                        "name": "The Sandbox",
                        "only_proxied_transfers": false,
                        "opensea_buyer_fee_basis_points": "0",
                        "opensea_seller_fee_basis_points": "250",
                        "payout_address": "0x7a9fe22691c811ea339d9b73150e6911a5343dca",
                        "require_email": false,
                        "short_description": null,
                        "slug": "sandbox",
                        "telegram_url": "https://t.me/sandboxgame",
                        "twitter_username": "thesandboxgame",
                        "instagram_username": null,
                        "wiki_url": null
                    },
                    "decimals": null,
                    "token_metadata": null
                },
                {
                    "id": 15816103,
                    "token_id": "80302",
                    "num_sales": 0,
                    "background_color": null,
                    "image_url": "https://storage.opensea.io/files/3faa959fa75531ac7913a9c9f8361b58.png",
                    "image_preview_url": "https://lh3.googleusercontent.com/17vU_UNWeMOVi4XOAwo4nvAXpeg1dnKPBk8VnAhJcFHOFZ9UBBvSL5Spj0ytvyfII3rdp4gHMY0mMvbnSzjdOZ0=s250",
                    "image_thumbnail_url": "https://lh3.googleusercontent.com/17vU_UNWeMOVi4XOAwo4nvAXpeg1dnKPBk8VnAhJcFHOFZ9UBBvSL5Spj0ytvyfII3rdp4gHMY0mMvbnSzjdOZ0=s128",
                    "image_original_url": "https://storage.googleapis.com/opensea-static/custom-fetcher-images/sandbox/land/sandbox-land.png",
                    "animation_url": null,
                    "animation_original_url": null,
                    "name": "LAND (130, -8)",
                    "description": "A LAND is a digital piece of real estate in The Sandbox metaverse that players can buy to build experiences on top of. Once you own a LAND, you will be able to populate it with Games and Assets. Each LAND is a unique (non-fungible) token lying on the public Ethereum blockchain (ERC-721).",
                    "external_link": "https://www.sandbox.game/en/map/?x=130&y=-8",
                    "asset_contract": {
                        "address": "0x50f5474724e0ee42d9a4e711ccfb275809fd6d4a",
                        "asset_contract_type": "non-fungible",
                        "created_date": "2019-12-04T10:58:28.892990",
                        "name": "Sandbox's LANDs",
                        "nft_version": "3.0",
                        "opensea_version": null,
                        "owner": null,
                        "schema_name": "ERC721",
                        "symbol": "",
                        "total_supply": null,
                        "description": "The Sandbox is a community-driven platform where creators can monetize voxel assets and gaming experiences on the blockchain. The Sandbox metaverse comprises a map made up of 166,464 LANDS.  LAND owners can host contests and events, stake SAND to earn and customize assets, monetize assets and experiences, vote in the metaverse governance, play games that you or others create, and more! Trade the collection and keep your eyes peeled for future drops.",
                        "external_link": "https://www.sandbox.game/",
                        "image_url": "https://lh3.googleusercontent.com/SXH8tW1siikB80rwCRnjm1a5xM_MwTg9Xl9Db6mioIk9HIlDM09pVoSR7GKJgS6ulSUpgW9BDtMk_ePX_NKgO9A=s60",
                        "default_to_fiat": false,
                        "dev_buyer_fee_basis_points": 0,
                        "dev_seller_fee_basis_points": 500,
                        "only_proxied_transfers": false,
                        "opensea_buyer_fee_basis_points": 0,
                        "opensea_seller_fee_basis_points": 250,
                        "buyer_fee_basis_points": 0,
                        "seller_fee_basis_points": 750,
                        "payout_address": "0x7a9fe22691c811ea339d9b73150e6911a5343dca"
                    },
                    "owner": {
                        "user": {
                            "username": "REVOLT"
                        },
                        "profile_img_url": "https://storage.googleapis.com/opensea-static/opensea-profile/25.png",
                        "address": "0xb6d820e80a2a7c49f94c9d6c8ea08dccedc9ce4c",
                        "config": "",
                        "discord_id": ""
                    },
                    "permalink": "https://opensea.io/assets/0x50f5474724e0ee42d9a4e711ccfb275809fd6d4a/80302",
                    "collection": {
                        "banner_image_url": "https://lh3.googleusercontent.com/4NQIRoGmzXeXQN4mjuhWuuDZSNW7_BqRXux5upd4Nn_A-bfsGxCnPF8qn98Y6MyHRDPGXIlgfZADcSOe6M2DyrDKXdbdaTgkZN5l=s2500",
                        "chat_url": null,
                        "created_date": "2019-12-04T10:58:29.069907",
                        "default_to_fiat": false,
                        "description": "The Sandbox is a community-driven platform where creators can monetize voxel assets and gaming experiences on the blockchain. The Sandbox metaverse comprises a map made up of 166,464 LANDS.  LAND owners can host contests and events, stake SAND to earn and customize assets, monetize assets and experiences, vote in the metaverse governance, play games that you or others create, and more! Trade the collection and keep your eyes peeled for future drops.",
                        "dev_buyer_fee_basis_points": "0",
                        "dev_seller_fee_basis_points": "500",
                        "discord_url": "https://discord.gg/vAe4zvY",
                        "display_data": {
                            "card_display_style": "contain"
                        },
                        "external_url": "https://www.sandbox.game/",
                        "featured": false,
                        "featured_image_url": "https://storage.googleapis.com/opensea-static/featured-images/sandbox-featured.png",
                        "hidden": false,
                        "safelist_request_status": "verified",
                        "image_url": "https://lh3.googleusercontent.com/SXH8tW1siikB80rwCRnjm1a5xM_MwTg9Xl9Db6mioIk9HIlDM09pVoSR7GKJgS6ulSUpgW9BDtMk_ePX_NKgO9A=s60",
                        "is_subject_to_whitelist": false,
                        "large_image_url": "https://lh3.googleusercontent.com/SXH8tW1siikB80rwCRnjm1a5xM_MwTg9Xl9Db6mioIk9HIlDM09pVoSR7GKJgS6ulSUpgW9BDtMk_ePX_NKgO9A",
                        "medium_username": "sandbox-game",
                        "name": "The Sandbox",
                        "only_proxied_transfers": false,
                        "opensea_buyer_fee_basis_points": "0",
                        "opensea_seller_fee_basis_points": "250",
                        "payout_address": "0x7a9fe22691c811ea339d9b73150e6911a5343dca",
                        "require_email": false,
                        "short_description": null,
                        "slug": "sandbox",
                        "telegram_url": "https://t.me/sandboxgame",
                        "twitter_username": "thesandboxgame",
                        "instagram_username": null,
                        "wiki_url": null
                    },
                    "decimals": null,
                    "token_metadata": null
                },
                {
                    "id": 15816127,
                    "token_id": "80301",
                    "num_sales": 0,
                    "background_color": null,
                    "image_url": "https://lh3.googleusercontent.com/17vU_UNWeMOVi4XOAwo4nvAXpeg1dnKPBk8VnAhJcFHOFZ9UBBvSL5Spj0ytvyfII3rdp4gHMY0mMvbnSzjdOZ0",
                    "image_preview_url": "https://lh3.googleusercontent.com/17vU_UNWeMOVi4XOAwo4nvAXpeg1dnKPBk8VnAhJcFHOFZ9UBBvSL5Spj0ytvyfII3rdp4gHMY0mMvbnSzjdOZ0=s250",
                    "image_thumbnail_url": "https://lh3.googleusercontent.com/17vU_UNWeMOVi4XOAwo4nvAXpeg1dnKPBk8VnAhJcFHOFZ9UBBvSL5Spj0ytvyfII3rdp4gHMY0mMvbnSzjdOZ0=s128",
                    "image_original_url": "https://storage.googleapis.com/opensea-static/custom-fetcher-images/sandbox/land/sandbox-land.png",
                    "animation_url": null,
                    "animation_original_url": null,
                    "name": "LAND (129, -8)",
                    "description": "A LAND is a digital piece of real estate in The Sandbox metaverse that players can buy to build experiences on top of. Once you own a LAND, you will be able to populate it with Games and Assets. Each LAND is a unique (non-fungible) token lying on the public Ethereum blockchain (ERC-721).",
                    "external_link": "https://www.sandbox.game/en/map/?x=129&y=-8",
                    "asset_contract": {
                        "address": "0x50f5474724e0ee42d9a4e711ccfb275809fd6d4a",
                        "asset_contract_type": "non-fungible",
                        "created_date": "2019-12-04T10:58:28.892990",
                        "name": "Sandbox's LANDs",
                        "nft_version": "3.0",
                        "opensea_version": null,
                        "owner": null,
                        "schema_name": "ERC721",
                        "symbol": "",
                        "total_supply": null,
                        "description": "The Sandbox is a community-driven platform where creators can monetize voxel assets and gaming experiences on the blockchain. The Sandbox metaverse comprises a map made up of 166,464 LANDS.  LAND owners can host contests and events, stake SAND to earn and customize assets, monetize assets and experiences, vote in the metaverse governance, play games that you or others create, and more! Trade the collection and keep your eyes peeled for future drops.",
                        "external_link": "https://www.sandbox.game/",
                        "image_url": "https://lh3.googleusercontent.com/SXH8tW1siikB80rwCRnjm1a5xM_MwTg9Xl9Db6mioIk9HIlDM09pVoSR7GKJgS6ulSUpgW9BDtMk_ePX_NKgO9A=s60",
                        "default_to_fiat": false,
                        "dev_buyer_fee_basis_points": 0,
                        "dev_seller_fee_basis_points": 500,
                        "only_proxied_transfers": false,
                        "opensea_buyer_fee_basis_points": 0,
                        "opensea_seller_fee_basis_points": 250,
                        "buyer_fee_basis_points": 0,
                        "seller_fee_basis_points": 750,
                        "payout_address": "0x7a9fe22691c811ea339d9b73150e6911a5343dca"
                    },
                    "owner": {
                        "user": {
                            "username": "REVOLT"
                        },
                        "profile_img_url": "https://storage.googleapis.com/opensea-static/opensea-profile/25.png",
                        "address": "0xb6d820e80a2a7c49f94c9d6c8ea08dccedc9ce4c",
                        "config": "",
                        "discord_id": ""
                    },
                    "permalink": "https://opensea.io/assets/0x50f5474724e0ee42d9a4e711ccfb275809fd6d4a/80301",
                    "collection": {
                        "banner_image_url": "https://lh3.googleusercontent.com/4NQIRoGmzXeXQN4mjuhWuuDZSNW7_BqRXux5upd4Nn_A-bfsGxCnPF8qn98Y6MyHRDPGXIlgfZADcSOe6M2DyrDKXdbdaTgkZN5l=s2500",
                        "chat_url": null,
                        "created_date": "2019-12-04T10:58:29.069907",
                        "default_to_fiat": false,
                        "description": "The Sandbox is a community-driven platform where creators can monetize voxel assets and gaming experiences on the blockchain. The Sandbox metaverse comprises a map made up of 166,464 LANDS.  LAND owners can host contests and events, stake SAND to earn and customize assets, monetize assets and experiences, vote in the metaverse governance, play games that you or others create, and more! Trade the collection and keep your eyes peeled for future drops.",
                        "dev_buyer_fee_basis_points": "0",
                        "dev_seller_fee_basis_points": "500",
                        "discord_url": "https://discord.gg/vAe4zvY",
                        "display_data": {
                            "card_display_style": "contain"
                        },
                        "external_url": "https://www.sandbox.game/",
                        "featured": false,
                        "featured_image_url": "https://storage.googleapis.com/opensea-static/featured-images/sandbox-featured.png",
                        "hidden": false,
                        "safelist_request_status": "verified",
                        "image_url": "https://lh3.googleusercontent.com/SXH8tW1siikB80rwCRnjm1a5xM_MwTg9Xl9Db6mioIk9HIlDM09pVoSR7GKJgS6ulSUpgW9BDtMk_ePX_NKgO9A=s60",
                        "is_subject_to_whitelist": false,
                        "large_image_url": "https://lh3.googleusercontent.com/SXH8tW1siikB80rwCRnjm1a5xM_MwTg9Xl9Db6mioIk9HIlDM09pVoSR7GKJgS6ulSUpgW9BDtMk_ePX_NKgO9A",
                        "medium_username": "sandbox-game",
                        "name": "The Sandbox",
                        "only_proxied_transfers": false,
                        "opensea_buyer_fee_basis_points": "0",
                        "opensea_seller_fee_basis_points": "250",
                        "payout_address": "0x7a9fe22691c811ea339d9b73150e6911a5343dca",
                        "require_email": false,
                        "short_description": null,
                        "slug": "sandbox",
                        "telegram_url": "https://t.me/sandboxgame",
                        "twitter_username": "thesandboxgame",
                        "instagram_username": null,
                        "wiki_url": null
                    },
                    "decimals": null,
                    "token_metadata": null
                },
                {
                    "id": 15816148,
                    "token_id": "80709",
                    "num_sales": 0,
                    "background_color": null,
                    "image_url": "https://lh3.googleusercontent.com/17vU_UNWeMOVi4XOAwo4nvAXpeg1dnKPBk8VnAhJcFHOFZ9UBBvSL5Spj0ytvyfII3rdp4gHMY0mMvbnSzjdOZ0",
                    "image_preview_url": "https://lh3.googleusercontent.com/17vU_UNWeMOVi4XOAwo4nvAXpeg1dnKPBk8VnAhJcFHOFZ9UBBvSL5Spj0ytvyfII3rdp4gHMY0mMvbnSzjdOZ0=s250",
                    "image_thumbnail_url": "https://lh3.googleusercontent.com/17vU_UNWeMOVi4XOAwo4nvAXpeg1dnKPBk8VnAhJcFHOFZ9UBBvSL5Spj0ytvyfII3rdp4gHMY0mMvbnSzjdOZ0=s128",
                    "image_original_url": "https://storage.googleapis.com/opensea-static/custom-fetcher-images/sandbox/land/sandbox-land.png",
                    "animation_url": null,
                    "animation_original_url": null,
                    "name": "LAND (129, -7)",
                    "description": "A LAND is a digital piece of real estate in The Sandbox metaverse that players can buy to build experiences on top of. Once you own a LAND, you will be able to populate it with Games and Assets. Each LAND is a unique (non-fungible) token lying on the public Ethereum blockchain (ERC-721).",
                    "external_link": "https://www.sandbox.game/en/map/?x=129&y=-7",
                    "asset_contract": {
                        "address": "0x50f5474724e0ee42d9a4e711ccfb275809fd6d4a",
                        "asset_contract_type": "non-fungible",
                        "created_date": "2019-12-04T10:58:28.892990",
                        "name": "Sandbox's LANDs",
                        "nft_version": "3.0",
                        "opensea_version": null,
                        "owner": null,
                        "schema_name": "ERC721",
                        "symbol": "",
                        "total_supply": null,
                        "description": "The Sandbox is a community-driven platform where creators can monetize voxel assets and gaming experiences on the blockchain. The Sandbox metaverse comprises a map made up of 166,464 LANDS.  LAND owners can host contests and events, stake SAND to earn and customize assets, monetize assets and experiences, vote in the metaverse governance, play games that you or others create, and more! Trade the collection and keep your eyes peeled for future drops.",
                        "external_link": "https://www.sandbox.game/",
                        "image_url": "https://lh3.googleusercontent.com/SXH8tW1siikB80rwCRnjm1a5xM_MwTg9Xl9Db6mioIk9HIlDM09pVoSR7GKJgS6ulSUpgW9BDtMk_ePX_NKgO9A=s60",
                        "default_to_fiat": false,
                        "dev_buyer_fee_basis_points": 0,
                        "dev_seller_fee_basis_points": 500,
                        "only_proxied_transfers": false,
                        "opensea_buyer_fee_basis_points": 0,
                        "opensea_seller_fee_basis_points": 250,
                        "buyer_fee_basis_points": 0,
                        "seller_fee_basis_points": 750,
                        "payout_address": "0x7a9fe22691c811ea339d9b73150e6911a5343dca"
                    },
                    "owner": {
                        "user": {
                            "username": "REVOLT"
                        },
                        "profile_img_url": "https://storage.googleapis.com/opensea-static/opensea-profile/25.png",
                        "address": "0xb6d820e80a2a7c49f94c9d6c8ea08dccedc9ce4c",
                        "config": "",
                        "discord_id": ""
                    },
                    "permalink": "https://opensea.io/assets/0x50f5474724e0ee42d9a4e711ccfb275809fd6d4a/80709",
                    "collection": {
                        "banner_image_url": "https://lh3.googleusercontent.com/4NQIRoGmzXeXQN4mjuhWuuDZSNW7_BqRXux5upd4Nn_A-bfsGxCnPF8qn98Y6MyHRDPGXIlgfZADcSOe6M2DyrDKXdbdaTgkZN5l=s2500",
                        "chat_url": null,
                        "created_date": "2019-12-04T10:58:29.069907",
                        "default_to_fiat": false,
                        "description": "The Sandbox is a community-driven platform where creators can monetize voxel assets and gaming experiences on the blockchain. The Sandbox metaverse comprises a map made up of 166,464 LANDS.  LAND owners can host contests and events, stake SAND to earn and customize assets, monetize assets and experiences, vote in the metaverse governance, play games that you or others create, and more! Trade the collection and keep your eyes peeled for future drops.",
                        "dev_buyer_fee_basis_points": "0",
                        "dev_seller_fee_basis_points": "500",
                        "discord_url": "https://discord.gg/vAe4zvY",
                        "display_data": {
                            "card_display_style": "contain"
                        },
                        "external_url": "https://www.sandbox.game/",
                        "featured": false,
                        "featured_image_url": "https://storage.googleapis.com/opensea-static/featured-images/sandbox-featured.png",
                        "hidden": false,
                        "safelist_request_status": "verified",
                        "image_url": "https://lh3.googleusercontent.com/SXH8tW1siikB80rwCRnjm1a5xM_MwTg9Xl9Db6mioIk9HIlDM09pVoSR7GKJgS6ulSUpgW9BDtMk_ePX_NKgO9A=s60",
                        "is_subject_to_whitelist": false,
                        "large_image_url": "https://lh3.googleusercontent.com/SXH8tW1siikB80rwCRnjm1a5xM_MwTg9Xl9Db6mioIk9HIlDM09pVoSR7GKJgS6ulSUpgW9BDtMk_ePX_NKgO9A",
                        "medium_username": "sandbox-game",
                        "name": "The Sandbox",
                        "only_proxied_transfers": false,
                        "opensea_buyer_fee_basis_points": "0",
                        "opensea_seller_fee_basis_points": "250",
                        "payout_address": "0x7a9fe22691c811ea339d9b73150e6911a5343dca",
                        "require_email": false,
                        "short_description": null,
                        "slug": "sandbox",
                        "telegram_url": "https://t.me/sandboxgame",
                        "twitter_username": "thesandboxgame",
                        "instagram_username": null,
                        "wiki_url": null
                    },
                    "decimals": null,
                    "token_metadata": null
                },
                {
                    "id": 15816169,
                    "token_id": "80710",
                    "num_sales": 0,
                    "background_color": null,
                    "image_url": "https://lh3.googleusercontent.com/17vU_UNWeMOVi4XOAwo4nvAXpeg1dnKPBk8VnAhJcFHOFZ9UBBvSL5Spj0ytvyfII3rdp4gHMY0mMvbnSzjdOZ0",
                    "image_preview_url": "https://lh3.googleusercontent.com/17vU_UNWeMOVi4XOAwo4nvAXpeg1dnKPBk8VnAhJcFHOFZ9UBBvSL5Spj0ytvyfII3rdp4gHMY0mMvbnSzjdOZ0=s250",
                    "image_thumbnail_url": "https://lh3.googleusercontent.com/17vU_UNWeMOVi4XOAwo4nvAXpeg1dnKPBk8VnAhJcFHOFZ9UBBvSL5Spj0ytvyfII3rdp4gHMY0mMvbnSzjdOZ0=s128",
                    "image_original_url": "https://storage.googleapis.com/opensea-static/custom-fetcher-images/sandbox/land/sandbox-land.png",
                    "animation_url": null,
                    "animation_original_url": null,
                    "name": "LAND (130, -7)",
                    "description": "A LAND is a digital piece of real estate in The Sandbox metaverse that players can buy to build experiences on top of. Once you own a LAND, you will be able to populate it with Games and Assets. Each LAND is a unique (non-fungible) token lying on the public Ethereum blockchain (ERC-721).",
                    "external_link": "https://www.sandbox.game/en/map/?x=130&y=-7",
                    "asset_contract": {
                        "address": "0x50f5474724e0ee42d9a4e711ccfb275809fd6d4a",
                        "asset_contract_type": "non-fungible",
                        "created_date": "2019-12-04T10:58:28.892990",
                        "name": "Sandbox's LANDs",
                        "nft_version": "3.0",
                        "opensea_version": null,
                        "owner": null,
                        "schema_name": "ERC721",
                        "symbol": "",
                        "total_supply": null,
                        "description": "The Sandbox is a community-driven platform where creators can monetize voxel assets and gaming experiences on the blockchain. The Sandbox metaverse comprises a map made up of 166,464 LANDS.  LAND owners can host contests and events, stake SAND to earn and customize assets, monetize assets and experiences, vote in the metaverse governance, play games that you or others create, and more! Trade the collection and keep your eyes peeled for future drops.",
                        "external_link": "https://www.sandbox.game/",
                        "image_url": "https://lh3.googleusercontent.com/SXH8tW1siikB80rwCRnjm1a5xM_MwTg9Xl9Db6mioIk9HIlDM09pVoSR7GKJgS6ulSUpgW9BDtMk_ePX_NKgO9A=s60",
                        "default_to_fiat": false,
                        "dev_buyer_fee_basis_points": 0,
                        "dev_seller_fee_basis_points": 500,
                        "only_proxied_transfers": false,
                        "opensea_buyer_fee_basis_points": 0,
                        "opensea_seller_fee_basis_points": 250,
                        "buyer_fee_basis_points": 0,
                        "seller_fee_basis_points": 750,
                        "payout_address": "0x7a9fe22691c811ea339d9b73150e6911a5343dca"
                    },
                    "owner": {
                        "user": {
                            "username": "REVOLT"
                        },
                        "profile_img_url": "https://storage.googleapis.com/opensea-static/opensea-profile/25.png",
                        "address": "0xb6d820e80a2a7c49f94c9d6c8ea08dccedc9ce4c",
                        "config": "",
                        "discord_id": ""
                    },
                    "permalink": "https://opensea.io/assets/0x50f5474724e0ee42d9a4e711ccfb275809fd6d4a/80710",
                    "collection": {
                        "banner_image_url": "https://lh3.googleusercontent.com/4NQIRoGmzXeXQN4mjuhWuuDZSNW7_BqRXux5upd4Nn_A-bfsGxCnPF8qn98Y6MyHRDPGXIlgfZADcSOe6M2DyrDKXdbdaTgkZN5l=s2500",
                        "chat_url": null,
                        "created_date": "2019-12-04T10:58:29.069907",
                        "default_to_fiat": false,
                        "description": "The Sandbox is a community-driven platform where creators can monetize voxel assets and gaming experiences on the blockchain. The Sandbox metaverse comprises a map made up of 166,464 LANDS.  LAND owners can host contests and events, stake SAND to earn and customize assets, monetize assets and experiences, vote in the metaverse governance, play games that you or others create, and more! Trade the collection and keep your eyes peeled for future drops.",
                        "dev_buyer_fee_basis_points": "0",
                        "dev_seller_fee_basis_points": "500",
                        "discord_url": "https://discord.gg/vAe4zvY",
                        "display_data": {
                            "card_display_style": "contain"
                        },
                        "external_url": "https://www.sandbox.game/",
                        "featured": false,
                        "featured_image_url": "https://storage.googleapis.com/opensea-static/featured-images/sandbox-featured.png",
                        "hidden": false,
                        "safelist_request_status": "verified",
                        "image_url": "https://lh3.googleusercontent.com/SXH8tW1siikB80rwCRnjm1a5xM_MwTg9Xl9Db6mioIk9HIlDM09pVoSR7GKJgS6ulSUpgW9BDtMk_ePX_NKgO9A=s60",
                        "is_subject_to_whitelist": false,
                        "large_image_url": "https://lh3.googleusercontent.com/SXH8tW1siikB80rwCRnjm1a5xM_MwTg9Xl9Db6mioIk9HIlDM09pVoSR7GKJgS6ulSUpgW9BDtMk_ePX_NKgO9A",
                        "medium_username": "sandbox-game",
                        "name": "The Sandbox",
                        "only_proxied_transfers": false,
                        "opensea_buyer_fee_basis_points": "0",
                        "opensea_seller_fee_basis_points": "250",
                        "payout_address": "0x7a9fe22691c811ea339d9b73150e6911a5343dca",
                        "require_email": false,
                        "short_description": null,
                        "slug": "sandbox",
                        "telegram_url": "https://t.me/sandboxgame",
                        "twitter_username": "thesandboxgame",
                        "instagram_username": null,
                        "wiki_url": null
                    },
                    "decimals": null,
                    "token_metadata": null
                },
                {
                    "id": 15816187,
                    "token_id": "80711",
                    "num_sales": 0,
                    "background_color": null,
                    "image_url": "https://storage.opensea.io/files/3faa959fa75531ac7913a9c9f8361b58.png",
                    "image_preview_url": "https://lh3.googleusercontent.com/17vU_UNWeMOVi4XOAwo4nvAXpeg1dnKPBk8VnAhJcFHOFZ9UBBvSL5Spj0ytvyfII3rdp4gHMY0mMvbnSzjdOZ0=s250",
                    "image_thumbnail_url": "https://lh3.googleusercontent.com/17vU_UNWeMOVi4XOAwo4nvAXpeg1dnKPBk8VnAhJcFHOFZ9UBBvSL5Spj0ytvyfII3rdp4gHMY0mMvbnSzjdOZ0=s128",
                    "image_original_url": "https://storage.googleapis.com/opensea-static/custom-fetcher-images/sandbox/land/sandbox-land.png",
                    "animation_url": null,
                    "animation_original_url": null,
                    "name": "LAND (131, -7)",
                    "description": "A LAND is a digital piece of real estate in The Sandbox metaverse that players can buy to build experiences on top of. Once you own a LAND, you will be able to populate it with Games and Assets. Each LAND is a unique (non-fungible) token lying on the public Ethereum blockchain (ERC-721).",
                    "external_link": "https://www.sandbox.game/en/map/?x=131&y=-7",
                    "asset_contract": {
                        "address": "0x50f5474724e0ee42d9a4e711ccfb275809fd6d4a",
                        "asset_contract_type": "non-fungible",
                        "created_date": "2019-12-04T10:58:28.892990",
                        "name": "Sandbox's LANDs",
                        "nft_version": "3.0",
                        "opensea_version": null,
                        "owner": null,
                        "schema_name": "ERC721",
                        "symbol": "",
                        "total_supply": null,
                        "description": "The Sandbox is a community-driven platform where creators can monetize voxel assets and gaming experiences on the blockchain. The Sandbox metaverse comprises a map made up of 166,464 LANDS.  LAND owners can host contests and events, stake SAND to earn and customize assets, monetize assets and experiences, vote in the metaverse governance, play games that you or others create, and more! Trade the collection and keep your eyes peeled for future drops.",
                        "external_link": "https://www.sandbox.game/",
                        "image_url": "https://lh3.googleusercontent.com/SXH8tW1siikB80rwCRnjm1a5xM_MwTg9Xl9Db6mioIk9HIlDM09pVoSR7GKJgS6ulSUpgW9BDtMk_ePX_NKgO9A=s60",
                        "default_to_fiat": false,
                        "dev_buyer_fee_basis_points": 0,
                        "dev_seller_fee_basis_points": 500,
                        "only_proxied_transfers": false,
                        "opensea_buyer_fee_basis_points": 0,
                        "opensea_seller_fee_basis_points": 250,
                        "buyer_fee_basis_points": 0,
                        "seller_fee_basis_points": 750,
                        "payout_address": "0x7a9fe22691c811ea339d9b73150e6911a5343dca"
                    },
                    "owner": {
                        "user": {
                            "username": "REVOLT"
                        },
                        "profile_img_url": "https://storage.googleapis.com/opensea-static/opensea-profile/25.png",
                        "address": "0xb6d820e80a2a7c49f94c9d6c8ea08dccedc9ce4c",
                        "config": "",
                        "discord_id": ""
                    },
                    "permalink": "https://opensea.io/assets/0x50f5474724e0ee42d9a4e711ccfb275809fd6d4a/80711",
                    "collection": {
                        "banner_image_url": "https://lh3.googleusercontent.com/4NQIRoGmzXeXQN4mjuhWuuDZSNW7_BqRXux5upd4Nn_A-bfsGxCnPF8qn98Y6MyHRDPGXIlgfZADcSOe6M2DyrDKXdbdaTgkZN5l=s2500",
                        "chat_url": null,
                        "created_date": "2019-12-04T10:58:29.069907",
                        "default_to_fiat": false,
                        "description": "The Sandbox is a community-driven platform where creators can monetize voxel assets and gaming experiences on the blockchain. The Sandbox metaverse comprises a map made up of 166,464 LANDS.  LAND owners can host contests and events, stake SAND to earn and customize assets, monetize assets and experiences, vote in the metaverse governance, play games that you or others create, and more! Trade the collection and keep your eyes peeled for future drops.",
                        "dev_buyer_fee_basis_points": "0",
                        "dev_seller_fee_basis_points": "500",
                        "discord_url": "https://discord.gg/vAe4zvY",
                        "display_data": {
                            "card_display_style": "contain"
                        },
                        "external_url": "https://www.sandbox.game/",
                        "featured": false,
                        "featured_image_url": "https://storage.googleapis.com/opensea-static/featured-images/sandbox-featured.png",
                        "hidden": false,
                        "safelist_request_status": "verified",
                        "image_url": "https://lh3.googleusercontent.com/SXH8tW1siikB80rwCRnjm1a5xM_MwTg9Xl9Db6mioIk9HIlDM09pVoSR7GKJgS6ulSUpgW9BDtMk_ePX_NKgO9A=s60",
                        "is_subject_to_whitelist": false,
                        "large_image_url": "https://lh3.googleusercontent.com/SXH8tW1siikB80rwCRnjm1a5xM_MwTg9Xl9Db6mioIk9HIlDM09pVoSR7GKJgS6ulSUpgW9BDtMk_ePX_NKgO9A",
                        "medium_username": "sandbox-game",
                        "name": "The Sandbox",
                        "only_proxied_transfers": false,
                        "opensea_buyer_fee_basis_points": "0",
                        "opensea_seller_fee_basis_points": "250",
                        "payout_address": "0x7a9fe22691c811ea339d9b73150e6911a5343dca",
                        "require_email": false,
                        "short_description": null,
                        "slug": "sandbox",
                        "telegram_url": "https://t.me/sandboxgame",
                        "twitter_username": "thesandboxgame",
                        "instagram_username": null,
                        "wiki_url": null
                    },
                    "decimals": null,
                    "token_metadata": null
                }
            ],
            "name": "Small estate (9 lands)",
            "description": "Yes, you can afford it :o))",
            "external_link": "",
            "asset_contract": {
                "collection": {
                    "banner_image_url": "https://lh3.googleusercontent.com/4NQIRoGmzXeXQN4mjuhWuuDZSNW7_BqRXux5upd4Nn_A-bfsGxCnPF8qn98Y6MyHRDPGXIlgfZADcSOe6M2DyrDKXdbdaTgkZN5l=s2500",
                    "chat_url": null,
                    "created_date": "2019-12-04T10:58:29.069907",
                    "default_to_fiat": false,
                    "description": "The Sandbox is a community-driven platform where creators can monetize voxel assets and gaming experiences on the blockchain. The Sandbox metaverse comprises a map made up of 166,464 LANDS.  LAND owners can host contests and events, stake SAND to earn and customize assets, monetize assets and experiences, vote in the metaverse governance, play games that you or others create, and more! Trade the collection and keep your eyes peeled for future drops.",
                    "dev_buyer_fee_basis_points": "0",
                    "dev_seller_fee_basis_points": "500",
                    "discord_url": "https://discord.gg/vAe4zvY",
                    "display_data": {
                        "card_display_style": "contain"
                    },
                    "external_url": "https://www.sandbox.game/",
                    "featured": false,
                    "featured_image_url": "https://storage.googleapis.com/opensea-static/featured-images/sandbox-featured.png",
                    "hidden": false,
                    "safelist_request_status": "verified",
                    "image_url": "https://lh3.googleusercontent.com/SXH8tW1siikB80rwCRnjm1a5xM_MwTg9Xl9Db6mioIk9HIlDM09pVoSR7GKJgS6ulSUpgW9BDtMk_ePX_NKgO9A=s60",
                    "is_subject_to_whitelist": false,
                    "large_image_url": "https://lh3.googleusercontent.com/SXH8tW1siikB80rwCRnjm1a5xM_MwTg9Xl9Db6mioIk9HIlDM09pVoSR7GKJgS6ulSUpgW9BDtMk_ePX_NKgO9A",
                    "medium_username": "sandbox-game",
                    "name": "The Sandbox",
                    "only_proxied_transfers": false,
                    "opensea_buyer_fee_basis_points": "0",
                    "opensea_seller_fee_basis_points": "250",
                    "payout_address": "0x7a9fe22691c811ea339d9b73150e6911a5343dca",
                    "require_email": false,
                    "short_description": null,
                    "slug": "sandbox",
                    "telegram_url": "https://t.me/sandboxgame",
                    "twitter_username": "thesandboxgame",
                    "instagram_username": null,
                    "wiki_url": null
                },
                "address": "0x50f5474724e0ee42d9a4e711ccfb275809fd6d4a",
                "asset_contract_type": "non-fungible",
                "created_date": "2019-12-04T10:58:28.892990",
                "name": "Sandbox's LANDs",
                "nft_version": "3.0",
                "opensea_version": null,
                "owner": null,
                "schema_name": "ERC721",
                "symbol": "",
                "total_supply": null,
                "description": "The Sandbox is a community-driven platform where creators can monetize voxel assets and gaming experiences on the blockchain. The Sandbox metaverse comprises a map made up of 166,464 LANDS.  LAND owners can host contests and events, stake SAND to earn and customize assets, monetize assets and experiences, vote in the metaverse governance, play games that you or others create, and more! Trade the collection and keep your eyes peeled for future drops.",
                "external_link": "https://www.sandbox.game/",
                "image_url": "https://lh3.googleusercontent.com/SXH8tW1siikB80rwCRnjm1a5xM_MwTg9Xl9Db6mioIk9HIlDM09pVoSR7GKJgS6ulSUpgW9BDtMk_ePX_NKgO9A=s60",
                "default_to_fiat": false,
                "dev_buyer_fee_basis_points": 0,
                "dev_seller_fee_basis_points": 500,
                "only_proxied_transfers": false,
                "opensea_buyer_fee_basis_points": 0,
                "opensea_seller_fee_basis_points": 250,
                "buyer_fee_basis_points": 0,
                "seller_fee_basis_points": 750,
                "payout_address": "0x7a9fe22691c811ea339d9b73150e6911a5343dca"
            },
            "permalink": "https://opensea.io/bundles/small-estate-9-lands-8WN",
            "sell_orders": [
                {
                    "created_date": "2021-05-25T21:54:59.781489",
                    "closing_date": null,
                    "closing_extendable": false,
                    "expiration_time": 0,
                    "listing_time": 1621979592,
                    "order_hash": "0x81e2a55681b82f64b0c8f1a7ec85936021bcb6ee3115af99f58fa5cec97df0bf",
                    "metadata": {
                        "bundle": {
                            "assets": [
                                {
                                    "id": "79893",
                                    "address": "0x50f5474724e0ee42d9a4e711ccfb275809fd6d4a"
                                },
                                {
                                    "id": "79894",
                                    "address": "0x50f5474724e0ee42d9a4e711ccfb275809fd6d4a"
                                },
                                {
                                    "id": "79895",
                                    "address": "0x50f5474724e0ee42d9a4e711ccfb275809fd6d4a"
                                },
                                {
                                    "id": "80301",
                                    "address": "0x50f5474724e0ee42d9a4e711ccfb275809fd6d4a"
                                },
                                {
                                    "id": "80302",
                                    "address": "0x50f5474724e0ee42d9a4e711ccfb275809fd6d4a"
                                },
                                {
                                    "id": "80303",
                                    "address": "0x50f5474724e0ee42d9a4e711ccfb275809fd6d4a"
                                },
                                {
                                    "id": "80709",
                                    "address": "0x50f5474724e0ee42d9a4e711ccfb275809fd6d4a"
                                },
                                {
                                    "id": "80710",
                                    "address": "0x50f5474724e0ee42d9a4e711ccfb275809fd6d4a"
                                },
                                {
                                    "id": "80711",
                                    "address": "0x50f5474724e0ee42d9a4e711ccfb275809fd6d4a"
                                }
                            ],
                            "schemas": [
                                "ERC721",
                                "ERC721",
                                "ERC721",
                                "ERC721",
                                "ERC721",
                                "ERC721",
                                "ERC721",
                                "ERC721",
                                "ERC721"
                            ],
                            "name": "Small estate (9 lands)",
                            "description": "Yes, you can afford it :o))",
                            "external_link": ""
                        }
                    },
                    "exchange": "0x7be8076f4ea4a4ad08075c2508e481d6c946d12b",
                    "maker": {
                        "user": 3797,
                        "profile_img_url": "https://storage.googleapis.com/opensea-static/opensea-profile/25.png",
                        "address": "0xb6d820e80a2a7c49f94c9d6c8ea08dccedc9ce4c",
                        "config": "",
                        "discord_id": ""
                    },
                    "taker": {
                        "user": 1766,
                        "profile_img_url": "https://storage.googleapis.com/opensea-static/opensea-profile/1.png",
                        "address": "0x0000000000000000000000000000000000000000",
                        "config": "",
                        "discord_id": ""
                    },
                    "current_price": "135000000000000000000",
                    "current_bounty": "1350000000000000000",
                    "bounty_multiple": "0.01",
                    "maker_relayer_fee": "750",
                    "taker_relayer_fee": "0",
                    "maker_protocol_fee": "0",
                    "taker_protocol_fee": "0",
                    "maker_referrer_fee": "0",
                    "fee_recipient": {
                        "user": 3585,
                        "profile_img_url": "https://storage.googleapis.com/opensea-static/opensea-profile/28.png",
                        "address": "0x5b3256965e7c3cf26e11fcaf296dfc8807c01073",
                        "config": "verified",
                        "discord_id": ""
                    },
                    "fee_method": 1,
                    "side": 1,
                    "sale_kind": 0,
                    "target": "0xc99f70bfd82fb7c8f8191fdfbfb735606b15e5c5",
                    "how_to_call": 1,
                    "calldata": "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",
                    "replacement_pattern": "0x0000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000ffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffff0000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000ffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffff0000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000ffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffff0000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000ffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffff0000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000ffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffff0000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000ffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffff0000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000ffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffff0000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000ffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffff0000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000ffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffff000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000",
                    "static_target": "0x0000000000000000000000000000000000000000",
                    "static_extradata": "0x",
                    "payment_token": "0x0000000000000000000000000000000000000000",
                    "payment_token_contract": {
                        "id": 1,
                        "symbol": "ETH",
                        "address": "0x0000000000000000000000000000000000000000",
                        "image_url": "https://storage.opensea.io/files/6f8e2979d428180222796ff4a33ab929.svg",
                        "name": "Ether",
                        "decimals": 18,
                        "eth_price": "1.000000000000000",
                        "usd_price": "2625.730000000000018000"
                    },
                    "base_price": "135000000000000000000",
                    "extra": "0",
                    "quantity": "1",
                    "salt": "21192706074564729652977239303467939735333497913873768782090581144047907578728",
                    "v": 27,
                    "r": "0xfaf563f767cfce911837df454abfe9bfb1216e2cca3afebfa33bf2a87939412d",
                    "s": "0x04f23a6f82d21457153c9da50df6f344737a0c12da9fe3f28be9747beca1234f",
                    "approved_on_chain": false,
                    "cancelled": false,
                    "finalized": false,
                    "marked_invalid": false,
                    "prefixed_hash": "0x10e00c80379f47fea465d7426c8233592a9fff10d8c668181f7a634f97b21792"
                }
            ]
        },
        {
            "maker": {
                "user": {
                    "username": "JunicsMM"
                },
                "profile_img_url": "https://storage.googleapis.com/opensea-static/opensea-profile/1.png",
                "address": "0x04c52bd080ecf149c16940379ce0b55e466b32c1",
                "config": "",
                "discord_id": ""
            },
            "slug": "og-punks-collection-PS5",
            "assets": [
                {
                    "id": 22873900,
                    "token_id": "33842662755948891384551277576951042885482700903621568592155336966688957530113",
                    "num_sales": 1,
                    "background_color": null,
                    "image_url": "https://lh3.googleusercontent.com/bUwP1hpWpyO6NsQqz0QeqNMSeTal3rhkBYgqLDt-wDZHO1rgdk9AXHe5Elvi964eQKqmVwVecYlA0myD2p338mzkGoSfeCcI7zfJB14",
                    "image_preview_url": "https://lh3.googleusercontent.com/bUwP1hpWpyO6NsQqz0QeqNMSeTal3rhkBYgqLDt-wDZHO1rgdk9AXHe5Elvi964eQKqmVwVecYlA0myD2p338mzkGoSfeCcI7zfJB14=s250",
                    "image_thumbnail_url": "https://lh3.googleusercontent.com/bUwP1hpWpyO6NsQqz0QeqNMSeTal3rhkBYgqLDt-wDZHO1rgdk9AXHe5Elvi964eQKqmVwVecYlA0myD2p338mzkGoSfeCcI7zfJB14=s128",
                    "image_original_url": null,
                    "animation_url": null,
                    "animation_original_url": null,
                    "name": "OGPunk #154 - Magic Johnson",
                    "description": null,
                    "external_link": null,
                    "asset_contract": {
                        "address": "0x495f947276749ce646f68ac8c248420045cb7b5e",
                        "asset_contract_type": "semi-fungible",
                        "created_date": "2020-12-02T17:40:53.232025",
                        "name": "OpenSea Collection",
                        "nft_version": null,
                        "opensea_version": "2.0.0",
                        "owner": 102384,
                        "schema_name": "ERC1155",
                        "symbol": "OPENSTORE",
                        "total_supply": null,
                        "description": null,
                        "external_link": null,
                        "image_url": null,
                        "default_to_fiat": false,
                        "dev_buyer_fee_basis_points": 0,
                        "dev_seller_fee_basis_points": 0,
                        "only_proxied_transfers": false,
                        "opensea_buyer_fee_basis_points": 0,
                        "opensea_seller_fee_basis_points": 250,
                        "buyer_fee_basis_points": 0,
                        "seller_fee_basis_points": 250,
                        "payout_address": null
                    },
                    "owner": {
                        "user": {
                            "username": "NullAddress"
                        },
                        "profile_img_url": "https://storage.googleapis.com/opensea-static/opensea-profile/1.png",
                        "address": "0x0000000000000000000000000000000000000000",
                        "config": "",
                        "discord_id": ""
                    },
                    "permalink": "https://opensea.io/assets/0x495f947276749ce646f68ac8c248420045cb7b5e/33842662755948891384551277576951042885482700903621568592155336966688957530113",
                    "collection": {
                        "banner_image_url": "https://lh3.googleusercontent.com/lu7QuVmj5Ns8xjDoPzF0Q7l--tJWaqqwuFFXY9EqDx_e__yhfJTKNl5Wwwl05ReDpr55ASZ66Zf6R0VitMwxshCkYTY76xzQF81Q=s2500",
                        "chat_url": null,
                        "created_date": "2021-04-14T02:34:40.817763",
                        "default_to_fiat": false,
                        "description": "They may be familiar. They may be weird. And they are damn cool! \n\nPast. Present. Future. ∞\n\nOGPunks is a digital art project on the Ethereum Blockchain inspired of the CryptoPunks and is not affilliated with LarvaLabs.\n\n1-20 -> 0.05 Ξ [SOLD]\n\n21-51 -> 0.075 Ξ [SOLD]\n\n52-100 -> 0.076 Ξ [SOLD]\n\n101-150 -> 0.10 Ξ [SOLD]\n\n151-200 -> 0.20 Ξ [SOLD]\n\n201-250 -> 0.30 Ξ\n\n251-300 -> 0.35 Ξ (Currently minting)\n\n301-333 -> ?.?? Ξ\n",
                        "dev_buyer_fee_basis_points": "0",
                        "dev_seller_fee_basis_points": "1000",
                        "discord_url": "https://discord.gg/zpxGtTd74w",
                        "display_data": {
                            "card_display_style": "contain"
                        },
                        "external_url": "https://ogpunks.xyz/",
                        "featured": false,
                        "featured_image_url": "https://lh3.googleusercontent.com/hTBmAceRX0auPHaoyun49mnkfA2fpCv-HomJf8HCqP7O4VhMIjT5iVRvIHf9Av260rPJvmP1ucLqcu2wM2TAAV-tdHnbCQnVWfQY8Q=s300",
                        "hidden": false,
                        "safelist_request_status": "approved",
                        "image_url": "https://lh3.googleusercontent.com/YXxFa07KaOTNH0dcLkxeDJ6fahRyF5Tzuk-ENSfsdPzQKGYhG2PVk-QdQiD_-wjrrkolPv1NQeqp24LkQs52Om1_bLZUBTaqB0W9=s120",
                        "is_subject_to_whitelist": false,
                        "large_image_url": "https://lh3.googleusercontent.com/hTBmAceRX0auPHaoyun49mnkfA2fpCv-HomJf8HCqP7O4VhMIjT5iVRvIHf9Av260rPJvmP1ucLqcu2wM2TAAV-tdHnbCQnVWfQY8Q=s300",
                        "medium_username": null,
                        "name": "OGPunks",
                        "only_proxied_transfers": false,
                        "opensea_buyer_fee_basis_points": "0",
                        "opensea_seller_fee_basis_points": "250",
                        "payout_address": "0xd7c100832b63c44c6f7364ef03a587b4d023884e",
                        "require_email": false,
                        "short_description": null,
                        "slug": "ogpunks",
                        "telegram_url": null,
                        "twitter_username": "OGPunkz",
                        "instagram_username": null,
                        "wiki_url": null
                    },
                    "decimals": null,
                    "token_metadata": null
                },
                {
                    "id": 22939972,
                    "token_id": "33842662755948891384551277576951042885482700903621568592155336984281143574529",
                    "num_sales": 1,
                    "background_color": null,
                    "image_url": "https://lh3.googleusercontent.com/LWD1ojBhHxWXTc9pkonX3xg1undOVSrCkHHvjpmqG0Uk2kemND-uhnoj_9mg7w4YdCJsH8IbeUnXdNF6tWB3uEZekvOdqPqExAeI5Zc",
                    "image_preview_url": "https://lh3.googleusercontent.com/LWD1ojBhHxWXTc9pkonX3xg1undOVSrCkHHvjpmqG0Uk2kemND-uhnoj_9mg7w4YdCJsH8IbeUnXdNF6tWB3uEZekvOdqPqExAeI5Zc=s250",
                    "image_thumbnail_url": "https://lh3.googleusercontent.com/LWD1ojBhHxWXTc9pkonX3xg1undOVSrCkHHvjpmqG0Uk2kemND-uhnoj_9mg7w4YdCJsH8IbeUnXdNF6tWB3uEZekvOdqPqExAeI5Zc=s128",
                    "image_original_url": null,
                    "animation_url": null,
                    "animation_original_url": null,
                    "name": "OGPunk #170 - Brian Griffin",
                    "description": null,
                    "external_link": null,
                    "asset_contract": {
                        "address": "0x495f947276749ce646f68ac8c248420045cb7b5e",
                        "asset_contract_type": "semi-fungible",
                        "created_date": "2020-12-02T17:40:53.232025",
                        "name": "OpenSea Collection",
                        "nft_version": null,
                        "opensea_version": "2.0.0",
                        "owner": 102384,
                        "schema_name": "ERC1155",
                        "symbol": "OPENSTORE",
                        "total_supply": null,
                        "description": null,
                        "external_link": null,
                        "image_url": null,
                        "default_to_fiat": false,
                        "dev_buyer_fee_basis_points": 0,
                        "dev_seller_fee_basis_points": 0,
                        "only_proxied_transfers": false,
                        "opensea_buyer_fee_basis_points": 0,
                        "opensea_seller_fee_basis_points": 250,
                        "buyer_fee_basis_points": 0,
                        "seller_fee_basis_points": 250,
                        "payout_address": null
                    },
                    "owner": {
                        "user": {
                            "username": "NullAddress"
                        },
                        "profile_img_url": "https://storage.googleapis.com/opensea-static/opensea-profile/1.png",
                        "address": "0x0000000000000000000000000000000000000000",
                        "config": "",
                        "discord_id": ""
                    },
                    "permalink": "https://opensea.io/assets/0x495f947276749ce646f68ac8c248420045cb7b5e/33842662755948891384551277576951042885482700903621568592155336984281143574529",
                    "collection": {
                        "banner_image_url": "https://lh3.googleusercontent.com/lu7QuVmj5Ns8xjDoPzF0Q7l--tJWaqqwuFFXY9EqDx_e__yhfJTKNl5Wwwl05ReDpr55ASZ66Zf6R0VitMwxshCkYTY76xzQF81Q=s2500",
                        "chat_url": null,
                        "created_date": "2021-04-14T02:34:40.817763",
                        "default_to_fiat": false,
                        "description": "They may be familiar. They may be weird. And they are damn cool! \n\nPast. Present. Future. ∞\n\nOGPunks is a digital art project on the Ethereum Blockchain inspired of the CryptoPunks and is not affilliated with LarvaLabs.\n\n1-20 -> 0.05 Ξ [SOLD]\n\n21-51 -> 0.075 Ξ [SOLD]\n\n52-100 -> 0.076 Ξ [SOLD]\n\n101-150 -> 0.10 Ξ [SOLD]\n\n151-200 -> 0.20 Ξ [SOLD]\n\n201-250 -> 0.30 Ξ\n\n251-300 -> 0.35 Ξ (Currently minting)\n\n301-333 -> ?.?? Ξ\n",
                        "dev_buyer_fee_basis_points": "0",
                        "dev_seller_fee_basis_points": "1000",
                        "discord_url": "https://discord.gg/zpxGtTd74w",
                        "display_data": {
                            "card_display_style": "contain"
                        },
                        "external_url": "https://ogpunks.xyz/",
                        "featured": false,
                        "featured_image_url": "https://lh3.googleusercontent.com/hTBmAceRX0auPHaoyun49mnkfA2fpCv-HomJf8HCqP7O4VhMIjT5iVRvIHf9Av260rPJvmP1ucLqcu2wM2TAAV-tdHnbCQnVWfQY8Q=s300",
                        "hidden": false,
                        "safelist_request_status": "approved",
                        "image_url": "https://lh3.googleusercontent.com/YXxFa07KaOTNH0dcLkxeDJ6fahRyF5Tzuk-ENSfsdPzQKGYhG2PVk-QdQiD_-wjrrkolPv1NQeqp24LkQs52Om1_bLZUBTaqB0W9=s120",
                        "is_subject_to_whitelist": false,
                        "large_image_url": "https://lh3.googleusercontent.com/hTBmAceRX0auPHaoyun49mnkfA2fpCv-HomJf8HCqP7O4VhMIjT5iVRvIHf9Av260rPJvmP1ucLqcu2wM2TAAV-tdHnbCQnVWfQY8Q=s300",
                        "medium_username": null,
                        "name": "OGPunks",
                        "only_proxied_transfers": false,
                        "opensea_buyer_fee_basis_points": "0",
                        "opensea_seller_fee_basis_points": "250",
                        "payout_address": "0xd7c100832b63c44c6f7364ef03a587b4d023884e",
                        "require_email": false,
                        "short_description": null,
                        "slug": "ogpunks",
                        "telegram_url": null,
                        "twitter_username": "OGPunkz",
                        "instagram_username": null,
                        "wiki_url": null
                    },
                    "decimals": null,
                    "token_metadata": null
                },
                {
                    "id": 23002142,
                    "token_id": "33842662755948891384551277576951042885482700903621568592155336996375771480065",
                    "num_sales": 1,
                    "background_color": null,
                    "image_url": "https://lh3.googleusercontent.com/dxCYs5NTQzQwOPXjpU1wKDqnHhTCCoQVyd5sKaqvAq35Zy5e6S_btE1EBAnrOv2fHGMjjV47ix2d_4-1S8ui2Rdt9CZXfNGRyPfb",
                    "image_preview_url": "https://lh3.googleusercontent.com/dxCYs5NTQzQwOPXjpU1wKDqnHhTCCoQVyd5sKaqvAq35Zy5e6S_btE1EBAnrOv2fHGMjjV47ix2d_4-1S8ui2Rdt9CZXfNGRyPfb=s250",
                    "image_thumbnail_url": "https://lh3.googleusercontent.com/dxCYs5NTQzQwOPXjpU1wKDqnHhTCCoQVyd5sKaqvAq35Zy5e6S_btE1EBAnrOv2fHGMjjV47ix2d_4-1S8ui2Rdt9CZXfNGRyPfb=s128",
                    "image_original_url": null,
                    "animation_url": null,
                    "animation_original_url": null,
                    "name": "OGPunk #181 - Gianluigi Buffon",
                    "description": null,
                    "external_link": null,
                    "asset_contract": {
                        "address": "0x495f947276749ce646f68ac8c248420045cb7b5e",
                        "asset_contract_type": "semi-fungible",
                        "created_date": "2020-12-02T17:40:53.232025",
                        "name": "OpenSea Collection",
                        "nft_version": null,
                        "opensea_version": "2.0.0",
                        "owner": 102384,
                        "schema_name": "ERC1155",
                        "symbol": "OPENSTORE",
                        "total_supply": null,
                        "description": null,
                        "external_link": null,
                        "image_url": null,
                        "default_to_fiat": false,
                        "dev_buyer_fee_basis_points": 0,
                        "dev_seller_fee_basis_points": 0,
                        "only_proxied_transfers": false,
                        "opensea_buyer_fee_basis_points": 0,
                        "opensea_seller_fee_basis_points": 250,
                        "buyer_fee_basis_points": 0,
                        "seller_fee_basis_points": 250,
                        "payout_address": null
                    },
                    "owner": {
                        "user": {
                            "username": "NullAddress"
                        },
                        "profile_img_url": "https://storage.googleapis.com/opensea-static/opensea-profile/1.png",
                        "address": "0x0000000000000000000000000000000000000000",
                        "config": "",
                        "discord_id": ""
                    },
                    "permalink": "https://opensea.io/assets/0x495f947276749ce646f68ac8c248420045cb7b5e/33842662755948891384551277576951042885482700903621568592155336996375771480065",
                    "collection": {
                        "banner_image_url": "https://lh3.googleusercontent.com/lu7QuVmj5Ns8xjDoPzF0Q7l--tJWaqqwuFFXY9EqDx_e__yhfJTKNl5Wwwl05ReDpr55ASZ66Zf6R0VitMwxshCkYTY76xzQF81Q=s2500",
                        "chat_url": null,
                        "created_date": "2021-04-14T02:34:40.817763",
                        "default_to_fiat": false,
                        "description": "They may be familiar. They may be weird. And they are damn cool! \n\nPast. Present. Future. ∞\n\nOGPunks is a digital art project on the Ethereum Blockchain inspired of the CryptoPunks and is not affilliated with LarvaLabs.\n\n1-20 -> 0.05 Ξ [SOLD]\n\n21-51 -> 0.075 Ξ [SOLD]\n\n52-100 -> 0.076 Ξ [SOLD]\n\n101-150 -> 0.10 Ξ [SOLD]\n\n151-200 -> 0.20 Ξ [SOLD]\n\n201-250 -> 0.30 Ξ\n\n251-300 -> 0.35 Ξ (Currently minting)\n\n301-333 -> ?.?? Ξ\n",
                        "dev_buyer_fee_basis_points": "0",
                        "dev_seller_fee_basis_points": "1000",
                        "discord_url": "https://discord.gg/zpxGtTd74w",
                        "display_data": {
                            "card_display_style": "contain"
                        },
                        "external_url": "https://ogpunks.xyz/",
                        "featured": false,
                        "featured_image_url": "https://lh3.googleusercontent.com/hTBmAceRX0auPHaoyun49mnkfA2fpCv-HomJf8HCqP7O4VhMIjT5iVRvIHf9Av260rPJvmP1ucLqcu2wM2TAAV-tdHnbCQnVWfQY8Q=s300",
                        "hidden": false,
                        "safelist_request_status": "approved",
                        "image_url": "https://lh3.googleusercontent.com/YXxFa07KaOTNH0dcLkxeDJ6fahRyF5Tzuk-ENSfsdPzQKGYhG2PVk-QdQiD_-wjrrkolPv1NQeqp24LkQs52Om1_bLZUBTaqB0W9=s120",
                        "is_subject_to_whitelist": false,
                        "large_image_url": "https://lh3.googleusercontent.com/hTBmAceRX0auPHaoyun49mnkfA2fpCv-HomJf8HCqP7O4VhMIjT5iVRvIHf9Av260rPJvmP1ucLqcu2wM2TAAV-tdHnbCQnVWfQY8Q=s300",
                        "medium_username": null,
                        "name": "OGPunks",
                        "only_proxied_transfers": false,
                        "opensea_buyer_fee_basis_points": "0",
                        "opensea_seller_fee_basis_points": "250",
                        "payout_address": "0xd7c100832b63c44c6f7364ef03a587b4d023884e",
                        "require_email": false,
                        "short_description": null,
                        "slug": "ogpunks",
                        "telegram_url": null,
                        "twitter_username": "OGPunkz",
                        "instagram_username": null,
                        "wiki_url": null
                    },
                    "decimals": null,
                    "token_metadata": null
                },
                {
                    "id": 23022339,
                    "token_id": "33842662755948891384551277576951042885482700903621568592155337000773817991169",
                    "num_sales": 1,
                    "background_color": null,
                    "image_url": "https://lh3.googleusercontent.com/t_XgihQA_8JYK9WgFxmdw8Crv_XjYD_TqiwhaUWynMzo9r09R8SzjqfLdXcWz4gvQWB3k-DrJ3OeLgxCc390vhZL1NALMWqvofNw7Q",
                    "image_preview_url": "https://lh3.googleusercontent.com/t_XgihQA_8JYK9WgFxmdw8Crv_XjYD_TqiwhaUWynMzo9r09R8SzjqfLdXcWz4gvQWB3k-DrJ3OeLgxCc390vhZL1NALMWqvofNw7Q=s250",
                    "image_thumbnail_url": "https://lh3.googleusercontent.com/t_XgihQA_8JYK9WgFxmdw8Crv_XjYD_TqiwhaUWynMzo9r09R8SzjqfLdXcWz4gvQWB3k-DrJ3OeLgxCc390vhZL1NALMWqvofNw7Q=s128",
                    "image_original_url": null,
                    "animation_url": null,
                    "animation_original_url": null,
                    "name": "OGPunk #185 - Mahatma Gandhi",
                    "description": null,
                    "external_link": null,
                    "asset_contract": {
                        "address": "0x495f947276749ce646f68ac8c248420045cb7b5e",
                        "asset_contract_type": "semi-fungible",
                        "created_date": "2020-12-02T17:40:53.232025",
                        "name": "OpenSea Collection",
                        "nft_version": null,
                        "opensea_version": "2.0.0",
                        "owner": 102384,
                        "schema_name": "ERC1155",
                        "symbol": "OPENSTORE",
                        "total_supply": null,
                        "description": null,
                        "external_link": null,
                        "image_url": null,
                        "default_to_fiat": false,
                        "dev_buyer_fee_basis_points": 0,
                        "dev_seller_fee_basis_points": 0,
                        "only_proxied_transfers": false,
                        "opensea_buyer_fee_basis_points": 0,
                        "opensea_seller_fee_basis_points": 250,
                        "buyer_fee_basis_points": 0,
                        "seller_fee_basis_points": 250,
                        "payout_address": null
                    },
                    "owner": {
                        "user": {
                            "username": "NullAddress"
                        },
                        "profile_img_url": "https://storage.googleapis.com/opensea-static/opensea-profile/1.png",
                        "address": "0x0000000000000000000000000000000000000000",
                        "config": "",
                        "discord_id": ""
                    },
                    "permalink": "https://opensea.io/assets/0x495f947276749ce646f68ac8c248420045cb7b5e/33842662755948891384551277576951042885482700903621568592155337000773817991169",
                    "collection": {
                        "banner_image_url": "https://lh3.googleusercontent.com/lu7QuVmj5Ns8xjDoPzF0Q7l--tJWaqqwuFFXY9EqDx_e__yhfJTKNl5Wwwl05ReDpr55ASZ66Zf6R0VitMwxshCkYTY76xzQF81Q=s2500",
                        "chat_url": null,
                        "created_date": "2021-04-14T02:34:40.817763",
                        "default_to_fiat": false,
                        "description": "They may be familiar. They may be weird. And they are damn cool! \n\nPast. Present. Future. ∞\n\nOGPunks is a digital art project on the Ethereum Blockchain inspired of the CryptoPunks and is not affilliated with LarvaLabs.\n\n1-20 -> 0.05 Ξ [SOLD]\n\n21-51 -> 0.075 Ξ [SOLD]\n\n52-100 -> 0.076 Ξ [SOLD]\n\n101-150 -> 0.10 Ξ [SOLD]\n\n151-200 -> 0.20 Ξ [SOLD]\n\n201-250 -> 0.30 Ξ\n\n251-300 -> 0.35 Ξ (Currently minting)\n\n301-333 -> ?.?? Ξ\n",
                        "dev_buyer_fee_basis_points": "0",
                        "dev_seller_fee_basis_points": "1000",
                        "discord_url": "https://discord.gg/zpxGtTd74w",
                        "display_data": {
                            "card_display_style": "contain"
                        },
                        "external_url": "https://ogpunks.xyz/",
                        "featured": false,
                        "featured_image_url": "https://lh3.googleusercontent.com/hTBmAceRX0auPHaoyun49mnkfA2fpCv-HomJf8HCqP7O4VhMIjT5iVRvIHf9Av260rPJvmP1ucLqcu2wM2TAAV-tdHnbCQnVWfQY8Q=s300",
                        "hidden": false,
                        "safelist_request_status": "approved",
                        "image_url": "https://lh3.googleusercontent.com/YXxFa07KaOTNH0dcLkxeDJ6fahRyF5Tzuk-ENSfsdPzQKGYhG2PVk-QdQiD_-wjrrkolPv1NQeqp24LkQs52Om1_bLZUBTaqB0W9=s120",
                        "is_subject_to_whitelist": false,
                        "large_image_url": "https://lh3.googleusercontent.com/hTBmAceRX0auPHaoyun49mnkfA2fpCv-HomJf8HCqP7O4VhMIjT5iVRvIHf9Av260rPJvmP1ucLqcu2wM2TAAV-tdHnbCQnVWfQY8Q=s300",
                        "medium_username": null,
                        "name": "OGPunks",
                        "only_proxied_transfers": false,
                        "opensea_buyer_fee_basis_points": "0",
                        "opensea_seller_fee_basis_points": "250",
                        "payout_address": "0xd7c100832b63c44c6f7364ef03a587b4d023884e",
                        "require_email": false,
                        "short_description": null,
                        "slug": "ogpunks",
                        "telegram_url": null,
                        "twitter_username": "OGPunkz",
                        "instagram_username": null,
                        "wiki_url": null
                    },
                    "decimals": null,
                    "token_metadata": null
                },
                {
                    "id": 23044692,
                    "token_id": "33842662755948891384551277576951042885482700903621568592155337006271376130049",
                    "num_sales": 1,
                    "background_color": null,
                    "image_url": "https://lh3.googleusercontent.com/laQb9n209vWakClT3M9dVyjQZPZmdUunH3_mEId6xkvJ5q3fdWXSqv47Qu64dshsTQGMb5UZRTsvXUZb_eEJC_9QpqZ27ICzyPAOHA",
                    "image_preview_url": "https://lh3.googleusercontent.com/laQb9n209vWakClT3M9dVyjQZPZmdUunH3_mEId6xkvJ5q3fdWXSqv47Qu64dshsTQGMb5UZRTsvXUZb_eEJC_9QpqZ27ICzyPAOHA=s250",
                    "image_thumbnail_url": "https://lh3.googleusercontent.com/laQb9n209vWakClT3M9dVyjQZPZmdUunH3_mEId6xkvJ5q3fdWXSqv47Qu64dshsTQGMb5UZRTsvXUZb_eEJC_9QpqZ27ICzyPAOHA=s128",
                    "image_original_url": null,
                    "animation_url": null,
                    "animation_original_url": null,
                    "name": "OGPunk #190 - Catwoman",
                    "description": null,
                    "external_link": null,
                    "asset_contract": {
                        "address": "0x495f947276749ce646f68ac8c248420045cb7b5e",
                        "asset_contract_type": "semi-fungible",
                        "created_date": "2020-12-02T17:40:53.232025",
                        "name": "OpenSea Collection",
                        "nft_version": null,
                        "opensea_version": "2.0.0",
                        "owner": 102384,
                        "schema_name": "ERC1155",
                        "symbol": "OPENSTORE",
                        "total_supply": null,
                        "description": null,
                        "external_link": null,
                        "image_url": null,
                        "default_to_fiat": false,
                        "dev_buyer_fee_basis_points": 0,
                        "dev_seller_fee_basis_points": 0,
                        "only_proxied_transfers": false,
                        "opensea_buyer_fee_basis_points": 0,
                        "opensea_seller_fee_basis_points": 250,
                        "buyer_fee_basis_points": 0,
                        "seller_fee_basis_points": 250,
                        "payout_address": null
                    },
                    "owner": {
                        "user": {
                            "username": "NullAddress"
                        },
                        "profile_img_url": "https://storage.googleapis.com/opensea-static/opensea-profile/1.png",
                        "address": "0x0000000000000000000000000000000000000000",
                        "config": "",
                        "discord_id": ""
                    },
                    "permalink": "https://opensea.io/assets/0x495f947276749ce646f68ac8c248420045cb7b5e/33842662755948891384551277576951042885482700903621568592155337006271376130049",
                    "collection": {
                        "banner_image_url": "https://lh3.googleusercontent.com/lu7QuVmj5Ns8xjDoPzF0Q7l--tJWaqqwuFFXY9EqDx_e__yhfJTKNl5Wwwl05ReDpr55ASZ66Zf6R0VitMwxshCkYTY76xzQF81Q=s2500",
                        "chat_url": null,
                        "created_date": "2021-04-14T02:34:40.817763",
                        "default_to_fiat": false,
                        "description": "They may be familiar. They may be weird. And they are damn cool! \n\nPast. Present. Future. ∞\n\nOGPunks is a digital art project on the Ethereum Blockchain inspired of the CryptoPunks and is not affilliated with LarvaLabs.\n\n1-20 -> 0.05 Ξ [SOLD]\n\n21-51 -> 0.075 Ξ [SOLD]\n\n52-100 -> 0.076 Ξ [SOLD]\n\n101-150 -> 0.10 Ξ [SOLD]\n\n151-200 -> 0.20 Ξ [SOLD]\n\n201-250 -> 0.30 Ξ\n\n251-300 -> 0.35 Ξ (Currently minting)\n\n301-333 -> ?.?? Ξ\n",
                        "dev_buyer_fee_basis_points": "0",
                        "dev_seller_fee_basis_points": "1000",
                        "discord_url": "https://discord.gg/zpxGtTd74w",
                        "display_data": {
                            "card_display_style": "contain"
                        },
                        "external_url": "https://ogpunks.xyz/",
                        "featured": false,
                        "featured_image_url": "https://lh3.googleusercontent.com/hTBmAceRX0auPHaoyun49mnkfA2fpCv-HomJf8HCqP7O4VhMIjT5iVRvIHf9Av260rPJvmP1ucLqcu2wM2TAAV-tdHnbCQnVWfQY8Q=s300",
                        "hidden": false,
                        "safelist_request_status": "approved",
                        "image_url": "https://lh3.googleusercontent.com/YXxFa07KaOTNH0dcLkxeDJ6fahRyF5Tzuk-ENSfsdPzQKGYhG2PVk-QdQiD_-wjrrkolPv1NQeqp24LkQs52Om1_bLZUBTaqB0W9=s120",
                        "is_subject_to_whitelist": false,
                        "large_image_url": "https://lh3.googleusercontent.com/hTBmAceRX0auPHaoyun49mnkfA2fpCv-HomJf8HCqP7O4VhMIjT5iVRvIHf9Av260rPJvmP1ucLqcu2wM2TAAV-tdHnbCQnVWfQY8Q=s300",
                        "medium_username": null,
                        "name": "OGPunks",
                        "only_proxied_transfers": false,
                        "opensea_buyer_fee_basis_points": "0",
                        "opensea_seller_fee_basis_points": "250",
                        "payout_address": "0xd7c100832b63c44c6f7364ef03a587b4d023884e",
                        "require_email": false,
                        "short_description": null,
                        "slug": "ogpunks",
                        "telegram_url": null,
                        "twitter_username": "OGPunkz",
                        "instagram_username": null,
                        "wiki_url": null
                    },
                    "decimals": null,
                    "token_metadata": null
                },
                {
                    "id": 23054925,
                    "token_id": "33842662755948891384551277576951042885482700903621568592155337010669422641153",
                    "num_sales": 1,
                    "background_color": null,
                    "image_url": "https://lh3.googleusercontent.com/nrbdnq8HjPduiOl20VYapjvxvtGWrfcO2KniM6wlqrouxq7SM7txaBQY6cNx8Aq9N5uJWdj8vV3ohIemWRHIffiJPF1NbJ_exYIO",
                    "image_preview_url": "https://lh3.googleusercontent.com/nrbdnq8HjPduiOl20VYapjvxvtGWrfcO2KniM6wlqrouxq7SM7txaBQY6cNx8Aq9N5uJWdj8vV3ohIemWRHIffiJPF1NbJ_exYIO=s250",
                    "image_thumbnail_url": "https://lh3.googleusercontent.com/nrbdnq8HjPduiOl20VYapjvxvtGWrfcO2KniM6wlqrouxq7SM7txaBQY6cNx8Aq9N5uJWdj8vV3ohIemWRHIffiJPF1NbJ_exYIO=s128",
                    "image_original_url": null,
                    "animation_url": null,
                    "animation_original_url": null,
                    "name": "OGPunk #194 - Frank Sinatra",
                    "description": null,
                    "external_link": null,
                    "asset_contract": {
                        "address": "0x495f947276749ce646f68ac8c248420045cb7b5e",
                        "asset_contract_type": "semi-fungible",
                        "created_date": "2020-12-02T17:40:53.232025",
                        "name": "OpenSea Collection",
                        "nft_version": null,
                        "opensea_version": "2.0.0",
                        "owner": 102384,
                        "schema_name": "ERC1155",
                        "symbol": "OPENSTORE",
                        "total_supply": null,
                        "description": null,
                        "external_link": null,
                        "image_url": null,
                        "default_to_fiat": false,
                        "dev_buyer_fee_basis_points": 0,
                        "dev_seller_fee_basis_points": 0,
                        "only_proxied_transfers": false,
                        "opensea_buyer_fee_basis_points": 0,
                        "opensea_seller_fee_basis_points": 250,
                        "buyer_fee_basis_points": 0,
                        "seller_fee_basis_points": 250,
                        "payout_address": null
                    },
                    "owner": {
                        "user": {
                            "username": "NullAddress"
                        },
                        "profile_img_url": "https://storage.googleapis.com/opensea-static/opensea-profile/1.png",
                        "address": "0x0000000000000000000000000000000000000000",
                        "config": "",
                        "discord_id": ""
                    },
                    "permalink": "https://opensea.io/assets/0x495f947276749ce646f68ac8c248420045cb7b5e/33842662755948891384551277576951042885482700903621568592155337010669422641153",
                    "collection": {
                        "banner_image_url": "https://lh3.googleusercontent.com/lu7QuVmj5Ns8xjDoPzF0Q7l--tJWaqqwuFFXY9EqDx_e__yhfJTKNl5Wwwl05ReDpr55ASZ66Zf6R0VitMwxshCkYTY76xzQF81Q=s2500",
                        "chat_url": null,
                        "created_date": "2021-04-14T02:34:40.817763",
                        "default_to_fiat": false,
                        "description": "They may be familiar. They may be weird. And they are damn cool! \n\nPast. Present. Future. ∞\n\nOGPunks is a digital art project on the Ethereum Blockchain inspired of the CryptoPunks and is not affilliated with LarvaLabs.\n\n1-20 -> 0.05 Ξ [SOLD]\n\n21-51 -> 0.075 Ξ [SOLD]\n\n52-100 -> 0.076 Ξ [SOLD]\n\n101-150 -> 0.10 Ξ [SOLD]\n\n151-200 -> 0.20 Ξ [SOLD]\n\n201-250 -> 0.30 Ξ\n\n251-300 -> 0.35 Ξ (Currently minting)\n\n301-333 -> ?.?? Ξ\n",
                        "dev_buyer_fee_basis_points": "0",
                        "dev_seller_fee_basis_points": "1000",
                        "discord_url": "https://discord.gg/zpxGtTd74w",
                        "display_data": {
                            "card_display_style": "contain"
                        },
                        "external_url": "https://ogpunks.xyz/",
                        "featured": false,
                        "featured_image_url": "https://lh3.googleusercontent.com/hTBmAceRX0auPHaoyun49mnkfA2fpCv-HomJf8HCqP7O4VhMIjT5iVRvIHf9Av260rPJvmP1ucLqcu2wM2TAAV-tdHnbCQnVWfQY8Q=s300",
                        "hidden": false,
                        "safelist_request_status": "approved",
                        "image_url": "https://lh3.googleusercontent.com/YXxFa07KaOTNH0dcLkxeDJ6fahRyF5Tzuk-ENSfsdPzQKGYhG2PVk-QdQiD_-wjrrkolPv1NQeqp24LkQs52Om1_bLZUBTaqB0W9=s120",
                        "is_subject_to_whitelist": false,
                        "large_image_url": "https://lh3.googleusercontent.com/hTBmAceRX0auPHaoyun49mnkfA2fpCv-HomJf8HCqP7O4VhMIjT5iVRvIHf9Av260rPJvmP1ucLqcu2wM2TAAV-tdHnbCQnVWfQY8Q=s300",
                        "medium_username": null,
                        "name": "OGPunks",
                        "only_proxied_transfers": false,
                        "opensea_buyer_fee_basis_points": "0",
                        "opensea_seller_fee_basis_points": "250",
                        "payout_address": "0xd7c100832b63c44c6f7364ef03a587b4d023884e",
                        "require_email": false,
                        "short_description": null,
                        "slug": "ogpunks",
                        "telegram_url": null,
                        "twitter_username": "OGPunkz",
                        "instagram_username": null,
                        "wiki_url": null
                    },
                    "decimals": null,
                    "token_metadata": null
                },
                {
                    "id": 23077561,
                    "token_id": "33842662755948891384551277576951042885482700903621568592155337016166980780033",
                    "num_sales": 1,
                    "background_color": null,
                    "image_url": "https://lh3.googleusercontent.com/ft_3uNGgFW7Y6Gu4zCnRlTJQf4qpOpzck_P2IEdkwXKnBdaZPQWhSMRQB8aJg04Kqd8-wmtA4TlMIvGo7uZzgglTLlTTVWjWLPBmnrM",
                    "image_preview_url": "https://lh3.googleusercontent.com/ft_3uNGgFW7Y6Gu4zCnRlTJQf4qpOpzck_P2IEdkwXKnBdaZPQWhSMRQB8aJg04Kqd8-wmtA4TlMIvGo7uZzgglTLlTTVWjWLPBmnrM=s250",
                    "image_thumbnail_url": "https://lh3.googleusercontent.com/ft_3uNGgFW7Y6Gu4zCnRlTJQf4qpOpzck_P2IEdkwXKnBdaZPQWhSMRQB8aJg04Kqd8-wmtA4TlMIvGo7uZzgglTLlTTVWjWLPBmnrM=s128",
                    "image_original_url": null,
                    "animation_url": null,
                    "animation_original_url": null,
                    "name": "OGPunk #199 - Porky Pig",
                    "description": null,
                    "external_link": null,
                    "asset_contract": {
                        "address": "0x495f947276749ce646f68ac8c248420045cb7b5e",
                        "asset_contract_type": "semi-fungible",
                        "created_date": "2020-12-02T17:40:53.232025",
                        "name": "OpenSea Collection",
                        "nft_version": null,
                        "opensea_version": "2.0.0",
                        "owner": 102384,
                        "schema_name": "ERC1155",
                        "symbol": "OPENSTORE",
                        "total_supply": null,
                        "description": null,
                        "external_link": null,
                        "image_url": null,
                        "default_to_fiat": false,
                        "dev_buyer_fee_basis_points": 0,
                        "dev_seller_fee_basis_points": 0,
                        "only_proxied_transfers": false,
                        "opensea_buyer_fee_basis_points": 0,
                        "opensea_seller_fee_basis_points": 250,
                        "buyer_fee_basis_points": 0,
                        "seller_fee_basis_points": 250,
                        "payout_address": null
                    },
                    "owner": {
                        "user": {
                            "username": "NullAddress"
                        },
                        "profile_img_url": "https://storage.googleapis.com/opensea-static/opensea-profile/1.png",
                        "address": "0x0000000000000000000000000000000000000000",
                        "config": "",
                        "discord_id": ""
                    },
                    "permalink": "https://opensea.io/assets/0x495f947276749ce646f68ac8c248420045cb7b5e/33842662755948891384551277576951042885482700903621568592155337016166980780033",
                    "collection": {
                        "banner_image_url": "https://lh3.googleusercontent.com/lu7QuVmj5Ns8xjDoPzF0Q7l--tJWaqqwuFFXY9EqDx_e__yhfJTKNl5Wwwl05ReDpr55ASZ66Zf6R0VitMwxshCkYTY76xzQF81Q=s2500",
                        "chat_url": null,
                        "created_date": "2021-04-14T02:34:40.817763",
                        "default_to_fiat": false,
                        "description": "They may be familiar. They may be weird. And they are damn cool! \n\nPast. Present. Future. ∞\n\nOGPunks is a digital art project on the Ethereum Blockchain inspired of the CryptoPunks and is not affilliated with LarvaLabs.\n\n1-20 -> 0.05 Ξ [SOLD]\n\n21-51 -> 0.075 Ξ [SOLD]\n\n52-100 -> 0.076 Ξ [SOLD]\n\n101-150 -> 0.10 Ξ [SOLD]\n\n151-200 -> 0.20 Ξ [SOLD]\n\n201-250 -> 0.30 Ξ\n\n251-300 -> 0.35 Ξ (Currently minting)\n\n301-333 -> ?.?? Ξ\n",
                        "dev_buyer_fee_basis_points": "0",
                        "dev_seller_fee_basis_points": "1000",
                        "discord_url": "https://discord.gg/zpxGtTd74w",
                        "display_data": {
                            "card_display_style": "contain"
                        },
                        "external_url": "https://ogpunks.xyz/",
                        "featured": false,
                        "featured_image_url": "https://lh3.googleusercontent.com/hTBmAceRX0auPHaoyun49mnkfA2fpCv-HomJf8HCqP7O4VhMIjT5iVRvIHf9Av260rPJvmP1ucLqcu2wM2TAAV-tdHnbCQnVWfQY8Q=s300",
                        "hidden": false,
                        "safelist_request_status": "approved",
                        "image_url": "https://lh3.googleusercontent.com/YXxFa07KaOTNH0dcLkxeDJ6fahRyF5Tzuk-ENSfsdPzQKGYhG2PVk-QdQiD_-wjrrkolPv1NQeqp24LkQs52Om1_bLZUBTaqB0W9=s120",
                        "is_subject_to_whitelist": false,
                        "large_image_url": "https://lh3.googleusercontent.com/hTBmAceRX0auPHaoyun49mnkfA2fpCv-HomJf8HCqP7O4VhMIjT5iVRvIHf9Av260rPJvmP1ucLqcu2wM2TAAV-tdHnbCQnVWfQY8Q=s300",
                        "medium_username": null,
                        "name": "OGPunks",
                        "only_proxied_transfers": false,
                        "opensea_buyer_fee_basis_points": "0",
                        "opensea_seller_fee_basis_points": "250",
                        "payout_address": "0xd7c100832b63c44c6f7364ef03a587b4d023884e",
                        "require_email": false,
                        "short_description": null,
                        "slug": "ogpunks",
                        "telegram_url": null,
                        "twitter_username": "OGPunkz",
                        "instagram_username": null,
                        "wiki_url": null
                    },
                    "decimals": null,
                    "token_metadata": null
                }
            ],
            "name": "OG Punks collection",
            "description": "Buying 7 OGPs at floor price would cost 2.45 as of now.  This bundle will give you what you need to kickstart your OGP collection and win rewards on future challenges using their initials and types.",
            "external_link": "",
            "asset_contract": {
                "collection": {
                    "banner_image_url": null,
                    "chat_url": null,
                    "created_date": "2020-12-02T17:40:53.507540",
                    "default_to_fiat": false,
                    "description": null,
                    "dev_buyer_fee_basis_points": "0",
                    "dev_seller_fee_basis_points": "0",
                    "discord_url": null,
                    "display_data": {
                        "card_display_style": "contain",
                        "images": []
                    },
                    "external_url": null,
                    "featured": false,
                    "featured_image_url": null,
                    "hidden": true,
                    "safelist_request_status": "not_requested",
                    "image_url": null,
                    "is_subject_to_whitelist": false,
                    "large_image_url": null,
                    "medium_username": null,
                    "name": "OpenSea Shared Storefront V2",
                    "only_proxied_transfers": false,
                    "opensea_buyer_fee_basis_points": "0",
                    "opensea_seller_fee_basis_points": "250",
                    "payout_address": null,
                    "require_email": false,
                    "short_description": null,
                    "slug": "opensea-shared-storefront-v2",
                    "telegram_url": null,
                    "twitter_username": null,
                    "instagram_username": null,
                    "wiki_url": null
                },
                "address": "0x495f947276749ce646f68ac8c248420045cb7b5e",
                "asset_contract_type": "semi-fungible",
                "created_date": "2020-12-02T17:40:53.232025",
                "name": "OpenSea Collection",
                "nft_version": null,
                "opensea_version": "2.0.0",
                "owner": 102384,
                "schema_name": "ERC1155",
                "symbol": "OPENSTORE",
                "total_supply": null,
                "description": null,
                "external_link": null,
                "image_url": null,
                "default_to_fiat": false,
                "dev_buyer_fee_basis_points": 0,
                "dev_seller_fee_basis_points": 0,
                "only_proxied_transfers": false,
                "opensea_buyer_fee_basis_points": 0,
                "opensea_seller_fee_basis_points": 250,
                "buyer_fee_basis_points": 0,
                "seller_fee_basis_points": 250,
                "payout_address": null
            },
            "permalink": "https://opensea.io/bundles/og-punks-collection-PS5",
            "sell_orders": [
                {
                    "created_date": "2021-05-25T21:53:54.265960",
                    "closing_date": null,
                    "closing_extendable": false,
                    "expiration_time": 0,
                    "listing_time": 1621979526,
                    "order_hash": "0x4c309e6f1ac3a2ff7a4d530eda6453a7c65a109bbf63c8dc3b91edb0b5d51426",
                    "metadata": {
                        "bundle": {
                            "assets": [
                                {
                                    "id": "33842662755948891384551277576951042885482700903621568592155336966688957530113",
                                    "address": "0x495f947276749ce646f68ac8c248420045cb7b5e",
                                    "quantity": "1"
                                },
                                {
                                    "id": "33842662755948891384551277576951042885482700903621568592155336984281143574529",
                                    "address": "0x495f947276749ce646f68ac8c248420045cb7b5e",
                                    "quantity": "1"
                                },
                                {
                                    "id": "33842662755948891384551277576951042885482700903621568592155336996375771480065",
                                    "address": "0x495f947276749ce646f68ac8c248420045cb7b5e",
                                    "quantity": "1"
                                },
                                {
                                    "id": "33842662755948891384551277576951042885482700903621568592155337000773817991169",
                                    "address": "0x495f947276749ce646f68ac8c248420045cb7b5e",
                                    "quantity": "1"
                                },
                                {
                                    "id": "33842662755948891384551277576951042885482700903621568592155337006271376130049",
                                    "address": "0x495f947276749ce646f68ac8c248420045cb7b5e",
                                    "quantity": "1"
                                },
                                {
                                    "id": "33842662755948891384551277576951042885482700903621568592155337010669422641153",
                                    "address": "0x495f947276749ce646f68ac8c248420045cb7b5e",
                                    "quantity": "1"
                                },
                                {
                                    "id": "33842662755948891384551277576951042885482700903621568592155337016166980780033",
                                    "address": "0x495f947276749ce646f68ac8c248420045cb7b5e",
                                    "quantity": "1"
                                }
                            ],
                            "schemas": [
                                "ERC1155",
                                "ERC1155",
                                "ERC1155",
                                "ERC1155",
                                "ERC1155",
                                "ERC1155",
                                "ERC1155"
                            ],
                            "name": "OG Punks collection",
                            "description": "Buying 7 OGPs at floor price would cost 2.45 as of now.  This bundle will give you what you need to kickstart your OGP collection and win rewards on future challenges using their initials and types.",
                            "external_link": ""
                        }
                    },
                    "exchange": "0x7be8076f4ea4a4ad08075c2508e481d6c946d12b",
                    "maker": {
                        "user": 692999,
                        "profile_img_url": "https://storage.googleapis.com/opensea-static/opensea-profile/1.png",
                        "address": "0x04c52bd080ecf149c16940379ce0b55e466b32c1",
                        "config": "",
                        "discord_id": ""
                    },
                    "taker": {
                        "user": 1766,
                        "profile_img_url": "https://storage.googleapis.com/opensea-static/opensea-profile/1.png",
                        "address": "0x0000000000000000000000000000000000000000",
                        "config": "",
                        "discord_id": ""
                    },
                    "current_price": "1500000000000000000",
                    "current_bounty": "15000000000000000",
                    "bounty_multiple": "0.01",
                    "maker_relayer_fee": "1250",
                    "taker_relayer_fee": "0",
                    "maker_protocol_fee": "0",
                    "taker_protocol_fee": "0",
                    "maker_referrer_fee": "0",
                    "fee_recipient": {
                        "user": 3585,
                        "profile_img_url": "https://storage.googleapis.com/opensea-static/opensea-profile/28.png",
                        "address": "0x5b3256965e7c3cf26e11fcaf296dfc8807c01073",
                        "config": "verified",
                        "discord_id": ""
                    },
                    "fee_method": 1,
                    "side": 1,
                    "sale_kind": 0,
                    "target": "0xc99f70bfd82fb7c8f8191fdfbfb735606b15e5c5",
                    "how_to_call": 1,
                    "calldata": "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",
                    "replacement_pattern": "0x0000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000ffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffff0000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000ffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffff0000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000ffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffff0000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000ffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffff0000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000ffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffff0000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000ffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffff0000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000ffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffff000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000",
                    "static_target": "0x0000000000000000000000000000000000000000",
                    "static_extradata": "0x",
                    "payment_token": "0x0000000000000000000000000000000000000000",
                    "payment_token_contract": {
                        "id": 1,
                        "symbol": "ETH",
                        "address": "0x0000000000000000000000000000000000000000",
                        "image_url": "https://storage.opensea.io/files/6f8e2979d428180222796ff4a33ab929.svg",
                        "name": "Ether",
                        "decimals": 18,
                        "eth_price": "1.000000000000000",
                        "usd_price": "2625.730000000000018000"
                    },
                    "base_price": "1500000000000000000",
                    "extra": "0",
                    "quantity": "1",
                    "salt": "50830352876236140956450065887558870796649768525340947276491950535129192051580",
                    "v": 27,
                    "r": "0x3fc8e9c7f2e7031cfada8050251a4f3a704a4f63c683c2456ed5b943258a9642",
                    "s": "0x18b912f01416a6f0a67a0a4d6e5d70a3990e206f426de4e16af9b2026f70e256",
                    "approved_on_chain": false,
                    "cancelled": false,
                    "finalized": false,
                    "marked_invalid": false,
                    "prefixed_hash": "0xd493479052f702901c53f4910e65eb9f9dde029b25461d31aaae52617d9b3fab"
                }
            ]
        },
        {
            "maker": {
                "user": {
                    "username": null
                },
                "profile_img_url": "https://storage.googleapis.com/opensea-static/opensea-profile/5.png",
                "address": "0xe289a24fc2859fa9fb4b5acc97de7d4d6f0dc831",
                "config": "",
                "discord_id": ""
            },
            "slug": "founders-hidef-logo-a1i",
            "assets": [
                {
                    "id": 20424330,
                    "token_id": "70479185245472823933799012500856922265354379340922944019462782659796320387073",
                    "num_sales": 0,
                    "background_color": null,
                    "image_url": "https://lh3.googleusercontent.com/khA7EtiuPRzqfY6BZTLfOkX_VgfBg-Yde-wfgEY8c2yxciCtHeZNAhZVryS2dDDNpvOy0rtRei-N9rUXBVzq3f-1X-QV9MNs2MWC0w",
                    "image_preview_url": "https://lh3.googleusercontent.com/khA7EtiuPRzqfY6BZTLfOkX_VgfBg-Yde-wfgEY8c2yxciCtHeZNAhZVryS2dDDNpvOy0rtRei-N9rUXBVzq3f-1X-QV9MNs2MWC0w=s250",
                    "image_thumbnail_url": "https://lh3.googleusercontent.com/khA7EtiuPRzqfY6BZTLfOkX_VgfBg-Yde-wfgEY8c2yxciCtHeZNAhZVryS2dDDNpvOy0rtRei-N9rUXBVzq3f-1X-QV9MNs2MWC0w=s128",
                    "image_original_url": null,
                    "animation_url": null,
                    "animation_original_url": null,
                    "name": "HiDef Launch Logo",
                    "description": "1 of 10",
                    "external_link": null,
                    "asset_contract": {
                        "address": "0x495f947276749ce646f68ac8c248420045cb7b5e",
                        "asset_contract_type": "semi-fungible",
                        "created_date": "2020-12-02T17:40:53.232025",
                        "name": "OpenSea Collection",
                        "nft_version": null,
                        "opensea_version": "2.0.0",
                        "owner": 102384,
                        "schema_name": "ERC1155",
                        "symbol": "OPENSTORE",
                        "total_supply": null,
                        "description": null,
                        "external_link": null,
                        "image_url": null,
                        "default_to_fiat": false,
                        "dev_buyer_fee_basis_points": 0,
                        "dev_seller_fee_basis_points": 0,
                        "only_proxied_transfers": false,
                        "opensea_buyer_fee_basis_points": 0,
                        "opensea_seller_fee_basis_points": 250,
                        "buyer_fee_basis_points": 0,
                        "seller_fee_basis_points": 250,
                        "payout_address": null
                    },
                    "owner": {
                        "user": {
                            "username": "NullAddress"
                        },
                        "profile_img_url": "https://storage.googleapis.com/opensea-static/opensea-profile/1.png",
                        "address": "0x0000000000000000000000000000000000000000",
                        "config": "",
                        "discord_id": ""
                    },
                    "permalink": "https://opensea.io/assets/0x495f947276749ce646f68ac8c248420045cb7b5e/70479185245472823933799012500856922265354379340922944019462782659796320387073",
                    "collection": {
                        "banner_image_url": "https://lh3.googleusercontent.com/i1dLTD9hXZSzeMGz02l202fkMjd3QQrZ2fCQ2TZt-ajo3L931rN_TRGeqU9IvTfm166GIvs5DWaWCKbnuxKq5JmMHLOXioRyCuMxNQ=s2500",
                        "chat_url": null,
                        "created_date": "2021-03-24T00:31:54.219565",
                        "default_to_fiat": false,
                        "description": "",
                        "dev_buyer_fee_basis_points": "0",
                        "dev_seller_fee_basis_points": "0",
                        "discord_url": null,
                        "display_data": {
                            "card_display_style": "contain",
                            "images": []
                        },
                        "external_url": null,
                        "featured": false,
                        "featured_image_url": null,
                        "hidden": true,
                        "safelist_request_status": "not_requested",
                        "image_url": "https://lh3.googleusercontent.com/qZRiTQMHRe5EswI1syqlf0Sf3sfY8bnZjtVhjn89Kh_RxfqZ1WBWTJBnyvnB-gJWsvr6-DsACvVxrPBsj5pSlecxj63iAcVfQTkD=s120",
                        "is_subject_to_whitelist": false,
                        "large_image_url": null,
                        "medium_username": null,
                        "name": "HiDef",
                        "only_proxied_transfers": false,
                        "opensea_buyer_fee_basis_points": "0",
                        "opensea_seller_fee_basis_points": "250",
                        "payout_address": null,
                        "require_email": false,
                        "short_description": null,
                        "slug": "hidef",
                        "telegram_url": null,
                        "twitter_username": null,
                        "instagram_username": null,
                        "wiki_url": null
                    },
                    "decimals": null,
                    "token_metadata": null
                },
                {
                    "id": 20424562,
                    "token_id": "70479185245472823933799012500856922265354379340922944019462782660895832014849",
                    "num_sales": 0,
                    "background_color": null,
                    "image_url": "https://lh3.googleusercontent.com/khA7EtiuPRzqfY6BZTLfOkX_VgfBg-Yde-wfgEY8c2yxciCtHeZNAhZVryS2dDDNpvOy0rtRei-N9rUXBVzq3f-1X-QV9MNs2MWC0w",
                    "image_preview_url": "https://lh3.googleusercontent.com/khA7EtiuPRzqfY6BZTLfOkX_VgfBg-Yde-wfgEY8c2yxciCtHeZNAhZVryS2dDDNpvOy0rtRei-N9rUXBVzq3f-1X-QV9MNs2MWC0w=s250",
                    "image_thumbnail_url": "https://lh3.googleusercontent.com/khA7EtiuPRzqfY6BZTLfOkX_VgfBg-Yde-wfgEY8c2yxciCtHeZNAhZVryS2dDDNpvOy0rtRei-N9rUXBVzq3f-1X-QV9MNs2MWC0w=s128",
                    "image_original_url": null,
                    "animation_url": null,
                    "animation_original_url": null,
                    "name": "HiDef Launch Logo",
                    "description": "2 of 10",
                    "external_link": null,
                    "asset_contract": {
                        "address": "0x495f947276749ce646f68ac8c248420045cb7b5e",
                        "asset_contract_type": "semi-fungible",
                        "created_date": "2020-12-02T17:40:53.232025",
                        "name": "OpenSea Collection",
                        "nft_version": null,
                        "opensea_version": "2.0.0",
                        "owner": 102384,
                        "schema_name": "ERC1155",
                        "symbol": "OPENSTORE",
                        "total_supply": null,
                        "description": null,
                        "external_link": null,
                        "image_url": null,
                        "default_to_fiat": false,
                        "dev_buyer_fee_basis_points": 0,
                        "dev_seller_fee_basis_points": 0,
                        "only_proxied_transfers": false,
                        "opensea_buyer_fee_basis_points": 0,
                        "opensea_seller_fee_basis_points": 250,
                        "buyer_fee_basis_points": 0,
                        "seller_fee_basis_points": 250,
                        "payout_address": null
                    },
                    "owner": {
                        "user": {
                            "username": "NullAddress"
                        },
                        "profile_img_url": "https://storage.googleapis.com/opensea-static/opensea-profile/1.png",
                        "address": "0x0000000000000000000000000000000000000000",
                        "config": "",
                        "discord_id": ""
                    },
                    "permalink": "https://opensea.io/assets/0x495f947276749ce646f68ac8c248420045cb7b5e/70479185245472823933799012500856922265354379340922944019462782660895832014849",
                    "collection": {
                        "banner_image_url": "https://lh3.googleusercontent.com/i1dLTD9hXZSzeMGz02l202fkMjd3QQrZ2fCQ2TZt-ajo3L931rN_TRGeqU9IvTfm166GIvs5DWaWCKbnuxKq5JmMHLOXioRyCuMxNQ=s2500",
                        "chat_url": null,
                        "created_date": "2021-03-24T00:31:54.219565",
                        "default_to_fiat": false,
                        "description": "",
                        "dev_buyer_fee_basis_points": "0",
                        "dev_seller_fee_basis_points": "0",
                        "discord_url": null,
                        "display_data": {
                            "card_display_style": "contain",
                            "images": []
                        },
                        "external_url": null,
                        "featured": false,
                        "featured_image_url": null,
                        "hidden": true,
                        "safelist_request_status": "not_requested",
                        "image_url": "https://lh3.googleusercontent.com/qZRiTQMHRe5EswI1syqlf0Sf3sfY8bnZjtVhjn89Kh_RxfqZ1WBWTJBnyvnB-gJWsvr6-DsACvVxrPBsj5pSlecxj63iAcVfQTkD=s120",
                        "is_subject_to_whitelist": false,
                        "large_image_url": null,
                        "medium_username": null,
                        "name": "HiDef",
                        "only_proxied_transfers": false,
                        "opensea_buyer_fee_basis_points": "0",
                        "opensea_seller_fee_basis_points": "250",
                        "payout_address": null,
                        "require_email": false,
                        "short_description": null,
                        "slug": "hidef",
                        "telegram_url": null,
                        "twitter_username": null,
                        "instagram_username": null,
                        "wiki_url": null
                    },
                    "decimals": null,
                    "token_metadata": null
                },
                {
                    "id": 20424595,
                    "token_id": "70479185245472823933799012500856922265354379340922944019462782661995343642625",
                    "num_sales": 0,
                    "background_color": null,
                    "image_url": "https://lh3.googleusercontent.com/khA7EtiuPRzqfY6BZTLfOkX_VgfBg-Yde-wfgEY8c2yxciCtHeZNAhZVryS2dDDNpvOy0rtRei-N9rUXBVzq3f-1X-QV9MNs2MWC0w",
                    "image_preview_url": "https://lh3.googleusercontent.com/khA7EtiuPRzqfY6BZTLfOkX_VgfBg-Yde-wfgEY8c2yxciCtHeZNAhZVryS2dDDNpvOy0rtRei-N9rUXBVzq3f-1X-QV9MNs2MWC0w=s250",
                    "image_thumbnail_url": "https://lh3.googleusercontent.com/khA7EtiuPRzqfY6BZTLfOkX_VgfBg-Yde-wfgEY8c2yxciCtHeZNAhZVryS2dDDNpvOy0rtRei-N9rUXBVzq3f-1X-QV9MNs2MWC0w=s128",
                    "image_original_url": null,
                    "animation_url": null,
                    "animation_original_url": null,
                    "name": "HiDef Launch Logo",
                    "description": "3 of 10",
                    "external_link": null,
                    "asset_contract": {
                        "address": "0x495f947276749ce646f68ac8c248420045cb7b5e",
                        "asset_contract_type": "semi-fungible",
                        "created_date": "2020-12-02T17:40:53.232025",
                        "name": "OpenSea Collection",
                        "nft_version": null,
                        "opensea_version": "2.0.0",
                        "owner": 102384,
                        "schema_name": "ERC1155",
                        "symbol": "OPENSTORE",
                        "total_supply": null,
                        "description": null,
                        "external_link": null,
                        "image_url": null,
                        "default_to_fiat": false,
                        "dev_buyer_fee_basis_points": 0,
                        "dev_seller_fee_basis_points": 0,
                        "only_proxied_transfers": false,
                        "opensea_buyer_fee_basis_points": 0,
                        "opensea_seller_fee_basis_points": 250,
                        "buyer_fee_basis_points": 0,
                        "seller_fee_basis_points": 250,
                        "payout_address": null
                    },
                    "owner": {
                        "user": {
                            "username": "NullAddress"
                        },
                        "profile_img_url": "https://storage.googleapis.com/opensea-static/opensea-profile/1.png",
                        "address": "0x0000000000000000000000000000000000000000",
                        "config": "",
                        "discord_id": ""
                    },
                    "permalink": "https://opensea.io/assets/0x495f947276749ce646f68ac8c248420045cb7b5e/70479185245472823933799012500856922265354379340922944019462782661995343642625",
                    "collection": {
                        "banner_image_url": "https://lh3.googleusercontent.com/i1dLTD9hXZSzeMGz02l202fkMjd3QQrZ2fCQ2TZt-ajo3L931rN_TRGeqU9IvTfm166GIvs5DWaWCKbnuxKq5JmMHLOXioRyCuMxNQ=s2500",
                        "chat_url": null,
                        "created_date": "2021-03-24T00:31:54.219565",
                        "default_to_fiat": false,
                        "description": "",
                        "dev_buyer_fee_basis_points": "0",
                        "dev_seller_fee_basis_points": "0",
                        "discord_url": null,
                        "display_data": {
                            "card_display_style": "contain",
                            "images": []
                        },
                        "external_url": null,
                        "featured": false,
                        "featured_image_url": null,
                        "hidden": true,
                        "safelist_request_status": "not_requested",
                        "image_url": "https://lh3.googleusercontent.com/qZRiTQMHRe5EswI1syqlf0Sf3sfY8bnZjtVhjn89Kh_RxfqZ1WBWTJBnyvnB-gJWsvr6-DsACvVxrPBsj5pSlecxj63iAcVfQTkD=s120",
                        "is_subject_to_whitelist": false,
                        "large_image_url": null,
                        "medium_username": null,
                        "name": "HiDef",
                        "only_proxied_transfers": false,
                        "opensea_buyer_fee_basis_points": "0",
                        "opensea_seller_fee_basis_points": "250",
                        "payout_address": null,
                        "require_email": false,
                        "short_description": null,
                        "slug": "hidef",
                        "telegram_url": null,
                        "twitter_username": null,
                        "instagram_username": null,
                        "wiki_url": null
                    },
                    "decimals": null,
                    "token_metadata": null
                },
                {
                    "id": 20424633,
                    "token_id": "70479185245472823933799012500856922265354379340922944019462782663094855270401",
                    "num_sales": 0,
                    "background_color": null,
                    "image_url": "https://lh3.googleusercontent.com/khA7EtiuPRzqfY6BZTLfOkX_VgfBg-Yde-wfgEY8c2yxciCtHeZNAhZVryS2dDDNpvOy0rtRei-N9rUXBVzq3f-1X-QV9MNs2MWC0w",
                    "image_preview_url": "https://lh3.googleusercontent.com/khA7EtiuPRzqfY6BZTLfOkX_VgfBg-Yde-wfgEY8c2yxciCtHeZNAhZVryS2dDDNpvOy0rtRei-N9rUXBVzq3f-1X-QV9MNs2MWC0w=s250",
                    "image_thumbnail_url": "https://lh3.googleusercontent.com/khA7EtiuPRzqfY6BZTLfOkX_VgfBg-Yde-wfgEY8c2yxciCtHeZNAhZVryS2dDDNpvOy0rtRei-N9rUXBVzq3f-1X-QV9MNs2MWC0w=s128",
                    "image_original_url": null,
                    "animation_url": null,
                    "animation_original_url": null,
                    "name": "HiDef Launch Logo",
                    "description": "4 of 10",
                    "external_link": null,
                    "asset_contract": {
                        "address": "0x495f947276749ce646f68ac8c248420045cb7b5e",
                        "asset_contract_type": "semi-fungible",
                        "created_date": "2020-12-02T17:40:53.232025",
                        "name": "OpenSea Collection",
                        "nft_version": null,
                        "opensea_version": "2.0.0",
                        "owner": 102384,
                        "schema_name": "ERC1155",
                        "symbol": "OPENSTORE",
                        "total_supply": null,
                        "description": null,
                        "external_link": null,
                        "image_url": null,
                        "default_to_fiat": false,
                        "dev_buyer_fee_basis_points": 0,
                        "dev_seller_fee_basis_points": 0,
                        "only_proxied_transfers": false,
                        "opensea_buyer_fee_basis_points": 0,
                        "opensea_seller_fee_basis_points": 250,
                        "buyer_fee_basis_points": 0,
                        "seller_fee_basis_points": 250,
                        "payout_address": null
                    },
                    "owner": {
                        "user": {
                            "username": "NullAddress"
                        },
                        "profile_img_url": "https://storage.googleapis.com/opensea-static/opensea-profile/1.png",
                        "address": "0x0000000000000000000000000000000000000000",
                        "config": "",
                        "discord_id": ""
                    },
                    "permalink": "https://opensea.io/assets/0x495f947276749ce646f68ac8c248420045cb7b5e/70479185245472823933799012500856922265354379340922944019462782663094855270401",
                    "collection": {
                        "banner_image_url": "https://lh3.googleusercontent.com/i1dLTD9hXZSzeMGz02l202fkMjd3QQrZ2fCQ2TZt-ajo3L931rN_TRGeqU9IvTfm166GIvs5DWaWCKbnuxKq5JmMHLOXioRyCuMxNQ=s2500",
                        "chat_url": null,
                        "created_date": "2021-03-24T00:31:54.219565",
                        "default_to_fiat": false,
                        "description": "",
                        "dev_buyer_fee_basis_points": "0",
                        "dev_seller_fee_basis_points": "0",
                        "discord_url": null,
                        "display_data": {
                            "card_display_style": "contain",
                            "images": []
                        },
                        "external_url": null,
                        "featured": false,
                        "featured_image_url": null,
                        "hidden": true,
                        "safelist_request_status": "not_requested",
                        "image_url": "https://lh3.googleusercontent.com/qZRiTQMHRe5EswI1syqlf0Sf3sfY8bnZjtVhjn89Kh_RxfqZ1WBWTJBnyvnB-gJWsvr6-DsACvVxrPBsj5pSlecxj63iAcVfQTkD=s120",
                        "is_subject_to_whitelist": false,
                        "large_image_url": null,
                        "medium_username": null,
                        "name": "HiDef",
                        "only_proxied_transfers": false,
                        "opensea_buyer_fee_basis_points": "0",
                        "opensea_seller_fee_basis_points": "250",
                        "payout_address": null,
                        "require_email": false,
                        "short_description": null,
                        "slug": "hidef",
                        "telegram_url": null,
                        "twitter_username": null,
                        "instagram_username": null,
                        "wiki_url": null
                    },
                    "decimals": null,
                    "token_metadata": null
                },
                {
                    "id": 20424665,
                    "token_id": "70479185245472823933799012500856922265354379340922944019462782664194366898177",
                    "num_sales": 0,
                    "background_color": null,
                    "image_url": "https://lh3.googleusercontent.com/khA7EtiuPRzqfY6BZTLfOkX_VgfBg-Yde-wfgEY8c2yxciCtHeZNAhZVryS2dDDNpvOy0rtRei-N9rUXBVzq3f-1X-QV9MNs2MWC0w",
                    "image_preview_url": "https://lh3.googleusercontent.com/khA7EtiuPRzqfY6BZTLfOkX_VgfBg-Yde-wfgEY8c2yxciCtHeZNAhZVryS2dDDNpvOy0rtRei-N9rUXBVzq3f-1X-QV9MNs2MWC0w=s250",
                    "image_thumbnail_url": "https://lh3.googleusercontent.com/khA7EtiuPRzqfY6BZTLfOkX_VgfBg-Yde-wfgEY8c2yxciCtHeZNAhZVryS2dDDNpvOy0rtRei-N9rUXBVzq3f-1X-QV9MNs2MWC0w=s128",
                    "image_original_url": null,
                    "animation_url": null,
                    "animation_original_url": null,
                    "name": "HiDef Launch Logo",
                    "description": "5 of 10",
                    "external_link": null,
                    "asset_contract": {
                        "address": "0x495f947276749ce646f68ac8c248420045cb7b5e",
                        "asset_contract_type": "semi-fungible",
                        "created_date": "2020-12-02T17:40:53.232025",
                        "name": "OpenSea Collection",
                        "nft_version": null,
                        "opensea_version": "2.0.0",
                        "owner": 102384,
                        "schema_name": "ERC1155",
                        "symbol": "OPENSTORE",
                        "total_supply": null,
                        "description": null,
                        "external_link": null,
                        "image_url": null,
                        "default_to_fiat": false,
                        "dev_buyer_fee_basis_points": 0,
                        "dev_seller_fee_basis_points": 0,
                        "only_proxied_transfers": false,
                        "opensea_buyer_fee_basis_points": 0,
                        "opensea_seller_fee_basis_points": 250,
                        "buyer_fee_basis_points": 0,
                        "seller_fee_basis_points": 250,
                        "payout_address": null
                    },
                    "owner": {
                        "user": {
                            "username": "NullAddress"
                        },
                        "profile_img_url": "https://storage.googleapis.com/opensea-static/opensea-profile/1.png",
                        "address": "0x0000000000000000000000000000000000000000",
                        "config": "",
                        "discord_id": ""
                    },
                    "permalink": "https://opensea.io/assets/0x495f947276749ce646f68ac8c248420045cb7b5e/70479185245472823933799012500856922265354379340922944019462782664194366898177",
                    "collection": {
                        "banner_image_url": "https://lh3.googleusercontent.com/i1dLTD9hXZSzeMGz02l202fkMjd3QQrZ2fCQ2TZt-ajo3L931rN_TRGeqU9IvTfm166GIvs5DWaWCKbnuxKq5JmMHLOXioRyCuMxNQ=s2500",
                        "chat_url": null,
                        "created_date": "2021-03-24T00:31:54.219565",
                        "default_to_fiat": false,
                        "description": "",
                        "dev_buyer_fee_basis_points": "0",
                        "dev_seller_fee_basis_points": "0",
                        "discord_url": null,
                        "display_data": {
                            "card_display_style": "contain",
                            "images": []
                        },
                        "external_url": null,
                        "featured": false,
                        "featured_image_url": null,
                        "hidden": true,
                        "safelist_request_status": "not_requested",
                        "image_url": "https://lh3.googleusercontent.com/qZRiTQMHRe5EswI1syqlf0Sf3sfY8bnZjtVhjn89Kh_RxfqZ1WBWTJBnyvnB-gJWsvr6-DsACvVxrPBsj5pSlecxj63iAcVfQTkD=s120",
                        "is_subject_to_whitelist": false,
                        "large_image_url": null,
                        "medium_username": null,
                        "name": "HiDef",
                        "only_proxied_transfers": false,
                        "opensea_buyer_fee_basis_points": "0",
                        "opensea_seller_fee_basis_points": "250",
                        "payout_address": null,
                        "require_email": false,
                        "short_description": null,
                        "slug": "hidef",
                        "telegram_url": null,
                        "twitter_username": null,
                        "instagram_username": null,
                        "wiki_url": null
                    },
                    "decimals": null,
                    "token_metadata": null
                },
                {
                    "id": 20424695,
                    "token_id": "70479185245472823933799012500856922265354379340922944019462782665293878525953",
                    "num_sales": 0,
                    "background_color": null,
                    "image_url": "https://lh3.googleusercontent.com/khA7EtiuPRzqfY6BZTLfOkX_VgfBg-Yde-wfgEY8c2yxciCtHeZNAhZVryS2dDDNpvOy0rtRei-N9rUXBVzq3f-1X-QV9MNs2MWC0w",
                    "image_preview_url": "https://lh3.googleusercontent.com/khA7EtiuPRzqfY6BZTLfOkX_VgfBg-Yde-wfgEY8c2yxciCtHeZNAhZVryS2dDDNpvOy0rtRei-N9rUXBVzq3f-1X-QV9MNs2MWC0w=s250",
                    "image_thumbnail_url": "https://lh3.googleusercontent.com/khA7EtiuPRzqfY6BZTLfOkX_VgfBg-Yde-wfgEY8c2yxciCtHeZNAhZVryS2dDDNpvOy0rtRei-N9rUXBVzq3f-1X-QV9MNs2MWC0w=s128",
                    "image_original_url": null,
                    "animation_url": null,
                    "animation_original_url": null,
                    "name": "HiDef Launch Logo",
                    "description": "6 of 10",
                    "external_link": null,
                    "asset_contract": {
                        "address": "0x495f947276749ce646f68ac8c248420045cb7b5e",
                        "asset_contract_type": "semi-fungible",
                        "created_date": "2020-12-02T17:40:53.232025",
                        "name": "OpenSea Collection",
                        "nft_version": null,
                        "opensea_version": "2.0.0",
                        "owner": 102384,
                        "schema_name": "ERC1155",
                        "symbol": "OPENSTORE",
                        "total_supply": null,
                        "description": null,
                        "external_link": null,
                        "image_url": null,
                        "default_to_fiat": false,
                        "dev_buyer_fee_basis_points": 0,
                        "dev_seller_fee_basis_points": 0,
                        "only_proxied_transfers": false,
                        "opensea_buyer_fee_basis_points": 0,
                        "opensea_seller_fee_basis_points": 250,
                        "buyer_fee_basis_points": 0,
                        "seller_fee_basis_points": 250,
                        "payout_address": null
                    },
                    "owner": {
                        "user": {
                            "username": "NullAddress"
                        },
                        "profile_img_url": "https://storage.googleapis.com/opensea-static/opensea-profile/1.png",
                        "address": "0x0000000000000000000000000000000000000000",
                        "config": "",
                        "discord_id": ""
                    },
                    "permalink": "https://opensea.io/assets/0x495f947276749ce646f68ac8c248420045cb7b5e/70479185245472823933799012500856922265354379340922944019462782665293878525953",
                    "collection": {
                        "banner_image_url": "https://lh3.googleusercontent.com/i1dLTD9hXZSzeMGz02l202fkMjd3QQrZ2fCQ2TZt-ajo3L931rN_TRGeqU9IvTfm166GIvs5DWaWCKbnuxKq5JmMHLOXioRyCuMxNQ=s2500",
                        "chat_url": null,
                        "created_date": "2021-03-24T00:31:54.219565",
                        "default_to_fiat": false,
                        "description": "",
                        "dev_buyer_fee_basis_points": "0",
                        "dev_seller_fee_basis_points": "0",
                        "discord_url": null,
                        "display_data": {
                            "card_display_style": "contain",
                            "images": []
                        },
                        "external_url": null,
                        "featured": false,
                        "featured_image_url": null,
                        "hidden": true,
                        "safelist_request_status": "not_requested",
                        "image_url": "https://lh3.googleusercontent.com/qZRiTQMHRe5EswI1syqlf0Sf3sfY8bnZjtVhjn89Kh_RxfqZ1WBWTJBnyvnB-gJWsvr6-DsACvVxrPBsj5pSlecxj63iAcVfQTkD=s120",
                        "is_subject_to_whitelist": false,
                        "large_image_url": null,
                        "medium_username": null,
                        "name": "HiDef",
                        "only_proxied_transfers": false,
                        "opensea_buyer_fee_basis_points": "0",
                        "opensea_seller_fee_basis_points": "250",
                        "payout_address": null,
                        "require_email": false,
                        "short_description": null,
                        "slug": "hidef",
                        "telegram_url": null,
                        "twitter_username": null,
                        "instagram_username": null,
                        "wiki_url": null
                    },
                    "decimals": null,
                    "token_metadata": null
                },
                {
                    "id": 20424735,
                    "token_id": "70479185245472823933799012500856922265354379340922944019462782666393390153729",
                    "num_sales": 0,
                    "background_color": null,
                    "image_url": "https://lh3.googleusercontent.com/khA7EtiuPRzqfY6BZTLfOkX_VgfBg-Yde-wfgEY8c2yxciCtHeZNAhZVryS2dDDNpvOy0rtRei-N9rUXBVzq3f-1X-QV9MNs2MWC0w",
                    "image_preview_url": "https://lh3.googleusercontent.com/khA7EtiuPRzqfY6BZTLfOkX_VgfBg-Yde-wfgEY8c2yxciCtHeZNAhZVryS2dDDNpvOy0rtRei-N9rUXBVzq3f-1X-QV9MNs2MWC0w=s250",
                    "image_thumbnail_url": "https://lh3.googleusercontent.com/khA7EtiuPRzqfY6BZTLfOkX_VgfBg-Yde-wfgEY8c2yxciCtHeZNAhZVryS2dDDNpvOy0rtRei-N9rUXBVzq3f-1X-QV9MNs2MWC0w=s128",
                    "image_original_url": null,
                    "animation_url": null,
                    "animation_original_url": null,
                    "name": "HiDef Launch Logo",
                    "description": "7 of 10",
                    "external_link": null,
                    "asset_contract": {
                        "address": "0x495f947276749ce646f68ac8c248420045cb7b5e",
                        "asset_contract_type": "semi-fungible",
                        "created_date": "2020-12-02T17:40:53.232025",
                        "name": "OpenSea Collection",
                        "nft_version": null,
                        "opensea_version": "2.0.0",
                        "owner": 102384,
                        "schema_name": "ERC1155",
                        "symbol": "OPENSTORE",
                        "total_supply": null,
                        "description": null,
                        "external_link": null,
                        "image_url": null,
                        "default_to_fiat": false,
                        "dev_buyer_fee_basis_points": 0,
                        "dev_seller_fee_basis_points": 0,
                        "only_proxied_transfers": false,
                        "opensea_buyer_fee_basis_points": 0,
                        "opensea_seller_fee_basis_points": 250,
                        "buyer_fee_basis_points": 0,
                        "seller_fee_basis_points": 250,
                        "payout_address": null
                    },
                    "owner": {
                        "user": {
                            "username": "NullAddress"
                        },
                        "profile_img_url": "https://storage.googleapis.com/opensea-static/opensea-profile/1.png",
                        "address": "0x0000000000000000000000000000000000000000",
                        "config": "",
                        "discord_id": ""
                    },
                    "permalink": "https://opensea.io/assets/0x495f947276749ce646f68ac8c248420045cb7b5e/70479185245472823933799012500856922265354379340922944019462782666393390153729",
                    "collection": {
                        "banner_image_url": "https://lh3.googleusercontent.com/i1dLTD9hXZSzeMGz02l202fkMjd3QQrZ2fCQ2TZt-ajo3L931rN_TRGeqU9IvTfm166GIvs5DWaWCKbnuxKq5JmMHLOXioRyCuMxNQ=s2500",
                        "chat_url": null,
                        "created_date": "2021-03-24T00:31:54.219565",
                        "default_to_fiat": false,
                        "description": "",
                        "dev_buyer_fee_basis_points": "0",
                        "dev_seller_fee_basis_points": "0",
                        "discord_url": null,
                        "display_data": {
                            "card_display_style": "contain",
                            "images": []
                        },
                        "external_url": null,
                        "featured": false,
                        "featured_image_url": null,
                        "hidden": true,
                        "safelist_request_status": "not_requested",
                        "image_url": "https://lh3.googleusercontent.com/qZRiTQMHRe5EswI1syqlf0Sf3sfY8bnZjtVhjn89Kh_RxfqZ1WBWTJBnyvnB-gJWsvr6-DsACvVxrPBsj5pSlecxj63iAcVfQTkD=s120",
                        "is_subject_to_whitelist": false,
                        "large_image_url": null,
                        "medium_username": null,
                        "name": "HiDef",
                        "only_proxied_transfers": false,
                        "opensea_buyer_fee_basis_points": "0",
                        "opensea_seller_fee_basis_points": "250",
                        "payout_address": null,
                        "require_email": false,
                        "short_description": null,
                        "slug": "hidef",
                        "telegram_url": null,
                        "twitter_username": null,
                        "instagram_username": null,
                        "wiki_url": null
                    },
                    "decimals": null,
                    "token_metadata": null
                },
                {
                    "id": 20424766,
                    "token_id": "70479185245472823933799012500856922265354379340922944019462782667492901781505",
                    "num_sales": 0,
                    "background_color": null,
                    "image_url": "https://lh3.googleusercontent.com/khA7EtiuPRzqfY6BZTLfOkX_VgfBg-Yde-wfgEY8c2yxciCtHeZNAhZVryS2dDDNpvOy0rtRei-N9rUXBVzq3f-1X-QV9MNs2MWC0w",
                    "image_preview_url": "https://lh3.googleusercontent.com/khA7EtiuPRzqfY6BZTLfOkX_VgfBg-Yde-wfgEY8c2yxciCtHeZNAhZVryS2dDDNpvOy0rtRei-N9rUXBVzq3f-1X-QV9MNs2MWC0w=s250",
                    "image_thumbnail_url": "https://lh3.googleusercontent.com/khA7EtiuPRzqfY6BZTLfOkX_VgfBg-Yde-wfgEY8c2yxciCtHeZNAhZVryS2dDDNpvOy0rtRei-N9rUXBVzq3f-1X-QV9MNs2MWC0w=s128",
                    "image_original_url": null,
                    "animation_url": null,
                    "animation_original_url": null,
                    "name": "HiDef Launch Logo",
                    "description": "8 of 10",
                    "external_link": null,
                    "asset_contract": {
                        "address": "0x495f947276749ce646f68ac8c248420045cb7b5e",
                        "asset_contract_type": "semi-fungible",
                        "created_date": "2020-12-02T17:40:53.232025",
                        "name": "OpenSea Collection",
                        "nft_version": null,
                        "opensea_version": "2.0.0",
                        "owner": 102384,
                        "schema_name": "ERC1155",
                        "symbol": "OPENSTORE",
                        "total_supply": null,
                        "description": null,
                        "external_link": null,
                        "image_url": null,
                        "default_to_fiat": false,
                        "dev_buyer_fee_basis_points": 0,
                        "dev_seller_fee_basis_points": 0,
                        "only_proxied_transfers": false,
                        "opensea_buyer_fee_basis_points": 0,
                        "opensea_seller_fee_basis_points": 250,
                        "buyer_fee_basis_points": 0,
                        "seller_fee_basis_points": 250,
                        "payout_address": null
                    },
                    "owner": {
                        "user": {
                            "username": "NullAddress"
                        },
                        "profile_img_url": "https://storage.googleapis.com/opensea-static/opensea-profile/1.png",
                        "address": "0x0000000000000000000000000000000000000000",
                        "config": "",
                        "discord_id": ""
                    },
                    "permalink": "https://opensea.io/assets/0x495f947276749ce646f68ac8c248420045cb7b5e/70479185245472823933799012500856922265354379340922944019462782667492901781505",
                    "collection": {
                        "banner_image_url": "https://lh3.googleusercontent.com/i1dLTD9hXZSzeMGz02l202fkMjd3QQrZ2fCQ2TZt-ajo3L931rN_TRGeqU9IvTfm166GIvs5DWaWCKbnuxKq5JmMHLOXioRyCuMxNQ=s2500",
                        "chat_url": null,
                        "created_date": "2021-03-24T00:31:54.219565",
                        "default_to_fiat": false,
                        "description": "",
                        "dev_buyer_fee_basis_points": "0",
                        "dev_seller_fee_basis_points": "0",
                        "discord_url": null,
                        "display_data": {
                            "card_display_style": "contain",
                            "images": []
                        },
                        "external_url": null,
                        "featured": false,
                        "featured_image_url": null,
                        "hidden": true,
                        "safelist_request_status": "not_requested",
                        "image_url": "https://lh3.googleusercontent.com/qZRiTQMHRe5EswI1syqlf0Sf3sfY8bnZjtVhjn89Kh_RxfqZ1WBWTJBnyvnB-gJWsvr6-DsACvVxrPBsj5pSlecxj63iAcVfQTkD=s120",
                        "is_subject_to_whitelist": false,
                        "large_image_url": null,
                        "medium_username": null,
                        "name": "HiDef",
                        "only_proxied_transfers": false,
                        "opensea_buyer_fee_basis_points": "0",
                        "opensea_seller_fee_basis_points": "250",
                        "payout_address": null,
                        "require_email": false,
                        "short_description": null,
                        "slug": "hidef",
                        "telegram_url": null,
                        "twitter_username": null,
                        "instagram_username": null,
                        "wiki_url": null
                    },
                    "decimals": null,
                    "token_metadata": null
                },
                {
                    "id": 20424788,
                    "token_id": "70479185245472823933799012500856922265354379340922944019462782668592413409281",
                    "num_sales": 0,
                    "background_color": null,
                    "image_url": "https://lh3.googleusercontent.com/khA7EtiuPRzqfY6BZTLfOkX_VgfBg-Yde-wfgEY8c2yxciCtHeZNAhZVryS2dDDNpvOy0rtRei-N9rUXBVzq3f-1X-QV9MNs2MWC0w",
                    "image_preview_url": "https://lh3.googleusercontent.com/khA7EtiuPRzqfY6BZTLfOkX_VgfBg-Yde-wfgEY8c2yxciCtHeZNAhZVryS2dDDNpvOy0rtRei-N9rUXBVzq3f-1X-QV9MNs2MWC0w=s250",
                    "image_thumbnail_url": "https://lh3.googleusercontent.com/khA7EtiuPRzqfY6BZTLfOkX_VgfBg-Yde-wfgEY8c2yxciCtHeZNAhZVryS2dDDNpvOy0rtRei-N9rUXBVzq3f-1X-QV9MNs2MWC0w=s128",
                    "image_original_url": null,
                    "animation_url": null,
                    "animation_original_url": null,
                    "name": "HiDef Launch Logo",
                    "description": "9 of 10",
                    "external_link": null,
                    "asset_contract": {
                        "address": "0x495f947276749ce646f68ac8c248420045cb7b5e",
                        "asset_contract_type": "semi-fungible",
                        "created_date": "2020-12-02T17:40:53.232025",
                        "name": "OpenSea Collection",
                        "nft_version": null,
                        "opensea_version": "2.0.0",
                        "owner": 102384,
                        "schema_name": "ERC1155",
                        "symbol": "OPENSTORE",
                        "total_supply": null,
                        "description": null,
                        "external_link": null,
                        "image_url": null,
                        "default_to_fiat": false,
                        "dev_buyer_fee_basis_points": 0,
                        "dev_seller_fee_basis_points": 0,
                        "only_proxied_transfers": false,
                        "opensea_buyer_fee_basis_points": 0,
                        "opensea_seller_fee_basis_points": 250,
                        "buyer_fee_basis_points": 0,
                        "seller_fee_basis_points": 250,
                        "payout_address": null
                    },
                    "owner": {
                        "user": {
                            "username": "NullAddress"
                        },
                        "profile_img_url": "https://storage.googleapis.com/opensea-static/opensea-profile/1.png",
                        "address": "0x0000000000000000000000000000000000000000",
                        "config": "",
                        "discord_id": ""
                    },
                    "permalink": "https://opensea.io/assets/0x495f947276749ce646f68ac8c248420045cb7b5e/70479185245472823933799012500856922265354379340922944019462782668592413409281",
                    "collection": {
                        "banner_image_url": "https://lh3.googleusercontent.com/i1dLTD9hXZSzeMGz02l202fkMjd3QQrZ2fCQ2TZt-ajo3L931rN_TRGeqU9IvTfm166GIvs5DWaWCKbnuxKq5JmMHLOXioRyCuMxNQ=s2500",
                        "chat_url": null,
                        "created_date": "2021-03-24T00:31:54.219565",
                        "default_to_fiat": false,
                        "description": "",
                        "dev_buyer_fee_basis_points": "0",
                        "dev_seller_fee_basis_points": "0",
                        "discord_url": null,
                        "display_data": {
                            "card_display_style": "contain",
                            "images": []
                        },
                        "external_url": null,
                        "featured": false,
                        "featured_image_url": null,
                        "hidden": true,
                        "safelist_request_status": "not_requested",
                        "image_url": "https://lh3.googleusercontent.com/qZRiTQMHRe5EswI1syqlf0Sf3sfY8bnZjtVhjn89Kh_RxfqZ1WBWTJBnyvnB-gJWsvr6-DsACvVxrPBsj5pSlecxj63iAcVfQTkD=s120",
                        "is_subject_to_whitelist": false,
                        "large_image_url": null,
                        "medium_username": null,
                        "name": "HiDef",
                        "only_proxied_transfers": false,
                        "opensea_buyer_fee_basis_points": "0",
                        "opensea_seller_fee_basis_points": "250",
                        "payout_address": null,
                        "require_email": false,
                        "short_description": null,
                        "slug": "hidef",
                        "telegram_url": null,
                        "twitter_username": null,
                        "instagram_username": null,
                        "wiki_url": null
                    },
                    "decimals": null,
                    "token_metadata": null
                },
                {
                    "id": 20424802,
                    "token_id": "70479185245472823933799012500856922265354379340922944019462782669691925037057",
                    "num_sales": 0,
                    "background_color": null,
                    "image_url": "https://lh3.googleusercontent.com/khA7EtiuPRzqfY6BZTLfOkX_VgfBg-Yde-wfgEY8c2yxciCtHeZNAhZVryS2dDDNpvOy0rtRei-N9rUXBVzq3f-1X-QV9MNs2MWC0w",
                    "image_preview_url": "https://lh3.googleusercontent.com/khA7EtiuPRzqfY6BZTLfOkX_VgfBg-Yde-wfgEY8c2yxciCtHeZNAhZVryS2dDDNpvOy0rtRei-N9rUXBVzq3f-1X-QV9MNs2MWC0w=s250",
                    "image_thumbnail_url": "https://lh3.googleusercontent.com/khA7EtiuPRzqfY6BZTLfOkX_VgfBg-Yde-wfgEY8c2yxciCtHeZNAhZVryS2dDDNpvOy0rtRei-N9rUXBVzq3f-1X-QV9MNs2MWC0w=s128",
                    "image_original_url": null,
                    "animation_url": null,
                    "animation_original_url": null,
                    "name": "HiDef Launch Logo",
                    "description": "10 of 10",
                    "external_link": null,
                    "asset_contract": {
                        "address": "0x495f947276749ce646f68ac8c248420045cb7b5e",
                        "asset_contract_type": "semi-fungible",
                        "created_date": "2020-12-02T17:40:53.232025",
                        "name": "OpenSea Collection",
                        "nft_version": null,
                        "opensea_version": "2.0.0",
                        "owner": 102384,
                        "schema_name": "ERC1155",
                        "symbol": "OPENSTORE",
                        "total_supply": null,
                        "description": null,
                        "external_link": null,
                        "image_url": null,
                        "default_to_fiat": false,
                        "dev_buyer_fee_basis_points": 0,
                        "dev_seller_fee_basis_points": 0,
                        "only_proxied_transfers": false,
                        "opensea_buyer_fee_basis_points": 0,
                        "opensea_seller_fee_basis_points": 250,
                        "buyer_fee_basis_points": 0,
                        "seller_fee_basis_points": 250,
                        "payout_address": null
                    },
                    "owner": {
                        "user": {
                            "username": "NullAddress"
                        },
                        "profile_img_url": "https://storage.googleapis.com/opensea-static/opensea-profile/1.png",
                        "address": "0x0000000000000000000000000000000000000000",
                        "config": "",
                        "discord_id": ""
                    },
                    "permalink": "https://opensea.io/assets/0x495f947276749ce646f68ac8c248420045cb7b5e/70479185245472823933799012500856922265354379340922944019462782669691925037057",
                    "collection": {
                        "banner_image_url": "https://lh3.googleusercontent.com/i1dLTD9hXZSzeMGz02l202fkMjd3QQrZ2fCQ2TZt-ajo3L931rN_TRGeqU9IvTfm166GIvs5DWaWCKbnuxKq5JmMHLOXioRyCuMxNQ=s2500",
                        "chat_url": null,
                        "created_date": "2021-03-24T00:31:54.219565",
                        "default_to_fiat": false,
                        "description": "",
                        "dev_buyer_fee_basis_points": "0",
                        "dev_seller_fee_basis_points": "0",
                        "discord_url": null,
                        "display_data": {
                            "card_display_style": "contain",
                            "images": []
                        },
                        "external_url": null,
                        "featured": false,
                        "featured_image_url": null,
                        "hidden": true,
                        "safelist_request_status": "not_requested",
                        "image_url": "https://lh3.googleusercontent.com/qZRiTQMHRe5EswI1syqlf0Sf3sfY8bnZjtVhjn89Kh_RxfqZ1WBWTJBnyvnB-gJWsvr6-DsACvVxrPBsj5pSlecxj63iAcVfQTkD=s120",
                        "is_subject_to_whitelist": false,
                        "large_image_url": null,
                        "medium_username": null,
                        "name": "HiDef",
                        "only_proxied_transfers": false,
                        "opensea_buyer_fee_basis_points": "0",
                        "opensea_seller_fee_basis_points": "250",
                        "payout_address": null,
                        "require_email": false,
                        "short_description": null,
                        "slug": "hidef",
                        "telegram_url": null,
                        "twitter_username": null,
                        "instagram_username": null,
                        "wiki_url": null
                    },
                    "decimals": null,
                    "token_metadata": null
                },
                {
                    "id": 20425265,
                    "token_id": "70479185245472823933799012500856922265354379340922944019462782692781669220353",
                    "num_sales": 0,
                    "background_color": null,
                    "image_url": "https://lh3.googleusercontent.com/4U_do2L61E94-14U2dUUeAIbK_KT6vxosDMtmoGIkqCSWXxr9oaNrom2dz6g3Ozk2lNrti74N88dHWmOWnFZPnVootRmw_nUhvCUQg",
                    "image_preview_url": "https://lh3.googleusercontent.com/4U_do2L61E94-14U2dUUeAIbK_KT6vxosDMtmoGIkqCSWXxr9oaNrom2dz6g3Ozk2lNrti74N88dHWmOWnFZPnVootRmw_nUhvCUQg=s250",
                    "image_thumbnail_url": "https://lh3.googleusercontent.com/4U_do2L61E94-14U2dUUeAIbK_KT6vxosDMtmoGIkqCSWXxr9oaNrom2dz6g3Ozk2lNrti74N88dHWmOWnFZPnVootRmw_nUhvCUQg=s128",
                    "image_original_url": null,
                    "animation_url": null,
                    "animation_original_url": null,
                    "name": "The Founders",
                    "description": "The fashionable four founders of HiDef 1 of 10",
                    "external_link": null,
                    "asset_contract": {
                        "address": "0x495f947276749ce646f68ac8c248420045cb7b5e",
                        "asset_contract_type": "semi-fungible",
                        "created_date": "2020-12-02T17:40:53.232025",
                        "name": "OpenSea Collection",
                        "nft_version": null,
                        "opensea_version": "2.0.0",
                        "owner": 102384,
                        "schema_name": "ERC1155",
                        "symbol": "OPENSTORE",
                        "total_supply": null,
                        "description": null,
                        "external_link": null,
                        "image_url": null,
                        "default_to_fiat": false,
                        "dev_buyer_fee_basis_points": 0,
                        "dev_seller_fee_basis_points": 0,
                        "only_proxied_transfers": false,
                        "opensea_buyer_fee_basis_points": 0,
                        "opensea_seller_fee_basis_points": 250,
                        "buyer_fee_basis_points": 0,
                        "seller_fee_basis_points": 250,
                        "payout_address": null
                    },
                    "owner": {
                        "user": {
                            "username": "NullAddress"
                        },
                        "profile_img_url": "https://storage.googleapis.com/opensea-static/opensea-profile/1.png",
                        "address": "0x0000000000000000000000000000000000000000",
                        "config": "",
                        "discord_id": ""
                    },
                    "permalink": "https://opensea.io/assets/0x495f947276749ce646f68ac8c248420045cb7b5e/70479185245472823933799012500856922265354379340922944019462782692781669220353",
                    "collection": {
                        "banner_image_url": "https://lh3.googleusercontent.com/i1dLTD9hXZSzeMGz02l202fkMjd3QQrZ2fCQ2TZt-ajo3L931rN_TRGeqU9IvTfm166GIvs5DWaWCKbnuxKq5JmMHLOXioRyCuMxNQ=s2500",
                        "chat_url": null,
                        "created_date": "2021-03-24T00:31:54.219565",
                        "default_to_fiat": false,
                        "description": "",
                        "dev_buyer_fee_basis_points": "0",
                        "dev_seller_fee_basis_points": "0",
                        "discord_url": null,
                        "display_data": {
                            "card_display_style": "contain",
                            "images": []
                        },
                        "external_url": null,
                        "featured": false,
                        "featured_image_url": null,
                        "hidden": true,
                        "safelist_request_status": "not_requested",
                        "image_url": "https://lh3.googleusercontent.com/qZRiTQMHRe5EswI1syqlf0Sf3sfY8bnZjtVhjn89Kh_RxfqZ1WBWTJBnyvnB-gJWsvr6-DsACvVxrPBsj5pSlecxj63iAcVfQTkD=s120",
                        "is_subject_to_whitelist": false,
                        "large_image_url": null,
                        "medium_username": null,
                        "name": "HiDef",
                        "only_proxied_transfers": false,
                        "opensea_buyer_fee_basis_points": "0",
                        "opensea_seller_fee_basis_points": "250",
                        "payout_address": null,
                        "require_email": false,
                        "short_description": null,
                        "slug": "hidef",
                        "telegram_url": null,
                        "twitter_username": null,
                        "instagram_username": null,
                        "wiki_url": null
                    },
                    "decimals": null,
                    "token_metadata": null
                },
                {
                    "id": 20425285,
                    "token_id": "70479185245472823933799012500856922265354379340922944019462782693881180848129",
                    "num_sales": 0,
                    "background_color": null,
                    "image_url": "https://lh3.googleusercontent.com/4U_do2L61E94-14U2dUUeAIbK_KT6vxosDMtmoGIkqCSWXxr9oaNrom2dz6g3Ozk2lNrti74N88dHWmOWnFZPnVootRmw_nUhvCUQg",
                    "image_preview_url": "https://lh3.googleusercontent.com/4U_do2L61E94-14U2dUUeAIbK_KT6vxosDMtmoGIkqCSWXxr9oaNrom2dz6g3Ozk2lNrti74N88dHWmOWnFZPnVootRmw_nUhvCUQg=s250",
                    "image_thumbnail_url": "https://lh3.googleusercontent.com/4U_do2L61E94-14U2dUUeAIbK_KT6vxosDMtmoGIkqCSWXxr9oaNrom2dz6g3Ozk2lNrti74N88dHWmOWnFZPnVootRmw_nUhvCUQg=s128",
                    "image_original_url": null,
                    "animation_url": null,
                    "animation_original_url": null,
                    "name": "The Founders",
                    "description": "The fashionable four founders of HiDef 2 of 10",
                    "external_link": null,
                    "asset_contract": {
                        "address": "0x495f947276749ce646f68ac8c248420045cb7b5e",
                        "asset_contract_type": "semi-fungible",
                        "created_date": "2020-12-02T17:40:53.232025",
                        "name": "OpenSea Collection",
                        "nft_version": null,
                        "opensea_version": "2.0.0",
                        "owner": 102384,
                        "schema_name": "ERC1155",
                        "symbol": "OPENSTORE",
                        "total_supply": null,
                        "description": null,
                        "external_link": null,
                        "image_url": null,
                        "default_to_fiat": false,
                        "dev_buyer_fee_basis_points": 0,
                        "dev_seller_fee_basis_points": 0,
                        "only_proxied_transfers": false,
                        "opensea_buyer_fee_basis_points": 0,
                        "opensea_seller_fee_basis_points": 250,
                        "buyer_fee_basis_points": 0,
                        "seller_fee_basis_points": 250,
                        "payout_address": null
                    },
                    "owner": {
                        "user": {
                            "username": "NullAddress"
                        },
                        "profile_img_url": "https://storage.googleapis.com/opensea-static/opensea-profile/1.png",
                        "address": "0x0000000000000000000000000000000000000000",
                        "config": "",
                        "discord_id": ""
                    },
                    "permalink": "https://opensea.io/assets/0x495f947276749ce646f68ac8c248420045cb7b5e/70479185245472823933799012500856922265354379340922944019462782693881180848129",
                    "collection": {
                        "banner_image_url": "https://lh3.googleusercontent.com/i1dLTD9hXZSzeMGz02l202fkMjd3QQrZ2fCQ2TZt-ajo3L931rN_TRGeqU9IvTfm166GIvs5DWaWCKbnuxKq5JmMHLOXioRyCuMxNQ=s2500",
                        "chat_url": null,
                        "created_date": "2021-03-24T00:31:54.219565",
                        "default_to_fiat": false,
                        "description": "",
                        "dev_buyer_fee_basis_points": "0",
                        "dev_seller_fee_basis_points": "0",
                        "discord_url": null,
                        "display_data": {
                            "card_display_style": "contain",
                            "images": []
                        },
                        "external_url": null,
                        "featured": false,
                        "featured_image_url": null,
                        "hidden": true,
                        "safelist_request_status": "not_requested",
                        "image_url": "https://lh3.googleusercontent.com/qZRiTQMHRe5EswI1syqlf0Sf3sfY8bnZjtVhjn89Kh_RxfqZ1WBWTJBnyvnB-gJWsvr6-DsACvVxrPBsj5pSlecxj63iAcVfQTkD=s120",
                        "is_subject_to_whitelist": false,
                        "large_image_url": null,
                        "medium_username": null,
                        "name": "HiDef",
                        "only_proxied_transfers": false,
                        "opensea_buyer_fee_basis_points": "0",
                        "opensea_seller_fee_basis_points": "250",
                        "payout_address": null,
                        "require_email": false,
                        "short_description": null,
                        "slug": "hidef",
                        "telegram_url": null,
                        "twitter_username": null,
                        "instagram_username": null,
                        "wiki_url": null
                    },
                    "decimals": null,
                    "token_metadata": null
                },
                {
                    "id": 20425301,
                    "token_id": "70479185245472823933799012500856922265354379340922944019462782694980692475905",
                    "num_sales": 0,
                    "background_color": null,
                    "image_url": "https://lh3.googleusercontent.com/4U_do2L61E94-14U2dUUeAIbK_KT6vxosDMtmoGIkqCSWXxr9oaNrom2dz6g3Ozk2lNrti74N88dHWmOWnFZPnVootRmw_nUhvCUQg",
                    "image_preview_url": "https://lh3.googleusercontent.com/4U_do2L61E94-14U2dUUeAIbK_KT6vxosDMtmoGIkqCSWXxr9oaNrom2dz6g3Ozk2lNrti74N88dHWmOWnFZPnVootRmw_nUhvCUQg=s250",
                    "image_thumbnail_url": "https://lh3.googleusercontent.com/4U_do2L61E94-14U2dUUeAIbK_KT6vxosDMtmoGIkqCSWXxr9oaNrom2dz6g3Ozk2lNrti74N88dHWmOWnFZPnVootRmw_nUhvCUQg=s128",
                    "image_original_url": null,
                    "animation_url": null,
                    "animation_original_url": null,
                    "name": "The Founders",
                    "description": "The fashionable four founders of HiDef 3 of 10",
                    "external_link": null,
                    "asset_contract": {
                        "address": "0x495f947276749ce646f68ac8c248420045cb7b5e",
                        "asset_contract_type": "semi-fungible",
                        "created_date": "2020-12-02T17:40:53.232025",
                        "name": "OpenSea Collection",
                        "nft_version": null,
                        "opensea_version": "2.0.0",
                        "owner": 102384,
                        "schema_name": "ERC1155",
                        "symbol": "OPENSTORE",
                        "total_supply": null,
                        "description": null,
                        "external_link": null,
                        "image_url": null,
                        "default_to_fiat": false,
                        "dev_buyer_fee_basis_points": 0,
                        "dev_seller_fee_basis_points": 0,
                        "only_proxied_transfers": false,
                        "opensea_buyer_fee_basis_points": 0,
                        "opensea_seller_fee_basis_points": 250,
                        "buyer_fee_basis_points": 0,
                        "seller_fee_basis_points": 250,
                        "payout_address": null
                    },
                    "owner": {
                        "user": {
                            "username": "NullAddress"
                        },
                        "profile_img_url": "https://storage.googleapis.com/opensea-static/opensea-profile/1.png",
                        "address": "0x0000000000000000000000000000000000000000",
                        "config": "",
                        "discord_id": ""
                    },
                    "permalink": "https://opensea.io/assets/0x495f947276749ce646f68ac8c248420045cb7b5e/70479185245472823933799012500856922265354379340922944019462782694980692475905",
                    "collection": {
                        "banner_image_url": "https://lh3.googleusercontent.com/i1dLTD9hXZSzeMGz02l202fkMjd3QQrZ2fCQ2TZt-ajo3L931rN_TRGeqU9IvTfm166GIvs5DWaWCKbnuxKq5JmMHLOXioRyCuMxNQ=s2500",
                        "chat_url": null,
                        "created_date": "2021-03-24T00:31:54.219565",
                        "default_to_fiat": false,
                        "description": "",
                        "dev_buyer_fee_basis_points": "0",
                        "dev_seller_fee_basis_points": "0",
                        "discord_url": null,
                        "display_data": {
                            "card_display_style": "contain",
                            "images": []
                        },
                        "external_url": null,
                        "featured": false,
                        "featured_image_url": null,
                        "hidden": true,
                        "safelist_request_status": "not_requested",
                        "image_url": "https://lh3.googleusercontent.com/qZRiTQMHRe5EswI1syqlf0Sf3sfY8bnZjtVhjn89Kh_RxfqZ1WBWTJBnyvnB-gJWsvr6-DsACvVxrPBsj5pSlecxj63iAcVfQTkD=s120",
                        "is_subject_to_whitelist": false,
                        "large_image_url": null,
                        "medium_username": null,
                        "name": "HiDef",
                        "only_proxied_transfers": false,
                        "opensea_buyer_fee_basis_points": "0",
                        "opensea_seller_fee_basis_points": "250",
                        "payout_address": null,
                        "require_email": false,
                        "short_description": null,
                        "slug": "hidef",
                        "telegram_url": null,
                        "twitter_username": null,
                        "instagram_username": null,
                        "wiki_url": null
                    },
                    "decimals": null,
                    "token_metadata": null
                },
                {
                    "id": 20425320,
                    "token_id": "70479185245472823933799012500856922265354379340922944019462782696080204103681",
                    "num_sales": 0,
                    "background_color": null,
                    "image_url": "https://lh3.googleusercontent.com/4U_do2L61E94-14U2dUUeAIbK_KT6vxosDMtmoGIkqCSWXxr9oaNrom2dz6g3Ozk2lNrti74N88dHWmOWnFZPnVootRmw_nUhvCUQg",
                    "image_preview_url": "https://lh3.googleusercontent.com/4U_do2L61E94-14U2dUUeAIbK_KT6vxosDMtmoGIkqCSWXxr9oaNrom2dz6g3Ozk2lNrti74N88dHWmOWnFZPnVootRmw_nUhvCUQg=s250",
                    "image_thumbnail_url": "https://lh3.googleusercontent.com/4U_do2L61E94-14U2dUUeAIbK_KT6vxosDMtmoGIkqCSWXxr9oaNrom2dz6g3Ozk2lNrti74N88dHWmOWnFZPnVootRmw_nUhvCUQg=s128",
                    "image_original_url": null,
                    "animation_url": null,
                    "animation_original_url": null,
                    "name": "The Founders",
                    "description": "The fashionable four founders of HiDef 4 of 10",
                    "external_link": null,
                    "asset_contract": {
                        "address": "0x495f947276749ce646f68ac8c248420045cb7b5e",
                        "asset_contract_type": "semi-fungible",
                        "created_date": "2020-12-02T17:40:53.232025",
                        "name": "OpenSea Collection",
                        "nft_version": null,
                        "opensea_version": "2.0.0",
                        "owner": 102384,
                        "schema_name": "ERC1155",
                        "symbol": "OPENSTORE",
                        "total_supply": null,
                        "description": null,
                        "external_link": null,
                        "image_url": null,
                        "default_to_fiat": false,
                        "dev_buyer_fee_basis_points": 0,
                        "dev_seller_fee_basis_points": 0,
                        "only_proxied_transfers": false,
                        "opensea_buyer_fee_basis_points": 0,
                        "opensea_seller_fee_basis_points": 250,
                        "buyer_fee_basis_points": 0,
                        "seller_fee_basis_points": 250,
                        "payout_address": null
                    },
                    "owner": {
                        "user": {
                            "username": "NullAddress"
                        },
                        "profile_img_url": "https://storage.googleapis.com/opensea-static/opensea-profile/1.png",
                        "address": "0x0000000000000000000000000000000000000000",
                        "config": "",
                        "discord_id": ""
                    },
                    "permalink": "https://opensea.io/assets/0x495f947276749ce646f68ac8c248420045cb7b5e/70479185245472823933799012500856922265354379340922944019462782696080204103681",
                    "collection": {
                        "banner_image_url": "https://lh3.googleusercontent.com/i1dLTD9hXZSzeMGz02l202fkMjd3QQrZ2fCQ2TZt-ajo3L931rN_TRGeqU9IvTfm166GIvs5DWaWCKbnuxKq5JmMHLOXioRyCuMxNQ=s2500",
                        "chat_url": null,
                        "created_date": "2021-03-24T00:31:54.219565",
                        "default_to_fiat": false,
                        "description": "",
                        "dev_buyer_fee_basis_points": "0",
                        "dev_seller_fee_basis_points": "0",
                        "discord_url": null,
                        "display_data": {
                            "card_display_style": "contain",
                            "images": []
                        },
                        "external_url": null,
                        "featured": false,
                        "featured_image_url": null,
                        "hidden": true,
                        "safelist_request_status": "not_requested",
                        "image_url": "https://lh3.googleusercontent.com/qZRiTQMHRe5EswI1syqlf0Sf3sfY8bnZjtVhjn89Kh_RxfqZ1WBWTJBnyvnB-gJWsvr6-DsACvVxrPBsj5pSlecxj63iAcVfQTkD=s120",
                        "is_subject_to_whitelist": false,
                        "large_image_url": null,
                        "medium_username": null,
                        "name": "HiDef",
                        "only_proxied_transfers": false,
                        "opensea_buyer_fee_basis_points": "0",
                        "opensea_seller_fee_basis_points": "250",
                        "payout_address": null,
                        "require_email": false,
                        "short_description": null,
                        "slug": "hidef",
                        "telegram_url": null,
                        "twitter_username": null,
                        "instagram_username": null,
                        "wiki_url": null
                    },
                    "decimals": null,
                    "token_metadata": null
                },
                {
                    "id": 20425336,
                    "token_id": "70479185245472823933799012500856922265354379340922944019462782697179715731457",
                    "num_sales": 0,
                    "background_color": null,
                    "image_url": "https://lh3.googleusercontent.com/4U_do2L61E94-14U2dUUeAIbK_KT6vxosDMtmoGIkqCSWXxr9oaNrom2dz6g3Ozk2lNrti74N88dHWmOWnFZPnVootRmw_nUhvCUQg",
                    "image_preview_url": "https://lh3.googleusercontent.com/4U_do2L61E94-14U2dUUeAIbK_KT6vxosDMtmoGIkqCSWXxr9oaNrom2dz6g3Ozk2lNrti74N88dHWmOWnFZPnVootRmw_nUhvCUQg=s250",
                    "image_thumbnail_url": "https://lh3.googleusercontent.com/4U_do2L61E94-14U2dUUeAIbK_KT6vxosDMtmoGIkqCSWXxr9oaNrom2dz6g3Ozk2lNrti74N88dHWmOWnFZPnVootRmw_nUhvCUQg=s128",
                    "image_original_url": null,
                    "animation_url": null,
                    "animation_original_url": null,
                    "name": "The Founders",
                    "description": "The fashionable four founders of HiDef 5 of 10",
                    "external_link": null,
                    "asset_contract": {
                        "address": "0x495f947276749ce646f68ac8c248420045cb7b5e",
                        "asset_contract_type": "semi-fungible",
                        "created_date": "2020-12-02T17:40:53.232025",
                        "name": "OpenSea Collection",
                        "nft_version": null,
                        "opensea_version": "2.0.0",
                        "owner": 102384,
                        "schema_name": "ERC1155",
                        "symbol": "OPENSTORE",
                        "total_supply": null,
                        "description": null,
                        "external_link": null,
                        "image_url": null,
                        "default_to_fiat": false,
                        "dev_buyer_fee_basis_points": 0,
                        "dev_seller_fee_basis_points": 0,
                        "only_proxied_transfers": false,
                        "opensea_buyer_fee_basis_points": 0,
                        "opensea_seller_fee_basis_points": 250,
                        "buyer_fee_basis_points": 0,
                        "seller_fee_basis_points": 250,
                        "payout_address": null
                    },
                    "owner": {
                        "user": {
                            "username": "NullAddress"
                        },
                        "profile_img_url": "https://storage.googleapis.com/opensea-static/opensea-profile/1.png",
                        "address": "0x0000000000000000000000000000000000000000",
                        "config": "",
                        "discord_id": ""
                    },
                    "permalink": "https://opensea.io/assets/0x495f947276749ce646f68ac8c248420045cb7b5e/70479185245472823933799012500856922265354379340922944019462782697179715731457",
                    "collection": {
                        "banner_image_url": "https://lh3.googleusercontent.com/i1dLTD9hXZSzeMGz02l202fkMjd3QQrZ2fCQ2TZt-ajo3L931rN_TRGeqU9IvTfm166GIvs5DWaWCKbnuxKq5JmMHLOXioRyCuMxNQ=s2500",
                        "chat_url": null,
                        "created_date": "2021-03-24T00:31:54.219565",
                        "default_to_fiat": false,
                        "description": "",
                        "dev_buyer_fee_basis_points": "0",
                        "dev_seller_fee_basis_points": "0",
                        "discord_url": null,
                        "display_data": {
                            "card_display_style": "contain",
                            "images": []
                        },
                        "external_url": null,
                        "featured": false,
                        "featured_image_url": null,
                        "hidden": true,
                        "safelist_request_status": "not_requested",
                        "image_url": "https://lh3.googleusercontent.com/qZRiTQMHRe5EswI1syqlf0Sf3sfY8bnZjtVhjn89Kh_RxfqZ1WBWTJBnyvnB-gJWsvr6-DsACvVxrPBsj5pSlecxj63iAcVfQTkD=s120",
                        "is_subject_to_whitelist": false,
                        "large_image_url": null,
                        "medium_username": null,
                        "name": "HiDef",
                        "only_proxied_transfers": false,
                        "opensea_buyer_fee_basis_points": "0",
                        "opensea_seller_fee_basis_points": "250",
                        "payout_address": null,
                        "require_email": false,
                        "short_description": null,
                        "slug": "hidef",
                        "telegram_url": null,
                        "twitter_username": null,
                        "instagram_username": null,
                        "wiki_url": null
                    },
                    "decimals": null,
                    "token_metadata": null
                },
                {
                    "id": 20425350,
                    "token_id": "70479185245472823933799012500856922265354379340922944019462782698279227359233",
                    "num_sales": 0,
                    "background_color": null,
                    "image_url": "https://lh3.googleusercontent.com/4U_do2L61E94-14U2dUUeAIbK_KT6vxosDMtmoGIkqCSWXxr9oaNrom2dz6g3Ozk2lNrti74N88dHWmOWnFZPnVootRmw_nUhvCUQg",
                    "image_preview_url": "https://lh3.googleusercontent.com/4U_do2L61E94-14U2dUUeAIbK_KT6vxosDMtmoGIkqCSWXxr9oaNrom2dz6g3Ozk2lNrti74N88dHWmOWnFZPnVootRmw_nUhvCUQg=s250",
                    "image_thumbnail_url": "https://lh3.googleusercontent.com/4U_do2L61E94-14U2dUUeAIbK_KT6vxosDMtmoGIkqCSWXxr9oaNrom2dz6g3Ozk2lNrti74N88dHWmOWnFZPnVootRmw_nUhvCUQg=s128",
                    "image_original_url": null,
                    "animation_url": null,
                    "animation_original_url": null,
                    "name": "The Founders",
                    "description": "The fashionable four founders of HiDef 6 of 10",
                    "external_link": null,
                    "asset_contract": {
                        "address": "0x495f947276749ce646f68ac8c248420045cb7b5e",
                        "asset_contract_type": "semi-fungible",
                        "created_date": "2020-12-02T17:40:53.232025",
                        "name": "OpenSea Collection",
                        "nft_version": null,
                        "opensea_version": "2.0.0",
                        "owner": 102384,
                        "schema_name": "ERC1155",
                        "symbol": "OPENSTORE",
                        "total_supply": null,
                        "description": null,
                        "external_link": null,
                        "image_url": null,
                        "default_to_fiat": false,
                        "dev_buyer_fee_basis_points": 0,
                        "dev_seller_fee_basis_points": 0,
                        "only_proxied_transfers": false,
                        "opensea_buyer_fee_basis_points": 0,
                        "opensea_seller_fee_basis_points": 250,
                        "buyer_fee_basis_points": 0,
                        "seller_fee_basis_points": 250,
                        "payout_address": null
                    },
                    "owner": {
                        "user": {
                            "username": "NullAddress"
                        },
                        "profile_img_url": "https://storage.googleapis.com/opensea-static/opensea-profile/1.png",
                        "address": "0x0000000000000000000000000000000000000000",
                        "config": "",
                        "discord_id": ""
                    },
                    "permalink": "https://opensea.io/assets/0x495f947276749ce646f68ac8c248420045cb7b5e/70479185245472823933799012500856922265354379340922944019462782698279227359233",
                    "collection": {
                        "banner_image_url": "https://lh3.googleusercontent.com/i1dLTD9hXZSzeMGz02l202fkMjd3QQrZ2fCQ2TZt-ajo3L931rN_TRGeqU9IvTfm166GIvs5DWaWCKbnuxKq5JmMHLOXioRyCuMxNQ=s2500",
                        "chat_url": null,
                        "created_date": "2021-03-24T00:31:54.219565",
                        "default_to_fiat": false,
                        "description": "",
                        "dev_buyer_fee_basis_points": "0",
                        "dev_seller_fee_basis_points": "0",
                        "discord_url": null,
                        "display_data": {
                            "card_display_style": "contain",
                            "images": []
                        },
                        "external_url": null,
                        "featured": false,
                        "featured_image_url": null,
                        "hidden": true,
                        "safelist_request_status": "not_requested",
                        "image_url": "https://lh3.googleusercontent.com/qZRiTQMHRe5EswI1syqlf0Sf3sfY8bnZjtVhjn89Kh_RxfqZ1WBWTJBnyvnB-gJWsvr6-DsACvVxrPBsj5pSlecxj63iAcVfQTkD=s120",
                        "is_subject_to_whitelist": false,
                        "large_image_url": null,
                        "medium_username": null,
                        "name": "HiDef",
                        "only_proxied_transfers": false,
                        "opensea_buyer_fee_basis_points": "0",
                        "opensea_seller_fee_basis_points": "250",
                        "payout_address": null,
                        "require_email": false,
                        "short_description": null,
                        "slug": "hidef",
                        "telegram_url": null,
                        "twitter_username": null,
                        "instagram_username": null,
                        "wiki_url": null
                    },
                    "decimals": null,
                    "token_metadata": null
                },
                {
                    "id": 20425368,
                    "token_id": "70479185245472823933799012500856922265354379340922944019462782699378738987009",
                    "num_sales": 0,
                    "background_color": null,
                    "image_url": "https://lh3.googleusercontent.com/4U_do2L61E94-14U2dUUeAIbK_KT6vxosDMtmoGIkqCSWXxr9oaNrom2dz6g3Ozk2lNrti74N88dHWmOWnFZPnVootRmw_nUhvCUQg",
                    "image_preview_url": "https://lh3.googleusercontent.com/4U_do2L61E94-14U2dUUeAIbK_KT6vxosDMtmoGIkqCSWXxr9oaNrom2dz6g3Ozk2lNrti74N88dHWmOWnFZPnVootRmw_nUhvCUQg=s250",
                    "image_thumbnail_url": "https://lh3.googleusercontent.com/4U_do2L61E94-14U2dUUeAIbK_KT6vxosDMtmoGIkqCSWXxr9oaNrom2dz6g3Ozk2lNrti74N88dHWmOWnFZPnVootRmw_nUhvCUQg=s128",
                    "image_original_url": null,
                    "animation_url": null,
                    "animation_original_url": null,
                    "name": "The Founders",
                    "description": "The fashionable four founders of HiDef 7 of 10",
                    "external_link": null,
                    "asset_contract": {
                        "address": "0x495f947276749ce646f68ac8c248420045cb7b5e",
                        "asset_contract_type": "semi-fungible",
                        "created_date": "2020-12-02T17:40:53.232025",
                        "name": "OpenSea Collection",
                        "nft_version": null,
                        "opensea_version": "2.0.0",
                        "owner": 102384,
                        "schema_name": "ERC1155",
                        "symbol": "OPENSTORE",
                        "total_supply": null,
                        "description": null,
                        "external_link": null,
                        "image_url": null,
                        "default_to_fiat": false,
                        "dev_buyer_fee_basis_points": 0,
                        "dev_seller_fee_basis_points": 0,
                        "only_proxied_transfers": false,
                        "opensea_buyer_fee_basis_points": 0,
                        "opensea_seller_fee_basis_points": 250,
                        "buyer_fee_basis_points": 0,
                        "seller_fee_basis_points": 250,
                        "payout_address": null
                    },
                    "owner": {
                        "user": {
                            "username": "NullAddress"
                        },
                        "profile_img_url": "https://storage.googleapis.com/opensea-static/opensea-profile/1.png",
                        "address": "0x0000000000000000000000000000000000000000",
                        "config": "",
                        "discord_id": ""
                    },
                    "permalink": "https://opensea.io/assets/0x495f947276749ce646f68ac8c248420045cb7b5e/70479185245472823933799012500856922265354379340922944019462782699378738987009",
                    "collection": {
                        "banner_image_url": "https://lh3.googleusercontent.com/i1dLTD9hXZSzeMGz02l202fkMjd3QQrZ2fCQ2TZt-ajo3L931rN_TRGeqU9IvTfm166GIvs5DWaWCKbnuxKq5JmMHLOXioRyCuMxNQ=s2500",
                        "chat_url": null,
                        "created_date": "2021-03-24T00:31:54.219565",
                        "default_to_fiat": false,
                        "description": "",
                        "dev_buyer_fee_basis_points": "0",
                        "dev_seller_fee_basis_points": "0",
                        "discord_url": null,
                        "display_data": {
                            "card_display_style": "contain",
                            "images": []
                        },
                        "external_url": null,
                        "featured": false,
                        "featured_image_url": null,
                        "hidden": true,
                        "safelist_request_status": "not_requested",
                        "image_url": "https://lh3.googleusercontent.com/qZRiTQMHRe5EswI1syqlf0Sf3sfY8bnZjtVhjn89Kh_RxfqZ1WBWTJBnyvnB-gJWsvr6-DsACvVxrPBsj5pSlecxj63iAcVfQTkD=s120",
                        "is_subject_to_whitelist": false,
                        "large_image_url": null,
                        "medium_username": null,
                        "name": "HiDef",
                        "only_proxied_transfers": false,
                        "opensea_buyer_fee_basis_points": "0",
                        "opensea_seller_fee_basis_points": "250",
                        "payout_address": null,
                        "require_email": false,
                        "short_description": null,
                        "slug": "hidef",
                        "telegram_url": null,
                        "twitter_username": null,
                        "instagram_username": null,
                        "wiki_url": null
                    },
                    "decimals": null,
                    "token_metadata": null
                },
                {
                    "id": 20425379,
                    "token_id": "70479185245472823933799012500856922265354379340922944019462782700478250614785",
                    "num_sales": 0,
                    "background_color": null,
                    "image_url": "https://lh3.googleusercontent.com/4U_do2L61E94-14U2dUUeAIbK_KT6vxosDMtmoGIkqCSWXxr9oaNrom2dz6g3Ozk2lNrti74N88dHWmOWnFZPnVootRmw_nUhvCUQg",
                    "image_preview_url": "https://lh3.googleusercontent.com/4U_do2L61E94-14U2dUUeAIbK_KT6vxosDMtmoGIkqCSWXxr9oaNrom2dz6g3Ozk2lNrti74N88dHWmOWnFZPnVootRmw_nUhvCUQg=s250",
                    "image_thumbnail_url": "https://lh3.googleusercontent.com/4U_do2L61E94-14U2dUUeAIbK_KT6vxosDMtmoGIkqCSWXxr9oaNrom2dz6g3Ozk2lNrti74N88dHWmOWnFZPnVootRmw_nUhvCUQg=s128",
                    "image_original_url": null,
                    "animation_url": null,
                    "animation_original_url": null,
                    "name": "The Founders",
                    "description": "The fashionable four founders of HiDef 8 of 10",
                    "external_link": null,
                    "asset_contract": {
                        "address": "0x495f947276749ce646f68ac8c248420045cb7b5e",
                        "asset_contract_type": "semi-fungible",
                        "created_date": "2020-12-02T17:40:53.232025",
                        "name": "OpenSea Collection",
                        "nft_version": null,
                        "opensea_version": "2.0.0",
                        "owner": 102384,
                        "schema_name": "ERC1155",
                        "symbol": "OPENSTORE",
                        "total_supply": null,
                        "description": null,
                        "external_link": null,
                        "image_url": null,
                        "default_to_fiat": false,
                        "dev_buyer_fee_basis_points": 0,
                        "dev_seller_fee_basis_points": 0,
                        "only_proxied_transfers": false,
                        "opensea_buyer_fee_basis_points": 0,
                        "opensea_seller_fee_basis_points": 250,
                        "buyer_fee_basis_points": 0,
                        "seller_fee_basis_points": 250,
                        "payout_address": null
                    },
                    "owner": {
                        "user": {
                            "username": "NullAddress"
                        },
                        "profile_img_url": "https://storage.googleapis.com/opensea-static/opensea-profile/1.png",
                        "address": "0x0000000000000000000000000000000000000000",
                        "config": "",
                        "discord_id": ""
                    },
                    "permalink": "https://opensea.io/assets/0x495f947276749ce646f68ac8c248420045cb7b5e/70479185245472823933799012500856922265354379340922944019462782700478250614785",
                    "collection": {
                        "banner_image_url": "https://lh3.googleusercontent.com/i1dLTD9hXZSzeMGz02l202fkMjd3QQrZ2fCQ2TZt-ajo3L931rN_TRGeqU9IvTfm166GIvs5DWaWCKbnuxKq5JmMHLOXioRyCuMxNQ=s2500",
                        "chat_url": null,
                        "created_date": "2021-03-24T00:31:54.219565",
                        "default_to_fiat": false,
                        "description": "",
                        "dev_buyer_fee_basis_points": "0",
                        "dev_seller_fee_basis_points": "0",
                        "discord_url": null,
                        "display_data": {
                            "card_display_style": "contain",
                            "images": []
                        },
                        "external_url": null,
                        "featured": false,
                        "featured_image_url": null,
                        "hidden": true,
                        "safelist_request_status": "not_requested",
                        "image_url": "https://lh3.googleusercontent.com/qZRiTQMHRe5EswI1syqlf0Sf3sfY8bnZjtVhjn89Kh_RxfqZ1WBWTJBnyvnB-gJWsvr6-DsACvVxrPBsj5pSlecxj63iAcVfQTkD=s120",
                        "is_subject_to_whitelist": false,
                        "large_image_url": null,
                        "medium_username": null,
                        "name": "HiDef",
                        "only_proxied_transfers": false,
                        "opensea_buyer_fee_basis_points": "0",
                        "opensea_seller_fee_basis_points": "250",
                        "payout_address": null,
                        "require_email": false,
                        "short_description": null,
                        "slug": "hidef",
                        "telegram_url": null,
                        "twitter_username": null,
                        "instagram_username": null,
                        "wiki_url": null
                    },
                    "decimals": null,
                    "token_metadata": null
                },
                {
                    "id": 20425392,
                    "token_id": "70479185245472823933799012500856922265354379340922944019462782701577762242561",
                    "num_sales": 0,
                    "background_color": null,
                    "image_url": "https://lh3.googleusercontent.com/4U_do2L61E94-14U2dUUeAIbK_KT6vxosDMtmoGIkqCSWXxr9oaNrom2dz6g3Ozk2lNrti74N88dHWmOWnFZPnVootRmw_nUhvCUQg",
                    "image_preview_url": "https://lh3.googleusercontent.com/4U_do2L61E94-14U2dUUeAIbK_KT6vxosDMtmoGIkqCSWXxr9oaNrom2dz6g3Ozk2lNrti74N88dHWmOWnFZPnVootRmw_nUhvCUQg=s250",
                    "image_thumbnail_url": "https://lh3.googleusercontent.com/4U_do2L61E94-14U2dUUeAIbK_KT6vxosDMtmoGIkqCSWXxr9oaNrom2dz6g3Ozk2lNrti74N88dHWmOWnFZPnVootRmw_nUhvCUQg=s128",
                    "image_original_url": null,
                    "animation_url": null,
                    "animation_original_url": null,
                    "name": "The Founders",
                    "description": "The fashionable four founders of HiDef 9 of 10",
                    "external_link": null,
                    "asset_contract": {
                        "address": "0x495f947276749ce646f68ac8c248420045cb7b5e",
                        "asset_contract_type": "semi-fungible",
                        "created_date": "2020-12-02T17:40:53.232025",
                        "name": "OpenSea Collection",
                        "nft_version": null,
                        "opensea_version": "2.0.0",
                        "owner": 102384,
                        "schema_name": "ERC1155",
                        "symbol": "OPENSTORE",
                        "total_supply": null,
                        "description": null,
                        "external_link": null,
                        "image_url": null,
                        "default_to_fiat": false,
                        "dev_buyer_fee_basis_points": 0,
                        "dev_seller_fee_basis_points": 0,
                        "only_proxied_transfers": false,
                        "opensea_buyer_fee_basis_points": 0,
                        "opensea_seller_fee_basis_points": 250,
                        "buyer_fee_basis_points": 0,
                        "seller_fee_basis_points": 250,
                        "payout_address": null
                    },
                    "owner": {
                        "user": {
                            "username": "NullAddress"
                        },
                        "profile_img_url": "https://storage.googleapis.com/opensea-static/opensea-profile/1.png",
                        "address": "0x0000000000000000000000000000000000000000",
                        "config": "",
                        "discord_id": ""
                    },
                    "permalink": "https://opensea.io/assets/0x495f947276749ce646f68ac8c248420045cb7b5e/70479185245472823933799012500856922265354379340922944019462782701577762242561",
                    "collection": {
                        "banner_image_url": "https://lh3.googleusercontent.com/i1dLTD9hXZSzeMGz02l202fkMjd3QQrZ2fCQ2TZt-ajo3L931rN_TRGeqU9IvTfm166GIvs5DWaWCKbnuxKq5JmMHLOXioRyCuMxNQ=s2500",
                        "chat_url": null,
                        "created_date": "2021-03-24T00:31:54.219565",
                        "default_to_fiat": false,
                        "description": "",
                        "dev_buyer_fee_basis_points": "0",
                        "dev_seller_fee_basis_points": "0",
                        "discord_url": null,
                        "display_data": {
                            "card_display_style": "contain",
                            "images": []
                        },
                        "external_url": null,
                        "featured": false,
                        "featured_image_url": null,
                        "hidden": true,
                        "safelist_request_status": "not_requested",
                        "image_url": "https://lh3.googleusercontent.com/qZRiTQMHRe5EswI1syqlf0Sf3sfY8bnZjtVhjn89Kh_RxfqZ1WBWTJBnyvnB-gJWsvr6-DsACvVxrPBsj5pSlecxj63iAcVfQTkD=s120",
                        "is_subject_to_whitelist": false,
                        "large_image_url": null,
                        "medium_username": null,
                        "name": "HiDef",
                        "only_proxied_transfers": false,
                        "opensea_buyer_fee_basis_points": "0",
                        "opensea_seller_fee_basis_points": "250",
                        "payout_address": null,
                        "require_email": false,
                        "short_description": null,
                        "slug": "hidef",
                        "telegram_url": null,
                        "twitter_username": null,
                        "instagram_username": null,
                        "wiki_url": null
                    },
                    "decimals": null,
                    "token_metadata": null
                },
                {
                    "id": 20425405,
                    "token_id": "70479185245472823933799012500856922265354379340922944019462782702677273870337",
                    "num_sales": 0,
                    "background_color": null,
                    "image_url": "https://lh3.googleusercontent.com/4U_do2L61E94-14U2dUUeAIbK_KT6vxosDMtmoGIkqCSWXxr9oaNrom2dz6g3Ozk2lNrti74N88dHWmOWnFZPnVootRmw_nUhvCUQg",
                    "image_preview_url": "https://lh3.googleusercontent.com/4U_do2L61E94-14U2dUUeAIbK_KT6vxosDMtmoGIkqCSWXxr9oaNrom2dz6g3Ozk2lNrti74N88dHWmOWnFZPnVootRmw_nUhvCUQg=s250",
                    "image_thumbnail_url": "https://lh3.googleusercontent.com/4U_do2L61E94-14U2dUUeAIbK_KT6vxosDMtmoGIkqCSWXxr9oaNrom2dz6g3Ozk2lNrti74N88dHWmOWnFZPnVootRmw_nUhvCUQg=s128",
                    "image_original_url": null,
                    "animation_url": null,
                    "animation_original_url": null,
                    "name": "The Founders",
                    "description": "The fashionable four founders of HiDef 10 of 10",
                    "external_link": null,
                    "asset_contract": {
                        "address": "0x495f947276749ce646f68ac8c248420045cb7b5e",
                        "asset_contract_type": "semi-fungible",
                        "created_date": "2020-12-02T17:40:53.232025",
                        "name": "OpenSea Collection",
                        "nft_version": null,
                        "opensea_version": "2.0.0",
                        "owner": 102384,
                        "schema_name": "ERC1155",
                        "symbol": "OPENSTORE",
                        "total_supply": null,
                        "description": null,
                        "external_link": null,
                        "image_url": null,
                        "default_to_fiat": false,
                        "dev_buyer_fee_basis_points": 0,
                        "dev_seller_fee_basis_points": 0,
                        "only_proxied_transfers": false,
                        "opensea_buyer_fee_basis_points": 0,
                        "opensea_seller_fee_basis_points": 250,
                        "buyer_fee_basis_points": 0,
                        "seller_fee_basis_points": 250,
                        "payout_address": null
                    },
                    "owner": {
                        "user": {
                            "username": "NullAddress"
                        },
                        "profile_img_url": "https://storage.googleapis.com/opensea-static/opensea-profile/1.png",
                        "address": "0x0000000000000000000000000000000000000000",
                        "config": "",
                        "discord_id": ""
                    },
                    "permalink": "https://opensea.io/assets/0x495f947276749ce646f68ac8c248420045cb7b5e/70479185245472823933799012500856922265354379340922944019462782702677273870337",
                    "collection": {
                        "banner_image_url": "https://lh3.googleusercontent.com/i1dLTD9hXZSzeMGz02l202fkMjd3QQrZ2fCQ2TZt-ajo3L931rN_TRGeqU9IvTfm166GIvs5DWaWCKbnuxKq5JmMHLOXioRyCuMxNQ=s2500",
                        "chat_url": null,
                        "created_date": "2021-03-24T00:31:54.219565",
                        "default_to_fiat": false,
                        "description": "",
                        "dev_buyer_fee_basis_points": "0",
                        "dev_seller_fee_basis_points": "0",
                        "discord_url": null,
                        "display_data": {
                            "card_display_style": "contain",
                            "images": []
                        },
                        "external_url": null,
                        "featured": false,
                        "featured_image_url": null,
                        "hidden": true,
                        "safelist_request_status": "not_requested",
                        "image_url": "https://lh3.googleusercontent.com/qZRiTQMHRe5EswI1syqlf0Sf3sfY8bnZjtVhjn89Kh_RxfqZ1WBWTJBnyvnB-gJWsvr6-DsACvVxrPBsj5pSlecxj63iAcVfQTkD=s120",
                        "is_subject_to_whitelist": false,
                        "large_image_url": null,
                        "medium_username": null,
                        "name": "HiDef",
                        "only_proxied_transfers": false,
                        "opensea_buyer_fee_basis_points": "0",
                        "opensea_seller_fee_basis_points": "250",
                        "payout_address": null,
                        "require_email": false,
                        "short_description": null,
                        "slug": "hidef",
                        "telegram_url": null,
                        "twitter_username": null,
                        "instagram_username": null,
                        "wiki_url": null
                    },
                    "decimals": null,
                    "token_metadata": null
                }
            ],
            "name": "Founders & HiDef Logo",
            "description": "",
            "external_link": "",
            "asset_contract": {
                "collection": {
                    "banner_image_url": null,
                    "chat_url": null,
                    "created_date": "2020-12-02T17:40:53.507540",
                    "default_to_fiat": false,
                    "description": null,
                    "dev_buyer_fee_basis_points": "0",
                    "dev_seller_fee_basis_points": "0",
                    "discord_url": null,
                    "display_data": {
                        "card_display_style": "contain",
                        "images": []
                    },
                    "external_url": null,
                    "featured": false,
                    "featured_image_url": null,
                    "hidden": true,
                    "safelist_request_status": "not_requested",
                    "image_url": null,
                    "is_subject_to_whitelist": false,
                    "large_image_url": null,
                    "medium_username": null,
                    "name": "OpenSea Shared Storefront V2",
                    "only_proxied_transfers": false,
                    "opensea_buyer_fee_basis_points": "0",
                    "opensea_seller_fee_basis_points": "250",
                    "payout_address": null,
                    "require_email": false,
                    "short_description": null,
                    "slug": "opensea-shared-storefront-v2",
                    "telegram_url": null,
                    "twitter_username": null,
                    "instagram_username": null,
                    "wiki_url": null
                },
                "address": "0x495f947276749ce646f68ac8c248420045cb7b5e",
                "asset_contract_type": "semi-fungible",
                "created_date": "2020-12-02T17:40:53.232025",
                "name": "OpenSea Collection",
                "nft_version": null,
                "opensea_version": "2.0.0",
                "owner": 102384,
                "schema_name": "ERC1155",
                "symbol": "OPENSTORE",
                "total_supply": null,
                "description": null,
                "external_link": null,
                "image_url": null,
                "default_to_fiat": false,
                "dev_buyer_fee_basis_points": 0,
                "dev_seller_fee_basis_points": 0,
                "only_proxied_transfers": false,
                "opensea_buyer_fee_basis_points": 0,
                "opensea_seller_fee_basis_points": 250,
                "buyer_fee_basis_points": 0,
                "seller_fee_basis_points": 250,
                "payout_address": null
            },
            "permalink": "https://opensea.io/bundles/founders-hidef-logo-a1i",
            "sell_orders": []
        },
        {
            "maker": {
                "user": {
                    "username": "P0PO"
                },
                "profile_img_url": "https://storage.googleapis.com/opensea-static/opensea-profile/8.png",
                "address": "0x316b95c5f0e524506109ce31034be825efccd1c8",
                "config": "",
                "discord_id": ""
            },
            "slug": "digital-drums-set-fWg",
            "assets": [
                {
                    "id": 25663851,
                    "token_id": "22353415913195718866916132271470535644201359484565030950018324003374300659713",
                    "num_sales": 0,
                    "background_color": null,
                    "image_url": "https://lh3.googleusercontent.com/wIIMud6aOMImgjFaJQL9TDNITG0m5Rbxy3UbTtek0T4TwY8FQQo31b4it2zF_yT6PADF0nr64hsg82HT2SyddzyiCs4LtuuttgC0",
                    "image_preview_url": "https://lh3.googleusercontent.com/wIIMud6aOMImgjFaJQL9TDNITG0m5Rbxy3UbTtek0T4TwY8FQQo31b4it2zF_yT6PADF0nr64hsg82HT2SyddzyiCs4LtuuttgC0=s250",
                    "image_thumbnail_url": "https://lh3.googleusercontent.com/wIIMud6aOMImgjFaJQL9TDNITG0m5Rbxy3UbTtek0T4TwY8FQQo31b4it2zF_yT6PADF0nr64hsg82HT2SyddzyiCs4LtuuttgC0=s128",
                    "image_original_url": null,
                    "animation_url": null,
                    "animation_original_url": null,
                    "name": "Drums",
                    "description": null,
                    "external_link": null,
                    "asset_contract": {
                        "address": "0x495f947276749ce646f68ac8c248420045cb7b5e",
                        "asset_contract_type": "semi-fungible",
                        "created_date": "2020-12-02T17:40:53.232025",
                        "name": "OpenSea Collection",
                        "nft_version": null,
                        "opensea_version": "2.0.0",
                        "owner": 102384,
                        "schema_name": "ERC1155",
                        "symbol": "OPENSTORE",
                        "total_supply": null,
                        "description": null,
                        "external_link": null,
                        "image_url": null,
                        "default_to_fiat": false,
                        "dev_buyer_fee_basis_points": 0,
                        "dev_seller_fee_basis_points": 0,
                        "only_proxied_transfers": false,
                        "opensea_buyer_fee_basis_points": 0,
                        "opensea_seller_fee_basis_points": 250,
                        "buyer_fee_basis_points": 0,
                        "seller_fee_basis_points": 250,
                        "payout_address": null
                    },
                    "owner": {
                        "user": {
                            "username": "NullAddress"
                        },
                        "profile_img_url": "https://storage.googleapis.com/opensea-static/opensea-profile/1.png",
                        "address": "0x0000000000000000000000000000000000000000",
                        "config": "",
                        "discord_id": ""
                    },
                    "permalink": "https://opensea.io/assets/0x495f947276749ce646f68ac8c248420045cb7b5e/22353415913195718866916132271470535644201359484565030950018324003374300659713",
                    "collection": {
                        "banner_image_url": null,
                        "chat_url": null,
                        "created_date": "2021-05-02T21:12:12.789428",
                        "default_to_fiat": false,
                        "description": "Unique collection of digital art.",
                        "dev_buyer_fee_basis_points": "0",
                        "dev_seller_fee_basis_points": "0",
                        "discord_url": null,
                        "display_data": {
                            "card_display_style": "contain"
                        },
                        "external_url": null,
                        "featured": false,
                        "featured_image_url": null,
                        "hidden": true,
                        "safelist_request_status": "not_requested",
                        "image_url": "https://lh3.googleusercontent.com/rscsxUmE0BWQJNGdT1jjjbrtRzxJBckBIxhtCWwp8dMMI4qeY_Uk_NAVvoxJuDnvAmjQlvItm4AX9RZLRBkLTK0JmQkIQ8aI1sbtKCU=s120",
                        "is_subject_to_whitelist": false,
                        "large_image_url": null,
                        "medium_username": null,
                        "name": "SiS - Still in Style",
                        "only_proxied_transfers": false,
                        "opensea_buyer_fee_basis_points": "0",
                        "opensea_seller_fee_basis_points": "250",
                        "payout_address": null,
                        "require_email": false,
                        "short_description": null,
                        "slug": "popos",
                        "telegram_url": null,
                        "twitter_username": null,
                        "instagram_username": null,
                        "wiki_url": null
                    },
                    "decimals": null,
                    "token_metadata": null
                },
                {
                    "id": 25663884,
                    "token_id": "22353415913195718866916132271470535644201359484565030950018324004473812287489",
                    "num_sales": 0,
                    "background_color": null,
                    "image_url": "https://lh3.googleusercontent.com/EbORh2EbJfn0OEDWTL8qoO4KUHrm5LclckKx33ul7b5p7r1U00EgNF8jJ1t6-oopzo_Bfy4bNi9mcgG5nDo1zZeQdlRC7jB2easykw",
                    "image_preview_url": "https://lh3.googleusercontent.com/EbORh2EbJfn0OEDWTL8qoO4KUHrm5LclckKx33ul7b5p7r1U00EgNF8jJ1t6-oopzo_Bfy4bNi9mcgG5nDo1zZeQdlRC7jB2easykw=s250",
                    "image_thumbnail_url": "https://lh3.googleusercontent.com/EbORh2EbJfn0OEDWTL8qoO4KUHrm5LclckKx33ul7b5p7r1U00EgNF8jJ1t6-oopzo_Bfy4bNi9mcgG5nDo1zZeQdlRC7jB2easykw=s128",
                    "image_original_url": null,
                    "animation_url": null,
                    "animation_original_url": null,
                    "name": "Drums II",
                    "description": null,
                    "external_link": null,
                    "asset_contract": {
                        "address": "0x495f947276749ce646f68ac8c248420045cb7b5e",
                        "asset_contract_type": "semi-fungible",
                        "created_date": "2020-12-02T17:40:53.232025",
                        "name": "OpenSea Collection",
                        "nft_version": null,
                        "opensea_version": "2.0.0",
                        "owner": 102384,
                        "schema_name": "ERC1155",
                        "symbol": "OPENSTORE",
                        "total_supply": null,
                        "description": null,
                        "external_link": null,
                        "image_url": null,
                        "default_to_fiat": false,
                        "dev_buyer_fee_basis_points": 0,
                        "dev_seller_fee_basis_points": 0,
                        "only_proxied_transfers": false,
                        "opensea_buyer_fee_basis_points": 0,
                        "opensea_seller_fee_basis_points": 250,
                        "buyer_fee_basis_points": 0,
                        "seller_fee_basis_points": 250,
                        "payout_address": null
                    },
                    "owner": {
                        "user": {
                            "username": "NullAddress"
                        },
                        "profile_img_url": "https://storage.googleapis.com/opensea-static/opensea-profile/1.png",
                        "address": "0x0000000000000000000000000000000000000000",
                        "config": "",
                        "discord_id": ""
                    },
                    "permalink": "https://opensea.io/assets/0x495f947276749ce646f68ac8c248420045cb7b5e/22353415913195718866916132271470535644201359484565030950018324004473812287489",
                    "collection": {
                        "banner_image_url": null,
                        "chat_url": null,
                        "created_date": "2021-05-02T21:12:12.789428",
                        "default_to_fiat": false,
                        "description": "Unique collection of digital art.",
                        "dev_buyer_fee_basis_points": "0",
                        "dev_seller_fee_basis_points": "0",
                        "discord_url": null,
                        "display_data": {
                            "card_display_style": "contain"
                        },
                        "external_url": null,
                        "featured": false,
                        "featured_image_url": null,
                        "hidden": true,
                        "safelist_request_status": "not_requested",
                        "image_url": "https://lh3.googleusercontent.com/rscsxUmE0BWQJNGdT1jjjbrtRzxJBckBIxhtCWwp8dMMI4qeY_Uk_NAVvoxJuDnvAmjQlvItm4AX9RZLRBkLTK0JmQkIQ8aI1sbtKCU=s120",
                        "is_subject_to_whitelist": false,
                        "large_image_url": null,
                        "medium_username": null,
                        "name": "SiS - Still in Style",
                        "only_proxied_transfers": false,
                        "opensea_buyer_fee_basis_points": "0",
                        "opensea_seller_fee_basis_points": "250",
                        "payout_address": null,
                        "require_email": false,
                        "short_description": null,
                        "slug": "popos",
                        "telegram_url": null,
                        "twitter_username": null,
                        "instagram_username": null,
                        "wiki_url": null
                    },
                    "decimals": null,
                    "token_metadata": null
                },
                {
                    "id": 25663905,
                    "token_id": "22353415913195718866916132271470535644201359484565030950018324005573323915265",
                    "num_sales": 0,
                    "background_color": null,
                    "image_url": "https://lh3.googleusercontent.com/HP3hyBy3HbXMipK8yblUGEP4RFlCxcREjST0_oT6xqojUzq1SPbIfuNEpJ-8V26iVadyHw5j787MIP53yBclMfs9EyxzrnUzWpTddw",
                    "image_preview_url": "https://lh3.googleusercontent.com/HP3hyBy3HbXMipK8yblUGEP4RFlCxcREjST0_oT6xqojUzq1SPbIfuNEpJ-8V26iVadyHw5j787MIP53yBclMfs9EyxzrnUzWpTddw=s250",
                    "image_thumbnail_url": "https://lh3.googleusercontent.com/HP3hyBy3HbXMipK8yblUGEP4RFlCxcREjST0_oT6xqojUzq1SPbIfuNEpJ-8V26iVadyHw5j787MIP53yBclMfs9EyxzrnUzWpTddw=s128",
                    "image_original_url": null,
                    "animation_url": null,
                    "animation_original_url": null,
                    "name": "Drums III",
                    "description": null,
                    "external_link": null,
                    "asset_contract": {
                        "address": "0x495f947276749ce646f68ac8c248420045cb7b5e",
                        "asset_contract_type": "semi-fungible",
                        "created_date": "2020-12-02T17:40:53.232025",
                        "name": "OpenSea Collection",
                        "nft_version": null,
                        "opensea_version": "2.0.0",
                        "owner": 102384,
                        "schema_name": "ERC1155",
                        "symbol": "OPENSTORE",
                        "total_supply": null,
                        "description": null,
                        "external_link": null,
                        "image_url": null,
                        "default_to_fiat": false,
                        "dev_buyer_fee_basis_points": 0,
                        "dev_seller_fee_basis_points": 0,
                        "only_proxied_transfers": false,
                        "opensea_buyer_fee_basis_points": 0,
                        "opensea_seller_fee_basis_points": 250,
                        "buyer_fee_basis_points": 0,
                        "seller_fee_basis_points": 250,
                        "payout_address": null
                    },
                    "owner": {
                        "user": {
                            "username": "NullAddress"
                        },
                        "profile_img_url": "https://storage.googleapis.com/opensea-static/opensea-profile/1.png",
                        "address": "0x0000000000000000000000000000000000000000",
                        "config": "",
                        "discord_id": ""
                    },
                    "permalink": "https://opensea.io/assets/0x495f947276749ce646f68ac8c248420045cb7b5e/22353415913195718866916132271470535644201359484565030950018324005573323915265",
                    "collection": {
                        "banner_image_url": null,
                        "chat_url": null,
                        "created_date": "2021-05-02T21:12:12.789428",
                        "default_to_fiat": false,
                        "description": "Unique collection of digital art.",
                        "dev_buyer_fee_basis_points": "0",
                        "dev_seller_fee_basis_points": "0",
                        "discord_url": null,
                        "display_data": {
                            "card_display_style": "contain"
                        },
                        "external_url": null,
                        "featured": false,
                        "featured_image_url": null,
                        "hidden": true,
                        "safelist_request_status": "not_requested",
                        "image_url": "https://lh3.googleusercontent.com/rscsxUmE0BWQJNGdT1jjjbrtRzxJBckBIxhtCWwp8dMMI4qeY_Uk_NAVvoxJuDnvAmjQlvItm4AX9RZLRBkLTK0JmQkIQ8aI1sbtKCU=s120",
                        "is_subject_to_whitelist": false,
                        "large_image_url": null,
                        "medium_username": null,
                        "name": "SiS - Still in Style",
                        "only_proxied_transfers": false,
                        "opensea_buyer_fee_basis_points": "0",
                        "opensea_seller_fee_basis_points": "250",
                        "payout_address": null,
                        "require_email": false,
                        "short_description": null,
                        "slug": "popos",
                        "telegram_url": null,
                        "twitter_username": null,
                        "instagram_username": null,
                        "wiki_url": null
                    },
                    "decimals": null,
                    "token_metadata": null
                },
                {
                    "id": 25663920,
                    "token_id": "22353415913195718866916132271470535644201359484565030950018324006672835543041",
                    "num_sales": 0,
                    "background_color": null,
                    "image_url": "https://lh3.googleusercontent.com/oe21d2jDNlZDQSdvnULaLqY1mIufIRd5rRWXgF8hrmQKyWa8476Z9gijyv5awQBugfclzCYmLbYwik9e32jh0crR30yyZ803ndxeKw",
                    "image_preview_url": "https://lh3.googleusercontent.com/oe21d2jDNlZDQSdvnULaLqY1mIufIRd5rRWXgF8hrmQKyWa8476Z9gijyv5awQBugfclzCYmLbYwik9e32jh0crR30yyZ803ndxeKw=s250",
                    "image_thumbnail_url": "https://lh3.googleusercontent.com/oe21d2jDNlZDQSdvnULaLqY1mIufIRd5rRWXgF8hrmQKyWa8476Z9gijyv5awQBugfclzCYmLbYwik9e32jh0crR30yyZ803ndxeKw=s128",
                    "image_original_url": null,
                    "animation_url": null,
                    "animation_original_url": null,
                    "name": "Drums IV",
                    "description": null,
                    "external_link": null,
                    "asset_contract": {
                        "address": "0x495f947276749ce646f68ac8c248420045cb7b5e",
                        "asset_contract_type": "semi-fungible",
                        "created_date": "2020-12-02T17:40:53.232025",
                        "name": "OpenSea Collection",
                        "nft_version": null,
                        "opensea_version": "2.0.0",
                        "owner": 102384,
                        "schema_name": "ERC1155",
                        "symbol": "OPENSTORE",
                        "total_supply": null,
                        "description": null,
                        "external_link": null,
                        "image_url": null,
                        "default_to_fiat": false,
                        "dev_buyer_fee_basis_points": 0,
                        "dev_seller_fee_basis_points": 0,
                        "only_proxied_transfers": false,
                        "opensea_buyer_fee_basis_points": 0,
                        "opensea_seller_fee_basis_points": 250,
                        "buyer_fee_basis_points": 0,
                        "seller_fee_basis_points": 250,
                        "payout_address": null
                    },
                    "owner": {
                        "user": {
                            "username": "NullAddress"
                        },
                        "profile_img_url": "https://storage.googleapis.com/opensea-static/opensea-profile/1.png",
                        "address": "0x0000000000000000000000000000000000000000",
                        "config": "",
                        "discord_id": ""
                    },
                    "permalink": "https://opensea.io/assets/0x495f947276749ce646f68ac8c248420045cb7b5e/22353415913195718866916132271470535644201359484565030950018324006672835543041",
                    "collection": {
                        "banner_image_url": null,
                        "chat_url": null,
                        "created_date": "2021-05-02T21:12:12.789428",
                        "default_to_fiat": false,
                        "description": "Unique collection of digital art.",
                        "dev_buyer_fee_basis_points": "0",
                        "dev_seller_fee_basis_points": "0",
                        "discord_url": null,
                        "display_data": {
                            "card_display_style": "contain"
                        },
                        "external_url": null,
                        "featured": false,
                        "featured_image_url": null,
                        "hidden": true,
                        "safelist_request_status": "not_requested",
                        "image_url": "https://lh3.googleusercontent.com/rscsxUmE0BWQJNGdT1jjjbrtRzxJBckBIxhtCWwp8dMMI4qeY_Uk_NAVvoxJuDnvAmjQlvItm4AX9RZLRBkLTK0JmQkIQ8aI1sbtKCU=s120",
                        "is_subject_to_whitelist": false,
                        "large_image_url": null,
                        "medium_username": null,
                        "name": "SiS - Still in Style",
                        "only_proxied_transfers": false,
                        "opensea_buyer_fee_basis_points": "0",
                        "opensea_seller_fee_basis_points": "250",
                        "payout_address": null,
                        "require_email": false,
                        "short_description": null,
                        "slug": "popos",
                        "telegram_url": null,
                        "twitter_username": null,
                        "instagram_username": null,
                        "wiki_url": null
                    },
                    "decimals": null,
                    "token_metadata": null
                },
                {
                    "id": 25663940,
                    "token_id": "22353415913195718866916132271470535644201359484565030950018324007772347170817",
                    "num_sales": 0,
                    "background_color": null,
                    "image_url": "https://lh3.googleusercontent.com/cLB6sNngJyRisbvFquSIcdoMUPPLhNUaVed_QnsZ5UySen6uAge5u8VABHbspcWaPvGtFvy7lpOW9wvSRHEvvcigh4fAxbNGa8CR8Q",
                    "image_preview_url": "https://lh3.googleusercontent.com/cLB6sNngJyRisbvFquSIcdoMUPPLhNUaVed_QnsZ5UySen6uAge5u8VABHbspcWaPvGtFvy7lpOW9wvSRHEvvcigh4fAxbNGa8CR8Q=s250",
                    "image_thumbnail_url": "https://lh3.googleusercontent.com/cLB6sNngJyRisbvFquSIcdoMUPPLhNUaVed_QnsZ5UySen6uAge5u8VABHbspcWaPvGtFvy7lpOW9wvSRHEvvcigh4fAxbNGa8CR8Q=s128",
                    "image_original_url": null,
                    "animation_url": null,
                    "animation_original_url": null,
                    "name": "Drums V",
                    "description": null,
                    "external_link": null,
                    "asset_contract": {
                        "address": "0x495f947276749ce646f68ac8c248420045cb7b5e",
                        "asset_contract_type": "semi-fungible",
                        "created_date": "2020-12-02T17:40:53.232025",
                        "name": "OpenSea Collection",
                        "nft_version": null,
                        "opensea_version": "2.0.0",
                        "owner": 102384,
                        "schema_name": "ERC1155",
                        "symbol": "OPENSTORE",
                        "total_supply": null,
                        "description": null,
                        "external_link": null,
                        "image_url": null,
                        "default_to_fiat": false,
                        "dev_buyer_fee_basis_points": 0,
                        "dev_seller_fee_basis_points": 0,
                        "only_proxied_transfers": false,
                        "opensea_buyer_fee_basis_points": 0,
                        "opensea_seller_fee_basis_points": 250,
                        "buyer_fee_basis_points": 0,
                        "seller_fee_basis_points": 250,
                        "payout_address": null
                    },
                    "owner": {
                        "user": {
                            "username": "NullAddress"
                        },
                        "profile_img_url": "https://storage.googleapis.com/opensea-static/opensea-profile/1.png",
                        "address": "0x0000000000000000000000000000000000000000",
                        "config": "",
                        "discord_id": ""
                    },
                    "permalink": "https://opensea.io/assets/0x495f947276749ce646f68ac8c248420045cb7b5e/22353415913195718866916132271470535644201359484565030950018324007772347170817",
                    "collection": {
                        "banner_image_url": null,
                        "chat_url": null,
                        "created_date": "2021-05-02T21:12:12.789428",
                        "default_to_fiat": false,
                        "description": "Unique collection of digital art.",
                        "dev_buyer_fee_basis_points": "0",
                        "dev_seller_fee_basis_points": "0",
                        "discord_url": null,
                        "display_data": {
                            "card_display_style": "contain"
                        },
                        "external_url": null,
                        "featured": false,
                        "featured_image_url": null,
                        "hidden": true,
                        "safelist_request_status": "not_requested",
                        "image_url": "https://lh3.googleusercontent.com/rscsxUmE0BWQJNGdT1jjjbrtRzxJBckBIxhtCWwp8dMMI4qeY_Uk_NAVvoxJuDnvAmjQlvItm4AX9RZLRBkLTK0JmQkIQ8aI1sbtKCU=s120",
                        "is_subject_to_whitelist": false,
                        "large_image_url": null,
                        "medium_username": null,
                        "name": "SiS - Still in Style",
                        "only_proxied_transfers": false,
                        "opensea_buyer_fee_basis_points": "0",
                        "opensea_seller_fee_basis_points": "250",
                        "payout_address": null,
                        "require_email": false,
                        "short_description": null,
                        "slug": "popos",
                        "telegram_url": null,
                        "twitter_username": null,
                        "instagram_username": null,
                        "wiki_url": null
                    },
                    "decimals": null,
                    "token_metadata": null
                },
                {
                    "id": 25663948,
                    "token_id": "22353415913195718866916132271470535644201359484565030950018324008871858798593",
                    "num_sales": 0,
                    "background_color": null,
                    "image_url": "https://lh3.googleusercontent.com/tF2wEzAeuZ8Zyv-m-GZ_EjlYKTZdLHQw_gp_H6E5zCOQrrQSH1fv3EUw6seF23xkRnKwq2VE2Zfzs9I8CbgOW0xlBZz3nkWBOcEpUaU",
                    "image_preview_url": "https://lh3.googleusercontent.com/tF2wEzAeuZ8Zyv-m-GZ_EjlYKTZdLHQw_gp_H6E5zCOQrrQSH1fv3EUw6seF23xkRnKwq2VE2Zfzs9I8CbgOW0xlBZz3nkWBOcEpUaU=s250",
                    "image_thumbnail_url": "https://lh3.googleusercontent.com/tF2wEzAeuZ8Zyv-m-GZ_EjlYKTZdLHQw_gp_H6E5zCOQrrQSH1fv3EUw6seF23xkRnKwq2VE2Zfzs9I8CbgOW0xlBZz3nkWBOcEpUaU=s128",
                    "image_original_url": null,
                    "animation_url": null,
                    "animation_original_url": null,
                    "name": "Drums VI",
                    "description": null,
                    "external_link": null,
                    "asset_contract": {
                        "address": "0x495f947276749ce646f68ac8c248420045cb7b5e",
                        "asset_contract_type": "semi-fungible",
                        "created_date": "2020-12-02T17:40:53.232025",
                        "name": "OpenSea Collection",
                        "nft_version": null,
                        "opensea_version": "2.0.0",
                        "owner": 102384,
                        "schema_name": "ERC1155",
                        "symbol": "OPENSTORE",
                        "total_supply": null,
                        "description": null,
                        "external_link": null,
                        "image_url": null,
                        "default_to_fiat": false,
                        "dev_buyer_fee_basis_points": 0,
                        "dev_seller_fee_basis_points": 0,
                        "only_proxied_transfers": false,
                        "opensea_buyer_fee_basis_points": 0,
                        "opensea_seller_fee_basis_points": 250,
                        "buyer_fee_basis_points": 0,
                        "seller_fee_basis_points": 250,
                        "payout_address": null
                    },
                    "owner": {
                        "user": {
                            "username": "NullAddress"
                        },
                        "profile_img_url": "https://storage.googleapis.com/opensea-static/opensea-profile/1.png",
                        "address": "0x0000000000000000000000000000000000000000",
                        "config": "",
                        "discord_id": ""
                    },
                    "permalink": "https://opensea.io/assets/0x495f947276749ce646f68ac8c248420045cb7b5e/22353415913195718866916132271470535644201359484565030950018324008871858798593",
                    "collection": {
                        "banner_image_url": null,
                        "chat_url": null,
                        "created_date": "2021-05-02T21:12:12.789428",
                        "default_to_fiat": false,
                        "description": "Unique collection of digital art.",
                        "dev_buyer_fee_basis_points": "0",
                        "dev_seller_fee_basis_points": "0",
                        "discord_url": null,
                        "display_data": {
                            "card_display_style": "contain"
                        },
                        "external_url": null,
                        "featured": false,
                        "featured_image_url": null,
                        "hidden": true,
                        "safelist_request_status": "not_requested",
                        "image_url": "https://lh3.googleusercontent.com/rscsxUmE0BWQJNGdT1jjjbrtRzxJBckBIxhtCWwp8dMMI4qeY_Uk_NAVvoxJuDnvAmjQlvItm4AX9RZLRBkLTK0JmQkIQ8aI1sbtKCU=s120",
                        "is_subject_to_whitelist": false,
                        "large_image_url": null,
                        "medium_username": null,
                        "name": "SiS - Still in Style",
                        "only_proxied_transfers": false,
                        "opensea_buyer_fee_basis_points": "0",
                        "opensea_seller_fee_basis_points": "250",
                        "payout_address": null,
                        "require_email": false,
                        "short_description": null,
                        "slug": "popos",
                        "telegram_url": null,
                        "twitter_username": null,
                        "instagram_username": null,
                        "wiki_url": null
                    },
                    "decimals": null,
                    "token_metadata": null
                }
            ],
            "name": "Digital Drums Set",
            "description": "",
            "external_link": "",
            "asset_contract": {
                "collection": {
                    "banner_image_url": null,
                    "chat_url": null,
                    "created_date": "2020-12-02T17:40:53.507540",
                    "default_to_fiat": false,
                    "description": null,
                    "dev_buyer_fee_basis_points": "0",
                    "dev_seller_fee_basis_points": "0",
                    "discord_url": null,
                    "display_data": {
                        "card_display_style": "contain",
                        "images": []
                    },
                    "external_url": null,
                    "featured": false,
                    "featured_image_url": null,
                    "hidden": true,
                    "safelist_request_status": "not_requested",
                    "image_url": null,
                    "is_subject_to_whitelist": false,
                    "large_image_url": null,
                    "medium_username": null,
                    "name": "OpenSea Shared Storefront V2",
                    "only_proxied_transfers": false,
                    "opensea_buyer_fee_basis_points": "0",
                    "opensea_seller_fee_basis_points": "250",
                    "payout_address": null,
                    "require_email": false,
                    "short_description": null,
                    "slug": "opensea-shared-storefront-v2",
                    "telegram_url": null,
                    "twitter_username": null,
                    "instagram_username": null,
                    "wiki_url": null
                },
                "address": "0x495f947276749ce646f68ac8c248420045cb7b5e",
                "asset_contract_type": "semi-fungible",
                "created_date": "2020-12-02T17:40:53.232025",
                "name": "OpenSea Collection",
                "nft_version": null,
                "opensea_version": "2.0.0",
                "owner": 102384,
                "schema_name": "ERC1155",
                "symbol": "OPENSTORE",
                "total_supply": null,
                "description": null,
                "external_link": null,
                "image_url": null,
                "default_to_fiat": false,
                "dev_buyer_fee_basis_points": 0,
                "dev_seller_fee_basis_points": 0,
                "only_proxied_transfers": false,
                "opensea_buyer_fee_basis_points": 0,
                "opensea_seller_fee_basis_points": 250,
                "buyer_fee_basis_points": 0,
                "seller_fee_basis_points": 250,
                "payout_address": null
            },
            "permalink": "https://opensea.io/bundles/digital-drums-set-fWg",
            "sell_orders": [
                {
                    "created_date": "2021-05-25T21:53:07.535173",
                    "closing_date": null,
                    "closing_extendable": false,
                    "expiration_time": 0,
                    "listing_time": 1621979477,
                    "order_hash": "0xaa280043e353ae0bfb4a3e2653b907f7933fe99df68176450ba45fc48cc644af",
                    "metadata": {
                        "bundle": {
                            "assets": [
                                {
                                    "id": "22353415913195718866916132271470535644201359484565030950018324003374300659713",
                                    "address": "0x495f947276749ce646f68ac8c248420045cb7b5e",
                                    "quantity": "1"
                                },
                                {
                                    "id": "22353415913195718866916132271470535644201359484565030950018324004473812287489",
                                    "address": "0x495f947276749ce646f68ac8c248420045cb7b5e",
                                    "quantity": "1"
                                },
                                {
                                    "id": "22353415913195718866916132271470535644201359484565030950018324005573323915265",
                                    "address": "0x495f947276749ce646f68ac8c248420045cb7b5e",
                                    "quantity": "1"
                                },
                                {
                                    "id": "22353415913195718866916132271470535644201359484565030950018324006672835543041",
                                    "address": "0x495f947276749ce646f68ac8c248420045cb7b5e",
                                    "quantity": "1"
                                },
                                {
                                    "id": "22353415913195718866916132271470535644201359484565030950018324007772347170817",
                                    "address": "0x495f947276749ce646f68ac8c248420045cb7b5e",
                                    "quantity": "1"
                                },
                                {
                                    "id": "22353415913195718866916132271470535644201359484565030950018324008871858798593",
                                    "address": "0x495f947276749ce646f68ac8c248420045cb7b5e",
                                    "quantity": "1"
                                }
                            ],
                            "schemas": [
                                "ERC1155",
                                "ERC1155",
                                "ERC1155",
                                "ERC1155",
                                "ERC1155",
                                "ERC1155"
                            ],
                            "name": "Digital Drums Set",
                            "description": "",
                            "external_link": ""
                        }
                    },
                    "exchange": "0x7be8076f4ea4a4ad08075c2508e481d6c946d12b",
                    "maker": {
                        "user": 699747,
                        "profile_img_url": "https://storage.googleapis.com/opensea-static/opensea-profile/8.png",
                        "address": "0x316b95c5f0e524506109ce31034be825efccd1c8",
                        "config": "",
                        "discord_id": ""
                    },
                    "taker": {
                        "user": 1766,
                        "profile_img_url": "https://storage.googleapis.com/opensea-static/opensea-profile/1.png",
                        "address": "0x0000000000000000000000000000000000000000",
                        "config": "",
                        "discord_id": ""
                    },
                    "current_price": "1200000000000000000",
                    "current_bounty": "12000000000000000",
                    "bounty_multiple": "0.01",
                    "maker_relayer_fee": "250",
                    "taker_relayer_fee": "0",
                    "maker_protocol_fee": "0",
                    "taker_protocol_fee": "0",
                    "maker_referrer_fee": "0",
                    "fee_recipient": {
                        "user": 3585,
                        "profile_img_url": "https://storage.googleapis.com/opensea-static/opensea-profile/28.png",
                        "address": "0x5b3256965e7c3cf26e11fcaf296dfc8807c01073",
                        "config": "verified",
                        "discord_id": ""
                    },
                    "fee_method": 1,
                    "side": 1,
                    "sale_kind": 0,
                    "target": "0xc99f70bfd82fb7c8f8191fdfbfb735606b15e5c5",
                    "how_to_call": 1,
                    "calldata": "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",
                    "replacement_pattern": "0x0000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000ffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffff0000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000ffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffff0000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000ffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffff0000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000ffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffff0000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000ffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffff0000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000ffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffff00000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000",
                    "static_target": "0x0000000000000000000000000000000000000000",
                    "static_extradata": "0x",
                    "payment_token": "0x0000000000000000000000000000000000000000",
                    "payment_token_contract": {
                        "id": 1,
                        "symbol": "ETH",
                        "address": "0x0000000000000000000000000000000000000000",
                        "image_url": "https://storage.opensea.io/files/6f8e2979d428180222796ff4a33ab929.svg",
                        "name": "Ether",
                        "decimals": 18,
                        "eth_price": "1.000000000000000",
                        "usd_price": "2625.730000000000018000"
                    },
                    "base_price": "1200000000000000000",
                    "extra": "0",
                    "quantity": "1",
                    "salt": "81935825594028746542462974686011339404219040169179874416284623419646707533082",
                    "v": 28,
                    "r": "0xf03a5a14d13f034c34ff6bc46f8f9e473a9dca6a8aadf24439807dcc451f2d32",
                    "s": "0x5d54c0fec2939280c4c9527e2f9e98683d3f7c3979b572dbee95ac6ea2e8c569",
                    "approved_on_chain": false,
                    "cancelled": false,
                    "finalized": false,
                    "marked_invalid": false,
                    "prefixed_hash": "0x2063461a77cbc7506926ae7a435af77ce6e2dac3e39014bf454aaf4a25443803"
                }
            ]
        },
        {
            "maker": {
                "user": {
                    "username": "meePIG"
                },
                "profile_img_url": "https://storage.googleapis.com/opensea-static/opensea-profile/5.png",
                "address": "0xf7e31c55c1771f64416ed96fa1a5ba09cae28133",
                "config": "",
                "discord_id": ""
            },
            "slug": "3-apymon-monsters-mRU",
            "assets": [
                {
                    "id": 25293890,
                    "token_id": "404",
                    "num_sales": 1,
                    "background_color": null,
                    "image_url": "https://lh3.googleusercontent.com/g1oK39xpORz-dbGCeflK1VKYTg064TLiYvVnTLV3Cn3WyRN-gygfH0f0_4BSo3WQzyq-M5-ASP93O6FvyAK63A9xRSjbSC8ix7H4",
                    "image_preview_url": "https://lh3.googleusercontent.com/g1oK39xpORz-dbGCeflK1VKYTg064TLiYvVnTLV3Cn3WyRN-gygfH0f0_4BSo3WQzyq-M5-ASP93O6FvyAK63A9xRSjbSC8ix7H4=s250",
                    "image_thumbnail_url": "https://lh3.googleusercontent.com/g1oK39xpORz-dbGCeflK1VKYTg064TLiYvVnTLV3Cn3WyRN-gygfH0f0_4BSo3WQzyq-M5-ASP93O6FvyAK63A9xRSjbSC8ix7H4=s128",
                    "image_original_url": "https://arweave.net/_1mfNITZ4n4gQjMgULjPHvmqQGrXgsPUZANck5l6Yhg",
                    "animation_url": null,
                    "animation_original_url": null,
                    "name": "Apymon Monsters #404",
                    "description": null,
                    "external_link": "https://apymon.com",
                    "asset_contract": {
                        "address": "0x6e0baaa0d1c11dc160143c0c7213df76acdf4e17",
                        "asset_contract_type": "non-fungible",
                        "created_date": "2021-05-18T16:21:48.758011",
                        "name": "Apymon Monsters",
                        "nft_version": "3.0",
                        "opensea_version": null,
                        "owner": 30104721,
                        "schema_name": "ERC721",
                        "symbol": "APYM",
                        "total_supply": "0",
                        "description": "The NFT built by ERC721, Apymon Monsters, on Ethereum.",
                        "external_link": null,
                        "image_url": "https://lh3.googleusercontent.com/nCcUQe3w8k7omeB6DSrP4Y792JQaRLfqFv6SFzDxab1k44mR7kT9p8d4-m_X6iEfr47RGup5wCdP2s2RS1Y88-KaeElQgyzTs4cc=s120",
                        "default_to_fiat": false,
                        "dev_buyer_fee_basis_points": 0,
                        "dev_seller_fee_basis_points": 0,
                        "only_proxied_transfers": false,
                        "opensea_buyer_fee_basis_points": 0,
                        "opensea_seller_fee_basis_points": 250,
                        "buyer_fee_basis_points": 0,
                        "seller_fee_basis_points": 250,
                        "payout_address": null
                    },
                    "owner": {
                        "user": {
                            "username": "meePIG"
                        },
                        "profile_img_url": "https://storage.googleapis.com/opensea-static/opensea-profile/5.png",
                        "address": "0xf7e31c55c1771f64416ed96fa1a5ba09cae28133",
                        "config": "",
                        "discord_id": ""
                    },
                    "permalink": "https://opensea.io/assets/0x6e0baaa0d1c11dc160143c0c7213df76acdf4e17/404",
                    "collection": {
                        "banner_image_url": "https://lh3.googleusercontent.com/xsxkSFVINW-MV2mnqiv5PN6uFynoq-ev16uvOIgkz73GODzvFeM7wOmBM7OkxGmhv1GHpP-t31VqHcEvfScUfAnfiDT-zGS_Y30C=s2500",
                        "chat_url": null,
                        "created_date": "2021-05-18T16:59:45.948886",
                        "default_to_fiat": false,
                        "description": "The NFT built by ERC721, Apymon Monsters, on Ethereum.",
                        "dev_buyer_fee_basis_points": "0",
                        "dev_seller_fee_basis_points": "0",
                        "discord_url": null,
                        "display_data": {
                            "card_display_style": "contain"
                        },
                        "external_url": null,
                        "featured": false,
                        "featured_image_url": "https://lh3.googleusercontent.com/hybKwm5kYCjE_IIF4DiObNzaHYVOH0Xenx3ye8domy0ssj1SQB7L7j0krdp8dFFiR8ZTznf16HX70btLTblWUqS-wxaFqbAencUTyw=s300",
                        "hidden": true,
                        "safelist_request_status": "not_requested",
                        "image_url": "https://lh3.googleusercontent.com/nCcUQe3w8k7omeB6DSrP4Y792JQaRLfqFv6SFzDxab1k44mR7kT9p8d4-m_X6iEfr47RGup5wCdP2s2RS1Y88-KaeElQgyzTs4cc=s120",
                        "is_subject_to_whitelist": false,
                        "large_image_url": "https://lh3.googleusercontent.com/hybKwm5kYCjE_IIF4DiObNzaHYVOH0Xenx3ye8domy0ssj1SQB7L7j0krdp8dFFiR8ZTznf16HX70btLTblWUqS-wxaFqbAencUTyw=s300",
                        "medium_username": null,
                        "name": "Apymon Monsters",
                        "only_proxied_transfers": false,
                        "opensea_buyer_fee_basis_points": "0",
                        "opensea_seller_fee_basis_points": "250",
                        "payout_address": null,
                        "require_email": false,
                        "short_description": null,
                        "slug": "apymon-monsters",
                        "telegram_url": null,
                        "twitter_username": null,
                        "instagram_username": null,
                        "wiki_url": null
                    },
                    "decimals": 0,
                    "token_metadata": "https://gateway.pinata.cloud/ipfs/QmTQeQgS5Xa5WiDzuGS5RCKe8z74CgfiuA5cADPXLVX7uB/404"
                },
                {
                    "id": 25663636,
                    "token_id": "112122543444638944511622707921156659601731686990296802203830456799671862951937",
                    "num_sales": 0,
                    "background_color": null,
                    "image_url": "https://lh3.googleusercontent.com/R4_bcwOoM13Phvmi1XCiwOLXCyQafLWg-unvCrp82Y_RwTNn1lS9aMVyO5j2VwcpRBMVcVBbWg8V4cE_xmfS6a9nz9RFX05XPUUpL84",
                    "image_preview_url": "https://lh3.googleusercontent.com/R4_bcwOoM13Phvmi1XCiwOLXCyQafLWg-unvCrp82Y_RwTNn1lS9aMVyO5j2VwcpRBMVcVBbWg8V4cE_xmfS6a9nz9RFX05XPUUpL84=s250",
                    "image_thumbnail_url": "https://lh3.googleusercontent.com/R4_bcwOoM13Phvmi1XCiwOLXCyQafLWg-unvCrp82Y_RwTNn1lS9aMVyO5j2VwcpRBMVcVBbWg8V4cE_xmfS6a9nz9RFX05XPUUpL84=s128",
                    "image_original_url": null,
                    "animation_url": "https://storage.opensea.io/files/f367392649b06a010993c9d0ea3db8a7.mp4",
                    "animation_original_url": "https://storage.opensea.io/files/f367392649b06a010993c9d0ea3db8a7.mp4",
                    "name": "Apymon Monsters #2245",
                    "description": null,
                    "external_link": null,
                    "asset_contract": {
                        "address": "0x495f947276749ce646f68ac8c248420045cb7b5e",
                        "asset_contract_type": "semi-fungible",
                        "created_date": "2020-12-02T17:40:53.232025",
                        "name": "OpenSea Collection",
                        "nft_version": null,
                        "opensea_version": "2.0.0",
                        "owner": 102384,
                        "schema_name": "ERC1155",
                        "symbol": "OPENSTORE",
                        "total_supply": null,
                        "description": null,
                        "external_link": null,
                        "image_url": null,
                        "default_to_fiat": false,
                        "dev_buyer_fee_basis_points": 0,
                        "dev_seller_fee_basis_points": 0,
                        "only_proxied_transfers": false,
                        "opensea_buyer_fee_basis_points": 0,
                        "opensea_seller_fee_basis_points": 250,
                        "buyer_fee_basis_points": 0,
                        "seller_fee_basis_points": 250,
                        "payout_address": null
                    },
                    "owner": {
                        "user": {
                            "username": "NullAddress"
                        },
                        "profile_img_url": "https://storage.googleapis.com/opensea-static/opensea-profile/1.png",
                        "address": "0x0000000000000000000000000000000000000000",
                        "config": "",
                        "discord_id": ""
                    },
                    "permalink": "https://opensea.io/assets/0x495f947276749ce646f68ac8c248420045cb7b5e/112122543444638944511622707921156659601731686990296802203830456799671862951937",
                    "collection": {
                        "banner_image_url": "https://lh3.googleusercontent.com/FOPcASeD6y7uAiRixUDEJpbw3AlPlRo4N1dmpATKbqzScL0Xaiteunz9unHIOyLO7KKgY8SqXzBLfh72VSZXhpeOlJaVkxIJESdZBw=s2500",
                        "chat_url": null,
                        "created_date": "2021-05-25T14:46:28.721872",
                        "default_to_fiat": false,
                        "description": "The NFT built by ERC721, Apymon Monsters, on Ethereum.",
                        "dev_buyer_fee_basis_points": "0",
                        "dev_seller_fee_basis_points": "0",
                        "discord_url": null,
                        "display_data": {
                            "card_display_style": "contain"
                        },
                        "external_url": null,
                        "featured": false,
                        "featured_image_url": null,
                        "hidden": true,
                        "safelist_request_status": "not_requested",
                        "image_url": "https://lh3.googleusercontent.com/nCcUQe3w8k7omeB6DSrP4Y792JQaRLfqFv6SFzDxab1k44mR7kT9p8d4-m_X6iEfr47RGup5wCdP2s2RS1Y88-KaeElQgyzTs4cc=s120",
                        "is_subject_to_whitelist": false,
                        "large_image_url": null,
                        "medium_username": null,
                        "name": "Apymon  Monsters",
                        "only_proxied_transfers": false,
                        "opensea_buyer_fee_basis_points": "0",
                        "opensea_seller_fee_basis_points": "250",
                        "payout_address": null,
                        "require_email": false,
                        "short_description": null,
                        "slug": "colored-boxes",
                        "telegram_url": null,
                        "twitter_username": null,
                        "instagram_username": null,
                        "wiki_url": null
                    },
                    "decimals": null,
                    "token_metadata": null
                },
                {
                    "id": 25663742,
                    "token_id": "112122543444638944511622707921156659601731686990296802203830456800771374579713",
                    "num_sales": 0,
                    "background_color": null,
                    "image_url": "https://lh3.googleusercontent.com/OcBIDMu-vX8jDpAGRVmniKUvKJmAOILJLdlGAwMedt7ZSX51NdsVpxQv08vp9RfJv5F0y5-n13yPeW1CZZv8dvUO91hTrbiyVdYQlg",
                    "image_preview_url": "https://lh3.googleusercontent.com/OcBIDMu-vX8jDpAGRVmniKUvKJmAOILJLdlGAwMedt7ZSX51NdsVpxQv08vp9RfJv5F0y5-n13yPeW1CZZv8dvUO91hTrbiyVdYQlg=s250",
                    "image_thumbnail_url": "https://lh3.googleusercontent.com/OcBIDMu-vX8jDpAGRVmniKUvKJmAOILJLdlGAwMedt7ZSX51NdsVpxQv08vp9RfJv5F0y5-n13yPeW1CZZv8dvUO91hTrbiyVdYQlg=s128",
                    "image_original_url": null,
                    "animation_url": "https://storage.opensea.io/files/956bf46d545e47d19a7b9329153c2b12.mp4",
                    "animation_original_url": "https://storage.opensea.io/files/956bf46d545e47d19a7b9329153c2b12.mp4",
                    "name": "Apymon Monsters #13",
                    "description": null,
                    "external_link": null,
                    "asset_contract": {
                        "address": "0x495f947276749ce646f68ac8c248420045cb7b5e",
                        "asset_contract_type": "semi-fungible",
                        "created_date": "2020-12-02T17:40:53.232025",
                        "name": "OpenSea Collection",
                        "nft_version": null,
                        "opensea_version": "2.0.0",
                        "owner": 102384,
                        "schema_name": "ERC1155",
                        "symbol": "OPENSTORE",
                        "total_supply": null,
                        "description": null,
                        "external_link": null,
                        "image_url": null,
                        "default_to_fiat": false,
                        "dev_buyer_fee_basis_points": 0,
                        "dev_seller_fee_basis_points": 0,
                        "only_proxied_transfers": false,
                        "opensea_buyer_fee_basis_points": 0,
                        "opensea_seller_fee_basis_points": 250,
                        "buyer_fee_basis_points": 0,
                        "seller_fee_basis_points": 250,
                        "payout_address": null
                    },
                    "owner": {
                        "user": {
                            "username": "NullAddress"
                        },
                        "profile_img_url": "https://storage.googleapis.com/opensea-static/opensea-profile/1.png",
                        "address": "0x0000000000000000000000000000000000000000",
                        "config": "",
                        "discord_id": ""
                    },
                    "permalink": "https://opensea.io/assets/0x495f947276749ce646f68ac8c248420045cb7b5e/112122543444638944511622707921156659601731686990296802203830456800771374579713",
                    "collection": {
                        "banner_image_url": "https://lh3.googleusercontent.com/FOPcASeD6y7uAiRixUDEJpbw3AlPlRo4N1dmpATKbqzScL0Xaiteunz9unHIOyLO7KKgY8SqXzBLfh72VSZXhpeOlJaVkxIJESdZBw=s2500",
                        "chat_url": null,
                        "created_date": "2021-05-25T14:46:28.721872",
                        "default_to_fiat": false,
                        "description": "The NFT built by ERC721, Apymon Monsters, on Ethereum.",
                        "dev_buyer_fee_basis_points": "0",
                        "dev_seller_fee_basis_points": "0",
                        "discord_url": null,
                        "display_data": {
                            "card_display_style": "contain"
                        },
                        "external_url": null,
                        "featured": false,
                        "featured_image_url": null,
                        "hidden": true,
                        "safelist_request_status": "not_requested",
                        "image_url": "https://lh3.googleusercontent.com/nCcUQe3w8k7omeB6DSrP4Y792JQaRLfqFv6SFzDxab1k44mR7kT9p8d4-m_X6iEfr47RGup5wCdP2s2RS1Y88-KaeElQgyzTs4cc=s120",
                        "is_subject_to_whitelist": false,
                        "large_image_url": null,
                        "medium_username": null,
                        "name": "Apymon  Monsters",
                        "only_proxied_transfers": false,
                        "opensea_buyer_fee_basis_points": "0",
                        "opensea_seller_fee_basis_points": "250",
                        "payout_address": null,
                        "require_email": false,
                        "short_description": null,
                        "slug": "colored-boxes",
                        "telegram_url": null,
                        "twitter_username": null,
                        "instagram_username": null,
                        "wiki_url": null
                    },
                    "decimals": null,
                    "token_metadata": null
                }
            ],
            "name": "3 apymon monsters",
            "description": null,
            "external_link": "",
            "asset_contract": null,
            "permalink": "https://opensea.io/bundles/3-apymon-monsters-mRU",
            "sell_orders": [
                {
                    "created_date": "2021-05-25T23:10:35.823157",
                    "closing_date": null,
                    "closing_extendable": false,
                    "expiration_time": 0,
                    "listing_time": 1621984128,
                    "order_hash": "0xaa922db8894902318921e4acc8dc1220f1963ae3d2c9661b7c4c8f46c6152fba",
                    "metadata": {
                        "bundle": {
                            "assets": [
                                {
                                    "id": "112122543444638944511622707921156659601731686990296802203830456799671862951937",
                                    "address": "0x495f947276749ce646f68ac8c248420045cb7b5e",
                                    "quantity": "1"
                                },
                                {
                                    "id": "112122543444638944511622707921156659601731686990296802203830456800771374579713",
                                    "address": "0x495f947276749ce646f68ac8c248420045cb7b5e",
                                    "quantity": "1"
                                },
                                {
                                    "id": "404",
                                    "address": "0x6e0baaa0d1c11dc160143c0c7213df76acdf4e17"
                                }
                            ],
                            "schemas": [
                                "ERC1155",
                                "ERC1155",
                                "ERC721"
                            ],
                            "name": "3 apymon monsters",
                            "external_link": ""
                        }
                    },
                    "exchange": "0x7be8076f4ea4a4ad08075c2508e481d6c946d12b",
                    "maker": {
                        "user": 821223,
                        "profile_img_url": "https://storage.googleapis.com/opensea-static/opensea-profile/5.png",
                        "address": "0xf7e31c55c1771f64416ed96fa1a5ba09cae28133",
                        "config": "",
                        "discord_id": ""
                    },
                    "taker": {
                        "user": 1766,
                        "profile_img_url": "https://storage.googleapis.com/opensea-static/opensea-profile/1.png",
                        "address": "0x0000000000000000000000000000000000000000",
                        "config": "",
                        "discord_id": ""
                    },
                    "current_price": "2490000000000000000",
                    "current_bounty": "24900000000000000",
                    "bounty_multiple": "0.01",
                    "maker_relayer_fee": "250",
                    "taker_relayer_fee": "0",
                    "maker_protocol_fee": "0",
                    "taker_protocol_fee": "0",
                    "maker_referrer_fee": "0",
                    "fee_recipient": {
                        "user": 3585,
                        "profile_img_url": "https://storage.googleapis.com/opensea-static/opensea-profile/28.png",
                        "address": "0x5b3256965e7c3cf26e11fcaf296dfc8807c01073",
                        "config": "verified",
                        "discord_id": ""
                    },
                    "fee_method": 1,
                    "side": 1,
                    "sale_kind": 0,
                    "target": "0xc99f70bfd82fb7c8f8191fdfbfb735606b15e5c5",
                    "how_to_call": 1,
                    "calldata": "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",
                    "replacement_pattern": "0x0000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000ffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffff0000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000ffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffff0000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000ffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffff00000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000",
                    "static_target": "0x0000000000000000000000000000000000000000",
                    "static_extradata": "0x",
                    "payment_token": "0x0000000000000000000000000000000000000000",
                    "payment_token_contract": {
                        "id": 1,
                        "symbol": "ETH",
                        "address": "0x0000000000000000000000000000000000000000",
                        "image_url": "https://storage.opensea.io/files/6f8e2979d428180222796ff4a33ab929.svg",
                        "name": "Ether",
                        "decimals": 18,
                        "eth_price": "1.000000000000000",
                        "usd_price": "2625.730000000000018000"
                    },
                    "base_price": "2490000000000000000",
                    "extra": "0",
                    "quantity": "1",
                    "salt": "4095181697038459668042545827146489910757833956875191366190846998707424686426",
                    "v": 28,
                    "r": "0xc7be57d45824692319d7f326241977e4e3c34be90457f6e6d1958c0f9d8a3a06",
                    "s": "0x62a9cb222eecf1e68d736e866cbadfb734d55d15eea09442bc8298f44e48c87c",
                    "approved_on_chain": false,
                    "cancelled": false,
                    "finalized": false,
                    "marked_invalid": false,
                    "prefixed_hash": "0x6646bd7a5a071244c766646efe7baad1a40e5f0a4b06c80c08fca4d114040336"
                }
            ]
        },
        {
            "maker": {
                "user": {
                    "username": null
                },
                "profile_img_url": "https://storage.googleapis.com/opensea-static/opensea-profile/5.png",
                "address": "0xe289a24fc2859fa9fb4b5acc97de7d4d6f0dc831",
                "config": "",
                "discord_id": ""
            },
            "slug": "rick-fox-dr-david-washington-Nf4",
            "assets": [
                {
                    "id": 20424839,
                    "token_id": "70479185245472823933799012500856922265354379340922944019462782670791436664833",
                    "num_sales": 0,
                    "background_color": null,
                    "image_url": "https://lh3.googleusercontent.com/-_MLjwBQS5zs9B703Kja525eerpYnmmbne1V18ixw3DGO1Ltdgr82iI_GIoBcP3dfb75C9q7Glw5LAWFsCZRZroi7PxJS6ZDoptZGQ",
                    "image_preview_url": "https://lh3.googleusercontent.com/-_MLjwBQS5zs9B703Kja525eerpYnmmbne1V18ixw3DGO1Ltdgr82iI_GIoBcP3dfb75C9q7Glw5LAWFsCZRZroi7PxJS6ZDoptZGQ=s250",
                    "image_thumbnail_url": "https://lh3.googleusercontent.com/-_MLjwBQS5zs9B703Kja525eerpYnmmbne1V18ixw3DGO1Ltdgr82iI_GIoBcP3dfb75C9q7Glw5LAWFsCZRZroi7PxJS6ZDoptZGQ=s128",
                    "image_original_url": null,
                    "animation_url": null,
                    "animation_original_url": null,
                    "name": "Rick Fox",
                    "description": "Empathy / Telepathy 1 of 10",
                    "external_link": null,
                    "asset_contract": {
                        "address": "0x495f947276749ce646f68ac8c248420045cb7b5e",
                        "asset_contract_type": "semi-fungible",
                        "created_date": "2020-12-02T17:40:53.232025",
                        "name": "OpenSea Collection",
                        "nft_version": null,
                        "opensea_version": "2.0.0",
                        "owner": 102384,
                        "schema_name": "ERC1155",
                        "symbol": "OPENSTORE",
                        "total_supply": null,
                        "description": null,
                        "external_link": null,
                        "image_url": null,
                        "default_to_fiat": false,
                        "dev_buyer_fee_basis_points": 0,
                        "dev_seller_fee_basis_points": 0,
                        "only_proxied_transfers": false,
                        "opensea_buyer_fee_basis_points": 0,
                        "opensea_seller_fee_basis_points": 250,
                        "buyer_fee_basis_points": 0,
                        "seller_fee_basis_points": 250,
                        "payout_address": null
                    },
                    "owner": {
                        "user": {
                            "username": "NullAddress"
                        },
                        "profile_img_url": "https://storage.googleapis.com/opensea-static/opensea-profile/1.png",
                        "address": "0x0000000000000000000000000000000000000000",
                        "config": "",
                        "discord_id": ""
                    },
                    "permalink": "https://opensea.io/assets/0x495f947276749ce646f68ac8c248420045cb7b5e/70479185245472823933799012500856922265354379340922944019462782670791436664833",
                    "collection": {
                        "banner_image_url": "https://lh3.googleusercontent.com/i1dLTD9hXZSzeMGz02l202fkMjd3QQrZ2fCQ2TZt-ajo3L931rN_TRGeqU9IvTfm166GIvs5DWaWCKbnuxKq5JmMHLOXioRyCuMxNQ=s2500",
                        "chat_url": null,
                        "created_date": "2021-03-24T00:31:54.219565",
                        "default_to_fiat": false,
                        "description": "",
                        "dev_buyer_fee_basis_points": "0",
                        "dev_seller_fee_basis_points": "0",
                        "discord_url": null,
                        "display_data": {
                            "card_display_style": "contain",
                            "images": []
                        },
                        "external_url": null,
                        "featured": false,
                        "featured_image_url": null,
                        "hidden": true,
                        "safelist_request_status": "not_requested",
                        "image_url": "https://lh3.googleusercontent.com/qZRiTQMHRe5EswI1syqlf0Sf3sfY8bnZjtVhjn89Kh_RxfqZ1WBWTJBnyvnB-gJWsvr6-DsACvVxrPBsj5pSlecxj63iAcVfQTkD=s120",
                        "is_subject_to_whitelist": false,
                        "large_image_url": null,
                        "medium_username": null,
                        "name": "HiDef",
                        "only_proxied_transfers": false,
                        "opensea_buyer_fee_basis_points": "0",
                        "opensea_seller_fee_basis_points": "250",
                        "payout_address": null,
                        "require_email": false,
                        "short_description": null,
                        "slug": "hidef",
                        "telegram_url": null,
                        "twitter_username": null,
                        "instagram_username": null,
                        "wiki_url": null
                    },
                    "decimals": null,
                    "token_metadata": null
                },
                {
                    "id": 20424858,
                    "token_id": "70479185245472823933799012500856922265354379340922944019462782671890948292609",
                    "num_sales": 0,
                    "background_color": null,
                    "image_url": "https://lh3.googleusercontent.com/-_MLjwBQS5zs9B703Kja525eerpYnmmbne1V18ixw3DGO1Ltdgr82iI_GIoBcP3dfb75C9q7Glw5LAWFsCZRZroi7PxJS6ZDoptZGQ",
                    "image_preview_url": "https://lh3.googleusercontent.com/-_MLjwBQS5zs9B703Kja525eerpYnmmbne1V18ixw3DGO1Ltdgr82iI_GIoBcP3dfb75C9q7Glw5LAWFsCZRZroi7PxJS6ZDoptZGQ=s250",
                    "image_thumbnail_url": "https://lh3.googleusercontent.com/-_MLjwBQS5zs9B703Kja525eerpYnmmbne1V18ixw3DGO1Ltdgr82iI_GIoBcP3dfb75C9q7Glw5LAWFsCZRZroi7PxJS6ZDoptZGQ=s128",
                    "image_original_url": null,
                    "animation_url": null,
                    "animation_original_url": null,
                    "name": "Rick Fox",
                    "description": "Empathy / Telepathy 2 of 10",
                    "external_link": null,
                    "asset_contract": {
                        "address": "0x495f947276749ce646f68ac8c248420045cb7b5e",
                        "asset_contract_type": "semi-fungible",
                        "created_date": "2020-12-02T17:40:53.232025",
                        "name": "OpenSea Collection",
                        "nft_version": null,
                        "opensea_version": "2.0.0",
                        "owner": 102384,
                        "schema_name": "ERC1155",
                        "symbol": "OPENSTORE",
                        "total_supply": null,
                        "description": null,
                        "external_link": null,
                        "image_url": null,
                        "default_to_fiat": false,
                        "dev_buyer_fee_basis_points": 0,
                        "dev_seller_fee_basis_points": 0,
                        "only_proxied_transfers": false,
                        "opensea_buyer_fee_basis_points": 0,
                        "opensea_seller_fee_basis_points": 250,
                        "buyer_fee_basis_points": 0,
                        "seller_fee_basis_points": 250,
                        "payout_address": null
                    },
                    "owner": {
                        "user": {
                            "username": "NullAddress"
                        },
                        "profile_img_url": "https://storage.googleapis.com/opensea-static/opensea-profile/1.png",
                        "address": "0x0000000000000000000000000000000000000000",
                        "config": "",
                        "discord_id": ""
                    },
                    "permalink": "https://opensea.io/assets/0x495f947276749ce646f68ac8c248420045cb7b5e/70479185245472823933799012500856922265354379340922944019462782671890948292609",
                    "collection": {
                        "banner_image_url": "https://lh3.googleusercontent.com/i1dLTD9hXZSzeMGz02l202fkMjd3QQrZ2fCQ2TZt-ajo3L931rN_TRGeqU9IvTfm166GIvs5DWaWCKbnuxKq5JmMHLOXioRyCuMxNQ=s2500",
                        "chat_url": null,
                        "created_date": "2021-03-24T00:31:54.219565",
                        "default_to_fiat": false,
                        "description": "",
                        "dev_buyer_fee_basis_points": "0",
                        "dev_seller_fee_basis_points": "0",
                        "discord_url": null,
                        "display_data": {
                            "card_display_style": "contain",
                            "images": []
                        },
                        "external_url": null,
                        "featured": false,
                        "featured_image_url": null,
                        "hidden": true,
                        "safelist_request_status": "not_requested",
                        "image_url": "https://lh3.googleusercontent.com/qZRiTQMHRe5EswI1syqlf0Sf3sfY8bnZjtVhjn89Kh_RxfqZ1WBWTJBnyvnB-gJWsvr6-DsACvVxrPBsj5pSlecxj63iAcVfQTkD=s120",
                        "is_subject_to_whitelist": false,
                        "large_image_url": null,
                        "medium_username": null,
                        "name": "HiDef",
                        "only_proxied_transfers": false,
                        "opensea_buyer_fee_basis_points": "0",
                        "opensea_seller_fee_basis_points": "250",
                        "payout_address": null,
                        "require_email": false,
                        "short_description": null,
                        "slug": "hidef",
                        "telegram_url": null,
                        "twitter_username": null,
                        "instagram_username": null,
                        "wiki_url": null
                    },
                    "decimals": null,
                    "token_metadata": null
                },
                {
                    "id": 20424868,
                    "token_id": "70479185245472823933799012500856922265354379340922944019462782672990459920385",
                    "num_sales": 0,
                    "background_color": null,
                    "image_url": "https://lh3.googleusercontent.com/-_MLjwBQS5zs9B703Kja525eerpYnmmbne1V18ixw3DGO1Ltdgr82iI_GIoBcP3dfb75C9q7Glw5LAWFsCZRZroi7PxJS6ZDoptZGQ",
                    "image_preview_url": "https://lh3.googleusercontent.com/-_MLjwBQS5zs9B703Kja525eerpYnmmbne1V18ixw3DGO1Ltdgr82iI_GIoBcP3dfb75C9q7Glw5LAWFsCZRZroi7PxJS6ZDoptZGQ=s250",
                    "image_thumbnail_url": "https://lh3.googleusercontent.com/-_MLjwBQS5zs9B703Kja525eerpYnmmbne1V18ixw3DGO1Ltdgr82iI_GIoBcP3dfb75C9q7Glw5LAWFsCZRZroi7PxJS6ZDoptZGQ=s128",
                    "image_original_url": null,
                    "animation_url": null,
                    "animation_original_url": null,
                    "name": "Rick Fox",
                    "description": "Empathy / Telepathy 3 of 10",
                    "external_link": null,
                    "asset_contract": {
                        "address": "0x495f947276749ce646f68ac8c248420045cb7b5e",
                        "asset_contract_type": "semi-fungible",
                        "created_date": "2020-12-02T17:40:53.232025",
                        "name": "OpenSea Collection",
                        "nft_version": null,
                        "opensea_version": "2.0.0",
                        "owner": 102384,
                        "schema_name": "ERC1155",
                        "symbol": "OPENSTORE",
                        "total_supply": null,
                        "description": null,
                        "external_link": null,
                        "image_url": null,
                        "default_to_fiat": false,
                        "dev_buyer_fee_basis_points": 0,
                        "dev_seller_fee_basis_points": 0,
                        "only_proxied_transfers": false,
                        "opensea_buyer_fee_basis_points": 0,
                        "opensea_seller_fee_basis_points": 250,
                        "buyer_fee_basis_points": 0,
                        "seller_fee_basis_points": 250,
                        "payout_address": null
                    },
                    "owner": {
                        "user": {
                            "username": "NullAddress"
                        },
                        "profile_img_url": "https://storage.googleapis.com/opensea-static/opensea-profile/1.png",
                        "address": "0x0000000000000000000000000000000000000000",
                        "config": "",
                        "discord_id": ""
                    },
                    "permalink": "https://opensea.io/assets/0x495f947276749ce646f68ac8c248420045cb7b5e/70479185245472823933799012500856922265354379340922944019462782672990459920385",
                    "collection": {
                        "banner_image_url": "https://lh3.googleusercontent.com/i1dLTD9hXZSzeMGz02l202fkMjd3QQrZ2fCQ2TZt-ajo3L931rN_TRGeqU9IvTfm166GIvs5DWaWCKbnuxKq5JmMHLOXioRyCuMxNQ=s2500",
                        "chat_url": null,
                        "created_date": "2021-03-24T00:31:54.219565",
                        "default_to_fiat": false,
                        "description": "",
                        "dev_buyer_fee_basis_points": "0",
                        "dev_seller_fee_basis_points": "0",
                        "discord_url": null,
                        "display_data": {
                            "card_display_style": "contain",
                            "images": []
                        },
                        "external_url": null,
                        "featured": false,
                        "featured_image_url": null,
                        "hidden": true,
                        "safelist_request_status": "not_requested",
                        "image_url": "https://lh3.googleusercontent.com/qZRiTQMHRe5EswI1syqlf0Sf3sfY8bnZjtVhjn89Kh_RxfqZ1WBWTJBnyvnB-gJWsvr6-DsACvVxrPBsj5pSlecxj63iAcVfQTkD=s120",
                        "is_subject_to_whitelist": false,
                        "large_image_url": null,
                        "medium_username": null,
                        "name": "HiDef",
                        "only_proxied_transfers": false,
                        "opensea_buyer_fee_basis_points": "0",
                        "opensea_seller_fee_basis_points": "250",
                        "payout_address": null,
                        "require_email": false,
                        "short_description": null,
                        "slug": "hidef",
                        "telegram_url": null,
                        "twitter_username": null,
                        "instagram_username": null,
                        "wiki_url": null
                    },
                    "decimals": null,
                    "token_metadata": null
                },
                {
                    "id": 20424881,
                    "token_id": "70479185245472823933799012500856922265354379340922944019462782674089971548161",
                    "num_sales": 0,
                    "background_color": null,
                    "image_url": "https://lh3.googleusercontent.com/-_MLjwBQS5zs9B703Kja525eerpYnmmbne1V18ixw3DGO1Ltdgr82iI_GIoBcP3dfb75C9q7Glw5LAWFsCZRZroi7PxJS6ZDoptZGQ",
                    "image_preview_url": "https://lh3.googleusercontent.com/-_MLjwBQS5zs9B703Kja525eerpYnmmbne1V18ixw3DGO1Ltdgr82iI_GIoBcP3dfb75C9q7Glw5LAWFsCZRZroi7PxJS6ZDoptZGQ=s250",
                    "image_thumbnail_url": "https://lh3.googleusercontent.com/-_MLjwBQS5zs9B703Kja525eerpYnmmbne1V18ixw3DGO1Ltdgr82iI_GIoBcP3dfb75C9q7Glw5LAWFsCZRZroi7PxJS6ZDoptZGQ=s128",
                    "image_original_url": null,
                    "animation_url": null,
                    "animation_original_url": null,
                    "name": "Rick Fox",
                    "description": "Empathy / Telepathy 4 of 10",
                    "external_link": null,
                    "asset_contract": {
                        "address": "0x495f947276749ce646f68ac8c248420045cb7b5e",
                        "asset_contract_type": "semi-fungible",
                        "created_date": "2020-12-02T17:40:53.232025",
                        "name": "OpenSea Collection",
                        "nft_version": null,
                        "opensea_version": "2.0.0",
                        "owner": 102384,
                        "schema_name": "ERC1155",
                        "symbol": "OPENSTORE",
                        "total_supply": null,
                        "description": null,
                        "external_link": null,
                        "image_url": null,
                        "default_to_fiat": false,
                        "dev_buyer_fee_basis_points": 0,
                        "dev_seller_fee_basis_points": 0,
                        "only_proxied_transfers": false,
                        "opensea_buyer_fee_basis_points": 0,
                        "opensea_seller_fee_basis_points": 250,
                        "buyer_fee_basis_points": 0,
                        "seller_fee_basis_points": 250,
                        "payout_address": null
                    },
                    "owner": {
                        "user": {
                            "username": "NullAddress"
                        },
                        "profile_img_url": "https://storage.googleapis.com/opensea-static/opensea-profile/1.png",
                        "address": "0x0000000000000000000000000000000000000000",
                        "config": "",
                        "discord_id": ""
                    },
                    "permalink": "https://opensea.io/assets/0x495f947276749ce646f68ac8c248420045cb7b5e/70479185245472823933799012500856922265354379340922944019462782674089971548161",
                    "collection": {
                        "banner_image_url": "https://lh3.googleusercontent.com/i1dLTD9hXZSzeMGz02l202fkMjd3QQrZ2fCQ2TZt-ajo3L931rN_TRGeqU9IvTfm166GIvs5DWaWCKbnuxKq5JmMHLOXioRyCuMxNQ=s2500",
                        "chat_url": null,
                        "created_date": "2021-03-24T00:31:54.219565",
                        "default_to_fiat": false,
                        "description": "",
                        "dev_buyer_fee_basis_points": "0",
                        "dev_seller_fee_basis_points": "0",
                        "discord_url": null,
                        "display_data": {
                            "card_display_style": "contain",
                            "images": []
                        },
                        "external_url": null,
                        "featured": false,
                        "featured_image_url": null,
                        "hidden": true,
                        "safelist_request_status": "not_requested",
                        "image_url": "https://lh3.googleusercontent.com/qZRiTQMHRe5EswI1syqlf0Sf3sfY8bnZjtVhjn89Kh_RxfqZ1WBWTJBnyvnB-gJWsvr6-DsACvVxrPBsj5pSlecxj63iAcVfQTkD=s120",
                        "is_subject_to_whitelist": false,
                        "large_image_url": null,
                        "medium_username": null,
                        "name": "HiDef",
                        "only_proxied_transfers": false,
                        "opensea_buyer_fee_basis_points": "0",
                        "opensea_seller_fee_basis_points": "250",
                        "payout_address": null,
                        "require_email": false,
                        "short_description": null,
                        "slug": "hidef",
                        "telegram_url": null,
                        "twitter_username": null,
                        "instagram_username": null,
                        "wiki_url": null
                    },
                    "decimals": null,
                    "token_metadata": null
                },
                {
                    "id": 20424902,
                    "token_id": "70479185245472823933799012500856922265354379340922944019462782675189483175937",
                    "num_sales": 0,
                    "background_color": null,
                    "image_url": "https://lh3.googleusercontent.com/-_MLjwBQS5zs9B703Kja525eerpYnmmbne1V18ixw3DGO1Ltdgr82iI_GIoBcP3dfb75C9q7Glw5LAWFsCZRZroi7PxJS6ZDoptZGQ",
                    "image_preview_url": "https://lh3.googleusercontent.com/-_MLjwBQS5zs9B703Kja525eerpYnmmbne1V18ixw3DGO1Ltdgr82iI_GIoBcP3dfb75C9q7Glw5LAWFsCZRZroi7PxJS6ZDoptZGQ=s250",
                    "image_thumbnail_url": "https://lh3.googleusercontent.com/-_MLjwBQS5zs9B703Kja525eerpYnmmbne1V18ixw3DGO1Ltdgr82iI_GIoBcP3dfb75C9q7Glw5LAWFsCZRZroi7PxJS6ZDoptZGQ=s128",
                    "image_original_url": null,
                    "animation_url": null,
                    "animation_original_url": null,
                    "name": "Rick Fox",
                    "description": "Empathy / Telepathy 5 of 10",
                    "external_link": null,
                    "asset_contract": {
                        "address": "0x495f947276749ce646f68ac8c248420045cb7b5e",
                        "asset_contract_type": "semi-fungible",
                        "created_date": "2020-12-02T17:40:53.232025",
                        "name": "OpenSea Collection",
                        "nft_version": null,
                        "opensea_version": "2.0.0",
                        "owner": 102384,
                        "schema_name": "ERC1155",
                        "symbol": "OPENSTORE",
                        "total_supply": null,
                        "description": null,
                        "external_link": null,
                        "image_url": null,
                        "default_to_fiat": false,
                        "dev_buyer_fee_basis_points": 0,
                        "dev_seller_fee_basis_points": 0,
                        "only_proxied_transfers": false,
                        "opensea_buyer_fee_basis_points": 0,
                        "opensea_seller_fee_basis_points": 250,
                        "buyer_fee_basis_points": 0,
                        "seller_fee_basis_points": 250,
                        "payout_address": null
                    },
                    "owner": {
                        "user": {
                            "username": "NullAddress"
                        },
                        "profile_img_url": "https://storage.googleapis.com/opensea-static/opensea-profile/1.png",
                        "address": "0x0000000000000000000000000000000000000000",
                        "config": "",
                        "discord_id": ""
                    },
                    "permalink": "https://opensea.io/assets/0x495f947276749ce646f68ac8c248420045cb7b5e/70479185245472823933799012500856922265354379340922944019462782675189483175937",
                    "collection": {
                        "banner_image_url": "https://lh3.googleusercontent.com/i1dLTD9hXZSzeMGz02l202fkMjd3QQrZ2fCQ2TZt-ajo3L931rN_TRGeqU9IvTfm166GIvs5DWaWCKbnuxKq5JmMHLOXioRyCuMxNQ=s2500",
                        "chat_url": null,
                        "created_date": "2021-03-24T00:31:54.219565",
                        "default_to_fiat": false,
                        "description": "",
                        "dev_buyer_fee_basis_points": "0",
                        "dev_seller_fee_basis_points": "0",
                        "discord_url": null,
                        "display_data": {
                            "card_display_style": "contain",
                            "images": []
                        },
                        "external_url": null,
                        "featured": false,
                        "featured_image_url": null,
                        "hidden": true,
                        "safelist_request_status": "not_requested",
                        "image_url": "https://lh3.googleusercontent.com/qZRiTQMHRe5EswI1syqlf0Sf3sfY8bnZjtVhjn89Kh_RxfqZ1WBWTJBnyvnB-gJWsvr6-DsACvVxrPBsj5pSlecxj63iAcVfQTkD=s120",
                        "is_subject_to_whitelist": false,
                        "large_image_url": null,
                        "medium_username": null,
                        "name": "HiDef",
                        "only_proxied_transfers": false,
                        "opensea_buyer_fee_basis_points": "0",
                        "opensea_seller_fee_basis_points": "250",
                        "payout_address": null,
                        "require_email": false,
                        "short_description": null,
                        "slug": "hidef",
                        "telegram_url": null,
                        "twitter_username": null,
                        "instagram_username": null,
                        "wiki_url": null
                    },
                    "decimals": null,
                    "token_metadata": null
                },
                {
                    "id": 20424918,
                    "token_id": "70479185245472823933799012500856922265354379340922944019462782676288994803713",
                    "num_sales": 0,
                    "background_color": null,
                    "image_url": "https://lh3.googleusercontent.com/-_MLjwBQS5zs9B703Kja525eerpYnmmbne1V18ixw3DGO1Ltdgr82iI_GIoBcP3dfb75C9q7Glw5LAWFsCZRZroi7PxJS6ZDoptZGQ",
                    "image_preview_url": "https://lh3.googleusercontent.com/-_MLjwBQS5zs9B703Kja525eerpYnmmbne1V18ixw3DGO1Ltdgr82iI_GIoBcP3dfb75C9q7Glw5LAWFsCZRZroi7PxJS6ZDoptZGQ=s250",
                    "image_thumbnail_url": "https://lh3.googleusercontent.com/-_MLjwBQS5zs9B703Kja525eerpYnmmbne1V18ixw3DGO1Ltdgr82iI_GIoBcP3dfb75C9q7Glw5LAWFsCZRZroi7PxJS6ZDoptZGQ=s128",
                    "image_original_url": null,
                    "animation_url": null,
                    "animation_original_url": null,
                    "name": "Rick Fox",
                    "description": "Empathy / Telepathy 6 of 10",
                    "external_link": null,
                    "asset_contract": {
                        "address": "0x495f947276749ce646f68ac8c248420045cb7b5e",
                        "asset_contract_type": "semi-fungible",
                        "created_date": "2020-12-02T17:40:53.232025",
                        "name": "OpenSea Collection",
                        "nft_version": null,
                        "opensea_version": "2.0.0",
                        "owner": 102384,
                        "schema_name": "ERC1155",
                        "symbol": "OPENSTORE",
                        "total_supply": null,
                        "description": null,
                        "external_link": null,
                        "image_url": null,
                        "default_to_fiat": false,
                        "dev_buyer_fee_basis_points": 0,
                        "dev_seller_fee_basis_points": 0,
                        "only_proxied_transfers": false,
                        "opensea_buyer_fee_basis_points": 0,
                        "opensea_seller_fee_basis_points": 250,
                        "buyer_fee_basis_points": 0,
                        "seller_fee_basis_points": 250,
                        "payout_address": null
                    },
                    "owner": {
                        "user": {
                            "username": "NullAddress"
                        },
                        "profile_img_url": "https://storage.googleapis.com/opensea-static/opensea-profile/1.png",
                        "address": "0x0000000000000000000000000000000000000000",
                        "config": "",
                        "discord_id": ""
                    },
                    "permalink": "https://opensea.io/assets/0x495f947276749ce646f68ac8c248420045cb7b5e/70479185245472823933799012500856922265354379340922944019462782676288994803713",
                    "collection": {
                        "banner_image_url": "https://lh3.googleusercontent.com/i1dLTD9hXZSzeMGz02l202fkMjd3QQrZ2fCQ2TZt-ajo3L931rN_TRGeqU9IvTfm166GIvs5DWaWCKbnuxKq5JmMHLOXioRyCuMxNQ=s2500",
                        "chat_url": null,
                        "created_date": "2021-03-24T00:31:54.219565",
                        "default_to_fiat": false,
                        "description": "",
                        "dev_buyer_fee_basis_points": "0",
                        "dev_seller_fee_basis_points": "0",
                        "discord_url": null,
                        "display_data": {
                            "card_display_style": "contain",
                            "images": []
                        },
                        "external_url": null,
                        "featured": false,
                        "featured_image_url": null,
                        "hidden": true,
                        "safelist_request_status": "not_requested",
                        "image_url": "https://lh3.googleusercontent.com/qZRiTQMHRe5EswI1syqlf0Sf3sfY8bnZjtVhjn89Kh_RxfqZ1WBWTJBnyvnB-gJWsvr6-DsACvVxrPBsj5pSlecxj63iAcVfQTkD=s120",
                        "is_subject_to_whitelist": false,
                        "large_image_url": null,
                        "medium_username": null,
                        "name": "HiDef",
                        "only_proxied_transfers": false,
                        "opensea_buyer_fee_basis_points": "0",
                        "opensea_seller_fee_basis_points": "250",
                        "payout_address": null,
                        "require_email": false,
                        "short_description": null,
                        "slug": "hidef",
                        "telegram_url": null,
                        "twitter_username": null,
                        "instagram_username": null,
                        "wiki_url": null
                    },
                    "decimals": null,
                    "token_metadata": null
                },
                {
                    "id": 20424936,
                    "token_id": "70479185245472823933799012500856922265354379340922944019462782677388506431489",
                    "num_sales": 0,
                    "background_color": null,
                    "image_url": "https://lh3.googleusercontent.com/-_MLjwBQS5zs9B703Kja525eerpYnmmbne1V18ixw3DGO1Ltdgr82iI_GIoBcP3dfb75C9q7Glw5LAWFsCZRZroi7PxJS6ZDoptZGQ",
                    "image_preview_url": "https://lh3.googleusercontent.com/-_MLjwBQS5zs9B703Kja525eerpYnmmbne1V18ixw3DGO1Ltdgr82iI_GIoBcP3dfb75C9q7Glw5LAWFsCZRZroi7PxJS6ZDoptZGQ=s250",
                    "image_thumbnail_url": "https://lh3.googleusercontent.com/-_MLjwBQS5zs9B703Kja525eerpYnmmbne1V18ixw3DGO1Ltdgr82iI_GIoBcP3dfb75C9q7Glw5LAWFsCZRZroi7PxJS6ZDoptZGQ=s128",
                    "image_original_url": null,
                    "animation_url": null,
                    "animation_original_url": null,
                    "name": "Rick Fox",
                    "description": "Empathy / Telepathy 7 of 10",
                    "external_link": null,
                    "asset_contract": {
                        "address": "0x495f947276749ce646f68ac8c248420045cb7b5e",
                        "asset_contract_type": "semi-fungible",
                        "created_date": "2020-12-02T17:40:53.232025",
                        "name": "OpenSea Collection",
                        "nft_version": null,
                        "opensea_version": "2.0.0",
                        "owner": 102384,
                        "schema_name": "ERC1155",
                        "symbol": "OPENSTORE",
                        "total_supply": null,
                        "description": null,
                        "external_link": null,
                        "image_url": null,
                        "default_to_fiat": false,
                        "dev_buyer_fee_basis_points": 0,
                        "dev_seller_fee_basis_points": 0,
                        "only_proxied_transfers": false,
                        "opensea_buyer_fee_basis_points": 0,
                        "opensea_seller_fee_basis_points": 250,
                        "buyer_fee_basis_points": 0,
                        "seller_fee_basis_points": 250,
                        "payout_address": null
                    },
                    "owner": {
                        "user": {
                            "username": "NullAddress"
                        },
                        "profile_img_url": "https://storage.googleapis.com/opensea-static/opensea-profile/1.png",
                        "address": "0x0000000000000000000000000000000000000000",
                        "config": "",
                        "discord_id": ""
                    },
                    "permalink": "https://opensea.io/assets/0x495f947276749ce646f68ac8c248420045cb7b5e/70479185245472823933799012500856922265354379340922944019462782677388506431489",
                    "collection": {
                        "banner_image_url": "https://lh3.googleusercontent.com/i1dLTD9hXZSzeMGz02l202fkMjd3QQrZ2fCQ2TZt-ajo3L931rN_TRGeqU9IvTfm166GIvs5DWaWCKbnuxKq5JmMHLOXioRyCuMxNQ=s2500",
                        "chat_url": null,
                        "created_date": "2021-03-24T00:31:54.219565",
                        "default_to_fiat": false,
                        "description": "",
                        "dev_buyer_fee_basis_points": "0",
                        "dev_seller_fee_basis_points": "0",
                        "discord_url": null,
                        "display_data": {
                            "card_display_style": "contain",
                            "images": []
                        },
                        "external_url": null,
                        "featured": false,
                        "featured_image_url": null,
                        "hidden": true,
                        "safelist_request_status": "not_requested",
                        "image_url": "https://lh3.googleusercontent.com/qZRiTQMHRe5EswI1syqlf0Sf3sfY8bnZjtVhjn89Kh_RxfqZ1WBWTJBnyvnB-gJWsvr6-DsACvVxrPBsj5pSlecxj63iAcVfQTkD=s120",
                        "is_subject_to_whitelist": false,
                        "large_image_url": null,
                        "medium_username": null,
                        "name": "HiDef",
                        "only_proxied_transfers": false,
                        "opensea_buyer_fee_basis_points": "0",
                        "opensea_seller_fee_basis_points": "250",
                        "payout_address": null,
                        "require_email": false,
                        "short_description": null,
                        "slug": "hidef",
                        "telegram_url": null,
                        "twitter_username": null,
                        "instagram_username": null,
                        "wiki_url": null
                    },
                    "decimals": null,
                    "token_metadata": null
                },
                {
                    "id": 20424942,
                    "token_id": "70479185245472823933799012500856922265354379340922944019462782678488018059265",
                    "num_sales": 0,
                    "background_color": null,
                    "image_url": "https://lh3.googleusercontent.com/-_MLjwBQS5zs9B703Kja525eerpYnmmbne1V18ixw3DGO1Ltdgr82iI_GIoBcP3dfb75C9q7Glw5LAWFsCZRZroi7PxJS6ZDoptZGQ",
                    "image_preview_url": "https://lh3.googleusercontent.com/-_MLjwBQS5zs9B703Kja525eerpYnmmbne1V18ixw3DGO1Ltdgr82iI_GIoBcP3dfb75C9q7Glw5LAWFsCZRZroi7PxJS6ZDoptZGQ=s250",
                    "image_thumbnail_url": "https://lh3.googleusercontent.com/-_MLjwBQS5zs9B703Kja525eerpYnmmbne1V18ixw3DGO1Ltdgr82iI_GIoBcP3dfb75C9q7Glw5LAWFsCZRZroi7PxJS6ZDoptZGQ=s128",
                    "image_original_url": null,
                    "animation_url": null,
                    "animation_original_url": null,
                    "name": "Rick Fox",
                    "description": "Empathy / Telepathy 8 of 10",
                    "external_link": null,
                    "asset_contract": {
                        "address": "0x495f947276749ce646f68ac8c248420045cb7b5e",
                        "asset_contract_type": "semi-fungible",
                        "created_date": "2020-12-02T17:40:53.232025",
                        "name": "OpenSea Collection",
                        "nft_version": null,
                        "opensea_version": "2.0.0",
                        "owner": 102384,
                        "schema_name": "ERC1155",
                        "symbol": "OPENSTORE",
                        "total_supply": null,
                        "description": null,
                        "external_link": null,
                        "image_url": null,
                        "default_to_fiat": false,
                        "dev_buyer_fee_basis_points": 0,
                        "dev_seller_fee_basis_points": 0,
                        "only_proxied_transfers": false,
                        "opensea_buyer_fee_basis_points": 0,
                        "opensea_seller_fee_basis_points": 250,
                        "buyer_fee_basis_points": 0,
                        "seller_fee_basis_points": 250,
                        "payout_address": null
                    },
                    "owner": {
                        "user": {
                            "username": "NullAddress"
                        },
                        "profile_img_url": "https://storage.googleapis.com/opensea-static/opensea-profile/1.png",
                        "address": "0x0000000000000000000000000000000000000000",
                        "config": "",
                        "discord_id": ""
                    },
                    "permalink": "https://opensea.io/assets/0x495f947276749ce646f68ac8c248420045cb7b5e/70479185245472823933799012500856922265354379340922944019462782678488018059265",
                    "collection": {
                        "banner_image_url": "https://lh3.googleusercontent.com/i1dLTD9hXZSzeMGz02l202fkMjd3QQrZ2fCQ2TZt-ajo3L931rN_TRGeqU9IvTfm166GIvs5DWaWCKbnuxKq5JmMHLOXioRyCuMxNQ=s2500",
                        "chat_url": null,
                        "created_date": "2021-03-24T00:31:54.219565",
                        "default_to_fiat": false,
                        "description": "",
                        "dev_buyer_fee_basis_points": "0",
                        "dev_seller_fee_basis_points": "0",
                        "discord_url": null,
                        "display_data": {
                            "card_display_style": "contain",
                            "images": []
                        },
                        "external_url": null,
                        "featured": false,
                        "featured_image_url": null,
                        "hidden": true,
                        "safelist_request_status": "not_requested",
                        "image_url": "https://lh3.googleusercontent.com/qZRiTQMHRe5EswI1syqlf0Sf3sfY8bnZjtVhjn89Kh_RxfqZ1WBWTJBnyvnB-gJWsvr6-DsACvVxrPBsj5pSlecxj63iAcVfQTkD=s120",
                        "is_subject_to_whitelist": false,
                        "large_image_url": null,
                        "medium_username": null,
                        "name": "HiDef",
                        "only_proxied_transfers": false,
                        "opensea_buyer_fee_basis_points": "0",
                        "opensea_seller_fee_basis_points": "250",
                        "payout_address": null,
                        "require_email": false,
                        "short_description": null,
                        "slug": "hidef",
                        "telegram_url": null,
                        "twitter_username": null,
                        "instagram_username": null,
                        "wiki_url": null
                    },
                    "decimals": null,
                    "token_metadata": null
                },
                {
                    "id": 20424964,
                    "token_id": "70479185245472823933799012500856922265354379340922944019462782679587529687041",
                    "num_sales": 0,
                    "background_color": null,
                    "image_url": "https://lh3.googleusercontent.com/-_MLjwBQS5zs9B703Kja525eerpYnmmbne1V18ixw3DGO1Ltdgr82iI_GIoBcP3dfb75C9q7Glw5LAWFsCZRZroi7PxJS6ZDoptZGQ",
                    "image_preview_url": "https://lh3.googleusercontent.com/-_MLjwBQS5zs9B703Kja525eerpYnmmbne1V18ixw3DGO1Ltdgr82iI_GIoBcP3dfb75C9q7Glw5LAWFsCZRZroi7PxJS6ZDoptZGQ=s250",
                    "image_thumbnail_url": "https://lh3.googleusercontent.com/-_MLjwBQS5zs9B703Kja525eerpYnmmbne1V18ixw3DGO1Ltdgr82iI_GIoBcP3dfb75C9q7Glw5LAWFsCZRZroi7PxJS6ZDoptZGQ=s128",
                    "image_original_url": null,
                    "animation_url": null,
                    "animation_original_url": null,
                    "name": "Rick Fox",
                    "description": "Empathy / Telepathy 9 of 10",
                    "external_link": null,
                    "asset_contract": {
                        "address": "0x495f947276749ce646f68ac8c248420045cb7b5e",
                        "asset_contract_type": "semi-fungible",
                        "created_date": "2020-12-02T17:40:53.232025",
                        "name": "OpenSea Collection",
                        "nft_version": null,
                        "opensea_version": "2.0.0",
                        "owner": 102384,
                        "schema_name": "ERC1155",
                        "symbol": "OPENSTORE",
                        "total_supply": null,
                        "description": null,
                        "external_link": null,
                        "image_url": null,
                        "default_to_fiat": false,
                        "dev_buyer_fee_basis_points": 0,
                        "dev_seller_fee_basis_points": 0,
                        "only_proxied_transfers": false,
                        "opensea_buyer_fee_basis_points": 0,
                        "opensea_seller_fee_basis_points": 250,
                        "buyer_fee_basis_points": 0,
                        "seller_fee_basis_points": 250,
                        "payout_address": null
                    },
                    "owner": {
                        "user": {
                            "username": "NullAddress"
                        },
                        "profile_img_url": "https://storage.googleapis.com/opensea-static/opensea-profile/1.png",
                        "address": "0x0000000000000000000000000000000000000000",
                        "config": "",
                        "discord_id": ""
                    },
                    "permalink": "https://opensea.io/assets/0x495f947276749ce646f68ac8c248420045cb7b5e/70479185245472823933799012500856922265354379340922944019462782679587529687041",
                    "collection": {
                        "banner_image_url": "https://lh3.googleusercontent.com/i1dLTD9hXZSzeMGz02l202fkMjd3QQrZ2fCQ2TZt-ajo3L931rN_TRGeqU9IvTfm166GIvs5DWaWCKbnuxKq5JmMHLOXioRyCuMxNQ=s2500",
                        "chat_url": null,
                        "created_date": "2021-03-24T00:31:54.219565",
                        "default_to_fiat": false,
                        "description": "",
                        "dev_buyer_fee_basis_points": "0",
                        "dev_seller_fee_basis_points": "0",
                        "discord_url": null,
                        "display_data": {
                            "card_display_style": "contain",
                            "images": []
                        },
                        "external_url": null,
                        "featured": false,
                        "featured_image_url": null,
                        "hidden": true,
                        "safelist_request_status": "not_requested",
                        "image_url": "https://lh3.googleusercontent.com/qZRiTQMHRe5EswI1syqlf0Sf3sfY8bnZjtVhjn89Kh_RxfqZ1WBWTJBnyvnB-gJWsvr6-DsACvVxrPBsj5pSlecxj63iAcVfQTkD=s120",
                        "is_subject_to_whitelist": false,
                        "large_image_url": null,
                        "medium_username": null,
                        "name": "HiDef",
                        "only_proxied_transfers": false,
                        "opensea_buyer_fee_basis_points": "0",
                        "opensea_seller_fee_basis_points": "250",
                        "payout_address": null,
                        "require_email": false,
                        "short_description": null,
                        "slug": "hidef",
                        "telegram_url": null,
                        "twitter_username": null,
                        "instagram_username": null,
                        "wiki_url": null
                    },
                    "decimals": null,
                    "token_metadata": null
                },
                {
                    "id": 20424976,
                    "token_id": "70479185245472823933799012500856922265354379340922944019462782680687041314817",
                    "num_sales": 0,
                    "background_color": null,
                    "image_url": "https://lh3.googleusercontent.com/-_MLjwBQS5zs9B703Kja525eerpYnmmbne1V18ixw3DGO1Ltdgr82iI_GIoBcP3dfb75C9q7Glw5LAWFsCZRZroi7PxJS6ZDoptZGQ",
                    "image_preview_url": "https://lh3.googleusercontent.com/-_MLjwBQS5zs9B703Kja525eerpYnmmbne1V18ixw3DGO1Ltdgr82iI_GIoBcP3dfb75C9q7Glw5LAWFsCZRZroi7PxJS6ZDoptZGQ=s250",
                    "image_thumbnail_url": "https://lh3.googleusercontent.com/-_MLjwBQS5zs9B703Kja525eerpYnmmbne1V18ixw3DGO1Ltdgr82iI_GIoBcP3dfb75C9q7Glw5LAWFsCZRZroi7PxJS6ZDoptZGQ=s128",
                    "image_original_url": null,
                    "animation_url": null,
                    "animation_original_url": null,
                    "name": "Rick Fox",
                    "description": "Empathy / Telepathy 10 of 10",
                    "external_link": null,
                    "asset_contract": {
                        "address": "0x495f947276749ce646f68ac8c248420045cb7b5e",
                        "asset_contract_type": "semi-fungible",
                        "created_date": "2020-12-02T17:40:53.232025",
                        "name": "OpenSea Collection",
                        "nft_version": null,
                        "opensea_version": "2.0.0",
                        "owner": 102384,
                        "schema_name": "ERC1155",
                        "symbol": "OPENSTORE",
                        "total_supply": null,
                        "description": null,
                        "external_link": null,
                        "image_url": null,
                        "default_to_fiat": false,
                        "dev_buyer_fee_basis_points": 0,
                        "dev_seller_fee_basis_points": 0,
                        "only_proxied_transfers": false,
                        "opensea_buyer_fee_basis_points": 0,
                        "opensea_seller_fee_basis_points": 250,
                        "buyer_fee_basis_points": 0,
                        "seller_fee_basis_points": 250,
                        "payout_address": null
                    },
                    "owner": {
                        "user": {
                            "username": "NullAddress"
                        },
                        "profile_img_url": "https://storage.googleapis.com/opensea-static/opensea-profile/1.png",
                        "address": "0x0000000000000000000000000000000000000000",
                        "config": "",
                        "discord_id": ""
                    },
                    "permalink": "https://opensea.io/assets/0x495f947276749ce646f68ac8c248420045cb7b5e/70479185245472823933799012500856922265354379340922944019462782680687041314817",
                    "collection": {
                        "banner_image_url": "https://lh3.googleusercontent.com/i1dLTD9hXZSzeMGz02l202fkMjd3QQrZ2fCQ2TZt-ajo3L931rN_TRGeqU9IvTfm166GIvs5DWaWCKbnuxKq5JmMHLOXioRyCuMxNQ=s2500",
                        "chat_url": null,
                        "created_date": "2021-03-24T00:31:54.219565",
                        "default_to_fiat": false,
                        "description": "",
                        "dev_buyer_fee_basis_points": "0",
                        "dev_seller_fee_basis_points": "0",
                        "discord_url": null,
                        "display_data": {
                            "card_display_style": "contain",
                            "images": []
                        },
                        "external_url": null,
                        "featured": false,
                        "featured_image_url": null,
                        "hidden": true,
                        "safelist_request_status": "not_requested",
                        "image_url": "https://lh3.googleusercontent.com/qZRiTQMHRe5EswI1syqlf0Sf3sfY8bnZjtVhjn89Kh_RxfqZ1WBWTJBnyvnB-gJWsvr6-DsACvVxrPBsj5pSlecxj63iAcVfQTkD=s120",
                        "is_subject_to_whitelist": false,
                        "large_image_url": null,
                        "medium_username": null,
                        "name": "HiDef",
                        "only_proxied_transfers": false,
                        "opensea_buyer_fee_basis_points": "0",
                        "opensea_seller_fee_basis_points": "250",
                        "payout_address": null,
                        "require_email": false,
                        "short_description": null,
                        "slug": "hidef",
                        "telegram_url": null,
                        "twitter_username": null,
                        "instagram_username": null,
                        "wiki_url": null
                    },
                    "decimals": null,
                    "token_metadata": null
                },
                {
                    "id": 20425014,
                    "token_id": "70479185245472823933799012500856922265354379340922944019462782681786552942593",
                    "num_sales": 0,
                    "background_color": null,
                    "image_url": "https://lh3.googleusercontent.com/p990XGYbbPFsXgdDAsrei3AoNmkPEuH3ag23DPvy1fgpnrR4SJm3pyMf2-M0GB0M90bPrBG15Hx1UFSN35IQynYmJha_5JevDPb1AkU",
                    "image_preview_url": "https://lh3.googleusercontent.com/p990XGYbbPFsXgdDAsrei3AoNmkPEuH3ag23DPvy1fgpnrR4SJm3pyMf2-M0GB0M90bPrBG15Hx1UFSN35IQynYmJha_5JevDPb1AkU=s250",
                    "image_thumbnail_url": "https://lh3.googleusercontent.com/p990XGYbbPFsXgdDAsrei3AoNmkPEuH3ag23DPvy1fgpnrR4SJm3pyMf2-M0GB0M90bPrBG15Hx1UFSN35IQynYmJha_5JevDPb1AkU=s128",
                    "image_original_url": null,
                    "animation_url": null,
                    "animation_original_url": null,
                    "name": "Dr. David Washington",
                    "description": "Healing / The Force 1 of 10",
                    "external_link": null,
                    "asset_contract": {
                        "address": "0x495f947276749ce646f68ac8c248420045cb7b5e",
                        "asset_contract_type": "semi-fungible",
                        "created_date": "2020-12-02T17:40:53.232025",
                        "name": "OpenSea Collection",
                        "nft_version": null,
                        "opensea_version": "2.0.0",
                        "owner": 102384,
                        "schema_name": "ERC1155",
                        "symbol": "OPENSTORE",
                        "total_supply": null,
                        "description": null,
                        "external_link": null,
                        "image_url": null,
                        "default_to_fiat": false,
                        "dev_buyer_fee_basis_points": 0,
                        "dev_seller_fee_basis_points": 0,
                        "only_proxied_transfers": false,
                        "opensea_buyer_fee_basis_points": 0,
                        "opensea_seller_fee_basis_points": 250,
                        "buyer_fee_basis_points": 0,
                        "seller_fee_basis_points": 250,
                        "payout_address": null
                    },
                    "owner": {
                        "user": {
                            "username": "NullAddress"
                        },
                        "profile_img_url": "https://storage.googleapis.com/opensea-static/opensea-profile/1.png",
                        "address": "0x0000000000000000000000000000000000000000",
                        "config": "",
                        "discord_id": ""
                    },
                    "permalink": "https://opensea.io/assets/0x495f947276749ce646f68ac8c248420045cb7b5e/70479185245472823933799012500856922265354379340922944019462782681786552942593",
                    "collection": {
                        "banner_image_url": "https://lh3.googleusercontent.com/i1dLTD9hXZSzeMGz02l202fkMjd3QQrZ2fCQ2TZt-ajo3L931rN_TRGeqU9IvTfm166GIvs5DWaWCKbnuxKq5JmMHLOXioRyCuMxNQ=s2500",
                        "chat_url": null,
                        "created_date": "2021-03-24T00:31:54.219565",
                        "default_to_fiat": false,
                        "description": "",
                        "dev_buyer_fee_basis_points": "0",
                        "dev_seller_fee_basis_points": "0",
                        "discord_url": null,
                        "display_data": {
                            "card_display_style": "contain",
                            "images": []
                        },
                        "external_url": null,
                        "featured": false,
                        "featured_image_url": null,
                        "hidden": true,
                        "safelist_request_status": "not_requested",
                        "image_url": "https://lh3.googleusercontent.com/qZRiTQMHRe5EswI1syqlf0Sf3sfY8bnZjtVhjn89Kh_RxfqZ1WBWTJBnyvnB-gJWsvr6-DsACvVxrPBsj5pSlecxj63iAcVfQTkD=s120",
                        "is_subject_to_whitelist": false,
                        "large_image_url": null,
                        "medium_username": null,
                        "name": "HiDef",
                        "only_proxied_transfers": false,
                        "opensea_buyer_fee_basis_points": "0",
                        "opensea_seller_fee_basis_points": "250",
                        "payout_address": null,
                        "require_email": false,
                        "short_description": null,
                        "slug": "hidef",
                        "telegram_url": null,
                        "twitter_username": null,
                        "instagram_username": null,
                        "wiki_url": null
                    },
                    "decimals": null,
                    "token_metadata": null
                },
                {
                    "id": 20425036,
                    "token_id": "70479185245472823933799012500856922265354379340922944019462782682886064570369",
                    "num_sales": 0,
                    "background_color": null,
                    "image_url": "https://lh3.googleusercontent.com/p990XGYbbPFsXgdDAsrei3AoNmkPEuH3ag23DPvy1fgpnrR4SJm3pyMf2-M0GB0M90bPrBG15Hx1UFSN35IQynYmJha_5JevDPb1AkU",
                    "image_preview_url": "https://lh3.googleusercontent.com/p990XGYbbPFsXgdDAsrei3AoNmkPEuH3ag23DPvy1fgpnrR4SJm3pyMf2-M0GB0M90bPrBG15Hx1UFSN35IQynYmJha_5JevDPb1AkU=s250",
                    "image_thumbnail_url": "https://lh3.googleusercontent.com/p990XGYbbPFsXgdDAsrei3AoNmkPEuH3ag23DPvy1fgpnrR4SJm3pyMf2-M0GB0M90bPrBG15Hx1UFSN35IQynYmJha_5JevDPb1AkU=s128",
                    "image_original_url": null,
                    "animation_url": null,
                    "animation_original_url": null,
                    "name": "Dr. David Washington",
                    "description": "Healing / The Force 2 of 10",
                    "external_link": null,
                    "asset_contract": {
                        "address": "0x495f947276749ce646f68ac8c248420045cb7b5e",
                        "asset_contract_type": "semi-fungible",
                        "created_date": "2020-12-02T17:40:53.232025",
                        "name": "OpenSea Collection",
                        "nft_version": null,
                        "opensea_version": "2.0.0",
                        "owner": 102384,
                        "schema_name": "ERC1155",
                        "symbol": "OPENSTORE",
                        "total_supply": null,
                        "description": null,
                        "external_link": null,
                        "image_url": null,
                        "default_to_fiat": false,
                        "dev_buyer_fee_basis_points": 0,
                        "dev_seller_fee_basis_points": 0,
                        "only_proxied_transfers": false,
                        "opensea_buyer_fee_basis_points": 0,
                        "opensea_seller_fee_basis_points": 250,
                        "buyer_fee_basis_points": 0,
                        "seller_fee_basis_points": 250,
                        "payout_address": null
                    },
                    "owner": {
                        "user": {
                            "username": "NullAddress"
                        },
                        "profile_img_url": "https://storage.googleapis.com/opensea-static/opensea-profile/1.png",
                        "address": "0x0000000000000000000000000000000000000000",
                        "config": "",
                        "discord_id": ""
                    },
                    "permalink": "https://opensea.io/assets/0x495f947276749ce646f68ac8c248420045cb7b5e/70479185245472823933799012500856922265354379340922944019462782682886064570369",
                    "collection": {
                        "banner_image_url": "https://lh3.googleusercontent.com/i1dLTD9hXZSzeMGz02l202fkMjd3QQrZ2fCQ2TZt-ajo3L931rN_TRGeqU9IvTfm166GIvs5DWaWCKbnuxKq5JmMHLOXioRyCuMxNQ=s2500",
                        "chat_url": null,
                        "created_date": "2021-03-24T00:31:54.219565",
                        "default_to_fiat": false,
                        "description": "",
                        "dev_buyer_fee_basis_points": "0",
                        "dev_seller_fee_basis_points": "0",
                        "discord_url": null,
                        "display_data": {
                            "card_display_style": "contain",
                            "images": []
                        },
                        "external_url": null,
                        "featured": false,
                        "featured_image_url": null,
                        "hidden": true,
                        "safelist_request_status": "not_requested",
                        "image_url": "https://lh3.googleusercontent.com/qZRiTQMHRe5EswI1syqlf0Sf3sfY8bnZjtVhjn89Kh_RxfqZ1WBWTJBnyvnB-gJWsvr6-DsACvVxrPBsj5pSlecxj63iAcVfQTkD=s120",
                        "is_subject_to_whitelist": false,
                        "large_image_url": null,
                        "medium_username": null,
                        "name": "HiDef",
                        "only_proxied_transfers": false,
                        "opensea_buyer_fee_basis_points": "0",
                        "opensea_seller_fee_basis_points": "250",
                        "payout_address": null,
                        "require_email": false,
                        "short_description": null,
                        "slug": "hidef",
                        "telegram_url": null,
                        "twitter_username": null,
                        "instagram_username": null,
                        "wiki_url": null
                    },
                    "decimals": null,
                    "token_metadata": null
                },
                {
                    "id": 20425055,
                    "token_id": "70479185245472823933799012500856922265354379340922944019462782683985576198145",
                    "num_sales": 0,
                    "background_color": null,
                    "image_url": "https://lh3.googleusercontent.com/p990XGYbbPFsXgdDAsrei3AoNmkPEuH3ag23DPvy1fgpnrR4SJm3pyMf2-M0GB0M90bPrBG15Hx1UFSN35IQynYmJha_5JevDPb1AkU",
                    "image_preview_url": "https://lh3.googleusercontent.com/p990XGYbbPFsXgdDAsrei3AoNmkPEuH3ag23DPvy1fgpnrR4SJm3pyMf2-M0GB0M90bPrBG15Hx1UFSN35IQynYmJha_5JevDPb1AkU=s250",
                    "image_thumbnail_url": "https://lh3.googleusercontent.com/p990XGYbbPFsXgdDAsrei3AoNmkPEuH3ag23DPvy1fgpnrR4SJm3pyMf2-M0GB0M90bPrBG15Hx1UFSN35IQynYmJha_5JevDPb1AkU=s128",
                    "image_original_url": null,
                    "animation_url": null,
                    "animation_original_url": null,
                    "name": "Dr. David Washington",
                    "description": "Healing / The Force 3 of 10",
                    "external_link": null,
                    "asset_contract": {
                        "address": "0x495f947276749ce646f68ac8c248420045cb7b5e",
                        "asset_contract_type": "semi-fungible",
                        "created_date": "2020-12-02T17:40:53.232025",
                        "name": "OpenSea Collection",
                        "nft_version": null,
                        "opensea_version": "2.0.0",
                        "owner": 102384,
                        "schema_name": "ERC1155",
                        "symbol": "OPENSTORE",
                        "total_supply": null,
                        "description": null,
                        "external_link": null,
                        "image_url": null,
                        "default_to_fiat": false,
                        "dev_buyer_fee_basis_points": 0,
                        "dev_seller_fee_basis_points": 0,
                        "only_proxied_transfers": false,
                        "opensea_buyer_fee_basis_points": 0,
                        "opensea_seller_fee_basis_points": 250,
                        "buyer_fee_basis_points": 0,
                        "seller_fee_basis_points": 250,
                        "payout_address": null
                    },
                    "owner": {
                        "user": {
                            "username": "NullAddress"
                        },
                        "profile_img_url": "https://storage.googleapis.com/opensea-static/opensea-profile/1.png",
                        "address": "0x0000000000000000000000000000000000000000",
                        "config": "",
                        "discord_id": ""
                    },
                    "permalink": "https://opensea.io/assets/0x495f947276749ce646f68ac8c248420045cb7b5e/70479185245472823933799012500856922265354379340922944019462782683985576198145",
                    "collection": {
                        "banner_image_url": "https://lh3.googleusercontent.com/i1dLTD9hXZSzeMGz02l202fkMjd3QQrZ2fCQ2TZt-ajo3L931rN_TRGeqU9IvTfm166GIvs5DWaWCKbnuxKq5JmMHLOXioRyCuMxNQ=s2500",
                        "chat_url": null,
                        "created_date": "2021-03-24T00:31:54.219565",
                        "default_to_fiat": false,
                        "description": "",
                        "dev_buyer_fee_basis_points": "0",
                        "dev_seller_fee_basis_points": "0",
                        "discord_url": null,
                        "display_data": {
                            "card_display_style": "contain",
                            "images": []
                        },
                        "external_url": null,
                        "featured": false,
                        "featured_image_url": null,
                        "hidden": true,
                        "safelist_request_status": "not_requested",
                        "image_url": "https://lh3.googleusercontent.com/qZRiTQMHRe5EswI1syqlf0Sf3sfY8bnZjtVhjn89Kh_RxfqZ1WBWTJBnyvnB-gJWsvr6-DsACvVxrPBsj5pSlecxj63iAcVfQTkD=s120",
                        "is_subject_to_whitelist": false,
                        "large_image_url": null,
                        "medium_username": null,
                        "name": "HiDef",
                        "only_proxied_transfers": false,
                        "opensea_buyer_fee_basis_points": "0",
                        "opensea_seller_fee_basis_points": "250",
                        "payout_address": null,
                        "require_email": false,
                        "short_description": null,
                        "slug": "hidef",
                        "telegram_url": null,
                        "twitter_username": null,
                        "instagram_username": null,
                        "wiki_url": null
                    },
                    "decimals": null,
                    "token_metadata": null
                },
                {
                    "id": 20425072,
                    "token_id": "70479185245472823933799012500856922265354379340922944019462782685085087825921",
                    "num_sales": 0,
                    "background_color": null,
                    "image_url": "https://lh3.googleusercontent.com/p990XGYbbPFsXgdDAsrei3AoNmkPEuH3ag23DPvy1fgpnrR4SJm3pyMf2-M0GB0M90bPrBG15Hx1UFSN35IQynYmJha_5JevDPb1AkU",
                    "image_preview_url": "https://lh3.googleusercontent.com/p990XGYbbPFsXgdDAsrei3AoNmkPEuH3ag23DPvy1fgpnrR4SJm3pyMf2-M0GB0M90bPrBG15Hx1UFSN35IQynYmJha_5JevDPb1AkU=s250",
                    "image_thumbnail_url": "https://lh3.googleusercontent.com/p990XGYbbPFsXgdDAsrei3AoNmkPEuH3ag23DPvy1fgpnrR4SJm3pyMf2-M0GB0M90bPrBG15Hx1UFSN35IQynYmJha_5JevDPb1AkU=s128",
                    "image_original_url": null,
                    "animation_url": null,
                    "animation_original_url": null,
                    "name": "Dr. David Washington",
                    "description": "Healing / The Force 4 of 10",
                    "external_link": null,
                    "asset_contract": {
                        "address": "0x495f947276749ce646f68ac8c248420045cb7b5e",
                        "asset_contract_type": "semi-fungible",
                        "created_date": "2020-12-02T17:40:53.232025",
                        "name": "OpenSea Collection",
                        "nft_version": null,
                        "opensea_version": "2.0.0",
                        "owner": 102384,
                        "schema_name": "ERC1155",
                        "symbol": "OPENSTORE",
                        "total_supply": null,
                        "description": null,
                        "external_link": null,
                        "image_url": null,
                        "default_to_fiat": false,
                        "dev_buyer_fee_basis_points": 0,
                        "dev_seller_fee_basis_points": 0,
                        "only_proxied_transfers": false,
                        "opensea_buyer_fee_basis_points": 0,
                        "opensea_seller_fee_basis_points": 250,
                        "buyer_fee_basis_points": 0,
                        "seller_fee_basis_points": 250,
                        "payout_address": null
                    },
                    "owner": {
                        "user": {
                            "username": "NullAddress"
                        },
                        "profile_img_url": "https://storage.googleapis.com/opensea-static/opensea-profile/1.png",
                        "address": "0x0000000000000000000000000000000000000000",
                        "config": "",
                        "discord_id": ""
                    },
                    "permalink": "https://opensea.io/assets/0x495f947276749ce646f68ac8c248420045cb7b5e/70479185245472823933799012500856922265354379340922944019462782685085087825921",
                    "collection": {
                        "banner_image_url": "https://lh3.googleusercontent.com/i1dLTD9hXZSzeMGz02l202fkMjd3QQrZ2fCQ2TZt-ajo3L931rN_TRGeqU9IvTfm166GIvs5DWaWCKbnuxKq5JmMHLOXioRyCuMxNQ=s2500",
                        "chat_url": null,
                        "created_date": "2021-03-24T00:31:54.219565",
                        "default_to_fiat": false,
                        "description": "",
                        "dev_buyer_fee_basis_points": "0",
                        "dev_seller_fee_basis_points": "0",
                        "discord_url": null,
                        "display_data": {
                            "card_display_style": "contain",
                            "images": []
                        },
                        "external_url": null,
                        "featured": false,
                        "featured_image_url": null,
                        "hidden": true,
                        "safelist_request_status": "not_requested",
                        "image_url": "https://lh3.googleusercontent.com/qZRiTQMHRe5EswI1syqlf0Sf3sfY8bnZjtVhjn89Kh_RxfqZ1WBWTJBnyvnB-gJWsvr6-DsACvVxrPBsj5pSlecxj63iAcVfQTkD=s120",
                        "is_subject_to_whitelist": false,
                        "large_image_url": null,
                        "medium_username": null,
                        "name": "HiDef",
                        "only_proxied_transfers": false,
                        "opensea_buyer_fee_basis_points": "0",
                        "opensea_seller_fee_basis_points": "250",
                        "payout_address": null,
                        "require_email": false,
                        "short_description": null,
                        "slug": "hidef",
                        "telegram_url": null,
                        "twitter_username": null,
                        "instagram_username": null,
                        "wiki_url": null
                    },
                    "decimals": null,
                    "token_metadata": null
                },
                {
                    "id": 20425085,
                    "token_id": "70479185245472823933799012500856922265354379340922944019462782686184599453697",
                    "num_sales": 0,
                    "background_color": null,
                    "image_url": "https://lh3.googleusercontent.com/p990XGYbbPFsXgdDAsrei3AoNmkPEuH3ag23DPvy1fgpnrR4SJm3pyMf2-M0GB0M90bPrBG15Hx1UFSN35IQynYmJha_5JevDPb1AkU",
                    "image_preview_url": "https://lh3.googleusercontent.com/p990XGYbbPFsXgdDAsrei3AoNmkPEuH3ag23DPvy1fgpnrR4SJm3pyMf2-M0GB0M90bPrBG15Hx1UFSN35IQynYmJha_5JevDPb1AkU=s250",
                    "image_thumbnail_url": "https://lh3.googleusercontent.com/p990XGYbbPFsXgdDAsrei3AoNmkPEuH3ag23DPvy1fgpnrR4SJm3pyMf2-M0GB0M90bPrBG15Hx1UFSN35IQynYmJha_5JevDPb1AkU=s128",
                    "image_original_url": null,
                    "animation_url": null,
                    "animation_original_url": null,
                    "name": "Dr. David Washington",
                    "description": "Healing / The Force 5 of 10",
                    "external_link": null,
                    "asset_contract": {
                        "address": "0x495f947276749ce646f68ac8c248420045cb7b5e",
                        "asset_contract_type": "semi-fungible",
                        "created_date": "2020-12-02T17:40:53.232025",
                        "name": "OpenSea Collection",
                        "nft_version": null,
                        "opensea_version": "2.0.0",
                        "owner": 102384,
                        "schema_name": "ERC1155",
                        "symbol": "OPENSTORE",
                        "total_supply": null,
                        "description": null,
                        "external_link": null,
                        "image_url": null,
                        "default_to_fiat": false,
                        "dev_buyer_fee_basis_points": 0,
                        "dev_seller_fee_basis_points": 0,
                        "only_proxied_transfers": false,
                        "opensea_buyer_fee_basis_points": 0,
                        "opensea_seller_fee_basis_points": 250,
                        "buyer_fee_basis_points": 0,
                        "seller_fee_basis_points": 250,
                        "payout_address": null
                    },
                    "owner": {
                        "user": {
                            "username": "NullAddress"
                        },
                        "profile_img_url": "https://storage.googleapis.com/opensea-static/opensea-profile/1.png",
                        "address": "0x0000000000000000000000000000000000000000",
                        "config": "",
                        "discord_id": ""
                    },
                    "permalink": "https://opensea.io/assets/0x495f947276749ce646f68ac8c248420045cb7b5e/70479185245472823933799012500856922265354379340922944019462782686184599453697",
                    "collection": {
                        "banner_image_url": "https://lh3.googleusercontent.com/i1dLTD9hXZSzeMGz02l202fkMjd3QQrZ2fCQ2TZt-ajo3L931rN_TRGeqU9IvTfm166GIvs5DWaWCKbnuxKq5JmMHLOXioRyCuMxNQ=s2500",
                        "chat_url": null,
                        "created_date": "2021-03-24T00:31:54.219565",
                        "default_to_fiat": false,
                        "description": "",
                        "dev_buyer_fee_basis_points": "0",
                        "dev_seller_fee_basis_points": "0",
                        "discord_url": null,
                        "display_data": {
                            "card_display_style": "contain",
                            "images": []
                        },
                        "external_url": null,
                        "featured": false,
                        "featured_image_url": null,
                        "hidden": true,
                        "safelist_request_status": "not_requested",
                        "image_url": "https://lh3.googleusercontent.com/qZRiTQMHRe5EswI1syqlf0Sf3sfY8bnZjtVhjn89Kh_RxfqZ1WBWTJBnyvnB-gJWsvr6-DsACvVxrPBsj5pSlecxj63iAcVfQTkD=s120",
                        "is_subject_to_whitelist": false,
                        "large_image_url": null,
                        "medium_username": null,
                        "name": "HiDef",
                        "only_proxied_transfers": false,
                        "opensea_buyer_fee_basis_points": "0",
                        "opensea_seller_fee_basis_points": "250",
                        "payout_address": null,
                        "require_email": false,
                        "short_description": null,
                        "slug": "hidef",
                        "telegram_url": null,
                        "twitter_username": null,
                        "instagram_username": null,
                        "wiki_url": null
                    },
                    "decimals": null,
                    "token_metadata": null
                },
                {
                    "id": 20425106,
                    "token_id": "70479185245472823933799012500856922265354379340922944019462782687284111081473",
                    "num_sales": 0,
                    "background_color": null,
                    "image_url": "https://lh3.googleusercontent.com/p990XGYbbPFsXgdDAsrei3AoNmkPEuH3ag23DPvy1fgpnrR4SJm3pyMf2-M0GB0M90bPrBG15Hx1UFSN35IQynYmJha_5JevDPb1AkU",
                    "image_preview_url": "https://lh3.googleusercontent.com/p990XGYbbPFsXgdDAsrei3AoNmkPEuH3ag23DPvy1fgpnrR4SJm3pyMf2-M0GB0M90bPrBG15Hx1UFSN35IQynYmJha_5JevDPb1AkU=s250",
                    "image_thumbnail_url": "https://lh3.googleusercontent.com/p990XGYbbPFsXgdDAsrei3AoNmkPEuH3ag23DPvy1fgpnrR4SJm3pyMf2-M0GB0M90bPrBG15Hx1UFSN35IQynYmJha_5JevDPb1AkU=s128",
                    "image_original_url": null,
                    "animation_url": null,
                    "animation_original_url": null,
                    "name": "Dr. David Washington",
                    "description": "Healing / The Force 6 of 10",
                    "external_link": null,
                    "asset_contract": {
                        "address": "0x495f947276749ce646f68ac8c248420045cb7b5e",
                        "asset_contract_type": "semi-fungible",
                        "created_date": "2020-12-02T17:40:53.232025",
                        "name": "OpenSea Collection",
                        "nft_version": null,
                        "opensea_version": "2.0.0",
                        "owner": 102384,
                        "schema_name": "ERC1155",
                        "symbol": "OPENSTORE",
                        "total_supply": null,
                        "description": null,
                        "external_link": null,
                        "image_url": null,
                        "default_to_fiat": false,
                        "dev_buyer_fee_basis_points": 0,
                        "dev_seller_fee_basis_points": 0,
                        "only_proxied_transfers": false,
                        "opensea_buyer_fee_basis_points": 0,
                        "opensea_seller_fee_basis_points": 250,
                        "buyer_fee_basis_points": 0,
                        "seller_fee_basis_points": 250,
                        "payout_address": null
                    },
                    "owner": {
                        "user": {
                            "username": "NullAddress"
                        },
                        "profile_img_url": "https://storage.googleapis.com/opensea-static/opensea-profile/1.png",
                        "address": "0x0000000000000000000000000000000000000000",
                        "config": "",
                        "discord_id": ""
                    },
                    "permalink": "https://opensea.io/assets/0x495f947276749ce646f68ac8c248420045cb7b5e/70479185245472823933799012500856922265354379340922944019462782687284111081473",
                    "collection": {
                        "banner_image_url": "https://lh3.googleusercontent.com/i1dLTD9hXZSzeMGz02l202fkMjd3QQrZ2fCQ2TZt-ajo3L931rN_TRGeqU9IvTfm166GIvs5DWaWCKbnuxKq5JmMHLOXioRyCuMxNQ=s2500",
                        "chat_url": null,
                        "created_date": "2021-03-24T00:31:54.219565",
                        "default_to_fiat": false,
                        "description": "",
                        "dev_buyer_fee_basis_points": "0",
                        "dev_seller_fee_basis_points": "0",
                        "discord_url": null,
                        "display_data": {
                            "card_display_style": "contain",
                            "images": []
                        },
                        "external_url": null,
                        "featured": false,
                        "featured_image_url": null,
                        "hidden": true,
                        "safelist_request_status": "not_requested",
                        "image_url": "https://lh3.googleusercontent.com/qZRiTQMHRe5EswI1syqlf0Sf3sfY8bnZjtVhjn89Kh_RxfqZ1WBWTJBnyvnB-gJWsvr6-DsACvVxrPBsj5pSlecxj63iAcVfQTkD=s120",
                        "is_subject_to_whitelist": false,
                        "large_image_url": null,
                        "medium_username": null,
                        "name": "HiDef",
                        "only_proxied_transfers": false,
                        "opensea_buyer_fee_basis_points": "0",
                        "opensea_seller_fee_basis_points": "250",
                        "payout_address": null,
                        "require_email": false,
                        "short_description": null,
                        "slug": "hidef",
                        "telegram_url": null,
                        "twitter_username": null,
                        "instagram_username": null,
                        "wiki_url": null
                    },
                    "decimals": null,
                    "token_metadata": null
                },
                {
                    "id": 20425123,
                    "token_id": "70479185245472823933799012500856922265354379340922944019462782688383622709249",
                    "num_sales": 0,
                    "background_color": null,
                    "image_url": "https://lh3.googleusercontent.com/p990XGYbbPFsXgdDAsrei3AoNmkPEuH3ag23DPvy1fgpnrR4SJm3pyMf2-M0GB0M90bPrBG15Hx1UFSN35IQynYmJha_5JevDPb1AkU",
                    "image_preview_url": "https://lh3.googleusercontent.com/p990XGYbbPFsXgdDAsrei3AoNmkPEuH3ag23DPvy1fgpnrR4SJm3pyMf2-M0GB0M90bPrBG15Hx1UFSN35IQynYmJha_5JevDPb1AkU=s250",
                    "image_thumbnail_url": "https://lh3.googleusercontent.com/p990XGYbbPFsXgdDAsrei3AoNmkPEuH3ag23DPvy1fgpnrR4SJm3pyMf2-M0GB0M90bPrBG15Hx1UFSN35IQynYmJha_5JevDPb1AkU=s128",
                    "image_original_url": null,
                    "animation_url": null,
                    "animation_original_url": null,
                    "name": "Dr. David Washington",
                    "description": "Healing / The Force 7 of 10",
                    "external_link": null,
                    "asset_contract": {
                        "address": "0x495f947276749ce646f68ac8c248420045cb7b5e",
                        "asset_contract_type": "semi-fungible",
                        "created_date": "2020-12-02T17:40:53.232025",
                        "name": "OpenSea Collection",
                        "nft_version": null,
                        "opensea_version": "2.0.0",
                        "owner": 102384,
                        "schema_name": "ERC1155",
                        "symbol": "OPENSTORE",
                        "total_supply": null,
                        "description": null,
                        "external_link": null,
                        "image_url": null,
                        "default_to_fiat": false,
                        "dev_buyer_fee_basis_points": 0,
                        "dev_seller_fee_basis_points": 0,
                        "only_proxied_transfers": false,
                        "opensea_buyer_fee_basis_points": 0,
                        "opensea_seller_fee_basis_points": 250,
                        "buyer_fee_basis_points": 0,
                        "seller_fee_basis_points": 250,
                        "payout_address": null
                    },
                    "owner": {
                        "user": {
                            "username": "NullAddress"
                        },
                        "profile_img_url": "https://storage.googleapis.com/opensea-static/opensea-profile/1.png",
                        "address": "0x0000000000000000000000000000000000000000",
                        "config": "",
                        "discord_id": ""
                    },
                    "permalink": "https://opensea.io/assets/0x495f947276749ce646f68ac8c248420045cb7b5e/70479185245472823933799012500856922265354379340922944019462782688383622709249",
                    "collection": {
                        "banner_image_url": "https://lh3.googleusercontent.com/i1dLTD9hXZSzeMGz02l202fkMjd3QQrZ2fCQ2TZt-ajo3L931rN_TRGeqU9IvTfm166GIvs5DWaWCKbnuxKq5JmMHLOXioRyCuMxNQ=s2500",
                        "chat_url": null,
                        "created_date": "2021-03-24T00:31:54.219565",
                        "default_to_fiat": false,
                        "description": "",
                        "dev_buyer_fee_basis_points": "0",
                        "dev_seller_fee_basis_points": "0",
                        "discord_url": null,
                        "display_data": {
                            "card_display_style": "contain",
                            "images": []
                        },
                        "external_url": null,
                        "featured": false,
                        "featured_image_url": null,
                        "hidden": true,
                        "safelist_request_status": "not_requested",
                        "image_url": "https://lh3.googleusercontent.com/qZRiTQMHRe5EswI1syqlf0Sf3sfY8bnZjtVhjn89Kh_RxfqZ1WBWTJBnyvnB-gJWsvr6-DsACvVxrPBsj5pSlecxj63iAcVfQTkD=s120",
                        "is_subject_to_whitelist": false,
                        "large_image_url": null,
                        "medium_username": null,
                        "name": "HiDef",
                        "only_proxied_transfers": false,
                        "opensea_buyer_fee_basis_points": "0",
                        "opensea_seller_fee_basis_points": "250",
                        "payout_address": null,
                        "require_email": false,
                        "short_description": null,
                        "slug": "hidef",
                        "telegram_url": null,
                        "twitter_username": null,
                        "instagram_username": null,
                        "wiki_url": null
                    },
                    "decimals": null,
                    "token_metadata": null
                },
                {
                    "id": 20425143,
                    "token_id": "70479185245472823933799012500856922265354379340922944019462782689483134337025",
                    "num_sales": 0,
                    "background_color": null,
                    "image_url": "https://lh3.googleusercontent.com/p990XGYbbPFsXgdDAsrei3AoNmkPEuH3ag23DPvy1fgpnrR4SJm3pyMf2-M0GB0M90bPrBG15Hx1UFSN35IQynYmJha_5JevDPb1AkU",
                    "image_preview_url": "https://lh3.googleusercontent.com/p990XGYbbPFsXgdDAsrei3AoNmkPEuH3ag23DPvy1fgpnrR4SJm3pyMf2-M0GB0M90bPrBG15Hx1UFSN35IQynYmJha_5JevDPb1AkU=s250",
                    "image_thumbnail_url": "https://lh3.googleusercontent.com/p990XGYbbPFsXgdDAsrei3AoNmkPEuH3ag23DPvy1fgpnrR4SJm3pyMf2-M0GB0M90bPrBG15Hx1UFSN35IQynYmJha_5JevDPb1AkU=s128",
                    "image_original_url": null,
                    "animation_url": null,
                    "animation_original_url": null,
                    "name": "Dr. David Washington",
                    "description": "Healing / The Force 8 of 10",
                    "external_link": null,
                    "asset_contract": {
                        "address": "0x495f947276749ce646f68ac8c248420045cb7b5e",
                        "asset_contract_type": "semi-fungible",
                        "created_date": "2020-12-02T17:40:53.232025",
                        "name": "OpenSea Collection",
                        "nft_version": null,
                        "opensea_version": "2.0.0",
                        "owner": 102384,
                        "schema_name": "ERC1155",
                        "symbol": "OPENSTORE",
                        "total_supply": null,
                        "description": null,
                        "external_link": null,
                        "image_url": null,
                        "default_to_fiat": false,
                        "dev_buyer_fee_basis_points": 0,
                        "dev_seller_fee_basis_points": 0,
                        "only_proxied_transfers": false,
                        "opensea_buyer_fee_basis_points": 0,
                        "opensea_seller_fee_basis_points": 250,
                        "buyer_fee_basis_points": 0,
                        "seller_fee_basis_points": 250,
                        "payout_address": null
                    },
                    "owner": {
                        "user": {
                            "username": "NullAddress"
                        },
                        "profile_img_url": "https://storage.googleapis.com/opensea-static/opensea-profile/1.png",
                        "address": "0x0000000000000000000000000000000000000000",
                        "config": "",
                        "discord_id": ""
                    },
                    "permalink": "https://opensea.io/assets/0x495f947276749ce646f68ac8c248420045cb7b5e/70479185245472823933799012500856922265354379340922944019462782689483134337025",
                    "collection": {
                        "banner_image_url": "https://lh3.googleusercontent.com/i1dLTD9hXZSzeMGz02l202fkMjd3QQrZ2fCQ2TZt-ajo3L931rN_TRGeqU9IvTfm166GIvs5DWaWCKbnuxKq5JmMHLOXioRyCuMxNQ=s2500",
                        "chat_url": null,
                        "created_date": "2021-03-24T00:31:54.219565",
                        "default_to_fiat": false,
                        "description": "",
                        "dev_buyer_fee_basis_points": "0",
                        "dev_seller_fee_basis_points": "0",
                        "discord_url": null,
                        "display_data": {
                            "card_display_style": "contain",
                            "images": []
                        },
                        "external_url": null,
                        "featured": false,
                        "featured_image_url": null,
                        "hidden": true,
                        "safelist_request_status": "not_requested",
                        "image_url": "https://lh3.googleusercontent.com/qZRiTQMHRe5EswI1syqlf0Sf3sfY8bnZjtVhjn89Kh_RxfqZ1WBWTJBnyvnB-gJWsvr6-DsACvVxrPBsj5pSlecxj63iAcVfQTkD=s120",
                        "is_subject_to_whitelist": false,
                        "large_image_url": null,
                        "medium_username": null,
                        "name": "HiDef",
                        "only_proxied_transfers": false,
                        "opensea_buyer_fee_basis_points": "0",
                        "opensea_seller_fee_basis_points": "250",
                        "payout_address": null,
                        "require_email": false,
                        "short_description": null,
                        "slug": "hidef",
                        "telegram_url": null,
                        "twitter_username": null,
                        "instagram_username": null,
                        "wiki_url": null
                    },
                    "decimals": null,
                    "token_metadata": null
                },
                {
                    "id": 20425159,
                    "token_id": "70479185245472823933799012500856922265354379340922944019462782690582645964801",
                    "num_sales": 0,
                    "background_color": null,
                    "image_url": "https://lh3.googleusercontent.com/p990XGYbbPFsXgdDAsrei3AoNmkPEuH3ag23DPvy1fgpnrR4SJm3pyMf2-M0GB0M90bPrBG15Hx1UFSN35IQynYmJha_5JevDPb1AkU",
                    "image_preview_url": "https://lh3.googleusercontent.com/p990XGYbbPFsXgdDAsrei3AoNmkPEuH3ag23DPvy1fgpnrR4SJm3pyMf2-M0GB0M90bPrBG15Hx1UFSN35IQynYmJha_5JevDPb1AkU=s250",
                    "image_thumbnail_url": "https://lh3.googleusercontent.com/p990XGYbbPFsXgdDAsrei3AoNmkPEuH3ag23DPvy1fgpnrR4SJm3pyMf2-M0GB0M90bPrBG15Hx1UFSN35IQynYmJha_5JevDPb1AkU=s128",
                    "image_original_url": null,
                    "animation_url": null,
                    "animation_original_url": null,
                    "name": "Dr. David Washington",
                    "description": "Healing / The Force 9 of 10",
                    "external_link": null,
                    "asset_contract": {
                        "address": "0x495f947276749ce646f68ac8c248420045cb7b5e",
                        "asset_contract_type": "semi-fungible",
                        "created_date": "2020-12-02T17:40:53.232025",
                        "name": "OpenSea Collection",
                        "nft_version": null,
                        "opensea_version": "2.0.0",
                        "owner": 102384,
                        "schema_name": "ERC1155",
                        "symbol": "OPENSTORE",
                        "total_supply": null,
                        "description": null,
                        "external_link": null,
                        "image_url": null,
                        "default_to_fiat": false,
                        "dev_buyer_fee_basis_points": 0,
                        "dev_seller_fee_basis_points": 0,
                        "only_proxied_transfers": false,
                        "opensea_buyer_fee_basis_points": 0,
                        "opensea_seller_fee_basis_points": 250,
                        "buyer_fee_basis_points": 0,
                        "seller_fee_basis_points": 250,
                        "payout_address": null
                    },
                    "owner": {
                        "user": {
                            "username": "NullAddress"
                        },
                        "profile_img_url": "https://storage.googleapis.com/opensea-static/opensea-profile/1.png",
                        "address": "0x0000000000000000000000000000000000000000",
                        "config": "",
                        "discord_id": ""
                    },
                    "permalink": "https://opensea.io/assets/0x495f947276749ce646f68ac8c248420045cb7b5e/70479185245472823933799012500856922265354379340922944019462782690582645964801",
                    "collection": {
                        "banner_image_url": "https://lh3.googleusercontent.com/i1dLTD9hXZSzeMGz02l202fkMjd3QQrZ2fCQ2TZt-ajo3L931rN_TRGeqU9IvTfm166GIvs5DWaWCKbnuxKq5JmMHLOXioRyCuMxNQ=s2500",
                        "chat_url": null,
                        "created_date": "2021-03-24T00:31:54.219565",
                        "default_to_fiat": false,
                        "description": "",
                        "dev_buyer_fee_basis_points": "0",
                        "dev_seller_fee_basis_points": "0",
                        "discord_url": null,
                        "display_data": {
                            "card_display_style": "contain",
                            "images": []
                        },
                        "external_url": null,
                        "featured": false,
                        "featured_image_url": null,
                        "hidden": true,
                        "safelist_request_status": "not_requested",
                        "image_url": "https://lh3.googleusercontent.com/qZRiTQMHRe5EswI1syqlf0Sf3sfY8bnZjtVhjn89Kh_RxfqZ1WBWTJBnyvnB-gJWsvr6-DsACvVxrPBsj5pSlecxj63iAcVfQTkD=s120",
                        "is_subject_to_whitelist": false,
                        "large_image_url": null,
                        "medium_username": null,
                        "name": "HiDef",
                        "only_proxied_transfers": false,
                        "opensea_buyer_fee_basis_points": "0",
                        "opensea_seller_fee_basis_points": "250",
                        "payout_address": null,
                        "require_email": false,
                        "short_description": null,
                        "slug": "hidef",
                        "telegram_url": null,
                        "twitter_username": null,
                        "instagram_username": null,
                        "wiki_url": null
                    },
                    "decimals": null,
                    "token_metadata": null
                },
                {
                    "id": 20425175,
                    "token_id": "70479185245472823933799012500856922265354379340922944019462782691682157592577",
                    "num_sales": 0,
                    "background_color": null,
                    "image_url": "https://lh3.googleusercontent.com/p990XGYbbPFsXgdDAsrei3AoNmkPEuH3ag23DPvy1fgpnrR4SJm3pyMf2-M0GB0M90bPrBG15Hx1UFSN35IQynYmJha_5JevDPb1AkU",
                    "image_preview_url": "https://lh3.googleusercontent.com/p990XGYbbPFsXgdDAsrei3AoNmkPEuH3ag23DPvy1fgpnrR4SJm3pyMf2-M0GB0M90bPrBG15Hx1UFSN35IQynYmJha_5JevDPb1AkU=s250",
                    "image_thumbnail_url": "https://lh3.googleusercontent.com/p990XGYbbPFsXgdDAsrei3AoNmkPEuH3ag23DPvy1fgpnrR4SJm3pyMf2-M0GB0M90bPrBG15Hx1UFSN35IQynYmJha_5JevDPb1AkU=s128",
                    "image_original_url": null,
                    "animation_url": null,
                    "animation_original_url": null,
                    "name": "Dr. David Washington",
                    "description": "Healing / The Force 10 of 10",
                    "external_link": null,
                    "asset_contract": {
                        "address": "0x495f947276749ce646f68ac8c248420045cb7b5e",
                        "asset_contract_type": "semi-fungible",
                        "created_date": "2020-12-02T17:40:53.232025",
                        "name": "OpenSea Collection",
                        "nft_version": null,
                        "opensea_version": "2.0.0",
                        "owner": 102384,
                        "schema_name": "ERC1155",
                        "symbol": "OPENSTORE",
                        "total_supply": null,
                        "description": null,
                        "external_link": null,
                        "image_url": null,
                        "default_to_fiat": false,
                        "dev_buyer_fee_basis_points": 0,
                        "dev_seller_fee_basis_points": 0,
                        "only_proxied_transfers": false,
                        "opensea_buyer_fee_basis_points": 0,
                        "opensea_seller_fee_basis_points": 250,
                        "buyer_fee_basis_points": 0,
                        "seller_fee_basis_points": 250,
                        "payout_address": null
                    },
                    "owner": {
                        "user": {
                            "username": "NullAddress"
                        },
                        "profile_img_url": "https://storage.googleapis.com/opensea-static/opensea-profile/1.png",
                        "address": "0x0000000000000000000000000000000000000000",
                        "config": "",
                        "discord_id": ""
                    },
                    "permalink": "https://opensea.io/assets/0x495f947276749ce646f68ac8c248420045cb7b5e/70479185245472823933799012500856922265354379340922944019462782691682157592577",
                    "collection": {
                        "banner_image_url": "https://lh3.googleusercontent.com/i1dLTD9hXZSzeMGz02l202fkMjd3QQrZ2fCQ2TZt-ajo3L931rN_TRGeqU9IvTfm166GIvs5DWaWCKbnuxKq5JmMHLOXioRyCuMxNQ=s2500",
                        "chat_url": null,
                        "created_date": "2021-03-24T00:31:54.219565",
                        "default_to_fiat": false,
                        "description": "",
                        "dev_buyer_fee_basis_points": "0",
                        "dev_seller_fee_basis_points": "0",
                        "discord_url": null,
                        "display_data": {
                            "card_display_style": "contain",
                            "images": []
                        },
                        "external_url": null,
                        "featured": false,
                        "featured_image_url": null,
                        "hidden": true,
                        "safelist_request_status": "not_requested",
                        "image_url": "https://lh3.googleusercontent.com/qZRiTQMHRe5EswI1syqlf0Sf3sfY8bnZjtVhjn89Kh_RxfqZ1WBWTJBnyvnB-gJWsvr6-DsACvVxrPBsj5pSlecxj63iAcVfQTkD=s120",
                        "is_subject_to_whitelist": false,
                        "large_image_url": null,
                        "medium_username": null,
                        "name": "HiDef",
                        "only_proxied_transfers": false,
                        "opensea_buyer_fee_basis_points": "0",
                        "opensea_seller_fee_basis_points": "250",
                        "payout_address": null,
                        "require_email": false,
                        "short_description": null,
                        "slug": "hidef",
                        "telegram_url": null,
                        "twitter_username": null,
                        "instagram_username": null,
                        "wiki_url": null
                    },
                    "decimals": null,
                    "token_metadata": null
                }
            ],
            "name": "Rick Fox & Dr David Washington",
            "description": "",
            "external_link": "",
            "asset_contract": {
                "collection": {
                    "banner_image_url": null,
                    "chat_url": null,
                    "created_date": "2020-12-02T17:40:53.507540",
                    "default_to_fiat": false,
                    "description": null,
                    "dev_buyer_fee_basis_points": "0",
                    "dev_seller_fee_basis_points": "0",
                    "discord_url": null,
                    "display_data": {
                        "card_display_style": "contain",
                        "images": []
                    },
                    "external_url": null,
                    "featured": false,
                    "featured_image_url": null,
                    "hidden": true,
                    "safelist_request_status": "not_requested",
                    "image_url": null,
                    "is_subject_to_whitelist": false,
                    "large_image_url": null,
                    "medium_username": null,
                    "name": "OpenSea Shared Storefront V2",
                    "only_proxied_transfers": false,
                    "opensea_buyer_fee_basis_points": "0",
                    "opensea_seller_fee_basis_points": "250",
                    "payout_address": null,
                    "require_email": false,
                    "short_description": null,
                    "slug": "opensea-shared-storefront-v2",
                    "telegram_url": null,
                    "twitter_username": null,
                    "instagram_username": null,
                    "wiki_url": null
                },
                "address": "0x495f947276749ce646f68ac8c248420045cb7b5e",
                "asset_contract_type": "semi-fungible",
                "created_date": "2020-12-02T17:40:53.232025",
                "name": "OpenSea Collection",
                "nft_version": null,
                "opensea_version": "2.0.0",
                "owner": 102384,
                "schema_name": "ERC1155",
                "symbol": "OPENSTORE",
                "total_supply": null,
                "description": null,
                "external_link": null,
                "image_url": null,
                "default_to_fiat": false,
                "dev_buyer_fee_basis_points": 0,
                "dev_seller_fee_basis_points": 0,
                "only_proxied_transfers": false,
                "opensea_buyer_fee_basis_points": 0,
                "opensea_seller_fee_basis_points": 250,
                "buyer_fee_basis_points": 0,
                "seller_fee_basis_points": 250,
                "payout_address": null
            },
            "permalink": "https://opensea.io/bundles/rick-fox-dr-david-washington-Nf4",
            "sell_orders": []
        },
        {
            "maker": {
                "user": {
                    "username": "REVOLT"
                },
                "profile_img_url": "https://storage.googleapis.com/opensea-static/opensea-profile/25.png",
                "address": "0xb6d820e80a2a7c49f94c9d6c8ea08dccedc9ce4c",
                "config": "",
                "discord_id": ""
            },
            "slug": "small-estate-9-lands-xh2",
            "assets": [
                {
                    "id": 15811468,
                    "token_id": "39399",
                    "num_sales": 0,
                    "background_color": null,
                    "image_url": "https://storage.opensea.io/files/3faa959fa75531ac7913a9c9f8361b58.png",
                    "image_preview_url": "https://lh3.googleusercontent.com/17vU_UNWeMOVi4XOAwo4nvAXpeg1dnKPBk8VnAhJcFHOFZ9UBBvSL5Spj0ytvyfII3rdp4gHMY0mMvbnSzjdOZ0=s250",
                    "image_thumbnail_url": "https://lh3.googleusercontent.com/17vU_UNWeMOVi4XOAwo4nvAXpeg1dnKPBk8VnAhJcFHOFZ9UBBvSL5Spj0ytvyfII3rdp4gHMY0mMvbnSzjdOZ0=s128",
                    "image_original_url": "https://storage.googleapis.com/opensea-static/custom-fetcher-images/sandbox/land/sandbox-land.png",
                    "animation_url": null,
                    "animation_original_url": null,
                    "name": "LAND (27, -108)",
                    "description": "A LAND is a digital piece of real estate in The Sandbox metaverse that players can buy to build experiences on top of. Once you own a LAND, you will be able to populate it with Games and Assets. Each LAND is a unique (non-fungible) token lying on the public Ethereum blockchain (ERC-721).",
                    "external_link": "https://www.sandbox.game/en/map/?x=27&y=-108",
                    "asset_contract": {
                        "address": "0x50f5474724e0ee42d9a4e711ccfb275809fd6d4a",
                        "asset_contract_type": "non-fungible",
                        "created_date": "2019-12-04T10:58:28.892990",
                        "name": "Sandbox's LANDs",
                        "nft_version": "3.0",
                        "opensea_version": null,
                        "owner": null,
                        "schema_name": "ERC721",
                        "symbol": "",
                        "total_supply": null,
                        "description": "The Sandbox is a community-driven platform where creators can monetize voxel assets and gaming experiences on the blockchain. The Sandbox metaverse comprises a map made up of 166,464 LANDS.  LAND owners can host contests and events, stake SAND to earn and customize assets, monetize assets and experiences, vote in the metaverse governance, play games that you or others create, and more! Trade the collection and keep your eyes peeled for future drops.",
                        "external_link": "https://www.sandbox.game/",
                        "image_url": "https://lh3.googleusercontent.com/SXH8tW1siikB80rwCRnjm1a5xM_MwTg9Xl9Db6mioIk9HIlDM09pVoSR7GKJgS6ulSUpgW9BDtMk_ePX_NKgO9A=s60",
                        "default_to_fiat": false,
                        "dev_buyer_fee_basis_points": 0,
                        "dev_seller_fee_basis_points": 500,
                        "only_proxied_transfers": false,
                        "opensea_buyer_fee_basis_points": 0,
                        "opensea_seller_fee_basis_points": 250,
                        "buyer_fee_basis_points": 0,
                        "seller_fee_basis_points": 750,
                        "payout_address": "0x7a9fe22691c811ea339d9b73150e6911a5343dca"
                    },
                    "owner": {
                        "user": {
                            "username": "REVOLT"
                        },
                        "profile_img_url": "https://storage.googleapis.com/opensea-static/opensea-profile/25.png",
                        "address": "0xb6d820e80a2a7c49f94c9d6c8ea08dccedc9ce4c",
                        "config": "",
                        "discord_id": ""
                    },
                    "permalink": "https://opensea.io/assets/0x50f5474724e0ee42d9a4e711ccfb275809fd6d4a/39399",
                    "collection": {
                        "banner_image_url": "https://lh3.googleusercontent.com/4NQIRoGmzXeXQN4mjuhWuuDZSNW7_BqRXux5upd4Nn_A-bfsGxCnPF8qn98Y6MyHRDPGXIlgfZADcSOe6M2DyrDKXdbdaTgkZN5l=s2500",
                        "chat_url": null,
                        "created_date": "2019-12-04T10:58:29.069907",
                        "default_to_fiat": false,
                        "description": "The Sandbox is a community-driven platform where creators can monetize voxel assets and gaming experiences on the blockchain. The Sandbox metaverse comprises a map made up of 166,464 LANDS.  LAND owners can host contests and events, stake SAND to earn and customize assets, monetize assets and experiences, vote in the metaverse governance, play games that you or others create, and more! Trade the collection and keep your eyes peeled for future drops.",
                        "dev_buyer_fee_basis_points": "0",
                        "dev_seller_fee_basis_points": "500",
                        "discord_url": "https://discord.gg/vAe4zvY",
                        "display_data": {
                            "card_display_style": "contain"
                        },
                        "external_url": "https://www.sandbox.game/",
                        "featured": false,
                        "featured_image_url": "https://storage.googleapis.com/opensea-static/featured-images/sandbox-featured.png",
                        "hidden": false,
                        "safelist_request_status": "verified",
                        "image_url": "https://lh3.googleusercontent.com/SXH8tW1siikB80rwCRnjm1a5xM_MwTg9Xl9Db6mioIk9HIlDM09pVoSR7GKJgS6ulSUpgW9BDtMk_ePX_NKgO9A=s60",
                        "is_subject_to_whitelist": false,
                        "large_image_url": "https://lh3.googleusercontent.com/SXH8tW1siikB80rwCRnjm1a5xM_MwTg9Xl9Db6mioIk9HIlDM09pVoSR7GKJgS6ulSUpgW9BDtMk_ePX_NKgO9A",
                        "medium_username": "sandbox-game",
                        "name": "The Sandbox",
                        "only_proxied_transfers": false,
                        "opensea_buyer_fee_basis_points": "0",
                        "opensea_seller_fee_basis_points": "250",
                        "payout_address": "0x7a9fe22691c811ea339d9b73150e6911a5343dca",
                        "require_email": false,
                        "short_description": null,
                        "slug": "sandbox",
                        "telegram_url": "https://t.me/sandboxgame",
                        "twitter_username": "thesandboxgame",
                        "instagram_username": null,
                        "wiki_url": null
                    },
                    "decimals": null,
                    "token_metadata": null
                },
                {
                    "id": 15811496,
                    "token_id": "39400",
                    "num_sales": 0,
                    "background_color": null,
                    "image_url": "https://lh3.googleusercontent.com/17vU_UNWeMOVi4XOAwo4nvAXpeg1dnKPBk8VnAhJcFHOFZ9UBBvSL5Spj0ytvyfII3rdp4gHMY0mMvbnSzjdOZ0",
                    "image_preview_url": "https://lh3.googleusercontent.com/17vU_UNWeMOVi4XOAwo4nvAXpeg1dnKPBk8VnAhJcFHOFZ9UBBvSL5Spj0ytvyfII3rdp4gHMY0mMvbnSzjdOZ0=s250",
                    "image_thumbnail_url": "https://lh3.googleusercontent.com/17vU_UNWeMOVi4XOAwo4nvAXpeg1dnKPBk8VnAhJcFHOFZ9UBBvSL5Spj0ytvyfII3rdp4gHMY0mMvbnSzjdOZ0=s128",
                    "image_original_url": "https://storage.googleapis.com/opensea-static/custom-fetcher-images/sandbox/land/sandbox-land.png",
                    "animation_url": null,
                    "animation_original_url": null,
                    "name": "LAND (28, -108)",
                    "description": "A LAND is a digital piece of real estate in The Sandbox metaverse that players can buy to build experiences on top of. Once you own a LAND, you will be able to populate it with Games and Assets. Each LAND is a unique (non-fungible) token lying on the public Ethereum blockchain (ERC-721).",
                    "external_link": "https://www.sandbox.game/en/map/?x=28&y=-108",
                    "asset_contract": {
                        "address": "0x50f5474724e0ee42d9a4e711ccfb275809fd6d4a",
                        "asset_contract_type": "non-fungible",
                        "created_date": "2019-12-04T10:58:28.892990",
                        "name": "Sandbox's LANDs",
                        "nft_version": "3.0",
                        "opensea_version": null,
                        "owner": null,
                        "schema_name": "ERC721",
                        "symbol": "",
                        "total_supply": null,
                        "description": "The Sandbox is a community-driven platform where creators can monetize voxel assets and gaming experiences on the blockchain. The Sandbox metaverse comprises a map made up of 166,464 LANDS.  LAND owners can host contests and events, stake SAND to earn and customize assets, monetize assets and experiences, vote in the metaverse governance, play games that you or others create, and more! Trade the collection and keep your eyes peeled for future drops.",
                        "external_link": "https://www.sandbox.game/",
                        "image_url": "https://lh3.googleusercontent.com/SXH8tW1siikB80rwCRnjm1a5xM_MwTg9Xl9Db6mioIk9HIlDM09pVoSR7GKJgS6ulSUpgW9BDtMk_ePX_NKgO9A=s60",
                        "default_to_fiat": false,
                        "dev_buyer_fee_basis_points": 0,
                        "dev_seller_fee_basis_points": 500,
                        "only_proxied_transfers": false,
                        "opensea_buyer_fee_basis_points": 0,
                        "opensea_seller_fee_basis_points": 250,
                        "buyer_fee_basis_points": 0,
                        "seller_fee_basis_points": 750,
                        "payout_address": "0x7a9fe22691c811ea339d9b73150e6911a5343dca"
                    },
                    "owner": {
                        "user": {
                            "username": "REVOLT"
                        },
                        "profile_img_url": "https://storage.googleapis.com/opensea-static/opensea-profile/25.png",
                        "address": "0xb6d820e80a2a7c49f94c9d6c8ea08dccedc9ce4c",
                        "config": "",
                        "discord_id": ""
                    },
                    "permalink": "https://opensea.io/assets/0x50f5474724e0ee42d9a4e711ccfb275809fd6d4a/39400",
                    "collection": {
                        "banner_image_url": "https://lh3.googleusercontent.com/4NQIRoGmzXeXQN4mjuhWuuDZSNW7_BqRXux5upd4Nn_A-bfsGxCnPF8qn98Y6MyHRDPGXIlgfZADcSOe6M2DyrDKXdbdaTgkZN5l=s2500",
                        "chat_url": null,
                        "created_date": "2019-12-04T10:58:29.069907",
                        "default_to_fiat": false,
                        "description": "The Sandbox is a community-driven platform where creators can monetize voxel assets and gaming experiences on the blockchain. The Sandbox metaverse comprises a map made up of 166,464 LANDS.  LAND owners can host contests and events, stake SAND to earn and customize assets, monetize assets and experiences, vote in the metaverse governance, play games that you or others create, and more! Trade the collection and keep your eyes peeled for future drops.",
                        "dev_buyer_fee_basis_points": "0",
                        "dev_seller_fee_basis_points": "500",
                        "discord_url": "https://discord.gg/vAe4zvY",
                        "display_data": {
                            "card_display_style": "contain"
                        },
                        "external_url": "https://www.sandbox.game/",
                        "featured": false,
                        "featured_image_url": "https://storage.googleapis.com/opensea-static/featured-images/sandbox-featured.png",
                        "hidden": false,
                        "safelist_request_status": "verified",
                        "image_url": "https://lh3.googleusercontent.com/SXH8tW1siikB80rwCRnjm1a5xM_MwTg9Xl9Db6mioIk9HIlDM09pVoSR7GKJgS6ulSUpgW9BDtMk_ePX_NKgO9A=s60",
                        "is_subject_to_whitelist": false,
                        "large_image_url": "https://lh3.googleusercontent.com/SXH8tW1siikB80rwCRnjm1a5xM_MwTg9Xl9Db6mioIk9HIlDM09pVoSR7GKJgS6ulSUpgW9BDtMk_ePX_NKgO9A",
                        "medium_username": "sandbox-game",
                        "name": "The Sandbox",
                        "only_proxied_transfers": false,
                        "opensea_buyer_fee_basis_points": "0",
                        "opensea_seller_fee_basis_points": "250",
                        "payout_address": "0x7a9fe22691c811ea339d9b73150e6911a5343dca",
                        "require_email": false,
                        "short_description": null,
                        "slug": "sandbox",
                        "telegram_url": "https://t.me/sandboxgame",
                        "twitter_username": "thesandboxgame",
                        "instagram_username": null,
                        "wiki_url": null
                    },
                    "decimals": null,
                    "token_metadata": null
                },
                {
                    "id": 15811525,
                    "token_id": "39401",
                    "num_sales": 0,
                    "background_color": null,
                    "image_url": "https://storage.opensea.io/files/3faa959fa75531ac7913a9c9f8361b58.png",
                    "image_preview_url": "https://lh3.googleusercontent.com/17vU_UNWeMOVi4XOAwo4nvAXpeg1dnKPBk8VnAhJcFHOFZ9UBBvSL5Spj0ytvyfII3rdp4gHMY0mMvbnSzjdOZ0=s250",
                    "image_thumbnail_url": "https://lh3.googleusercontent.com/17vU_UNWeMOVi4XOAwo4nvAXpeg1dnKPBk8VnAhJcFHOFZ9UBBvSL5Spj0ytvyfII3rdp4gHMY0mMvbnSzjdOZ0=s128",
                    "image_original_url": "https://storage.googleapis.com/opensea-static/custom-fetcher-images/sandbox/land/sandbox-land.png",
                    "animation_url": null,
                    "animation_original_url": null,
                    "name": "LAND (29, -108)",
                    "description": "A LAND is a digital piece of real estate in The Sandbox metaverse that players can buy to build experiences on top of. Once you own a LAND, you will be able to populate it with Games and Assets. Each LAND is a unique (non-fungible) token lying on the public Ethereum blockchain (ERC-721).",
                    "external_link": "https://www.sandbox.game/en/map/?x=29&y=-108",
                    "asset_contract": {
                        "address": "0x50f5474724e0ee42d9a4e711ccfb275809fd6d4a",
                        "asset_contract_type": "non-fungible",
                        "created_date": "2019-12-04T10:58:28.892990",
                        "name": "Sandbox's LANDs",
                        "nft_version": "3.0",
                        "opensea_version": null,
                        "owner": null,
                        "schema_name": "ERC721",
                        "symbol": "",
                        "total_supply": null,
                        "description": "The Sandbox is a community-driven platform where creators can monetize voxel assets and gaming experiences on the blockchain. The Sandbox metaverse comprises a map made up of 166,464 LANDS.  LAND owners can host contests and events, stake SAND to earn and customize assets, monetize assets and experiences, vote in the metaverse governance, play games that you or others create, and more! Trade the collection and keep your eyes peeled for future drops.",
                        "external_link": "https://www.sandbox.game/",
                        "image_url": "https://lh3.googleusercontent.com/SXH8tW1siikB80rwCRnjm1a5xM_MwTg9Xl9Db6mioIk9HIlDM09pVoSR7GKJgS6ulSUpgW9BDtMk_ePX_NKgO9A=s60",
                        "default_to_fiat": false,
                        "dev_buyer_fee_basis_points": 0,
                        "dev_seller_fee_basis_points": 500,
                        "only_proxied_transfers": false,
                        "opensea_buyer_fee_basis_points": 0,
                        "opensea_seller_fee_basis_points": 250,
                        "buyer_fee_basis_points": 0,
                        "seller_fee_basis_points": 750,
                        "payout_address": "0x7a9fe22691c811ea339d9b73150e6911a5343dca"
                    },
                    "owner": {
                        "user": {
                            "username": "REVOLT"
                        },
                        "profile_img_url": "https://storage.googleapis.com/opensea-static/opensea-profile/25.png",
                        "address": "0xb6d820e80a2a7c49f94c9d6c8ea08dccedc9ce4c",
                        "config": "",
                        "discord_id": ""
                    },
                    "permalink": "https://opensea.io/assets/0x50f5474724e0ee42d9a4e711ccfb275809fd6d4a/39401",
                    "collection": {
                        "banner_image_url": "https://lh3.googleusercontent.com/4NQIRoGmzXeXQN4mjuhWuuDZSNW7_BqRXux5upd4Nn_A-bfsGxCnPF8qn98Y6MyHRDPGXIlgfZADcSOe6M2DyrDKXdbdaTgkZN5l=s2500",
                        "chat_url": null,
                        "created_date": "2019-12-04T10:58:29.069907",
                        "default_to_fiat": false,
                        "description": "The Sandbox is a community-driven platform where creators can monetize voxel assets and gaming experiences on the blockchain. The Sandbox metaverse comprises a map made up of 166,464 LANDS.  LAND owners can host contests and events, stake SAND to earn and customize assets, monetize assets and experiences, vote in the metaverse governance, play games that you or others create, and more! Trade the collection and keep your eyes peeled for future drops.",
                        "dev_buyer_fee_basis_points": "0",
                        "dev_seller_fee_basis_points": "500",
                        "discord_url": "https://discord.gg/vAe4zvY",
                        "display_data": {
                            "card_display_style": "contain"
                        },
                        "external_url": "https://www.sandbox.game/",
                        "featured": false,
                        "featured_image_url": "https://storage.googleapis.com/opensea-static/featured-images/sandbox-featured.png",
                        "hidden": false,
                        "safelist_request_status": "verified",
                        "image_url": "https://lh3.googleusercontent.com/SXH8tW1siikB80rwCRnjm1a5xM_MwTg9Xl9Db6mioIk9HIlDM09pVoSR7GKJgS6ulSUpgW9BDtMk_ePX_NKgO9A=s60",
                        "is_subject_to_whitelist": false,
                        "large_image_url": "https://lh3.googleusercontent.com/SXH8tW1siikB80rwCRnjm1a5xM_MwTg9Xl9Db6mioIk9HIlDM09pVoSR7GKJgS6ulSUpgW9BDtMk_ePX_NKgO9A",
                        "medium_username": "sandbox-game",
                        "name": "The Sandbox",
                        "only_proxied_transfers": false,
                        "opensea_buyer_fee_basis_points": "0",
                        "opensea_seller_fee_basis_points": "250",
                        "payout_address": "0x7a9fe22691c811ea339d9b73150e6911a5343dca",
                        "require_email": false,
                        "short_description": null,
                        "slug": "sandbox",
                        "telegram_url": "https://t.me/sandboxgame",
                        "twitter_username": "thesandboxgame",
                        "instagram_username": null,
                        "wiki_url": null
                    },
                    "decimals": null,
                    "token_metadata": null
                },
                {
                    "id": 15811547,
                    "token_id": "39809",
                    "num_sales": 0,
                    "background_color": null,
                    "image_url": "https://storage.opensea.io/files/3faa959fa75531ac7913a9c9f8361b58.png",
                    "image_preview_url": "https://lh3.googleusercontent.com/17vU_UNWeMOVi4XOAwo4nvAXpeg1dnKPBk8VnAhJcFHOFZ9UBBvSL5Spj0ytvyfII3rdp4gHMY0mMvbnSzjdOZ0=s250",
                    "image_thumbnail_url": "https://lh3.googleusercontent.com/17vU_UNWeMOVi4XOAwo4nvAXpeg1dnKPBk8VnAhJcFHOFZ9UBBvSL5Spj0ytvyfII3rdp4gHMY0mMvbnSzjdOZ0=s128",
                    "image_original_url": "https://storage.googleapis.com/opensea-static/custom-fetcher-images/sandbox/land/sandbox-land.png",
                    "animation_url": null,
                    "animation_original_url": null,
                    "name": "LAND (29, -107)",
                    "description": "A LAND is a digital piece of real estate in The Sandbox metaverse that players can buy to build experiences on top of. Once you own a LAND, you will be able to populate it with Games and Assets. Each LAND is a unique (non-fungible) token lying on the public Ethereum blockchain (ERC-721).",
                    "external_link": "https://www.sandbox.game/en/map/?x=29&y=-107",
                    "asset_contract": {
                        "address": "0x50f5474724e0ee42d9a4e711ccfb275809fd6d4a",
                        "asset_contract_type": "non-fungible",
                        "created_date": "2019-12-04T10:58:28.892990",
                        "name": "Sandbox's LANDs",
                        "nft_version": "3.0",
                        "opensea_version": null,
                        "owner": null,
                        "schema_name": "ERC721",
                        "symbol": "",
                        "total_supply": null,
                        "description": "The Sandbox is a community-driven platform where creators can monetize voxel assets and gaming experiences on the blockchain. The Sandbox metaverse comprises a map made up of 166,464 LANDS.  LAND owners can host contests and events, stake SAND to earn and customize assets, monetize assets and experiences, vote in the metaverse governance, play games that you or others create, and more! Trade the collection and keep your eyes peeled for future drops.",
                        "external_link": "https://www.sandbox.game/",
                        "image_url": "https://lh3.googleusercontent.com/SXH8tW1siikB80rwCRnjm1a5xM_MwTg9Xl9Db6mioIk9HIlDM09pVoSR7GKJgS6ulSUpgW9BDtMk_ePX_NKgO9A=s60",
                        "default_to_fiat": false,
                        "dev_buyer_fee_basis_points": 0,
                        "dev_seller_fee_basis_points": 500,
                        "only_proxied_transfers": false,
                        "opensea_buyer_fee_basis_points": 0,
                        "opensea_seller_fee_basis_points": 250,
                        "buyer_fee_basis_points": 0,
                        "seller_fee_basis_points": 750,
                        "payout_address": "0x7a9fe22691c811ea339d9b73150e6911a5343dca"
                    },
                    "owner": {
                        "user": {
                            "username": "REVOLT"
                        },
                        "profile_img_url": "https://storage.googleapis.com/opensea-static/opensea-profile/25.png",
                        "address": "0xb6d820e80a2a7c49f94c9d6c8ea08dccedc9ce4c",
                        "config": "",
                        "discord_id": ""
                    },
                    "permalink": "https://opensea.io/assets/0x50f5474724e0ee42d9a4e711ccfb275809fd6d4a/39809",
                    "collection": {
                        "banner_image_url": "https://lh3.googleusercontent.com/4NQIRoGmzXeXQN4mjuhWuuDZSNW7_BqRXux5upd4Nn_A-bfsGxCnPF8qn98Y6MyHRDPGXIlgfZADcSOe6M2DyrDKXdbdaTgkZN5l=s2500",
                        "chat_url": null,
                        "created_date": "2019-12-04T10:58:29.069907",
                        "default_to_fiat": false,
                        "description": "The Sandbox is a community-driven platform where creators can monetize voxel assets and gaming experiences on the blockchain. The Sandbox metaverse comprises a map made up of 166,464 LANDS.  LAND owners can host contests and events, stake SAND to earn and customize assets, monetize assets and experiences, vote in the metaverse governance, play games that you or others create, and more! Trade the collection and keep your eyes peeled for future drops.",
                        "dev_buyer_fee_basis_points": "0",
                        "dev_seller_fee_basis_points": "500",
                        "discord_url": "https://discord.gg/vAe4zvY",
                        "display_data": {
                            "card_display_style": "contain"
                        },
                        "external_url": "https://www.sandbox.game/",
                        "featured": false,
                        "featured_image_url": "https://storage.googleapis.com/opensea-static/featured-images/sandbox-featured.png",
                        "hidden": false,
                        "safelist_request_status": "verified",
                        "image_url": "https://lh3.googleusercontent.com/SXH8tW1siikB80rwCRnjm1a5xM_MwTg9Xl9Db6mioIk9HIlDM09pVoSR7GKJgS6ulSUpgW9BDtMk_ePX_NKgO9A=s60",
                        "is_subject_to_whitelist": false,
                        "large_image_url": "https://lh3.googleusercontent.com/SXH8tW1siikB80rwCRnjm1a5xM_MwTg9Xl9Db6mioIk9HIlDM09pVoSR7GKJgS6ulSUpgW9BDtMk_ePX_NKgO9A",
                        "medium_username": "sandbox-game",
                        "name": "The Sandbox",
                        "only_proxied_transfers": false,
                        "opensea_buyer_fee_basis_points": "0",
                        "opensea_seller_fee_basis_points": "250",
                        "payout_address": "0x7a9fe22691c811ea339d9b73150e6911a5343dca",
                        "require_email": false,
                        "short_description": null,
                        "slug": "sandbox",
                        "telegram_url": "https://t.me/sandboxgame",
                        "twitter_username": "thesandboxgame",
                        "instagram_username": null,
                        "wiki_url": null
                    },
                    "decimals": null,
                    "token_metadata": null
                },
                {
                    "id": 15811573,
                    "token_id": "39808",
                    "num_sales": 0,
                    "background_color": null,
                    "image_url": "https://lh3.googleusercontent.com/17vU_UNWeMOVi4XOAwo4nvAXpeg1dnKPBk8VnAhJcFHOFZ9UBBvSL5Spj0ytvyfII3rdp4gHMY0mMvbnSzjdOZ0",
                    "image_preview_url": "https://lh3.googleusercontent.com/17vU_UNWeMOVi4XOAwo4nvAXpeg1dnKPBk8VnAhJcFHOFZ9UBBvSL5Spj0ytvyfII3rdp4gHMY0mMvbnSzjdOZ0=s250",
                    "image_thumbnail_url": "https://lh3.googleusercontent.com/17vU_UNWeMOVi4XOAwo4nvAXpeg1dnKPBk8VnAhJcFHOFZ9UBBvSL5Spj0ytvyfII3rdp4gHMY0mMvbnSzjdOZ0=s128",
                    "image_original_url": "https://storage.googleapis.com/opensea-static/custom-fetcher-images/sandbox/land/sandbox-land.png",
                    "animation_url": null,
                    "animation_original_url": null,
                    "name": "LAND (28, -107)",
                    "description": "A LAND is a digital piece of real estate in The Sandbox metaverse that players can buy to build experiences on top of. Once you own a LAND, you will be able to populate it with Games and Assets. Each LAND is a unique (non-fungible) token lying on the public Ethereum blockchain (ERC-721).",
                    "external_link": "https://www.sandbox.game/en/map/?x=28&y=-107",
                    "asset_contract": {
                        "address": "0x50f5474724e0ee42d9a4e711ccfb275809fd6d4a",
                        "asset_contract_type": "non-fungible",
                        "created_date": "2019-12-04T10:58:28.892990",
                        "name": "Sandbox's LANDs",
                        "nft_version": "3.0",
                        "opensea_version": null,
                        "owner": null,
                        "schema_name": "ERC721",
                        "symbol": "",
                        "total_supply": null,
                        "description": "The Sandbox is a community-driven platform where creators can monetize voxel assets and gaming experiences on the blockchain. The Sandbox metaverse comprises a map made up of 166,464 LANDS.  LAND owners can host contests and events, stake SAND to earn and customize assets, monetize assets and experiences, vote in the metaverse governance, play games that you or others create, and more! Trade the collection and keep your eyes peeled for future drops.",
                        "external_link": "https://www.sandbox.game/",
                        "image_url": "https://lh3.googleusercontent.com/SXH8tW1siikB80rwCRnjm1a5xM_MwTg9Xl9Db6mioIk9HIlDM09pVoSR7GKJgS6ulSUpgW9BDtMk_ePX_NKgO9A=s60",
                        "default_to_fiat": false,
                        "dev_buyer_fee_basis_points": 0,
                        "dev_seller_fee_basis_points": 500,
                        "only_proxied_transfers": false,
                        "opensea_buyer_fee_basis_points": 0,
                        "opensea_seller_fee_basis_points": 250,
                        "buyer_fee_basis_points": 0,
                        "seller_fee_basis_points": 750,
                        "payout_address": "0x7a9fe22691c811ea339d9b73150e6911a5343dca"
                    },
                    "owner": {
                        "user": {
                            "username": "REVOLT"
                        },
                        "profile_img_url": "https://storage.googleapis.com/opensea-static/opensea-profile/25.png",
                        "address": "0xb6d820e80a2a7c49f94c9d6c8ea08dccedc9ce4c",
                        "config": "",
                        "discord_id": ""
                    },
                    "permalink": "https://opensea.io/assets/0x50f5474724e0ee42d9a4e711ccfb275809fd6d4a/39808",
                    "collection": {
                        "banner_image_url": "https://lh3.googleusercontent.com/4NQIRoGmzXeXQN4mjuhWuuDZSNW7_BqRXux5upd4Nn_A-bfsGxCnPF8qn98Y6MyHRDPGXIlgfZADcSOe6M2DyrDKXdbdaTgkZN5l=s2500",
                        "chat_url": null,
                        "created_date": "2019-12-04T10:58:29.069907",
                        "default_to_fiat": false,
                        "description": "The Sandbox is a community-driven platform where creators can monetize voxel assets and gaming experiences on the blockchain. The Sandbox metaverse comprises a map made up of 166,464 LANDS.  LAND owners can host contests and events, stake SAND to earn and customize assets, monetize assets and experiences, vote in the metaverse governance, play games that you or others create, and more! Trade the collection and keep your eyes peeled for future drops.",
                        "dev_buyer_fee_basis_points": "0",
                        "dev_seller_fee_basis_points": "500",
                        "discord_url": "https://discord.gg/vAe4zvY",
                        "display_data": {
                            "card_display_style": "contain"
                        },
                        "external_url": "https://www.sandbox.game/",
                        "featured": false,
                        "featured_image_url": "https://storage.googleapis.com/opensea-static/featured-images/sandbox-featured.png",
                        "hidden": false,
                        "safelist_request_status": "verified",
                        "image_url": "https://lh3.googleusercontent.com/SXH8tW1siikB80rwCRnjm1a5xM_MwTg9Xl9Db6mioIk9HIlDM09pVoSR7GKJgS6ulSUpgW9BDtMk_ePX_NKgO9A=s60",
                        "is_subject_to_whitelist": false,
                        "large_image_url": "https://lh3.googleusercontent.com/SXH8tW1siikB80rwCRnjm1a5xM_MwTg9Xl9Db6mioIk9HIlDM09pVoSR7GKJgS6ulSUpgW9BDtMk_ePX_NKgO9A",
                        "medium_username": "sandbox-game",
                        "name": "The Sandbox",
                        "only_proxied_transfers": false,
                        "opensea_buyer_fee_basis_points": "0",
                        "opensea_seller_fee_basis_points": "250",
                        "payout_address": "0x7a9fe22691c811ea339d9b73150e6911a5343dca",
                        "require_email": false,
                        "short_description": null,
                        "slug": "sandbox",
                        "telegram_url": "https://t.me/sandboxgame",
                        "twitter_username": "thesandboxgame",
                        "instagram_username": null,
                        "wiki_url": null
                    },
                    "decimals": null,
                    "token_metadata": null
                },
                {
                    "id": 15811597,
                    "token_id": "39807",
                    "num_sales": 0,
                    "background_color": null,
                    "image_url": "https://storage.opensea.io/files/3faa959fa75531ac7913a9c9f8361b58.png",
                    "image_preview_url": "https://lh3.googleusercontent.com/17vU_UNWeMOVi4XOAwo4nvAXpeg1dnKPBk8VnAhJcFHOFZ9UBBvSL5Spj0ytvyfII3rdp4gHMY0mMvbnSzjdOZ0=s250",
                    "image_thumbnail_url": "https://lh3.googleusercontent.com/17vU_UNWeMOVi4XOAwo4nvAXpeg1dnKPBk8VnAhJcFHOFZ9UBBvSL5Spj0ytvyfII3rdp4gHMY0mMvbnSzjdOZ0=s128",
                    "image_original_url": "https://storage.googleapis.com/opensea-static/custom-fetcher-images/sandbox/land/sandbox-land.png",
                    "animation_url": null,
                    "animation_original_url": null,
                    "name": "LAND (27, -107)",
                    "description": "A LAND is a digital piece of real estate in The Sandbox metaverse that players can buy to build experiences on top of. Once you own a LAND, you will be able to populate it with Games and Assets. Each LAND is a unique (non-fungible) token lying on the public Ethereum blockchain (ERC-721).",
                    "external_link": "https://www.sandbox.game/en/map/?x=27&y=-107",
                    "asset_contract": {
                        "address": "0x50f5474724e0ee42d9a4e711ccfb275809fd6d4a",
                        "asset_contract_type": "non-fungible",
                        "created_date": "2019-12-04T10:58:28.892990",
                        "name": "Sandbox's LANDs",
                        "nft_version": "3.0",
                        "opensea_version": null,
                        "owner": null,
                        "schema_name": "ERC721",
                        "symbol": "",
                        "total_supply": null,
                        "description": "The Sandbox is a community-driven platform where creators can monetize voxel assets and gaming experiences on the blockchain. The Sandbox metaverse comprises a map made up of 166,464 LANDS.  LAND owners can host contests and events, stake SAND to earn and customize assets, monetize assets and experiences, vote in the metaverse governance, play games that you or others create, and more! Trade the collection and keep your eyes peeled for future drops.",
                        "external_link": "https://www.sandbox.game/",
                        "image_url": "https://lh3.googleusercontent.com/SXH8tW1siikB80rwCRnjm1a5xM_MwTg9Xl9Db6mioIk9HIlDM09pVoSR7GKJgS6ulSUpgW9BDtMk_ePX_NKgO9A=s60",
                        "default_to_fiat": false,
                        "dev_buyer_fee_basis_points": 0,
                        "dev_seller_fee_basis_points": 500,
                        "only_proxied_transfers": false,
                        "opensea_buyer_fee_basis_points": 0,
                        "opensea_seller_fee_basis_points": 250,
                        "buyer_fee_basis_points": 0,
                        "seller_fee_basis_points": 750,
                        "payout_address": "0x7a9fe22691c811ea339d9b73150e6911a5343dca"
                    },
                    "owner": {
                        "user": {
                            "username": "REVOLT"
                        },
                        "profile_img_url": "https://storage.googleapis.com/opensea-static/opensea-profile/25.png",
                        "address": "0xb6d820e80a2a7c49f94c9d6c8ea08dccedc9ce4c",
                        "config": "",
                        "discord_id": ""
                    },
                    "permalink": "https://opensea.io/assets/0x50f5474724e0ee42d9a4e711ccfb275809fd6d4a/39807",
                    "collection": {
                        "banner_image_url": "https://lh3.googleusercontent.com/4NQIRoGmzXeXQN4mjuhWuuDZSNW7_BqRXux5upd4Nn_A-bfsGxCnPF8qn98Y6MyHRDPGXIlgfZADcSOe6M2DyrDKXdbdaTgkZN5l=s2500",
                        "chat_url": null,
                        "created_date": "2019-12-04T10:58:29.069907",
                        "default_to_fiat": false,
                        "description": "The Sandbox is a community-driven platform where creators can monetize voxel assets and gaming experiences on the blockchain. The Sandbox metaverse comprises a map made up of 166,464 LANDS.  LAND owners can host contests and events, stake SAND to earn and customize assets, monetize assets and experiences, vote in the metaverse governance, play games that you or others create, and more! Trade the collection and keep your eyes peeled for future drops.",
                        "dev_buyer_fee_basis_points": "0",
                        "dev_seller_fee_basis_points": "500",
                        "discord_url": "https://discord.gg/vAe4zvY",
                        "display_data": {
                            "card_display_style": "contain"
                        },
                        "external_url": "https://www.sandbox.game/",
                        "featured": false,
                        "featured_image_url": "https://storage.googleapis.com/opensea-static/featured-images/sandbox-featured.png",
                        "hidden": false,
                        "safelist_request_status": "verified",
                        "image_url": "https://lh3.googleusercontent.com/SXH8tW1siikB80rwCRnjm1a5xM_MwTg9Xl9Db6mioIk9HIlDM09pVoSR7GKJgS6ulSUpgW9BDtMk_ePX_NKgO9A=s60",
                        "is_subject_to_whitelist": false,
                        "large_image_url": "https://lh3.googleusercontent.com/SXH8tW1siikB80rwCRnjm1a5xM_MwTg9Xl9Db6mioIk9HIlDM09pVoSR7GKJgS6ulSUpgW9BDtMk_ePX_NKgO9A",
                        "medium_username": "sandbox-game",
                        "name": "The Sandbox",
                        "only_proxied_transfers": false,
                        "opensea_buyer_fee_basis_points": "0",
                        "opensea_seller_fee_basis_points": "250",
                        "payout_address": "0x7a9fe22691c811ea339d9b73150e6911a5343dca",
                        "require_email": false,
                        "short_description": null,
                        "slug": "sandbox",
                        "telegram_url": "https://t.me/sandboxgame",
                        "twitter_username": "thesandboxgame",
                        "instagram_username": null,
                        "wiki_url": null
                    },
                    "decimals": null,
                    "token_metadata": null
                },
                {
                    "id": 15811620,
                    "token_id": "40215",
                    "num_sales": 0,
                    "background_color": null,
                    "image_url": "https://storage.opensea.io/files/3faa959fa75531ac7913a9c9f8361b58.png",
                    "image_preview_url": "https://lh3.googleusercontent.com/17vU_UNWeMOVi4XOAwo4nvAXpeg1dnKPBk8VnAhJcFHOFZ9UBBvSL5Spj0ytvyfII3rdp4gHMY0mMvbnSzjdOZ0=s250",
                    "image_thumbnail_url": "https://lh3.googleusercontent.com/17vU_UNWeMOVi4XOAwo4nvAXpeg1dnKPBk8VnAhJcFHOFZ9UBBvSL5Spj0ytvyfII3rdp4gHMY0mMvbnSzjdOZ0=s128",
                    "image_original_url": "https://storage.googleapis.com/opensea-static/custom-fetcher-images/sandbox/land/sandbox-land.png",
                    "animation_url": null,
                    "animation_original_url": null,
                    "name": "LAND (27, -106)",
                    "description": "A LAND is a digital piece of real estate in The Sandbox metaverse that players can buy to build experiences on top of. Once you own a LAND, you will be able to populate it with Games and Assets. Each LAND is a unique (non-fungible) token lying on the public Ethereum blockchain (ERC-721).",
                    "external_link": "https://www.sandbox.game/en/map/?x=27&y=-106",
                    "asset_contract": {
                        "address": "0x50f5474724e0ee42d9a4e711ccfb275809fd6d4a",
                        "asset_contract_type": "non-fungible",
                        "created_date": "2019-12-04T10:58:28.892990",
                        "name": "Sandbox's LANDs",
                        "nft_version": "3.0",
                        "opensea_version": null,
                        "owner": null,
                        "schema_name": "ERC721",
                        "symbol": "",
                        "total_supply": null,
                        "description": "The Sandbox is a community-driven platform where creators can monetize voxel assets and gaming experiences on the blockchain. The Sandbox metaverse comprises a map made up of 166,464 LANDS.  LAND owners can host contests and events, stake SAND to earn and customize assets, monetize assets and experiences, vote in the metaverse governance, play games that you or others create, and more! Trade the collection and keep your eyes peeled for future drops.",
                        "external_link": "https://www.sandbox.game/",
                        "image_url": "https://lh3.googleusercontent.com/SXH8tW1siikB80rwCRnjm1a5xM_MwTg9Xl9Db6mioIk9HIlDM09pVoSR7GKJgS6ulSUpgW9BDtMk_ePX_NKgO9A=s60",
                        "default_to_fiat": false,
                        "dev_buyer_fee_basis_points": 0,
                        "dev_seller_fee_basis_points": 500,
                        "only_proxied_transfers": false,
                        "opensea_buyer_fee_basis_points": 0,
                        "opensea_seller_fee_basis_points": 250,
                        "buyer_fee_basis_points": 0,
                        "seller_fee_basis_points": 750,
                        "payout_address": "0x7a9fe22691c811ea339d9b73150e6911a5343dca"
                    },
                    "owner": {
                        "user": {
                            "username": "REVOLT"
                        },
                        "profile_img_url": "https://storage.googleapis.com/opensea-static/opensea-profile/25.png",
                        "address": "0xb6d820e80a2a7c49f94c9d6c8ea08dccedc9ce4c",
                        "config": "",
                        "discord_id": ""
                    },
                    "permalink": "https://opensea.io/assets/0x50f5474724e0ee42d9a4e711ccfb275809fd6d4a/40215",
                    "collection": {
                        "banner_image_url": "https://lh3.googleusercontent.com/4NQIRoGmzXeXQN4mjuhWuuDZSNW7_BqRXux5upd4Nn_A-bfsGxCnPF8qn98Y6MyHRDPGXIlgfZADcSOe6M2DyrDKXdbdaTgkZN5l=s2500",
                        "chat_url": null,
                        "created_date": "2019-12-04T10:58:29.069907",
                        "default_to_fiat": false,
                        "description": "The Sandbox is a community-driven platform where creators can monetize voxel assets and gaming experiences on the blockchain. The Sandbox metaverse comprises a map made up of 166,464 LANDS.  LAND owners can host contests and events, stake SAND to earn and customize assets, monetize assets and experiences, vote in the metaverse governance, play games that you or others create, and more! Trade the collection and keep your eyes peeled for future drops.",
                        "dev_buyer_fee_basis_points": "0",
                        "dev_seller_fee_basis_points": "500",
                        "discord_url": "https://discord.gg/vAe4zvY",
                        "display_data": {
                            "card_display_style": "contain"
                        },
                        "external_url": "https://www.sandbox.game/",
                        "featured": false,
                        "featured_image_url": "https://storage.googleapis.com/opensea-static/featured-images/sandbox-featured.png",
                        "hidden": false,
                        "safelist_request_status": "verified",
                        "image_url": "https://lh3.googleusercontent.com/SXH8tW1siikB80rwCRnjm1a5xM_MwTg9Xl9Db6mioIk9HIlDM09pVoSR7GKJgS6ulSUpgW9BDtMk_ePX_NKgO9A=s60",
                        "is_subject_to_whitelist": false,
                        "large_image_url": "https://lh3.googleusercontent.com/SXH8tW1siikB80rwCRnjm1a5xM_MwTg9Xl9Db6mioIk9HIlDM09pVoSR7GKJgS6ulSUpgW9BDtMk_ePX_NKgO9A",
                        "medium_username": "sandbox-game",
                        "name": "The Sandbox",
                        "only_proxied_transfers": false,
                        "opensea_buyer_fee_basis_points": "0",
                        "opensea_seller_fee_basis_points": "250",
                        "payout_address": "0x7a9fe22691c811ea339d9b73150e6911a5343dca",
                        "require_email": false,
                        "short_description": null,
                        "slug": "sandbox",
                        "telegram_url": "https://t.me/sandboxgame",
                        "twitter_username": "thesandboxgame",
                        "instagram_username": null,
                        "wiki_url": null
                    },
                    "decimals": null,
                    "token_metadata": null
                },
                {
                    "id": 15811645,
                    "token_id": "40216",
                    "num_sales": 0,
                    "background_color": null,
                    "image_url": "https://lh3.googleusercontent.com/17vU_UNWeMOVi4XOAwo4nvAXpeg1dnKPBk8VnAhJcFHOFZ9UBBvSL5Spj0ytvyfII3rdp4gHMY0mMvbnSzjdOZ0",
                    "image_preview_url": "https://lh3.googleusercontent.com/17vU_UNWeMOVi4XOAwo4nvAXpeg1dnKPBk8VnAhJcFHOFZ9UBBvSL5Spj0ytvyfII3rdp4gHMY0mMvbnSzjdOZ0=s250",
                    "image_thumbnail_url": "https://lh3.googleusercontent.com/17vU_UNWeMOVi4XOAwo4nvAXpeg1dnKPBk8VnAhJcFHOFZ9UBBvSL5Spj0ytvyfII3rdp4gHMY0mMvbnSzjdOZ0=s128",
                    "image_original_url": "https://storage.googleapis.com/opensea-static/custom-fetcher-images/sandbox/land/sandbox-land.png",
                    "animation_url": null,
                    "animation_original_url": null,
                    "name": "LAND (28, -106)",
                    "description": "A LAND is a digital piece of real estate in The Sandbox metaverse that players can buy to build experiences on top of. Once you own a LAND, you will be able to populate it with Games and Assets. Each LAND is a unique (non-fungible) token lying on the public Ethereum blockchain (ERC-721).",
                    "external_link": "https://www.sandbox.game/en/map/?x=28&y=-106",
                    "asset_contract": {
                        "address": "0x50f5474724e0ee42d9a4e711ccfb275809fd6d4a",
                        "asset_contract_type": "non-fungible",
                        "created_date": "2019-12-04T10:58:28.892990",
                        "name": "Sandbox's LANDs",
                        "nft_version": "3.0",
                        "opensea_version": null,
                        "owner": null,
                        "schema_name": "ERC721",
                        "symbol": "",
                        "total_supply": null,
                        "description": "The Sandbox is a community-driven platform where creators can monetize voxel assets and gaming experiences on the blockchain. The Sandbox metaverse comprises a map made up of 166,464 LANDS.  LAND owners can host contests and events, stake SAND to earn and customize assets, monetize assets and experiences, vote in the metaverse governance, play games that you or others create, and more! Trade the collection and keep your eyes peeled for future drops.",
                        "external_link": "https://www.sandbox.game/",
                        "image_url": "https://lh3.googleusercontent.com/SXH8tW1siikB80rwCRnjm1a5xM_MwTg9Xl9Db6mioIk9HIlDM09pVoSR7GKJgS6ulSUpgW9BDtMk_ePX_NKgO9A=s60",
                        "default_to_fiat": false,
                        "dev_buyer_fee_basis_points": 0,
                        "dev_seller_fee_basis_points": 500,
                        "only_proxied_transfers": false,
                        "opensea_buyer_fee_basis_points": 0,
                        "opensea_seller_fee_basis_points": 250,
                        "buyer_fee_basis_points": 0,
                        "seller_fee_basis_points": 750,
                        "payout_address": "0x7a9fe22691c811ea339d9b73150e6911a5343dca"
                    },
                    "owner": {
                        "user": {
                            "username": "REVOLT"
                        },
                        "profile_img_url": "https://storage.googleapis.com/opensea-static/opensea-profile/25.png",
                        "address": "0xb6d820e80a2a7c49f94c9d6c8ea08dccedc9ce4c",
                        "config": "",
                        "discord_id": ""
                    },
                    "permalink": "https://opensea.io/assets/0x50f5474724e0ee42d9a4e711ccfb275809fd6d4a/40216",
                    "collection": {
                        "banner_image_url": "https://lh3.googleusercontent.com/4NQIRoGmzXeXQN4mjuhWuuDZSNW7_BqRXux5upd4Nn_A-bfsGxCnPF8qn98Y6MyHRDPGXIlgfZADcSOe6M2DyrDKXdbdaTgkZN5l=s2500",
                        "chat_url": null,
                        "created_date": "2019-12-04T10:58:29.069907",
                        "default_to_fiat": false,
                        "description": "The Sandbox is a community-driven platform where creators can monetize voxel assets and gaming experiences on the blockchain. The Sandbox metaverse comprises a map made up of 166,464 LANDS.  LAND owners can host contests and events, stake SAND to earn and customize assets, monetize assets and experiences, vote in the metaverse governance, play games that you or others create, and more! Trade the collection and keep your eyes peeled for future drops.",
                        "dev_buyer_fee_basis_points": "0",
                        "dev_seller_fee_basis_points": "500",
                        "discord_url": "https://discord.gg/vAe4zvY",
                        "display_data": {
                            "card_display_style": "contain"
                        },
                        "external_url": "https://www.sandbox.game/",
                        "featured": false,
                        "featured_image_url": "https://storage.googleapis.com/opensea-static/featured-images/sandbox-featured.png",
                        "hidden": false,
                        "safelist_request_status": "verified",
                        "image_url": "https://lh3.googleusercontent.com/SXH8tW1siikB80rwCRnjm1a5xM_MwTg9Xl9Db6mioIk9HIlDM09pVoSR7GKJgS6ulSUpgW9BDtMk_ePX_NKgO9A=s60",
                        "is_subject_to_whitelist": false,
                        "large_image_url": "https://lh3.googleusercontent.com/SXH8tW1siikB80rwCRnjm1a5xM_MwTg9Xl9Db6mioIk9HIlDM09pVoSR7GKJgS6ulSUpgW9BDtMk_ePX_NKgO9A",
                        "medium_username": "sandbox-game",
                        "name": "The Sandbox",
                        "only_proxied_transfers": false,
                        "opensea_buyer_fee_basis_points": "0",
                        "opensea_seller_fee_basis_points": "250",
                        "payout_address": "0x7a9fe22691c811ea339d9b73150e6911a5343dca",
                        "require_email": false,
                        "short_description": null,
                        "slug": "sandbox",
                        "telegram_url": "https://t.me/sandboxgame",
                        "twitter_username": "thesandboxgame",
                        "instagram_username": null,
                        "wiki_url": null
                    },
                    "decimals": null,
                    "token_metadata": null
                },
                {
                    "id": 15811671,
                    "token_id": "40217",
                    "num_sales": 0,
                    "background_color": null,
                    "image_url": "https://storage.opensea.io/files/3faa959fa75531ac7913a9c9f8361b58.png",
                    "image_preview_url": "https://lh3.googleusercontent.com/17vU_UNWeMOVi4XOAwo4nvAXpeg1dnKPBk8VnAhJcFHOFZ9UBBvSL5Spj0ytvyfII3rdp4gHMY0mMvbnSzjdOZ0=s250",
                    "image_thumbnail_url": "https://lh3.googleusercontent.com/17vU_UNWeMOVi4XOAwo4nvAXpeg1dnKPBk8VnAhJcFHOFZ9UBBvSL5Spj0ytvyfII3rdp4gHMY0mMvbnSzjdOZ0=s128",
                    "image_original_url": "https://storage.googleapis.com/opensea-static/custom-fetcher-images/sandbox/land/sandbox-land.png",
                    "animation_url": null,
                    "animation_original_url": null,
                    "name": "LAND (29, -106)",
                    "description": "A LAND is a digital piece of real estate in The Sandbox metaverse that players can buy to build experiences on top of. Once you own a LAND, you will be able to populate it with Games and Assets. Each LAND is a unique (non-fungible) token lying on the public Ethereum blockchain (ERC-721).",
                    "external_link": "https://www.sandbox.game/en/map/?x=29&y=-106",
                    "asset_contract": {
                        "address": "0x50f5474724e0ee42d9a4e711ccfb275809fd6d4a",
                        "asset_contract_type": "non-fungible",
                        "created_date": "2019-12-04T10:58:28.892990",
                        "name": "Sandbox's LANDs",
                        "nft_version": "3.0",
                        "opensea_version": null,
                        "owner": null,
                        "schema_name": "ERC721",
                        "symbol": "",
                        "total_supply": null,
                        "description": "The Sandbox is a community-driven platform where creators can monetize voxel assets and gaming experiences on the blockchain. The Sandbox metaverse comprises a map made up of 166,464 LANDS.  LAND owners can host contests and events, stake SAND to earn and customize assets, monetize assets and experiences, vote in the metaverse governance, play games that you or others create, and more! Trade the collection and keep your eyes peeled for future drops.",
                        "external_link": "https://www.sandbox.game/",
                        "image_url": "https://lh3.googleusercontent.com/SXH8tW1siikB80rwCRnjm1a5xM_MwTg9Xl9Db6mioIk9HIlDM09pVoSR7GKJgS6ulSUpgW9BDtMk_ePX_NKgO9A=s60",
                        "default_to_fiat": false,
                        "dev_buyer_fee_basis_points": 0,
                        "dev_seller_fee_basis_points": 500,
                        "only_proxied_transfers": false,
                        "opensea_buyer_fee_basis_points": 0,
                        "opensea_seller_fee_basis_points": 250,
                        "buyer_fee_basis_points": 0,
                        "seller_fee_basis_points": 750,
                        "payout_address": "0x7a9fe22691c811ea339d9b73150e6911a5343dca"
                    },
                    "owner": {
                        "user": {
                            "username": "REVOLT"
                        },
                        "profile_img_url": "https://storage.googleapis.com/opensea-static/opensea-profile/25.png",
                        "address": "0xb6d820e80a2a7c49f94c9d6c8ea08dccedc9ce4c",
                        "config": "",
                        "discord_id": ""
                    },
                    "permalink": "https://opensea.io/assets/0x50f5474724e0ee42d9a4e711ccfb275809fd6d4a/40217",
                    "collection": {
                        "banner_image_url": "https://lh3.googleusercontent.com/4NQIRoGmzXeXQN4mjuhWuuDZSNW7_BqRXux5upd4Nn_A-bfsGxCnPF8qn98Y6MyHRDPGXIlgfZADcSOe6M2DyrDKXdbdaTgkZN5l=s2500",
                        "chat_url": null,
                        "created_date": "2019-12-04T10:58:29.069907",
                        "default_to_fiat": false,
                        "description": "The Sandbox is a community-driven platform where creators can monetize voxel assets and gaming experiences on the blockchain. The Sandbox metaverse comprises a map made up of 166,464 LANDS.  LAND owners can host contests and events, stake SAND to earn and customize assets, monetize assets and experiences, vote in the metaverse governance, play games that you or others create, and more! Trade the collection and keep your eyes peeled for future drops.",
                        "dev_buyer_fee_basis_points": "0",
                        "dev_seller_fee_basis_points": "500",
                        "discord_url": "https://discord.gg/vAe4zvY",
                        "display_data": {
                            "card_display_style": "contain"
                        },
                        "external_url": "https://www.sandbox.game/",
                        "featured": false,
                        "featured_image_url": "https://storage.googleapis.com/opensea-static/featured-images/sandbox-featured.png",
                        "hidden": false,
                        "safelist_request_status": "verified",
                        "image_url": "https://lh3.googleusercontent.com/SXH8tW1siikB80rwCRnjm1a5xM_MwTg9Xl9Db6mioIk9HIlDM09pVoSR7GKJgS6ulSUpgW9BDtMk_ePX_NKgO9A=s60",
                        "is_subject_to_whitelist": false,
                        "large_image_url": "https://lh3.googleusercontent.com/SXH8tW1siikB80rwCRnjm1a5xM_MwTg9Xl9Db6mioIk9HIlDM09pVoSR7GKJgS6ulSUpgW9BDtMk_ePX_NKgO9A",
                        "medium_username": "sandbox-game",
                        "name": "The Sandbox",
                        "only_proxied_transfers": false,
                        "opensea_buyer_fee_basis_points": "0",
                        "opensea_seller_fee_basis_points": "250",
                        "payout_address": "0x7a9fe22691c811ea339d9b73150e6911a5343dca",
                        "require_email": false,
                        "short_description": null,
                        "slug": "sandbox",
                        "telegram_url": "https://t.me/sandboxgame",
                        "twitter_username": "thesandboxgame",
                        "instagram_username": null,
                        "wiki_url": null
                    },
                    "decimals": null,
                    "token_metadata": null
                }
            ],
            "name": "Small estate (9 lands)",
            "description": "Yes, you can afford it :o))",
            "external_link": "",
            "asset_contract": {
                "collection": {
                    "banner_image_url": "https://lh3.googleusercontent.com/4NQIRoGmzXeXQN4mjuhWuuDZSNW7_BqRXux5upd4Nn_A-bfsGxCnPF8qn98Y6MyHRDPGXIlgfZADcSOe6M2DyrDKXdbdaTgkZN5l=s2500",
                    "chat_url": null,
                    "created_date": "2019-12-04T10:58:29.069907",
                    "default_to_fiat": false,
                    "description": "The Sandbox is a community-driven platform where creators can monetize voxel assets and gaming experiences on the blockchain. The Sandbox metaverse comprises a map made up of 166,464 LANDS.  LAND owners can host contests and events, stake SAND to earn and customize assets, monetize assets and experiences, vote in the metaverse governance, play games that you or others create, and more! Trade the collection and keep your eyes peeled for future drops.",
                    "dev_buyer_fee_basis_points": "0",
                    "dev_seller_fee_basis_points": "500",
                    "discord_url": "https://discord.gg/vAe4zvY",
                    "display_data": {
                        "card_display_style": "contain"
                    },
                    "external_url": "https://www.sandbox.game/",
                    "featured": false,
                    "featured_image_url": "https://storage.googleapis.com/opensea-static/featured-images/sandbox-featured.png",
                    "hidden": false,
                    "safelist_request_status": "verified",
                    "image_url": "https://lh3.googleusercontent.com/SXH8tW1siikB80rwCRnjm1a5xM_MwTg9Xl9Db6mioIk9HIlDM09pVoSR7GKJgS6ulSUpgW9BDtMk_ePX_NKgO9A=s60",
                    "is_subject_to_whitelist": false,
                    "large_image_url": "https://lh3.googleusercontent.com/SXH8tW1siikB80rwCRnjm1a5xM_MwTg9Xl9Db6mioIk9HIlDM09pVoSR7GKJgS6ulSUpgW9BDtMk_ePX_NKgO9A",
                    "medium_username": "sandbox-game",
                    "name": "The Sandbox",
                    "only_proxied_transfers": false,
                    "opensea_buyer_fee_basis_points": "0",
                    "opensea_seller_fee_basis_points": "250",
                    "payout_address": "0x7a9fe22691c811ea339d9b73150e6911a5343dca",
                    "require_email": false,
                    "short_description": null,
                    "slug": "sandbox",
                    "telegram_url": "https://t.me/sandboxgame",
                    "twitter_username": "thesandboxgame",
                    "instagram_username": null,
                    "wiki_url": null
                },
                "address": "0x50f5474724e0ee42d9a4e711ccfb275809fd6d4a",
                "asset_contract_type": "non-fungible",
                "created_date": "2019-12-04T10:58:28.892990",
                "name": "Sandbox's LANDs",
                "nft_version": "3.0",
                "opensea_version": null,
                "owner": null,
                "schema_name": "ERC721",
                "symbol": "",
                "total_supply": null,
                "description": "The Sandbox is a community-driven platform where creators can monetize voxel assets and gaming experiences on the blockchain. The Sandbox metaverse comprises a map made up of 166,464 LANDS.  LAND owners can host contests and events, stake SAND to earn and customize assets, monetize assets and experiences, vote in the metaverse governance, play games that you or others create, and more! Trade the collection and keep your eyes peeled for future drops.",
                "external_link": "https://www.sandbox.game/",
                "image_url": "https://lh3.googleusercontent.com/SXH8tW1siikB80rwCRnjm1a5xM_MwTg9Xl9Db6mioIk9HIlDM09pVoSR7GKJgS6ulSUpgW9BDtMk_ePX_NKgO9A=s60",
                "default_to_fiat": false,
                "dev_buyer_fee_basis_points": 0,
                "dev_seller_fee_basis_points": 500,
                "only_proxied_transfers": false,
                "opensea_buyer_fee_basis_points": 0,
                "opensea_seller_fee_basis_points": 250,
                "buyer_fee_basis_points": 0,
                "seller_fee_basis_points": 750,
                "payout_address": "0x7a9fe22691c811ea339d9b73150e6911a5343dca"
            },
            "permalink": "https://opensea.io/bundles/small-estate-9-lands-xh2",
            "sell_orders": [
                {
                    "created_date": "2021-05-25T21:49:28.539357",
                    "closing_date": null,
                    "closing_extendable": false,
                    "expiration_time": 0,
                    "listing_time": 1621979261,
                    "order_hash": "0x196d7e49f218492f50c5158dac536658b8dc625cad5075e2e252ddcecc12af85",
                    "metadata": {
                        "bundle": {
                            "assets": [
                                {
                                    "id": "39399",
                                    "address": "0x50f5474724e0ee42d9a4e711ccfb275809fd6d4a"
                                },
                                {
                                    "id": "39400",
                                    "address": "0x50f5474724e0ee42d9a4e711ccfb275809fd6d4a"
                                },
                                {
                                    "id": "39401",
                                    "address": "0x50f5474724e0ee42d9a4e711ccfb275809fd6d4a"
                                },
                                {
                                    "id": "39807",
                                    "address": "0x50f5474724e0ee42d9a4e711ccfb275809fd6d4a"
                                },
                                {
                                    "id": "39808",
                                    "address": "0x50f5474724e0ee42d9a4e711ccfb275809fd6d4a"
                                },
                                {
                                    "id": "39809",
                                    "address": "0x50f5474724e0ee42d9a4e711ccfb275809fd6d4a"
                                },
                                {
                                    "id": "40215",
                                    "address": "0x50f5474724e0ee42d9a4e711ccfb275809fd6d4a"
                                },
                                {
                                    "id": "40216",
                                    "address": "0x50f5474724e0ee42d9a4e711ccfb275809fd6d4a"
                                },
                                {
                                    "id": "40217",
                                    "address": "0x50f5474724e0ee42d9a4e711ccfb275809fd6d4a"
                                }
                            ],
                            "schemas": [
                                "ERC721",
                                "ERC721",
                                "ERC721",
                                "ERC721",
                                "ERC721",
                                "ERC721",
                                "ERC721",
                                "ERC721",
                                "ERC721"
                            ],
                            "name": "Small estate (9 lands)",
                            "description": "Yes, you can afford it :o))",
                            "external_link": ""
                        }
                    },
                    "exchange": "0x7be8076f4ea4a4ad08075c2508e481d6c946d12b",
                    "maker": {
                        "user": 3797,
                        "profile_img_url": "https://storage.googleapis.com/opensea-static/opensea-profile/25.png",
                        "address": "0xb6d820e80a2a7c49f94c9d6c8ea08dccedc9ce4c",
                        "config": "",
                        "discord_id": ""
                    },
                    "taker": {
                        "user": 1766,
                        "profile_img_url": "https://storage.googleapis.com/opensea-static/opensea-profile/1.png",
                        "address": "0x0000000000000000000000000000000000000000",
                        "config": "",
                        "discord_id": ""
                    },
                    "current_price": "135000000000000000000",
                    "current_bounty": "1350000000000000000",
                    "bounty_multiple": "0.01",
                    "maker_relayer_fee": "750",
                    "taker_relayer_fee": "0",
                    "maker_protocol_fee": "0",
                    "taker_protocol_fee": "0",
                    "maker_referrer_fee": "0",
                    "fee_recipient": {
                        "user": 3585,
                        "profile_img_url": "https://storage.googleapis.com/opensea-static/opensea-profile/28.png",
                        "address": "0x5b3256965e7c3cf26e11fcaf296dfc8807c01073",
                        "config": "verified",
                        "discord_id": ""
                    },
                    "fee_method": 1,
                    "side": 1,
                    "sale_kind": 0,
                    "target": "0xc99f70bfd82fb7c8f8191fdfbfb735606b15e5c5",
                    "how_to_call": 1,
                    "calldata": "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",
                    "replacement_pattern": "0x0000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000ffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffff0000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000ffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffff0000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000ffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffff0000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000ffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffff0000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000ffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffff0000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000ffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffff0000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000ffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffff0000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000ffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffff0000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000ffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffff000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000",
                    "static_target": "0x0000000000000000000000000000000000000000",
                    "static_extradata": "0x",
                    "payment_token": "0x0000000000000000000000000000000000000000",
                    "payment_token_contract": {
                        "id": 1,
                        "symbol": "ETH",
                        "address": "0x0000000000000000000000000000000000000000",
                        "image_url": "https://storage.opensea.io/files/6f8e2979d428180222796ff4a33ab929.svg",
                        "name": "Ether",
                        "decimals": 18,
                        "eth_price": "1.000000000000000",
                        "usd_price": "2625.730000000000018000"
                    },
                    "base_price": "135000000000000000000",
                    "extra": "0",
                    "quantity": "1",
                    "salt": "80279138577308095190584397585401398490605461720484803458371937296874867611333",
                    "v": 28,
                    "r": "0xee27061ff7676d0a78ddf493f574cf6ac7086af808482cc7c5a3a455f607ea77",
                    "s": "0x5aa2708cc91bc3c7927ff1894f0540e1e8ca5d5643406abe2526b44b09b50b9e",
                    "approved_on_chain": false,
                    "cancelled": false,
                    "finalized": false,
                    "marked_invalid": false,
                    "prefixed_hash": "0xf7d253d119bb76666758e8254bbada4ec7ef0a22f8326eea5489c95c71538a5c"
                }
            ]
        },
        {
            "maker": {
                "user": {
                    "username": "P0PO"
                },
                "profile_img_url": "https://storage.googleapis.com/opensea-static/opensea-profile/8.png",
                "address": "0x316b95c5f0e524506109ce31034be825efccd1c8",
                "config": "",
                "discord_id": ""
            },
            "slug": "bo-hp1-de4",
            "assets": [
                {
                    "id": 25663551,
                    "token_id": "22353415913195718866916132271470535644201359484565030950018323996777230893057",
                    "num_sales": 0,
                    "background_color": null,
                    "image_url": "https://lh3.googleusercontent.com/iy9gxWpyrTHccOM_ADOikKoSQZBPOvbfR-i5tCrY19AW_tjXruhW13vBiU-fe-xawlU-RpnggGL7ffGG4bSmrxfdNd1t_VWx8ieV0w",
                    "image_preview_url": "https://lh3.googleusercontent.com/iy9gxWpyrTHccOM_ADOikKoSQZBPOvbfR-i5tCrY19AW_tjXruhW13vBiU-fe-xawlU-RpnggGL7ffGG4bSmrxfdNd1t_VWx8ieV0w=s250",
                    "image_thumbnail_url": "https://lh3.googleusercontent.com/iy9gxWpyrTHccOM_ADOikKoSQZBPOvbfR-i5tCrY19AW_tjXruhW13vBiU-fe-xawlU-RpnggGL7ffGG4bSmrxfdNd1t_VWx8ieV0w=s128",
                    "image_original_url": null,
                    "animation_url": null,
                    "animation_original_url": null,
                    "name": "BO-1",
                    "description": null,
                    "external_link": null,
                    "asset_contract": {
                        "address": "0x495f947276749ce646f68ac8c248420045cb7b5e",
                        "asset_contract_type": "semi-fungible",
                        "created_date": "2020-12-02T17:40:53.232025",
                        "name": "OpenSea Collection",
                        "nft_version": null,
                        "opensea_version": "2.0.0",
                        "owner": 102384,
                        "schema_name": "ERC1155",
                        "symbol": "OPENSTORE",
                        "total_supply": null,
                        "description": null,
                        "external_link": null,
                        "image_url": null,
                        "default_to_fiat": false,
                        "dev_buyer_fee_basis_points": 0,
                        "dev_seller_fee_basis_points": 0,
                        "only_proxied_transfers": false,
                        "opensea_buyer_fee_basis_points": 0,
                        "opensea_seller_fee_basis_points": 250,
                        "buyer_fee_basis_points": 0,
                        "seller_fee_basis_points": 250,
                        "payout_address": null
                    },
                    "owner": {
                        "user": {
                            "username": "NullAddress"
                        },
                        "profile_img_url": "https://storage.googleapis.com/opensea-static/opensea-profile/1.png",
                        "address": "0x0000000000000000000000000000000000000000",
                        "config": "",
                        "discord_id": ""
                    },
                    "permalink": "https://opensea.io/assets/0x495f947276749ce646f68ac8c248420045cb7b5e/22353415913195718866916132271470535644201359484565030950018323996777230893057",
                    "collection": {
                        "banner_image_url": null,
                        "chat_url": null,
                        "created_date": "2021-05-02T21:12:12.789428",
                        "default_to_fiat": false,
                        "description": "Unique collection of digital art.",
                        "dev_buyer_fee_basis_points": "0",
                        "dev_seller_fee_basis_points": "0",
                        "discord_url": null,
                        "display_data": {
                            "card_display_style": "contain"
                        },
                        "external_url": null,
                        "featured": false,
                        "featured_image_url": null,
                        "hidden": true,
                        "safelist_request_status": "not_requested",
                        "image_url": "https://lh3.googleusercontent.com/rscsxUmE0BWQJNGdT1jjjbrtRzxJBckBIxhtCWwp8dMMI4qeY_Uk_NAVvoxJuDnvAmjQlvItm4AX9RZLRBkLTK0JmQkIQ8aI1sbtKCU=s120",
                        "is_subject_to_whitelist": false,
                        "large_image_url": null,
                        "medium_username": null,
                        "name": "SiS - Still in Style",
                        "only_proxied_transfers": false,
                        "opensea_buyer_fee_basis_points": "0",
                        "opensea_seller_fee_basis_points": "250",
                        "payout_address": null,
                        "require_email": false,
                        "short_description": null,
                        "slug": "popos",
                        "telegram_url": null,
                        "twitter_username": null,
                        "instagram_username": null,
                        "wiki_url": null
                    },
                    "decimals": null,
                    "token_metadata": null
                },
                {
                    "id": 25663584,
                    "token_id": "22353415913195718866916132271470535644201359484565030950018323997876742520833",
                    "num_sales": 0,
                    "background_color": null,
                    "image_url": "https://lh3.googleusercontent.com/bMlUb452pAo0p3GxSeI-RC62v8BzSnNaXEXGDOlZ1qbUomnkctUtgEXDYbwegnXcjV9-sE14CMfl28WxWnIWD14URqTeP-iFKe8dO-Y",
                    "image_preview_url": "https://lh3.googleusercontent.com/bMlUb452pAo0p3GxSeI-RC62v8BzSnNaXEXGDOlZ1qbUomnkctUtgEXDYbwegnXcjV9-sE14CMfl28WxWnIWD14URqTeP-iFKe8dO-Y=s250",
                    "image_thumbnail_url": "https://lh3.googleusercontent.com/bMlUb452pAo0p3GxSeI-RC62v8BzSnNaXEXGDOlZ1qbUomnkctUtgEXDYbwegnXcjV9-sE14CMfl28WxWnIWD14URqTeP-iFKe8dO-Y=s128",
                    "image_original_url": null,
                    "animation_url": null,
                    "animation_original_url": null,
                    "name": "BO-2",
                    "description": null,
                    "external_link": null,
                    "asset_contract": {
                        "address": "0x495f947276749ce646f68ac8c248420045cb7b5e",
                        "asset_contract_type": "semi-fungible",
                        "created_date": "2020-12-02T17:40:53.232025",
                        "name": "OpenSea Collection",
                        "nft_version": null,
                        "opensea_version": "2.0.0",
                        "owner": 102384,
                        "schema_name": "ERC1155",
                        "symbol": "OPENSTORE",
                        "total_supply": null,
                        "description": null,
                        "external_link": null,
                        "image_url": null,
                        "default_to_fiat": false,
                        "dev_buyer_fee_basis_points": 0,
                        "dev_seller_fee_basis_points": 0,
                        "only_proxied_transfers": false,
                        "opensea_buyer_fee_basis_points": 0,
                        "opensea_seller_fee_basis_points": 250,
                        "buyer_fee_basis_points": 0,
                        "seller_fee_basis_points": 250,
                        "payout_address": null
                    },
                    "owner": {
                        "user": {
                            "username": "NullAddress"
                        },
                        "profile_img_url": "https://storage.googleapis.com/opensea-static/opensea-profile/1.png",
                        "address": "0x0000000000000000000000000000000000000000",
                        "config": "",
                        "discord_id": ""
                    },
                    "permalink": "https://opensea.io/assets/0x495f947276749ce646f68ac8c248420045cb7b5e/22353415913195718866916132271470535644201359484565030950018323997876742520833",
                    "collection": {
                        "banner_image_url": null,
                        "chat_url": null,
                        "created_date": "2021-05-02T21:12:12.789428",
                        "default_to_fiat": false,
                        "description": "Unique collection of digital art.",
                        "dev_buyer_fee_basis_points": "0",
                        "dev_seller_fee_basis_points": "0",
                        "discord_url": null,
                        "display_data": {
                            "card_display_style": "contain"
                        },
                        "external_url": null,
                        "featured": false,
                        "featured_image_url": null,
                        "hidden": true,
                        "safelist_request_status": "not_requested",
                        "image_url": "https://lh3.googleusercontent.com/rscsxUmE0BWQJNGdT1jjjbrtRzxJBckBIxhtCWwp8dMMI4qeY_Uk_NAVvoxJuDnvAmjQlvItm4AX9RZLRBkLTK0JmQkIQ8aI1sbtKCU=s120",
                        "is_subject_to_whitelist": false,
                        "large_image_url": null,
                        "medium_username": null,
                        "name": "SiS - Still in Style",
                        "only_proxied_transfers": false,
                        "opensea_buyer_fee_basis_points": "0",
                        "opensea_seller_fee_basis_points": "250",
                        "payout_address": null,
                        "require_email": false,
                        "short_description": null,
                        "slug": "popos",
                        "telegram_url": null,
                        "twitter_username": null,
                        "instagram_username": null,
                        "wiki_url": null
                    },
                    "decimals": null,
                    "token_metadata": null
                },
                {
                    "id": 25663602,
                    "token_id": "22353415913195718866916132271470535644201359484565030950018323998976254148609",
                    "num_sales": 0,
                    "background_color": null,
                    "image_url": "https://lh3.googleusercontent.com/6Xw9KVbkFt5xYq6goLP1MSg2tWtA8LS9QWoYUILXDgNkMISmc7WUR4_G0lx4PjaSLVyCH2HdFLa9jF7lppk-9dTbiAxHP0GHS6MRzNI",
                    "image_preview_url": "https://lh3.googleusercontent.com/6Xw9KVbkFt5xYq6goLP1MSg2tWtA8LS9QWoYUILXDgNkMISmc7WUR4_G0lx4PjaSLVyCH2HdFLa9jF7lppk-9dTbiAxHP0GHS6MRzNI=s250",
                    "image_thumbnail_url": "https://lh3.googleusercontent.com/6Xw9KVbkFt5xYq6goLP1MSg2tWtA8LS9QWoYUILXDgNkMISmc7WUR4_G0lx4PjaSLVyCH2HdFLa9jF7lppk-9dTbiAxHP0GHS6MRzNI=s128",
                    "image_original_url": null,
                    "animation_url": null,
                    "animation_original_url": null,
                    "name": "BO-3",
                    "description": null,
                    "external_link": null,
                    "asset_contract": {
                        "address": "0x495f947276749ce646f68ac8c248420045cb7b5e",
                        "asset_contract_type": "semi-fungible",
                        "created_date": "2020-12-02T17:40:53.232025",
                        "name": "OpenSea Collection",
                        "nft_version": null,
                        "opensea_version": "2.0.0",
                        "owner": 102384,
                        "schema_name": "ERC1155",
                        "symbol": "OPENSTORE",
                        "total_supply": null,
                        "description": null,
                        "external_link": null,
                        "image_url": null,
                        "default_to_fiat": false,
                        "dev_buyer_fee_basis_points": 0,
                        "dev_seller_fee_basis_points": 0,
                        "only_proxied_transfers": false,
                        "opensea_buyer_fee_basis_points": 0,
                        "opensea_seller_fee_basis_points": 250,
                        "buyer_fee_basis_points": 0,
                        "seller_fee_basis_points": 250,
                        "payout_address": null
                    },
                    "owner": {
                        "user": {
                            "username": "NullAddress"
                        },
                        "profile_img_url": "https://storage.googleapis.com/opensea-static/opensea-profile/1.png",
                        "address": "0x0000000000000000000000000000000000000000",
                        "config": "",
                        "discord_id": ""
                    },
                    "permalink": "https://opensea.io/assets/0x495f947276749ce646f68ac8c248420045cb7b5e/22353415913195718866916132271470535644201359484565030950018323998976254148609",
                    "collection": {
                        "banner_image_url": null,
                        "chat_url": null,
                        "created_date": "2021-05-02T21:12:12.789428",
                        "default_to_fiat": false,
                        "description": "Unique collection of digital art.",
                        "dev_buyer_fee_basis_points": "0",
                        "dev_seller_fee_basis_points": "0",
                        "discord_url": null,
                        "display_data": {
                            "card_display_style": "contain"
                        },
                        "external_url": null,
                        "featured": false,
                        "featured_image_url": null,
                        "hidden": true,
                        "safelist_request_status": "not_requested",
                        "image_url": "https://lh3.googleusercontent.com/rscsxUmE0BWQJNGdT1jjjbrtRzxJBckBIxhtCWwp8dMMI4qeY_Uk_NAVvoxJuDnvAmjQlvItm4AX9RZLRBkLTK0JmQkIQ8aI1sbtKCU=s120",
                        "is_subject_to_whitelist": false,
                        "large_image_url": null,
                        "medium_username": null,
                        "name": "SiS - Still in Style",
                        "only_proxied_transfers": false,
                        "opensea_buyer_fee_basis_points": "0",
                        "opensea_seller_fee_basis_points": "250",
                        "payout_address": null,
                        "require_email": false,
                        "short_description": null,
                        "slug": "popos",
                        "telegram_url": null,
                        "twitter_username": null,
                        "instagram_username": null,
                        "wiki_url": null
                    },
                    "decimals": null,
                    "token_metadata": null
                }
            ],
            "name": "BO-HP1",
            "description": "",
            "external_link": "",
            "asset_contract": {
                "collection": {
                    "banner_image_url": null,
                    "chat_url": null,
                    "created_date": "2020-12-02T17:40:53.507540",
                    "default_to_fiat": false,
                    "description": null,
                    "dev_buyer_fee_basis_points": "0",
                    "dev_seller_fee_basis_points": "0",
                    "discord_url": null,
                    "display_data": {
                        "card_display_style": "contain",
                        "images": []
                    },
                    "external_url": null,
                    "featured": false,
                    "featured_image_url": null,
                    "hidden": true,
                    "safelist_request_status": "not_requested",
                    "image_url": null,
                    "is_subject_to_whitelist": false,
                    "large_image_url": null,
                    "medium_username": null,
                    "name": "OpenSea Shared Storefront V2",
                    "only_proxied_transfers": false,
                    "opensea_buyer_fee_basis_points": "0",
                    "opensea_seller_fee_basis_points": "250",
                    "payout_address": null,
                    "require_email": false,
                    "short_description": null,
                    "slug": "opensea-shared-storefront-v2",
                    "telegram_url": null,
                    "twitter_username": null,
                    "instagram_username": null,
                    "wiki_url": null
                },
                "address": "0x495f947276749ce646f68ac8c248420045cb7b5e",
                "asset_contract_type": "semi-fungible",
                "created_date": "2020-12-02T17:40:53.232025",
                "name": "OpenSea Collection",
                "nft_version": null,
                "opensea_version": "2.0.0",
                "owner": 102384,
                "schema_name": "ERC1155",
                "symbol": "OPENSTORE",
                "total_supply": null,
                "description": null,
                "external_link": null,
                "image_url": null,
                "default_to_fiat": false,
                "dev_buyer_fee_basis_points": 0,
                "dev_seller_fee_basis_points": 0,
                "only_proxied_transfers": false,
                "opensea_buyer_fee_basis_points": 0,
                "opensea_seller_fee_basis_points": 250,
                "buyer_fee_basis_points": 0,
                "seller_fee_basis_points": 250,
                "payout_address": null
            },
            "permalink": "https://opensea.io/bundles/bo-hp1-de4",
            "sell_orders": [
                {
                    "created_date": "2021-05-25T21:47:42.514865",
                    "closing_date": null,
                    "closing_extendable": false,
                    "expiration_time": 0,
                    "listing_time": 1621979154,
                    "order_hash": "0x6811ff034e1c3e106cef99fcfa0d867594e565461fd5bf756f7edb49156736f1",
                    "metadata": {
                        "bundle": {
                            "assets": [
                                {
                                    "id": "22353415913195718866916132271470535644201359484565030950018323996777230893057",
                                    "address": "0x495f947276749ce646f68ac8c248420045cb7b5e",
                                    "quantity": "1"
                                },
                                {
                                    "id": "22353415913195718866916132271470535644201359484565030950018323997876742520833",
                                    "address": "0x495f947276749ce646f68ac8c248420045cb7b5e",
                                    "quantity": "1"
                                },
                                {
                                    "id": "22353415913195718866916132271470535644201359484565030950018323998976254148609",
                                    "address": "0x495f947276749ce646f68ac8c248420045cb7b5e",
                                    "quantity": "1"
                                }
                            ],
                            "schemas": [
                                "ERC1155",
                                "ERC1155",
                                "ERC1155"
                            ],
                            "name": "BO-HP1",
                            "description": "",
                            "external_link": ""
                        }
                    },
                    "exchange": "0x7be8076f4ea4a4ad08075c2508e481d6c946d12b",
                    "maker": {
                        "user": 699747,
                        "profile_img_url": "https://storage.googleapis.com/opensea-static/opensea-profile/8.png",
                        "address": "0x316b95c5f0e524506109ce31034be825efccd1c8",
                        "config": "",
                        "discord_id": ""
                    },
                    "taker": {
                        "user": 1766,
                        "profile_img_url": "https://storage.googleapis.com/opensea-static/opensea-profile/1.png",
                        "address": "0x0000000000000000000000000000000000000000",
                        "config": "",
                        "discord_id": ""
                    },
                    "current_price": "1000000000000000000",
                    "current_bounty": "10000000000000000",
                    "bounty_multiple": "0.01",
                    "maker_relayer_fee": "250",
                    "taker_relayer_fee": "0",
                    "maker_protocol_fee": "0",
                    "taker_protocol_fee": "0",
                    "maker_referrer_fee": "0",
                    "fee_recipient": {
                        "user": 3585,
                        "profile_img_url": "https://storage.googleapis.com/opensea-static/opensea-profile/28.png",
                        "address": "0x5b3256965e7c3cf26e11fcaf296dfc8807c01073",
                        "config": "verified",
                        "discord_id": ""
                    },
                    "fee_method": 1,
                    "side": 1,
                    "sale_kind": 0,
                    "target": "0xc99f70bfd82fb7c8f8191fdfbfb735606b15e5c5",
                    "how_to_call": 1,
                    "calldata": "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",
                    "replacement_pattern": "0x0000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000ffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffff0000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000ffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffff0000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000ffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffff00000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000",
                    "static_target": "0x0000000000000000000000000000000000000000",
                    "static_extradata": "0x",
                    "payment_token": "0x0000000000000000000000000000000000000000",
                    "payment_token_contract": {
                        "id": 1,
                        "symbol": "ETH",
                        "address": "0x0000000000000000000000000000000000000000",
                        "image_url": "https://storage.opensea.io/files/6f8e2979d428180222796ff4a33ab929.svg",
                        "name": "Ether",
                        "decimals": 18,
                        "eth_price": "1.000000000000000",
                        "usd_price": "2625.730000000000018000"
                    },
                    "base_price": "1000000000000000000",
                    "extra": "0",
                    "quantity": "1",
                    "salt": "10076705126744834839900575801572626346431065045683462062796650993256486214867",
                    "v": 28,
                    "r": "0x54e1b9f5e19e067b049c542d5fcd5a9f16d3eb2e380e5b0ef7292d0f82564655",
                    "s": "0x3af58e9035adecb2cfba84d3eb098c4cca8c8fd57b1870d8f01743334ec894a7",
                    "approved_on_chain": false,
                    "cancelled": false,
                    "finalized": false,
                    "marked_invalid": false,
                    "prefixed_hash": "0x6a0caff8d09cc3d9e5f3a676dbdeef1f63f809e3cd6f217a5b60fd688f68039c"
                }
            ]
        },
        {
            "maker": {
                "user": {
                    "username": "REVOLT"
                },
                "profile_img_url": "https://storage.googleapis.com/opensea-static/opensea-profile/25.png",
                "address": "0xb6d820e80a2a7c49f94c9d6c8ea08dccedc9ce4c",
                "config": "",
                "discord_id": ""
            },
            "slug": "small-estate-9-lands-caP",
            "assets": [
                {
                    "id": 15816677,
                    "token_id": "38181",
                    "num_sales": 0,
                    "background_color": null,
                    "image_url": "https://storage.opensea.io/files/3faa959fa75531ac7913a9c9f8361b58.png",
                    "image_preview_url": "https://lh3.googleusercontent.com/17vU_UNWeMOVi4XOAwo4nvAXpeg1dnKPBk8VnAhJcFHOFZ9UBBvSL5Spj0ytvyfII3rdp4gHMY0mMvbnSzjdOZ0=s250",
                    "image_thumbnail_url": "https://lh3.googleusercontent.com/17vU_UNWeMOVi4XOAwo4nvAXpeg1dnKPBk8VnAhJcFHOFZ9UBBvSL5Spj0ytvyfII3rdp4gHMY0mMvbnSzjdOZ0=s128",
                    "image_original_url": "https://storage.googleapis.com/opensea-static/custom-fetcher-images/sandbox/land/sandbox-land.png",
                    "animation_url": null,
                    "animation_original_url": null,
                    "name": "LAND (33, -111)",
                    "description": "A LAND is a digital piece of real estate in The Sandbox metaverse that players can buy to build experiences on top of. Once you own a LAND, you will be able to populate it with Games and Assets. Each LAND is a unique (non-fungible) token lying on the public Ethereum blockchain (ERC-721).",
                    "external_link": "https://www.sandbox.game/en/map/?x=33&y=-111",
                    "asset_contract": {
                        "address": "0x50f5474724e0ee42d9a4e711ccfb275809fd6d4a",
                        "asset_contract_type": "non-fungible",
                        "created_date": "2019-12-04T10:58:28.892990",
                        "name": "Sandbox's LANDs",
                        "nft_version": "3.0",
                        "opensea_version": null,
                        "owner": null,
                        "schema_name": "ERC721",
                        "symbol": "",
                        "total_supply": null,
                        "description": "The Sandbox is a community-driven platform where creators can monetize voxel assets and gaming experiences on the blockchain. The Sandbox metaverse comprises a map made up of 166,464 LANDS.  LAND owners can host contests and events, stake SAND to earn and customize assets, monetize assets and experiences, vote in the metaverse governance, play games that you or others create, and more! Trade the collection and keep your eyes peeled for future drops.",
                        "external_link": "https://www.sandbox.game/",
                        "image_url": "https://lh3.googleusercontent.com/SXH8tW1siikB80rwCRnjm1a5xM_MwTg9Xl9Db6mioIk9HIlDM09pVoSR7GKJgS6ulSUpgW9BDtMk_ePX_NKgO9A=s60",
                        "default_to_fiat": false,
                        "dev_buyer_fee_basis_points": 0,
                        "dev_seller_fee_basis_points": 500,
                        "only_proxied_transfers": false,
                        "opensea_buyer_fee_basis_points": 0,
                        "opensea_seller_fee_basis_points": 250,
                        "buyer_fee_basis_points": 0,
                        "seller_fee_basis_points": 750,
                        "payout_address": "0x7a9fe22691c811ea339d9b73150e6911a5343dca"
                    },
                    "owner": {
                        "user": {
                            "username": "REVOLT"
                        },
                        "profile_img_url": "https://storage.googleapis.com/opensea-static/opensea-profile/25.png",
                        "address": "0xb6d820e80a2a7c49f94c9d6c8ea08dccedc9ce4c",
                        "config": "",
                        "discord_id": ""
                    },
                    "permalink": "https://opensea.io/assets/0x50f5474724e0ee42d9a4e711ccfb275809fd6d4a/38181",
                    "collection": {
                        "banner_image_url": "https://lh3.googleusercontent.com/4NQIRoGmzXeXQN4mjuhWuuDZSNW7_BqRXux5upd4Nn_A-bfsGxCnPF8qn98Y6MyHRDPGXIlgfZADcSOe6M2DyrDKXdbdaTgkZN5l=s2500",
                        "chat_url": null,
                        "created_date": "2019-12-04T10:58:29.069907",
                        "default_to_fiat": false,
                        "description": "The Sandbox is a community-driven platform where creators can monetize voxel assets and gaming experiences on the blockchain. The Sandbox metaverse comprises a map made up of 166,464 LANDS.  LAND owners can host contests and events, stake SAND to earn and customize assets, monetize assets and experiences, vote in the metaverse governance, play games that you or others create, and more! Trade the collection and keep your eyes peeled for future drops.",
                        "dev_buyer_fee_basis_points": "0",
                        "dev_seller_fee_basis_points": "500",
                        "discord_url": "https://discord.gg/vAe4zvY",
                        "display_data": {
                            "card_display_style": "contain"
                        },
                        "external_url": "https://www.sandbox.game/",
                        "featured": false,
                        "featured_image_url": "https://storage.googleapis.com/opensea-static/featured-images/sandbox-featured.png",
                        "hidden": false,
                        "safelist_request_status": "verified",
                        "image_url": "https://lh3.googleusercontent.com/SXH8tW1siikB80rwCRnjm1a5xM_MwTg9Xl9Db6mioIk9HIlDM09pVoSR7GKJgS6ulSUpgW9BDtMk_ePX_NKgO9A=s60",
                        "is_subject_to_whitelist": false,
                        "large_image_url": "https://lh3.googleusercontent.com/SXH8tW1siikB80rwCRnjm1a5xM_MwTg9Xl9Db6mioIk9HIlDM09pVoSR7GKJgS6ulSUpgW9BDtMk_ePX_NKgO9A",
                        "medium_username": "sandbox-game",
                        "name": "The Sandbox",
                        "only_proxied_transfers": false,
                        "opensea_buyer_fee_basis_points": "0",
                        "opensea_seller_fee_basis_points": "250",
                        "payout_address": "0x7a9fe22691c811ea339d9b73150e6911a5343dca",
                        "require_email": false,
                        "short_description": null,
                        "slug": "sandbox",
                        "telegram_url": "https://t.me/sandboxgame",
                        "twitter_username": "thesandboxgame",
                        "instagram_username": null,
                        "wiki_url": null
                    },
                    "decimals": null,
                    "token_metadata": null
                },
                {
                    "id": 15816696,
                    "token_id": "38182",
                    "num_sales": 0,
                    "background_color": null,
                    "image_url": "https://lh3.googleusercontent.com/17vU_UNWeMOVi4XOAwo4nvAXpeg1dnKPBk8VnAhJcFHOFZ9UBBvSL5Spj0ytvyfII3rdp4gHMY0mMvbnSzjdOZ0",
                    "image_preview_url": "https://lh3.googleusercontent.com/17vU_UNWeMOVi4XOAwo4nvAXpeg1dnKPBk8VnAhJcFHOFZ9UBBvSL5Spj0ytvyfII3rdp4gHMY0mMvbnSzjdOZ0=s250",
                    "image_thumbnail_url": "https://lh3.googleusercontent.com/17vU_UNWeMOVi4XOAwo4nvAXpeg1dnKPBk8VnAhJcFHOFZ9UBBvSL5Spj0ytvyfII3rdp4gHMY0mMvbnSzjdOZ0=s128",
                    "image_original_url": "https://storage.googleapis.com/opensea-static/custom-fetcher-images/sandbox/land/sandbox-land.png",
                    "animation_url": null,
                    "animation_original_url": null,
                    "name": "LAND (34, -111)",
                    "description": "A LAND is a digital piece of real estate in The Sandbox metaverse that players can buy to build experiences on top of. Once you own a LAND, you will be able to populate it with Games and Assets. Each LAND is a unique (non-fungible) token lying on the public Ethereum blockchain (ERC-721).",
                    "external_link": "https://www.sandbox.game/en/map/?x=34&y=-111",
                    "asset_contract": {
                        "address": "0x50f5474724e0ee42d9a4e711ccfb275809fd6d4a",
                        "asset_contract_type": "non-fungible",
                        "created_date": "2019-12-04T10:58:28.892990",
                        "name": "Sandbox's LANDs",
                        "nft_version": "3.0",
                        "opensea_version": null,
                        "owner": null,
                        "schema_name": "ERC721",
                        "symbol": "",
                        "total_supply": null,
                        "description": "The Sandbox is a community-driven platform where creators can monetize voxel assets and gaming experiences on the blockchain. The Sandbox metaverse comprises a map made up of 166,464 LANDS.  LAND owners can host contests and events, stake SAND to earn and customize assets, monetize assets and experiences, vote in the metaverse governance, play games that you or others create, and more! Trade the collection and keep your eyes peeled for future drops.",
                        "external_link": "https://www.sandbox.game/",
                        "image_url": "https://lh3.googleusercontent.com/SXH8tW1siikB80rwCRnjm1a5xM_MwTg9Xl9Db6mioIk9HIlDM09pVoSR7GKJgS6ulSUpgW9BDtMk_ePX_NKgO9A=s60",
                        "default_to_fiat": false,
                        "dev_buyer_fee_basis_points": 0,
                        "dev_seller_fee_basis_points": 500,
                        "only_proxied_transfers": false,
                        "opensea_buyer_fee_basis_points": 0,
                        "opensea_seller_fee_basis_points": 250,
                        "buyer_fee_basis_points": 0,
                        "seller_fee_basis_points": 750,
                        "payout_address": "0x7a9fe22691c811ea339d9b73150e6911a5343dca"
                    },
                    "owner": {
                        "user": {
                            "username": "REVOLT"
                        },
                        "profile_img_url": "https://storage.googleapis.com/opensea-static/opensea-profile/25.png",
                        "address": "0xb6d820e80a2a7c49f94c9d6c8ea08dccedc9ce4c",
                        "config": "",
                        "discord_id": ""
                    },
                    "permalink": "https://opensea.io/assets/0x50f5474724e0ee42d9a4e711ccfb275809fd6d4a/38182",
                    "collection": {
                        "banner_image_url": "https://lh3.googleusercontent.com/4NQIRoGmzXeXQN4mjuhWuuDZSNW7_BqRXux5upd4Nn_A-bfsGxCnPF8qn98Y6MyHRDPGXIlgfZADcSOe6M2DyrDKXdbdaTgkZN5l=s2500",
                        "chat_url": null,
                        "created_date": "2019-12-04T10:58:29.069907",
                        "default_to_fiat": false,
                        "description": "The Sandbox is a community-driven platform where creators can monetize voxel assets and gaming experiences on the blockchain. The Sandbox metaverse comprises a map made up of 166,464 LANDS.  LAND owners can host contests and events, stake SAND to earn and customize assets, monetize assets and experiences, vote in the metaverse governance, play games that you or others create, and more! Trade the collection and keep your eyes peeled for future drops.",
                        "dev_buyer_fee_basis_points": "0",
                        "dev_seller_fee_basis_points": "500",
                        "discord_url": "https://discord.gg/vAe4zvY",
                        "display_data": {
                            "card_display_style": "contain"
                        },
                        "external_url": "https://www.sandbox.game/",
                        "featured": false,
                        "featured_image_url": "https://storage.googleapis.com/opensea-static/featured-images/sandbox-featured.png",
                        "hidden": false,
                        "safelist_request_status": "verified",
                        "image_url": "https://lh3.googleusercontent.com/SXH8tW1siikB80rwCRnjm1a5xM_MwTg9Xl9Db6mioIk9HIlDM09pVoSR7GKJgS6ulSUpgW9BDtMk_ePX_NKgO9A=s60",
                        "is_subject_to_whitelist": false,
                        "large_image_url": "https://lh3.googleusercontent.com/SXH8tW1siikB80rwCRnjm1a5xM_MwTg9Xl9Db6mioIk9HIlDM09pVoSR7GKJgS6ulSUpgW9BDtMk_ePX_NKgO9A",
                        "medium_username": "sandbox-game",
                        "name": "The Sandbox",
                        "only_proxied_transfers": false,
                        "opensea_buyer_fee_basis_points": "0",
                        "opensea_seller_fee_basis_points": "250",
                        "payout_address": "0x7a9fe22691c811ea339d9b73150e6911a5343dca",
                        "require_email": false,
                        "short_description": null,
                        "slug": "sandbox",
                        "telegram_url": "https://t.me/sandboxgame",
                        "twitter_username": "thesandboxgame",
                        "instagram_username": null,
                        "wiki_url": null
                    },
                    "decimals": null,
                    "token_metadata": null
                },
                {
                    "id": 15816711,
                    "token_id": "38183",
                    "num_sales": 0,
                    "background_color": null,
                    "image_url": "https://storage.opensea.io/files/3faa959fa75531ac7913a9c9f8361b58.png",
                    "image_preview_url": "https://lh3.googleusercontent.com/17vU_UNWeMOVi4XOAwo4nvAXpeg1dnKPBk8VnAhJcFHOFZ9UBBvSL5Spj0ytvyfII3rdp4gHMY0mMvbnSzjdOZ0=s250",
                    "image_thumbnail_url": "https://lh3.googleusercontent.com/17vU_UNWeMOVi4XOAwo4nvAXpeg1dnKPBk8VnAhJcFHOFZ9UBBvSL5Spj0ytvyfII3rdp4gHMY0mMvbnSzjdOZ0=s128",
                    "image_original_url": "https://storage.googleapis.com/opensea-static/custom-fetcher-images/sandbox/land/sandbox-land.png",
                    "animation_url": null,
                    "animation_original_url": null,
                    "name": "LAND (35, -111)",
                    "description": "A LAND is a digital piece of real estate in The Sandbox metaverse that players can buy to build experiences on top of. Once you own a LAND, you will be able to populate it with Games and Assets. Each LAND is a unique (non-fungible) token lying on the public Ethereum blockchain (ERC-721).",
                    "external_link": "https://www.sandbox.game/en/map/?x=35&y=-111",
                    "asset_contract": {
                        "address": "0x50f5474724e0ee42d9a4e711ccfb275809fd6d4a",
                        "asset_contract_type": "non-fungible",
                        "created_date": "2019-12-04T10:58:28.892990",
                        "name": "Sandbox's LANDs",
                        "nft_version": "3.0",
                        "opensea_version": null,
                        "owner": null,
                        "schema_name": "ERC721",
                        "symbol": "",
                        "total_supply": null,
                        "description": "The Sandbox is a community-driven platform where creators can monetize voxel assets and gaming experiences on the blockchain. The Sandbox metaverse comprises a map made up of 166,464 LANDS.  LAND owners can host contests and events, stake SAND to earn and customize assets, monetize assets and experiences, vote in the metaverse governance, play games that you or others create, and more! Trade the collection and keep your eyes peeled for future drops.",
                        "external_link": "https://www.sandbox.game/",
                        "image_url": "https://lh3.googleusercontent.com/SXH8tW1siikB80rwCRnjm1a5xM_MwTg9Xl9Db6mioIk9HIlDM09pVoSR7GKJgS6ulSUpgW9BDtMk_ePX_NKgO9A=s60",
                        "default_to_fiat": false,
                        "dev_buyer_fee_basis_points": 0,
                        "dev_seller_fee_basis_points": 500,
                        "only_proxied_transfers": false,
                        "opensea_buyer_fee_basis_points": 0,
                        "opensea_seller_fee_basis_points": 250,
                        "buyer_fee_basis_points": 0,
                        "seller_fee_basis_points": 750,
                        "payout_address": "0x7a9fe22691c811ea339d9b73150e6911a5343dca"
                    },
                    "owner": {
                        "user": {
                            "username": "REVOLT"
                        },
                        "profile_img_url": "https://storage.googleapis.com/opensea-static/opensea-profile/25.png",
                        "address": "0xb6d820e80a2a7c49f94c9d6c8ea08dccedc9ce4c",
                        "config": "",
                        "discord_id": ""
                    },
                    "permalink": "https://opensea.io/assets/0x50f5474724e0ee42d9a4e711ccfb275809fd6d4a/38183",
                    "collection": {
                        "banner_image_url": "https://lh3.googleusercontent.com/4NQIRoGmzXeXQN4mjuhWuuDZSNW7_BqRXux5upd4Nn_A-bfsGxCnPF8qn98Y6MyHRDPGXIlgfZADcSOe6M2DyrDKXdbdaTgkZN5l=s2500",
                        "chat_url": null,
                        "created_date": "2019-12-04T10:58:29.069907",
                        "default_to_fiat": false,
                        "description": "The Sandbox is a community-driven platform where creators can monetize voxel assets and gaming experiences on the blockchain. The Sandbox metaverse comprises a map made up of 166,464 LANDS.  LAND owners can host contests and events, stake SAND to earn and customize assets, monetize assets and experiences, vote in the metaverse governance, play games that you or others create, and more! Trade the collection and keep your eyes peeled for future drops.",
                        "dev_buyer_fee_basis_points": "0",
                        "dev_seller_fee_basis_points": "500",
                        "discord_url": "https://discord.gg/vAe4zvY",
                        "display_data": {
                            "card_display_style": "contain"
                        },
                        "external_url": "https://www.sandbox.game/",
                        "featured": false,
                        "featured_image_url": "https://storage.googleapis.com/opensea-static/featured-images/sandbox-featured.png",
                        "hidden": false,
                        "safelist_request_status": "verified",
                        "image_url": "https://lh3.googleusercontent.com/SXH8tW1siikB80rwCRnjm1a5xM_MwTg9Xl9Db6mioIk9HIlDM09pVoSR7GKJgS6ulSUpgW9BDtMk_ePX_NKgO9A=s60",
                        "is_subject_to_whitelist": false,
                        "large_image_url": "https://lh3.googleusercontent.com/SXH8tW1siikB80rwCRnjm1a5xM_MwTg9Xl9Db6mioIk9HIlDM09pVoSR7GKJgS6ulSUpgW9BDtMk_ePX_NKgO9A",
                        "medium_username": "sandbox-game",
                        "name": "The Sandbox",
                        "only_proxied_transfers": false,
                        "opensea_buyer_fee_basis_points": "0",
                        "opensea_seller_fee_basis_points": "250",
                        "payout_address": "0x7a9fe22691c811ea339d9b73150e6911a5343dca",
                        "require_email": false,
                        "short_description": null,
                        "slug": "sandbox",
                        "telegram_url": "https://t.me/sandboxgame",
                        "twitter_username": "thesandboxgame",
                        "instagram_username": null,
                        "wiki_url": null
                    },
                    "decimals": null,
                    "token_metadata": null
                },
                {
                    "id": 15816725,
                    "token_id": "38591",
                    "num_sales": 0,
                    "background_color": null,
                    "image_url": "https://lh3.googleusercontent.com/17vU_UNWeMOVi4XOAwo4nvAXpeg1dnKPBk8VnAhJcFHOFZ9UBBvSL5Spj0ytvyfII3rdp4gHMY0mMvbnSzjdOZ0",
                    "image_preview_url": "https://lh3.googleusercontent.com/17vU_UNWeMOVi4XOAwo4nvAXpeg1dnKPBk8VnAhJcFHOFZ9UBBvSL5Spj0ytvyfII3rdp4gHMY0mMvbnSzjdOZ0=s250",
                    "image_thumbnail_url": "https://lh3.googleusercontent.com/17vU_UNWeMOVi4XOAwo4nvAXpeg1dnKPBk8VnAhJcFHOFZ9UBBvSL5Spj0ytvyfII3rdp4gHMY0mMvbnSzjdOZ0=s128",
                    "image_original_url": "https://storage.googleapis.com/opensea-static/custom-fetcher-images/sandbox/land/sandbox-land.png",
                    "animation_url": null,
                    "animation_original_url": null,
                    "name": "LAND (35, -110)",
                    "description": "A LAND is a digital piece of real estate in The Sandbox metaverse that players can buy to build experiences on top of. Once you own a LAND, you will be able to populate it with Games and Assets. Each LAND is a unique (non-fungible) token lying on the public Ethereum blockchain (ERC-721).",
                    "external_link": "https://www.sandbox.game/en/map/?x=35&y=-110",
                    "asset_contract": {
                        "address": "0x50f5474724e0ee42d9a4e711ccfb275809fd6d4a",
                        "asset_contract_type": "non-fungible",
                        "created_date": "2019-12-04T10:58:28.892990",
                        "name": "Sandbox's LANDs",
                        "nft_version": "3.0",
                        "opensea_version": null,
                        "owner": null,
                        "schema_name": "ERC721",
                        "symbol": "",
                        "total_supply": null,
                        "description": "The Sandbox is a community-driven platform where creators can monetize voxel assets and gaming experiences on the blockchain. The Sandbox metaverse comprises a map made up of 166,464 LANDS.  LAND owners can host contests and events, stake SAND to earn and customize assets, monetize assets and experiences, vote in the metaverse governance, play games that you or others create, and more! Trade the collection and keep your eyes peeled for future drops.",
                        "external_link": "https://www.sandbox.game/",
                        "image_url": "https://lh3.googleusercontent.com/SXH8tW1siikB80rwCRnjm1a5xM_MwTg9Xl9Db6mioIk9HIlDM09pVoSR7GKJgS6ulSUpgW9BDtMk_ePX_NKgO9A=s60",
                        "default_to_fiat": false,
                        "dev_buyer_fee_basis_points": 0,
                        "dev_seller_fee_basis_points": 500,
                        "only_proxied_transfers": false,
                        "opensea_buyer_fee_basis_points": 0,
                        "opensea_seller_fee_basis_points": 250,
                        "buyer_fee_basis_points": 0,
                        "seller_fee_basis_points": 750,
                        "payout_address": "0x7a9fe22691c811ea339d9b73150e6911a5343dca"
                    },
                    "owner": {
                        "user": {
                            "username": "REVOLT"
                        },
                        "profile_img_url": "https://storage.googleapis.com/opensea-static/opensea-profile/25.png",
                        "address": "0xb6d820e80a2a7c49f94c9d6c8ea08dccedc9ce4c",
                        "config": "",
                        "discord_id": ""
                    },
                    "permalink": "https://opensea.io/assets/0x50f5474724e0ee42d9a4e711ccfb275809fd6d4a/38591",
                    "collection": {
                        "banner_image_url": "https://lh3.googleusercontent.com/4NQIRoGmzXeXQN4mjuhWuuDZSNW7_BqRXux5upd4Nn_A-bfsGxCnPF8qn98Y6MyHRDPGXIlgfZADcSOe6M2DyrDKXdbdaTgkZN5l=s2500",
                        "chat_url": null,
                        "created_date": "2019-12-04T10:58:29.069907",
                        "default_to_fiat": false,
                        "description": "The Sandbox is a community-driven platform where creators can monetize voxel assets and gaming experiences on the blockchain. The Sandbox metaverse comprises a map made up of 166,464 LANDS.  LAND owners can host contests and events, stake SAND to earn and customize assets, monetize assets and experiences, vote in the metaverse governance, play games that you or others create, and more! Trade the collection and keep your eyes peeled for future drops.",
                        "dev_buyer_fee_basis_points": "0",
                        "dev_seller_fee_basis_points": "500",
                        "discord_url": "https://discord.gg/vAe4zvY",
                        "display_data": {
                            "card_display_style": "contain"
                        },
                        "external_url": "https://www.sandbox.game/",
                        "featured": false,
                        "featured_image_url": "https://storage.googleapis.com/opensea-static/featured-images/sandbox-featured.png",
                        "hidden": false,
                        "safelist_request_status": "verified",
                        "image_url": "https://lh3.googleusercontent.com/SXH8tW1siikB80rwCRnjm1a5xM_MwTg9Xl9Db6mioIk9HIlDM09pVoSR7GKJgS6ulSUpgW9BDtMk_ePX_NKgO9A=s60",
                        "is_subject_to_whitelist": false,
                        "large_image_url": "https://lh3.googleusercontent.com/SXH8tW1siikB80rwCRnjm1a5xM_MwTg9Xl9Db6mioIk9HIlDM09pVoSR7GKJgS6ulSUpgW9BDtMk_ePX_NKgO9A",
                        "medium_username": "sandbox-game",
                        "name": "The Sandbox",
                        "only_proxied_transfers": false,
                        "opensea_buyer_fee_basis_points": "0",
                        "opensea_seller_fee_basis_points": "250",
                        "payout_address": "0x7a9fe22691c811ea339d9b73150e6911a5343dca",
                        "require_email": false,
                        "short_description": null,
                        "slug": "sandbox",
                        "telegram_url": "https://t.me/sandboxgame",
                        "twitter_username": "thesandboxgame",
                        "instagram_username": null,
                        "wiki_url": null
                    },
                    "decimals": null,
                    "token_metadata": null
                },
                {
                    "id": 15816736,
                    "token_id": "38590",
                    "num_sales": 0,
                    "background_color": null,
                    "image_url": "https://lh3.googleusercontent.com/17vU_UNWeMOVi4XOAwo4nvAXpeg1dnKPBk8VnAhJcFHOFZ9UBBvSL5Spj0ytvyfII3rdp4gHMY0mMvbnSzjdOZ0",
                    "image_preview_url": "https://lh3.googleusercontent.com/17vU_UNWeMOVi4XOAwo4nvAXpeg1dnKPBk8VnAhJcFHOFZ9UBBvSL5Spj0ytvyfII3rdp4gHMY0mMvbnSzjdOZ0=s250",
                    "image_thumbnail_url": "https://lh3.googleusercontent.com/17vU_UNWeMOVi4XOAwo4nvAXpeg1dnKPBk8VnAhJcFHOFZ9UBBvSL5Spj0ytvyfII3rdp4gHMY0mMvbnSzjdOZ0=s128",
                    "image_original_url": "https://storage.googleapis.com/opensea-static/custom-fetcher-images/sandbox/land/sandbox-land.png",
                    "animation_url": null,
                    "animation_original_url": null,
                    "name": "LAND (34, -110)",
                    "description": "A LAND is a digital piece of real estate in The Sandbox metaverse that players can buy to build experiences on top of. Once you own a LAND, you will be able to populate it with Games and Assets. Each LAND is a unique (non-fungible) token lying on the public Ethereum blockchain (ERC-721).",
                    "external_link": "https://www.sandbox.game/en/map/?x=34&y=-110",
                    "asset_contract": {
                        "address": "0x50f5474724e0ee42d9a4e711ccfb275809fd6d4a",
                        "asset_contract_type": "non-fungible",
                        "created_date": "2019-12-04T10:58:28.892990",
                        "name": "Sandbox's LANDs",
                        "nft_version": "3.0",
                        "opensea_version": null,
                        "owner": null,
                        "schema_name": "ERC721",
                        "symbol": "",
                        "total_supply": null,
                        "description": "The Sandbox is a community-driven platform where creators can monetize voxel assets and gaming experiences on the blockchain. The Sandbox metaverse comprises a map made up of 166,464 LANDS.  LAND owners can host contests and events, stake SAND to earn and customize assets, monetize assets and experiences, vote in the metaverse governance, play games that you or others create, and more! Trade the collection and keep your eyes peeled for future drops.",
                        "external_link": "https://www.sandbox.game/",
                        "image_url": "https://lh3.googleusercontent.com/SXH8tW1siikB80rwCRnjm1a5xM_MwTg9Xl9Db6mioIk9HIlDM09pVoSR7GKJgS6ulSUpgW9BDtMk_ePX_NKgO9A=s60",
                        "default_to_fiat": false,
                        "dev_buyer_fee_basis_points": 0,
                        "dev_seller_fee_basis_points": 500,
                        "only_proxied_transfers": false,
                        "opensea_buyer_fee_basis_points": 0,
                        "opensea_seller_fee_basis_points": 250,
                        "buyer_fee_basis_points": 0,
                        "seller_fee_basis_points": 750,
                        "payout_address": "0x7a9fe22691c811ea339d9b73150e6911a5343dca"
                    },
                    "owner": {
                        "user": {
                            "username": "REVOLT"
                        },
                        "profile_img_url": "https://storage.googleapis.com/opensea-static/opensea-profile/25.png",
                        "address": "0xb6d820e80a2a7c49f94c9d6c8ea08dccedc9ce4c",
                        "config": "",
                        "discord_id": ""
                    },
                    "permalink": "https://opensea.io/assets/0x50f5474724e0ee42d9a4e711ccfb275809fd6d4a/38590",
                    "collection": {
                        "banner_image_url": "https://lh3.googleusercontent.com/4NQIRoGmzXeXQN4mjuhWuuDZSNW7_BqRXux5upd4Nn_A-bfsGxCnPF8qn98Y6MyHRDPGXIlgfZADcSOe6M2DyrDKXdbdaTgkZN5l=s2500",
                        "chat_url": null,
                        "created_date": "2019-12-04T10:58:29.069907",
                        "default_to_fiat": false,
                        "description": "The Sandbox is a community-driven platform where creators can monetize voxel assets and gaming experiences on the blockchain. The Sandbox metaverse comprises a map made up of 166,464 LANDS.  LAND owners can host contests and events, stake SAND to earn and customize assets, monetize assets and experiences, vote in the metaverse governance, play games that you or others create, and more! Trade the collection and keep your eyes peeled for future drops.",
                        "dev_buyer_fee_basis_points": "0",
                        "dev_seller_fee_basis_points": "500",
                        "discord_url": "https://discord.gg/vAe4zvY",
                        "display_data": {
                            "card_display_style": "contain"
                        },
                        "external_url": "https://www.sandbox.game/",
                        "featured": false,
                        "featured_image_url": "https://storage.googleapis.com/opensea-static/featured-images/sandbox-featured.png",
                        "hidden": false,
                        "safelist_request_status": "verified",
                        "image_url": "https://lh3.googleusercontent.com/SXH8tW1siikB80rwCRnjm1a5xM_MwTg9Xl9Db6mioIk9HIlDM09pVoSR7GKJgS6ulSUpgW9BDtMk_ePX_NKgO9A=s60",
                        "is_subject_to_whitelist": false,
                        "large_image_url": "https://lh3.googleusercontent.com/SXH8tW1siikB80rwCRnjm1a5xM_MwTg9Xl9Db6mioIk9HIlDM09pVoSR7GKJgS6ulSUpgW9BDtMk_ePX_NKgO9A",
                        "medium_username": "sandbox-game",
                        "name": "The Sandbox",
                        "only_proxied_transfers": false,
                        "opensea_buyer_fee_basis_points": "0",
                        "opensea_seller_fee_basis_points": "250",
                        "payout_address": "0x7a9fe22691c811ea339d9b73150e6911a5343dca",
                        "require_email": false,
                        "short_description": null,
                        "slug": "sandbox",
                        "telegram_url": "https://t.me/sandboxgame",
                        "twitter_username": "thesandboxgame",
                        "instagram_username": null,
                        "wiki_url": null
                    },
                    "decimals": null,
                    "token_metadata": null
                },
                {
                    "id": 15816748,
                    "token_id": "38589",
                    "num_sales": 0,
                    "background_color": null,
                    "image_url": "https://storage.opensea.io/files/3faa959fa75531ac7913a9c9f8361b58.png",
                    "image_preview_url": "https://lh3.googleusercontent.com/17vU_UNWeMOVi4XOAwo4nvAXpeg1dnKPBk8VnAhJcFHOFZ9UBBvSL5Spj0ytvyfII3rdp4gHMY0mMvbnSzjdOZ0=s250",
                    "image_thumbnail_url": "https://lh3.googleusercontent.com/17vU_UNWeMOVi4XOAwo4nvAXpeg1dnKPBk8VnAhJcFHOFZ9UBBvSL5Spj0ytvyfII3rdp4gHMY0mMvbnSzjdOZ0=s128",
                    "image_original_url": "https://storage.googleapis.com/opensea-static/custom-fetcher-images/sandbox/land/sandbox-land.png",
                    "animation_url": null,
                    "animation_original_url": null,
                    "name": "LAND (33, -110)",
                    "description": "A LAND is a digital piece of real estate in The Sandbox metaverse that players can buy to build experiences on top of. Once you own a LAND, you will be able to populate it with Games and Assets. Each LAND is a unique (non-fungible) token lying on the public Ethereum blockchain (ERC-721).",
                    "external_link": "https://www.sandbox.game/en/map/?x=33&y=-110",
                    "asset_contract": {
                        "address": "0x50f5474724e0ee42d9a4e711ccfb275809fd6d4a",
                        "asset_contract_type": "non-fungible",
                        "created_date": "2019-12-04T10:58:28.892990",
                        "name": "Sandbox's LANDs",
                        "nft_version": "3.0",
                        "opensea_version": null,
                        "owner": null,
                        "schema_name": "ERC721",
                        "symbol": "",
                        "total_supply": null,
                        "description": "The Sandbox is a community-driven platform where creators can monetize voxel assets and gaming experiences on the blockchain. The Sandbox metaverse comprises a map made up of 166,464 LANDS.  LAND owners can host contests and events, stake SAND to earn and customize assets, monetize assets and experiences, vote in the metaverse governance, play games that you or others create, and more! Trade the collection and keep your eyes peeled for future drops.",
                        "external_link": "https://www.sandbox.game/",
                        "image_url": "https://lh3.googleusercontent.com/SXH8tW1siikB80rwCRnjm1a5xM_MwTg9Xl9Db6mioIk9HIlDM09pVoSR7GKJgS6ulSUpgW9BDtMk_ePX_NKgO9A=s60",
                        "default_to_fiat": false,
                        "dev_buyer_fee_basis_points": 0,
                        "dev_seller_fee_basis_points": 500,
                        "only_proxied_transfers": false,
                        "opensea_buyer_fee_basis_points": 0,
                        "opensea_seller_fee_basis_points": 250,
                        "buyer_fee_basis_points": 0,
                        "seller_fee_basis_points": 750,
                        "payout_address": "0x7a9fe22691c811ea339d9b73150e6911a5343dca"
                    },
                    "owner": {
                        "user": {
                            "username": "REVOLT"
                        },
                        "profile_img_url": "https://storage.googleapis.com/opensea-static/opensea-profile/25.png",
                        "address": "0xb6d820e80a2a7c49f94c9d6c8ea08dccedc9ce4c",
                        "config": "",
                        "discord_id": ""
                    },
                    "permalink": "https://opensea.io/assets/0x50f5474724e0ee42d9a4e711ccfb275809fd6d4a/38589",
                    "collection": {
                        "banner_image_url": "https://lh3.googleusercontent.com/4NQIRoGmzXeXQN4mjuhWuuDZSNW7_BqRXux5upd4Nn_A-bfsGxCnPF8qn98Y6MyHRDPGXIlgfZADcSOe6M2DyrDKXdbdaTgkZN5l=s2500",
                        "chat_url": null,
                        "created_date": "2019-12-04T10:58:29.069907",
                        "default_to_fiat": false,
                        "description": "The Sandbox is a community-driven platform where creators can monetize voxel assets and gaming experiences on the blockchain. The Sandbox metaverse comprises a map made up of 166,464 LANDS.  LAND owners can host contests and events, stake SAND to earn and customize assets, monetize assets and experiences, vote in the metaverse governance, play games that you or others create, and more! Trade the collection and keep your eyes peeled for future drops.",
                        "dev_buyer_fee_basis_points": "0",
                        "dev_seller_fee_basis_points": "500",
                        "discord_url": "https://discord.gg/vAe4zvY",
                        "display_data": {
                            "card_display_style": "contain"
                        },
                        "external_url": "https://www.sandbox.game/",
                        "featured": false,
                        "featured_image_url": "https://storage.googleapis.com/opensea-static/featured-images/sandbox-featured.png",
                        "hidden": false,
                        "safelist_request_status": "verified",
                        "image_url": "https://lh3.googleusercontent.com/SXH8tW1siikB80rwCRnjm1a5xM_MwTg9Xl9Db6mioIk9HIlDM09pVoSR7GKJgS6ulSUpgW9BDtMk_ePX_NKgO9A=s60",
                        "is_subject_to_whitelist": false,
                        "large_image_url": "https://lh3.googleusercontent.com/SXH8tW1siikB80rwCRnjm1a5xM_MwTg9Xl9Db6mioIk9HIlDM09pVoSR7GKJgS6ulSUpgW9BDtMk_ePX_NKgO9A",
                        "medium_username": "sandbox-game",
                        "name": "The Sandbox",
                        "only_proxied_transfers": false,
                        "opensea_buyer_fee_basis_points": "0",
                        "opensea_seller_fee_basis_points": "250",
                        "payout_address": "0x7a9fe22691c811ea339d9b73150e6911a5343dca",
                        "require_email": false,
                        "short_description": null,
                        "slug": "sandbox",
                        "telegram_url": "https://t.me/sandboxgame",
                        "twitter_username": "thesandboxgame",
                        "instagram_username": null,
                        "wiki_url": null
                    },
                    "decimals": null,
                    "token_metadata": null
                },
                {
                    "id": 15816760,
                    "token_id": "38997",
                    "num_sales": 0,
                    "background_color": null,
                    "image_url": "https://lh3.googleusercontent.com/17vU_UNWeMOVi4XOAwo4nvAXpeg1dnKPBk8VnAhJcFHOFZ9UBBvSL5Spj0ytvyfII3rdp4gHMY0mMvbnSzjdOZ0",
                    "image_preview_url": "https://lh3.googleusercontent.com/17vU_UNWeMOVi4XOAwo4nvAXpeg1dnKPBk8VnAhJcFHOFZ9UBBvSL5Spj0ytvyfII3rdp4gHMY0mMvbnSzjdOZ0=s250",
                    "image_thumbnail_url": "https://lh3.googleusercontent.com/17vU_UNWeMOVi4XOAwo4nvAXpeg1dnKPBk8VnAhJcFHOFZ9UBBvSL5Spj0ytvyfII3rdp4gHMY0mMvbnSzjdOZ0=s128",
                    "image_original_url": "https://storage.googleapis.com/opensea-static/custom-fetcher-images/sandbox/land/sandbox-land.png",
                    "animation_url": null,
                    "animation_original_url": null,
                    "name": "LAND (33, -109)",
                    "description": "A LAND is a digital piece of real estate in The Sandbox metaverse that players can buy to build experiences on top of. Once you own a LAND, you will be able to populate it with Games and Assets. Each LAND is a unique (non-fungible) token lying on the public Ethereum blockchain (ERC-721).",
                    "external_link": "https://www.sandbox.game/en/map/?x=33&y=-109",
                    "asset_contract": {
                        "address": "0x50f5474724e0ee42d9a4e711ccfb275809fd6d4a",
                        "asset_contract_type": "non-fungible",
                        "created_date": "2019-12-04T10:58:28.892990",
                        "name": "Sandbox's LANDs",
                        "nft_version": "3.0",
                        "opensea_version": null,
                        "owner": null,
                        "schema_name": "ERC721",
                        "symbol": "",
                        "total_supply": null,
                        "description": "The Sandbox is a community-driven platform where creators can monetize voxel assets and gaming experiences on the blockchain. The Sandbox metaverse comprises a map made up of 166,464 LANDS.  LAND owners can host contests and events, stake SAND to earn and customize assets, monetize assets and experiences, vote in the metaverse governance, play games that you or others create, and more! Trade the collection and keep your eyes peeled for future drops.",
                        "external_link": "https://www.sandbox.game/",
                        "image_url": "https://lh3.googleusercontent.com/SXH8tW1siikB80rwCRnjm1a5xM_MwTg9Xl9Db6mioIk9HIlDM09pVoSR7GKJgS6ulSUpgW9BDtMk_ePX_NKgO9A=s60",
                        "default_to_fiat": false,
                        "dev_buyer_fee_basis_points": 0,
                        "dev_seller_fee_basis_points": 500,
                        "only_proxied_transfers": false,
                        "opensea_buyer_fee_basis_points": 0,
                        "opensea_seller_fee_basis_points": 250,
                        "buyer_fee_basis_points": 0,
                        "seller_fee_basis_points": 750,
                        "payout_address": "0x7a9fe22691c811ea339d9b73150e6911a5343dca"
                    },
                    "owner": {
                        "user": {
                            "username": "REVOLT"
                        },
                        "profile_img_url": "https://storage.googleapis.com/opensea-static/opensea-profile/25.png",
                        "address": "0xb6d820e80a2a7c49f94c9d6c8ea08dccedc9ce4c",
                        "config": "",
                        "discord_id": ""
                    },
                    "permalink": "https://opensea.io/assets/0x50f5474724e0ee42d9a4e711ccfb275809fd6d4a/38997",
                    "collection": {
                        "banner_image_url": "https://lh3.googleusercontent.com/4NQIRoGmzXeXQN4mjuhWuuDZSNW7_BqRXux5upd4Nn_A-bfsGxCnPF8qn98Y6MyHRDPGXIlgfZADcSOe6M2DyrDKXdbdaTgkZN5l=s2500",
                        "chat_url": null,
                        "created_date": "2019-12-04T10:58:29.069907",
                        "default_to_fiat": false,
                        "description": "The Sandbox is a community-driven platform where creators can monetize voxel assets and gaming experiences on the blockchain. The Sandbox metaverse comprises a map made up of 166,464 LANDS.  LAND owners can host contests and events, stake SAND to earn and customize assets, monetize assets and experiences, vote in the metaverse governance, play games that you or others create, and more! Trade the collection and keep your eyes peeled for future drops.",
                        "dev_buyer_fee_basis_points": "0",
                        "dev_seller_fee_basis_points": "500",
                        "discord_url": "https://discord.gg/vAe4zvY",
                        "display_data": {
                            "card_display_style": "contain"
                        },
                        "external_url": "https://www.sandbox.game/",
                        "featured": false,
                        "featured_image_url": "https://storage.googleapis.com/opensea-static/featured-images/sandbox-featured.png",
                        "hidden": false,
                        "safelist_request_status": "verified",
                        "image_url": "https://lh3.googleusercontent.com/SXH8tW1siikB80rwCRnjm1a5xM_MwTg9Xl9Db6mioIk9HIlDM09pVoSR7GKJgS6ulSUpgW9BDtMk_ePX_NKgO9A=s60",
                        "is_subject_to_whitelist": false,
                        "large_image_url": "https://lh3.googleusercontent.com/SXH8tW1siikB80rwCRnjm1a5xM_MwTg9Xl9Db6mioIk9HIlDM09pVoSR7GKJgS6ulSUpgW9BDtMk_ePX_NKgO9A",
                        "medium_username": "sandbox-game",
                        "name": "The Sandbox",
                        "only_proxied_transfers": false,
                        "opensea_buyer_fee_basis_points": "0",
                        "opensea_seller_fee_basis_points": "250",
                        "payout_address": "0x7a9fe22691c811ea339d9b73150e6911a5343dca",
                        "require_email": false,
                        "short_description": null,
                        "slug": "sandbox",
                        "telegram_url": "https://t.me/sandboxgame",
                        "twitter_username": "thesandboxgame",
                        "instagram_username": null,
                        "wiki_url": null
                    },
                    "decimals": null,
                    "token_metadata": null
                },
                {
                    "id": 15816771,
                    "token_id": "38998",
                    "num_sales": 0,
                    "background_color": null,
                    "image_url": "https://storage.opensea.io/files/3faa959fa75531ac7913a9c9f8361b58.png",
                    "image_preview_url": "https://lh3.googleusercontent.com/17vU_UNWeMOVi4XOAwo4nvAXpeg1dnKPBk8VnAhJcFHOFZ9UBBvSL5Spj0ytvyfII3rdp4gHMY0mMvbnSzjdOZ0=s250",
                    "image_thumbnail_url": "https://lh3.googleusercontent.com/17vU_UNWeMOVi4XOAwo4nvAXpeg1dnKPBk8VnAhJcFHOFZ9UBBvSL5Spj0ytvyfII3rdp4gHMY0mMvbnSzjdOZ0=s128",
                    "image_original_url": "https://storage.googleapis.com/opensea-static/custom-fetcher-images/sandbox/land/sandbox-land.png",
                    "animation_url": null,
                    "animation_original_url": null,
                    "name": "LAND (34, -109)",
                    "description": "A LAND is a digital piece of real estate in The Sandbox metaverse that players can buy to build experiences on top of. Once you own a LAND, you will be able to populate it with Games and Assets. Each LAND is a unique (non-fungible) token lying on the public Ethereum blockchain (ERC-721).",
                    "external_link": "https://www.sandbox.game/en/map/?x=34&y=-109",
                    "asset_contract": {
                        "address": "0x50f5474724e0ee42d9a4e711ccfb275809fd6d4a",
                        "asset_contract_type": "non-fungible",
                        "created_date": "2019-12-04T10:58:28.892990",
                        "name": "Sandbox's LANDs",
                        "nft_version": "3.0",
                        "opensea_version": null,
                        "owner": null,
                        "schema_name": "ERC721",
                        "symbol": "",
                        "total_supply": null,
                        "description": "The Sandbox is a community-driven platform where creators can monetize voxel assets and gaming experiences on the blockchain. The Sandbox metaverse comprises a map made up of 166,464 LANDS.  LAND owners can host contests and events, stake SAND to earn and customize assets, monetize assets and experiences, vote in the metaverse governance, play games that you or others create, and more! Trade the collection and keep your eyes peeled for future drops.",
                        "external_link": "https://www.sandbox.game/",
                        "image_url": "https://lh3.googleusercontent.com/SXH8tW1siikB80rwCRnjm1a5xM_MwTg9Xl9Db6mioIk9HIlDM09pVoSR7GKJgS6ulSUpgW9BDtMk_ePX_NKgO9A=s60",
                        "default_to_fiat": false,
                        "dev_buyer_fee_basis_points": 0,
                        "dev_seller_fee_basis_points": 500,
                        "only_proxied_transfers": false,
                        "opensea_buyer_fee_basis_points": 0,
                        "opensea_seller_fee_basis_points": 250,
                        "buyer_fee_basis_points": 0,
                        "seller_fee_basis_points": 750,
                        "payout_address": "0x7a9fe22691c811ea339d9b73150e6911a5343dca"
                    },
                    "owner": {
                        "user": {
                            "username": "REVOLT"
                        },
                        "profile_img_url": "https://storage.googleapis.com/opensea-static/opensea-profile/25.png",
                        "address": "0xb6d820e80a2a7c49f94c9d6c8ea08dccedc9ce4c",
                        "config": "",
                        "discord_id": ""
                    },
                    "permalink": "https://opensea.io/assets/0x50f5474724e0ee42d9a4e711ccfb275809fd6d4a/38998",
                    "collection": {
                        "banner_image_url": "https://lh3.googleusercontent.com/4NQIRoGmzXeXQN4mjuhWuuDZSNW7_BqRXux5upd4Nn_A-bfsGxCnPF8qn98Y6MyHRDPGXIlgfZADcSOe6M2DyrDKXdbdaTgkZN5l=s2500",
                        "chat_url": null,
                        "created_date": "2019-12-04T10:58:29.069907",
                        "default_to_fiat": false,
                        "description": "The Sandbox is a community-driven platform where creators can monetize voxel assets and gaming experiences on the blockchain. The Sandbox metaverse comprises a map made up of 166,464 LANDS.  LAND owners can host contests and events, stake SAND to earn and customize assets, monetize assets and experiences, vote in the metaverse governance, play games that you or others create, and more! Trade the collection and keep your eyes peeled for future drops.",
                        "dev_buyer_fee_basis_points": "0",
                        "dev_seller_fee_basis_points": "500",
                        "discord_url": "https://discord.gg/vAe4zvY",
                        "display_data": {
                            "card_display_style": "contain"
                        },
                        "external_url": "https://www.sandbox.game/",
                        "featured": false,
                        "featured_image_url": "https://storage.googleapis.com/opensea-static/featured-images/sandbox-featured.png",
                        "hidden": false,
                        "safelist_request_status": "verified",
                        "image_url": "https://lh3.googleusercontent.com/SXH8tW1siikB80rwCRnjm1a5xM_MwTg9Xl9Db6mioIk9HIlDM09pVoSR7GKJgS6ulSUpgW9BDtMk_ePX_NKgO9A=s60",
                        "is_subject_to_whitelist": false,
                        "large_image_url": "https://lh3.googleusercontent.com/SXH8tW1siikB80rwCRnjm1a5xM_MwTg9Xl9Db6mioIk9HIlDM09pVoSR7GKJgS6ulSUpgW9BDtMk_ePX_NKgO9A",
                        "medium_username": "sandbox-game",
                        "name": "The Sandbox",
                        "only_proxied_transfers": false,
                        "opensea_buyer_fee_basis_points": "0",
                        "opensea_seller_fee_basis_points": "250",
                        "payout_address": "0x7a9fe22691c811ea339d9b73150e6911a5343dca",
                        "require_email": false,
                        "short_description": null,
                        "slug": "sandbox",
                        "telegram_url": "https://t.me/sandboxgame",
                        "twitter_username": "thesandboxgame",
                        "instagram_username": null,
                        "wiki_url": null
                    },
                    "decimals": null,
                    "token_metadata": null
                },
                {
                    "id": 15816789,
                    "token_id": "38999",
                    "num_sales": 0,
                    "background_color": null,
                    "image_url": "https://storage.opensea.io/files/3faa959fa75531ac7913a9c9f8361b58.png",
                    "image_preview_url": "https://lh3.googleusercontent.com/17vU_UNWeMOVi4XOAwo4nvAXpeg1dnKPBk8VnAhJcFHOFZ9UBBvSL5Spj0ytvyfII3rdp4gHMY0mMvbnSzjdOZ0=s250",
                    "image_thumbnail_url": "https://lh3.googleusercontent.com/17vU_UNWeMOVi4XOAwo4nvAXpeg1dnKPBk8VnAhJcFHOFZ9UBBvSL5Spj0ytvyfII3rdp4gHMY0mMvbnSzjdOZ0=s128",
                    "image_original_url": "https://storage.googleapis.com/opensea-static/custom-fetcher-images/sandbox/land/sandbox-land.png",
                    "animation_url": null,
                    "animation_original_url": null,
                    "name": "LAND (35, -109)",
                    "description": "A LAND is a digital piece of real estate in The Sandbox metaverse that players can buy to build experiences on top of. Once you own a LAND, you will be able to populate it with Games and Assets. Each LAND is a unique (non-fungible) token lying on the public Ethereum blockchain (ERC-721).",
                    "external_link": "https://www.sandbox.game/en/map/?x=35&y=-109",
                    "asset_contract": {
                        "address": "0x50f5474724e0ee42d9a4e711ccfb275809fd6d4a",
                        "asset_contract_type": "non-fungible",
                        "created_date": "2019-12-04T10:58:28.892990",
                        "name": "Sandbox's LANDs",
                        "nft_version": "3.0",
                        "opensea_version": null,
                        "owner": null,
                        "schema_name": "ERC721",
                        "symbol": "",
                        "total_supply": null,
                        "description": "The Sandbox is a community-driven platform where creators can monetize voxel assets and gaming experiences on the blockchain. The Sandbox metaverse comprises a map made up of 166,464 LANDS.  LAND owners can host contests and events, stake SAND to earn and customize assets, monetize assets and experiences, vote in the metaverse governance, play games that you or others create, and more! Trade the collection and keep your eyes peeled for future drops.",
                        "external_link": "https://www.sandbox.game/",
                        "image_url": "https://lh3.googleusercontent.com/SXH8tW1siikB80rwCRnjm1a5xM_MwTg9Xl9Db6mioIk9HIlDM09pVoSR7GKJgS6ulSUpgW9BDtMk_ePX_NKgO9A=s60",
                        "default_to_fiat": false,
                        "dev_buyer_fee_basis_points": 0,
                        "dev_seller_fee_basis_points": 500,
                        "only_proxied_transfers": false,
                        "opensea_buyer_fee_basis_points": 0,
                        "opensea_seller_fee_basis_points": 250,
                        "buyer_fee_basis_points": 0,
                        "seller_fee_basis_points": 750,
                        "payout_address": "0x7a9fe22691c811ea339d9b73150e6911a5343dca"
                    },
                    "owner": {
                        "user": {
                            "username": "REVOLT"
                        },
                        "profile_img_url": "https://storage.googleapis.com/opensea-static/opensea-profile/25.png",
                        "address": "0xb6d820e80a2a7c49f94c9d6c8ea08dccedc9ce4c",
                        "config": "",
                        "discord_id": ""
                    },
                    "permalink": "https://opensea.io/assets/0x50f5474724e0ee42d9a4e711ccfb275809fd6d4a/38999",
                    "collection": {
                        "banner_image_url": "https://lh3.googleusercontent.com/4NQIRoGmzXeXQN4mjuhWuuDZSNW7_BqRXux5upd4Nn_A-bfsGxCnPF8qn98Y6MyHRDPGXIlgfZADcSOe6M2DyrDKXdbdaTgkZN5l=s2500",
                        "chat_url": null,
                        "created_date": "2019-12-04T10:58:29.069907",
                        "default_to_fiat": false,
                        "description": "The Sandbox is a community-driven platform where creators can monetize voxel assets and gaming experiences on the blockchain. The Sandbox metaverse comprises a map made up of 166,464 LANDS.  LAND owners can host contests and events, stake SAND to earn and customize assets, monetize assets and experiences, vote in the metaverse governance, play games that you or others create, and more! Trade the collection and keep your eyes peeled for future drops.",
                        "dev_buyer_fee_basis_points": "0",
                        "dev_seller_fee_basis_points": "500",
                        "discord_url": "https://discord.gg/vAe4zvY",
                        "display_data": {
                            "card_display_style": "contain"
                        },
                        "external_url": "https://www.sandbox.game/",
                        "featured": false,
                        "featured_image_url": "https://storage.googleapis.com/opensea-static/featured-images/sandbox-featured.png",
                        "hidden": false,
                        "safelist_request_status": "verified",
                        "image_url": "https://lh3.googleusercontent.com/SXH8tW1siikB80rwCRnjm1a5xM_MwTg9Xl9Db6mioIk9HIlDM09pVoSR7GKJgS6ulSUpgW9BDtMk_ePX_NKgO9A=s60",
                        "is_subject_to_whitelist": false,
                        "large_image_url": "https://lh3.googleusercontent.com/SXH8tW1siikB80rwCRnjm1a5xM_MwTg9Xl9Db6mioIk9HIlDM09pVoSR7GKJgS6ulSUpgW9BDtMk_ePX_NKgO9A",
                        "medium_username": "sandbox-game",
                        "name": "The Sandbox",
                        "only_proxied_transfers": false,
                        "opensea_buyer_fee_basis_points": "0",
                        "opensea_seller_fee_basis_points": "250",
                        "payout_address": "0x7a9fe22691c811ea339d9b73150e6911a5343dca",
                        "require_email": false,
                        "short_description": null,
                        "slug": "sandbox",
                        "telegram_url": "https://t.me/sandboxgame",
                        "twitter_username": "thesandboxgame",
                        "instagram_username": null,
                        "wiki_url": null
                    },
                    "decimals": null,
                    "token_metadata": null
                }
            ],
            "name": "Small estate (9 lands)",
            "description": "Yes, you can afford it :o))",
            "external_link": "",
            "asset_contract": {
                "collection": {
                    "banner_image_url": "https://lh3.googleusercontent.com/4NQIRoGmzXeXQN4mjuhWuuDZSNW7_BqRXux5upd4Nn_A-bfsGxCnPF8qn98Y6MyHRDPGXIlgfZADcSOe6M2DyrDKXdbdaTgkZN5l=s2500",
                    "chat_url": null,
                    "created_date": "2019-12-04T10:58:29.069907",
                    "default_to_fiat": false,
                    "description": "The Sandbox is a community-driven platform where creators can monetize voxel assets and gaming experiences on the blockchain. The Sandbox metaverse comprises a map made up of 166,464 LANDS.  LAND owners can host contests and events, stake SAND to earn and customize assets, monetize assets and experiences, vote in the metaverse governance, play games that you or others create, and more! Trade the collection and keep your eyes peeled for future drops.",
                    "dev_buyer_fee_basis_points": "0",
                    "dev_seller_fee_basis_points": "500",
                    "discord_url": "https://discord.gg/vAe4zvY",
                    "display_data": {
                        "card_display_style": "contain"
                    },
                    "external_url": "https://www.sandbox.game/",
                    "featured": false,
                    "featured_image_url": "https://storage.googleapis.com/opensea-static/featured-images/sandbox-featured.png",
                    "hidden": false,
                    "safelist_request_status": "verified",
                    "image_url": "https://lh3.googleusercontent.com/SXH8tW1siikB80rwCRnjm1a5xM_MwTg9Xl9Db6mioIk9HIlDM09pVoSR7GKJgS6ulSUpgW9BDtMk_ePX_NKgO9A=s60",
                    "is_subject_to_whitelist": false,
                    "large_image_url": "https://lh3.googleusercontent.com/SXH8tW1siikB80rwCRnjm1a5xM_MwTg9Xl9Db6mioIk9HIlDM09pVoSR7GKJgS6ulSUpgW9BDtMk_ePX_NKgO9A",
                    "medium_username": "sandbox-game",
                    "name": "The Sandbox",
                    "only_proxied_transfers": false,
                    "opensea_buyer_fee_basis_points": "0",
                    "opensea_seller_fee_basis_points": "250",
                    "payout_address": "0x7a9fe22691c811ea339d9b73150e6911a5343dca",
                    "require_email": false,
                    "short_description": null,
                    "slug": "sandbox",
                    "telegram_url": "https://t.me/sandboxgame",
                    "twitter_username": "thesandboxgame",
                    "instagram_username": null,
                    "wiki_url": null
                },
                "address": "0x50f5474724e0ee42d9a4e711ccfb275809fd6d4a",
                "asset_contract_type": "non-fungible",
                "created_date": "2019-12-04T10:58:28.892990",
                "name": "Sandbox's LANDs",
                "nft_version": "3.0",
                "opensea_version": null,
                "owner": null,
                "schema_name": "ERC721",
                "symbol": "",
                "total_supply": null,
                "description": "The Sandbox is a community-driven platform where creators can monetize voxel assets and gaming experiences on the blockchain. The Sandbox metaverse comprises a map made up of 166,464 LANDS.  LAND owners can host contests and events, stake SAND to earn and customize assets, monetize assets and experiences, vote in the metaverse governance, play games that you or others create, and more! Trade the collection and keep your eyes peeled for future drops.",
                "external_link": "https://www.sandbox.game/",
                "image_url": "https://lh3.googleusercontent.com/SXH8tW1siikB80rwCRnjm1a5xM_MwTg9Xl9Db6mioIk9HIlDM09pVoSR7GKJgS6ulSUpgW9BDtMk_ePX_NKgO9A=s60",
                "default_to_fiat": false,
                "dev_buyer_fee_basis_points": 0,
                "dev_seller_fee_basis_points": 500,
                "only_proxied_transfers": false,
                "opensea_buyer_fee_basis_points": 0,
                "opensea_seller_fee_basis_points": 250,
                "buyer_fee_basis_points": 0,
                "seller_fee_basis_points": 750,
                "payout_address": "0x7a9fe22691c811ea339d9b73150e6911a5343dca"
            },
            "permalink": "https://opensea.io/bundles/small-estate-9-lands-caP",
            "sell_orders": [
                {
                    "created_date": "2021-05-25T21:46:09.677302",
                    "closing_date": null,
                    "closing_extendable": false,
                    "expiration_time": 0,
                    "listing_time": 1621979063,
                    "order_hash": "0xfc929b5793a077c1d53063d23662b35a417ff45880c329e6e9396a989d9d1b9b",
                    "metadata": {
                        "bundle": {
                            "assets": [
                                {
                                    "id": "38181",
                                    "address": "0x50f5474724e0ee42d9a4e711ccfb275809fd6d4a"
                                },
                                {
                                    "id": "38182",
                                    "address": "0x50f5474724e0ee42d9a4e711ccfb275809fd6d4a"
                                },
                                {
                                    "id": "38183",
                                    "address": "0x50f5474724e0ee42d9a4e711ccfb275809fd6d4a"
                                },
                                {
                                    "id": "38589",
                                    "address": "0x50f5474724e0ee42d9a4e711ccfb275809fd6d4a"
                                },
                                {
                                    "id": "38590",
                                    "address": "0x50f5474724e0ee42d9a4e711ccfb275809fd6d4a"
                                },
                                {
                                    "id": "38591",
                                    "address": "0x50f5474724e0ee42d9a4e711ccfb275809fd6d4a"
                                },
                                {
                                    "id": "38997",
                                    "address": "0x50f5474724e0ee42d9a4e711ccfb275809fd6d4a"
                                },
                                {
                                    "id": "38998",
                                    "address": "0x50f5474724e0ee42d9a4e711ccfb275809fd6d4a"
                                },
                                {
                                    "id": "38999",
                                    "address": "0x50f5474724e0ee42d9a4e711ccfb275809fd6d4a"
                                }
                            ],
                            "schemas": [
                                "ERC721",
                                "ERC721",
                                "ERC721",
                                "ERC721",
                                "ERC721",
                                "ERC721",
                                "ERC721",
                                "ERC721",
                                "ERC721"
                            ],
                            "name": "Small estate (9 lands)",
                            "description": "Yes, you can afford it :o))",
                            "external_link": ""
                        }
                    },
                    "exchange": "0x7be8076f4ea4a4ad08075c2508e481d6c946d12b",
                    "maker": {
                        "user": 3797,
                        "profile_img_url": "https://storage.googleapis.com/opensea-static/opensea-profile/25.png",
                        "address": "0xb6d820e80a2a7c49f94c9d6c8ea08dccedc9ce4c",
                        "config": "",
                        "discord_id": ""
                    },
                    "taker": {
                        "user": 1766,
                        "profile_img_url": "https://storage.googleapis.com/opensea-static/opensea-profile/1.png",
                        "address": "0x0000000000000000000000000000000000000000",
                        "config": "",
                        "discord_id": ""
                    },
                    "current_price": "135000000000000000000",
                    "current_bounty": "1350000000000000000",
                    "bounty_multiple": "0.01",
                    "maker_relayer_fee": "750",
                    "taker_relayer_fee": "0",
                    "maker_protocol_fee": "0",
                    "taker_protocol_fee": "0",
                    "maker_referrer_fee": "0",
                    "fee_recipient": {
                        "user": 3585,
                        "profile_img_url": "https://storage.googleapis.com/opensea-static/opensea-profile/28.png",
                        "address": "0x5b3256965e7c3cf26e11fcaf296dfc8807c01073",
                        "config": "verified",
                        "discord_id": ""
                    },
                    "fee_method": 1,
                    "side": 1,
                    "sale_kind": 0,
                    "target": "0xc99f70bfd82fb7c8f8191fdfbfb735606b15e5c5",
                    "how_to_call": 1,
                    "calldata": "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",
                    "replacement_pattern": "0x0000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000ffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffff0000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000ffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffff0000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000ffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffff0000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000ffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffff0000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000ffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffff0000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000ffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffff0000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000ffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffff0000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000ffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffff0000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000ffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffff000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000",
                    "static_target": "0x0000000000000000000000000000000000000000",
                    "static_extradata": "0x",
                    "payment_token": "0x0000000000000000000000000000000000000000",
                    "payment_token_contract": {
                        "id": 1,
                        "symbol": "ETH",
                        "address": "0x0000000000000000000000000000000000000000",
                        "image_url": "https://storage.opensea.io/files/6f8e2979d428180222796ff4a33ab929.svg",
                        "name": "Ether",
                        "decimals": 18,
                        "eth_price": "1.000000000000000",
                        "usd_price": "2625.730000000000018000"
                    },
                    "base_price": "135000000000000000000",
                    "extra": "0",
                    "quantity": "1",
                    "salt": "9769485547560478340092609806504322721842245432266059906703094179470249585895",
                    "v": 27,
                    "r": "0xc61494aeb3080f09d97b950c540109c07eb165b5c609cd174585547c24bfa38a",
                    "s": "0x09b683d7778732a8f6708d6fb24a8575aaeb72c32b3d4bef8d9183efc4dfb2d0",
                    "approved_on_chain": false,
                    "cancelled": false,
                    "finalized": false,
                    "marked_invalid": false,
                    "prefixed_hash": "0x68cfb3569bf39693f1158c90e93382554017599d84d21005aa2834017562214f"
                }
            ]
        },
        {
            "maker": {
                "user": {
                    "username": null
                },
                "profile_img_url": "https://storage.googleapis.com/opensea-static/opensea-profile/5.png",
                "address": "0xe289a24fc2859fa9fb4b5acc97de7d4d6f0dc831",
                "config": "",
                "discord_id": ""
            },
            "slug": "anthony-castoro-jace-hall-RTS",
            "assets": [
                {
                    "id": 20420931,
                    "token_id": "70479185245472823933799012500856922265354379340922944019462782626810971553793",
                    "num_sales": 0,
                    "background_color": null,
                    "image_url": "https://lh3.googleusercontent.com/1rpqnQD6iJ_Ukn27Ow5aWocYuyUk6GfZAkUhTZucGsnHN6KDcSTk-xXfwapdsVD4n8aSjXtzYlw3X7s9ZGaVPnjRfMfrdSHK1TvKbQ",
                    "image_preview_url": "https://lh3.googleusercontent.com/1rpqnQD6iJ_Ukn27Ow5aWocYuyUk6GfZAkUhTZucGsnHN6KDcSTk-xXfwapdsVD4n8aSjXtzYlw3X7s9ZGaVPnjRfMfrdSHK1TvKbQ=s250",
                    "image_thumbnail_url": "https://lh3.googleusercontent.com/1rpqnQD6iJ_Ukn27Ow5aWocYuyUk6GfZAkUhTZucGsnHN6KDcSTk-xXfwapdsVD4n8aSjXtzYlw3X7s9ZGaVPnjRfMfrdSHK1TvKbQ=s128",
                    "image_original_url": null,
                    "animation_url": null,
                    "animation_original_url": null,
                    "name": "Anthony Castoro",
                    "description": "Energy Amplification / Deadpan Delivery\n1 of 10",
                    "external_link": null,
                    "asset_contract": {
                        "address": "0x495f947276749ce646f68ac8c248420045cb7b5e",
                        "asset_contract_type": "semi-fungible",
                        "created_date": "2020-12-02T17:40:53.232025",
                        "name": "OpenSea Collection",
                        "nft_version": null,
                        "opensea_version": "2.0.0",
                        "owner": 102384,
                        "schema_name": "ERC1155",
                        "symbol": "OPENSTORE",
                        "total_supply": null,
                        "description": null,
                        "external_link": null,
                        "image_url": null,
                        "default_to_fiat": false,
                        "dev_buyer_fee_basis_points": 0,
                        "dev_seller_fee_basis_points": 0,
                        "only_proxied_transfers": false,
                        "opensea_buyer_fee_basis_points": 0,
                        "opensea_seller_fee_basis_points": 250,
                        "buyer_fee_basis_points": 0,
                        "seller_fee_basis_points": 250,
                        "payout_address": null
                    },
                    "owner": {
                        "user": {
                            "username": "NullAddress"
                        },
                        "profile_img_url": "https://storage.googleapis.com/opensea-static/opensea-profile/1.png",
                        "address": "0x0000000000000000000000000000000000000000",
                        "config": "",
                        "discord_id": ""
                    },
                    "permalink": "https://opensea.io/assets/0x495f947276749ce646f68ac8c248420045cb7b5e/70479185245472823933799012500856922265354379340922944019462782626810971553793",
                    "collection": {
                        "banner_image_url": "https://lh3.googleusercontent.com/i1dLTD9hXZSzeMGz02l202fkMjd3QQrZ2fCQ2TZt-ajo3L931rN_TRGeqU9IvTfm166GIvs5DWaWCKbnuxKq5JmMHLOXioRyCuMxNQ=s2500",
                        "chat_url": null,
                        "created_date": "2021-03-24T00:31:54.219565",
                        "default_to_fiat": false,
                        "description": "",
                        "dev_buyer_fee_basis_points": "0",
                        "dev_seller_fee_basis_points": "0",
                        "discord_url": null,
                        "display_data": {
                            "card_display_style": "contain",
                            "images": []
                        },
                        "external_url": null,
                        "featured": false,
                        "featured_image_url": null,
                        "hidden": true,
                        "safelist_request_status": "not_requested",
                        "image_url": "https://lh3.googleusercontent.com/qZRiTQMHRe5EswI1syqlf0Sf3sfY8bnZjtVhjn89Kh_RxfqZ1WBWTJBnyvnB-gJWsvr6-DsACvVxrPBsj5pSlecxj63iAcVfQTkD=s120",
                        "is_subject_to_whitelist": false,
                        "large_image_url": null,
                        "medium_username": null,
                        "name": "HiDef",
                        "only_proxied_transfers": false,
                        "opensea_buyer_fee_basis_points": "0",
                        "opensea_seller_fee_basis_points": "250",
                        "payout_address": null,
                        "require_email": false,
                        "short_description": null,
                        "slug": "hidef",
                        "telegram_url": null,
                        "twitter_username": null,
                        "instagram_username": null,
                        "wiki_url": null
                    },
                    "decimals": null,
                    "token_metadata": null
                },
                {
                    "id": 20420957,
                    "token_id": "70479185245472823933799012500856922265354379340922944019462782627910483181569",
                    "num_sales": 0,
                    "background_color": null,
                    "image_url": "https://lh3.googleusercontent.com/1rpqnQD6iJ_Ukn27Ow5aWocYuyUk6GfZAkUhTZucGsnHN6KDcSTk-xXfwapdsVD4n8aSjXtzYlw3X7s9ZGaVPnjRfMfrdSHK1TvKbQ",
                    "image_preview_url": "https://lh3.googleusercontent.com/1rpqnQD6iJ_Ukn27Ow5aWocYuyUk6GfZAkUhTZucGsnHN6KDcSTk-xXfwapdsVD4n8aSjXtzYlw3X7s9ZGaVPnjRfMfrdSHK1TvKbQ=s250",
                    "image_thumbnail_url": "https://lh3.googleusercontent.com/1rpqnQD6iJ_Ukn27Ow5aWocYuyUk6GfZAkUhTZucGsnHN6KDcSTk-xXfwapdsVD4n8aSjXtzYlw3X7s9ZGaVPnjRfMfrdSHK1TvKbQ=s128",
                    "image_original_url": null,
                    "animation_url": null,
                    "animation_original_url": null,
                    "name": "Anthony Castoro",
                    "description": "Energy Amplification / Deadpan Delivery\n2 of 10",
                    "external_link": null,
                    "asset_contract": {
                        "address": "0x495f947276749ce646f68ac8c248420045cb7b5e",
                        "asset_contract_type": "semi-fungible",
                        "created_date": "2020-12-02T17:40:53.232025",
                        "name": "OpenSea Collection",
                        "nft_version": null,
                        "opensea_version": "2.0.0",
                        "owner": 102384,
                        "schema_name": "ERC1155",
                        "symbol": "OPENSTORE",
                        "total_supply": null,
                        "description": null,
                        "external_link": null,
                        "image_url": null,
                        "default_to_fiat": false,
                        "dev_buyer_fee_basis_points": 0,
                        "dev_seller_fee_basis_points": 0,
                        "only_proxied_transfers": false,
                        "opensea_buyer_fee_basis_points": 0,
                        "opensea_seller_fee_basis_points": 250,
                        "buyer_fee_basis_points": 0,
                        "seller_fee_basis_points": 250,
                        "payout_address": null
                    },
                    "owner": {
                        "user": {
                            "username": "NullAddress"
                        },
                        "profile_img_url": "https://storage.googleapis.com/opensea-static/opensea-profile/1.png",
                        "address": "0x0000000000000000000000000000000000000000",
                        "config": "",
                        "discord_id": ""
                    },
                    "permalink": "https://opensea.io/assets/0x495f947276749ce646f68ac8c248420045cb7b5e/70479185245472823933799012500856922265354379340922944019462782627910483181569",
                    "collection": {
                        "banner_image_url": "https://lh3.googleusercontent.com/i1dLTD9hXZSzeMGz02l202fkMjd3QQrZ2fCQ2TZt-ajo3L931rN_TRGeqU9IvTfm166GIvs5DWaWCKbnuxKq5JmMHLOXioRyCuMxNQ=s2500",
                        "chat_url": null,
                        "created_date": "2021-03-24T00:31:54.219565",
                        "default_to_fiat": false,
                        "description": "",
                        "dev_buyer_fee_basis_points": "0",
                        "dev_seller_fee_basis_points": "0",
                        "discord_url": null,
                        "display_data": {
                            "card_display_style": "contain",
                            "images": []
                        },
                        "external_url": null,
                        "featured": false,
                        "featured_image_url": null,
                        "hidden": true,
                        "safelist_request_status": "not_requested",
                        "image_url": "https://lh3.googleusercontent.com/qZRiTQMHRe5EswI1syqlf0Sf3sfY8bnZjtVhjn89Kh_RxfqZ1WBWTJBnyvnB-gJWsvr6-DsACvVxrPBsj5pSlecxj63iAcVfQTkD=s120",
                        "is_subject_to_whitelist": false,
                        "large_image_url": null,
                        "medium_username": null,
                        "name": "HiDef",
                        "only_proxied_transfers": false,
                        "opensea_buyer_fee_basis_points": "0",
                        "opensea_seller_fee_basis_points": "250",
                        "payout_address": null,
                        "require_email": false,
                        "short_description": null,
                        "slug": "hidef",
                        "telegram_url": null,
                        "twitter_username": null,
                        "instagram_username": null,
                        "wiki_url": null
                    },
                    "decimals": null,
                    "token_metadata": null
                },
                {
                    "id": 20420986,
                    "token_id": "70479185245472823933799012500856922265354379340922944019462782629009994809345",
                    "num_sales": 0,
                    "background_color": null,
                    "image_url": "https://lh3.googleusercontent.com/1rpqnQD6iJ_Ukn27Ow5aWocYuyUk6GfZAkUhTZucGsnHN6KDcSTk-xXfwapdsVD4n8aSjXtzYlw3X7s9ZGaVPnjRfMfrdSHK1TvKbQ",
                    "image_preview_url": "https://lh3.googleusercontent.com/1rpqnQD6iJ_Ukn27Ow5aWocYuyUk6GfZAkUhTZucGsnHN6KDcSTk-xXfwapdsVD4n8aSjXtzYlw3X7s9ZGaVPnjRfMfrdSHK1TvKbQ=s250",
                    "image_thumbnail_url": "https://lh3.googleusercontent.com/1rpqnQD6iJ_Ukn27Ow5aWocYuyUk6GfZAkUhTZucGsnHN6KDcSTk-xXfwapdsVD4n8aSjXtzYlw3X7s9ZGaVPnjRfMfrdSHK1TvKbQ=s128",
                    "image_original_url": null,
                    "animation_url": null,
                    "animation_original_url": null,
                    "name": "Anthony Castoro",
                    "description": "Energy Amplification / Deadpan Delivery\n3 of 10",
                    "external_link": null,
                    "asset_contract": {
                        "address": "0x495f947276749ce646f68ac8c248420045cb7b5e",
                        "asset_contract_type": "semi-fungible",
                        "created_date": "2020-12-02T17:40:53.232025",
                        "name": "OpenSea Collection",
                        "nft_version": null,
                        "opensea_version": "2.0.0",
                        "owner": 102384,
                        "schema_name": "ERC1155",
                        "symbol": "OPENSTORE",
                        "total_supply": null,
                        "description": null,
                        "external_link": null,
                        "image_url": null,
                        "default_to_fiat": false,
                        "dev_buyer_fee_basis_points": 0,
                        "dev_seller_fee_basis_points": 0,
                        "only_proxied_transfers": false,
                        "opensea_buyer_fee_basis_points": 0,
                        "opensea_seller_fee_basis_points": 250,
                        "buyer_fee_basis_points": 0,
                        "seller_fee_basis_points": 250,
                        "payout_address": null
                    },
                    "owner": {
                        "user": {
                            "username": "NullAddress"
                        },
                        "profile_img_url": "https://storage.googleapis.com/opensea-static/opensea-profile/1.png",
                        "address": "0x0000000000000000000000000000000000000000",
                        "config": "",
                        "discord_id": ""
                    },
                    "permalink": "https://opensea.io/assets/0x495f947276749ce646f68ac8c248420045cb7b5e/70479185245472823933799012500856922265354379340922944019462782629009994809345",
                    "collection": {
                        "banner_image_url": "https://lh3.googleusercontent.com/i1dLTD9hXZSzeMGz02l202fkMjd3QQrZ2fCQ2TZt-ajo3L931rN_TRGeqU9IvTfm166GIvs5DWaWCKbnuxKq5JmMHLOXioRyCuMxNQ=s2500",
                        "chat_url": null,
                        "created_date": "2021-03-24T00:31:54.219565",
                        "default_to_fiat": false,
                        "description": "",
                        "dev_buyer_fee_basis_points": "0",
                        "dev_seller_fee_basis_points": "0",
                        "discord_url": null,
                        "display_data": {
                            "card_display_style": "contain",
                            "images": []
                        },
                        "external_url": null,
                        "featured": false,
                        "featured_image_url": null,
                        "hidden": true,
                        "safelist_request_status": "not_requested",
                        "image_url": "https://lh3.googleusercontent.com/qZRiTQMHRe5EswI1syqlf0Sf3sfY8bnZjtVhjn89Kh_RxfqZ1WBWTJBnyvnB-gJWsvr6-DsACvVxrPBsj5pSlecxj63iAcVfQTkD=s120",
                        "is_subject_to_whitelist": false,
                        "large_image_url": null,
                        "medium_username": null,
                        "name": "HiDef",
                        "only_proxied_transfers": false,
                        "opensea_buyer_fee_basis_points": "0",
                        "opensea_seller_fee_basis_points": "250",
                        "payout_address": null,
                        "require_email": false,
                        "short_description": null,
                        "slug": "hidef",
                        "telegram_url": null,
                        "twitter_username": null,
                        "instagram_username": null,
                        "wiki_url": null
                    },
                    "decimals": null,
                    "token_metadata": null
                },
                {
                    "id": 20421008,
                    "token_id": "70479185245472823933799012500856922265354379340922944019462782630109506437121",
                    "num_sales": 0,
                    "background_color": null,
                    "image_url": "https://lh3.googleusercontent.com/1rpqnQD6iJ_Ukn27Ow5aWocYuyUk6GfZAkUhTZucGsnHN6KDcSTk-xXfwapdsVD4n8aSjXtzYlw3X7s9ZGaVPnjRfMfrdSHK1TvKbQ",
                    "image_preview_url": "https://lh3.googleusercontent.com/1rpqnQD6iJ_Ukn27Ow5aWocYuyUk6GfZAkUhTZucGsnHN6KDcSTk-xXfwapdsVD4n8aSjXtzYlw3X7s9ZGaVPnjRfMfrdSHK1TvKbQ=s250",
                    "image_thumbnail_url": "https://lh3.googleusercontent.com/1rpqnQD6iJ_Ukn27Ow5aWocYuyUk6GfZAkUhTZucGsnHN6KDcSTk-xXfwapdsVD4n8aSjXtzYlw3X7s9ZGaVPnjRfMfrdSHK1TvKbQ=s128",
                    "image_original_url": null,
                    "animation_url": null,
                    "animation_original_url": null,
                    "name": "Anthony Castoro",
                    "description": "Energy Amplification / Deadpan Delivery\n4 of 10",
                    "external_link": null,
                    "asset_contract": {
                        "address": "0x495f947276749ce646f68ac8c248420045cb7b5e",
                        "asset_contract_type": "semi-fungible",
                        "created_date": "2020-12-02T17:40:53.232025",
                        "name": "OpenSea Collection",
                        "nft_version": null,
                        "opensea_version": "2.0.0",
                        "owner": 102384,
                        "schema_name": "ERC1155",
                        "symbol": "OPENSTORE",
                        "total_supply": null,
                        "description": null,
                        "external_link": null,
                        "image_url": null,
                        "default_to_fiat": false,
                        "dev_buyer_fee_basis_points": 0,
                        "dev_seller_fee_basis_points": 0,
                        "only_proxied_transfers": false,
                        "opensea_buyer_fee_basis_points": 0,
                        "opensea_seller_fee_basis_points": 250,
                        "buyer_fee_basis_points": 0,
                        "seller_fee_basis_points": 250,
                        "payout_address": null
                    },
                    "owner": {
                        "user": {
                            "username": "NullAddress"
                        },
                        "profile_img_url": "https://storage.googleapis.com/opensea-static/opensea-profile/1.png",
                        "address": "0x0000000000000000000000000000000000000000",
                        "config": "",
                        "discord_id": ""
                    },
                    "permalink": "https://opensea.io/assets/0x495f947276749ce646f68ac8c248420045cb7b5e/70479185245472823933799012500856922265354379340922944019462782630109506437121",
                    "collection": {
                        "banner_image_url": "https://lh3.googleusercontent.com/i1dLTD9hXZSzeMGz02l202fkMjd3QQrZ2fCQ2TZt-ajo3L931rN_TRGeqU9IvTfm166GIvs5DWaWCKbnuxKq5JmMHLOXioRyCuMxNQ=s2500",
                        "chat_url": null,
                        "created_date": "2021-03-24T00:31:54.219565",
                        "default_to_fiat": false,
                        "description": "",
                        "dev_buyer_fee_basis_points": "0",
                        "dev_seller_fee_basis_points": "0",
                        "discord_url": null,
                        "display_data": {
                            "card_display_style": "contain",
                            "images": []
                        },
                        "external_url": null,
                        "featured": false,
                        "featured_image_url": null,
                        "hidden": true,
                        "safelist_request_status": "not_requested",
                        "image_url": "https://lh3.googleusercontent.com/qZRiTQMHRe5EswI1syqlf0Sf3sfY8bnZjtVhjn89Kh_RxfqZ1WBWTJBnyvnB-gJWsvr6-DsACvVxrPBsj5pSlecxj63iAcVfQTkD=s120",
                        "is_subject_to_whitelist": false,
                        "large_image_url": null,
                        "medium_username": null,
                        "name": "HiDef",
                        "only_proxied_transfers": false,
                        "opensea_buyer_fee_basis_points": "0",
                        "opensea_seller_fee_basis_points": "250",
                        "payout_address": null,
                        "require_email": false,
                        "short_description": null,
                        "slug": "hidef",
                        "telegram_url": null,
                        "twitter_username": null,
                        "instagram_username": null,
                        "wiki_url": null
                    },
                    "decimals": null,
                    "token_metadata": null
                },
                {
                    "id": 20421052,
                    "token_id": "70479185245472823933799012500856922265354379340922944019462782631209018064897",
                    "num_sales": 0,
                    "background_color": null,
                    "image_url": "https://lh3.googleusercontent.com/1rpqnQD6iJ_Ukn27Ow5aWocYuyUk6GfZAkUhTZucGsnHN6KDcSTk-xXfwapdsVD4n8aSjXtzYlw3X7s9ZGaVPnjRfMfrdSHK1TvKbQ",
                    "image_preview_url": "https://lh3.googleusercontent.com/1rpqnQD6iJ_Ukn27Ow5aWocYuyUk6GfZAkUhTZucGsnHN6KDcSTk-xXfwapdsVD4n8aSjXtzYlw3X7s9ZGaVPnjRfMfrdSHK1TvKbQ=s250",
                    "image_thumbnail_url": "https://lh3.googleusercontent.com/1rpqnQD6iJ_Ukn27Ow5aWocYuyUk6GfZAkUhTZucGsnHN6KDcSTk-xXfwapdsVD4n8aSjXtzYlw3X7s9ZGaVPnjRfMfrdSHK1TvKbQ=s128",
                    "image_original_url": null,
                    "animation_url": null,
                    "animation_original_url": null,
                    "name": "Anthony Castoro",
                    "description": "Energy Amplification / Deadpan Delivery\n5 of 10",
                    "external_link": null,
                    "asset_contract": {
                        "address": "0x495f947276749ce646f68ac8c248420045cb7b5e",
                        "asset_contract_type": "semi-fungible",
                        "created_date": "2020-12-02T17:40:53.232025",
                        "name": "OpenSea Collection",
                        "nft_version": null,
                        "opensea_version": "2.0.0",
                        "owner": 102384,
                        "schema_name": "ERC1155",
                        "symbol": "OPENSTORE",
                        "total_supply": null,
                        "description": null,
                        "external_link": null,
                        "image_url": null,
                        "default_to_fiat": false,
                        "dev_buyer_fee_basis_points": 0,
                        "dev_seller_fee_basis_points": 0,
                        "only_proxied_transfers": false,
                        "opensea_buyer_fee_basis_points": 0,
                        "opensea_seller_fee_basis_points": 250,
                        "buyer_fee_basis_points": 0,
                        "seller_fee_basis_points": 250,
                        "payout_address": null
                    },
                    "owner": {
                        "user": {
                            "username": "NullAddress"
                        },
                        "profile_img_url": "https://storage.googleapis.com/opensea-static/opensea-profile/1.png",
                        "address": "0x0000000000000000000000000000000000000000",
                        "config": "",
                        "discord_id": ""
                    },
                    "permalink": "https://opensea.io/assets/0x495f947276749ce646f68ac8c248420045cb7b5e/70479185245472823933799012500856922265354379340922944019462782631209018064897",
                    "collection": {
                        "banner_image_url": "https://lh3.googleusercontent.com/i1dLTD9hXZSzeMGz02l202fkMjd3QQrZ2fCQ2TZt-ajo3L931rN_TRGeqU9IvTfm166GIvs5DWaWCKbnuxKq5JmMHLOXioRyCuMxNQ=s2500",
                        "chat_url": null,
                        "created_date": "2021-03-24T00:31:54.219565",
                        "default_to_fiat": false,
                        "description": "",
                        "dev_buyer_fee_basis_points": "0",
                        "dev_seller_fee_basis_points": "0",
                        "discord_url": null,
                        "display_data": {
                            "card_display_style": "contain",
                            "images": []
                        },
                        "external_url": null,
                        "featured": false,
                        "featured_image_url": null,
                        "hidden": true,
                        "safelist_request_status": "not_requested",
                        "image_url": "https://lh3.googleusercontent.com/qZRiTQMHRe5EswI1syqlf0Sf3sfY8bnZjtVhjn89Kh_RxfqZ1WBWTJBnyvnB-gJWsvr6-DsACvVxrPBsj5pSlecxj63iAcVfQTkD=s120",
                        "is_subject_to_whitelist": false,
                        "large_image_url": null,
                        "medium_username": null,
                        "name": "HiDef",
                        "only_proxied_transfers": false,
                        "opensea_buyer_fee_basis_points": "0",
                        "opensea_seller_fee_basis_points": "250",
                        "payout_address": null,
                        "require_email": false,
                        "short_description": null,
                        "slug": "hidef",
                        "telegram_url": null,
                        "twitter_username": null,
                        "instagram_username": null,
                        "wiki_url": null
                    },
                    "decimals": null,
                    "token_metadata": null
                },
                {
                    "id": 20421068,
                    "token_id": "70479185245472823933799012500856922265354379340922944019462782632308529692673",
                    "num_sales": 0,
                    "background_color": null,
                    "image_url": "https://lh3.googleusercontent.com/1rpqnQD6iJ_Ukn27Ow5aWocYuyUk6GfZAkUhTZucGsnHN6KDcSTk-xXfwapdsVD4n8aSjXtzYlw3X7s9ZGaVPnjRfMfrdSHK1TvKbQ",
                    "image_preview_url": "https://lh3.googleusercontent.com/1rpqnQD6iJ_Ukn27Ow5aWocYuyUk6GfZAkUhTZucGsnHN6KDcSTk-xXfwapdsVD4n8aSjXtzYlw3X7s9ZGaVPnjRfMfrdSHK1TvKbQ=s250",
                    "image_thumbnail_url": "https://lh3.googleusercontent.com/1rpqnQD6iJ_Ukn27Ow5aWocYuyUk6GfZAkUhTZucGsnHN6KDcSTk-xXfwapdsVD4n8aSjXtzYlw3X7s9ZGaVPnjRfMfrdSHK1TvKbQ=s128",
                    "image_original_url": null,
                    "animation_url": null,
                    "animation_original_url": null,
                    "name": "Anthony Castoro",
                    "description": "Energy Amplification / Deadpan Delivery\n6 of 10",
                    "external_link": null,
                    "asset_contract": {
                        "address": "0x495f947276749ce646f68ac8c248420045cb7b5e",
                        "asset_contract_type": "semi-fungible",
                        "created_date": "2020-12-02T17:40:53.232025",
                        "name": "OpenSea Collection",
                        "nft_version": null,
                        "opensea_version": "2.0.0",
                        "owner": 102384,
                        "schema_name": "ERC1155",
                        "symbol": "OPENSTORE",
                        "total_supply": null,
                        "description": null,
                        "external_link": null,
                        "image_url": null,
                        "default_to_fiat": false,
                        "dev_buyer_fee_basis_points": 0,
                        "dev_seller_fee_basis_points": 0,
                        "only_proxied_transfers": false,
                        "opensea_buyer_fee_basis_points": 0,
                        "opensea_seller_fee_basis_points": 250,
                        "buyer_fee_basis_points": 0,
                        "seller_fee_basis_points": 250,
                        "payout_address": null
                    },
                    "owner": {
                        "user": {
                            "username": "NullAddress"
                        },
                        "profile_img_url": "https://storage.googleapis.com/opensea-static/opensea-profile/1.png",
                        "address": "0x0000000000000000000000000000000000000000",
                        "config": "",
                        "discord_id": ""
                    },
                    "permalink": "https://opensea.io/assets/0x495f947276749ce646f68ac8c248420045cb7b5e/70479185245472823933799012500856922265354379340922944019462782632308529692673",
                    "collection": {
                        "banner_image_url": "https://lh3.googleusercontent.com/i1dLTD9hXZSzeMGz02l202fkMjd3QQrZ2fCQ2TZt-ajo3L931rN_TRGeqU9IvTfm166GIvs5DWaWCKbnuxKq5JmMHLOXioRyCuMxNQ=s2500",
                        "chat_url": null,
                        "created_date": "2021-03-24T00:31:54.219565",
                        "default_to_fiat": false,
                        "description": "",
                        "dev_buyer_fee_basis_points": "0",
                        "dev_seller_fee_basis_points": "0",
                        "discord_url": null,
                        "display_data": {
                            "card_display_style": "contain",
                            "images": []
                        },
                        "external_url": null,
                        "featured": false,
                        "featured_image_url": null,
                        "hidden": true,
                        "safelist_request_status": "not_requested",
                        "image_url": "https://lh3.googleusercontent.com/qZRiTQMHRe5EswI1syqlf0Sf3sfY8bnZjtVhjn89Kh_RxfqZ1WBWTJBnyvnB-gJWsvr6-DsACvVxrPBsj5pSlecxj63iAcVfQTkD=s120",
                        "is_subject_to_whitelist": false,
                        "large_image_url": null,
                        "medium_username": null,
                        "name": "HiDef",
                        "only_proxied_transfers": false,
                        "opensea_buyer_fee_basis_points": "0",
                        "opensea_seller_fee_basis_points": "250",
                        "payout_address": null,
                        "require_email": false,
                        "short_description": null,
                        "slug": "hidef",
                        "telegram_url": null,
                        "twitter_username": null,
                        "instagram_username": null,
                        "wiki_url": null
                    },
                    "decimals": null,
                    "token_metadata": null
                },
                {
                    "id": 20421099,
                    "token_id": "70479185245472823933799012500856922265354379340922944019462782633408041320449",
                    "num_sales": 0,
                    "background_color": null,
                    "image_url": "https://lh3.googleusercontent.com/1rpqnQD6iJ_Ukn27Ow5aWocYuyUk6GfZAkUhTZucGsnHN6KDcSTk-xXfwapdsVD4n8aSjXtzYlw3X7s9ZGaVPnjRfMfrdSHK1TvKbQ",
                    "image_preview_url": "https://lh3.googleusercontent.com/1rpqnQD6iJ_Ukn27Ow5aWocYuyUk6GfZAkUhTZucGsnHN6KDcSTk-xXfwapdsVD4n8aSjXtzYlw3X7s9ZGaVPnjRfMfrdSHK1TvKbQ=s250",
                    "image_thumbnail_url": "https://lh3.googleusercontent.com/1rpqnQD6iJ_Ukn27Ow5aWocYuyUk6GfZAkUhTZucGsnHN6KDcSTk-xXfwapdsVD4n8aSjXtzYlw3X7s9ZGaVPnjRfMfrdSHK1TvKbQ=s128",
                    "image_original_url": null,
                    "animation_url": null,
                    "animation_original_url": null,
                    "name": "Anthony Castoro",
                    "description": "Energy Amplification / Deadpan Delivery\n7 of 10",
                    "external_link": null,
                    "asset_contract": {
                        "address": "0x495f947276749ce646f68ac8c248420045cb7b5e",
                        "asset_contract_type": "semi-fungible",
                        "created_date": "2020-12-02T17:40:53.232025",
                        "name": "OpenSea Collection",
                        "nft_version": null,
                        "opensea_version": "2.0.0",
                        "owner": 102384,
                        "schema_name": "ERC1155",
                        "symbol": "OPENSTORE",
                        "total_supply": null,
                        "description": null,
                        "external_link": null,
                        "image_url": null,
                        "default_to_fiat": false,
                        "dev_buyer_fee_basis_points": 0,
                        "dev_seller_fee_basis_points": 0,
                        "only_proxied_transfers": false,
                        "opensea_buyer_fee_basis_points": 0,
                        "opensea_seller_fee_basis_points": 250,
                        "buyer_fee_basis_points": 0,
                        "seller_fee_basis_points": 250,
                        "payout_address": null
                    },
                    "owner": {
                        "user": {
                            "username": "NullAddress"
                        },
                        "profile_img_url": "https://storage.googleapis.com/opensea-static/opensea-profile/1.png",
                        "address": "0x0000000000000000000000000000000000000000",
                        "config": "",
                        "discord_id": ""
                    },
                    "permalink": "https://opensea.io/assets/0x495f947276749ce646f68ac8c248420045cb7b5e/70479185245472823933799012500856922265354379340922944019462782633408041320449",
                    "collection": {
                        "banner_image_url": "https://lh3.googleusercontent.com/i1dLTD9hXZSzeMGz02l202fkMjd3QQrZ2fCQ2TZt-ajo3L931rN_TRGeqU9IvTfm166GIvs5DWaWCKbnuxKq5JmMHLOXioRyCuMxNQ=s2500",
                        "chat_url": null,
                        "created_date": "2021-03-24T00:31:54.219565",
                        "default_to_fiat": false,
                        "description": "",
                        "dev_buyer_fee_basis_points": "0",
                        "dev_seller_fee_basis_points": "0",
                        "discord_url": null,
                        "display_data": {
                            "card_display_style": "contain",
                            "images": []
                        },
                        "external_url": null,
                        "featured": false,
                        "featured_image_url": null,
                        "hidden": true,
                        "safelist_request_status": "not_requested",
                        "image_url": "https://lh3.googleusercontent.com/qZRiTQMHRe5EswI1syqlf0Sf3sfY8bnZjtVhjn89Kh_RxfqZ1WBWTJBnyvnB-gJWsvr6-DsACvVxrPBsj5pSlecxj63iAcVfQTkD=s120",
                        "is_subject_to_whitelist": false,
                        "large_image_url": null,
                        "medium_username": null,
                        "name": "HiDef",
                        "only_proxied_transfers": false,
                        "opensea_buyer_fee_basis_points": "0",
                        "opensea_seller_fee_basis_points": "250",
                        "payout_address": null,
                        "require_email": false,
                        "short_description": null,
                        "slug": "hidef",
                        "telegram_url": null,
                        "twitter_username": null,
                        "instagram_username": null,
                        "wiki_url": null
                    },
                    "decimals": null,
                    "token_metadata": null
                },
                {
                    "id": 20421116,
                    "token_id": "70479185245472823933799012500856922265354379340922944019462782634507552948225",
                    "num_sales": 0,
                    "background_color": null,
                    "image_url": "https://lh3.googleusercontent.com/1rpqnQD6iJ_Ukn27Ow5aWocYuyUk6GfZAkUhTZucGsnHN6KDcSTk-xXfwapdsVD4n8aSjXtzYlw3X7s9ZGaVPnjRfMfrdSHK1TvKbQ",
                    "image_preview_url": "https://lh3.googleusercontent.com/1rpqnQD6iJ_Ukn27Ow5aWocYuyUk6GfZAkUhTZucGsnHN6KDcSTk-xXfwapdsVD4n8aSjXtzYlw3X7s9ZGaVPnjRfMfrdSHK1TvKbQ=s250",
                    "image_thumbnail_url": "https://lh3.googleusercontent.com/1rpqnQD6iJ_Ukn27Ow5aWocYuyUk6GfZAkUhTZucGsnHN6KDcSTk-xXfwapdsVD4n8aSjXtzYlw3X7s9ZGaVPnjRfMfrdSHK1TvKbQ=s128",
                    "image_original_url": null,
                    "animation_url": null,
                    "animation_original_url": null,
                    "name": "Anthony Castoro",
                    "description": "Energy Amplification / Deadpan Delivery\n8 of 10",
                    "external_link": null,
                    "asset_contract": {
                        "address": "0x495f947276749ce646f68ac8c248420045cb7b5e",
                        "asset_contract_type": "semi-fungible",
                        "created_date": "2020-12-02T17:40:53.232025",
                        "name": "OpenSea Collection",
                        "nft_version": null,
                        "opensea_version": "2.0.0",
                        "owner": 102384,
                        "schema_name": "ERC1155",
                        "symbol": "OPENSTORE",
                        "total_supply": null,
                        "description": null,
                        "external_link": null,
                        "image_url": null,
                        "default_to_fiat": false,
                        "dev_buyer_fee_basis_points": 0,
                        "dev_seller_fee_basis_points": 0,
                        "only_proxied_transfers": false,
                        "opensea_buyer_fee_basis_points": 0,
                        "opensea_seller_fee_basis_points": 250,
                        "buyer_fee_basis_points": 0,
                        "seller_fee_basis_points": 250,
                        "payout_address": null
                    },
                    "owner": {
                        "user": {
                            "username": "NullAddress"
                        },
                        "profile_img_url": "https://storage.googleapis.com/opensea-static/opensea-profile/1.png",
                        "address": "0x0000000000000000000000000000000000000000",
                        "config": "",
                        "discord_id": ""
                    },
                    "permalink": "https://opensea.io/assets/0x495f947276749ce646f68ac8c248420045cb7b5e/70479185245472823933799012500856922265354379340922944019462782634507552948225",
                    "collection": {
                        "banner_image_url": "https://lh3.googleusercontent.com/i1dLTD9hXZSzeMGz02l202fkMjd3QQrZ2fCQ2TZt-ajo3L931rN_TRGeqU9IvTfm166GIvs5DWaWCKbnuxKq5JmMHLOXioRyCuMxNQ=s2500",
                        "chat_url": null,
                        "created_date": "2021-03-24T00:31:54.219565",
                        "default_to_fiat": false,
                        "description": "",
                        "dev_buyer_fee_basis_points": "0",
                        "dev_seller_fee_basis_points": "0",
                        "discord_url": null,
                        "display_data": {
                            "card_display_style": "contain",
                            "images": []
                        },
                        "external_url": null,
                        "featured": false,
                        "featured_image_url": null,
                        "hidden": true,
                        "safelist_request_status": "not_requested",
                        "image_url": "https://lh3.googleusercontent.com/qZRiTQMHRe5EswI1syqlf0Sf3sfY8bnZjtVhjn89Kh_RxfqZ1WBWTJBnyvnB-gJWsvr6-DsACvVxrPBsj5pSlecxj63iAcVfQTkD=s120",
                        "is_subject_to_whitelist": false,
                        "large_image_url": null,
                        "medium_username": null,
                        "name": "HiDef",
                        "only_proxied_transfers": false,
                        "opensea_buyer_fee_basis_points": "0",
                        "opensea_seller_fee_basis_points": "250",
                        "payout_address": null,
                        "require_email": false,
                        "short_description": null,
                        "slug": "hidef",
                        "telegram_url": null,
                        "twitter_username": null,
                        "instagram_username": null,
                        "wiki_url": null
                    },
                    "decimals": null,
                    "token_metadata": null
                },
                {
                    "id": 20421142,
                    "token_id": "70479185245472823933799012500856922265354379340922944019462782635607064576001",
                    "num_sales": 0,
                    "background_color": null,
                    "image_url": "https://lh3.googleusercontent.com/1rpqnQD6iJ_Ukn27Ow5aWocYuyUk6GfZAkUhTZucGsnHN6KDcSTk-xXfwapdsVD4n8aSjXtzYlw3X7s9ZGaVPnjRfMfrdSHK1TvKbQ",
                    "image_preview_url": "https://lh3.googleusercontent.com/1rpqnQD6iJ_Ukn27Ow5aWocYuyUk6GfZAkUhTZucGsnHN6KDcSTk-xXfwapdsVD4n8aSjXtzYlw3X7s9ZGaVPnjRfMfrdSHK1TvKbQ=s250",
                    "image_thumbnail_url": "https://lh3.googleusercontent.com/1rpqnQD6iJ_Ukn27Ow5aWocYuyUk6GfZAkUhTZucGsnHN6KDcSTk-xXfwapdsVD4n8aSjXtzYlw3X7s9ZGaVPnjRfMfrdSHK1TvKbQ=s128",
                    "image_original_url": null,
                    "animation_url": null,
                    "animation_original_url": null,
                    "name": "Anthony Castoro",
                    "description": "Energy Amplification / Deadpan Delivery\n9 of 10",
                    "external_link": null,
                    "asset_contract": {
                        "address": "0x495f947276749ce646f68ac8c248420045cb7b5e",
                        "asset_contract_type": "semi-fungible",
                        "created_date": "2020-12-02T17:40:53.232025",
                        "name": "OpenSea Collection",
                        "nft_version": null,
                        "opensea_version": "2.0.0",
                        "owner": 102384,
                        "schema_name": "ERC1155",
                        "symbol": "OPENSTORE",
                        "total_supply": null,
                        "description": null,
                        "external_link": null,
                        "image_url": null,
                        "default_to_fiat": false,
                        "dev_buyer_fee_basis_points": 0,
                        "dev_seller_fee_basis_points": 0,
                        "only_proxied_transfers": false,
                        "opensea_buyer_fee_basis_points": 0,
                        "opensea_seller_fee_basis_points": 250,
                        "buyer_fee_basis_points": 0,
                        "seller_fee_basis_points": 250,
                        "payout_address": null
                    },
                    "owner": {
                        "user": {
                            "username": "NullAddress"
                        },
                        "profile_img_url": "https://storage.googleapis.com/opensea-static/opensea-profile/1.png",
                        "address": "0x0000000000000000000000000000000000000000",
                        "config": "",
                        "discord_id": ""
                    },
                    "permalink": "https://opensea.io/assets/0x495f947276749ce646f68ac8c248420045cb7b5e/70479185245472823933799012500856922265354379340922944019462782635607064576001",
                    "collection": {
                        "banner_image_url": "https://lh3.googleusercontent.com/i1dLTD9hXZSzeMGz02l202fkMjd3QQrZ2fCQ2TZt-ajo3L931rN_TRGeqU9IvTfm166GIvs5DWaWCKbnuxKq5JmMHLOXioRyCuMxNQ=s2500",
                        "chat_url": null,
                        "created_date": "2021-03-24T00:31:54.219565",
                        "default_to_fiat": false,
                        "description": "",
                        "dev_buyer_fee_basis_points": "0",
                        "dev_seller_fee_basis_points": "0",
                        "discord_url": null,
                        "display_data": {
                            "card_display_style": "contain",
                            "images": []
                        },
                        "external_url": null,
                        "featured": false,
                        "featured_image_url": null,
                        "hidden": true,
                        "safelist_request_status": "not_requested",
                        "image_url": "https://lh3.googleusercontent.com/qZRiTQMHRe5EswI1syqlf0Sf3sfY8bnZjtVhjn89Kh_RxfqZ1WBWTJBnyvnB-gJWsvr6-DsACvVxrPBsj5pSlecxj63iAcVfQTkD=s120",
                        "is_subject_to_whitelist": false,
                        "large_image_url": null,
                        "medium_username": null,
                        "name": "HiDef",
                        "only_proxied_transfers": false,
                        "opensea_buyer_fee_basis_points": "0",
                        "opensea_seller_fee_basis_points": "250",
                        "payout_address": null,
                        "require_email": false,
                        "short_description": null,
                        "slug": "hidef",
                        "telegram_url": null,
                        "twitter_username": null,
                        "instagram_username": null,
                        "wiki_url": null
                    },
                    "decimals": null,
                    "token_metadata": null
                },
                {
                    "id": 20421249,
                    "token_id": "70479185245472823933799012500856922265354379340922944019462782636706576203777",
                    "num_sales": 0,
                    "background_color": null,
                    "image_url": "https://lh3.googleusercontent.com/1rpqnQD6iJ_Ukn27Ow5aWocYuyUk6GfZAkUhTZucGsnHN6KDcSTk-xXfwapdsVD4n8aSjXtzYlw3X7s9ZGaVPnjRfMfrdSHK1TvKbQ",
                    "image_preview_url": "https://lh3.googleusercontent.com/1rpqnQD6iJ_Ukn27Ow5aWocYuyUk6GfZAkUhTZucGsnHN6KDcSTk-xXfwapdsVD4n8aSjXtzYlw3X7s9ZGaVPnjRfMfrdSHK1TvKbQ=s250",
                    "image_thumbnail_url": "https://lh3.googleusercontent.com/1rpqnQD6iJ_Ukn27Ow5aWocYuyUk6GfZAkUhTZucGsnHN6KDcSTk-xXfwapdsVD4n8aSjXtzYlw3X7s9ZGaVPnjRfMfrdSHK1TvKbQ=s128",
                    "image_original_url": null,
                    "animation_url": null,
                    "animation_original_url": null,
                    "name": "Anthony Castoro",
                    "description": "Energy Amplification / Deadpan Delivery\n10 of 10",
                    "external_link": null,
                    "asset_contract": {
                        "address": "0x495f947276749ce646f68ac8c248420045cb7b5e",
                        "asset_contract_type": "semi-fungible",
                        "created_date": "2020-12-02T17:40:53.232025",
                        "name": "OpenSea Collection",
                        "nft_version": null,
                        "opensea_version": "2.0.0",
                        "owner": 102384,
                        "schema_name": "ERC1155",
                        "symbol": "OPENSTORE",
                        "total_supply": null,
                        "description": null,
                        "external_link": null,
                        "image_url": null,
                        "default_to_fiat": false,
                        "dev_buyer_fee_basis_points": 0,
                        "dev_seller_fee_basis_points": 0,
                        "only_proxied_transfers": false,
                        "opensea_buyer_fee_basis_points": 0,
                        "opensea_seller_fee_basis_points": 250,
                        "buyer_fee_basis_points": 0,
                        "seller_fee_basis_points": 250,
                        "payout_address": null
                    },
                    "owner": {
                        "user": {
                            "username": "NullAddress"
                        },
                        "profile_img_url": "https://storage.googleapis.com/opensea-static/opensea-profile/1.png",
                        "address": "0x0000000000000000000000000000000000000000",
                        "config": "",
                        "discord_id": ""
                    },
                    "permalink": "https://opensea.io/assets/0x495f947276749ce646f68ac8c248420045cb7b5e/70479185245472823933799012500856922265354379340922944019462782636706576203777",
                    "collection": {
                        "banner_image_url": "https://lh3.googleusercontent.com/i1dLTD9hXZSzeMGz02l202fkMjd3QQrZ2fCQ2TZt-ajo3L931rN_TRGeqU9IvTfm166GIvs5DWaWCKbnuxKq5JmMHLOXioRyCuMxNQ=s2500",
                        "chat_url": null,
                        "created_date": "2021-03-24T00:31:54.219565",
                        "default_to_fiat": false,
                        "description": "",
                        "dev_buyer_fee_basis_points": "0",
                        "dev_seller_fee_basis_points": "0",
                        "discord_url": null,
                        "display_data": {
                            "card_display_style": "contain",
                            "images": []
                        },
                        "external_url": null,
                        "featured": false,
                        "featured_image_url": null,
                        "hidden": true,
                        "safelist_request_status": "not_requested",
                        "image_url": "https://lh3.googleusercontent.com/qZRiTQMHRe5EswI1syqlf0Sf3sfY8bnZjtVhjn89Kh_RxfqZ1WBWTJBnyvnB-gJWsvr6-DsACvVxrPBsj5pSlecxj63iAcVfQTkD=s120",
                        "is_subject_to_whitelist": false,
                        "large_image_url": null,
                        "medium_username": null,
                        "name": "HiDef",
                        "only_proxied_transfers": false,
                        "opensea_buyer_fee_basis_points": "0",
                        "opensea_seller_fee_basis_points": "250",
                        "payout_address": null,
                        "require_email": false,
                        "short_description": null,
                        "slug": "hidef",
                        "telegram_url": null,
                        "twitter_username": null,
                        "instagram_username": null,
                        "wiki_url": null
                    },
                    "decimals": null,
                    "token_metadata": null
                },
                {
                    "id": 20424095,
                    "token_id": "70479185245472823933799012500856922265354379340922944019462782648801204109313",
                    "num_sales": 0,
                    "background_color": null,
                    "image_url": "https://lh3.googleusercontent.com/aoi4FgSswGyNO-rZxxkHZaxxN59S7NTI5TXixC7DA0LYJ3z1-8lzgCKWECb1l7J-cFNmUdZdeRuFFB8TU7ReVudYWhKuI0R-C-DmXqw",
                    "image_preview_url": "https://lh3.googleusercontent.com/aoi4FgSswGyNO-rZxxkHZaxxN59S7NTI5TXixC7DA0LYJ3z1-8lzgCKWECb1l7J-cFNmUdZdeRuFFB8TU7ReVudYWhKuI0R-C-DmXqw=s250",
                    "image_thumbnail_url": "https://lh3.googleusercontent.com/aoi4FgSswGyNO-rZxxkHZaxxN59S7NTI5TXixC7DA0LYJ3z1-8lzgCKWECb1l7J-cFNmUdZdeRuFFB8TU7ReVudYWhKuI0R-C-DmXqw=s128",
                    "image_original_url": null,
                    "animation_url": null,
                    "animation_original_url": null,
                    "name": "Jace Hall",
                    "description": "Yeet / Grind 1 of 10",
                    "external_link": null,
                    "asset_contract": {
                        "address": "0x495f947276749ce646f68ac8c248420045cb7b5e",
                        "asset_contract_type": "semi-fungible",
                        "created_date": "2020-12-02T17:40:53.232025",
                        "name": "OpenSea Collection",
                        "nft_version": null,
                        "opensea_version": "2.0.0",
                        "owner": 102384,
                        "schema_name": "ERC1155",
                        "symbol": "OPENSTORE",
                        "total_supply": null,
                        "description": null,
                        "external_link": null,
                        "image_url": null,
                        "default_to_fiat": false,
                        "dev_buyer_fee_basis_points": 0,
                        "dev_seller_fee_basis_points": 0,
                        "only_proxied_transfers": false,
                        "opensea_buyer_fee_basis_points": 0,
                        "opensea_seller_fee_basis_points": 250,
                        "buyer_fee_basis_points": 0,
                        "seller_fee_basis_points": 250,
                        "payout_address": null
                    },
                    "owner": {
                        "user": {
                            "username": "NullAddress"
                        },
                        "profile_img_url": "https://storage.googleapis.com/opensea-static/opensea-profile/1.png",
                        "address": "0x0000000000000000000000000000000000000000",
                        "config": "",
                        "discord_id": ""
                    },
                    "permalink": "https://opensea.io/assets/0x495f947276749ce646f68ac8c248420045cb7b5e/70479185245472823933799012500856922265354379340922944019462782648801204109313",
                    "collection": {
                        "banner_image_url": "https://lh3.googleusercontent.com/i1dLTD9hXZSzeMGz02l202fkMjd3QQrZ2fCQ2TZt-ajo3L931rN_TRGeqU9IvTfm166GIvs5DWaWCKbnuxKq5JmMHLOXioRyCuMxNQ=s2500",
                        "chat_url": null,
                        "created_date": "2021-03-24T00:31:54.219565",
                        "default_to_fiat": false,
                        "description": "",
                        "dev_buyer_fee_basis_points": "0",
                        "dev_seller_fee_basis_points": "0",
                        "discord_url": null,
                        "display_data": {
                            "card_display_style": "contain",
                            "images": []
                        },
                        "external_url": null,
                        "featured": false,
                        "featured_image_url": null,
                        "hidden": true,
                        "safelist_request_status": "not_requested",
                        "image_url": "https://lh3.googleusercontent.com/qZRiTQMHRe5EswI1syqlf0Sf3sfY8bnZjtVhjn89Kh_RxfqZ1WBWTJBnyvnB-gJWsvr6-DsACvVxrPBsj5pSlecxj63iAcVfQTkD=s120",
                        "is_subject_to_whitelist": false,
                        "large_image_url": null,
                        "medium_username": null,
                        "name": "HiDef",
                        "only_proxied_transfers": false,
                        "opensea_buyer_fee_basis_points": "0",
                        "opensea_seller_fee_basis_points": "250",
                        "payout_address": null,
                        "require_email": false,
                        "short_description": null,
                        "slug": "hidef",
                        "telegram_url": null,
                        "twitter_username": null,
                        "instagram_username": null,
                        "wiki_url": null
                    },
                    "decimals": null,
                    "token_metadata": null
                },
                {
                    "id": 20424124,
                    "token_id": "70479185245472823933799012500856922265354379340922944019462782649900715737089",
                    "num_sales": 0,
                    "background_color": null,
                    "image_url": "https://lh3.googleusercontent.com/aoi4FgSswGyNO-rZxxkHZaxxN59S7NTI5TXixC7DA0LYJ3z1-8lzgCKWECb1l7J-cFNmUdZdeRuFFB8TU7ReVudYWhKuI0R-C-DmXqw",
                    "image_preview_url": "https://lh3.googleusercontent.com/aoi4FgSswGyNO-rZxxkHZaxxN59S7NTI5TXixC7DA0LYJ3z1-8lzgCKWECb1l7J-cFNmUdZdeRuFFB8TU7ReVudYWhKuI0R-C-DmXqw=s250",
                    "image_thumbnail_url": "https://lh3.googleusercontent.com/aoi4FgSswGyNO-rZxxkHZaxxN59S7NTI5TXixC7DA0LYJ3z1-8lzgCKWECb1l7J-cFNmUdZdeRuFFB8TU7ReVudYWhKuI0R-C-DmXqw=s128",
                    "image_original_url": null,
                    "animation_url": null,
                    "animation_original_url": null,
                    "name": "Jace Hall",
                    "description": "Yeet / Grind 2 of 10",
                    "external_link": null,
                    "asset_contract": {
                        "address": "0x495f947276749ce646f68ac8c248420045cb7b5e",
                        "asset_contract_type": "semi-fungible",
                        "created_date": "2020-12-02T17:40:53.232025",
                        "name": "OpenSea Collection",
                        "nft_version": null,
                        "opensea_version": "2.0.0",
                        "owner": 102384,
                        "schema_name": "ERC1155",
                        "symbol": "OPENSTORE",
                        "total_supply": null,
                        "description": null,
                        "external_link": null,
                        "image_url": null,
                        "default_to_fiat": false,
                        "dev_buyer_fee_basis_points": 0,
                        "dev_seller_fee_basis_points": 0,
                        "only_proxied_transfers": false,
                        "opensea_buyer_fee_basis_points": 0,
                        "opensea_seller_fee_basis_points": 250,
                        "buyer_fee_basis_points": 0,
                        "seller_fee_basis_points": 250,
                        "payout_address": null
                    },
                    "owner": {
                        "user": {
                            "username": "NullAddress"
                        },
                        "profile_img_url": "https://storage.googleapis.com/opensea-static/opensea-profile/1.png",
                        "address": "0x0000000000000000000000000000000000000000",
                        "config": "",
                        "discord_id": ""
                    },
                    "permalink": "https://opensea.io/assets/0x495f947276749ce646f68ac8c248420045cb7b5e/70479185245472823933799012500856922265354379340922944019462782649900715737089",
                    "collection": {
                        "banner_image_url": "https://lh3.googleusercontent.com/i1dLTD9hXZSzeMGz02l202fkMjd3QQrZ2fCQ2TZt-ajo3L931rN_TRGeqU9IvTfm166GIvs5DWaWCKbnuxKq5JmMHLOXioRyCuMxNQ=s2500",
                        "chat_url": null,
                        "created_date": "2021-03-24T00:31:54.219565",
                        "default_to_fiat": false,
                        "description": "",
                        "dev_buyer_fee_basis_points": "0",
                        "dev_seller_fee_basis_points": "0",
                        "discord_url": null,
                        "display_data": {
                            "card_display_style": "contain",
                            "images": []
                        },
                        "external_url": null,
                        "featured": false,
                        "featured_image_url": null,
                        "hidden": true,
                        "safelist_request_status": "not_requested",
                        "image_url": "https://lh3.googleusercontent.com/qZRiTQMHRe5EswI1syqlf0Sf3sfY8bnZjtVhjn89Kh_RxfqZ1WBWTJBnyvnB-gJWsvr6-DsACvVxrPBsj5pSlecxj63iAcVfQTkD=s120",
                        "is_subject_to_whitelist": false,
                        "large_image_url": null,
                        "medium_username": null,
                        "name": "HiDef",
                        "only_proxied_transfers": false,
                        "opensea_buyer_fee_basis_points": "0",
                        "opensea_seller_fee_basis_points": "250",
                        "payout_address": null,
                        "require_email": false,
                        "short_description": null,
                        "slug": "hidef",
                        "telegram_url": null,
                        "twitter_username": null,
                        "instagram_username": null,
                        "wiki_url": null
                    },
                    "decimals": null,
                    "token_metadata": null
                },
                {
                    "id": 20424142,
                    "token_id": "70479185245472823933799012500856922265354379340922944019462782651000227364865",
                    "num_sales": 0,
                    "background_color": null,
                    "image_url": "https://lh3.googleusercontent.com/aoi4FgSswGyNO-rZxxkHZaxxN59S7NTI5TXixC7DA0LYJ3z1-8lzgCKWECb1l7J-cFNmUdZdeRuFFB8TU7ReVudYWhKuI0R-C-DmXqw",
                    "image_preview_url": "https://lh3.googleusercontent.com/aoi4FgSswGyNO-rZxxkHZaxxN59S7NTI5TXixC7DA0LYJ3z1-8lzgCKWECb1l7J-cFNmUdZdeRuFFB8TU7ReVudYWhKuI0R-C-DmXqw=s250",
                    "image_thumbnail_url": "https://lh3.googleusercontent.com/aoi4FgSswGyNO-rZxxkHZaxxN59S7NTI5TXixC7DA0LYJ3z1-8lzgCKWECb1l7J-cFNmUdZdeRuFFB8TU7ReVudYWhKuI0R-C-DmXqw=s128",
                    "image_original_url": null,
                    "animation_url": null,
                    "animation_original_url": null,
                    "name": "Jace Hall",
                    "description": "Yeet / Grind 3 of 10",
                    "external_link": null,
                    "asset_contract": {
                        "address": "0x495f947276749ce646f68ac8c248420045cb7b5e",
                        "asset_contract_type": "semi-fungible",
                        "created_date": "2020-12-02T17:40:53.232025",
                        "name": "OpenSea Collection",
                        "nft_version": null,
                        "opensea_version": "2.0.0",
                        "owner": 102384,
                        "schema_name": "ERC1155",
                        "symbol": "OPENSTORE",
                        "total_supply": null,
                        "description": null,
                        "external_link": null,
                        "image_url": null,
                        "default_to_fiat": false,
                        "dev_buyer_fee_basis_points": 0,
                        "dev_seller_fee_basis_points": 0,
                        "only_proxied_transfers": false,
                        "opensea_buyer_fee_basis_points": 0,
                        "opensea_seller_fee_basis_points": 250,
                        "buyer_fee_basis_points": 0,
                        "seller_fee_basis_points": 250,
                        "payout_address": null
                    },
                    "owner": {
                        "user": {
                            "username": "NullAddress"
                        },
                        "profile_img_url": "https://storage.googleapis.com/opensea-static/opensea-profile/1.png",
                        "address": "0x0000000000000000000000000000000000000000",
                        "config": "",
                        "discord_id": ""
                    },
                    "permalink": "https://opensea.io/assets/0x495f947276749ce646f68ac8c248420045cb7b5e/70479185245472823933799012500856922265354379340922944019462782651000227364865",
                    "collection": {
                        "banner_image_url": "https://lh3.googleusercontent.com/i1dLTD9hXZSzeMGz02l202fkMjd3QQrZ2fCQ2TZt-ajo3L931rN_TRGeqU9IvTfm166GIvs5DWaWCKbnuxKq5JmMHLOXioRyCuMxNQ=s2500",
                        "chat_url": null,
                        "created_date": "2021-03-24T00:31:54.219565",
                        "default_to_fiat": false,
                        "description": "",
                        "dev_buyer_fee_basis_points": "0",
                        "dev_seller_fee_basis_points": "0",
                        "discord_url": null,
                        "display_data": {
                            "card_display_style": "contain",
                            "images": []
                        },
                        "external_url": null,
                        "featured": false,
                        "featured_image_url": null,
                        "hidden": true,
                        "safelist_request_status": "not_requested",
                        "image_url": "https://lh3.googleusercontent.com/qZRiTQMHRe5EswI1syqlf0Sf3sfY8bnZjtVhjn89Kh_RxfqZ1WBWTJBnyvnB-gJWsvr6-DsACvVxrPBsj5pSlecxj63iAcVfQTkD=s120",
                        "is_subject_to_whitelist": false,
                        "large_image_url": null,
                        "medium_username": null,
                        "name": "HiDef",
                        "only_proxied_transfers": false,
                        "opensea_buyer_fee_basis_points": "0",
                        "opensea_seller_fee_basis_points": "250",
                        "payout_address": null,
                        "require_email": false,
                        "short_description": null,
                        "slug": "hidef",
                        "telegram_url": null,
                        "twitter_username": null,
                        "instagram_username": null,
                        "wiki_url": null
                    },
                    "decimals": null,
                    "token_metadata": null
                },
                {
                    "id": 20424161,
                    "token_id": "70479185245472823933799012500856922265354379340922944019462782652099738992641",
                    "num_sales": 0,
                    "background_color": null,
                    "image_url": "https://lh3.googleusercontent.com/aoi4FgSswGyNO-rZxxkHZaxxN59S7NTI5TXixC7DA0LYJ3z1-8lzgCKWECb1l7J-cFNmUdZdeRuFFB8TU7ReVudYWhKuI0R-C-DmXqw",
                    "image_preview_url": "https://lh3.googleusercontent.com/aoi4FgSswGyNO-rZxxkHZaxxN59S7NTI5TXixC7DA0LYJ3z1-8lzgCKWECb1l7J-cFNmUdZdeRuFFB8TU7ReVudYWhKuI0R-C-DmXqw=s250",
                    "image_thumbnail_url": "https://lh3.googleusercontent.com/aoi4FgSswGyNO-rZxxkHZaxxN59S7NTI5TXixC7DA0LYJ3z1-8lzgCKWECb1l7J-cFNmUdZdeRuFFB8TU7ReVudYWhKuI0R-C-DmXqw=s128",
                    "image_original_url": null,
                    "animation_url": null,
                    "animation_original_url": null,
                    "name": "Jace Hall",
                    "description": "Yeet / Grind 4 of 10",
                    "external_link": null,
                    "asset_contract": {
                        "address": "0x495f947276749ce646f68ac8c248420045cb7b5e",
                        "asset_contract_type": "semi-fungible",
                        "created_date": "2020-12-02T17:40:53.232025",
                        "name": "OpenSea Collection",
                        "nft_version": null,
                        "opensea_version": "2.0.0",
                        "owner": 102384,
                        "schema_name": "ERC1155",
                        "symbol": "OPENSTORE",
                        "total_supply": null,
                        "description": null,
                        "external_link": null,
                        "image_url": null,
                        "default_to_fiat": false,
                        "dev_buyer_fee_basis_points": 0,
                        "dev_seller_fee_basis_points": 0,
                        "only_proxied_transfers": false,
                        "opensea_buyer_fee_basis_points": 0,
                        "opensea_seller_fee_basis_points": 250,
                        "buyer_fee_basis_points": 0,
                        "seller_fee_basis_points": 250,
                        "payout_address": null
                    },
                    "owner": {
                        "user": {
                            "username": "NullAddress"
                        },
                        "profile_img_url": "https://storage.googleapis.com/opensea-static/opensea-profile/1.png",
                        "address": "0x0000000000000000000000000000000000000000",
                        "config": "",
                        "discord_id": ""
                    },
                    "permalink": "https://opensea.io/assets/0x495f947276749ce646f68ac8c248420045cb7b5e/70479185245472823933799012500856922265354379340922944019462782652099738992641",
                    "collection": {
                        "banner_image_url": "https://lh3.googleusercontent.com/i1dLTD9hXZSzeMGz02l202fkMjd3QQrZ2fCQ2TZt-ajo3L931rN_TRGeqU9IvTfm166GIvs5DWaWCKbnuxKq5JmMHLOXioRyCuMxNQ=s2500",
                        "chat_url": null,
                        "created_date": "2021-03-24T00:31:54.219565",
                        "default_to_fiat": false,
                        "description": "",
                        "dev_buyer_fee_basis_points": "0",
                        "dev_seller_fee_basis_points": "0",
                        "discord_url": null,
                        "display_data": {
                            "card_display_style": "contain",
                            "images": []
                        },
                        "external_url": null,
                        "featured": false,
                        "featured_image_url": null,
                        "hidden": true,
                        "safelist_request_status": "not_requested",
                        "image_url": "https://lh3.googleusercontent.com/qZRiTQMHRe5EswI1syqlf0Sf3sfY8bnZjtVhjn89Kh_RxfqZ1WBWTJBnyvnB-gJWsvr6-DsACvVxrPBsj5pSlecxj63iAcVfQTkD=s120",
                        "is_subject_to_whitelist": false,
                        "large_image_url": null,
                        "medium_username": null,
                        "name": "HiDef",
                        "only_proxied_transfers": false,
                        "opensea_buyer_fee_basis_points": "0",
                        "opensea_seller_fee_basis_points": "250",
                        "payout_address": null,
                        "require_email": false,
                        "short_description": null,
                        "slug": "hidef",
                        "telegram_url": null,
                        "twitter_username": null,
                        "instagram_username": null,
                        "wiki_url": null
                    },
                    "decimals": null,
                    "token_metadata": null
                },
                {
                    "id": 20424179,
                    "token_id": "70479185245472823933799012500856922265354379340922944019462782653199250620417",
                    "num_sales": 0,
                    "background_color": null,
                    "image_url": "https://lh3.googleusercontent.com/aoi4FgSswGyNO-rZxxkHZaxxN59S7NTI5TXixC7DA0LYJ3z1-8lzgCKWECb1l7J-cFNmUdZdeRuFFB8TU7ReVudYWhKuI0R-C-DmXqw",
                    "image_preview_url": "https://lh3.googleusercontent.com/aoi4FgSswGyNO-rZxxkHZaxxN59S7NTI5TXixC7DA0LYJ3z1-8lzgCKWECb1l7J-cFNmUdZdeRuFFB8TU7ReVudYWhKuI0R-C-DmXqw=s250",
                    "image_thumbnail_url": "https://lh3.googleusercontent.com/aoi4FgSswGyNO-rZxxkHZaxxN59S7NTI5TXixC7DA0LYJ3z1-8lzgCKWECb1l7J-cFNmUdZdeRuFFB8TU7ReVudYWhKuI0R-C-DmXqw=s128",
                    "image_original_url": null,
                    "animation_url": null,
                    "animation_original_url": null,
                    "name": "Jace Hall",
                    "description": "Yeet / Grind 5 of 10",
                    "external_link": null,
                    "asset_contract": {
                        "address": "0x495f947276749ce646f68ac8c248420045cb7b5e",
                        "asset_contract_type": "semi-fungible",
                        "created_date": "2020-12-02T17:40:53.232025",
                        "name": "OpenSea Collection",
                        "nft_version": null,
                        "opensea_version": "2.0.0",
                        "owner": 102384,
                        "schema_name": "ERC1155",
                        "symbol": "OPENSTORE",
                        "total_supply": null,
                        "description": null,
                        "external_link": null,
                        "image_url": null,
                        "default_to_fiat": false,
                        "dev_buyer_fee_basis_points": 0,
                        "dev_seller_fee_basis_points": 0,
                        "only_proxied_transfers": false,
                        "opensea_buyer_fee_basis_points": 0,
                        "opensea_seller_fee_basis_points": 250,
                        "buyer_fee_basis_points": 0,
                        "seller_fee_basis_points": 250,
                        "payout_address": null
                    },
                    "owner": {
                        "user": {
                            "username": "NullAddress"
                        },
                        "profile_img_url": "https://storage.googleapis.com/opensea-static/opensea-profile/1.png",
                        "address": "0x0000000000000000000000000000000000000000",
                        "config": "",
                        "discord_id": ""
                    },
                    "permalink": "https://opensea.io/assets/0x495f947276749ce646f68ac8c248420045cb7b5e/70479185245472823933799012500856922265354379340922944019462782653199250620417",
                    "collection": {
                        "banner_image_url": "https://lh3.googleusercontent.com/i1dLTD9hXZSzeMGz02l202fkMjd3QQrZ2fCQ2TZt-ajo3L931rN_TRGeqU9IvTfm166GIvs5DWaWCKbnuxKq5JmMHLOXioRyCuMxNQ=s2500",
                        "chat_url": null,
                        "created_date": "2021-03-24T00:31:54.219565",
                        "default_to_fiat": false,
                        "description": "",
                        "dev_buyer_fee_basis_points": "0",
                        "dev_seller_fee_basis_points": "0",
                        "discord_url": null,
                        "display_data": {
                            "card_display_style": "contain",
                            "images": []
                        },
                        "external_url": null,
                        "featured": false,
                        "featured_image_url": null,
                        "hidden": true,
                        "safelist_request_status": "not_requested",
                        "image_url": "https://lh3.googleusercontent.com/qZRiTQMHRe5EswI1syqlf0Sf3sfY8bnZjtVhjn89Kh_RxfqZ1WBWTJBnyvnB-gJWsvr6-DsACvVxrPBsj5pSlecxj63iAcVfQTkD=s120",
                        "is_subject_to_whitelist": false,
                        "large_image_url": null,
                        "medium_username": null,
                        "name": "HiDef",
                        "only_proxied_transfers": false,
                        "opensea_buyer_fee_basis_points": "0",
                        "opensea_seller_fee_basis_points": "250",
                        "payout_address": null,
                        "require_email": false,
                        "short_description": null,
                        "slug": "hidef",
                        "telegram_url": null,
                        "twitter_username": null,
                        "instagram_username": null,
                        "wiki_url": null
                    },
                    "decimals": null,
                    "token_metadata": null
                },
                {
                    "id": 20424193,
                    "token_id": "70479185245472823933799012500856922265354379340922944019462782654298762248193",
                    "num_sales": 0,
                    "background_color": null,
                    "image_url": "https://lh3.googleusercontent.com/aoi4FgSswGyNO-rZxxkHZaxxN59S7NTI5TXixC7DA0LYJ3z1-8lzgCKWECb1l7J-cFNmUdZdeRuFFB8TU7ReVudYWhKuI0R-C-DmXqw",
                    "image_preview_url": "https://lh3.googleusercontent.com/aoi4FgSswGyNO-rZxxkHZaxxN59S7NTI5TXixC7DA0LYJ3z1-8lzgCKWECb1l7J-cFNmUdZdeRuFFB8TU7ReVudYWhKuI0R-C-DmXqw=s250",
                    "image_thumbnail_url": "https://lh3.googleusercontent.com/aoi4FgSswGyNO-rZxxkHZaxxN59S7NTI5TXixC7DA0LYJ3z1-8lzgCKWECb1l7J-cFNmUdZdeRuFFB8TU7ReVudYWhKuI0R-C-DmXqw=s128",
                    "image_original_url": null,
                    "animation_url": null,
                    "animation_original_url": null,
                    "name": "Jace Hall",
                    "description": "Yeet / Grind 6 of 10",
                    "external_link": null,
                    "asset_contract": {
                        "address": "0x495f947276749ce646f68ac8c248420045cb7b5e",
                        "asset_contract_type": "semi-fungible",
                        "created_date": "2020-12-02T17:40:53.232025",
                        "name": "OpenSea Collection",
                        "nft_version": null,
                        "opensea_version": "2.0.0",
                        "owner": 102384,
                        "schema_name": "ERC1155",
                        "symbol": "OPENSTORE",
                        "total_supply": null,
                        "description": null,
                        "external_link": null,
                        "image_url": null,
                        "default_to_fiat": false,
                        "dev_buyer_fee_basis_points": 0,
                        "dev_seller_fee_basis_points": 0,
                        "only_proxied_transfers": false,
                        "opensea_buyer_fee_basis_points": 0,
                        "opensea_seller_fee_basis_points": 250,
                        "buyer_fee_basis_points": 0,
                        "seller_fee_basis_points": 250,
                        "payout_address": null
                    },
                    "owner": {
                        "user": {
                            "username": "NullAddress"
                        },
                        "profile_img_url": "https://storage.googleapis.com/opensea-static/opensea-profile/1.png",
                        "address": "0x0000000000000000000000000000000000000000",
                        "config": "",
                        "discord_id": ""
                    },
                    "permalink": "https://opensea.io/assets/0x495f947276749ce646f68ac8c248420045cb7b5e/70479185245472823933799012500856922265354379340922944019462782654298762248193",
                    "collection": {
                        "banner_image_url": "https://lh3.googleusercontent.com/i1dLTD9hXZSzeMGz02l202fkMjd3QQrZ2fCQ2TZt-ajo3L931rN_TRGeqU9IvTfm166GIvs5DWaWCKbnuxKq5JmMHLOXioRyCuMxNQ=s2500",
                        "chat_url": null,
                        "created_date": "2021-03-24T00:31:54.219565",
                        "default_to_fiat": false,
                        "description": "",
                        "dev_buyer_fee_basis_points": "0",
                        "dev_seller_fee_basis_points": "0",
                        "discord_url": null,
                        "display_data": {
                            "card_display_style": "contain",
                            "images": []
                        },
                        "external_url": null,
                        "featured": false,
                        "featured_image_url": null,
                        "hidden": true,
                        "safelist_request_status": "not_requested",
                        "image_url": "https://lh3.googleusercontent.com/qZRiTQMHRe5EswI1syqlf0Sf3sfY8bnZjtVhjn89Kh_RxfqZ1WBWTJBnyvnB-gJWsvr6-DsACvVxrPBsj5pSlecxj63iAcVfQTkD=s120",
                        "is_subject_to_whitelist": false,
                        "large_image_url": null,
                        "medium_username": null,
                        "name": "HiDef",
                        "only_proxied_transfers": false,
                        "opensea_buyer_fee_basis_points": "0",
                        "opensea_seller_fee_basis_points": "250",
                        "payout_address": null,
                        "require_email": false,
                        "short_description": null,
                        "slug": "hidef",
                        "telegram_url": null,
                        "twitter_username": null,
                        "instagram_username": null,
                        "wiki_url": null
                    },
                    "decimals": null,
                    "token_metadata": null
                },
                {
                    "id": 20424208,
                    "token_id": "70479185245472823933799012500856922265354379340922944019462782655398273875969",
                    "num_sales": 0,
                    "background_color": null,
                    "image_url": "https://lh3.googleusercontent.com/aoi4FgSswGyNO-rZxxkHZaxxN59S7NTI5TXixC7DA0LYJ3z1-8lzgCKWECb1l7J-cFNmUdZdeRuFFB8TU7ReVudYWhKuI0R-C-DmXqw",
                    "image_preview_url": "https://lh3.googleusercontent.com/aoi4FgSswGyNO-rZxxkHZaxxN59S7NTI5TXixC7DA0LYJ3z1-8lzgCKWECb1l7J-cFNmUdZdeRuFFB8TU7ReVudYWhKuI0R-C-DmXqw=s250",
                    "image_thumbnail_url": "https://lh3.googleusercontent.com/aoi4FgSswGyNO-rZxxkHZaxxN59S7NTI5TXixC7DA0LYJ3z1-8lzgCKWECb1l7J-cFNmUdZdeRuFFB8TU7ReVudYWhKuI0R-C-DmXqw=s128",
                    "image_original_url": null,
                    "animation_url": null,
                    "animation_original_url": null,
                    "name": "Jace Hall",
                    "description": "Yeet / Grind 7 of 10",
                    "external_link": null,
                    "asset_contract": {
                        "address": "0x495f947276749ce646f68ac8c248420045cb7b5e",
                        "asset_contract_type": "semi-fungible",
                        "created_date": "2020-12-02T17:40:53.232025",
                        "name": "OpenSea Collection",
                        "nft_version": null,
                        "opensea_version": "2.0.0",
                        "owner": 102384,
                        "schema_name": "ERC1155",
                        "symbol": "OPENSTORE",
                        "total_supply": null,
                        "description": null,
                        "external_link": null,
                        "image_url": null,
                        "default_to_fiat": false,
                        "dev_buyer_fee_basis_points": 0,
                        "dev_seller_fee_basis_points": 0,
                        "only_proxied_transfers": false,
                        "opensea_buyer_fee_basis_points": 0,
                        "opensea_seller_fee_basis_points": 250,
                        "buyer_fee_basis_points": 0,
                        "seller_fee_basis_points": 250,
                        "payout_address": null
                    },
                    "owner": {
                        "user": {
                            "username": "NullAddress"
                        },
                        "profile_img_url": "https://storage.googleapis.com/opensea-static/opensea-profile/1.png",
                        "address": "0x0000000000000000000000000000000000000000",
                        "config": "",
                        "discord_id": ""
                    },
                    "permalink": "https://opensea.io/assets/0x495f947276749ce646f68ac8c248420045cb7b5e/70479185245472823933799012500856922265354379340922944019462782655398273875969",
                    "collection": {
                        "banner_image_url": "https://lh3.googleusercontent.com/i1dLTD9hXZSzeMGz02l202fkMjd3QQrZ2fCQ2TZt-ajo3L931rN_TRGeqU9IvTfm166GIvs5DWaWCKbnuxKq5JmMHLOXioRyCuMxNQ=s2500",
                        "chat_url": null,
                        "created_date": "2021-03-24T00:31:54.219565",
                        "default_to_fiat": false,
                        "description": "",
                        "dev_buyer_fee_basis_points": "0",
                        "dev_seller_fee_basis_points": "0",
                        "discord_url": null,
                        "display_data": {
                            "card_display_style": "contain",
                            "images": []
                        },
                        "external_url": null,
                        "featured": false,
                        "featured_image_url": null,
                        "hidden": true,
                        "safelist_request_status": "not_requested",
                        "image_url": "https://lh3.googleusercontent.com/qZRiTQMHRe5EswI1syqlf0Sf3sfY8bnZjtVhjn89Kh_RxfqZ1WBWTJBnyvnB-gJWsvr6-DsACvVxrPBsj5pSlecxj63iAcVfQTkD=s120",
                        "is_subject_to_whitelist": false,
                        "large_image_url": null,
                        "medium_username": null,
                        "name": "HiDef",
                        "only_proxied_transfers": false,
                        "opensea_buyer_fee_basis_points": "0",
                        "opensea_seller_fee_basis_points": "250",
                        "payout_address": null,
                        "require_email": false,
                        "short_description": null,
                        "slug": "hidef",
                        "telegram_url": null,
                        "twitter_username": null,
                        "instagram_username": null,
                        "wiki_url": null
                    },
                    "decimals": null,
                    "token_metadata": null
                },
                {
                    "id": 20424229,
                    "token_id": "70479185245472823933799012500856922265354379340922944019462782656497785503745",
                    "num_sales": 0,
                    "background_color": null,
                    "image_url": "https://lh3.googleusercontent.com/aoi4FgSswGyNO-rZxxkHZaxxN59S7NTI5TXixC7DA0LYJ3z1-8lzgCKWECb1l7J-cFNmUdZdeRuFFB8TU7ReVudYWhKuI0R-C-DmXqw",
                    "image_preview_url": "https://lh3.googleusercontent.com/aoi4FgSswGyNO-rZxxkHZaxxN59S7NTI5TXixC7DA0LYJ3z1-8lzgCKWECb1l7J-cFNmUdZdeRuFFB8TU7ReVudYWhKuI0R-C-DmXqw=s250",
                    "image_thumbnail_url": "https://lh3.googleusercontent.com/aoi4FgSswGyNO-rZxxkHZaxxN59S7NTI5TXixC7DA0LYJ3z1-8lzgCKWECb1l7J-cFNmUdZdeRuFFB8TU7ReVudYWhKuI0R-C-DmXqw=s128",
                    "image_original_url": null,
                    "animation_url": null,
                    "animation_original_url": null,
                    "name": "Jace Hall",
                    "description": "Yeet / Grind 8 of 10",
                    "external_link": null,
                    "asset_contract": {
                        "address": "0x495f947276749ce646f68ac8c248420045cb7b5e",
                        "asset_contract_type": "semi-fungible",
                        "created_date": "2020-12-02T17:40:53.232025",
                        "name": "OpenSea Collection",
                        "nft_version": null,
                        "opensea_version": "2.0.0",
                        "owner": 102384,
                        "schema_name": "ERC1155",
                        "symbol": "OPENSTORE",
                        "total_supply": null,
                        "description": null,
                        "external_link": null,
                        "image_url": null,
                        "default_to_fiat": false,
                        "dev_buyer_fee_basis_points": 0,
                        "dev_seller_fee_basis_points": 0,
                        "only_proxied_transfers": false,
                        "opensea_buyer_fee_basis_points": 0,
                        "opensea_seller_fee_basis_points": 250,
                        "buyer_fee_basis_points": 0,
                        "seller_fee_basis_points": 250,
                        "payout_address": null
                    },
                    "owner": {
                        "user": {
                            "username": "NullAddress"
                        },
                        "profile_img_url": "https://storage.googleapis.com/opensea-static/opensea-profile/1.png",
                        "address": "0x0000000000000000000000000000000000000000",
                        "config": "",
                        "discord_id": ""
                    },
                    "permalink": "https://opensea.io/assets/0x495f947276749ce646f68ac8c248420045cb7b5e/70479185245472823933799012500856922265354379340922944019462782656497785503745",
                    "collection": {
                        "banner_image_url": "https://lh3.googleusercontent.com/i1dLTD9hXZSzeMGz02l202fkMjd3QQrZ2fCQ2TZt-ajo3L931rN_TRGeqU9IvTfm166GIvs5DWaWCKbnuxKq5JmMHLOXioRyCuMxNQ=s2500",
                        "chat_url": null,
                        "created_date": "2021-03-24T00:31:54.219565",
                        "default_to_fiat": false,
                        "description": "",
                        "dev_buyer_fee_basis_points": "0",
                        "dev_seller_fee_basis_points": "0",
                        "discord_url": null,
                        "display_data": {
                            "card_display_style": "contain",
                            "images": []
                        },
                        "external_url": null,
                        "featured": false,
                        "featured_image_url": null,
                        "hidden": true,
                        "safelist_request_status": "not_requested",
                        "image_url": "https://lh3.googleusercontent.com/qZRiTQMHRe5EswI1syqlf0Sf3sfY8bnZjtVhjn89Kh_RxfqZ1WBWTJBnyvnB-gJWsvr6-DsACvVxrPBsj5pSlecxj63iAcVfQTkD=s120",
                        "is_subject_to_whitelist": false,
                        "large_image_url": null,
                        "medium_username": null,
                        "name": "HiDef",
                        "only_proxied_transfers": false,
                        "opensea_buyer_fee_basis_points": "0",
                        "opensea_seller_fee_basis_points": "250",
                        "payout_address": null,
                        "require_email": false,
                        "short_description": null,
                        "slug": "hidef",
                        "telegram_url": null,
                        "twitter_username": null,
                        "instagram_username": null,
                        "wiki_url": null
                    },
                    "decimals": null,
                    "token_metadata": null
                },
                {
                    "id": 20424243,
                    "token_id": "70479185245472823933799012500856922265354379340922944019462782657597297131521",
                    "num_sales": 0,
                    "background_color": null,
                    "image_url": "https://lh3.googleusercontent.com/aoi4FgSswGyNO-rZxxkHZaxxN59S7NTI5TXixC7DA0LYJ3z1-8lzgCKWECb1l7J-cFNmUdZdeRuFFB8TU7ReVudYWhKuI0R-C-DmXqw",
                    "image_preview_url": "https://lh3.googleusercontent.com/aoi4FgSswGyNO-rZxxkHZaxxN59S7NTI5TXixC7DA0LYJ3z1-8lzgCKWECb1l7J-cFNmUdZdeRuFFB8TU7ReVudYWhKuI0R-C-DmXqw=s250",
                    "image_thumbnail_url": "https://lh3.googleusercontent.com/aoi4FgSswGyNO-rZxxkHZaxxN59S7NTI5TXixC7DA0LYJ3z1-8lzgCKWECb1l7J-cFNmUdZdeRuFFB8TU7ReVudYWhKuI0R-C-DmXqw=s128",
                    "image_original_url": null,
                    "animation_url": null,
                    "animation_original_url": null,
                    "name": "Jace Hall",
                    "description": "Yeet / Grind 9 of 10",
                    "external_link": null,
                    "asset_contract": {
                        "address": "0x495f947276749ce646f68ac8c248420045cb7b5e",
                        "asset_contract_type": "semi-fungible",
                        "created_date": "2020-12-02T17:40:53.232025",
                        "name": "OpenSea Collection",
                        "nft_version": null,
                        "opensea_version": "2.0.0",
                        "owner": 102384,
                        "schema_name": "ERC1155",
                        "symbol": "OPENSTORE",
                        "total_supply": null,
                        "description": null,
                        "external_link": null,
                        "image_url": null,
                        "default_to_fiat": false,
                        "dev_buyer_fee_basis_points": 0,
                        "dev_seller_fee_basis_points": 0,
                        "only_proxied_transfers": false,
                        "opensea_buyer_fee_basis_points": 0,
                        "opensea_seller_fee_basis_points": 250,
                        "buyer_fee_basis_points": 0,
                        "seller_fee_basis_points": 250,
                        "payout_address": null
                    },
                    "owner": {
                        "user": {
                            "username": "NullAddress"
                        },
                        "profile_img_url": "https://storage.googleapis.com/opensea-static/opensea-profile/1.png",
                        "address": "0x0000000000000000000000000000000000000000",
                        "config": "",
                        "discord_id": ""
                    },
                    "permalink": "https://opensea.io/assets/0x495f947276749ce646f68ac8c248420045cb7b5e/70479185245472823933799012500856922265354379340922944019462782657597297131521",
                    "collection": {
                        "banner_image_url": "https://lh3.googleusercontent.com/i1dLTD9hXZSzeMGz02l202fkMjd3QQrZ2fCQ2TZt-ajo3L931rN_TRGeqU9IvTfm166GIvs5DWaWCKbnuxKq5JmMHLOXioRyCuMxNQ=s2500",
                        "chat_url": null,
                        "created_date": "2021-03-24T00:31:54.219565",
                        "default_to_fiat": false,
                        "description": "",
                        "dev_buyer_fee_basis_points": "0",
                        "dev_seller_fee_basis_points": "0",
                        "discord_url": null,
                        "display_data": {
                            "card_display_style": "contain",
                            "images": []
                        },
                        "external_url": null,
                        "featured": false,
                        "featured_image_url": null,
                        "hidden": true,
                        "safelist_request_status": "not_requested",
                        "image_url": "https://lh3.googleusercontent.com/qZRiTQMHRe5EswI1syqlf0Sf3sfY8bnZjtVhjn89Kh_RxfqZ1WBWTJBnyvnB-gJWsvr6-DsACvVxrPBsj5pSlecxj63iAcVfQTkD=s120",
                        "is_subject_to_whitelist": false,
                        "large_image_url": null,
                        "medium_username": null,
                        "name": "HiDef",
                        "only_proxied_transfers": false,
                        "opensea_buyer_fee_basis_points": "0",
                        "opensea_seller_fee_basis_points": "250",
                        "payout_address": null,
                        "require_email": false,
                        "short_description": null,
                        "slug": "hidef",
                        "telegram_url": null,
                        "twitter_username": null,
                        "instagram_username": null,
                        "wiki_url": null
                    },
                    "decimals": null,
                    "token_metadata": null
                },
                {
                    "id": 20424262,
                    "token_id": "70479185245472823933799012500856922265354379340922944019462782658696808759297",
                    "num_sales": 0,
                    "background_color": null,
                    "image_url": "https://lh3.googleusercontent.com/aoi4FgSswGyNO-rZxxkHZaxxN59S7NTI5TXixC7DA0LYJ3z1-8lzgCKWECb1l7J-cFNmUdZdeRuFFB8TU7ReVudYWhKuI0R-C-DmXqw",
                    "image_preview_url": "https://lh3.googleusercontent.com/aoi4FgSswGyNO-rZxxkHZaxxN59S7NTI5TXixC7DA0LYJ3z1-8lzgCKWECb1l7J-cFNmUdZdeRuFFB8TU7ReVudYWhKuI0R-C-DmXqw=s250",
                    "image_thumbnail_url": "https://lh3.googleusercontent.com/aoi4FgSswGyNO-rZxxkHZaxxN59S7NTI5TXixC7DA0LYJ3z1-8lzgCKWECb1l7J-cFNmUdZdeRuFFB8TU7ReVudYWhKuI0R-C-DmXqw=s128",
                    "image_original_url": null,
                    "animation_url": null,
                    "animation_original_url": null,
                    "name": "Jace Hall",
                    "description": "Yeet / Grind 10 of 10",
                    "external_link": null,
                    "asset_contract": {
                        "address": "0x495f947276749ce646f68ac8c248420045cb7b5e",
                        "asset_contract_type": "semi-fungible",
                        "created_date": "2020-12-02T17:40:53.232025",
                        "name": "OpenSea Collection",
                        "nft_version": null,
                        "opensea_version": "2.0.0",
                        "owner": 102384,
                        "schema_name": "ERC1155",
                        "symbol": "OPENSTORE",
                        "total_supply": null,
                        "description": null,
                        "external_link": null,
                        "image_url": null,
                        "default_to_fiat": false,
                        "dev_buyer_fee_basis_points": 0,
                        "dev_seller_fee_basis_points": 0,
                        "only_proxied_transfers": false,
                        "opensea_buyer_fee_basis_points": 0,
                        "opensea_seller_fee_basis_points": 250,
                        "buyer_fee_basis_points": 0,
                        "seller_fee_basis_points": 250,
                        "payout_address": null
                    },
                    "owner": {
                        "user": {
                            "username": "NullAddress"
                        },
                        "profile_img_url": "https://storage.googleapis.com/opensea-static/opensea-profile/1.png",
                        "address": "0x0000000000000000000000000000000000000000",
                        "config": "",
                        "discord_id": ""
                    },
                    "permalink": "https://opensea.io/assets/0x495f947276749ce646f68ac8c248420045cb7b5e/70479185245472823933799012500856922265354379340922944019462782658696808759297",
                    "collection": {
                        "banner_image_url": "https://lh3.googleusercontent.com/i1dLTD9hXZSzeMGz02l202fkMjd3QQrZ2fCQ2TZt-ajo3L931rN_TRGeqU9IvTfm166GIvs5DWaWCKbnuxKq5JmMHLOXioRyCuMxNQ=s2500",
                        "chat_url": null,
                        "created_date": "2021-03-24T00:31:54.219565",
                        "default_to_fiat": false,
                        "description": "",
                        "dev_buyer_fee_basis_points": "0",
                        "dev_seller_fee_basis_points": "0",
                        "discord_url": null,
                        "display_data": {
                            "card_display_style": "contain",
                            "images": []
                        },
                        "external_url": null,
                        "featured": false,
                        "featured_image_url": null,
                        "hidden": true,
                        "safelist_request_status": "not_requested",
                        "image_url": "https://lh3.googleusercontent.com/qZRiTQMHRe5EswI1syqlf0Sf3sfY8bnZjtVhjn89Kh_RxfqZ1WBWTJBnyvnB-gJWsvr6-DsACvVxrPBsj5pSlecxj63iAcVfQTkD=s120",
                        "is_subject_to_whitelist": false,
                        "large_image_url": null,
                        "medium_username": null,
                        "name": "HiDef",
                        "only_proxied_transfers": false,
                        "opensea_buyer_fee_basis_points": "0",
                        "opensea_seller_fee_basis_points": "250",
                        "payout_address": null,
                        "require_email": false,
                        "short_description": null,
                        "slug": "hidef",
                        "telegram_url": null,
                        "twitter_username": null,
                        "instagram_username": null,
                        "wiki_url": null
                    },
                    "decimals": null,
                    "token_metadata": null
                }
            ],
            "name": "Anthony Castoro & Jace Hall",
            "description": "",
            "external_link": "",
            "asset_contract": {
                "collection": {
                    "banner_image_url": null,
                    "chat_url": null,
                    "created_date": "2020-12-02T17:40:53.507540",
                    "default_to_fiat": false,
                    "description": null,
                    "dev_buyer_fee_basis_points": "0",
                    "dev_seller_fee_basis_points": "0",
                    "discord_url": null,
                    "display_data": {
                        "card_display_style": "contain",
                        "images": []
                    },
                    "external_url": null,
                    "featured": false,
                    "featured_image_url": null,
                    "hidden": true,
                    "safelist_request_status": "not_requested",
                    "image_url": null,
                    "is_subject_to_whitelist": false,
                    "large_image_url": null,
                    "medium_username": null,
                    "name": "OpenSea Shared Storefront V2",
                    "only_proxied_transfers": false,
                    "opensea_buyer_fee_basis_points": "0",
                    "opensea_seller_fee_basis_points": "250",
                    "payout_address": null,
                    "require_email": false,
                    "short_description": null,
                    "slug": "opensea-shared-storefront-v2",
                    "telegram_url": null,
                    "twitter_username": null,
                    "instagram_username": null,
                    "wiki_url": null
                },
                "address": "0x495f947276749ce646f68ac8c248420045cb7b5e",
                "asset_contract_type": "semi-fungible",
                "created_date": "2020-12-02T17:40:53.232025",
                "name": "OpenSea Collection",
                "nft_version": null,
                "opensea_version": "2.0.0",
                "owner": 102384,
                "schema_name": "ERC1155",
                "symbol": "OPENSTORE",
                "total_supply": null,
                "description": null,
                "external_link": null,
                "image_url": null,
                "default_to_fiat": false,
                "dev_buyer_fee_basis_points": 0,
                "dev_seller_fee_basis_points": 0,
                "only_proxied_transfers": false,
                "opensea_buyer_fee_basis_points": 0,
                "opensea_seller_fee_basis_points": 250,
                "buyer_fee_basis_points": 0,
                "seller_fee_basis_points": 250,
                "payout_address": null
            },
            "permalink": "https://opensea.io/bundles/anthony-castoro-jace-hall-RTS",
            "sell_orders": []
        },
        {
            "maker": {
                "user": {
                    "username": "REVOLT"
                },
                "profile_img_url": "https://storage.googleapis.com/opensea-static/opensea-profile/25.png",
                "address": "0xb6d820e80a2a7c49f94c9d6c8ea08dccedc9ce4c",
                "config": "",
                "discord_id": ""
            },
            "slug": "small-estate-9-lands-E3u",
            "assets": [
                {
                    "id": 15815915,
                    "token_id": "16164",
                    "num_sales": 0,
                    "background_color": null,
                    "image_url": "https://lh3.googleusercontent.com/17vU_UNWeMOVi4XOAwo4nvAXpeg1dnKPBk8VnAhJcFHOFZ9UBBvSL5Spj0ytvyfII3rdp4gHMY0mMvbnSzjdOZ0",
                    "image_preview_url": "https://lh3.googleusercontent.com/17vU_UNWeMOVi4XOAwo4nvAXpeg1dnKPBk8VnAhJcFHOFZ9UBBvSL5Spj0ytvyfII3rdp4gHMY0mMvbnSzjdOZ0=s250",
                    "image_thumbnail_url": "https://lh3.googleusercontent.com/17vU_UNWeMOVi4XOAwo4nvAXpeg1dnKPBk8VnAhJcFHOFZ9UBBvSL5Spj0ytvyfII3rdp4gHMY0mMvbnSzjdOZ0=s128",
                    "image_original_url": "https://storage.googleapis.com/opensea-static/custom-fetcher-images/sandbox/land/sandbox-land.png",
                    "animation_url": null,
                    "animation_original_url": null,
                    "name": "LAND (48, -165)",
                    "description": "A LAND is a digital piece of real estate in The Sandbox metaverse that players can buy to build experiences on top of. Once you own a LAND, you will be able to populate it with Games and Assets. Each LAND is a unique (non-fungible) token lying on the public Ethereum blockchain (ERC-721).",
                    "external_link": "https://www.sandbox.game/en/map/?x=48&y=-165",
                    "asset_contract": {
                        "address": "0x50f5474724e0ee42d9a4e711ccfb275809fd6d4a",
                        "asset_contract_type": "non-fungible",
                        "created_date": "2019-12-04T10:58:28.892990",
                        "name": "Sandbox's LANDs",
                        "nft_version": "3.0",
                        "opensea_version": null,
                        "owner": null,
                        "schema_name": "ERC721",
                        "symbol": "",
                        "total_supply": null,
                        "description": "The Sandbox is a community-driven platform where creators can monetize voxel assets and gaming experiences on the blockchain. The Sandbox metaverse comprises a map made up of 166,464 LANDS.  LAND owners can host contests and events, stake SAND to earn and customize assets, monetize assets and experiences, vote in the metaverse governance, play games that you or others create, and more! Trade the collection and keep your eyes peeled for future drops.",
                        "external_link": "https://www.sandbox.game/",
                        "image_url": "https://lh3.googleusercontent.com/SXH8tW1siikB80rwCRnjm1a5xM_MwTg9Xl9Db6mioIk9HIlDM09pVoSR7GKJgS6ulSUpgW9BDtMk_ePX_NKgO9A=s60",
                        "default_to_fiat": false,
                        "dev_buyer_fee_basis_points": 0,
                        "dev_seller_fee_basis_points": 500,
                        "only_proxied_transfers": false,
                        "opensea_buyer_fee_basis_points": 0,
                        "opensea_seller_fee_basis_points": 250,
                        "buyer_fee_basis_points": 0,
                        "seller_fee_basis_points": 750,
                        "payout_address": "0x7a9fe22691c811ea339d9b73150e6911a5343dca"
                    },
                    "owner": {
                        "user": {
                            "username": "REVOLT"
                        },
                        "profile_img_url": "https://storage.googleapis.com/opensea-static/opensea-profile/25.png",
                        "address": "0xb6d820e80a2a7c49f94c9d6c8ea08dccedc9ce4c",
                        "config": "",
                        "discord_id": ""
                    },
                    "permalink": "https://opensea.io/assets/0x50f5474724e0ee42d9a4e711ccfb275809fd6d4a/16164",
                    "collection": {
                        "banner_image_url": "https://lh3.googleusercontent.com/4NQIRoGmzXeXQN4mjuhWuuDZSNW7_BqRXux5upd4Nn_A-bfsGxCnPF8qn98Y6MyHRDPGXIlgfZADcSOe6M2DyrDKXdbdaTgkZN5l=s2500",
                        "chat_url": null,
                        "created_date": "2019-12-04T10:58:29.069907",
                        "default_to_fiat": false,
                        "description": "The Sandbox is a community-driven platform where creators can monetize voxel assets and gaming experiences on the blockchain. The Sandbox metaverse comprises a map made up of 166,464 LANDS.  LAND owners can host contests and events, stake SAND to earn and customize assets, monetize assets and experiences, vote in the metaverse governance, play games that you or others create, and more! Trade the collection and keep your eyes peeled for future drops.",
                        "dev_buyer_fee_basis_points": "0",
                        "dev_seller_fee_basis_points": "500",
                        "discord_url": "https://discord.gg/vAe4zvY",
                        "display_data": {
                            "card_display_style": "contain"
                        },
                        "external_url": "https://www.sandbox.game/",
                        "featured": false,
                        "featured_image_url": "https://storage.googleapis.com/opensea-static/featured-images/sandbox-featured.png",
                        "hidden": false,
                        "safelist_request_status": "verified",
                        "image_url": "https://lh3.googleusercontent.com/SXH8tW1siikB80rwCRnjm1a5xM_MwTg9Xl9Db6mioIk9HIlDM09pVoSR7GKJgS6ulSUpgW9BDtMk_ePX_NKgO9A=s60",
                        "is_subject_to_whitelist": false,
                        "large_image_url": "https://lh3.googleusercontent.com/SXH8tW1siikB80rwCRnjm1a5xM_MwTg9Xl9Db6mioIk9HIlDM09pVoSR7GKJgS6ulSUpgW9BDtMk_ePX_NKgO9A",
                        "medium_username": "sandbox-game",
                        "name": "The Sandbox",
                        "only_proxied_transfers": false,
                        "opensea_buyer_fee_basis_points": "0",
                        "opensea_seller_fee_basis_points": "250",
                        "payout_address": "0x7a9fe22691c811ea339d9b73150e6911a5343dca",
                        "require_email": false,
                        "short_description": null,
                        "slug": "sandbox",
                        "telegram_url": "https://t.me/sandboxgame",
                        "twitter_username": "thesandboxgame",
                        "instagram_username": null,
                        "wiki_url": null
                    },
                    "decimals": null,
                    "token_metadata": null
                },
                {
                    "id": 15815951,
                    "token_id": "16165",
                    "num_sales": 0,
                    "background_color": null,
                    "image_url": "https://storage.opensea.io/files/3faa959fa75531ac7913a9c9f8361b58.png",
                    "image_preview_url": "https://lh3.googleusercontent.com/17vU_UNWeMOVi4XOAwo4nvAXpeg1dnKPBk8VnAhJcFHOFZ9UBBvSL5Spj0ytvyfII3rdp4gHMY0mMvbnSzjdOZ0=s250",
                    "image_thumbnail_url": "https://lh3.googleusercontent.com/17vU_UNWeMOVi4XOAwo4nvAXpeg1dnKPBk8VnAhJcFHOFZ9UBBvSL5Spj0ytvyfII3rdp4gHMY0mMvbnSzjdOZ0=s128",
                    "image_original_url": "https://storage.googleapis.com/opensea-static/custom-fetcher-images/sandbox/land/sandbox-land.png",
                    "animation_url": null,
                    "animation_original_url": null,
                    "name": "LAND (49, -165)",
                    "description": "A LAND is a digital piece of real estate in The Sandbox metaverse that players can buy to build experiences on top of. Once you own a LAND, you will be able to populate it with Games and Assets. Each LAND is a unique (non-fungible) token lying on the public Ethereum blockchain (ERC-721).",
                    "external_link": "https://www.sandbox.game/en/map/?x=49&y=-165",
                    "asset_contract": {
                        "address": "0x50f5474724e0ee42d9a4e711ccfb275809fd6d4a",
                        "asset_contract_type": "non-fungible",
                        "created_date": "2019-12-04T10:58:28.892990",
                        "name": "Sandbox's LANDs",
                        "nft_version": "3.0",
                        "opensea_version": null,
                        "owner": null,
                        "schema_name": "ERC721",
                        "symbol": "",
                        "total_supply": null,
                        "description": "The Sandbox is a community-driven platform where creators can monetize voxel assets and gaming experiences on the blockchain. The Sandbox metaverse comprises a map made up of 166,464 LANDS.  LAND owners can host contests and events, stake SAND to earn and customize assets, monetize assets and experiences, vote in the metaverse governance, play games that you or others create, and more! Trade the collection and keep your eyes peeled for future drops.",
                        "external_link": "https://www.sandbox.game/",
                        "image_url": "https://lh3.googleusercontent.com/SXH8tW1siikB80rwCRnjm1a5xM_MwTg9Xl9Db6mioIk9HIlDM09pVoSR7GKJgS6ulSUpgW9BDtMk_ePX_NKgO9A=s60",
                        "default_to_fiat": false,
                        "dev_buyer_fee_basis_points": 0,
                        "dev_seller_fee_basis_points": 500,
                        "only_proxied_transfers": false,
                        "opensea_buyer_fee_basis_points": 0,
                        "opensea_seller_fee_basis_points": 250,
                        "buyer_fee_basis_points": 0,
                        "seller_fee_basis_points": 750,
                        "payout_address": "0x7a9fe22691c811ea339d9b73150e6911a5343dca"
                    },
                    "owner": {
                        "user": {
                            "username": "REVOLT"
                        },
                        "profile_img_url": "https://storage.googleapis.com/opensea-static/opensea-profile/25.png",
                        "address": "0xb6d820e80a2a7c49f94c9d6c8ea08dccedc9ce4c",
                        "config": "",
                        "discord_id": ""
                    },
                    "permalink": "https://opensea.io/assets/0x50f5474724e0ee42d9a4e711ccfb275809fd6d4a/16165",
                    "collection": {
                        "banner_image_url": "https://lh3.googleusercontent.com/4NQIRoGmzXeXQN4mjuhWuuDZSNW7_BqRXux5upd4Nn_A-bfsGxCnPF8qn98Y6MyHRDPGXIlgfZADcSOe6M2DyrDKXdbdaTgkZN5l=s2500",
                        "chat_url": null,
                        "created_date": "2019-12-04T10:58:29.069907",
                        "default_to_fiat": false,
                        "description": "The Sandbox is a community-driven platform where creators can monetize voxel assets and gaming experiences on the blockchain. The Sandbox metaverse comprises a map made up of 166,464 LANDS.  LAND owners can host contests and events, stake SAND to earn and customize assets, monetize assets and experiences, vote in the metaverse governance, play games that you or others create, and more! Trade the collection and keep your eyes peeled for future drops.",
                        "dev_buyer_fee_basis_points": "0",
                        "dev_seller_fee_basis_points": "500",
                        "discord_url": "https://discord.gg/vAe4zvY",
                        "display_data": {
                            "card_display_style": "contain"
                        },
                        "external_url": "https://www.sandbox.game/",
                        "featured": false,
                        "featured_image_url": "https://storage.googleapis.com/opensea-static/featured-images/sandbox-featured.png",
                        "hidden": false,
                        "safelist_request_status": "verified",
                        "image_url": "https://lh3.googleusercontent.com/SXH8tW1siikB80rwCRnjm1a5xM_MwTg9Xl9Db6mioIk9HIlDM09pVoSR7GKJgS6ulSUpgW9BDtMk_ePX_NKgO9A=s60",
                        "is_subject_to_whitelist": false,
                        "large_image_url": "https://lh3.googleusercontent.com/SXH8tW1siikB80rwCRnjm1a5xM_MwTg9Xl9Db6mioIk9HIlDM09pVoSR7GKJgS6ulSUpgW9BDtMk_ePX_NKgO9A",
                        "medium_username": "sandbox-game",
                        "name": "The Sandbox",
                        "only_proxied_transfers": false,
                        "opensea_buyer_fee_basis_points": "0",
                        "opensea_seller_fee_basis_points": "250",
                        "payout_address": "0x7a9fe22691c811ea339d9b73150e6911a5343dca",
                        "require_email": false,
                        "short_description": null,
                        "slug": "sandbox",
                        "telegram_url": "https://t.me/sandboxgame",
                        "twitter_username": "thesandboxgame",
                        "instagram_username": null,
                        "wiki_url": null
                    },
                    "decimals": null,
                    "token_metadata": null
                },
                {
                    "id": 15815978,
                    "token_id": "16166",
                    "num_sales": 0,
                    "background_color": null,
                    "image_url": "https://storage.opensea.io/files/3faa959fa75531ac7913a9c9f8361b58.png",
                    "image_preview_url": "https://lh3.googleusercontent.com/17vU_UNWeMOVi4XOAwo4nvAXpeg1dnKPBk8VnAhJcFHOFZ9UBBvSL5Spj0ytvyfII3rdp4gHMY0mMvbnSzjdOZ0=s250",
                    "image_thumbnail_url": "https://lh3.googleusercontent.com/17vU_UNWeMOVi4XOAwo4nvAXpeg1dnKPBk8VnAhJcFHOFZ9UBBvSL5Spj0ytvyfII3rdp4gHMY0mMvbnSzjdOZ0=s128",
                    "image_original_url": "https://storage.googleapis.com/opensea-static/custom-fetcher-images/sandbox/land/sandbox-land.png",
                    "animation_url": null,
                    "animation_original_url": null,
                    "name": "LAND (50, -165)",
                    "description": "A LAND is a digital piece of real estate in The Sandbox metaverse that players can buy to build experiences on top of. Once you own a LAND, you will be able to populate it with Games and Assets. Each LAND is a unique (non-fungible) token lying on the public Ethereum blockchain (ERC-721).",
                    "external_link": "https://www.sandbox.game/en/map/?x=50&y=-165",
                    "asset_contract": {
                        "address": "0x50f5474724e0ee42d9a4e711ccfb275809fd6d4a",
                        "asset_contract_type": "non-fungible",
                        "created_date": "2019-12-04T10:58:28.892990",
                        "name": "Sandbox's LANDs",
                        "nft_version": "3.0",
                        "opensea_version": null,
                        "owner": null,
                        "schema_name": "ERC721",
                        "symbol": "",
                        "total_supply": null,
                        "description": "The Sandbox is a community-driven platform where creators can monetize voxel assets and gaming experiences on the blockchain. The Sandbox metaverse comprises a map made up of 166,464 LANDS.  LAND owners can host contests and events, stake SAND to earn and customize assets, monetize assets and experiences, vote in the metaverse governance, play games that you or others create, and more! Trade the collection and keep your eyes peeled for future drops.",
                        "external_link": "https://www.sandbox.game/",
                        "image_url": "https://lh3.googleusercontent.com/SXH8tW1siikB80rwCRnjm1a5xM_MwTg9Xl9Db6mioIk9HIlDM09pVoSR7GKJgS6ulSUpgW9BDtMk_ePX_NKgO9A=s60",
                        "default_to_fiat": false,
                        "dev_buyer_fee_basis_points": 0,
                        "dev_seller_fee_basis_points": 500,
                        "only_proxied_transfers": false,
                        "opensea_buyer_fee_basis_points": 0,
                        "opensea_seller_fee_basis_points": 250,
                        "buyer_fee_basis_points": 0,
                        "seller_fee_basis_points": 750,
                        "payout_address": "0x7a9fe22691c811ea339d9b73150e6911a5343dca"
                    },
                    "owner": {
                        "user": {
                            "username": "REVOLT"
                        },
                        "profile_img_url": "https://storage.googleapis.com/opensea-static/opensea-profile/25.png",
                        "address": "0xb6d820e80a2a7c49f94c9d6c8ea08dccedc9ce4c",
                        "config": "",
                        "discord_id": ""
                    },
                    "permalink": "https://opensea.io/assets/0x50f5474724e0ee42d9a4e711ccfb275809fd6d4a/16166",
                    "collection": {
                        "banner_image_url": "https://lh3.googleusercontent.com/4NQIRoGmzXeXQN4mjuhWuuDZSNW7_BqRXux5upd4Nn_A-bfsGxCnPF8qn98Y6MyHRDPGXIlgfZADcSOe6M2DyrDKXdbdaTgkZN5l=s2500",
                        "chat_url": null,
                        "created_date": "2019-12-04T10:58:29.069907",
                        "default_to_fiat": false,
                        "description": "The Sandbox is a community-driven platform where creators can monetize voxel assets and gaming experiences on the blockchain. The Sandbox metaverse comprises a map made up of 166,464 LANDS.  LAND owners can host contests and events, stake SAND to earn and customize assets, monetize assets and experiences, vote in the metaverse governance, play games that you or others create, and more! Trade the collection and keep your eyes peeled for future drops.",
                        "dev_buyer_fee_basis_points": "0",
                        "dev_seller_fee_basis_points": "500",
                        "discord_url": "https://discord.gg/vAe4zvY",
                        "display_data": {
                            "card_display_style": "contain"
                        },
                        "external_url": "https://www.sandbox.game/",
                        "featured": false,
                        "featured_image_url": "https://storage.googleapis.com/opensea-static/featured-images/sandbox-featured.png",
                        "hidden": false,
                        "safelist_request_status": "verified",
                        "image_url": "https://lh3.googleusercontent.com/SXH8tW1siikB80rwCRnjm1a5xM_MwTg9Xl9Db6mioIk9HIlDM09pVoSR7GKJgS6ulSUpgW9BDtMk_ePX_NKgO9A=s60",
                        "is_subject_to_whitelist": false,
                        "large_image_url": "https://lh3.googleusercontent.com/SXH8tW1siikB80rwCRnjm1a5xM_MwTg9Xl9Db6mioIk9HIlDM09pVoSR7GKJgS6ulSUpgW9BDtMk_ePX_NKgO9A",
                        "medium_username": "sandbox-game",
                        "name": "The Sandbox",
                        "only_proxied_transfers": false,
                        "opensea_buyer_fee_basis_points": "0",
                        "opensea_seller_fee_basis_points": "250",
                        "payout_address": "0x7a9fe22691c811ea339d9b73150e6911a5343dca",
                        "require_email": false,
                        "short_description": null,
                        "slug": "sandbox",
                        "telegram_url": "https://t.me/sandboxgame",
                        "twitter_username": "thesandboxgame",
                        "instagram_username": null,
                        "wiki_url": null
                    },
                    "decimals": null,
                    "token_metadata": null
                },
                {
                    "id": 15816005,
                    "token_id": "16574",
                    "num_sales": 0,
                    "background_color": null,
                    "image_url": "https://storage.opensea.io/files/3faa959fa75531ac7913a9c9f8361b58.png",
                    "image_preview_url": "https://lh3.googleusercontent.com/17vU_UNWeMOVi4XOAwo4nvAXpeg1dnKPBk8VnAhJcFHOFZ9UBBvSL5Spj0ytvyfII3rdp4gHMY0mMvbnSzjdOZ0=s250",
                    "image_thumbnail_url": "https://lh3.googleusercontent.com/17vU_UNWeMOVi4XOAwo4nvAXpeg1dnKPBk8VnAhJcFHOFZ9UBBvSL5Spj0ytvyfII3rdp4gHMY0mMvbnSzjdOZ0=s128",
                    "image_original_url": "https://storage.googleapis.com/opensea-static/custom-fetcher-images/sandbox/land/sandbox-land.png",
                    "animation_url": null,
                    "animation_original_url": null,
                    "name": "LAND (50, -164)",
                    "description": "A LAND is a digital piece of real estate in The Sandbox metaverse that players can buy to build experiences on top of. Once you own a LAND, you will be able to populate it with Games and Assets. Each LAND is a unique (non-fungible) token lying on the public Ethereum blockchain (ERC-721).",
                    "external_link": "https://www.sandbox.game/en/map/?x=50&y=-164",
                    "asset_contract": {
                        "address": "0x50f5474724e0ee42d9a4e711ccfb275809fd6d4a",
                        "asset_contract_type": "non-fungible",
                        "created_date": "2019-12-04T10:58:28.892990",
                        "name": "Sandbox's LANDs",
                        "nft_version": "3.0",
                        "opensea_version": null,
                        "owner": null,
                        "schema_name": "ERC721",
                        "symbol": "",
                        "total_supply": null,
                        "description": "The Sandbox is a community-driven platform where creators can monetize voxel assets and gaming experiences on the blockchain. The Sandbox metaverse comprises a map made up of 166,464 LANDS.  LAND owners can host contests and events, stake SAND to earn and customize assets, monetize assets and experiences, vote in the metaverse governance, play games that you or others create, and more! Trade the collection and keep your eyes peeled for future drops.",
                        "external_link": "https://www.sandbox.game/",
                        "image_url": "https://lh3.googleusercontent.com/SXH8tW1siikB80rwCRnjm1a5xM_MwTg9Xl9Db6mioIk9HIlDM09pVoSR7GKJgS6ulSUpgW9BDtMk_ePX_NKgO9A=s60",
                        "default_to_fiat": false,
                        "dev_buyer_fee_basis_points": 0,
                        "dev_seller_fee_basis_points": 500,
                        "only_proxied_transfers": false,
                        "opensea_buyer_fee_basis_points": 0,
                        "opensea_seller_fee_basis_points": 250,
                        "buyer_fee_basis_points": 0,
                        "seller_fee_basis_points": 750,
                        "payout_address": "0x7a9fe22691c811ea339d9b73150e6911a5343dca"
                    },
                    "owner": {
                        "user": {
                            "username": "REVOLT"
                        },
                        "profile_img_url": "https://storage.googleapis.com/opensea-static/opensea-profile/25.png",
                        "address": "0xb6d820e80a2a7c49f94c9d6c8ea08dccedc9ce4c",
                        "config": "",
                        "discord_id": ""
                    },
                    "permalink": "https://opensea.io/assets/0x50f5474724e0ee42d9a4e711ccfb275809fd6d4a/16574",
                    "collection": {
                        "banner_image_url": "https://lh3.googleusercontent.com/4NQIRoGmzXeXQN4mjuhWuuDZSNW7_BqRXux5upd4Nn_A-bfsGxCnPF8qn98Y6MyHRDPGXIlgfZADcSOe6M2DyrDKXdbdaTgkZN5l=s2500",
                        "chat_url": null,
                        "created_date": "2019-12-04T10:58:29.069907",
                        "default_to_fiat": false,
                        "description": "The Sandbox is a community-driven platform where creators can monetize voxel assets and gaming experiences on the blockchain. The Sandbox metaverse comprises a map made up of 166,464 LANDS.  LAND owners can host contests and events, stake SAND to earn and customize assets, monetize assets and experiences, vote in the metaverse governance, play games that you or others create, and more! Trade the collection and keep your eyes peeled for future drops.",
                        "dev_buyer_fee_basis_points": "0",
                        "dev_seller_fee_basis_points": "500",
                        "discord_url": "https://discord.gg/vAe4zvY",
                        "display_data": {
                            "card_display_style": "contain"
                        },
                        "external_url": "https://www.sandbox.game/",
                        "featured": false,
                        "featured_image_url": "https://storage.googleapis.com/opensea-static/featured-images/sandbox-featured.png",
                        "hidden": false,
                        "safelist_request_status": "verified",
                        "image_url": "https://lh3.googleusercontent.com/SXH8tW1siikB80rwCRnjm1a5xM_MwTg9Xl9Db6mioIk9HIlDM09pVoSR7GKJgS6ulSUpgW9BDtMk_ePX_NKgO9A=s60",
                        "is_subject_to_whitelist": false,
                        "large_image_url": "https://lh3.googleusercontent.com/SXH8tW1siikB80rwCRnjm1a5xM_MwTg9Xl9Db6mioIk9HIlDM09pVoSR7GKJgS6ulSUpgW9BDtMk_ePX_NKgO9A",
                        "medium_username": "sandbox-game",
                        "name": "The Sandbox",
                        "only_proxied_transfers": false,
                        "opensea_buyer_fee_basis_points": "0",
                        "opensea_seller_fee_basis_points": "250",
                        "payout_address": "0x7a9fe22691c811ea339d9b73150e6911a5343dca",
                        "require_email": false,
                        "short_description": null,
                        "slug": "sandbox",
                        "telegram_url": "https://t.me/sandboxgame",
                        "twitter_username": "thesandboxgame",
                        "instagram_username": null,
                        "wiki_url": null
                    },
                    "decimals": null,
                    "token_metadata": null
                },
                {
                    "id": 15816034,
                    "token_id": "16573",
                    "num_sales": 0,
                    "background_color": null,
                    "image_url": "https://storage.opensea.io/files/3faa959fa75531ac7913a9c9f8361b58.png",
                    "image_preview_url": "https://lh3.googleusercontent.com/17vU_UNWeMOVi4XOAwo4nvAXpeg1dnKPBk8VnAhJcFHOFZ9UBBvSL5Spj0ytvyfII3rdp4gHMY0mMvbnSzjdOZ0=s250",
                    "image_thumbnail_url": "https://lh3.googleusercontent.com/17vU_UNWeMOVi4XOAwo4nvAXpeg1dnKPBk8VnAhJcFHOFZ9UBBvSL5Spj0ytvyfII3rdp4gHMY0mMvbnSzjdOZ0=s128",
                    "image_original_url": "https://storage.googleapis.com/opensea-static/custom-fetcher-images/sandbox/land/sandbox-land.png",
                    "animation_url": null,
                    "animation_original_url": null,
                    "name": "LAND (49, -164)",
                    "description": "A LAND is a digital piece of real estate in The Sandbox metaverse that players can buy to build experiences on top of. Once you own a LAND, you will be able to populate it with Games and Assets. Each LAND is a unique (non-fungible) token lying on the public Ethereum blockchain (ERC-721).",
                    "external_link": "https://www.sandbox.game/en/map/?x=49&y=-164",
                    "asset_contract": {
                        "address": "0x50f5474724e0ee42d9a4e711ccfb275809fd6d4a",
                        "asset_contract_type": "non-fungible",
                        "created_date": "2019-12-04T10:58:28.892990",
                        "name": "Sandbox's LANDs",
                        "nft_version": "3.0",
                        "opensea_version": null,
                        "owner": null,
                        "schema_name": "ERC721",
                        "symbol": "",
                        "total_supply": null,
                        "description": "The Sandbox is a community-driven platform where creators can monetize voxel assets and gaming experiences on the blockchain. The Sandbox metaverse comprises a map made up of 166,464 LANDS.  LAND owners can host contests and events, stake SAND to earn and customize assets, monetize assets and experiences, vote in the metaverse governance, play games that you or others create, and more! Trade the collection and keep your eyes peeled for future drops.",
                        "external_link": "https://www.sandbox.game/",
                        "image_url": "https://lh3.googleusercontent.com/SXH8tW1siikB80rwCRnjm1a5xM_MwTg9Xl9Db6mioIk9HIlDM09pVoSR7GKJgS6ulSUpgW9BDtMk_ePX_NKgO9A=s60",
                        "default_to_fiat": false,
                        "dev_buyer_fee_basis_points": 0,
                        "dev_seller_fee_basis_points": 500,
                        "only_proxied_transfers": false,
                        "opensea_buyer_fee_basis_points": 0,
                        "opensea_seller_fee_basis_points": 250,
                        "buyer_fee_basis_points": 0,
                        "seller_fee_basis_points": 750,
                        "payout_address": "0x7a9fe22691c811ea339d9b73150e6911a5343dca"
                    },
                    "owner": {
                        "user": {
                            "username": "REVOLT"
                        },
                        "profile_img_url": "https://storage.googleapis.com/opensea-static/opensea-profile/25.png",
                        "address": "0xb6d820e80a2a7c49f94c9d6c8ea08dccedc9ce4c",
                        "config": "",
                        "discord_id": ""
                    },
                    "permalink": "https://opensea.io/assets/0x50f5474724e0ee42d9a4e711ccfb275809fd6d4a/16573",
                    "collection": {
                        "banner_image_url": "https://lh3.googleusercontent.com/4NQIRoGmzXeXQN4mjuhWuuDZSNW7_BqRXux5upd4Nn_A-bfsGxCnPF8qn98Y6MyHRDPGXIlgfZADcSOe6M2DyrDKXdbdaTgkZN5l=s2500",
                        "chat_url": null,
                        "created_date": "2019-12-04T10:58:29.069907",
                        "default_to_fiat": false,
                        "description": "The Sandbox is a community-driven platform where creators can monetize voxel assets and gaming experiences on the blockchain. The Sandbox metaverse comprises a map made up of 166,464 LANDS.  LAND owners can host contests and events, stake SAND to earn and customize assets, monetize assets and experiences, vote in the metaverse governance, play games that you or others create, and more! Trade the collection and keep your eyes peeled for future drops.",
                        "dev_buyer_fee_basis_points": "0",
                        "dev_seller_fee_basis_points": "500",
                        "discord_url": "https://discord.gg/vAe4zvY",
                        "display_data": {
                            "card_display_style": "contain"
                        },
                        "external_url": "https://www.sandbox.game/",
                        "featured": false,
                        "featured_image_url": "https://storage.googleapis.com/opensea-static/featured-images/sandbox-featured.png",
                        "hidden": false,
                        "safelist_request_status": "verified",
                        "image_url": "https://lh3.googleusercontent.com/SXH8tW1siikB80rwCRnjm1a5xM_MwTg9Xl9Db6mioIk9HIlDM09pVoSR7GKJgS6ulSUpgW9BDtMk_ePX_NKgO9A=s60",
                        "is_subject_to_whitelist": false,
                        "large_image_url": "https://lh3.googleusercontent.com/SXH8tW1siikB80rwCRnjm1a5xM_MwTg9Xl9Db6mioIk9HIlDM09pVoSR7GKJgS6ulSUpgW9BDtMk_ePX_NKgO9A",
                        "medium_username": "sandbox-game",
                        "name": "The Sandbox",
                        "only_proxied_transfers": false,
                        "opensea_buyer_fee_basis_points": "0",
                        "opensea_seller_fee_basis_points": "250",
                        "payout_address": "0x7a9fe22691c811ea339d9b73150e6911a5343dca",
                        "require_email": false,
                        "short_description": null,
                        "slug": "sandbox",
                        "telegram_url": "https://t.me/sandboxgame",
                        "twitter_username": "thesandboxgame",
                        "instagram_username": null,
                        "wiki_url": null
                    },
                    "decimals": null,
                    "token_metadata": null
                },
                {
                    "id": 15816059,
                    "token_id": "16572",
                    "num_sales": 0,
                    "background_color": null,
                    "image_url": "https://storage.opensea.io/files/3faa959fa75531ac7913a9c9f8361b58.png",
                    "image_preview_url": "https://lh3.googleusercontent.com/17vU_UNWeMOVi4XOAwo4nvAXpeg1dnKPBk8VnAhJcFHOFZ9UBBvSL5Spj0ytvyfII3rdp4gHMY0mMvbnSzjdOZ0=s250",
                    "image_thumbnail_url": "https://lh3.googleusercontent.com/17vU_UNWeMOVi4XOAwo4nvAXpeg1dnKPBk8VnAhJcFHOFZ9UBBvSL5Spj0ytvyfII3rdp4gHMY0mMvbnSzjdOZ0=s128",
                    "image_original_url": "https://storage.googleapis.com/opensea-static/custom-fetcher-images/sandbox/land/sandbox-land.png",
                    "animation_url": null,
                    "animation_original_url": null,
                    "name": "LAND (48, -164)",
                    "description": "A LAND is a digital piece of real estate in The Sandbox metaverse that players can buy to build experiences on top of. Once you own a LAND, you will be able to populate it with Games and Assets. Each LAND is a unique (non-fungible) token lying on the public Ethereum blockchain (ERC-721).",
                    "external_link": "https://www.sandbox.game/en/map/?x=48&y=-164",
                    "asset_contract": {
                        "address": "0x50f5474724e0ee42d9a4e711ccfb275809fd6d4a",
                        "asset_contract_type": "non-fungible",
                        "created_date": "2019-12-04T10:58:28.892990",
                        "name": "Sandbox's LANDs",
                        "nft_version": "3.0",
                        "opensea_version": null,
                        "owner": null,
                        "schema_name": "ERC721",
                        "symbol": "",
                        "total_supply": null,
                        "description": "The Sandbox is a community-driven platform where creators can monetize voxel assets and gaming experiences on the blockchain. The Sandbox metaverse comprises a map made up of 166,464 LANDS.  LAND owners can host contests and events, stake SAND to earn and customize assets, monetize assets and experiences, vote in the metaverse governance, play games that you or others create, and more! Trade the collection and keep your eyes peeled for future drops.",
                        "external_link": "https://www.sandbox.game/",
                        "image_url": "https://lh3.googleusercontent.com/SXH8tW1siikB80rwCRnjm1a5xM_MwTg9Xl9Db6mioIk9HIlDM09pVoSR7GKJgS6ulSUpgW9BDtMk_ePX_NKgO9A=s60",
                        "default_to_fiat": false,
                        "dev_buyer_fee_basis_points": 0,
                        "dev_seller_fee_basis_points": 500,
                        "only_proxied_transfers": false,
                        "opensea_buyer_fee_basis_points": 0,
                        "opensea_seller_fee_basis_points": 250,
                        "buyer_fee_basis_points": 0,
                        "seller_fee_basis_points": 750,
                        "payout_address": "0x7a9fe22691c811ea339d9b73150e6911a5343dca"
                    },
                    "owner": {
                        "user": {
                            "username": "REVOLT"
                        },
                        "profile_img_url": "https://storage.googleapis.com/opensea-static/opensea-profile/25.png",
                        "address": "0xb6d820e80a2a7c49f94c9d6c8ea08dccedc9ce4c",
                        "config": "",
                        "discord_id": ""
                    },
                    "permalink": "https://opensea.io/assets/0x50f5474724e0ee42d9a4e711ccfb275809fd6d4a/16572",
                    "collection": {
                        "banner_image_url": "https://lh3.googleusercontent.com/4NQIRoGmzXeXQN4mjuhWuuDZSNW7_BqRXux5upd4Nn_A-bfsGxCnPF8qn98Y6MyHRDPGXIlgfZADcSOe6M2DyrDKXdbdaTgkZN5l=s2500",
                        "chat_url": null,
                        "created_date": "2019-12-04T10:58:29.069907",
                        "default_to_fiat": false,
                        "description": "The Sandbox is a community-driven platform where creators can monetize voxel assets and gaming experiences on the blockchain. The Sandbox metaverse comprises a map made up of 166,464 LANDS.  LAND owners can host contests and events, stake SAND to earn and customize assets, monetize assets and experiences, vote in the metaverse governance, play games that you or others create, and more! Trade the collection and keep your eyes peeled for future drops.",
                        "dev_buyer_fee_basis_points": "0",
                        "dev_seller_fee_basis_points": "500",
                        "discord_url": "https://discord.gg/vAe4zvY",
                        "display_data": {
                            "card_display_style": "contain"
                        },
                        "external_url": "https://www.sandbox.game/",
                        "featured": false,
                        "featured_image_url": "https://storage.googleapis.com/opensea-static/featured-images/sandbox-featured.png",
                        "hidden": false,
                        "safelist_request_status": "verified",
                        "image_url": "https://lh3.googleusercontent.com/SXH8tW1siikB80rwCRnjm1a5xM_MwTg9Xl9Db6mioIk9HIlDM09pVoSR7GKJgS6ulSUpgW9BDtMk_ePX_NKgO9A=s60",
                        "is_subject_to_whitelist": false,
                        "large_image_url": "https://lh3.googleusercontent.com/SXH8tW1siikB80rwCRnjm1a5xM_MwTg9Xl9Db6mioIk9HIlDM09pVoSR7GKJgS6ulSUpgW9BDtMk_ePX_NKgO9A",
                        "medium_username": "sandbox-game",
                        "name": "The Sandbox",
                        "only_proxied_transfers": false,
                        "opensea_buyer_fee_basis_points": "0",
                        "opensea_seller_fee_basis_points": "250",
                        "payout_address": "0x7a9fe22691c811ea339d9b73150e6911a5343dca",
                        "require_email": false,
                        "short_description": null,
                        "slug": "sandbox",
                        "telegram_url": "https://t.me/sandboxgame",
                        "twitter_username": "thesandboxgame",
                        "instagram_username": null,
                        "wiki_url": null
                    },
                    "decimals": null,
                    "token_metadata": null
                },
                {
                    "id": 15816083,
                    "token_id": "16980",
                    "num_sales": 0,
                    "background_color": null,
                    "image_url": "https://storage.opensea.io/files/3faa959fa75531ac7913a9c9f8361b58.png",
                    "image_preview_url": "https://lh3.googleusercontent.com/17vU_UNWeMOVi4XOAwo4nvAXpeg1dnKPBk8VnAhJcFHOFZ9UBBvSL5Spj0ytvyfII3rdp4gHMY0mMvbnSzjdOZ0=s250",
                    "image_thumbnail_url": "https://lh3.googleusercontent.com/17vU_UNWeMOVi4XOAwo4nvAXpeg1dnKPBk8VnAhJcFHOFZ9UBBvSL5Spj0ytvyfII3rdp4gHMY0mMvbnSzjdOZ0=s128",
                    "image_original_url": "https://storage.googleapis.com/opensea-static/custom-fetcher-images/sandbox/land/sandbox-land.png",
                    "animation_url": null,
                    "animation_original_url": null,
                    "name": "LAND (48, -163)",
                    "description": "A LAND is a digital piece of real estate in The Sandbox metaverse that players can buy to build experiences on top of. Once you own a LAND, you will be able to populate it with Games and Assets. Each LAND is a unique (non-fungible) token lying on the public Ethereum blockchain (ERC-721).",
                    "external_link": "https://www.sandbox.game/en/map/?x=48&y=-163",
                    "asset_contract": {
                        "address": "0x50f5474724e0ee42d9a4e711ccfb275809fd6d4a",
                        "asset_contract_type": "non-fungible",
                        "created_date": "2019-12-04T10:58:28.892990",
                        "name": "Sandbox's LANDs",
                        "nft_version": "3.0",
                        "opensea_version": null,
                        "owner": null,
                        "schema_name": "ERC721",
                        "symbol": "",
                        "total_supply": null,
                        "description": "The Sandbox is a community-driven platform where creators can monetize voxel assets and gaming experiences on the blockchain. The Sandbox metaverse comprises a map made up of 166,464 LANDS.  LAND owners can host contests and events, stake SAND to earn and customize assets, monetize assets and experiences, vote in the metaverse governance, play games that you or others create, and more! Trade the collection and keep your eyes peeled for future drops.",
                        "external_link": "https://www.sandbox.game/",
                        "image_url": "https://lh3.googleusercontent.com/SXH8tW1siikB80rwCRnjm1a5xM_MwTg9Xl9Db6mioIk9HIlDM09pVoSR7GKJgS6ulSUpgW9BDtMk_ePX_NKgO9A=s60",
                        "default_to_fiat": false,
                        "dev_buyer_fee_basis_points": 0,
                        "dev_seller_fee_basis_points": 500,
                        "only_proxied_transfers": false,
                        "opensea_buyer_fee_basis_points": 0,
                        "opensea_seller_fee_basis_points": 250,
                        "buyer_fee_basis_points": 0,
                        "seller_fee_basis_points": 750,
                        "payout_address": "0x7a9fe22691c811ea339d9b73150e6911a5343dca"
                    },
                    "owner": {
                        "user": {
                            "username": "REVOLT"
                        },
                        "profile_img_url": "https://storage.googleapis.com/opensea-static/opensea-profile/25.png",
                        "address": "0xb6d820e80a2a7c49f94c9d6c8ea08dccedc9ce4c",
                        "config": "",
                        "discord_id": ""
                    },
                    "permalink": "https://opensea.io/assets/0x50f5474724e0ee42d9a4e711ccfb275809fd6d4a/16980",
                    "collection": {
                        "banner_image_url": "https://lh3.googleusercontent.com/4NQIRoGmzXeXQN4mjuhWuuDZSNW7_BqRXux5upd4Nn_A-bfsGxCnPF8qn98Y6MyHRDPGXIlgfZADcSOe6M2DyrDKXdbdaTgkZN5l=s2500",
                        "chat_url": null,
                        "created_date": "2019-12-04T10:58:29.069907",
                        "default_to_fiat": false,
                        "description": "The Sandbox is a community-driven platform where creators can monetize voxel assets and gaming experiences on the blockchain. The Sandbox metaverse comprises a map made up of 166,464 LANDS.  LAND owners can host contests and events, stake SAND to earn and customize assets, monetize assets and experiences, vote in the metaverse governance, play games that you or others create, and more! Trade the collection and keep your eyes peeled for future drops.",
                        "dev_buyer_fee_basis_points": "0",
                        "dev_seller_fee_basis_points": "500",
                        "discord_url": "https://discord.gg/vAe4zvY",
                        "display_data": {
                            "card_display_style": "contain"
                        },
                        "external_url": "https://www.sandbox.game/",
                        "featured": false,
                        "featured_image_url": "https://storage.googleapis.com/opensea-static/featured-images/sandbox-featured.png",
                        "hidden": false,
                        "safelist_request_status": "verified",
                        "image_url": "https://lh3.googleusercontent.com/SXH8tW1siikB80rwCRnjm1a5xM_MwTg9Xl9Db6mioIk9HIlDM09pVoSR7GKJgS6ulSUpgW9BDtMk_ePX_NKgO9A=s60",
                        "is_subject_to_whitelist": false,
                        "large_image_url": "https://lh3.googleusercontent.com/SXH8tW1siikB80rwCRnjm1a5xM_MwTg9Xl9Db6mioIk9HIlDM09pVoSR7GKJgS6ulSUpgW9BDtMk_ePX_NKgO9A",
                        "medium_username": "sandbox-game",
                        "name": "The Sandbox",
                        "only_proxied_transfers": false,
                        "opensea_buyer_fee_basis_points": "0",
                        "opensea_seller_fee_basis_points": "250",
                        "payout_address": "0x7a9fe22691c811ea339d9b73150e6911a5343dca",
                        "require_email": false,
                        "short_description": null,
                        "slug": "sandbox",
                        "telegram_url": "https://t.me/sandboxgame",
                        "twitter_username": "thesandboxgame",
                        "instagram_username": null,
                        "wiki_url": null
                    },
                    "decimals": null,
                    "token_metadata": null
                },
                {
                    "id": 15816098,
                    "token_id": "16981",
                    "num_sales": 0,
                    "background_color": null,
                    "image_url": "https://storage.opensea.io/files/3faa959fa75531ac7913a9c9f8361b58.png",
                    "image_preview_url": "https://lh3.googleusercontent.com/17vU_UNWeMOVi4XOAwo4nvAXpeg1dnKPBk8VnAhJcFHOFZ9UBBvSL5Spj0ytvyfII3rdp4gHMY0mMvbnSzjdOZ0=s250",
                    "image_thumbnail_url": "https://lh3.googleusercontent.com/17vU_UNWeMOVi4XOAwo4nvAXpeg1dnKPBk8VnAhJcFHOFZ9UBBvSL5Spj0ytvyfII3rdp4gHMY0mMvbnSzjdOZ0=s128",
                    "image_original_url": "https://storage.googleapis.com/opensea-static/custom-fetcher-images/sandbox/land/sandbox-land.png",
                    "animation_url": null,
                    "animation_original_url": null,
                    "name": "LAND (49, -163)",
                    "description": "A LAND is a digital piece of real estate in The Sandbox metaverse that players can buy to build experiences on top of. Once you own a LAND, you will be able to populate it with Games and Assets. Each LAND is a unique (non-fungible) token lying on the public Ethereum blockchain (ERC-721).",
                    "external_link": "https://www.sandbox.game/en/map/?x=49&y=-163",
                    "asset_contract": {
                        "address": "0x50f5474724e0ee42d9a4e711ccfb275809fd6d4a",
                        "asset_contract_type": "non-fungible",
                        "created_date": "2019-12-04T10:58:28.892990",
                        "name": "Sandbox's LANDs",
                        "nft_version": "3.0",
                        "opensea_version": null,
                        "owner": null,
                        "schema_name": "ERC721",
                        "symbol": "",
                        "total_supply": null,
                        "description": "The Sandbox is a community-driven platform where creators can monetize voxel assets and gaming experiences on the blockchain. The Sandbox metaverse comprises a map made up of 166,464 LANDS.  LAND owners can host contests and events, stake SAND to earn and customize assets, monetize assets and experiences, vote in the metaverse governance, play games that you or others create, and more! Trade the collection and keep your eyes peeled for future drops.",
                        "external_link": "https://www.sandbox.game/",
                        "image_url": "https://lh3.googleusercontent.com/SXH8tW1siikB80rwCRnjm1a5xM_MwTg9Xl9Db6mioIk9HIlDM09pVoSR7GKJgS6ulSUpgW9BDtMk_ePX_NKgO9A=s60",
                        "default_to_fiat": false,
                        "dev_buyer_fee_basis_points": 0,
                        "dev_seller_fee_basis_points": 500,
                        "only_proxied_transfers": false,
                        "opensea_buyer_fee_basis_points": 0,
                        "opensea_seller_fee_basis_points": 250,
                        "buyer_fee_basis_points": 0,
                        "seller_fee_basis_points": 750,
                        "payout_address": "0x7a9fe22691c811ea339d9b73150e6911a5343dca"
                    },
                    "owner": {
                        "user": {
                            "username": "REVOLT"
                        },
                        "profile_img_url": "https://storage.googleapis.com/opensea-static/opensea-profile/25.png",
                        "address": "0xb6d820e80a2a7c49f94c9d6c8ea08dccedc9ce4c",
                        "config": "",
                        "discord_id": ""
                    },
                    "permalink": "https://opensea.io/assets/0x50f5474724e0ee42d9a4e711ccfb275809fd6d4a/16981",
                    "collection": {
                        "banner_image_url": "https://lh3.googleusercontent.com/4NQIRoGmzXeXQN4mjuhWuuDZSNW7_BqRXux5upd4Nn_A-bfsGxCnPF8qn98Y6MyHRDPGXIlgfZADcSOe6M2DyrDKXdbdaTgkZN5l=s2500",
                        "chat_url": null,
                        "created_date": "2019-12-04T10:58:29.069907",
                        "default_to_fiat": false,
                        "description": "The Sandbox is a community-driven platform where creators can monetize voxel assets and gaming experiences on the blockchain. The Sandbox metaverse comprises a map made up of 166,464 LANDS.  LAND owners can host contests and events, stake SAND to earn and customize assets, monetize assets and experiences, vote in the metaverse governance, play games that you or others create, and more! Trade the collection and keep your eyes peeled for future drops.",
                        "dev_buyer_fee_basis_points": "0",
                        "dev_seller_fee_basis_points": "500",
                        "discord_url": "https://discord.gg/vAe4zvY",
                        "display_data": {
                            "card_display_style": "contain"
                        },
                        "external_url": "https://www.sandbox.game/",
                        "featured": false,
                        "featured_image_url": "https://storage.googleapis.com/opensea-static/featured-images/sandbox-featured.png",
                        "hidden": false,
                        "safelist_request_status": "verified",
                        "image_url": "https://lh3.googleusercontent.com/SXH8tW1siikB80rwCRnjm1a5xM_MwTg9Xl9Db6mioIk9HIlDM09pVoSR7GKJgS6ulSUpgW9BDtMk_ePX_NKgO9A=s60",
                        "is_subject_to_whitelist": false,
                        "large_image_url": "https://lh3.googleusercontent.com/SXH8tW1siikB80rwCRnjm1a5xM_MwTg9Xl9Db6mioIk9HIlDM09pVoSR7GKJgS6ulSUpgW9BDtMk_ePX_NKgO9A",
                        "medium_username": "sandbox-game",
                        "name": "The Sandbox",
                        "only_proxied_transfers": false,
                        "opensea_buyer_fee_basis_points": "0",
                        "opensea_seller_fee_basis_points": "250",
                        "payout_address": "0x7a9fe22691c811ea339d9b73150e6911a5343dca",
                        "require_email": false,
                        "short_description": null,
                        "slug": "sandbox",
                        "telegram_url": "https://t.me/sandboxgame",
                        "twitter_username": "thesandboxgame",
                        "instagram_username": null,
                        "wiki_url": null
                    },
                    "decimals": null,
                    "token_metadata": null
                },
                {
                    "id": 15816122,
                    "token_id": "16982",
                    "num_sales": 0,
                    "background_color": null,
                    "image_url": "https://storage.opensea.io/files/3faa959fa75531ac7913a9c9f8361b58.png",
                    "image_preview_url": "https://lh3.googleusercontent.com/17vU_UNWeMOVi4XOAwo4nvAXpeg1dnKPBk8VnAhJcFHOFZ9UBBvSL5Spj0ytvyfII3rdp4gHMY0mMvbnSzjdOZ0=s250",
                    "image_thumbnail_url": "https://lh3.googleusercontent.com/17vU_UNWeMOVi4XOAwo4nvAXpeg1dnKPBk8VnAhJcFHOFZ9UBBvSL5Spj0ytvyfII3rdp4gHMY0mMvbnSzjdOZ0=s128",
                    "image_original_url": "https://storage.googleapis.com/opensea-static/custom-fetcher-images/sandbox/land/sandbox-land.png",
                    "animation_url": null,
                    "animation_original_url": null,
                    "name": "LAND (50, -163)",
                    "description": "A LAND is a digital piece of real estate in The Sandbox metaverse that players can buy to build experiences on top of. Once you own a LAND, you will be able to populate it with Games and Assets. Each LAND is a unique (non-fungible) token lying on the public Ethereum blockchain (ERC-721).",
                    "external_link": "https://www.sandbox.game/en/map/?x=50&y=-163",
                    "asset_contract": {
                        "address": "0x50f5474724e0ee42d9a4e711ccfb275809fd6d4a",
                        "asset_contract_type": "non-fungible",
                        "created_date": "2019-12-04T10:58:28.892990",
                        "name": "Sandbox's LANDs",
                        "nft_version": "3.0",
                        "opensea_version": null,
                        "owner": null,
                        "schema_name": "ERC721",
                        "symbol": "",
                        "total_supply": null,
                        "description": "The Sandbox is a community-driven platform where creators can monetize voxel assets and gaming experiences on the blockchain. The Sandbox metaverse comprises a map made up of 166,464 LANDS.  LAND owners can host contests and events, stake SAND to earn and customize assets, monetize assets and experiences, vote in the metaverse governance, play games that you or others create, and more! Trade the collection and keep your eyes peeled for future drops.",
                        "external_link": "https://www.sandbox.game/",
                        "image_url": "https://lh3.googleusercontent.com/SXH8tW1siikB80rwCRnjm1a5xM_MwTg9Xl9Db6mioIk9HIlDM09pVoSR7GKJgS6ulSUpgW9BDtMk_ePX_NKgO9A=s60",
                        "default_to_fiat": false,
                        "dev_buyer_fee_basis_points": 0,
                        "dev_seller_fee_basis_points": 500,
                        "only_proxied_transfers": false,
                        "opensea_buyer_fee_basis_points": 0,
                        "opensea_seller_fee_basis_points": 250,
                        "buyer_fee_basis_points": 0,
                        "seller_fee_basis_points": 750,
                        "payout_address": "0x7a9fe22691c811ea339d9b73150e6911a5343dca"
                    },
                    "owner": {
                        "user": {
                            "username": "REVOLT"
                        },
                        "profile_img_url": "https://storage.googleapis.com/opensea-static/opensea-profile/25.png",
                        "address": "0xb6d820e80a2a7c49f94c9d6c8ea08dccedc9ce4c",
                        "config": "",
                        "discord_id": ""
                    },
                    "permalink": "https://opensea.io/assets/0x50f5474724e0ee42d9a4e711ccfb275809fd6d4a/16982",
                    "collection": {
                        "banner_image_url": "https://lh3.googleusercontent.com/4NQIRoGmzXeXQN4mjuhWuuDZSNW7_BqRXux5upd4Nn_A-bfsGxCnPF8qn98Y6MyHRDPGXIlgfZADcSOe6M2DyrDKXdbdaTgkZN5l=s2500",
                        "chat_url": null,
                        "created_date": "2019-12-04T10:58:29.069907",
                        "default_to_fiat": false,
                        "description": "The Sandbox is a community-driven platform where creators can monetize voxel assets and gaming experiences on the blockchain. The Sandbox metaverse comprises a map made up of 166,464 LANDS.  LAND owners can host contests and events, stake SAND to earn and customize assets, monetize assets and experiences, vote in the metaverse governance, play games that you or others create, and more! Trade the collection and keep your eyes peeled for future drops.",
                        "dev_buyer_fee_basis_points": "0",
                        "dev_seller_fee_basis_points": "500",
                        "discord_url": "https://discord.gg/vAe4zvY",
                        "display_data": {
                            "card_display_style": "contain"
                        },
                        "external_url": "https://www.sandbox.game/",
                        "featured": false,
                        "featured_image_url": "https://storage.googleapis.com/opensea-static/featured-images/sandbox-featured.png",
                        "hidden": false,
                        "safelist_request_status": "verified",
                        "image_url": "https://lh3.googleusercontent.com/SXH8tW1siikB80rwCRnjm1a5xM_MwTg9Xl9Db6mioIk9HIlDM09pVoSR7GKJgS6ulSUpgW9BDtMk_ePX_NKgO9A=s60",
                        "is_subject_to_whitelist": false,
                        "large_image_url": "https://lh3.googleusercontent.com/SXH8tW1siikB80rwCRnjm1a5xM_MwTg9Xl9Db6mioIk9HIlDM09pVoSR7GKJgS6ulSUpgW9BDtMk_ePX_NKgO9A",
                        "medium_username": "sandbox-game",
                        "name": "The Sandbox",
                        "only_proxied_transfers": false,
                        "opensea_buyer_fee_basis_points": "0",
                        "opensea_seller_fee_basis_points": "250",
                        "payout_address": "0x7a9fe22691c811ea339d9b73150e6911a5343dca",
                        "require_email": false,
                        "short_description": null,
                        "slug": "sandbox",
                        "telegram_url": "https://t.me/sandboxgame",
                        "twitter_username": "thesandboxgame",
                        "instagram_username": null,
                        "wiki_url": null
                    },
                    "decimals": null,
                    "token_metadata": null
                }
            ],
            "name": "Small estate (9 lands)",
            "description": "Yes, you can afford it :o))",
            "external_link": "",
            "asset_contract": {
                "collection": {
                    "banner_image_url": "https://lh3.googleusercontent.com/4NQIRoGmzXeXQN4mjuhWuuDZSNW7_BqRXux5upd4Nn_A-bfsGxCnPF8qn98Y6MyHRDPGXIlgfZADcSOe6M2DyrDKXdbdaTgkZN5l=s2500",
                    "chat_url": null,
                    "created_date": "2019-12-04T10:58:29.069907",
                    "default_to_fiat": false,
                    "description": "The Sandbox is a community-driven platform where creators can monetize voxel assets and gaming experiences on the blockchain. The Sandbox metaverse comprises a map made up of 166,464 LANDS.  LAND owners can host contests and events, stake SAND to earn and customize assets, monetize assets and experiences, vote in the metaverse governance, play games that you or others create, and more! Trade the collection and keep your eyes peeled for future drops.",
                    "dev_buyer_fee_basis_points": "0",
                    "dev_seller_fee_basis_points": "500",
                    "discord_url": "https://discord.gg/vAe4zvY",
                    "display_data": {
                        "card_display_style": "contain"
                    },
                    "external_url": "https://www.sandbox.game/",
                    "featured": false,
                    "featured_image_url": "https://storage.googleapis.com/opensea-static/featured-images/sandbox-featured.png",
                    "hidden": false,
                    "safelist_request_status": "verified",
                    "image_url": "https://lh3.googleusercontent.com/SXH8tW1siikB80rwCRnjm1a5xM_MwTg9Xl9Db6mioIk9HIlDM09pVoSR7GKJgS6ulSUpgW9BDtMk_ePX_NKgO9A=s60",
                    "is_subject_to_whitelist": false,
                    "large_image_url": "https://lh3.googleusercontent.com/SXH8tW1siikB80rwCRnjm1a5xM_MwTg9Xl9Db6mioIk9HIlDM09pVoSR7GKJgS6ulSUpgW9BDtMk_ePX_NKgO9A",
                    "medium_username": "sandbox-game",
                    "name": "The Sandbox",
                    "only_proxied_transfers": false,
                    "opensea_buyer_fee_basis_points": "0",
                    "opensea_seller_fee_basis_points": "250",
                    "payout_address": "0x7a9fe22691c811ea339d9b73150e6911a5343dca",
                    "require_email": false,
                    "short_description": null,
                    "slug": "sandbox",
                    "telegram_url": "https://t.me/sandboxgame",
                    "twitter_username": "thesandboxgame",
                    "instagram_username": null,
                    "wiki_url": null
                },
                "address": "0x50f5474724e0ee42d9a4e711ccfb275809fd6d4a",
                "asset_contract_type": "non-fungible",
                "created_date": "2019-12-04T10:58:28.892990",
                "name": "Sandbox's LANDs",
                "nft_version": "3.0",
                "opensea_version": null,
                "owner": null,
                "schema_name": "ERC721",
                "symbol": "",
                "total_supply": null,
                "description": "The Sandbox is a community-driven platform where creators can monetize voxel assets and gaming experiences on the blockchain. The Sandbox metaverse comprises a map made up of 166,464 LANDS.  LAND owners can host contests and events, stake SAND to earn and customize assets, monetize assets and experiences, vote in the metaverse governance, play games that you or others create, and more! Trade the collection and keep your eyes peeled for future drops.",
                "external_link": "https://www.sandbox.game/",
                "image_url": "https://lh3.googleusercontent.com/SXH8tW1siikB80rwCRnjm1a5xM_MwTg9Xl9Db6mioIk9HIlDM09pVoSR7GKJgS6ulSUpgW9BDtMk_ePX_NKgO9A=s60",
                "default_to_fiat": false,
                "dev_buyer_fee_basis_points": 0,
                "dev_seller_fee_basis_points": 500,
                "only_proxied_transfers": false,
                "opensea_buyer_fee_basis_points": 0,
                "opensea_seller_fee_basis_points": 250,
                "buyer_fee_basis_points": 0,
                "seller_fee_basis_points": 750,
                "payout_address": "0x7a9fe22691c811ea339d9b73150e6911a5343dca"
            },
            "permalink": "https://opensea.io/bundles/small-estate-9-lands-E3u",
            "sell_orders": [
                {
                    "created_date": "2021-05-25T21:42:26.401937",
                    "closing_date": null,
                    "closing_extendable": false,
                    "expiration_time": 0,
                    "listing_time": 1621978839,
                    "order_hash": "0x7d45561f31414efc1e5d0a05132f3cc591fdc3aef18dfe751fab9eda6fcac2a1",
                    "metadata": {
                        "bundle": {
                            "assets": [
                                {
                                    "id": "16164",
                                    "address": "0x50f5474724e0ee42d9a4e711ccfb275809fd6d4a"
                                },
                                {
                                    "id": "16165",
                                    "address": "0x50f5474724e0ee42d9a4e711ccfb275809fd6d4a"
                                },
                                {
                                    "id": "16166",
                                    "address": "0x50f5474724e0ee42d9a4e711ccfb275809fd6d4a"
                                },
                                {
                                    "id": "16572",
                                    "address": "0x50f5474724e0ee42d9a4e711ccfb275809fd6d4a"
                                },
                                {
                                    "id": "16573",
                                    "address": "0x50f5474724e0ee42d9a4e711ccfb275809fd6d4a"
                                },
                                {
                                    "id": "16574",
                                    "address": "0x50f5474724e0ee42d9a4e711ccfb275809fd6d4a"
                                },
                                {
                                    "id": "16980",
                                    "address": "0x50f5474724e0ee42d9a4e711ccfb275809fd6d4a"
                                },
                                {
                                    "id": "16981",
                                    "address": "0x50f5474724e0ee42d9a4e711ccfb275809fd6d4a"
                                },
                                {
                                    "id": "16982",
                                    "address": "0x50f5474724e0ee42d9a4e711ccfb275809fd6d4a"
                                }
                            ],
                            "schemas": [
                                "ERC721",
                                "ERC721",
                                "ERC721",
                                "ERC721",
                                "ERC721",
                                "ERC721",
                                "ERC721",
                                "ERC721",
                                "ERC721"
                            ],
                            "name": "Small estate (9 lands)",
                            "description": "Yes, you can afford it :o))",
                            "external_link": ""
                        }
                    },
                    "exchange": "0x7be8076f4ea4a4ad08075c2508e481d6c946d12b",
                    "maker": {
                        "user": 3797,
                        "profile_img_url": "https://storage.googleapis.com/opensea-static/opensea-profile/25.png",
                        "address": "0xb6d820e80a2a7c49f94c9d6c8ea08dccedc9ce4c",
                        "config": "",
                        "discord_id": ""
                    },
                    "taker": {
                        "user": 1766,
                        "profile_img_url": "https://storage.googleapis.com/opensea-static/opensea-profile/1.png",
                        "address": "0x0000000000000000000000000000000000000000",
                        "config": "",
                        "discord_id": ""
                    },
                    "current_price": "135000000000000000000",
                    "current_bounty": "1350000000000000000",
                    "bounty_multiple": "0.01",
                    "maker_relayer_fee": "750",
                    "taker_relayer_fee": "0",
                    "maker_protocol_fee": "0",
                    "taker_protocol_fee": "0",
                    "maker_referrer_fee": "0",
                    "fee_recipient": {
                        "user": 3585,
                        "profile_img_url": "https://storage.googleapis.com/opensea-static/opensea-profile/28.png",
                        "address": "0x5b3256965e7c3cf26e11fcaf296dfc8807c01073",
                        "config": "verified",
                        "discord_id": ""
                    },
                    "fee_method": 1,
                    "side": 1,
                    "sale_kind": 0,
                    "target": "0xc99f70bfd82fb7c8f8191fdfbfb735606b15e5c5",
                    "how_to_call": 1,
                    "calldata": "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",
                    "replacement_pattern": "0x0000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000ffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffff0000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000ffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffff0000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000ffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffff0000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000ffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffff0000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000ffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffff0000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000ffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffff0000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000ffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffff0000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000ffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffff0000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000ffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffff000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000",
                    "static_target": "0x0000000000000000000000000000000000000000",
                    "static_extradata": "0x",
                    "payment_token": "0x0000000000000000000000000000000000000000",
                    "payment_token_contract": {
                        "id": 1,
                        "symbol": "ETH",
                        "address": "0x0000000000000000000000000000000000000000",
                        "image_url": "https://storage.opensea.io/files/6f8e2979d428180222796ff4a33ab929.svg",
                        "name": "Ether",
                        "decimals": 18,
                        "eth_price": "1.000000000000000",
                        "usd_price": "2625.730000000000018000"
                    },
                    "base_price": "135000000000000000000",
                    "extra": "0",
                    "quantity": "1",
                    "salt": "94639218699318746942105453185366520029457297175418677428125085959358664688864",
                    "v": 27,
                    "r": "0xe9cf3716857de0e78630c0ca1feadd69583be1d4e76ca05277408bf38589fd04",
                    "s": "0x40161caf75a1d098a8ac80f3d9ce1d20aa7626a22fbed322da89d82b7a1b51a3",
                    "approved_on_chain": false,
                    "cancelled": false,
                    "finalized": false,
                    "marked_invalid": false,
                    "prefixed_hash": "0xf5dc91d016c55c33337d6b2096fbc3a8efbe2a406ddafdeca4720b5453a79867"
                }
            ]
        },
        {
            "maker": {
                "user": {
                    "username": "BoredElonMusk"
                },
                "profile_img_url": "https://storage.googleapis.com/opensea-static/opensea-profile/14.png",
                "address": "0xf56345338cb4cddaf915ebef3bfde63e70fe3053",
                "config": "verified",
                "discord_id": ""
            },
            "slug": "martian-bunker-bundle-fEk",
            "assets": [
                {
                    "id": 25619723,
                    "token_id": "578993",
                    "num_sales": 2,
                    "background_color": null,
                    "image_url": "https://lh3.googleusercontent.com/2zmgry_o7-hKX8snudG85vuFFrzoDPkWZuDfcb5XJzB0kkWd98uP7dEr1nyb-Pfw2qk5jyfPFVAJEBpETkE__U8VTaEJA-qLrlRN",
                    "image_preview_url": "https://lh3.googleusercontent.com/2zmgry_o7-hKX8snudG85vuFFrzoDPkWZuDfcb5XJzB0kkWd98uP7dEr1nyb-Pfw2qk5jyfPFVAJEBpETkE__U8VTaEJA-qLrlRN=s250",
                    "image_thumbnail_url": "https://lh3.googleusercontent.com/2zmgry_o7-hKX8snudG85vuFFrzoDPkWZuDfcb5XJzB0kkWd98uP7dEr1nyb-Pfw2qk5jyfPFVAJEBpETkE__U8VTaEJA-qLrlRN=s128",
                    "image_original_url": "https://ipfs.io/ipfs/QmUEroB167Sueidi8QjQFiivGWp2mvJLAShq5oEXMAsAg7/image.jpeg",
                    "animation_url": null,
                    "animation_original_url": null,
                    "name": "Martian Bunkers: Rover Wash (Module 1)",
                    "description": "Your future Martian home will mostly be located under the surface of the red planet. These modular units represent rooms you can add to your residence to serve the various needs of the bunker billionaire that you are. Limited editions of the Martian Bunkers series will be released in sets of 4. \n\nThe Rover Wash unit will make sure your shiny rover stays shiny after a long day of...rovering...around a very dusty planet. Tip: don't pay for the extra turtle wax shine on your wheels. It's not worth it. \n\nThis project is a collaboration by Bored Elon and the talented Amrit Pal Singh https://twitter.com/amritpaldesign",
                    "external_link": "https://rarible.com/token/0xd07dc4262bcdbf85190c01c996b4c06a461d2430:578993",
                    "asset_contract": {
                        "address": "0xd07dc4262bcdbf85190c01c996b4c06a461d2430",
                        "asset_contract_type": "semi-fungible",
                        "created_date": "2020-05-27T16:53:32.834583",
                        "name": "Rarible 1155",
                        "nft_version": null,
                        "opensea_version": null,
                        "owner": 42603523,
                        "schema_name": "ERC1155",
                        "symbol": "",
                        "total_supply": null,
                        "description": "Create and sell digital collectibles secured with blockchain technology. Rarible is home to thousands of artists and collectors, creating and exchanging immutable art without using code. Trade with RARI token on OpenSea.",
                        "external_link": "https://rarible.com/",
                        "image_url": "https://lh3.googleusercontent.com/FG0QJ00fN3c_FWuPeUr9-T__iQl63j9hn5d6svW8UqOmia5zp3lKHPkJuHcvhZ0f_Pd6P2COo9tt9zVUvdPxG_9BBw=s60",
                        "default_to_fiat": false,
                        "dev_buyer_fee_basis_points": 0,
                        "dev_seller_fee_basis_points": 0,
                        "only_proxied_transfers": false,
                        "opensea_buyer_fee_basis_points": 0,
                        "opensea_seller_fee_basis_points": 250,
                        "buyer_fee_basis_points": 0,
                        "seller_fee_basis_points": 250,
                        "payout_address": null
                    },
                    "owner": {
                        "user": {
                            "username": "NullAddress"
                        },
                        "profile_img_url": "https://storage.googleapis.com/opensea-static/opensea-profile/1.png",
                        "address": "0x0000000000000000000000000000000000000000",
                        "config": "",
                        "discord_id": ""
                    },
                    "permalink": "https://opensea.io/assets/0xd07dc4262bcdbf85190c01c996b4c06a461d2430/578993",
                    "collection": {
                        "banner_image_url": "https://storage.opensea.io/static/banners/rarible-banner4.png",
                        "chat_url": null,
                        "created_date": "2020-01-01T13:22:57.777065",
                        "default_to_fiat": false,
                        "description": "Create and sell digital collectibles secured with blockchain technology. Rarible is home to thousands of artists and collectors, creating and exchanging immutable art without using code. Trade with RARI token on OpenSea.",
                        "dev_buyer_fee_basis_points": "0",
                        "dev_seller_fee_basis_points": "0",
                        "discord_url": null,
                        "display_data": {
                            "card_display_style": "contain"
                        },
                        "external_url": "https://rarible.com/",
                        "featured": false,
                        "featured_image_url": null,
                        "hidden": false,
                        "safelist_request_status": "verified",
                        "image_url": "https://lh3.googleusercontent.com/FG0QJ00fN3c_FWuPeUr9-T__iQl63j9hn5d6svW8UqOmia5zp3lKHPkJuHcvhZ0f_Pd6P2COo9tt9zVUvdPxG_9BBw=s60",
                        "is_subject_to_whitelist": false,
                        "large_image_url": "https://lh3.googleusercontent.com/FG0QJ00fN3c_FWuPeUr9-T__iQl63j9hn5d6svW8UqOmia5zp3lKHPkJuHcvhZ0f_Pd6P2COo9tt9zVUvdPxG_9BBw",
                        "medium_username": "rarible",
                        "name": "Rarible",
                        "only_proxied_transfers": false,
                        "opensea_buyer_fee_basis_points": "0",
                        "opensea_seller_fee_basis_points": "250",
                        "payout_address": null,
                        "require_email": false,
                        "short_description": null,
                        "slug": "rarible",
                        "telegram_url": "https://t.me/rarible",
                        "twitter_username": "rariblecom",
                        "instagram_username": null,
                        "wiki_url": null
                    },
                    "decimals": null,
                    "token_metadata": "https://ipfs.io/ipfs/QmPpcC6xXTAmpn8aXfRFpjkejaZMM4yR77S4Kk7KgqTKNz"
                },
                {
                    "id": 25619898,
                    "token_id": "578995",
                    "num_sales": 4,
                    "background_color": null,
                    "image_url": "https://lh3.googleusercontent.com/jWEkaSgiaasCNufs_7v-_FSo89_qjlKwof2hBTnURp-XPyLdUm8ufw1Vji_KEipNfwswdQhG5LcPnsaIcayxuCl8-eZe0ggTKWx6cQ",
                    "image_preview_url": "https://lh3.googleusercontent.com/jWEkaSgiaasCNufs_7v-_FSo89_qjlKwof2hBTnURp-XPyLdUm8ufw1Vji_KEipNfwswdQhG5LcPnsaIcayxuCl8-eZe0ggTKWx6cQ=s250",
                    "image_thumbnail_url": "https://lh3.googleusercontent.com/jWEkaSgiaasCNufs_7v-_FSo89_qjlKwof2hBTnURp-XPyLdUm8ufw1Vji_KEipNfwswdQhG5LcPnsaIcayxuCl8-eZe0ggTKWx6cQ=s128",
                    "image_original_url": "https://ipfs.io/ipfs/QmdMFJ1dPHZ9FF4emuanYwQCcVLZtDi7zoxGfV6LLUdMRv/image.jpeg",
                    "animation_url": null,
                    "animation_original_url": null,
                    "name": "Martian Bunkers: Greenhouse (Module 2)",
                    "description": "Your future Martian home will mostly be located under the surface of the red planet. These modular units represent rooms you can add to your residence to serve the various needs of the bunker billionaire that you are. Limited editions of the Martian Bunkers series will be released in sets of 4. \n\nThe Greenhouse unit is a critical component of the modern Martian household. Grow potatoes, carrots, and celery for your space smoothies. Tip: You can also grow crops that aren't food, but may come in handy if you have an upcoming podcast interview. \n\nThis project is a collaboration by Bored Elon and the talented Amrit Pal Singh https://twitter.com/amritpaldesign",
                    "external_link": "https://rarible.com/token/0xd07dc4262bcdbf85190c01c996b4c06a461d2430:578995",
                    "asset_contract": {
                        "address": "0xd07dc4262bcdbf85190c01c996b4c06a461d2430",
                        "asset_contract_type": "semi-fungible",
                        "created_date": "2020-05-27T16:53:32.834583",
                        "name": "Rarible 1155",
                        "nft_version": null,
                        "opensea_version": null,
                        "owner": 42603523,
                        "schema_name": "ERC1155",
                        "symbol": "",
                        "total_supply": null,
                        "description": "Create and sell digital collectibles secured with blockchain technology. Rarible is home to thousands of artists and collectors, creating and exchanging immutable art without using code. Trade with RARI token on OpenSea.",
                        "external_link": "https://rarible.com/",
                        "image_url": "https://lh3.googleusercontent.com/FG0QJ00fN3c_FWuPeUr9-T__iQl63j9hn5d6svW8UqOmia5zp3lKHPkJuHcvhZ0f_Pd6P2COo9tt9zVUvdPxG_9BBw=s60",
                        "default_to_fiat": false,
                        "dev_buyer_fee_basis_points": 0,
                        "dev_seller_fee_basis_points": 0,
                        "only_proxied_transfers": false,
                        "opensea_buyer_fee_basis_points": 0,
                        "opensea_seller_fee_basis_points": 250,
                        "buyer_fee_basis_points": 0,
                        "seller_fee_basis_points": 250,
                        "payout_address": null
                    },
                    "owner": {
                        "user": {
                            "username": "NullAddress"
                        },
                        "profile_img_url": "https://storage.googleapis.com/opensea-static/opensea-profile/1.png",
                        "address": "0x0000000000000000000000000000000000000000",
                        "config": "",
                        "discord_id": ""
                    },
                    "permalink": "https://opensea.io/assets/0xd07dc4262bcdbf85190c01c996b4c06a461d2430/578995",
                    "collection": {
                        "banner_image_url": "https://storage.opensea.io/static/banners/rarible-banner4.png",
                        "chat_url": null,
                        "created_date": "2020-01-01T13:22:57.777065",
                        "default_to_fiat": false,
                        "description": "Create and sell digital collectibles secured with blockchain technology. Rarible is home to thousands of artists and collectors, creating and exchanging immutable art without using code. Trade with RARI token on OpenSea.",
                        "dev_buyer_fee_basis_points": "0",
                        "dev_seller_fee_basis_points": "0",
                        "discord_url": null,
                        "display_data": {
                            "card_display_style": "contain"
                        },
                        "external_url": "https://rarible.com/",
                        "featured": false,
                        "featured_image_url": null,
                        "hidden": false,
                        "safelist_request_status": "verified",
                        "image_url": "https://lh3.googleusercontent.com/FG0QJ00fN3c_FWuPeUr9-T__iQl63j9hn5d6svW8UqOmia5zp3lKHPkJuHcvhZ0f_Pd6P2COo9tt9zVUvdPxG_9BBw=s60",
                        "is_subject_to_whitelist": false,
                        "large_image_url": "https://lh3.googleusercontent.com/FG0QJ00fN3c_FWuPeUr9-T__iQl63j9hn5d6svW8UqOmia5zp3lKHPkJuHcvhZ0f_Pd6P2COo9tt9zVUvdPxG_9BBw",
                        "medium_username": "rarible",
                        "name": "Rarible",
                        "only_proxied_transfers": false,
                        "opensea_buyer_fee_basis_points": "0",
                        "opensea_seller_fee_basis_points": "250",
                        "payout_address": null,
                        "require_email": false,
                        "short_description": null,
                        "slug": "rarible",
                        "telegram_url": "https://t.me/rarible",
                        "twitter_username": "rariblecom",
                        "instagram_username": null,
                        "wiki_url": null
                    },
                    "decimals": null,
                    "token_metadata": "https://ipfs.io/ipfs/QmcepaC5kEe7wfTj8o1Cy873oZ7o4iaSXq7fj718uSemhc"
                },
                {
                    "id": 25620739,
                    "token_id": "579010",
                    "num_sales": 3,
                    "background_color": null,
                    "image_url": "https://lh3.googleusercontent.com/qm1QYdFoTpN0VwvWxdp7peqxlMctYJ0yB2-hIrgNk6eY8Mk5YefvACyZx_nHFfZj6_Sx6_Ja3t32FQhLAwFj0Y8IiD8HaLxY1c491Y0",
                    "image_preview_url": "https://lh3.googleusercontent.com/qm1QYdFoTpN0VwvWxdp7peqxlMctYJ0yB2-hIrgNk6eY8Mk5YefvACyZx_nHFfZj6_Sx6_Ja3t32FQhLAwFj0Y8IiD8HaLxY1c491Y0=s250",
                    "image_thumbnail_url": "https://lh3.googleusercontent.com/qm1QYdFoTpN0VwvWxdp7peqxlMctYJ0yB2-hIrgNk6eY8Mk5YefvACyZx_nHFfZj6_Sx6_Ja3t32FQhLAwFj0Y8IiD8HaLxY1c491Y0=s128",
                    "image_original_url": "https://ipfs.io/ipfs/QmYR6HUFrNiihoDin9LoZdEQ3MMMPFrPesmaFKiRcgu4zU/image.jpeg",
                    "animation_url": null,
                    "animation_original_url": null,
                    "name": "Martian Bunkers: Suit Room (Module 3)",
                    "description": "Your future Martian home will mostly be located under the surface of the red planet. These modular units represent rooms you can add to your residence to serve the various needs of the bunker billionaire that you are. Limited editions of the Martian Bunkers series will be released in sets of 4. \n\nThe Suit Room will be the place you store your evening attire if your evening involves leaving your bunker and bouncing around the surface of Mars. Tip: Don't poop in the suit. Please.\n\nThis project is a collaboration by Bored Elon and the talented Amrit Pal Singh https://twitter.com/amritpaldesign",
                    "external_link": "https://rarible.com/token/0xd07dc4262bcdbf85190c01c996b4c06a461d2430:579010",
                    "asset_contract": {
                        "address": "0xd07dc4262bcdbf85190c01c996b4c06a461d2430",
                        "asset_contract_type": "semi-fungible",
                        "created_date": "2020-05-27T16:53:32.834583",
                        "name": "Rarible 1155",
                        "nft_version": null,
                        "opensea_version": null,
                        "owner": 42603523,
                        "schema_name": "ERC1155",
                        "symbol": "",
                        "total_supply": null,
                        "description": "Create and sell digital collectibles secured with blockchain technology. Rarible is home to thousands of artists and collectors, creating and exchanging immutable art without using code. Trade with RARI token on OpenSea.",
                        "external_link": "https://rarible.com/",
                        "image_url": "https://lh3.googleusercontent.com/FG0QJ00fN3c_FWuPeUr9-T__iQl63j9hn5d6svW8UqOmia5zp3lKHPkJuHcvhZ0f_Pd6P2COo9tt9zVUvdPxG_9BBw=s60",
                        "default_to_fiat": false,
                        "dev_buyer_fee_basis_points": 0,
                        "dev_seller_fee_basis_points": 0,
                        "only_proxied_transfers": false,
                        "opensea_buyer_fee_basis_points": 0,
                        "opensea_seller_fee_basis_points": 250,
                        "buyer_fee_basis_points": 0,
                        "seller_fee_basis_points": 250,
                        "payout_address": null
                    },
                    "owner": {
                        "user": {
                            "username": "NullAddress"
                        },
                        "profile_img_url": "https://storage.googleapis.com/opensea-static/opensea-profile/1.png",
                        "address": "0x0000000000000000000000000000000000000000",
                        "config": "",
                        "discord_id": ""
                    },
                    "permalink": "https://opensea.io/assets/0xd07dc4262bcdbf85190c01c996b4c06a461d2430/579010",
                    "collection": {
                        "banner_image_url": "https://storage.opensea.io/static/banners/rarible-banner4.png",
                        "chat_url": null,
                        "created_date": "2020-01-01T13:22:57.777065",
                        "default_to_fiat": false,
                        "description": "Create and sell digital collectibles secured with blockchain technology. Rarible is home to thousands of artists and collectors, creating and exchanging immutable art without using code. Trade with RARI token on OpenSea.",
                        "dev_buyer_fee_basis_points": "0",
                        "dev_seller_fee_basis_points": "0",
                        "discord_url": null,
                        "display_data": {
                            "card_display_style": "contain"
                        },
                        "external_url": "https://rarible.com/",
                        "featured": false,
                        "featured_image_url": null,
                        "hidden": false,
                        "safelist_request_status": "verified",
                        "image_url": "https://lh3.googleusercontent.com/FG0QJ00fN3c_FWuPeUr9-T__iQl63j9hn5d6svW8UqOmia5zp3lKHPkJuHcvhZ0f_Pd6P2COo9tt9zVUvdPxG_9BBw=s60",
                        "is_subject_to_whitelist": false,
                        "large_image_url": "https://lh3.googleusercontent.com/FG0QJ00fN3c_FWuPeUr9-T__iQl63j9hn5d6svW8UqOmia5zp3lKHPkJuHcvhZ0f_Pd6P2COo9tt9zVUvdPxG_9BBw",
                        "medium_username": "rarible",
                        "name": "Rarible",
                        "only_proxied_transfers": false,
                        "opensea_buyer_fee_basis_points": "0",
                        "opensea_seller_fee_basis_points": "250",
                        "payout_address": null,
                        "require_email": false,
                        "short_description": null,
                        "slug": "rarible",
                        "telegram_url": "https://t.me/rarible",
                        "twitter_username": "rariblecom",
                        "instagram_username": null,
                        "wiki_url": null
                    },
                    "decimals": null,
                    "token_metadata": "https://ipfs.io/ipfs/QmVygtDjBMchYJi3NxQZdGPxY37z2qKLN4EYzk7wvoo68b"
                },
                {
                    "id": 25620740,
                    "token_id": "579016",
                    "num_sales": 3,
                    "background_color": null,
                    "image_url": "https://lh3.googleusercontent.com/3PeSI1F8qoNq31H1Of2YS_xoYdCBOtI1NQHsLY6O9xIMBMm__2Rw2d-kPDYJVmc4c1Tkf-DLW55uE0RJ-u13ICJvCRNSVhH0eBQIdw",
                    "image_preview_url": "https://lh3.googleusercontent.com/3PeSI1F8qoNq31H1Of2YS_xoYdCBOtI1NQHsLY6O9xIMBMm__2Rw2d-kPDYJVmc4c1Tkf-DLW55uE0RJ-u13ICJvCRNSVhH0eBQIdw=s250",
                    "image_thumbnail_url": "https://lh3.googleusercontent.com/3PeSI1F8qoNq31H1Of2YS_xoYdCBOtI1NQHsLY6O9xIMBMm__2Rw2d-kPDYJVmc4c1Tkf-DLW55uE0RJ-u13ICJvCRNSVhH0eBQIdw=s128",
                    "image_original_url": "https://ipfs.io/ipfs/QmXcrsdvtYbV2YWNaAWiLDbZHj8GE6xYwfbvgm3Zsnoc9p/image.jpeg",
                    "animation_url": null,
                    "animation_original_url": null,
                    "name": "Martian Bunkers: Arcade (Module 4)",
                    "description": "Your future Martian home will mostly be located under the surface of the red planet. These modular units represent rooms you can add to your residence to serve the various needs of the bunker billionaire that you are. Limited editions of the Martian Bunkers series will be released in sets of 4. \n\nThe Arcade Room will be the center of entertainment in your Martian abode. Centuries of gaming simulations will be at your finger tips, including classic arcade machines that accept priceless Mars Coins. Tip: If you bump the pinball machine too hard instead of going on \"tilt\" the game will reduce the oxygen level in the room by 10% \n\nThis project is a collaboration by Bored Elon and the talented Amrit Pal Singh https://twitter.com/amritpaldesign",
                    "external_link": "https://rarible.com/token/0xd07dc4262bcdbf85190c01c996b4c06a461d2430:579016",
                    "asset_contract": {
                        "address": "0xd07dc4262bcdbf85190c01c996b4c06a461d2430",
                        "asset_contract_type": "semi-fungible",
                        "created_date": "2020-05-27T16:53:32.834583",
                        "name": "Rarible 1155",
                        "nft_version": null,
                        "opensea_version": null,
                        "owner": 42603523,
                        "schema_name": "ERC1155",
                        "symbol": "",
                        "total_supply": null,
                        "description": "Create and sell digital collectibles secured with blockchain technology. Rarible is home to thousands of artists and collectors, creating and exchanging immutable art without using code. Trade with RARI token on OpenSea.",
                        "external_link": "https://rarible.com/",
                        "image_url": "https://lh3.googleusercontent.com/FG0QJ00fN3c_FWuPeUr9-T__iQl63j9hn5d6svW8UqOmia5zp3lKHPkJuHcvhZ0f_Pd6P2COo9tt9zVUvdPxG_9BBw=s60",
                        "default_to_fiat": false,
                        "dev_buyer_fee_basis_points": 0,
                        "dev_seller_fee_basis_points": 0,
                        "only_proxied_transfers": false,
                        "opensea_buyer_fee_basis_points": 0,
                        "opensea_seller_fee_basis_points": 250,
                        "buyer_fee_basis_points": 0,
                        "seller_fee_basis_points": 250,
                        "payout_address": null
                    },
                    "owner": {
                        "user": {
                            "username": "NullAddress"
                        },
                        "profile_img_url": "https://storage.googleapis.com/opensea-static/opensea-profile/1.png",
                        "address": "0x0000000000000000000000000000000000000000",
                        "config": "",
                        "discord_id": ""
                    },
                    "permalink": "https://opensea.io/assets/0xd07dc4262bcdbf85190c01c996b4c06a461d2430/579016",
                    "collection": {
                        "banner_image_url": "https://storage.opensea.io/static/banners/rarible-banner4.png",
                        "chat_url": null,
                        "created_date": "2020-01-01T13:22:57.777065",
                        "default_to_fiat": false,
                        "description": "Create and sell digital collectibles secured with blockchain technology. Rarible is home to thousands of artists and collectors, creating and exchanging immutable art without using code. Trade with RARI token on OpenSea.",
                        "dev_buyer_fee_basis_points": "0",
                        "dev_seller_fee_basis_points": "0",
                        "discord_url": null,
                        "display_data": {
                            "card_display_style": "contain"
                        },
                        "external_url": "https://rarible.com/",
                        "featured": false,
                        "featured_image_url": null,
                        "hidden": false,
                        "safelist_request_status": "verified",
                        "image_url": "https://lh3.googleusercontent.com/FG0QJ00fN3c_FWuPeUr9-T__iQl63j9hn5d6svW8UqOmia5zp3lKHPkJuHcvhZ0f_Pd6P2COo9tt9zVUvdPxG_9BBw=s60",
                        "is_subject_to_whitelist": false,
                        "large_image_url": "https://lh3.googleusercontent.com/FG0QJ00fN3c_FWuPeUr9-T__iQl63j9hn5d6svW8UqOmia5zp3lKHPkJuHcvhZ0f_Pd6P2COo9tt9zVUvdPxG_9BBw",
                        "medium_username": "rarible",
                        "name": "Rarible",
                        "only_proxied_transfers": false,
                        "opensea_buyer_fee_basis_points": "0",
                        "opensea_seller_fee_basis_points": "250",
                        "payout_address": null,
                        "require_email": false,
                        "short_description": null,
                        "slug": "rarible",
                        "telegram_url": "https://t.me/rarible",
                        "twitter_username": "rariblecom",
                        "instagram_username": null,
                        "wiki_url": null
                    },
                    "decimals": null,
                    "token_metadata": "https://ipfs.io/ipfs/QmXEx8oerM5FUYaiZeERhZJkqGm1GdHpPeYPYNw8UoaUTJ"
                }
            ],
            "name": "Martian Bunker Bundle",
            "description": "",
            "external_link": "",
            "asset_contract": {
                "collection": {
                    "banner_image_url": "https://storage.opensea.io/static/banners/rarible-banner4.png",
                    "chat_url": null,
                    "created_date": "2020-01-01T13:22:57.777065",
                    "default_to_fiat": false,
                    "description": "Create and sell digital collectibles secured with blockchain technology. Rarible is home to thousands of artists and collectors, creating and exchanging immutable art without using code. Trade with RARI token on OpenSea.",
                    "dev_buyer_fee_basis_points": "0",
                    "dev_seller_fee_basis_points": "0",
                    "discord_url": null,
                    "display_data": {
                        "card_display_style": "contain"
                    },
                    "external_url": "https://rarible.com/",
                    "featured": false,
                    "featured_image_url": null,
                    "hidden": false,
                    "safelist_request_status": "verified",
                    "image_url": "https://lh3.googleusercontent.com/FG0QJ00fN3c_FWuPeUr9-T__iQl63j9hn5d6svW8UqOmia5zp3lKHPkJuHcvhZ0f_Pd6P2COo9tt9zVUvdPxG_9BBw=s60",
                    "is_subject_to_whitelist": false,
                    "large_image_url": "https://lh3.googleusercontent.com/FG0QJ00fN3c_FWuPeUr9-T__iQl63j9hn5d6svW8UqOmia5zp3lKHPkJuHcvhZ0f_Pd6P2COo9tt9zVUvdPxG_9BBw",
                    "medium_username": "rarible",
                    "name": "Rarible",
                    "only_proxied_transfers": false,
                    "opensea_buyer_fee_basis_points": "0",
                    "opensea_seller_fee_basis_points": "250",
                    "payout_address": null,
                    "require_email": false,
                    "short_description": null,
                    "slug": "rarible",
                    "telegram_url": "https://t.me/rarible",
                    "twitter_username": "rariblecom",
                    "instagram_username": null,
                    "wiki_url": null
                },
                "address": "0xd07dc4262bcdbf85190c01c996b4c06a461d2430",
                "asset_contract_type": "semi-fungible",
                "created_date": "2020-05-27T16:53:32.834583",
                "name": "Rarible 1155",
                "nft_version": null,
                "opensea_version": null,
                "owner": 42603523,
                "schema_name": "ERC1155",
                "symbol": "",
                "total_supply": null,
                "description": "Create and sell digital collectibles secured with blockchain technology. Rarible is home to thousands of artists and collectors, creating and exchanging immutable art without using code. Trade with RARI token on OpenSea.",
                "external_link": "https://rarible.com/",
                "image_url": "https://lh3.googleusercontent.com/FG0QJ00fN3c_FWuPeUr9-T__iQl63j9hn5d6svW8UqOmia5zp3lKHPkJuHcvhZ0f_Pd6P2COo9tt9zVUvdPxG_9BBw=s60",
                "default_to_fiat": false,
                "dev_buyer_fee_basis_points": 0,
                "dev_seller_fee_basis_points": 0,
                "only_proxied_transfers": false,
                "opensea_buyer_fee_basis_points": 0,
                "opensea_seller_fee_basis_points": 250,
                "buyer_fee_basis_points": 0,
                "seller_fee_basis_points": 250,
                "payout_address": null
            },
            "permalink": "https://opensea.io/bundles/martian-bunker-bundle-fEk",
            "sell_orders": [
                {
                    "created_date": "2021-05-25T21:40:26.299123",
                    "closing_date": null,
                    "closing_extendable": false,
                    "expiration_time": 0,
                    "listing_time": 1621978723,
                    "order_hash": "0x165d8f245e6214ffadc2a600209a645934e643157eb792abc40fd381f02a553b",
                    "metadata": {
                        "bundle": {
                            "assets": [
                                {
                                    "id": "578993",
                                    "address": "0xd07dc4262bcdbf85190c01c996b4c06a461d2430",
                                    "quantity": "1"
                                },
                                {
                                    "id": "578995",
                                    "address": "0xd07dc4262bcdbf85190c01c996b4c06a461d2430",
                                    "quantity": "1"
                                },
                                {
                                    "id": "579010",
                                    "address": "0xd07dc4262bcdbf85190c01c996b4c06a461d2430",
                                    "quantity": "1"
                                },
                                {
                                    "id": "579016",
                                    "address": "0xd07dc4262bcdbf85190c01c996b4c06a461d2430",
                                    "quantity": "1"
                                }
                            ],
                            "schemas": [
                                "ERC1155",
                                "ERC1155",
                                "ERC1155",
                                "ERC1155"
                            ],
                            "name": "Martian Bunker Bundle",
                            "description": "",
                            "external_link": ""
                        }
                    },
                    "exchange": "0x7be8076f4ea4a4ad08075c2508e481d6c946d12b",
                    "maker": {
                        "user": 178384,
                        "profile_img_url": "https://storage.googleapis.com/opensea-static/opensea-profile/14.png",
                        "address": "0xf56345338cb4cddaf915ebef3bfde63e70fe3053",
                        "config": "verified",
                        "discord_id": ""
                    },
                    "taker": {
                        "user": 1766,
                        "profile_img_url": "https://storage.googleapis.com/opensea-static/opensea-profile/1.png",
                        "address": "0x0000000000000000000000000000000000000000",
                        "config": "",
                        "discord_id": ""
                    },
                    "current_price": "650000000000000000",
                    "current_bounty": "6500000000000000",
                    "bounty_multiple": "0.01",
                    "maker_relayer_fee": "250",
                    "taker_relayer_fee": "0",
                    "maker_protocol_fee": "0",
                    "taker_protocol_fee": "0",
                    "maker_referrer_fee": "0",
                    "fee_recipient": {
                        "user": 3585,
                        "profile_img_url": "https://storage.googleapis.com/opensea-static/opensea-profile/28.png",
                        "address": "0x5b3256965e7c3cf26e11fcaf296dfc8807c01073",
                        "config": "verified",
                        "discord_id": ""
                    },
                    "fee_method": 1,
                    "side": 1,
                    "sale_kind": 0,
                    "target": "0xc99f70bfd82fb7c8f8191fdfbfb735606b15e5c5",
                    "how_to_call": 1,
                    "calldata": "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",
                    "replacement_pattern": "0x0000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000ffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffff0000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000ffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffff0000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000ffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffff0000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000ffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffff000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000",
                    "static_target": "0x0000000000000000000000000000000000000000",
                    "static_extradata": "0x",
                    "payment_token": "0x0000000000000000000000000000000000000000",
                    "payment_token_contract": {
                        "id": 1,
                        "symbol": "ETH",
                        "address": "0x0000000000000000000000000000000000000000",
                        "image_url": "https://storage.opensea.io/files/6f8e2979d428180222796ff4a33ab929.svg",
                        "name": "Ether",
                        "decimals": 18,
                        "eth_price": "1.000000000000000",
                        "usd_price": "2625.730000000000018000"
                    },
                    "base_price": "650000000000000000",
                    "extra": "0",
                    "quantity": "1",
                    "salt": "90008015405802080364615452164059778202355865472085086898926692296120648399954",
                    "v": 27,
                    "r": "0x72d3b08f3e77ab83f37210276c9943f6abe8a91652f0821efd03027fbbb5a755",
                    "s": "0x34aac288b167340e04d792d690e2e7d3f7ac0db14ff91d467a9976bc5e950f40",
                    "approved_on_chain": false,
                    "cancelled": false,
                    "finalized": false,
                    "marked_invalid": false,
                    "prefixed_hash": "0x03cebde0671e8b0a0bfaebb2724b2b15d67b28a8d1bc4314f67bc611d33d3dde"
                }
            ]
        },
        {
            "maker": {
                "user": {
                    "username": "REVOLT"
                },
                "profile_img_url": "https://storage.googleapis.com/opensea-static/opensea-profile/25.png",
                "address": "0xb6d820e80a2a7c49f94c9d6c8ea08dccedc9ce4c",
                "config": "",
                "discord_id": ""
            },
            "slug": "small-estate-9-lands-yVr",
            "assets": [
                {
                    "id": 15817488,
                    "token_id": "14946",
                    "num_sales": 0,
                    "background_color": null,
                    "image_url": "https://lh3.googleusercontent.com/17vU_UNWeMOVi4XOAwo4nvAXpeg1dnKPBk8VnAhJcFHOFZ9UBBvSL5Spj0ytvyfII3rdp4gHMY0mMvbnSzjdOZ0",
                    "image_preview_url": "https://lh3.googleusercontent.com/17vU_UNWeMOVi4XOAwo4nvAXpeg1dnKPBk8VnAhJcFHOFZ9UBBvSL5Spj0ytvyfII3rdp4gHMY0mMvbnSzjdOZ0=s250",
                    "image_thumbnail_url": "https://lh3.googleusercontent.com/17vU_UNWeMOVi4XOAwo4nvAXpeg1dnKPBk8VnAhJcFHOFZ9UBBvSL5Spj0ytvyfII3rdp4gHMY0mMvbnSzjdOZ0=s128",
                    "image_original_url": "https://storage.googleapis.com/opensea-static/custom-fetcher-images/sandbox/land/sandbox-land.png",
                    "animation_url": null,
                    "animation_original_url": null,
                    "name": "LAND (54, -168)",
                    "description": "A LAND is a digital piece of real estate in The Sandbox metaverse that players can buy to build experiences on top of. Once you own a LAND, you will be able to populate it with Games and Assets. Each LAND is a unique (non-fungible) token lying on the public Ethereum blockchain (ERC-721).",
                    "external_link": "https://www.sandbox.game/en/map/?x=54&y=-168",
                    "asset_contract": {
                        "address": "0x50f5474724e0ee42d9a4e711ccfb275809fd6d4a",
                        "asset_contract_type": "non-fungible",
                        "created_date": "2019-12-04T10:58:28.892990",
                        "name": "Sandbox's LANDs",
                        "nft_version": "3.0",
                        "opensea_version": null,
                        "owner": null,
                        "schema_name": "ERC721",
                        "symbol": "",
                        "total_supply": null,
                        "description": "The Sandbox is a community-driven platform where creators can monetize voxel assets and gaming experiences on the blockchain. The Sandbox metaverse comprises a map made up of 166,464 LANDS.  LAND owners can host contests and events, stake SAND to earn and customize assets, monetize assets and experiences, vote in the metaverse governance, play games that you or others create, and more! Trade the collection and keep your eyes peeled for future drops.",
                        "external_link": "https://www.sandbox.game/",
                        "image_url": "https://lh3.googleusercontent.com/SXH8tW1siikB80rwCRnjm1a5xM_MwTg9Xl9Db6mioIk9HIlDM09pVoSR7GKJgS6ulSUpgW9BDtMk_ePX_NKgO9A=s60",
                        "default_to_fiat": false,
                        "dev_buyer_fee_basis_points": 0,
                        "dev_seller_fee_basis_points": 500,
                        "only_proxied_transfers": false,
                        "opensea_buyer_fee_basis_points": 0,
                        "opensea_seller_fee_basis_points": 250,
                        "buyer_fee_basis_points": 0,
                        "seller_fee_basis_points": 750,
                        "payout_address": "0x7a9fe22691c811ea339d9b73150e6911a5343dca"
                    },
                    "owner": {
                        "user": {
                            "username": "REVOLT"
                        },
                        "profile_img_url": "https://storage.googleapis.com/opensea-static/opensea-profile/25.png",
                        "address": "0xb6d820e80a2a7c49f94c9d6c8ea08dccedc9ce4c",
                        "config": "",
                        "discord_id": ""
                    },
                    "permalink": "https://opensea.io/assets/0x50f5474724e0ee42d9a4e711ccfb275809fd6d4a/14946",
                    "collection": {
                        "banner_image_url": "https://lh3.googleusercontent.com/4NQIRoGmzXeXQN4mjuhWuuDZSNW7_BqRXux5upd4Nn_A-bfsGxCnPF8qn98Y6MyHRDPGXIlgfZADcSOe6M2DyrDKXdbdaTgkZN5l=s2500",
                        "chat_url": null,
                        "created_date": "2019-12-04T10:58:29.069907",
                        "default_to_fiat": false,
                        "description": "The Sandbox is a community-driven platform where creators can monetize voxel assets and gaming experiences on the blockchain. The Sandbox metaverse comprises a map made up of 166,464 LANDS.  LAND owners can host contests and events, stake SAND to earn and customize assets, monetize assets and experiences, vote in the metaverse governance, play games that you or others create, and more! Trade the collection and keep your eyes peeled for future drops.",
                        "dev_buyer_fee_basis_points": "0",
                        "dev_seller_fee_basis_points": "500",
                        "discord_url": "https://discord.gg/vAe4zvY",
                        "display_data": {
                            "card_display_style": "contain"
                        },
                        "external_url": "https://www.sandbox.game/",
                        "featured": false,
                        "featured_image_url": "https://storage.googleapis.com/opensea-static/featured-images/sandbox-featured.png",
                        "hidden": false,
                        "safelist_request_status": "verified",
                        "image_url": "https://lh3.googleusercontent.com/SXH8tW1siikB80rwCRnjm1a5xM_MwTg9Xl9Db6mioIk9HIlDM09pVoSR7GKJgS6ulSUpgW9BDtMk_ePX_NKgO9A=s60",
                        "is_subject_to_whitelist": false,
                        "large_image_url": "https://lh3.googleusercontent.com/SXH8tW1siikB80rwCRnjm1a5xM_MwTg9Xl9Db6mioIk9HIlDM09pVoSR7GKJgS6ulSUpgW9BDtMk_ePX_NKgO9A",
                        "medium_username": "sandbox-game",
                        "name": "The Sandbox",
                        "only_proxied_transfers": false,
                        "opensea_buyer_fee_basis_points": "0",
                        "opensea_seller_fee_basis_points": "250",
                        "payout_address": "0x7a9fe22691c811ea339d9b73150e6911a5343dca",
                        "require_email": false,
                        "short_description": null,
                        "slug": "sandbox",
                        "telegram_url": "https://t.me/sandboxgame",
                        "twitter_username": "thesandboxgame",
                        "instagram_username": null,
                        "wiki_url": null
                    },
                    "decimals": null,
                    "token_metadata": null
                },
                {
                    "id": 15817497,
                    "token_id": "14947",
                    "num_sales": 0,
                    "background_color": null,
                    "image_url": "https://lh3.googleusercontent.com/17vU_UNWeMOVi4XOAwo4nvAXpeg1dnKPBk8VnAhJcFHOFZ9UBBvSL5Spj0ytvyfII3rdp4gHMY0mMvbnSzjdOZ0",
                    "image_preview_url": "https://lh3.googleusercontent.com/17vU_UNWeMOVi4XOAwo4nvAXpeg1dnKPBk8VnAhJcFHOFZ9UBBvSL5Spj0ytvyfII3rdp4gHMY0mMvbnSzjdOZ0=s250",
                    "image_thumbnail_url": "https://lh3.googleusercontent.com/17vU_UNWeMOVi4XOAwo4nvAXpeg1dnKPBk8VnAhJcFHOFZ9UBBvSL5Spj0ytvyfII3rdp4gHMY0mMvbnSzjdOZ0=s128",
                    "image_original_url": "https://storage.googleapis.com/opensea-static/custom-fetcher-images/sandbox/land/sandbox-land.png",
                    "animation_url": null,
                    "animation_original_url": null,
                    "name": "LAND (55, -168)",
                    "description": "A LAND is a digital piece of real estate in The Sandbox metaverse that players can buy to build experiences on top of. Once you own a LAND, you will be able to populate it with Games and Assets. Each LAND is a unique (non-fungible) token lying on the public Ethereum blockchain (ERC-721).",
                    "external_link": "https://www.sandbox.game/en/map/?x=55&y=-168",
                    "asset_contract": {
                        "address": "0x50f5474724e0ee42d9a4e711ccfb275809fd6d4a",
                        "asset_contract_type": "non-fungible",
                        "created_date": "2019-12-04T10:58:28.892990",
                        "name": "Sandbox's LANDs",
                        "nft_version": "3.0",
                        "opensea_version": null,
                        "owner": null,
                        "schema_name": "ERC721",
                        "symbol": "",
                        "total_supply": null,
                        "description": "The Sandbox is a community-driven platform where creators can monetize voxel assets and gaming experiences on the blockchain. The Sandbox metaverse comprises a map made up of 166,464 LANDS.  LAND owners can host contests and events, stake SAND to earn and customize assets, monetize assets and experiences, vote in the metaverse governance, play games that you or others create, and more! Trade the collection and keep your eyes peeled for future drops.",
                        "external_link": "https://www.sandbox.game/",
                        "image_url": "https://lh3.googleusercontent.com/SXH8tW1siikB80rwCRnjm1a5xM_MwTg9Xl9Db6mioIk9HIlDM09pVoSR7GKJgS6ulSUpgW9BDtMk_ePX_NKgO9A=s60",
                        "default_to_fiat": false,
                        "dev_buyer_fee_basis_points": 0,
                        "dev_seller_fee_basis_points": 500,
                        "only_proxied_transfers": false,
                        "opensea_buyer_fee_basis_points": 0,
                        "opensea_seller_fee_basis_points": 250,
                        "buyer_fee_basis_points": 0,
                        "seller_fee_basis_points": 750,
                        "payout_address": "0x7a9fe22691c811ea339d9b73150e6911a5343dca"
                    },
                    "owner": {
                        "user": {
                            "username": "REVOLT"
                        },
                        "profile_img_url": "https://storage.googleapis.com/opensea-static/opensea-profile/25.png",
                        "address": "0xb6d820e80a2a7c49f94c9d6c8ea08dccedc9ce4c",
                        "config": "",
                        "discord_id": ""
                    },
                    "permalink": "https://opensea.io/assets/0x50f5474724e0ee42d9a4e711ccfb275809fd6d4a/14947",
                    "collection": {
                        "banner_image_url": "https://lh3.googleusercontent.com/4NQIRoGmzXeXQN4mjuhWuuDZSNW7_BqRXux5upd4Nn_A-bfsGxCnPF8qn98Y6MyHRDPGXIlgfZADcSOe6M2DyrDKXdbdaTgkZN5l=s2500",
                        "chat_url": null,
                        "created_date": "2019-12-04T10:58:29.069907",
                        "default_to_fiat": false,
                        "description": "The Sandbox is a community-driven platform where creators can monetize voxel assets and gaming experiences on the blockchain. The Sandbox metaverse comprises a map made up of 166,464 LANDS.  LAND owners can host contests and events, stake SAND to earn and customize assets, monetize assets and experiences, vote in the metaverse governance, play games that you or others create, and more! Trade the collection and keep your eyes peeled for future drops.",
                        "dev_buyer_fee_basis_points": "0",
                        "dev_seller_fee_basis_points": "500",
                        "discord_url": "https://discord.gg/vAe4zvY",
                        "display_data": {
                            "card_display_style": "contain"
                        },
                        "external_url": "https://www.sandbox.game/",
                        "featured": false,
                        "featured_image_url": "https://storage.googleapis.com/opensea-static/featured-images/sandbox-featured.png",
                        "hidden": false,
                        "safelist_request_status": "verified",
                        "image_url": "https://lh3.googleusercontent.com/SXH8tW1siikB80rwCRnjm1a5xM_MwTg9Xl9Db6mioIk9HIlDM09pVoSR7GKJgS6ulSUpgW9BDtMk_ePX_NKgO9A=s60",
                        "is_subject_to_whitelist": false,
                        "large_image_url": "https://lh3.googleusercontent.com/SXH8tW1siikB80rwCRnjm1a5xM_MwTg9Xl9Db6mioIk9HIlDM09pVoSR7GKJgS6ulSUpgW9BDtMk_ePX_NKgO9A",
                        "medium_username": "sandbox-game",
                        "name": "The Sandbox",
                        "only_proxied_transfers": false,
                        "opensea_buyer_fee_basis_points": "0",
                        "opensea_seller_fee_basis_points": "250",
                        "payout_address": "0x7a9fe22691c811ea339d9b73150e6911a5343dca",
                        "require_email": false,
                        "short_description": null,
                        "slug": "sandbox",
                        "telegram_url": "https://t.me/sandboxgame",
                        "twitter_username": "thesandboxgame",
                        "instagram_username": null,
                        "wiki_url": null
                    },
                    "decimals": null,
                    "token_metadata": null
                },
                {
                    "id": 15817503,
                    "token_id": "14948",
                    "num_sales": 0,
                    "background_color": null,
                    "image_url": "https://lh3.googleusercontent.com/17vU_UNWeMOVi4XOAwo4nvAXpeg1dnKPBk8VnAhJcFHOFZ9UBBvSL5Spj0ytvyfII3rdp4gHMY0mMvbnSzjdOZ0",
                    "image_preview_url": "https://lh3.googleusercontent.com/17vU_UNWeMOVi4XOAwo4nvAXpeg1dnKPBk8VnAhJcFHOFZ9UBBvSL5Spj0ytvyfII3rdp4gHMY0mMvbnSzjdOZ0=s250",
                    "image_thumbnail_url": "https://lh3.googleusercontent.com/17vU_UNWeMOVi4XOAwo4nvAXpeg1dnKPBk8VnAhJcFHOFZ9UBBvSL5Spj0ytvyfII3rdp4gHMY0mMvbnSzjdOZ0=s128",
                    "image_original_url": "https://storage.googleapis.com/opensea-static/custom-fetcher-images/sandbox/land/sandbox-land.png",
                    "animation_url": null,
                    "animation_original_url": null,
                    "name": "LAND (56, -168)",
                    "description": "A LAND is a digital piece of real estate in The Sandbox metaverse that players can buy to build experiences on top of. Once you own a LAND, you will be able to populate it with Games and Assets. Each LAND is a unique (non-fungible) token lying on the public Ethereum blockchain (ERC-721).",
                    "external_link": "https://www.sandbox.game/en/map/?x=56&y=-168",
                    "asset_contract": {
                        "address": "0x50f5474724e0ee42d9a4e711ccfb275809fd6d4a",
                        "asset_contract_type": "non-fungible",
                        "created_date": "2019-12-04T10:58:28.892990",
                        "name": "Sandbox's LANDs",
                        "nft_version": "3.0",
                        "opensea_version": null,
                        "owner": null,
                        "schema_name": "ERC721",
                        "symbol": "",
                        "total_supply": null,
                        "description": "The Sandbox is a community-driven platform where creators can monetize voxel assets and gaming experiences on the blockchain. The Sandbox metaverse comprises a map made up of 166,464 LANDS.  LAND owners can host contests and events, stake SAND to earn and customize assets, monetize assets and experiences, vote in the metaverse governance, play games that you or others create, and more! Trade the collection and keep your eyes peeled for future drops.",
                        "external_link": "https://www.sandbox.game/",
                        "image_url": "https://lh3.googleusercontent.com/SXH8tW1siikB80rwCRnjm1a5xM_MwTg9Xl9Db6mioIk9HIlDM09pVoSR7GKJgS6ulSUpgW9BDtMk_ePX_NKgO9A=s60",
                        "default_to_fiat": false,
                        "dev_buyer_fee_basis_points": 0,
                        "dev_seller_fee_basis_points": 500,
                        "only_proxied_transfers": false,
                        "opensea_buyer_fee_basis_points": 0,
                        "opensea_seller_fee_basis_points": 250,
                        "buyer_fee_basis_points": 0,
                        "seller_fee_basis_points": 750,
                        "payout_address": "0x7a9fe22691c811ea339d9b73150e6911a5343dca"
                    },
                    "owner": {
                        "user": {
                            "username": "REVOLT"
                        },
                        "profile_img_url": "https://storage.googleapis.com/opensea-static/opensea-profile/25.png",
                        "address": "0xb6d820e80a2a7c49f94c9d6c8ea08dccedc9ce4c",
                        "config": "",
                        "discord_id": ""
                    },
                    "permalink": "https://opensea.io/assets/0x50f5474724e0ee42d9a4e711ccfb275809fd6d4a/14948",
                    "collection": {
                        "banner_image_url": "https://lh3.googleusercontent.com/4NQIRoGmzXeXQN4mjuhWuuDZSNW7_BqRXux5upd4Nn_A-bfsGxCnPF8qn98Y6MyHRDPGXIlgfZADcSOe6M2DyrDKXdbdaTgkZN5l=s2500",
                        "chat_url": null,
                        "created_date": "2019-12-04T10:58:29.069907",
                        "default_to_fiat": false,
                        "description": "The Sandbox is a community-driven platform where creators can monetize voxel assets and gaming experiences on the blockchain. The Sandbox metaverse comprises a map made up of 166,464 LANDS.  LAND owners can host contests and events, stake SAND to earn and customize assets, monetize assets and experiences, vote in the metaverse governance, play games that you or others create, and more! Trade the collection and keep your eyes peeled for future drops.",
                        "dev_buyer_fee_basis_points": "0",
                        "dev_seller_fee_basis_points": "500",
                        "discord_url": "https://discord.gg/vAe4zvY",
                        "display_data": {
                            "card_display_style": "contain"
                        },
                        "external_url": "https://www.sandbox.game/",
                        "featured": false,
                        "featured_image_url": "https://storage.googleapis.com/opensea-static/featured-images/sandbox-featured.png",
                        "hidden": false,
                        "safelist_request_status": "verified",
                        "image_url": "https://lh3.googleusercontent.com/SXH8tW1siikB80rwCRnjm1a5xM_MwTg9Xl9Db6mioIk9HIlDM09pVoSR7GKJgS6ulSUpgW9BDtMk_ePX_NKgO9A=s60",
                        "is_subject_to_whitelist": false,
                        "large_image_url": "https://lh3.googleusercontent.com/SXH8tW1siikB80rwCRnjm1a5xM_MwTg9Xl9Db6mioIk9HIlDM09pVoSR7GKJgS6ulSUpgW9BDtMk_ePX_NKgO9A",
                        "medium_username": "sandbox-game",
                        "name": "The Sandbox",
                        "only_proxied_transfers": false,
                        "opensea_buyer_fee_basis_points": "0",
                        "opensea_seller_fee_basis_points": "250",
                        "payout_address": "0x7a9fe22691c811ea339d9b73150e6911a5343dca",
                        "require_email": false,
                        "short_description": null,
                        "slug": "sandbox",
                        "telegram_url": "https://t.me/sandboxgame",
                        "twitter_username": "thesandboxgame",
                        "instagram_username": null,
                        "wiki_url": null
                    },
                    "decimals": null,
                    "token_metadata": null
                },
                {
                    "id": 15817508,
                    "token_id": "15356",
                    "num_sales": 0,
                    "background_color": null,
                    "image_url": "https://storage.opensea.io/files/3faa959fa75531ac7913a9c9f8361b58.png",
                    "image_preview_url": "https://lh3.googleusercontent.com/17vU_UNWeMOVi4XOAwo4nvAXpeg1dnKPBk8VnAhJcFHOFZ9UBBvSL5Spj0ytvyfII3rdp4gHMY0mMvbnSzjdOZ0=s250",
                    "image_thumbnail_url": "https://lh3.googleusercontent.com/17vU_UNWeMOVi4XOAwo4nvAXpeg1dnKPBk8VnAhJcFHOFZ9UBBvSL5Spj0ytvyfII3rdp4gHMY0mMvbnSzjdOZ0=s128",
                    "image_original_url": "https://storage.googleapis.com/opensea-static/custom-fetcher-images/sandbox/land/sandbox-land.png",
                    "animation_url": null,
                    "animation_original_url": null,
                    "name": "LAND (56, -167)",
                    "description": "A LAND is a digital piece of real estate in The Sandbox metaverse that players can buy to build experiences on top of. Once you own a LAND, you will be able to populate it with Games and Assets. Each LAND is a unique (non-fungible) token lying on the public Ethereum blockchain (ERC-721).",
                    "external_link": "https://www.sandbox.game/en/map/?x=56&y=-167",
                    "asset_contract": {
                        "address": "0x50f5474724e0ee42d9a4e711ccfb275809fd6d4a",
                        "asset_contract_type": "non-fungible",
                        "created_date": "2019-12-04T10:58:28.892990",
                        "name": "Sandbox's LANDs",
                        "nft_version": "3.0",
                        "opensea_version": null,
                        "owner": null,
                        "schema_name": "ERC721",
                        "symbol": "",
                        "total_supply": null,
                        "description": "The Sandbox is a community-driven platform where creators can monetize voxel assets and gaming experiences on the blockchain. The Sandbox metaverse comprises a map made up of 166,464 LANDS.  LAND owners can host contests and events, stake SAND to earn and customize assets, monetize assets and experiences, vote in the metaverse governance, play games that you or others create, and more! Trade the collection and keep your eyes peeled for future drops.",
                        "external_link": "https://www.sandbox.game/",
                        "image_url": "https://lh3.googleusercontent.com/SXH8tW1siikB80rwCRnjm1a5xM_MwTg9Xl9Db6mioIk9HIlDM09pVoSR7GKJgS6ulSUpgW9BDtMk_ePX_NKgO9A=s60",
                        "default_to_fiat": false,
                        "dev_buyer_fee_basis_points": 0,
                        "dev_seller_fee_basis_points": 500,
                        "only_proxied_transfers": false,
                        "opensea_buyer_fee_basis_points": 0,
                        "opensea_seller_fee_basis_points": 250,
                        "buyer_fee_basis_points": 0,
                        "seller_fee_basis_points": 750,
                        "payout_address": "0x7a9fe22691c811ea339d9b73150e6911a5343dca"
                    },
                    "owner": {
                        "user": {
                            "username": "REVOLT"
                        },
                        "profile_img_url": "https://storage.googleapis.com/opensea-static/opensea-profile/25.png",
                        "address": "0xb6d820e80a2a7c49f94c9d6c8ea08dccedc9ce4c",
                        "config": "",
                        "discord_id": ""
                    },
                    "permalink": "https://opensea.io/assets/0x50f5474724e0ee42d9a4e711ccfb275809fd6d4a/15356",
                    "collection": {
                        "banner_image_url": "https://lh3.googleusercontent.com/4NQIRoGmzXeXQN4mjuhWuuDZSNW7_BqRXux5upd4Nn_A-bfsGxCnPF8qn98Y6MyHRDPGXIlgfZADcSOe6M2DyrDKXdbdaTgkZN5l=s2500",
                        "chat_url": null,
                        "created_date": "2019-12-04T10:58:29.069907",
                        "default_to_fiat": false,
                        "description": "The Sandbox is a community-driven platform where creators can monetize voxel assets and gaming experiences on the blockchain. The Sandbox metaverse comprises a map made up of 166,464 LANDS.  LAND owners can host contests and events, stake SAND to earn and customize assets, monetize assets and experiences, vote in the metaverse governance, play games that you or others create, and more! Trade the collection and keep your eyes peeled for future drops.",
                        "dev_buyer_fee_basis_points": "0",
                        "dev_seller_fee_basis_points": "500",
                        "discord_url": "https://discord.gg/vAe4zvY",
                        "display_data": {
                            "card_display_style": "contain"
                        },
                        "external_url": "https://www.sandbox.game/",
                        "featured": false,
                        "featured_image_url": "https://storage.googleapis.com/opensea-static/featured-images/sandbox-featured.png",
                        "hidden": false,
                        "safelist_request_status": "verified",
                        "image_url": "https://lh3.googleusercontent.com/SXH8tW1siikB80rwCRnjm1a5xM_MwTg9Xl9Db6mioIk9HIlDM09pVoSR7GKJgS6ulSUpgW9BDtMk_ePX_NKgO9A=s60",
                        "is_subject_to_whitelist": false,
                        "large_image_url": "https://lh3.googleusercontent.com/SXH8tW1siikB80rwCRnjm1a5xM_MwTg9Xl9Db6mioIk9HIlDM09pVoSR7GKJgS6ulSUpgW9BDtMk_ePX_NKgO9A",
                        "medium_username": "sandbox-game",
                        "name": "The Sandbox",
                        "only_proxied_transfers": false,
                        "opensea_buyer_fee_basis_points": "0",
                        "opensea_seller_fee_basis_points": "250",
                        "payout_address": "0x7a9fe22691c811ea339d9b73150e6911a5343dca",
                        "require_email": false,
                        "short_description": null,
                        "slug": "sandbox",
                        "telegram_url": "https://t.me/sandboxgame",
                        "twitter_username": "thesandboxgame",
                        "instagram_username": null,
                        "wiki_url": null
                    },
                    "decimals": null,
                    "token_metadata": null
                },
                {
                    "id": 15817513,
                    "token_id": "15355",
                    "num_sales": 0,
                    "background_color": null,
                    "image_url": "https://storage.opensea.io/files/3faa959fa75531ac7913a9c9f8361b58.png",
                    "image_preview_url": "https://lh3.googleusercontent.com/17vU_UNWeMOVi4XOAwo4nvAXpeg1dnKPBk8VnAhJcFHOFZ9UBBvSL5Spj0ytvyfII3rdp4gHMY0mMvbnSzjdOZ0=s250",
                    "image_thumbnail_url": "https://lh3.googleusercontent.com/17vU_UNWeMOVi4XOAwo4nvAXpeg1dnKPBk8VnAhJcFHOFZ9UBBvSL5Spj0ytvyfII3rdp4gHMY0mMvbnSzjdOZ0=s128",
                    "image_original_url": "https://storage.googleapis.com/opensea-static/custom-fetcher-images/sandbox/land/sandbox-land.png",
                    "animation_url": null,
                    "animation_original_url": null,
                    "name": "LAND (55, -167)",
                    "description": "A LAND is a digital piece of real estate in The Sandbox metaverse that players can buy to build experiences on top of. Once you own a LAND, you will be able to populate it with Games and Assets. Each LAND is a unique (non-fungible) token lying on the public Ethereum blockchain (ERC-721).",
                    "external_link": "https://www.sandbox.game/en/map/?x=55&y=-167",
                    "asset_contract": {
                        "address": "0x50f5474724e0ee42d9a4e711ccfb275809fd6d4a",
                        "asset_contract_type": "non-fungible",
                        "created_date": "2019-12-04T10:58:28.892990",
                        "name": "Sandbox's LANDs",
                        "nft_version": "3.0",
                        "opensea_version": null,
                        "owner": null,
                        "schema_name": "ERC721",
                        "symbol": "",
                        "total_supply": null,
                        "description": "The Sandbox is a community-driven platform where creators can monetize voxel assets and gaming experiences on the blockchain. The Sandbox metaverse comprises a map made up of 166,464 LANDS.  LAND owners can host contests and events, stake SAND to earn and customize assets, monetize assets and experiences, vote in the metaverse governance, play games that you or others create, and more! Trade the collection and keep your eyes peeled for future drops.",
                        "external_link": "https://www.sandbox.game/",
                        "image_url": "https://lh3.googleusercontent.com/SXH8tW1siikB80rwCRnjm1a5xM_MwTg9Xl9Db6mioIk9HIlDM09pVoSR7GKJgS6ulSUpgW9BDtMk_ePX_NKgO9A=s60",
                        "default_to_fiat": false,
                        "dev_buyer_fee_basis_points": 0,
                        "dev_seller_fee_basis_points": 500,
                        "only_proxied_transfers": false,
                        "opensea_buyer_fee_basis_points": 0,
                        "opensea_seller_fee_basis_points": 250,
                        "buyer_fee_basis_points": 0,
                        "seller_fee_basis_points": 750,
                        "payout_address": "0x7a9fe22691c811ea339d9b73150e6911a5343dca"
                    },
                    "owner": {
                        "user": {
                            "username": "REVOLT"
                        },
                        "profile_img_url": "https://storage.googleapis.com/opensea-static/opensea-profile/25.png",
                        "address": "0xb6d820e80a2a7c49f94c9d6c8ea08dccedc9ce4c",
                        "config": "",
                        "discord_id": ""
                    },
                    "permalink": "https://opensea.io/assets/0x50f5474724e0ee42d9a4e711ccfb275809fd6d4a/15355",
                    "collection": {
                        "banner_image_url": "https://lh3.googleusercontent.com/4NQIRoGmzXeXQN4mjuhWuuDZSNW7_BqRXux5upd4Nn_A-bfsGxCnPF8qn98Y6MyHRDPGXIlgfZADcSOe6M2DyrDKXdbdaTgkZN5l=s2500",
                        "chat_url": null,
                        "created_date": "2019-12-04T10:58:29.069907",
                        "default_to_fiat": false,
                        "description": "The Sandbox is a community-driven platform where creators can monetize voxel assets and gaming experiences on the blockchain. The Sandbox metaverse comprises a map made up of 166,464 LANDS.  LAND owners can host contests and events, stake SAND to earn and customize assets, monetize assets and experiences, vote in the metaverse governance, play games that you or others create, and more! Trade the collection and keep your eyes peeled for future drops.",
                        "dev_buyer_fee_basis_points": "0",
                        "dev_seller_fee_basis_points": "500",
                        "discord_url": "https://discord.gg/vAe4zvY",
                        "display_data": {
                            "card_display_style": "contain"
                        },
                        "external_url": "https://www.sandbox.game/",
                        "featured": false,
                        "featured_image_url": "https://storage.googleapis.com/opensea-static/featured-images/sandbox-featured.png",
                        "hidden": false,
                        "safelist_request_status": "verified",
                        "image_url": "https://lh3.googleusercontent.com/SXH8tW1siikB80rwCRnjm1a5xM_MwTg9Xl9Db6mioIk9HIlDM09pVoSR7GKJgS6ulSUpgW9BDtMk_ePX_NKgO9A=s60",
                        "is_subject_to_whitelist": false,
                        "large_image_url": "https://lh3.googleusercontent.com/SXH8tW1siikB80rwCRnjm1a5xM_MwTg9Xl9Db6mioIk9HIlDM09pVoSR7GKJgS6ulSUpgW9BDtMk_ePX_NKgO9A",
                        "medium_username": "sandbox-game",
                        "name": "The Sandbox",
                        "only_proxied_transfers": false,
                        "opensea_buyer_fee_basis_points": "0",
                        "opensea_seller_fee_basis_points": "250",
                        "payout_address": "0x7a9fe22691c811ea339d9b73150e6911a5343dca",
                        "require_email": false,
                        "short_description": null,
                        "slug": "sandbox",
                        "telegram_url": "https://t.me/sandboxgame",
                        "twitter_username": "thesandboxgame",
                        "instagram_username": null,
                        "wiki_url": null
                    },
                    "decimals": null,
                    "token_metadata": null
                },
                {
                    "id": 15817517,
                    "token_id": "15354",
                    "num_sales": 0,
                    "background_color": null,
                    "image_url": "https://lh3.googleusercontent.com/17vU_UNWeMOVi4XOAwo4nvAXpeg1dnKPBk8VnAhJcFHOFZ9UBBvSL5Spj0ytvyfII3rdp4gHMY0mMvbnSzjdOZ0",
                    "image_preview_url": "https://lh3.googleusercontent.com/17vU_UNWeMOVi4XOAwo4nvAXpeg1dnKPBk8VnAhJcFHOFZ9UBBvSL5Spj0ytvyfII3rdp4gHMY0mMvbnSzjdOZ0=s250",
                    "image_thumbnail_url": "https://lh3.googleusercontent.com/17vU_UNWeMOVi4XOAwo4nvAXpeg1dnKPBk8VnAhJcFHOFZ9UBBvSL5Spj0ytvyfII3rdp4gHMY0mMvbnSzjdOZ0=s128",
                    "image_original_url": "https://storage.googleapis.com/opensea-static/custom-fetcher-images/sandbox/land/sandbox-land.png",
                    "animation_url": null,
                    "animation_original_url": null,
                    "name": "LAND (54, -167)",
                    "description": "A LAND is a digital piece of real estate in The Sandbox metaverse that players can buy to build experiences on top of. Once you own a LAND, you will be able to populate it with Games and Assets. Each LAND is a unique (non-fungible) token lying on the public Ethereum blockchain (ERC-721).",
                    "external_link": "https://www.sandbox.game/en/map/?x=54&y=-167",
                    "asset_contract": {
                        "address": "0x50f5474724e0ee42d9a4e711ccfb275809fd6d4a",
                        "asset_contract_type": "non-fungible",
                        "created_date": "2019-12-04T10:58:28.892990",
                        "name": "Sandbox's LANDs",
                        "nft_version": "3.0",
                        "opensea_version": null,
                        "owner": null,
                        "schema_name": "ERC721",
                        "symbol": "",
                        "total_supply": null,
                        "description": "The Sandbox is a community-driven platform where creators can monetize voxel assets and gaming experiences on the blockchain. The Sandbox metaverse comprises a map made up of 166,464 LANDS.  LAND owners can host contests and events, stake SAND to earn and customize assets, monetize assets and experiences, vote in the metaverse governance, play games that you or others create, and more! Trade the collection and keep your eyes peeled for future drops.",
                        "external_link": "https://www.sandbox.game/",
                        "image_url": "https://lh3.googleusercontent.com/SXH8tW1siikB80rwCRnjm1a5xM_MwTg9Xl9Db6mioIk9HIlDM09pVoSR7GKJgS6ulSUpgW9BDtMk_ePX_NKgO9A=s60",
                        "default_to_fiat": false,
                        "dev_buyer_fee_basis_points": 0,
                        "dev_seller_fee_basis_points": 500,
                        "only_proxied_transfers": false,
                        "opensea_buyer_fee_basis_points": 0,
                        "opensea_seller_fee_basis_points": 250,
                        "buyer_fee_basis_points": 0,
                        "seller_fee_basis_points": 750,
                        "payout_address": "0x7a9fe22691c811ea339d9b73150e6911a5343dca"
                    },
                    "owner": {
                        "user": {
                            "username": "REVOLT"
                        },
                        "profile_img_url": "https://storage.googleapis.com/opensea-static/opensea-profile/25.png",
                        "address": "0xb6d820e80a2a7c49f94c9d6c8ea08dccedc9ce4c",
                        "config": "",
                        "discord_id": ""
                    },
                    "permalink": "https://opensea.io/assets/0x50f5474724e0ee42d9a4e711ccfb275809fd6d4a/15354",
                    "collection": {
                        "banner_image_url": "https://lh3.googleusercontent.com/4NQIRoGmzXeXQN4mjuhWuuDZSNW7_BqRXux5upd4Nn_A-bfsGxCnPF8qn98Y6MyHRDPGXIlgfZADcSOe6M2DyrDKXdbdaTgkZN5l=s2500",
                        "chat_url": null,
                        "created_date": "2019-12-04T10:58:29.069907",
                        "default_to_fiat": false,
                        "description": "The Sandbox is a community-driven platform where creators can monetize voxel assets and gaming experiences on the blockchain. The Sandbox metaverse comprises a map made up of 166,464 LANDS.  LAND owners can host contests and events, stake SAND to earn and customize assets, monetize assets and experiences, vote in the metaverse governance, play games that you or others create, and more! Trade the collection and keep your eyes peeled for future drops.",
                        "dev_buyer_fee_basis_points": "0",
                        "dev_seller_fee_basis_points": "500",
                        "discord_url": "https://discord.gg/vAe4zvY",
                        "display_data": {
                            "card_display_style": "contain"
                        },
                        "external_url": "https://www.sandbox.game/",
                        "featured": false,
                        "featured_image_url": "https://storage.googleapis.com/opensea-static/featured-images/sandbox-featured.png",
                        "hidden": false,
                        "safelist_request_status": "verified",
                        "image_url": "https://lh3.googleusercontent.com/SXH8tW1siikB80rwCRnjm1a5xM_MwTg9Xl9Db6mioIk9HIlDM09pVoSR7GKJgS6ulSUpgW9BDtMk_ePX_NKgO9A=s60",
                        "is_subject_to_whitelist": false,
                        "large_image_url": "https://lh3.googleusercontent.com/SXH8tW1siikB80rwCRnjm1a5xM_MwTg9Xl9Db6mioIk9HIlDM09pVoSR7GKJgS6ulSUpgW9BDtMk_ePX_NKgO9A",
                        "medium_username": "sandbox-game",
                        "name": "The Sandbox",
                        "only_proxied_transfers": false,
                        "opensea_buyer_fee_basis_points": "0",
                        "opensea_seller_fee_basis_points": "250",
                        "payout_address": "0x7a9fe22691c811ea339d9b73150e6911a5343dca",
                        "require_email": false,
                        "short_description": null,
                        "slug": "sandbox",
                        "telegram_url": "https://t.me/sandboxgame",
                        "twitter_username": "thesandboxgame",
                        "instagram_username": null,
                        "wiki_url": null
                    },
                    "decimals": null,
                    "token_metadata": null
                },
                {
                    "id": 15817522,
                    "token_id": "15762",
                    "num_sales": 0,
                    "background_color": null,
                    "image_url": "https://lh3.googleusercontent.com/17vU_UNWeMOVi4XOAwo4nvAXpeg1dnKPBk8VnAhJcFHOFZ9UBBvSL5Spj0ytvyfII3rdp4gHMY0mMvbnSzjdOZ0",
                    "image_preview_url": "https://lh3.googleusercontent.com/17vU_UNWeMOVi4XOAwo4nvAXpeg1dnKPBk8VnAhJcFHOFZ9UBBvSL5Spj0ytvyfII3rdp4gHMY0mMvbnSzjdOZ0=s250",
                    "image_thumbnail_url": "https://lh3.googleusercontent.com/17vU_UNWeMOVi4XOAwo4nvAXpeg1dnKPBk8VnAhJcFHOFZ9UBBvSL5Spj0ytvyfII3rdp4gHMY0mMvbnSzjdOZ0=s128",
                    "image_original_url": "https://storage.googleapis.com/opensea-static/custom-fetcher-images/sandbox/land/sandbox-land.png",
                    "animation_url": null,
                    "animation_original_url": null,
                    "name": "LAND (54, -166)",
                    "description": "A LAND is a digital piece of real estate in The Sandbox metaverse that players can buy to build experiences on top of. Once you own a LAND, you will be able to populate it with Games and Assets. Each LAND is a unique (non-fungible) token lying on the public Ethereum blockchain (ERC-721).",
                    "external_link": "https://www.sandbox.game/en/map/?x=54&y=-166",
                    "asset_contract": {
                        "address": "0x50f5474724e0ee42d9a4e711ccfb275809fd6d4a",
                        "asset_contract_type": "non-fungible",
                        "created_date": "2019-12-04T10:58:28.892990",
                        "name": "Sandbox's LANDs",
                        "nft_version": "3.0",
                        "opensea_version": null,
                        "owner": null,
                        "schema_name": "ERC721",
                        "symbol": "",
                        "total_supply": null,
                        "description": "The Sandbox is a community-driven platform where creators can monetize voxel assets and gaming experiences on the blockchain. The Sandbox metaverse comprises a map made up of 166,464 LANDS.  LAND owners can host contests and events, stake SAND to earn and customize assets, monetize assets and experiences, vote in the metaverse governance, play games that you or others create, and more! Trade the collection and keep your eyes peeled for future drops.",
                        "external_link": "https://www.sandbox.game/",
                        "image_url": "https://lh3.googleusercontent.com/SXH8tW1siikB80rwCRnjm1a5xM_MwTg9Xl9Db6mioIk9HIlDM09pVoSR7GKJgS6ulSUpgW9BDtMk_ePX_NKgO9A=s60",
                        "default_to_fiat": false,
                        "dev_buyer_fee_basis_points": 0,
                        "dev_seller_fee_basis_points": 500,
                        "only_proxied_transfers": false,
                        "opensea_buyer_fee_basis_points": 0,
                        "opensea_seller_fee_basis_points": 250,
                        "buyer_fee_basis_points": 0,
                        "seller_fee_basis_points": 750,
                        "payout_address": "0x7a9fe22691c811ea339d9b73150e6911a5343dca"
                    },
                    "owner": {
                        "user": {
                            "username": "REVOLT"
                        },
                        "profile_img_url": "https://storage.googleapis.com/opensea-static/opensea-profile/25.png",
                        "address": "0xb6d820e80a2a7c49f94c9d6c8ea08dccedc9ce4c",
                        "config": "",
                        "discord_id": ""
                    },
                    "permalink": "https://opensea.io/assets/0x50f5474724e0ee42d9a4e711ccfb275809fd6d4a/15762",
                    "collection": {
                        "banner_image_url": "https://lh3.googleusercontent.com/4NQIRoGmzXeXQN4mjuhWuuDZSNW7_BqRXux5upd4Nn_A-bfsGxCnPF8qn98Y6MyHRDPGXIlgfZADcSOe6M2DyrDKXdbdaTgkZN5l=s2500",
                        "chat_url": null,
                        "created_date": "2019-12-04T10:58:29.069907",
                        "default_to_fiat": false,
                        "description": "The Sandbox is a community-driven platform where creators can monetize voxel assets and gaming experiences on the blockchain. The Sandbox metaverse comprises a map made up of 166,464 LANDS.  LAND owners can host contests and events, stake SAND to earn and customize assets, monetize assets and experiences, vote in the metaverse governance, play games that you or others create, and more! Trade the collection and keep your eyes peeled for future drops.",
                        "dev_buyer_fee_basis_points": "0",
                        "dev_seller_fee_basis_points": "500",
                        "discord_url": "https://discord.gg/vAe4zvY",
                        "display_data": {
                            "card_display_style": "contain"
                        },
                        "external_url": "https://www.sandbox.game/",
                        "featured": false,
                        "featured_image_url": "https://storage.googleapis.com/opensea-static/featured-images/sandbox-featured.png",
                        "hidden": false,
                        "safelist_request_status": "verified",
                        "image_url": "https://lh3.googleusercontent.com/SXH8tW1siikB80rwCRnjm1a5xM_MwTg9Xl9Db6mioIk9HIlDM09pVoSR7GKJgS6ulSUpgW9BDtMk_ePX_NKgO9A=s60",
                        "is_subject_to_whitelist": false,
                        "large_image_url": "https://lh3.googleusercontent.com/SXH8tW1siikB80rwCRnjm1a5xM_MwTg9Xl9Db6mioIk9HIlDM09pVoSR7GKJgS6ulSUpgW9BDtMk_ePX_NKgO9A",
                        "medium_username": "sandbox-game",
                        "name": "The Sandbox",
                        "only_proxied_transfers": false,
                        "opensea_buyer_fee_basis_points": "0",
                        "opensea_seller_fee_basis_points": "250",
                        "payout_address": "0x7a9fe22691c811ea339d9b73150e6911a5343dca",
                        "require_email": false,
                        "short_description": null,
                        "slug": "sandbox",
                        "telegram_url": "https://t.me/sandboxgame",
                        "twitter_username": "thesandboxgame",
                        "instagram_username": null,
                        "wiki_url": null
                    },
                    "decimals": null,
                    "token_metadata": null
                },
                {
                    "id": 15817531,
                    "token_id": "15763",
                    "num_sales": 0,
                    "background_color": null,
                    "image_url": "https://storage.opensea.io/files/3faa959fa75531ac7913a9c9f8361b58.png",
                    "image_preview_url": "https://lh3.googleusercontent.com/17vU_UNWeMOVi4XOAwo4nvAXpeg1dnKPBk8VnAhJcFHOFZ9UBBvSL5Spj0ytvyfII3rdp4gHMY0mMvbnSzjdOZ0=s250",
                    "image_thumbnail_url": "https://lh3.googleusercontent.com/17vU_UNWeMOVi4XOAwo4nvAXpeg1dnKPBk8VnAhJcFHOFZ9UBBvSL5Spj0ytvyfII3rdp4gHMY0mMvbnSzjdOZ0=s128",
                    "image_original_url": "https://storage.googleapis.com/opensea-static/custom-fetcher-images/sandbox/land/sandbox-land.png",
                    "animation_url": null,
                    "animation_original_url": null,
                    "name": "LAND (55, -166)",
                    "description": "A LAND is a digital piece of real estate in The Sandbox metaverse that players can buy to build experiences on top of. Once you own a LAND, you will be able to populate it with Games and Assets. Each LAND is a unique (non-fungible) token lying on the public Ethereum blockchain (ERC-721).",
                    "external_link": "https://www.sandbox.game/en/map/?x=55&y=-166",
                    "asset_contract": {
                        "address": "0x50f5474724e0ee42d9a4e711ccfb275809fd6d4a",
                        "asset_contract_type": "non-fungible",
                        "created_date": "2019-12-04T10:58:28.892990",
                        "name": "Sandbox's LANDs",
                        "nft_version": "3.0",
                        "opensea_version": null,
                        "owner": null,
                        "schema_name": "ERC721",
                        "symbol": "",
                        "total_supply": null,
                        "description": "The Sandbox is a community-driven platform where creators can monetize voxel assets and gaming experiences on the blockchain. The Sandbox metaverse comprises a map made up of 166,464 LANDS.  LAND owners can host contests and events, stake SAND to earn and customize assets, monetize assets and experiences, vote in the metaverse governance, play games that you or others create, and more! Trade the collection and keep your eyes peeled for future drops.",
                        "external_link": "https://www.sandbox.game/",
                        "image_url": "https://lh3.googleusercontent.com/SXH8tW1siikB80rwCRnjm1a5xM_MwTg9Xl9Db6mioIk9HIlDM09pVoSR7GKJgS6ulSUpgW9BDtMk_ePX_NKgO9A=s60",
                        "default_to_fiat": false,
                        "dev_buyer_fee_basis_points": 0,
                        "dev_seller_fee_basis_points": 500,
                        "only_proxied_transfers": false,
                        "opensea_buyer_fee_basis_points": 0,
                        "opensea_seller_fee_basis_points": 250,
                        "buyer_fee_basis_points": 0,
                        "seller_fee_basis_points": 750,
                        "payout_address": "0x7a9fe22691c811ea339d9b73150e6911a5343dca"
                    },
                    "owner": {
                        "user": {
                            "username": "REVOLT"
                        },
                        "profile_img_url": "https://storage.googleapis.com/opensea-static/opensea-profile/25.png",
                        "address": "0xb6d820e80a2a7c49f94c9d6c8ea08dccedc9ce4c",
                        "config": "",
                        "discord_id": ""
                    },
                    "permalink": "https://opensea.io/assets/0x50f5474724e0ee42d9a4e711ccfb275809fd6d4a/15763",
                    "collection": {
                        "banner_image_url": "https://lh3.googleusercontent.com/4NQIRoGmzXeXQN4mjuhWuuDZSNW7_BqRXux5upd4Nn_A-bfsGxCnPF8qn98Y6MyHRDPGXIlgfZADcSOe6M2DyrDKXdbdaTgkZN5l=s2500",
                        "chat_url": null,
                        "created_date": "2019-12-04T10:58:29.069907",
                        "default_to_fiat": false,
                        "description": "The Sandbox is a community-driven platform where creators can monetize voxel assets and gaming experiences on the blockchain. The Sandbox metaverse comprises a map made up of 166,464 LANDS.  LAND owners can host contests and events, stake SAND to earn and customize assets, monetize assets and experiences, vote in the metaverse governance, play games that you or others create, and more! Trade the collection and keep your eyes peeled for future drops.",
                        "dev_buyer_fee_basis_points": "0",
                        "dev_seller_fee_basis_points": "500",
                        "discord_url": "https://discord.gg/vAe4zvY",
                        "display_data": {
                            "card_display_style": "contain"
                        },
                        "external_url": "https://www.sandbox.game/",
                        "featured": false,
                        "featured_image_url": "https://storage.googleapis.com/opensea-static/featured-images/sandbox-featured.png",
                        "hidden": false,
                        "safelist_request_status": "verified",
                        "image_url": "https://lh3.googleusercontent.com/SXH8tW1siikB80rwCRnjm1a5xM_MwTg9Xl9Db6mioIk9HIlDM09pVoSR7GKJgS6ulSUpgW9BDtMk_ePX_NKgO9A=s60",
                        "is_subject_to_whitelist": false,
                        "large_image_url": "https://lh3.googleusercontent.com/SXH8tW1siikB80rwCRnjm1a5xM_MwTg9Xl9Db6mioIk9HIlDM09pVoSR7GKJgS6ulSUpgW9BDtMk_ePX_NKgO9A",
                        "medium_username": "sandbox-game",
                        "name": "The Sandbox",
                        "only_proxied_transfers": false,
                        "opensea_buyer_fee_basis_points": "0",
                        "opensea_seller_fee_basis_points": "250",
                        "payout_address": "0x7a9fe22691c811ea339d9b73150e6911a5343dca",
                        "require_email": false,
                        "short_description": null,
                        "slug": "sandbox",
                        "telegram_url": "https://t.me/sandboxgame",
                        "twitter_username": "thesandboxgame",
                        "instagram_username": null,
                        "wiki_url": null
                    },
                    "decimals": null,
                    "token_metadata": null
                },
                {
                    "id": 15817535,
                    "token_id": "15764",
                    "num_sales": 0,
                    "background_color": null,
                    "image_url": "https://lh3.googleusercontent.com/17vU_UNWeMOVi4XOAwo4nvAXpeg1dnKPBk8VnAhJcFHOFZ9UBBvSL5Spj0ytvyfII3rdp4gHMY0mMvbnSzjdOZ0",
                    "image_preview_url": "https://lh3.googleusercontent.com/17vU_UNWeMOVi4XOAwo4nvAXpeg1dnKPBk8VnAhJcFHOFZ9UBBvSL5Spj0ytvyfII3rdp4gHMY0mMvbnSzjdOZ0=s250",
                    "image_thumbnail_url": "https://lh3.googleusercontent.com/17vU_UNWeMOVi4XOAwo4nvAXpeg1dnKPBk8VnAhJcFHOFZ9UBBvSL5Spj0ytvyfII3rdp4gHMY0mMvbnSzjdOZ0=s128",
                    "image_original_url": "https://storage.googleapis.com/opensea-static/custom-fetcher-images/sandbox/land/sandbox-land.png",
                    "animation_url": null,
                    "animation_original_url": null,
                    "name": "LAND (56, -166)",
                    "description": "A LAND is a digital piece of real estate in The Sandbox metaverse that players can buy to build experiences on top of. Once you own a LAND, you will be able to populate it with Games and Assets. Each LAND is a unique (non-fungible) token lying on the public Ethereum blockchain (ERC-721).",
                    "external_link": "https://www.sandbox.game/en/map/?x=56&y=-166",
                    "asset_contract": {
                        "address": "0x50f5474724e0ee42d9a4e711ccfb275809fd6d4a",
                        "asset_contract_type": "non-fungible",
                        "created_date": "2019-12-04T10:58:28.892990",
                        "name": "Sandbox's LANDs",
                        "nft_version": "3.0",
                        "opensea_version": null,
                        "owner": null,
                        "schema_name": "ERC721",
                        "symbol": "",
                        "total_supply": null,
                        "description": "The Sandbox is a community-driven platform where creators can monetize voxel assets and gaming experiences on the blockchain. The Sandbox metaverse comprises a map made up of 166,464 LANDS.  LAND owners can host contests and events, stake SAND to earn and customize assets, monetize assets and experiences, vote in the metaverse governance, play games that you or others create, and more! Trade the collection and keep your eyes peeled for future drops.",
                        "external_link": "https://www.sandbox.game/",
                        "image_url": "https://lh3.googleusercontent.com/SXH8tW1siikB80rwCRnjm1a5xM_MwTg9Xl9Db6mioIk9HIlDM09pVoSR7GKJgS6ulSUpgW9BDtMk_ePX_NKgO9A=s60",
                        "default_to_fiat": false,
                        "dev_buyer_fee_basis_points": 0,
                        "dev_seller_fee_basis_points": 500,
                        "only_proxied_transfers": false,
                        "opensea_buyer_fee_basis_points": 0,
                        "opensea_seller_fee_basis_points": 250,
                        "buyer_fee_basis_points": 0,
                        "seller_fee_basis_points": 750,
                        "payout_address": "0x7a9fe22691c811ea339d9b73150e6911a5343dca"
                    },
                    "owner": {
                        "user": {
                            "username": "REVOLT"
                        },
                        "profile_img_url": "https://storage.googleapis.com/opensea-static/opensea-profile/25.png",
                        "address": "0xb6d820e80a2a7c49f94c9d6c8ea08dccedc9ce4c",
                        "config": "",
                        "discord_id": ""
                    },
                    "permalink": "https://opensea.io/assets/0x50f5474724e0ee42d9a4e711ccfb275809fd6d4a/15764",
                    "collection": {
                        "banner_image_url": "https://lh3.googleusercontent.com/4NQIRoGmzXeXQN4mjuhWuuDZSNW7_BqRXux5upd4Nn_A-bfsGxCnPF8qn98Y6MyHRDPGXIlgfZADcSOe6M2DyrDKXdbdaTgkZN5l=s2500",
                        "chat_url": null,
                        "created_date": "2019-12-04T10:58:29.069907",
                        "default_to_fiat": false,
                        "description": "The Sandbox is a community-driven platform where creators can monetize voxel assets and gaming experiences on the blockchain. The Sandbox metaverse comprises a map made up of 166,464 LANDS.  LAND owners can host contests and events, stake SAND to earn and customize assets, monetize assets and experiences, vote in the metaverse governance, play games that you or others create, and more! Trade the collection and keep your eyes peeled for future drops.",
                        "dev_buyer_fee_basis_points": "0",
                        "dev_seller_fee_basis_points": "500",
                        "discord_url": "https://discord.gg/vAe4zvY",
                        "display_data": {
                            "card_display_style": "contain"
                        },
                        "external_url": "https://www.sandbox.game/",
                        "featured": false,
                        "featured_image_url": "https://storage.googleapis.com/opensea-static/featured-images/sandbox-featured.png",
                        "hidden": false,
                        "safelist_request_status": "verified",
                        "image_url": "https://lh3.googleusercontent.com/SXH8tW1siikB80rwCRnjm1a5xM_MwTg9Xl9Db6mioIk9HIlDM09pVoSR7GKJgS6ulSUpgW9BDtMk_ePX_NKgO9A=s60",
                        "is_subject_to_whitelist": false,
                        "large_image_url": "https://lh3.googleusercontent.com/SXH8tW1siikB80rwCRnjm1a5xM_MwTg9Xl9Db6mioIk9HIlDM09pVoSR7GKJgS6ulSUpgW9BDtMk_ePX_NKgO9A",
                        "medium_username": "sandbox-game",
                        "name": "The Sandbox",
                        "only_proxied_transfers": false,
                        "opensea_buyer_fee_basis_points": "0",
                        "opensea_seller_fee_basis_points": "250",
                        "payout_address": "0x7a9fe22691c811ea339d9b73150e6911a5343dca",
                        "require_email": false,
                        "short_description": null,
                        "slug": "sandbox",
                        "telegram_url": "https://t.me/sandboxgame",
                        "twitter_username": "thesandboxgame",
                        "instagram_username": null,
                        "wiki_url": null
                    },
                    "decimals": null,
                    "token_metadata": null
                }
            ],
            "name": "Small estate (9 lands)",
            "description": "Yes, you can afford it :o))",
            "external_link": "",
            "asset_contract": {
                "collection": {
                    "banner_image_url": "https://lh3.googleusercontent.com/4NQIRoGmzXeXQN4mjuhWuuDZSNW7_BqRXux5upd4Nn_A-bfsGxCnPF8qn98Y6MyHRDPGXIlgfZADcSOe6M2DyrDKXdbdaTgkZN5l=s2500",
                    "chat_url": null,
                    "created_date": "2019-12-04T10:58:29.069907",
                    "default_to_fiat": false,
                    "description": "The Sandbox is a community-driven platform where creators can monetize voxel assets and gaming experiences on the blockchain. The Sandbox metaverse comprises a map made up of 166,464 LANDS.  LAND owners can host contests and events, stake SAND to earn and customize assets, monetize assets and experiences, vote in the metaverse governance, play games that you or others create, and more! Trade the collection and keep your eyes peeled for future drops.",
                    "dev_buyer_fee_basis_points": "0",
                    "dev_seller_fee_basis_points": "500",
                    "discord_url": "https://discord.gg/vAe4zvY",
                    "display_data": {
                        "card_display_style": "contain"
                    },
                    "external_url": "https://www.sandbox.game/",
                    "featured": false,
                    "featured_image_url": "https://storage.googleapis.com/opensea-static/featured-images/sandbox-featured.png",
                    "hidden": false,
                    "safelist_request_status": "verified",
                    "image_url": "https://lh3.googleusercontent.com/SXH8tW1siikB80rwCRnjm1a5xM_MwTg9Xl9Db6mioIk9HIlDM09pVoSR7GKJgS6ulSUpgW9BDtMk_ePX_NKgO9A=s60",
                    "is_subject_to_whitelist": false,
                    "large_image_url": "https://lh3.googleusercontent.com/SXH8tW1siikB80rwCRnjm1a5xM_MwTg9Xl9Db6mioIk9HIlDM09pVoSR7GKJgS6ulSUpgW9BDtMk_ePX_NKgO9A",
                    "medium_username": "sandbox-game",
                    "name": "The Sandbox",
                    "only_proxied_transfers": false,
                    "opensea_buyer_fee_basis_points": "0",
                    "opensea_seller_fee_basis_points": "250",
                    "payout_address": "0x7a9fe22691c811ea339d9b73150e6911a5343dca",
                    "require_email": false,
                    "short_description": null,
                    "slug": "sandbox",
                    "telegram_url": "https://t.me/sandboxgame",
                    "twitter_username": "thesandboxgame",
                    "instagram_username": null,
                    "wiki_url": null
                },
                "address": "0x50f5474724e0ee42d9a4e711ccfb275809fd6d4a",
                "asset_contract_type": "non-fungible",
                "created_date": "2019-12-04T10:58:28.892990",
                "name": "Sandbox's LANDs",
                "nft_version": "3.0",
                "opensea_version": null,
                "owner": null,
                "schema_name": "ERC721",
                "symbol": "",
                "total_supply": null,
                "description": "The Sandbox is a community-driven platform where creators can monetize voxel assets and gaming experiences on the blockchain. The Sandbox metaverse comprises a map made up of 166,464 LANDS.  LAND owners can host contests and events, stake SAND to earn and customize assets, monetize assets and experiences, vote in the metaverse governance, play games that you or others create, and more! Trade the collection and keep your eyes peeled for future drops.",
                "external_link": "https://www.sandbox.game/",
                "image_url": "https://lh3.googleusercontent.com/SXH8tW1siikB80rwCRnjm1a5xM_MwTg9Xl9Db6mioIk9HIlDM09pVoSR7GKJgS6ulSUpgW9BDtMk_ePX_NKgO9A=s60",
                "default_to_fiat": false,
                "dev_buyer_fee_basis_points": 0,
                "dev_seller_fee_basis_points": 500,
                "only_proxied_transfers": false,
                "opensea_buyer_fee_basis_points": 0,
                "opensea_seller_fee_basis_points": 250,
                "buyer_fee_basis_points": 0,
                "seller_fee_basis_points": 750,
                "payout_address": "0x7a9fe22691c811ea339d9b73150e6911a5343dca"
            },
            "permalink": "https://opensea.io/bundles/small-estate-9-lands-yVr",
            "sell_orders": [
                {
                    "created_date": "2021-05-25T21:38:57.580582",
                    "closing_date": null,
                    "closing_extendable": false,
                    "expiration_time": 0,
                    "listing_time": 1621978631,
                    "order_hash": "0x0beba9311e78470532fa4d90179b48e116e844227d4ff9c582cfb8bf362fabcd",
                    "metadata": {
                        "bundle": {
                            "assets": [
                                {
                                    "id": "14946",
                                    "address": "0x50f5474724e0ee42d9a4e711ccfb275809fd6d4a"
                                },
                                {
                                    "id": "14947",
                                    "address": "0x50f5474724e0ee42d9a4e711ccfb275809fd6d4a"
                                },
                                {
                                    "id": "14948",
                                    "address": "0x50f5474724e0ee42d9a4e711ccfb275809fd6d4a"
                                },
                                {
                                    "id": "15354",
                                    "address": "0x50f5474724e0ee42d9a4e711ccfb275809fd6d4a"
                                },
                                {
                                    "id": "15355",
                                    "address": "0x50f5474724e0ee42d9a4e711ccfb275809fd6d4a"
                                },
                                {
                                    "id": "15356",
                                    "address": "0x50f5474724e0ee42d9a4e711ccfb275809fd6d4a"
                                },
                                {
                                    "id": "15762",
                                    "address": "0x50f5474724e0ee42d9a4e711ccfb275809fd6d4a"
                                },
                                {
                                    "id": "15763",
                                    "address": "0x50f5474724e0ee42d9a4e711ccfb275809fd6d4a"
                                },
                                {
                                    "id": "15764",
                                    "address": "0x50f5474724e0ee42d9a4e711ccfb275809fd6d4a"
                                }
                            ],
                            "schemas": [
                                "ERC721",
                                "ERC721",
                                "ERC721",
                                "ERC721",
                                "ERC721",
                                "ERC721",
                                "ERC721",
                                "ERC721",
                                "ERC721"
                            ],
                            "name": "Small estate (9 lands)",
                            "description": "Yes, you can afford it :o))",
                            "external_link": ""
                        }
                    },
                    "exchange": "0x7be8076f4ea4a4ad08075c2508e481d6c946d12b",
                    "maker": {
                        "user": 3797,
                        "profile_img_url": "https://storage.googleapis.com/opensea-static/opensea-profile/25.png",
                        "address": "0xb6d820e80a2a7c49f94c9d6c8ea08dccedc9ce4c",
                        "config": "",
                        "discord_id": ""
                    },
                    "taker": {
                        "user": 1766,
                        "profile_img_url": "https://storage.googleapis.com/opensea-static/opensea-profile/1.png",
                        "address": "0x0000000000000000000000000000000000000000",
                        "config": "",
                        "discord_id": ""
                    },
                    "current_price": "135000000000000000000",
                    "current_bounty": "1350000000000000000",
                    "bounty_multiple": "0.01",
                    "maker_relayer_fee": "750",
                    "taker_relayer_fee": "0",
                    "maker_protocol_fee": "0",
                    "taker_protocol_fee": "0",
                    "maker_referrer_fee": "0",
                    "fee_recipient": {
                        "user": 3585,
                        "profile_img_url": "https://storage.googleapis.com/opensea-static/opensea-profile/28.png",
                        "address": "0x5b3256965e7c3cf26e11fcaf296dfc8807c01073",
                        "config": "verified",
                        "discord_id": ""
                    },
                    "fee_method": 1,
                    "side": 1,
                    "sale_kind": 0,
                    "target": "0xc99f70bfd82fb7c8f8191fdfbfb735606b15e5c5",
                    "how_to_call": 1,
                    "calldata": "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",
                    "replacement_pattern": "0x0000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000ffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffff0000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000ffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffff0000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000ffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffff0000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000ffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffff0000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000ffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffff0000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000ffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffff0000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000ffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffff0000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000ffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffff0000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000ffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffff000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000",
                    "static_target": "0x0000000000000000000000000000000000000000",
                    "static_extradata": "0x",
                    "payment_token": "0x0000000000000000000000000000000000000000",
                    "payment_token_contract": {
                        "id": 1,
                        "symbol": "ETH",
                        "address": "0x0000000000000000000000000000000000000000",
                        "image_url": "https://storage.opensea.io/files/6f8e2979d428180222796ff4a33ab929.svg",
                        "name": "Ether",
                        "decimals": 18,
                        "eth_price": "1.000000000000000",
                        "usd_price": "2625.730000000000018000"
                    },
                    "base_price": "135000000000000000000",
                    "extra": "0",
                    "quantity": "1",
                    "salt": "38159690333430169114788008781819753571752299821315776150902229114250040041596",
                    "v": 27,
                    "r": "0x9bf3844527bfcc4d75ebfd3a69e993f182b9746878d4a2bef450daf1ed2a99b5",
                    "s": "0x0c4358e64c4f66a15ddc4eafb2814dc17944e964f609745598832ffe8ffc8b94",
                    "approved_on_chain": false,
                    "cancelled": false,
                    "finalized": false,
                    "marked_invalid": false,
                    "prefixed_hash": "0xf671692872951ab607ad3b1858ebb259a0de112ca1be1c4d6f3ee2414991dfde"
                }
            ]
        },
        {
            "maker": {
                "user": {
                    "username": "Framboos"
                },
                "profile_img_url": "https://storage.googleapis.com/opensea-static/opensea-profile/12.png",
                "address": "0xc0b7baddb0631b81f305ed41ebbc8518706b0005",
                "config": "",
                "discord_id": ""
            },
            "slug": "west-coast-CN3",
            "assets": [
                {
                    "id": 22552978,
                    "token_id": "1312",
                    "num_sales": 0,
                    "background_color": null,
                    "image_url": "https://lh3.googleusercontent.com/02teghep23h6m4pcehMgI_3Ax4PX3Wh7q-IU28KpObR_axEOGqz_d7--6iAputprqitCOK_nG_1zSbbDzYpE7lUM0cu5xzNmIB5E",
                    "image_preview_url": "https://lh3.googleusercontent.com/02teghep23h6m4pcehMgI_3Ax4PX3Wh7q-IU28KpObR_axEOGqz_d7--6iAputprqitCOK_nG_1zSbbDzYpE7lUM0cu5xzNmIB5E=s250",
                    "image_thumbnail_url": "https://lh3.googleusercontent.com/02teghep23h6m4pcehMgI_3Ax4PX3Wh7q-IU28KpObR_axEOGqz_d7--6iAputprqitCOK_nG_1zSbbDzYpE7lUM0cu5xzNmIB5E=s128",
                    "image_original_url": "https://voxies-data-final.s3.us-east-2.amazonaws.com/1312.gif",
                    "animation_url": "https://storage.opensea.io/files/ca42b4f1d000f44c5ad641a52686e799.mp4",
                    "animation_original_url": "https://voxies-data-final.s3.us-east-2.amazonaws.com/1312.mp4",
                    "name": "Voxie #1312",
                    "description": "Voxies are cute, lovable and collectible voxel buddies, that live and play on the Ethereum blockchain. There are only 10,000 Voxies in existence and no two Voxies are identical. Lots of random properties and fun traits make each Voxie cute, unique and sometimes rare!",
                    "external_link": "https://voxies.io",
                    "asset_contract": {
                        "address": "0xe3435edbf54b5126e817363900234adfee5b3cee",
                        "asset_contract_type": "non-fungible",
                        "created_date": "2021-03-29T04:02:58.795005",
                        "name": "Voxies",
                        "nft_version": "3.0",
                        "opensea_version": null,
                        "owner": 27283107,
                        "schema_name": "ERC721",
                        "symbol": "VOXIES",
                        "total_supply": "0",
                        "description": "Voxies are cute, lovable and collectible 3d voxel buddies, that live and play on the Ethereum blockchain. There are only 10,000 Voxies in existence and no two Voxies are identical. Lots of random properties and fun traits make each Voxie cute, unique and sometimes rare!\n\nVoxies are not just a collectible but are also the first and only NFT to be fully integrated with a playable RPG turn-based tactical game. Bring your owned Voxies to life in Voxie Tactics as you collect, battle, and earn rewards in the Voxiverse. VOXEL tokens are awarded for ownership of Voxies and are used as the currency in Voxie Tactics and on the secondary Voxie marketplace.",
                        "external_link": "https://voxies.io",
                        "image_url": "https://lh3.googleusercontent.com/2wMNoHCnxCHOZEqeCeBj9CT9atRLOVt7Gl6Oh0Rw_TIDxx7tNes9Os4xWT7V_9iDOLMdmhUPG6MUySmbggCTEaYsdIWUO8RnsBMt0Q=s120",
                        "default_to_fiat": false,
                        "dev_buyer_fee_basis_points": 0,
                        "dev_seller_fee_basis_points": 1000,
                        "only_proxied_transfers": false,
                        "opensea_buyer_fee_basis_points": 0,
                        "opensea_seller_fee_basis_points": 250,
                        "buyer_fee_basis_points": 0,
                        "seller_fee_basis_points": 1250,
                        "payout_address": "0x5b21dab3f002a8236feb43224e3952dedda7b3b0"
                    },
                    "owner": {
                        "user": {
                            "username": "Framboos"
                        },
                        "profile_img_url": "https://storage.googleapis.com/opensea-static/opensea-profile/12.png",
                        "address": "0xc0b7baddb0631b81f305ed41ebbc8518706b0005",
                        "config": "",
                        "discord_id": ""
                    },
                    "permalink": "https://opensea.io/assets/0xe3435edbf54b5126e817363900234adfee5b3cee/1312",
                    "collection": {
                        "banner_image_url": "https://lh3.googleusercontent.com/iuMvEmVIC8arNZjIiX89dM2P3HvQHbmNMrKjd2Qqw82QD2JfE8rB_7NGrzvToHnK5MJqJdtR49km_aOfeh8XyeFOH19d3I13PrB79Qo=s2500",
                        "chat_url": null,
                        "created_date": "2021-03-29T04:08:28.050626",
                        "default_to_fiat": false,
                        "description": "Voxies are cute, lovable and collectible 3d voxel buddies, that live and play on the Ethereum blockchain. There are only 10,000 Voxies in existence and no two Voxies are identical. Lots of random properties and fun traits make each Voxie cute, unique and sometimes rare!\n\nVoxies are not just a collectible but are also the first and only NFT to be fully integrated with a playable RPG turn-based tactical game. Bring your owned Voxies to life in Voxie Tactics as you collect, battle, and earn rewards in the Voxiverse. VOXEL tokens are awarded for ownership of Voxies and are used as the currency in Voxie Tactics and on the secondary Voxie marketplace.",
                        "dev_buyer_fee_basis_points": "0",
                        "dev_seller_fee_basis_points": "1000",
                        "discord_url": "https://discord.gg/voxies",
                        "display_data": {
                            "card_display_style": "cover"
                        },
                        "external_url": "https://voxies.io",
                        "featured": false,
                        "featured_image_url": "https://lh3.googleusercontent.com/iuMvEmVIC8arNZjIiX89dM2P3HvQHbmNMrKjd2Qqw82QD2JfE8rB_7NGrzvToHnK5MJqJdtR49km_aOfeh8XyeFOH19d3I13PrB79Qo=s300",
                        "hidden": false,
                        "safelist_request_status": "approved",
                        "image_url": "https://lh3.googleusercontent.com/2wMNoHCnxCHOZEqeCeBj9CT9atRLOVt7Gl6Oh0Rw_TIDxx7tNes9Os4xWT7V_9iDOLMdmhUPG6MUySmbggCTEaYsdIWUO8RnsBMt0Q=s120",
                        "is_subject_to_whitelist": false,
                        "large_image_url": "https://lh3.googleusercontent.com/iuMvEmVIC8arNZjIiX89dM2P3HvQHbmNMrKjd2Qqw82QD2JfE8rB_7NGrzvToHnK5MJqJdtR49km_aOfeh8XyeFOH19d3I13PrB79Qo=s300",
                        "medium_username": "voxiesnft",
                        "name": "Voxies",
                        "only_proxied_transfers": false,
                        "opensea_buyer_fee_basis_points": "0",
                        "opensea_seller_fee_basis_points": "250",
                        "payout_address": "0x5b21dab3f002a8236feb43224e3952dedda7b3b0",
                        "require_email": false,
                        "short_description": null,
                        "slug": "voxies",
                        "telegram_url": null,
                        "twitter_username": "VoxiesNFT",
                        "instagram_username": null,
                        "wiki_url": null
                    },
                    "decimals": 0,
                    "token_metadata": "https://voxies-meta-final.s3.us-east-2.amazonaws.com/1312"
                },
                {
                    "id": 22775217,
                    "token_id": "71855948861368315935117884060099194885085341910626672500222055239698637389825",
                    "num_sales": 1,
                    "background_color": null,
                    "image_url": "https://lh3.googleusercontent.com/1KVS378dzNI8kS1u_ErrdqACWRUMbi5Lc7o_gYPGkIy4tYlNddpqU0LTpMGW4nDV-_D_SIKjMYf8xRupzxLQEkC_4UDJaVm_EB8iPQ",
                    "image_preview_url": "https://lh3.googleusercontent.com/1KVS378dzNI8kS1u_ErrdqACWRUMbi5Lc7o_gYPGkIy4tYlNddpqU0LTpMGW4nDV-_D_SIKjMYf8xRupzxLQEkC_4UDJaVm_EB8iPQ=s250",
                    "image_thumbnail_url": "https://lh3.googleusercontent.com/1KVS378dzNI8kS1u_ErrdqACWRUMbi5Lc7o_gYPGkIy4tYlNddpqU0LTpMGW4nDV-_D_SIKjMYf8xRupzxLQEkC_4UDJaVm_EB8iPQ=s128",
                    "image_original_url": null,
                    "animation_url": null,
                    "animation_original_url": null,
                    "name": "Mindvision 23 - Perfect Vibration",
                    "description": null,
                    "external_link": null,
                    "asset_contract": {
                        "address": "0x495f947276749ce646f68ac8c248420045cb7b5e",
                        "asset_contract_type": "semi-fungible",
                        "created_date": "2020-12-02T17:40:53.232025",
                        "name": "OpenSea Collection",
                        "nft_version": null,
                        "opensea_version": "2.0.0",
                        "owner": 102384,
                        "schema_name": "ERC1155",
                        "symbol": "OPENSTORE",
                        "total_supply": null,
                        "description": null,
                        "external_link": null,
                        "image_url": null,
                        "default_to_fiat": false,
                        "dev_buyer_fee_basis_points": 0,
                        "dev_seller_fee_basis_points": 0,
                        "only_proxied_transfers": false,
                        "opensea_buyer_fee_basis_points": 0,
                        "opensea_seller_fee_basis_points": 250,
                        "buyer_fee_basis_points": 0,
                        "seller_fee_basis_points": 250,
                        "payout_address": null
                    },
                    "owner": {
                        "user": {
                            "username": "NullAddress"
                        },
                        "profile_img_url": "https://storage.googleapis.com/opensea-static/opensea-profile/1.png",
                        "address": "0x0000000000000000000000000000000000000000",
                        "config": "",
                        "discord_id": ""
                    },
                    "permalink": "https://opensea.io/assets/0x495f947276749ce646f68ac8c248420045cb7b5e/71855948861368315935117884060099194885085341910626672500222055239698637389825",
                    "collection": {
                        "banner_image_url": "https://lh3.googleusercontent.com/HCJgi7tcGj4zzWjfzZlpirYhKrs8UqVj-Z14gLIJl_p5w7dLyMk6qxSOAv3hX-y3XcoN0te0DZwrr4UCQfPuUPYy_a0WPKtizQJcnQ=s2500",
                        "chat_url": null,
                        "created_date": "2021-04-15T13:11:07.390886",
                        "default_to_fiat": false,
                        "description": "Mindvisions is a collection of psychedelic gif. Every gif is unique. The chosen transformations are neither automatic nor generative. Each is manually created with care and choice for a specific view of the mind.\n\nOnly 100 psychedelic experiences \n\n- Enjoy your vision \n- Do not abuse drugs\n- Be safe",
                        "dev_buyer_fee_basis_points": "0",
                        "dev_seller_fee_basis_points": "1000",
                        "discord_url": null,
                        "display_data": {
                            "card_display_style": "contain"
                        },
                        "external_url": "https://mindvisions.carrd.co/",
                        "featured": false,
                        "featured_image_url": "https://lh3.googleusercontent.com/9c_qTzyjXIe6nfvIz6DQmwfCAuK0yv9h2O4PqpntzAR2t82iwTf0t8XQpo-ud0z1R0FSqEURGCxjIFSeVRBg_k0fKO1m_BbZCN7d8DA=s300",
                        "hidden": true,
                        "safelist_request_status": "not_requested",
                        "image_url": "https://lh3.googleusercontent.com/z63ZrtKG-ohYPZQ_Nwiy_6AWZ2iyB-lUgvUR4M_6wp-1tAj0rKItmuuCWCb79JhS037cInXCqKbeHt_edQzhUiwtelbhADp7WW6W=s120",
                        "is_subject_to_whitelist": false,
                        "large_image_url": "https://lh3.googleusercontent.com/9c_qTzyjXIe6nfvIz6DQmwfCAuK0yv9h2O4PqpntzAR2t82iwTf0t8XQpo-ud0z1R0FSqEURGCxjIFSeVRBg_k0fKO1m_BbZCN7d8DA=s300",
                        "medium_username": null,
                        "name": "Mindvisions",
                        "only_proxied_transfers": false,
                        "opensea_buyer_fee_basis_points": "0",
                        "opensea_seller_fee_basis_points": "250",
                        "payout_address": "0x9edd069accf979f744ce3fbbebf54507ead29a21",
                        "require_email": false,
                        "short_description": null,
                        "slug": "mindvisions",
                        "telegram_url": null,
                        "twitter_username": "https://twitter.com/kraotaxnft",
                        "instagram_username": null,
                        "wiki_url": null
                    },
                    "decimals": null,
                    "token_metadata": null
                }
            ],
            "name": "West Coast",
            "description": "",
            "external_link": "",
            "asset_contract": null,
            "permalink": "https://opensea.io/bundles/west-coast-CN3",
            "sell_orders": [
                {
                    "created_date": "2021-05-25T21:35:41.866879",
                    "closing_date": "2021-05-30T21:34:42",
                    "closing_extendable": false,
                    "expiration_time": 1622410482,
                    "listing_time": 1621978434,
                    "order_hash": "0x2a89eca413878e2082313521b940520d7723fb4e049eb304d6899138a10fe5a9",
                    "metadata": {
                        "bundle": {
                            "assets": [
                                {
                                    "id": "71855948861368315935117884060099194885085341910626672500222055239698637389825",
                                    "address": "0x495f947276749ce646f68ac8c248420045cb7b5e",
                                    "quantity": "1"
                                },
                                {
                                    "id": "1312",
                                    "address": "0xe3435edbf54b5126e817363900234adfee5b3cee"
                                }
                            ],
                            "schemas": [
                                "ERC1155",
                                "ERC721"
                            ],
                            "name": "West Coast",
                            "description": "",
                            "external_link": ""
                        }
                    },
                    "exchange": "0x7be8076f4ea4a4ad08075c2508e481d6c946d12b",
                    "maker": {
                        "user": 40123,
                        "profile_img_url": "https://storage.googleapis.com/opensea-static/opensea-profile/12.png",
                        "address": "0xc0b7baddb0631b81f305ed41ebbc8518706b0005",
                        "config": "",
                        "discord_id": ""
                    },
                    "taker": {
                        "user": 1766,
                        "profile_img_url": "https://storage.googleapis.com/opensea-static/opensea-profile/1.png",
                        "address": "0x0000000000000000000000000000000000000000",
                        "config": "",
                        "discord_id": ""
                    },
                    "current_price": "390000000000000000.0000000000",
                    "current_bounty": "3900000000000000",
                    "bounty_multiple": "0.01",
                    "maker_relayer_fee": "250",
                    "taker_relayer_fee": "0",
                    "maker_protocol_fee": "0",
                    "taker_protocol_fee": "0",
                    "maker_referrer_fee": "0",
                    "fee_recipient": {
                        "user": 3585,
                        "profile_img_url": "https://storage.googleapis.com/opensea-static/opensea-profile/28.png",
                        "address": "0x5b3256965e7c3cf26e11fcaf296dfc8807c01073",
                        "config": "verified",
                        "discord_id": ""
                    },
                    "fee_method": 1,
                    "side": 1,
                    "sale_kind": 0,
                    "target": "0xc99f70bfd82fb7c8f8191fdfbfb735606b15e5c5",
                    "how_to_call": 1,
                    "calldata": "0x68f0bcaa000000000000000000000000000000000000000000000000000000000000008000000000000000000000000000000000000000000000000000000000000000e0000000000000000000000000000000000000000000000000000000000000014000000000000000000000000000000000000000000000000000000000000001a00000000000000000000000000000000000000000000000000000000000000002000000000000000000000000495f947276749ce646f68ac8c248420045cb7b5e000000000000000000000000e3435edbf54b5126e817363900234adfee5b3cee000000000000000000000000000000000000000000000000000000000000000200000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000200000000000000000000000000000000000000000000000000000000000000c400000000000000000000000000000000000000000000000000000000000000640000000000000000000000000000000000000000000000000000000000000128f242432a000000000000000000000000c0b7baddb0631b81f305ed41ebbc8518706b000500000000000000000000000000000000000000000000000000000000000000009edd069accf979f744ce3fbbebf54507ead29a21000000000000170000000001000000000000000000000000000000000000000000000000000000000000000100000000000000000000000000000000000000000000000000000000000000a0000000000000000000000000000000000000000000000000000000000000000023b872dd000000000000000000000000c0b7baddb0631b81f305ed41ebbc8518706b000500000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000520000000000000000000000000000000000000000000000000",
                    "replacement_pattern": "0x0000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000ffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffff0000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000ffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffff0000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000",
                    "static_target": "0x0000000000000000000000000000000000000000",
                    "static_extradata": "0x",
                    "payment_token": "0x0000000000000000000000000000000000000000",
                    "payment_token_contract": {
                        "id": 1,
                        "symbol": "ETH",
                        "address": "0x0000000000000000000000000000000000000000",
                        "image_url": "https://storage.opensea.io/files/6f8e2979d428180222796ff4a33ab929.svg",
                        "name": "Ether",
                        "decimals": 18,
                        "eth_price": "1.000000000000000",
                        "usd_price": "2625.730000000000018000"
                    },
                    "base_price": "390000000000000000",
                    "extra": "0",
                    "quantity": "1",
                    "salt": "65862722496075715470977036338987273114503532206625284978095761717622401884227",
                    "v": 28,
                    "r": "0xc320b5ed038a36884b736d062b63c3e96c572a265a4b64d727ac985741e7033b",
                    "s": "0x6f36ef1f03ad767ccb7be3aaf1d1a6be0fd409b60b1b33f70bedf234b7f2615b",
                    "approved_on_chain": false,
                    "cancelled": false,
                    "finalized": false,
                    "marked_invalid": false,
                    "prefixed_hash": "0x116a645c761627d597ebc337bcfb861f46b5937a0d1b7fd0f8ecea0ee2d8ac09"
                }
            ]
        },
        {
            "maker": {
                "user": {
                    "username": "REVOLT"
                },
                "profile_img_url": "https://storage.googleapis.com/opensea-static/opensea-profile/25.png",
                "address": "0xb6d820e80a2a7c49f94c9d6c8ea08dccedc9ce4c",
                "config": "",
                "discord_id": ""
            },
            "slug": "small-estate-9-lands-fTf",
            "assets": [
                {
                    "id": 15810586,
                    "token_id": "77475",
                    "num_sales": 0,
                    "background_color": null,
                    "image_url": "https://lh3.googleusercontent.com/17vU_UNWeMOVi4XOAwo4nvAXpeg1dnKPBk8VnAhJcFHOFZ9UBBvSL5Spj0ytvyfII3rdp4gHMY0mMvbnSzjdOZ0",
                    "image_preview_url": "https://lh3.googleusercontent.com/17vU_UNWeMOVi4XOAwo4nvAXpeg1dnKPBk8VnAhJcFHOFZ9UBBvSL5Spj0ytvyfII3rdp4gHMY0mMvbnSzjdOZ0=s250",
                    "image_thumbnail_url": "https://lh3.googleusercontent.com/17vU_UNWeMOVi4XOAwo4nvAXpeg1dnKPBk8VnAhJcFHOFZ9UBBvSL5Spj0ytvyfII3rdp4gHMY0mMvbnSzjdOZ0=s128",
                    "image_original_url": "https://storage.googleapis.com/opensea-static/custom-fetcher-images/sandbox/land/sandbox-land.png",
                    "animation_url": null,
                    "animation_original_url": null,
                    "name": "LAND (159, -15)",
                    "description": "A LAND is a digital piece of real estate in The Sandbox metaverse that players can buy to build experiences on top of. Once you own a LAND, you will be able to populate it with Games and Assets. Each LAND is a unique (non-fungible) token lying on the public Ethereum blockchain (ERC-721).",
                    "external_link": "https://www.sandbox.game/en/map/?x=159&y=-15",
                    "asset_contract": {
                        "address": "0x50f5474724e0ee42d9a4e711ccfb275809fd6d4a",
                        "asset_contract_type": "non-fungible",
                        "created_date": "2019-12-04T10:58:28.892990",
                        "name": "Sandbox's LANDs",
                        "nft_version": "3.0",
                        "opensea_version": null,
                        "owner": null,
                        "schema_name": "ERC721",
                        "symbol": "",
                        "total_supply": null,
                        "description": "The Sandbox is a community-driven platform where creators can monetize voxel assets and gaming experiences on the blockchain. The Sandbox metaverse comprises a map made up of 166,464 LANDS.  LAND owners can host contests and events, stake SAND to earn and customize assets, monetize assets and experiences, vote in the metaverse governance, play games that you or others create, and more! Trade the collection and keep your eyes peeled for future drops.",
                        "external_link": "https://www.sandbox.game/",
                        "image_url": "https://lh3.googleusercontent.com/SXH8tW1siikB80rwCRnjm1a5xM_MwTg9Xl9Db6mioIk9HIlDM09pVoSR7GKJgS6ulSUpgW9BDtMk_ePX_NKgO9A=s60",
                        "default_to_fiat": false,
                        "dev_buyer_fee_basis_points": 0,
                        "dev_seller_fee_basis_points": 500,
                        "only_proxied_transfers": false,
                        "opensea_buyer_fee_basis_points": 0,
                        "opensea_seller_fee_basis_points": 250,
                        "buyer_fee_basis_points": 0,
                        "seller_fee_basis_points": 750,
                        "payout_address": "0x7a9fe22691c811ea339d9b73150e6911a5343dca"
                    },
                    "owner": {
                        "user": {
                            "username": "REVOLT"
                        },
                        "profile_img_url": "https://storage.googleapis.com/opensea-static/opensea-profile/25.png",
                        "address": "0xb6d820e80a2a7c49f94c9d6c8ea08dccedc9ce4c",
                        "config": "",
                        "discord_id": ""
                    },
                    "permalink": "https://opensea.io/assets/0x50f5474724e0ee42d9a4e711ccfb275809fd6d4a/77475",
                    "collection": {
                        "banner_image_url": "https://lh3.googleusercontent.com/4NQIRoGmzXeXQN4mjuhWuuDZSNW7_BqRXux5upd4Nn_A-bfsGxCnPF8qn98Y6MyHRDPGXIlgfZADcSOe6M2DyrDKXdbdaTgkZN5l=s2500",
                        "chat_url": null,
                        "created_date": "2019-12-04T10:58:29.069907",
                        "default_to_fiat": false,
                        "description": "The Sandbox is a community-driven platform where creators can monetize voxel assets and gaming experiences on the blockchain. The Sandbox metaverse comprises a map made up of 166,464 LANDS.  LAND owners can host contests and events, stake SAND to earn and customize assets, monetize assets and experiences, vote in the metaverse governance, play games that you or others create, and more! Trade the collection and keep your eyes peeled for future drops.",
                        "dev_buyer_fee_basis_points": "0",
                        "dev_seller_fee_basis_points": "500",
                        "discord_url": "https://discord.gg/vAe4zvY",
                        "display_data": {
                            "card_display_style": "contain"
                        },
                        "external_url": "https://www.sandbox.game/",
                        "featured": false,
                        "featured_image_url": "https://storage.googleapis.com/opensea-static/featured-images/sandbox-featured.png",
                        "hidden": false,
                        "safelist_request_status": "verified",
                        "image_url": "https://lh3.googleusercontent.com/SXH8tW1siikB80rwCRnjm1a5xM_MwTg9Xl9Db6mioIk9HIlDM09pVoSR7GKJgS6ulSUpgW9BDtMk_ePX_NKgO9A=s60",
                        "is_subject_to_whitelist": false,
                        "large_image_url": "https://lh3.googleusercontent.com/SXH8tW1siikB80rwCRnjm1a5xM_MwTg9Xl9Db6mioIk9HIlDM09pVoSR7GKJgS6ulSUpgW9BDtMk_ePX_NKgO9A",
                        "medium_username": "sandbox-game",
                        "name": "The Sandbox",
                        "only_proxied_transfers": false,
                        "opensea_buyer_fee_basis_points": "0",
                        "opensea_seller_fee_basis_points": "250",
                        "payout_address": "0x7a9fe22691c811ea339d9b73150e6911a5343dca",
                        "require_email": false,
                        "short_description": null,
                        "slug": "sandbox",
                        "telegram_url": "https://t.me/sandboxgame",
                        "twitter_username": "thesandboxgame",
                        "instagram_username": null,
                        "wiki_url": null
                    },
                    "decimals": null,
                    "token_metadata": null
                },
                {
                    "id": 15810616,
                    "token_id": "77476",
                    "num_sales": 0,
                    "background_color": null,
                    "image_url": "https://lh3.googleusercontent.com/17vU_UNWeMOVi4XOAwo4nvAXpeg1dnKPBk8VnAhJcFHOFZ9UBBvSL5Spj0ytvyfII3rdp4gHMY0mMvbnSzjdOZ0",
                    "image_preview_url": "https://lh3.googleusercontent.com/17vU_UNWeMOVi4XOAwo4nvAXpeg1dnKPBk8VnAhJcFHOFZ9UBBvSL5Spj0ytvyfII3rdp4gHMY0mMvbnSzjdOZ0=s250",
                    "image_thumbnail_url": "https://lh3.googleusercontent.com/17vU_UNWeMOVi4XOAwo4nvAXpeg1dnKPBk8VnAhJcFHOFZ9UBBvSL5Spj0ytvyfII3rdp4gHMY0mMvbnSzjdOZ0=s128",
                    "image_original_url": "https://storage.googleapis.com/opensea-static/custom-fetcher-images/sandbox/land/sandbox-land.png",
                    "animation_url": null,
                    "animation_original_url": null,
                    "name": "LAND (160, -15)",
                    "description": "A LAND is a digital piece of real estate in The Sandbox metaverse that players can buy to build experiences on top of. Once you own a LAND, you will be able to populate it with Games and Assets. Each LAND is a unique (non-fungible) token lying on the public Ethereum blockchain (ERC-721).",
                    "external_link": "https://www.sandbox.game/en/map/?x=160&y=-15",
                    "asset_contract": {
                        "address": "0x50f5474724e0ee42d9a4e711ccfb275809fd6d4a",
                        "asset_contract_type": "non-fungible",
                        "created_date": "2019-12-04T10:58:28.892990",
                        "name": "Sandbox's LANDs",
                        "nft_version": "3.0",
                        "opensea_version": null,
                        "owner": null,
                        "schema_name": "ERC721",
                        "symbol": "",
                        "total_supply": null,
                        "description": "The Sandbox is a community-driven platform where creators can monetize voxel assets and gaming experiences on the blockchain. The Sandbox metaverse comprises a map made up of 166,464 LANDS.  LAND owners can host contests and events, stake SAND to earn and customize assets, monetize assets and experiences, vote in the metaverse governance, play games that you or others create, and more! Trade the collection and keep your eyes peeled for future drops.",
                        "external_link": "https://www.sandbox.game/",
                        "image_url": "https://lh3.googleusercontent.com/SXH8tW1siikB80rwCRnjm1a5xM_MwTg9Xl9Db6mioIk9HIlDM09pVoSR7GKJgS6ulSUpgW9BDtMk_ePX_NKgO9A=s60",
                        "default_to_fiat": false,
                        "dev_buyer_fee_basis_points": 0,
                        "dev_seller_fee_basis_points": 500,
                        "only_proxied_transfers": false,
                        "opensea_buyer_fee_basis_points": 0,
                        "opensea_seller_fee_basis_points": 250,
                        "buyer_fee_basis_points": 0,
                        "seller_fee_basis_points": 750,
                        "payout_address": "0x7a9fe22691c811ea339d9b73150e6911a5343dca"
                    },
                    "owner": {
                        "user": {
                            "username": "REVOLT"
                        },
                        "profile_img_url": "https://storage.googleapis.com/opensea-static/opensea-profile/25.png",
                        "address": "0xb6d820e80a2a7c49f94c9d6c8ea08dccedc9ce4c",
                        "config": "",
                        "discord_id": ""
                    },
                    "permalink": "https://opensea.io/assets/0x50f5474724e0ee42d9a4e711ccfb275809fd6d4a/77476",
                    "collection": {
                        "banner_image_url": "https://lh3.googleusercontent.com/4NQIRoGmzXeXQN4mjuhWuuDZSNW7_BqRXux5upd4Nn_A-bfsGxCnPF8qn98Y6MyHRDPGXIlgfZADcSOe6M2DyrDKXdbdaTgkZN5l=s2500",
                        "chat_url": null,
                        "created_date": "2019-12-04T10:58:29.069907",
                        "default_to_fiat": false,
                        "description": "The Sandbox is a community-driven platform where creators can monetize voxel assets and gaming experiences on the blockchain. The Sandbox metaverse comprises a map made up of 166,464 LANDS.  LAND owners can host contests and events, stake SAND to earn and customize assets, monetize assets and experiences, vote in the metaverse governance, play games that you or others create, and more! Trade the collection and keep your eyes peeled for future drops.",
                        "dev_buyer_fee_basis_points": "0",
                        "dev_seller_fee_basis_points": "500",
                        "discord_url": "https://discord.gg/vAe4zvY",
                        "display_data": {
                            "card_display_style": "contain"
                        },
                        "external_url": "https://www.sandbox.game/",
                        "featured": false,
                        "featured_image_url": "https://storage.googleapis.com/opensea-static/featured-images/sandbox-featured.png",
                        "hidden": false,
                        "safelist_request_status": "verified",
                        "image_url": "https://lh3.googleusercontent.com/SXH8tW1siikB80rwCRnjm1a5xM_MwTg9Xl9Db6mioIk9HIlDM09pVoSR7GKJgS6ulSUpgW9BDtMk_ePX_NKgO9A=s60",
                        "is_subject_to_whitelist": false,
                        "large_image_url": "https://lh3.googleusercontent.com/SXH8tW1siikB80rwCRnjm1a5xM_MwTg9Xl9Db6mioIk9HIlDM09pVoSR7GKJgS6ulSUpgW9BDtMk_ePX_NKgO9A",
                        "medium_username": "sandbox-game",
                        "name": "The Sandbox",
                        "only_proxied_transfers": false,
                        "opensea_buyer_fee_basis_points": "0",
                        "opensea_seller_fee_basis_points": "250",
                        "payout_address": "0x7a9fe22691c811ea339d9b73150e6911a5343dca",
                        "require_email": false,
                        "short_description": null,
                        "slug": "sandbox",
                        "telegram_url": "https://t.me/sandboxgame",
                        "twitter_username": "thesandboxgame",
                        "instagram_username": null,
                        "wiki_url": null
                    },
                    "decimals": null,
                    "token_metadata": null
                },
                {
                    "id": 15810645,
                    "token_id": "77477",
                    "num_sales": 0,
                    "background_color": null,
                    "image_url": "https://lh3.googleusercontent.com/17vU_UNWeMOVi4XOAwo4nvAXpeg1dnKPBk8VnAhJcFHOFZ9UBBvSL5Spj0ytvyfII3rdp4gHMY0mMvbnSzjdOZ0",
                    "image_preview_url": "https://lh3.googleusercontent.com/17vU_UNWeMOVi4XOAwo4nvAXpeg1dnKPBk8VnAhJcFHOFZ9UBBvSL5Spj0ytvyfII3rdp4gHMY0mMvbnSzjdOZ0=s250",
                    "image_thumbnail_url": "https://lh3.googleusercontent.com/17vU_UNWeMOVi4XOAwo4nvAXpeg1dnKPBk8VnAhJcFHOFZ9UBBvSL5Spj0ytvyfII3rdp4gHMY0mMvbnSzjdOZ0=s128",
                    "image_original_url": "https://storage.googleapis.com/opensea-static/custom-fetcher-images/sandbox/land/sandbox-land.png",
                    "animation_url": null,
                    "animation_original_url": null,
                    "name": "LAND (161, -15)",
                    "description": "A LAND is a digital piece of real estate in The Sandbox metaverse that players can buy to build experiences on top of. Once you own a LAND, you will be able to populate it with Games and Assets. Each LAND is a unique (non-fungible) token lying on the public Ethereum blockchain (ERC-721).",
                    "external_link": "https://www.sandbox.game/en/map/?x=161&y=-15",
                    "asset_contract": {
                        "address": "0x50f5474724e0ee42d9a4e711ccfb275809fd6d4a",
                        "asset_contract_type": "non-fungible",
                        "created_date": "2019-12-04T10:58:28.892990",
                        "name": "Sandbox's LANDs",
                        "nft_version": "3.0",
                        "opensea_version": null,
                        "owner": null,
                        "schema_name": "ERC721",
                        "symbol": "",
                        "total_supply": null,
                        "description": "The Sandbox is a community-driven platform where creators can monetize voxel assets and gaming experiences on the blockchain. The Sandbox metaverse comprises a map made up of 166,464 LANDS.  LAND owners can host contests and events, stake SAND to earn and customize assets, monetize assets and experiences, vote in the metaverse governance, play games that you or others create, and more! Trade the collection and keep your eyes peeled for future drops.",
                        "external_link": "https://www.sandbox.game/",
                        "image_url": "https://lh3.googleusercontent.com/SXH8tW1siikB80rwCRnjm1a5xM_MwTg9Xl9Db6mioIk9HIlDM09pVoSR7GKJgS6ulSUpgW9BDtMk_ePX_NKgO9A=s60",
                        "default_to_fiat": false,
                        "dev_buyer_fee_basis_points": 0,
                        "dev_seller_fee_basis_points": 500,
                        "only_proxied_transfers": false,
                        "opensea_buyer_fee_basis_points": 0,
                        "opensea_seller_fee_basis_points": 250,
                        "buyer_fee_basis_points": 0,
                        "seller_fee_basis_points": 750,
                        "payout_address": "0x7a9fe22691c811ea339d9b73150e6911a5343dca"
                    },
                    "owner": {
                        "user": {
                            "username": "REVOLT"
                        },
                        "profile_img_url": "https://storage.googleapis.com/opensea-static/opensea-profile/25.png",
                        "address": "0xb6d820e80a2a7c49f94c9d6c8ea08dccedc9ce4c",
                        "config": "",
                        "discord_id": ""
                    },
                    "permalink": "https://opensea.io/assets/0x50f5474724e0ee42d9a4e711ccfb275809fd6d4a/77477",
                    "collection": {
                        "banner_image_url": "https://lh3.googleusercontent.com/4NQIRoGmzXeXQN4mjuhWuuDZSNW7_BqRXux5upd4Nn_A-bfsGxCnPF8qn98Y6MyHRDPGXIlgfZADcSOe6M2DyrDKXdbdaTgkZN5l=s2500",
                        "chat_url": null,
                        "created_date": "2019-12-04T10:58:29.069907",
                        "default_to_fiat": false,
                        "description": "The Sandbox is a community-driven platform where creators can monetize voxel assets and gaming experiences on the blockchain. The Sandbox metaverse comprises a map made up of 166,464 LANDS.  LAND owners can host contests and events, stake SAND to earn and customize assets, monetize assets and experiences, vote in the metaverse governance, play games that you or others create, and more! Trade the collection and keep your eyes peeled for future drops.",
                        "dev_buyer_fee_basis_points": "0",
                        "dev_seller_fee_basis_points": "500",
                        "discord_url": "https://discord.gg/vAe4zvY",
                        "display_data": {
                            "card_display_style": "contain"
                        },
                        "external_url": "https://www.sandbox.game/",
                        "featured": false,
                        "featured_image_url": "https://storage.googleapis.com/opensea-static/featured-images/sandbox-featured.png",
                        "hidden": false,
                        "safelist_request_status": "verified",
                        "image_url": "https://lh3.googleusercontent.com/SXH8tW1siikB80rwCRnjm1a5xM_MwTg9Xl9Db6mioIk9HIlDM09pVoSR7GKJgS6ulSUpgW9BDtMk_ePX_NKgO9A=s60",
                        "is_subject_to_whitelist": false,
                        "large_image_url": "https://lh3.googleusercontent.com/SXH8tW1siikB80rwCRnjm1a5xM_MwTg9Xl9Db6mioIk9HIlDM09pVoSR7GKJgS6ulSUpgW9BDtMk_ePX_NKgO9A",
                        "medium_username": "sandbox-game",
                        "name": "The Sandbox",
                        "only_proxied_transfers": false,
                        "opensea_buyer_fee_basis_points": "0",
                        "opensea_seller_fee_basis_points": "250",
                        "payout_address": "0x7a9fe22691c811ea339d9b73150e6911a5343dca",
                        "require_email": false,
                        "short_description": null,
                        "slug": "sandbox",
                        "telegram_url": "https://t.me/sandboxgame",
                        "twitter_username": "thesandboxgame",
                        "instagram_username": null,
                        "wiki_url": null
                    },
                    "decimals": null,
                    "token_metadata": null
                },
                {
                    "id": 15810672,
                    "token_id": "77885",
                    "num_sales": 0,
                    "background_color": null,
                    "image_url": "https://lh3.googleusercontent.com/17vU_UNWeMOVi4XOAwo4nvAXpeg1dnKPBk8VnAhJcFHOFZ9UBBvSL5Spj0ytvyfII3rdp4gHMY0mMvbnSzjdOZ0",
                    "image_preview_url": "https://lh3.googleusercontent.com/17vU_UNWeMOVi4XOAwo4nvAXpeg1dnKPBk8VnAhJcFHOFZ9UBBvSL5Spj0ytvyfII3rdp4gHMY0mMvbnSzjdOZ0=s250",
                    "image_thumbnail_url": "https://lh3.googleusercontent.com/17vU_UNWeMOVi4XOAwo4nvAXpeg1dnKPBk8VnAhJcFHOFZ9UBBvSL5Spj0ytvyfII3rdp4gHMY0mMvbnSzjdOZ0=s128",
                    "image_original_url": "https://storage.googleapis.com/opensea-static/custom-fetcher-images/sandbox/land/sandbox-land.png",
                    "animation_url": null,
                    "animation_original_url": null,
                    "name": "LAND (161, -14)",
                    "description": "A LAND is a digital piece of real estate in The Sandbox metaverse that players can buy to build experiences on top of. Once you own a LAND, you will be able to populate it with Games and Assets. Each LAND is a unique (non-fungible) token lying on the public Ethereum blockchain (ERC-721).",
                    "external_link": "https://www.sandbox.game/en/map/?x=161&y=-14",
                    "asset_contract": {
                        "address": "0x50f5474724e0ee42d9a4e711ccfb275809fd6d4a",
                        "asset_contract_type": "non-fungible",
                        "created_date": "2019-12-04T10:58:28.892990",
                        "name": "Sandbox's LANDs",
                        "nft_version": "3.0",
                        "opensea_version": null,
                        "owner": null,
                        "schema_name": "ERC721",
                        "symbol": "",
                        "total_supply": null,
                        "description": "The Sandbox is a community-driven platform where creators can monetize voxel assets and gaming experiences on the blockchain. The Sandbox metaverse comprises a map made up of 166,464 LANDS.  LAND owners can host contests and events, stake SAND to earn and customize assets, monetize assets and experiences, vote in the metaverse governance, play games that you or others create, and more! Trade the collection and keep your eyes peeled for future drops.",
                        "external_link": "https://www.sandbox.game/",
                        "image_url": "https://lh3.googleusercontent.com/SXH8tW1siikB80rwCRnjm1a5xM_MwTg9Xl9Db6mioIk9HIlDM09pVoSR7GKJgS6ulSUpgW9BDtMk_ePX_NKgO9A=s60",
                        "default_to_fiat": false,
                        "dev_buyer_fee_basis_points": 0,
                        "dev_seller_fee_basis_points": 500,
                        "only_proxied_transfers": false,
                        "opensea_buyer_fee_basis_points": 0,
                        "opensea_seller_fee_basis_points": 250,
                        "buyer_fee_basis_points": 0,
                        "seller_fee_basis_points": 750,
                        "payout_address": "0x7a9fe22691c811ea339d9b73150e6911a5343dca"
                    },
                    "owner": {
                        "user": {
                            "username": "REVOLT"
                        },
                        "profile_img_url": "https://storage.googleapis.com/opensea-static/opensea-profile/25.png",
                        "address": "0xb6d820e80a2a7c49f94c9d6c8ea08dccedc9ce4c",
                        "config": "",
                        "discord_id": ""
                    },
                    "permalink": "https://opensea.io/assets/0x50f5474724e0ee42d9a4e711ccfb275809fd6d4a/77885",
                    "collection": {
                        "banner_image_url": "https://lh3.googleusercontent.com/4NQIRoGmzXeXQN4mjuhWuuDZSNW7_BqRXux5upd4Nn_A-bfsGxCnPF8qn98Y6MyHRDPGXIlgfZADcSOe6M2DyrDKXdbdaTgkZN5l=s2500",
                        "chat_url": null,
                        "created_date": "2019-12-04T10:58:29.069907",
                        "default_to_fiat": false,
                        "description": "The Sandbox is a community-driven platform where creators can monetize voxel assets and gaming experiences on the blockchain. The Sandbox metaverse comprises a map made up of 166,464 LANDS.  LAND owners can host contests and events, stake SAND to earn and customize assets, monetize assets and experiences, vote in the metaverse governance, play games that you or others create, and more! Trade the collection and keep your eyes peeled for future drops.",
                        "dev_buyer_fee_basis_points": "0",
                        "dev_seller_fee_basis_points": "500",
                        "discord_url": "https://discord.gg/vAe4zvY",
                        "display_data": {
                            "card_display_style": "contain"
                        },
                        "external_url": "https://www.sandbox.game/",
                        "featured": false,
                        "featured_image_url": "https://storage.googleapis.com/opensea-static/featured-images/sandbox-featured.png",
                        "hidden": false,
                        "safelist_request_status": "verified",
                        "image_url": "https://lh3.googleusercontent.com/SXH8tW1siikB80rwCRnjm1a5xM_MwTg9Xl9Db6mioIk9HIlDM09pVoSR7GKJgS6ulSUpgW9BDtMk_ePX_NKgO9A=s60",
                        "is_subject_to_whitelist": false,
                        "large_image_url": "https://lh3.googleusercontent.com/SXH8tW1siikB80rwCRnjm1a5xM_MwTg9Xl9Db6mioIk9HIlDM09pVoSR7GKJgS6ulSUpgW9BDtMk_ePX_NKgO9A",
                        "medium_username": "sandbox-game",
                        "name": "The Sandbox",
                        "only_proxied_transfers": false,
                        "opensea_buyer_fee_basis_points": "0",
                        "opensea_seller_fee_basis_points": "250",
                        "payout_address": "0x7a9fe22691c811ea339d9b73150e6911a5343dca",
                        "require_email": false,
                        "short_description": null,
                        "slug": "sandbox",
                        "telegram_url": "https://t.me/sandboxgame",
                        "twitter_username": "thesandboxgame",
                        "instagram_username": null,
                        "wiki_url": null
                    },
                    "decimals": null,
                    "token_metadata": null
                },
                {
                    "id": 15810699,
                    "token_id": "77884",
                    "num_sales": 0,
                    "background_color": null,
                    "image_url": "https://storage.opensea.io/files/3faa959fa75531ac7913a9c9f8361b58.png",
                    "image_preview_url": "https://lh3.googleusercontent.com/17vU_UNWeMOVi4XOAwo4nvAXpeg1dnKPBk8VnAhJcFHOFZ9UBBvSL5Spj0ytvyfII3rdp4gHMY0mMvbnSzjdOZ0=s250",
                    "image_thumbnail_url": "https://lh3.googleusercontent.com/17vU_UNWeMOVi4XOAwo4nvAXpeg1dnKPBk8VnAhJcFHOFZ9UBBvSL5Spj0ytvyfII3rdp4gHMY0mMvbnSzjdOZ0=s128",
                    "image_original_url": "https://storage.googleapis.com/opensea-static/custom-fetcher-images/sandbox/land/sandbox-land.png",
                    "animation_url": null,
                    "animation_original_url": null,
                    "name": "LAND (160, -14)",
                    "description": "A LAND is a digital piece of real estate in The Sandbox metaverse that players can buy to build experiences on top of. Once you own a LAND, you will be able to populate it with Games and Assets. Each LAND is a unique (non-fungible) token lying on the public Ethereum blockchain (ERC-721).",
                    "external_link": "https://www.sandbox.game/en/map/?x=160&y=-14",
                    "asset_contract": {
                        "address": "0x50f5474724e0ee42d9a4e711ccfb275809fd6d4a",
                        "asset_contract_type": "non-fungible",
                        "created_date": "2019-12-04T10:58:28.892990",
                        "name": "Sandbox's LANDs",
                        "nft_version": "3.0",
                        "opensea_version": null,
                        "owner": null,
                        "schema_name": "ERC721",
                        "symbol": "",
                        "total_supply": null,
                        "description": "The Sandbox is a community-driven platform where creators can monetize voxel assets and gaming experiences on the blockchain. The Sandbox metaverse comprises a map made up of 166,464 LANDS.  LAND owners can host contests and events, stake SAND to earn and customize assets, monetize assets and experiences, vote in the metaverse governance, play games that you or others create, and more! Trade the collection and keep your eyes peeled for future drops.",
                        "external_link": "https://www.sandbox.game/",
                        "image_url": "https://lh3.googleusercontent.com/SXH8tW1siikB80rwCRnjm1a5xM_MwTg9Xl9Db6mioIk9HIlDM09pVoSR7GKJgS6ulSUpgW9BDtMk_ePX_NKgO9A=s60",
                        "default_to_fiat": false,
                        "dev_buyer_fee_basis_points": 0,
                        "dev_seller_fee_basis_points": 500,
                        "only_proxied_transfers": false,
                        "opensea_buyer_fee_basis_points": 0,
                        "opensea_seller_fee_basis_points": 250,
                        "buyer_fee_basis_points": 0,
                        "seller_fee_basis_points": 750,
                        "payout_address": "0x7a9fe22691c811ea339d9b73150e6911a5343dca"
                    },
                    "owner": {
                        "user": {
                            "username": "REVOLT"
                        },
                        "profile_img_url": "https://storage.googleapis.com/opensea-static/opensea-profile/25.png",
                        "address": "0xb6d820e80a2a7c49f94c9d6c8ea08dccedc9ce4c",
                        "config": "",
                        "discord_id": ""
                    },
                    "permalink": "https://opensea.io/assets/0x50f5474724e0ee42d9a4e711ccfb275809fd6d4a/77884",
                    "collection": {
                        "banner_image_url": "https://lh3.googleusercontent.com/4NQIRoGmzXeXQN4mjuhWuuDZSNW7_BqRXux5upd4Nn_A-bfsGxCnPF8qn98Y6MyHRDPGXIlgfZADcSOe6M2DyrDKXdbdaTgkZN5l=s2500",
                        "chat_url": null,
                        "created_date": "2019-12-04T10:58:29.069907",
                        "default_to_fiat": false,
                        "description": "The Sandbox is a community-driven platform where creators can monetize voxel assets and gaming experiences on the blockchain. The Sandbox metaverse comprises a map made up of 166,464 LANDS.  LAND owners can host contests and events, stake SAND to earn and customize assets, monetize assets and experiences, vote in the metaverse governance, play games that you or others create, and more! Trade the collection and keep your eyes peeled for future drops.",
                        "dev_buyer_fee_basis_points": "0",
                        "dev_seller_fee_basis_points": "500",
                        "discord_url": "https://discord.gg/vAe4zvY",
                        "display_data": {
                            "card_display_style": "contain"
                        },
                        "external_url": "https://www.sandbox.game/",
                        "featured": false,
                        "featured_image_url": "https://storage.googleapis.com/opensea-static/featured-images/sandbox-featured.png",
                        "hidden": false,
                        "safelist_request_status": "verified",
                        "image_url": "https://lh3.googleusercontent.com/SXH8tW1siikB80rwCRnjm1a5xM_MwTg9Xl9Db6mioIk9HIlDM09pVoSR7GKJgS6ulSUpgW9BDtMk_ePX_NKgO9A=s60",
                        "is_subject_to_whitelist": false,
                        "large_image_url": "https://lh3.googleusercontent.com/SXH8tW1siikB80rwCRnjm1a5xM_MwTg9Xl9Db6mioIk9HIlDM09pVoSR7GKJgS6ulSUpgW9BDtMk_ePX_NKgO9A",
                        "medium_username": "sandbox-game",
                        "name": "The Sandbox",
                        "only_proxied_transfers": false,
                        "opensea_buyer_fee_basis_points": "0",
                        "opensea_seller_fee_basis_points": "250",
                        "payout_address": "0x7a9fe22691c811ea339d9b73150e6911a5343dca",
                        "require_email": false,
                        "short_description": null,
                        "slug": "sandbox",
                        "telegram_url": "https://t.me/sandboxgame",
                        "twitter_username": "thesandboxgame",
                        "instagram_username": null,
                        "wiki_url": null
                    },
                    "decimals": null,
                    "token_metadata": null
                },
                {
                    "id": 15810724,
                    "token_id": "77883",
                    "num_sales": 0,
                    "background_color": null,
                    "image_url": "https://storage.opensea.io/files/3faa959fa75531ac7913a9c9f8361b58.png",
                    "image_preview_url": "https://lh3.googleusercontent.com/17vU_UNWeMOVi4XOAwo4nvAXpeg1dnKPBk8VnAhJcFHOFZ9UBBvSL5Spj0ytvyfII3rdp4gHMY0mMvbnSzjdOZ0=s250",
                    "image_thumbnail_url": "https://lh3.googleusercontent.com/17vU_UNWeMOVi4XOAwo4nvAXpeg1dnKPBk8VnAhJcFHOFZ9UBBvSL5Spj0ytvyfII3rdp4gHMY0mMvbnSzjdOZ0=s128",
                    "image_original_url": "https://storage.googleapis.com/opensea-static/custom-fetcher-images/sandbox/land/sandbox-land.png",
                    "animation_url": null,
                    "animation_original_url": null,
                    "name": "LAND (159, -14)",
                    "description": "A LAND is a digital piece of real estate in The Sandbox metaverse that players can buy to build experiences on top of. Once you own a LAND, you will be able to populate it with Games and Assets. Each LAND is a unique (non-fungible) token lying on the public Ethereum blockchain (ERC-721).",
                    "external_link": "https://www.sandbox.game/en/map/?x=159&y=-14",
                    "asset_contract": {
                        "address": "0x50f5474724e0ee42d9a4e711ccfb275809fd6d4a",
                        "asset_contract_type": "non-fungible",
                        "created_date": "2019-12-04T10:58:28.892990",
                        "name": "Sandbox's LANDs",
                        "nft_version": "3.0",
                        "opensea_version": null,
                        "owner": null,
                        "schema_name": "ERC721",
                        "symbol": "",
                        "total_supply": null,
                        "description": "The Sandbox is a community-driven platform where creators can monetize voxel assets and gaming experiences on the blockchain. The Sandbox metaverse comprises a map made up of 166,464 LANDS.  LAND owners can host contests and events, stake SAND to earn and customize assets, monetize assets and experiences, vote in the metaverse governance, play games that you or others create, and more! Trade the collection and keep your eyes peeled for future drops.",
                        "external_link": "https://www.sandbox.game/",
                        "image_url": "https://lh3.googleusercontent.com/SXH8tW1siikB80rwCRnjm1a5xM_MwTg9Xl9Db6mioIk9HIlDM09pVoSR7GKJgS6ulSUpgW9BDtMk_ePX_NKgO9A=s60",
                        "default_to_fiat": false,
                        "dev_buyer_fee_basis_points": 0,
                        "dev_seller_fee_basis_points": 500,
                        "only_proxied_transfers": false,
                        "opensea_buyer_fee_basis_points": 0,
                        "opensea_seller_fee_basis_points": 250,
                        "buyer_fee_basis_points": 0,
                        "seller_fee_basis_points": 750,
                        "payout_address": "0x7a9fe22691c811ea339d9b73150e6911a5343dca"
                    },
                    "owner": {
                        "user": {
                            "username": "REVOLT"
                        },
                        "profile_img_url": "https://storage.googleapis.com/opensea-static/opensea-profile/25.png",
                        "address": "0xb6d820e80a2a7c49f94c9d6c8ea08dccedc9ce4c",
                        "config": "",
                        "discord_id": ""
                    },
                    "permalink": "https://opensea.io/assets/0x50f5474724e0ee42d9a4e711ccfb275809fd6d4a/77883",
                    "collection": {
                        "banner_image_url": "https://lh3.googleusercontent.com/4NQIRoGmzXeXQN4mjuhWuuDZSNW7_BqRXux5upd4Nn_A-bfsGxCnPF8qn98Y6MyHRDPGXIlgfZADcSOe6M2DyrDKXdbdaTgkZN5l=s2500",
                        "chat_url": null,
                        "created_date": "2019-12-04T10:58:29.069907",
                        "default_to_fiat": false,
                        "description": "The Sandbox is a community-driven platform where creators can monetize voxel assets and gaming experiences on the blockchain. The Sandbox metaverse comprises a map made up of 166,464 LANDS.  LAND owners can host contests and events, stake SAND to earn and customize assets, monetize assets and experiences, vote in the metaverse governance, play games that you or others create, and more! Trade the collection and keep your eyes peeled for future drops.",
                        "dev_buyer_fee_basis_points": "0",
                        "dev_seller_fee_basis_points": "500",
                        "discord_url": "https://discord.gg/vAe4zvY",
                        "display_data": {
                            "card_display_style": "contain"
                        },
                        "external_url": "https://www.sandbox.game/",
                        "featured": false,
                        "featured_image_url": "https://storage.googleapis.com/opensea-static/featured-images/sandbox-featured.png",
                        "hidden": false,
                        "safelist_request_status": "verified",
                        "image_url": "https://lh3.googleusercontent.com/SXH8tW1siikB80rwCRnjm1a5xM_MwTg9Xl9Db6mioIk9HIlDM09pVoSR7GKJgS6ulSUpgW9BDtMk_ePX_NKgO9A=s60",
                        "is_subject_to_whitelist": false,
                        "large_image_url": "https://lh3.googleusercontent.com/SXH8tW1siikB80rwCRnjm1a5xM_MwTg9Xl9Db6mioIk9HIlDM09pVoSR7GKJgS6ulSUpgW9BDtMk_ePX_NKgO9A",
                        "medium_username": "sandbox-game",
                        "name": "The Sandbox",
                        "only_proxied_transfers": false,
                        "opensea_buyer_fee_basis_points": "0",
                        "opensea_seller_fee_basis_points": "250",
                        "payout_address": "0x7a9fe22691c811ea339d9b73150e6911a5343dca",
                        "require_email": false,
                        "short_description": null,
                        "slug": "sandbox",
                        "telegram_url": "https://t.me/sandboxgame",
                        "twitter_username": "thesandboxgame",
                        "instagram_username": null,
                        "wiki_url": null
                    },
                    "decimals": null,
                    "token_metadata": null
                },
                {
                    "id": 15810748,
                    "token_id": "78291",
                    "num_sales": 0,
                    "background_color": null,
                    "image_url": "https://lh3.googleusercontent.com/17vU_UNWeMOVi4XOAwo4nvAXpeg1dnKPBk8VnAhJcFHOFZ9UBBvSL5Spj0ytvyfII3rdp4gHMY0mMvbnSzjdOZ0",
                    "image_preview_url": "https://lh3.googleusercontent.com/17vU_UNWeMOVi4XOAwo4nvAXpeg1dnKPBk8VnAhJcFHOFZ9UBBvSL5Spj0ytvyfII3rdp4gHMY0mMvbnSzjdOZ0=s250",
                    "image_thumbnail_url": "https://lh3.googleusercontent.com/17vU_UNWeMOVi4XOAwo4nvAXpeg1dnKPBk8VnAhJcFHOFZ9UBBvSL5Spj0ytvyfII3rdp4gHMY0mMvbnSzjdOZ0=s128",
                    "image_original_url": "https://storage.googleapis.com/opensea-static/custom-fetcher-images/sandbox/land/sandbox-land.png",
                    "animation_url": null,
                    "animation_original_url": null,
                    "name": "LAND (159, -13)",
                    "description": "A LAND is a digital piece of real estate in The Sandbox metaverse that players can buy to build experiences on top of. Once you own a LAND, you will be able to populate it with Games and Assets. Each LAND is a unique (non-fungible) token lying on the public Ethereum blockchain (ERC-721).",
                    "external_link": "https://www.sandbox.game/en/map/?x=159&y=-13",
                    "asset_contract": {
                        "address": "0x50f5474724e0ee42d9a4e711ccfb275809fd6d4a",
                        "asset_contract_type": "non-fungible",
                        "created_date": "2019-12-04T10:58:28.892990",
                        "name": "Sandbox's LANDs",
                        "nft_version": "3.0",
                        "opensea_version": null,
                        "owner": null,
                        "schema_name": "ERC721",
                        "symbol": "",
                        "total_supply": null,
                        "description": "The Sandbox is a community-driven platform where creators can monetize voxel assets and gaming experiences on the blockchain. The Sandbox metaverse comprises a map made up of 166,464 LANDS.  LAND owners can host contests and events, stake SAND to earn and customize assets, monetize assets and experiences, vote in the metaverse governance, play games that you or others create, and more! Trade the collection and keep your eyes peeled for future drops.",
                        "external_link": "https://www.sandbox.game/",
                        "image_url": "https://lh3.googleusercontent.com/SXH8tW1siikB80rwCRnjm1a5xM_MwTg9Xl9Db6mioIk9HIlDM09pVoSR7GKJgS6ulSUpgW9BDtMk_ePX_NKgO9A=s60",
                        "default_to_fiat": false,
                        "dev_buyer_fee_basis_points": 0,
                        "dev_seller_fee_basis_points": 500,
                        "only_proxied_transfers": false,
                        "opensea_buyer_fee_basis_points": 0,
                        "opensea_seller_fee_basis_points": 250,
                        "buyer_fee_basis_points": 0,
                        "seller_fee_basis_points": 750,
                        "payout_address": "0x7a9fe22691c811ea339d9b73150e6911a5343dca"
                    },
                    "owner": {
                        "user": {
                            "username": "REVOLT"
                        },
                        "profile_img_url": "https://storage.googleapis.com/opensea-static/opensea-profile/25.png",
                        "address": "0xb6d820e80a2a7c49f94c9d6c8ea08dccedc9ce4c",
                        "config": "",
                        "discord_id": ""
                    },
                    "permalink": "https://opensea.io/assets/0x50f5474724e0ee42d9a4e711ccfb275809fd6d4a/78291",
                    "collection": {
                        "banner_image_url": "https://lh3.googleusercontent.com/4NQIRoGmzXeXQN4mjuhWuuDZSNW7_BqRXux5upd4Nn_A-bfsGxCnPF8qn98Y6MyHRDPGXIlgfZADcSOe6M2DyrDKXdbdaTgkZN5l=s2500",
                        "chat_url": null,
                        "created_date": "2019-12-04T10:58:29.069907",
                        "default_to_fiat": false,
                        "description": "The Sandbox is a community-driven platform where creators can monetize voxel assets and gaming experiences on the blockchain. The Sandbox metaverse comprises a map made up of 166,464 LANDS.  LAND owners can host contests and events, stake SAND to earn and customize assets, monetize assets and experiences, vote in the metaverse governance, play games that you or others create, and more! Trade the collection and keep your eyes peeled for future drops.",
                        "dev_buyer_fee_basis_points": "0",
                        "dev_seller_fee_basis_points": "500",
                        "discord_url": "https://discord.gg/vAe4zvY",
                        "display_data": {
                            "card_display_style": "contain"
                        },
                        "external_url": "https://www.sandbox.game/",
                        "featured": false,
                        "featured_image_url": "https://storage.googleapis.com/opensea-static/featured-images/sandbox-featured.png",
                        "hidden": false,
                        "safelist_request_status": "verified",
                        "image_url": "https://lh3.googleusercontent.com/SXH8tW1siikB80rwCRnjm1a5xM_MwTg9Xl9Db6mioIk9HIlDM09pVoSR7GKJgS6ulSUpgW9BDtMk_ePX_NKgO9A=s60",
                        "is_subject_to_whitelist": false,
                        "large_image_url": "https://lh3.googleusercontent.com/SXH8tW1siikB80rwCRnjm1a5xM_MwTg9Xl9Db6mioIk9HIlDM09pVoSR7GKJgS6ulSUpgW9BDtMk_ePX_NKgO9A",
                        "medium_username": "sandbox-game",
                        "name": "The Sandbox",
                        "only_proxied_transfers": false,
                        "opensea_buyer_fee_basis_points": "0",
                        "opensea_seller_fee_basis_points": "250",
                        "payout_address": "0x7a9fe22691c811ea339d9b73150e6911a5343dca",
                        "require_email": false,
                        "short_description": null,
                        "slug": "sandbox",
                        "telegram_url": "https://t.me/sandboxgame",
                        "twitter_username": "thesandboxgame",
                        "instagram_username": null,
                        "wiki_url": null
                    },
                    "decimals": null,
                    "token_metadata": null
                },
                {
                    "id": 15810775,
                    "token_id": "78292",
                    "num_sales": 0,
                    "background_color": null,
                    "image_url": "https://storage.opensea.io/files/3faa959fa75531ac7913a9c9f8361b58.png",
                    "image_preview_url": "https://lh3.googleusercontent.com/17vU_UNWeMOVi4XOAwo4nvAXpeg1dnKPBk8VnAhJcFHOFZ9UBBvSL5Spj0ytvyfII3rdp4gHMY0mMvbnSzjdOZ0=s250",
                    "image_thumbnail_url": "https://lh3.googleusercontent.com/17vU_UNWeMOVi4XOAwo4nvAXpeg1dnKPBk8VnAhJcFHOFZ9UBBvSL5Spj0ytvyfII3rdp4gHMY0mMvbnSzjdOZ0=s128",
                    "image_original_url": "https://storage.googleapis.com/opensea-static/custom-fetcher-images/sandbox/land/sandbox-land.png",
                    "animation_url": null,
                    "animation_original_url": null,
                    "name": "LAND (160, -13)",
                    "description": "A LAND is a digital piece of real estate in The Sandbox metaverse that players can buy to build experiences on top of. Once you own a LAND, you will be able to populate it with Games and Assets. Each LAND is a unique (non-fungible) token lying on the public Ethereum blockchain (ERC-721).",
                    "external_link": "https://www.sandbox.game/en/map/?x=160&y=-13",
                    "asset_contract": {
                        "address": "0x50f5474724e0ee42d9a4e711ccfb275809fd6d4a",
                        "asset_contract_type": "non-fungible",
                        "created_date": "2019-12-04T10:58:28.892990",
                        "name": "Sandbox's LANDs",
                        "nft_version": "3.0",
                        "opensea_version": null,
                        "owner": null,
                        "schema_name": "ERC721",
                        "symbol": "",
                        "total_supply": null,
                        "description": "The Sandbox is a community-driven platform where creators can monetize voxel assets and gaming experiences on the blockchain. The Sandbox metaverse comprises a map made up of 166,464 LANDS.  LAND owners can host contests and events, stake SAND to earn and customize assets, monetize assets and experiences, vote in the metaverse governance, play games that you or others create, and more! Trade the collection and keep your eyes peeled for future drops.",
                        "external_link": "https://www.sandbox.game/",
                        "image_url": "https://lh3.googleusercontent.com/SXH8tW1siikB80rwCRnjm1a5xM_MwTg9Xl9Db6mioIk9HIlDM09pVoSR7GKJgS6ulSUpgW9BDtMk_ePX_NKgO9A=s60",
                        "default_to_fiat": false,
                        "dev_buyer_fee_basis_points": 0,
                        "dev_seller_fee_basis_points": 500,
                        "only_proxied_transfers": false,
                        "opensea_buyer_fee_basis_points": 0,
                        "opensea_seller_fee_basis_points": 250,
                        "buyer_fee_basis_points": 0,
                        "seller_fee_basis_points": 750,
                        "payout_address": "0x7a9fe22691c811ea339d9b73150e6911a5343dca"
                    },
                    "owner": {
                        "user": {
                            "username": "REVOLT"
                        },
                        "profile_img_url": "https://storage.googleapis.com/opensea-static/opensea-profile/25.png",
                        "address": "0xb6d820e80a2a7c49f94c9d6c8ea08dccedc9ce4c",
                        "config": "",
                        "discord_id": ""
                    },
                    "permalink": "https://opensea.io/assets/0x50f5474724e0ee42d9a4e711ccfb275809fd6d4a/78292",
                    "collection": {
                        "banner_image_url": "https://lh3.googleusercontent.com/4NQIRoGmzXeXQN4mjuhWuuDZSNW7_BqRXux5upd4Nn_A-bfsGxCnPF8qn98Y6MyHRDPGXIlgfZADcSOe6M2DyrDKXdbdaTgkZN5l=s2500",
                        "chat_url": null,
                        "created_date": "2019-12-04T10:58:29.069907",
                        "default_to_fiat": false,
                        "description": "The Sandbox is a community-driven platform where creators can monetize voxel assets and gaming experiences on the blockchain. The Sandbox metaverse comprises a map made up of 166,464 LANDS.  LAND owners can host contests and events, stake SAND to earn and customize assets, monetize assets and experiences, vote in the metaverse governance, play games that you or others create, and more! Trade the collection and keep your eyes peeled for future drops.",
                        "dev_buyer_fee_basis_points": "0",
                        "dev_seller_fee_basis_points": "500",
                        "discord_url": "https://discord.gg/vAe4zvY",
                        "display_data": {
                            "card_display_style": "contain"
                        },
                        "external_url": "https://www.sandbox.game/",
                        "featured": false,
                        "featured_image_url": "https://storage.googleapis.com/opensea-static/featured-images/sandbox-featured.png",
                        "hidden": false,
                        "safelist_request_status": "verified",
                        "image_url": "https://lh3.googleusercontent.com/SXH8tW1siikB80rwCRnjm1a5xM_MwTg9Xl9Db6mioIk9HIlDM09pVoSR7GKJgS6ulSUpgW9BDtMk_ePX_NKgO9A=s60",
                        "is_subject_to_whitelist": false,
                        "large_image_url": "https://lh3.googleusercontent.com/SXH8tW1siikB80rwCRnjm1a5xM_MwTg9Xl9Db6mioIk9HIlDM09pVoSR7GKJgS6ulSUpgW9BDtMk_ePX_NKgO9A",
                        "medium_username": "sandbox-game",
                        "name": "The Sandbox",
                        "only_proxied_transfers": false,
                        "opensea_buyer_fee_basis_points": "0",
                        "opensea_seller_fee_basis_points": "250",
                        "payout_address": "0x7a9fe22691c811ea339d9b73150e6911a5343dca",
                        "require_email": false,
                        "short_description": null,
                        "slug": "sandbox",
                        "telegram_url": "https://t.me/sandboxgame",
                        "twitter_username": "thesandboxgame",
                        "instagram_username": null,
                        "wiki_url": null
                    },
                    "decimals": null,
                    "token_metadata": null
                },
                {
                    "id": 15810807,
                    "token_id": "78293",
                    "num_sales": 0,
                    "background_color": null,
                    "image_url": "https://storage.opensea.io/files/3faa959fa75531ac7913a9c9f8361b58.png",
                    "image_preview_url": "https://lh3.googleusercontent.com/17vU_UNWeMOVi4XOAwo4nvAXpeg1dnKPBk8VnAhJcFHOFZ9UBBvSL5Spj0ytvyfII3rdp4gHMY0mMvbnSzjdOZ0=s250",
                    "image_thumbnail_url": "https://lh3.googleusercontent.com/17vU_UNWeMOVi4XOAwo4nvAXpeg1dnKPBk8VnAhJcFHOFZ9UBBvSL5Spj0ytvyfII3rdp4gHMY0mMvbnSzjdOZ0=s128",
                    "image_original_url": "https://storage.googleapis.com/opensea-static/custom-fetcher-images/sandbox/land/sandbox-land.png",
                    "animation_url": null,
                    "animation_original_url": null,
                    "name": "LAND (161, -13)",
                    "description": "A LAND is a digital piece of real estate in The Sandbox metaverse that players can buy to build experiences on top of. Once you own a LAND, you will be able to populate it with Games and Assets. Each LAND is a unique (non-fungible) token lying on the public Ethereum blockchain (ERC-721).",
                    "external_link": "https://www.sandbox.game/en/map/?x=161&y=-13",
                    "asset_contract": {
                        "address": "0x50f5474724e0ee42d9a4e711ccfb275809fd6d4a",
                        "asset_contract_type": "non-fungible",
                        "created_date": "2019-12-04T10:58:28.892990",
                        "name": "Sandbox's LANDs",
                        "nft_version": "3.0",
                        "opensea_version": null,
                        "owner": null,
                        "schema_name": "ERC721",
                        "symbol": "",
                        "total_supply": null,
                        "description": "The Sandbox is a community-driven platform where creators can monetize voxel assets and gaming experiences on the blockchain. The Sandbox metaverse comprises a map made up of 166,464 LANDS.  LAND owners can host contests and events, stake SAND to earn and customize assets, monetize assets and experiences, vote in the metaverse governance, play games that you or others create, and more! Trade the collection and keep your eyes peeled for future drops.",
                        "external_link": "https://www.sandbox.game/",
                        "image_url": "https://lh3.googleusercontent.com/SXH8tW1siikB80rwCRnjm1a5xM_MwTg9Xl9Db6mioIk9HIlDM09pVoSR7GKJgS6ulSUpgW9BDtMk_ePX_NKgO9A=s60",
                        "default_to_fiat": false,
                        "dev_buyer_fee_basis_points": 0,
                        "dev_seller_fee_basis_points": 500,
                        "only_proxied_transfers": false,
                        "opensea_buyer_fee_basis_points": 0,
                        "opensea_seller_fee_basis_points": 250,
                        "buyer_fee_basis_points": 0,
                        "seller_fee_basis_points": 750,
                        "payout_address": "0x7a9fe22691c811ea339d9b73150e6911a5343dca"
                    },
                    "owner": {
                        "user": {
                            "username": "REVOLT"
                        },
                        "profile_img_url": "https://storage.googleapis.com/opensea-static/opensea-profile/25.png",
                        "address": "0xb6d820e80a2a7c49f94c9d6c8ea08dccedc9ce4c",
                        "config": "",
                        "discord_id": ""
                    },
                    "permalink": "https://opensea.io/assets/0x50f5474724e0ee42d9a4e711ccfb275809fd6d4a/78293",
                    "collection": {
                        "banner_image_url": "https://lh3.googleusercontent.com/4NQIRoGmzXeXQN4mjuhWuuDZSNW7_BqRXux5upd4Nn_A-bfsGxCnPF8qn98Y6MyHRDPGXIlgfZADcSOe6M2DyrDKXdbdaTgkZN5l=s2500",
                        "chat_url": null,
                        "created_date": "2019-12-04T10:58:29.069907",
                        "default_to_fiat": false,
                        "description": "The Sandbox is a community-driven platform where creators can monetize voxel assets and gaming experiences on the blockchain. The Sandbox metaverse comprises a map made up of 166,464 LANDS.  LAND owners can host contests and events, stake SAND to earn and customize assets, monetize assets and experiences, vote in the metaverse governance, play games that you or others create, and more! Trade the collection and keep your eyes peeled for future drops.",
                        "dev_buyer_fee_basis_points": "0",
                        "dev_seller_fee_basis_points": "500",
                        "discord_url": "https://discord.gg/vAe4zvY",
                        "display_data": {
                            "card_display_style": "contain"
                        },
                        "external_url": "https://www.sandbox.game/",
                        "featured": false,
                        "featured_image_url": "https://storage.googleapis.com/opensea-static/featured-images/sandbox-featured.png",
                        "hidden": false,
                        "safelist_request_status": "verified",
                        "image_url": "https://lh3.googleusercontent.com/SXH8tW1siikB80rwCRnjm1a5xM_MwTg9Xl9Db6mioIk9HIlDM09pVoSR7GKJgS6ulSUpgW9BDtMk_ePX_NKgO9A=s60",
                        "is_subject_to_whitelist": false,
                        "large_image_url": "https://lh3.googleusercontent.com/SXH8tW1siikB80rwCRnjm1a5xM_MwTg9Xl9Db6mioIk9HIlDM09pVoSR7GKJgS6ulSUpgW9BDtMk_ePX_NKgO9A",
                        "medium_username": "sandbox-game",
                        "name": "The Sandbox",
                        "only_proxied_transfers": false,
                        "opensea_buyer_fee_basis_points": "0",
                        "opensea_seller_fee_basis_points": "250",
                        "payout_address": "0x7a9fe22691c811ea339d9b73150e6911a5343dca",
                        "require_email": false,
                        "short_description": null,
                        "slug": "sandbox",
                        "telegram_url": "https://t.me/sandboxgame",
                        "twitter_username": "thesandboxgame",
                        "instagram_username": null,
                        "wiki_url": null
                    },
                    "decimals": null,
                    "token_metadata": null
                }
            ],
            "name": "Small estate (9 lands)",
            "description": "Yes, you can afford it :o))",
            "external_link": "",
            "asset_contract": {
                "collection": {
                    "banner_image_url": "https://lh3.googleusercontent.com/4NQIRoGmzXeXQN4mjuhWuuDZSNW7_BqRXux5upd4Nn_A-bfsGxCnPF8qn98Y6MyHRDPGXIlgfZADcSOe6M2DyrDKXdbdaTgkZN5l=s2500",
                    "chat_url": null,
                    "created_date": "2019-12-04T10:58:29.069907",
                    "default_to_fiat": false,
                    "description": "The Sandbox is a community-driven platform where creators can monetize voxel assets and gaming experiences on the blockchain. The Sandbox metaverse comprises a map made up of 166,464 LANDS.  LAND owners can host contests and events, stake SAND to earn and customize assets, monetize assets and experiences, vote in the metaverse governance, play games that you or others create, and more! Trade the collection and keep your eyes peeled for future drops.",
                    "dev_buyer_fee_basis_points": "0",
                    "dev_seller_fee_basis_points": "500",
                    "discord_url": "https://discord.gg/vAe4zvY",
                    "display_data": {
                        "card_display_style": "contain"
                    },
                    "external_url": "https://www.sandbox.game/",
                    "featured": false,
                    "featured_image_url": "https://storage.googleapis.com/opensea-static/featured-images/sandbox-featured.png",
                    "hidden": false,
                    "safelist_request_status": "verified",
                    "image_url": "https://lh3.googleusercontent.com/SXH8tW1siikB80rwCRnjm1a5xM_MwTg9Xl9Db6mioIk9HIlDM09pVoSR7GKJgS6ulSUpgW9BDtMk_ePX_NKgO9A=s60",
                    "is_subject_to_whitelist": false,
                    "large_image_url": "https://lh3.googleusercontent.com/SXH8tW1siikB80rwCRnjm1a5xM_MwTg9Xl9Db6mioIk9HIlDM09pVoSR7GKJgS6ulSUpgW9BDtMk_ePX_NKgO9A",
                    "medium_username": "sandbox-game",
                    "name": "The Sandbox",
                    "only_proxied_transfers": false,
                    "opensea_buyer_fee_basis_points": "0",
                    "opensea_seller_fee_basis_points": "250",
                    "payout_address": "0x7a9fe22691c811ea339d9b73150e6911a5343dca",
                    "require_email": false,
                    "short_description": null,
                    "slug": "sandbox",
                    "telegram_url": "https://t.me/sandboxgame",
                    "twitter_username": "thesandboxgame",
                    "instagram_username": null,
                    "wiki_url": null
                },
                "address": "0x50f5474724e0ee42d9a4e711ccfb275809fd6d4a",
                "asset_contract_type": "non-fungible",
                "created_date": "2019-12-04T10:58:28.892990",
                "name": "Sandbox's LANDs",
                "nft_version": "3.0",
                "opensea_version": null,
                "owner": null,
                "schema_name": "ERC721",
                "symbol": "",
                "total_supply": null,
                "description": "The Sandbox is a community-driven platform where creators can monetize voxel assets and gaming experiences on the blockchain. The Sandbox metaverse comprises a map made up of 166,464 LANDS.  LAND owners can host contests and events, stake SAND to earn and customize assets, monetize assets and experiences, vote in the metaverse governance, play games that you or others create, and more! Trade the collection and keep your eyes peeled for future drops.",
                "external_link": "https://www.sandbox.game/",
                "image_url": "https://lh3.googleusercontent.com/SXH8tW1siikB80rwCRnjm1a5xM_MwTg9Xl9Db6mioIk9HIlDM09pVoSR7GKJgS6ulSUpgW9BDtMk_ePX_NKgO9A=s60",
                "default_to_fiat": false,
                "dev_buyer_fee_basis_points": 0,
                "dev_seller_fee_basis_points": 500,
                "only_proxied_transfers": false,
                "opensea_buyer_fee_basis_points": 0,
                "opensea_seller_fee_basis_points": 250,
                "buyer_fee_basis_points": 0,
                "seller_fee_basis_points": 750,
                "payout_address": "0x7a9fe22691c811ea339d9b73150e6911a5343dca"
            },
            "permalink": "https://opensea.io/bundles/small-estate-9-lands-fTf",
            "sell_orders": [
                {
                    "created_date": "2021-05-25T21:35:00.407816",
                    "closing_date": null,
                    "closing_extendable": false,
                    "expiration_time": 0,
                    "listing_time": 1621978394,
                    "order_hash": "0x0401722829007208b9b8174adffc71772c3f73179cebc3c8d9afdff3450bba2a",
                    "metadata": {
                        "bundle": {
                            "assets": [
                                {
                                    "id": "77475",
                                    "address": "0x50f5474724e0ee42d9a4e711ccfb275809fd6d4a"
                                },
                                {
                                    "id": "77476",
                                    "address": "0x50f5474724e0ee42d9a4e711ccfb275809fd6d4a"
                                },
                                {
                                    "id": "77477",
                                    "address": "0x50f5474724e0ee42d9a4e711ccfb275809fd6d4a"
                                },
                                {
                                    "id": "77883",
                                    "address": "0x50f5474724e0ee42d9a4e711ccfb275809fd6d4a"
                                },
                                {
                                    "id": "77884",
                                    "address": "0x50f5474724e0ee42d9a4e711ccfb275809fd6d4a"
                                },
                                {
                                    "id": "77885",
                                    "address": "0x50f5474724e0ee42d9a4e711ccfb275809fd6d4a"
                                },
                                {
                                    "id": "78291",
                                    "address": "0x50f5474724e0ee42d9a4e711ccfb275809fd6d4a"
                                },
                                {
                                    "id": "78292",
                                    "address": "0x50f5474724e0ee42d9a4e711ccfb275809fd6d4a"
                                },
                                {
                                    "id": "78293",
                                    "address": "0x50f5474724e0ee42d9a4e711ccfb275809fd6d4a"
                                }
                            ],
                            "schemas": [
                                "ERC721",
                                "ERC721",
                                "ERC721",
                                "ERC721",
                                "ERC721",
                                "ERC721",
                                "ERC721",
                                "ERC721",
                                "ERC721"
                            ],
                            "name": "Small estate (9 lands)",
                            "description": "Yes, you can afford it :o))",
                            "external_link": ""
                        }
                    },
                    "exchange": "0x7be8076f4ea4a4ad08075c2508e481d6c946d12b",
                    "maker": {
                        "user": 3797,
                        "profile_img_url": "https://storage.googleapis.com/opensea-static/opensea-profile/25.png",
                        "address": "0xb6d820e80a2a7c49f94c9d6c8ea08dccedc9ce4c",
                        "config": "",
                        "discord_id": ""
                    },
                    "taker": {
                        "user": 1766,
                        "profile_img_url": "https://storage.googleapis.com/opensea-static/opensea-profile/1.png",
                        "address": "0x0000000000000000000000000000000000000000",
                        "config": "",
                        "discord_id": ""
                    },
                    "current_price": "135000000000000000000",
                    "current_bounty": "1350000000000000000",
                    "bounty_multiple": "0.01",
                    "maker_relayer_fee": "750",
                    "taker_relayer_fee": "0",
                    "maker_protocol_fee": "0",
                    "taker_protocol_fee": "0",
                    "maker_referrer_fee": "0",
                    "fee_recipient": {
                        "user": 3585,
                        "profile_img_url": "https://storage.googleapis.com/opensea-static/opensea-profile/28.png",
                        "address": "0x5b3256965e7c3cf26e11fcaf296dfc8807c01073",
                        "config": "verified",
                        "discord_id": ""
                    },
                    "fee_method": 1,
                    "side": 1,
                    "sale_kind": 0,
                    "target": "0xc99f70bfd82fb7c8f8191fdfbfb735606b15e5c5",
                    "how_to_call": 1,
                    "calldata": "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",
                    "replacement_pattern": "0x0000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000ffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffff0000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000ffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffff0000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000ffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffff0000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000ffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffff0000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000ffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffff0000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000ffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffff0000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000ffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffff0000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000ffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffff0000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000ffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffff000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000",
                    "static_target": "0x0000000000000000000000000000000000000000",
                    "static_extradata": "0x",
                    "payment_token": "0x0000000000000000000000000000000000000000",
                    "payment_token_contract": {
                        "id": 1,
                        "symbol": "ETH",
                        "address": "0x0000000000000000000000000000000000000000",
                        "image_url": "https://storage.opensea.io/files/6f8e2979d428180222796ff4a33ab929.svg",
                        "name": "Ether",
                        "decimals": 18,
                        "eth_price": "1.000000000000000",
                        "usd_price": "2625.730000000000018000"
                    },
                    "base_price": "135000000000000000000",
                    "extra": "0",
                    "quantity": "1",
                    "salt": "68739212113662148328281233623725729442515677636993161402962723056513542543061",
                    "v": 28,
                    "r": "0x60cde8d5ca94e7c5f281370a7d5812d49402687252be75244e70e94722ce56cc",
                    "s": "0x3f5dbe341db65247814474445916acffd49704334f0c2cb4b8bd090d4493ece3",
                    "approved_on_chain": false,
                    "cancelled": false,
                    "finalized": false,
                    "marked_invalid": false,
                    "prefixed_hash": "0x74b28ea094265263c77663b4f8baa32d03dac538ae3ccb7729c4c793f2a16be7"
                }
            ]
        },
        {
            "maker": {
                "user": {
                    "username": "Framboos"
                },
                "profile_img_url": "https://storage.googleapis.com/opensea-static/opensea-profile/12.png",
                "address": "0xc0b7baddb0631b81f305ed41ebbc8518706b0005",
                "config": "",
                "discord_id": ""
            },
            "slug": "ticket-ClP",
            "assets": [
                {
                    "id": 22775217,
                    "token_id": "71855948861368315935117884060099194885085341910626672500222055239698637389825",
                    "num_sales": 1,
                    "background_color": null,
                    "image_url": "https://lh3.googleusercontent.com/1KVS378dzNI8kS1u_ErrdqACWRUMbi5Lc7o_gYPGkIy4tYlNddpqU0LTpMGW4nDV-_D_SIKjMYf8xRupzxLQEkC_4UDJaVm_EB8iPQ",
                    "image_preview_url": "https://lh3.googleusercontent.com/1KVS378dzNI8kS1u_ErrdqACWRUMbi5Lc7o_gYPGkIy4tYlNddpqU0LTpMGW4nDV-_D_SIKjMYf8xRupzxLQEkC_4UDJaVm_EB8iPQ=s250",
                    "image_thumbnail_url": "https://lh3.googleusercontent.com/1KVS378dzNI8kS1u_ErrdqACWRUMbi5Lc7o_gYPGkIy4tYlNddpqU0LTpMGW4nDV-_D_SIKjMYf8xRupzxLQEkC_4UDJaVm_EB8iPQ=s128",
                    "image_original_url": null,
                    "animation_url": null,
                    "animation_original_url": null,
                    "name": "Mindvision 23 - Perfect Vibration",
                    "description": null,
                    "external_link": null,
                    "asset_contract": {
                        "address": "0x495f947276749ce646f68ac8c248420045cb7b5e",
                        "asset_contract_type": "semi-fungible",
                        "created_date": "2020-12-02T17:40:53.232025",
                        "name": "OpenSea Collection",
                        "nft_version": null,
                        "opensea_version": "2.0.0",
                        "owner": 102384,
                        "schema_name": "ERC1155",
                        "symbol": "OPENSTORE",
                        "total_supply": null,
                        "description": null,
                        "external_link": null,
                        "image_url": null,
                        "default_to_fiat": false,
                        "dev_buyer_fee_basis_points": 0,
                        "dev_seller_fee_basis_points": 0,
                        "only_proxied_transfers": false,
                        "opensea_buyer_fee_basis_points": 0,
                        "opensea_seller_fee_basis_points": 250,
                        "buyer_fee_basis_points": 0,
                        "seller_fee_basis_points": 250,
                        "payout_address": null
                    },
                    "owner": {
                        "user": {
                            "username": "NullAddress"
                        },
                        "profile_img_url": "https://storage.googleapis.com/opensea-static/opensea-profile/1.png",
                        "address": "0x0000000000000000000000000000000000000000",
                        "config": "",
                        "discord_id": ""
                    },
                    "permalink": "https://opensea.io/assets/0x495f947276749ce646f68ac8c248420045cb7b5e/71855948861368315935117884060099194885085341910626672500222055239698637389825",
                    "collection": {
                        "banner_image_url": "https://lh3.googleusercontent.com/HCJgi7tcGj4zzWjfzZlpirYhKrs8UqVj-Z14gLIJl_p5w7dLyMk6qxSOAv3hX-y3XcoN0te0DZwrr4UCQfPuUPYy_a0WPKtizQJcnQ=s2500",
                        "chat_url": null,
                        "created_date": "2021-04-15T13:11:07.390886",
                        "default_to_fiat": false,
                        "description": "Mindvisions is a collection of psychedelic gif. Every gif is unique. The chosen transformations are neither automatic nor generative. Each is manually created with care and choice for a specific view of the mind.\n\nOnly 100 psychedelic experiences \n\n- Enjoy your vision \n- Do not abuse drugs\n- Be safe",
                        "dev_buyer_fee_basis_points": "0",
                        "dev_seller_fee_basis_points": "1000",
                        "discord_url": null,
                        "display_data": {
                            "card_display_style": "contain"
                        },
                        "external_url": "https://mindvisions.carrd.co/",
                        "featured": false,
                        "featured_image_url": "https://lh3.googleusercontent.com/9c_qTzyjXIe6nfvIz6DQmwfCAuK0yv9h2O4PqpntzAR2t82iwTf0t8XQpo-ud0z1R0FSqEURGCxjIFSeVRBg_k0fKO1m_BbZCN7d8DA=s300",
                        "hidden": true,
                        "safelist_request_status": "not_requested",
                        "image_url": "https://lh3.googleusercontent.com/z63ZrtKG-ohYPZQ_Nwiy_6AWZ2iyB-lUgvUR4M_6wp-1tAj0rKItmuuCWCb79JhS037cInXCqKbeHt_edQzhUiwtelbhADp7WW6W=s120",
                        "is_subject_to_whitelist": false,
                        "large_image_url": "https://lh3.googleusercontent.com/9c_qTzyjXIe6nfvIz6DQmwfCAuK0yv9h2O4PqpntzAR2t82iwTf0t8XQpo-ud0z1R0FSqEURGCxjIFSeVRBg_k0fKO1m_BbZCN7d8DA=s300",
                        "medium_username": null,
                        "name": "Mindvisions",
                        "only_proxied_transfers": false,
                        "opensea_buyer_fee_basis_points": "0",
                        "opensea_seller_fee_basis_points": "250",
                        "payout_address": "0x9edd069accf979f744ce3fbbebf54507ead29a21",
                        "require_email": false,
                        "short_description": null,
                        "slug": "mindvisions",
                        "telegram_url": null,
                        "twitter_username": "https://twitter.com/kraotaxnft",
                        "instagram_username": null,
                        "wiki_url": null
                    },
                    "decimals": null,
                    "token_metadata": null
                },
                {
                    "id": 25021646,
                    "token_id": "5",
                    "num_sales": 29,
                    "background_color": null,
                    "image_url": "https://lh3.googleusercontent.com/VAvThZxO0pMS947VNNhvFeKu-1s00ECR11U592QMqUocJg78URFmBcTi0HcTLfumLu6lzpcCHGp-1U1teYx2KLs_5XKQM_tSpH8",
                    "image_preview_url": "https://lh3.googleusercontent.com/VAvThZxO0pMS947VNNhvFeKu-1s00ECR11U592QMqUocJg78URFmBcTi0HcTLfumLu6lzpcCHGp-1U1teYx2KLs_5XKQM_tSpH8=s250",
                    "image_thumbnail_url": "https://lh3.googleusercontent.com/VAvThZxO0pMS947VNNhvFeKu-1s00ECR11U592QMqUocJg78URFmBcTi0HcTLfumLu6lzpcCHGp-1U1teYx2KLs_5XKQM_tSpH8=s128",
                    "image_original_url": "https://ipfs.infura.io/ipfs/QmWm3mExQeJcKKVqtGKNgV4L2Ezi53XDrx9Z9Mdw22cgxJ",
                    "animation_url": null,
                    "animation_original_url": null,
                    "name": "NFTBoxes - May 2021 Ticket",
                    "description": "This Ticket entitles the owner to purchase one May 2021 NFTBoxes - Please note it expires after the sale - check the sale date before purchasing this ticket",
                    "external_link": null,
                    "asset_contract": {
                        "address": "0x5237e33d805339925aa5ab220f13b386357aa349",
                        "asset_contract_type": "semi-fungible",
                        "created_date": "2021-03-10T09:45:02.770628",
                        "name": "Unidentified contract",
                        "nft_version": null,
                        "opensea_version": null,
                        "owner": 20747194,
                        "schema_name": "ERC1155",
                        "symbol": "",
                        "total_supply": null,
                        "description": "NFTBoxes is a curated monthly box of NFTs on the newest gold standard of NFT technology.",
                        "external_link": "https://nftboxes.io/",
                        "image_url": "https://lh3.googleusercontent.com/idBAygWnojIvrPdHGzXYOwi4T6Fp7jgJSM6CIyXFknLWWT8IJH-hGhKsE6B5D4FCLBSScCHkvar15use94vnJfLDH7A50aV4JLXDnw=s120",
                        "default_to_fiat": false,
                        "dev_buyer_fee_basis_points": 0,
                        "dev_seller_fee_basis_points": 1000,
                        "only_proxied_transfers": false,
                        "opensea_buyer_fee_basis_points": 0,
                        "opensea_seller_fee_basis_points": 250,
                        "buyer_fee_basis_points": 0,
                        "seller_fee_basis_points": 1250,
                        "payout_address": "0x630e5968db317d711e714a43b2fc98ac9b0196fd"
                    },
                    "owner": {
                        "user": {
                            "username": "NullAddress"
                        },
                        "profile_img_url": "https://storage.googleapis.com/opensea-static/opensea-profile/1.png",
                        "address": "0x0000000000000000000000000000000000000000",
                        "config": "",
                        "discord_id": ""
                    },
                    "permalink": "https://opensea.io/assets/0x5237e33d805339925aa5ab220f13b386357aa349/5",
                    "collection": {
                        "banner_image_url": null,
                        "chat_url": null,
                        "created_date": "2021-02-19T10:06:34.504509",
                        "default_to_fiat": false,
                        "description": "NFTBoxes is a curated monthly box of NFTs on the newest gold standard of NFT technology.",
                        "dev_buyer_fee_basis_points": "0",
                        "dev_seller_fee_basis_points": "1000",
                        "discord_url": "https://discord.gg/eQWR2HBCYs",
                        "display_data": {
                            "card_display_style": "contain"
                        },
                        "external_url": "https://nftboxes.io/",
                        "featured": false,
                        "featured_image_url": "https://lh3.googleusercontent.com/JpR4Vwt8IGDgFCjiKNAJ6Bhn7LekLLfBkDP3kL8-rEWjgJMUc80rtnuzH5APrf9C4LC55neyjQMQa8AkXEKfZTTOejeGQ2hWlwayauc=s300",
                        "hidden": false,
                        "safelist_request_status": "verified",
                        "image_url": "https://lh3.googleusercontent.com/idBAygWnojIvrPdHGzXYOwi4T6Fp7jgJSM6CIyXFknLWWT8IJH-hGhKsE6B5D4FCLBSScCHkvar15use94vnJfLDH7A50aV4JLXDnw=s120",
                        "is_subject_to_whitelist": false,
                        "large_image_url": "https://lh3.googleusercontent.com/JpR4Vwt8IGDgFCjiKNAJ6Bhn7LekLLfBkDP3kL8-rEWjgJMUc80rtnuzH5APrf9C4LC55neyjQMQa8AkXEKfZTTOejeGQ2hWlwayauc=s300",
                        "medium_username": null,
                        "name": "NFTBoxes",
                        "only_proxied_transfers": false,
                        "opensea_buyer_fee_basis_points": "0",
                        "opensea_seller_fee_basis_points": "250",
                        "payout_address": "0x630e5968db317d711e714a43b2fc98ac9b0196fd",
                        "require_email": false,
                        "short_description": null,
                        "slug": "nftboxes",
                        "telegram_url": null,
                        "twitter_username": "nftboxes",
                        "instagram_username": null,
                        "wiki_url": null
                    },
                    "decimals": null,
                    "token_metadata": "https://gateway.pinata.cloud/ipfs/QmUKkbhuBJKkJPRGXG7AwFtqDgDpNH1FFTgpGE7pdE2yqP"
                }
            ],
            "name": "Ticket",
            "description": "",
            "external_link": "",
            "asset_contract": null,
            "permalink": "https://opensea.io/bundles/ticket-ClP",
            "sell_orders": [
                {
                    "created_date": "2021-05-25T21:32:44.113201",
                    "closing_date": "2021-05-30T21:31:30",
                    "closing_extendable": false,
                    "expiration_time": 1622410290,
                    "listing_time": 1621978256,
                    "order_hash": "0xd7f628bbc86c8d6a14a1e4aed7926e246d38b7d857fcee93a7d1ce49f6787808",
                    "metadata": {
                        "bundle": {
                            "assets": [
                                {
                                    "id": "71855948861368315935117884060099194885085341910626672500222055239698637389825",
                                    "address": "0x495f947276749ce646f68ac8c248420045cb7b5e",
                                    "quantity": "1"
                                },
                                {
                                    "id": "5",
                                    "address": "0x5237e33d805339925aa5ab220f13b386357aa349",
                                    "quantity": "1"
                                }
                            ],
                            "schemas": [
                                "ERC1155",
                                "ERC1155"
                            ],
                            "name": "Ticket",
                            "description": "",
                            "external_link": ""
                        }
                    },
                    "exchange": "0x7be8076f4ea4a4ad08075c2508e481d6c946d12b",
                    "maker": {
                        "user": 40123,
                        "profile_img_url": "https://storage.googleapis.com/opensea-static/opensea-profile/12.png",
                        "address": "0xc0b7baddb0631b81f305ed41ebbc8518706b0005",
                        "config": "",
                        "discord_id": ""
                    },
                    "taker": {
                        "user": 1766,
                        "profile_img_url": "https://storage.googleapis.com/opensea-static/opensea-profile/1.png",
                        "address": "0x0000000000000000000000000000000000000000",
                        "config": "",
                        "discord_id": ""
                    },
                    "current_price": "50000000000000000.00000000000",
                    "current_bounty": "500000000000000",
                    "bounty_multiple": "0.01",
                    "maker_relayer_fee": "250",
                    "taker_relayer_fee": "0",
                    "maker_protocol_fee": "0",
                    "taker_protocol_fee": "0",
                    "maker_referrer_fee": "0",
                    "fee_recipient": {
                        "user": 3585,
                        "profile_img_url": "https://storage.googleapis.com/opensea-static/opensea-profile/28.png",
                        "address": "0x5b3256965e7c3cf26e11fcaf296dfc8807c01073",
                        "config": "verified",
                        "discord_id": ""
                    },
                    "fee_method": 1,
                    "side": 1,
                    "sale_kind": 0,
                    "target": "0xc99f70bfd82fb7c8f8191fdfbfb735606b15e5c5",
                    "how_to_call": 1,
                    "calldata": "0x68f0bcaa000000000000000000000000000000000000000000000000000000000000008000000000000000000000000000000000000000000000000000000000000000e0000000000000000000000000000000000000000000000000000000000000014000000000000000000000000000000000000000000000000000000000000001a00000000000000000000000000000000000000000000000000000000000000002000000000000000000000000495f947276749ce646f68ac8c248420045cb7b5e0000000000000000000000005237e33d805339925aa5ab220f13b386357aa349000000000000000000000000000000000000000000000000000000000000000200000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000200000000000000000000000000000000000000000000000000000000000000c400000000000000000000000000000000000000000000000000000000000000c40000000000000000000000000000000000000000000000000000000000000188f242432a000000000000000000000000c0b7baddb0631b81f305ed41ebbc8518706b000500000000000000000000000000000000000000000000000000000000000000009edd069accf979f744ce3fbbebf54507ead29a21000000000000170000000001000000000000000000000000000000000000000000000000000000000000000100000000000000000000000000000000000000000000000000000000000000a00000000000000000000000000000000000000000000000000000000000000000f242432a000000000000000000000000c0b7baddb0631b81f305ed41ebbc8518706b000500000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000005000000000000000000000000000000000000000000000000000000000000000100000000000000000000000000000000000000000000000000000000000000a00000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000",
                    "replacement_pattern": "0x0000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000ffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffff0000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000ffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffff0000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000",
                    "static_target": "0x0000000000000000000000000000000000000000",
                    "static_extradata": "0x",
                    "payment_token": "0x0000000000000000000000000000000000000000",
                    "payment_token_contract": {
                        "id": 1,
                        "symbol": "ETH",
                        "address": "0x0000000000000000000000000000000000000000",
                        "image_url": "https://storage.opensea.io/files/6f8e2979d428180222796ff4a33ab929.svg",
                        "name": "Ether",
                        "decimals": 18,
                        "eth_price": "1.000000000000000",
                        "usd_price": "2625.730000000000018000"
                    },
                    "base_price": "50000000000000000",
                    "extra": "0",
                    "quantity": "1",
                    "salt": "84755681605297897394206076753241693355227300736671330685507757269129306422872",
                    "v": 28,
                    "r": "0xbe84623f4f1b58bc59274991703038418d854ff74eb92ba87dd4e473ebf65a52",
                    "s": "0x113a9b84fb7eaa46e01d81b92bf731bc2abfe43bf2d1a4e3f8bb837c493cdb85",
                    "approved_on_chain": false,
                    "cancelled": false,
                    "finalized": false,
                    "marked_invalid": false,
                    "prefixed_hash": "0x30c68bd9dd1edcb877d115520c3e0dca870fdca4572eca440025651c34e98202"
                }
            ]
        },
        {
            "maker": {
                "user": {
                    "username": null
                },
                "profile_img_url": "https://storage.googleapis.com/opensea-static/opensea-profile/25.png",
                "address": "0x2252a85e520fe2f29e0be62104d8551b32649c66",
                "config": "",
                "discord_id": ""
            },
            "slug": "2x-apymon-1x-1-75x-egg-Kff",
            "assets": [
                {
                    "id": 22431587,
                    "token_id": "2060",
                    "num_sales": 0,
                    "background_color": null,
                    "image_url": "https://lh3.googleusercontent.com/4Kbe2jDIQW_1qkYszJsXPmC4oPSTKpPhhf7W6NyNWW_Iq3na3LTiRU6vdHyqBvP1VvcA6JnbsEsnAv7OipFKE7y8oBf0IVlhpTHnHA",
                    "image_preview_url": "https://lh3.googleusercontent.com/4Kbe2jDIQW_1qkYszJsXPmC4oPSTKpPhhf7W6NyNWW_Iq3na3LTiRU6vdHyqBvP1VvcA6JnbsEsnAv7OipFKE7y8oBf0IVlhpTHnHA=s250",
                    "image_thumbnail_url": "https://lh3.googleusercontent.com/4Kbe2jDIQW_1qkYszJsXPmC4oPSTKpPhhf7W6NyNWW_Iq3na3LTiRU6vdHyqBvP1VvcA6JnbsEsnAv7OipFKE7y8oBf0IVlhpTHnHA=s128",
                    "image_original_url": "https://arweave.net/ZRJ6Gwo9l2ODFfsMS-zJDPOSXkz5ArKs3mYW3IrwB10",
                    "animation_url": null,
                    "animation_original_url": null,
                    "name": "Genesis Egg #2060",
                    "description": "Apymon is a collection of 6400 creatures created by AI which are contained in procedurally designed eggs. What makes these Genesis Eggs special is that they can hold other NFTs, ERC20 and ERC1155 tokens, making them function as your personal vault. No two Apymon creatures or Genesis Eggs are the same, each one is unique and crafted with love.",
                    "external_link": "https://apymon.com",
                    "asset_contract": {
                        "address": "0x9c008a22d71b6182029b694b0311486e4c0e53db",
                        "asset_contract_type": "non-fungible",
                        "created_date": "2021-04-13T22:14:12.881973",
                        "name": "Apymon",
                        "nft_version": "3.0",
                        "opensea_version": null,
                        "owner": 30104721,
                        "schema_name": "ERC721",
                        "symbol": "APYMON",
                        "total_supply": "0",
                        "description": "Apymon is a collection of 6400 creatures created by AI which are contained in procedurally designed eggs. What makes these Genesis Eggs special is that they can hold other NFTs, ERC20 and ERC1155 tokens, making them function as your personal vault. No two Apymon creatures or  Genesis Eggs are the same, each one is unique and crafted with love.\nMint your Genesis Egg at https://apymon.com\nFollow our Twitter (https://twitter.com/ApymonOfficial) for the latest news and join our Discord (https://discord.gg/apymon) to chat with the community",
                        "external_link": "https://apymon.com/",
                        "image_url": "https://lh3.googleusercontent.com/8OogKrYF_3kTL3w_8J_TwEWTn6E4OS_SP5EVdeAJnw7GycEJJy36uZYkLKoMnrX-ObWNYlMpEIu5fGoRMtJrkL8HRnVz4gY8jrD2Cw=s120",
                        "default_to_fiat": false,
                        "dev_buyer_fee_basis_points": 0,
                        "dev_seller_fee_basis_points": 0,
                        "only_proxied_transfers": false,
                        "opensea_buyer_fee_basis_points": 0,
                        "opensea_seller_fee_basis_points": 250,
                        "buyer_fee_basis_points": 0,
                        "seller_fee_basis_points": 250,
                        "payout_address": null
                    },
                    "owner": {
                        "user": {
                            "username": null
                        },
                        "profile_img_url": "https://storage.googleapis.com/opensea-static/opensea-profile/25.png",
                        "address": "0x2252a85e520fe2f29e0be62104d8551b32649c66",
                        "config": "",
                        "discord_id": ""
                    },
                    "permalink": "https://opensea.io/assets/0x9c008a22d71b6182029b694b0311486e4c0e53db/2060",
                    "collection": {
                        "banner_image_url": "https://lh3.googleusercontent.com/fdO2dxomM3FxkZiO7B8c-ie6Dj3VfhOlmYy-VgHsjkaFpjvfyd3a4wmglM9fLdpc4n9_s_bY_6MAzOmHacl5LApQ4agG4YEtCboMMd4=s2500",
                        "chat_url": null,
                        "created_date": "2021-04-13T23:45:21.662101",
                        "default_to_fiat": false,
                        "description": "Apymon is a collection of 6400 creatures created by AI which are contained in procedurally designed eggs. What makes these Genesis Eggs special is that they can hold other NFTs, ERC20 and ERC1155 tokens, making them function as your personal vault. No two Apymon creatures or  Genesis Eggs are the same, each one is unique and crafted with love.\nMint your Genesis Egg at https://apymon.com\nFollow our Twitter (https://twitter.com/ApymonOfficial) for the latest news and join our Discord (https://discord.gg/apymon) to chat with the community",
                        "dev_buyer_fee_basis_points": "0",
                        "dev_seller_fee_basis_points": "0",
                        "discord_url": "https://discord.gg/K2PQnsJR7h",
                        "display_data": {
                            "card_display_style": "contain"
                        },
                        "external_url": "https://apymon.com/",
                        "featured": false,
                        "featured_image_url": "https://lh3.googleusercontent.com/tr5SJmi42FEob8GHgBZj4CG1w-J_b2jK2TwjguvUrSZDWsTQDM9er-jdTfHnv7rfAbHy6wpkwOXVYz1HvS1M7u-QgkOj5rrv-jk8zw=s300",
                        "hidden": false,
                        "safelist_request_status": "approved",
                        "image_url": "https://lh3.googleusercontent.com/8OogKrYF_3kTL3w_8J_TwEWTn6E4OS_SP5EVdeAJnw7GycEJJy36uZYkLKoMnrX-ObWNYlMpEIu5fGoRMtJrkL8HRnVz4gY8jrD2Cw=s120",
                        "is_subject_to_whitelist": false,
                        "large_image_url": "https://lh3.googleusercontent.com/tr5SJmi42FEob8GHgBZj4CG1w-J_b2jK2TwjguvUrSZDWsTQDM9er-jdTfHnv7rfAbHy6wpkwOXVYz1HvS1M7u-QgkOj5rrv-jk8zw=s300",
                        "medium_username": "apymon",
                        "name": "Apymon",
                        "only_proxied_transfers": false,
                        "opensea_buyer_fee_basis_points": "0",
                        "opensea_seller_fee_basis_points": "250",
                        "payout_address": null,
                        "require_email": false,
                        "short_description": null,
                        "slug": "apymon",
                        "telegram_url": null,
                        "twitter_username": "ApymonOfficial",
                        "instagram_username": null,
                        "wiki_url": null
                    },
                    "decimals": 0,
                    "token_metadata": "https://gateway.pinata.cloud/ipfs/QmbbsQmfaoX41xKh2g3Ng563WMQ1BmeaQC2BnoaUkT7DHQ/2060"
                },
                {
                    "id": 25506629,
                    "token_id": "1685",
                    "num_sales": 0,
                    "background_color": null,
                    "image_url": "https://lh3.googleusercontent.com/Gh0Ab8lj3LMn9hW8HIDf2PoL9FoYiaFP7XvgvXTO-enQAbnKAQT_p2ZKYsv8IFWRt3vo_nGLplqAKUHVdRB06zh6A4Syc2dkccyxOQ",
                    "image_preview_url": "https://lh3.googleusercontent.com/Gh0Ab8lj3LMn9hW8HIDf2PoL9FoYiaFP7XvgvXTO-enQAbnKAQT_p2ZKYsv8IFWRt3vo_nGLplqAKUHVdRB06zh6A4Syc2dkccyxOQ=s250",
                    "image_thumbnail_url": "https://lh3.googleusercontent.com/Gh0Ab8lj3LMn9hW8HIDf2PoL9FoYiaFP7XvgvXTO-enQAbnKAQT_p2ZKYsv8IFWRt3vo_nGLplqAKUHVdRB06zh6A4Syc2dkccyxOQ=s128",
                    "image_original_url": "https://arweave.net/XKOiPDINxbIMrjshCBfV7iiSObf6xOTgyERTaU1dEYQ",
                    "animation_url": null,
                    "animation_original_url": null,
                    "name": "Apymon Monsters #1685",
                    "description": null,
                    "external_link": "https://apymon.com",
                    "asset_contract": {
                        "address": "0x6e0baaa0d1c11dc160143c0c7213df76acdf4e17",
                        "asset_contract_type": "non-fungible",
                        "created_date": "2021-05-18T16:21:48.758011",
                        "name": "Apymon Monsters",
                        "nft_version": "3.0",
                        "opensea_version": null,
                        "owner": 30104721,
                        "schema_name": "ERC721",
                        "symbol": "APYM",
                        "total_supply": "0",
                        "description": "The NFT built by ERC721, Apymon Monsters, on Ethereum.",
                        "external_link": null,
                        "image_url": "https://lh3.googleusercontent.com/nCcUQe3w8k7omeB6DSrP4Y792JQaRLfqFv6SFzDxab1k44mR7kT9p8d4-m_X6iEfr47RGup5wCdP2s2RS1Y88-KaeElQgyzTs4cc=s120",
                        "default_to_fiat": false,
                        "dev_buyer_fee_basis_points": 0,
                        "dev_seller_fee_basis_points": 0,
                        "only_proxied_transfers": false,
                        "opensea_buyer_fee_basis_points": 0,
                        "opensea_seller_fee_basis_points": 250,
                        "buyer_fee_basis_points": 0,
                        "seller_fee_basis_points": 250,
                        "payout_address": null
                    },
                    "owner": {
                        "user": {
                            "username": null
                        },
                        "profile_img_url": "https://storage.googleapis.com/opensea-static/opensea-profile/25.png",
                        "address": "0x2252a85e520fe2f29e0be62104d8551b32649c66",
                        "config": "",
                        "discord_id": ""
                    },
                    "permalink": "https://opensea.io/assets/0x6e0baaa0d1c11dc160143c0c7213df76acdf4e17/1685",
                    "collection": {
                        "banner_image_url": "https://lh3.googleusercontent.com/xsxkSFVINW-MV2mnqiv5PN6uFynoq-ev16uvOIgkz73GODzvFeM7wOmBM7OkxGmhv1GHpP-t31VqHcEvfScUfAnfiDT-zGS_Y30C=s2500",
                        "chat_url": null,
                        "created_date": "2021-05-18T16:59:45.948886",
                        "default_to_fiat": false,
                        "description": "The NFT built by ERC721, Apymon Monsters, on Ethereum.",
                        "dev_buyer_fee_basis_points": "0",
                        "dev_seller_fee_basis_points": "0",
                        "discord_url": null,
                        "display_data": {
                            "card_display_style": "contain"
                        },
                        "external_url": null,
                        "featured": false,
                        "featured_image_url": "https://lh3.googleusercontent.com/hybKwm5kYCjE_IIF4DiObNzaHYVOH0Xenx3ye8domy0ssj1SQB7L7j0krdp8dFFiR8ZTznf16HX70btLTblWUqS-wxaFqbAencUTyw=s300",
                        "hidden": true,
                        "safelist_request_status": "not_requested",
                        "image_url": "https://lh3.googleusercontent.com/nCcUQe3w8k7omeB6DSrP4Y792JQaRLfqFv6SFzDxab1k44mR7kT9p8d4-m_X6iEfr47RGup5wCdP2s2RS1Y88-KaeElQgyzTs4cc=s120",
                        "is_subject_to_whitelist": false,
                        "large_image_url": "https://lh3.googleusercontent.com/hybKwm5kYCjE_IIF4DiObNzaHYVOH0Xenx3ye8domy0ssj1SQB7L7j0krdp8dFFiR8ZTznf16HX70btLTblWUqS-wxaFqbAencUTyw=s300",
                        "medium_username": null,
                        "name": "Apymon Monsters",
                        "only_proxied_transfers": false,
                        "opensea_buyer_fee_basis_points": "0",
                        "opensea_seller_fee_basis_points": "250",
                        "payout_address": null,
                        "require_email": false,
                        "short_description": null,
                        "slug": "apymon-monsters",
                        "telegram_url": null,
                        "twitter_username": null,
                        "instagram_username": null,
                        "wiki_url": null
                    },
                    "decimals": 0,
                    "token_metadata": "https://gateway.pinata.cloud/ipfs/QmTQeQgS5Xa5WiDzuGS5RCKe8z74CgfiuA5cADPXLVX7uB/1685"
                },
                {
                    "id": 25506656,
                    "token_id": "1691",
                    "num_sales": 0,
                    "background_color": null,
                    "image_url": "https://lh3.googleusercontent.com/pRLD6lIDkgHydqXmqeT2FSuJhnU7iRocbVsexzZHTmFFp1YEM2CwfNyqXUtcev88NYfDDeF5oG2o45osqSse3GqdCi6OgTv0H9-ntQ",
                    "image_preview_url": "https://lh3.googleusercontent.com/pRLD6lIDkgHydqXmqeT2FSuJhnU7iRocbVsexzZHTmFFp1YEM2CwfNyqXUtcev88NYfDDeF5oG2o45osqSse3GqdCi6OgTv0H9-ntQ=s250",
                    "image_thumbnail_url": "https://lh3.googleusercontent.com/pRLD6lIDkgHydqXmqeT2FSuJhnU7iRocbVsexzZHTmFFp1YEM2CwfNyqXUtcev88NYfDDeF5oG2o45osqSse3GqdCi6OgTv0H9-ntQ=s128",
                    "image_original_url": "https://arweave.net/dcV21giA2woHw2iUl9z3fvwLQdfDA8L4U8jsIdBNlVQ",
                    "animation_url": null,
                    "animation_original_url": null,
                    "name": "Apymon Monsters #1691",
                    "description": null,
                    "external_link": "https://apymon.com",
                    "asset_contract": {
                        "address": "0x6e0baaa0d1c11dc160143c0c7213df76acdf4e17",
                        "asset_contract_type": "non-fungible",
                        "created_date": "2021-05-18T16:21:48.758011",
                        "name": "Apymon Monsters",
                        "nft_version": "3.0",
                        "opensea_version": null,
                        "owner": 30104721,
                        "schema_name": "ERC721",
                        "symbol": "APYM",
                        "total_supply": "0",
                        "description": "The NFT built by ERC721, Apymon Monsters, on Ethereum.",
                        "external_link": null,
                        "image_url": "https://lh3.googleusercontent.com/nCcUQe3w8k7omeB6DSrP4Y792JQaRLfqFv6SFzDxab1k44mR7kT9p8d4-m_X6iEfr47RGup5wCdP2s2RS1Y88-KaeElQgyzTs4cc=s120",
                        "default_to_fiat": false,
                        "dev_buyer_fee_basis_points": 0,
                        "dev_seller_fee_basis_points": 0,
                        "only_proxied_transfers": false,
                        "opensea_buyer_fee_basis_points": 0,
                        "opensea_seller_fee_basis_points": 250,
                        "buyer_fee_basis_points": 0,
                        "seller_fee_basis_points": 250,
                        "payout_address": null
                    },
                    "owner": {
                        "user": {
                            "username": null
                        },
                        "profile_img_url": "https://storage.googleapis.com/opensea-static/opensea-profile/25.png",
                        "address": "0x2252a85e520fe2f29e0be62104d8551b32649c66",
                        "config": "",
                        "discord_id": ""
                    },
                    "permalink": "https://opensea.io/assets/0x6e0baaa0d1c11dc160143c0c7213df76acdf4e17/1691",
                    "collection": {
                        "banner_image_url": "https://lh3.googleusercontent.com/xsxkSFVINW-MV2mnqiv5PN6uFynoq-ev16uvOIgkz73GODzvFeM7wOmBM7OkxGmhv1GHpP-t31VqHcEvfScUfAnfiDT-zGS_Y30C=s2500",
                        "chat_url": null,
                        "created_date": "2021-05-18T16:59:45.948886",
                        "default_to_fiat": false,
                        "description": "The NFT built by ERC721, Apymon Monsters, on Ethereum.",
                        "dev_buyer_fee_basis_points": "0",
                        "dev_seller_fee_basis_points": "0",
                        "discord_url": null,
                        "display_data": {
                            "card_display_style": "contain"
                        },
                        "external_url": null,
                        "featured": false,
                        "featured_image_url": "https://lh3.googleusercontent.com/hybKwm5kYCjE_IIF4DiObNzaHYVOH0Xenx3ye8domy0ssj1SQB7L7j0krdp8dFFiR8ZTznf16HX70btLTblWUqS-wxaFqbAencUTyw=s300",
                        "hidden": true,
                        "safelist_request_status": "not_requested",
                        "image_url": "https://lh3.googleusercontent.com/nCcUQe3w8k7omeB6DSrP4Y792JQaRLfqFv6SFzDxab1k44mR7kT9p8d4-m_X6iEfr47RGup5wCdP2s2RS1Y88-KaeElQgyzTs4cc=s120",
                        "is_subject_to_whitelist": false,
                        "large_image_url": "https://lh3.googleusercontent.com/hybKwm5kYCjE_IIF4DiObNzaHYVOH0Xenx3ye8domy0ssj1SQB7L7j0krdp8dFFiR8ZTznf16HX70btLTblWUqS-wxaFqbAencUTyw=s300",
                        "medium_username": null,
                        "name": "Apymon Monsters",
                        "only_proxied_transfers": false,
                        "opensea_buyer_fee_basis_points": "0",
                        "opensea_seller_fee_basis_points": "250",
                        "payout_address": null,
                        "require_email": false,
                        "short_description": null,
                        "slug": "apymon-monsters",
                        "telegram_url": null,
                        "twitter_username": null,
                        "instagram_username": null,
                        "wiki_url": null
                    },
                    "decimals": 0,
                    "token_metadata": "https://gateway.pinata.cloud/ipfs/QmTQeQgS5Xa5WiDzuGS5RCKe8z74CgfiuA5cADPXLVX7uB/1691"
                }
            ],
            "name": "2x Apymon, 1x 1.75x egg",
            "description": "",
            "external_link": "",
            "asset_contract": null,
            "permalink": "https://opensea.io/bundles/2x-apymon-1x-1-75x-egg-Kff",
            "sell_orders": [
                {
                    "created_date": "2021-05-25T21:29:35.584393",
                    "closing_date": null,
                    "closing_extendable": false,
                    "expiration_time": 0,
                    "listing_time": 1621977991,
                    "order_hash": "0x3317039db4e956c5a878cfbb3c5b28f7c4dc228ab4b7057614d29c9f81a6e6ac",
                    "metadata": {
                        "bundle": {
                            "assets": [
                                {
                                    "id": "1685",
                                    "address": "0x6e0baaa0d1c11dc160143c0c7213df76acdf4e17"
                                },
                                {
                                    "id": "1691",
                                    "address": "0x6e0baaa0d1c11dc160143c0c7213df76acdf4e17"
                                },
                                {
                                    "id": "2060",
                                    "address": "0x9c008a22d71b6182029b694b0311486e4c0e53db"
                                }
                            ],
                            "schemas": [
                                "ERC721",
                                "ERC721",
                                "ERC721"
                            ],
                            "name": "2x Apymon, 1x 1.75x egg",
                            "description": "",
                            "external_link": ""
                        }
                    },
                    "exchange": "0x7be8076f4ea4a4ad08075c2508e481d6c946d12b",
                    "maker": {
                        "user": 116145,
                        "profile_img_url": "https://storage.googleapis.com/opensea-static/opensea-profile/25.png",
                        "address": "0x2252a85e520fe2f29e0be62104d8551b32649c66",
                        "config": "",
                        "discord_id": ""
                    },
                    "taker": {
                        "user": 1766,
                        "profile_img_url": "https://storage.googleapis.com/opensea-static/opensea-profile/1.png",
                        "address": "0x0000000000000000000000000000000000000000",
                        "config": "",
                        "discord_id": ""
                    },
                    "current_price": "380000000000000000",
                    "current_bounty": "3800000000000000",
                    "bounty_multiple": "0.01",
                    "maker_relayer_fee": "250",
                    "taker_relayer_fee": "0",
                    "maker_protocol_fee": "0",
                    "taker_protocol_fee": "0",
                    "maker_referrer_fee": "0",
                    "fee_recipient": {
                        "user": 3585,
                        "profile_img_url": "https://storage.googleapis.com/opensea-static/opensea-profile/28.png",
                        "address": "0x5b3256965e7c3cf26e11fcaf296dfc8807c01073",
                        "config": "verified",
                        "discord_id": ""
                    },
                    "fee_method": 1,
                    "side": 1,
                    "sale_kind": 0,
                    "target": "0xc99f70bfd82fb7c8f8191fdfbfb735606b15e5c5",
                    "how_to_call": 1,
                    "calldata": "0x68f0bcaa000000000000000000000000000000000000000000000000000000000000008000000000000000000000000000000000000000000000000000000000000001000000000000000000000000000000000000000000000000000000000000000180000000000000000000000000000000000000000000000000000000000000020000000000000000000000000000000000000000000000000000000000000000030000000000000000000000006e0baaa0d1c11dc160143c0c7213df76acdf4e170000000000000000000000006e0baaa0d1c11dc160143c0c7213df76acdf4e170000000000000000000000009c008a22d71b6182029b694b0311486e4c0e53db00000000000000000000000000000000000000000000000000000000000000030000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000003000000000000000000000000000000000000000000000000000000000000006400000000000000000000000000000000000000000000000000000000000000640000000000000000000000000000000000000000000000000000000000000064000000000000000000000000000000000000000000000000000000000000012c23b872dd0000000000000000000000002252a85e520fe2f29e0be62104d8551b32649c660000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000069523b872dd0000000000000000000000002252a85e520fe2f29e0be62104d8551b32649c660000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000069b23b872dd0000000000000000000000002252a85e520fe2f29e0be62104d8551b32649c660000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000080c0000000000000000000000000000000000000000",
                    "replacement_pattern": "0x0000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000ffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffff0000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000ffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffff0000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000ffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffff00000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000",
                    "static_target": "0x0000000000000000000000000000000000000000",
                    "static_extradata": "0x",
                    "payment_token": "0x0000000000000000000000000000000000000000",
                    "payment_token_contract": {
                        "id": 1,
                        "symbol": "ETH",
                        "address": "0x0000000000000000000000000000000000000000",
                        "image_url": "https://storage.opensea.io/files/6f8e2979d428180222796ff4a33ab929.svg",
                        "name": "Ether",
                        "decimals": 18,
                        "eth_price": "1.000000000000000",
                        "usd_price": "2625.730000000000018000"
                    },
                    "base_price": "380000000000000000",
                    "extra": "0",
                    "quantity": "1",
                    "salt": "66365918755986303268761822683397188555767622927587638130644272485902980441951",
                    "v": 28,
                    "r": "0xda322505c1fc61fbd7f2abe76330d0e61c3bb579863798386e73c2a45990c855",
                    "s": "0x1d019f87b0f2603be5ec91457a06a10010882d73cbf93e0dcc3de14c69c9a42d",
                    "approved_on_chain": false,
                    "cancelled": false,
                    "finalized": false,
                    "marked_invalid": false,
                    "prefixed_hash": "0x27952471237a085969e88afd086b0f2b6a8e141881df00711547b034dc1c067a"
                }
            ]
        },
        {
            "maker": {
                "user": {
                    "username": "wedfr"
                },
                "profile_img_url": "https://storage.googleapis.com/opensea-static/opensea-profile/14.png",
                "address": "0x436317eef036eb72e74812dcea5c31a945724f77",
                "config": "",
                "discord_id": ""
            },
            "slug": "first-milestone-amp",
            "assets": [
                {
                    "id": 23277349,
                    "token_id": "80494307024529346018053650490912529916739680814770830097664395504035580346369",
                    "num_sales": 1,
                    "background_color": null,
                    "image_url": "https://lh3.googleusercontent.com/zqhvbLiHT8bs8zT2usEAC0h1DYW8fW3p2oQdakSW-lQtjTcW4Dn5Yhhzz3vPhUhK5MN_-A6qvB542PImJy3TpJMauhcM_Nyaa05YqsA",
                    "image_preview_url": "https://lh3.googleusercontent.com/zqhvbLiHT8bs8zT2usEAC0h1DYW8fW3p2oQdakSW-lQtjTcW4Dn5Yhhzz3vPhUhK5MN_-A6qvB542PImJy3TpJMauhcM_Nyaa05YqsA=s250",
                    "image_thumbnail_url": "https://lh3.googleusercontent.com/zqhvbLiHT8bs8zT2usEAC0h1DYW8fW3p2oQdakSW-lQtjTcW4Dn5Yhhzz3vPhUhK5MN_-A6qvB542PImJy3TpJMauhcM_Nyaa05YqsA=s128",
                    "image_original_url": null,
                    "animation_url": null,
                    "animation_original_url": null,
                    "name": "Ghxst 026",
                    "description": "026/100",
                    "external_link": null,
                    "asset_contract": {
                        "address": "0x495f947276749ce646f68ac8c248420045cb7b5e",
                        "asset_contract_type": "semi-fungible",
                        "created_date": "2020-12-02T17:40:53.232025",
                        "name": "OpenSea Collection",
                        "nft_version": null,
                        "opensea_version": "2.0.0",
                        "owner": 102384,
                        "schema_name": "ERC1155",
                        "symbol": "OPENSTORE",
                        "total_supply": null,
                        "description": null,
                        "external_link": null,
                        "image_url": null,
                        "default_to_fiat": false,
                        "dev_buyer_fee_basis_points": 0,
                        "dev_seller_fee_basis_points": 0,
                        "only_proxied_transfers": false,
                        "opensea_buyer_fee_basis_points": 0,
                        "opensea_seller_fee_basis_points": 250,
                        "buyer_fee_basis_points": 0,
                        "seller_fee_basis_points": 250,
                        "payout_address": null
                    },
                    "owner": {
                        "user": {
                            "username": "NullAddress"
                        },
                        "profile_img_url": "https://storage.googleapis.com/opensea-static/opensea-profile/1.png",
                        "address": "0x0000000000000000000000000000000000000000",
                        "config": "",
                        "discord_id": ""
                    },
                    "permalink": "https://opensea.io/assets/0x495f947276749ce646f68ac8c248420045cb7b5e/80494307024529346018053650490912529916739680814770830097664395504035580346369",
                    "collection": {
                        "banner_image_url": "https://lh3.googleusercontent.com/4XSyHJVve1Mf46CW06BJp4-pBY3O8Pf3plqcVul2OgehwRAiCf0AWVmABV1s9A-qiqyDA_f7T5f8BHmzVRQ3RCRllfcQNxlIcTvkaQ=s2500",
                        "chat_url": null,
                        "created_date": "2021-05-02T00:12:04.318582",
                        "default_to_fiat": false,
                        "description": "101/101 Ghxsts rescued.\n21/43 Immxrtals born.\n20/50 Demxns saved.\n",
                        "dev_buyer_fee_basis_points": "0",
                        "dev_seller_fee_basis_points": "1000",
                        "discord_url": "https://discord.gg/yT88JmnQew",
                        "display_data": {
                            "card_display_style": "contain"
                        },
                        "external_url": null,
                        "featured": false,
                        "featured_image_url": "https://lh3.googleusercontent.com/uVziXd8Q64_zvofgrKFp5SmrcObngHoVWZMJQOHAZ3bdERsO4GaYvQcuGsz0ofr8zy8iajJdNQHCwFkSdBmkVy_osTPvoAuQFv489g=s300",
                        "hidden": false,
                        "safelist_request_status": "approved",
                        "image_url": "https://lh3.googleusercontent.com/uVziXd8Q64_zvofgrKFp5SmrcObngHoVWZMJQOHAZ3bdERsO4GaYvQcuGsz0ofr8zy8iajJdNQHCwFkSdBmkVy_osTPvoAuQFv489g=s120",
                        "is_subject_to_whitelist": false,
                        "large_image_url": "https://lh3.googleusercontent.com/uVziXd8Q64_zvofgrKFp5SmrcObngHoVWZMJQOHAZ3bdERsO4GaYvQcuGsz0ofr8zy8iajJdNQHCwFkSdBmkVy_osTPvoAuQFv489g=s300",
                        "medium_username": null,
                        "name": "Ghxsts",
                        "only_proxied_transfers": false,
                        "opensea_buyer_fee_basis_points": "0",
                        "opensea_seller_fee_basis_points": "250",
                        "payout_address": "0xb1f629cb1b6841e5ac98aa5b1cffab1b6c88d8b7",
                        "require_email": false,
                        "short_description": null,
                        "slug": "ghxsts",
                        "telegram_url": null,
                        "twitter_username": "GhxstNFT",
                        "instagram_username": null,
                        "wiki_url": null
                    },
                    "decimals": null,
                    "token_metadata": null
                },
                {
                    "id": 23895227,
                    "token_id": "80494307024529346018053650490912529916739680814770830097664395551314580340737",
                    "num_sales": 1,
                    "background_color": null,
                    "image_url": "https://lh3.googleusercontent.com/mSMlRJxbyhqeQcmV5EhnLupzsvZnIBgww1eTa4df2aBne-WAs_JcEaYGodH8O57-EpNg6270wCJ6oqBIfFBxmGWfb1wzFgSU376l",
                    "image_preview_url": "https://lh3.googleusercontent.com/mSMlRJxbyhqeQcmV5EhnLupzsvZnIBgww1eTa4df2aBne-WAs_JcEaYGodH8O57-EpNg6270wCJ6oqBIfFBxmGWfb1wzFgSU376l=s250",
                    "image_thumbnail_url": "https://lh3.googleusercontent.com/mSMlRJxbyhqeQcmV5EhnLupzsvZnIBgww1eTa4df2aBne-WAs_JcEaYGodH8O57-EpNg6270wCJ6oqBIfFBxmGWfb1wzFgSU376l=s128",
                    "image_original_url": null,
                    "animation_url": null,
                    "animation_original_url": null,
                    "name": "Ghxst 069",
                    "description": "069/100",
                    "external_link": null,
                    "asset_contract": {
                        "address": "0x495f947276749ce646f68ac8c248420045cb7b5e",
                        "asset_contract_type": "semi-fungible",
                        "created_date": "2020-12-02T17:40:53.232025",
                        "name": "OpenSea Collection",
                        "nft_version": null,
                        "opensea_version": "2.0.0",
                        "owner": 102384,
                        "schema_name": "ERC1155",
                        "symbol": "OPENSTORE",
                        "total_supply": null,
                        "description": null,
                        "external_link": null,
                        "image_url": null,
                        "default_to_fiat": false,
                        "dev_buyer_fee_basis_points": 0,
                        "dev_seller_fee_basis_points": 0,
                        "only_proxied_transfers": false,
                        "opensea_buyer_fee_basis_points": 0,
                        "opensea_seller_fee_basis_points": 250,
                        "buyer_fee_basis_points": 0,
                        "seller_fee_basis_points": 250,
                        "payout_address": null
                    },
                    "owner": {
                        "user": {
                            "username": "NullAddress"
                        },
                        "profile_img_url": "https://storage.googleapis.com/opensea-static/opensea-profile/1.png",
                        "address": "0x0000000000000000000000000000000000000000",
                        "config": "",
                        "discord_id": ""
                    },
                    "permalink": "https://opensea.io/assets/0x495f947276749ce646f68ac8c248420045cb7b5e/80494307024529346018053650490912529916739680814770830097664395551314580340737",
                    "collection": {
                        "banner_image_url": "https://lh3.googleusercontent.com/4XSyHJVve1Mf46CW06BJp4-pBY3O8Pf3plqcVul2OgehwRAiCf0AWVmABV1s9A-qiqyDA_f7T5f8BHmzVRQ3RCRllfcQNxlIcTvkaQ=s2500",
                        "chat_url": null,
                        "created_date": "2021-05-02T00:12:04.318582",
                        "default_to_fiat": false,
                        "description": "101/101 Ghxsts rescued.\n21/43 Immxrtals born.\n20/50 Demxns saved.\n",
                        "dev_buyer_fee_basis_points": "0",
                        "dev_seller_fee_basis_points": "1000",
                        "discord_url": "https://discord.gg/yT88JmnQew",
                        "display_data": {
                            "card_display_style": "contain"
                        },
                        "external_url": null,
                        "featured": false,
                        "featured_image_url": "https://lh3.googleusercontent.com/uVziXd8Q64_zvofgrKFp5SmrcObngHoVWZMJQOHAZ3bdERsO4GaYvQcuGsz0ofr8zy8iajJdNQHCwFkSdBmkVy_osTPvoAuQFv489g=s300",
                        "hidden": false,
                        "safelist_request_status": "approved",
                        "image_url": "https://lh3.googleusercontent.com/uVziXd8Q64_zvofgrKFp5SmrcObngHoVWZMJQOHAZ3bdERsO4GaYvQcuGsz0ofr8zy8iajJdNQHCwFkSdBmkVy_osTPvoAuQFv489g=s120",
                        "is_subject_to_whitelist": false,
                        "large_image_url": "https://lh3.googleusercontent.com/uVziXd8Q64_zvofgrKFp5SmrcObngHoVWZMJQOHAZ3bdERsO4GaYvQcuGsz0ofr8zy8iajJdNQHCwFkSdBmkVy_osTPvoAuQFv489g=s300",
                        "medium_username": null,
                        "name": "Ghxsts",
                        "only_proxied_transfers": false,
                        "opensea_buyer_fee_basis_points": "0",
                        "opensea_seller_fee_basis_points": "250",
                        "payout_address": "0xb1f629cb1b6841e5ac98aa5b1cffab1b6c88d8b7",
                        "require_email": false,
                        "short_description": null,
                        "slug": "ghxsts",
                        "telegram_url": null,
                        "twitter_username": "GhxstNFT",
                        "instagram_username": null,
                        "wiki_url": null
                    },
                    "decimals": null,
                    "token_metadata": null
                },
                {
                    "id": 25596662,
                    "token_id": "80494307024529346018053650490912529916739680814770830097664395653569161723905",
                    "num_sales": 0,
                    "background_color": null,
                    "image_url": "https://lh3.googleusercontent.com/r3_UHbsIZyms0ZNaT_lODDPCjHyp2e8OgGV08SJWiaqRlrmxjg05lCt-D6HlI5k8HzSIMeLX31BxBA9uQPh0Rgy0jv6vGfP7VvZP7w",
                    "image_preview_url": "https://lh3.googleusercontent.com/r3_UHbsIZyms0ZNaT_lODDPCjHyp2e8OgGV08SJWiaqRlrmxjg05lCt-D6HlI5k8HzSIMeLX31BxBA9uQPh0Rgy0jv6vGfP7VvZP7w=s250",
                    "image_thumbnail_url": "https://lh3.googleusercontent.com/r3_UHbsIZyms0ZNaT_lODDPCjHyp2e8OgGV08SJWiaqRlrmxjg05lCt-D6HlI5k8HzSIMeLX31BxBA9uQPh0Rgy0jv6vGfP7VvZP7w=s128",
                    "image_original_url": null,
                    "animation_url": null,
                    "animation_original_url": null,
                    "name": "Immxrtal 26:69",
                    "description": "An Immxrtal born from the souls of Ghxsts 026 and 069. Finally at peace, free from pain.",
                    "external_link": null,
                    "asset_contract": {
                        "address": "0x495f947276749ce646f68ac8c248420045cb7b5e",
                        "asset_contract_type": "semi-fungible",
                        "created_date": "2020-12-02T17:40:53.232025",
                        "name": "OpenSea Collection",
                        "nft_version": null,
                        "opensea_version": "2.0.0",
                        "owner": 102384,
                        "schema_name": "ERC1155",
                        "symbol": "OPENSTORE",
                        "total_supply": null,
                        "description": null,
                        "external_link": null,
                        "image_url": null,
                        "default_to_fiat": false,
                        "dev_buyer_fee_basis_points": 0,
                        "dev_seller_fee_basis_points": 0,
                        "only_proxied_transfers": false,
                        "opensea_buyer_fee_basis_points": 0,
                        "opensea_seller_fee_basis_points": 250,
                        "buyer_fee_basis_points": 0,
                        "seller_fee_basis_points": 250,
                        "payout_address": null
                    },
                    "owner": {
                        "user": {
                            "username": "NullAddress"
                        },
                        "profile_img_url": "https://storage.googleapis.com/opensea-static/opensea-profile/1.png",
                        "address": "0x0000000000000000000000000000000000000000",
                        "config": "",
                        "discord_id": ""
                    },
                    "permalink": "https://opensea.io/assets/0x495f947276749ce646f68ac8c248420045cb7b5e/80494307024529346018053650490912529916739680814770830097664395653569161723905",
                    "collection": {
                        "banner_image_url": "https://lh3.googleusercontent.com/4XSyHJVve1Mf46CW06BJp4-pBY3O8Pf3plqcVul2OgehwRAiCf0AWVmABV1s9A-qiqyDA_f7T5f8BHmzVRQ3RCRllfcQNxlIcTvkaQ=s2500",
                        "chat_url": null,
                        "created_date": "2021-05-02T00:12:04.318582",
                        "default_to_fiat": false,
                        "description": "101/101 Ghxsts rescued.\n21/43 Immxrtals born.\n20/50 Demxns saved.\n",
                        "dev_buyer_fee_basis_points": "0",
                        "dev_seller_fee_basis_points": "1000",
                        "discord_url": "https://discord.gg/yT88JmnQew",
                        "display_data": {
                            "card_display_style": "contain"
                        },
                        "external_url": null,
                        "featured": false,
                        "featured_image_url": "https://lh3.googleusercontent.com/uVziXd8Q64_zvofgrKFp5SmrcObngHoVWZMJQOHAZ3bdERsO4GaYvQcuGsz0ofr8zy8iajJdNQHCwFkSdBmkVy_osTPvoAuQFv489g=s300",
                        "hidden": false,
                        "safelist_request_status": "approved",
                        "image_url": "https://lh3.googleusercontent.com/uVziXd8Q64_zvofgrKFp5SmrcObngHoVWZMJQOHAZ3bdERsO4GaYvQcuGsz0ofr8zy8iajJdNQHCwFkSdBmkVy_osTPvoAuQFv489g=s120",
                        "is_subject_to_whitelist": false,
                        "large_image_url": "https://lh3.googleusercontent.com/uVziXd8Q64_zvofgrKFp5SmrcObngHoVWZMJQOHAZ3bdERsO4GaYvQcuGsz0ofr8zy8iajJdNQHCwFkSdBmkVy_osTPvoAuQFv489g=s300",
                        "medium_username": null,
                        "name": "Ghxsts",
                        "only_proxied_transfers": false,
                        "opensea_buyer_fee_basis_points": "0",
                        "opensea_seller_fee_basis_points": "250",
                        "payout_address": "0xb1f629cb1b6841e5ac98aa5b1cffab1b6c88d8b7",
                        "require_email": false,
                        "short_description": null,
                        "slug": "ghxsts",
                        "telegram_url": null,
                        "twitter_username": "GhxstNFT",
                        "instagram_username": null,
                        "wiki_url": null
                    },
                    "decimals": null,
                    "token_metadata": null
                }
            ],
            "name": "first milestone",
            "description": "",
            "external_link": "",
            "asset_contract": {
                "collection": {
                    "banner_image_url": null,
                    "chat_url": null,
                    "created_date": "2020-12-02T17:40:53.507540",
                    "default_to_fiat": false,
                    "description": null,
                    "dev_buyer_fee_basis_points": "0",
                    "dev_seller_fee_basis_points": "0",
                    "discord_url": null,
                    "display_data": {
                        "card_display_style": "contain",
                        "images": []
                    },
                    "external_url": null,
                    "featured": false,
                    "featured_image_url": null,
                    "hidden": true,
                    "safelist_request_status": "not_requested",
                    "image_url": null,
                    "is_subject_to_whitelist": false,
                    "large_image_url": null,
                    "medium_username": null,
                    "name": "OpenSea Shared Storefront V2",
                    "only_proxied_transfers": false,
                    "opensea_buyer_fee_basis_points": "0",
                    "opensea_seller_fee_basis_points": "250",
                    "payout_address": null,
                    "require_email": false,
                    "short_description": null,
                    "slug": "opensea-shared-storefront-v2",
                    "telegram_url": null,
                    "twitter_username": null,
                    "instagram_username": null,
                    "wiki_url": null
                },
                "address": "0x495f947276749ce646f68ac8c248420045cb7b5e",
                "asset_contract_type": "semi-fungible",
                "created_date": "2020-12-02T17:40:53.232025",
                "name": "OpenSea Collection",
                "nft_version": null,
                "opensea_version": "2.0.0",
                "owner": 102384,
                "schema_name": "ERC1155",
                "symbol": "OPENSTORE",
                "total_supply": null,
                "description": null,
                "external_link": null,
                "image_url": null,
                "default_to_fiat": false,
                "dev_buyer_fee_basis_points": 0,
                "dev_seller_fee_basis_points": 0,
                "only_proxied_transfers": false,
                "opensea_buyer_fee_basis_points": 0,
                "opensea_seller_fee_basis_points": 250,
                "buyer_fee_basis_points": 0,
                "seller_fee_basis_points": 250,
                "payout_address": null
            },
            "permalink": "https://opensea.io/bundles/first-milestone-amp",
            "sell_orders": []
        },
        {
            "maker": {
                "user": {
                    "username": "REVOLT"
                },
                "profile_img_url": "https://storage.googleapis.com/opensea-static/opensea-profile/25.png",
                "address": "0xb6d820e80a2a7c49f94c9d6c8ea08dccedc9ce4c",
                "config": "",
                "discord_id": ""
            },
            "slug": "small-estate-9-lands-Wkh",
            "assets": [
                {
                    "id": 15825046,
                    "token_id": "35802",
                    "num_sales": 0,
                    "background_color": null,
                    "image_url": "https://lh3.googleusercontent.com/17vU_UNWeMOVi4XOAwo4nvAXpeg1dnKPBk8VnAhJcFHOFZ9UBBvSL5Spj0ytvyfII3rdp4gHMY0mMvbnSzjdOZ0",
                    "image_preview_url": "https://lh3.googleusercontent.com/17vU_UNWeMOVi4XOAwo4nvAXpeg1dnKPBk8VnAhJcFHOFZ9UBBvSL5Spj0ytvyfII3rdp4gHMY0mMvbnSzjdOZ0=s250",
                    "image_thumbnail_url": "https://lh3.googleusercontent.com/17vU_UNWeMOVi4XOAwo4nvAXpeg1dnKPBk8VnAhJcFHOFZ9UBBvSL5Spj0ytvyfII3rdp4gHMY0mMvbnSzjdOZ0=s128",
                    "image_original_url": "https://storage.googleapis.com/opensea-static/custom-fetcher-images/sandbox/land/sandbox-land.png",
                    "animation_url": null,
                    "animation_original_url": null,
                    "name": "LAND (102, -117)",
                    "description": "A LAND is a digital piece of real estate in The Sandbox metaverse that players can buy to build experiences on top of. Once you own a LAND, you will be able to populate it with Games and Assets. Each LAND is a unique (non-fungible) token lying on the public Ethereum blockchain (ERC-721).",
                    "external_link": "https://www.sandbox.game/en/map/?x=102&y=-117",
                    "asset_contract": {
                        "address": "0x50f5474724e0ee42d9a4e711ccfb275809fd6d4a",
                        "asset_contract_type": "non-fungible",
                        "created_date": "2019-12-04T10:58:28.892990",
                        "name": "Sandbox's LANDs",
                        "nft_version": "3.0",
                        "opensea_version": null,
                        "owner": null,
                        "schema_name": "ERC721",
                        "symbol": "",
                        "total_supply": null,
                        "description": "The Sandbox is a community-driven platform where creators can monetize voxel assets and gaming experiences on the blockchain. The Sandbox metaverse comprises a map made up of 166,464 LANDS.  LAND owners can host contests and events, stake SAND to earn and customize assets, monetize assets and experiences, vote in the metaverse governance, play games that you or others create, and more! Trade the collection and keep your eyes peeled for future drops.",
                        "external_link": "https://www.sandbox.game/",
                        "image_url": "https://lh3.googleusercontent.com/SXH8tW1siikB80rwCRnjm1a5xM_MwTg9Xl9Db6mioIk9HIlDM09pVoSR7GKJgS6ulSUpgW9BDtMk_ePX_NKgO9A=s60",
                        "default_to_fiat": false,
                        "dev_buyer_fee_basis_points": 0,
                        "dev_seller_fee_basis_points": 500,
                        "only_proxied_transfers": false,
                        "opensea_buyer_fee_basis_points": 0,
                        "opensea_seller_fee_basis_points": 250,
                        "buyer_fee_basis_points": 0,
                        "seller_fee_basis_points": 750,
                        "payout_address": "0x7a9fe22691c811ea339d9b73150e6911a5343dca"
                    },
                    "owner": {
                        "user": {
                            "username": "REVOLT"
                        },
                        "profile_img_url": "https://storage.googleapis.com/opensea-static/opensea-profile/25.png",
                        "address": "0xb6d820e80a2a7c49f94c9d6c8ea08dccedc9ce4c",
                        "config": "",
                        "discord_id": ""
                    },
                    "permalink": "https://opensea.io/assets/0x50f5474724e0ee42d9a4e711ccfb275809fd6d4a/35802",
                    "collection": {
                        "banner_image_url": "https://lh3.googleusercontent.com/4NQIRoGmzXeXQN4mjuhWuuDZSNW7_BqRXux5upd4Nn_A-bfsGxCnPF8qn98Y6MyHRDPGXIlgfZADcSOe6M2DyrDKXdbdaTgkZN5l=s2500",
                        "chat_url": null,
                        "created_date": "2019-12-04T10:58:29.069907",
                        "default_to_fiat": false,
                        "description": "The Sandbox is a community-driven platform where creators can monetize voxel assets and gaming experiences on the blockchain. The Sandbox metaverse comprises a map made up of 166,464 LANDS.  LAND owners can host contests and events, stake SAND to earn and customize assets, monetize assets and experiences, vote in the metaverse governance, play games that you or others create, and more! Trade the collection and keep your eyes peeled for future drops.",
                        "dev_buyer_fee_basis_points": "0",
                        "dev_seller_fee_basis_points": "500",
                        "discord_url": "https://discord.gg/vAe4zvY",
                        "display_data": {
                            "card_display_style": "contain"
                        },
                        "external_url": "https://www.sandbox.game/",
                        "featured": false,
                        "featured_image_url": "https://storage.googleapis.com/opensea-static/featured-images/sandbox-featured.png",
                        "hidden": false,
                        "safelist_request_status": "verified",
                        "image_url": "https://lh3.googleusercontent.com/SXH8tW1siikB80rwCRnjm1a5xM_MwTg9Xl9Db6mioIk9HIlDM09pVoSR7GKJgS6ulSUpgW9BDtMk_ePX_NKgO9A=s60",
                        "is_subject_to_whitelist": false,
                        "large_image_url": "https://lh3.googleusercontent.com/SXH8tW1siikB80rwCRnjm1a5xM_MwTg9Xl9Db6mioIk9HIlDM09pVoSR7GKJgS6ulSUpgW9BDtMk_ePX_NKgO9A",
                        "medium_username": "sandbox-game",
                        "name": "The Sandbox",
                        "only_proxied_transfers": false,
                        "opensea_buyer_fee_basis_points": "0",
                        "opensea_seller_fee_basis_points": "250",
                        "payout_address": "0x7a9fe22691c811ea339d9b73150e6911a5343dca",
                        "require_email": false,
                        "short_description": null,
                        "slug": "sandbox",
                        "telegram_url": "https://t.me/sandboxgame",
                        "twitter_username": "thesandboxgame",
                        "instagram_username": null,
                        "wiki_url": null
                    },
                    "decimals": null,
                    "token_metadata": null
                },
                {
                    "id": 15825050,
                    "token_id": "35803",
                    "num_sales": 0,
                    "background_color": null,
                    "image_url": "https://lh3.googleusercontent.com/17vU_UNWeMOVi4XOAwo4nvAXpeg1dnKPBk8VnAhJcFHOFZ9UBBvSL5Spj0ytvyfII3rdp4gHMY0mMvbnSzjdOZ0",
                    "image_preview_url": "https://lh3.googleusercontent.com/17vU_UNWeMOVi4XOAwo4nvAXpeg1dnKPBk8VnAhJcFHOFZ9UBBvSL5Spj0ytvyfII3rdp4gHMY0mMvbnSzjdOZ0=s250",
                    "image_thumbnail_url": "https://lh3.googleusercontent.com/17vU_UNWeMOVi4XOAwo4nvAXpeg1dnKPBk8VnAhJcFHOFZ9UBBvSL5Spj0ytvyfII3rdp4gHMY0mMvbnSzjdOZ0=s128",
                    "image_original_url": "https://storage.googleapis.com/opensea-static/custom-fetcher-images/sandbox/land/sandbox-land.png",
                    "animation_url": null,
                    "animation_original_url": null,
                    "name": "LAND (103, -117)",
                    "description": "A LAND is a digital piece of real estate in The Sandbox metaverse that players can buy to build experiences on top of. Once you own a LAND, you will be able to populate it with Games and Assets. Each LAND is a unique (non-fungible) token lying on the public Ethereum blockchain (ERC-721).",
                    "external_link": "https://www.sandbox.game/en/map/?x=103&y=-117",
                    "asset_contract": {
                        "address": "0x50f5474724e0ee42d9a4e711ccfb275809fd6d4a",
                        "asset_contract_type": "non-fungible",
                        "created_date": "2019-12-04T10:58:28.892990",
                        "name": "Sandbox's LANDs",
                        "nft_version": "3.0",
                        "opensea_version": null,
                        "owner": null,
                        "schema_name": "ERC721",
                        "symbol": "",
                        "total_supply": null,
                        "description": "The Sandbox is a community-driven platform where creators can monetize voxel assets and gaming experiences on the blockchain. The Sandbox metaverse comprises a map made up of 166,464 LANDS.  LAND owners can host contests and events, stake SAND to earn and customize assets, monetize assets and experiences, vote in the metaverse governance, play games that you or others create, and more! Trade the collection and keep your eyes peeled for future drops.",
                        "external_link": "https://www.sandbox.game/",
                        "image_url": "https://lh3.googleusercontent.com/SXH8tW1siikB80rwCRnjm1a5xM_MwTg9Xl9Db6mioIk9HIlDM09pVoSR7GKJgS6ulSUpgW9BDtMk_ePX_NKgO9A=s60",
                        "default_to_fiat": false,
                        "dev_buyer_fee_basis_points": 0,
                        "dev_seller_fee_basis_points": 500,
                        "only_proxied_transfers": false,
                        "opensea_buyer_fee_basis_points": 0,
                        "opensea_seller_fee_basis_points": 250,
                        "buyer_fee_basis_points": 0,
                        "seller_fee_basis_points": 750,
                        "payout_address": "0x7a9fe22691c811ea339d9b73150e6911a5343dca"
                    },
                    "owner": {
                        "user": {
                            "username": "REVOLT"
                        },
                        "profile_img_url": "https://storage.googleapis.com/opensea-static/opensea-profile/25.png",
                        "address": "0xb6d820e80a2a7c49f94c9d6c8ea08dccedc9ce4c",
                        "config": "",
                        "discord_id": ""
                    },
                    "permalink": "https://opensea.io/assets/0x50f5474724e0ee42d9a4e711ccfb275809fd6d4a/35803",
                    "collection": {
                        "banner_image_url": "https://lh3.googleusercontent.com/4NQIRoGmzXeXQN4mjuhWuuDZSNW7_BqRXux5upd4Nn_A-bfsGxCnPF8qn98Y6MyHRDPGXIlgfZADcSOe6M2DyrDKXdbdaTgkZN5l=s2500",
                        "chat_url": null,
                        "created_date": "2019-12-04T10:58:29.069907",
                        "default_to_fiat": false,
                        "description": "The Sandbox is a community-driven platform where creators can monetize voxel assets and gaming experiences on the blockchain. The Sandbox metaverse comprises a map made up of 166,464 LANDS.  LAND owners can host contests and events, stake SAND to earn and customize assets, monetize assets and experiences, vote in the metaverse governance, play games that you or others create, and more! Trade the collection and keep your eyes peeled for future drops.",
                        "dev_buyer_fee_basis_points": "0",
                        "dev_seller_fee_basis_points": "500",
                        "discord_url": "https://discord.gg/vAe4zvY",
                        "display_data": {
                            "card_display_style": "contain"
                        },
                        "external_url": "https://www.sandbox.game/",
                        "featured": false,
                        "featured_image_url": "https://storage.googleapis.com/opensea-static/featured-images/sandbox-featured.png",
                        "hidden": false,
                        "safelist_request_status": "verified",
                        "image_url": "https://lh3.googleusercontent.com/SXH8tW1siikB80rwCRnjm1a5xM_MwTg9Xl9Db6mioIk9HIlDM09pVoSR7GKJgS6ulSUpgW9BDtMk_ePX_NKgO9A=s60",
                        "is_subject_to_whitelist": false,
                        "large_image_url": "https://lh3.googleusercontent.com/SXH8tW1siikB80rwCRnjm1a5xM_MwTg9Xl9Db6mioIk9HIlDM09pVoSR7GKJgS6ulSUpgW9BDtMk_ePX_NKgO9A",
                        "medium_username": "sandbox-game",
                        "name": "The Sandbox",
                        "only_proxied_transfers": false,
                        "opensea_buyer_fee_basis_points": "0",
                        "opensea_seller_fee_basis_points": "250",
                        "payout_address": "0x7a9fe22691c811ea339d9b73150e6911a5343dca",
                        "require_email": false,
                        "short_description": null,
                        "slug": "sandbox",
                        "telegram_url": "https://t.me/sandboxgame",
                        "twitter_username": "thesandboxgame",
                        "instagram_username": null,
                        "wiki_url": null
                    },
                    "decimals": null,
                    "token_metadata": null
                },
                {
                    "id": 15825052,
                    "token_id": "35804",
                    "num_sales": 0,
                    "background_color": null,
                    "image_url": "https://lh3.googleusercontent.com/17vU_UNWeMOVi4XOAwo4nvAXpeg1dnKPBk8VnAhJcFHOFZ9UBBvSL5Spj0ytvyfII3rdp4gHMY0mMvbnSzjdOZ0",
                    "image_preview_url": "https://lh3.googleusercontent.com/17vU_UNWeMOVi4XOAwo4nvAXpeg1dnKPBk8VnAhJcFHOFZ9UBBvSL5Spj0ytvyfII3rdp4gHMY0mMvbnSzjdOZ0=s250",
                    "image_thumbnail_url": "https://lh3.googleusercontent.com/17vU_UNWeMOVi4XOAwo4nvAXpeg1dnKPBk8VnAhJcFHOFZ9UBBvSL5Spj0ytvyfII3rdp4gHMY0mMvbnSzjdOZ0=s128",
                    "image_original_url": "https://storage.googleapis.com/opensea-static/custom-fetcher-images/sandbox/land/sandbox-land.png",
                    "animation_url": null,
                    "animation_original_url": null,
                    "name": "LAND (104, -117)",
                    "description": "A LAND is a digital piece of real estate in The Sandbox metaverse that players can buy to build experiences on top of. Once you own a LAND, you will be able to populate it with Games and Assets. Each LAND is a unique (non-fungible) token lying on the public Ethereum blockchain (ERC-721).",
                    "external_link": "https://www.sandbox.game/en/map/?x=104&y=-117",
                    "asset_contract": {
                        "address": "0x50f5474724e0ee42d9a4e711ccfb275809fd6d4a",
                        "asset_contract_type": "non-fungible",
                        "created_date": "2019-12-04T10:58:28.892990",
                        "name": "Sandbox's LANDs",
                        "nft_version": "3.0",
                        "opensea_version": null,
                        "owner": null,
                        "schema_name": "ERC721",
                        "symbol": "",
                        "total_supply": null,
                        "description": "The Sandbox is a community-driven platform where creators can monetize voxel assets and gaming experiences on the blockchain. The Sandbox metaverse comprises a map made up of 166,464 LANDS.  LAND owners can host contests and events, stake SAND to earn and customize assets, monetize assets and experiences, vote in the metaverse governance, play games that you or others create, and more! Trade the collection and keep your eyes peeled for future drops.",
                        "external_link": "https://www.sandbox.game/",
                        "image_url": "https://lh3.googleusercontent.com/SXH8tW1siikB80rwCRnjm1a5xM_MwTg9Xl9Db6mioIk9HIlDM09pVoSR7GKJgS6ulSUpgW9BDtMk_ePX_NKgO9A=s60",
                        "default_to_fiat": false,
                        "dev_buyer_fee_basis_points": 0,
                        "dev_seller_fee_basis_points": 500,
                        "only_proxied_transfers": false,
                        "opensea_buyer_fee_basis_points": 0,
                        "opensea_seller_fee_basis_points": 250,
                        "buyer_fee_basis_points": 0,
                        "seller_fee_basis_points": 750,
                        "payout_address": "0x7a9fe22691c811ea339d9b73150e6911a5343dca"
                    },
                    "owner": {
                        "user": {
                            "username": "REVOLT"
                        },
                        "profile_img_url": "https://storage.googleapis.com/opensea-static/opensea-profile/25.png",
                        "address": "0xb6d820e80a2a7c49f94c9d6c8ea08dccedc9ce4c",
                        "config": "",
                        "discord_id": ""
                    },
                    "permalink": "https://opensea.io/assets/0x50f5474724e0ee42d9a4e711ccfb275809fd6d4a/35804",
                    "collection": {
                        "banner_image_url": "https://lh3.googleusercontent.com/4NQIRoGmzXeXQN4mjuhWuuDZSNW7_BqRXux5upd4Nn_A-bfsGxCnPF8qn98Y6MyHRDPGXIlgfZADcSOe6M2DyrDKXdbdaTgkZN5l=s2500",
                        "chat_url": null,
                        "created_date": "2019-12-04T10:58:29.069907",
                        "default_to_fiat": false,
                        "description": "The Sandbox is a community-driven platform where creators can monetize voxel assets and gaming experiences on the blockchain. The Sandbox metaverse comprises a map made up of 166,464 LANDS.  LAND owners can host contests and events, stake SAND to earn and customize assets, monetize assets and experiences, vote in the metaverse governance, play games that you or others create, and more! Trade the collection and keep your eyes peeled for future drops.",
                        "dev_buyer_fee_basis_points": "0",
                        "dev_seller_fee_basis_points": "500",
                        "discord_url": "https://discord.gg/vAe4zvY",
                        "display_data": {
                            "card_display_style": "contain"
                        },
                        "external_url": "https://www.sandbox.game/",
                        "featured": false,
                        "featured_image_url": "https://storage.googleapis.com/opensea-static/featured-images/sandbox-featured.png",
                        "hidden": false,
                        "safelist_request_status": "verified",
                        "image_url": "https://lh3.googleusercontent.com/SXH8tW1siikB80rwCRnjm1a5xM_MwTg9Xl9Db6mioIk9HIlDM09pVoSR7GKJgS6ulSUpgW9BDtMk_ePX_NKgO9A=s60",
                        "is_subject_to_whitelist": false,
                        "large_image_url": "https://lh3.googleusercontent.com/SXH8tW1siikB80rwCRnjm1a5xM_MwTg9Xl9Db6mioIk9HIlDM09pVoSR7GKJgS6ulSUpgW9BDtMk_ePX_NKgO9A",
                        "medium_username": "sandbox-game",
                        "name": "The Sandbox",
                        "only_proxied_transfers": false,
                        "opensea_buyer_fee_basis_points": "0",
                        "opensea_seller_fee_basis_points": "250",
                        "payout_address": "0x7a9fe22691c811ea339d9b73150e6911a5343dca",
                        "require_email": false,
                        "short_description": null,
                        "slug": "sandbox",
                        "telegram_url": "https://t.me/sandboxgame",
                        "twitter_username": "thesandboxgame",
                        "instagram_username": null,
                        "wiki_url": null
                    },
                    "decimals": null,
                    "token_metadata": null
                },
                {
                    "id": 15825054,
                    "token_id": "36212",
                    "num_sales": 0,
                    "background_color": null,
                    "image_url": "https://lh3.googleusercontent.com/17vU_UNWeMOVi4XOAwo4nvAXpeg1dnKPBk8VnAhJcFHOFZ9UBBvSL5Spj0ytvyfII3rdp4gHMY0mMvbnSzjdOZ0",
                    "image_preview_url": "https://lh3.googleusercontent.com/17vU_UNWeMOVi4XOAwo4nvAXpeg1dnKPBk8VnAhJcFHOFZ9UBBvSL5Spj0ytvyfII3rdp4gHMY0mMvbnSzjdOZ0=s250",
                    "image_thumbnail_url": "https://lh3.googleusercontent.com/17vU_UNWeMOVi4XOAwo4nvAXpeg1dnKPBk8VnAhJcFHOFZ9UBBvSL5Spj0ytvyfII3rdp4gHMY0mMvbnSzjdOZ0=s128",
                    "image_original_url": "https://storage.googleapis.com/opensea-static/custom-fetcher-images/sandbox/land/sandbox-land.png",
                    "animation_url": null,
                    "animation_original_url": null,
                    "name": "LAND (104, -116)",
                    "description": "A LAND is a digital piece of real estate in The Sandbox metaverse that players can buy to build experiences on top of. Once you own a LAND, you will be able to populate it with Games and Assets. Each LAND is a unique (non-fungible) token lying on the public Ethereum blockchain (ERC-721).",
                    "external_link": "https://www.sandbox.game/en/map/?x=104&y=-116",
                    "asset_contract": {
                        "address": "0x50f5474724e0ee42d9a4e711ccfb275809fd6d4a",
                        "asset_contract_type": "non-fungible",
                        "created_date": "2019-12-04T10:58:28.892990",
                        "name": "Sandbox's LANDs",
                        "nft_version": "3.0",
                        "opensea_version": null,
                        "owner": null,
                        "schema_name": "ERC721",
                        "symbol": "",
                        "total_supply": null,
                        "description": "The Sandbox is a community-driven platform where creators can monetize voxel assets and gaming experiences on the blockchain. The Sandbox metaverse comprises a map made up of 166,464 LANDS.  LAND owners can host contests and events, stake SAND to earn and customize assets, monetize assets and experiences, vote in the metaverse governance, play games that you or others create, and more! Trade the collection and keep your eyes peeled for future drops.",
                        "external_link": "https://www.sandbox.game/",
                        "image_url": "https://lh3.googleusercontent.com/SXH8tW1siikB80rwCRnjm1a5xM_MwTg9Xl9Db6mioIk9HIlDM09pVoSR7GKJgS6ulSUpgW9BDtMk_ePX_NKgO9A=s60",
                        "default_to_fiat": false,
                        "dev_buyer_fee_basis_points": 0,
                        "dev_seller_fee_basis_points": 500,
                        "only_proxied_transfers": false,
                        "opensea_buyer_fee_basis_points": 0,
                        "opensea_seller_fee_basis_points": 250,
                        "buyer_fee_basis_points": 0,
                        "seller_fee_basis_points": 750,
                        "payout_address": "0x7a9fe22691c811ea339d9b73150e6911a5343dca"
                    },
                    "owner": {
                        "user": {
                            "username": "REVOLT"
                        },
                        "profile_img_url": "https://storage.googleapis.com/opensea-static/opensea-profile/25.png",
                        "address": "0xb6d820e80a2a7c49f94c9d6c8ea08dccedc9ce4c",
                        "config": "",
                        "discord_id": ""
                    },
                    "permalink": "https://opensea.io/assets/0x50f5474724e0ee42d9a4e711ccfb275809fd6d4a/36212",
                    "collection": {
                        "banner_image_url": "https://lh3.googleusercontent.com/4NQIRoGmzXeXQN4mjuhWuuDZSNW7_BqRXux5upd4Nn_A-bfsGxCnPF8qn98Y6MyHRDPGXIlgfZADcSOe6M2DyrDKXdbdaTgkZN5l=s2500",
                        "chat_url": null,
                        "created_date": "2019-12-04T10:58:29.069907",
                        "default_to_fiat": false,
                        "description": "The Sandbox is a community-driven platform where creators can monetize voxel assets and gaming experiences on the blockchain. The Sandbox metaverse comprises a map made up of 166,464 LANDS.  LAND owners can host contests and events, stake SAND to earn and customize assets, monetize assets and experiences, vote in the metaverse governance, play games that you or others create, and more! Trade the collection and keep your eyes peeled for future drops.",
                        "dev_buyer_fee_basis_points": "0",
                        "dev_seller_fee_basis_points": "500",
                        "discord_url": "https://discord.gg/vAe4zvY",
                        "display_data": {
                            "card_display_style": "contain"
                        },
                        "external_url": "https://www.sandbox.game/",
                        "featured": false,
                        "featured_image_url": "https://storage.googleapis.com/opensea-static/featured-images/sandbox-featured.png",
                        "hidden": false,
                        "safelist_request_status": "verified",
                        "image_url": "https://lh3.googleusercontent.com/SXH8tW1siikB80rwCRnjm1a5xM_MwTg9Xl9Db6mioIk9HIlDM09pVoSR7GKJgS6ulSUpgW9BDtMk_ePX_NKgO9A=s60",
                        "is_subject_to_whitelist": false,
                        "large_image_url": "https://lh3.googleusercontent.com/SXH8tW1siikB80rwCRnjm1a5xM_MwTg9Xl9Db6mioIk9HIlDM09pVoSR7GKJgS6ulSUpgW9BDtMk_ePX_NKgO9A",
                        "medium_username": "sandbox-game",
                        "name": "The Sandbox",
                        "only_proxied_transfers": false,
                        "opensea_buyer_fee_basis_points": "0",
                        "opensea_seller_fee_basis_points": "250",
                        "payout_address": "0x7a9fe22691c811ea339d9b73150e6911a5343dca",
                        "require_email": false,
                        "short_description": null,
                        "slug": "sandbox",
                        "telegram_url": "https://t.me/sandboxgame",
                        "twitter_username": "thesandboxgame",
                        "instagram_username": null,
                        "wiki_url": null
                    },
                    "decimals": null,
                    "token_metadata": null
                },
                {
                    "id": 15825056,
                    "token_id": "36211",
                    "num_sales": 0,
                    "background_color": null,
                    "image_url": "https://storage.opensea.io/files/3faa959fa75531ac7913a9c9f8361b58.png",
                    "image_preview_url": "https://lh3.googleusercontent.com/17vU_UNWeMOVi4XOAwo4nvAXpeg1dnKPBk8VnAhJcFHOFZ9UBBvSL5Spj0ytvyfII3rdp4gHMY0mMvbnSzjdOZ0=s250",
                    "image_thumbnail_url": "https://lh3.googleusercontent.com/17vU_UNWeMOVi4XOAwo4nvAXpeg1dnKPBk8VnAhJcFHOFZ9UBBvSL5Spj0ytvyfII3rdp4gHMY0mMvbnSzjdOZ0=s128",
                    "image_original_url": "https://storage.googleapis.com/opensea-static/custom-fetcher-images/sandbox/land/sandbox-land.png",
                    "animation_url": null,
                    "animation_original_url": null,
                    "name": "LAND (103, -116)",
                    "description": "A LAND is a digital piece of real estate in The Sandbox metaverse that players can buy to build experiences on top of. Once you own a LAND, you will be able to populate it with Games and Assets. Each LAND is a unique (non-fungible) token lying on the public Ethereum blockchain (ERC-721).",
                    "external_link": "https://www.sandbox.game/en/map/?x=103&y=-116",
                    "asset_contract": {
                        "address": "0x50f5474724e0ee42d9a4e711ccfb275809fd6d4a",
                        "asset_contract_type": "non-fungible",
                        "created_date": "2019-12-04T10:58:28.892990",
                        "name": "Sandbox's LANDs",
                        "nft_version": "3.0",
                        "opensea_version": null,
                        "owner": null,
                        "schema_name": "ERC721",
                        "symbol": "",
                        "total_supply": null,
                        "description": "The Sandbox is a community-driven platform where creators can monetize voxel assets and gaming experiences on the blockchain. The Sandbox metaverse comprises a map made up of 166,464 LANDS.  LAND owners can host contests and events, stake SAND to earn and customize assets, monetize assets and experiences, vote in the metaverse governance, play games that you or others create, and more! Trade the collection and keep your eyes peeled for future drops.",
                        "external_link": "https://www.sandbox.game/",
                        "image_url": "https://lh3.googleusercontent.com/SXH8tW1siikB80rwCRnjm1a5xM_MwTg9Xl9Db6mioIk9HIlDM09pVoSR7GKJgS6ulSUpgW9BDtMk_ePX_NKgO9A=s60",
                        "default_to_fiat": false,
                        "dev_buyer_fee_basis_points": 0,
                        "dev_seller_fee_basis_points": 500,
                        "only_proxied_transfers": false,
                        "opensea_buyer_fee_basis_points": 0,
                        "opensea_seller_fee_basis_points": 250,
                        "buyer_fee_basis_points": 0,
                        "seller_fee_basis_points": 750,
                        "payout_address": "0x7a9fe22691c811ea339d9b73150e6911a5343dca"
                    },
                    "owner": {
                        "user": {
                            "username": "REVOLT"
                        },
                        "profile_img_url": "https://storage.googleapis.com/opensea-static/opensea-profile/25.png",
                        "address": "0xb6d820e80a2a7c49f94c9d6c8ea08dccedc9ce4c",
                        "config": "",
                        "discord_id": ""
                    },
                    "permalink": "https://opensea.io/assets/0x50f5474724e0ee42d9a4e711ccfb275809fd6d4a/36211",
                    "collection": {
                        "banner_image_url": "https://lh3.googleusercontent.com/4NQIRoGmzXeXQN4mjuhWuuDZSNW7_BqRXux5upd4Nn_A-bfsGxCnPF8qn98Y6MyHRDPGXIlgfZADcSOe6M2DyrDKXdbdaTgkZN5l=s2500",
                        "chat_url": null,
                        "created_date": "2019-12-04T10:58:29.069907",
                        "default_to_fiat": false,
                        "description": "The Sandbox is a community-driven platform where creators can monetize voxel assets and gaming experiences on the blockchain. The Sandbox metaverse comprises a map made up of 166,464 LANDS.  LAND owners can host contests and events, stake SAND to earn and customize assets, monetize assets and experiences, vote in the metaverse governance, play games that you or others create, and more! Trade the collection and keep your eyes peeled for future drops.",
                        "dev_buyer_fee_basis_points": "0",
                        "dev_seller_fee_basis_points": "500",
                        "discord_url": "https://discord.gg/vAe4zvY",
                        "display_data": {
                            "card_display_style": "contain"
                        },
                        "external_url": "https://www.sandbox.game/",
                        "featured": false,
                        "featured_image_url": "https://storage.googleapis.com/opensea-static/featured-images/sandbox-featured.png",
                        "hidden": false,
                        "safelist_request_status": "verified",
                        "image_url": "https://lh3.googleusercontent.com/SXH8tW1siikB80rwCRnjm1a5xM_MwTg9Xl9Db6mioIk9HIlDM09pVoSR7GKJgS6ulSUpgW9BDtMk_ePX_NKgO9A=s60",
                        "is_subject_to_whitelist": false,
                        "large_image_url": "https://lh3.googleusercontent.com/SXH8tW1siikB80rwCRnjm1a5xM_MwTg9Xl9Db6mioIk9HIlDM09pVoSR7GKJgS6ulSUpgW9BDtMk_ePX_NKgO9A",
                        "medium_username": "sandbox-game",
                        "name": "The Sandbox",
                        "only_proxied_transfers": false,
                        "opensea_buyer_fee_basis_points": "0",
                        "opensea_seller_fee_basis_points": "250",
                        "payout_address": "0x7a9fe22691c811ea339d9b73150e6911a5343dca",
                        "require_email": false,
                        "short_description": null,
                        "slug": "sandbox",
                        "telegram_url": "https://t.me/sandboxgame",
                        "twitter_username": "thesandboxgame",
                        "instagram_username": null,
                        "wiki_url": null
                    },
                    "decimals": null,
                    "token_metadata": null
                },
                {
                    "id": 15825058,
                    "token_id": "36210",
                    "num_sales": 0,
                    "background_color": null,
                    "image_url": "https://storage.opensea.io/files/3faa959fa75531ac7913a9c9f8361b58.png",
                    "image_preview_url": "https://lh3.googleusercontent.com/17vU_UNWeMOVi4XOAwo4nvAXpeg1dnKPBk8VnAhJcFHOFZ9UBBvSL5Spj0ytvyfII3rdp4gHMY0mMvbnSzjdOZ0=s250",
                    "image_thumbnail_url": "https://lh3.googleusercontent.com/17vU_UNWeMOVi4XOAwo4nvAXpeg1dnKPBk8VnAhJcFHOFZ9UBBvSL5Spj0ytvyfII3rdp4gHMY0mMvbnSzjdOZ0=s128",
                    "image_original_url": "https://storage.googleapis.com/opensea-static/custom-fetcher-images/sandbox/land/sandbox-land.png",
                    "animation_url": null,
                    "animation_original_url": null,
                    "name": "LAND (102, -116)",
                    "description": "A LAND is a digital piece of real estate in The Sandbox metaverse that players can buy to build experiences on top of. Once you own a LAND, you will be able to populate it with Games and Assets. Each LAND is a unique (non-fungible) token lying on the public Ethereum blockchain (ERC-721).",
                    "external_link": "https://www.sandbox.game/en/map/?x=102&y=-116",
                    "asset_contract": {
                        "address": "0x50f5474724e0ee42d9a4e711ccfb275809fd6d4a",
                        "asset_contract_type": "non-fungible",
                        "created_date": "2019-12-04T10:58:28.892990",
                        "name": "Sandbox's LANDs",
                        "nft_version": "3.0",
                        "opensea_version": null,
                        "owner": null,
                        "schema_name": "ERC721",
                        "symbol": "",
                        "total_supply": null,
                        "description": "The Sandbox is a community-driven platform where creators can monetize voxel assets and gaming experiences on the blockchain. The Sandbox metaverse comprises a map made up of 166,464 LANDS.  LAND owners can host contests and events, stake SAND to earn and customize assets, monetize assets and experiences, vote in the metaverse governance, play games that you or others create, and more! Trade the collection and keep your eyes peeled for future drops.",
                        "external_link": "https://www.sandbox.game/",
                        "image_url": "https://lh3.googleusercontent.com/SXH8tW1siikB80rwCRnjm1a5xM_MwTg9Xl9Db6mioIk9HIlDM09pVoSR7GKJgS6ulSUpgW9BDtMk_ePX_NKgO9A=s60",
                        "default_to_fiat": false,
                        "dev_buyer_fee_basis_points": 0,
                        "dev_seller_fee_basis_points": 500,
                        "only_proxied_transfers": false,
                        "opensea_buyer_fee_basis_points": 0,
                        "opensea_seller_fee_basis_points": 250,
                        "buyer_fee_basis_points": 0,
                        "seller_fee_basis_points": 750,
                        "payout_address": "0x7a9fe22691c811ea339d9b73150e6911a5343dca"
                    },
                    "owner": {
                        "user": {
                            "username": "REVOLT"
                        },
                        "profile_img_url": "https://storage.googleapis.com/opensea-static/opensea-profile/25.png",
                        "address": "0xb6d820e80a2a7c49f94c9d6c8ea08dccedc9ce4c",
                        "config": "",
                        "discord_id": ""
                    },
                    "permalink": "https://opensea.io/assets/0x50f5474724e0ee42d9a4e711ccfb275809fd6d4a/36210",
                    "collection": {
                        "banner_image_url": "https://lh3.googleusercontent.com/4NQIRoGmzXeXQN4mjuhWuuDZSNW7_BqRXux5upd4Nn_A-bfsGxCnPF8qn98Y6MyHRDPGXIlgfZADcSOe6M2DyrDKXdbdaTgkZN5l=s2500",
                        "chat_url": null,
                        "created_date": "2019-12-04T10:58:29.069907",
                        "default_to_fiat": false,
                        "description": "The Sandbox is a community-driven platform where creators can monetize voxel assets and gaming experiences on the blockchain. The Sandbox metaverse comprises a map made up of 166,464 LANDS.  LAND owners can host contests and events, stake SAND to earn and customize assets, monetize assets and experiences, vote in the metaverse governance, play games that you or others create, and more! Trade the collection and keep your eyes peeled for future drops.",
                        "dev_buyer_fee_basis_points": "0",
                        "dev_seller_fee_basis_points": "500",
                        "discord_url": "https://discord.gg/vAe4zvY",
                        "display_data": {
                            "card_display_style": "contain"
                        },
                        "external_url": "https://www.sandbox.game/",
                        "featured": false,
                        "featured_image_url": "https://storage.googleapis.com/opensea-static/featured-images/sandbox-featured.png",
                        "hidden": false,
                        "safelist_request_status": "verified",
                        "image_url": "https://lh3.googleusercontent.com/SXH8tW1siikB80rwCRnjm1a5xM_MwTg9Xl9Db6mioIk9HIlDM09pVoSR7GKJgS6ulSUpgW9BDtMk_ePX_NKgO9A=s60",
                        "is_subject_to_whitelist": false,
                        "large_image_url": "https://lh3.googleusercontent.com/SXH8tW1siikB80rwCRnjm1a5xM_MwTg9Xl9Db6mioIk9HIlDM09pVoSR7GKJgS6ulSUpgW9BDtMk_ePX_NKgO9A",
                        "medium_username": "sandbox-game",
                        "name": "The Sandbox",
                        "only_proxied_transfers": false,
                        "opensea_buyer_fee_basis_points": "0",
                        "opensea_seller_fee_basis_points": "250",
                        "payout_address": "0x7a9fe22691c811ea339d9b73150e6911a5343dca",
                        "require_email": false,
                        "short_description": null,
                        "slug": "sandbox",
                        "telegram_url": "https://t.me/sandboxgame",
                        "twitter_username": "thesandboxgame",
                        "instagram_username": null,
                        "wiki_url": null
                    },
                    "decimals": null,
                    "token_metadata": null
                },
                {
                    "id": 15825060,
                    "token_id": "36618",
                    "num_sales": 0,
                    "background_color": null,
                    "image_url": "https://storage.opensea.io/files/3faa959fa75531ac7913a9c9f8361b58.png",
                    "image_preview_url": "https://lh3.googleusercontent.com/17vU_UNWeMOVi4XOAwo4nvAXpeg1dnKPBk8VnAhJcFHOFZ9UBBvSL5Spj0ytvyfII3rdp4gHMY0mMvbnSzjdOZ0=s250",
                    "image_thumbnail_url": "https://lh3.googleusercontent.com/17vU_UNWeMOVi4XOAwo4nvAXpeg1dnKPBk8VnAhJcFHOFZ9UBBvSL5Spj0ytvyfII3rdp4gHMY0mMvbnSzjdOZ0=s128",
                    "image_original_url": "https://storage.googleapis.com/opensea-static/custom-fetcher-images/sandbox/land/sandbox-land.png",
                    "animation_url": null,
                    "animation_original_url": null,
                    "name": "LAND (102, -115)",
                    "description": "A LAND is a digital piece of real estate in The Sandbox metaverse that players can buy to build experiences on top of. Once you own a LAND, you will be able to populate it with Games and Assets. Each LAND is a unique (non-fungible) token lying on the public Ethereum blockchain (ERC-721).",
                    "external_link": "https://www.sandbox.game/en/map/?x=102&y=-115",
                    "asset_contract": {
                        "address": "0x50f5474724e0ee42d9a4e711ccfb275809fd6d4a",
                        "asset_contract_type": "non-fungible",
                        "created_date": "2019-12-04T10:58:28.892990",
                        "name": "Sandbox's LANDs",
                        "nft_version": "3.0",
                        "opensea_version": null,
                        "owner": null,
                        "schema_name": "ERC721",
                        "symbol": "",
                        "total_supply": null,
                        "description": "The Sandbox is a community-driven platform where creators can monetize voxel assets and gaming experiences on the blockchain. The Sandbox metaverse comprises a map made up of 166,464 LANDS.  LAND owners can host contests and events, stake SAND to earn and customize assets, monetize assets and experiences, vote in the metaverse governance, play games that you or others create, and more! Trade the collection and keep your eyes peeled for future drops.",
                        "external_link": "https://www.sandbox.game/",
                        "image_url": "https://lh3.googleusercontent.com/SXH8tW1siikB80rwCRnjm1a5xM_MwTg9Xl9Db6mioIk9HIlDM09pVoSR7GKJgS6ulSUpgW9BDtMk_ePX_NKgO9A=s60",
                        "default_to_fiat": false,
                        "dev_buyer_fee_basis_points": 0,
                        "dev_seller_fee_basis_points": 500,
                        "only_proxied_transfers": false,
                        "opensea_buyer_fee_basis_points": 0,
                        "opensea_seller_fee_basis_points": 250,
                        "buyer_fee_basis_points": 0,
                        "seller_fee_basis_points": 750,
                        "payout_address": "0x7a9fe22691c811ea339d9b73150e6911a5343dca"
                    },
                    "owner": {
                        "user": {
                            "username": "REVOLT"
                        },
                        "profile_img_url": "https://storage.googleapis.com/opensea-static/opensea-profile/25.png",
                        "address": "0xb6d820e80a2a7c49f94c9d6c8ea08dccedc9ce4c",
                        "config": "",
                        "discord_id": ""
                    },
                    "permalink": "https://opensea.io/assets/0x50f5474724e0ee42d9a4e711ccfb275809fd6d4a/36618",
                    "collection": {
                        "banner_image_url": "https://lh3.googleusercontent.com/4NQIRoGmzXeXQN4mjuhWuuDZSNW7_BqRXux5upd4Nn_A-bfsGxCnPF8qn98Y6MyHRDPGXIlgfZADcSOe6M2DyrDKXdbdaTgkZN5l=s2500",
                        "chat_url": null,
                        "created_date": "2019-12-04T10:58:29.069907",
                        "default_to_fiat": false,
                        "description": "The Sandbox is a community-driven platform where creators can monetize voxel assets and gaming experiences on the blockchain. The Sandbox metaverse comprises a map made up of 166,464 LANDS.  LAND owners can host contests and events, stake SAND to earn and customize assets, monetize assets and experiences, vote in the metaverse governance, play games that you or others create, and more! Trade the collection and keep your eyes peeled for future drops.",
                        "dev_buyer_fee_basis_points": "0",
                        "dev_seller_fee_basis_points": "500",
                        "discord_url": "https://discord.gg/vAe4zvY",
                        "display_data": {
                            "card_display_style": "contain"
                        },
                        "external_url": "https://www.sandbox.game/",
                        "featured": false,
                        "featured_image_url": "https://storage.googleapis.com/opensea-static/featured-images/sandbox-featured.png",
                        "hidden": false,
                        "safelist_request_status": "verified",
                        "image_url": "https://lh3.googleusercontent.com/SXH8tW1siikB80rwCRnjm1a5xM_MwTg9Xl9Db6mioIk9HIlDM09pVoSR7GKJgS6ulSUpgW9BDtMk_ePX_NKgO9A=s60",
                        "is_subject_to_whitelist": false,
                        "large_image_url": "https://lh3.googleusercontent.com/SXH8tW1siikB80rwCRnjm1a5xM_MwTg9Xl9Db6mioIk9HIlDM09pVoSR7GKJgS6ulSUpgW9BDtMk_ePX_NKgO9A",
                        "medium_username": "sandbox-game",
                        "name": "The Sandbox",
                        "only_proxied_transfers": false,
                        "opensea_buyer_fee_basis_points": "0",
                        "opensea_seller_fee_basis_points": "250",
                        "payout_address": "0x7a9fe22691c811ea339d9b73150e6911a5343dca",
                        "require_email": false,
                        "short_description": null,
                        "slug": "sandbox",
                        "telegram_url": "https://t.me/sandboxgame",
                        "twitter_username": "thesandboxgame",
                        "instagram_username": null,
                        "wiki_url": null
                    },
                    "decimals": null,
                    "token_metadata": null
                },
                {
                    "id": 15825062,
                    "token_id": "36619",
                    "num_sales": 0,
                    "background_color": null,
                    "image_url": "https://lh3.googleusercontent.com/17vU_UNWeMOVi4XOAwo4nvAXpeg1dnKPBk8VnAhJcFHOFZ9UBBvSL5Spj0ytvyfII3rdp4gHMY0mMvbnSzjdOZ0",
                    "image_preview_url": "https://lh3.googleusercontent.com/17vU_UNWeMOVi4XOAwo4nvAXpeg1dnKPBk8VnAhJcFHOFZ9UBBvSL5Spj0ytvyfII3rdp4gHMY0mMvbnSzjdOZ0=s250",
                    "image_thumbnail_url": "https://lh3.googleusercontent.com/17vU_UNWeMOVi4XOAwo4nvAXpeg1dnKPBk8VnAhJcFHOFZ9UBBvSL5Spj0ytvyfII3rdp4gHMY0mMvbnSzjdOZ0=s128",
                    "image_original_url": "https://storage.googleapis.com/opensea-static/custom-fetcher-images/sandbox/land/sandbox-land.png",
                    "animation_url": null,
                    "animation_original_url": null,
                    "name": "LAND (103, -115)",
                    "description": "A LAND is a digital piece of real estate in The Sandbox metaverse that players can buy to build experiences on top of. Once you own a LAND, you will be able to populate it with Games and Assets. Each LAND is a unique (non-fungible) token lying on the public Ethereum blockchain (ERC-721).",
                    "external_link": "https://www.sandbox.game/en/map/?x=103&y=-115",
                    "asset_contract": {
                        "address": "0x50f5474724e0ee42d9a4e711ccfb275809fd6d4a",
                        "asset_contract_type": "non-fungible",
                        "created_date": "2019-12-04T10:58:28.892990",
                        "name": "Sandbox's LANDs",
                        "nft_version": "3.0",
                        "opensea_version": null,
                        "owner": null,
                        "schema_name": "ERC721",
                        "symbol": "",
                        "total_supply": null,
                        "description": "The Sandbox is a community-driven platform where creators can monetize voxel assets and gaming experiences on the blockchain. The Sandbox metaverse comprises a map made up of 166,464 LANDS.  LAND owners can host contests and events, stake SAND to earn and customize assets, monetize assets and experiences, vote in the metaverse governance, play games that you or others create, and more! Trade the collection and keep your eyes peeled for future drops.",
                        "external_link": "https://www.sandbox.game/",
                        "image_url": "https://lh3.googleusercontent.com/SXH8tW1siikB80rwCRnjm1a5xM_MwTg9Xl9Db6mioIk9HIlDM09pVoSR7GKJgS6ulSUpgW9BDtMk_ePX_NKgO9A=s60",
                        "default_to_fiat": false,
                        "dev_buyer_fee_basis_points": 0,
                        "dev_seller_fee_basis_points": 500,
                        "only_proxied_transfers": false,
                        "opensea_buyer_fee_basis_points": 0,
                        "opensea_seller_fee_basis_points": 250,
                        "buyer_fee_basis_points": 0,
                        "seller_fee_basis_points": 750,
                        "payout_address": "0x7a9fe22691c811ea339d9b73150e6911a5343dca"
                    },
                    "owner": {
                        "user": {
                            "username": "REVOLT"
                        },
                        "profile_img_url": "https://storage.googleapis.com/opensea-static/opensea-profile/25.png",
                        "address": "0xb6d820e80a2a7c49f94c9d6c8ea08dccedc9ce4c",
                        "config": "",
                        "discord_id": ""
                    },
                    "permalink": "https://opensea.io/assets/0x50f5474724e0ee42d9a4e711ccfb275809fd6d4a/36619",
                    "collection": {
                        "banner_image_url": "https://lh3.googleusercontent.com/4NQIRoGmzXeXQN4mjuhWuuDZSNW7_BqRXux5upd4Nn_A-bfsGxCnPF8qn98Y6MyHRDPGXIlgfZADcSOe6M2DyrDKXdbdaTgkZN5l=s2500",
                        "chat_url": null,
                        "created_date": "2019-12-04T10:58:29.069907",
                        "default_to_fiat": false,
                        "description": "The Sandbox is a community-driven platform where creators can monetize voxel assets and gaming experiences on the blockchain. The Sandbox metaverse comprises a map made up of 166,464 LANDS.  LAND owners can host contests and events, stake SAND to earn and customize assets, monetize assets and experiences, vote in the metaverse governance, play games that you or others create, and more! Trade the collection and keep your eyes peeled for future drops.",
                        "dev_buyer_fee_basis_points": "0",
                        "dev_seller_fee_basis_points": "500",
                        "discord_url": "https://discord.gg/vAe4zvY",
                        "display_data": {
                            "card_display_style": "contain"
                        },
                        "external_url": "https://www.sandbox.game/",
                        "featured": false,
                        "featured_image_url": "https://storage.googleapis.com/opensea-static/featured-images/sandbox-featured.png",
                        "hidden": false,
                        "safelist_request_status": "verified",
                        "image_url": "https://lh3.googleusercontent.com/SXH8tW1siikB80rwCRnjm1a5xM_MwTg9Xl9Db6mioIk9HIlDM09pVoSR7GKJgS6ulSUpgW9BDtMk_ePX_NKgO9A=s60",
                        "is_subject_to_whitelist": false,
                        "large_image_url": "https://lh3.googleusercontent.com/SXH8tW1siikB80rwCRnjm1a5xM_MwTg9Xl9Db6mioIk9HIlDM09pVoSR7GKJgS6ulSUpgW9BDtMk_ePX_NKgO9A",
                        "medium_username": "sandbox-game",
                        "name": "The Sandbox",
                        "only_proxied_transfers": false,
                        "opensea_buyer_fee_basis_points": "0",
                        "opensea_seller_fee_basis_points": "250",
                        "payout_address": "0x7a9fe22691c811ea339d9b73150e6911a5343dca",
                        "require_email": false,
                        "short_description": null,
                        "slug": "sandbox",
                        "telegram_url": "https://t.me/sandboxgame",
                        "twitter_username": "thesandboxgame",
                        "instagram_username": null,
                        "wiki_url": null
                    },
                    "decimals": null,
                    "token_metadata": null
                },
                {
                    "id": 15825064,
                    "token_id": "36620",
                    "num_sales": 0,
                    "background_color": null,
                    "image_url": "https://storage.opensea.io/files/3faa959fa75531ac7913a9c9f8361b58.png",
                    "image_preview_url": "https://lh3.googleusercontent.com/17vU_UNWeMOVi4XOAwo4nvAXpeg1dnKPBk8VnAhJcFHOFZ9UBBvSL5Spj0ytvyfII3rdp4gHMY0mMvbnSzjdOZ0=s250",
                    "image_thumbnail_url": "https://lh3.googleusercontent.com/17vU_UNWeMOVi4XOAwo4nvAXpeg1dnKPBk8VnAhJcFHOFZ9UBBvSL5Spj0ytvyfII3rdp4gHMY0mMvbnSzjdOZ0=s128",
                    "image_original_url": "https://storage.googleapis.com/opensea-static/custom-fetcher-images/sandbox/land/sandbox-land.png",
                    "animation_url": null,
                    "animation_original_url": null,
                    "name": "LAND (104, -115)",
                    "description": "A LAND is a digital piece of real estate in The Sandbox metaverse that players can buy to build experiences on top of. Once you own a LAND, you will be able to populate it with Games and Assets. Each LAND is a unique (non-fungible) token lying on the public Ethereum blockchain (ERC-721).",
                    "external_link": "https://www.sandbox.game/en/map/?x=104&y=-115",
                    "asset_contract": {
                        "address": "0x50f5474724e0ee42d9a4e711ccfb275809fd6d4a",
                        "asset_contract_type": "non-fungible",
                        "created_date": "2019-12-04T10:58:28.892990",
                        "name": "Sandbox's LANDs",
                        "nft_version": "3.0",
                        "opensea_version": null,
                        "owner": null,
                        "schema_name": "ERC721",
                        "symbol": "",
                        "total_supply": null,
                        "description": "The Sandbox is a community-driven platform where creators can monetize voxel assets and gaming experiences on the blockchain. The Sandbox metaverse comprises a map made up of 166,464 LANDS.  LAND owners can host contests and events, stake SAND to earn and customize assets, monetize assets and experiences, vote in the metaverse governance, play games that you or others create, and more! Trade the collection and keep your eyes peeled for future drops.",
                        "external_link": "https://www.sandbox.game/",
                        "image_url": "https://lh3.googleusercontent.com/SXH8tW1siikB80rwCRnjm1a5xM_MwTg9Xl9Db6mioIk9HIlDM09pVoSR7GKJgS6ulSUpgW9BDtMk_ePX_NKgO9A=s60",
                        "default_to_fiat": false,
                        "dev_buyer_fee_basis_points": 0,
                        "dev_seller_fee_basis_points": 500,
                        "only_proxied_transfers": false,
                        "opensea_buyer_fee_basis_points": 0,
                        "opensea_seller_fee_basis_points": 250,
                        "buyer_fee_basis_points": 0,
                        "seller_fee_basis_points": 750,
                        "payout_address": "0x7a9fe22691c811ea339d9b73150e6911a5343dca"
                    },
                    "owner": {
                        "user": {
                            "username": "REVOLT"
                        },
                        "profile_img_url": "https://storage.googleapis.com/opensea-static/opensea-profile/25.png",
                        "address": "0xb6d820e80a2a7c49f94c9d6c8ea08dccedc9ce4c",
                        "config": "",
                        "discord_id": ""
                    },
                    "permalink": "https://opensea.io/assets/0x50f5474724e0ee42d9a4e711ccfb275809fd6d4a/36620",
                    "collection": {
                        "banner_image_url": "https://lh3.googleusercontent.com/4NQIRoGmzXeXQN4mjuhWuuDZSNW7_BqRXux5upd4Nn_A-bfsGxCnPF8qn98Y6MyHRDPGXIlgfZADcSOe6M2DyrDKXdbdaTgkZN5l=s2500",
                        "chat_url": null,
                        "created_date": "2019-12-04T10:58:29.069907",
                        "default_to_fiat": false,
                        "description": "The Sandbox is a community-driven platform where creators can monetize voxel assets and gaming experiences on the blockchain. The Sandbox metaverse comprises a map made up of 166,464 LANDS.  LAND owners can host contests and events, stake SAND to earn and customize assets, monetize assets and experiences, vote in the metaverse governance, play games that you or others create, and more! Trade the collection and keep your eyes peeled for future drops.",
                        "dev_buyer_fee_basis_points": "0",
                        "dev_seller_fee_basis_points": "500",
                        "discord_url": "https://discord.gg/vAe4zvY",
                        "display_data": {
                            "card_display_style": "contain"
                        },
                        "external_url": "https://www.sandbox.game/",
                        "featured": false,
                        "featured_image_url": "https://storage.googleapis.com/opensea-static/featured-images/sandbox-featured.png",
                        "hidden": false,
                        "safelist_request_status": "verified",
                        "image_url": "https://lh3.googleusercontent.com/SXH8tW1siikB80rwCRnjm1a5xM_MwTg9Xl9Db6mioIk9HIlDM09pVoSR7GKJgS6ulSUpgW9BDtMk_ePX_NKgO9A=s60",
                        "is_subject_to_whitelist": false,
                        "large_image_url": "https://lh3.googleusercontent.com/SXH8tW1siikB80rwCRnjm1a5xM_MwTg9Xl9Db6mioIk9HIlDM09pVoSR7GKJgS6ulSUpgW9BDtMk_ePX_NKgO9A",
                        "medium_username": "sandbox-game",
                        "name": "The Sandbox",
                        "only_proxied_transfers": false,
                        "opensea_buyer_fee_basis_points": "0",
                        "opensea_seller_fee_basis_points": "250",
                        "payout_address": "0x7a9fe22691c811ea339d9b73150e6911a5343dca",
                        "require_email": false,
                        "short_description": null,
                        "slug": "sandbox",
                        "telegram_url": "https://t.me/sandboxgame",
                        "twitter_username": "thesandboxgame",
                        "instagram_username": null,
                        "wiki_url": null
                    },
                    "decimals": null,
                    "token_metadata": null
                }
            ],
            "name": "Small estate (9 lands)",
            "description": "Yes, you can afford it :o))",
            "external_link": "",
            "asset_contract": {
                "collection": {
                    "banner_image_url": "https://lh3.googleusercontent.com/4NQIRoGmzXeXQN4mjuhWuuDZSNW7_BqRXux5upd4Nn_A-bfsGxCnPF8qn98Y6MyHRDPGXIlgfZADcSOe6M2DyrDKXdbdaTgkZN5l=s2500",
                    "chat_url": null,
                    "created_date": "2019-12-04T10:58:29.069907",
                    "default_to_fiat": false,
                    "description": "The Sandbox is a community-driven platform where creators can monetize voxel assets and gaming experiences on the blockchain. The Sandbox metaverse comprises a map made up of 166,464 LANDS.  LAND owners can host contests and events, stake SAND to earn and customize assets, monetize assets and experiences, vote in the metaverse governance, play games that you or others create, and more! Trade the collection and keep your eyes peeled for future drops.",
                    "dev_buyer_fee_basis_points": "0",
                    "dev_seller_fee_basis_points": "500",
                    "discord_url": "https://discord.gg/vAe4zvY",
                    "display_data": {
                        "card_display_style": "contain"
                    },
                    "external_url": "https://www.sandbox.game/",
                    "featured": false,
                    "featured_image_url": "https://storage.googleapis.com/opensea-static/featured-images/sandbox-featured.png",
                    "hidden": false,
                    "safelist_request_status": "verified",
                    "image_url": "https://lh3.googleusercontent.com/SXH8tW1siikB80rwCRnjm1a5xM_MwTg9Xl9Db6mioIk9HIlDM09pVoSR7GKJgS6ulSUpgW9BDtMk_ePX_NKgO9A=s60",
                    "is_subject_to_whitelist": false,
                    "large_image_url": "https://lh3.googleusercontent.com/SXH8tW1siikB80rwCRnjm1a5xM_MwTg9Xl9Db6mioIk9HIlDM09pVoSR7GKJgS6ulSUpgW9BDtMk_ePX_NKgO9A",
                    "medium_username": "sandbox-game",
                    "name": "The Sandbox",
                    "only_proxied_transfers": false,
                    "opensea_buyer_fee_basis_points": "0",
                    "opensea_seller_fee_basis_points": "250",
                    "payout_address": "0x7a9fe22691c811ea339d9b73150e6911a5343dca",
                    "require_email": false,
                    "short_description": null,
                    "slug": "sandbox",
                    "telegram_url": "https://t.me/sandboxgame",
                    "twitter_username": "thesandboxgame",
                    "instagram_username": null,
                    "wiki_url": null
                },
                "address": "0x50f5474724e0ee42d9a4e711ccfb275809fd6d4a",
                "asset_contract_type": "non-fungible",
                "created_date": "2019-12-04T10:58:28.892990",
                "name": "Sandbox's LANDs",
                "nft_version": "3.0",
                "opensea_version": null,
                "owner": null,
                "schema_name": "ERC721",
                "symbol": "",
                "total_supply": null,
                "description": "The Sandbox is a community-driven platform where creators can monetize voxel assets and gaming experiences on the blockchain. The Sandbox metaverse comprises a map made up of 166,464 LANDS.  LAND owners can host contests and events, stake SAND to earn and customize assets, monetize assets and experiences, vote in the metaverse governance, play games that you or others create, and more! Trade the collection and keep your eyes peeled for future drops.",
                "external_link": "https://www.sandbox.game/",
                "image_url": "https://lh3.googleusercontent.com/SXH8tW1siikB80rwCRnjm1a5xM_MwTg9Xl9Db6mioIk9HIlDM09pVoSR7GKJgS6ulSUpgW9BDtMk_ePX_NKgO9A=s60",
                "default_to_fiat": false,
                "dev_buyer_fee_basis_points": 0,
                "dev_seller_fee_basis_points": 500,
                "only_proxied_transfers": false,
                "opensea_buyer_fee_basis_points": 0,
                "opensea_seller_fee_basis_points": 250,
                "buyer_fee_basis_points": 0,
                "seller_fee_basis_points": 750,
                "payout_address": "0x7a9fe22691c811ea339d9b73150e6911a5343dca"
            },
            "permalink": "https://opensea.io/bundles/small-estate-9-lands-Wkh",
            "sell_orders": [
                {
                    "created_date": "2021-05-25T21:27:50.708408",
                    "closing_date": null,
                    "closing_extendable": false,
                    "expiration_time": 0,
                    "listing_time": 1621977963,
                    "order_hash": "0x9703e3899a44f093e73ad9ac83511bd85f5bbfacb83efc5b82258182f5d1abde",
                    "metadata": {
                        "bundle": {
                            "assets": [
                                {
                                    "id": "35802",
                                    "address": "0x50f5474724e0ee42d9a4e711ccfb275809fd6d4a"
                                },
                                {
                                    "id": "35803",
                                    "address": "0x50f5474724e0ee42d9a4e711ccfb275809fd6d4a"
                                },
                                {
                                    "id": "35804",
                                    "address": "0x50f5474724e0ee42d9a4e711ccfb275809fd6d4a"
                                },
                                {
                                    "id": "36210",
                                    "address": "0x50f5474724e0ee42d9a4e711ccfb275809fd6d4a"
                                },
                                {
                                    "id": "36211",
                                    "address": "0x50f5474724e0ee42d9a4e711ccfb275809fd6d4a"
                                },
                                {
                                    "id": "36212",
                                    "address": "0x50f5474724e0ee42d9a4e711ccfb275809fd6d4a"
                                },
                                {
                                    "id": "36618",
                                    "address": "0x50f5474724e0ee42d9a4e711ccfb275809fd6d4a"
                                },
                                {
                                    "id": "36619",
                                    "address": "0x50f5474724e0ee42d9a4e711ccfb275809fd6d4a"
                                },
                                {
                                    "id": "36620",
                                    "address": "0x50f5474724e0ee42d9a4e711ccfb275809fd6d4a"
                                }
                            ],
                            "schemas": [
                                "ERC721",
                                "ERC721",
                                "ERC721",
                                "ERC721",
                                "ERC721",
                                "ERC721",
                                "ERC721",
                                "ERC721",
                                "ERC721"
                            ],
                            "name": "Small estate (9 lands)",
                            "description": "Yes, you can afford it :o))",
                            "external_link": ""
                        }
                    },
                    "exchange": "0x7be8076f4ea4a4ad08075c2508e481d6c946d12b",
                    "maker": {
                        "user": 3797,
                        "profile_img_url": "https://storage.googleapis.com/opensea-static/opensea-profile/25.png",
                        "address": "0xb6d820e80a2a7c49f94c9d6c8ea08dccedc9ce4c",
                        "config": "",
                        "discord_id": ""
                    },
                    "taker": {
                        "user": 1766,
                        "profile_img_url": "https://storage.googleapis.com/opensea-static/opensea-profile/1.png",
                        "address": "0x0000000000000000000000000000000000000000",
                        "config": "",
                        "discord_id": ""
                    },
                    "current_price": "135000000000000000000",
                    "current_bounty": "1350000000000000000",
                    "bounty_multiple": "0.01",
                    "maker_relayer_fee": "750",
                    "taker_relayer_fee": "0",
                    "maker_protocol_fee": "0",
                    "taker_protocol_fee": "0",
                    "maker_referrer_fee": "0",
                    "fee_recipient": {
                        "user": 3585,
                        "profile_img_url": "https://storage.googleapis.com/opensea-static/opensea-profile/28.png",
                        "address": "0x5b3256965e7c3cf26e11fcaf296dfc8807c01073",
                        "config": "verified",
                        "discord_id": ""
                    },
                    "fee_method": 1,
                    "side": 1,
                    "sale_kind": 0,
                    "target": "0xc99f70bfd82fb7c8f8191fdfbfb735606b15e5c5",
                    "how_to_call": 1,
                    "calldata": "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",
                    "replacement_pattern": "0x0000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000ffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffff0000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000ffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffff0000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000ffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffff0000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000ffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffff0000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000ffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffff0000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000ffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffff0000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000ffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffff0000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000ffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffff0000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000ffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffff000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000",
                    "static_target": "0x0000000000000000000000000000000000000000",
                    "static_extradata": "0x",
                    "payment_token": "0x0000000000000000000000000000000000000000",
                    "payment_token_contract": {
                        "id": 1,
                        "symbol": "ETH",
                        "address": "0x0000000000000000000000000000000000000000",
                        "image_url": "https://storage.opensea.io/files/6f8e2979d428180222796ff4a33ab929.svg",
                        "name": "Ether",
                        "decimals": 18,
                        "eth_price": "1.000000000000000",
                        "usd_price": "2625.730000000000018000"
                    },
                    "base_price": "135000000000000000000",
                    "extra": "0",
                    "quantity": "1",
                    "salt": "26900394445192288499063886688896148425915265593830891514174201106407601769856",
                    "v": 28,
                    "r": "0xa472d30ed75a50a1ad5c0947aa562698e08bed39b2ff9b19c3671ba965dd6816",
                    "s": "0x4a1dd73d361e5cf842a3979ae776c9e4a04bd2fe41ab964ab66cf812e9496e0c",
                    "approved_on_chain": false,
                    "cancelled": false,
                    "finalized": false,
                    "marked_invalid": false,
                    "prefixed_hash": "0x20e11e2559716cc5c20ae531bede444e0e1a8c4b73956eddf045b52dd24bcf8b"
                }
            ]
        },
        {
            "maker": {
                "user": {
                    "username": "KozmoStudio"
                },
                "profile_img_url": "https://storage.googleapis.com/opensea-static/opensea-profile/13.png",
                "address": "0xbcba66a96b330be24133fa768d94eb4deb8cfc3b",
                "config": "",
                "discord_id": ""
            },
            "slug": "ophanim-flat-e-mother-savior-jXb",
            "assets": [
                {
                    "id": 16791955,
                    "token_id": "36384",
                    "num_sales": 1,
                    "background_color": null,
                    "image_url": "https://lh3.googleusercontent.com/DKs4BymAdcPOvFd7TZ_xtdGdklVfc9tETJpzY739NW66LO5Fj8aoKgR-2ovi1v5UDL0nk3M_1lCli_nU2hZt54wa",
                    "image_preview_url": "https://lh3.googleusercontent.com/DKs4BymAdcPOvFd7TZ_xtdGdklVfc9tETJpzY739NW66LO5Fj8aoKgR-2ovi1v5UDL0nk3M_1lCli_nU2hZt54wa=s250",
                    "image_thumbnail_url": "https://lh3.googleusercontent.com/DKs4BymAdcPOvFd7TZ_xtdGdklVfc9tETJpzY739NW66LO5Fj8aoKgR-2ovi1v5UDL0nk3M_1lCli_nU2hZt54wa=s128",
                    "image_original_url": "https://ipfs.io/ipfs/QmZT2t6ruj39boKgzyCcaBdqpCr8RFCqeeFzw4XbgVDrPh",
                    "animation_url": null,
                    "animation_original_url": null,
                    "name": "Flat 𝐸",
                    "description": "\"Wait, it's all flat?\"\n\n\"I thought Earth was the center of the solar system?\"",
                    "external_link": "https://app.rarible.com/token/0xd07dc4262bcdbf85190c01c996b4c06a461d2430:36384",
                    "asset_contract": {
                        "address": "0xd07dc4262bcdbf85190c01c996b4c06a461d2430",
                        "asset_contract_type": "semi-fungible",
                        "created_date": "2020-05-27T16:53:32.834583",
                        "name": "Rarible 1155",
                        "nft_version": null,
                        "opensea_version": null,
                        "owner": 42603523,
                        "schema_name": "ERC1155",
                        "symbol": "",
                        "total_supply": null,
                        "description": "Create and sell digital collectibles secured with blockchain technology. Rarible is home to thousands of artists and collectors, creating and exchanging immutable art without using code. Trade with RARI token on OpenSea.",
                        "external_link": "https://rarible.com/",
                        "image_url": "https://lh3.googleusercontent.com/FG0QJ00fN3c_FWuPeUr9-T__iQl63j9hn5d6svW8UqOmia5zp3lKHPkJuHcvhZ0f_Pd6P2COo9tt9zVUvdPxG_9BBw=s60",
                        "default_to_fiat": false,
                        "dev_buyer_fee_basis_points": 0,
                        "dev_seller_fee_basis_points": 0,
                        "only_proxied_transfers": false,
                        "opensea_buyer_fee_basis_points": 0,
                        "opensea_seller_fee_basis_points": 250,
                        "buyer_fee_basis_points": 0,
                        "seller_fee_basis_points": 250,
                        "payout_address": null
                    },
                    "owner": {
                        "user": {
                            "username": "NullAddress"
                        },
                        "profile_img_url": "https://storage.googleapis.com/opensea-static/opensea-profile/1.png",
                        "address": "0x0000000000000000000000000000000000000000",
                        "config": "",
                        "discord_id": ""
                    },
                    "permalink": "https://opensea.io/assets/0xd07dc4262bcdbf85190c01c996b4c06a461d2430/36384",
                    "collection": {
                        "banner_image_url": "https://storage.opensea.io/static/banners/rarible-banner4.png",
                        "chat_url": null,
                        "created_date": "2020-01-01T13:22:57.777065",
                        "default_to_fiat": false,
                        "description": "Create and sell digital collectibles secured with blockchain technology. Rarible is home to thousands of artists and collectors, creating and exchanging immutable art without using code. Trade with RARI token on OpenSea.",
                        "dev_buyer_fee_basis_points": "0",
                        "dev_seller_fee_basis_points": "0",
                        "discord_url": null,
                        "display_data": {
                            "card_display_style": "contain"
                        },
                        "external_url": "https://rarible.com/",
                        "featured": false,
                        "featured_image_url": null,
                        "hidden": false,
                        "safelist_request_status": "verified",
                        "image_url": "https://lh3.googleusercontent.com/FG0QJ00fN3c_FWuPeUr9-T__iQl63j9hn5d6svW8UqOmia5zp3lKHPkJuHcvhZ0f_Pd6P2COo9tt9zVUvdPxG_9BBw=s60",
                        "is_subject_to_whitelist": false,
                        "large_image_url": "https://lh3.googleusercontent.com/FG0QJ00fN3c_FWuPeUr9-T__iQl63j9hn5d6svW8UqOmia5zp3lKHPkJuHcvhZ0f_Pd6P2COo9tt9zVUvdPxG_9BBw",
                        "medium_username": "rarible",
                        "name": "Rarible",
                        "only_proxied_transfers": false,
                        "opensea_buyer_fee_basis_points": "0",
                        "opensea_seller_fee_basis_points": "250",
                        "payout_address": null,
                        "require_email": false,
                        "short_description": null,
                        "slug": "rarible",
                        "telegram_url": "https://t.me/rarible",
                        "twitter_username": "rariblecom",
                        "instagram_username": null,
                        "wiki_url": null
                    },
                    "decimals": null,
                    "token_metadata": "https://ipfs.io/ipfs/QmcZim8Lz2aqB321D1pEemZNZRwek2fyqBRzqUPAZUhAqV"
                },
                {
                    "id": 16793492,
                    "token_id": "36726",
                    "num_sales": 0,
                    "background_color": null,
                    "image_url": "https://lh3.googleusercontent.com/r6A_PFJ4HPFCNgdZ_FKaZ-lz-8EoawO-baLRbyWdt3Fm40mHa0bJ78cJ3Hf7s9xFyw96T_BZMPhXxrFv6O2ckjdj",
                    "image_preview_url": "https://lh3.googleusercontent.com/r6A_PFJ4HPFCNgdZ_FKaZ-lz-8EoawO-baLRbyWdt3Fm40mHa0bJ78cJ3Hf7s9xFyw96T_BZMPhXxrFv6O2ckjdj=s250",
                    "image_thumbnail_url": "https://lh3.googleusercontent.com/r6A_PFJ4HPFCNgdZ_FKaZ-lz-8EoawO-baLRbyWdt3Fm40mHa0bJ78cJ3Hf7s9xFyw96T_BZMPhXxrFv6O2ckjdj=s128",
                    "image_original_url": "https://ipfs.io/ipfs/QmYYchvrm8Hkoa74hJbXHoksyLZcTYStcg8KeuAhvj2PHZ",
                    "animation_url": null,
                    "animation_original_url": null,
                    "name": "Ophanim",
                    "description": "The ophanim or ofanim (Heb. \"wheels\" אוֹפַנִּים ’ōphannīm)  refer to the wheels seen in Ezekiel's vision of the chariot, the Book of Enoch (61:10, 71:7) portray them as a class of celestial beings who (along with the Cherubim and Seraphim) never sleep, but guard the throne of God.\n\nAn excerpt from the Bible, Ezekiel 1:15-21:\n\"As I looked at the living creatures, I saw a wheel on the ground beside each creature with its four faces. This was the appearance and structure of the wheels: They sparkled like topaz, and all four looked alike. Each appeared to be made like a wheel intersecting a wheel. As they moved, they would go in any one of the four directions the creatures faced; the wheels did not change direction as the creatures went. Their rims were high and awesome, and all four rims were full of eyes all around.\n\nWhen the living creatures moved, the wheels beside them moved; and when the living creatures rose from the ground, the wheels also rose. Wherever the spirit would go, they would go, and the wheels would rise along with them, because the spirit of the living creatures was in the wheels. When the creatures moved, they also moved; when the creatures stood still, they also stood still; and when the creatures rose from the ground, the wheels rose along with them, because the spirit of the living creatures was in the wheels.\"",
                    "external_link": "https://app.rarible.com/token/0xd07dc4262bcdbf85190c01c996b4c06a461d2430:36726",
                    "asset_contract": {
                        "address": "0xd07dc4262bcdbf85190c01c996b4c06a461d2430",
                        "asset_contract_type": "semi-fungible",
                        "created_date": "2020-05-27T16:53:32.834583",
                        "name": "Rarible 1155",
                        "nft_version": null,
                        "opensea_version": null,
                        "owner": 42603523,
                        "schema_name": "ERC1155",
                        "symbol": "",
                        "total_supply": null,
                        "description": "Create and sell digital collectibles secured with blockchain technology. Rarible is home to thousands of artists and collectors, creating and exchanging immutable art without using code. Trade with RARI token on OpenSea.",
                        "external_link": "https://rarible.com/",
                        "image_url": "https://lh3.googleusercontent.com/FG0QJ00fN3c_FWuPeUr9-T__iQl63j9hn5d6svW8UqOmia5zp3lKHPkJuHcvhZ0f_Pd6P2COo9tt9zVUvdPxG_9BBw=s60",
                        "default_to_fiat": false,
                        "dev_buyer_fee_basis_points": 0,
                        "dev_seller_fee_basis_points": 0,
                        "only_proxied_transfers": false,
                        "opensea_buyer_fee_basis_points": 0,
                        "opensea_seller_fee_basis_points": 250,
                        "buyer_fee_basis_points": 0,
                        "seller_fee_basis_points": 250,
                        "payout_address": null
                    },
                    "owner": {
                        "user": {
                            "username": "NullAddress"
                        },
                        "profile_img_url": "https://storage.googleapis.com/opensea-static/opensea-profile/1.png",
                        "address": "0x0000000000000000000000000000000000000000",
                        "config": "",
                        "discord_id": ""
                    },
                    "permalink": "https://opensea.io/assets/0xd07dc4262bcdbf85190c01c996b4c06a461d2430/36726",
                    "collection": {
                        "banner_image_url": "https://storage.opensea.io/static/banners/rarible-banner4.png",
                        "chat_url": null,
                        "created_date": "2020-01-01T13:22:57.777065",
                        "default_to_fiat": false,
                        "description": "Create and sell digital collectibles secured with blockchain technology. Rarible is home to thousands of artists and collectors, creating and exchanging immutable art without using code. Trade with RARI token on OpenSea.",
                        "dev_buyer_fee_basis_points": "0",
                        "dev_seller_fee_basis_points": "0",
                        "discord_url": null,
                        "display_data": {
                            "card_display_style": "contain"
                        },
                        "external_url": "https://rarible.com/",
                        "featured": false,
                        "featured_image_url": null,
                        "hidden": false,
                        "safelist_request_status": "verified",
                        "image_url": "https://lh3.googleusercontent.com/FG0QJ00fN3c_FWuPeUr9-T__iQl63j9hn5d6svW8UqOmia5zp3lKHPkJuHcvhZ0f_Pd6P2COo9tt9zVUvdPxG_9BBw=s60",
                        "is_subject_to_whitelist": false,
                        "large_image_url": "https://lh3.googleusercontent.com/FG0QJ00fN3c_FWuPeUr9-T__iQl63j9hn5d6svW8UqOmia5zp3lKHPkJuHcvhZ0f_Pd6P2COo9tt9zVUvdPxG_9BBw",
                        "medium_username": "rarible",
                        "name": "Rarible",
                        "only_proxied_transfers": false,
                        "opensea_buyer_fee_basis_points": "0",
                        "opensea_seller_fee_basis_points": "250",
                        "payout_address": null,
                        "require_email": false,
                        "short_description": null,
                        "slug": "rarible",
                        "telegram_url": "https://t.me/rarible",
                        "twitter_username": "rariblecom",
                        "instagram_username": null,
                        "wiki_url": null
                    },
                    "decimals": null,
                    "token_metadata": "https://ipfs.io/ipfs/QmTZcS2U8QhSXuDufqKBVx6wABsWFdm7uft55dTKMTx9BH"
                },
                {
                    "id": 22579268,
                    "token_id": "504064",
                    "num_sales": 0,
                    "background_color": null,
                    "image_url": "https://lh3.googleusercontent.com/rIyYUyx09_k7_Or83VYwh8JJ8IuJWUrtFcsR3fhw-u4o3FwJMfcXQpwwAo4GYLkxo-bvC5g-z9Pn4OVzvTFrefCjwQBbEZscu74UGw",
                    "image_preview_url": "https://lh3.googleusercontent.com/rIyYUyx09_k7_Or83VYwh8JJ8IuJWUrtFcsR3fhw-u4o3FwJMfcXQpwwAo4GYLkxo-bvC5g-z9Pn4OVzvTFrefCjwQBbEZscu74UGw=s250",
                    "image_thumbnail_url": "https://lh3.googleusercontent.com/rIyYUyx09_k7_Or83VYwh8JJ8IuJWUrtFcsR3fhw-u4o3FwJMfcXQpwwAo4GYLkxo-bvC5g-z9Pn4OVzvTFrefCjwQBbEZscu74UGw=s128",
                    "image_original_url": "https://ipfs.io/ipfs/QmSM6F7vWq48pfkbwNror8nDNNbfFYPgLixX6tqXkDDFm6/image.gif",
                    "animation_url": "https://storage.opensea.io/files/9aa4fc22b1684b86c8eeb04537ecb6cb.mp4",
                    "animation_original_url": "https://ipfs.io/ipfs/QmSM6F7vWq48pfkbwNror8nDNNbfFYPgLixX6tqXkDDFm6/animation.mp4",
                    "name": "Mother Savior",
                    "description": "Celebrating Earth Day 2021\n\nChose your side and save the Earth so we are saved. \nUnlock MOV file once purchased.",
                    "external_link": "https://rarible.com/token/0xd07dc4262bcdbf85190c01c996b4c06a461d2430:504064",
                    "asset_contract": {
                        "address": "0xd07dc4262bcdbf85190c01c996b4c06a461d2430",
                        "asset_contract_type": "semi-fungible",
                        "created_date": "2020-05-27T16:53:32.834583",
                        "name": "Rarible 1155",
                        "nft_version": null,
                        "opensea_version": null,
                        "owner": 42603523,
                        "schema_name": "ERC1155",
                        "symbol": "",
                        "total_supply": null,
                        "description": "Create and sell digital collectibles secured with blockchain technology. Rarible is home to thousands of artists and collectors, creating and exchanging immutable art without using code. Trade with RARI token on OpenSea.",
                        "external_link": "https://rarible.com/",
                        "image_url": "https://lh3.googleusercontent.com/FG0QJ00fN3c_FWuPeUr9-T__iQl63j9hn5d6svW8UqOmia5zp3lKHPkJuHcvhZ0f_Pd6P2COo9tt9zVUvdPxG_9BBw=s60",
                        "default_to_fiat": false,
                        "dev_buyer_fee_basis_points": 0,
                        "dev_seller_fee_basis_points": 0,
                        "only_proxied_transfers": false,
                        "opensea_buyer_fee_basis_points": 0,
                        "opensea_seller_fee_basis_points": 250,
                        "buyer_fee_basis_points": 0,
                        "seller_fee_basis_points": 250,
                        "payout_address": null
                    },
                    "owner": {
                        "user": {
                            "username": "NullAddress"
                        },
                        "profile_img_url": "https://storage.googleapis.com/opensea-static/opensea-profile/1.png",
                        "address": "0x0000000000000000000000000000000000000000",
                        "config": "",
                        "discord_id": ""
                    },
                    "permalink": "https://opensea.io/assets/0xd07dc4262bcdbf85190c01c996b4c06a461d2430/504064",
                    "collection": {
                        "banner_image_url": "https://storage.opensea.io/static/banners/rarible-banner4.png",
                        "chat_url": null,
                        "created_date": "2020-01-01T13:22:57.777065",
                        "default_to_fiat": false,
                        "description": "Create and sell digital collectibles secured with blockchain technology. Rarible is home to thousands of artists and collectors, creating and exchanging immutable art without using code. Trade with RARI token on OpenSea.",
                        "dev_buyer_fee_basis_points": "0",
                        "dev_seller_fee_basis_points": "0",
                        "discord_url": null,
                        "display_data": {
                            "card_display_style": "contain"
                        },
                        "external_url": "https://rarible.com/",
                        "featured": false,
                        "featured_image_url": null,
                        "hidden": false,
                        "safelist_request_status": "verified",
                        "image_url": "https://lh3.googleusercontent.com/FG0QJ00fN3c_FWuPeUr9-T__iQl63j9hn5d6svW8UqOmia5zp3lKHPkJuHcvhZ0f_Pd6P2COo9tt9zVUvdPxG_9BBw=s60",
                        "is_subject_to_whitelist": false,
                        "large_image_url": "https://lh3.googleusercontent.com/FG0QJ00fN3c_FWuPeUr9-T__iQl63j9hn5d6svW8UqOmia5zp3lKHPkJuHcvhZ0f_Pd6P2COo9tt9zVUvdPxG_9BBw",
                        "medium_username": "rarible",
                        "name": "Rarible",
                        "only_proxied_transfers": false,
                        "opensea_buyer_fee_basis_points": "0",
                        "opensea_seller_fee_basis_points": "250",
                        "payout_address": null,
                        "require_email": false,
                        "short_description": null,
                        "slug": "rarible",
                        "telegram_url": "https://t.me/rarible",
                        "twitter_username": "rariblecom",
                        "instagram_username": null,
                        "wiki_url": null
                    },
                    "decimals": null,
                    "token_metadata": "https://ipfs.io/ipfs/QmQEctHKc1dbxyfM2f9gK9Kw3Uzxn9rRBcmK8boVX9PsT5"
                }
            ],
            "name": "Ophanim & Flat E & Mother Savior",
            "description": "",
            "external_link": "",
            "asset_contract": {
                "collection": {
                    "banner_image_url": "https://storage.opensea.io/static/banners/rarible-banner4.png",
                    "chat_url": null,
                    "created_date": "2020-01-01T13:22:57.777065",
                    "default_to_fiat": false,
                    "description": "Create and sell digital collectibles secured with blockchain technology. Rarible is home to thousands of artists and collectors, creating and exchanging immutable art without using code. Trade with RARI token on OpenSea.",
                    "dev_buyer_fee_basis_points": "0",
                    "dev_seller_fee_basis_points": "0",
                    "discord_url": null,
                    "display_data": {
                        "card_display_style": "contain"
                    },
                    "external_url": "https://rarible.com/",
                    "featured": false,
                    "featured_image_url": null,
                    "hidden": false,
                    "safelist_request_status": "verified",
                    "image_url": "https://lh3.googleusercontent.com/FG0QJ00fN3c_FWuPeUr9-T__iQl63j9hn5d6svW8UqOmia5zp3lKHPkJuHcvhZ0f_Pd6P2COo9tt9zVUvdPxG_9BBw=s60",
                    "is_subject_to_whitelist": false,
                    "large_image_url": "https://lh3.googleusercontent.com/FG0QJ00fN3c_FWuPeUr9-T__iQl63j9hn5d6svW8UqOmia5zp3lKHPkJuHcvhZ0f_Pd6P2COo9tt9zVUvdPxG_9BBw",
                    "medium_username": "rarible",
                    "name": "Rarible",
                    "only_proxied_transfers": false,
                    "opensea_buyer_fee_basis_points": "0",
                    "opensea_seller_fee_basis_points": "250",
                    "payout_address": null,
                    "require_email": false,
                    "short_description": null,
                    "slug": "rarible",
                    "telegram_url": "https://t.me/rarible",
                    "twitter_username": "rariblecom",
                    "instagram_username": null,
                    "wiki_url": null
                },
                "address": "0xd07dc4262bcdbf85190c01c996b4c06a461d2430",
                "asset_contract_type": "semi-fungible",
                "created_date": "2020-05-27T16:53:32.834583",
                "name": "Rarible 1155",
                "nft_version": null,
                "opensea_version": null,
                "owner": 42603523,
                "schema_name": "ERC1155",
                "symbol": "",
                "total_supply": null,
                "description": "Create and sell digital collectibles secured with blockchain technology. Rarible is home to thousands of artists and collectors, creating and exchanging immutable art without using code. Trade with RARI token on OpenSea.",
                "external_link": "https://rarible.com/",
                "image_url": "https://lh3.googleusercontent.com/FG0QJ00fN3c_FWuPeUr9-T__iQl63j9hn5d6svW8UqOmia5zp3lKHPkJuHcvhZ0f_Pd6P2COo9tt9zVUvdPxG_9BBw=s60",
                "default_to_fiat": false,
                "dev_buyer_fee_basis_points": 0,
                "dev_seller_fee_basis_points": 0,
                "only_proxied_transfers": false,
                "opensea_buyer_fee_basis_points": 0,
                "opensea_seller_fee_basis_points": 250,
                "buyer_fee_basis_points": 0,
                "seller_fee_basis_points": 250,
                "payout_address": null
            },
            "permalink": "https://opensea.io/bundles/ophanim-flat-e-mother-savior-jXb",
            "sell_orders": [
                {
                    "created_date": "2021-05-25T21:20:58.632425",
                    "closing_date": "2021-05-25T23:30:00",
                    "closing_extendable": false,
                    "expiration_time": 1621985400,
                    "listing_time": 1621977552,
                    "order_hash": "0x04a865ccbcabf37e5fdaec4ff00dd7fa4082c8cf1f93a9dd96dcdceb5d2fd9b9",
                    "metadata": {
                        "bundle": {
                            "assets": [
                                {
                                    "id": "36384",
                                    "address": "0xd07dc4262bcdbf85190c01c996b4c06a461d2430",
                                    "quantity": "1"
                                },
                                {
                                    "id": "36726",
                                    "address": "0xd07dc4262bcdbf85190c01c996b4c06a461d2430",
                                    "quantity": "1"
                                },
                                {
                                    "id": "504064",
                                    "address": "0xd07dc4262bcdbf85190c01c996b4c06a461d2430",
                                    "quantity": "1"
                                }
                            ],
                            "schemas": [
                                "ERC1155",
                                "ERC1155",
                                "ERC1155"
                            ],
                            "name": "Ophanim & Flat E & Mother Savior",
                            "description": "",
                            "external_link": ""
                        }
                    },
                    "exchange": "0x7be8076f4ea4a4ad08075c2508e481d6c946d12b",
                    "maker": {
                        "user": 601518,
                        "profile_img_url": "https://storage.googleapis.com/opensea-static/opensea-profile/13.png",
                        "address": "0xbcba66a96b330be24133fa768d94eb4deb8cfc3b",
                        "config": "",
                        "discord_id": ""
                    },
                    "taker": {
                        "user": 1766,
                        "profile_img_url": "https://storage.googleapis.com/opensea-static/opensea-profile/1.png",
                        "address": "0x0000000000000000000000000000000000000000",
                        "config": "",
                        "discord_id": ""
                    },
                    "current_price": "79297789336466040.83777633294",
                    "current_bounty": "792977885004212",
                    "bounty_multiple": "0.01",
                    "maker_relayer_fee": "250",
                    "taker_relayer_fee": "0",
                    "maker_protocol_fee": "0",
                    "taker_protocol_fee": "0",
                    "maker_referrer_fee": "0",
                    "fee_recipient": {
                        "user": 3585,
                        "profile_img_url": "https://storage.googleapis.com/opensea-static/opensea-profile/28.png",
                        "address": "0x5b3256965e7c3cf26e11fcaf296dfc8807c01073",
                        "config": "verified",
                        "discord_id": ""
                    },
                    "fee_method": 1,
                    "side": 1,
                    "sale_kind": 1,
                    "target": "0xc99f70bfd82fb7c8f8191fdfbfb735606b15e5c5",
                    "how_to_call": 1,
                    "calldata": "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",
                    "replacement_pattern": "0x0000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000ffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffff0000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000ffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffff0000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000ffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffff00000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000",
                    "static_target": "0x0000000000000000000000000000000000000000",
                    "static_extradata": "0x",
                    "payment_token": "0x0000000000000000000000000000000000000000",
                    "payment_token_contract": {
                        "id": 1,
                        "symbol": "ETH",
                        "address": "0x0000000000000000000000000000000000000000",
                        "image_url": "https://storage.opensea.io/files/6f8e2979d428180222796ff4a33ab929.svg",
                        "name": "Ether",
                        "decimals": 18,
                        "eth_price": "1.000000000000000",
                        "usd_price": "2625.730000000000018000"
                    },
                    "base_price": "150000000000000000",
                    "extra": "79999999999999990",
                    "quantity": "1",
                    "salt": "56017759069718323172553900949789764510027696525748254330540422089112708500067",
                    "v": 28,
                    "r": "0x8248a2f7548782b9ef9f5b681ee000921f22217d5c3cd80e331fffae17b77006",
                    "s": "0x07b04c00d0d1b102654aa85d99f265887fd0df91553e91be84776d4909d43730",
                    "approved_on_chain": false,
                    "cancelled": false,
                    "finalized": false,
                    "marked_invalid": false,
                    "prefixed_hash": "0x89c17d5feb31d0c9002b9ad681cae3b3ac5a3191f506a247f839da0e9a29cb67"
                }
            ]
        },
        {
            "maker": {
                "user": {
                    "username": "JakeShepherd"
                },
                "profile_img_url": "https://storage.googleapis.com/opensea-static/opensea-profile/29.png",
                "address": "0xd887758a36bbf3c44ba3f1ffa0d8ff8d536cc129",
                "config": "",
                "discord_id": ""
            },
            "slug": "huge-bundle-10-eggs-some-2x-10-monsters-AS3",
            "assets": [
                {
                    "id": 21902767,
                    "token_id": "188",
                    "num_sales": 0,
                    "background_color": null,
                    "image_url": "https://lh3.googleusercontent.com/KO81jiVK7j_X8IBiBrT6IGYidy0kRx9jSXVGo8_BSF6c52Adt2LqAjgl6weJJxNj8yQoh2moPZHISaL9fBOcnfSSpgxOFzF4R3kFxw",
                    "image_preview_url": "https://lh3.googleusercontent.com/KO81jiVK7j_X8IBiBrT6IGYidy0kRx9jSXVGo8_BSF6c52Adt2LqAjgl6weJJxNj8yQoh2moPZHISaL9fBOcnfSSpgxOFzF4R3kFxw=s250",
                    "image_thumbnail_url": "https://lh3.googleusercontent.com/KO81jiVK7j_X8IBiBrT6IGYidy0kRx9jSXVGo8_BSF6c52Adt2LqAjgl6weJJxNj8yQoh2moPZHISaL9fBOcnfSSpgxOFzF4R3kFxw=s128",
                    "image_original_url": "https://arweave.net/PImNF2j_gMNHMPBIIl2TE19ksZGHe117FY6Y4QcnNR8",
                    "animation_url": null,
                    "animation_original_url": null,
                    "name": "Genesis Egg #188",
                    "description": "Apymon is a collection of 6400 creatures created by AI which are contained in procedurally designed eggs. What makes these Genesis Eggs special is that they can hold other NFTs, ERC20 and ERC1155 tokens, making them function as your personal vault. No two Apymon creatures or Genesis Eggs are the same, each one is unique and crafted with love.",
                    "external_link": "https://apymon.com",
                    "asset_contract": {
                        "address": "0x9c008a22d71b6182029b694b0311486e4c0e53db",
                        "asset_contract_type": "non-fungible",
                        "created_date": "2021-04-13T22:14:12.881973",
                        "name": "Apymon",
                        "nft_version": "3.0",
                        "opensea_version": null,
                        "owner": 30104721,
                        "schema_name": "ERC721",
                        "symbol": "APYMON",
                        "total_supply": "0",
                        "description": "Apymon is a collection of 6400 creatures created by AI which are contained in procedurally designed eggs. What makes these Genesis Eggs special is that they can hold other NFTs, ERC20 and ERC1155 tokens, making them function as your personal vault. No two Apymon creatures or  Genesis Eggs are the same, each one is unique and crafted with love.\nMint your Genesis Egg at https://apymon.com\nFollow our Twitter (https://twitter.com/ApymonOfficial) for the latest news and join our Discord (https://discord.gg/apymon) to chat with the community",
                        "external_link": "https://apymon.com/",
                        "image_url": "https://lh3.googleusercontent.com/8OogKrYF_3kTL3w_8J_TwEWTn6E4OS_SP5EVdeAJnw7GycEJJy36uZYkLKoMnrX-ObWNYlMpEIu5fGoRMtJrkL8HRnVz4gY8jrD2Cw=s120",
                        "default_to_fiat": false,
                        "dev_buyer_fee_basis_points": 0,
                        "dev_seller_fee_basis_points": 0,
                        "only_proxied_transfers": false,
                        "opensea_buyer_fee_basis_points": 0,
                        "opensea_seller_fee_basis_points": 250,
                        "buyer_fee_basis_points": 0,
                        "seller_fee_basis_points": 250,
                        "payout_address": null
                    },
                    "owner": {
                        "user": {
                            "username": "JakeShepherd"
                        },
                        "profile_img_url": "https://storage.googleapis.com/opensea-static/opensea-profile/29.png",
                        "address": "0xd887758a36bbf3c44ba3f1ffa0d8ff8d536cc129",
                        "config": "",
                        "discord_id": ""
                    },
                    "permalink": "https://opensea.io/assets/0x9c008a22d71b6182029b694b0311486e4c0e53db/188",
                    "collection": {
                        "banner_image_url": "https://lh3.googleusercontent.com/fdO2dxomM3FxkZiO7B8c-ie6Dj3VfhOlmYy-VgHsjkaFpjvfyd3a4wmglM9fLdpc4n9_s_bY_6MAzOmHacl5LApQ4agG4YEtCboMMd4=s2500",
                        "chat_url": null,
                        "created_date": "2021-04-13T23:45:21.662101",
                        "default_to_fiat": false,
                        "description": "Apymon is a collection of 6400 creatures created by AI which are contained in procedurally designed eggs. What makes these Genesis Eggs special is that they can hold other NFTs, ERC20 and ERC1155 tokens, making them function as your personal vault. No two Apymon creatures or  Genesis Eggs are the same, each one is unique and crafted with love.\nMint your Genesis Egg at https://apymon.com\nFollow our Twitter (https://twitter.com/ApymonOfficial) for the latest news and join our Discord (https://discord.gg/apymon) to chat with the community",
                        "dev_buyer_fee_basis_points": "0",
                        "dev_seller_fee_basis_points": "0",
                        "discord_url": "https://discord.gg/K2PQnsJR7h",
                        "display_data": {
                            "card_display_style": "contain"
                        },
                        "external_url": "https://apymon.com/",
                        "featured": false,
                        "featured_image_url": "https://lh3.googleusercontent.com/tr5SJmi42FEob8GHgBZj4CG1w-J_b2jK2TwjguvUrSZDWsTQDM9er-jdTfHnv7rfAbHy6wpkwOXVYz1HvS1M7u-QgkOj5rrv-jk8zw=s300",
                        "hidden": false,
                        "safelist_request_status": "approved",
                        "image_url": "https://lh3.googleusercontent.com/8OogKrYF_3kTL3w_8J_TwEWTn6E4OS_SP5EVdeAJnw7GycEJJy36uZYkLKoMnrX-ObWNYlMpEIu5fGoRMtJrkL8HRnVz4gY8jrD2Cw=s120",
                        "is_subject_to_whitelist": false,
                        "large_image_url": "https://lh3.googleusercontent.com/tr5SJmi42FEob8GHgBZj4CG1w-J_b2jK2TwjguvUrSZDWsTQDM9er-jdTfHnv7rfAbHy6wpkwOXVYz1HvS1M7u-QgkOj5rrv-jk8zw=s300",
                        "medium_username": "apymon",
                        "name": "Apymon",
                        "only_proxied_transfers": false,
                        "opensea_buyer_fee_basis_points": "0",
                        "opensea_seller_fee_basis_points": "250",
                        "payout_address": null,
                        "require_email": false,
                        "short_description": null,
                        "slug": "apymon",
                        "telegram_url": null,
                        "twitter_username": "ApymonOfficial",
                        "instagram_username": null,
                        "wiki_url": null
                    },
                    "decimals": 0,
                    "token_metadata": "https://gateway.pinata.cloud/ipfs/QmbbsQmfaoX41xKh2g3Ng563WMQ1BmeaQC2BnoaUkT7DHQ/188"
                },
                {
                    "id": 21902769,
                    "token_id": "189",
                    "num_sales": 0,
                    "background_color": null,
                    "image_url": "https://lh3.googleusercontent.com/cXn8WKHyo3ahv0yJmQjeaDhlZxCnW7wGyBdXEsxUb9X_zHfx8KmGv4nSZfoGlut0lEL9ikRTVu75HVkLc0P_oimOSMt6WkU-PMA5",
                    "image_preview_url": "https://lh3.googleusercontent.com/cXn8WKHyo3ahv0yJmQjeaDhlZxCnW7wGyBdXEsxUb9X_zHfx8KmGv4nSZfoGlut0lEL9ikRTVu75HVkLc0P_oimOSMt6WkU-PMA5=s250",
                    "image_thumbnail_url": "https://lh3.googleusercontent.com/cXn8WKHyo3ahv0yJmQjeaDhlZxCnW7wGyBdXEsxUb9X_zHfx8KmGv4nSZfoGlut0lEL9ikRTVu75HVkLc0P_oimOSMt6WkU-PMA5=s128",
                    "image_original_url": "https://arweave.net/Q6P_gy0BONzVleeMAiD-ELATSkqvhxaH6QiARA7qZ_I",
                    "animation_url": null,
                    "animation_original_url": null,
                    "name": "Genesis Egg #189",
                    "description": "Apymon is a collection of 6400 creatures created by AI which are contained in procedurally designed eggs. What makes these Genesis Eggs special is that they can hold other NFTs, ERC20 and ERC1155 tokens, making them function as your personal vault. No two Apymon creatures or Genesis Eggs are the same, each one is unique and crafted with love.",
                    "external_link": "https://apymon.com",
                    "asset_contract": {
                        "address": "0x9c008a22d71b6182029b694b0311486e4c0e53db",
                        "asset_contract_type": "non-fungible",
                        "created_date": "2021-04-13T22:14:12.881973",
                        "name": "Apymon",
                        "nft_version": "3.0",
                        "opensea_version": null,
                        "owner": 30104721,
                        "schema_name": "ERC721",
                        "symbol": "APYMON",
                        "total_supply": "0",
                        "description": "Apymon is a collection of 6400 creatures created by AI which are contained in procedurally designed eggs. What makes these Genesis Eggs special is that they can hold other NFTs, ERC20 and ERC1155 tokens, making them function as your personal vault. No two Apymon creatures or  Genesis Eggs are the same, each one is unique and crafted with love.\nMint your Genesis Egg at https://apymon.com\nFollow our Twitter (https://twitter.com/ApymonOfficial) for the latest news and join our Discord (https://discord.gg/apymon) to chat with the community",
                        "external_link": "https://apymon.com/",
                        "image_url": "https://lh3.googleusercontent.com/8OogKrYF_3kTL3w_8J_TwEWTn6E4OS_SP5EVdeAJnw7GycEJJy36uZYkLKoMnrX-ObWNYlMpEIu5fGoRMtJrkL8HRnVz4gY8jrD2Cw=s120",
                        "default_to_fiat": false,
                        "dev_buyer_fee_basis_points": 0,
                        "dev_seller_fee_basis_points": 0,
                        "only_proxied_transfers": false,
                        "opensea_buyer_fee_basis_points": 0,
                        "opensea_seller_fee_basis_points": 250,
                        "buyer_fee_basis_points": 0,
                        "seller_fee_basis_points": 250,
                        "payout_address": null
                    },
                    "owner": {
                        "user": {
                            "username": "JakeShepherd"
                        },
                        "profile_img_url": "https://storage.googleapis.com/opensea-static/opensea-profile/29.png",
                        "address": "0xd887758a36bbf3c44ba3f1ffa0d8ff8d536cc129",
                        "config": "",
                        "discord_id": ""
                    },
                    "permalink": "https://opensea.io/assets/0x9c008a22d71b6182029b694b0311486e4c0e53db/189",
                    "collection": {
                        "banner_image_url": "https://lh3.googleusercontent.com/fdO2dxomM3FxkZiO7B8c-ie6Dj3VfhOlmYy-VgHsjkaFpjvfyd3a4wmglM9fLdpc4n9_s_bY_6MAzOmHacl5LApQ4agG4YEtCboMMd4=s2500",
                        "chat_url": null,
                        "created_date": "2021-04-13T23:45:21.662101",
                        "default_to_fiat": false,
                        "description": "Apymon is a collection of 6400 creatures created by AI which are contained in procedurally designed eggs. What makes these Genesis Eggs special is that they can hold other NFTs, ERC20 and ERC1155 tokens, making them function as your personal vault. No two Apymon creatures or  Genesis Eggs are the same, each one is unique and crafted with love.\nMint your Genesis Egg at https://apymon.com\nFollow our Twitter (https://twitter.com/ApymonOfficial) for the latest news and join our Discord (https://discord.gg/apymon) to chat with the community",
                        "dev_buyer_fee_basis_points": "0",
                        "dev_seller_fee_basis_points": "0",
                        "discord_url": "https://discord.gg/K2PQnsJR7h",
                        "display_data": {
                            "card_display_style": "contain"
                        },
                        "external_url": "https://apymon.com/",
                        "featured": false,
                        "featured_image_url": "https://lh3.googleusercontent.com/tr5SJmi42FEob8GHgBZj4CG1w-J_b2jK2TwjguvUrSZDWsTQDM9er-jdTfHnv7rfAbHy6wpkwOXVYz1HvS1M7u-QgkOj5rrv-jk8zw=s300",
                        "hidden": false,
                        "safelist_request_status": "approved",
                        "image_url": "https://lh3.googleusercontent.com/8OogKrYF_3kTL3w_8J_TwEWTn6E4OS_SP5EVdeAJnw7GycEJJy36uZYkLKoMnrX-ObWNYlMpEIu5fGoRMtJrkL8HRnVz4gY8jrD2Cw=s120",
                        "is_subject_to_whitelist": false,
                        "large_image_url": "https://lh3.googleusercontent.com/tr5SJmi42FEob8GHgBZj4CG1w-J_b2jK2TwjguvUrSZDWsTQDM9er-jdTfHnv7rfAbHy6wpkwOXVYz1HvS1M7u-QgkOj5rrv-jk8zw=s300",
                        "medium_username": "apymon",
                        "name": "Apymon",
                        "only_proxied_transfers": false,
                        "opensea_buyer_fee_basis_points": "0",
                        "opensea_seller_fee_basis_points": "250",
                        "payout_address": null,
                        "require_email": false,
                        "short_description": null,
                        "slug": "apymon",
                        "telegram_url": null,
                        "twitter_username": "ApymonOfficial",
                        "instagram_username": null,
                        "wiki_url": null
                    },
                    "decimals": 0,
                    "token_metadata": "https://gateway.pinata.cloud/ipfs/QmbbsQmfaoX41xKh2g3Ng563WMQ1BmeaQC2BnoaUkT7DHQ/189"
                },
                {
                    "id": 21902770,
                    "token_id": "190",
                    "num_sales": 0,
                    "background_color": null,
                    "image_url": "https://lh3.googleusercontent.com/SgxL9XWnF31e4NpNv9uamz4K0oGr2Ol5xxXQg_1LaiWxIYOQqnw36F0942C_B6Zd1-pQnlKa73C5ZHDY4QZ0caRUUL-h6P9C0ByI",
                    "image_preview_url": "https://lh3.googleusercontent.com/SgxL9XWnF31e4NpNv9uamz4K0oGr2Ol5xxXQg_1LaiWxIYOQqnw36F0942C_B6Zd1-pQnlKa73C5ZHDY4QZ0caRUUL-h6P9C0ByI=s250",
                    "image_thumbnail_url": "https://lh3.googleusercontent.com/SgxL9XWnF31e4NpNv9uamz4K0oGr2Ol5xxXQg_1LaiWxIYOQqnw36F0942C_B6Zd1-pQnlKa73C5ZHDY4QZ0caRUUL-h6P9C0ByI=s128",
                    "image_original_url": "https://arweave.net/sFdBScvYmqXZj3KzLtrx9m-b-7Ht3emw0RN7i8tAsj0",
                    "animation_url": null,
                    "animation_original_url": null,
                    "name": "Genesis Egg #190",
                    "description": "Apymon is a collection of 6400 creatures created by AI which are contained in procedurally designed eggs. What makes these Genesis Eggs special is that they can hold other NFTs, ERC20 and ERC1155 tokens, making them function as your personal vault. No two Apymon creatures or Genesis Eggs are the same, each one is unique and crafted with love.",
                    "external_link": "https://apymon.com",
                    "asset_contract": {
                        "address": "0x9c008a22d71b6182029b694b0311486e4c0e53db",
                        "asset_contract_type": "non-fungible",
                        "created_date": "2021-04-13T22:14:12.881973",
                        "name": "Apymon",
                        "nft_version": "3.0",
                        "opensea_version": null,
                        "owner": 30104721,
                        "schema_name": "ERC721",
                        "symbol": "APYMON",
                        "total_supply": "0",
                        "description": "Apymon is a collection of 6400 creatures created by AI which are contained in procedurally designed eggs. What makes these Genesis Eggs special is that they can hold other NFTs, ERC20 and ERC1155 tokens, making them function as your personal vault. No two Apymon creatures or  Genesis Eggs are the same, each one is unique and crafted with love.\nMint your Genesis Egg at https://apymon.com\nFollow our Twitter (https://twitter.com/ApymonOfficial) for the latest news and join our Discord (https://discord.gg/apymon) to chat with the community",
                        "external_link": "https://apymon.com/",
                        "image_url": "https://lh3.googleusercontent.com/8OogKrYF_3kTL3w_8J_TwEWTn6E4OS_SP5EVdeAJnw7GycEJJy36uZYkLKoMnrX-ObWNYlMpEIu5fGoRMtJrkL8HRnVz4gY8jrD2Cw=s120",
                        "default_to_fiat": false,
                        "dev_buyer_fee_basis_points": 0,
                        "dev_seller_fee_basis_points": 0,
                        "only_proxied_transfers": false,
                        "opensea_buyer_fee_basis_points": 0,
                        "opensea_seller_fee_basis_points": 250,
                        "buyer_fee_basis_points": 0,
                        "seller_fee_basis_points": 250,
                        "payout_address": null
                    },
                    "owner": {
                        "user": {
                            "username": "JakeShepherd"
                        },
                        "profile_img_url": "https://storage.googleapis.com/opensea-static/opensea-profile/29.png",
                        "address": "0xd887758a36bbf3c44ba3f1ffa0d8ff8d536cc129",
                        "config": "",
                        "discord_id": ""
                    },
                    "permalink": "https://opensea.io/assets/0x9c008a22d71b6182029b694b0311486e4c0e53db/190",
                    "collection": {
                        "banner_image_url": "https://lh3.googleusercontent.com/fdO2dxomM3FxkZiO7B8c-ie6Dj3VfhOlmYy-VgHsjkaFpjvfyd3a4wmglM9fLdpc4n9_s_bY_6MAzOmHacl5LApQ4agG4YEtCboMMd4=s2500",
                        "chat_url": null,
                        "created_date": "2021-04-13T23:45:21.662101",
                        "default_to_fiat": false,
                        "description": "Apymon is a collection of 6400 creatures created by AI which are contained in procedurally designed eggs. What makes these Genesis Eggs special is that they can hold other NFTs, ERC20 and ERC1155 tokens, making them function as your personal vault. No two Apymon creatures or  Genesis Eggs are the same, each one is unique and crafted with love.\nMint your Genesis Egg at https://apymon.com\nFollow our Twitter (https://twitter.com/ApymonOfficial) for the latest news and join our Discord (https://discord.gg/apymon) to chat with the community",
                        "dev_buyer_fee_basis_points": "0",
                        "dev_seller_fee_basis_points": "0",
                        "discord_url": "https://discord.gg/K2PQnsJR7h",
                        "display_data": {
                            "card_display_style": "contain"
                        },
                        "external_url": "https://apymon.com/",
                        "featured": false,
                        "featured_image_url": "https://lh3.googleusercontent.com/tr5SJmi42FEob8GHgBZj4CG1w-J_b2jK2TwjguvUrSZDWsTQDM9er-jdTfHnv7rfAbHy6wpkwOXVYz1HvS1M7u-QgkOj5rrv-jk8zw=s300",
                        "hidden": false,
                        "safelist_request_status": "approved",
                        "image_url": "https://lh3.googleusercontent.com/8OogKrYF_3kTL3w_8J_TwEWTn6E4OS_SP5EVdeAJnw7GycEJJy36uZYkLKoMnrX-ObWNYlMpEIu5fGoRMtJrkL8HRnVz4gY8jrD2Cw=s120",
                        "is_subject_to_whitelist": false,
                        "large_image_url": "https://lh3.googleusercontent.com/tr5SJmi42FEob8GHgBZj4CG1w-J_b2jK2TwjguvUrSZDWsTQDM9er-jdTfHnv7rfAbHy6wpkwOXVYz1HvS1M7u-QgkOj5rrv-jk8zw=s300",
                        "medium_username": "apymon",
                        "name": "Apymon",
                        "only_proxied_transfers": false,
                        "opensea_buyer_fee_basis_points": "0",
                        "opensea_seller_fee_basis_points": "250",
                        "payout_address": null,
                        "require_email": false,
                        "short_description": null,
                        "slug": "apymon",
                        "telegram_url": null,
                        "twitter_username": "ApymonOfficial",
                        "instagram_username": null,
                        "wiki_url": null
                    },
                    "decimals": 0,
                    "token_metadata": "https://gateway.pinata.cloud/ipfs/QmSSEWJZ52aoj5WxwyJiBrtsZv8AEzL5J3KzjKUpoBi4sS/190"
                },
                {
                    "id": 21902771,
                    "token_id": "191",
                    "num_sales": 0,
                    "background_color": null,
                    "image_url": "https://lh3.googleusercontent.com/DLWj3lkoUUCraMFUGWy9y1qr3aPncSRu9hfchrH2Kwl9REhNVzCvKps1lciCIqro4vozI5Z4plJw861cWAIwL_aIXYJPIjeR1VNsTg",
                    "image_preview_url": "https://lh3.googleusercontent.com/DLWj3lkoUUCraMFUGWy9y1qr3aPncSRu9hfchrH2Kwl9REhNVzCvKps1lciCIqro4vozI5Z4plJw861cWAIwL_aIXYJPIjeR1VNsTg=s250",
                    "image_thumbnail_url": "https://lh3.googleusercontent.com/DLWj3lkoUUCraMFUGWy9y1qr3aPncSRu9hfchrH2Kwl9REhNVzCvKps1lciCIqro4vozI5Z4plJw861cWAIwL_aIXYJPIjeR1VNsTg=s128",
                    "image_original_url": "https://arweave.net/UBccHZllxGGd4-jWmqzH_EyjEZ98Npb_IGtPz4q_Gvg",
                    "animation_url": null,
                    "animation_original_url": null,
                    "name": "Genesis Egg #191",
                    "description": "Apymon is a collection of 6400 creatures created by AI which are contained in procedurally designed eggs. What makes these Genesis Eggs special is that they can hold other NFTs, ERC20 and ERC1155 tokens, making them function as your personal vault. No two Apymon creatures or Genesis Eggs are the same, each one is unique and crafted with love.",
                    "external_link": "https://apymon.com",
                    "asset_contract": {
                        "address": "0x9c008a22d71b6182029b694b0311486e4c0e53db",
                        "asset_contract_type": "non-fungible",
                        "created_date": "2021-04-13T22:14:12.881973",
                        "name": "Apymon",
                        "nft_version": "3.0",
                        "opensea_version": null,
                        "owner": 30104721,
                        "schema_name": "ERC721",
                        "symbol": "APYMON",
                        "total_supply": "0",
                        "description": "Apymon is a collection of 6400 creatures created by AI which are contained in procedurally designed eggs. What makes these Genesis Eggs special is that they can hold other NFTs, ERC20 and ERC1155 tokens, making them function as your personal vault. No two Apymon creatures or  Genesis Eggs are the same, each one is unique and crafted with love.\nMint your Genesis Egg at https://apymon.com\nFollow our Twitter (https://twitter.com/ApymonOfficial) for the latest news and join our Discord (https://discord.gg/apymon) to chat with the community",
                        "external_link": "https://apymon.com/",
                        "image_url": "https://lh3.googleusercontent.com/8OogKrYF_3kTL3w_8J_TwEWTn6E4OS_SP5EVdeAJnw7GycEJJy36uZYkLKoMnrX-ObWNYlMpEIu5fGoRMtJrkL8HRnVz4gY8jrD2Cw=s120",
                        "default_to_fiat": false,
                        "dev_buyer_fee_basis_points": 0,
                        "dev_seller_fee_basis_points": 0,
                        "only_proxied_transfers": false,
                        "opensea_buyer_fee_basis_points": 0,
                        "opensea_seller_fee_basis_points": 250,
                        "buyer_fee_basis_points": 0,
                        "seller_fee_basis_points": 250,
                        "payout_address": null
                    },
                    "owner": {
                        "user": {
                            "username": "JakeShepherd"
                        },
                        "profile_img_url": "https://storage.googleapis.com/opensea-static/opensea-profile/29.png",
                        "address": "0xd887758a36bbf3c44ba3f1ffa0d8ff8d536cc129",
                        "config": "",
                        "discord_id": ""
                    },
                    "permalink": "https://opensea.io/assets/0x9c008a22d71b6182029b694b0311486e4c0e53db/191",
                    "collection": {
                        "banner_image_url": "https://lh3.googleusercontent.com/fdO2dxomM3FxkZiO7B8c-ie6Dj3VfhOlmYy-VgHsjkaFpjvfyd3a4wmglM9fLdpc4n9_s_bY_6MAzOmHacl5LApQ4agG4YEtCboMMd4=s2500",
                        "chat_url": null,
                        "created_date": "2021-04-13T23:45:21.662101",
                        "default_to_fiat": false,
                        "description": "Apymon is a collection of 6400 creatures created by AI which are contained in procedurally designed eggs. What makes these Genesis Eggs special is that they can hold other NFTs, ERC20 and ERC1155 tokens, making them function as your personal vault. No two Apymon creatures or  Genesis Eggs are the same, each one is unique and crafted with love.\nMint your Genesis Egg at https://apymon.com\nFollow our Twitter (https://twitter.com/ApymonOfficial) for the latest news and join our Discord (https://discord.gg/apymon) to chat with the community",
                        "dev_buyer_fee_basis_points": "0",
                        "dev_seller_fee_basis_points": "0",
                        "discord_url": "https://discord.gg/K2PQnsJR7h",
                        "display_data": {
                            "card_display_style": "contain"
                        },
                        "external_url": "https://apymon.com/",
                        "featured": false,
                        "featured_image_url": "https://lh3.googleusercontent.com/tr5SJmi42FEob8GHgBZj4CG1w-J_b2jK2TwjguvUrSZDWsTQDM9er-jdTfHnv7rfAbHy6wpkwOXVYz1HvS1M7u-QgkOj5rrv-jk8zw=s300",
                        "hidden": false,
                        "safelist_request_status": "approved",
                        "image_url": "https://lh3.googleusercontent.com/8OogKrYF_3kTL3w_8J_TwEWTn6E4OS_SP5EVdeAJnw7GycEJJy36uZYkLKoMnrX-ObWNYlMpEIu5fGoRMtJrkL8HRnVz4gY8jrD2Cw=s120",
                        "is_subject_to_whitelist": false,
                        "large_image_url": "https://lh3.googleusercontent.com/tr5SJmi42FEob8GHgBZj4CG1w-J_b2jK2TwjguvUrSZDWsTQDM9er-jdTfHnv7rfAbHy6wpkwOXVYz1HvS1M7u-QgkOj5rrv-jk8zw=s300",
                        "medium_username": "apymon",
                        "name": "Apymon",
                        "only_proxied_transfers": false,
                        "opensea_buyer_fee_basis_points": "0",
                        "opensea_seller_fee_basis_points": "250",
                        "payout_address": null,
                        "require_email": false,
                        "short_description": null,
                        "slug": "apymon",
                        "telegram_url": null,
                        "twitter_username": "ApymonOfficial",
                        "instagram_username": null,
                        "wiki_url": null
                    },
                    "decimals": 0,
                    "token_metadata": "https://gateway.pinata.cloud/ipfs/QmRG2zSxpoF6CeyLehQxAHA2egRDB3wJ1n65S6dh64sqiV/191"
                },
                {
                    "id": 21902774,
                    "token_id": "192",
                    "num_sales": 0,
                    "background_color": null,
                    "image_url": "https://lh3.googleusercontent.com/zrNrGMih4BVgU8FyFJ4pTVCO26jS9gzUo2wVXXkfntcgVEerVFgJ6v8uH3FwsPjlbHvJEge5OsayBmI-mVpwkxd0JRCJSdDCa_uW0nY",
                    "image_preview_url": "https://lh3.googleusercontent.com/zrNrGMih4BVgU8FyFJ4pTVCO26jS9gzUo2wVXXkfntcgVEerVFgJ6v8uH3FwsPjlbHvJEge5OsayBmI-mVpwkxd0JRCJSdDCa_uW0nY=s250",
                    "image_thumbnail_url": "https://lh3.googleusercontent.com/zrNrGMih4BVgU8FyFJ4pTVCO26jS9gzUo2wVXXkfntcgVEerVFgJ6v8uH3FwsPjlbHvJEge5OsayBmI-mVpwkxd0JRCJSdDCa_uW0nY=s128",
                    "image_original_url": "https://arweave.net/vIpSjh6YCqGDMITtYZ3xs6oYI7vqsJWjricG7L2JuMA",
                    "animation_url": null,
                    "animation_original_url": null,
                    "name": "Genesis Egg #192",
                    "description": "Apymon is a collection of 6400 creatures created by AI which are contained in procedurally designed eggs. What makes these Genesis Eggs special is that they can hold other NFTs, ERC20 and ERC1155 tokens, making them function as your personal vault. No two Apymon creatures or Genesis Eggs are the same, each one is unique and crafted with love.",
                    "external_link": "https://apymon.com",
                    "asset_contract": {
                        "address": "0x9c008a22d71b6182029b694b0311486e4c0e53db",
                        "asset_contract_type": "non-fungible",
                        "created_date": "2021-04-13T22:14:12.881973",
                        "name": "Apymon",
                        "nft_version": "3.0",
                        "opensea_version": null,
                        "owner": 30104721,
                        "schema_name": "ERC721",
                        "symbol": "APYMON",
                        "total_supply": "0",
                        "description": "Apymon is a collection of 6400 creatures created by AI which are contained in procedurally designed eggs. What makes these Genesis Eggs special is that they can hold other NFTs, ERC20 and ERC1155 tokens, making them function as your personal vault. No two Apymon creatures or  Genesis Eggs are the same, each one is unique and crafted with love.\nMint your Genesis Egg at https://apymon.com\nFollow our Twitter (https://twitter.com/ApymonOfficial) for the latest news and join our Discord (https://discord.gg/apymon) to chat with the community",
                        "external_link": "https://apymon.com/",
                        "image_url": "https://lh3.googleusercontent.com/8OogKrYF_3kTL3w_8J_TwEWTn6E4OS_SP5EVdeAJnw7GycEJJy36uZYkLKoMnrX-ObWNYlMpEIu5fGoRMtJrkL8HRnVz4gY8jrD2Cw=s120",
                        "default_to_fiat": false,
                        "dev_buyer_fee_basis_points": 0,
                        "dev_seller_fee_basis_points": 0,
                        "only_proxied_transfers": false,
                        "opensea_buyer_fee_basis_points": 0,
                        "opensea_seller_fee_basis_points": 250,
                        "buyer_fee_basis_points": 0,
                        "seller_fee_basis_points": 250,
                        "payout_address": null
                    },
                    "owner": {
                        "user": {
                            "username": "JakeShepherd"
                        },
                        "profile_img_url": "https://storage.googleapis.com/opensea-static/opensea-profile/29.png",
                        "address": "0xd887758a36bbf3c44ba3f1ffa0d8ff8d536cc129",
                        "config": "",
                        "discord_id": ""
                    },
                    "permalink": "https://opensea.io/assets/0x9c008a22d71b6182029b694b0311486e4c0e53db/192",
                    "collection": {
                        "banner_image_url": "https://lh3.googleusercontent.com/fdO2dxomM3FxkZiO7B8c-ie6Dj3VfhOlmYy-VgHsjkaFpjvfyd3a4wmglM9fLdpc4n9_s_bY_6MAzOmHacl5LApQ4agG4YEtCboMMd4=s2500",
                        "chat_url": null,
                        "created_date": "2021-04-13T23:45:21.662101",
                        "default_to_fiat": false,
                        "description": "Apymon is a collection of 6400 creatures created by AI which are contained in procedurally designed eggs. What makes these Genesis Eggs special is that they can hold other NFTs, ERC20 and ERC1155 tokens, making them function as your personal vault. No two Apymon creatures or  Genesis Eggs are the same, each one is unique and crafted with love.\nMint your Genesis Egg at https://apymon.com\nFollow our Twitter (https://twitter.com/ApymonOfficial) for the latest news and join our Discord (https://discord.gg/apymon) to chat with the community",
                        "dev_buyer_fee_basis_points": "0",
                        "dev_seller_fee_basis_points": "0",
                        "discord_url": "https://discord.gg/K2PQnsJR7h",
                        "display_data": {
                            "card_display_style": "contain"
                        },
                        "external_url": "https://apymon.com/",
                        "featured": false,
                        "featured_image_url": "https://lh3.googleusercontent.com/tr5SJmi42FEob8GHgBZj4CG1w-J_b2jK2TwjguvUrSZDWsTQDM9er-jdTfHnv7rfAbHy6wpkwOXVYz1HvS1M7u-QgkOj5rrv-jk8zw=s300",
                        "hidden": false,
                        "safelist_request_status": "approved",
                        "image_url": "https://lh3.googleusercontent.com/8OogKrYF_3kTL3w_8J_TwEWTn6E4OS_SP5EVdeAJnw7GycEJJy36uZYkLKoMnrX-ObWNYlMpEIu5fGoRMtJrkL8HRnVz4gY8jrD2Cw=s120",
                        "is_subject_to_whitelist": false,
                        "large_image_url": "https://lh3.googleusercontent.com/tr5SJmi42FEob8GHgBZj4CG1w-J_b2jK2TwjguvUrSZDWsTQDM9er-jdTfHnv7rfAbHy6wpkwOXVYz1HvS1M7u-QgkOj5rrv-jk8zw=s300",
                        "medium_username": "apymon",
                        "name": "Apymon",
                        "only_proxied_transfers": false,
                        "opensea_buyer_fee_basis_points": "0",
                        "opensea_seller_fee_basis_points": "250",
                        "payout_address": null,
                        "require_email": false,
                        "short_description": null,
                        "slug": "apymon",
                        "telegram_url": null,
                        "twitter_username": "ApymonOfficial",
                        "instagram_username": null,
                        "wiki_url": null
                    },
                    "decimals": 0,
                    "token_metadata": "https://gateway.pinata.cloud/ipfs/QmeDH9PgJFsiv2zS845ZZdLtYQZZeoEXdq5KCCwp8cLegM/192"
                },
                {
                    "id": 21902775,
                    "token_id": "193",
                    "num_sales": 0,
                    "background_color": null,
                    "image_url": "https://lh3.googleusercontent.com/eyYlg4pDTKOG9zgVpv2f-sGYNuLFBA4fgEl1MR_WkeunvZzP4HK5OzJMqCZwCPWNyV3LCwQkYHu-FNEEln4JYPu8lpGvLOIs_f4tiAQ",
                    "image_preview_url": "https://lh3.googleusercontent.com/eyYlg4pDTKOG9zgVpv2f-sGYNuLFBA4fgEl1MR_WkeunvZzP4HK5OzJMqCZwCPWNyV3LCwQkYHu-FNEEln4JYPu8lpGvLOIs_f4tiAQ=s250",
                    "image_thumbnail_url": "https://lh3.googleusercontent.com/eyYlg4pDTKOG9zgVpv2f-sGYNuLFBA4fgEl1MR_WkeunvZzP4HK5OzJMqCZwCPWNyV3LCwQkYHu-FNEEln4JYPu8lpGvLOIs_f4tiAQ=s128",
                    "image_original_url": "https://arweave.net/5cK04uu1G_NqrYv4kYok6BeKZXr3c6XeGq244UuuFLs",
                    "animation_url": null,
                    "animation_original_url": null,
                    "name": "Genesis Egg #193",
                    "description": "Apymon is a collection of 6400 creatures created by AI which are contained in procedurally designed eggs. What makes these Genesis Eggs special is that they can hold other NFTs, ERC20 and ERC1155 tokens, making them function as your personal vault. No two Apymon creatures or Genesis Eggs are the same, each one is unique and crafted with love.",
                    "external_link": "https://apymon.com",
                    "asset_contract": {
                        "address": "0x9c008a22d71b6182029b694b0311486e4c0e53db",
                        "asset_contract_type": "non-fungible",
                        "created_date": "2021-04-13T22:14:12.881973",
                        "name": "Apymon",
                        "nft_version": "3.0",
                        "opensea_version": null,
                        "owner": 30104721,
                        "schema_name": "ERC721",
                        "symbol": "APYMON",
                        "total_supply": "0",
                        "description": "Apymon is a collection of 6400 creatures created by AI which are contained in procedurally designed eggs. What makes these Genesis Eggs special is that they can hold other NFTs, ERC20 and ERC1155 tokens, making them function as your personal vault. No two Apymon creatures or  Genesis Eggs are the same, each one is unique and crafted with love.\nMint your Genesis Egg at https://apymon.com\nFollow our Twitter (https://twitter.com/ApymonOfficial) for the latest news and join our Discord (https://discord.gg/apymon) to chat with the community",
                        "external_link": "https://apymon.com/",
                        "image_url": "https://lh3.googleusercontent.com/8OogKrYF_3kTL3w_8J_TwEWTn6E4OS_SP5EVdeAJnw7GycEJJy36uZYkLKoMnrX-ObWNYlMpEIu5fGoRMtJrkL8HRnVz4gY8jrD2Cw=s120",
                        "default_to_fiat": false,
                        "dev_buyer_fee_basis_points": 0,
                        "dev_seller_fee_basis_points": 0,
                        "only_proxied_transfers": false,
                        "opensea_buyer_fee_basis_points": 0,
                        "opensea_seller_fee_basis_points": 250,
                        "buyer_fee_basis_points": 0,
                        "seller_fee_basis_points": 250,
                        "payout_address": null
                    },
                    "owner": {
                        "user": {
                            "username": "JakeShepherd"
                        },
                        "profile_img_url": "https://storage.googleapis.com/opensea-static/opensea-profile/29.png",
                        "address": "0xd887758a36bbf3c44ba3f1ffa0d8ff8d536cc129",
                        "config": "",
                        "discord_id": ""
                    },
                    "permalink": "https://opensea.io/assets/0x9c008a22d71b6182029b694b0311486e4c0e53db/193",
                    "collection": {
                        "banner_image_url": "https://lh3.googleusercontent.com/fdO2dxomM3FxkZiO7B8c-ie6Dj3VfhOlmYy-VgHsjkaFpjvfyd3a4wmglM9fLdpc4n9_s_bY_6MAzOmHacl5LApQ4agG4YEtCboMMd4=s2500",
                        "chat_url": null,
                        "created_date": "2021-04-13T23:45:21.662101",
                        "default_to_fiat": false,
                        "description": "Apymon is a collection of 6400 creatures created by AI which are contained in procedurally designed eggs. What makes these Genesis Eggs special is that they can hold other NFTs, ERC20 and ERC1155 tokens, making them function as your personal vault. No two Apymon creatures or  Genesis Eggs are the same, each one is unique and crafted with love.\nMint your Genesis Egg at https://apymon.com\nFollow our Twitter (https://twitter.com/ApymonOfficial) for the latest news and join our Discord (https://discord.gg/apymon) to chat with the community",
                        "dev_buyer_fee_basis_points": "0",
                        "dev_seller_fee_basis_points": "0",
                        "discord_url": "https://discord.gg/K2PQnsJR7h",
                        "display_data": {
                            "card_display_style": "contain"
                        },
                        "external_url": "https://apymon.com/",
                        "featured": false,
                        "featured_image_url": "https://lh3.googleusercontent.com/tr5SJmi42FEob8GHgBZj4CG1w-J_b2jK2TwjguvUrSZDWsTQDM9er-jdTfHnv7rfAbHy6wpkwOXVYz1HvS1M7u-QgkOj5rrv-jk8zw=s300",
                        "hidden": false,
                        "safelist_request_status": "approved",
                        "image_url": "https://lh3.googleusercontent.com/8OogKrYF_3kTL3w_8J_TwEWTn6E4OS_SP5EVdeAJnw7GycEJJy36uZYkLKoMnrX-ObWNYlMpEIu5fGoRMtJrkL8HRnVz4gY8jrD2Cw=s120",
                        "is_subject_to_whitelist": false,
                        "large_image_url": "https://lh3.googleusercontent.com/tr5SJmi42FEob8GHgBZj4CG1w-J_b2jK2TwjguvUrSZDWsTQDM9er-jdTfHnv7rfAbHy6wpkwOXVYz1HvS1M7u-QgkOj5rrv-jk8zw=s300",
                        "medium_username": "apymon",
                        "name": "Apymon",
                        "only_proxied_transfers": false,
                        "opensea_buyer_fee_basis_points": "0",
                        "opensea_seller_fee_basis_points": "250",
                        "payout_address": null,
                        "require_email": false,
                        "short_description": null,
                        "slug": "apymon",
                        "telegram_url": null,
                        "twitter_username": "ApymonOfficial",
                        "instagram_username": null,
                        "wiki_url": null
                    },
                    "decimals": 0,
                    "token_metadata": "https://gateway.pinata.cloud/ipfs/QmSSEWJZ52aoj5WxwyJiBrtsZv8AEzL5J3KzjKUpoBi4sS/193"
                },
                {
                    "id": 21902776,
                    "token_id": "194",
                    "num_sales": 0,
                    "background_color": null,
                    "image_url": "https://lh3.googleusercontent.com/jIBSXwpbNuWQYt6RZXTo2DlRqwstM2z19IxIV1rI1PI-S8nJbKR-LEI_WHynAeOv_audSwOUDMajUaLff5IV-thgzhjxDvnbdLdrUw",
                    "image_preview_url": "https://lh3.googleusercontent.com/jIBSXwpbNuWQYt6RZXTo2DlRqwstM2z19IxIV1rI1PI-S8nJbKR-LEI_WHynAeOv_audSwOUDMajUaLff5IV-thgzhjxDvnbdLdrUw=s250",
                    "image_thumbnail_url": "https://lh3.googleusercontent.com/jIBSXwpbNuWQYt6RZXTo2DlRqwstM2z19IxIV1rI1PI-S8nJbKR-LEI_WHynAeOv_audSwOUDMajUaLff5IV-thgzhjxDvnbdLdrUw=s128",
                    "image_original_url": "https://arweave.net/O9913oy8wo5hcBNz5lMRF9vnwBXkP9RD3QD_hD4yHPk",
                    "animation_url": null,
                    "animation_original_url": null,
                    "name": "Genesis Egg #194",
                    "description": "Apymon is a collection of 6400 creatures created by AI which are contained in procedurally designed eggs. What makes these Genesis Eggs special is that they can hold other NFTs, ERC20 and ERC1155 tokens, making them function as your personal vault. No two Apymon creatures or Genesis Eggs are the same, each one is unique and crafted with love.",
                    "external_link": "https://apymon.com",
                    "asset_contract": {
                        "address": "0x9c008a22d71b6182029b694b0311486e4c0e53db",
                        "asset_contract_type": "non-fungible",
                        "created_date": "2021-04-13T22:14:12.881973",
                        "name": "Apymon",
                        "nft_version": "3.0",
                        "opensea_version": null,
                        "owner": 30104721,
                        "schema_name": "ERC721",
                        "symbol": "APYMON",
                        "total_supply": "0",
                        "description": "Apymon is a collection of 6400 creatures created by AI which are contained in procedurally designed eggs. What makes these Genesis Eggs special is that they can hold other NFTs, ERC20 and ERC1155 tokens, making them function as your personal vault. No two Apymon creatures or  Genesis Eggs are the same, each one is unique and crafted with love.\nMint your Genesis Egg at https://apymon.com\nFollow our Twitter (https://twitter.com/ApymonOfficial) for the latest news and join our Discord (https://discord.gg/apymon) to chat with the community",
                        "external_link": "https://apymon.com/",
                        "image_url": "https://lh3.googleusercontent.com/8OogKrYF_3kTL3w_8J_TwEWTn6E4OS_SP5EVdeAJnw7GycEJJy36uZYkLKoMnrX-ObWNYlMpEIu5fGoRMtJrkL8HRnVz4gY8jrD2Cw=s120",
                        "default_to_fiat": false,
                        "dev_buyer_fee_basis_points": 0,
                        "dev_seller_fee_basis_points": 0,
                        "only_proxied_transfers": false,
                        "opensea_buyer_fee_basis_points": 0,
                        "opensea_seller_fee_basis_points": 250,
                        "buyer_fee_basis_points": 0,
                        "seller_fee_basis_points": 250,
                        "payout_address": null
                    },
                    "owner": {
                        "user": {
                            "username": "JakeShepherd"
                        },
                        "profile_img_url": "https://storage.googleapis.com/opensea-static/opensea-profile/29.png",
                        "address": "0xd887758a36bbf3c44ba3f1ffa0d8ff8d536cc129",
                        "config": "",
                        "discord_id": ""
                    },
                    "permalink": "https://opensea.io/assets/0x9c008a22d71b6182029b694b0311486e4c0e53db/194",
                    "collection": {
                        "banner_image_url": "https://lh3.googleusercontent.com/fdO2dxomM3FxkZiO7B8c-ie6Dj3VfhOlmYy-VgHsjkaFpjvfyd3a4wmglM9fLdpc4n9_s_bY_6MAzOmHacl5LApQ4agG4YEtCboMMd4=s2500",
                        "chat_url": null,
                        "created_date": "2021-04-13T23:45:21.662101",
                        "default_to_fiat": false,
                        "description": "Apymon is a collection of 6400 creatures created by AI which are contained in procedurally designed eggs. What makes these Genesis Eggs special is that they can hold other NFTs, ERC20 and ERC1155 tokens, making them function as your personal vault. No two Apymon creatures or  Genesis Eggs are the same, each one is unique and crafted with love.\nMint your Genesis Egg at https://apymon.com\nFollow our Twitter (https://twitter.com/ApymonOfficial) for the latest news and join our Discord (https://discord.gg/apymon) to chat with the community",
                        "dev_buyer_fee_basis_points": "0",
                        "dev_seller_fee_basis_points": "0",
                        "discord_url": "https://discord.gg/K2PQnsJR7h",
                        "display_data": {
                            "card_display_style": "contain"
                        },
                        "external_url": "https://apymon.com/",
                        "featured": false,
                        "featured_image_url": "https://lh3.googleusercontent.com/tr5SJmi42FEob8GHgBZj4CG1w-J_b2jK2TwjguvUrSZDWsTQDM9er-jdTfHnv7rfAbHy6wpkwOXVYz1HvS1M7u-QgkOj5rrv-jk8zw=s300",
                        "hidden": false,
                        "safelist_request_status": "approved",
                        "image_url": "https://lh3.googleusercontent.com/8OogKrYF_3kTL3w_8J_TwEWTn6E4OS_SP5EVdeAJnw7GycEJJy36uZYkLKoMnrX-ObWNYlMpEIu5fGoRMtJrkL8HRnVz4gY8jrD2Cw=s120",
                        "is_subject_to_whitelist": false,
                        "large_image_url": "https://lh3.googleusercontent.com/tr5SJmi42FEob8GHgBZj4CG1w-J_b2jK2TwjguvUrSZDWsTQDM9er-jdTfHnv7rfAbHy6wpkwOXVYz1HvS1M7u-QgkOj5rrv-jk8zw=s300",
                        "medium_username": "apymon",
                        "name": "Apymon",
                        "only_proxied_transfers": false,
                        "opensea_buyer_fee_basis_points": "0",
                        "opensea_seller_fee_basis_points": "250",
                        "payout_address": null,
                        "require_email": false,
                        "short_description": null,
                        "slug": "apymon",
                        "telegram_url": null,
                        "twitter_username": "ApymonOfficial",
                        "instagram_username": null,
                        "wiki_url": null
                    },
                    "decimals": 0,
                    "token_metadata": "https://gateway.pinata.cloud/ipfs/QmbbsQmfaoX41xKh2g3Ng563WMQ1BmeaQC2BnoaUkT7DHQ/194"
                },
                {
                    "id": 21902778,
                    "token_id": "195",
                    "num_sales": 0,
                    "background_color": null,
                    "image_url": "https://lh3.googleusercontent.com/NgSUcM31h4FEPsOtme-74Er0xTlRWlf465yVbmezOXwMmTBROkWl2Q7Hjf6-o70KVpY7A0buV2jC_FId9QUcdWWA8oNIWxkAiFKJcA",
                    "image_preview_url": "https://lh3.googleusercontent.com/NgSUcM31h4FEPsOtme-74Er0xTlRWlf465yVbmezOXwMmTBROkWl2Q7Hjf6-o70KVpY7A0buV2jC_FId9QUcdWWA8oNIWxkAiFKJcA=s250",
                    "image_thumbnail_url": "https://lh3.googleusercontent.com/NgSUcM31h4FEPsOtme-74Er0xTlRWlf465yVbmezOXwMmTBROkWl2Q7Hjf6-o70KVpY7A0buV2jC_FId9QUcdWWA8oNIWxkAiFKJcA=s128",
                    "image_original_url": "https://arweave.net/3iCPkQOpSJuyoMX2OtpwSyGTqf6vZfY4S0lmVGJfm9Y",
                    "animation_url": null,
                    "animation_original_url": null,
                    "name": "Genesis Egg #195",
                    "description": "Apymon is a collection of 6400 creatures created by AI which are contained in procedurally designed eggs. What makes these Genesis Eggs special is that they can hold other NFTs, ERC20 and ERC1155 tokens, making them function as your personal vault. No two Apymon creatures or Genesis Eggs are the same, each one is unique and crafted with love.",
                    "external_link": "https://apymon.com",
                    "asset_contract": {
                        "address": "0x9c008a22d71b6182029b694b0311486e4c0e53db",
                        "asset_contract_type": "non-fungible",
                        "created_date": "2021-04-13T22:14:12.881973",
                        "name": "Apymon",
                        "nft_version": "3.0",
                        "opensea_version": null,
                        "owner": 30104721,
                        "schema_name": "ERC721",
                        "symbol": "APYMON",
                        "total_supply": "0",
                        "description": "Apymon is a collection of 6400 creatures created by AI which are contained in procedurally designed eggs. What makes these Genesis Eggs special is that they can hold other NFTs, ERC20 and ERC1155 tokens, making them function as your personal vault. No two Apymon creatures or  Genesis Eggs are the same, each one is unique and crafted with love.\nMint your Genesis Egg at https://apymon.com\nFollow our Twitter (https://twitter.com/ApymonOfficial) for the latest news and join our Discord (https://discord.gg/apymon) to chat with the community",
                        "external_link": "https://apymon.com/",
                        "image_url": "https://lh3.googleusercontent.com/8OogKrYF_3kTL3w_8J_TwEWTn6E4OS_SP5EVdeAJnw7GycEJJy36uZYkLKoMnrX-ObWNYlMpEIu5fGoRMtJrkL8HRnVz4gY8jrD2Cw=s120",
                        "default_to_fiat": false,
                        "dev_buyer_fee_basis_points": 0,
                        "dev_seller_fee_basis_points": 0,
                        "only_proxied_transfers": false,
                        "opensea_buyer_fee_basis_points": 0,
                        "opensea_seller_fee_basis_points": 250,
                        "buyer_fee_basis_points": 0,
                        "seller_fee_basis_points": 250,
                        "payout_address": null
                    },
                    "owner": {
                        "user": {
                            "username": "JakeShepherd"
                        },
                        "profile_img_url": "https://storage.googleapis.com/opensea-static/opensea-profile/29.png",
                        "address": "0xd887758a36bbf3c44ba3f1ffa0d8ff8d536cc129",
                        "config": "",
                        "discord_id": ""
                    },
                    "permalink": "https://opensea.io/assets/0x9c008a22d71b6182029b694b0311486e4c0e53db/195",
                    "collection": {
                        "banner_image_url": "https://lh3.googleusercontent.com/fdO2dxomM3FxkZiO7B8c-ie6Dj3VfhOlmYy-VgHsjkaFpjvfyd3a4wmglM9fLdpc4n9_s_bY_6MAzOmHacl5LApQ4agG4YEtCboMMd4=s2500",
                        "chat_url": null,
                        "created_date": "2021-04-13T23:45:21.662101",
                        "default_to_fiat": false,
                        "description": "Apymon is a collection of 6400 creatures created by AI which are contained in procedurally designed eggs. What makes these Genesis Eggs special is that they can hold other NFTs, ERC20 and ERC1155 tokens, making them function as your personal vault. No two Apymon creatures or  Genesis Eggs are the same, each one is unique and crafted with love.\nMint your Genesis Egg at https://apymon.com\nFollow our Twitter (https://twitter.com/ApymonOfficial) for the latest news and join our Discord (https://discord.gg/apymon) to chat with the community",
                        "dev_buyer_fee_basis_points": "0",
                        "dev_seller_fee_basis_points": "0",
                        "discord_url": "https://discord.gg/K2PQnsJR7h",
                        "display_data": {
                            "card_display_style": "contain"
                        },
                        "external_url": "https://apymon.com/",
                        "featured": false,
                        "featured_image_url": "https://lh3.googleusercontent.com/tr5SJmi42FEob8GHgBZj4CG1w-J_b2jK2TwjguvUrSZDWsTQDM9er-jdTfHnv7rfAbHy6wpkwOXVYz1HvS1M7u-QgkOj5rrv-jk8zw=s300",
                        "hidden": false,
                        "safelist_request_status": "approved",
                        "image_url": "https://lh3.googleusercontent.com/8OogKrYF_3kTL3w_8J_TwEWTn6E4OS_SP5EVdeAJnw7GycEJJy36uZYkLKoMnrX-ObWNYlMpEIu5fGoRMtJrkL8HRnVz4gY8jrD2Cw=s120",
                        "is_subject_to_whitelist": false,
                        "large_image_url": "https://lh3.googleusercontent.com/tr5SJmi42FEob8GHgBZj4CG1w-J_b2jK2TwjguvUrSZDWsTQDM9er-jdTfHnv7rfAbHy6wpkwOXVYz1HvS1M7u-QgkOj5rrv-jk8zw=s300",
                        "medium_username": "apymon",
                        "name": "Apymon",
                        "only_proxied_transfers": false,
                        "opensea_buyer_fee_basis_points": "0",
                        "opensea_seller_fee_basis_points": "250",
                        "payout_address": null,
                        "require_email": false,
                        "short_description": null,
                        "slug": "apymon",
                        "telegram_url": null,
                        "twitter_username": "ApymonOfficial",
                        "instagram_username": null,
                        "wiki_url": null
                    },
                    "decimals": 0,
                    "token_metadata": "https://gateway.pinata.cloud/ipfs/QmRG2zSxpoF6CeyLehQxAHA2egRDB3wJ1n65S6dh64sqiV/195"
                },
                {
                    "id": 21902779,
                    "token_id": "196",
                    "num_sales": 0,
                    "background_color": null,
                    "image_url": "https://lh3.googleusercontent.com/7eihDS29bUtN5GfBtUAR5DxPVDkJHQ5xdupEHu3SEgrkxMToYu1rjpr0fBucb9dpg6XHFmbcdwYGkpC_TXel037W5if_BmveYVHGbLs",
                    "image_preview_url": "https://lh3.googleusercontent.com/7eihDS29bUtN5GfBtUAR5DxPVDkJHQ5xdupEHu3SEgrkxMToYu1rjpr0fBucb9dpg6XHFmbcdwYGkpC_TXel037W5if_BmveYVHGbLs=s250",
                    "image_thumbnail_url": "https://lh3.googleusercontent.com/7eihDS29bUtN5GfBtUAR5DxPVDkJHQ5xdupEHu3SEgrkxMToYu1rjpr0fBucb9dpg6XHFmbcdwYGkpC_TXel037W5if_BmveYVHGbLs=s128",
                    "image_original_url": "https://arweave.net/hEjpS1q5Neyn-AQCXC-pP3niMVVPoRPTt65HCPm4dSQ",
                    "animation_url": null,
                    "animation_original_url": null,
                    "name": "Genesis Egg #196",
                    "description": "Apymon is a collection of 6400 creatures created by AI which are contained in procedurally designed eggs. What makes these Genesis Eggs special is that they can hold other NFTs, ERC20 and ERC1155 tokens, making them function as your personal vault. No two Apymon creatures or Genesis Eggs are the same, each one is unique and crafted with love.",
                    "external_link": "https://apymon.com",
                    "asset_contract": {
                        "address": "0x9c008a22d71b6182029b694b0311486e4c0e53db",
                        "asset_contract_type": "non-fungible",
                        "created_date": "2021-04-13T22:14:12.881973",
                        "name": "Apymon",
                        "nft_version": "3.0",
                        "opensea_version": null,
                        "owner": 30104721,
                        "schema_name": "ERC721",
                        "symbol": "APYMON",
                        "total_supply": "0",
                        "description": "Apymon is a collection of 6400 creatures created by AI which are contained in procedurally designed eggs. What makes these Genesis Eggs special is that they can hold other NFTs, ERC20 and ERC1155 tokens, making them function as your personal vault. No two Apymon creatures or  Genesis Eggs are the same, each one is unique and crafted with love.\nMint your Genesis Egg at https://apymon.com\nFollow our Twitter (https://twitter.com/ApymonOfficial) for the latest news and join our Discord (https://discord.gg/apymon) to chat with the community",
                        "external_link": "https://apymon.com/",
                        "image_url": "https://lh3.googleusercontent.com/8OogKrYF_3kTL3w_8J_TwEWTn6E4OS_SP5EVdeAJnw7GycEJJy36uZYkLKoMnrX-ObWNYlMpEIu5fGoRMtJrkL8HRnVz4gY8jrD2Cw=s120",
                        "default_to_fiat": false,
                        "dev_buyer_fee_basis_points": 0,
                        "dev_seller_fee_basis_points": 0,
                        "only_proxied_transfers": false,
                        "opensea_buyer_fee_basis_points": 0,
                        "opensea_seller_fee_basis_points": 250,
                        "buyer_fee_basis_points": 0,
                        "seller_fee_basis_points": 250,
                        "payout_address": null
                    },
                    "owner": {
                        "user": {
                            "username": "JakeShepherd"
                        },
                        "profile_img_url": "https://storage.googleapis.com/opensea-static/opensea-profile/29.png",
                        "address": "0xd887758a36bbf3c44ba3f1ffa0d8ff8d536cc129",
                        "config": "",
                        "discord_id": ""
                    },
                    "permalink": "https://opensea.io/assets/0x9c008a22d71b6182029b694b0311486e4c0e53db/196",
                    "collection": {
                        "banner_image_url": "https://lh3.googleusercontent.com/fdO2dxomM3FxkZiO7B8c-ie6Dj3VfhOlmYy-VgHsjkaFpjvfyd3a4wmglM9fLdpc4n9_s_bY_6MAzOmHacl5LApQ4agG4YEtCboMMd4=s2500",
                        "chat_url": null,
                        "created_date": "2021-04-13T23:45:21.662101",
                        "default_to_fiat": false,
                        "description": "Apymon is a collection of 6400 creatures created by AI which are contained in procedurally designed eggs. What makes these Genesis Eggs special is that they can hold other NFTs, ERC20 and ERC1155 tokens, making them function as your personal vault. No two Apymon creatures or  Genesis Eggs are the same, each one is unique and crafted with love.\nMint your Genesis Egg at https://apymon.com\nFollow our Twitter (https://twitter.com/ApymonOfficial) for the latest news and join our Discord (https://discord.gg/apymon) to chat with the community",
                        "dev_buyer_fee_basis_points": "0",
                        "dev_seller_fee_basis_points": "0",
                        "discord_url": "https://discord.gg/K2PQnsJR7h",
                        "display_data": {
                            "card_display_style": "contain"
                        },
                        "external_url": "https://apymon.com/",
                        "featured": false,
                        "featured_image_url": "https://lh3.googleusercontent.com/tr5SJmi42FEob8GHgBZj4CG1w-J_b2jK2TwjguvUrSZDWsTQDM9er-jdTfHnv7rfAbHy6wpkwOXVYz1HvS1M7u-QgkOj5rrv-jk8zw=s300",
                        "hidden": false,
                        "safelist_request_status": "approved",
                        "image_url": "https://lh3.googleusercontent.com/8OogKrYF_3kTL3w_8J_TwEWTn6E4OS_SP5EVdeAJnw7GycEJJy36uZYkLKoMnrX-ObWNYlMpEIu5fGoRMtJrkL8HRnVz4gY8jrD2Cw=s120",
                        "is_subject_to_whitelist": false,
                        "large_image_url": "https://lh3.googleusercontent.com/tr5SJmi42FEob8GHgBZj4CG1w-J_b2jK2TwjguvUrSZDWsTQDM9er-jdTfHnv7rfAbHy6wpkwOXVYz1HvS1M7u-QgkOj5rrv-jk8zw=s300",
                        "medium_username": "apymon",
                        "name": "Apymon",
                        "only_proxied_transfers": false,
                        "opensea_buyer_fee_basis_points": "0",
                        "opensea_seller_fee_basis_points": "250",
                        "payout_address": null,
                        "require_email": false,
                        "short_description": null,
                        "slug": "apymon",
                        "telegram_url": null,
                        "twitter_username": "ApymonOfficial",
                        "instagram_username": null,
                        "wiki_url": null
                    },
                    "decimals": 0,
                    "token_metadata": "https://gateway.pinata.cloud/ipfs/QmbbsQmfaoX41xKh2g3Ng563WMQ1BmeaQC2BnoaUkT7DHQ/196"
                },
                {
                    "id": 21902781,
                    "token_id": "197",
                    "num_sales": 0,
                    "background_color": null,
                    "image_url": "https://lh3.googleusercontent.com/Rsi2SRjcktB_ZF2BlKZfcmp70UH38gxs0JH6NM8vrqQIM1m5wcLit3DrOzSUZpOegF0L8aMGtSECEnaWMBjQ7Y4kCTWVm5haeqK9Rds",
                    "image_preview_url": "https://lh3.googleusercontent.com/Rsi2SRjcktB_ZF2BlKZfcmp70UH38gxs0JH6NM8vrqQIM1m5wcLit3DrOzSUZpOegF0L8aMGtSECEnaWMBjQ7Y4kCTWVm5haeqK9Rds=s250",
                    "image_thumbnail_url": "https://lh3.googleusercontent.com/Rsi2SRjcktB_ZF2BlKZfcmp70UH38gxs0JH6NM8vrqQIM1m5wcLit3DrOzSUZpOegF0L8aMGtSECEnaWMBjQ7Y4kCTWVm5haeqK9Rds=s128",
                    "image_original_url": "https://arweave.net/g0mdX28D1L4R5RQNLg8vjPadB2hnPnzIsvCdTTzTRgQ",
                    "animation_url": null,
                    "animation_original_url": null,
                    "name": "Genesis Egg #197",
                    "description": "Apymon is a collection of 6400 creatures created by AI which are contained in procedurally designed eggs. What makes these Genesis Eggs special is that they can hold other NFTs, ERC20 and ERC1155 tokens, making them function as your personal vault. No two Apymon creatures or Genesis Eggs are the same, each one is unique and crafted with love.",
                    "external_link": "https://apymon.com",
                    "asset_contract": {
                        "address": "0x9c008a22d71b6182029b694b0311486e4c0e53db",
                        "asset_contract_type": "non-fungible",
                        "created_date": "2021-04-13T22:14:12.881973",
                        "name": "Apymon",
                        "nft_version": "3.0",
                        "opensea_version": null,
                        "owner": 30104721,
                        "schema_name": "ERC721",
                        "symbol": "APYMON",
                        "total_supply": "0",
                        "description": "Apymon is a collection of 6400 creatures created by AI which are contained in procedurally designed eggs. What makes these Genesis Eggs special is that they can hold other NFTs, ERC20 and ERC1155 tokens, making them function as your personal vault. No two Apymon creatures or  Genesis Eggs are the same, each one is unique and crafted with love.\nMint your Genesis Egg at https://apymon.com\nFollow our Twitter (https://twitter.com/ApymonOfficial) for the latest news and join our Discord (https://discord.gg/apymon) to chat with the community",
                        "external_link": "https://apymon.com/",
                        "image_url": "https://lh3.googleusercontent.com/8OogKrYF_3kTL3w_8J_TwEWTn6E4OS_SP5EVdeAJnw7GycEJJy36uZYkLKoMnrX-ObWNYlMpEIu5fGoRMtJrkL8HRnVz4gY8jrD2Cw=s120",
                        "default_to_fiat": false,
                        "dev_buyer_fee_basis_points": 0,
                        "dev_seller_fee_basis_points": 0,
                        "only_proxied_transfers": false,
                        "opensea_buyer_fee_basis_points": 0,
                        "opensea_seller_fee_basis_points": 250,
                        "buyer_fee_basis_points": 0,
                        "seller_fee_basis_points": 250,
                        "payout_address": null
                    },
                    "owner": {
                        "user": {
                            "username": "JakeShepherd"
                        },
                        "profile_img_url": "https://storage.googleapis.com/opensea-static/opensea-profile/29.png",
                        "address": "0xd887758a36bbf3c44ba3f1ffa0d8ff8d536cc129",
                        "config": "",
                        "discord_id": ""
                    },
                    "permalink": "https://opensea.io/assets/0x9c008a22d71b6182029b694b0311486e4c0e53db/197",
                    "collection": {
                        "banner_image_url": "https://lh3.googleusercontent.com/fdO2dxomM3FxkZiO7B8c-ie6Dj3VfhOlmYy-VgHsjkaFpjvfyd3a4wmglM9fLdpc4n9_s_bY_6MAzOmHacl5LApQ4agG4YEtCboMMd4=s2500",
                        "chat_url": null,
                        "created_date": "2021-04-13T23:45:21.662101",
                        "default_to_fiat": false,
                        "description": "Apymon is a collection of 6400 creatures created by AI which are contained in procedurally designed eggs. What makes these Genesis Eggs special is that they can hold other NFTs, ERC20 and ERC1155 tokens, making them function as your personal vault. No two Apymon creatures or  Genesis Eggs are the same, each one is unique and crafted with love.\nMint your Genesis Egg at https://apymon.com\nFollow our Twitter (https://twitter.com/ApymonOfficial) for the latest news and join our Discord (https://discord.gg/apymon) to chat with the community",
                        "dev_buyer_fee_basis_points": "0",
                        "dev_seller_fee_basis_points": "0",
                        "discord_url": "https://discord.gg/K2PQnsJR7h",
                        "display_data": {
                            "card_display_style": "contain"
                        },
                        "external_url": "https://apymon.com/",
                        "featured": false,
                        "featured_image_url": "https://lh3.googleusercontent.com/tr5SJmi42FEob8GHgBZj4CG1w-J_b2jK2TwjguvUrSZDWsTQDM9er-jdTfHnv7rfAbHy6wpkwOXVYz1HvS1M7u-QgkOj5rrv-jk8zw=s300",
                        "hidden": false,
                        "safelist_request_status": "approved",
                        "image_url": "https://lh3.googleusercontent.com/8OogKrYF_3kTL3w_8J_TwEWTn6E4OS_SP5EVdeAJnw7GycEJJy36uZYkLKoMnrX-ObWNYlMpEIu5fGoRMtJrkL8HRnVz4gY8jrD2Cw=s120",
                        "is_subject_to_whitelist": false,
                        "large_image_url": "https://lh3.googleusercontent.com/tr5SJmi42FEob8GHgBZj4CG1w-J_b2jK2TwjguvUrSZDWsTQDM9er-jdTfHnv7rfAbHy6wpkwOXVYz1HvS1M7u-QgkOj5rrv-jk8zw=s300",
                        "medium_username": "apymon",
                        "name": "Apymon",
                        "only_proxied_transfers": false,
                        "opensea_buyer_fee_basis_points": "0",
                        "opensea_seller_fee_basis_points": "250",
                        "payout_address": null,
                        "require_email": false,
                        "short_description": null,
                        "slug": "apymon",
                        "telegram_url": null,
                        "twitter_username": "ApymonOfficial",
                        "instagram_username": null,
                        "wiki_url": null
                    },
                    "decimals": 0,
                    "token_metadata": "https://gateway.pinata.cloud/ipfs/QmbbsQmfaoX41xKh2g3Ng563WMQ1BmeaQC2BnoaUkT7DHQ/197"
                },
                {
                    "id": 25281322,
                    "token_id": "17",
                    "num_sales": 0,
                    "background_color": null,
                    "image_url": "https://lh3.googleusercontent.com/N9emgIc7lwYfWDoNXztYbH6n6UI25jFbumIr2XOvmXGhpQ5vFaCHMlHDzvWTO7d_UaQtH8352fRne7h_8aMh4ynjLWJF0bRBb0oAbQw",
                    "image_preview_url": "https://lh3.googleusercontent.com/N9emgIc7lwYfWDoNXztYbH6n6UI25jFbumIr2XOvmXGhpQ5vFaCHMlHDzvWTO7d_UaQtH8352fRne7h_8aMh4ynjLWJF0bRBb0oAbQw=s250",
                    "image_thumbnail_url": "https://lh3.googleusercontent.com/N9emgIc7lwYfWDoNXztYbH6n6UI25jFbumIr2XOvmXGhpQ5vFaCHMlHDzvWTO7d_UaQtH8352fRne7h_8aMh4ynjLWJF0bRBb0oAbQw=s128",
                    "image_original_url": "https://arweave.net/SbOBwIw9dqCf-5mubG65X4lCGA_AQXEa1C2ZwdTM_b0",
                    "animation_url": null,
                    "animation_original_url": null,
                    "name": "Apymon Monsters #17",
                    "description": null,
                    "external_link": "https://apymon.com",
                    "asset_contract": {
                        "address": "0x6e0baaa0d1c11dc160143c0c7213df76acdf4e17",
                        "asset_contract_type": "non-fungible",
                        "created_date": "2021-05-18T16:21:48.758011",
                        "name": "Apymon Monsters",
                        "nft_version": "3.0",
                        "opensea_version": null,
                        "owner": 30104721,
                        "schema_name": "ERC721",
                        "symbol": "APYM",
                        "total_supply": "0",
                        "description": "The NFT built by ERC721, Apymon Monsters, on Ethereum.",
                        "external_link": null,
                        "image_url": "https://lh3.googleusercontent.com/nCcUQe3w8k7omeB6DSrP4Y792JQaRLfqFv6SFzDxab1k44mR7kT9p8d4-m_X6iEfr47RGup5wCdP2s2RS1Y88-KaeElQgyzTs4cc=s120",
                        "default_to_fiat": false,
                        "dev_buyer_fee_basis_points": 0,
                        "dev_seller_fee_basis_points": 0,
                        "only_proxied_transfers": false,
                        "opensea_buyer_fee_basis_points": 0,
                        "opensea_seller_fee_basis_points": 250,
                        "buyer_fee_basis_points": 0,
                        "seller_fee_basis_points": 250,
                        "payout_address": null
                    },
                    "owner": {
                        "user": {
                            "username": "JakeShepherd"
                        },
                        "profile_img_url": "https://storage.googleapis.com/opensea-static/opensea-profile/29.png",
                        "address": "0xd887758a36bbf3c44ba3f1ffa0d8ff8d536cc129",
                        "config": "",
                        "discord_id": ""
                    },
                    "permalink": "https://opensea.io/assets/0x6e0baaa0d1c11dc160143c0c7213df76acdf4e17/17",
                    "collection": {
                        "banner_image_url": "https://lh3.googleusercontent.com/xsxkSFVINW-MV2mnqiv5PN6uFynoq-ev16uvOIgkz73GODzvFeM7wOmBM7OkxGmhv1GHpP-t31VqHcEvfScUfAnfiDT-zGS_Y30C=s2500",
                        "chat_url": null,
                        "created_date": "2021-05-18T16:59:45.948886",
                        "default_to_fiat": false,
                        "description": "The NFT built by ERC721, Apymon Monsters, on Ethereum.",
                        "dev_buyer_fee_basis_points": "0",
                        "dev_seller_fee_basis_points": "0",
                        "discord_url": null,
                        "display_data": {
                            "card_display_style": "contain"
                        },
                        "external_url": null,
                        "featured": false,
                        "featured_image_url": "https://lh3.googleusercontent.com/hybKwm5kYCjE_IIF4DiObNzaHYVOH0Xenx3ye8domy0ssj1SQB7L7j0krdp8dFFiR8ZTznf16HX70btLTblWUqS-wxaFqbAencUTyw=s300",
                        "hidden": true,
                        "safelist_request_status": "not_requested",
                        "image_url": "https://lh3.googleusercontent.com/nCcUQe3w8k7omeB6DSrP4Y792JQaRLfqFv6SFzDxab1k44mR7kT9p8d4-m_X6iEfr47RGup5wCdP2s2RS1Y88-KaeElQgyzTs4cc=s120",
                        "is_subject_to_whitelist": false,
                        "large_image_url": "https://lh3.googleusercontent.com/hybKwm5kYCjE_IIF4DiObNzaHYVOH0Xenx3ye8domy0ssj1SQB7L7j0krdp8dFFiR8ZTznf16HX70btLTblWUqS-wxaFqbAencUTyw=s300",
                        "medium_username": null,
                        "name": "Apymon Monsters",
                        "only_proxied_transfers": false,
                        "opensea_buyer_fee_basis_points": "0",
                        "opensea_seller_fee_basis_points": "250",
                        "payout_address": null,
                        "require_email": false,
                        "short_description": null,
                        "slug": "apymon-monsters",
                        "telegram_url": null,
                        "twitter_username": null,
                        "instagram_username": null,
                        "wiki_url": null
                    },
                    "decimals": 0,
                    "token_metadata": "https://gateway.pinata.cloud/ipfs/QmTQeQgS5Xa5WiDzuGS5RCKe8z74CgfiuA5cADPXLVX7uB/17"
                },
                {
                    "id": 25298996,
                    "token_id": "520",
                    "num_sales": 0,
                    "background_color": null,
                    "image_url": "https://lh3.googleusercontent.com/A0Ji0e8lR6LUSkG-WZskyjSS4OT0YIGx0e4TyxLwLLRtZIg-niHi_2WhndWl0Vx4fGjV38NmlqJCLYF70lz9UNZUibeewdYs6iIwdg",
                    "image_preview_url": "https://lh3.googleusercontent.com/A0Ji0e8lR6LUSkG-WZskyjSS4OT0YIGx0e4TyxLwLLRtZIg-niHi_2WhndWl0Vx4fGjV38NmlqJCLYF70lz9UNZUibeewdYs6iIwdg=s250",
                    "image_thumbnail_url": "https://lh3.googleusercontent.com/A0Ji0e8lR6LUSkG-WZskyjSS4OT0YIGx0e4TyxLwLLRtZIg-niHi_2WhndWl0Vx4fGjV38NmlqJCLYF70lz9UNZUibeewdYs6iIwdg=s128",
                    "image_original_url": "https://arweave.net/eiDtj6eYCVCNITxJtSHhf0MVlVTs-3ngUnFLTCEHyU8",
                    "animation_url": null,
                    "animation_original_url": null,
                    "name": "Apymon Monsters #520",
                    "description": null,
                    "external_link": "https://apymon.com",
                    "asset_contract": {
                        "address": "0x6e0baaa0d1c11dc160143c0c7213df76acdf4e17",
                        "asset_contract_type": "non-fungible",
                        "created_date": "2021-05-18T16:21:48.758011",
                        "name": "Apymon Monsters",
                        "nft_version": "3.0",
                        "opensea_version": null,
                        "owner": 30104721,
                        "schema_name": "ERC721",
                        "symbol": "APYM",
                        "total_supply": "0",
                        "description": "The NFT built by ERC721, Apymon Monsters, on Ethereum.",
                        "external_link": null,
                        "image_url": "https://lh3.googleusercontent.com/nCcUQe3w8k7omeB6DSrP4Y792JQaRLfqFv6SFzDxab1k44mR7kT9p8d4-m_X6iEfr47RGup5wCdP2s2RS1Y88-KaeElQgyzTs4cc=s120",
                        "default_to_fiat": false,
                        "dev_buyer_fee_basis_points": 0,
                        "dev_seller_fee_basis_points": 0,
                        "only_proxied_transfers": false,
                        "opensea_buyer_fee_basis_points": 0,
                        "opensea_seller_fee_basis_points": 250,
                        "buyer_fee_basis_points": 0,
                        "seller_fee_basis_points": 250,
                        "payout_address": null
                    },
                    "owner": {
                        "user": {
                            "username": "JakeShepherd"
                        },
                        "profile_img_url": "https://storage.googleapis.com/opensea-static/opensea-profile/29.png",
                        "address": "0xd887758a36bbf3c44ba3f1ffa0d8ff8d536cc129",
                        "config": "",
                        "discord_id": ""
                    },
                    "permalink": "https://opensea.io/assets/0x6e0baaa0d1c11dc160143c0c7213df76acdf4e17/520",
                    "collection": {
                        "banner_image_url": "https://lh3.googleusercontent.com/xsxkSFVINW-MV2mnqiv5PN6uFynoq-ev16uvOIgkz73GODzvFeM7wOmBM7OkxGmhv1GHpP-t31VqHcEvfScUfAnfiDT-zGS_Y30C=s2500",
                        "chat_url": null,
                        "created_date": "2021-05-18T16:59:45.948886",
                        "default_to_fiat": false,
                        "description": "The NFT built by ERC721, Apymon Monsters, on Ethereum.",
                        "dev_buyer_fee_basis_points": "0",
                        "dev_seller_fee_basis_points": "0",
                        "discord_url": null,
                        "display_data": {
                            "card_display_style": "contain"
                        },
                        "external_url": null,
                        "featured": false,
                        "featured_image_url": "https://lh3.googleusercontent.com/hybKwm5kYCjE_IIF4DiObNzaHYVOH0Xenx3ye8domy0ssj1SQB7L7j0krdp8dFFiR8ZTznf16HX70btLTblWUqS-wxaFqbAencUTyw=s300",
                        "hidden": true,
                        "safelist_request_status": "not_requested",
                        "image_url": "https://lh3.googleusercontent.com/nCcUQe3w8k7omeB6DSrP4Y792JQaRLfqFv6SFzDxab1k44mR7kT9p8d4-m_X6iEfr47RGup5wCdP2s2RS1Y88-KaeElQgyzTs4cc=s120",
                        "is_subject_to_whitelist": false,
                        "large_image_url": "https://lh3.googleusercontent.com/hybKwm5kYCjE_IIF4DiObNzaHYVOH0Xenx3ye8domy0ssj1SQB7L7j0krdp8dFFiR8ZTznf16HX70btLTblWUqS-wxaFqbAencUTyw=s300",
                        "medium_username": null,
                        "name": "Apymon Monsters",
                        "only_proxied_transfers": false,
                        "opensea_buyer_fee_basis_points": "0",
                        "opensea_seller_fee_basis_points": "250",
                        "payout_address": null,
                        "require_email": false,
                        "short_description": null,
                        "slug": "apymon-monsters",
                        "telegram_url": null,
                        "twitter_username": null,
                        "instagram_username": null,
                        "wiki_url": null
                    },
                    "decimals": 0,
                    "token_metadata": "https://gateway.pinata.cloud/ipfs/QmTQeQgS5Xa5WiDzuGS5RCKe8z74CgfiuA5cADPXLVX7uB/520"
                },
                {
                    "id": 25299099,
                    "token_id": "521",
                    "num_sales": 0,
                    "background_color": null,
                    "image_url": "https://lh3.googleusercontent.com/2X3gxT1CFMVlSIfRNLAzsp9yOHVuoUnCkjZjwi_3HDMrKBaduJviOxdUz9_UgeCvo61I-Vo0QWhbdSsGApey5YbDKOOLJq2MW7p1mA",
                    "image_preview_url": "https://lh3.googleusercontent.com/2X3gxT1CFMVlSIfRNLAzsp9yOHVuoUnCkjZjwi_3HDMrKBaduJviOxdUz9_UgeCvo61I-Vo0QWhbdSsGApey5YbDKOOLJq2MW7p1mA=s250",
                    "image_thumbnail_url": "https://lh3.googleusercontent.com/2X3gxT1CFMVlSIfRNLAzsp9yOHVuoUnCkjZjwi_3HDMrKBaduJviOxdUz9_UgeCvo61I-Vo0QWhbdSsGApey5YbDKOOLJq2MW7p1mA=s128",
                    "image_original_url": "https://arweave.net/d5T4Z0iQ44REtmraOLDUuahhGgtBPZ4VNMIDAgf7S08",
                    "animation_url": null,
                    "animation_original_url": null,
                    "name": "Apymon Monsters #521",
                    "description": null,
                    "external_link": "https://apymon.com",
                    "asset_contract": {
                        "address": "0x6e0baaa0d1c11dc160143c0c7213df76acdf4e17",
                        "asset_contract_type": "non-fungible",
                        "created_date": "2021-05-18T16:21:48.758011",
                        "name": "Apymon Monsters",
                        "nft_version": "3.0",
                        "opensea_version": null,
                        "owner": 30104721,
                        "schema_name": "ERC721",
                        "symbol": "APYM",
                        "total_supply": "0",
                        "description": "The NFT built by ERC721, Apymon Monsters, on Ethereum.",
                        "external_link": null,
                        "image_url": "https://lh3.googleusercontent.com/nCcUQe3w8k7omeB6DSrP4Y792JQaRLfqFv6SFzDxab1k44mR7kT9p8d4-m_X6iEfr47RGup5wCdP2s2RS1Y88-KaeElQgyzTs4cc=s120",
                        "default_to_fiat": false,
                        "dev_buyer_fee_basis_points": 0,
                        "dev_seller_fee_basis_points": 0,
                        "only_proxied_transfers": false,
                        "opensea_buyer_fee_basis_points": 0,
                        "opensea_seller_fee_basis_points": 250,
                        "buyer_fee_basis_points": 0,
                        "seller_fee_basis_points": 250,
                        "payout_address": null
                    },
                    "owner": {
                        "user": {
                            "username": "JakeShepherd"
                        },
                        "profile_img_url": "https://storage.googleapis.com/opensea-static/opensea-profile/29.png",
                        "address": "0xd887758a36bbf3c44ba3f1ffa0d8ff8d536cc129",
                        "config": "",
                        "discord_id": ""
                    },
                    "permalink": "https://opensea.io/assets/0x6e0baaa0d1c11dc160143c0c7213df76acdf4e17/521",
                    "collection": {
                        "banner_image_url": "https://lh3.googleusercontent.com/xsxkSFVINW-MV2mnqiv5PN6uFynoq-ev16uvOIgkz73GODzvFeM7wOmBM7OkxGmhv1GHpP-t31VqHcEvfScUfAnfiDT-zGS_Y30C=s2500",
                        "chat_url": null,
                        "created_date": "2021-05-18T16:59:45.948886",
                        "default_to_fiat": false,
                        "description": "The NFT built by ERC721, Apymon Monsters, on Ethereum.",
                        "dev_buyer_fee_basis_points": "0",
                        "dev_seller_fee_basis_points": "0",
                        "discord_url": null,
                        "display_data": {
                            "card_display_style": "contain"
                        },
                        "external_url": null,
                        "featured": false,
                        "featured_image_url": "https://lh3.googleusercontent.com/hybKwm5kYCjE_IIF4DiObNzaHYVOH0Xenx3ye8domy0ssj1SQB7L7j0krdp8dFFiR8ZTznf16HX70btLTblWUqS-wxaFqbAencUTyw=s300",
                        "hidden": true,
                        "safelist_request_status": "not_requested",
                        "image_url": "https://lh3.googleusercontent.com/nCcUQe3w8k7omeB6DSrP4Y792JQaRLfqFv6SFzDxab1k44mR7kT9p8d4-m_X6iEfr47RGup5wCdP2s2RS1Y88-KaeElQgyzTs4cc=s120",
                        "is_subject_to_whitelist": false,
                        "large_image_url": "https://lh3.googleusercontent.com/hybKwm5kYCjE_IIF4DiObNzaHYVOH0Xenx3ye8domy0ssj1SQB7L7j0krdp8dFFiR8ZTznf16HX70btLTblWUqS-wxaFqbAencUTyw=s300",
                        "medium_username": null,
                        "name": "Apymon Monsters",
                        "only_proxied_transfers": false,
                        "opensea_buyer_fee_basis_points": "0",
                        "opensea_seller_fee_basis_points": "250",
                        "payout_address": null,
                        "require_email": false,
                        "short_description": null,
                        "slug": "apymon-monsters",
                        "telegram_url": null,
                        "twitter_username": null,
                        "instagram_username": null,
                        "wiki_url": null
                    },
                    "decimals": 0,
                    "token_metadata": "https://gateway.pinata.cloud/ipfs/QmTQeQgS5Xa5WiDzuGS5RCKe8z74CgfiuA5cADPXLVX7uB/521"
                },
                {
                    "id": 25299100,
                    "token_id": "522",
                    "num_sales": 0,
                    "background_color": null,
                    "image_url": "https://lh3.googleusercontent.com/PGRx_Tuc_kntn4EctF74WC73QWboBX3KXTgeGnwaj0gGMyQuN3WwZ_Sd5TmGFwos7ri3PtvWKN_A2G9oc_ljCSimXf9crw8GsEg1xw",
                    "image_preview_url": "https://lh3.googleusercontent.com/PGRx_Tuc_kntn4EctF74WC73QWboBX3KXTgeGnwaj0gGMyQuN3WwZ_Sd5TmGFwos7ri3PtvWKN_A2G9oc_ljCSimXf9crw8GsEg1xw=s250",
                    "image_thumbnail_url": "https://lh3.googleusercontent.com/PGRx_Tuc_kntn4EctF74WC73QWboBX3KXTgeGnwaj0gGMyQuN3WwZ_Sd5TmGFwos7ri3PtvWKN_A2G9oc_ljCSimXf9crw8GsEg1xw=s128",
                    "image_original_url": "https://arweave.net/sBju-_Bpe6zqMfMDMqUj4Iu9FHLVCjatVJRjnq86BuU",
                    "animation_url": null,
                    "animation_original_url": null,
                    "name": "Apymon Monsters #522",
                    "description": null,
                    "external_link": "https://apymon.com",
                    "asset_contract": {
                        "address": "0x6e0baaa0d1c11dc160143c0c7213df76acdf4e17",
                        "asset_contract_type": "non-fungible",
                        "created_date": "2021-05-18T16:21:48.758011",
                        "name": "Apymon Monsters",
                        "nft_version": "3.0",
                        "opensea_version": null,
                        "owner": 30104721,
                        "schema_name": "ERC721",
                        "symbol": "APYM",
                        "total_supply": "0",
                        "description": "The NFT built by ERC721, Apymon Monsters, on Ethereum.",
                        "external_link": null,
                        "image_url": "https://lh3.googleusercontent.com/nCcUQe3w8k7omeB6DSrP4Y792JQaRLfqFv6SFzDxab1k44mR7kT9p8d4-m_X6iEfr47RGup5wCdP2s2RS1Y88-KaeElQgyzTs4cc=s120",
                        "default_to_fiat": false,
                        "dev_buyer_fee_basis_points": 0,
                        "dev_seller_fee_basis_points": 0,
                        "only_proxied_transfers": false,
                        "opensea_buyer_fee_basis_points": 0,
                        "opensea_seller_fee_basis_points": 250,
                        "buyer_fee_basis_points": 0,
                        "seller_fee_basis_points": 250,
                        "payout_address": null
                    },
                    "owner": {
                        "user": {
                            "username": "JakeShepherd"
                        },
                        "profile_img_url": "https://storage.googleapis.com/opensea-static/opensea-profile/29.png",
                        "address": "0xd887758a36bbf3c44ba3f1ffa0d8ff8d536cc129",
                        "config": "",
                        "discord_id": ""
                    },
                    "permalink": "https://opensea.io/assets/0x6e0baaa0d1c11dc160143c0c7213df76acdf4e17/522",
                    "collection": {
                        "banner_image_url": "https://lh3.googleusercontent.com/xsxkSFVINW-MV2mnqiv5PN6uFynoq-ev16uvOIgkz73GODzvFeM7wOmBM7OkxGmhv1GHpP-t31VqHcEvfScUfAnfiDT-zGS_Y30C=s2500",
                        "chat_url": null,
                        "created_date": "2021-05-18T16:59:45.948886",
                        "default_to_fiat": false,
                        "description": "The NFT built by ERC721, Apymon Monsters, on Ethereum.",
                        "dev_buyer_fee_basis_points": "0",
                        "dev_seller_fee_basis_points": "0",
                        "discord_url": null,
                        "display_data": {
                            "card_display_style": "contain"
                        },
                        "external_url": null,
                        "featured": false,
                        "featured_image_url": "https://lh3.googleusercontent.com/hybKwm5kYCjE_IIF4DiObNzaHYVOH0Xenx3ye8domy0ssj1SQB7L7j0krdp8dFFiR8ZTznf16HX70btLTblWUqS-wxaFqbAencUTyw=s300",
                        "hidden": true,
                        "safelist_request_status": "not_requested",
                        "image_url": "https://lh3.googleusercontent.com/nCcUQe3w8k7omeB6DSrP4Y792JQaRLfqFv6SFzDxab1k44mR7kT9p8d4-m_X6iEfr47RGup5wCdP2s2RS1Y88-KaeElQgyzTs4cc=s120",
                        "is_subject_to_whitelist": false,
                        "large_image_url": "https://lh3.googleusercontent.com/hybKwm5kYCjE_IIF4DiObNzaHYVOH0Xenx3ye8domy0ssj1SQB7L7j0krdp8dFFiR8ZTznf16HX70btLTblWUqS-wxaFqbAencUTyw=s300",
                        "medium_username": null,
                        "name": "Apymon Monsters",
                        "only_proxied_transfers": false,
                        "opensea_buyer_fee_basis_points": "0",
                        "opensea_seller_fee_basis_points": "250",
                        "payout_address": null,
                        "require_email": false,
                        "short_description": null,
                        "slug": "apymon-monsters",
                        "telegram_url": null,
                        "twitter_username": null,
                        "instagram_username": null,
                        "wiki_url": null
                    },
                    "decimals": 0,
                    "token_metadata": "https://gateway.pinata.cloud/ipfs/QmTQeQgS5Xa5WiDzuGS5RCKe8z74CgfiuA5cADPXLVX7uB/522"
                },
                {
                    "id": 25299104,
                    "token_id": "523",
                    "num_sales": 0,
                    "background_color": null,
                    "image_url": "https://lh3.googleusercontent.com/hJrUfD1iVQIzLphPMJDT5-ZOT-uPnTvr2TZfavXsOZz30q_2CP-nX9wW4St1B9xmUx7m8xZ2JW212jt491VFl9eUJL9zUvztYtSj",
                    "image_preview_url": "https://lh3.googleusercontent.com/hJrUfD1iVQIzLphPMJDT5-ZOT-uPnTvr2TZfavXsOZz30q_2CP-nX9wW4St1B9xmUx7m8xZ2JW212jt491VFl9eUJL9zUvztYtSj=s250",
                    "image_thumbnail_url": "https://lh3.googleusercontent.com/hJrUfD1iVQIzLphPMJDT5-ZOT-uPnTvr2TZfavXsOZz30q_2CP-nX9wW4St1B9xmUx7m8xZ2JW212jt491VFl9eUJL9zUvztYtSj=s128",
                    "image_original_url": "https://arweave.net/1vopHXCAH5Aya18qcw2RpWD6zRtOBFcvRb2jrPcUaaA",
                    "animation_url": null,
                    "animation_original_url": null,
                    "name": "Apymon Monsters #523",
                    "description": null,
                    "external_link": "https://apymon.com",
                    "asset_contract": {
                        "address": "0x6e0baaa0d1c11dc160143c0c7213df76acdf4e17",
                        "asset_contract_type": "non-fungible",
                        "created_date": "2021-05-18T16:21:48.758011",
                        "name": "Apymon Monsters",
                        "nft_version": "3.0",
                        "opensea_version": null,
                        "owner": 30104721,
                        "schema_name": "ERC721",
                        "symbol": "APYM",
                        "total_supply": "0",
                        "description": "The NFT built by ERC721, Apymon Monsters, on Ethereum.",
                        "external_link": null,
                        "image_url": "https://lh3.googleusercontent.com/nCcUQe3w8k7omeB6DSrP4Y792JQaRLfqFv6SFzDxab1k44mR7kT9p8d4-m_X6iEfr47RGup5wCdP2s2RS1Y88-KaeElQgyzTs4cc=s120",
                        "default_to_fiat": false,
                        "dev_buyer_fee_basis_points": 0,
                        "dev_seller_fee_basis_points": 0,
                        "only_proxied_transfers": false,
                        "opensea_buyer_fee_basis_points": 0,
                        "opensea_seller_fee_basis_points": 250,
                        "buyer_fee_basis_points": 0,
                        "seller_fee_basis_points": 250,
                        "payout_address": null
                    },
                    "owner": {
                        "user": {
                            "username": "JakeShepherd"
                        },
                        "profile_img_url": "https://storage.googleapis.com/opensea-static/opensea-profile/29.png",
                        "address": "0xd887758a36bbf3c44ba3f1ffa0d8ff8d536cc129",
                        "config": "",
                        "discord_id": ""
                    },
                    "permalink": "https://opensea.io/assets/0x6e0baaa0d1c11dc160143c0c7213df76acdf4e17/523",
                    "collection": {
                        "banner_image_url": "https://lh3.googleusercontent.com/xsxkSFVINW-MV2mnqiv5PN6uFynoq-ev16uvOIgkz73GODzvFeM7wOmBM7OkxGmhv1GHpP-t31VqHcEvfScUfAnfiDT-zGS_Y30C=s2500",
                        "chat_url": null,
                        "created_date": "2021-05-18T16:59:45.948886",
                        "default_to_fiat": false,
                        "description": "The NFT built by ERC721, Apymon Monsters, on Ethereum.",
                        "dev_buyer_fee_basis_points": "0",
                        "dev_seller_fee_basis_points": "0",
                        "discord_url": null,
                        "display_data": {
                            "card_display_style": "contain"
                        },
                        "external_url": null,
                        "featured": false,
                        "featured_image_url": "https://lh3.googleusercontent.com/hybKwm5kYCjE_IIF4DiObNzaHYVOH0Xenx3ye8domy0ssj1SQB7L7j0krdp8dFFiR8ZTznf16HX70btLTblWUqS-wxaFqbAencUTyw=s300",
                        "hidden": true,
                        "safelist_request_status": "not_requested",
                        "image_url": "https://lh3.googleusercontent.com/nCcUQe3w8k7omeB6DSrP4Y792JQaRLfqFv6SFzDxab1k44mR7kT9p8d4-m_X6iEfr47RGup5wCdP2s2RS1Y88-KaeElQgyzTs4cc=s120",
                        "is_subject_to_whitelist": false,
                        "large_image_url": "https://lh3.googleusercontent.com/hybKwm5kYCjE_IIF4DiObNzaHYVOH0Xenx3ye8domy0ssj1SQB7L7j0krdp8dFFiR8ZTznf16HX70btLTblWUqS-wxaFqbAencUTyw=s300",
                        "medium_username": null,
                        "name": "Apymon Monsters",
                        "only_proxied_transfers": false,
                        "opensea_buyer_fee_basis_points": "0",
                        "opensea_seller_fee_basis_points": "250",
                        "payout_address": null,
                        "require_email": false,
                        "short_description": null,
                        "slug": "apymon-monsters",
                        "telegram_url": null,
                        "twitter_username": null,
                        "instagram_username": null,
                        "wiki_url": null
                    },
                    "decimals": 0,
                    "token_metadata": "https://gateway.pinata.cloud/ipfs/QmTQeQgS5Xa5WiDzuGS5RCKe8z74CgfiuA5cADPXLVX7uB/523"
                },
                {
                    "id": 25299108,
                    "token_id": "524",
                    "num_sales": 0,
                    "background_color": null,
                    "image_url": "https://lh3.googleusercontent.com/2EfI5gPnaxj1CSKM23A-0_pi5ejcik2zBQtzCF6krUl35787VVvpmrTDJ305Or5s4DIvPLCzcrCbqUL6-zOrZxG1_uZ6jcP8cAk5IGI",
                    "image_preview_url": "https://lh3.googleusercontent.com/2EfI5gPnaxj1CSKM23A-0_pi5ejcik2zBQtzCF6krUl35787VVvpmrTDJ305Or5s4DIvPLCzcrCbqUL6-zOrZxG1_uZ6jcP8cAk5IGI=s250",
                    "image_thumbnail_url": "https://lh3.googleusercontent.com/2EfI5gPnaxj1CSKM23A-0_pi5ejcik2zBQtzCF6krUl35787VVvpmrTDJ305Or5s4DIvPLCzcrCbqUL6-zOrZxG1_uZ6jcP8cAk5IGI=s128",
                    "image_original_url": "https://arweave.net/hKRLteXMtjIDHlbuNuEOMRC-IrbbDh9fsRtL63eX5EA",
                    "animation_url": null,
                    "animation_original_url": null,
                    "name": "Apymon Monsters #524",
                    "description": null,
                    "external_link": "https://apymon.com",
                    "asset_contract": {
                        "address": "0x6e0baaa0d1c11dc160143c0c7213df76acdf4e17",
                        "asset_contract_type": "non-fungible",
                        "created_date": "2021-05-18T16:21:48.758011",
                        "name": "Apymon Monsters",
                        "nft_version": "3.0",
                        "opensea_version": null,
                        "owner": 30104721,
                        "schema_name": "ERC721",
                        "symbol": "APYM",
                        "total_supply": "0",
                        "description": "The NFT built by ERC721, Apymon Monsters, on Ethereum.",
                        "external_link": null,
                        "image_url": "https://lh3.googleusercontent.com/nCcUQe3w8k7omeB6DSrP4Y792JQaRLfqFv6SFzDxab1k44mR7kT9p8d4-m_X6iEfr47RGup5wCdP2s2RS1Y88-KaeElQgyzTs4cc=s120",
                        "default_to_fiat": false,
                        "dev_buyer_fee_basis_points": 0,
                        "dev_seller_fee_basis_points": 0,
                        "only_proxied_transfers": false,
                        "opensea_buyer_fee_basis_points": 0,
                        "opensea_seller_fee_basis_points": 250,
                        "buyer_fee_basis_points": 0,
                        "seller_fee_basis_points": 250,
                        "payout_address": null
                    },
                    "owner": {
                        "user": {
                            "username": "JakeShepherd"
                        },
                        "profile_img_url": "https://storage.googleapis.com/opensea-static/opensea-profile/29.png",
                        "address": "0xd887758a36bbf3c44ba3f1ffa0d8ff8d536cc129",
                        "config": "",
                        "discord_id": ""
                    },
                    "permalink": "https://opensea.io/assets/0x6e0baaa0d1c11dc160143c0c7213df76acdf4e17/524",
                    "collection": {
                        "banner_image_url": "https://lh3.googleusercontent.com/xsxkSFVINW-MV2mnqiv5PN6uFynoq-ev16uvOIgkz73GODzvFeM7wOmBM7OkxGmhv1GHpP-t31VqHcEvfScUfAnfiDT-zGS_Y30C=s2500",
                        "chat_url": null,
                        "created_date": "2021-05-18T16:59:45.948886",
                        "default_to_fiat": false,
                        "description": "The NFT built by ERC721, Apymon Monsters, on Ethereum.",
                        "dev_buyer_fee_basis_points": "0",
                        "dev_seller_fee_basis_points": "0",
                        "discord_url": null,
                        "display_data": {
                            "card_display_style": "contain"
                        },
                        "external_url": null,
                        "featured": false,
                        "featured_image_url": "https://lh3.googleusercontent.com/hybKwm5kYCjE_IIF4DiObNzaHYVOH0Xenx3ye8domy0ssj1SQB7L7j0krdp8dFFiR8ZTznf16HX70btLTblWUqS-wxaFqbAencUTyw=s300",
                        "hidden": true,
                        "safelist_request_status": "not_requested",
                        "image_url": "https://lh3.googleusercontent.com/nCcUQe3w8k7omeB6DSrP4Y792JQaRLfqFv6SFzDxab1k44mR7kT9p8d4-m_X6iEfr47RGup5wCdP2s2RS1Y88-KaeElQgyzTs4cc=s120",
                        "is_subject_to_whitelist": false,
                        "large_image_url": "https://lh3.googleusercontent.com/hybKwm5kYCjE_IIF4DiObNzaHYVOH0Xenx3ye8domy0ssj1SQB7L7j0krdp8dFFiR8ZTznf16HX70btLTblWUqS-wxaFqbAencUTyw=s300",
                        "medium_username": null,
                        "name": "Apymon Monsters",
                        "only_proxied_transfers": false,
                        "opensea_buyer_fee_basis_points": "0",
                        "opensea_seller_fee_basis_points": "250",
                        "payout_address": null,
                        "require_email": false,
                        "short_description": null,
                        "slug": "apymon-monsters",
                        "telegram_url": null,
                        "twitter_username": null,
                        "instagram_username": null,
                        "wiki_url": null
                    },
                    "decimals": 0,
                    "token_metadata": "https://gateway.pinata.cloud/ipfs/QmTQeQgS5Xa5WiDzuGS5RCKe8z74CgfiuA5cADPXLVX7uB/524"
                },
                {
                    "id": 25299109,
                    "token_id": "526",
                    "num_sales": 0,
                    "background_color": null,
                    "image_url": "https://lh3.googleusercontent.com/QxnwzQm_cEiA8fFMGwV7ONEsS92x2Z1LJ8XXeMa9H0fggApN08YFRFoe5FWUlYBvj4U1qZ0lr6PWDyxNSDVbtpdSCYm7dIM9jfr4wEw",
                    "image_preview_url": "https://lh3.googleusercontent.com/QxnwzQm_cEiA8fFMGwV7ONEsS92x2Z1LJ8XXeMa9H0fggApN08YFRFoe5FWUlYBvj4U1qZ0lr6PWDyxNSDVbtpdSCYm7dIM9jfr4wEw=s250",
                    "image_thumbnail_url": "https://lh3.googleusercontent.com/QxnwzQm_cEiA8fFMGwV7ONEsS92x2Z1LJ8XXeMa9H0fggApN08YFRFoe5FWUlYBvj4U1qZ0lr6PWDyxNSDVbtpdSCYm7dIM9jfr4wEw=s128",
                    "image_original_url": "https://arweave.net/YUE1dPHuf8LuLDibMnHyGzvY-sYKcM1abeyxBFBNPiY",
                    "animation_url": null,
                    "animation_original_url": null,
                    "name": "Apymon Monsters #526",
                    "description": null,
                    "external_link": "https://apymon.com",
                    "asset_contract": {
                        "address": "0x6e0baaa0d1c11dc160143c0c7213df76acdf4e17",
                        "asset_contract_type": "non-fungible",
                        "created_date": "2021-05-18T16:21:48.758011",
                        "name": "Apymon Monsters",
                        "nft_version": "3.0",
                        "opensea_version": null,
                        "owner": 30104721,
                        "schema_name": "ERC721",
                        "symbol": "APYM",
                        "total_supply": "0",
                        "description": "The NFT built by ERC721, Apymon Monsters, on Ethereum.",
                        "external_link": null,
                        "image_url": "https://lh3.googleusercontent.com/nCcUQe3w8k7omeB6DSrP4Y792JQaRLfqFv6SFzDxab1k44mR7kT9p8d4-m_X6iEfr47RGup5wCdP2s2RS1Y88-KaeElQgyzTs4cc=s120",
                        "default_to_fiat": false,
                        "dev_buyer_fee_basis_points": 0,
                        "dev_seller_fee_basis_points": 0,
                        "only_proxied_transfers": false,
                        "opensea_buyer_fee_basis_points": 0,
                        "opensea_seller_fee_basis_points": 250,
                        "buyer_fee_basis_points": 0,
                        "seller_fee_basis_points": 250,
                        "payout_address": null
                    },
                    "owner": {
                        "user": {
                            "username": "JakeShepherd"
                        },
                        "profile_img_url": "https://storage.googleapis.com/opensea-static/opensea-profile/29.png",
                        "address": "0xd887758a36bbf3c44ba3f1ffa0d8ff8d536cc129",
                        "config": "",
                        "discord_id": ""
                    },
                    "permalink": "https://opensea.io/assets/0x6e0baaa0d1c11dc160143c0c7213df76acdf4e17/526",
                    "collection": {
                        "banner_image_url": "https://lh3.googleusercontent.com/xsxkSFVINW-MV2mnqiv5PN6uFynoq-ev16uvOIgkz73GODzvFeM7wOmBM7OkxGmhv1GHpP-t31VqHcEvfScUfAnfiDT-zGS_Y30C=s2500",
                        "chat_url": null,
                        "created_date": "2021-05-18T16:59:45.948886",
                        "default_to_fiat": false,
                        "description": "The NFT built by ERC721, Apymon Monsters, on Ethereum.",
                        "dev_buyer_fee_basis_points": "0",
                        "dev_seller_fee_basis_points": "0",
                        "discord_url": null,
                        "display_data": {
                            "card_display_style": "contain"
                        },
                        "external_url": null,
                        "featured": false,
                        "featured_image_url": "https://lh3.googleusercontent.com/hybKwm5kYCjE_IIF4DiObNzaHYVOH0Xenx3ye8domy0ssj1SQB7L7j0krdp8dFFiR8ZTznf16HX70btLTblWUqS-wxaFqbAencUTyw=s300",
                        "hidden": true,
                        "safelist_request_status": "not_requested",
                        "image_url": "https://lh3.googleusercontent.com/nCcUQe3w8k7omeB6DSrP4Y792JQaRLfqFv6SFzDxab1k44mR7kT9p8d4-m_X6iEfr47RGup5wCdP2s2RS1Y88-KaeElQgyzTs4cc=s120",
                        "is_subject_to_whitelist": false,
                        "large_image_url": "https://lh3.googleusercontent.com/hybKwm5kYCjE_IIF4DiObNzaHYVOH0Xenx3ye8domy0ssj1SQB7L7j0krdp8dFFiR8ZTznf16HX70btLTblWUqS-wxaFqbAencUTyw=s300",
                        "medium_username": null,
                        "name": "Apymon Monsters",
                        "only_proxied_transfers": false,
                        "opensea_buyer_fee_basis_points": "0",
                        "opensea_seller_fee_basis_points": "250",
                        "payout_address": null,
                        "require_email": false,
                        "short_description": null,
                        "slug": "apymon-monsters",
                        "telegram_url": null,
                        "twitter_username": null,
                        "instagram_username": null,
                        "wiki_url": null
                    },
                    "decimals": 0,
                    "token_metadata": "https://gateway.pinata.cloud/ipfs/QmTQeQgS5Xa5WiDzuGS5RCKe8z74CgfiuA5cADPXLVX7uB/526"
                },
                {
                    "id": 25299110,
                    "token_id": "525",
                    "num_sales": 0,
                    "background_color": null,
                    "image_url": "https://lh3.googleusercontent.com/qf-5PuVkLgKmCQYcE0vbgwfto2OjaSDP7dbG2jr2odhAD71SQOuXlQTkLWFSnkThwqxJpOC5vaXsQCIS1Zqja_Wn_AWwIx5WaXfq3A",
                    "image_preview_url": "https://lh3.googleusercontent.com/qf-5PuVkLgKmCQYcE0vbgwfto2OjaSDP7dbG2jr2odhAD71SQOuXlQTkLWFSnkThwqxJpOC5vaXsQCIS1Zqja_Wn_AWwIx5WaXfq3A=s250",
                    "image_thumbnail_url": "https://lh3.googleusercontent.com/qf-5PuVkLgKmCQYcE0vbgwfto2OjaSDP7dbG2jr2odhAD71SQOuXlQTkLWFSnkThwqxJpOC5vaXsQCIS1Zqja_Wn_AWwIx5WaXfq3A=s128",
                    "image_original_url": "https://arweave.net/o0E3ox4AI67TyZTrpicsv7f2W28fB7cVk4eqbNatxkg",
                    "animation_url": null,
                    "animation_original_url": null,
                    "name": "Apymon Monsters #525",
                    "description": null,
                    "external_link": "https://apymon.com",
                    "asset_contract": {
                        "address": "0x6e0baaa0d1c11dc160143c0c7213df76acdf4e17",
                        "asset_contract_type": "non-fungible",
                        "created_date": "2021-05-18T16:21:48.758011",
                        "name": "Apymon Monsters",
                        "nft_version": "3.0",
                        "opensea_version": null,
                        "owner": 30104721,
                        "schema_name": "ERC721",
                        "symbol": "APYM",
                        "total_supply": "0",
                        "description": "The NFT built by ERC721, Apymon Monsters, on Ethereum.",
                        "external_link": null,
                        "image_url": "https://lh3.googleusercontent.com/nCcUQe3w8k7omeB6DSrP4Y792JQaRLfqFv6SFzDxab1k44mR7kT9p8d4-m_X6iEfr47RGup5wCdP2s2RS1Y88-KaeElQgyzTs4cc=s120",
                        "default_to_fiat": false,
                        "dev_buyer_fee_basis_points": 0,
                        "dev_seller_fee_basis_points": 0,
                        "only_proxied_transfers": false,
                        "opensea_buyer_fee_basis_points": 0,
                        "opensea_seller_fee_basis_points": 250,
                        "buyer_fee_basis_points": 0,
                        "seller_fee_basis_points": 250,
                        "payout_address": null
                    },
                    "owner": {
                        "user": {
                            "username": "JakeShepherd"
                        },
                        "profile_img_url": "https://storage.googleapis.com/opensea-static/opensea-profile/29.png",
                        "address": "0xd887758a36bbf3c44ba3f1ffa0d8ff8d536cc129",
                        "config": "",
                        "discord_id": ""
                    },
                    "permalink": "https://opensea.io/assets/0x6e0baaa0d1c11dc160143c0c7213df76acdf4e17/525",
                    "collection": {
                        "banner_image_url": "https://lh3.googleusercontent.com/xsxkSFVINW-MV2mnqiv5PN6uFynoq-ev16uvOIgkz73GODzvFeM7wOmBM7OkxGmhv1GHpP-t31VqHcEvfScUfAnfiDT-zGS_Y30C=s2500",
                        "chat_url": null,
                        "created_date": "2021-05-18T16:59:45.948886",
                        "default_to_fiat": false,
                        "description": "The NFT built by ERC721, Apymon Monsters, on Ethereum.",
                        "dev_buyer_fee_basis_points": "0",
                        "dev_seller_fee_basis_points": "0",
                        "discord_url": null,
                        "display_data": {
                            "card_display_style": "contain"
                        },
                        "external_url": null,
                        "featured": false,
                        "featured_image_url": "https://lh3.googleusercontent.com/hybKwm5kYCjE_IIF4DiObNzaHYVOH0Xenx3ye8domy0ssj1SQB7L7j0krdp8dFFiR8ZTznf16HX70btLTblWUqS-wxaFqbAencUTyw=s300",
                        "hidden": true,
                        "safelist_request_status": "not_requested",
                        "image_url": "https://lh3.googleusercontent.com/nCcUQe3w8k7omeB6DSrP4Y792JQaRLfqFv6SFzDxab1k44mR7kT9p8d4-m_X6iEfr47RGup5wCdP2s2RS1Y88-KaeElQgyzTs4cc=s120",
                        "is_subject_to_whitelist": false,
                        "large_image_url": "https://lh3.googleusercontent.com/hybKwm5kYCjE_IIF4DiObNzaHYVOH0Xenx3ye8domy0ssj1SQB7L7j0krdp8dFFiR8ZTznf16HX70btLTblWUqS-wxaFqbAencUTyw=s300",
                        "medium_username": null,
                        "name": "Apymon Monsters",
                        "only_proxied_transfers": false,
                        "opensea_buyer_fee_basis_points": "0",
                        "opensea_seller_fee_basis_points": "250",
                        "payout_address": null,
                        "require_email": false,
                        "short_description": null,
                        "slug": "apymon-monsters",
                        "telegram_url": null,
                        "twitter_username": null,
                        "instagram_username": null,
                        "wiki_url": null
                    },
                    "decimals": 0,
                    "token_metadata": "https://gateway.pinata.cloud/ipfs/QmTQeQgS5Xa5WiDzuGS5RCKe8z74CgfiuA5cADPXLVX7uB/525"
                },
                {
                    "id": 25299175,
                    "token_id": "527",
                    "num_sales": 0,
                    "background_color": null,
                    "image_url": "https://lh3.googleusercontent.com/rEzftNeRYfLxItA-X8natN9d6JgRoeMgGjR0TAnAVnIVT2Vb1PjPbfsCf0IzbuF2Zka1tD55ccbaEAHE8tYL5tB73jZNJGX6LqI3MA",
                    "image_preview_url": "https://lh3.googleusercontent.com/rEzftNeRYfLxItA-X8natN9d6JgRoeMgGjR0TAnAVnIVT2Vb1PjPbfsCf0IzbuF2Zka1tD55ccbaEAHE8tYL5tB73jZNJGX6LqI3MA=s250",
                    "image_thumbnail_url": "https://lh3.googleusercontent.com/rEzftNeRYfLxItA-X8natN9d6JgRoeMgGjR0TAnAVnIVT2Vb1PjPbfsCf0IzbuF2Zka1tD55ccbaEAHE8tYL5tB73jZNJGX6LqI3MA=s128",
                    "image_original_url": "https://arweave.net/_OU1R0apyfrGuYtt8IhRIMVWxmbFtxZssKTg8lqbqFI",
                    "animation_url": null,
                    "animation_original_url": null,
                    "name": "Apymon Monsters #527",
                    "description": null,
                    "external_link": "https://apymon.com",
                    "asset_contract": {
                        "address": "0x6e0baaa0d1c11dc160143c0c7213df76acdf4e17",
                        "asset_contract_type": "non-fungible",
                        "created_date": "2021-05-18T16:21:48.758011",
                        "name": "Apymon Monsters",
                        "nft_version": "3.0",
                        "opensea_version": null,
                        "owner": 30104721,
                        "schema_name": "ERC721",
                        "symbol": "APYM",
                        "total_supply": "0",
                        "description": "The NFT built by ERC721, Apymon Monsters, on Ethereum.",
                        "external_link": null,
                        "image_url": "https://lh3.googleusercontent.com/nCcUQe3w8k7omeB6DSrP4Y792JQaRLfqFv6SFzDxab1k44mR7kT9p8d4-m_X6iEfr47RGup5wCdP2s2RS1Y88-KaeElQgyzTs4cc=s120",
                        "default_to_fiat": false,
                        "dev_buyer_fee_basis_points": 0,
                        "dev_seller_fee_basis_points": 0,
                        "only_proxied_transfers": false,
                        "opensea_buyer_fee_basis_points": 0,
                        "opensea_seller_fee_basis_points": 250,
                        "buyer_fee_basis_points": 0,
                        "seller_fee_basis_points": 250,
                        "payout_address": null
                    },
                    "owner": {
                        "user": {
                            "username": "JakeShepherd"
                        },
                        "profile_img_url": "https://storage.googleapis.com/opensea-static/opensea-profile/29.png",
                        "address": "0xd887758a36bbf3c44ba3f1ffa0d8ff8d536cc129",
                        "config": "",
                        "discord_id": ""
                    },
                    "permalink": "https://opensea.io/assets/0x6e0baaa0d1c11dc160143c0c7213df76acdf4e17/527",
                    "collection": {
                        "banner_image_url": "https://lh3.googleusercontent.com/xsxkSFVINW-MV2mnqiv5PN6uFynoq-ev16uvOIgkz73GODzvFeM7wOmBM7OkxGmhv1GHpP-t31VqHcEvfScUfAnfiDT-zGS_Y30C=s2500",
                        "chat_url": null,
                        "created_date": "2021-05-18T16:59:45.948886",
                        "default_to_fiat": false,
                        "description": "The NFT built by ERC721, Apymon Monsters, on Ethereum.",
                        "dev_buyer_fee_basis_points": "0",
                        "dev_seller_fee_basis_points": "0",
                        "discord_url": null,
                        "display_data": {
                            "card_display_style": "contain"
                        },
                        "external_url": null,
                        "featured": false,
                        "featured_image_url": "https://lh3.googleusercontent.com/hybKwm5kYCjE_IIF4DiObNzaHYVOH0Xenx3ye8domy0ssj1SQB7L7j0krdp8dFFiR8ZTznf16HX70btLTblWUqS-wxaFqbAencUTyw=s300",
                        "hidden": true,
                        "safelist_request_status": "not_requested",
                        "image_url": "https://lh3.googleusercontent.com/nCcUQe3w8k7omeB6DSrP4Y792JQaRLfqFv6SFzDxab1k44mR7kT9p8d4-m_X6iEfr47RGup5wCdP2s2RS1Y88-KaeElQgyzTs4cc=s120",
                        "is_subject_to_whitelist": false,
                        "large_image_url": "https://lh3.googleusercontent.com/hybKwm5kYCjE_IIF4DiObNzaHYVOH0Xenx3ye8domy0ssj1SQB7L7j0krdp8dFFiR8ZTznf16HX70btLTblWUqS-wxaFqbAencUTyw=s300",
                        "medium_username": null,
                        "name": "Apymon Monsters",
                        "only_proxied_transfers": false,
                        "opensea_buyer_fee_basis_points": "0",
                        "opensea_seller_fee_basis_points": "250",
                        "payout_address": null,
                        "require_email": false,
                        "short_description": null,
                        "slug": "apymon-monsters",
                        "telegram_url": null,
                        "twitter_username": null,
                        "instagram_username": null,
                        "wiki_url": null
                    },
                    "decimals": 0,
                    "token_metadata": "https://gateway.pinata.cloud/ipfs/QmTQeQgS5Xa5WiDzuGS5RCKe8z74CgfiuA5cADPXLVX7uB/527"
                },
                {
                    "id": 25299176,
                    "token_id": "528",
                    "num_sales": 0,
                    "background_color": null,
                    "image_url": "https://lh3.googleusercontent.com/C8CUA8q0Vn4a6nNO5R9kZHSlFVJ5gWOXyoZ50zBMT3Z3X66zfn4bHXZmewrIz5HgvScMNjZ3201621Ddp20VAvaJfs6CO1CEBveA",
                    "image_preview_url": "https://lh3.googleusercontent.com/C8CUA8q0Vn4a6nNO5R9kZHSlFVJ5gWOXyoZ50zBMT3Z3X66zfn4bHXZmewrIz5HgvScMNjZ3201621Ddp20VAvaJfs6CO1CEBveA=s250",
                    "image_thumbnail_url": "https://lh3.googleusercontent.com/C8CUA8q0Vn4a6nNO5R9kZHSlFVJ5gWOXyoZ50zBMT3Z3X66zfn4bHXZmewrIz5HgvScMNjZ3201621Ddp20VAvaJfs6CO1CEBveA=s128",
                    "image_original_url": "https://arweave.net/0lwJobGvnC30-79jqT_Pc_5KICRr6AeQ1ZC85b4D2vA",
                    "animation_url": null,
                    "animation_original_url": null,
                    "name": "Apymon Monsters #528",
                    "description": null,
                    "external_link": "https://apymon.com",
                    "asset_contract": {
                        "address": "0x6e0baaa0d1c11dc160143c0c7213df76acdf4e17",
                        "asset_contract_type": "non-fungible",
                        "created_date": "2021-05-18T16:21:48.758011",
                        "name": "Apymon Monsters",
                        "nft_version": "3.0",
                        "opensea_version": null,
                        "owner": 30104721,
                        "schema_name": "ERC721",
                        "symbol": "APYM",
                        "total_supply": "0",
                        "description": "The NFT built by ERC721, Apymon Monsters, on Ethereum.",
                        "external_link": null,
                        "image_url": "https://lh3.googleusercontent.com/nCcUQe3w8k7omeB6DSrP4Y792JQaRLfqFv6SFzDxab1k44mR7kT9p8d4-m_X6iEfr47RGup5wCdP2s2RS1Y88-KaeElQgyzTs4cc=s120",
                        "default_to_fiat": false,
                        "dev_buyer_fee_basis_points": 0,
                        "dev_seller_fee_basis_points": 0,
                        "only_proxied_transfers": false,
                        "opensea_buyer_fee_basis_points": 0,
                        "opensea_seller_fee_basis_points": 250,
                        "buyer_fee_basis_points": 0,
                        "seller_fee_basis_points": 250,
                        "payout_address": null
                    },
                    "owner": {
                        "user": {
                            "username": "JakeShepherd"
                        },
                        "profile_img_url": "https://storage.googleapis.com/opensea-static/opensea-profile/29.png",
                        "address": "0xd887758a36bbf3c44ba3f1ffa0d8ff8d536cc129",
                        "config": "",
                        "discord_id": ""
                    },
                    "permalink": "https://opensea.io/assets/0x6e0baaa0d1c11dc160143c0c7213df76acdf4e17/528",
                    "collection": {
                        "banner_image_url": "https://lh3.googleusercontent.com/xsxkSFVINW-MV2mnqiv5PN6uFynoq-ev16uvOIgkz73GODzvFeM7wOmBM7OkxGmhv1GHpP-t31VqHcEvfScUfAnfiDT-zGS_Y30C=s2500",
                        "chat_url": null,
                        "created_date": "2021-05-18T16:59:45.948886",
                        "default_to_fiat": false,
                        "description": "The NFT built by ERC721, Apymon Monsters, on Ethereum.",
                        "dev_buyer_fee_basis_points": "0",
                        "dev_seller_fee_basis_points": "0",
                        "discord_url": null,
                        "display_data": {
                            "card_display_style": "contain"
                        },
                        "external_url": null,
                        "featured": false,
                        "featured_image_url": "https://lh3.googleusercontent.com/hybKwm5kYCjE_IIF4DiObNzaHYVOH0Xenx3ye8domy0ssj1SQB7L7j0krdp8dFFiR8ZTznf16HX70btLTblWUqS-wxaFqbAencUTyw=s300",
                        "hidden": true,
                        "safelist_request_status": "not_requested",
                        "image_url": "https://lh3.googleusercontent.com/nCcUQe3w8k7omeB6DSrP4Y792JQaRLfqFv6SFzDxab1k44mR7kT9p8d4-m_X6iEfr47RGup5wCdP2s2RS1Y88-KaeElQgyzTs4cc=s120",
                        "is_subject_to_whitelist": false,
                        "large_image_url": "https://lh3.googleusercontent.com/hybKwm5kYCjE_IIF4DiObNzaHYVOH0Xenx3ye8domy0ssj1SQB7L7j0krdp8dFFiR8ZTznf16HX70btLTblWUqS-wxaFqbAencUTyw=s300",
                        "medium_username": null,
                        "name": "Apymon Monsters",
                        "only_proxied_transfers": false,
                        "opensea_buyer_fee_basis_points": "0",
                        "opensea_seller_fee_basis_points": "250",
                        "payout_address": null,
                        "require_email": false,
                        "short_description": null,
                        "slug": "apymon-monsters",
                        "telegram_url": null,
                        "twitter_username": null,
                        "instagram_username": null,
                        "wiki_url": null
                    },
                    "decimals": 0,
                    "token_metadata": "https://gateway.pinata.cloud/ipfs/QmTQeQgS5Xa5WiDzuGS5RCKe8z74CgfiuA5cADPXLVX7uB/528"
                }
            ],
            "name": "HUGE BUNDLE - 10 EGGS (Some 2x) + 10 MONSTERS",
            "description": "",
            "external_link": "",
            "asset_contract": null,
            "permalink": "https://opensea.io/bundles/huge-bundle-10-eggs-some-2x-10-monsters-AS3",
            "sell_orders": [
                {
                    "created_date": "2021-05-25T20:56:40.216382",
                    "closing_date": null,
                    "closing_extendable": false,
                    "expiration_time": 0,
                    "listing_time": 1621976095,
                    "order_hash": "0x2ca3c0fe3e005c23bb6d010960e0a83297a0bf8552411bb258c279df5c176756",
                    "metadata": {
                        "bundle": {
                            "assets": [
                                {
                                    "id": "17",
                                    "address": "0x6e0baaa0d1c11dc160143c0c7213df76acdf4e17"
                                },
                                {
                                    "id": "520",
                                    "address": "0x6e0baaa0d1c11dc160143c0c7213df76acdf4e17"
                                },
                                {
                                    "id": "521",
                                    "address": "0x6e0baaa0d1c11dc160143c0c7213df76acdf4e17"
                                },
                                {
                                    "id": "522",
                                    "address": "0x6e0baaa0d1c11dc160143c0c7213df76acdf4e17"
                                },
                                {
                                    "id": "523",
                                    "address": "0x6e0baaa0d1c11dc160143c0c7213df76acdf4e17"
                                },
                                {
                                    "id": "524",
                                    "address": "0x6e0baaa0d1c11dc160143c0c7213df76acdf4e17"
                                },
                                {
                                    "id": "525",
                                    "address": "0x6e0baaa0d1c11dc160143c0c7213df76acdf4e17"
                                },
                                {
                                    "id": "526",
                                    "address": "0x6e0baaa0d1c11dc160143c0c7213df76acdf4e17"
                                },
                                {
                                    "id": "527",
                                    "address": "0x6e0baaa0d1c11dc160143c0c7213df76acdf4e17"
                                },
                                {
                                    "id": "528",
                                    "address": "0x6e0baaa0d1c11dc160143c0c7213df76acdf4e17"
                                },
                                {
                                    "id": "188",
                                    "address": "0x9c008a22d71b6182029b694b0311486e4c0e53db"
                                },
                                {
                                    "id": "189",
                                    "address": "0x9c008a22d71b6182029b694b0311486e4c0e53db"
                                },
                                {
                                    "id": "190",
                                    "address": "0x9c008a22d71b6182029b694b0311486e4c0e53db"
                                },
                                {
                                    "id": "191",
                                    "address": "0x9c008a22d71b6182029b694b0311486e4c0e53db"
                                },
                                {
                                    "id": "192",
                                    "address": "0x9c008a22d71b6182029b694b0311486e4c0e53db"
                                },
                                {
                                    "id": "193",
                                    "address": "0x9c008a22d71b6182029b694b0311486e4c0e53db"
                                },
                                {
                                    "id": "194",
                                    "address": "0x9c008a22d71b6182029b694b0311486e4c0e53db"
                                },
                                {
                                    "id": "195",
                                    "address": "0x9c008a22d71b6182029b694b0311486e4c0e53db"
                                },
                                {
                                    "id": "196",
                                    "address": "0x9c008a22d71b6182029b694b0311486e4c0e53db"
                                },
                                {
                                    "id": "197",
                                    "address": "0x9c008a22d71b6182029b694b0311486e4c0e53db"
                                }
                            ],
                            "schemas": [
                                "ERC721",
                                "ERC721",
                                "ERC721",
                                "ERC721",
                                "ERC721",
                                "ERC721",
                                "ERC721",
                                "ERC721",
                                "ERC721",
                                "ERC721",
                                "ERC721",
                                "ERC721",
                                "ERC721",
                                "ERC721",
                                "ERC721",
                                "ERC721",
                                "ERC721",
                                "ERC721",
                                "ERC721",
                                "ERC721"
                            ],
                            "name": "HUGE BUNDLE - 10 EGGS (Some 2x) + 10 MONSTERS",
                            "description": "",
                            "external_link": ""
                        }
                    },
                    "exchange": "0x7be8076f4ea4a4ad08075c2508e481d6c946d12b",
                    "maker": {
                        "user": 62403,
                        "profile_img_url": "https://storage.googleapis.com/opensea-static/opensea-profile/29.png",
                        "address": "0xd887758a36bbf3c44ba3f1ffa0d8ff8d536cc129",
                        "config": "",
                        "discord_id": ""
                    },
                    "taker": {
                        "user": 1766,
                        "profile_img_url": "https://storage.googleapis.com/opensea-static/opensea-profile/1.png",
                        "address": "0x0000000000000000000000000000000000000000",
                        "config": "",
                        "discord_id": ""
                    },
                    "current_price": "3750000000000000000",
                    "current_bounty": "37500000000000000",
                    "bounty_multiple": "0.01",
                    "maker_relayer_fee": "250",
                    "taker_relayer_fee": "0",
                    "maker_protocol_fee": "0",
                    "taker_protocol_fee": "0",
                    "maker_referrer_fee": "0",
                    "fee_recipient": {
                        "user": 3585,
                        "profile_img_url": "https://storage.googleapis.com/opensea-static/opensea-profile/28.png",
                        "address": "0x5b3256965e7c3cf26e11fcaf296dfc8807c01073",
                        "config": "verified",
                        "discord_id": ""
                    },
                    "fee_method": 1,
                    "side": 1,
                    "sale_kind": 0,
                    "target": "0xc99f70bfd82fb7c8f8191fdfbfb735606b15e5c5",
                    "how_to_call": 1,
                    "calldata": "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",
                    "replacement_pattern": "0x0000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000ffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffff0000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000ffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffff0000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000ffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffff0000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000ffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffff0000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000ffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffff0000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000ffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffff0000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000ffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffff0000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000ffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffff0000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000ffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffff0000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000ffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffff0000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000ffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffff0000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000ffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffff0000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000ffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffff0000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000ffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffff0000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000ffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffff0000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000ffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffff0000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000ffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffff0000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000ffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffff0000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000ffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffff0000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000ffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffff000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000",
                    "static_target": "0x0000000000000000000000000000000000000000",
                    "static_extradata": "0x",
                    "payment_token": "0x0000000000000000000000000000000000000000",
                    "payment_token_contract": {
                        "id": 1,
                        "symbol": "ETH",
                        "address": "0x0000000000000000000000000000000000000000",
                        "image_url": "https://storage.opensea.io/files/6f8e2979d428180222796ff4a33ab929.svg",
                        "name": "Ether",
                        "decimals": 18,
                        "eth_price": "1.000000000000000",
                        "usd_price": "2625.730000000000018000"
                    },
                    "base_price": "3750000000000000000",
                    "extra": "0",
                    "quantity": "1",
                    "salt": "72100263169738490071697238366427087506367094679059282248655928367874626631368",
                    "v": 27,
                    "r": "0x02da88aaf6bf5ef9e257faa1fe865af300d34605cb61e47a646f1e6b05c4a73b",
                    "s": "0x5802fe712b96a8254b943553e57e79a90314bd835e2a56291f5cbcb5b6848d46",
                    "approved_on_chain": false,
                    "cancelled": false,
                    "finalized": false,
                    "marked_invalid": false,
                    "prefixed_hash": "0xf0c797b7830e5c63e89ddc9dec60f5cc6d1197bd3faa943b3eda1e8cc483f1ec"
                }
            ]
        },
        {
            "maker": {
                "user": {
                    "username": "RealKush_Cabin"
                },
                "profile_img_url": "https://storage.googleapis.com/opensea-static/opensea-profile/2.png",
                "address": "0x8f800cc88bffede0dbaecc76a0c15a2f5701ac1e",
                "config": "",
                "discord_id": ""
            },
            "slug": "low-effort-punk-kushpunk-nQ4",
            "assets": [
                {
                    "id": 19950466,
                    "token_id": "58829031497677301765439391501516551631592351449409907467332645155788417925121",
                    "num_sales": 1,
                    "background_color": null,
                    "image_url": "https://lh3.googleusercontent.com/70ycNjcAsqvKQlwDlsQ7KjrEO_1GkWu1w1a5hDT9xIkOYnMVE0XxHkTJ5IVP7G9F-BIIN_KM0jJ2ZC78xfIIhFWV3G0w1sxFJNSAGA",
                    "image_preview_url": "https://lh3.googleusercontent.com/70ycNjcAsqvKQlwDlsQ7KjrEO_1GkWu1w1a5hDT9xIkOYnMVE0XxHkTJ5IVP7G9F-BIIN_KM0jJ2ZC78xfIIhFWV3G0w1sxFJNSAGA=s250",
                    "image_thumbnail_url": "https://lh3.googleusercontent.com/70ycNjcAsqvKQlwDlsQ7KjrEO_1GkWu1w1a5hDT9xIkOYnMVE0XxHkTJ5IVP7G9F-BIIN_KM0jJ2ZC78xfIIhFWV3G0w1sxFJNSAGA=s128",
                    "image_original_url": null,
                    "animation_url": null,
                    "animation_original_url": null,
                    "name": "KushPunk #0005",
                    "description": "#0005/420",
                    "external_link": "http://twitter.com/kushpunks",
                    "asset_contract": {
                        "address": "0x495f947276749ce646f68ac8c248420045cb7b5e",
                        "asset_contract_type": "semi-fungible",
                        "created_date": "2020-12-02T17:40:53.232025",
                        "name": "OpenSea Collection",
                        "nft_version": null,
                        "opensea_version": "2.0.0",
                        "owner": 102384,
                        "schema_name": "ERC1155",
                        "symbol": "OPENSTORE",
                        "total_supply": null,
                        "description": null,
                        "external_link": null,
                        "image_url": null,
                        "default_to_fiat": false,
                        "dev_buyer_fee_basis_points": 0,
                        "dev_seller_fee_basis_points": 0,
                        "only_proxied_transfers": false,
                        "opensea_buyer_fee_basis_points": 0,
                        "opensea_seller_fee_basis_points": 250,
                        "buyer_fee_basis_points": 0,
                        "seller_fee_basis_points": 250,
                        "payout_address": null
                    },
                    "owner": {
                        "user": {
                            "username": "NullAddress"
                        },
                        "profile_img_url": "https://storage.googleapis.com/opensea-static/opensea-profile/1.png",
                        "address": "0x0000000000000000000000000000000000000000",
                        "config": "",
                        "discord_id": ""
                    },
                    "permalink": "https://opensea.io/assets/0x495f947276749ce646f68ac8c248420045cb7b5e/58829031497677301765439391501516551631592351449409907467332645155788417925121",
                    "collection": {
                        "banner_image_url": "https://lh3.googleusercontent.com/fZrBBLPxouSiz5P-NBBndl0Ekk8auixQTh0-iCXdBu_yf6cpbaCT4F9mQXNZ7v2GrRz3f9r3vbyHMWOeQvKVVn_SxpVxSrTjPLyl=s2500",
                        "chat_url": null,
                        "created_date": "2021-03-18T23:35:53.166137",
                        "default_to_fiat": false,
                        "description": "420 NFTs not affiliated with the original Larva Labs collection of CryptoPunks. We just like to get high.",
                        "dev_buyer_fee_basis_points": "0",
                        "dev_seller_fee_basis_points": "1000",
                        "discord_url": null,
                        "display_data": {
                            "card_display_style": "contain"
                        },
                        "external_url": null,
                        "featured": false,
                        "featured_image_url": "https://lh3.googleusercontent.com/fZrBBLPxouSiz5P-NBBndl0Ekk8auixQTh0-iCXdBu_yf6cpbaCT4F9mQXNZ7v2GrRz3f9r3vbyHMWOeQvKVVn_SxpVxSrTjPLyl=s300",
                        "hidden": true,
                        "safelist_request_status": "not_requested",
                        "image_url": "https://lh3.googleusercontent.com/2CGC1DjqcM6DBTBXTjslOVaFvfpAiSmLva2TyMSX7qNRHs5i2uoKv7CNIxE5sdukeSX6LG4HfCgRllLgm7WZU-SYkt2XAsSW1Dopetk=s120",
                        "is_subject_to_whitelist": false,
                        "large_image_url": "https://lh3.googleusercontent.com/fZrBBLPxouSiz5P-NBBndl0Ekk8auixQTh0-iCXdBu_yf6cpbaCT4F9mQXNZ7v2GrRz3f9r3vbyHMWOeQvKVVn_SxpVxSrTjPLyl=s300",
                        "medium_username": null,
                        "name": "KushPunks",
                        "only_proxied_transfers": false,
                        "opensea_buyer_fee_basis_points": "0",
                        "opensea_seller_fee_basis_points": "250",
                        "payout_address": "0x82100d46b3a1c126cf52f9d66a0e7b1e6df0dfef",
                        "require_email": false,
                        "short_description": null,
                        "slug": "kushpunks",
                        "telegram_url": null,
                        "twitter_username": "kushpunks",
                        "instagram_username": "kushpunks",
                        "wiki_url": null
                    },
                    "decimals": null,
                    "token_metadata": null
                },
                {
                    "id": 25152682,
                    "token_id": "87198930750286842836902562062466327909054195361095182156017572017769342304257",
                    "num_sales": 1,
                    "background_color": null,
                    "image_url": "https://lh3.googleusercontent.com/P8YPYEyA5xGan2scSlKJDQnYODk_BFzNc8FQS_dJ3mBXFk7MUjgVI_j5YDNEfPI7EntBfgpTgmHNalS1eev6rCGLc78K3eLGU3iWYA",
                    "image_preview_url": "https://lh3.googleusercontent.com/P8YPYEyA5xGan2scSlKJDQnYODk_BFzNc8FQS_dJ3mBXFk7MUjgVI_j5YDNEfPI7EntBfgpTgmHNalS1eev6rCGLc78K3eLGU3iWYA=s250",
                    "image_thumbnail_url": "https://lh3.googleusercontent.com/P8YPYEyA5xGan2scSlKJDQnYODk_BFzNc8FQS_dJ3mBXFk7MUjgVI_j5YDNEfPI7EntBfgpTgmHNalS1eev6rCGLc78K3eLGU3iWYA=s128",
                    "image_original_url": null,
                    "animation_url": null,
                    "animation_original_url": null,
                    "name": "low effort punk 253",
                    "description": null,
                    "external_link": null,
                    "asset_contract": {
                        "address": "0x495f947276749ce646f68ac8c248420045cb7b5e",
                        "asset_contract_type": "semi-fungible",
                        "created_date": "2020-12-02T17:40:53.232025",
                        "name": "OpenSea Collection",
                        "nft_version": null,
                        "opensea_version": "2.0.0",
                        "owner": 102384,
                        "schema_name": "ERC1155",
                        "symbol": "OPENSTORE",
                        "total_supply": null,
                        "description": null,
                        "external_link": null,
                        "image_url": null,
                        "default_to_fiat": false,
                        "dev_buyer_fee_basis_points": 0,
                        "dev_seller_fee_basis_points": 0,
                        "only_proxied_transfers": false,
                        "opensea_buyer_fee_basis_points": 0,
                        "opensea_seller_fee_basis_points": 250,
                        "buyer_fee_basis_points": 0,
                        "seller_fee_basis_points": 250,
                        "payout_address": null
                    },
                    "owner": {
                        "user": {
                            "username": "NullAddress"
                        },
                        "profile_img_url": "https://storage.googleapis.com/opensea-static/opensea-profile/1.png",
                        "address": "0x0000000000000000000000000000000000000000",
                        "config": "",
                        "discord_id": ""
                    },
                    "permalink": "https://opensea.io/assets/0x495f947276749ce646f68ac8c248420045cb7b5e/87198930750286842836902562062466327909054195361095182156017572017769342304257",
                    "collection": {
                        "banner_image_url": "https://lh3.googleusercontent.com/Etu-qUrtkP37k7nb0CklOzLPh9WzyXSKxt-3rV4NITJQ3VmZf4zedqGegTHVSKWnvHJym2OgcqdU403Ft7CZ3BYjgxOX5oGfjSh1Uw=s2500",
                        "chat_url": null,
                        "created_date": "2021-04-29T20:43:07.901697",
                        "default_to_fiat": false,
                        "description": "An homage to all of those moneygrab collections. made in one minute each without care",
                        "dev_buyer_fee_basis_points": "0",
                        "dev_seller_fee_basis_points": "1000",
                        "discord_url": null,
                        "display_data": {
                            "card_display_style": "contain"
                        },
                        "external_url": null,
                        "featured": false,
                        "featured_image_url": "https://lh3.googleusercontent.com/eLHT0U0jE4yelbd-rC-kwFJjk3vGq-RmCXcF65ZqpOzJdENGZht2b8IvJOTP-S6Up6tzt879SslHRIoQL-RjscsMtEQmrVG4tEcGIA=s300",
                        "hidden": true,
                        "safelist_request_status": "not_requested",
                        "image_url": "https://lh3.googleusercontent.com/xKcl3Db57QjJSVXWcTru44p4DV3ruJX9t6Rv3wqFmh5mOpXQBZTqXlUSdRcp9ca7tPJ79Ne_aX-zZj9wKyoG1kv-SW7ERykFLgPA=s120",
                        "is_subject_to_whitelist": false,
                        "large_image_url": "https://lh3.googleusercontent.com/eLHT0U0jE4yelbd-rC-kwFJjk3vGq-RmCXcF65ZqpOzJdENGZht2b8IvJOTP-S6Up6tzt879SslHRIoQL-RjscsMtEQmrVG4tEcGIA=s300",
                        "medium_username": null,
                        "name": "Low effort Punks",
                        "only_proxied_transfers": false,
                        "opensea_buyer_fee_basis_points": "0",
                        "opensea_seller_fee_basis_points": "250",
                        "payout_address": "0xc0c8d886b92a811e8e41cb6ab5144e44dbbfbfa3",
                        "require_email": false,
                        "short_description": null,
                        "slug": "low-effort-punks",
                        "telegram_url": null,
                        "twitter_username": "LowEffortPunks",
                        "instagram_username": null,
                        "wiki_url": null
                    },
                    "decimals": null,
                    "token_metadata": null
                }
            ],
            "name": "Low Effort Punk + KushPunk",
            "description": "Low Effort Punk + KushPunk Bundle",
            "external_link": "",
            "asset_contract": {
                "collection": {
                    "banner_image_url": null,
                    "chat_url": null,
                    "created_date": "2020-12-02T17:40:53.507540",
                    "default_to_fiat": false,
                    "description": null,
                    "dev_buyer_fee_basis_points": "0",
                    "dev_seller_fee_basis_points": "0",
                    "discord_url": null,
                    "display_data": {
                        "card_display_style": "contain",
                        "images": []
                    },
                    "external_url": null,
                    "featured": false,
                    "featured_image_url": null,
                    "hidden": true,
                    "safelist_request_status": "not_requested",
                    "image_url": null,
                    "is_subject_to_whitelist": false,
                    "large_image_url": null,
                    "medium_username": null,
                    "name": "OpenSea Shared Storefront V2",
                    "only_proxied_transfers": false,
                    "opensea_buyer_fee_basis_points": "0",
                    "opensea_seller_fee_basis_points": "250",
                    "payout_address": null,
                    "require_email": false,
                    "short_description": null,
                    "slug": "opensea-shared-storefront-v2",
                    "telegram_url": null,
                    "twitter_username": null,
                    "instagram_username": null,
                    "wiki_url": null
                },
                "address": "0x495f947276749ce646f68ac8c248420045cb7b5e",
                "asset_contract_type": "semi-fungible",
                "created_date": "2020-12-02T17:40:53.232025",
                "name": "OpenSea Collection",
                "nft_version": null,
                "opensea_version": "2.0.0",
                "owner": 102384,
                "schema_name": "ERC1155",
                "symbol": "OPENSTORE",
                "total_supply": null,
                "description": null,
                "external_link": null,
                "image_url": null,
                "default_to_fiat": false,
                "dev_buyer_fee_basis_points": 0,
                "dev_seller_fee_basis_points": 0,
                "only_proxied_transfers": false,
                "opensea_buyer_fee_basis_points": 0,
                "opensea_seller_fee_basis_points": 250,
                "buyer_fee_basis_points": 0,
                "seller_fee_basis_points": 250,
                "payout_address": null
            },
            "permalink": "https://opensea.io/bundles/low-effort-punk-kushpunk-nQ4",
            "sell_orders": [
                {
                    "created_date": "2021-05-25T20:55:15.929750",
                    "closing_date": null,
                    "closing_extendable": false,
                    "expiration_time": 0,
                    "listing_time": 1621975958,
                    "order_hash": "0x95202245da13acacf0710ac79aaf39bb8617a3d713348cd4f2f314c9165048ae",
                    "metadata": {
                        "bundle": {
                            "assets": [
                                {
                                    "id": "58829031497677301765439391501516551631592351449409907467332645155788417925121",
                                    "address": "0x495f947276749ce646f68ac8c248420045cb7b5e",
                                    "quantity": "1"
                                },
                                {
                                    "id": "87198930750286842836902562062466327909054195361095182156017572017769342304257",
                                    "address": "0x495f947276749ce646f68ac8c248420045cb7b5e",
                                    "quantity": "1"
                                }
                            ],
                            "schemas": [
                                "ERC1155",
                                "ERC1155"
                            ],
                            "name": "Low Effort Punk + KushPunk",
                            "description": "Low Effort Punk + KushPunk Bundle",
                            "external_link": ""
                        }
                    },
                    "exchange": "0x7be8076f4ea4a4ad08075c2508e481d6c946d12b",
                    "maker": {
                        "user": 668568,
                        "profile_img_url": "https://storage.googleapis.com/opensea-static/opensea-profile/2.png",
                        "address": "0x8f800cc88bffede0dbaecc76a0c15a2f5701ac1e",
                        "config": "",
                        "discord_id": ""
                    },
                    "taker": {
                        "user": 1766,
                        "profile_img_url": "https://storage.googleapis.com/opensea-static/opensea-profile/1.png",
                        "address": "0x0000000000000000000000000000000000000000",
                        "config": "",
                        "discord_id": ""
                    },
                    "current_price": "675000000000000000",
                    "current_bounty": "6750000000000000",
                    "bounty_multiple": "0.01",
                    "maker_relayer_fee": "250",
                    "taker_relayer_fee": "0",
                    "maker_protocol_fee": "0",
                    "taker_protocol_fee": "0",
                    "maker_referrer_fee": "0",
                    "fee_recipient": {
                        "user": 3585,
                        "profile_img_url": "https://storage.googleapis.com/opensea-static/opensea-profile/28.png",
                        "address": "0x5b3256965e7c3cf26e11fcaf296dfc8807c01073",
                        "config": "verified",
                        "discord_id": ""
                    },
                    "fee_method": 1,
                    "side": 1,
                    "sale_kind": 0,
                    "target": "0xc99f70bfd82fb7c8f8191fdfbfb735606b15e5c5",
                    "how_to_call": 1,
                    "calldata": "0x68f0bcaa000000000000000000000000000000000000000000000000000000000000008000000000000000000000000000000000000000000000000000000000000000e0000000000000000000000000000000000000000000000000000000000000014000000000000000000000000000000000000000000000000000000000000001a00000000000000000000000000000000000000000000000000000000000000002000000000000000000000000495f947276749ce646f68ac8c248420045cb7b5e000000000000000000000000495f947276749ce646f68ac8c248420045cb7b5e000000000000000000000000000000000000000000000000000000000000000200000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000200000000000000000000000000000000000000000000000000000000000000c400000000000000000000000000000000000000000000000000000000000000c40000000000000000000000000000000000000000000000000000000000000188f242432a0000000000000000000000008f800cc88bffede0dbaecc76a0c15a2f5701ac1e000000000000000000000000000000000000000000000000000000000000000082100d46b3a1c126cf52f9d66a0e7b1e6df0dfef0000000000004f0000000001000000000000000000000000000000000000000000000000000000000000000100000000000000000000000000000000000000000000000000000000000000a00000000000000000000000000000000000000000000000000000000000000000f242432a0000000000000000000000008f800cc88bffede0dbaecc76a0c15a2f5701ac1e0000000000000000000000000000000000000000000000000000000000000000c0c8d886b92a811e8e41cb6ab5144e44dbbfbfa30000000000028b0000000001000000000000000000000000000000000000000000000000000000000000000100000000000000000000000000000000000000000000000000000000000000a00000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000",
                    "replacement_pattern": "0x0000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000ffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffff0000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000ffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffff0000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000",
                    "static_target": "0x0000000000000000000000000000000000000000",
                    "static_extradata": "0x",
                    "payment_token": "0x0000000000000000000000000000000000000000",
                    "payment_token_contract": {
                        "id": 1,
                        "symbol": "ETH",
                        "address": "0x0000000000000000000000000000000000000000",
                        "image_url": "https://storage.opensea.io/files/6f8e2979d428180222796ff4a33ab929.svg",
                        "name": "Ether",
                        "decimals": 18,
                        "eth_price": "1.000000000000000",
                        "usd_price": "2625.730000000000018000"
                    },
                    "base_price": "675000000000000000",
                    "extra": "0",
                    "quantity": "1",
                    "salt": "50830296633194629905420963267650084060684263303423010320551904522367360582477",
                    "v": 28,
                    "r": "0x7b5cac21911fd0d7156c3ac95fee6b6f263ce44b7397337bb89a1287ac42ccf6",
                    "s": "0x0f5933aae509e060a39896e3f62c8ede36681b2baba9d9f437cbba3356783814",
                    "approved_on_chain": false,
                    "cancelled": false,
                    "finalized": false,
                    "marked_invalid": false,
                    "prefixed_hash": "0xeb54a5cbabfb48b6e494c090aa8eb0a06527913567d0bcb66dd36c6c4e9758ab"
                }
            ]
        },
        {
            "maker": {
                "user": {
                    "username": "ThomasDP"
                },
                "profile_img_url": "https://storage.googleapis.com/opensea-static/opensea-profile/4.png",
                "address": "0x23b10b746895924eb182d55e56521be16fb1cc10",
                "config": "",
                "discord_id": ""
            },
            "slug": "dragons-d2Z",
            "assets": [
                {
                    "id": 25532779,
                    "token_id": "1000768501",
                    "num_sales": 0,
                    "background_color": "FFFFFF",
                    "image_url": "https://lh3.googleusercontent.com/YbmMQMsV-miIYBKGxOnNCNyltvXgn_qcxqbY0pz6oBiqhotp-5bTZiknm3vnBHs1YE832UGmpHoyFLZZFJgKOAyWKjLAVWcS5fnoog",
                    "image_preview_url": "https://lh3.googleusercontent.com/YbmMQMsV-miIYBKGxOnNCNyltvXgn_qcxqbY0pz6oBiqhotp-5bTZiknm3vnBHs1YE832UGmpHoyFLZZFJgKOAyWKjLAVWcS5fnoog=s250",
                    "image_thumbnail_url": "https://lh3.googleusercontent.com/YbmMQMsV-miIYBKGxOnNCNyltvXgn_qcxqbY0pz6oBiqhotp-5bTZiknm3vnBHs1YE832UGmpHoyFLZZFJgKOAyWKjLAVWcS5fnoog=s128",
                    "image_original_url": "https://assets.polkamon.com/images/Unimons_T11C03H10B01G00.jpg",
                    "animation_url": "https://storage.opensea.io/files/f2d113cada1f3169a1623912768c69bd.mp4",
                    "animation_original_url": "https://assets.polkamon.com/videos/Unimons_T11C03H10B01G00.mp4",
                    "name": "Unidragon",
                    "description": "Adorning both glimmer and self-confidence, the Unidragon is stalwart and courageous. None stands above such a character except for the Bitcoin Unidragon.",
                    "external_link": "https://polkamon.com/polkamon/T11C03H10B01G00",
                    "asset_contract": {
                        "address": "0x85f0e02cb992aa1f9f47112f815f519ef1a59e2d",
                        "asset_contract_type": "non-fungible",
                        "created_date": "2021-03-29T13:50:15.075765",
                        "name": "PolkamonOfficialCollection",
                        "nft_version": "3.0",
                        "opensea_version": null,
                        "owner": null,
                        "schema_name": "ERC721",
                        "symbol": "PMONC",
                        "total_supply": "0",
                        "description": "Polkamon are beautifully animated digital collectibles with varying scarcities. Each Polkamon is backed by a truly unique NFT and can be unpacked with $PMON tokens.",
                        "external_link": "https://polkamon.com",
                        "image_url": "https://lh3.googleusercontent.com/5ciPSamybZfmS8m45I1hXlUWKOIfAVLApQswnUaJvKHyHFbvPYEpSCkGqhH0TGn54QZCyKh-kzT2sxXIoe4e0aWcHYagwCO3cc_4=s120",
                        "default_to_fiat": false,
                        "dev_buyer_fee_basis_points": 0,
                        "dev_seller_fee_basis_points": 0,
                        "only_proxied_transfers": false,
                        "opensea_buyer_fee_basis_points": 0,
                        "opensea_seller_fee_basis_points": 250,
                        "buyer_fee_basis_points": 0,
                        "seller_fee_basis_points": 250,
                        "payout_address": null
                    },
                    "owner": {
                        "user": {
                            "username": "ThomasDP"
                        },
                        "profile_img_url": "https://storage.googleapis.com/opensea-static/opensea-profile/4.png",
                        "address": "0x23b10b746895924eb182d55e56521be16fb1cc10",
                        "config": "",
                        "discord_id": ""
                    },
                    "permalink": "https://opensea.io/assets/0x85f0e02cb992aa1f9f47112f815f519ef1a59e2d/1000768501",
                    "collection": {
                        "banner_image_url": "https://lh3.googleusercontent.com/NvdDSV8QKiIu1XiJTXmHqK0v2_Xd0zXs4n1j9McmDDobCIByulyBFelOyzs4D5T-rwXS-fFMxqNuK7SPIE1t4dIFMnzNAv4PycXj4jk=s2500",
                        "chat_url": null,
                        "created_date": "2021-03-29T17:40:16.454131",
                        "default_to_fiat": false,
                        "description": "Polkamon are beautifully animated digital collectibles with varying scarcities. Each Polkamon is backed by a truly unique NFT and can be unpacked with $PMON tokens.",
                        "dev_buyer_fee_basis_points": "0",
                        "dev_seller_fee_basis_points": "0",
                        "discord_url": null,
                        "display_data": {
                            "card_display_style": "contain"
                        },
                        "external_url": "https://polkamon.com",
                        "featured": false,
                        "featured_image_url": "https://lh3.googleusercontent.com/AagBX9ojONiTuhszoTxVg-eJid-m8wQDaqnWH3XW56icaHnjTvjSFjdntrP2ntJXSJEEHBQavKfuSQh8OB-GO8vanFeNzO2NczF0qdQ=s300",
                        "hidden": false,
                        "safelist_request_status": "verified",
                        "image_url": "https://lh3.googleusercontent.com/5ciPSamybZfmS8m45I1hXlUWKOIfAVLApQswnUaJvKHyHFbvPYEpSCkGqhH0TGn54QZCyKh-kzT2sxXIoe4e0aWcHYagwCO3cc_4=s120",
                        "is_subject_to_whitelist": false,
                        "large_image_url": "https://lh3.googleusercontent.com/AagBX9ojONiTuhszoTxVg-eJid-m8wQDaqnWH3XW56icaHnjTvjSFjdntrP2ntJXSJEEHBQavKfuSQh8OB-GO8vanFeNzO2NczF0qdQ=s300",
                        "medium_username": "polkamon",
                        "name": "Polkamon",
                        "only_proxied_transfers": false,
                        "opensea_buyer_fee_basis_points": "0",
                        "opensea_seller_fee_basis_points": "250",
                        "payout_address": null,
                        "require_email": false,
                        "short_description": null,
                        "slug": "polkamon",
                        "telegram_url": "https://t.me/polkamonorg",
                        "twitter_username": "Polkamonorg",
                        "instagram_username": null,
                        "wiki_url": null
                    },
                    "decimals": 0,
                    "token_metadata": "https://meta.polkamon.com/meta?id=1000768501"
                },
                {
                    "id": 25534607,
                    "token_id": "1000769026",
                    "num_sales": 0,
                    "background_color": "FFFFFF",
                    "image_url": "https://lh3.googleusercontent.com/L0ChvI4fG5HU_iU6vmgsZjter_OtUciMMqVy2taPUCp9Hf40r19xm5VcjRoc2n_o_jtKAfj_aEGD9aqZCGQQXiKzuV_5Ib8IPMJb",
                    "image_preview_url": "https://lh3.googleusercontent.com/L0ChvI4fG5HU_iU6vmgsZjter_OtUciMMqVy2taPUCp9Hf40r19xm5VcjRoc2n_o_jtKAfj_aEGD9aqZCGQQXiKzuV_5Ib8IPMJb=s250",
                    "image_thumbnail_url": "https://lh3.googleusercontent.com/L0ChvI4fG5HU_iU6vmgsZjter_OtUciMMqVy2taPUCp9Hf40r19xm5VcjRoc2n_o_jtKAfj_aEGD9aqZCGQQXiKzuV_5Ib8IPMJb=s128",
                    "image_original_url": "https://assets.polkamon.com/images/Unimons_T11C05H08B01G00.jpg",
                    "animation_url": "https://storage.opensea.io/files/9b90fd3bb0d56631645a9b7a7c274ad2.mp4",
                    "animation_original_url": "https://assets.polkamon.com/videos/Unimons_T11C05H08B01G00.mp4",
                    "name": "Unidragon",
                    "description": "Adorning both glimmer and self-confidence, the Unidragon is stalwart and courageous. None stands above such a character except for the Bitcoin Unidragon.",
                    "external_link": "https://polkamon.com/polkamon/T11C05H08B01G00",
                    "asset_contract": {
                        "address": "0x85f0e02cb992aa1f9f47112f815f519ef1a59e2d",
                        "asset_contract_type": "non-fungible",
                        "created_date": "2021-03-29T13:50:15.075765",
                        "name": "PolkamonOfficialCollection",
                        "nft_version": "3.0",
                        "opensea_version": null,
                        "owner": null,
                        "schema_name": "ERC721",
                        "symbol": "PMONC",
                        "total_supply": "0",
                        "description": "Polkamon are beautifully animated digital collectibles with varying scarcities. Each Polkamon is backed by a truly unique NFT and can be unpacked with $PMON tokens.",
                        "external_link": "https://polkamon.com",
                        "image_url": "https://lh3.googleusercontent.com/5ciPSamybZfmS8m45I1hXlUWKOIfAVLApQswnUaJvKHyHFbvPYEpSCkGqhH0TGn54QZCyKh-kzT2sxXIoe4e0aWcHYagwCO3cc_4=s120",
                        "default_to_fiat": false,
                        "dev_buyer_fee_basis_points": 0,
                        "dev_seller_fee_basis_points": 0,
                        "only_proxied_transfers": false,
                        "opensea_buyer_fee_basis_points": 0,
                        "opensea_seller_fee_basis_points": 250,
                        "buyer_fee_basis_points": 0,
                        "seller_fee_basis_points": 250,
                        "payout_address": null
                    },
                    "owner": {
                        "user": {
                            "username": "ThomasDP"
                        },
                        "profile_img_url": "https://storage.googleapis.com/opensea-static/opensea-profile/4.png",
                        "address": "0x23b10b746895924eb182d55e56521be16fb1cc10",
                        "config": "",
                        "discord_id": ""
                    },
                    "permalink": "https://opensea.io/assets/0x85f0e02cb992aa1f9f47112f815f519ef1a59e2d/1000769026",
                    "collection": {
                        "banner_image_url": "https://lh3.googleusercontent.com/NvdDSV8QKiIu1XiJTXmHqK0v2_Xd0zXs4n1j9McmDDobCIByulyBFelOyzs4D5T-rwXS-fFMxqNuK7SPIE1t4dIFMnzNAv4PycXj4jk=s2500",
                        "chat_url": null,
                        "created_date": "2021-03-29T17:40:16.454131",
                        "default_to_fiat": false,
                        "description": "Polkamon are beautifully animated digital collectibles with varying scarcities. Each Polkamon is backed by a truly unique NFT and can be unpacked with $PMON tokens.",
                        "dev_buyer_fee_basis_points": "0",
                        "dev_seller_fee_basis_points": "0",
                        "discord_url": null,
                        "display_data": {
                            "card_display_style": "contain"
                        },
                        "external_url": "https://polkamon.com",
                        "featured": false,
                        "featured_image_url": "https://lh3.googleusercontent.com/AagBX9ojONiTuhszoTxVg-eJid-m8wQDaqnWH3XW56icaHnjTvjSFjdntrP2ntJXSJEEHBQavKfuSQh8OB-GO8vanFeNzO2NczF0qdQ=s300",
                        "hidden": false,
                        "safelist_request_status": "verified",
                        "image_url": "https://lh3.googleusercontent.com/5ciPSamybZfmS8m45I1hXlUWKOIfAVLApQswnUaJvKHyHFbvPYEpSCkGqhH0TGn54QZCyKh-kzT2sxXIoe4e0aWcHYagwCO3cc_4=s120",
                        "is_subject_to_whitelist": false,
                        "large_image_url": "https://lh3.googleusercontent.com/AagBX9ojONiTuhszoTxVg-eJid-m8wQDaqnWH3XW56icaHnjTvjSFjdntrP2ntJXSJEEHBQavKfuSQh8OB-GO8vanFeNzO2NczF0qdQ=s300",
                        "medium_username": "polkamon",
                        "name": "Polkamon",
                        "only_proxied_transfers": false,
                        "opensea_buyer_fee_basis_points": "0",
                        "opensea_seller_fee_basis_points": "250",
                        "payout_address": null,
                        "require_email": false,
                        "short_description": null,
                        "slug": "polkamon",
                        "telegram_url": "https://t.me/polkamonorg",
                        "twitter_username": "Polkamonorg",
                        "instagram_username": null,
                        "wiki_url": null
                    },
                    "decimals": 0,
                    "token_metadata": "https://meta.polkamon.com/meta?id=1000769026"
                },
                {
                    "id": 25535506,
                    "token_id": "1000769308",
                    "num_sales": 0,
                    "background_color": "FFFFFF",
                    "image_url": "https://lh3.googleusercontent.com/rSdh6AIcQe9lX3_75yh9Liw26CsOudtpNlAdmu4MJ0Y68Op3BXkP7vBYXkcZ3RiNkFP8OIj8LZjggFHzOxPrMZRug7iJQWTJU8WIsYw",
                    "image_preview_url": "https://lh3.googleusercontent.com/rSdh6AIcQe9lX3_75yh9Liw26CsOudtpNlAdmu4MJ0Y68Op3BXkP7vBYXkcZ3RiNkFP8OIj8LZjggFHzOxPrMZRug7iJQWTJU8WIsYw=s250",
                    "image_thumbnail_url": "https://lh3.googleusercontent.com/rSdh6AIcQe9lX3_75yh9Liw26CsOudtpNlAdmu4MJ0Y68Op3BXkP7vBYXkcZ3RiNkFP8OIj8LZjggFHzOxPrMZRug7iJQWTJU8WIsYw=s128",
                    "image_original_url": "https://assets.polkamon.com/images/Unimons_T11C02H10B01G00.jpg",
                    "animation_url": "https://storage.opensea.io/files/55a5041e50fd4f633c986317556f25ad.mp4",
                    "animation_original_url": "https://assets.polkamon.com/videos/Unimons_T11C02H10B01G00.mp4",
                    "name": "Unidragon",
                    "description": "Adorning both glimmer and self-confidence, the Unidragon is stalwart and courageous. None stands above such a character except for the Bitcoin Unidragon.",
                    "external_link": "https://polkamon.com/polkamon/T11C02H10B01G00",
                    "asset_contract": {
                        "address": "0x85f0e02cb992aa1f9f47112f815f519ef1a59e2d",
                        "asset_contract_type": "non-fungible",
                        "created_date": "2021-03-29T13:50:15.075765",
                        "name": "PolkamonOfficialCollection",
                        "nft_version": "3.0",
                        "opensea_version": null,
                        "owner": null,
                        "schema_name": "ERC721",
                        "symbol": "PMONC",
                        "total_supply": "0",
                        "description": "Polkamon are beautifully animated digital collectibles with varying scarcities. Each Polkamon is backed by a truly unique NFT and can be unpacked with $PMON tokens.",
                        "external_link": "https://polkamon.com",
                        "image_url": "https://lh3.googleusercontent.com/5ciPSamybZfmS8m45I1hXlUWKOIfAVLApQswnUaJvKHyHFbvPYEpSCkGqhH0TGn54QZCyKh-kzT2sxXIoe4e0aWcHYagwCO3cc_4=s120",
                        "default_to_fiat": false,
                        "dev_buyer_fee_basis_points": 0,
                        "dev_seller_fee_basis_points": 0,
                        "only_proxied_transfers": false,
                        "opensea_buyer_fee_basis_points": 0,
                        "opensea_seller_fee_basis_points": 250,
                        "buyer_fee_basis_points": 0,
                        "seller_fee_basis_points": 250,
                        "payout_address": null
                    },
                    "owner": {
                        "user": {
                            "username": "ThomasDP"
                        },
                        "profile_img_url": "https://storage.googleapis.com/opensea-static/opensea-profile/4.png",
                        "address": "0x23b10b746895924eb182d55e56521be16fb1cc10",
                        "config": "",
                        "discord_id": ""
                    },
                    "permalink": "https://opensea.io/assets/0x85f0e02cb992aa1f9f47112f815f519ef1a59e2d/1000769308",
                    "collection": {
                        "banner_image_url": "https://lh3.googleusercontent.com/NvdDSV8QKiIu1XiJTXmHqK0v2_Xd0zXs4n1j9McmDDobCIByulyBFelOyzs4D5T-rwXS-fFMxqNuK7SPIE1t4dIFMnzNAv4PycXj4jk=s2500",
                        "chat_url": null,
                        "created_date": "2021-03-29T17:40:16.454131",
                        "default_to_fiat": false,
                        "description": "Polkamon are beautifully animated digital collectibles with varying scarcities. Each Polkamon is backed by a truly unique NFT and can be unpacked with $PMON tokens.",
                        "dev_buyer_fee_basis_points": "0",
                        "dev_seller_fee_basis_points": "0",
                        "discord_url": null,
                        "display_data": {
                            "card_display_style": "contain"
                        },
                        "external_url": "https://polkamon.com",
                        "featured": false,
                        "featured_image_url": "https://lh3.googleusercontent.com/AagBX9ojONiTuhszoTxVg-eJid-m8wQDaqnWH3XW56icaHnjTvjSFjdntrP2ntJXSJEEHBQavKfuSQh8OB-GO8vanFeNzO2NczF0qdQ=s300",
                        "hidden": false,
                        "safelist_request_status": "verified",
                        "image_url": "https://lh3.googleusercontent.com/5ciPSamybZfmS8m45I1hXlUWKOIfAVLApQswnUaJvKHyHFbvPYEpSCkGqhH0TGn54QZCyKh-kzT2sxXIoe4e0aWcHYagwCO3cc_4=s120",
                        "is_subject_to_whitelist": false,
                        "large_image_url": "https://lh3.googleusercontent.com/AagBX9ojONiTuhszoTxVg-eJid-m8wQDaqnWH3XW56icaHnjTvjSFjdntrP2ntJXSJEEHBQavKfuSQh8OB-GO8vanFeNzO2NczF0qdQ=s300",
                        "medium_username": "polkamon",
                        "name": "Polkamon",
                        "only_proxied_transfers": false,
                        "opensea_buyer_fee_basis_points": "0",
                        "opensea_seller_fee_basis_points": "250",
                        "payout_address": null,
                        "require_email": false,
                        "short_description": null,
                        "slug": "polkamon",
                        "telegram_url": "https://t.me/polkamonorg",
                        "twitter_username": "Polkamonorg",
                        "instagram_username": null,
                        "wiki_url": null
                    },
                    "decimals": 0,
                    "token_metadata": "https://meta.polkamon.com/meta?id=1000769308"
                },
                {
                    "id": 25590882,
                    "token_id": "1000773174",
                    "num_sales": 0,
                    "background_color": "FFFFFF",
                    "image_url": "https://lh3.googleusercontent.com/9a5SSsaNXLoKtv2lD8CSn4JiPydKkm_xVz8eHGl3MVqQ-qunLX8GBp-Z130LO9I7Oo5_RvTeU2h7MxuC0EXsB2WLTh1biCnOGw61GQ",
                    "image_preview_url": "https://lh3.googleusercontent.com/9a5SSsaNXLoKtv2lD8CSn4JiPydKkm_xVz8eHGl3MVqQ-qunLX8GBp-Z130LO9I7Oo5_RvTeU2h7MxuC0EXsB2WLTh1biCnOGw61GQ=s250",
                    "image_thumbnail_url": "https://lh3.googleusercontent.com/9a5SSsaNXLoKtv2lD8CSn4JiPydKkm_xVz8eHGl3MVqQ-qunLX8GBp-Z130LO9I7Oo5_RvTeU2h7MxuC0EXsB2WLTh1biCnOGw61GQ=s128",
                    "image_original_url": "https://assets.polkamon.com/images/Unimons_T11C04H06B01G00.jpg",
                    "animation_url": "https://storage.opensea.io/files/e23d24b307acf2e89f4ada6385a2b263.mp4",
                    "animation_original_url": "https://assets.polkamon.com/videos/Unimons_T11C04H06B01G00.mp4",
                    "name": "Unidragon",
                    "description": "Adorning both glimmer and self-confidence, the Unidragon is stalwart and courageous. None stands above such a character except for the Bitcoin Unidragon.",
                    "external_link": "https://polkamon.com/polkamon/T11C04H06B01G00",
                    "asset_contract": {
                        "address": "0x85f0e02cb992aa1f9f47112f815f519ef1a59e2d",
                        "asset_contract_type": "non-fungible",
                        "created_date": "2021-03-29T13:50:15.075765",
                        "name": "PolkamonOfficialCollection",
                        "nft_version": "3.0",
                        "opensea_version": null,
                        "owner": null,
                        "schema_name": "ERC721",
                        "symbol": "PMONC",
                        "total_supply": "0",
                        "description": "Polkamon are beautifully animated digital collectibles with varying scarcities. Each Polkamon is backed by a truly unique NFT and can be unpacked with $PMON tokens.",
                        "external_link": "https://polkamon.com",
                        "image_url": "https://lh3.googleusercontent.com/5ciPSamybZfmS8m45I1hXlUWKOIfAVLApQswnUaJvKHyHFbvPYEpSCkGqhH0TGn54QZCyKh-kzT2sxXIoe4e0aWcHYagwCO3cc_4=s120",
                        "default_to_fiat": false,
                        "dev_buyer_fee_basis_points": 0,
                        "dev_seller_fee_basis_points": 0,
                        "only_proxied_transfers": false,
                        "opensea_buyer_fee_basis_points": 0,
                        "opensea_seller_fee_basis_points": 250,
                        "buyer_fee_basis_points": 0,
                        "seller_fee_basis_points": 250,
                        "payout_address": null
                    },
                    "owner": {
                        "user": {
                            "username": "ThomasDP"
                        },
                        "profile_img_url": "https://storage.googleapis.com/opensea-static/opensea-profile/4.png",
                        "address": "0x23b10b746895924eb182d55e56521be16fb1cc10",
                        "config": "",
                        "discord_id": ""
                    },
                    "permalink": "https://opensea.io/assets/0x85f0e02cb992aa1f9f47112f815f519ef1a59e2d/1000773174",
                    "collection": {
                        "banner_image_url": "https://lh3.googleusercontent.com/NvdDSV8QKiIu1XiJTXmHqK0v2_Xd0zXs4n1j9McmDDobCIByulyBFelOyzs4D5T-rwXS-fFMxqNuK7SPIE1t4dIFMnzNAv4PycXj4jk=s2500",
                        "chat_url": null,
                        "created_date": "2021-03-29T17:40:16.454131",
                        "default_to_fiat": false,
                        "description": "Polkamon are beautifully animated digital collectibles with varying scarcities. Each Polkamon is backed by a truly unique NFT and can be unpacked with $PMON tokens.",
                        "dev_buyer_fee_basis_points": "0",
                        "dev_seller_fee_basis_points": "0",
                        "discord_url": null,
                        "display_data": {
                            "card_display_style": "contain"
                        },
                        "external_url": "https://polkamon.com",
                        "featured": false,
                        "featured_image_url": "https://lh3.googleusercontent.com/AagBX9ojONiTuhszoTxVg-eJid-m8wQDaqnWH3XW56icaHnjTvjSFjdntrP2ntJXSJEEHBQavKfuSQh8OB-GO8vanFeNzO2NczF0qdQ=s300",
                        "hidden": false,
                        "safelist_request_status": "verified",
                        "image_url": "https://lh3.googleusercontent.com/5ciPSamybZfmS8m45I1hXlUWKOIfAVLApQswnUaJvKHyHFbvPYEpSCkGqhH0TGn54QZCyKh-kzT2sxXIoe4e0aWcHYagwCO3cc_4=s120",
                        "is_subject_to_whitelist": false,
                        "large_image_url": "https://lh3.googleusercontent.com/AagBX9ojONiTuhszoTxVg-eJid-m8wQDaqnWH3XW56icaHnjTvjSFjdntrP2ntJXSJEEHBQavKfuSQh8OB-GO8vanFeNzO2NczF0qdQ=s300",
                        "medium_username": "polkamon",
                        "name": "Polkamon",
                        "only_proxied_transfers": false,
                        "opensea_buyer_fee_basis_points": "0",
                        "opensea_seller_fee_basis_points": "250",
                        "payout_address": null,
                        "require_email": false,
                        "short_description": null,
                        "slug": "polkamon",
                        "telegram_url": "https://t.me/polkamonorg",
                        "twitter_username": "Polkamonorg",
                        "instagram_username": null,
                        "wiki_url": null
                    },
                    "decimals": 0,
                    "token_metadata": "https://meta.polkamon.com/meta?id=1000773174"
                }
            ],
            "name": "Dragons",
            "description": "",
            "external_link": "",
            "asset_contract": {
                "collection": {
                    "banner_image_url": "https://lh3.googleusercontent.com/NvdDSV8QKiIu1XiJTXmHqK0v2_Xd0zXs4n1j9McmDDobCIByulyBFelOyzs4D5T-rwXS-fFMxqNuK7SPIE1t4dIFMnzNAv4PycXj4jk=s2500",
                    "chat_url": null,
                    "created_date": "2021-03-29T17:40:16.454131",
                    "default_to_fiat": false,
                    "description": "Polkamon are beautifully animated digital collectibles with varying scarcities. Each Polkamon is backed by a truly unique NFT and can be unpacked with $PMON tokens.",
                    "dev_buyer_fee_basis_points": "0",
                    "dev_seller_fee_basis_points": "0",
                    "discord_url": null,
                    "display_data": {
                        "card_display_style": "contain"
                    },
                    "external_url": "https://polkamon.com",
                    "featured": false,
                    "featured_image_url": "https://lh3.googleusercontent.com/AagBX9ojONiTuhszoTxVg-eJid-m8wQDaqnWH3XW56icaHnjTvjSFjdntrP2ntJXSJEEHBQavKfuSQh8OB-GO8vanFeNzO2NczF0qdQ=s300",
                    "hidden": false,
                    "safelist_request_status": "verified",
                    "image_url": "https://lh3.googleusercontent.com/5ciPSamybZfmS8m45I1hXlUWKOIfAVLApQswnUaJvKHyHFbvPYEpSCkGqhH0TGn54QZCyKh-kzT2sxXIoe4e0aWcHYagwCO3cc_4=s120",
                    "is_subject_to_whitelist": false,
                    "large_image_url": "https://lh3.googleusercontent.com/AagBX9ojONiTuhszoTxVg-eJid-m8wQDaqnWH3XW56icaHnjTvjSFjdntrP2ntJXSJEEHBQavKfuSQh8OB-GO8vanFeNzO2NczF0qdQ=s300",
                    "medium_username": "polkamon",
                    "name": "Polkamon",
                    "only_proxied_transfers": false,
                    "opensea_buyer_fee_basis_points": "0",
                    "opensea_seller_fee_basis_points": "250",
                    "payout_address": null,
                    "require_email": false,
                    "short_description": null,
                    "slug": "polkamon",
                    "telegram_url": "https://t.me/polkamonorg",
                    "twitter_username": "Polkamonorg",
                    "instagram_username": null,
                    "wiki_url": null
                },
                "address": "0x85f0e02cb992aa1f9f47112f815f519ef1a59e2d",
                "asset_contract_type": "non-fungible",
                "created_date": "2021-03-29T13:50:15.075765",
                "name": "PolkamonOfficialCollection",
                "nft_version": "3.0",
                "opensea_version": null,
                "owner": null,
                "schema_name": "ERC721",
                "symbol": "PMONC",
                "total_supply": "0",
                "description": "Polkamon are beautifully animated digital collectibles with varying scarcities. Each Polkamon is backed by a truly unique NFT and can be unpacked with $PMON tokens.",
                "external_link": "https://polkamon.com",
                "image_url": "https://lh3.googleusercontent.com/5ciPSamybZfmS8m45I1hXlUWKOIfAVLApQswnUaJvKHyHFbvPYEpSCkGqhH0TGn54QZCyKh-kzT2sxXIoe4e0aWcHYagwCO3cc_4=s120",
                "default_to_fiat": false,
                "dev_buyer_fee_basis_points": 0,
                "dev_seller_fee_basis_points": 0,
                "only_proxied_transfers": false,
                "opensea_buyer_fee_basis_points": 0,
                "opensea_seller_fee_basis_points": 250,
                "buyer_fee_basis_points": 0,
                "seller_fee_basis_points": 250,
                "payout_address": null
            },
            "permalink": "https://opensea.io/bundles/dragons-d2Z",
            "sell_orders": [
                {
                    "created_date": "2021-05-25T20:51:39.299297",
                    "closing_date": null,
                    "closing_extendable": false,
                    "expiration_time": 0,
                    "listing_time": 1621975788,
                    "order_hash": "0xdad36b07f97e154784ccaac4bb807822c948c0b8968fb39e316189a6f95956bd",
                    "metadata": {
                        "bundle": {
                            "assets": [
                                {
                                    "id": "1000768501",
                                    "address": "0x85f0e02cb992aa1f9f47112f815f519ef1a59e2d"
                                },
                                {
                                    "id": "1000769026",
                                    "address": "0x85f0e02cb992aa1f9f47112f815f519ef1a59e2d"
                                },
                                {
                                    "id": "1000769308",
                                    "address": "0x85f0e02cb992aa1f9f47112f815f519ef1a59e2d"
                                },
                                {
                                    "id": "1000773174",
                                    "address": "0x85f0e02cb992aa1f9f47112f815f519ef1a59e2d"
                                }
                            ],
                            "schemas": [
                                "ERC721",
                                "ERC721",
                                "ERC721",
                                "ERC721"
                            ],
                            "name": "Dragons",
                            "description": "",
                            "external_link": ""
                        }
                    },
                    "exchange": "0x7be8076f4ea4a4ad08075c2508e481d6c946d12b",
                    "maker": {
                        "user": 837444,
                        "profile_img_url": "https://storage.googleapis.com/opensea-static/opensea-profile/4.png",
                        "address": "0x23b10b746895924eb182d55e56521be16fb1cc10",
                        "config": "",
                        "discord_id": ""
                    },
                    "taker": {
                        "user": 1766,
                        "profile_img_url": "https://storage.googleapis.com/opensea-static/opensea-profile/1.png",
                        "address": "0x0000000000000000000000000000000000000000",
                        "config": "",
                        "discord_id": ""
                    },
                    "current_price": "1000000000000000000",
                    "current_bounty": "10000000000000000",
                    "bounty_multiple": "0.01",
                    "maker_relayer_fee": "250",
                    "taker_relayer_fee": "0",
                    "maker_protocol_fee": "0",
                    "taker_protocol_fee": "0",
                    "maker_referrer_fee": "0",
                    "fee_recipient": {
                        "user": 3585,
                        "profile_img_url": "https://storage.googleapis.com/opensea-static/opensea-profile/28.png",
                        "address": "0x5b3256965e7c3cf26e11fcaf296dfc8807c01073",
                        "config": "verified",
                        "discord_id": ""
                    },
                    "fee_method": 1,
                    "side": 1,
                    "sale_kind": 0,
                    "target": "0xc99f70bfd82fb7c8f8191fdfbfb735606b15e5c5",
                    "how_to_call": 1,
                    "calldata": "0x68f0bcaa0000000000000000000000000000000000000000000000000000000000000080000000000000000000000000000000000000000000000000000000000000012000000000000000000000000000000000000000000000000000000000000001c00000000000000000000000000000000000000000000000000000000000000260000000000000000000000000000000000000000000000000000000000000000400000000000000000000000085f0e02cb992aa1f9f47112f815f519ef1a59e2d00000000000000000000000085f0e02cb992aa1f9f47112f815f519ef1a59e2d00000000000000000000000085f0e02cb992aa1f9f47112f815f519ef1a59e2d00000000000000000000000085f0e02cb992aa1f9f47112f815f519ef1a59e2d0000000000000000000000000000000000000000000000000000000000000004000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000040000000000000000000000000000000000000000000000000000000000000064000000000000000000000000000000000000000000000000000000000000006400000000000000000000000000000000000000000000000000000000000000640000000000000000000000000000000000000000000000000000000000000064000000000000000000000000000000000000000000000000000000000000019023b872dd00000000000000000000000023b10b746895924eb182d55e56521be16fb1cc100000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000003ba683f523b872dd00000000000000000000000023b10b746895924eb182d55e56521be16fb1cc100000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000003ba6860223b872dd00000000000000000000000023b10b746895924eb182d55e56521be16fb1cc100000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000003ba6871c23b872dd00000000000000000000000023b10b746895924eb182d55e56521be16fb1cc100000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000003ba6963600000000000000000000000000000000",
                    "replacement_pattern": "0x0000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000ffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffff0000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000ffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffff0000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000ffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffff0000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000ffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffff000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000",
                    "static_target": "0x0000000000000000000000000000000000000000",
                    "static_extradata": "0x",
                    "payment_token": "0x0000000000000000000000000000000000000000",
                    "payment_token_contract": {
                        "id": 1,
                        "symbol": "ETH",
                        "address": "0x0000000000000000000000000000000000000000",
                        "image_url": "https://storage.opensea.io/files/6f8e2979d428180222796ff4a33ab929.svg",
                        "name": "Ether",
                        "decimals": 18,
                        "eth_price": "1.000000000000000",
                        "usd_price": "2625.730000000000018000"
                    },
                    "base_price": "1000000000000000000",
                    "extra": "0",
                    "quantity": "1",
                    "salt": "95803775778408835413263544364921431593307868675519238412663406554866865052129",
                    "v": 27,
                    "r": "0x29e99db629a79ab1a115488283d65fd810a075eda2e62cd82a7761cb08113efe",
                    "s": "0x74863a7684327084f2ff7b111e614c3783fe319fb81dfd309ad8a5c8d48973dd",
                    "approved_on_chain": false,
                    "cancelled": false,
                    "finalized": false,
                    "marked_invalid": false,
                    "prefixed_hash": "0x1175131d9eed1407f4e8947e5548f5ce26708ddd1f3d564f897dff0ff046c21e"
                }
            ]
        },
        {
            "maker": {
                "user": {
                    "username": "RealKush_Cabin"
                },
                "profile_img_url": "https://storage.googleapis.com/opensea-static/opensea-profile/2.png",
                "address": "0x8f800cc88bffede0dbaecc76a0c15a2f5701ac1e",
                "config": "",
                "discord_id": ""
            },
            "slug": "bastard-ghost-32-83-bundle-uiL",
            "assets": [
                {
                    "id": 20747314,
                    "token_id": "50717425042824338886285061199929582610378645077537395401447485537375582420993",
                    "num_sales": 1,
                    "background_color": null,
                    "image_url": "https://lh3.googleusercontent.com/HTZFqzsYDyEapnNmbxlhqZ0EuXs4yAGSYnYHIDElO1tUZ25zC9xVuQMoEfG6Q8qlqN_w2q_3KRy_BaxCrO7He1BXyi4Oo4Adfgq3",
                    "image_preview_url": "https://lh3.googleusercontent.com/HTZFqzsYDyEapnNmbxlhqZ0EuXs4yAGSYnYHIDElO1tUZ25zC9xVuQMoEfG6Q8qlqN_w2q_3KRy_BaxCrO7He1BXyi4Oo4Adfgq3=s250",
                    "image_thumbnail_url": "https://lh3.googleusercontent.com/HTZFqzsYDyEapnNmbxlhqZ0EuXs4yAGSYnYHIDElO1tUZ25zC9xVuQMoEfG6Q8qlqN_w2q_3KRy_BaxCrO7He1BXyi4Oo4Adfgq3=s128",
                    "image_original_url": null,
                    "animation_url": null,
                    "animation_original_url": null,
                    "name": "#BG #032 (Static in the Blockchain 2/7)",
                    "description": null,
                    "external_link": null,
                    "asset_contract": {
                        "address": "0x495f947276749ce646f68ac8c248420045cb7b5e",
                        "asset_contract_type": "semi-fungible",
                        "created_date": "2020-12-02T17:40:53.232025",
                        "name": "OpenSea Collection",
                        "nft_version": null,
                        "opensea_version": "2.0.0",
                        "owner": 102384,
                        "schema_name": "ERC1155",
                        "symbol": "OPENSTORE",
                        "total_supply": null,
                        "description": null,
                        "external_link": null,
                        "image_url": null,
                        "default_to_fiat": false,
                        "dev_buyer_fee_basis_points": 0,
                        "dev_seller_fee_basis_points": 0,
                        "only_proxied_transfers": false,
                        "opensea_buyer_fee_basis_points": 0,
                        "opensea_seller_fee_basis_points": 250,
                        "buyer_fee_basis_points": 0,
                        "seller_fee_basis_points": 250,
                        "payout_address": null
                    },
                    "owner": {
                        "user": {
                            "username": "NullAddress"
                        },
                        "profile_img_url": "https://storage.googleapis.com/opensea-static/opensea-profile/1.png",
                        "address": "0x0000000000000000000000000000000000000000",
                        "config": "",
                        "discord_id": ""
                    },
                    "permalink": "https://opensea.io/assets/0x495f947276749ce646f68ac8c248420045cb7b5e/50717425042824338886285061199929582610378645077537395401447485537375582420993",
                    "collection": {
                        "banner_image_url": "https://lh3.googleusercontent.com/ZIWJXKXTHQDDq2PTU6oAkGrx8QS-icNkj8S91ZkamW6Ci5h4FyltlZnAtLNOb2R5Ypg8Ot_M2WHNeCgxM-7FqOw6kS8WfxdGQwBqcQ=s2500",
                        "chat_url": null,
                        "created_date": "2021-03-22T14:25:09.146978",
                        "default_to_fiat": false,
                        "description": "#### 200 BastardGhosts will haunt the blockchain\n\n#### 133/200 BastardGhosts FULLY MINTED\n\n#### 100% custom code generated (JavaScript, see pinned tweet).\n\n#### 001-025 : 'OG' BastardGhosts (256px by 256px)\n\n#### 026-100 : Various Mini Series (256px by 256px)\n\n#### 101 : METALPUNKS collab (256px by 256px)\n\n#### 102-200 : MADNESS (1024px by 1024px)\n\n#### Number 126 Flying solo in Matic \n\n",
                        "dev_buyer_fee_basis_points": "0",
                        "dev_seller_fee_basis_points": "1000",
                        "discord_url": null,
                        "display_data": {
                            "card_display_style": "contain"
                        },
                        "external_url": null,
                        "featured": false,
                        "featured_image_url": "https://lh3.googleusercontent.com/_m7mT7oBoMC4siGMrTctkoi05kmosW0b0cAq_5MrzN5joWoJgkMw9Y9HNxskx55ToUIVS0cuwUtEFl4bv21NcoWynb6uuZmOyf4VFAI=s300",
                        "hidden": true,
                        "safelist_request_status": "not_requested",
                        "image_url": "https://lh3.googleusercontent.com/x-TqZMDLhNoVAvkEhbMxSA4haIVMD13tXPmWopUitTBI89-3iCeDLSKLwmtikDxV53hArTznYdCSEtts--urqE4w2em7zxpWiQms4nY=s120",
                        "is_subject_to_whitelist": false,
                        "large_image_url": "https://lh3.googleusercontent.com/_m7mT7oBoMC4siGMrTctkoi05kmosW0b0cAq_5MrzN5joWoJgkMw9Y9HNxskx55ToUIVS0cuwUtEFl4bv21NcoWynb6uuZmOyf4VFAI=s300",
                        "medium_username": null,
                        "name": "BastardGhosts",
                        "only_proxied_transfers": false,
                        "opensea_buyer_fee_basis_points": "0",
                        "opensea_seller_fee_basis_points": "250",
                        "payout_address": "0x70210b9928a21102900dede6ec65cbeb2992dd50",
                        "require_email": false,
                        "short_description": null,
                        "slug": "bastardghosts",
                        "telegram_url": null,
                        "twitter_username": "BastardGhosts",
                        "instagram_username": null,
                        "wiki_url": null
                    },
                    "decimals": null,
                    "token_metadata": null
                },
                {
                    "id": 21007299,
                    "token_id": "50717425042824338886285061199929582610378645077537395401447485677013559148545",
                    "num_sales": 0,
                    "background_color": null,
                    "image_url": "https://lh3.googleusercontent.com/bUCIcYC_lla9PTV35cq3laA2yTuUaLxx3X7p8YCStVX3ebUafWF9rMkWCvkLp6Eo3bZGcody3HW2lFZ_ZsMKyzYeRgLhgmTZ1IpC",
                    "image_preview_url": "https://lh3.googleusercontent.com/bUCIcYC_lla9PTV35cq3laA2yTuUaLxx3X7p8YCStVX3ebUafWF9rMkWCvkLp6Eo3bZGcody3HW2lFZ_ZsMKyzYeRgLhgmTZ1IpC=s250",
                    "image_thumbnail_url": "https://lh3.googleusercontent.com/bUCIcYC_lla9PTV35cq3laA2yTuUaLxx3X7p8YCStVX3ebUafWF9rMkWCvkLp6Eo3bZGcody3HW2lFZ_ZsMKyzYeRgLhgmTZ1IpC=s128",
                    "image_original_url": null,
                    "animation_url": null,
                    "animation_original_url": null,
                    "name": "#BG #083 (Overexposure 4/6)",
                    "description": null,
                    "external_link": null,
                    "asset_contract": {
                        "address": "0x495f947276749ce646f68ac8c248420045cb7b5e",
                        "asset_contract_type": "semi-fungible",
                        "created_date": "2020-12-02T17:40:53.232025",
                        "name": "OpenSea Collection",
                        "nft_version": null,
                        "opensea_version": "2.0.0",
                        "owner": 102384,
                        "schema_name": "ERC1155",
                        "symbol": "OPENSTORE",
                        "total_supply": null,
                        "description": null,
                        "external_link": null,
                        "image_url": null,
                        "default_to_fiat": false,
                        "dev_buyer_fee_basis_points": 0,
                        "dev_seller_fee_basis_points": 0,
                        "only_proxied_transfers": false,
                        "opensea_buyer_fee_basis_points": 0,
                        "opensea_seller_fee_basis_points": 250,
                        "buyer_fee_basis_points": 0,
                        "seller_fee_basis_points": 250,
                        "payout_address": null
                    },
                    "owner": {
                        "user": {
                            "username": "NullAddress"
                        },
                        "profile_img_url": "https://storage.googleapis.com/opensea-static/opensea-profile/1.png",
                        "address": "0x0000000000000000000000000000000000000000",
                        "config": "",
                        "discord_id": ""
                    },
                    "permalink": "https://opensea.io/assets/0x495f947276749ce646f68ac8c248420045cb7b5e/50717425042824338886285061199929582610378645077537395401447485677013559148545",
                    "collection": {
                        "banner_image_url": "https://lh3.googleusercontent.com/ZIWJXKXTHQDDq2PTU6oAkGrx8QS-icNkj8S91ZkamW6Ci5h4FyltlZnAtLNOb2R5Ypg8Ot_M2WHNeCgxM-7FqOw6kS8WfxdGQwBqcQ=s2500",
                        "chat_url": null,
                        "created_date": "2021-03-22T14:25:09.146978",
                        "default_to_fiat": false,
                        "description": "#### 200 BastardGhosts will haunt the blockchain\n\n#### 133/200 BastardGhosts FULLY MINTED\n\n#### 100% custom code generated (JavaScript, see pinned tweet).\n\n#### 001-025 : 'OG' BastardGhosts (256px by 256px)\n\n#### 026-100 : Various Mini Series (256px by 256px)\n\n#### 101 : METALPUNKS collab (256px by 256px)\n\n#### 102-200 : MADNESS (1024px by 1024px)\n\n#### Number 126 Flying solo in Matic \n\n",
                        "dev_buyer_fee_basis_points": "0",
                        "dev_seller_fee_basis_points": "1000",
                        "discord_url": null,
                        "display_data": {
                            "card_display_style": "contain"
                        },
                        "external_url": null,
                        "featured": false,
                        "featured_image_url": "https://lh3.googleusercontent.com/_m7mT7oBoMC4siGMrTctkoi05kmosW0b0cAq_5MrzN5joWoJgkMw9Y9HNxskx55ToUIVS0cuwUtEFl4bv21NcoWynb6uuZmOyf4VFAI=s300",
                        "hidden": true,
                        "safelist_request_status": "not_requested",
                        "image_url": "https://lh3.googleusercontent.com/x-TqZMDLhNoVAvkEhbMxSA4haIVMD13tXPmWopUitTBI89-3iCeDLSKLwmtikDxV53hArTznYdCSEtts--urqE4w2em7zxpWiQms4nY=s120",
                        "is_subject_to_whitelist": false,
                        "large_image_url": "https://lh3.googleusercontent.com/_m7mT7oBoMC4siGMrTctkoi05kmosW0b0cAq_5MrzN5joWoJgkMw9Y9HNxskx55ToUIVS0cuwUtEFl4bv21NcoWynb6uuZmOyf4VFAI=s300",
                        "medium_username": null,
                        "name": "BastardGhosts",
                        "only_proxied_transfers": false,
                        "opensea_buyer_fee_basis_points": "0",
                        "opensea_seller_fee_basis_points": "250",
                        "payout_address": "0x70210b9928a21102900dede6ec65cbeb2992dd50",
                        "require_email": false,
                        "short_description": null,
                        "slug": "bastardghosts",
                        "telegram_url": null,
                        "twitter_username": "BastardGhosts",
                        "instagram_username": null,
                        "wiki_url": null
                    },
                    "decimals": null,
                    "token_metadata": null
                }
            ],
            "name": "Bastard Ghost 32 & 83 (Bundle)",
            "description": "Pick up 2 Bastard Ghosts with this bundle (32 and 83)",
            "external_link": "",
            "asset_contract": {
                "collection": {
                    "banner_image_url": null,
                    "chat_url": null,
                    "created_date": "2020-12-02T17:40:53.507540",
                    "default_to_fiat": false,
                    "description": null,
                    "dev_buyer_fee_basis_points": "0",
                    "dev_seller_fee_basis_points": "0",
                    "discord_url": null,
                    "display_data": {
                        "card_display_style": "contain",
                        "images": []
                    },
                    "external_url": null,
                    "featured": false,
                    "featured_image_url": null,
                    "hidden": true,
                    "safelist_request_status": "not_requested",
                    "image_url": null,
                    "is_subject_to_whitelist": false,
                    "large_image_url": null,
                    "medium_username": null,
                    "name": "OpenSea Shared Storefront V2",
                    "only_proxied_transfers": false,
                    "opensea_buyer_fee_basis_points": "0",
                    "opensea_seller_fee_basis_points": "250",
                    "payout_address": null,
                    "require_email": false,
                    "short_description": null,
                    "slug": "opensea-shared-storefront-v2",
                    "telegram_url": null,
                    "twitter_username": null,
                    "instagram_username": null,
                    "wiki_url": null
                },
                "address": "0x495f947276749ce646f68ac8c248420045cb7b5e",
                "asset_contract_type": "semi-fungible",
                "created_date": "2020-12-02T17:40:53.232025",
                "name": "OpenSea Collection",
                "nft_version": null,
                "opensea_version": "2.0.0",
                "owner": 102384,
                "schema_name": "ERC1155",
                "symbol": "OPENSTORE",
                "total_supply": null,
                "description": null,
                "external_link": null,
                "image_url": null,
                "default_to_fiat": false,
                "dev_buyer_fee_basis_points": 0,
                "dev_seller_fee_basis_points": 0,
                "only_proxied_transfers": false,
                "opensea_buyer_fee_basis_points": 0,
                "opensea_seller_fee_basis_points": 250,
                "buyer_fee_basis_points": 0,
                "seller_fee_basis_points": 250,
                "payout_address": null
            },
            "permalink": "https://opensea.io/bundles/bastard-ghost-32-83-bundle-uiL",
            "sell_orders": [
                {
                    "created_date": "2021-05-25T20:51:08.670880",
                    "closing_date": null,
                    "closing_extendable": false,
                    "expiration_time": 0,
                    "listing_time": 1621975760,
                    "order_hash": "0x9e6f535238a6d41460ea638c3e6522e51e03e1361f3472fb61fdef58dae02158",
                    "metadata": {
                        "bundle": {
                            "assets": [
                                {
                                    "id": "50717425042824338886285061199929582610378645077537395401447485537375582420993",
                                    "address": "0x495f947276749ce646f68ac8c248420045cb7b5e",
                                    "quantity": "1"
                                },
                                {
                                    "id": "50717425042824338886285061199929582610378645077537395401447485677013559148545",
                                    "address": "0x495f947276749ce646f68ac8c248420045cb7b5e",
                                    "quantity": "1"
                                }
                            ],
                            "schemas": [
                                "ERC1155",
                                "ERC1155"
                            ],
                            "name": "Bastard Ghost 32 & 83 (Bundle)",
                            "description": "Pick up 2 Bastard Ghosts with this bundle (32 and 83)",
                            "external_link": ""
                        }
                    },
                    "exchange": "0x7be8076f4ea4a4ad08075c2508e481d6c946d12b",
                    "maker": {
                        "user": 668568,
                        "profile_img_url": "https://storage.googleapis.com/opensea-static/opensea-profile/2.png",
                        "address": "0x8f800cc88bffede0dbaecc76a0c15a2f5701ac1e",
                        "config": "",
                        "discord_id": ""
                    },
                    "taker": {
                        "user": 1766,
                        "profile_img_url": "https://storage.googleapis.com/opensea-static/opensea-profile/1.png",
                        "address": "0x0000000000000000000000000000000000000000",
                        "config": "",
                        "discord_id": ""
                    },
                    "current_price": "56000000000000000",
                    "current_bounty": "560000000000000",
                    "bounty_multiple": "0.01",
                    "maker_relayer_fee": "1250",
                    "taker_relayer_fee": "0",
                    "maker_protocol_fee": "0",
                    "taker_protocol_fee": "0",
                    "maker_referrer_fee": "0",
                    "fee_recipient": {
                        "user": 3585,
                        "profile_img_url": "https://storage.googleapis.com/opensea-static/opensea-profile/28.png",
                        "address": "0x5b3256965e7c3cf26e11fcaf296dfc8807c01073",
                        "config": "verified",
                        "discord_id": ""
                    },
                    "fee_method": 1,
                    "side": 1,
                    "sale_kind": 0,
                    "target": "0xc99f70bfd82fb7c8f8191fdfbfb735606b15e5c5",
                    "how_to_call": 1,
                    "calldata": "0x68f0bcaa000000000000000000000000000000000000000000000000000000000000008000000000000000000000000000000000000000000000000000000000000000e0000000000000000000000000000000000000000000000000000000000000014000000000000000000000000000000000000000000000000000000000000001a00000000000000000000000000000000000000000000000000000000000000002000000000000000000000000495f947276749ce646f68ac8c248420045cb7b5e000000000000000000000000495f947276749ce646f68ac8c248420045cb7b5e000000000000000000000000000000000000000000000000000000000000000200000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000200000000000000000000000000000000000000000000000000000000000000c400000000000000000000000000000000000000000000000000000000000000c40000000000000000000000000000000000000000000000000000000000000188f242432a0000000000000000000000008f800cc88bffede0dbaecc76a0c15a2f5701ac1e000000000000000000000000000000000000000000000000000000000000000070210b9928a21102900dede6ec65cbeb2992dd50000000000001450000000001000000000000000000000000000000000000000000000000000000000000000100000000000000000000000000000000000000000000000000000000000000a00000000000000000000000000000000000000000000000000000000000000000f242432a0000000000000000000000008f800cc88bffede0dbaecc76a0c15a2f5701ac1e000000000000000000000000000000000000000000000000000000000000000070210b9928a21102900dede6ec65cbeb2992dd50000000000001c40000000001000000000000000000000000000000000000000000000000000000000000000100000000000000000000000000000000000000000000000000000000000000a00000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000",
                    "replacement_pattern": "0x0000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000ffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffff0000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000ffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffff0000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000",
                    "static_target": "0x0000000000000000000000000000000000000000",
                    "static_extradata": "0x",
                    "payment_token": "0x0000000000000000000000000000000000000000",
                    "payment_token_contract": {
                        "id": 1,
                        "symbol": "ETH",
                        "address": "0x0000000000000000000000000000000000000000",
                        "image_url": "https://storage.opensea.io/files/6f8e2979d428180222796ff4a33ab929.svg",
                        "name": "Ether",
                        "decimals": 18,
                        "eth_price": "1.000000000000000",
                        "usd_price": "2625.730000000000018000"
                    },
                    "base_price": "56000000000000000",
                    "extra": "0",
                    "quantity": "1",
                    "salt": "6375120568748438403628860660572949193745476048659875224027607385925984972387",
                    "v": 27,
                    "r": "0x4b78bccdc1f8b52d3b5b2704a73e856a16d0a9a769f225b3a6df45e0b5cd79d1",
                    "s": "0x4fc88f98058ccaa888a65621467b83838b8a6497ed02e22252958bc42f8b173c",
                    "approved_on_chain": false,
                    "cancelled": false,
                    "finalized": false,
                    "marked_invalid": false,
                    "prefixed_hash": "0x2662995c498cba5e85ec03dbce8a6d3b1bd22a58bc908cfa8aa08bb60a01b92b"
                }
            ]
        },
        {
            "maker": {
                "user": {
                    "username": "DaviD_MalloN"
                },
                "profile_img_url": "https://storage.googleapis.com/opensea-static/opensea-profile/17.png",
                "address": "0x2dadc3d7a73f577a96e5e41fbf492c250b6dd3ad",
                "config": "",
                "discord_id": ""
            },
            "slug": "king-tupac-H4W",
            "assets": [
                {
                    "id": 23849135,
                    "token_id": "20661094382993015541686733221866554480139049088319845449901515003854298546177",
                    "num_sales": 0,
                    "background_color": null,
                    "image_url": "https://lh3.googleusercontent.com/GmClYcgTzmmq7HxEW29DbmEiqASCRMwVjBupaxer6UFMuKqWxD1h53aR6KfcJscgRgJ0CD0XLMPPaGmhicmp4xErNHTj6g2W_63OEg",
                    "image_preview_url": "https://lh3.googleusercontent.com/GmClYcgTzmmq7HxEW29DbmEiqASCRMwVjBupaxer6UFMuKqWxD1h53aR6KfcJscgRgJ0CD0XLMPPaGmhicmp4xErNHTj6g2W_63OEg=s250",
                    "image_thumbnail_url": "https://lh3.googleusercontent.com/GmClYcgTzmmq7HxEW29DbmEiqASCRMwVjBupaxer6UFMuKqWxD1h53aR6KfcJscgRgJ0CD0XLMPPaGmhicmp4xErNHTj6g2W_63OEg=s128",
                    "image_original_url": null,
                    "animation_url": null,
                    "animation_original_url": null,
                    "name": "King Tupac",
                    "description": "Tupac Amaru Shakur- born Lesane Parish Crooks, June 16, 1971 – September 13, 1996 \nbetter known by his stage name 2Pac and by his alias Makaveli, was an American rapper and actor. He is widely considered to be one of the most influential rappers of all time. Much of Shakur's work has been noted for addressing contemporary social issues that plagued inner cities, and he has often been considered a symbol of activism against inequality.\n\n",
                    "external_link": null,
                    "asset_contract": {
                        "address": "0x495f947276749ce646f68ac8c248420045cb7b5e",
                        "asset_contract_type": "semi-fungible",
                        "created_date": "2020-12-02T17:40:53.232025",
                        "name": "OpenSea Collection",
                        "nft_version": null,
                        "opensea_version": "2.0.0",
                        "owner": 102384,
                        "schema_name": "ERC1155",
                        "symbol": "OPENSTORE",
                        "total_supply": null,
                        "description": null,
                        "external_link": null,
                        "image_url": null,
                        "default_to_fiat": false,
                        "dev_buyer_fee_basis_points": 0,
                        "dev_seller_fee_basis_points": 0,
                        "only_proxied_transfers": false,
                        "opensea_buyer_fee_basis_points": 0,
                        "opensea_seller_fee_basis_points": 250,
                        "buyer_fee_basis_points": 0,
                        "seller_fee_basis_points": 250,
                        "payout_address": null
                    },
                    "owner": {
                        "user": {
                            "username": "NullAddress"
                        },
                        "profile_img_url": "https://storage.googleapis.com/opensea-static/opensea-profile/1.png",
                        "address": "0x0000000000000000000000000000000000000000",
                        "config": "",
                        "discord_id": ""
                    },
                    "permalink": "https://opensea.io/assets/0x495f947276749ce646f68ac8c248420045cb7b5e/20661094382993015541686733221866554480139049088319845449901515003854298546177",
                    "collection": {
                        "banner_image_url": null,
                        "chat_url": null,
                        "created_date": "2021-05-06T06:34:44.111504",
                        "default_to_fiat": false,
                        "description": "A fascinating collection of art and beauty from celebrities",
                        "dev_buyer_fee_basis_points": "0",
                        "dev_seller_fee_basis_points": "0",
                        "discord_url": null,
                        "display_data": {
                            "card_display_style": "contain"
                        },
                        "external_url": null,
                        "featured": false,
                        "featured_image_url": "https://lh3.googleusercontent.com/GmClYcgTzmmq7HxEW29DbmEiqASCRMwVjBupaxer6UFMuKqWxD1h53aR6KfcJscgRgJ0CD0XLMPPaGmhicmp4xErNHTj6g2W_63OEg=s300",
                        "hidden": true,
                        "safelist_request_status": "not_requested",
                        "image_url": "https://lh3.googleusercontent.com/GmClYcgTzmmq7HxEW29DbmEiqASCRMwVjBupaxer6UFMuKqWxD1h53aR6KfcJscgRgJ0CD0XLMPPaGmhicmp4xErNHTj6g2W_63OEg=s120",
                        "is_subject_to_whitelist": false,
                        "large_image_url": "https://lh3.googleusercontent.com/GmClYcgTzmmq7HxEW29DbmEiqASCRMwVjBupaxer6UFMuKqWxD1h53aR6KfcJscgRgJ0CD0XLMPPaGmhicmp4xErNHTj6g2W_63OEg=s300",
                        "medium_username": null,
                        "name": "King Tupac",
                        "only_proxied_transfers": false,
                        "opensea_buyer_fee_basis_points": "0",
                        "opensea_seller_fee_basis_points": "250",
                        "payout_address": null,
                        "require_email": false,
                        "short_description": null,
                        "slug": "tupak",
                        "telegram_url": null,
                        "twitter_username": null,
                        "instagram_username": null,
                        "wiki_url": null
                    },
                    "decimals": null,
                    "token_metadata": null
                },
                {
                    "id": 23850793,
                    "token_id": "20661094382993015541686733221866554480139049088319845449901515004953810173953",
                    "num_sales": 0,
                    "background_color": null,
                    "image_url": "https://lh3.googleusercontent.com/-KUCwxx5sFWv-HHCO354ZOvdk-GXIUiDW_X2oHWUpMOQBMeOGbiFaLOiCdCsVWH5FdjWrlU7s02YkJrDl-53plZXzalmzErHbeKB2XU",
                    "image_preview_url": "https://lh3.googleusercontent.com/-KUCwxx5sFWv-HHCO354ZOvdk-GXIUiDW_X2oHWUpMOQBMeOGbiFaLOiCdCsVWH5FdjWrlU7s02YkJrDl-53plZXzalmzErHbeKB2XU=s250",
                    "image_thumbnail_url": "https://lh3.googleusercontent.com/-KUCwxx5sFWv-HHCO354ZOvdk-GXIUiDW_X2oHWUpMOQBMeOGbiFaLOiCdCsVWH5FdjWrlU7s02YkJrDl-53plZXzalmzErHbeKB2XU=s128",
                    "image_original_url": null,
                    "animation_url": null,
                    "animation_original_url": null,
                    "name": "Bruce Lee",
                    "description": null,
                    "external_link": null,
                    "asset_contract": {
                        "address": "0x495f947276749ce646f68ac8c248420045cb7b5e",
                        "asset_contract_type": "semi-fungible",
                        "created_date": "2020-12-02T17:40:53.232025",
                        "name": "OpenSea Collection",
                        "nft_version": null,
                        "opensea_version": "2.0.0",
                        "owner": 102384,
                        "schema_name": "ERC1155",
                        "symbol": "OPENSTORE",
                        "total_supply": null,
                        "description": null,
                        "external_link": null,
                        "image_url": null,
                        "default_to_fiat": false,
                        "dev_buyer_fee_basis_points": 0,
                        "dev_seller_fee_basis_points": 0,
                        "only_proxied_transfers": false,
                        "opensea_buyer_fee_basis_points": 0,
                        "opensea_seller_fee_basis_points": 250,
                        "buyer_fee_basis_points": 0,
                        "seller_fee_basis_points": 250,
                        "payout_address": null
                    },
                    "owner": {
                        "user": {
                            "username": "NullAddress"
                        },
                        "profile_img_url": "https://storage.googleapis.com/opensea-static/opensea-profile/1.png",
                        "address": "0x0000000000000000000000000000000000000000",
                        "config": "",
                        "discord_id": ""
                    },
                    "permalink": "https://opensea.io/assets/0x495f947276749ce646f68ac8c248420045cb7b5e/20661094382993015541686733221866554480139049088319845449901515004953810173953",
                    "collection": {
                        "banner_image_url": null,
                        "chat_url": null,
                        "created_date": "2021-05-06T06:34:44.111504",
                        "default_to_fiat": false,
                        "description": "A fascinating collection of art and beauty from celebrities",
                        "dev_buyer_fee_basis_points": "0",
                        "dev_seller_fee_basis_points": "0",
                        "discord_url": null,
                        "display_data": {
                            "card_display_style": "contain"
                        },
                        "external_url": null,
                        "featured": false,
                        "featured_image_url": "https://lh3.googleusercontent.com/GmClYcgTzmmq7HxEW29DbmEiqASCRMwVjBupaxer6UFMuKqWxD1h53aR6KfcJscgRgJ0CD0XLMPPaGmhicmp4xErNHTj6g2W_63OEg=s300",
                        "hidden": true,
                        "safelist_request_status": "not_requested",
                        "image_url": "https://lh3.googleusercontent.com/GmClYcgTzmmq7HxEW29DbmEiqASCRMwVjBupaxer6UFMuKqWxD1h53aR6KfcJscgRgJ0CD0XLMPPaGmhicmp4xErNHTj6g2W_63OEg=s120",
                        "is_subject_to_whitelist": false,
                        "large_image_url": "https://lh3.googleusercontent.com/GmClYcgTzmmq7HxEW29DbmEiqASCRMwVjBupaxer6UFMuKqWxD1h53aR6KfcJscgRgJ0CD0XLMPPaGmhicmp4xErNHTj6g2W_63OEg=s300",
                        "medium_username": null,
                        "name": "King Tupac",
                        "only_proxied_transfers": false,
                        "opensea_buyer_fee_basis_points": "0",
                        "opensea_seller_fee_basis_points": "250",
                        "payout_address": null,
                        "require_email": false,
                        "short_description": null,
                        "slug": "tupak",
                        "telegram_url": null,
                        "twitter_username": null,
                        "instagram_username": null,
                        "wiki_url": null
                    },
                    "decimals": null,
                    "token_metadata": null
                },
                {
                    "id": 23850998,
                    "token_id": "20661094382993015541686733221866554480139049088319845449901515006053321801729",
                    "num_sales": 0,
                    "background_color": null,
                    "image_url": "https://lh3.googleusercontent.com/M19CNa1qyTpuh-hKpFSh6EesvjGghhB9XfBC0htMzQE3Ru98V4J1BKxBCQPy6SAvNM-4RnWB7jI2haQDt4XFV-2a2ZVFeam_jq39-g",
                    "image_preview_url": "https://lh3.googleusercontent.com/M19CNa1qyTpuh-hKpFSh6EesvjGghhB9XfBC0htMzQE3Ru98V4J1BKxBCQPy6SAvNM-4RnWB7jI2haQDt4XFV-2a2ZVFeam_jq39-g=s250",
                    "image_thumbnail_url": "https://lh3.googleusercontent.com/M19CNa1qyTpuh-hKpFSh6EesvjGghhB9XfBC0htMzQE3Ru98V4J1BKxBCQPy6SAvNM-4RnWB7jI2haQDt4XFV-2a2ZVFeam_jq39-g=s128",
                    "image_original_url": null,
                    "animation_url": null,
                    "animation_original_url": null,
                    "name": "joker",
                    "description": null,
                    "external_link": null,
                    "asset_contract": {
                        "address": "0x495f947276749ce646f68ac8c248420045cb7b5e",
                        "asset_contract_type": "semi-fungible",
                        "created_date": "2020-12-02T17:40:53.232025",
                        "name": "OpenSea Collection",
                        "nft_version": null,
                        "opensea_version": "2.0.0",
                        "owner": 102384,
                        "schema_name": "ERC1155",
                        "symbol": "OPENSTORE",
                        "total_supply": null,
                        "description": null,
                        "external_link": null,
                        "image_url": null,
                        "default_to_fiat": false,
                        "dev_buyer_fee_basis_points": 0,
                        "dev_seller_fee_basis_points": 0,
                        "only_proxied_transfers": false,
                        "opensea_buyer_fee_basis_points": 0,
                        "opensea_seller_fee_basis_points": 250,
                        "buyer_fee_basis_points": 0,
                        "seller_fee_basis_points": 250,
                        "payout_address": null
                    },
                    "owner": {
                        "user": {
                            "username": "NullAddress"
                        },
                        "profile_img_url": "https://storage.googleapis.com/opensea-static/opensea-profile/1.png",
                        "address": "0x0000000000000000000000000000000000000000",
                        "config": "",
                        "discord_id": ""
                    },
                    "permalink": "https://opensea.io/assets/0x495f947276749ce646f68ac8c248420045cb7b5e/20661094382993015541686733221866554480139049088319845449901515006053321801729",
                    "collection": {
                        "banner_image_url": null,
                        "chat_url": null,
                        "created_date": "2021-05-06T06:34:44.111504",
                        "default_to_fiat": false,
                        "description": "A fascinating collection of art and beauty from celebrities",
                        "dev_buyer_fee_basis_points": "0",
                        "dev_seller_fee_basis_points": "0",
                        "discord_url": null,
                        "display_data": {
                            "card_display_style": "contain"
                        },
                        "external_url": null,
                        "featured": false,
                        "featured_image_url": "https://lh3.googleusercontent.com/GmClYcgTzmmq7HxEW29DbmEiqASCRMwVjBupaxer6UFMuKqWxD1h53aR6KfcJscgRgJ0CD0XLMPPaGmhicmp4xErNHTj6g2W_63OEg=s300",
                        "hidden": true,
                        "safelist_request_status": "not_requested",
                        "image_url": "https://lh3.googleusercontent.com/GmClYcgTzmmq7HxEW29DbmEiqASCRMwVjBupaxer6UFMuKqWxD1h53aR6KfcJscgRgJ0CD0XLMPPaGmhicmp4xErNHTj6g2W_63OEg=s120",
                        "is_subject_to_whitelist": false,
                        "large_image_url": "https://lh3.googleusercontent.com/GmClYcgTzmmq7HxEW29DbmEiqASCRMwVjBupaxer6UFMuKqWxD1h53aR6KfcJscgRgJ0CD0XLMPPaGmhicmp4xErNHTj6g2W_63OEg=s300",
                        "medium_username": null,
                        "name": "King Tupac",
                        "only_proxied_transfers": false,
                        "opensea_buyer_fee_basis_points": "0",
                        "opensea_seller_fee_basis_points": "250",
                        "payout_address": null,
                        "require_email": false,
                        "short_description": null,
                        "slug": "tupak",
                        "telegram_url": null,
                        "twitter_username": null,
                        "instagram_username": null,
                        "wiki_url": null
                    },
                    "decimals": null,
                    "token_metadata": null
                },
                {
                    "id": 23851071,
                    "token_id": "20661094382993015541686733221866554480139049088319845449901515007152833429505",
                    "num_sales": 0,
                    "background_color": null,
                    "image_url": "https://lh3.googleusercontent.com/_IC7aGvSLuZhUSVr2l3wk-ZBCkag_1qMAiAmBg35w8fbppiPAzxuH6T1SbJnf6NCM8EeuxImW9MLumS9VY5x-5YM8TXBINeCDL0g",
                    "image_preview_url": "https://lh3.googleusercontent.com/_IC7aGvSLuZhUSVr2l3wk-ZBCkag_1qMAiAmBg35w8fbppiPAzxuH6T1SbJnf6NCM8EeuxImW9MLumS9VY5x-5YM8TXBINeCDL0g=s250",
                    "image_thumbnail_url": "https://lh3.googleusercontent.com/_IC7aGvSLuZhUSVr2l3wk-ZBCkag_1qMAiAmBg35w8fbppiPAzxuH6T1SbJnf6NCM8EeuxImW9MLumS9VY5x-5YM8TXBINeCDL0g=s128",
                    "image_original_url": null,
                    "animation_url": null,
                    "animation_original_url": null,
                    "name": "frida collage",
                    "description": null,
                    "external_link": null,
                    "asset_contract": {
                        "address": "0x495f947276749ce646f68ac8c248420045cb7b5e",
                        "asset_contract_type": "semi-fungible",
                        "created_date": "2020-12-02T17:40:53.232025",
                        "name": "OpenSea Collection",
                        "nft_version": null,
                        "opensea_version": "2.0.0",
                        "owner": 102384,
                        "schema_name": "ERC1155",
                        "symbol": "OPENSTORE",
                        "total_supply": null,
                        "description": null,
                        "external_link": null,
                        "image_url": null,
                        "default_to_fiat": false,
                        "dev_buyer_fee_basis_points": 0,
                        "dev_seller_fee_basis_points": 0,
                        "only_proxied_transfers": false,
                        "opensea_buyer_fee_basis_points": 0,
                        "opensea_seller_fee_basis_points": 250,
                        "buyer_fee_basis_points": 0,
                        "seller_fee_basis_points": 250,
                        "payout_address": null
                    },
                    "owner": {
                        "user": {
                            "username": "NullAddress"
                        },
                        "profile_img_url": "https://storage.googleapis.com/opensea-static/opensea-profile/1.png",
                        "address": "0x0000000000000000000000000000000000000000",
                        "config": "",
                        "discord_id": ""
                    },
                    "permalink": "https://opensea.io/assets/0x495f947276749ce646f68ac8c248420045cb7b5e/20661094382993015541686733221866554480139049088319845449901515007152833429505",
                    "collection": {
                        "banner_image_url": null,
                        "chat_url": null,
                        "created_date": "2021-05-06T06:34:44.111504",
                        "default_to_fiat": false,
                        "description": "A fascinating collection of art and beauty from celebrities",
                        "dev_buyer_fee_basis_points": "0",
                        "dev_seller_fee_basis_points": "0",
                        "discord_url": null,
                        "display_data": {
                            "card_display_style": "contain"
                        },
                        "external_url": null,
                        "featured": false,
                        "featured_image_url": "https://lh3.googleusercontent.com/GmClYcgTzmmq7HxEW29DbmEiqASCRMwVjBupaxer6UFMuKqWxD1h53aR6KfcJscgRgJ0CD0XLMPPaGmhicmp4xErNHTj6g2W_63OEg=s300",
                        "hidden": true,
                        "safelist_request_status": "not_requested",
                        "image_url": "https://lh3.googleusercontent.com/GmClYcgTzmmq7HxEW29DbmEiqASCRMwVjBupaxer6UFMuKqWxD1h53aR6KfcJscgRgJ0CD0XLMPPaGmhicmp4xErNHTj6g2W_63OEg=s120",
                        "is_subject_to_whitelist": false,
                        "large_image_url": "https://lh3.googleusercontent.com/GmClYcgTzmmq7HxEW29DbmEiqASCRMwVjBupaxer6UFMuKqWxD1h53aR6KfcJscgRgJ0CD0XLMPPaGmhicmp4xErNHTj6g2W_63OEg=s300",
                        "medium_username": null,
                        "name": "King Tupac",
                        "only_proxied_transfers": false,
                        "opensea_buyer_fee_basis_points": "0",
                        "opensea_seller_fee_basis_points": "250",
                        "payout_address": null,
                        "require_email": false,
                        "short_description": null,
                        "slug": "tupak",
                        "telegram_url": null,
                        "twitter_username": null,
                        "instagram_username": null,
                        "wiki_url": null
                    },
                    "decimals": null,
                    "token_metadata": null
                },
                {
                    "id": 23851285,
                    "token_id": "20661094382993015541686733221866554480139049088319845449901515008252345057281",
                    "num_sales": 0,
                    "background_color": null,
                    "image_url": "https://lh3.googleusercontent.com/gFhOIcaCkts7EVPQCyroYGuwr0caME__Og1S150csH85LAViNucn1yCtb_WRacJElscSTuCdigZQ1E81efft2wmKkcg-JMQxIOHF",
                    "image_preview_url": "https://lh3.googleusercontent.com/gFhOIcaCkts7EVPQCyroYGuwr0caME__Og1S150csH85LAViNucn1yCtb_WRacJElscSTuCdigZQ1E81efft2wmKkcg-JMQxIOHF=s250",
                    "image_thumbnail_url": "https://lh3.googleusercontent.com/gFhOIcaCkts7EVPQCyroYGuwr0caME__Og1S150csH85LAViNucn1yCtb_WRacJElscSTuCdigZQ1E81efft2wmKkcg-JMQxIOHF=s128",
                    "image_original_url": null,
                    "animation_url": null,
                    "animation_original_url": null,
                    "name": "Bob Marley",
                    "description": null,
                    "external_link": null,
                    "asset_contract": {
                        "address": "0x495f947276749ce646f68ac8c248420045cb7b5e",
                        "asset_contract_type": "semi-fungible",
                        "created_date": "2020-12-02T17:40:53.232025",
                        "name": "OpenSea Collection",
                        "nft_version": null,
                        "opensea_version": "2.0.0",
                        "owner": 102384,
                        "schema_name": "ERC1155",
                        "symbol": "OPENSTORE",
                        "total_supply": null,
                        "description": null,
                        "external_link": null,
                        "image_url": null,
                        "default_to_fiat": false,
                        "dev_buyer_fee_basis_points": 0,
                        "dev_seller_fee_basis_points": 0,
                        "only_proxied_transfers": false,
                        "opensea_buyer_fee_basis_points": 0,
                        "opensea_seller_fee_basis_points": 250,
                        "buyer_fee_basis_points": 0,
                        "seller_fee_basis_points": 250,
                        "payout_address": null
                    },
                    "owner": {
                        "user": {
                            "username": "NullAddress"
                        },
                        "profile_img_url": "https://storage.googleapis.com/opensea-static/opensea-profile/1.png",
                        "address": "0x0000000000000000000000000000000000000000",
                        "config": "",
                        "discord_id": ""
                    },
                    "permalink": "https://opensea.io/assets/0x495f947276749ce646f68ac8c248420045cb7b5e/20661094382993015541686733221866554480139049088319845449901515008252345057281",
                    "collection": {
                        "banner_image_url": null,
                        "chat_url": null,
                        "created_date": "2021-05-06T06:34:44.111504",
                        "default_to_fiat": false,
                        "description": "A fascinating collection of art and beauty from celebrities",
                        "dev_buyer_fee_basis_points": "0",
                        "dev_seller_fee_basis_points": "0",
                        "discord_url": null,
                        "display_data": {
                            "card_display_style": "contain"
                        },
                        "external_url": null,
                        "featured": false,
                        "featured_image_url": "https://lh3.googleusercontent.com/GmClYcgTzmmq7HxEW29DbmEiqASCRMwVjBupaxer6UFMuKqWxD1h53aR6KfcJscgRgJ0CD0XLMPPaGmhicmp4xErNHTj6g2W_63OEg=s300",
                        "hidden": true,
                        "safelist_request_status": "not_requested",
                        "image_url": "https://lh3.googleusercontent.com/GmClYcgTzmmq7HxEW29DbmEiqASCRMwVjBupaxer6UFMuKqWxD1h53aR6KfcJscgRgJ0CD0XLMPPaGmhicmp4xErNHTj6g2W_63OEg=s120",
                        "is_subject_to_whitelist": false,
                        "large_image_url": "https://lh3.googleusercontent.com/GmClYcgTzmmq7HxEW29DbmEiqASCRMwVjBupaxer6UFMuKqWxD1h53aR6KfcJscgRgJ0CD0XLMPPaGmhicmp4xErNHTj6g2W_63OEg=s300",
                        "medium_username": null,
                        "name": "King Tupac",
                        "only_proxied_transfers": false,
                        "opensea_buyer_fee_basis_points": "0",
                        "opensea_seller_fee_basis_points": "250",
                        "payout_address": null,
                        "require_email": false,
                        "short_description": null,
                        "slug": "tupak",
                        "telegram_url": null,
                        "twitter_username": null,
                        "instagram_username": null,
                        "wiki_url": null
                    },
                    "decimals": null,
                    "token_metadata": null
                },
                {
                    "id": 23851987,
                    "token_id": "20661094382993015541686733221866554480139049088319845449901515009351856685057",
                    "num_sales": 0,
                    "background_color": null,
                    "image_url": "https://lh3.googleusercontent.com/dRJsgqGurxeHSdYT4GpPQOqyfiWWJYRFk8I0Gn360AGcIbl_LGFemFRApMQ8GygOULWHk6trJd-1rcg62AkZJpTMcdwWF72y1AIVUA",
                    "image_preview_url": "https://lh3.googleusercontent.com/dRJsgqGurxeHSdYT4GpPQOqyfiWWJYRFk8I0Gn360AGcIbl_LGFemFRApMQ8GygOULWHk6trJd-1rcg62AkZJpTMcdwWF72y1AIVUA=s250",
                    "image_thumbnail_url": "https://lh3.googleusercontent.com/dRJsgqGurxeHSdYT4GpPQOqyfiWWJYRFk8I0Gn360AGcIbl_LGFemFRApMQ8GygOULWHk6trJd-1rcg62AkZJpTMcdwWF72y1AIVUA=s128",
                    "image_original_url": null,
                    "animation_url": null,
                    "animation_original_url": null,
                    "name": "marilyn monroe",
                    "description": null,
                    "external_link": null,
                    "asset_contract": {
                        "address": "0x495f947276749ce646f68ac8c248420045cb7b5e",
                        "asset_contract_type": "semi-fungible",
                        "created_date": "2020-12-02T17:40:53.232025",
                        "name": "OpenSea Collection",
                        "nft_version": null,
                        "opensea_version": "2.0.0",
                        "owner": 102384,
                        "schema_name": "ERC1155",
                        "symbol": "OPENSTORE",
                        "total_supply": null,
                        "description": null,
                        "external_link": null,
                        "image_url": null,
                        "default_to_fiat": false,
                        "dev_buyer_fee_basis_points": 0,
                        "dev_seller_fee_basis_points": 0,
                        "only_proxied_transfers": false,
                        "opensea_buyer_fee_basis_points": 0,
                        "opensea_seller_fee_basis_points": 250,
                        "buyer_fee_basis_points": 0,
                        "seller_fee_basis_points": 250,
                        "payout_address": null
                    },
                    "owner": {
                        "user": {
                            "username": "NullAddress"
                        },
                        "profile_img_url": "https://storage.googleapis.com/opensea-static/opensea-profile/1.png",
                        "address": "0x0000000000000000000000000000000000000000",
                        "config": "",
                        "discord_id": ""
                    },
                    "permalink": "https://opensea.io/assets/0x495f947276749ce646f68ac8c248420045cb7b5e/20661094382993015541686733221866554480139049088319845449901515009351856685057",
                    "collection": {
                        "banner_image_url": null,
                        "chat_url": null,
                        "created_date": "2021-05-06T06:34:44.111504",
                        "default_to_fiat": false,
                        "description": "A fascinating collection of art and beauty from celebrities",
                        "dev_buyer_fee_basis_points": "0",
                        "dev_seller_fee_basis_points": "0",
                        "discord_url": null,
                        "display_data": {
                            "card_display_style": "contain"
                        },
                        "external_url": null,
                        "featured": false,
                        "featured_image_url": "https://lh3.googleusercontent.com/GmClYcgTzmmq7HxEW29DbmEiqASCRMwVjBupaxer6UFMuKqWxD1h53aR6KfcJscgRgJ0CD0XLMPPaGmhicmp4xErNHTj6g2W_63OEg=s300",
                        "hidden": true,
                        "safelist_request_status": "not_requested",
                        "image_url": "https://lh3.googleusercontent.com/GmClYcgTzmmq7HxEW29DbmEiqASCRMwVjBupaxer6UFMuKqWxD1h53aR6KfcJscgRgJ0CD0XLMPPaGmhicmp4xErNHTj6g2W_63OEg=s120",
                        "is_subject_to_whitelist": false,
                        "large_image_url": "https://lh3.googleusercontent.com/GmClYcgTzmmq7HxEW29DbmEiqASCRMwVjBupaxer6UFMuKqWxD1h53aR6KfcJscgRgJ0CD0XLMPPaGmhicmp4xErNHTj6g2W_63OEg=s300",
                        "medium_username": null,
                        "name": "King Tupac",
                        "only_proxied_transfers": false,
                        "opensea_buyer_fee_basis_points": "0",
                        "opensea_seller_fee_basis_points": "250",
                        "payout_address": null,
                        "require_email": false,
                        "short_description": null,
                        "slug": "tupak",
                        "telegram_url": null,
                        "twitter_username": null,
                        "instagram_username": null,
                        "wiki_url": null
                    },
                    "decimals": null,
                    "token_metadata": null
                }
            ],
            "name": "king tupac",
            "description": "",
            "external_link": "",
            "asset_contract": {
                "collection": {
                    "banner_image_url": null,
                    "chat_url": null,
                    "created_date": "2020-12-02T17:40:53.507540",
                    "default_to_fiat": false,
                    "description": null,
                    "dev_buyer_fee_basis_points": "0",
                    "dev_seller_fee_basis_points": "0",
                    "discord_url": null,
                    "display_data": {
                        "card_display_style": "contain",
                        "images": []
                    },
                    "external_url": null,
                    "featured": false,
                    "featured_image_url": null,
                    "hidden": true,
                    "safelist_request_status": "not_requested",
                    "image_url": null,
                    "is_subject_to_whitelist": false,
                    "large_image_url": null,
                    "medium_username": null,
                    "name": "OpenSea Shared Storefront V2",
                    "only_proxied_transfers": false,
                    "opensea_buyer_fee_basis_points": "0",
                    "opensea_seller_fee_basis_points": "250",
                    "payout_address": null,
                    "require_email": false,
                    "short_description": null,
                    "slug": "opensea-shared-storefront-v2",
                    "telegram_url": null,
                    "twitter_username": null,
                    "instagram_username": null,
                    "wiki_url": null
                },
                "address": "0x495f947276749ce646f68ac8c248420045cb7b5e",
                "asset_contract_type": "semi-fungible",
                "created_date": "2020-12-02T17:40:53.232025",
                "name": "OpenSea Collection",
                "nft_version": null,
                "opensea_version": "2.0.0",
                "owner": 102384,
                "schema_name": "ERC1155",
                "symbol": "OPENSTORE",
                "total_supply": null,
                "description": null,
                "external_link": null,
                "image_url": null,
                "default_to_fiat": false,
                "dev_buyer_fee_basis_points": 0,
                "dev_seller_fee_basis_points": 0,
                "only_proxied_transfers": false,
                "opensea_buyer_fee_basis_points": 0,
                "opensea_seller_fee_basis_points": 250,
                "buyer_fee_basis_points": 0,
                "seller_fee_basis_points": 250,
                "payout_address": null
            },
            "permalink": "https://opensea.io/bundles/king-tupac-H4W",
            "sell_orders": [
                {
                    "created_date": "2021-05-25T20:40:26.625654",
                    "closing_date": "2021-05-30T20:37:54",
                    "closing_extendable": false,
                    "expiration_time": 1622407074,
                    "listing_time": 1621975104,
                    "order_hash": "0x997a42e14e4130835d04da0a70e64930d8c3c10d0af955bb43d209529aa6d0d2",
                    "metadata": {
                        "bundle": {
                            "assets": [
                                {
                                    "id": "20661094382993015541686733221866554480139049088319845449901515003854298546177",
                                    "address": "0x495f947276749ce646f68ac8c248420045cb7b5e",
                                    "quantity": "1"
                                },
                                {
                                    "id": "20661094382993015541686733221866554480139049088319845449901515004953810173953",
                                    "address": "0x495f947276749ce646f68ac8c248420045cb7b5e",
                                    "quantity": "1"
                                },
                                {
                                    "id": "20661094382993015541686733221866554480139049088319845449901515006053321801729",
                                    "address": "0x495f947276749ce646f68ac8c248420045cb7b5e",
                                    "quantity": "1"
                                },
                                {
                                    "id": "20661094382993015541686733221866554480139049088319845449901515007152833429505",
                                    "address": "0x495f947276749ce646f68ac8c248420045cb7b5e",
                                    "quantity": "1"
                                },
                                {
                                    "id": "20661094382993015541686733221866554480139049088319845449901515008252345057281",
                                    "address": "0x495f947276749ce646f68ac8c248420045cb7b5e",
                                    "quantity": "1"
                                },
                                {
                                    "id": "20661094382993015541686733221866554480139049088319845449901515009351856685057",
                                    "address": "0x495f947276749ce646f68ac8c248420045cb7b5e",
                                    "quantity": "1"
                                }
                            ],
                            "schemas": [
                                "ERC1155",
                                "ERC1155",
                                "ERC1155",
                                "ERC1155",
                                "ERC1155",
                                "ERC1155"
                            ],
                            "name": "king tupac",
                            "description": "",
                            "external_link": ""
                        }
                    },
                    "exchange": "0x7be8076f4ea4a4ad08075c2508e481d6c946d12b",
                    "maker": {
                        "user": 493422,
                        "profile_img_url": "https://storage.googleapis.com/opensea-static/opensea-profile/17.png",
                        "address": "0x2dadc3d7a73f577a96e5e41fbf492c250b6dd3ad",
                        "config": "",
                        "discord_id": ""
                    },
                    "taker": {
                        "user": 1766,
                        "profile_img_url": "https://storage.googleapis.com/opensea-static/opensea-profile/1.png",
                        "address": "0x0000000000000000000000000000000000000000",
                        "config": "",
                        "discord_id": ""
                    },
                    "current_price": "697827628644596667.9344742711",
                    "current_bounty": "6978276286242303",
                    "bounty_multiple": "0.01",
                    "maker_relayer_fee": "250",
                    "taker_relayer_fee": "0",
                    "maker_protocol_fee": "0",
                    "taker_protocol_fee": "0",
                    "maker_referrer_fee": "0",
                    "fee_recipient": {
                        "user": 3585,
                        "profile_img_url": "https://storage.googleapis.com/opensea-static/opensea-profile/28.png",
                        "address": "0x5b3256965e7c3cf26e11fcaf296dfc8807c01073",
                        "config": "verified",
                        "discord_id": ""
                    },
                    "fee_method": 1,
                    "side": 1,
                    "sale_kind": 1,
                    "target": "0xc99f70bfd82fb7c8f8191fdfbfb735606b15e5c5",
                    "how_to_call": 1,
                    "calldata": "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",
                    "replacement_pattern": "0x0000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000ffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffff0000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000ffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffff0000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000ffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffff0000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000ffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffff0000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000ffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffff0000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000ffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffff00000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000",
                    "static_target": "0x0000000000000000000000000000000000000000",
                    "static_extradata": "0x",
                    "payment_token": "0x0000000000000000000000000000000000000000",
                    "payment_token_contract": {
                        "id": 1,
                        "symbol": "ETH",
                        "address": "0x0000000000000000000000000000000000000000",
                        "image_url": "https://storage.opensea.io/files/6f8e2979d428180222796ff4a33ab929.svg",
                        "name": "Ether",
                        "decimals": 18,
                        "eth_price": "1.000000000000000",
                        "usd_price": "2625.730000000000018000"
                    },
                    "base_price": "700000000000000000",
                    "extra": "99999999999999980",
                    "quantity": "1",
                    "salt": "45806220523524789333551731883745805365886263169552578476000890195591706413313",
                    "v": 27,
                    "r": "0xeb5fde0d35c4eb1728dd5e80bde271a6e288526c0f8e5393641f8716372cb92d",
                    "s": "0x6b92a389ab44ec3f02040142d751ad53bf0ce8a76d3fe24050f64380b4e83db5",
                    "approved_on_chain": false,
                    "cancelled": false,
                    "finalized": false,
                    "marked_invalid": false,
                    "prefixed_hash": "0x572771bea47d31aec4af6d723eddf48c6c82ad04d2037f9a9cc20260d8572473"
                }
            ]
        },
        {
            "maker": {
                "user": {
                    "username": "ONE8"
                },
                "profile_img_url": "https://storage.googleapis.com/opensea-static/opensea-profile/14.png",
                "address": "0x280bac10abee27e3978d4e1e119066ebc3fad8a5",
                "config": "",
                "discord_id": ""
            },
            "slug": "5-pack-39a",
            "assets": [
                {
                    "id": 25653017,
                    "token_id": "18113136810880385909625812461941578260802280914005851637645524663279510618113",
                    "num_sales": 0,
                    "background_color": null,
                    "image_url": "https://lh3.googleusercontent.com/MJGJK3cXCoNfo7ai6_CSw9EuwlPZR6AZILPPJV67CTBITyXqO3Xh16vwWpej35t2CzKycFiD4oSAJa3nIRrp28EJfrufcE-toB19OSQ",
                    "image_preview_url": "https://lh3.googleusercontent.com/MJGJK3cXCoNfo7ai6_CSw9EuwlPZR6AZILPPJV67CTBITyXqO3Xh16vwWpej35t2CzKycFiD4oSAJa3nIRrp28EJfrufcE-toB19OSQ=s250",
                    "image_thumbnail_url": "https://lh3.googleusercontent.com/MJGJK3cXCoNfo7ai6_CSw9EuwlPZR6AZILPPJV67CTBITyXqO3Xh16vwWpej35t2CzKycFiD4oSAJa3nIRrp28EJfrufcE-toB19OSQ=s128",
                    "image_original_url": null,
                    "animation_url": null,
                    "animation_original_url": null,
                    "name": "Doodle Doodz #0061 (wrapped)",
                    "description": "Doodle Doodz #0061\n\nThis gives you the opportunity to buy the new drops doodz at the previous drops common rate. That means you could unwrap a rare at almost half the price! These will expire if not purchased, so hurry! Each pack contains 1 random NFT. Good luck! If stated more than one in a pack, it means it’s part of a handle deal. \n\nThere will be a total of 1000 1/1 Doodle Doodz with a total supply of 1000. Each drop will consist of 15 Doodz: 10 additional Super Rare Doodz will be added throughout the series & can be obtained as gifts,prizes & special air drops for members with a supply of only 1 each. \n\nSo stay tuned to the Doodz various channels not to miss out! For more info visit our site 🖖 check out Family tree to see how you can SPAWN a free NFT with your Doodle Doodz",
                    "external_link": "https://doodledoodz.app",
                    "asset_contract": {
                        "address": "0x495f947276749ce646f68ac8c248420045cb7b5e",
                        "asset_contract_type": "semi-fungible",
                        "created_date": "2020-12-02T17:40:53.232025",
                        "name": "OpenSea Collection",
                        "nft_version": null,
                        "opensea_version": "2.0.0",
                        "owner": 102384,
                        "schema_name": "ERC1155",
                        "symbol": "OPENSTORE",
                        "total_supply": null,
                        "description": null,
                        "external_link": null,
                        "image_url": null,
                        "default_to_fiat": false,
                        "dev_buyer_fee_basis_points": 0,
                        "dev_seller_fee_basis_points": 0,
                        "only_proxied_transfers": false,
                        "opensea_buyer_fee_basis_points": 0,
                        "opensea_seller_fee_basis_points": 250,
                        "buyer_fee_basis_points": 0,
                        "seller_fee_basis_points": 250,
                        "payout_address": null
                    },
                    "owner": {
                        "user": {
                            "username": "NullAddress"
                        },
                        "profile_img_url": "https://storage.googleapis.com/opensea-static/opensea-profile/1.png",
                        "address": "0x0000000000000000000000000000000000000000",
                        "config": "",
                        "discord_id": ""
                    },
                    "permalink": "https://opensea.io/assets/0x495f947276749ce646f68ac8c248420045cb7b5e/18113136810880385909625812461941578260802280914005851637645524663279510618113",
                    "collection": {
                        "banner_image_url": "https://lh3.googleusercontent.com/dnL546psc4poERNp7pEc5uaRflOW08f3SwNQOIqNSWj1dGKUkmZrTDiC_-t9SKPo1UEGJMPRRbO8fAN8YTP3rASgqiKAWDnixsSeeUA=s2500",
                        "chat_url": null,
                        "created_date": "2021-03-26T01:38:13.859308",
                        "default_to_fiat": false,
                        "description": "There will be a total Supply of 1000 Doodle-Doodz, each uniquely created 1/1 with different traits making some more valuable. a drop will consist of 15 Doodle-Doodz. Each drop will go up in price. ",
                        "dev_buyer_fee_basis_points": "0",
                        "dev_seller_fee_basis_points": "1000",
                        "discord_url": "https://discord.gg/RUXYZDcpgD",
                        "display_data": {
                            "card_display_style": "cover"
                        },
                        "external_url": "http://doodledoodz.app",
                        "featured": false,
                        "featured_image_url": "https://lh3.googleusercontent.com/Z2tF1YmDxYKffPli_0MMHokhOO-Z_LiMc762In8_mJ027WnE5g-3NLq4tUv061mbt6tVuURl1NwWkWPVC2UFLqafUkOhwZo5KEyJ=s300",
                        "hidden": true,
                        "safelist_request_status": "not_requested",
                        "image_url": "https://lh3.googleusercontent.com/vSNu55FSceIbRUaklGdw56D0m3jpfmS8R4LyuW2eeX8ir23EY6YFKeJHl55tBX0iUhVscBfGcClDPwyPb7aB26wO1IrOJHf2uD2w=s120",
                        "is_subject_to_whitelist": false,
                        "large_image_url": "https://lh3.googleusercontent.com/Z2tF1YmDxYKffPli_0MMHokhOO-Z_LiMc762In8_mJ027WnE5g-3NLq4tUv061mbt6tVuURl1NwWkWPVC2UFLqafUkOhwZo5KEyJ=s300",
                        "medium_username": null,
                        "name": "Doodle Doodz",
                        "only_proxied_transfers": false,
                        "opensea_buyer_fee_basis_points": "0",
                        "opensea_seller_fee_basis_points": "250",
                        "payout_address": "0x280bac10abee27e3978d4e1e119066ebc3fad8a5",
                        "require_email": false,
                        "short_description": null,
                        "slug": "doodle-doodz",
                        "telegram_url": null,
                        "twitter_username": "doodledoodz",
                        "instagram_username": "nftdoodledoodz",
                        "wiki_url": null
                    },
                    "decimals": null,
                    "token_metadata": null
                },
                {
                    "id": 25653193,
                    "token_id": "18113136810880385909625812461941578260802280914005851637645524664379022245889",
                    "num_sales": 0,
                    "background_color": null,
                    "image_url": "https://lh3.googleusercontent.com/MJGJK3cXCoNfo7ai6_CSw9EuwlPZR6AZILPPJV67CTBITyXqO3Xh16vwWpej35t2CzKycFiD4oSAJa3nIRrp28EJfrufcE-toB19OSQ",
                    "image_preview_url": "https://lh3.googleusercontent.com/MJGJK3cXCoNfo7ai6_CSw9EuwlPZR6AZILPPJV67CTBITyXqO3Xh16vwWpej35t2CzKycFiD4oSAJa3nIRrp28EJfrufcE-toB19OSQ=s250",
                    "image_thumbnail_url": "https://lh3.googleusercontent.com/MJGJK3cXCoNfo7ai6_CSw9EuwlPZR6AZILPPJV67CTBITyXqO3Xh16vwWpej35t2CzKycFiD4oSAJa3nIRrp28EJfrufcE-toB19OSQ=s128",
                    "image_original_url": null,
                    "animation_url": null,
                    "animation_original_url": null,
                    "name": "Doodle Doodz #0062 (wrapped)",
                    "description": "Doodle Doodz #0062\n\nThis gives you the opportunity to buy the new drops doodz at the previous drops common rate. That means you could unwrap a rare at almost half the price! These will expire if not purchased, so hurry! Each pack contains 1 random NFT. Good luck! If stated more than one in a pack, it means it’s part of a handle deal. \n\nThere will be a total of 1000 1/1 Doodle Doodz with a total supply of 1000. Each drop will consist of 15 Doodz: 10 additional Super Rare Doodz will be added throughout the series & can be obtained as gifts,prizes & special air drops for members with a supply of only 1 each. \n\nSo stay tuned to the Doodz various channels not to miss out! For more info visit our site 🖖 check out Family tree to see how you can SPAWN a free NFT with your Doodle Doodz",
                    "external_link": "https://doodledoodz.app",
                    "asset_contract": {
                        "address": "0x495f947276749ce646f68ac8c248420045cb7b5e",
                        "asset_contract_type": "semi-fungible",
                        "created_date": "2020-12-02T17:40:53.232025",
                        "name": "OpenSea Collection",
                        "nft_version": null,
                        "opensea_version": "2.0.0",
                        "owner": 102384,
                        "schema_name": "ERC1155",
                        "symbol": "OPENSTORE",
                        "total_supply": null,
                        "description": null,
                        "external_link": null,
                        "image_url": null,
                        "default_to_fiat": false,
                        "dev_buyer_fee_basis_points": 0,
                        "dev_seller_fee_basis_points": 0,
                        "only_proxied_transfers": false,
                        "opensea_buyer_fee_basis_points": 0,
                        "opensea_seller_fee_basis_points": 250,
                        "buyer_fee_basis_points": 0,
                        "seller_fee_basis_points": 250,
                        "payout_address": null
                    },
                    "owner": {
                        "user": {
                            "username": "NullAddress"
                        },
                        "profile_img_url": "https://storage.googleapis.com/opensea-static/opensea-profile/1.png",
                        "address": "0x0000000000000000000000000000000000000000",
                        "config": "",
                        "discord_id": ""
                    },
                    "permalink": "https://opensea.io/assets/0x495f947276749ce646f68ac8c248420045cb7b5e/18113136810880385909625812461941578260802280914005851637645524664379022245889",
                    "collection": {
                        "banner_image_url": "https://lh3.googleusercontent.com/dnL546psc4poERNp7pEc5uaRflOW08f3SwNQOIqNSWj1dGKUkmZrTDiC_-t9SKPo1UEGJMPRRbO8fAN8YTP3rASgqiKAWDnixsSeeUA=s2500",
                        "chat_url": null,
                        "created_date": "2021-03-26T01:38:13.859308",
                        "default_to_fiat": false,
                        "description": "There will be a total Supply of 1000 Doodle-Doodz, each uniquely created 1/1 with different traits making some more valuable. a drop will consist of 15 Doodle-Doodz. Each drop will go up in price. ",
                        "dev_buyer_fee_basis_points": "0",
                        "dev_seller_fee_basis_points": "1000",
                        "discord_url": "https://discord.gg/RUXYZDcpgD",
                        "display_data": {
                            "card_display_style": "cover"
                        },
                        "external_url": "http://doodledoodz.app",
                        "featured": false,
                        "featured_image_url": "https://lh3.googleusercontent.com/Z2tF1YmDxYKffPli_0MMHokhOO-Z_LiMc762In8_mJ027WnE5g-3NLq4tUv061mbt6tVuURl1NwWkWPVC2UFLqafUkOhwZo5KEyJ=s300",
                        "hidden": true,
                        "safelist_request_status": "not_requested",
                        "image_url": "https://lh3.googleusercontent.com/vSNu55FSceIbRUaklGdw56D0m3jpfmS8R4LyuW2eeX8ir23EY6YFKeJHl55tBX0iUhVscBfGcClDPwyPb7aB26wO1IrOJHf2uD2w=s120",
                        "is_subject_to_whitelist": false,
                        "large_image_url": "https://lh3.googleusercontent.com/Z2tF1YmDxYKffPli_0MMHokhOO-Z_LiMc762In8_mJ027WnE5g-3NLq4tUv061mbt6tVuURl1NwWkWPVC2UFLqafUkOhwZo5KEyJ=s300",
                        "medium_username": null,
                        "name": "Doodle Doodz",
                        "only_proxied_transfers": false,
                        "opensea_buyer_fee_basis_points": "0",
                        "opensea_seller_fee_basis_points": "250",
                        "payout_address": "0x280bac10abee27e3978d4e1e119066ebc3fad8a5",
                        "require_email": false,
                        "short_description": null,
                        "slug": "doodle-doodz",
                        "telegram_url": null,
                        "twitter_username": "doodledoodz",
                        "instagram_username": "nftdoodledoodz",
                        "wiki_url": null
                    },
                    "decimals": null,
                    "token_metadata": null
                },
                {
                    "id": 25653239,
                    "token_id": "18113136810880385909625812461941578260802280914005851637645524665478533873665",
                    "num_sales": 0,
                    "background_color": null,
                    "image_url": "https://lh3.googleusercontent.com/MJGJK3cXCoNfo7ai6_CSw9EuwlPZR6AZILPPJV67CTBITyXqO3Xh16vwWpej35t2CzKycFiD4oSAJa3nIRrp28EJfrufcE-toB19OSQ",
                    "image_preview_url": "https://lh3.googleusercontent.com/MJGJK3cXCoNfo7ai6_CSw9EuwlPZR6AZILPPJV67CTBITyXqO3Xh16vwWpej35t2CzKycFiD4oSAJa3nIRrp28EJfrufcE-toB19OSQ=s250",
                    "image_thumbnail_url": "https://lh3.googleusercontent.com/MJGJK3cXCoNfo7ai6_CSw9EuwlPZR6AZILPPJV67CTBITyXqO3Xh16vwWpej35t2CzKycFiD4oSAJa3nIRrp28EJfrufcE-toB19OSQ=s128",
                    "image_original_url": null,
                    "animation_url": null,
                    "animation_original_url": null,
                    "name": "Doodle Doodz #0063 (wrapped)",
                    "description": "Doodle Doodz #0063\n\nThis gives you the opportunity to buy the new drops doodz at the previous drops common rate. That means you could unwrap a rare at almost half the price! These will expire if not purchased, so hurry! Each pack contains 1 random NFT. Good luck! If stated more than one in a pack, it means it’s part of a handle deal. \n\nThere will be a total of 1000 1/1 Doodle Doodz with a total supply of 1000. Each drop will consist of 15 Doodz: 10 additional Super Rare Doodz will be added throughout the series & can be obtained as gifts,prizes & special air drops for members with a supply of only 1 each. \n\nSo stay tuned to the Doodz various channels not to miss out! For more info visit our site 🖖 check out Family tree to see how you can SPAWN a free NFT with your Doodle Doodz",
                    "external_link": "https://doodledoodz.app",
                    "asset_contract": {
                        "address": "0x495f947276749ce646f68ac8c248420045cb7b5e",
                        "asset_contract_type": "semi-fungible",
                        "created_date": "2020-12-02T17:40:53.232025",
                        "name": "OpenSea Collection",
                        "nft_version": null,
                        "opensea_version": "2.0.0",
                        "owner": 102384,
                        "schema_name": "ERC1155",
                        "symbol": "OPENSTORE",
                        "total_supply": null,
                        "description": null,
                        "external_link": null,
                        "image_url": null,
                        "default_to_fiat": false,
                        "dev_buyer_fee_basis_points": 0,
                        "dev_seller_fee_basis_points": 0,
                        "only_proxied_transfers": false,
                        "opensea_buyer_fee_basis_points": 0,
                        "opensea_seller_fee_basis_points": 250,
                        "buyer_fee_basis_points": 0,
                        "seller_fee_basis_points": 250,
                        "payout_address": null
                    },
                    "owner": {
                        "user": {
                            "username": "NullAddress"
                        },
                        "profile_img_url": "https://storage.googleapis.com/opensea-static/opensea-profile/1.png",
                        "address": "0x0000000000000000000000000000000000000000",
                        "config": "",
                        "discord_id": ""
                    },
                    "permalink": "https://opensea.io/assets/0x495f947276749ce646f68ac8c248420045cb7b5e/18113136810880385909625812461941578260802280914005851637645524665478533873665",
                    "collection": {
                        "banner_image_url": "https://lh3.googleusercontent.com/dnL546psc4poERNp7pEc5uaRflOW08f3SwNQOIqNSWj1dGKUkmZrTDiC_-t9SKPo1UEGJMPRRbO8fAN8YTP3rASgqiKAWDnixsSeeUA=s2500",
                        "chat_url": null,
                        "created_date": "2021-03-26T01:38:13.859308",
                        "default_to_fiat": false,
                        "description": "There will be a total Supply of 1000 Doodle-Doodz, each uniquely created 1/1 with different traits making some more valuable. a drop will consist of 15 Doodle-Doodz. Each drop will go up in price. ",
                        "dev_buyer_fee_basis_points": "0",
                        "dev_seller_fee_basis_points": "1000",
                        "discord_url": "https://discord.gg/RUXYZDcpgD",
                        "display_data": {
                            "card_display_style": "cover"
                        },
                        "external_url": "http://doodledoodz.app",
                        "featured": false,
                        "featured_image_url": "https://lh3.googleusercontent.com/Z2tF1YmDxYKffPli_0MMHokhOO-Z_LiMc762In8_mJ027WnE5g-3NLq4tUv061mbt6tVuURl1NwWkWPVC2UFLqafUkOhwZo5KEyJ=s300",
                        "hidden": true,
                        "safelist_request_status": "not_requested",
                        "image_url": "https://lh3.googleusercontent.com/vSNu55FSceIbRUaklGdw56D0m3jpfmS8R4LyuW2eeX8ir23EY6YFKeJHl55tBX0iUhVscBfGcClDPwyPb7aB26wO1IrOJHf2uD2w=s120",
                        "is_subject_to_whitelist": false,
                        "large_image_url": "https://lh3.googleusercontent.com/Z2tF1YmDxYKffPli_0MMHokhOO-Z_LiMc762In8_mJ027WnE5g-3NLq4tUv061mbt6tVuURl1NwWkWPVC2UFLqafUkOhwZo5KEyJ=s300",
                        "medium_username": null,
                        "name": "Doodle Doodz",
                        "only_proxied_transfers": false,
                        "opensea_buyer_fee_basis_points": "0",
                        "opensea_seller_fee_basis_points": "250",
                        "payout_address": "0x280bac10abee27e3978d4e1e119066ebc3fad8a5",
                        "require_email": false,
                        "short_description": null,
                        "slug": "doodle-doodz",
                        "telegram_url": null,
                        "twitter_username": "doodledoodz",
                        "instagram_username": "nftdoodledoodz",
                        "wiki_url": null
                    },
                    "decimals": null,
                    "token_metadata": null
                },
                {
                    "id": 25653306,
                    "token_id": "18113136810880385909625812461941578260802280914005851637645524666578045501441",
                    "num_sales": 0,
                    "background_color": null,
                    "image_url": "https://lh3.googleusercontent.com/MJGJK3cXCoNfo7ai6_CSw9EuwlPZR6AZILPPJV67CTBITyXqO3Xh16vwWpej35t2CzKycFiD4oSAJa3nIRrp28EJfrufcE-toB19OSQ",
                    "image_preview_url": "https://lh3.googleusercontent.com/MJGJK3cXCoNfo7ai6_CSw9EuwlPZR6AZILPPJV67CTBITyXqO3Xh16vwWpej35t2CzKycFiD4oSAJa3nIRrp28EJfrufcE-toB19OSQ=s250",
                    "image_thumbnail_url": "https://lh3.googleusercontent.com/MJGJK3cXCoNfo7ai6_CSw9EuwlPZR6AZILPPJV67CTBITyXqO3Xh16vwWpej35t2CzKycFiD4oSAJa3nIRrp28EJfrufcE-toB19OSQ=s128",
                    "image_original_url": null,
                    "animation_url": null,
                    "animation_original_url": null,
                    "name": "Doodle Doodz #0064 (wrapped)",
                    "description": "Doodle Doodz #0064\n\nThis gives you the opportunity to buy the new drops doodz at the previous drops common rate. That means you could unwrap a rare at almost half the price! These will expire if not purchased, so hurry! Each pack contains 1 random NFT. Good luck! If stated more than one in a pack, it means it’s part of a handle deal. \n\nThere will be a total of 1000 1/1 Doodle Doodz with a total supply of 1000. Each drop will consist of 15 Doodz: 10 additional Super Rare Doodz will be added throughout the series & can be obtained as gifts,prizes & special air drops for members with a supply of only 1 each. \n\nSo stay tuned to the Doodz various channels not to miss out! For more info visit our site 🖖 check out Family tree to see how you can SPAWN a free NFT with your Doodle Doodz",
                    "external_link": "https://doodledoodz.app",
                    "asset_contract": {
                        "address": "0x495f947276749ce646f68ac8c248420045cb7b5e",
                        "asset_contract_type": "semi-fungible",
                        "created_date": "2020-12-02T17:40:53.232025",
                        "name": "OpenSea Collection",
                        "nft_version": null,
                        "opensea_version": "2.0.0",
                        "owner": 102384,
                        "schema_name": "ERC1155",
                        "symbol": "OPENSTORE",
                        "total_supply": null,
                        "description": null,
                        "external_link": null,
                        "image_url": null,
                        "default_to_fiat": false,
                        "dev_buyer_fee_basis_points": 0,
                        "dev_seller_fee_basis_points": 0,
                        "only_proxied_transfers": false,
                        "opensea_buyer_fee_basis_points": 0,
                        "opensea_seller_fee_basis_points": 250,
                        "buyer_fee_basis_points": 0,
                        "seller_fee_basis_points": 250,
                        "payout_address": null
                    },
                    "owner": {
                        "user": {
                            "username": "NullAddress"
                        },
                        "profile_img_url": "https://storage.googleapis.com/opensea-static/opensea-profile/1.png",
                        "address": "0x0000000000000000000000000000000000000000",
                        "config": "",
                        "discord_id": ""
                    },
                    "permalink": "https://opensea.io/assets/0x495f947276749ce646f68ac8c248420045cb7b5e/18113136810880385909625812461941578260802280914005851637645524666578045501441",
                    "collection": {
                        "banner_image_url": "https://lh3.googleusercontent.com/dnL546psc4poERNp7pEc5uaRflOW08f3SwNQOIqNSWj1dGKUkmZrTDiC_-t9SKPo1UEGJMPRRbO8fAN8YTP3rASgqiKAWDnixsSeeUA=s2500",
                        "chat_url": null,
                        "created_date": "2021-03-26T01:38:13.859308",
                        "default_to_fiat": false,
                        "description": "There will be a total Supply of 1000 Doodle-Doodz, each uniquely created 1/1 with different traits making some more valuable. a drop will consist of 15 Doodle-Doodz. Each drop will go up in price. ",
                        "dev_buyer_fee_basis_points": "0",
                        "dev_seller_fee_basis_points": "1000",
                        "discord_url": "https://discord.gg/RUXYZDcpgD",
                        "display_data": {
                            "card_display_style": "cover"
                        },
                        "external_url": "http://doodledoodz.app",
                        "featured": false,
                        "featured_image_url": "https://lh3.googleusercontent.com/Z2tF1YmDxYKffPli_0MMHokhOO-Z_LiMc762In8_mJ027WnE5g-3NLq4tUv061mbt6tVuURl1NwWkWPVC2UFLqafUkOhwZo5KEyJ=s300",
                        "hidden": true,
                        "safelist_request_status": "not_requested",
                        "image_url": "https://lh3.googleusercontent.com/vSNu55FSceIbRUaklGdw56D0m3jpfmS8R4LyuW2eeX8ir23EY6YFKeJHl55tBX0iUhVscBfGcClDPwyPb7aB26wO1IrOJHf2uD2w=s120",
                        "is_subject_to_whitelist": false,
                        "large_image_url": "https://lh3.googleusercontent.com/Z2tF1YmDxYKffPli_0MMHokhOO-Z_LiMc762In8_mJ027WnE5g-3NLq4tUv061mbt6tVuURl1NwWkWPVC2UFLqafUkOhwZo5KEyJ=s300",
                        "medium_username": null,
                        "name": "Doodle Doodz",
                        "only_proxied_transfers": false,
                        "opensea_buyer_fee_basis_points": "0",
                        "opensea_seller_fee_basis_points": "250",
                        "payout_address": "0x280bac10abee27e3978d4e1e119066ebc3fad8a5",
                        "require_email": false,
                        "short_description": null,
                        "slug": "doodle-doodz",
                        "telegram_url": null,
                        "twitter_username": "doodledoodz",
                        "instagram_username": "nftdoodledoodz",
                        "wiki_url": null
                    },
                    "decimals": null,
                    "token_metadata": null
                },
                {
                    "id": 25653390,
                    "token_id": "18113136810880385909625812461941578260802280914005851637645524667677557129217",
                    "num_sales": 0,
                    "background_color": null,
                    "image_url": "https://lh3.googleusercontent.com/MJGJK3cXCoNfo7ai6_CSw9EuwlPZR6AZILPPJV67CTBITyXqO3Xh16vwWpej35t2CzKycFiD4oSAJa3nIRrp28EJfrufcE-toB19OSQ",
                    "image_preview_url": "https://lh3.googleusercontent.com/MJGJK3cXCoNfo7ai6_CSw9EuwlPZR6AZILPPJV67CTBITyXqO3Xh16vwWpej35t2CzKycFiD4oSAJa3nIRrp28EJfrufcE-toB19OSQ=s250",
                    "image_thumbnail_url": "https://lh3.googleusercontent.com/MJGJK3cXCoNfo7ai6_CSw9EuwlPZR6AZILPPJV67CTBITyXqO3Xh16vwWpej35t2CzKycFiD4oSAJa3nIRrp28EJfrufcE-toB19OSQ=s128",
                    "image_original_url": null,
                    "animation_url": null,
                    "animation_original_url": null,
                    "name": "Doodle Doodz #0068 (wrapped)",
                    "description": "Doodle Doodz #0061 (wrapped)\n\nThis gives you the opportunity to buy the new drops doodz at the previous drops common rate. That means you could unwrap a rare at almost half the price! These will expire if not purchased, so hurry! Each pack contains 1 random NFT. Good luck! If stated more than one in a pack, it means it’s part of a bundle deal. \n\nThere will be a total of 1000 1/1 Doodle Doodz with a total supply of 1000. Each drop will consist of 15 Doodz: 10 additional Super Rare Doodz will be added throughout the series & can be obtained as gifts,prizes & special air drops for members with a supply of only 1 each. \n\nSo stay tuned to the Doodz various channels not to miss out! For more info visit our site 🖖 check out Family tree to see how you can SPAWN a free NFT with your Doodle Doodz",
                    "external_link": "https://doodledoodz.app",
                    "asset_contract": {
                        "address": "0x495f947276749ce646f68ac8c248420045cb7b5e",
                        "asset_contract_type": "semi-fungible",
                        "created_date": "2020-12-02T17:40:53.232025",
                        "name": "OpenSea Collection",
                        "nft_version": null,
                        "opensea_version": "2.0.0",
                        "owner": 102384,
                        "schema_name": "ERC1155",
                        "symbol": "OPENSTORE",
                        "total_supply": null,
                        "description": null,
                        "external_link": null,
                        "image_url": null,
                        "default_to_fiat": false,
                        "dev_buyer_fee_basis_points": 0,
                        "dev_seller_fee_basis_points": 0,
                        "only_proxied_transfers": false,
                        "opensea_buyer_fee_basis_points": 0,
                        "opensea_seller_fee_basis_points": 250,
                        "buyer_fee_basis_points": 0,
                        "seller_fee_basis_points": 250,
                        "payout_address": null
                    },
                    "owner": {
                        "user": {
                            "username": "NullAddress"
                        },
                        "profile_img_url": "https://storage.googleapis.com/opensea-static/opensea-profile/1.png",
                        "address": "0x0000000000000000000000000000000000000000",
                        "config": "",
                        "discord_id": ""
                    },
                    "permalink": "https://opensea.io/assets/0x495f947276749ce646f68ac8c248420045cb7b5e/18113136810880385909625812461941578260802280914005851637645524667677557129217",
                    "collection": {
                        "banner_image_url": "https://lh3.googleusercontent.com/dnL546psc4poERNp7pEc5uaRflOW08f3SwNQOIqNSWj1dGKUkmZrTDiC_-t9SKPo1UEGJMPRRbO8fAN8YTP3rASgqiKAWDnixsSeeUA=s2500",
                        "chat_url": null,
                        "created_date": "2021-03-26T01:38:13.859308",
                        "default_to_fiat": false,
                        "description": "There will be a total Supply of 1000 Doodle-Doodz, each uniquely created 1/1 with different traits making some more valuable. a drop will consist of 15 Doodle-Doodz. Each drop will go up in price. ",
                        "dev_buyer_fee_basis_points": "0",
                        "dev_seller_fee_basis_points": "1000",
                        "discord_url": "https://discord.gg/RUXYZDcpgD",
                        "display_data": {
                            "card_display_style": "cover"
                        },
                        "external_url": "http://doodledoodz.app",
                        "featured": false,
                        "featured_image_url": "https://lh3.googleusercontent.com/Z2tF1YmDxYKffPli_0MMHokhOO-Z_LiMc762In8_mJ027WnE5g-3NLq4tUv061mbt6tVuURl1NwWkWPVC2UFLqafUkOhwZo5KEyJ=s300",
                        "hidden": true,
                        "safelist_request_status": "not_requested",
                        "image_url": "https://lh3.googleusercontent.com/vSNu55FSceIbRUaklGdw56D0m3jpfmS8R4LyuW2eeX8ir23EY6YFKeJHl55tBX0iUhVscBfGcClDPwyPb7aB26wO1IrOJHf2uD2w=s120",
                        "is_subject_to_whitelist": false,
                        "large_image_url": "https://lh3.googleusercontent.com/Z2tF1YmDxYKffPli_0MMHokhOO-Z_LiMc762In8_mJ027WnE5g-3NLq4tUv061mbt6tVuURl1NwWkWPVC2UFLqafUkOhwZo5KEyJ=s300",
                        "medium_username": null,
                        "name": "Doodle Doodz",
                        "only_proxied_transfers": false,
                        "opensea_buyer_fee_basis_points": "0",
                        "opensea_seller_fee_basis_points": "250",
                        "payout_address": "0x280bac10abee27e3978d4e1e119066ebc3fad8a5",
                        "require_email": false,
                        "short_description": null,
                        "slug": "doodle-doodz",
                        "telegram_url": null,
                        "twitter_username": "doodledoodz",
                        "instagram_username": "nftdoodledoodz",
                        "wiki_url": null
                    },
                    "decimals": null,
                    "token_metadata": null
                }
            ],
            "name": "5 Pack",
            "description": "Includes: #0061 #0062 #0063 #0064 #0068",
            "external_link": "",
            "asset_contract": {
                "collection": {
                    "banner_image_url": null,
                    "chat_url": null,
                    "created_date": "2020-12-02T17:40:53.507540",
                    "default_to_fiat": false,
                    "description": null,
                    "dev_buyer_fee_basis_points": "0",
                    "dev_seller_fee_basis_points": "0",
                    "discord_url": null,
                    "display_data": {
                        "card_display_style": "contain",
                        "images": []
                    },
                    "external_url": null,
                    "featured": false,
                    "featured_image_url": null,
                    "hidden": true,
                    "safelist_request_status": "not_requested",
                    "image_url": null,
                    "is_subject_to_whitelist": false,
                    "large_image_url": null,
                    "medium_username": null,
                    "name": "OpenSea Shared Storefront V2",
                    "only_proxied_transfers": false,
                    "opensea_buyer_fee_basis_points": "0",
                    "opensea_seller_fee_basis_points": "250",
                    "payout_address": null,
                    "require_email": false,
                    "short_description": null,
                    "slug": "opensea-shared-storefront-v2",
                    "telegram_url": null,
                    "twitter_username": null,
                    "instagram_username": null,
                    "wiki_url": null
                },
                "address": "0x495f947276749ce646f68ac8c248420045cb7b5e",
                "asset_contract_type": "semi-fungible",
                "created_date": "2020-12-02T17:40:53.232025",
                "name": "OpenSea Collection",
                "nft_version": null,
                "opensea_version": "2.0.0",
                "owner": 102384,
                "schema_name": "ERC1155",
                "symbol": "OPENSTORE",
                "total_supply": null,
                "description": null,
                "external_link": null,
                "image_url": null,
                "default_to_fiat": false,
                "dev_buyer_fee_basis_points": 0,
                "dev_seller_fee_basis_points": 0,
                "only_proxied_transfers": false,
                "opensea_buyer_fee_basis_points": 0,
                "opensea_seller_fee_basis_points": 250,
                "buyer_fee_basis_points": 0,
                "seller_fee_basis_points": 250,
                "payout_address": null
            },
            "permalink": "https://opensea.io/bundles/5-pack-39a",
            "sell_orders": [
                {
                    "created_date": "2021-05-25T20:33:18.133377",
                    "closing_date": null,
                    "closing_extendable": false,
                    "expiration_time": 0,
                    "listing_time": 1621980000,
                    "order_hash": "0x2a6864e8a4ab6b742b72a3b6101dfb85fa44bc56a2a707a6751647d7cab8d4f9",
                    "metadata": {
                        "bundle": {
                            "assets": [
                                {
                                    "id": "18113136810880385909625812461941578260802280914005851637645524663279510618113",
                                    "address": "0x495f947276749ce646f68ac8c248420045cb7b5e",
                                    "quantity": "1"
                                },
                                {
                                    "id": "18113136810880385909625812461941578260802280914005851637645524664379022245889",
                                    "address": "0x495f947276749ce646f68ac8c248420045cb7b5e",
                                    "quantity": "1"
                                },
                                {
                                    "id": "18113136810880385909625812461941578260802280914005851637645524665478533873665",
                                    "address": "0x495f947276749ce646f68ac8c248420045cb7b5e",
                                    "quantity": "1"
                                },
                                {
                                    "id": "18113136810880385909625812461941578260802280914005851637645524666578045501441",
                                    "address": "0x495f947276749ce646f68ac8c248420045cb7b5e",
                                    "quantity": "1"
                                },
                                {
                                    "id": "18113136810880385909625812461941578260802280914005851637645524667677557129217",
                                    "address": "0x495f947276749ce646f68ac8c248420045cb7b5e",
                                    "quantity": "1"
                                }
                            ],
                            "schemas": [
                                "ERC1155",
                                "ERC1155",
                                "ERC1155",
                                "ERC1155",
                                "ERC1155"
                            ],
                            "name": "5 Pack",
                            "description": "Includes: #0061 #0062 #0063 #0064 #0068",
                            "external_link": ""
                        }
                    },
                    "exchange": "0x7be8076f4ea4a4ad08075c2508e481d6c946d12b",
                    "maker": {
                        "user": 472027,
                        "profile_img_url": "https://storage.googleapis.com/opensea-static/opensea-profile/14.png",
                        "address": "0x280bac10abee27e3978d4e1e119066ebc3fad8a5",
                        "config": "",
                        "discord_id": ""
                    },
                    "taker": {
                        "user": 1766,
                        "profile_img_url": "https://storage.googleapis.com/opensea-static/opensea-profile/1.png",
                        "address": "0x0000000000000000000000000000000000000000",
                        "config": "",
                        "discord_id": ""
                    },
                    "current_price": "110000000000000000",
                    "current_bounty": "1100000000000000",
                    "bounty_multiple": "0.01",
                    "maker_relayer_fee": "1250",
                    "taker_relayer_fee": "0",
                    "maker_protocol_fee": "0",
                    "taker_protocol_fee": "0",
                    "maker_referrer_fee": "0",
                    "fee_recipient": {
                        "user": 3585,
                        "profile_img_url": "https://storage.googleapis.com/opensea-static/opensea-profile/28.png",
                        "address": "0x5b3256965e7c3cf26e11fcaf296dfc8807c01073",
                        "config": "verified",
                        "discord_id": ""
                    },
                    "fee_method": 1,
                    "side": 1,
                    "sale_kind": 0,
                    "target": "0xc99f70bfd82fb7c8f8191fdfbfb735606b15e5c5",
                    "how_to_call": 1,
                    "calldata": "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",
                    "replacement_pattern": "0x0000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000ffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffff0000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000ffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffff0000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000ffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffff0000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000ffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffff0000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000ffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffff0000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000",
                    "static_target": "0x0000000000000000000000000000000000000000",
                    "static_extradata": "0x",
                    "payment_token": "0x0000000000000000000000000000000000000000",
                    "payment_token_contract": {
                        "id": 1,
                        "symbol": "ETH",
                        "address": "0x0000000000000000000000000000000000000000",
                        "image_url": "https://storage.opensea.io/files/6f8e2979d428180222796ff4a33ab929.svg",
                        "name": "Ether",
                        "decimals": 18,
                        "eth_price": "1.000000000000000",
                        "usd_price": "2625.730000000000018000"
                    },
                    "base_price": "110000000000000000",
                    "extra": "0",
                    "quantity": "1",
                    "salt": "49988517475076399181748693825033592432516091801506144352884241403541242172694",
                    "v": 27,
                    "r": "0xe6faae59ddb341820c58461d8036596d3002cd308398cdae6825f5319cde2e47",
                    "s": "0x605740b5968502970e286d207764fa7c3da0d556e7488211ae050e2e4fda4198",
                    "approved_on_chain": false,
                    "cancelled": false,
                    "finalized": false,
                    "marked_invalid": false,
                    "prefixed_hash": "0x92b5cfab17ee37c3d6d7778dcc47dd59e5eacafc06710208e902563594f556aa"
                }
            ]
        },
        {
            "maker": {
                "user": {
                    "username": "ONE8"
                },
                "profile_img_url": "https://storage.googleapis.com/opensea-static/opensea-profile/14.png",
                "address": "0x280bac10abee27e3978d4e1e119066ebc3fad8a5",
                "config": "",
                "discord_id": ""
            },
            "slug": "3-pack-NH3",
            "assets": [
                {
                    "id": 25653466,
                    "token_id": "18113136810880385909625812461941578260802280914005851637645524668777068756993",
                    "num_sales": 0,
                    "background_color": null,
                    "image_url": "https://lh3.googleusercontent.com/6lQtq24qvggYAs3Pz2vFMpAnfJBnrUjXEP-Qy63K2_0N9jWpSPCNBad9TdXl_BC5EAPsrZ65yrilJQpmRwi8UUYS0nqNA8lUfGg6D_U",
                    "image_preview_url": "https://lh3.googleusercontent.com/6lQtq24qvggYAs3Pz2vFMpAnfJBnrUjXEP-Qy63K2_0N9jWpSPCNBad9TdXl_BC5EAPsrZ65yrilJQpmRwi8UUYS0nqNA8lUfGg6D_U=s250",
                    "image_thumbnail_url": "https://lh3.googleusercontent.com/6lQtq24qvggYAs3Pz2vFMpAnfJBnrUjXEP-Qy63K2_0N9jWpSPCNBad9TdXl_BC5EAPsrZ65yrilJQpmRwi8UUYS0nqNA8lUfGg6D_U=s128",
                    "image_original_url": null,
                    "animation_url": null,
                    "animation_original_url": null,
                    "name": "Doodle Doodz #0065 (wrapped)",
                    "description": "Doodle Doodz #0065\n\nThis gives you the opportunity to buy the new drops doodz at the previous drops common rate. That means you could unwrap a rare at almost half the price! These will expire if not purchased, so hurry! Each pack contains 1 random NFT. Good luck! If stated more than one in a pack, it means it’s part of a bundle deal. \n\nThere will be a total of 1000 1/1 Doodle Doodz with a total supply of 1000. Each drop will consist of 15 Doodz: 10 additional Super Rare Doodz will be added throughout the series & can be obtained as gifts,prizes & special air drops for members with a supply of only 1 each. \n\nSo stay tuned to the Doodz various channels not to miss out! For more info visit our site 🖖 check out Family tree to see how you can SPAWN a free NFT with your Doodle Doodz",
                    "external_link": "https://doodledoodz.app",
                    "asset_contract": {
                        "address": "0x495f947276749ce646f68ac8c248420045cb7b5e",
                        "asset_contract_type": "semi-fungible",
                        "created_date": "2020-12-02T17:40:53.232025",
                        "name": "OpenSea Collection",
                        "nft_version": null,
                        "opensea_version": "2.0.0",
                        "owner": 102384,
                        "schema_name": "ERC1155",
                        "symbol": "OPENSTORE",
                        "total_supply": null,
                        "description": null,
                        "external_link": null,
                        "image_url": null,
                        "default_to_fiat": false,
                        "dev_buyer_fee_basis_points": 0,
                        "dev_seller_fee_basis_points": 0,
                        "only_proxied_transfers": false,
                        "opensea_buyer_fee_basis_points": 0,
                        "opensea_seller_fee_basis_points": 250,
                        "buyer_fee_basis_points": 0,
                        "seller_fee_basis_points": 250,
                        "payout_address": null
                    },
                    "owner": {
                        "user": {
                            "username": "NullAddress"
                        },
                        "profile_img_url": "https://storage.googleapis.com/opensea-static/opensea-profile/1.png",
                        "address": "0x0000000000000000000000000000000000000000",
                        "config": "",
                        "discord_id": ""
                    },
                    "permalink": "https://opensea.io/assets/0x495f947276749ce646f68ac8c248420045cb7b5e/18113136810880385909625812461941578260802280914005851637645524668777068756993",
                    "collection": {
                        "banner_image_url": "https://lh3.googleusercontent.com/dnL546psc4poERNp7pEc5uaRflOW08f3SwNQOIqNSWj1dGKUkmZrTDiC_-t9SKPo1UEGJMPRRbO8fAN8YTP3rASgqiKAWDnixsSeeUA=s2500",
                        "chat_url": null,
                        "created_date": "2021-03-26T01:38:13.859308",
                        "default_to_fiat": false,
                        "description": "There will be a total Supply of 1000 Doodle-Doodz, each uniquely created 1/1 with different traits making some more valuable. a drop will consist of 15 Doodle-Doodz. Each drop will go up in price. ",
                        "dev_buyer_fee_basis_points": "0",
                        "dev_seller_fee_basis_points": "1000",
                        "discord_url": "https://discord.gg/RUXYZDcpgD",
                        "display_data": {
                            "card_display_style": "cover"
                        },
                        "external_url": "http://doodledoodz.app",
                        "featured": false,
                        "featured_image_url": "https://lh3.googleusercontent.com/Z2tF1YmDxYKffPli_0MMHokhOO-Z_LiMc762In8_mJ027WnE5g-3NLq4tUv061mbt6tVuURl1NwWkWPVC2UFLqafUkOhwZo5KEyJ=s300",
                        "hidden": true,
                        "safelist_request_status": "not_requested",
                        "image_url": "https://lh3.googleusercontent.com/vSNu55FSceIbRUaklGdw56D0m3jpfmS8R4LyuW2eeX8ir23EY6YFKeJHl55tBX0iUhVscBfGcClDPwyPb7aB26wO1IrOJHf2uD2w=s120",
                        "is_subject_to_whitelist": false,
                        "large_image_url": "https://lh3.googleusercontent.com/Z2tF1YmDxYKffPli_0MMHokhOO-Z_LiMc762In8_mJ027WnE5g-3NLq4tUv061mbt6tVuURl1NwWkWPVC2UFLqafUkOhwZo5KEyJ=s300",
                        "medium_username": null,
                        "name": "Doodle Doodz",
                        "only_proxied_transfers": false,
                        "opensea_buyer_fee_basis_points": "0",
                        "opensea_seller_fee_basis_points": "250",
                        "payout_address": "0x280bac10abee27e3978d4e1e119066ebc3fad8a5",
                        "require_email": false,
                        "short_description": null,
                        "slug": "doodle-doodz",
                        "telegram_url": null,
                        "twitter_username": "doodledoodz",
                        "instagram_username": "nftdoodledoodz",
                        "wiki_url": null
                    },
                    "decimals": null,
                    "token_metadata": null
                },
                {
                    "id": 25653552,
                    "token_id": "18113136810880385909625812461941578260802280914005851637645524669876580384769",
                    "num_sales": 0,
                    "background_color": null,
                    "image_url": "https://lh3.googleusercontent.com/6lQtq24qvggYAs3Pz2vFMpAnfJBnrUjXEP-Qy63K2_0N9jWpSPCNBad9TdXl_BC5EAPsrZ65yrilJQpmRwi8UUYS0nqNA8lUfGg6D_U",
                    "image_preview_url": "https://lh3.googleusercontent.com/6lQtq24qvggYAs3Pz2vFMpAnfJBnrUjXEP-Qy63K2_0N9jWpSPCNBad9TdXl_BC5EAPsrZ65yrilJQpmRwi8UUYS0nqNA8lUfGg6D_U=s250",
                    "image_thumbnail_url": "https://lh3.googleusercontent.com/6lQtq24qvggYAs3Pz2vFMpAnfJBnrUjXEP-Qy63K2_0N9jWpSPCNBad9TdXl_BC5EAPsrZ65yrilJQpmRwi8UUYS0nqNA8lUfGg6D_U=s128",
                    "image_original_url": null,
                    "animation_url": null,
                    "animation_original_url": null,
                    "name": "Doodle Doodz #0066 (wrapped)",
                    "description": "Doodle Doodz #0066\n\nThis gives you the opportunity to buy the new drops doodz at the previous drops common rate. That means you could unwrap a rare at almost half the price! These will expire if not purchased, so hurry! Each pack contains 1 random NFT. Good luck! If stated more than one in a pack, it means it’s part of a bundle deal. \n\nThere will be a total of 1000 1/1 Doodle Doodz with a total supply of 1000. Each drop will consist of 15 Doodz: 10 additional Super Rare Doodz will be added throughout the series & can be obtained as gifts,prizes & special air drops for members with a supply of only 1 each. \n\nSo stay tuned to the Doodz various channels not to miss out! For more info visit our site 🖖 check out Family tree to see how you can SPAWN a free NFT with your Doodle Doodz",
                    "external_link": "https://doodledoodz.app",
                    "asset_contract": {
                        "address": "0x495f947276749ce646f68ac8c248420045cb7b5e",
                        "asset_contract_type": "semi-fungible",
                        "created_date": "2020-12-02T17:40:53.232025",
                        "name": "OpenSea Collection",
                        "nft_version": null,
                        "opensea_version": "2.0.0",
                        "owner": 102384,
                        "schema_name": "ERC1155",
                        "symbol": "OPENSTORE",
                        "total_supply": null,
                        "description": null,
                        "external_link": null,
                        "image_url": null,
                        "default_to_fiat": false,
                        "dev_buyer_fee_basis_points": 0,
                        "dev_seller_fee_basis_points": 0,
                        "only_proxied_transfers": false,
                        "opensea_buyer_fee_basis_points": 0,
                        "opensea_seller_fee_basis_points": 250,
                        "buyer_fee_basis_points": 0,
                        "seller_fee_basis_points": 250,
                        "payout_address": null
                    },
                    "owner": {
                        "user": {
                            "username": "NullAddress"
                        },
                        "profile_img_url": "https://storage.googleapis.com/opensea-static/opensea-profile/1.png",
                        "address": "0x0000000000000000000000000000000000000000",
                        "config": "",
                        "discord_id": ""
                    },
                    "permalink": "https://opensea.io/assets/0x495f947276749ce646f68ac8c248420045cb7b5e/18113136810880385909625812461941578260802280914005851637645524669876580384769",
                    "collection": {
                        "banner_image_url": "https://lh3.googleusercontent.com/dnL546psc4poERNp7pEc5uaRflOW08f3SwNQOIqNSWj1dGKUkmZrTDiC_-t9SKPo1UEGJMPRRbO8fAN8YTP3rASgqiKAWDnixsSeeUA=s2500",
                        "chat_url": null,
                        "created_date": "2021-03-26T01:38:13.859308",
                        "default_to_fiat": false,
                        "description": "There will be a total Supply of 1000 Doodle-Doodz, each uniquely created 1/1 with different traits making some more valuable. a drop will consist of 15 Doodle-Doodz. Each drop will go up in price. ",
                        "dev_buyer_fee_basis_points": "0",
                        "dev_seller_fee_basis_points": "1000",
                        "discord_url": "https://discord.gg/RUXYZDcpgD",
                        "display_data": {
                            "card_display_style": "cover"
                        },
                        "external_url": "http://doodledoodz.app",
                        "featured": false,
                        "featured_image_url": "https://lh3.googleusercontent.com/Z2tF1YmDxYKffPli_0MMHokhOO-Z_LiMc762In8_mJ027WnE5g-3NLq4tUv061mbt6tVuURl1NwWkWPVC2UFLqafUkOhwZo5KEyJ=s300",
                        "hidden": true,
                        "safelist_request_status": "not_requested",
                        "image_url": "https://lh3.googleusercontent.com/vSNu55FSceIbRUaklGdw56D0m3jpfmS8R4LyuW2eeX8ir23EY6YFKeJHl55tBX0iUhVscBfGcClDPwyPb7aB26wO1IrOJHf2uD2w=s120",
                        "is_subject_to_whitelist": false,
                        "large_image_url": "https://lh3.googleusercontent.com/Z2tF1YmDxYKffPli_0MMHokhOO-Z_LiMc762In8_mJ027WnE5g-3NLq4tUv061mbt6tVuURl1NwWkWPVC2UFLqafUkOhwZo5KEyJ=s300",
                        "medium_username": null,
                        "name": "Doodle Doodz",
                        "only_proxied_transfers": false,
                        "opensea_buyer_fee_basis_points": "0",
                        "opensea_seller_fee_basis_points": "250",
                        "payout_address": "0x280bac10abee27e3978d4e1e119066ebc3fad8a5",
                        "require_email": false,
                        "short_description": null,
                        "slug": "doodle-doodz",
                        "telegram_url": null,
                        "twitter_username": "doodledoodz",
                        "instagram_username": "nftdoodledoodz",
                        "wiki_url": null
                    },
                    "decimals": null,
                    "token_metadata": null
                },
                {
                    "id": 25653618,
                    "token_id": "18113136810880385909625812461941578260802280914005851637645524670976092012545",
                    "num_sales": 0,
                    "background_color": null,
                    "image_url": "https://lh3.googleusercontent.com/6lQtq24qvggYAs3Pz2vFMpAnfJBnrUjXEP-Qy63K2_0N9jWpSPCNBad9TdXl_BC5EAPsrZ65yrilJQpmRwi8UUYS0nqNA8lUfGg6D_U",
                    "image_preview_url": "https://lh3.googleusercontent.com/6lQtq24qvggYAs3Pz2vFMpAnfJBnrUjXEP-Qy63K2_0N9jWpSPCNBad9TdXl_BC5EAPsrZ65yrilJQpmRwi8UUYS0nqNA8lUfGg6D_U=s250",
                    "image_thumbnail_url": "https://lh3.googleusercontent.com/6lQtq24qvggYAs3Pz2vFMpAnfJBnrUjXEP-Qy63K2_0N9jWpSPCNBad9TdXl_BC5EAPsrZ65yrilJQpmRwi8UUYS0nqNA8lUfGg6D_U=s128",
                    "image_original_url": null,
                    "animation_url": null,
                    "animation_original_url": null,
                    "name": "Doodle Doodz #0069 (wrapped)",
                    "description": "Doodle Doodz #0069\n\nThis gives you the opportunity to buy the new drops doodz at the previous drops common rate. That means you could unwrap a rare at almost half the price! These will expire if not purchased, so hurry! Each pack contains 1 random NFT. Good luck! If stated more than one in a pack, it means it’s part of a handle deal. \n\nThere will be a total of 1000 1/1 Doodle Doodz with a total supply of 1000. Each drop will consist of 15 Doodz: 10 additional Super Rare Doodz will be added throughout the series & can be obtained as gifts,prizes & special air drops for members with a supply of only 1 each. \n\nSo stay tuned to the Doodz various channels not to miss out! For more info visit our site 🖖 check out Family tree to see how you can SPAWN a free NFT with your Doodle Doodz",
                    "external_link": "https://doodledoodz.app",
                    "asset_contract": {
                        "address": "0x495f947276749ce646f68ac8c248420045cb7b5e",
                        "asset_contract_type": "semi-fungible",
                        "created_date": "2020-12-02T17:40:53.232025",
                        "name": "OpenSea Collection",
                        "nft_version": null,
                        "opensea_version": "2.0.0",
                        "owner": 102384,
                        "schema_name": "ERC1155",
                        "symbol": "OPENSTORE",
                        "total_supply": null,
                        "description": null,
                        "external_link": null,
                        "image_url": null,
                        "default_to_fiat": false,
                        "dev_buyer_fee_basis_points": 0,
                        "dev_seller_fee_basis_points": 0,
                        "only_proxied_transfers": false,
                        "opensea_buyer_fee_basis_points": 0,
                        "opensea_seller_fee_basis_points": 250,
                        "buyer_fee_basis_points": 0,
                        "seller_fee_basis_points": 250,
                        "payout_address": null
                    },
                    "owner": {
                        "user": {
                            "username": "NullAddress"
                        },
                        "profile_img_url": "https://storage.googleapis.com/opensea-static/opensea-profile/1.png",
                        "address": "0x0000000000000000000000000000000000000000",
                        "config": "",
                        "discord_id": ""
                    },
                    "permalink": "https://opensea.io/assets/0x495f947276749ce646f68ac8c248420045cb7b5e/18113136810880385909625812461941578260802280914005851637645524670976092012545",
                    "collection": {
                        "banner_image_url": "https://lh3.googleusercontent.com/dnL546psc4poERNp7pEc5uaRflOW08f3SwNQOIqNSWj1dGKUkmZrTDiC_-t9SKPo1UEGJMPRRbO8fAN8YTP3rASgqiKAWDnixsSeeUA=s2500",
                        "chat_url": null,
                        "created_date": "2021-03-26T01:38:13.859308",
                        "default_to_fiat": false,
                        "description": "There will be a total Supply of 1000 Doodle-Doodz, each uniquely created 1/1 with different traits making some more valuable. a drop will consist of 15 Doodle-Doodz. Each drop will go up in price. ",
                        "dev_buyer_fee_basis_points": "0",
                        "dev_seller_fee_basis_points": "1000",
                        "discord_url": "https://discord.gg/RUXYZDcpgD",
                        "display_data": {
                            "card_display_style": "cover"
                        },
                        "external_url": "http://doodledoodz.app",
                        "featured": false,
                        "featured_image_url": "https://lh3.googleusercontent.com/Z2tF1YmDxYKffPli_0MMHokhOO-Z_LiMc762In8_mJ027WnE5g-3NLq4tUv061mbt6tVuURl1NwWkWPVC2UFLqafUkOhwZo5KEyJ=s300",
                        "hidden": true,
                        "safelist_request_status": "not_requested",
                        "image_url": "https://lh3.googleusercontent.com/vSNu55FSceIbRUaklGdw56D0m3jpfmS8R4LyuW2eeX8ir23EY6YFKeJHl55tBX0iUhVscBfGcClDPwyPb7aB26wO1IrOJHf2uD2w=s120",
                        "is_subject_to_whitelist": false,
                        "large_image_url": "https://lh3.googleusercontent.com/Z2tF1YmDxYKffPli_0MMHokhOO-Z_LiMc762In8_mJ027WnE5g-3NLq4tUv061mbt6tVuURl1NwWkWPVC2UFLqafUkOhwZo5KEyJ=s300",
                        "medium_username": null,
                        "name": "Doodle Doodz",
                        "only_proxied_transfers": false,
                        "opensea_buyer_fee_basis_points": "0",
                        "opensea_seller_fee_basis_points": "250",
                        "payout_address": "0x280bac10abee27e3978d4e1e119066ebc3fad8a5",
                        "require_email": false,
                        "short_description": null,
                        "slug": "doodle-doodz",
                        "telegram_url": null,
                        "twitter_username": "doodledoodz",
                        "instagram_username": "nftdoodledoodz",
                        "wiki_url": null
                    },
                    "decimals": null,
                    "token_metadata": null
                }
            ],
            "name": "3 Pack",
            "description": "Includes: #0065 #0066 #0069",
            "external_link": "",
            "asset_contract": {
                "collection": {
                    "banner_image_url": null,
                    "chat_url": null,
                    "created_date": "2020-12-02T17:40:53.507540",
                    "default_to_fiat": false,
                    "description": null,
                    "dev_buyer_fee_basis_points": "0",
                    "dev_seller_fee_basis_points": "0",
                    "discord_url": null,
                    "display_data": {
                        "card_display_style": "contain",
                        "images": []
                    },
                    "external_url": null,
                    "featured": false,
                    "featured_image_url": null,
                    "hidden": true,
                    "safelist_request_status": "not_requested",
                    "image_url": null,
                    "is_subject_to_whitelist": false,
                    "large_image_url": null,
                    "medium_username": null,
                    "name": "OpenSea Shared Storefront V2",
                    "only_proxied_transfers": false,
                    "opensea_buyer_fee_basis_points": "0",
                    "opensea_seller_fee_basis_points": "250",
                    "payout_address": null,
                    "require_email": false,
                    "short_description": null,
                    "slug": "opensea-shared-storefront-v2",
                    "telegram_url": null,
                    "twitter_username": null,
                    "instagram_username": null,
                    "wiki_url": null
                },
                "address": "0x495f947276749ce646f68ac8c248420045cb7b5e",
                "asset_contract_type": "semi-fungible",
                "created_date": "2020-12-02T17:40:53.232025",
                "name": "OpenSea Collection",
                "nft_version": null,
                "opensea_version": "2.0.0",
                "owner": 102384,
                "schema_name": "ERC1155",
                "symbol": "OPENSTORE",
                "total_supply": null,
                "description": null,
                "external_link": null,
                "image_url": null,
                "default_to_fiat": false,
                "dev_buyer_fee_basis_points": 0,
                "dev_seller_fee_basis_points": 0,
                "only_proxied_transfers": false,
                "opensea_buyer_fee_basis_points": 0,
                "opensea_seller_fee_basis_points": 250,
                "buyer_fee_basis_points": 0,
                "seller_fee_basis_points": 250,
                "payout_address": null
            },
            "permalink": "https://opensea.io/bundles/3-pack-NH3",
            "sell_orders": [
                {
                    "created_date": "2021-05-25T20:29:15.138081",
                    "closing_date": null,
                    "closing_extendable": false,
                    "expiration_time": 0,
                    "listing_time": 1621974445,
                    "order_hash": "0xdd0d88631055c8a6b8381ca03c3c2f051fa5bfea7223c94316817c997b3231f3",
                    "metadata": {
                        "bundle": {
                            "assets": [
                                {
                                    "id": "18113136810880385909625812461941578260802280914005851637645524668777068756993",
                                    "address": "0x495f947276749ce646f68ac8c248420045cb7b5e",
                                    "quantity": "1"
                                },
                                {
                                    "id": "18113136810880385909625812461941578260802280914005851637645524669876580384769",
                                    "address": "0x495f947276749ce646f68ac8c248420045cb7b5e",
                                    "quantity": "1"
                                },
                                {
                                    "id": "18113136810880385909625812461941578260802280914005851637645524670976092012545",
                                    "address": "0x495f947276749ce646f68ac8c248420045cb7b5e",
                                    "quantity": "1"
                                }
                            ],
                            "schemas": [
                                "ERC1155",
                                "ERC1155",
                                "ERC1155"
                            ],
                            "name": "3 Pack",
                            "description": "Includes: #0065 #0066 #0069",
                            "external_link": ""
                        }
                    },
                    "exchange": "0x7be8076f4ea4a4ad08075c2508e481d6c946d12b",
                    "maker": {
                        "user": 472027,
                        "profile_img_url": "https://storage.googleapis.com/opensea-static/opensea-profile/14.png",
                        "address": "0x280bac10abee27e3978d4e1e119066ebc3fad8a5",
                        "config": "",
                        "discord_id": ""
                    },
                    "taker": {
                        "user": 1766,
                        "profile_img_url": "https://storage.googleapis.com/opensea-static/opensea-profile/1.png",
                        "address": "0x0000000000000000000000000000000000000000",
                        "config": "",
                        "discord_id": ""
                    },
                    "current_price": "66000000000000000",
                    "current_bounty": "660000000000000",
                    "bounty_multiple": "0.01",
                    "maker_relayer_fee": "1250",
                    "taker_relayer_fee": "0",
                    "maker_protocol_fee": "0",
                    "taker_protocol_fee": "0",
                    "maker_referrer_fee": "0",
                    "fee_recipient": {
                        "user": 3585,
                        "profile_img_url": "https://storage.googleapis.com/opensea-static/opensea-profile/28.png",
                        "address": "0x5b3256965e7c3cf26e11fcaf296dfc8807c01073",
                        "config": "verified",
                        "discord_id": ""
                    },
                    "fee_method": 1,
                    "side": 1,
                    "sale_kind": 0,
                    "target": "0xc99f70bfd82fb7c8f8191fdfbfb735606b15e5c5",
                    "how_to_call": 1,
                    "calldata": "0x68f0bcaa00000000000000000000000000000000000000000000000000000000000000800000000000000000000000000000000000000000000000000000000000000100000000000000000000000000000000000000000000000000000000000000018000000000000000000000000000000000000000000000000000000000000002000000000000000000000000000000000000000000000000000000000000000003000000000000000000000000495f947276749ce646f68ac8c248420045cb7b5e000000000000000000000000495f947276749ce646f68ac8c248420045cb7b5e000000000000000000000000495f947276749ce646f68ac8c248420045cb7b5e0000000000000000000000000000000000000000000000000000000000000003000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000300000000000000000000000000000000000000000000000000000000000000c400000000000000000000000000000000000000000000000000000000000000c400000000000000000000000000000000000000000000000000000000000000c4000000000000000000000000000000000000000000000000000000000000024cf242432a000000000000000000000000280bac10abee27e3978d4e1e119066ebc3fad8a50000000000000000000000000000000000000000000000000000000000000000280bac10abee27e3978d4e1e119066ebc3fad8a5000000000000860000000001000000000000000000000000000000000000000000000000000000000000000100000000000000000000000000000000000000000000000000000000000000a00000000000000000000000000000000000000000000000000000000000000000f242432a000000000000000000000000280bac10abee27e3978d4e1e119066ebc3fad8a50000000000000000000000000000000000000000000000000000000000000000280bac10abee27e3978d4e1e119066ebc3fad8a5000000000000870000000001000000000000000000000000000000000000000000000000000000000000000100000000000000000000000000000000000000000000000000000000000000a00000000000000000000000000000000000000000000000000000000000000000f242432a000000000000000000000000280bac10abee27e3978d4e1e119066ebc3fad8a50000000000000000000000000000000000000000000000000000000000000000280bac10abee27e3978d4e1e119066ebc3fad8a5000000000000880000000001000000000000000000000000000000000000000000000000000000000000000100000000000000000000000000000000000000000000000000000000000000a000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000",
                    "replacement_pattern": "0x0000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000ffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffff0000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000ffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffff0000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000ffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffff00000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000",
                    "static_target": "0x0000000000000000000000000000000000000000",
                    "static_extradata": "0x",
                    "payment_token": "0x0000000000000000000000000000000000000000",
                    "payment_token_contract": {
                        "id": 1,
                        "symbol": "ETH",
                        "address": "0x0000000000000000000000000000000000000000",
                        "image_url": "https://storage.opensea.io/files/6f8e2979d428180222796ff4a33ab929.svg",
                        "name": "Ether",
                        "decimals": 18,
                        "eth_price": "1.000000000000000",
                        "usd_price": "2625.730000000000018000"
                    },
                    "base_price": "66000000000000000",
                    "extra": "0",
                    "quantity": "1",
                    "salt": "3252608464370923372939803283375765149475020755621229552924769788653304540811",
                    "v": 27,
                    "r": "0x8193e86050394c0c94ded96c3599a5183cf1c42b2218f56a7288e3d749f8343a",
                    "s": "0x0bb8faa770807b6e22381860a363194a2fd461f80463f9ade72a9ee2d9d2f002",
                    "approved_on_chain": false,
                    "cancelled": false,
                    "finalized": false,
                    "marked_invalid": false,
                    "prefixed_hash": "0xec049536ae895f0976724736ea211061b511c4bd74176a418df89ea2fbf5bb33"
                }
            ]
        },
        {
            "maker": {
                "user": {
                    "username": "ONE8"
                },
                "profile_img_url": "https://storage.googleapis.com/opensea-static/opensea-profile/14.png",
                "address": "0x280bac10abee27e3978d4e1e119066ebc3fad8a5",
                "config": "",
                "discord_id": ""
            },
            "slug": "2-pack-bTs",
            "assets": [
                {
                    "id": 25653732,
                    "token_id": "18113136810880385909625812461941578260802280914005851637645524672075603640321",
                    "num_sales": 0,
                    "background_color": null,
                    "image_url": "https://lh3.googleusercontent.com/dHoakGosb8xFHVMwhO4_jPACTie1UpFWob2u97hfCjlZ6nSB8Ks8q6bCtvb81LwDGByf6yzg1a2OO5YoR4rK37_cxYSwaYyGBYBLIw",
                    "image_preview_url": "https://lh3.googleusercontent.com/dHoakGosb8xFHVMwhO4_jPACTie1UpFWob2u97hfCjlZ6nSB8Ks8q6bCtvb81LwDGByf6yzg1a2OO5YoR4rK37_cxYSwaYyGBYBLIw=s250",
                    "image_thumbnail_url": "https://lh3.googleusercontent.com/dHoakGosb8xFHVMwhO4_jPACTie1UpFWob2u97hfCjlZ6nSB8Ks8q6bCtvb81LwDGByf6yzg1a2OO5YoR4rK37_cxYSwaYyGBYBLIw=s128",
                    "image_original_url": null,
                    "animation_url": null,
                    "animation_original_url": null,
                    "name": "Doodle Doodz #0067 (wrapped)",
                    "description": "Doodle Doodz #0067\n\nThis gives you the opportunity to buy the new drops doodz at the previous drops common rate. That means you could unwrap a rare at almost half the price! These will expire if not purchased, so hurry! Each pack contains 1 random NFT. Good luck! If stated more than one in a pack, it means it’s part of a handle deal. \n\nThere will be a total of 1000 1/1 Doodle Doodz with a total supply of 1000. Each drop will consist of 15 Doodz: 10 additional Super Rare Doodz will be added throughout the series & can be obtained as gifts,prizes & special air drops for members with a supply of only 1 each. \n\nSo stay tuned to the Doodz various channels not to miss out! For more info visit our site 🖖 check out Family tree to see how you can SPAWN a free NFT with your Doodle Doodz",
                    "external_link": "https://doodledoodz.app",
                    "asset_contract": {
                        "address": "0x495f947276749ce646f68ac8c248420045cb7b5e",
                        "asset_contract_type": "semi-fungible",
                        "created_date": "2020-12-02T17:40:53.232025",
                        "name": "OpenSea Collection",
                        "nft_version": null,
                        "opensea_version": "2.0.0",
                        "owner": 102384,
                        "schema_name": "ERC1155",
                        "symbol": "OPENSTORE",
                        "total_supply": null,
                        "description": null,
                        "external_link": null,
                        "image_url": null,
                        "default_to_fiat": false,
                        "dev_buyer_fee_basis_points": 0,
                        "dev_seller_fee_basis_points": 0,
                        "only_proxied_transfers": false,
                        "opensea_buyer_fee_basis_points": 0,
                        "opensea_seller_fee_basis_points": 250,
                        "buyer_fee_basis_points": 0,
                        "seller_fee_basis_points": 250,
                        "payout_address": null
                    },
                    "owner": {
                        "user": {
                            "username": "NullAddress"
                        },
                        "profile_img_url": "https://storage.googleapis.com/opensea-static/opensea-profile/1.png",
                        "address": "0x0000000000000000000000000000000000000000",
                        "config": "",
                        "discord_id": ""
                    },
                    "permalink": "https://opensea.io/assets/0x495f947276749ce646f68ac8c248420045cb7b5e/18113136810880385909625812461941578260802280914005851637645524672075603640321",
                    "collection": {
                        "banner_image_url": "https://lh3.googleusercontent.com/dnL546psc4poERNp7pEc5uaRflOW08f3SwNQOIqNSWj1dGKUkmZrTDiC_-t9SKPo1UEGJMPRRbO8fAN8YTP3rASgqiKAWDnixsSeeUA=s2500",
                        "chat_url": null,
                        "created_date": "2021-03-26T01:38:13.859308",
                        "default_to_fiat": false,
                        "description": "There will be a total Supply of 1000 Doodle-Doodz, each uniquely created 1/1 with different traits making some more valuable. a drop will consist of 15 Doodle-Doodz. Each drop will go up in price. ",
                        "dev_buyer_fee_basis_points": "0",
                        "dev_seller_fee_basis_points": "1000",
                        "discord_url": "https://discord.gg/RUXYZDcpgD",
                        "display_data": {
                            "card_display_style": "cover"
                        },
                        "external_url": "http://doodledoodz.app",
                        "featured": false,
                        "featured_image_url": "https://lh3.googleusercontent.com/Z2tF1YmDxYKffPli_0MMHokhOO-Z_LiMc762In8_mJ027WnE5g-3NLq4tUv061mbt6tVuURl1NwWkWPVC2UFLqafUkOhwZo5KEyJ=s300",
                        "hidden": true,
                        "safelist_request_status": "not_requested",
                        "image_url": "https://lh3.googleusercontent.com/vSNu55FSceIbRUaklGdw56D0m3jpfmS8R4LyuW2eeX8ir23EY6YFKeJHl55tBX0iUhVscBfGcClDPwyPb7aB26wO1IrOJHf2uD2w=s120",
                        "is_subject_to_whitelist": false,
                        "large_image_url": "https://lh3.googleusercontent.com/Z2tF1YmDxYKffPli_0MMHokhOO-Z_LiMc762In8_mJ027WnE5g-3NLq4tUv061mbt6tVuURl1NwWkWPVC2UFLqafUkOhwZo5KEyJ=s300",
                        "medium_username": null,
                        "name": "Doodle Doodz",
                        "only_proxied_transfers": false,
                        "opensea_buyer_fee_basis_points": "0",
                        "opensea_seller_fee_basis_points": "250",
                        "payout_address": "0x280bac10abee27e3978d4e1e119066ebc3fad8a5",
                        "require_email": false,
                        "short_description": null,
                        "slug": "doodle-doodz",
                        "telegram_url": null,
                        "twitter_username": "doodledoodz",
                        "instagram_username": "nftdoodledoodz",
                        "wiki_url": null
                    },
                    "decimals": null,
                    "token_metadata": null
                },
                {
                    "id": 25653820,
                    "token_id": "18113136810880385909625812461941578260802280914005851637645524673175115268097",
                    "num_sales": 0,
                    "background_color": null,
                    "image_url": "https://lh3.googleusercontent.com/dHoakGosb8xFHVMwhO4_jPACTie1UpFWob2u97hfCjlZ6nSB8Ks8q6bCtvb81LwDGByf6yzg1a2OO5YoR4rK37_cxYSwaYyGBYBLIw",
                    "image_preview_url": "https://lh3.googleusercontent.com/dHoakGosb8xFHVMwhO4_jPACTie1UpFWob2u97hfCjlZ6nSB8Ks8q6bCtvb81LwDGByf6yzg1a2OO5YoR4rK37_cxYSwaYyGBYBLIw=s250",
                    "image_thumbnail_url": "https://lh3.googleusercontent.com/dHoakGosb8xFHVMwhO4_jPACTie1UpFWob2u97hfCjlZ6nSB8Ks8q6bCtvb81LwDGByf6yzg1a2OO5YoR4rK37_cxYSwaYyGBYBLIw=s128",
                    "image_original_url": null,
                    "animation_url": null,
                    "animation_original_url": null,
                    "name": "Doodle Doodz #0071 (wrapped)",
                    "description": "Doodle Doodz #0071\n\nThis gives you the opportunity to buy the new drops doodz at the previous drops common rate. That means you could unwrap a rare at almost half the price! These will expire if not purchased, so hurry! Each pack contains 1 random NFT. Good luck! If stated more than one in a pack, it means it’s part of a bundle deal. \n\nThere will be a total of 1000 1/1 Doodle Doodz with a total supply of 1000. Each drop will consist of 15 Doodz: 10 additional Super Rare Doodz will be added throughout the series & can be obtained as gifts,prizes & special air drops for members with a supply of only 1 each. \n\nSo stay tuned to the Doodz various channels not to miss out! For more info visit our site 🖖 check out Family tree to see how you can SPAWN a free NFT with your Doodle Doodz",
                    "external_link": "https://doodledoodz.app",
                    "asset_contract": {
                        "address": "0x495f947276749ce646f68ac8c248420045cb7b5e",
                        "asset_contract_type": "semi-fungible",
                        "created_date": "2020-12-02T17:40:53.232025",
                        "name": "OpenSea Collection",
                        "nft_version": null,
                        "opensea_version": "2.0.0",
                        "owner": 102384,
                        "schema_name": "ERC1155",
                        "symbol": "OPENSTORE",
                        "total_supply": null,
                        "description": null,
                        "external_link": null,
                        "image_url": null,
                        "default_to_fiat": false,
                        "dev_buyer_fee_basis_points": 0,
                        "dev_seller_fee_basis_points": 0,
                        "only_proxied_transfers": false,
                        "opensea_buyer_fee_basis_points": 0,
                        "opensea_seller_fee_basis_points": 250,
                        "buyer_fee_basis_points": 0,
                        "seller_fee_basis_points": 250,
                        "payout_address": null
                    },
                    "owner": {
                        "user": {
                            "username": "NullAddress"
                        },
                        "profile_img_url": "https://storage.googleapis.com/opensea-static/opensea-profile/1.png",
                        "address": "0x0000000000000000000000000000000000000000",
                        "config": "",
                        "discord_id": ""
                    },
                    "permalink": "https://opensea.io/assets/0x495f947276749ce646f68ac8c248420045cb7b5e/18113136810880385909625812461941578260802280914005851637645524673175115268097",
                    "collection": {
                        "banner_image_url": "https://lh3.googleusercontent.com/dnL546psc4poERNp7pEc5uaRflOW08f3SwNQOIqNSWj1dGKUkmZrTDiC_-t9SKPo1UEGJMPRRbO8fAN8YTP3rASgqiKAWDnixsSeeUA=s2500",
                        "chat_url": null,
                        "created_date": "2021-03-26T01:38:13.859308",
                        "default_to_fiat": false,
                        "description": "There will be a total Supply of 1000 Doodle-Doodz, each uniquely created 1/1 with different traits making some more valuable. a drop will consist of 15 Doodle-Doodz. Each drop will go up in price. ",
                        "dev_buyer_fee_basis_points": "0",
                        "dev_seller_fee_basis_points": "1000",
                        "discord_url": "https://discord.gg/RUXYZDcpgD",
                        "display_data": {
                            "card_display_style": "cover"
                        },
                        "external_url": "http://doodledoodz.app",
                        "featured": false,
                        "featured_image_url": "https://lh3.googleusercontent.com/Z2tF1YmDxYKffPli_0MMHokhOO-Z_LiMc762In8_mJ027WnE5g-3NLq4tUv061mbt6tVuURl1NwWkWPVC2UFLqafUkOhwZo5KEyJ=s300",
                        "hidden": true,
                        "safelist_request_status": "not_requested",
                        "image_url": "https://lh3.googleusercontent.com/vSNu55FSceIbRUaklGdw56D0m3jpfmS8R4LyuW2eeX8ir23EY6YFKeJHl55tBX0iUhVscBfGcClDPwyPb7aB26wO1IrOJHf2uD2w=s120",
                        "is_subject_to_whitelist": false,
                        "large_image_url": "https://lh3.googleusercontent.com/Z2tF1YmDxYKffPli_0MMHokhOO-Z_LiMc762In8_mJ027WnE5g-3NLq4tUv061mbt6tVuURl1NwWkWPVC2UFLqafUkOhwZo5KEyJ=s300",
                        "medium_username": null,
                        "name": "Doodle Doodz",
                        "only_proxied_transfers": false,
                        "opensea_buyer_fee_basis_points": "0",
                        "opensea_seller_fee_basis_points": "250",
                        "payout_address": "0x280bac10abee27e3978d4e1e119066ebc3fad8a5",
                        "require_email": false,
                        "short_description": null,
                        "slug": "doodle-doodz",
                        "telegram_url": null,
                        "twitter_username": "doodledoodz",
                        "instagram_username": "nftdoodledoodz",
                        "wiki_url": null
                    },
                    "decimals": null,
                    "token_metadata": null
                }
            ],
            "name": "2 Pack",
            "description": "Pack Includes #0067 #0071",
            "external_link": "",
            "asset_contract": {
                "collection": {
                    "banner_image_url": null,
                    "chat_url": null,
                    "created_date": "2020-12-02T17:40:53.507540",
                    "default_to_fiat": false,
                    "description": null,
                    "dev_buyer_fee_basis_points": "0",
                    "dev_seller_fee_basis_points": "0",
                    "discord_url": null,
                    "display_data": {
                        "card_display_style": "contain",
                        "images": []
                    },
                    "external_url": null,
                    "featured": false,
                    "featured_image_url": null,
                    "hidden": true,
                    "safelist_request_status": "not_requested",
                    "image_url": null,
                    "is_subject_to_whitelist": false,
                    "large_image_url": null,
                    "medium_username": null,
                    "name": "OpenSea Shared Storefront V2",
                    "only_proxied_transfers": false,
                    "opensea_buyer_fee_basis_points": "0",
                    "opensea_seller_fee_basis_points": "250",
                    "payout_address": null,
                    "require_email": false,
                    "short_description": null,
                    "slug": "opensea-shared-storefront-v2",
                    "telegram_url": null,
                    "twitter_username": null,
                    "instagram_username": null,
                    "wiki_url": null
                },
                "address": "0x495f947276749ce646f68ac8c248420045cb7b5e",
                "asset_contract_type": "semi-fungible",
                "created_date": "2020-12-02T17:40:53.232025",
                "name": "OpenSea Collection",
                "nft_version": null,
                "opensea_version": "2.0.0",
                "owner": 102384,
                "schema_name": "ERC1155",
                "symbol": "OPENSTORE",
                "total_supply": null,
                "description": null,
                "external_link": null,
                "image_url": null,
                "default_to_fiat": false,
                "dev_buyer_fee_basis_points": 0,
                "dev_seller_fee_basis_points": 0,
                "only_proxied_transfers": false,
                "opensea_buyer_fee_basis_points": 0,
                "opensea_seller_fee_basis_points": 250,
                "buyer_fee_basis_points": 0,
                "seller_fee_basis_points": 250,
                "payout_address": null
            },
            "permalink": "https://opensea.io/bundles/2-pack-bTs",
            "sell_orders": [
                {
                    "created_date": "2021-05-25T20:27:01.949345",
                    "closing_date": null,
                    "closing_extendable": false,
                    "expiration_time": 0,
                    "listing_time": 1621980000,
                    "order_hash": "0x01df6d6e7f4a02bfa73255f448a1460c5ce6125dce2dde61375d5cf9f5bd20aa",
                    "metadata": {
                        "bundle": {
                            "assets": [
                                {
                                    "id": "18113136810880385909625812461941578260802280914005851637645524672075603640321",
                                    "address": "0x495f947276749ce646f68ac8c248420045cb7b5e",
                                    "quantity": "1"
                                },
                                {
                                    "id": "18113136810880385909625812461941578260802280914005851637645524673175115268097",
                                    "address": "0x495f947276749ce646f68ac8c248420045cb7b5e",
                                    "quantity": "1"
                                }
                            ],
                            "schemas": [
                                "ERC1155",
                                "ERC1155"
                            ],
                            "name": "2 Pack",
                            "description": "Pack Includes #0067 #0071",
                            "external_link": ""
                        }
                    },
                    "exchange": "0x7be8076f4ea4a4ad08075c2508e481d6c946d12b",
                    "maker": {
                        "user": 472027,
                        "profile_img_url": "https://storage.googleapis.com/opensea-static/opensea-profile/14.png",
                        "address": "0x280bac10abee27e3978d4e1e119066ebc3fad8a5",
                        "config": "",
                        "discord_id": ""
                    },
                    "taker": {
                        "user": 1766,
                        "profile_img_url": "https://storage.googleapis.com/opensea-static/opensea-profile/1.png",
                        "address": "0x0000000000000000000000000000000000000000",
                        "config": "",
                        "discord_id": ""
                    },
                    "current_price": "44000000000000000",
                    "current_bounty": "440000000000000",
                    "bounty_multiple": "0.01",
                    "maker_relayer_fee": "1250",
                    "taker_relayer_fee": "0",
                    "maker_protocol_fee": "0",
                    "taker_protocol_fee": "0",
                    "maker_referrer_fee": "0",
                    "fee_recipient": {
                        "user": 3585,
                        "profile_img_url": "https://storage.googleapis.com/opensea-static/opensea-profile/28.png",
                        "address": "0x5b3256965e7c3cf26e11fcaf296dfc8807c01073",
                        "config": "verified",
                        "discord_id": ""
                    },
                    "fee_method": 1,
                    "side": 1,
                    "sale_kind": 0,
                    "target": "0xc99f70bfd82fb7c8f8191fdfbfb735606b15e5c5",
                    "how_to_call": 1,
                    "calldata": "0x68f0bcaa000000000000000000000000000000000000000000000000000000000000008000000000000000000000000000000000000000000000000000000000000000e0000000000000000000000000000000000000000000000000000000000000014000000000000000000000000000000000000000000000000000000000000001a00000000000000000000000000000000000000000000000000000000000000002000000000000000000000000495f947276749ce646f68ac8c248420045cb7b5e000000000000000000000000495f947276749ce646f68ac8c248420045cb7b5e000000000000000000000000000000000000000000000000000000000000000200000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000200000000000000000000000000000000000000000000000000000000000000c400000000000000000000000000000000000000000000000000000000000000c40000000000000000000000000000000000000000000000000000000000000188f242432a000000000000000000000000280bac10abee27e3978d4e1e119066ebc3fad8a50000000000000000000000000000000000000000000000000000000000000000280bac10abee27e3978d4e1e119066ebc3fad8a5000000000000890000000001000000000000000000000000000000000000000000000000000000000000000100000000000000000000000000000000000000000000000000000000000000a00000000000000000000000000000000000000000000000000000000000000000f242432a000000000000000000000000280bac10abee27e3978d4e1e119066ebc3fad8a50000000000000000000000000000000000000000000000000000000000000000280bac10abee27e3978d4e1e119066ebc3fad8a50000000000008a0000000001000000000000000000000000000000000000000000000000000000000000000100000000000000000000000000000000000000000000000000000000000000a00000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000",
                    "replacement_pattern": "0x0000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000ffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffff0000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000ffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffff0000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000",
                    "static_target": "0x0000000000000000000000000000000000000000",
                    "static_extradata": "0x",
                    "payment_token": "0x0000000000000000000000000000000000000000",
                    "payment_token_contract": {
                        "id": 1,
                        "symbol": "ETH",
                        "address": "0x0000000000000000000000000000000000000000",
                        "image_url": "https://storage.opensea.io/files/6f8e2979d428180222796ff4a33ab929.svg",
                        "name": "Ether",
                        "decimals": 18,
                        "eth_price": "1.000000000000000",
                        "usd_price": "2625.730000000000018000"
                    },
                    "base_price": "44000000000000000",
                    "extra": "0",
                    "quantity": "1",
                    "salt": "58868549029646267952726977161072344165717464306158741500619728850501928931012",
                    "v": 28,
                    "r": "0x9a57ce1a67015ecf01b43edd1c84a60cabad89725bbe85d738e85236be727af5",
                    "s": "0x0d82af28f2ee41b6f07604738dde0aa09107030136b688f0ee454eaaa43e463b",
                    "approved_on_chain": false,
                    "cancelled": false,
                    "finalized": false,
                    "marked_invalid": false,
                    "prefixed_hash": "0x00d3bef7aecc5d6b34b52c9eb21802b45ed604c48050f12cfe9afaa0d19acac7"
                }
            ]
        },
        {
            "maker": {
                "user": {
                    "username": "NFT_Arts"
                },
                "profile_img_url": "https://storage.googleapis.com/opensea-static/opensea-profile/14.png",
                "address": "0x19c15f85e57fc0c780527fa9a57bad7630948099",
                "config": "",
                "discord_id": ""
            },
            "slug": "dont-give-a-fuck-chronobundle-9uq",
            "assets": [
                {
                    "id": 25660695,
                    "token_id": "11649481973828809065726319200282038590073976728382359933062055010096310648833",
                    "num_sales": 0,
                    "background_color": null,
                    "image_url": "https://lh3.googleusercontent.com/_5d-wjVyn1djXeypOBL-vHPYlKxvcBlY5170JtixI0r3HzRbbGciaXaddtQZGQNmKEllIfH0o7CoWvo-cBfNJ2qV4M2ebURDSAcfiA",
                    "image_preview_url": "https://lh3.googleusercontent.com/_5d-wjVyn1djXeypOBL-vHPYlKxvcBlY5170JtixI0r3HzRbbGciaXaddtQZGQNmKEllIfH0o7CoWvo-cBfNJ2qV4M2ebURDSAcfiA=s250",
                    "image_thumbnail_url": "https://lh3.googleusercontent.com/_5d-wjVyn1djXeypOBL-vHPYlKxvcBlY5170JtixI0r3HzRbbGciaXaddtQZGQNmKEllIfH0o7CoWvo-cBfNJ2qV4M2ebURDSAcfiA=s128",
                    "image_original_url": null,
                    "animation_url": null,
                    "animation_original_url": null,
                    "name": "Don't Give a Fuck ChronoArt",
                    "description": null,
                    "external_link": null,
                    "asset_contract": {
                        "address": "0x495f947276749ce646f68ac8c248420045cb7b5e",
                        "asset_contract_type": "semi-fungible",
                        "created_date": "2020-12-02T17:40:53.232025",
                        "name": "OpenSea Collection",
                        "nft_version": null,
                        "opensea_version": "2.0.0",
                        "owner": 102384,
                        "schema_name": "ERC1155",
                        "symbol": "OPENSTORE",
                        "total_supply": null,
                        "description": null,
                        "external_link": null,
                        "image_url": null,
                        "default_to_fiat": false,
                        "dev_buyer_fee_basis_points": 0,
                        "dev_seller_fee_basis_points": 0,
                        "only_proxied_transfers": false,
                        "opensea_buyer_fee_basis_points": 0,
                        "opensea_seller_fee_basis_points": 250,
                        "buyer_fee_basis_points": 0,
                        "seller_fee_basis_points": 250,
                        "payout_address": null
                    },
                    "owner": {
                        "user": {
                            "username": "NullAddress"
                        },
                        "profile_img_url": "https://storage.googleapis.com/opensea-static/opensea-profile/1.png",
                        "address": "0x0000000000000000000000000000000000000000",
                        "config": "",
                        "discord_id": ""
                    },
                    "permalink": "https://opensea.io/assets/0x495f947276749ce646f68ac8c248420045cb7b5e/11649481973828809065726319200282038590073976728382359933062055010096310648833",
                    "collection": {
                        "banner_image_url": null,
                        "chat_url": null,
                        "created_date": "2021-05-25T20:14:05.702457",
                        "default_to_fiat": false,
                        "description": "",
                        "dev_buyer_fee_basis_points": "0",
                        "dev_seller_fee_basis_points": "0",
                        "discord_url": null,
                        "display_data": {
                            "card_display_style": "contain",
                            "images": []
                        },
                        "external_url": null,
                        "featured": false,
                        "featured_image_url": null,
                        "hidden": true,
                        "safelist_request_status": "not_requested",
                        "image_url": "https://lh3.googleusercontent.com/lgvpTGFLscvM9IfUAsF587OXyPdebakJ4jQsDiTC3w7T5fom-R4fwd3ORr9xXyEPSC9-4iaDXHiPliSbrYyEyzg1I5mPsdlHghzD=s120",
                        "is_subject_to_whitelist": false,
                        "large_image_url": null,
                        "medium_username": null,
                        "name": "Don't Give a Fuck",
                        "only_proxied_transfers": false,
                        "opensea_buyer_fee_basis_points": "0",
                        "opensea_seller_fee_basis_points": "250",
                        "payout_address": null,
                        "require_email": false,
                        "short_description": null,
                        "slug": "don-t-give-a-fuck",
                        "telegram_url": null,
                        "twitter_username": null,
                        "instagram_username": null,
                        "wiki_url": null
                    },
                    "decimals": null,
                    "token_metadata": null
                },
                {
                    "id": 25660709,
                    "token_id": "11649481973828809065726319200282038590073976728382359933062055011195822276609",
                    "num_sales": 0,
                    "background_color": null,
                    "image_url": "https://lh3.googleusercontent.com/P98b05550TzOKyGLg-IWyGO3GbqUnbIJz6y3rx_j1HyYeH8adU0JPZTFyNHxSu1arfqqGRiaDAS-kOzS-yDyLxKJauuA2yi--5aGKQ",
                    "image_preview_url": "https://lh3.googleusercontent.com/P98b05550TzOKyGLg-IWyGO3GbqUnbIJz6y3rx_j1HyYeH8adU0JPZTFyNHxSu1arfqqGRiaDAS-kOzS-yDyLxKJauuA2yi--5aGKQ=s250",
                    "image_thumbnail_url": "https://lh3.googleusercontent.com/P98b05550TzOKyGLg-IWyGO3GbqUnbIJz6y3rx_j1HyYeH8adU0JPZTFyNHxSu1arfqqGRiaDAS-kOzS-yDyLxKJauuA2yi--5aGKQ=s128",
                    "image_original_url": null,
                    "animation_url": null,
                    "animation_original_url": null,
                    "name": "Don't Give a Fuck ChronoArt 2",
                    "description": null,
                    "external_link": null,
                    "asset_contract": {
                        "address": "0x495f947276749ce646f68ac8c248420045cb7b5e",
                        "asset_contract_type": "semi-fungible",
                        "created_date": "2020-12-02T17:40:53.232025",
                        "name": "OpenSea Collection",
                        "nft_version": null,
                        "opensea_version": "2.0.0",
                        "owner": 102384,
                        "schema_name": "ERC1155",
                        "symbol": "OPENSTORE",
                        "total_supply": null,
                        "description": null,
                        "external_link": null,
                        "image_url": null,
                        "default_to_fiat": false,
                        "dev_buyer_fee_basis_points": 0,
                        "dev_seller_fee_basis_points": 0,
                        "only_proxied_transfers": false,
                        "opensea_buyer_fee_basis_points": 0,
                        "opensea_seller_fee_basis_points": 250,
                        "buyer_fee_basis_points": 0,
                        "seller_fee_basis_points": 250,
                        "payout_address": null
                    },
                    "owner": {
                        "user": {
                            "username": "NullAddress"
                        },
                        "profile_img_url": "https://storage.googleapis.com/opensea-static/opensea-profile/1.png",
                        "address": "0x0000000000000000000000000000000000000000",
                        "config": "",
                        "discord_id": ""
                    },
                    "permalink": "https://opensea.io/assets/0x495f947276749ce646f68ac8c248420045cb7b5e/11649481973828809065726319200282038590073976728382359933062055011195822276609",
                    "collection": {
                        "banner_image_url": null,
                        "chat_url": null,
                        "created_date": "2021-05-25T20:14:05.702457",
                        "default_to_fiat": false,
                        "description": "",
                        "dev_buyer_fee_basis_points": "0",
                        "dev_seller_fee_basis_points": "0",
                        "discord_url": null,
                        "display_data": {
                            "card_display_style": "contain",
                            "images": []
                        },
                        "external_url": null,
                        "featured": false,
                        "featured_image_url": null,
                        "hidden": true,
                        "safelist_request_status": "not_requested",
                        "image_url": "https://lh3.googleusercontent.com/lgvpTGFLscvM9IfUAsF587OXyPdebakJ4jQsDiTC3w7T5fom-R4fwd3ORr9xXyEPSC9-4iaDXHiPliSbrYyEyzg1I5mPsdlHghzD=s120",
                        "is_subject_to_whitelist": false,
                        "large_image_url": null,
                        "medium_username": null,
                        "name": "Don't Give a Fuck",
                        "only_proxied_transfers": false,
                        "opensea_buyer_fee_basis_points": "0",
                        "opensea_seller_fee_basis_points": "250",
                        "payout_address": null,
                        "require_email": false,
                        "short_description": null,
                        "slug": "don-t-give-a-fuck",
                        "telegram_url": null,
                        "twitter_username": null,
                        "instagram_username": null,
                        "wiki_url": null
                    },
                    "decimals": null,
                    "token_metadata": null
                },
                {
                    "id": 25660722,
                    "token_id": "11649481973828809065726319200282038590073976728382359933062055012295333904385",
                    "num_sales": 0,
                    "background_color": null,
                    "image_url": "https://lh3.googleusercontent.com/mBnPzaoLyK6Koy0qf-iYOR-W5mL6hL6_NBiPOuYeNHhgVoAREYErtXC2XfiyuRv9vA0ac8EQ11ubO3sG8oP1fZFP-COpM5BMeL3jEnc",
                    "image_preview_url": "https://lh3.googleusercontent.com/mBnPzaoLyK6Koy0qf-iYOR-W5mL6hL6_NBiPOuYeNHhgVoAREYErtXC2XfiyuRv9vA0ac8EQ11ubO3sG8oP1fZFP-COpM5BMeL3jEnc=s250",
                    "image_thumbnail_url": "https://lh3.googleusercontent.com/mBnPzaoLyK6Koy0qf-iYOR-W5mL6hL6_NBiPOuYeNHhgVoAREYErtXC2XfiyuRv9vA0ac8EQ11ubO3sG8oP1fZFP-COpM5BMeL3jEnc=s128",
                    "image_original_url": null,
                    "animation_url": null,
                    "animation_original_url": null,
                    "name": "Don't Give a Fuck ChronoArtCrazy",
                    "description": null,
                    "external_link": null,
                    "asset_contract": {
                        "address": "0x495f947276749ce646f68ac8c248420045cb7b5e",
                        "asset_contract_type": "semi-fungible",
                        "created_date": "2020-12-02T17:40:53.232025",
                        "name": "OpenSea Collection",
                        "nft_version": null,
                        "opensea_version": "2.0.0",
                        "owner": 102384,
                        "schema_name": "ERC1155",
                        "symbol": "OPENSTORE",
                        "total_supply": null,
                        "description": null,
                        "external_link": null,
                        "image_url": null,
                        "default_to_fiat": false,
                        "dev_buyer_fee_basis_points": 0,
                        "dev_seller_fee_basis_points": 0,
                        "only_proxied_transfers": false,
                        "opensea_buyer_fee_basis_points": 0,
                        "opensea_seller_fee_basis_points": 250,
                        "buyer_fee_basis_points": 0,
                        "seller_fee_basis_points": 250,
                        "payout_address": null
                    },
                    "owner": {
                        "user": {
                            "username": "NullAddress"
                        },
                        "profile_img_url": "https://storage.googleapis.com/opensea-static/opensea-profile/1.png",
                        "address": "0x0000000000000000000000000000000000000000",
                        "config": "",
                        "discord_id": ""
                    },
                    "permalink": "https://opensea.io/assets/0x495f947276749ce646f68ac8c248420045cb7b5e/11649481973828809065726319200282038590073976728382359933062055012295333904385",
                    "collection": {
                        "banner_image_url": null,
                        "chat_url": null,
                        "created_date": "2021-05-25T20:14:05.702457",
                        "default_to_fiat": false,
                        "description": "",
                        "dev_buyer_fee_basis_points": "0",
                        "dev_seller_fee_basis_points": "0",
                        "discord_url": null,
                        "display_data": {
                            "card_display_style": "contain",
                            "images": []
                        },
                        "external_url": null,
                        "featured": false,
                        "featured_image_url": null,
                        "hidden": true,
                        "safelist_request_status": "not_requested",
                        "image_url": "https://lh3.googleusercontent.com/lgvpTGFLscvM9IfUAsF587OXyPdebakJ4jQsDiTC3w7T5fom-R4fwd3ORr9xXyEPSC9-4iaDXHiPliSbrYyEyzg1I5mPsdlHghzD=s120",
                        "is_subject_to_whitelist": false,
                        "large_image_url": null,
                        "medium_username": null,
                        "name": "Don't Give a Fuck",
                        "only_proxied_transfers": false,
                        "opensea_buyer_fee_basis_points": "0",
                        "opensea_seller_fee_basis_points": "250",
                        "payout_address": null,
                        "require_email": false,
                        "short_description": null,
                        "slug": "don-t-give-a-fuck",
                        "telegram_url": null,
                        "twitter_username": null,
                        "instagram_username": null,
                        "wiki_url": null
                    },
                    "decimals": null,
                    "token_metadata": null
                }
            ],
            "name": "Don‘t Give a Fuck ChronoBundle",
            "description": "Full Chrono Bundle",
            "external_link": "",
            "asset_contract": {
                "collection": {
                    "banner_image_url": null,
                    "chat_url": null,
                    "created_date": "2020-12-02T17:40:53.507540",
                    "default_to_fiat": false,
                    "description": null,
                    "dev_buyer_fee_basis_points": "0",
                    "dev_seller_fee_basis_points": "0",
                    "discord_url": null,
                    "display_data": {
                        "card_display_style": "contain",
                        "images": []
                    },
                    "external_url": null,
                    "featured": false,
                    "featured_image_url": null,
                    "hidden": true,
                    "safelist_request_status": "not_requested",
                    "image_url": null,
                    "is_subject_to_whitelist": false,
                    "large_image_url": null,
                    "medium_username": null,
                    "name": "OpenSea Shared Storefront V2",
                    "only_proxied_transfers": false,
                    "opensea_buyer_fee_basis_points": "0",
                    "opensea_seller_fee_basis_points": "250",
                    "payout_address": null,
                    "require_email": false,
                    "short_description": null,
                    "slug": "opensea-shared-storefront-v2",
                    "telegram_url": null,
                    "twitter_username": null,
                    "instagram_username": null,
                    "wiki_url": null
                },
                "address": "0x495f947276749ce646f68ac8c248420045cb7b5e",
                "asset_contract_type": "semi-fungible",
                "created_date": "2020-12-02T17:40:53.232025",
                "name": "OpenSea Collection",
                "nft_version": null,
                "opensea_version": "2.0.0",
                "owner": 102384,
                "schema_name": "ERC1155",
                "symbol": "OPENSTORE",
                "total_supply": null,
                "description": null,
                "external_link": null,
                "image_url": null,
                "default_to_fiat": false,
                "dev_buyer_fee_basis_points": 0,
                "dev_seller_fee_basis_points": 0,
                "only_proxied_transfers": false,
                "opensea_buyer_fee_basis_points": 0,
                "opensea_seller_fee_basis_points": 250,
                "buyer_fee_basis_points": 0,
                "seller_fee_basis_points": 250,
                "payout_address": null
            },
            "permalink": "https://opensea.io/bundles/dont-give-a-fuck-chronobundle-9uq",
            "sell_orders": [
                {
                    "created_date": "2021-05-25T20:26:50.074305",
                    "closing_date": null,
                    "closing_extendable": false,
                    "expiration_time": 0,
                    "listing_time": 1621974302,
                    "order_hash": "0x9071a6faa524a772bacc2ae4c12cd0083111779af8d9613d24e24d28910572a8",
                    "metadata": {
                        "bundle": {
                            "assets": [
                                {
                                    "id": "11649481973828809065726319200282038590073976728382359933062055010096310648833",
                                    "address": "0x495f947276749ce646f68ac8c248420045cb7b5e",
                                    "quantity": "1"
                                },
                                {
                                    "id": "11649481973828809065726319200282038590073976728382359933062055011195822276609",
                                    "address": "0x495f947276749ce646f68ac8c248420045cb7b5e",
                                    "quantity": "1"
                                },
                                {
                                    "id": "11649481973828809065726319200282038590073976728382359933062055012295333904385",
                                    "address": "0x495f947276749ce646f68ac8c248420045cb7b5e",
                                    "quantity": "1"
                                }
                            ],
                            "schemas": [
                                "ERC1155",
                                "ERC1155",
                                "ERC1155"
                            ],
                            "name": "Don‘t Give a Fuck ChronoBundle",
                            "description": "Full Chrono Bundle",
                            "external_link": ""
                        }
                    },
                    "exchange": "0x7be8076f4ea4a4ad08075c2508e481d6c946d12b",
                    "maker": {
                        "user": 838981,
                        "profile_img_url": "https://storage.googleapis.com/opensea-static/opensea-profile/14.png",
                        "address": "0x19c15f85e57fc0c780527fa9a57bad7630948099",
                        "config": "",
                        "discord_id": ""
                    },
                    "taker": {
                        "user": 1766,
                        "profile_img_url": "https://storage.googleapis.com/opensea-static/opensea-profile/1.png",
                        "address": "0x0000000000000000000000000000000000000000",
                        "config": "",
                        "discord_id": ""
                    },
                    "current_price": "1234500000000000000",
                    "current_bounty": "12345000000000000",
                    "bounty_multiple": "0.01",
                    "maker_relayer_fee": "250",
                    "taker_relayer_fee": "0",
                    "maker_protocol_fee": "0",
                    "taker_protocol_fee": "0",
                    "maker_referrer_fee": "0",
                    "fee_recipient": {
                        "user": 3585,
                        "profile_img_url": "https://storage.googleapis.com/opensea-static/opensea-profile/28.png",
                        "address": "0x5b3256965e7c3cf26e11fcaf296dfc8807c01073",
                        "config": "verified",
                        "discord_id": ""
                    },
                    "fee_method": 1,
                    "side": 1,
                    "sale_kind": 0,
                    "target": "0xc99f70bfd82fb7c8f8191fdfbfb735606b15e5c5",
                    "how_to_call": 1,
                    "calldata": "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",
                    "replacement_pattern": "0x0000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000ffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffff0000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000ffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffff0000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000ffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffff00000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000",
                    "static_target": "0x0000000000000000000000000000000000000000",
                    "static_extradata": "0x",
                    "payment_token": "0x0000000000000000000000000000000000000000",
                    "payment_token_contract": {
                        "id": 1,
                        "symbol": "ETH",
                        "address": "0x0000000000000000000000000000000000000000",
                        "image_url": "https://storage.opensea.io/files/6f8e2979d428180222796ff4a33ab929.svg",
                        "name": "Ether",
                        "decimals": 18,
                        "eth_price": "1.000000000000000",
                        "usd_price": "2625.730000000000018000"
                    },
                    "base_price": "1234500000000000000",
                    "extra": "0",
                    "quantity": "1",
                    "salt": "40126441559563992801737469836987188466558591471081720989635704932954266602354",
                    "v": 27,
                    "r": "0x1dba64bf4ad59f35728bfe3805f714f72b05bb057797c288d2a9916bea4b14ab",
                    "s": "0x5b618459505c48a92f74d2a1bed540cf272b03faf9e1b1bfd584a294a82437b1",
                    "approved_on_chain": false,
                    "cancelled": false,
                    "finalized": false,
                    "marked_invalid": false,
                    "prefixed_hash": "0x63a81f1aad74dd6b0a136f724bf507ba4a5d015e91261bba22efece83a7b2a17"
                }
            ]
        },
        {
            "maker": {
                "user": {
                    "username": "NFT_Arts"
                },
                "profile_img_url": "https://storage.googleapis.com/opensea-static/opensea-profile/14.png",
                "address": "0x19c15f85e57fc0c780527fa9a57bad7630948099",
                "config": "",
                "discord_id": ""
            },
            "slug": "dont-give-a-fuck-artwork-bundle-yP4",
            "assets": [
                {
                    "id": 25660777,
                    "token_id": "11649481973828809065726319200282038590073976728382359933062055013394845532161",
                    "num_sales": 0,
                    "background_color": null,
                    "image_url": "https://lh3.googleusercontent.com/F6l6sEJznfFudyGFznptqp3_rAo04dUaFSFoDj093JDeoQsjWO8VRvGpIEBBVBZh8JvL3wTVqdo81-nQXBhqRfMEywo8TE0YnQAm",
                    "image_preview_url": "https://lh3.googleusercontent.com/F6l6sEJznfFudyGFznptqp3_rAo04dUaFSFoDj093JDeoQsjWO8VRvGpIEBBVBZh8JvL3wTVqdo81-nQXBhqRfMEywo8TE0YnQAm=s250",
                    "image_thumbnail_url": "https://lh3.googleusercontent.com/F6l6sEJznfFudyGFznptqp3_rAo04dUaFSFoDj093JDeoQsjWO8VRvGpIEBBVBZh8JvL3wTVqdo81-nQXBhqRfMEywo8TE0YnQAm=s128",
                    "image_original_url": null,
                    "animation_url": null,
                    "animation_original_url": null,
                    "name": "Don't Give a Fuck Artwork 001",
                    "description": null,
                    "external_link": null,
                    "asset_contract": {
                        "address": "0x495f947276749ce646f68ac8c248420045cb7b5e",
                        "asset_contract_type": "semi-fungible",
                        "created_date": "2020-12-02T17:40:53.232025",
                        "name": "OpenSea Collection",
                        "nft_version": null,
                        "opensea_version": "2.0.0",
                        "owner": 102384,
                        "schema_name": "ERC1155",
                        "symbol": "OPENSTORE",
                        "total_supply": null,
                        "description": null,
                        "external_link": null,
                        "image_url": null,
                        "default_to_fiat": false,
                        "dev_buyer_fee_basis_points": 0,
                        "dev_seller_fee_basis_points": 0,
                        "only_proxied_transfers": false,
                        "opensea_buyer_fee_basis_points": 0,
                        "opensea_seller_fee_basis_points": 250,
                        "buyer_fee_basis_points": 0,
                        "seller_fee_basis_points": 250,
                        "payout_address": null
                    },
                    "owner": {
                        "user": {
                            "username": "NullAddress"
                        },
                        "profile_img_url": "https://storage.googleapis.com/opensea-static/opensea-profile/1.png",
                        "address": "0x0000000000000000000000000000000000000000",
                        "config": "",
                        "discord_id": ""
                    },
                    "permalink": "https://opensea.io/assets/0x495f947276749ce646f68ac8c248420045cb7b5e/11649481973828809065726319200282038590073976728382359933062055013394845532161",
                    "collection": {
                        "banner_image_url": null,
                        "chat_url": null,
                        "created_date": "2021-05-25T20:14:05.702457",
                        "default_to_fiat": false,
                        "description": "",
                        "dev_buyer_fee_basis_points": "0",
                        "dev_seller_fee_basis_points": "0",
                        "discord_url": null,
                        "display_data": {
                            "card_display_style": "contain",
                            "images": []
                        },
                        "external_url": null,
                        "featured": false,
                        "featured_image_url": null,
                        "hidden": true,
                        "safelist_request_status": "not_requested",
                        "image_url": "https://lh3.googleusercontent.com/lgvpTGFLscvM9IfUAsF587OXyPdebakJ4jQsDiTC3w7T5fom-R4fwd3ORr9xXyEPSC9-4iaDXHiPliSbrYyEyzg1I5mPsdlHghzD=s120",
                        "is_subject_to_whitelist": false,
                        "large_image_url": null,
                        "medium_username": null,
                        "name": "Don't Give a Fuck",
                        "only_proxied_transfers": false,
                        "opensea_buyer_fee_basis_points": "0",
                        "opensea_seller_fee_basis_points": "250",
                        "payout_address": null,
                        "require_email": false,
                        "short_description": null,
                        "slug": "don-t-give-a-fuck",
                        "telegram_url": null,
                        "twitter_username": null,
                        "instagram_username": null,
                        "wiki_url": null
                    },
                    "decimals": null,
                    "token_metadata": null
                },
                {
                    "id": 25660858,
                    "token_id": "11649481973828809065726319200282038590073976728382359933062055014494357159937",
                    "num_sales": 0,
                    "background_color": null,
                    "image_url": "https://lh3.googleusercontent.com/so73befTOjrwRowIUrgFbfQ1ce_vVDiN2t9XTdh6u1AKA4Q7HoDwN0dRz-2Ejk4Ld2NVB2GZ1do7pyrcqhH-UWb_g73o2KJf-wbo_g",
                    "image_preview_url": "https://lh3.googleusercontent.com/so73befTOjrwRowIUrgFbfQ1ce_vVDiN2t9XTdh6u1AKA4Q7HoDwN0dRz-2Ejk4Ld2NVB2GZ1do7pyrcqhH-UWb_g73o2KJf-wbo_g=s250",
                    "image_thumbnail_url": "https://lh3.googleusercontent.com/so73befTOjrwRowIUrgFbfQ1ce_vVDiN2t9XTdh6u1AKA4Q7HoDwN0dRz-2Ejk4Ld2NVB2GZ1do7pyrcqhH-UWb_g73o2KJf-wbo_g=s128",
                    "image_original_url": null,
                    "animation_url": null,
                    "animation_original_url": null,
                    "name": "Don't Give a Fuck Artwork 002",
                    "description": null,
                    "external_link": null,
                    "asset_contract": {
                        "address": "0x495f947276749ce646f68ac8c248420045cb7b5e",
                        "asset_contract_type": "semi-fungible",
                        "created_date": "2020-12-02T17:40:53.232025",
                        "name": "OpenSea Collection",
                        "nft_version": null,
                        "opensea_version": "2.0.0",
                        "owner": 102384,
                        "schema_name": "ERC1155",
                        "symbol": "OPENSTORE",
                        "total_supply": null,
                        "description": null,
                        "external_link": null,
                        "image_url": null,
                        "default_to_fiat": false,
                        "dev_buyer_fee_basis_points": 0,
                        "dev_seller_fee_basis_points": 0,
                        "only_proxied_transfers": false,
                        "opensea_buyer_fee_basis_points": 0,
                        "opensea_seller_fee_basis_points": 250,
                        "buyer_fee_basis_points": 0,
                        "seller_fee_basis_points": 250,
                        "payout_address": null
                    },
                    "owner": {
                        "user": {
                            "username": "NullAddress"
                        },
                        "profile_img_url": "https://storage.googleapis.com/opensea-static/opensea-profile/1.png",
                        "address": "0x0000000000000000000000000000000000000000",
                        "config": "",
                        "discord_id": ""
                    },
                    "permalink": "https://opensea.io/assets/0x495f947276749ce646f68ac8c248420045cb7b5e/11649481973828809065726319200282038590073976728382359933062055014494357159937",
                    "collection": {
                        "banner_image_url": null,
                        "chat_url": null,
                        "created_date": "2021-05-25T20:14:05.702457",
                        "default_to_fiat": false,
                        "description": "",
                        "dev_buyer_fee_basis_points": "0",
                        "dev_seller_fee_basis_points": "0",
                        "discord_url": null,
                        "display_data": {
                            "card_display_style": "contain",
                            "images": []
                        },
                        "external_url": null,
                        "featured": false,
                        "featured_image_url": null,
                        "hidden": true,
                        "safelist_request_status": "not_requested",
                        "image_url": "https://lh3.googleusercontent.com/lgvpTGFLscvM9IfUAsF587OXyPdebakJ4jQsDiTC3w7T5fom-R4fwd3ORr9xXyEPSC9-4iaDXHiPliSbrYyEyzg1I5mPsdlHghzD=s120",
                        "is_subject_to_whitelist": false,
                        "large_image_url": null,
                        "medium_username": null,
                        "name": "Don't Give a Fuck",
                        "only_proxied_transfers": false,
                        "opensea_buyer_fee_basis_points": "0",
                        "opensea_seller_fee_basis_points": "250",
                        "payout_address": null,
                        "require_email": false,
                        "short_description": null,
                        "slug": "don-t-give-a-fuck",
                        "telegram_url": null,
                        "twitter_username": null,
                        "instagram_username": null,
                        "wiki_url": null
                    },
                    "decimals": null,
                    "token_metadata": null
                },
                {
                    "id": 25660882,
                    "token_id": "11649481973828809065726319200282038590073976728382359933062055015593868787713",
                    "num_sales": 0,
                    "background_color": null,
                    "image_url": "https://lh3.googleusercontent.com/csEeyU-Fi8nk7O0SHwHOUu050FbLIc5BnYPZyAVMujBEfI-peYJVv4OBgy0XIwiVrVkmuLQfGFClW4tycttmMMe2YuCiLk1u3bnRYw",
                    "image_preview_url": "https://lh3.googleusercontent.com/csEeyU-Fi8nk7O0SHwHOUu050FbLIc5BnYPZyAVMujBEfI-peYJVv4OBgy0XIwiVrVkmuLQfGFClW4tycttmMMe2YuCiLk1u3bnRYw=s250",
                    "image_thumbnail_url": "https://lh3.googleusercontent.com/csEeyU-Fi8nk7O0SHwHOUu050FbLIc5BnYPZyAVMujBEfI-peYJVv4OBgy0XIwiVrVkmuLQfGFClW4tycttmMMe2YuCiLk1u3bnRYw=s128",
                    "image_original_url": null,
                    "animation_url": null,
                    "animation_original_url": null,
                    "name": "Don't Give a Fuck Artwork 003",
                    "description": null,
                    "external_link": null,
                    "asset_contract": {
                        "address": "0x495f947276749ce646f68ac8c248420045cb7b5e",
                        "asset_contract_type": "semi-fungible",
                        "created_date": "2020-12-02T17:40:53.232025",
                        "name": "OpenSea Collection",
                        "nft_version": null,
                        "opensea_version": "2.0.0",
                        "owner": 102384,
                        "schema_name": "ERC1155",
                        "symbol": "OPENSTORE",
                        "total_supply": null,
                        "description": null,
                        "external_link": null,
                        "image_url": null,
                        "default_to_fiat": false,
                        "dev_buyer_fee_basis_points": 0,
                        "dev_seller_fee_basis_points": 0,
                        "only_proxied_transfers": false,
                        "opensea_buyer_fee_basis_points": 0,
                        "opensea_seller_fee_basis_points": 250,
                        "buyer_fee_basis_points": 0,
                        "seller_fee_basis_points": 250,
                        "payout_address": null
                    },
                    "owner": {
                        "user": {
                            "username": "NullAddress"
                        },
                        "profile_img_url": "https://storage.googleapis.com/opensea-static/opensea-profile/1.png",
                        "address": "0x0000000000000000000000000000000000000000",
                        "config": "",
                        "discord_id": ""
                    },
                    "permalink": "https://opensea.io/assets/0x495f947276749ce646f68ac8c248420045cb7b5e/11649481973828809065726319200282038590073976728382359933062055015593868787713",
                    "collection": {
                        "banner_image_url": null,
                        "chat_url": null,
                        "created_date": "2021-05-25T20:14:05.702457",
                        "default_to_fiat": false,
                        "description": "",
                        "dev_buyer_fee_basis_points": "0",
                        "dev_seller_fee_basis_points": "0",
                        "discord_url": null,
                        "display_data": {
                            "card_display_style": "contain",
                            "images": []
                        },
                        "external_url": null,
                        "featured": false,
                        "featured_image_url": null,
                        "hidden": true,
                        "safelist_request_status": "not_requested",
                        "image_url": "https://lh3.googleusercontent.com/lgvpTGFLscvM9IfUAsF587OXyPdebakJ4jQsDiTC3w7T5fom-R4fwd3ORr9xXyEPSC9-4iaDXHiPliSbrYyEyzg1I5mPsdlHghzD=s120",
                        "is_subject_to_whitelist": false,
                        "large_image_url": null,
                        "medium_username": null,
                        "name": "Don't Give a Fuck",
                        "only_proxied_transfers": false,
                        "opensea_buyer_fee_basis_points": "0",
                        "opensea_seller_fee_basis_points": "250",
                        "payout_address": null,
                        "require_email": false,
                        "short_description": null,
                        "slug": "don-t-give-a-fuck",
                        "telegram_url": null,
                        "twitter_username": null,
                        "instagram_username": null,
                        "wiki_url": null
                    },
                    "decimals": null,
                    "token_metadata": null
                }
            ],
            "name": "Don‘t Give a Fuck Artwork Bundle",
            "description": "Full Artwork Bundle",
            "external_link": "",
            "asset_contract": {
                "collection": {
                    "banner_image_url": null,
                    "chat_url": null,
                    "created_date": "2020-12-02T17:40:53.507540",
                    "default_to_fiat": false,
                    "description": null,
                    "dev_buyer_fee_basis_points": "0",
                    "dev_seller_fee_basis_points": "0",
                    "discord_url": null,
                    "display_data": {
                        "card_display_style": "contain",
                        "images": []
                    },
                    "external_url": null,
                    "featured": false,
                    "featured_image_url": null,
                    "hidden": true,
                    "safelist_request_status": "not_requested",
                    "image_url": null,
                    "is_subject_to_whitelist": false,
                    "large_image_url": null,
                    "medium_username": null,
                    "name": "OpenSea Shared Storefront V2",
                    "only_proxied_transfers": false,
                    "opensea_buyer_fee_basis_points": "0",
                    "opensea_seller_fee_basis_points": "250",
                    "payout_address": null,
                    "require_email": false,
                    "short_description": null,
                    "slug": "opensea-shared-storefront-v2",
                    "telegram_url": null,
                    "twitter_username": null,
                    "instagram_username": null,
                    "wiki_url": null
                },
                "address": "0x495f947276749ce646f68ac8c248420045cb7b5e",
                "asset_contract_type": "semi-fungible",
                "created_date": "2020-12-02T17:40:53.232025",
                "name": "OpenSea Collection",
                "nft_version": null,
                "opensea_version": "2.0.0",
                "owner": 102384,
                "schema_name": "ERC1155",
                "symbol": "OPENSTORE",
                "total_supply": null,
                "description": null,
                "external_link": null,
                "image_url": null,
                "default_to_fiat": false,
                "dev_buyer_fee_basis_points": 0,
                "dev_seller_fee_basis_points": 0,
                "only_proxied_transfers": false,
                "opensea_buyer_fee_basis_points": 0,
                "opensea_seller_fee_basis_points": 250,
                "buyer_fee_basis_points": 0,
                "seller_fee_basis_points": 250,
                "payout_address": null
            },
            "permalink": "https://opensea.io/bundles/dont-give-a-fuck-artwork-bundle-yP4",
            "sell_orders": [
                {
                    "created_date": "2021-05-25T20:24:01.325613",
                    "closing_date": null,
                    "closing_extendable": false,
                    "expiration_time": 0,
                    "listing_time": 1621974132,
                    "order_hash": "0xaa41e549c068fc279075a78d311a3059d36de08fd02fea3c5fccf5de3dc08915",
                    "metadata": {
                        "bundle": {
                            "assets": [
                                {
                                    "id": "11649481973828809065726319200282038590073976728382359933062055013394845532161",
                                    "address": "0x495f947276749ce646f68ac8c248420045cb7b5e",
                                    "quantity": "1"
                                },
                                {
                                    "id": "11649481973828809065726319200282038590073976728382359933062055014494357159937",
                                    "address": "0x495f947276749ce646f68ac8c248420045cb7b5e",
                                    "quantity": "1"
                                },
                                {
                                    "id": "11649481973828809065726319200282038590073976728382359933062055015593868787713",
                                    "address": "0x495f947276749ce646f68ac8c248420045cb7b5e",
                                    "quantity": "1"
                                }
                            ],
                            "schemas": [
                                "ERC1155",
                                "ERC1155",
                                "ERC1155"
                            ],
                            "name": "Don‘t Give a Fuck Artwork Bundle",
                            "description": "Full Artwork Bundle",
                            "external_link": ""
                        }
                    },
                    "exchange": "0x7be8076f4ea4a4ad08075c2508e481d6c946d12b",
                    "maker": {
                        "user": 838981,
                        "profile_img_url": "https://storage.googleapis.com/opensea-static/opensea-profile/14.png",
                        "address": "0x19c15f85e57fc0c780527fa9a57bad7630948099",
                        "config": "",
                        "discord_id": ""
                    },
                    "taker": {
                        "user": 1766,
                        "profile_img_url": "https://storage.googleapis.com/opensea-static/opensea-profile/1.png",
                        "address": "0x0000000000000000000000000000000000000000",
                        "config": "",
                        "discord_id": ""
                    },
                    "current_price": "1500000000000000000",
                    "current_bounty": "15000000000000000",
                    "bounty_multiple": "0.01",
                    "maker_relayer_fee": "250",
                    "taker_relayer_fee": "0",
                    "maker_protocol_fee": "0",
                    "taker_protocol_fee": "0",
                    "maker_referrer_fee": "0",
                    "fee_recipient": {
                        "user": 3585,
                        "profile_img_url": "https://storage.googleapis.com/opensea-static/opensea-profile/28.png",
                        "address": "0x5b3256965e7c3cf26e11fcaf296dfc8807c01073",
                        "config": "verified",
                        "discord_id": ""
                    },
                    "fee_method": 1,
                    "side": 1,
                    "sale_kind": 0,
                    "target": "0xc99f70bfd82fb7c8f8191fdfbfb735606b15e5c5",
                    "how_to_call": 1,
                    "calldata": "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",
                    "replacement_pattern": "0x0000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000ffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffff0000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000ffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffff0000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000ffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffff00000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000",
                    "static_target": "0x0000000000000000000000000000000000000000",
                    "static_extradata": "0x",
                    "payment_token": "0x0000000000000000000000000000000000000000",
                    "payment_token_contract": {
                        "id": 1,
                        "symbol": "ETH",
                        "address": "0x0000000000000000000000000000000000000000",
                        "image_url": "https://storage.opensea.io/files/6f8e2979d428180222796ff4a33ab929.svg",
                        "name": "Ether",
                        "decimals": 18,
                        "eth_price": "1.000000000000000",
                        "usd_price": "2625.730000000000018000"
                    },
                    "base_price": "1500000000000000000",
                    "extra": "0",
                    "quantity": "1",
                    "salt": "48278368976539765301346076802126103672199365127663398494515769588241943497709",
                    "v": 28,
                    "r": "0x7eb1e63f928d84e76a83b722762ab074786ca3d66a8f348296160be921e97e2a",
                    "s": "0x3389651a2554fc572fcc3f2a99c4a6aecb97725bc8f1123eb65174ed6f556c42",
                    "approved_on_chain": false,
                    "cancelled": false,
                    "finalized": false,
                    "marked_invalid": false,
                    "prefixed_hash": "0x7f68e5f5fb16a5ff0b0973806d34040b18dd3b41b3483d8cdcb693dcb223d74b"
                }
            ]
        },
        {
            "maker": {
                "user": {
                    "username": null
                },
                "profile_img_url": "https://storage.googleapis.com/opensea-static/opensea-profile/6.png",
                "address": "0x54e069893032ae2196ab02fe7d013069dd6f3416",
                "config": "",
                "discord_id": ""
            },
            "slug": "criptohojas-j5K",
            "assets": [
                {
                    "id": 25633319,
                    "token_id": "38390781405459679747136907948379193480062007280636129664739814617993904652289",
                    "num_sales": 0,
                    "background_color": null,
                    "image_url": "https://lh3.googleusercontent.com/Fj2bDy1tgicfT3hBVmY5oala0NEyCojpOSQWoXnGKIS_Cjb7Qm71MvdauXQprHEDvuVMqYz6mg_lsYKXwLrzvgmsHdxWRgq-mRcH5w",
                    "image_preview_url": "https://lh3.googleusercontent.com/Fj2bDy1tgicfT3hBVmY5oala0NEyCojpOSQWoXnGKIS_Cjb7Qm71MvdauXQprHEDvuVMqYz6mg_lsYKXwLrzvgmsHdxWRgq-mRcH5w=s250",
                    "image_thumbnail_url": "https://lh3.googleusercontent.com/Fj2bDy1tgicfT3hBVmY5oala0NEyCojpOSQWoXnGKIS_Cjb7Qm71MvdauXQprHEDvuVMqYz6mg_lsYKXwLrzvgmsHdxWRgq-mRcH5w=s128",
                    "image_original_url": null,
                    "animation_url": null,
                    "animation_original_url": null,
                    "name": "criptohoja #009",
                    "description": null,
                    "external_link": null,
                    "asset_contract": {
                        "address": "0x495f947276749ce646f68ac8c248420045cb7b5e",
                        "asset_contract_type": "semi-fungible",
                        "created_date": "2020-12-02T17:40:53.232025",
                        "name": "OpenSea Collection",
                        "nft_version": null,
                        "opensea_version": "2.0.0",
                        "owner": 102384,
                        "schema_name": "ERC1155",
                        "symbol": "OPENSTORE",
                        "total_supply": null,
                        "description": null,
                        "external_link": null,
                        "image_url": null,
                        "default_to_fiat": false,
                        "dev_buyer_fee_basis_points": 0,
                        "dev_seller_fee_basis_points": 0,
                        "only_proxied_transfers": false,
                        "opensea_buyer_fee_basis_points": 0,
                        "opensea_seller_fee_basis_points": 250,
                        "buyer_fee_basis_points": 0,
                        "seller_fee_basis_points": 250,
                        "payout_address": null
                    },
                    "owner": {
                        "user": {
                            "username": "NullAddress"
                        },
                        "profile_img_url": "https://storage.googleapis.com/opensea-static/opensea-profile/1.png",
                        "address": "0x0000000000000000000000000000000000000000",
                        "config": "",
                        "discord_id": ""
                    },
                    "permalink": "https://opensea.io/assets/0x495f947276749ce646f68ac8c248420045cb7b5e/38390781405459679747136907948379193480062007280636129664739814617993904652289",
                    "collection": {
                        "banner_image_url": "https://lh3.googleusercontent.com/yU2MIuvFBuJAstQeAmZZdzIKtV4uikn2TO5iJ7Gbwu8f3TKnp7wLGlHHKlfi8ef_I_yqlQ1eB6yJNLElh-JgGZndn66E32vPj03PDQ=s2500",
                        "chat_url": null,
                        "created_date": "2021-05-21T11:53:37.018091",
                        "default_to_fiat": false,
                        "description": "",
                        "dev_buyer_fee_basis_points": "0",
                        "dev_seller_fee_basis_points": "100",
                        "discord_url": null,
                        "display_data": {
                            "card_display_style": "contain"
                        },
                        "external_url": null,
                        "featured": false,
                        "featured_image_url": "https://lh3.googleusercontent.com/yU2MIuvFBuJAstQeAmZZdzIKtV4uikn2TO5iJ7Gbwu8f3TKnp7wLGlHHKlfi8ef_I_yqlQ1eB6yJNLElh-JgGZndn66E32vPj03PDQ=s300",
                        "hidden": true,
                        "safelist_request_status": "not_requested",
                        "image_url": "https://lh3.googleusercontent.com/FdEriNWK8E94vs8Ox-1BONF-3NxgGyIvzNG4X2iX09Z2S0on0AjZOWGnpnV-CnDvNeWYn7nh8Ormch7T-QvrW029hf0rRPOFP99A=s120",
                        "is_subject_to_whitelist": false,
                        "large_image_url": "https://lh3.googleusercontent.com/yU2MIuvFBuJAstQeAmZZdzIKtV4uikn2TO5iJ7Gbwu8f3TKnp7wLGlHHKlfi8ef_I_yqlQ1eB6yJNLElh-JgGZndn66E32vPj03PDQ=s300",
                        "medium_username": null,
                        "name": "neocalix",
                        "only_proxied_transfers": false,
                        "opensea_buyer_fee_basis_points": "0",
                        "opensea_seller_fee_basis_points": "250",
                        "payout_address": "0x54e069893032ae2196ab02fe7d013069dd6f3416",
                        "require_email": false,
                        "short_description": null,
                        "slug": "neocalix",
                        "telegram_url": null,
                        "twitter_username": null,
                        "instagram_username": null,
                        "wiki_url": null
                    },
                    "decimals": null,
                    "token_metadata": null
                },
                {
                    "id": 25633380,
                    "token_id": "38390781405459679747136907948379193480062007280636129664739814619093416280065",
                    "num_sales": 0,
                    "background_color": null,
                    "image_url": "https://lh3.googleusercontent.com/gtHUqT9sDu-lgnOPTviarOjUpYktIyy_MBtqnf61eJHzoBqKYjINNuA8UkJpkFRWAIAiS5-_-rtOdeHOS4OA2RGOrZNdF_l3hYfu-6U",
                    "image_preview_url": "https://lh3.googleusercontent.com/gtHUqT9sDu-lgnOPTviarOjUpYktIyy_MBtqnf61eJHzoBqKYjINNuA8UkJpkFRWAIAiS5-_-rtOdeHOS4OA2RGOrZNdF_l3hYfu-6U=s250",
                    "image_thumbnail_url": "https://lh3.googleusercontent.com/gtHUqT9sDu-lgnOPTviarOjUpYktIyy_MBtqnf61eJHzoBqKYjINNuA8UkJpkFRWAIAiS5-_-rtOdeHOS4OA2RGOrZNdF_l3hYfu-6U=s128",
                    "image_original_url": null,
                    "animation_url": null,
                    "animation_original_url": null,
                    "name": "criptohoja #010",
                    "description": null,
                    "external_link": null,
                    "asset_contract": {
                        "address": "0x495f947276749ce646f68ac8c248420045cb7b5e",
                        "asset_contract_type": "semi-fungible",
                        "created_date": "2020-12-02T17:40:53.232025",
                        "name": "OpenSea Collection",
                        "nft_version": null,
                        "opensea_version": "2.0.0",
                        "owner": 102384,
                        "schema_name": "ERC1155",
                        "symbol": "OPENSTORE",
                        "total_supply": null,
                        "description": null,
                        "external_link": null,
                        "image_url": null,
                        "default_to_fiat": false,
                        "dev_buyer_fee_basis_points": 0,
                        "dev_seller_fee_basis_points": 0,
                        "only_proxied_transfers": false,
                        "opensea_buyer_fee_basis_points": 0,
                        "opensea_seller_fee_basis_points": 250,
                        "buyer_fee_basis_points": 0,
                        "seller_fee_basis_points": 250,
                        "payout_address": null
                    },
                    "owner": {
                        "user": {
                            "username": "NullAddress"
                        },
                        "profile_img_url": "https://storage.googleapis.com/opensea-static/opensea-profile/1.png",
                        "address": "0x0000000000000000000000000000000000000000",
                        "config": "",
                        "discord_id": ""
                    },
                    "permalink": "https://opensea.io/assets/0x495f947276749ce646f68ac8c248420045cb7b5e/38390781405459679747136907948379193480062007280636129664739814619093416280065",
                    "collection": {
                        "banner_image_url": "https://lh3.googleusercontent.com/yU2MIuvFBuJAstQeAmZZdzIKtV4uikn2TO5iJ7Gbwu8f3TKnp7wLGlHHKlfi8ef_I_yqlQ1eB6yJNLElh-JgGZndn66E32vPj03PDQ=s2500",
                        "chat_url": null,
                        "created_date": "2021-05-21T11:53:37.018091",
                        "default_to_fiat": false,
                        "description": "",
                        "dev_buyer_fee_basis_points": "0",
                        "dev_seller_fee_basis_points": "100",
                        "discord_url": null,
                        "display_data": {
                            "card_display_style": "contain"
                        },
                        "external_url": null,
                        "featured": false,
                        "featured_image_url": "https://lh3.googleusercontent.com/yU2MIuvFBuJAstQeAmZZdzIKtV4uikn2TO5iJ7Gbwu8f3TKnp7wLGlHHKlfi8ef_I_yqlQ1eB6yJNLElh-JgGZndn66E32vPj03PDQ=s300",
                        "hidden": true,
                        "safelist_request_status": "not_requested",
                        "image_url": "https://lh3.googleusercontent.com/FdEriNWK8E94vs8Ox-1BONF-3NxgGyIvzNG4X2iX09Z2S0on0AjZOWGnpnV-CnDvNeWYn7nh8Ormch7T-QvrW029hf0rRPOFP99A=s120",
                        "is_subject_to_whitelist": false,
                        "large_image_url": "https://lh3.googleusercontent.com/yU2MIuvFBuJAstQeAmZZdzIKtV4uikn2TO5iJ7Gbwu8f3TKnp7wLGlHHKlfi8ef_I_yqlQ1eB6yJNLElh-JgGZndn66E32vPj03PDQ=s300",
                        "medium_username": null,
                        "name": "neocalix",
                        "only_proxied_transfers": false,
                        "opensea_buyer_fee_basis_points": "0",
                        "opensea_seller_fee_basis_points": "250",
                        "payout_address": "0x54e069893032ae2196ab02fe7d013069dd6f3416",
                        "require_email": false,
                        "short_description": null,
                        "slug": "neocalix",
                        "telegram_url": null,
                        "twitter_username": null,
                        "instagram_username": null,
                        "wiki_url": null
                    },
                    "decimals": null,
                    "token_metadata": null
                }
            ],
            "name": "criptohojas",
            "description": "",
            "external_link": "",
            "asset_contract": {
                "collection": {
                    "banner_image_url": null,
                    "chat_url": null,
                    "created_date": "2020-12-02T17:40:53.507540",
                    "default_to_fiat": false,
                    "description": null,
                    "dev_buyer_fee_basis_points": "0",
                    "dev_seller_fee_basis_points": "0",
                    "discord_url": null,
                    "display_data": {
                        "card_display_style": "contain",
                        "images": []
                    },
                    "external_url": null,
                    "featured": false,
                    "featured_image_url": null,
                    "hidden": true,
                    "safelist_request_status": "not_requested",
                    "image_url": null,
                    "is_subject_to_whitelist": false,
                    "large_image_url": null,
                    "medium_username": null,
                    "name": "OpenSea Shared Storefront V2",
                    "only_proxied_transfers": false,
                    "opensea_buyer_fee_basis_points": "0",
                    "opensea_seller_fee_basis_points": "250",
                    "payout_address": null,
                    "require_email": false,
                    "short_description": null,
                    "slug": "opensea-shared-storefront-v2",
                    "telegram_url": null,
                    "twitter_username": null,
                    "instagram_username": null,
                    "wiki_url": null
                },
                "address": "0x495f947276749ce646f68ac8c248420045cb7b5e",
                "asset_contract_type": "semi-fungible",
                "created_date": "2020-12-02T17:40:53.232025",
                "name": "OpenSea Collection",
                "nft_version": null,
                "opensea_version": "2.0.0",
                "owner": 102384,
                "schema_name": "ERC1155",
                "symbol": "OPENSTORE",
                "total_supply": null,
                "description": null,
                "external_link": null,
                "image_url": null,
                "default_to_fiat": false,
                "dev_buyer_fee_basis_points": 0,
                "dev_seller_fee_basis_points": 0,
                "only_proxied_transfers": false,
                "opensea_buyer_fee_basis_points": 0,
                "opensea_seller_fee_basis_points": 250,
                "buyer_fee_basis_points": 0,
                "seller_fee_basis_points": 250,
                "payout_address": null
            },
            "permalink": "https://opensea.io/bundles/criptohojas-j5K",
            "sell_orders": [
                {
                    "created_date": "2021-05-25T20:22:16.488800",
                    "closing_date": null,
                    "closing_extendable": false,
                    "expiration_time": 0,
                    "listing_time": 1621974028,
                    "order_hash": "0xff42fdd1156b3cf6ed9e88dab8936bc513d217f14874ffb45a04c87f745ea243",
                    "metadata": {
                        "bundle": {
                            "assets": [
                                {
                                    "id": "38390781405459679747136907948379193480062007280636129664739814617993904652289",
                                    "address": "0x495f947276749ce646f68ac8c248420045cb7b5e",
                                    "quantity": "1"
                                },
                                {
                                    "id": "38390781405459679747136907948379193480062007280636129664739814619093416280065",
                                    "address": "0x495f947276749ce646f68ac8c248420045cb7b5e",
                                    "quantity": "1"
                                }
                            ],
                            "schemas": [
                                "ERC1155",
                                "ERC1155"
                            ],
                            "name": "criptohojas",
                            "description": "",
                            "external_link": ""
                        }
                    },
                    "exchange": "0x7be8076f4ea4a4ad08075c2508e481d6c946d12b",
                    "maker": {
                        "user": 833525,
                        "profile_img_url": "https://storage.googleapis.com/opensea-static/opensea-profile/6.png",
                        "address": "0x54e069893032ae2196ab02fe7d013069dd6f3416",
                        "config": "",
                        "discord_id": ""
                    },
                    "taker": {
                        "user": 1766,
                        "profile_img_url": "https://storage.googleapis.com/opensea-static/opensea-profile/1.png",
                        "address": "0x0000000000000000000000000000000000000000",
                        "config": "",
                        "discord_id": ""
                    },
                    "current_price": "29000000000000000",
                    "current_bounty": "290000000000000",
                    "bounty_multiple": "0.01",
                    "maker_relayer_fee": "350",
                    "taker_relayer_fee": "0",
                    "maker_protocol_fee": "0",
                    "taker_protocol_fee": "0",
                    "maker_referrer_fee": "0",
                    "fee_recipient": {
                        "user": 3585,
                        "profile_img_url": "https://storage.googleapis.com/opensea-static/opensea-profile/28.png",
                        "address": "0x5b3256965e7c3cf26e11fcaf296dfc8807c01073",
                        "config": "verified",
                        "discord_id": ""
                    },
                    "fee_method": 1,
                    "side": 1,
                    "sale_kind": 0,
                    "target": "0xc99f70bfd82fb7c8f8191fdfbfb735606b15e5c5",
                    "how_to_call": 1,
                    "calldata": "0x68f0bcaa000000000000000000000000000000000000000000000000000000000000008000000000000000000000000000000000000000000000000000000000000000e0000000000000000000000000000000000000000000000000000000000000014000000000000000000000000000000000000000000000000000000000000001a00000000000000000000000000000000000000000000000000000000000000002000000000000000000000000495f947276749ce646f68ac8c248420045cb7b5e000000000000000000000000495f947276749ce646f68ac8c248420045cb7b5e000000000000000000000000000000000000000000000000000000000000000200000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000200000000000000000000000000000000000000000000000000000000000000c400000000000000000000000000000000000000000000000000000000000000c40000000000000000000000000000000000000000000000000000000000000188f242432a00000000000000000000000054e069893032ae2196ab02fe7d013069dd6f3416000000000000000000000000000000000000000000000000000000000000000054e069893032ae2196ab02fe7d013069dd6f3416000000000000470000000001000000000000000000000000000000000000000000000000000000000000000100000000000000000000000000000000000000000000000000000000000000a00000000000000000000000000000000000000000000000000000000000000000f242432a00000000000000000000000054e069893032ae2196ab02fe7d013069dd6f3416000000000000000000000000000000000000000000000000000000000000000054e069893032ae2196ab02fe7d013069dd6f3416000000000000480000000001000000000000000000000000000000000000000000000000000000000000000100000000000000000000000000000000000000000000000000000000000000a00000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000",
                    "replacement_pattern": "0x0000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000ffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffff0000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000ffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffff0000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000",
                    "static_target": "0x0000000000000000000000000000000000000000",
                    "static_extradata": "0x",
                    "payment_token": "0x0000000000000000000000000000000000000000",
                    "payment_token_contract": {
                        "id": 1,
                        "symbol": "ETH",
                        "address": "0x0000000000000000000000000000000000000000",
                        "image_url": "https://storage.opensea.io/files/6f8e2979d428180222796ff4a33ab929.svg",
                        "name": "Ether",
                        "decimals": 18,
                        "eth_price": "1.000000000000000",
                        "usd_price": "2625.730000000000018000"
                    },
                    "base_price": "29000000000000000",
                    "extra": "0",
                    "quantity": "1",
                    "salt": "58214604856012602468084551041801161171249084020472397518327472345547720304671",
                    "v": 28,
                    "r": "0xf9e3edfa1a6e7e5810295ffe743d6d884bbfb45a5bd7d1adc10a0f3c6e37e6cb",
                    "s": "0x03e30387ece528141390db09c1294717eed8a16f76df987c10101de4e4a5cdf4",
                    "approved_on_chain": false,
                    "cancelled": false,
                    "finalized": false,
                    "marked_invalid": false,
                    "prefixed_hash": "0xd3b1fd71cc692817e922481044c92d224e5fec9618fb35008db1ae69940e8027"
                }
            ]
        },
        {
            "maker": {
                "user": {
                    "username": "ONE8"
                },
                "profile_img_url": "https://storage.googleapis.com/opensea-static/opensea-profile/14.png",
                "address": "0x280bac10abee27e3978d4e1e119066ebc3fad8a5",
                "config": "",
                "discord_id": ""
            },
            "slug": "2-pack-30b",
            "assets": [
                {
                    "id": 25654051,
                    "token_id": "18113136810880385909625812461941578260802280914005851637645524675374138523649",
                    "num_sales": 0,
                    "background_color": null,
                    "image_url": "https://lh3.googleusercontent.com/7qs8B4ZTOJYIZW8sK4nvmmD1F1qPMxmBvNhPWh8Y6GOtq-Gk43gft2ExTtOQVUJXdOHU2hg5Oym0Z5evMeEdFl6FEqWs6L8z7L4L",
                    "image_preview_url": "https://lh3.googleusercontent.com/7qs8B4ZTOJYIZW8sK4nvmmD1F1qPMxmBvNhPWh8Y6GOtq-Gk43gft2ExTtOQVUJXdOHU2hg5Oym0Z5evMeEdFl6FEqWs6L8z7L4L=s250",
                    "image_thumbnail_url": "https://lh3.googleusercontent.com/7qs8B4ZTOJYIZW8sK4nvmmD1F1qPMxmBvNhPWh8Y6GOtq-Gk43gft2ExTtOQVUJXdOHU2hg5Oym0Z5evMeEdFl6FEqWs6L8z7L4L=s128",
                    "image_original_url": null,
                    "animation_url": null,
                    "animation_original_url": null,
                    "name": "Doodle Doodz #0072 (wrapped)",
                    "description": "Doodle Doodz #0072\n\nThis gives you the opportunity to buy the new drops doodz at the previous drops common rate. That means you could unwrap a rare at almost half the price! These will expire if not purchased, so hurry! Each pack contains 1 random NFT. Good luck! If stated more than one in a pack, it means it’s part of a bundle deal. \n\nThere will be a total of 1000 1/1 Doodle Doodz with a total supply of 1000. Each drop will consist of 15 Doodz: 10 additional Super Rare Doodz will be added throughout the series & can be obtained as gifts,prizes & special air drops for members with a supply of only 1 each. \n\nSo stay tuned to the Doodz various channels not to miss out! For more info visit our site 🖖 check out Family tree to see how you can SPAWN a free NFT with your Doodle Doodz",
                    "external_link": "https://doodledoodz.app",
                    "asset_contract": {
                        "address": "0x495f947276749ce646f68ac8c248420045cb7b5e",
                        "asset_contract_type": "semi-fungible",
                        "created_date": "2020-12-02T17:40:53.232025",
                        "name": "OpenSea Collection",
                        "nft_version": null,
                        "opensea_version": "2.0.0",
                        "owner": 102384,
                        "schema_name": "ERC1155",
                        "symbol": "OPENSTORE",
                        "total_supply": null,
                        "description": null,
                        "external_link": null,
                        "image_url": null,
                        "default_to_fiat": false,
                        "dev_buyer_fee_basis_points": 0,
                        "dev_seller_fee_basis_points": 0,
                        "only_proxied_transfers": false,
                        "opensea_buyer_fee_basis_points": 0,
                        "opensea_seller_fee_basis_points": 250,
                        "buyer_fee_basis_points": 0,
                        "seller_fee_basis_points": 250,
                        "payout_address": null
                    },
                    "owner": {
                        "user": {
                            "username": "NullAddress"
                        },
                        "profile_img_url": "https://storage.googleapis.com/opensea-static/opensea-profile/1.png",
                        "address": "0x0000000000000000000000000000000000000000",
                        "config": "",
                        "discord_id": ""
                    },
                    "permalink": "https://opensea.io/assets/0x495f947276749ce646f68ac8c248420045cb7b5e/18113136810880385909625812461941578260802280914005851637645524675374138523649",
                    "collection": {
                        "banner_image_url": "https://lh3.googleusercontent.com/dnL546psc4poERNp7pEc5uaRflOW08f3SwNQOIqNSWj1dGKUkmZrTDiC_-t9SKPo1UEGJMPRRbO8fAN8YTP3rASgqiKAWDnixsSeeUA=s2500",
                        "chat_url": null,
                        "created_date": "2021-03-26T01:38:13.859308",
                        "default_to_fiat": false,
                        "description": "There will be a total Supply of 1000 Doodle-Doodz, each uniquely created 1/1 with different traits making some more valuable. a drop will consist of 15 Doodle-Doodz. Each drop will go up in price. ",
                        "dev_buyer_fee_basis_points": "0",
                        "dev_seller_fee_basis_points": "1000",
                        "discord_url": "https://discord.gg/RUXYZDcpgD",
                        "display_data": {
                            "card_display_style": "cover"
                        },
                        "external_url": "http://doodledoodz.app",
                        "featured": false,
                        "featured_image_url": "https://lh3.googleusercontent.com/Z2tF1YmDxYKffPli_0MMHokhOO-Z_LiMc762In8_mJ027WnE5g-3NLq4tUv061mbt6tVuURl1NwWkWPVC2UFLqafUkOhwZo5KEyJ=s300",
                        "hidden": true,
                        "safelist_request_status": "not_requested",
                        "image_url": "https://lh3.googleusercontent.com/vSNu55FSceIbRUaklGdw56D0m3jpfmS8R4LyuW2eeX8ir23EY6YFKeJHl55tBX0iUhVscBfGcClDPwyPb7aB26wO1IrOJHf2uD2w=s120",
                        "is_subject_to_whitelist": false,
                        "large_image_url": "https://lh3.googleusercontent.com/Z2tF1YmDxYKffPli_0MMHokhOO-Z_LiMc762In8_mJ027WnE5g-3NLq4tUv061mbt6tVuURl1NwWkWPVC2UFLqafUkOhwZo5KEyJ=s300",
                        "medium_username": null,
                        "name": "Doodle Doodz",
                        "only_proxied_transfers": false,
                        "opensea_buyer_fee_basis_points": "0",
                        "opensea_seller_fee_basis_points": "250",
                        "payout_address": "0x280bac10abee27e3978d4e1e119066ebc3fad8a5",
                        "require_email": false,
                        "short_description": null,
                        "slug": "doodle-doodz",
                        "telegram_url": null,
                        "twitter_username": "doodledoodz",
                        "instagram_username": "nftdoodledoodz",
                        "wiki_url": null
                    },
                    "decimals": null,
                    "token_metadata": null
                },
                {
                    "id": 25654299,
                    "token_id": "18113136810880385909625812461941578260802280914005851637645524676473650151425",
                    "num_sales": 0,
                    "background_color": null,
                    "image_url": "https://lh3.googleusercontent.com/7qs8B4ZTOJYIZW8sK4nvmmD1F1qPMxmBvNhPWh8Y6GOtq-Gk43gft2ExTtOQVUJXdOHU2hg5Oym0Z5evMeEdFl6FEqWs6L8z7L4L",
                    "image_preview_url": "https://lh3.googleusercontent.com/7qs8B4ZTOJYIZW8sK4nvmmD1F1qPMxmBvNhPWh8Y6GOtq-Gk43gft2ExTtOQVUJXdOHU2hg5Oym0Z5evMeEdFl6FEqWs6L8z7L4L=s250",
                    "image_thumbnail_url": "https://lh3.googleusercontent.com/7qs8B4ZTOJYIZW8sK4nvmmD1F1qPMxmBvNhPWh8Y6GOtq-Gk43gft2ExTtOQVUJXdOHU2hg5Oym0Z5evMeEdFl6FEqWs6L8z7L4L=s128",
                    "image_original_url": null,
                    "animation_url": null,
                    "animation_original_url": null,
                    "name": "Doodle Doodz #0074 (wrapped)",
                    "description": "Doodle Doodz #0074\n\nThis gives you the opportunity to buy the new drops doodz at the previous drops common rate. That means you could unwrap a rare at almost half the price! These will expire if not purchased, so hurry! Each pack contains 1 random NFT. Good luck! If stated more than one in a pack, it means it’s part of a bundle deal. \n\nThere will be a total of 1000 1/1 Doodle Doodz with a total supply of 1000. Each drop will consist of 15 Doodz: 10 additional Super Rare Doodz will be added throughout the series & can be obtained as gifts,prizes & special air drops for members with a supply of only 1 each. \n\nSo stay tuned to the Doodz various channels not to miss out! For more info visit our site 🖖 check out Family tree to see how you can SPAWN a free NFT with your Doodle Doodz",
                    "external_link": "https://doodledoodz.app",
                    "asset_contract": {
                        "address": "0x495f947276749ce646f68ac8c248420045cb7b5e",
                        "asset_contract_type": "semi-fungible",
                        "created_date": "2020-12-02T17:40:53.232025",
                        "name": "OpenSea Collection",
                        "nft_version": null,
                        "opensea_version": "2.0.0",
                        "owner": 102384,
                        "schema_name": "ERC1155",
                        "symbol": "OPENSTORE",
                        "total_supply": null,
                        "description": null,
                        "external_link": null,
                        "image_url": null,
                        "default_to_fiat": false,
                        "dev_buyer_fee_basis_points": 0,
                        "dev_seller_fee_basis_points": 0,
                        "only_proxied_transfers": false,
                        "opensea_buyer_fee_basis_points": 0,
                        "opensea_seller_fee_basis_points": 250,
                        "buyer_fee_basis_points": 0,
                        "seller_fee_basis_points": 250,
                        "payout_address": null
                    },
                    "owner": {
                        "user": {
                            "username": "NullAddress"
                        },
                        "profile_img_url": "https://storage.googleapis.com/opensea-static/opensea-profile/1.png",
                        "address": "0x0000000000000000000000000000000000000000",
                        "config": "",
                        "discord_id": ""
                    },
                    "permalink": "https://opensea.io/assets/0x495f947276749ce646f68ac8c248420045cb7b5e/18113136810880385909625812461941578260802280914005851637645524676473650151425",
                    "collection": {
                        "banner_image_url": "https://lh3.googleusercontent.com/dnL546psc4poERNp7pEc5uaRflOW08f3SwNQOIqNSWj1dGKUkmZrTDiC_-t9SKPo1UEGJMPRRbO8fAN8YTP3rASgqiKAWDnixsSeeUA=s2500",
                        "chat_url": null,
                        "created_date": "2021-03-26T01:38:13.859308",
                        "default_to_fiat": false,
                        "description": "There will be a total Supply of 1000 Doodle-Doodz, each uniquely created 1/1 with different traits making some more valuable. a drop will consist of 15 Doodle-Doodz. Each drop will go up in price. ",
                        "dev_buyer_fee_basis_points": "0",
                        "dev_seller_fee_basis_points": "1000",
                        "discord_url": "https://discord.gg/RUXYZDcpgD",
                        "display_data": {
                            "card_display_style": "cover"
                        },
                        "external_url": "http://doodledoodz.app",
                        "featured": false,
                        "featured_image_url": "https://lh3.googleusercontent.com/Z2tF1YmDxYKffPli_0MMHokhOO-Z_LiMc762In8_mJ027WnE5g-3NLq4tUv061mbt6tVuURl1NwWkWPVC2UFLqafUkOhwZo5KEyJ=s300",
                        "hidden": true,
                        "safelist_request_status": "not_requested",
                        "image_url": "https://lh3.googleusercontent.com/vSNu55FSceIbRUaklGdw56D0m3jpfmS8R4LyuW2eeX8ir23EY6YFKeJHl55tBX0iUhVscBfGcClDPwyPb7aB26wO1IrOJHf2uD2w=s120",
                        "is_subject_to_whitelist": false,
                        "large_image_url": "https://lh3.googleusercontent.com/Z2tF1YmDxYKffPli_0MMHokhOO-Z_LiMc762In8_mJ027WnE5g-3NLq4tUv061mbt6tVuURl1NwWkWPVC2UFLqafUkOhwZo5KEyJ=s300",
                        "medium_username": null,
                        "name": "Doodle Doodz",
                        "only_proxied_transfers": false,
                        "opensea_buyer_fee_basis_points": "0",
                        "opensea_seller_fee_basis_points": "250",
                        "payout_address": "0x280bac10abee27e3978d4e1e119066ebc3fad8a5",
                        "require_email": false,
                        "short_description": null,
                        "slug": "doodle-doodz",
                        "telegram_url": null,
                        "twitter_username": "doodledoodz",
                        "instagram_username": "nftdoodledoodz",
                        "wiki_url": null
                    },
                    "decimals": null,
                    "token_metadata": null
                }
            ],
            "name": "2 Pack",
            "description": "Includes #0072 #0074",
            "external_link": "",
            "asset_contract": {
                "collection": {
                    "banner_image_url": null,
                    "chat_url": null,
                    "created_date": "2020-12-02T17:40:53.507540",
                    "default_to_fiat": false,
                    "description": null,
                    "dev_buyer_fee_basis_points": "0",
                    "dev_seller_fee_basis_points": "0",
                    "discord_url": null,
                    "display_data": {
                        "card_display_style": "contain",
                        "images": []
                    },
                    "external_url": null,
                    "featured": false,
                    "featured_image_url": null,
                    "hidden": true,
                    "safelist_request_status": "not_requested",
                    "image_url": null,
                    "is_subject_to_whitelist": false,
                    "large_image_url": null,
                    "medium_username": null,
                    "name": "OpenSea Shared Storefront V2",
                    "only_proxied_transfers": false,
                    "opensea_buyer_fee_basis_points": "0",
                    "opensea_seller_fee_basis_points": "250",
                    "payout_address": null,
                    "require_email": false,
                    "short_description": null,
                    "slug": "opensea-shared-storefront-v2",
                    "telegram_url": null,
                    "twitter_username": null,
                    "instagram_username": null,
                    "wiki_url": null
                },
                "address": "0x495f947276749ce646f68ac8c248420045cb7b5e",
                "asset_contract_type": "semi-fungible",
                "created_date": "2020-12-02T17:40:53.232025",
                "name": "OpenSea Collection",
                "nft_version": null,
                "opensea_version": "2.0.0",
                "owner": 102384,
                "schema_name": "ERC1155",
                "symbol": "OPENSTORE",
                "total_supply": null,
                "description": null,
                "external_link": null,
                "image_url": null,
                "default_to_fiat": false,
                "dev_buyer_fee_basis_points": 0,
                "dev_seller_fee_basis_points": 0,
                "only_proxied_transfers": false,
                "opensea_buyer_fee_basis_points": 0,
                "opensea_seller_fee_basis_points": 250,
                "buyer_fee_basis_points": 0,
                "seller_fee_basis_points": 250,
                "payout_address": null
            },
            "permalink": "https://opensea.io/bundles/2-pack-30b",
            "sell_orders": [
                {
                    "created_date": "2021-05-25T20:21:10.551508",
                    "closing_date": null,
                    "closing_extendable": false,
                    "expiration_time": 0,
                    "listing_time": 1621980000,
                    "order_hash": "0xc33866c4cdbc9b0a8d4fa14d0ab15e4bb73d3c9d8dd9d3000e314714378f167d",
                    "metadata": {
                        "bundle": {
                            "assets": [
                                {
                                    "id": "18113136810880385909625812461941578260802280914005851637645524675374138523649",
                                    "address": "0x495f947276749ce646f68ac8c248420045cb7b5e",
                                    "quantity": "1"
                                },
                                {
                                    "id": "18113136810880385909625812461941578260802280914005851637645524676473650151425",
                                    "address": "0x495f947276749ce646f68ac8c248420045cb7b5e",
                                    "quantity": "1"
                                }
                            ],
                            "schemas": [
                                "ERC1155",
                                "ERC1155"
                            ],
                            "name": "2 Pack",
                            "description": "#0072 #0074",
                            "external_link": ""
                        }
                    },
                    "exchange": "0x7be8076f4ea4a4ad08075c2508e481d6c946d12b",
                    "maker": {
                        "user": 472027,
                        "profile_img_url": "https://storage.googleapis.com/opensea-static/opensea-profile/14.png",
                        "address": "0x280bac10abee27e3978d4e1e119066ebc3fad8a5",
                        "config": "",
                        "discord_id": ""
                    },
                    "taker": {
                        "user": 1766,
                        "profile_img_url": "https://storage.googleapis.com/opensea-static/opensea-profile/1.png",
                        "address": "0x0000000000000000000000000000000000000000",
                        "config": "",
                        "discord_id": ""
                    },
                    "current_price": "44000000000000000",
                    "current_bounty": "440000000000000",
                    "bounty_multiple": "0.01",
                    "maker_relayer_fee": "1250",
                    "taker_relayer_fee": "0",
                    "maker_protocol_fee": "0",
                    "taker_protocol_fee": "0",
                    "maker_referrer_fee": "0",
                    "fee_recipient": {
                        "user": 3585,
                        "profile_img_url": "https://storage.googleapis.com/opensea-static/opensea-profile/28.png",
                        "address": "0x5b3256965e7c3cf26e11fcaf296dfc8807c01073",
                        "config": "verified",
                        "discord_id": ""
                    },
                    "fee_method": 1,
                    "side": 1,
                    "sale_kind": 0,
                    "target": "0xc99f70bfd82fb7c8f8191fdfbfb735606b15e5c5",
                    "how_to_call": 1,
                    "calldata": "0x68f0bcaa000000000000000000000000000000000000000000000000000000000000008000000000000000000000000000000000000000000000000000000000000000e0000000000000000000000000000000000000000000000000000000000000014000000000000000000000000000000000000000000000000000000000000001a00000000000000000000000000000000000000000000000000000000000000002000000000000000000000000495f947276749ce646f68ac8c248420045cb7b5e000000000000000000000000495f947276749ce646f68ac8c248420045cb7b5e000000000000000000000000000000000000000000000000000000000000000200000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000200000000000000000000000000000000000000000000000000000000000000c400000000000000000000000000000000000000000000000000000000000000c40000000000000000000000000000000000000000000000000000000000000188f242432a000000000000000000000000280bac10abee27e3978d4e1e119066ebc3fad8a50000000000000000000000000000000000000000000000000000000000000000280bac10abee27e3978d4e1e119066ebc3fad8a50000000000008c0000000001000000000000000000000000000000000000000000000000000000000000000100000000000000000000000000000000000000000000000000000000000000a00000000000000000000000000000000000000000000000000000000000000000f242432a000000000000000000000000280bac10abee27e3978d4e1e119066ebc3fad8a50000000000000000000000000000000000000000000000000000000000000000280bac10abee27e3978d4e1e119066ebc3fad8a50000000000008d0000000001000000000000000000000000000000000000000000000000000000000000000100000000000000000000000000000000000000000000000000000000000000a00000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000",
                    "replacement_pattern": "0x0000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000ffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffff0000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000ffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffff0000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000",
                    "static_target": "0x0000000000000000000000000000000000000000",
                    "static_extradata": "0x",
                    "payment_token": "0x0000000000000000000000000000000000000000",
                    "payment_token_contract": {
                        "id": 1,
                        "symbol": "ETH",
                        "address": "0x0000000000000000000000000000000000000000",
                        "image_url": "https://storage.opensea.io/files/6f8e2979d428180222796ff4a33ab929.svg",
                        "name": "Ether",
                        "decimals": 18,
                        "eth_price": "1.000000000000000",
                        "usd_price": "2625.730000000000018000"
                    },
                    "base_price": "44000000000000000",
                    "extra": "0",
                    "quantity": "1",
                    "salt": "69704881582856617708643973206361374452725677636937835608266836136737224836631",
                    "v": 27,
                    "r": "0x15769ce7985f9113f5cf2efb3db990a6b6fce4b8a5a890c629c9293e0b9dda34",
                    "s": "0x6665d0aad4e370bad120e70548d17b3fb69c45be89ff5698619f53081c8497e6",
                    "approved_on_chain": false,
                    "cancelled": false,
                    "finalized": false,
                    "marked_invalid": false,
                    "prefixed_hash": "0xd6a6cc9fbc546b62e3c1c84f98a51af04cb0bc0e045d3c46ea551e2266853c2d"
                }
            ]
        },
        {
            "maker": {
                "user": {
                    "username": "NitroSea"
                },
                "profile_img_url": "https://storage.googleapis.com/opensea-static/opensea-profile/5.png",
                "address": "0xca89f07e2f171bf8f1f46368cd8a1f28be8e702d",
                "config": "",
                "discord_id": ""
            },
            "slug": "laser-eye-bundle-3Ws",
            "assets": [
                {
                    "id": 25653635,
                    "token_id": "91610913282730143210461911219693399380844700131462702282955080970606332608513",
                    "num_sales": 0,
                    "background_color": null,
                    "image_url": "https://lh3.googleusercontent.com/xOr6sGG5zUZl9dO8_KfNFDZlYRyoV1KjHsRgoyu7OnV12-aPUTg6IjJlzp1IRDFJbRsOyGo0_77RbuwUiUosHqvRwlQezykIAKMHcw",
                    "image_preview_url": "https://lh3.googleusercontent.com/xOr6sGG5zUZl9dO8_KfNFDZlYRyoV1KjHsRgoyu7OnV12-aPUTg6IjJlzp1IRDFJbRsOyGo0_77RbuwUiUosHqvRwlQezykIAKMHcw=s250",
                    "image_thumbnail_url": "https://lh3.googleusercontent.com/xOr6sGG5zUZl9dO8_KfNFDZlYRyoV1KjHsRgoyu7OnV12-aPUTg6IjJlzp1IRDFJbRsOyGo0_77RbuwUiUosHqvRwlQezykIAKMHcw=s128",
                    "image_original_url": null,
                    "animation_url": null,
                    "animation_original_url": null,
                    "name": "Laser Eye Nicholas Cage",
                    "description": null,
                    "external_link": null,
                    "asset_contract": {
                        "address": "0x495f947276749ce646f68ac8c248420045cb7b5e",
                        "asset_contract_type": "semi-fungible",
                        "created_date": "2020-12-02T17:40:53.232025",
                        "name": "OpenSea Collection",
                        "nft_version": null,
                        "opensea_version": "2.0.0",
                        "owner": 102384,
                        "schema_name": "ERC1155",
                        "symbol": "OPENSTORE",
                        "total_supply": null,
                        "description": null,
                        "external_link": null,
                        "image_url": null,
                        "default_to_fiat": false,
                        "dev_buyer_fee_basis_points": 0,
                        "dev_seller_fee_basis_points": 0,
                        "only_proxied_transfers": false,
                        "opensea_buyer_fee_basis_points": 0,
                        "opensea_seller_fee_basis_points": 250,
                        "buyer_fee_basis_points": 0,
                        "seller_fee_basis_points": 250,
                        "payout_address": null
                    },
                    "owner": {
                        "user": {
                            "username": "NullAddress"
                        },
                        "profile_img_url": "https://storage.googleapis.com/opensea-static/opensea-profile/1.png",
                        "address": "0x0000000000000000000000000000000000000000",
                        "config": "",
                        "discord_id": ""
                    },
                    "permalink": "https://opensea.io/assets/0x495f947276749ce646f68ac8c248420045cb7b5e/91610913282730143210461911219693399380844700131462702282955080970606332608513",
                    "collection": {
                        "banner_image_url": null,
                        "chat_url": null,
                        "created_date": "2021-05-25T17:35:56.869380",
                        "default_to_fiat": false,
                        "description": "Laser eyes for no reason whatsoever.",
                        "dev_buyer_fee_basis_points": "0",
                        "dev_seller_fee_basis_points": "0",
                        "discord_url": null,
                        "display_data": {
                            "card_display_style": "contain",
                            "images": []
                        },
                        "external_url": null,
                        "featured": false,
                        "featured_image_url": null,
                        "hidden": true,
                        "safelist_request_status": "not_requested",
                        "image_url": "https://lh3.googleusercontent.com/xOr6sGG5zUZl9dO8_KfNFDZlYRyoV1KjHsRgoyu7OnV12-aPUTg6IjJlzp1IRDFJbRsOyGo0_77RbuwUiUosHqvRwlQezykIAKMHcw=s120",
                        "is_subject_to_whitelist": false,
                        "large_image_url": null,
                        "medium_username": null,
                        "name": "The Laser Eye Collection",
                        "only_proxied_transfers": false,
                        "opensea_buyer_fee_basis_points": "0",
                        "opensea_seller_fee_basis_points": "250",
                        "payout_address": null,
                        "require_email": false,
                        "short_description": null,
                        "slug": "the-laser-eye-collection",
                        "telegram_url": null,
                        "twitter_username": null,
                        "instagram_username": null,
                        "wiki_url": null
                    },
                    "decimals": null,
                    "token_metadata": null
                },
                {
                    "id": 25653814,
                    "token_id": "91610913282730143210461911219693399380844700131462702282955080971705844236289",
                    "num_sales": 0,
                    "background_color": null,
                    "image_url": "https://lh3.googleusercontent.com/jMHSkKz1a7IBl8Y6TftdQsNVQq0XzJu5s7dmQV9vbMvxWOBW1LyoJT9oCN77NchvA43IQi-T2Kx3WwiFEuQTjrRK2SODxdShHX9HQQ",
                    "image_preview_url": "https://lh3.googleusercontent.com/jMHSkKz1a7IBl8Y6TftdQsNVQq0XzJu5s7dmQV9vbMvxWOBW1LyoJT9oCN77NchvA43IQi-T2Kx3WwiFEuQTjrRK2SODxdShHX9HQQ=s250",
                    "image_thumbnail_url": "https://lh3.googleusercontent.com/jMHSkKz1a7IBl8Y6TftdQsNVQq0XzJu5s7dmQV9vbMvxWOBW1LyoJT9oCN77NchvA43IQi-T2Kx3WwiFEuQTjrRK2SODxdShHX9HQQ=s128",
                    "image_original_url": null,
                    "animation_url": null,
                    "animation_original_url": null,
                    "name": "Laser Eye Nicholas Cage #2",
                    "description": null,
                    "external_link": null,
                    "asset_contract": {
                        "address": "0x495f947276749ce646f68ac8c248420045cb7b5e",
                        "asset_contract_type": "semi-fungible",
                        "created_date": "2020-12-02T17:40:53.232025",
                        "name": "OpenSea Collection",
                        "nft_version": null,
                        "opensea_version": "2.0.0",
                        "owner": 102384,
                        "schema_name": "ERC1155",
                        "symbol": "OPENSTORE",
                        "total_supply": null,
                        "description": null,
                        "external_link": null,
                        "image_url": null,
                        "default_to_fiat": false,
                        "dev_buyer_fee_basis_points": 0,
                        "dev_seller_fee_basis_points": 0,
                        "only_proxied_transfers": false,
                        "opensea_buyer_fee_basis_points": 0,
                        "opensea_seller_fee_basis_points": 250,
                        "buyer_fee_basis_points": 0,
                        "seller_fee_basis_points": 250,
                        "payout_address": null
                    },
                    "owner": {
                        "user": {
                            "username": "NullAddress"
                        },
                        "profile_img_url": "https://storage.googleapis.com/opensea-static/opensea-profile/1.png",
                        "address": "0x0000000000000000000000000000000000000000",
                        "config": "",
                        "discord_id": ""
                    },
                    "permalink": "https://opensea.io/assets/0x495f947276749ce646f68ac8c248420045cb7b5e/91610913282730143210461911219693399380844700131462702282955080971705844236289",
                    "collection": {
                        "banner_image_url": null,
                        "chat_url": null,
                        "created_date": "2021-05-25T17:35:56.869380",
                        "default_to_fiat": false,
                        "description": "Laser eyes for no reason whatsoever.",
                        "dev_buyer_fee_basis_points": "0",
                        "dev_seller_fee_basis_points": "0",
                        "discord_url": null,
                        "display_data": {
                            "card_display_style": "contain",
                            "images": []
                        },
                        "external_url": null,
                        "featured": false,
                        "featured_image_url": null,
                        "hidden": true,
                        "safelist_request_status": "not_requested",
                        "image_url": "https://lh3.googleusercontent.com/xOr6sGG5zUZl9dO8_KfNFDZlYRyoV1KjHsRgoyu7OnV12-aPUTg6IjJlzp1IRDFJbRsOyGo0_77RbuwUiUosHqvRwlQezykIAKMHcw=s120",
                        "is_subject_to_whitelist": false,
                        "large_image_url": null,
                        "medium_username": null,
                        "name": "The Laser Eye Collection",
                        "only_proxied_transfers": false,
                        "opensea_buyer_fee_basis_points": "0",
                        "opensea_seller_fee_basis_points": "250",
                        "payout_address": null,
                        "require_email": false,
                        "short_description": null,
                        "slug": "the-laser-eye-collection",
                        "telegram_url": null,
                        "twitter_username": null,
                        "instagram_username": null,
                        "wiki_url": null
                    },
                    "decimals": null,
                    "token_metadata": null
                },
                {
                    "id": 25654221,
                    "token_id": "91610913282730143210461911219693399380844700131462702282955080975004379119617",
                    "num_sales": 0,
                    "background_color": null,
                    "image_url": "https://lh3.googleusercontent.com/oAcRpHQb8OJ1OHilPOIfJ-dQtNokOL-vbBApj5iSQ3dMQP54x5Qa6I5gD1YHgftIuDtJljWj5JU4VK9X2Gp5GsUA688G3VoWXOzBIw",
                    "image_preview_url": "https://lh3.googleusercontent.com/oAcRpHQb8OJ1OHilPOIfJ-dQtNokOL-vbBApj5iSQ3dMQP54x5Qa6I5gD1YHgftIuDtJljWj5JU4VK9X2Gp5GsUA688G3VoWXOzBIw=s250",
                    "image_thumbnail_url": "https://lh3.googleusercontent.com/oAcRpHQb8OJ1OHilPOIfJ-dQtNokOL-vbBApj5iSQ3dMQP54x5Qa6I5gD1YHgftIuDtJljWj5JU4VK9X2Gp5GsUA688G3VoWXOzBIw=s128",
                    "image_original_url": null,
                    "animation_url": null,
                    "animation_original_url": null,
                    "name": "Grim Reaper Laser Eyes",
                    "description": null,
                    "external_link": null,
                    "asset_contract": {
                        "address": "0x495f947276749ce646f68ac8c248420045cb7b5e",
                        "asset_contract_type": "semi-fungible",
                        "created_date": "2020-12-02T17:40:53.232025",
                        "name": "OpenSea Collection",
                        "nft_version": null,
                        "opensea_version": "2.0.0",
                        "owner": 102384,
                        "schema_name": "ERC1155",
                        "symbol": "OPENSTORE",
                        "total_supply": null,
                        "description": null,
                        "external_link": null,
                        "image_url": null,
                        "default_to_fiat": false,
                        "dev_buyer_fee_basis_points": 0,
                        "dev_seller_fee_basis_points": 0,
                        "only_proxied_transfers": false,
                        "opensea_buyer_fee_basis_points": 0,
                        "opensea_seller_fee_basis_points": 250,
                        "buyer_fee_basis_points": 0,
                        "seller_fee_basis_points": 250,
                        "payout_address": null
                    },
                    "owner": {
                        "user": {
                            "username": "NullAddress"
                        },
                        "profile_img_url": "https://storage.googleapis.com/opensea-static/opensea-profile/1.png",
                        "address": "0x0000000000000000000000000000000000000000",
                        "config": "",
                        "discord_id": ""
                    },
                    "permalink": "https://opensea.io/assets/0x495f947276749ce646f68ac8c248420045cb7b5e/91610913282730143210461911219693399380844700131462702282955080975004379119617",
                    "collection": {
                        "banner_image_url": null,
                        "chat_url": null,
                        "created_date": "2021-05-25T17:35:56.869380",
                        "default_to_fiat": false,
                        "description": "Laser eyes for no reason whatsoever.",
                        "dev_buyer_fee_basis_points": "0",
                        "dev_seller_fee_basis_points": "0",
                        "discord_url": null,
                        "display_data": {
                            "card_display_style": "contain",
                            "images": []
                        },
                        "external_url": null,
                        "featured": false,
                        "featured_image_url": null,
                        "hidden": true,
                        "safelist_request_status": "not_requested",
                        "image_url": "https://lh3.googleusercontent.com/xOr6sGG5zUZl9dO8_KfNFDZlYRyoV1KjHsRgoyu7OnV12-aPUTg6IjJlzp1IRDFJbRsOyGo0_77RbuwUiUosHqvRwlQezykIAKMHcw=s120",
                        "is_subject_to_whitelist": false,
                        "large_image_url": null,
                        "medium_username": null,
                        "name": "The Laser Eye Collection",
                        "only_proxied_transfers": false,
                        "opensea_buyer_fee_basis_points": "0",
                        "opensea_seller_fee_basis_points": "250",
                        "payout_address": null,
                        "require_email": false,
                        "short_description": null,
                        "slug": "the-laser-eye-collection",
                        "telegram_url": null,
                        "twitter_username": null,
                        "instagram_username": null,
                        "wiki_url": null
                    },
                    "decimals": null,
                    "token_metadata": null
                },
                {
                    "id": 25654301,
                    "token_id": "91610913282730143210461911219693399380844700131462702282955080976103890747393",
                    "num_sales": 0,
                    "background_color": null,
                    "image_url": "https://lh3.googleusercontent.com/jrhZVLS2_tvRzrIa3PF7FWxGCKJXqdABW7ndHXboMoYIbEbPOrPNxWbYeSjKDettLZeWMz77al4c2Da7GW6mvlckwiNkktVKlSKFMA",
                    "image_preview_url": "https://lh3.googleusercontent.com/jrhZVLS2_tvRzrIa3PF7FWxGCKJXqdABW7ndHXboMoYIbEbPOrPNxWbYeSjKDettLZeWMz77al4c2Da7GW6mvlckwiNkktVKlSKFMA=s250",
                    "image_thumbnail_url": "https://lh3.googleusercontent.com/jrhZVLS2_tvRzrIa3PF7FWxGCKJXqdABW7ndHXboMoYIbEbPOrPNxWbYeSjKDettLZeWMz77al4c2Da7GW6mvlckwiNkktVKlSKFMA=s128",
                    "image_original_url": null,
                    "animation_url": null,
                    "animation_original_url": null,
                    "name": "Optimus Prime Laser Eyes Blue",
                    "description": null,
                    "external_link": null,
                    "asset_contract": {
                        "address": "0x495f947276749ce646f68ac8c248420045cb7b5e",
                        "asset_contract_type": "semi-fungible",
                        "created_date": "2020-12-02T17:40:53.232025",
                        "name": "OpenSea Collection",
                        "nft_version": null,
                        "opensea_version": "2.0.0",
                        "owner": 102384,
                        "schema_name": "ERC1155",
                        "symbol": "OPENSTORE",
                        "total_supply": null,
                        "description": null,
                        "external_link": null,
                        "image_url": null,
                        "default_to_fiat": false,
                        "dev_buyer_fee_basis_points": 0,
                        "dev_seller_fee_basis_points": 0,
                        "only_proxied_transfers": false,
                        "opensea_buyer_fee_basis_points": 0,
                        "opensea_seller_fee_basis_points": 250,
                        "buyer_fee_basis_points": 0,
                        "seller_fee_basis_points": 250,
                        "payout_address": null
                    },
                    "owner": {
                        "user": {
                            "username": "NullAddress"
                        },
                        "profile_img_url": "https://storage.googleapis.com/opensea-static/opensea-profile/1.png",
                        "address": "0x0000000000000000000000000000000000000000",
                        "config": "",
                        "discord_id": ""
                    },
                    "permalink": "https://opensea.io/assets/0x495f947276749ce646f68ac8c248420045cb7b5e/91610913282730143210461911219693399380844700131462702282955080976103890747393",
                    "collection": {
                        "banner_image_url": null,
                        "chat_url": null,
                        "created_date": "2021-05-25T17:35:56.869380",
                        "default_to_fiat": false,
                        "description": "Laser eyes for no reason whatsoever.",
                        "dev_buyer_fee_basis_points": "0",
                        "dev_seller_fee_basis_points": "0",
                        "discord_url": null,
                        "display_data": {
                            "card_display_style": "contain",
                            "images": []
                        },
                        "external_url": null,
                        "featured": false,
                        "featured_image_url": null,
                        "hidden": true,
                        "safelist_request_status": "not_requested",
                        "image_url": "https://lh3.googleusercontent.com/xOr6sGG5zUZl9dO8_KfNFDZlYRyoV1KjHsRgoyu7OnV12-aPUTg6IjJlzp1IRDFJbRsOyGo0_77RbuwUiUosHqvRwlQezykIAKMHcw=s120",
                        "is_subject_to_whitelist": false,
                        "large_image_url": null,
                        "medium_username": null,
                        "name": "The Laser Eye Collection",
                        "only_proxied_transfers": false,
                        "opensea_buyer_fee_basis_points": "0",
                        "opensea_seller_fee_basis_points": "250",
                        "payout_address": null,
                        "require_email": false,
                        "short_description": null,
                        "slug": "the-laser-eye-collection",
                        "telegram_url": null,
                        "twitter_username": null,
                        "instagram_username": null,
                        "wiki_url": null
                    },
                    "decimals": null,
                    "token_metadata": null
                },
                {
                    "id": 25654364,
                    "token_id": "91610913282730143210461911219693399380844700131462702282955080977203402375169",
                    "num_sales": 0,
                    "background_color": null,
                    "image_url": "https://lh3.googleusercontent.com/RMgI_k7ttOHqEaRVmldHAeRd4_BXCDf_QsgEfNEKwXouLj30uE46LykhOFUlZ6QB7rWdRekmI4DFN-DmxOabY8cDKSQMOEtFvpVb7No",
                    "image_preview_url": "https://lh3.googleusercontent.com/RMgI_k7ttOHqEaRVmldHAeRd4_BXCDf_QsgEfNEKwXouLj30uE46LykhOFUlZ6QB7rWdRekmI4DFN-DmxOabY8cDKSQMOEtFvpVb7No=s250",
                    "image_thumbnail_url": "https://lh3.googleusercontent.com/RMgI_k7ttOHqEaRVmldHAeRd4_BXCDf_QsgEfNEKwXouLj30uE46LykhOFUlZ6QB7rWdRekmI4DFN-DmxOabY8cDKSQMOEtFvpVb7No=s128",
                    "image_original_url": null,
                    "animation_url": null,
                    "animation_original_url": null,
                    "name": "Optimus Prime Laser Eyes Red",
                    "description": null,
                    "external_link": null,
                    "asset_contract": {
                        "address": "0x495f947276749ce646f68ac8c248420045cb7b5e",
                        "asset_contract_type": "semi-fungible",
                        "created_date": "2020-12-02T17:40:53.232025",
                        "name": "OpenSea Collection",
                        "nft_version": null,
                        "opensea_version": "2.0.0",
                        "owner": 102384,
                        "schema_name": "ERC1155",
                        "symbol": "OPENSTORE",
                        "total_supply": null,
                        "description": null,
                        "external_link": null,
                        "image_url": null,
                        "default_to_fiat": false,
                        "dev_buyer_fee_basis_points": 0,
                        "dev_seller_fee_basis_points": 0,
                        "only_proxied_transfers": false,
                        "opensea_buyer_fee_basis_points": 0,
                        "opensea_seller_fee_basis_points": 250,
                        "buyer_fee_basis_points": 0,
                        "seller_fee_basis_points": 250,
                        "payout_address": null
                    },
                    "owner": {
                        "user": {
                            "username": "NullAddress"
                        },
                        "profile_img_url": "https://storage.googleapis.com/opensea-static/opensea-profile/1.png",
                        "address": "0x0000000000000000000000000000000000000000",
                        "config": "",
                        "discord_id": ""
                    },
                    "permalink": "https://opensea.io/assets/0x495f947276749ce646f68ac8c248420045cb7b5e/91610913282730143210461911219693399380844700131462702282955080977203402375169",
                    "collection": {
                        "banner_image_url": null,
                        "chat_url": null,
                        "created_date": "2021-05-25T17:35:56.869380",
                        "default_to_fiat": false,
                        "description": "Laser eyes for no reason whatsoever.",
                        "dev_buyer_fee_basis_points": "0",
                        "dev_seller_fee_basis_points": "0",
                        "discord_url": null,
                        "display_data": {
                            "card_display_style": "contain",
                            "images": []
                        },
                        "external_url": null,
                        "featured": false,
                        "featured_image_url": null,
                        "hidden": true,
                        "safelist_request_status": "not_requested",
                        "image_url": "https://lh3.googleusercontent.com/xOr6sGG5zUZl9dO8_KfNFDZlYRyoV1KjHsRgoyu7OnV12-aPUTg6IjJlzp1IRDFJbRsOyGo0_77RbuwUiUosHqvRwlQezykIAKMHcw=s120",
                        "is_subject_to_whitelist": false,
                        "large_image_url": null,
                        "medium_username": null,
                        "name": "The Laser Eye Collection",
                        "only_proxied_transfers": false,
                        "opensea_buyer_fee_basis_points": "0",
                        "opensea_seller_fee_basis_points": "250",
                        "payout_address": null,
                        "require_email": false,
                        "short_description": null,
                        "slug": "the-laser-eye-collection",
                        "telegram_url": null,
                        "twitter_username": null,
                        "instagram_username": null,
                        "wiki_url": null
                    },
                    "decimals": null,
                    "token_metadata": null
                },
                {
                    "id": 25654451,
                    "token_id": "91610913282730143210461911219693399380844700131462702282955080978302914002945",
                    "num_sales": 0,
                    "background_color": null,
                    "image_url": "https://lh3.googleusercontent.com/2lq0nsZnUtVgIv1bEDCm-fJWOtFo5fpwHoirkZoQz3Uep3YNXfdaI_Y1TS13AUCj2wiue3agbPJsosO4whYaXMi4VXdnElaEDx5-jg",
                    "image_preview_url": "https://lh3.googleusercontent.com/2lq0nsZnUtVgIv1bEDCm-fJWOtFo5fpwHoirkZoQz3Uep3YNXfdaI_Y1TS13AUCj2wiue3agbPJsosO4whYaXMi4VXdnElaEDx5-jg=s250",
                    "image_thumbnail_url": "https://lh3.googleusercontent.com/2lq0nsZnUtVgIv1bEDCm-fJWOtFo5fpwHoirkZoQz3Uep3YNXfdaI_Y1TS13AUCj2wiue3agbPJsosO4whYaXMi4VXdnElaEDx5-jg=s128",
                    "image_original_url": null,
                    "animation_url": null,
                    "animation_original_url": null,
                    "name": "Optimus Prime Laser Eyes Green",
                    "description": null,
                    "external_link": null,
                    "asset_contract": {
                        "address": "0x495f947276749ce646f68ac8c248420045cb7b5e",
                        "asset_contract_type": "semi-fungible",
                        "created_date": "2020-12-02T17:40:53.232025",
                        "name": "OpenSea Collection",
                        "nft_version": null,
                        "opensea_version": "2.0.0",
                        "owner": 102384,
                        "schema_name": "ERC1155",
                        "symbol": "OPENSTORE",
                        "total_supply": null,
                        "description": null,
                        "external_link": null,
                        "image_url": null,
                        "default_to_fiat": false,
                        "dev_buyer_fee_basis_points": 0,
                        "dev_seller_fee_basis_points": 0,
                        "only_proxied_transfers": false,
                        "opensea_buyer_fee_basis_points": 0,
                        "opensea_seller_fee_basis_points": 250,
                        "buyer_fee_basis_points": 0,
                        "seller_fee_basis_points": 250,
                        "payout_address": null
                    },
                    "owner": {
                        "user": {
                            "username": "NullAddress"
                        },
                        "profile_img_url": "https://storage.googleapis.com/opensea-static/opensea-profile/1.png",
                        "address": "0x0000000000000000000000000000000000000000",
                        "config": "",
                        "discord_id": ""
                    },
                    "permalink": "https://opensea.io/assets/0x495f947276749ce646f68ac8c248420045cb7b5e/91610913282730143210461911219693399380844700131462702282955080978302914002945",
                    "collection": {
                        "banner_image_url": null,
                        "chat_url": null,
                        "created_date": "2021-05-25T17:35:56.869380",
                        "default_to_fiat": false,
                        "description": "Laser eyes for no reason whatsoever.",
                        "dev_buyer_fee_basis_points": "0",
                        "dev_seller_fee_basis_points": "0",
                        "discord_url": null,
                        "display_data": {
                            "card_display_style": "contain",
                            "images": []
                        },
                        "external_url": null,
                        "featured": false,
                        "featured_image_url": null,
                        "hidden": true,
                        "safelist_request_status": "not_requested",
                        "image_url": "https://lh3.googleusercontent.com/xOr6sGG5zUZl9dO8_KfNFDZlYRyoV1KjHsRgoyu7OnV12-aPUTg6IjJlzp1IRDFJbRsOyGo0_77RbuwUiUosHqvRwlQezykIAKMHcw=s120",
                        "is_subject_to_whitelist": false,
                        "large_image_url": null,
                        "medium_username": null,
                        "name": "The Laser Eye Collection",
                        "only_proxied_transfers": false,
                        "opensea_buyer_fee_basis_points": "0",
                        "opensea_seller_fee_basis_points": "250",
                        "payout_address": null,
                        "require_email": false,
                        "short_description": null,
                        "slug": "the-laser-eye-collection",
                        "telegram_url": null,
                        "twitter_username": null,
                        "instagram_username": null,
                        "wiki_url": null
                    },
                    "decimals": null,
                    "token_metadata": null
                },
                {
                    "id": 25654855,
                    "token_id": "91610913282730143210461911219693399380844700131462702282955080980501937258497",
                    "num_sales": 0,
                    "background_color": null,
                    "image_url": "https://lh3.googleusercontent.com/cGeJULiVJWBezTf3vtbC4z6dQuf2GWJOX4rXqxA_SylruWkJgqJcRwyIwpe6piXANMfmqb7WU2t3iSK4P7ieLGV1arwl0n82xOkrhA",
                    "image_preview_url": "https://lh3.googleusercontent.com/cGeJULiVJWBezTf3vtbC4z6dQuf2GWJOX4rXqxA_SylruWkJgqJcRwyIwpe6piXANMfmqb7WU2t3iSK4P7ieLGV1arwl0n82xOkrhA=s250",
                    "image_thumbnail_url": "https://lh3.googleusercontent.com/cGeJULiVJWBezTf3vtbC4z6dQuf2GWJOX4rXqxA_SylruWkJgqJcRwyIwpe6piXANMfmqb7WU2t3iSK4P7ieLGV1arwl0n82xOkrhA=s128",
                    "image_original_url": null,
                    "animation_url": null,
                    "animation_original_url": null,
                    "name": "Optimus Prime Laser Eyes Omega",
                    "description": null,
                    "external_link": null,
                    "asset_contract": {
                        "address": "0x495f947276749ce646f68ac8c248420045cb7b5e",
                        "asset_contract_type": "semi-fungible",
                        "created_date": "2020-12-02T17:40:53.232025",
                        "name": "OpenSea Collection",
                        "nft_version": null,
                        "opensea_version": "2.0.0",
                        "owner": 102384,
                        "schema_name": "ERC1155",
                        "symbol": "OPENSTORE",
                        "total_supply": null,
                        "description": null,
                        "external_link": null,
                        "image_url": null,
                        "default_to_fiat": false,
                        "dev_buyer_fee_basis_points": 0,
                        "dev_seller_fee_basis_points": 0,
                        "only_proxied_transfers": false,
                        "opensea_buyer_fee_basis_points": 0,
                        "opensea_seller_fee_basis_points": 250,
                        "buyer_fee_basis_points": 0,
                        "seller_fee_basis_points": 250,
                        "payout_address": null
                    },
                    "owner": {
                        "user": {
                            "username": "NullAddress"
                        },
                        "profile_img_url": "https://storage.googleapis.com/opensea-static/opensea-profile/1.png",
                        "address": "0x0000000000000000000000000000000000000000",
                        "config": "",
                        "discord_id": ""
                    },
                    "permalink": "https://opensea.io/assets/0x495f947276749ce646f68ac8c248420045cb7b5e/91610913282730143210461911219693399380844700131462702282955080980501937258497",
                    "collection": {
                        "banner_image_url": null,
                        "chat_url": null,
                        "created_date": "2021-05-25T17:35:56.869380",
                        "default_to_fiat": false,
                        "description": "Laser eyes for no reason whatsoever.",
                        "dev_buyer_fee_basis_points": "0",
                        "dev_seller_fee_basis_points": "0",
                        "discord_url": null,
                        "display_data": {
                            "card_display_style": "contain",
                            "images": []
                        },
                        "external_url": null,
                        "featured": false,
                        "featured_image_url": null,
                        "hidden": true,
                        "safelist_request_status": "not_requested",
                        "image_url": "https://lh3.googleusercontent.com/xOr6sGG5zUZl9dO8_KfNFDZlYRyoV1KjHsRgoyu7OnV12-aPUTg6IjJlzp1IRDFJbRsOyGo0_77RbuwUiUosHqvRwlQezykIAKMHcw=s120",
                        "is_subject_to_whitelist": false,
                        "large_image_url": null,
                        "medium_username": null,
                        "name": "The Laser Eye Collection",
                        "only_proxied_transfers": false,
                        "opensea_buyer_fee_basis_points": "0",
                        "opensea_seller_fee_basis_points": "250",
                        "payout_address": null,
                        "require_email": false,
                        "short_description": null,
                        "slug": "the-laser-eye-collection",
                        "telegram_url": null,
                        "twitter_username": null,
                        "instagram_username": null,
                        "wiki_url": null
                    },
                    "decimals": null,
                    "token_metadata": null
                }
            ],
            "name": "Laser Eye Bundle",
            "description": "Bundle of laser eyes.",
            "external_link": "",
            "asset_contract": {
                "collection": {
                    "banner_image_url": null,
                    "chat_url": null,
                    "created_date": "2020-12-02T17:40:53.507540",
                    "default_to_fiat": false,
                    "description": null,
                    "dev_buyer_fee_basis_points": "0",
                    "dev_seller_fee_basis_points": "0",
                    "discord_url": null,
                    "display_data": {
                        "card_display_style": "contain",
                        "images": []
                    },
                    "external_url": null,
                    "featured": false,
                    "featured_image_url": null,
                    "hidden": true,
                    "safelist_request_status": "not_requested",
                    "image_url": null,
                    "is_subject_to_whitelist": false,
                    "large_image_url": null,
                    "medium_username": null,
                    "name": "OpenSea Shared Storefront V2",
                    "only_proxied_transfers": false,
                    "opensea_buyer_fee_basis_points": "0",
                    "opensea_seller_fee_basis_points": "250",
                    "payout_address": null,
                    "require_email": false,
                    "short_description": null,
                    "slug": "opensea-shared-storefront-v2",
                    "telegram_url": null,
                    "twitter_username": null,
                    "instagram_username": null,
                    "wiki_url": null
                },
                "address": "0x495f947276749ce646f68ac8c248420045cb7b5e",
                "asset_contract_type": "semi-fungible",
                "created_date": "2020-12-02T17:40:53.232025",
                "name": "OpenSea Collection",
                "nft_version": null,
                "opensea_version": "2.0.0",
                "owner": 102384,
                "schema_name": "ERC1155",
                "symbol": "OPENSTORE",
                "total_supply": null,
                "description": null,
                "external_link": null,
                "image_url": null,
                "default_to_fiat": false,
                "dev_buyer_fee_basis_points": 0,
                "dev_seller_fee_basis_points": 0,
                "only_proxied_transfers": false,
                "opensea_buyer_fee_basis_points": 0,
                "opensea_seller_fee_basis_points": 250,
                "buyer_fee_basis_points": 0,
                "seller_fee_basis_points": 250,
                "payout_address": null
            },
            "permalink": "https://opensea.io/bundles/laser-eye-bundle-3Ws",
            "sell_orders": [
                {
                    "created_date": "2021-05-25T20:20:41.533701",
                    "closing_date": null,
                    "closing_extendable": false,
                    "expiration_time": 0,
                    "listing_time": 1621973921,
                    "order_hash": "0xf4a05baa2816ac6b4d0fe823cbe6635575d70ce23589dce2c4cb09aa1aa5ba43",
                    "metadata": {
                        "bundle": {
                            "assets": [
                                {
                                    "id": "91610913282730143210461911219693399380844700131462702282955080970606332608513",
                                    "address": "0x495f947276749ce646f68ac8c248420045cb7b5e",
                                    "quantity": "1"
                                },
                                {
                                    "id": "91610913282730143210461911219693399380844700131462702282955080971705844236289",
                                    "address": "0x495f947276749ce646f68ac8c248420045cb7b5e",
                                    "quantity": "1"
                                },
                                {
                                    "id": "91610913282730143210461911219693399380844700131462702282955080975004379119617",
                                    "address": "0x495f947276749ce646f68ac8c248420045cb7b5e",
                                    "quantity": "1"
                                },
                                {
                                    "id": "91610913282730143210461911219693399380844700131462702282955080976103890747393",
                                    "address": "0x495f947276749ce646f68ac8c248420045cb7b5e",
                                    "quantity": "1"
                                },
                                {
                                    "id": "91610913282730143210461911219693399380844700131462702282955080977203402375169",
                                    "address": "0x495f947276749ce646f68ac8c248420045cb7b5e",
                                    "quantity": "1"
                                },
                                {
                                    "id": "91610913282730143210461911219693399380844700131462702282955080978302914002945",
                                    "address": "0x495f947276749ce646f68ac8c248420045cb7b5e",
                                    "quantity": "1"
                                },
                                {
                                    "id": "91610913282730143210461911219693399380844700131462702282955080980501937258497",
                                    "address": "0x495f947276749ce646f68ac8c248420045cb7b5e",
                                    "quantity": "1"
                                }
                            ],
                            "schemas": [
                                "ERC1155",
                                "ERC1155",
                                "ERC1155",
                                "ERC1155",
                                "ERC1155",
                                "ERC1155",
                                "ERC1155"
                            ],
                            "name": "Laser Eye Bundle",
                            "description": "Bundle of laser eyes.",
                            "external_link": ""
                        }
                    },
                    "exchange": "0x7be8076f4ea4a4ad08075c2508e481d6c946d12b",
                    "maker": {
                        "user": 850998,
                        "profile_img_url": "https://storage.googleapis.com/opensea-static/opensea-profile/5.png",
                        "address": "0xca89f07e2f171bf8f1f46368cd8a1f28be8e702d",
                        "config": "",
                        "discord_id": ""
                    },
                    "taker": {
                        "user": 1766,
                        "profile_img_url": "https://storage.googleapis.com/opensea-static/opensea-profile/1.png",
                        "address": "0x0000000000000000000000000000000000000000",
                        "config": "",
                        "discord_id": ""
                    },
                    "current_price": "40000000000000000",
                    "current_bounty": "400000000000000",
                    "bounty_multiple": "0.01",
                    "maker_relayer_fee": "250",
                    "taker_relayer_fee": "0",
                    "maker_protocol_fee": "0",
                    "taker_protocol_fee": "0",
                    "maker_referrer_fee": "0",
                    "fee_recipient": {
                        "user": 3585,
                        "profile_img_url": "https://storage.googleapis.com/opensea-static/opensea-profile/28.png",
                        "address": "0x5b3256965e7c3cf26e11fcaf296dfc8807c01073",
                        "config": "verified",
                        "discord_id": ""
                    },
                    "fee_method": 1,
                    "side": 1,
                    "sale_kind": 0,
                    "target": "0xc99f70bfd82fb7c8f8191fdfbfb735606b15e5c5",
                    "how_to_call": 1,
                    "calldata": "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",
                    "replacement_pattern": "0x0000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000ffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffff0000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000ffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffff0000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000ffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffff0000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000ffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffff0000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000ffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffff0000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000ffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffff0000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000ffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffff000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000",
                    "static_target": "0x0000000000000000000000000000000000000000",
                    "static_extradata": "0x",
                    "payment_token": "0x0000000000000000000000000000000000000000",
                    "payment_token_contract": {
                        "id": 1,
                        "symbol": "ETH",
                        "address": "0x0000000000000000000000000000000000000000",
                        "image_url": "https://storage.opensea.io/files/6f8e2979d428180222796ff4a33ab929.svg",
                        "name": "Ether",
                        "decimals": 18,
                        "eth_price": "1.000000000000000",
                        "usd_price": "2625.730000000000018000"
                    },
                    "base_price": "40000000000000000",
                    "extra": "0",
                    "quantity": "1",
                    "salt": "13683506627202132049304419258981697359701080933644897269628398730805540426799",
                    "v": 28,
                    "r": "0x7d8c313d815faae005c655ee6b9b74e89f935ad835d629b81db6347d908a8957",
                    "s": "0x25811c11751c29242ece35a6c9eadcc23299a9b39893a590d97303cc6ac3d0bc",
                    "approved_on_chain": false,
                    "cancelled": false,
                    "finalized": false,
                    "marked_invalid": false,
                    "prefixed_hash": "0xc452148a60c4c0d68e6bec21e97ccb21a90599139613eaf4fb20a55737d37114"
                }
            ]
        },
        {
            "maker": {
                "user": {
                    "username": "AndresMCP"
                },
                "profile_img_url": "https://storage.googleapis.com/opensea-static/opensea-profile/25.png",
                "address": "0x707fc60f834e1ffe012339876705f375532e96e0",
                "config": "affiliate",
                "discord_id": ""
            },
            "slug": "44-7gO",
            "assets": [
                {
                    "id": 13303556,
                    "token_id": "18402",
                    "num_sales": 0,
                    "background_color": null,
                    "image_url": "https://lh3.googleusercontent.com/aUafsiapdNLnzgmxO03shZdhGz-M9vhx6_l2p6rMFgh040tyRJuukTxASCnPRG49yNQx7H5lqXX80U1T3FnHQvVPsA",
                    "image_preview_url": "https://lh3.googleusercontent.com/aUafsiapdNLnzgmxO03shZdhGz-M9vhx6_l2p6rMFgh040tyRJuukTxASCnPRG49yNQx7H5lqXX80U1T3FnHQvVPsA=s250",
                    "image_thumbnail_url": "https://lh3.googleusercontent.com/aUafsiapdNLnzgmxO03shZdhGz-M9vhx6_l2p6rMFgh040tyRJuukTxASCnPRG49yNQx7H5lqXX80U1T3FnHQvVPsA=s128",
                    "image_original_url": "https://mcp3d.com/api/image/land/18402/b",
                    "animation_url": null,
                    "animation_original_url": null,
                    "name": "Business Center #124 X 160 Y 211",
                    "description": "Allows to collect Ether from the Global Fund.",
                    "external_link": "https://play.mcp3d.com/?x=160&y=211",
                    "asset_contract": {
                        "address": "0xe15e9c0bf6b6b29d3b9e1c921ab2cb09c2194463",
                        "asset_contract_type": "non-fungible",
                        "created_date": "2019-12-10T23:47:44.431801",
                        "name": "MCP Land",
                        "nft_version": "3.0",
                        "opensea_version": null,
                        "owner": 304453,
                        "schema_name": "ERC721",
                        "symbol": "",
                        "total_supply": "11",
                        "description": "MegaCryptoPolis is the decentralized city builder game. Citizens are required for buildings to operate under the Microeconomy concept.",
                        "external_link": "https://www.megacryptopolis.com",
                        "image_url": "https://lh3.googleusercontent.com/OBW6ndpdiJuU1ZW_N1WsF60c1Q-6TANtp33VS8HVyCvz-yvh3CUTDhNBG0PLcQXAhxg33fsBXB1DXS-uU7X1H9uxng=s60",
                        "default_to_fiat": false,
                        "dev_buyer_fee_basis_points": 0,
                        "dev_seller_fee_basis_points": 0,
                        "only_proxied_transfers": false,
                        "opensea_buyer_fee_basis_points": 0,
                        "opensea_seller_fee_basis_points": 250,
                        "buyer_fee_basis_points": 0,
                        "seller_fee_basis_points": 250,
                        "payout_address": null
                    },
                    "owner": {
                        "user": {
                            "username": "OneVacciNation"
                        },
                        "profile_img_url": "https://storage.googleapis.com/opensea-static/opensea-profile/17.png",
                        "address": "0x6bfb033c1b882f494770ffdcbca1b67e62d960fd",
                        "config": "affiliate",
                        "discord_id": ""
                    },
                    "permalink": "https://opensea.io/assets/0xe15e9c0bf6b6b29d3b9e1c921ab2cb09c2194463/18402",
                    "collection": {
                        "banner_image_url": null,
                        "chat_url": null,
                        "created_date": "2019-06-25T03:52:24.508387",
                        "default_to_fiat": false,
                        "description": "MegaCryptoPolis is the decentralized city builder game. Citizens are required for buildings to operate under the Microeconomy concept.",
                        "dev_buyer_fee_basis_points": "0",
                        "dev_seller_fee_basis_points": "0",
                        "discord_url": "https://discord.gg/AyX5QRw",
                        "display_data": {
                            "card_display_style": "padded"
                        },
                        "external_url": "https://www.megacryptopolis.com",
                        "featured": false,
                        "featured_image_url": "https://lh3.googleusercontent.com/oo_QBA7QFDwtX8s9r77SmD0ImjeVOGe2ewrUsalGKDONn8Mmw-TMYNvEnlhdylbGWmLkA2S4hGM7P0p3zvyZEo4unpRkFBqGmtwT=s300",
                        "hidden": false,
                        "safelist_request_status": "verified",
                        "image_url": "https://lh3.googleusercontent.com/OBW6ndpdiJuU1ZW_N1WsF60c1Q-6TANtp33VS8HVyCvz-yvh3CUTDhNBG0PLcQXAhxg33fsBXB1DXS-uU7X1H9uxng=s60",
                        "is_subject_to_whitelist": false,
                        "large_image_url": "https://lh3.googleusercontent.com/oo_QBA7QFDwtX8s9r77SmD0ImjeVOGe2ewrUsalGKDONn8Mmw-TMYNvEnlhdylbGWmLkA2S4hGM7P0p3zvyZEo4unpRkFBqGmtwT=s300",
                        "medium_username": "megacryptopolis/",
                        "name": "MegaCryptoPolis",
                        "only_proxied_transfers": false,
                        "opensea_buyer_fee_basis_points": "0",
                        "opensea_seller_fee_basis_points": "250",
                        "payout_address": null,
                        "require_email": false,
                        "short_description": null,
                        "slug": "megacryptopolis",
                        "telegram_url": "https://t.me/megacryptopolis",
                        "twitter_username": "megacryptopolis",
                        "instagram_username": null,
                        "wiki_url": null
                    },
                    "decimals": 0,
                    "token_metadata": "https://mcp.town/api/land/18402"
                },
                {
                    "id": 13305961,
                    "token_id": "19760",
                    "num_sales": 0,
                    "background_color": null,
                    "image_url": "https://lh3.googleusercontent.com/aUafsiapdNLnzgmxO03shZdhGz-M9vhx6_l2p6rMFgh040tyRJuukTxASCnPRG49yNQx7H5lqXX80U1T3FnHQvVPsA",
                    "image_preview_url": "https://lh3.googleusercontent.com/aUafsiapdNLnzgmxO03shZdhGz-M9vhx6_l2p6rMFgh040tyRJuukTxASCnPRG49yNQx7H5lqXX80U1T3FnHQvVPsA=s250",
                    "image_thumbnail_url": "https://lh3.googleusercontent.com/aUafsiapdNLnzgmxO03shZdhGz-M9vhx6_l2p6rMFgh040tyRJuukTxASCnPRG49yNQx7H5lqXX80U1T3FnHQvVPsA=s128",
                    "image_original_url": "https://mcp3d.com/api/image/land/19760/b",
                    "animation_url": null,
                    "animation_original_url": null,
                    "name": "Business Center #133 X 63 Y 379",
                    "description": "Allows to collect Ether from the Global Fund.",
                    "external_link": "https://play.mcp3d.com/?x=63&y=379",
                    "asset_contract": {
                        "address": "0xe15e9c0bf6b6b29d3b9e1c921ab2cb09c2194463",
                        "asset_contract_type": "non-fungible",
                        "created_date": "2019-12-10T23:47:44.431801",
                        "name": "MCP Land",
                        "nft_version": "3.0",
                        "opensea_version": null,
                        "owner": 304453,
                        "schema_name": "ERC721",
                        "symbol": "",
                        "total_supply": "11",
                        "description": "MegaCryptoPolis is the decentralized city builder game. Citizens are required for buildings to operate under the Microeconomy concept.",
                        "external_link": "https://www.megacryptopolis.com",
                        "image_url": "https://lh3.googleusercontent.com/OBW6ndpdiJuU1ZW_N1WsF60c1Q-6TANtp33VS8HVyCvz-yvh3CUTDhNBG0PLcQXAhxg33fsBXB1DXS-uU7X1H9uxng=s60",
                        "default_to_fiat": false,
                        "dev_buyer_fee_basis_points": 0,
                        "dev_seller_fee_basis_points": 0,
                        "only_proxied_transfers": false,
                        "opensea_buyer_fee_basis_points": 0,
                        "opensea_seller_fee_basis_points": 250,
                        "buyer_fee_basis_points": 0,
                        "seller_fee_basis_points": 250,
                        "payout_address": null
                    },
                    "owner": {
                        "user": {
                            "username": "OneVacciNation"
                        },
                        "profile_img_url": "https://storage.googleapis.com/opensea-static/opensea-profile/17.png",
                        "address": "0x6bfb033c1b882f494770ffdcbca1b67e62d960fd",
                        "config": "affiliate",
                        "discord_id": ""
                    },
                    "permalink": "https://opensea.io/assets/0xe15e9c0bf6b6b29d3b9e1c921ab2cb09c2194463/19760",
                    "collection": {
                        "banner_image_url": null,
                        "chat_url": null,
                        "created_date": "2019-06-25T03:52:24.508387",
                        "default_to_fiat": false,
                        "description": "MegaCryptoPolis is the decentralized city builder game. Citizens are required for buildings to operate under the Microeconomy concept.",
                        "dev_buyer_fee_basis_points": "0",
                        "dev_seller_fee_basis_points": "0",
                        "discord_url": "https://discord.gg/AyX5QRw",
                        "display_data": {
                            "card_display_style": "padded"
                        },
                        "external_url": "https://www.megacryptopolis.com",
                        "featured": false,
                        "featured_image_url": "https://lh3.googleusercontent.com/oo_QBA7QFDwtX8s9r77SmD0ImjeVOGe2ewrUsalGKDONn8Mmw-TMYNvEnlhdylbGWmLkA2S4hGM7P0p3zvyZEo4unpRkFBqGmtwT=s300",
                        "hidden": false,
                        "safelist_request_status": "verified",
                        "image_url": "https://lh3.googleusercontent.com/OBW6ndpdiJuU1ZW_N1WsF60c1Q-6TANtp33VS8HVyCvz-yvh3CUTDhNBG0PLcQXAhxg33fsBXB1DXS-uU7X1H9uxng=s60",
                        "is_subject_to_whitelist": false,
                        "large_image_url": "https://lh3.googleusercontent.com/oo_QBA7QFDwtX8s9r77SmD0ImjeVOGe2ewrUsalGKDONn8Mmw-TMYNvEnlhdylbGWmLkA2S4hGM7P0p3zvyZEo4unpRkFBqGmtwT=s300",
                        "medium_username": "megacryptopolis/",
                        "name": "MegaCryptoPolis",
                        "only_proxied_transfers": false,
                        "opensea_buyer_fee_basis_points": "0",
                        "opensea_seller_fee_basis_points": "250",
                        "payout_address": null,
                        "require_email": false,
                        "short_description": null,
                        "slug": "megacryptopolis",
                        "telegram_url": "https://t.me/megacryptopolis",
                        "twitter_username": "megacryptopolis",
                        "instagram_username": null,
                        "wiki_url": null
                    },
                    "decimals": 0,
                    "token_metadata": "https://mcp.town/api/land/19760"
                },
                {
                    "id": 13342316,
                    "token_id": "44",
                    "num_sales": 2,
                    "background_color": null,
                    "image_url": "https://lh3.googleusercontent.com/2W12m3p_XuI_C3Ki_1xKV0PLnV3lKMyGFXS5E01XnYtuxL8wNguUYjn4cQ_iYvZcC1SiHm3JsWkIzrGNesO2cPiF",
                    "image_preview_url": "https://lh3.googleusercontent.com/2W12m3p_XuI_C3Ki_1xKV0PLnV3lKMyGFXS5E01XnYtuxL8wNguUYjn4cQ_iYvZcC1SiHm3JsWkIzrGNesO2cPiF=s250",
                    "image_thumbnail_url": "https://lh3.googleusercontent.com/2W12m3p_XuI_C3Ki_1xKV0PLnV3lKMyGFXS5E01XnYtuxL8wNguUYjn4cQ_iYvZcC1SiHm3JsWkIzrGNesO2cPiF=s128",
                    "image_original_url": "https://mcp3d.com/api/image/region/44/b",
                    "animation_url": null,
                    "animation_original_url": null,
                    "name": "Region #44",
                    "description": null,
                    "external_link": "https://play.mcp3d.com/?manage=region&id=44",
                    "asset_contract": {
                        "address": "0x778cc248cdddfd926bfba49850098eac16b0d12a",
                        "asset_contract_type": "non-fungible",
                        "created_date": "2019-12-13T15:19:42.304460",
                        "name": "MCP Region",
                        "nft_version": "3.0",
                        "opensea_version": null,
                        "owner": 304453,
                        "schema_name": "ERC721",
                        "symbol": "",
                        "total_supply": "5",
                        "description": "MegaCryptoPolis is the decentralized city builder game. Citizens are required for buildings to operate under the Microeconomy concept.",
                        "external_link": "https://www.megacryptopolis.com",
                        "image_url": "https://lh3.googleusercontent.com/OBW6ndpdiJuU1ZW_N1WsF60c1Q-6TANtp33VS8HVyCvz-yvh3CUTDhNBG0PLcQXAhxg33fsBXB1DXS-uU7X1H9uxng=s60",
                        "default_to_fiat": false,
                        "dev_buyer_fee_basis_points": 0,
                        "dev_seller_fee_basis_points": 0,
                        "only_proxied_transfers": false,
                        "opensea_buyer_fee_basis_points": 0,
                        "opensea_seller_fee_basis_points": 250,
                        "buyer_fee_basis_points": 0,
                        "seller_fee_basis_points": 250,
                        "payout_address": null
                    },
                    "owner": {
                        "user": {
                            "username": "OneVacciNation"
                        },
                        "profile_img_url": "https://storage.googleapis.com/opensea-static/opensea-profile/17.png",
                        "address": "0x6bfb033c1b882f494770ffdcbca1b67e62d960fd",
                        "config": "affiliate",
                        "discord_id": ""
                    },
                    "permalink": "https://opensea.io/assets/0x778cc248cdddfd926bfba49850098eac16b0d12a/44",
                    "collection": {
                        "banner_image_url": null,
                        "chat_url": null,
                        "created_date": "2019-06-25T03:52:24.508387",
                        "default_to_fiat": false,
                        "description": "MegaCryptoPolis is the decentralized city builder game. Citizens are required for buildings to operate under the Microeconomy concept.",
                        "dev_buyer_fee_basis_points": "0",
                        "dev_seller_fee_basis_points": "0",
                        "discord_url": "https://discord.gg/AyX5QRw",
                        "display_data": {
                            "card_display_style": "padded"
                        },
                        "external_url": "https://www.megacryptopolis.com",
                        "featured": false,
                        "featured_image_url": "https://lh3.googleusercontent.com/oo_QBA7QFDwtX8s9r77SmD0ImjeVOGe2ewrUsalGKDONn8Mmw-TMYNvEnlhdylbGWmLkA2S4hGM7P0p3zvyZEo4unpRkFBqGmtwT=s300",
                        "hidden": false,
                        "safelist_request_status": "verified",
                        "image_url": "https://lh3.googleusercontent.com/OBW6ndpdiJuU1ZW_N1WsF60c1Q-6TANtp33VS8HVyCvz-yvh3CUTDhNBG0PLcQXAhxg33fsBXB1DXS-uU7X1H9uxng=s60",
                        "is_subject_to_whitelist": false,
                        "large_image_url": "https://lh3.googleusercontent.com/oo_QBA7QFDwtX8s9r77SmD0ImjeVOGe2ewrUsalGKDONn8Mmw-TMYNvEnlhdylbGWmLkA2S4hGM7P0p3zvyZEo4unpRkFBqGmtwT=s300",
                        "medium_username": "megacryptopolis/",
                        "name": "MegaCryptoPolis",
                        "only_proxied_transfers": false,
                        "opensea_buyer_fee_basis_points": "0",
                        "opensea_seller_fee_basis_points": "250",
                        "payout_address": null,
                        "require_email": false,
                        "short_description": null,
                        "slug": "megacryptopolis",
                        "telegram_url": "https://t.me/megacryptopolis",
                        "twitter_username": "megacryptopolis",
                        "instagram_username": null,
                        "wiki_url": null
                    },
                    "decimals": 0,
                    "token_metadata": "https://mcp.town/api/region/44"
                }
            ],
            "name": "44",
            "description": "",
            "external_link": "",
            "asset_contract": null,
            "permalink": "https://opensea.io/bundles/44-7gO",
            "sell_orders": []
        },
        {
            "maker": {
                "user": {
                    "username": "Treasure_Seeker"
                },
                "profile_img_url": "https://storage.googleapis.com/opensea-static/opensea-profile/13.png",
                "address": "0xdc8eb8d2d1babd956136b57b0b9f49b433c019e3",
                "config": "",
                "discord_id": ""
            },
            "slug": "skeleton-weebits-w61",
            "assets": [
                {
                    "id": 25443239,
                    "token_id": "77993642746362625660084917667317678697710155686795798893749615011415979982849",
                    "num_sales": 1,
                    "background_color": null,
                    "image_url": "https://lh3.googleusercontent.com/ZNoBn61dxZkaUvVHPk0FKWUxzjW83kY1DDpfXmfj6vTWTpPcCQ1sM9wOhXRlIlCyLuA_V5bHS-pq2ya4MPdnczOJWVc1UmMClOB_d-I",
                    "image_preview_url": "https://lh3.googleusercontent.com/ZNoBn61dxZkaUvVHPk0FKWUxzjW83kY1DDpfXmfj6vTWTpPcCQ1sM9wOhXRlIlCyLuA_V5bHS-pq2ya4MPdnczOJWVc1UmMClOB_d-I=s250",
                    "image_thumbnail_url": "https://lh3.googleusercontent.com/ZNoBn61dxZkaUvVHPk0FKWUxzjW83kY1DDpfXmfj6vTWTpPcCQ1sM9wOhXRlIlCyLuA_V5bHS-pq2ya4MPdnczOJWVc1UmMClOB_d-I=s128",
                    "image_original_url": null,
                    "animation_url": null,
                    "animation_original_url": null,
                    "name": "BabyWeebit #184",
                    "description": null,
                    "external_link": null,
                    "asset_contract": {
                        "address": "0x495f947276749ce646f68ac8c248420045cb7b5e",
                        "asset_contract_type": "semi-fungible",
                        "created_date": "2020-12-02T17:40:53.232025",
                        "name": "OpenSea Collection",
                        "nft_version": null,
                        "opensea_version": "2.0.0",
                        "owner": 102384,
                        "schema_name": "ERC1155",
                        "symbol": "OPENSTORE",
                        "total_supply": null,
                        "description": null,
                        "external_link": null,
                        "image_url": null,
                        "default_to_fiat": false,
                        "dev_buyer_fee_basis_points": 0,
                        "dev_seller_fee_basis_points": 0,
                        "only_proxied_transfers": false,
                        "opensea_buyer_fee_basis_points": 0,
                        "opensea_seller_fee_basis_points": 250,
                        "buyer_fee_basis_points": 0,
                        "seller_fee_basis_points": 250,
                        "payout_address": null
                    },
                    "owner": {
                        "user": {
                            "username": "NullAddress"
                        },
                        "profile_img_url": "https://storage.googleapis.com/opensea-static/opensea-profile/1.png",
                        "address": "0x0000000000000000000000000000000000000000",
                        "config": "",
                        "discord_id": ""
                    },
                    "permalink": "https://opensea.io/assets/0x495f947276749ce646f68ac8c248420045cb7b5e/77993642746362625660084917667317678697710155686795798893749615011415979982849",
                    "collection": {
                        "banner_image_url": "https://lh3.googleusercontent.com/n5NOChuCPFzcKs8qq74XWk_O-HyUF5sUY-V3RIqLtVPzLhY8NwdxZ9ry6w2DAR02ZO0Q8OBL0T897WxXzrJuf8Gick_zdBW9LZIDqA=s2500",
                        "chat_url": null,
                        "created_date": "2021-05-07T23:00:45.108468",
                        "default_to_fiat": false,
                        "description": "👶 BabyWeebits is a project of 500 unique 3D voxel characters, supply for each is 1/1\n\n\n🛸 TYPES: \n\n🦾Robot = 2 🦴Skeleton = 2  🐷Pig = 3 🧝‍Elf = 9 🐼Panda = 16 🐸Pepe = 18 💀Skeleton Pig =19 🧟Zombie Pig = 23 🦏Rhino = 24 🐵Ape = 26 🐂Minotaur = 27 👺Two-Faced = 32 😵Undead = 60 👶Girl/Boy = 217\n\nLegendary:  🐘Elephant = 1 👽Visitor = 1 🥒Slime = 2 👻Ghost = 4 👹Custom = 6 🤖Cyborg = 8\n\n👾 Editions:\n\n#001 - Giveaway \n\n#002-100 - SOLD 👼\n\n#101-200 - SOLD 👼\n\n#201-300 - SOLD 👼\n\n#301-400 - 0.1 ETH ✔️\n\n#401-490 - 🔒\n\n#491-500 - 🔒\n\n➡️ Roadmap: (coming soon on the website)\n\nThe project is not affiliated with Larva Labs",
                        "dev_buyer_fee_basis_points": "0",
                        "dev_seller_fee_basis_points": "200",
                        "discord_url": "https://discord.gg/ZqRXE9C93X",
                        "display_data": {
                            "card_display_style": "contain"
                        },
                        "external_url": "https://linktr.ee/BabyWeebits",
                        "featured": false,
                        "featured_image_url": "https://lh3.googleusercontent.com/0CDz6SYYVi_SSc60oXo3nJNR-ogO75bd5NSTvJ-GuA-EmOps0_jqG7nAwZgn_KmMnX38lKJ38qc7HuB4VLpp94dOGrLnAiDgd-OEHQ=s300",
                        "hidden": true,
                        "safelist_request_status": "requested",
                        "image_url": "https://lh3.googleusercontent.com/9i-kApGrXyecmZJxA6oDUbgQ8rHUVluD06YL_keKnqcfWyU3btGpTtTw5xC27hOyOoMdaZwlisg9Uk84nPzUCzkgmNjrfp-H3kr1Mw=s120",
                        "is_subject_to_whitelist": false,
                        "large_image_url": "https://lh3.googleusercontent.com/0CDz6SYYVi_SSc60oXo3nJNR-ogO75bd5NSTvJ-GuA-EmOps0_jqG7nAwZgn_KmMnX38lKJ38qc7HuB4VLpp94dOGrLnAiDgd-OEHQ=s300",
                        "medium_username": null,
                        "name": "BabyWeebits",
                        "only_proxied_transfers": false,
                        "opensea_buyer_fee_basis_points": "0",
                        "opensea_seller_fee_basis_points": "250",
                        "payout_address": "0xac6ed661e4ac736ebbc71afab34ed291ce923e4e",
                        "require_email": false,
                        "short_description": null,
                        "slug": "babyweebits",
                        "telegram_url": null,
                        "twitter_username": "BabyWeebits",
                        "instagram_username": null,
                        "wiki_url": null
                    },
                    "decimals": null,
                    "token_metadata": null
                },
                {
                    "id": 25650492,
                    "token_id": "77993642746362625660084917667317678697710155686795798893749615134561282293761",
                    "num_sales": 1,
                    "background_color": null,
                    "image_url": "https://lh3.googleusercontent.com/OSXm1GbilCZ1Lg-YMpnYMOxdDKW_Fbkw4aQk-LinzOGVG4KrixovuypKJh06iSn_GUj-EP3-JB3_03WqBC3vBvy4mxKiTa9Cqx2MsA",
                    "image_preview_url": "https://lh3.googleusercontent.com/OSXm1GbilCZ1Lg-YMpnYMOxdDKW_Fbkw4aQk-LinzOGVG4KrixovuypKJh06iSn_GUj-EP3-JB3_03WqBC3vBvy4mxKiTa9Cqx2MsA=s250",
                    "image_thumbnail_url": "https://lh3.googleusercontent.com/OSXm1GbilCZ1Lg-YMpnYMOxdDKW_Fbkw4aQk-LinzOGVG4KrixovuypKJh06iSn_GUj-EP3-JB3_03WqBC3vBvy4mxKiTa9Cqx2MsA=s128",
                    "image_original_url": null,
                    "animation_url": null,
                    "animation_original_url": null,
                    "name": "BabyWeebit #296",
                    "description": null,
                    "external_link": null,
                    "asset_contract": {
                        "address": "0x495f947276749ce646f68ac8c248420045cb7b5e",
                        "asset_contract_type": "semi-fungible",
                        "created_date": "2020-12-02T17:40:53.232025",
                        "name": "OpenSea Collection",
                        "nft_version": null,
                        "opensea_version": "2.0.0",
                        "owner": 102384,
                        "schema_name": "ERC1155",
                        "symbol": "OPENSTORE",
                        "total_supply": null,
                        "description": null,
                        "external_link": null,
                        "image_url": null,
                        "default_to_fiat": false,
                        "dev_buyer_fee_basis_points": 0,
                        "dev_seller_fee_basis_points": 0,
                        "only_proxied_transfers": false,
                        "opensea_buyer_fee_basis_points": 0,
                        "opensea_seller_fee_basis_points": 250,
                        "buyer_fee_basis_points": 0,
                        "seller_fee_basis_points": 250,
                        "payout_address": null
                    },
                    "owner": {
                        "user": {
                            "username": "NullAddress"
                        },
                        "profile_img_url": "https://storage.googleapis.com/opensea-static/opensea-profile/1.png",
                        "address": "0x0000000000000000000000000000000000000000",
                        "config": "",
                        "discord_id": ""
                    },
                    "permalink": "https://opensea.io/assets/0x495f947276749ce646f68ac8c248420045cb7b5e/77993642746362625660084917667317678697710155686795798893749615134561282293761",
                    "collection": {
                        "banner_image_url": "https://lh3.googleusercontent.com/n5NOChuCPFzcKs8qq74XWk_O-HyUF5sUY-V3RIqLtVPzLhY8NwdxZ9ry6w2DAR02ZO0Q8OBL0T897WxXzrJuf8Gick_zdBW9LZIDqA=s2500",
                        "chat_url": null,
                        "created_date": "2021-05-07T23:00:45.108468",
                        "default_to_fiat": false,
                        "description": "👶 BabyWeebits is a project of 500 unique 3D voxel characters, supply for each is 1/1\n\n\n🛸 TYPES: \n\n🦾Robot = 2 🦴Skeleton = 2  🐷Pig = 3 🧝‍Elf = 9 🐼Panda = 16 🐸Pepe = 18 💀Skeleton Pig =19 🧟Zombie Pig = 23 🦏Rhino = 24 🐵Ape = 26 🐂Minotaur = 27 👺Two-Faced = 32 😵Undead = 60 👶Girl/Boy = 217\n\nLegendary:  🐘Elephant = 1 👽Visitor = 1 🥒Slime = 2 👻Ghost = 4 👹Custom = 6 🤖Cyborg = 8\n\n👾 Editions:\n\n#001 - Giveaway \n\n#002-100 - SOLD 👼\n\n#101-200 - SOLD 👼\n\n#201-300 - SOLD 👼\n\n#301-400 - 0.1 ETH ✔️\n\n#401-490 - 🔒\n\n#491-500 - 🔒\n\n➡️ Roadmap: (coming soon on the website)\n\nThe project is not affiliated with Larva Labs",
                        "dev_buyer_fee_basis_points": "0",
                        "dev_seller_fee_basis_points": "200",
                        "discord_url": "https://discord.gg/ZqRXE9C93X",
                        "display_data": {
                            "card_display_style": "contain"
                        },
                        "external_url": "https://linktr.ee/BabyWeebits",
                        "featured": false,
                        "featured_image_url": "https://lh3.googleusercontent.com/0CDz6SYYVi_SSc60oXo3nJNR-ogO75bd5NSTvJ-GuA-EmOps0_jqG7nAwZgn_KmMnX38lKJ38qc7HuB4VLpp94dOGrLnAiDgd-OEHQ=s300",
                        "hidden": true,
                        "safelist_request_status": "requested",
                        "image_url": "https://lh3.googleusercontent.com/9i-kApGrXyecmZJxA6oDUbgQ8rHUVluD06YL_keKnqcfWyU3btGpTtTw5xC27hOyOoMdaZwlisg9Uk84nPzUCzkgmNjrfp-H3kr1Mw=s120",
                        "is_subject_to_whitelist": false,
                        "large_image_url": "https://lh3.googleusercontent.com/0CDz6SYYVi_SSc60oXo3nJNR-ogO75bd5NSTvJ-GuA-EmOps0_jqG7nAwZgn_KmMnX38lKJ38qc7HuB4VLpp94dOGrLnAiDgd-OEHQ=s300",
                        "medium_username": null,
                        "name": "BabyWeebits",
                        "only_proxied_transfers": false,
                        "opensea_buyer_fee_basis_points": "0",
                        "opensea_seller_fee_basis_points": "250",
                        "payout_address": "0xac6ed661e4ac736ebbc71afab34ed291ce923e4e",
                        "require_email": false,
                        "short_description": null,
                        "slug": "babyweebits",
                        "telegram_url": null,
                        "twitter_username": "BabyWeebits",
                        "instagram_username": null,
                        "wiki_url": null
                    },
                    "decimals": null,
                    "token_metadata": null
                }
            ],
            "name": "Skeleton Weebits",
            "description": "Rare skeleton baby weebit buddies!",
            "external_link": "",
            "asset_contract": {
                "collection": {
                    "banner_image_url": null,
                    "chat_url": null,
                    "created_date": "2020-12-02T17:40:53.507540",
                    "default_to_fiat": false,
                    "description": null,
                    "dev_buyer_fee_basis_points": "0",
                    "dev_seller_fee_basis_points": "0",
                    "discord_url": null,
                    "display_data": {
                        "card_display_style": "contain",
                        "images": []
                    },
                    "external_url": null,
                    "featured": false,
                    "featured_image_url": null,
                    "hidden": true,
                    "safelist_request_status": "not_requested",
                    "image_url": null,
                    "is_subject_to_whitelist": false,
                    "large_image_url": null,
                    "medium_username": null,
                    "name": "OpenSea Shared Storefront V2",
                    "only_proxied_transfers": false,
                    "opensea_buyer_fee_basis_points": "0",
                    "opensea_seller_fee_basis_points": "250",
                    "payout_address": null,
                    "require_email": false,
                    "short_description": null,
                    "slug": "opensea-shared-storefront-v2",
                    "telegram_url": null,
                    "twitter_username": null,
                    "instagram_username": null,
                    "wiki_url": null
                },
                "address": "0x495f947276749ce646f68ac8c248420045cb7b5e",
                "asset_contract_type": "semi-fungible",
                "created_date": "2020-12-02T17:40:53.232025",
                "name": "OpenSea Collection",
                "nft_version": null,
                "opensea_version": "2.0.0",
                "owner": 102384,
                "schema_name": "ERC1155",
                "symbol": "OPENSTORE",
                "total_supply": null,
                "description": null,
                "external_link": null,
                "image_url": null,
                "default_to_fiat": false,
                "dev_buyer_fee_basis_points": 0,
                "dev_seller_fee_basis_points": 0,
                "only_proxied_transfers": false,
                "opensea_buyer_fee_basis_points": 0,
                "opensea_seller_fee_basis_points": 250,
                "buyer_fee_basis_points": 0,
                "seller_fee_basis_points": 250,
                "payout_address": null
            },
            "permalink": "https://opensea.io/bundles/skeleton-weebits-w61",
            "sell_orders": [
                {
                    "created_date": "2021-05-25T20:17:32.469260",
                    "closing_date": "2021-05-26T20:17:22",
                    "closing_extendable": false,
                    "expiration_time": 1622060242,
                    "listing_time": 1621973748,
                    "order_hash": "0x3c0dcebfdb0d2f3e5051b6554e2c40257f7678fc7135dc7de8a271e5bfc96fdd",
                    "metadata": {
                        "bundle": {
                            "assets": [
                                {
                                    "id": "77993642746362625660084917667317678697710155686795798893749615011415979982849",
                                    "address": "0x495f947276749ce646f68ac8c248420045cb7b5e",
                                    "quantity": "1"
                                },
                                {
                                    "id": "77993642746362625660084917667317678697710155686795798893749615134561282293761",
                                    "address": "0x495f947276749ce646f68ac8c248420045cb7b5e",
                                    "quantity": "1"
                                }
                            ],
                            "schemas": [
                                "ERC1155",
                                "ERC1155"
                            ],
                            "name": "Skeleton Weebits",
                            "description": "Rare skeleton baby weebit buddies!",
                            "external_link": ""
                        }
                    },
                    "exchange": "0x7be8076f4ea4a4ad08075c2508e481d6c946d12b",
                    "maker": {
                        "user": 822726,
                        "profile_img_url": "https://storage.googleapis.com/opensea-static/opensea-profile/13.png",
                        "address": "0xdc8eb8d2d1babd956136b57b0b9f49b433c019e3",
                        "config": "",
                        "discord_id": ""
                    },
                    "taker": {
                        "user": 1766,
                        "profile_img_url": "https://storage.googleapis.com/opensea-static/opensea-profile/1.png",
                        "address": "0x0000000000000000000000000000000000000000",
                        "config": "",
                        "discord_id": ""
                    },
                    "current_price": "1000000000000000000.000000000",
                    "current_bounty": "10000000000000000",
                    "bounty_multiple": "0.01",
                    "maker_relayer_fee": "450",
                    "taker_relayer_fee": "0",
                    "maker_protocol_fee": "0",
                    "taker_protocol_fee": "0",
                    "maker_referrer_fee": "0",
                    "fee_recipient": {
                        "user": 3585,
                        "profile_img_url": "https://storage.googleapis.com/opensea-static/opensea-profile/28.png",
                        "address": "0x5b3256965e7c3cf26e11fcaf296dfc8807c01073",
                        "config": "verified",
                        "discord_id": ""
                    },
                    "fee_method": 1,
                    "side": 1,
                    "sale_kind": 0,
                    "target": "0xc99f70bfd82fb7c8f8191fdfbfb735606b15e5c5",
                    "how_to_call": 1,
                    "calldata": "0x68f0bcaa000000000000000000000000000000000000000000000000000000000000008000000000000000000000000000000000000000000000000000000000000000e0000000000000000000000000000000000000000000000000000000000000014000000000000000000000000000000000000000000000000000000000000001a00000000000000000000000000000000000000000000000000000000000000002000000000000000000000000495f947276749ce646f68ac8c248420045cb7b5e000000000000000000000000495f947276749ce646f68ac8c248420045cb7b5e000000000000000000000000000000000000000000000000000000000000000200000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000200000000000000000000000000000000000000000000000000000000000000c400000000000000000000000000000000000000000000000000000000000000c40000000000000000000000000000000000000000000000000000000000000188f242432a000000000000000000000000dc8eb8d2d1babd956136b57b0b9f49b433c019e30000000000000000000000000000000000000000000000000000000000000000ac6ed661e4ac736ebbc71afab34ed291ce923e4e000000000004000000000001000000000000000000000000000000000000000000000000000000000000000100000000000000000000000000000000000000000000000000000000000000a00000000000000000000000000000000000000000000000000000000000000000f242432a000000000000000000000000dc8eb8d2d1babd956136b57b0b9f49b433c019e30000000000000000000000000000000000000000000000000000000000000000ac6ed661e4ac736ebbc71afab34ed291ce923e4e000000000004700000000001000000000000000000000000000000000000000000000000000000000000000100000000000000000000000000000000000000000000000000000000000000a00000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000",
                    "replacement_pattern": "0x0000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000ffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffff0000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000ffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffff0000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000",
                    "static_target": "0x0000000000000000000000000000000000000000",
                    "static_extradata": "0x",
                    "payment_token": "0x0000000000000000000000000000000000000000",
                    "payment_token_contract": {
                        "id": 1,
                        "symbol": "ETH",
                        "address": "0x0000000000000000000000000000000000000000",
                        "image_url": "https://storage.opensea.io/files/6f8e2979d428180222796ff4a33ab929.svg",
                        "name": "Ether",
                        "decimals": 18,
                        "eth_price": "1.000000000000000",
                        "usd_price": "2625.730000000000018000"
                    },
                    "base_price": "1000000000000000000",
                    "extra": "0",
                    "quantity": "1",
                    "salt": "83925649084776748047452536225843686758954074465125043214355988533452326239116",
                    "v": 27,
                    "r": "0x1013505f1988a70deddc62eab535aeab508a3aa0f546fa3c33dd0fa776a4e95f",
                    "s": "0x0ffab6cdcf0a4834e317b0a2f773ab43a3d4be764ec358a4e6827cdf004ff5de",
                    "approved_on_chain": false,
                    "cancelled": false,
                    "finalized": false,
                    "marked_invalid": false,
                    "prefixed_hash": "0x9fd74a72a9fcd8f2a25d3d91374efbe94df098a757d15592cc69cba2e1fa1af9"
                }
            ]
        },
        {
            "maker": {
                "user": {
                    "username": "Treasure_Seeker"
                },
                "profile_img_url": "https://storage.googleapis.com/opensea-static/opensea-profile/13.png",
                "address": "0xdc8eb8d2d1babd956136b57b0b9f49b433c019e3",
                "config": "",
                "discord_id": ""
            },
            "slug": "cute-weebits-YlA",
            "assets": [
                {
                    "id": 25200966,
                    "token_id": "77993642746362625660084917667317678697710155686795798893749614900365305577473",
                    "num_sales": 2,
                    "background_color": null,
                    "image_url": "https://lh3.googleusercontent.com/RklS6Rtdo5qH2gQocWg6924GVa7qGuyJfdwmr2tlsojO165X4PvLhSGiiwW8KPlBbLMQnhpULSjhpdNBaJ-XAiceWFSjg6Ih-3CiLA",
                    "image_preview_url": "https://lh3.googleusercontent.com/RklS6Rtdo5qH2gQocWg6924GVa7qGuyJfdwmr2tlsojO165X4PvLhSGiiwW8KPlBbLMQnhpULSjhpdNBaJ-XAiceWFSjg6Ih-3CiLA=s250",
                    "image_thumbnail_url": "https://lh3.googleusercontent.com/RklS6Rtdo5qH2gQocWg6924GVa7qGuyJfdwmr2tlsojO165X4PvLhSGiiwW8KPlBbLMQnhpULSjhpdNBaJ-XAiceWFSjg6Ih-3CiLA=s128",
                    "image_original_url": null,
                    "animation_url": null,
                    "animation_original_url": null,
                    "name": "BabyWeebit #83",
                    "description": null,
                    "external_link": null,
                    "asset_contract": {
                        "address": "0x495f947276749ce646f68ac8c248420045cb7b5e",
                        "asset_contract_type": "semi-fungible",
                        "created_date": "2020-12-02T17:40:53.232025",
                        "name": "OpenSea Collection",
                        "nft_version": null,
                        "opensea_version": "2.0.0",
                        "owner": 102384,
                        "schema_name": "ERC1155",
                        "symbol": "OPENSTORE",
                        "total_supply": null,
                        "description": null,
                        "external_link": null,
                        "image_url": null,
                        "default_to_fiat": false,
                        "dev_buyer_fee_basis_points": 0,
                        "dev_seller_fee_basis_points": 0,
                        "only_proxied_transfers": false,
                        "opensea_buyer_fee_basis_points": 0,
                        "opensea_seller_fee_basis_points": 250,
                        "buyer_fee_basis_points": 0,
                        "seller_fee_basis_points": 250,
                        "payout_address": null
                    },
                    "owner": {
                        "user": {
                            "username": "NullAddress"
                        },
                        "profile_img_url": "https://storage.googleapis.com/opensea-static/opensea-profile/1.png",
                        "address": "0x0000000000000000000000000000000000000000",
                        "config": "",
                        "discord_id": ""
                    },
                    "permalink": "https://opensea.io/assets/0x495f947276749ce646f68ac8c248420045cb7b5e/77993642746362625660084917667317678697710155686795798893749614900365305577473",
                    "collection": {
                        "banner_image_url": "https://lh3.googleusercontent.com/n5NOChuCPFzcKs8qq74XWk_O-HyUF5sUY-V3RIqLtVPzLhY8NwdxZ9ry6w2DAR02ZO0Q8OBL0T897WxXzrJuf8Gick_zdBW9LZIDqA=s2500",
                        "chat_url": null,
                        "created_date": "2021-05-07T23:00:45.108468",
                        "default_to_fiat": false,
                        "description": "👶 BabyWeebits is a project of 500 unique 3D voxel characters, supply for each is 1/1\n\n\n🛸 TYPES: \n\n🦾Robot = 2 🦴Skeleton = 2  🐷Pig = 3 🧝‍Elf = 9 🐼Panda = 16 🐸Pepe = 18 💀Skeleton Pig =19 🧟Zombie Pig = 23 🦏Rhino = 24 🐵Ape = 26 🐂Minotaur = 27 👺Two-Faced = 32 😵Undead = 60 👶Girl/Boy = 217\n\nLegendary:  🐘Elephant = 1 👽Visitor = 1 🥒Slime = 2 👻Ghost = 4 👹Custom = 6 🤖Cyborg = 8\n\n👾 Editions:\n\n#001 - Giveaway \n\n#002-100 - SOLD 👼\n\n#101-200 - SOLD 👼\n\n#201-300 - SOLD 👼\n\n#301-400 - 0.1 ETH ✔️\n\n#401-490 - 🔒\n\n#491-500 - 🔒\n\n➡️ Roadmap: (coming soon on the website)\n\nThe project is not affiliated with Larva Labs",
                        "dev_buyer_fee_basis_points": "0",
                        "dev_seller_fee_basis_points": "200",
                        "discord_url": "https://discord.gg/ZqRXE9C93X",
                        "display_data": {
                            "card_display_style": "contain"
                        },
                        "external_url": "https://linktr.ee/BabyWeebits",
                        "featured": false,
                        "featured_image_url": "https://lh3.googleusercontent.com/0CDz6SYYVi_SSc60oXo3nJNR-ogO75bd5NSTvJ-GuA-EmOps0_jqG7nAwZgn_KmMnX38lKJ38qc7HuB4VLpp94dOGrLnAiDgd-OEHQ=s300",
                        "hidden": true,
                        "safelist_request_status": "requested",
                        "image_url": "https://lh3.googleusercontent.com/9i-kApGrXyecmZJxA6oDUbgQ8rHUVluD06YL_keKnqcfWyU3btGpTtTw5xC27hOyOoMdaZwlisg9Uk84nPzUCzkgmNjrfp-H3kr1Mw=s120",
                        "is_subject_to_whitelist": false,
                        "large_image_url": "https://lh3.googleusercontent.com/0CDz6SYYVi_SSc60oXo3nJNR-ogO75bd5NSTvJ-GuA-EmOps0_jqG7nAwZgn_KmMnX38lKJ38qc7HuB4VLpp94dOGrLnAiDgd-OEHQ=s300",
                        "medium_username": null,
                        "name": "BabyWeebits",
                        "only_proxied_transfers": false,
                        "opensea_buyer_fee_basis_points": "0",
                        "opensea_seller_fee_basis_points": "250",
                        "payout_address": "0xac6ed661e4ac736ebbc71afab34ed291ce923e4e",
                        "require_email": false,
                        "short_description": null,
                        "slug": "babyweebits",
                        "telegram_url": null,
                        "twitter_username": "BabyWeebits",
                        "instagram_username": null,
                        "wiki_url": null
                    },
                    "decimals": null,
                    "token_metadata": null
                },
                {
                    "id": 25528681,
                    "token_id": "77993642746362625660084917667317678697710155686795798893749615089481305554945",
                    "num_sales": 1,
                    "background_color": null,
                    "image_url": "https://lh3.googleusercontent.com/rARVi6vdtdDgrLLqSFK6hOosfq6xjhtIzcmFVsUKm7tQdflJsb5Wkc-_Y0vto5hOjaeBHgntXLMulLPIzr869GvPXsPa5WGtD5Sgig",
                    "image_preview_url": "https://lh3.googleusercontent.com/rARVi6vdtdDgrLLqSFK6hOosfq6xjhtIzcmFVsUKm7tQdflJsb5Wkc-_Y0vto5hOjaeBHgntXLMulLPIzr869GvPXsPa5WGtD5Sgig=s250",
                    "image_thumbnail_url": "https://lh3.googleusercontent.com/rARVi6vdtdDgrLLqSFK6hOosfq6xjhtIzcmFVsUKm7tQdflJsb5Wkc-_Y0vto5hOjaeBHgntXLMulLPIzr869GvPXsPa5WGtD5Sgig=s128",
                    "image_original_url": null,
                    "animation_url": null,
                    "animation_original_url": null,
                    "name": "BabyWeebit #255",
                    "description": null,
                    "external_link": null,
                    "asset_contract": {
                        "address": "0x495f947276749ce646f68ac8c248420045cb7b5e",
                        "asset_contract_type": "semi-fungible",
                        "created_date": "2020-12-02T17:40:53.232025",
                        "name": "OpenSea Collection",
                        "nft_version": null,
                        "opensea_version": "2.0.0",
                        "owner": 102384,
                        "schema_name": "ERC1155",
                        "symbol": "OPENSTORE",
                        "total_supply": null,
                        "description": null,
                        "external_link": null,
                        "image_url": null,
                        "default_to_fiat": false,
                        "dev_buyer_fee_basis_points": 0,
                        "dev_seller_fee_basis_points": 0,
                        "only_proxied_transfers": false,
                        "opensea_buyer_fee_basis_points": 0,
                        "opensea_seller_fee_basis_points": 250,
                        "buyer_fee_basis_points": 0,
                        "seller_fee_basis_points": 250,
                        "payout_address": null
                    },
                    "owner": {
                        "user": {
                            "username": "NullAddress"
                        },
                        "profile_img_url": "https://storage.googleapis.com/opensea-static/opensea-profile/1.png",
                        "address": "0x0000000000000000000000000000000000000000",
                        "config": "",
                        "discord_id": ""
                    },
                    "permalink": "https://opensea.io/assets/0x495f947276749ce646f68ac8c248420045cb7b5e/77993642746362625660084917667317678697710155686795798893749615089481305554945",
                    "collection": {
                        "banner_image_url": "https://lh3.googleusercontent.com/n5NOChuCPFzcKs8qq74XWk_O-HyUF5sUY-V3RIqLtVPzLhY8NwdxZ9ry6w2DAR02ZO0Q8OBL0T897WxXzrJuf8Gick_zdBW9LZIDqA=s2500",
                        "chat_url": null,
                        "created_date": "2021-05-07T23:00:45.108468",
                        "default_to_fiat": false,
                        "description": "👶 BabyWeebits is a project of 500 unique 3D voxel characters, supply for each is 1/1\n\n\n🛸 TYPES: \n\n🦾Robot = 2 🦴Skeleton = 2  🐷Pig = 3 🧝‍Elf = 9 🐼Panda = 16 🐸Pepe = 18 💀Skeleton Pig =19 🧟Zombie Pig = 23 🦏Rhino = 24 🐵Ape = 26 🐂Minotaur = 27 👺Two-Faced = 32 😵Undead = 60 👶Girl/Boy = 217\n\nLegendary:  🐘Elephant = 1 👽Visitor = 1 🥒Slime = 2 👻Ghost = 4 👹Custom = 6 🤖Cyborg = 8\n\n👾 Editions:\n\n#001 - Giveaway \n\n#002-100 - SOLD 👼\n\n#101-200 - SOLD 👼\n\n#201-300 - SOLD 👼\n\n#301-400 - 0.1 ETH ✔️\n\n#401-490 - 🔒\n\n#491-500 - 🔒\n\n➡️ Roadmap: (coming soon on the website)\n\nThe project is not affiliated with Larva Labs",
                        "dev_buyer_fee_basis_points": "0",
                        "dev_seller_fee_basis_points": "200",
                        "discord_url": "https://discord.gg/ZqRXE9C93X",
                        "display_data": {
                            "card_display_style": "contain"
                        },
                        "external_url": "https://linktr.ee/BabyWeebits",
                        "featured": false,
                        "featured_image_url": "https://lh3.googleusercontent.com/0CDz6SYYVi_SSc60oXo3nJNR-ogO75bd5NSTvJ-GuA-EmOps0_jqG7nAwZgn_KmMnX38lKJ38qc7HuB4VLpp94dOGrLnAiDgd-OEHQ=s300",
                        "hidden": true,
                        "safelist_request_status": "requested",
                        "image_url": "https://lh3.googleusercontent.com/9i-kApGrXyecmZJxA6oDUbgQ8rHUVluD06YL_keKnqcfWyU3btGpTtTw5xC27hOyOoMdaZwlisg9Uk84nPzUCzkgmNjrfp-H3kr1Mw=s120",
                        "is_subject_to_whitelist": false,
                        "large_image_url": "https://lh3.googleusercontent.com/0CDz6SYYVi_SSc60oXo3nJNR-ogO75bd5NSTvJ-GuA-EmOps0_jqG7nAwZgn_KmMnX38lKJ38qc7HuB4VLpp94dOGrLnAiDgd-OEHQ=s300",
                        "medium_username": null,
                        "name": "BabyWeebits",
                        "only_proxied_transfers": false,
                        "opensea_buyer_fee_basis_points": "0",
                        "opensea_seller_fee_basis_points": "250",
                        "payout_address": "0xac6ed661e4ac736ebbc71afab34ed291ce923e4e",
                        "require_email": false,
                        "short_description": null,
                        "slug": "babyweebits",
                        "telegram_url": null,
                        "twitter_username": "BabyWeebits",
                        "instagram_username": null,
                        "wiki_url": null
                    },
                    "decimals": null,
                    "token_metadata": null
                },
                {
                    "id": 25650055,
                    "token_id": "77993642746362625660084917667317678697710155686795798893749615131262747410433",
                    "num_sales": 1,
                    "background_color": null,
                    "image_url": "https://lh3.googleusercontent.com/iunIoxz-Z7Nxp4R40vZbpYGRQ-Oovf7h1P2n_Zz1OZOh-fgmk9nRr66KJknLuqx8sF0OivaCpiZkZ1veqIa9rvDjogWrdi3BgcSz",
                    "image_preview_url": "https://lh3.googleusercontent.com/iunIoxz-Z7Nxp4R40vZbpYGRQ-Oovf7h1P2n_Zz1OZOh-fgmk9nRr66KJknLuqx8sF0OivaCpiZkZ1veqIa9rvDjogWrdi3BgcSz=s250",
                    "image_thumbnail_url": "https://lh3.googleusercontent.com/iunIoxz-Z7Nxp4R40vZbpYGRQ-Oovf7h1P2n_Zz1OZOh-fgmk9nRr66KJknLuqx8sF0OivaCpiZkZ1veqIa9rvDjogWrdi3BgcSz=s128",
                    "image_original_url": null,
                    "animation_url": null,
                    "animation_original_url": null,
                    "name": "BabyWeebit #293",
                    "description": null,
                    "external_link": null,
                    "asset_contract": {
                        "address": "0x495f947276749ce646f68ac8c248420045cb7b5e",
                        "asset_contract_type": "semi-fungible",
                        "created_date": "2020-12-02T17:40:53.232025",
                        "name": "OpenSea Collection",
                        "nft_version": null,
                        "opensea_version": "2.0.0",
                        "owner": 102384,
                        "schema_name": "ERC1155",
                        "symbol": "OPENSTORE",
                        "total_supply": null,
                        "description": null,
                        "external_link": null,
                        "image_url": null,
                        "default_to_fiat": false,
                        "dev_buyer_fee_basis_points": 0,
                        "dev_seller_fee_basis_points": 0,
                        "only_proxied_transfers": false,
                        "opensea_buyer_fee_basis_points": 0,
                        "opensea_seller_fee_basis_points": 250,
                        "buyer_fee_basis_points": 0,
                        "seller_fee_basis_points": 250,
                        "payout_address": null
                    },
                    "owner": {
                        "user": {
                            "username": "NullAddress"
                        },
                        "profile_img_url": "https://storage.googleapis.com/opensea-static/opensea-profile/1.png",
                        "address": "0x0000000000000000000000000000000000000000",
                        "config": "",
                        "discord_id": ""
                    },
                    "permalink": "https://opensea.io/assets/0x495f947276749ce646f68ac8c248420045cb7b5e/77993642746362625660084917667317678697710155686795798893749615131262747410433",
                    "collection": {
                        "banner_image_url": "https://lh3.googleusercontent.com/n5NOChuCPFzcKs8qq74XWk_O-HyUF5sUY-V3RIqLtVPzLhY8NwdxZ9ry6w2DAR02ZO0Q8OBL0T897WxXzrJuf8Gick_zdBW9LZIDqA=s2500",
                        "chat_url": null,
                        "created_date": "2021-05-07T23:00:45.108468",
                        "default_to_fiat": false,
                        "description": "👶 BabyWeebits is a project of 500 unique 3D voxel characters, supply for each is 1/1\n\n\n🛸 TYPES: \n\n🦾Robot = 2 🦴Skeleton = 2  🐷Pig = 3 🧝‍Elf = 9 🐼Panda = 16 🐸Pepe = 18 💀Skeleton Pig =19 🧟Zombie Pig = 23 🦏Rhino = 24 🐵Ape = 26 🐂Minotaur = 27 👺Two-Faced = 32 😵Undead = 60 👶Girl/Boy = 217\n\nLegendary:  🐘Elephant = 1 👽Visitor = 1 🥒Slime = 2 👻Ghost = 4 👹Custom = 6 🤖Cyborg = 8\n\n👾 Editions:\n\n#001 - Giveaway \n\n#002-100 - SOLD 👼\n\n#101-200 - SOLD 👼\n\n#201-300 - SOLD 👼\n\n#301-400 - 0.1 ETH ✔️\n\n#401-490 - 🔒\n\n#491-500 - 🔒\n\n➡️ Roadmap: (coming soon on the website)\n\nThe project is not affiliated with Larva Labs",
                        "dev_buyer_fee_basis_points": "0",
                        "dev_seller_fee_basis_points": "200",
                        "discord_url": "https://discord.gg/ZqRXE9C93X",
                        "display_data": {
                            "card_display_style": "contain"
                        },
                        "external_url": "https://linktr.ee/BabyWeebits",
                        "featured": false,
                        "featured_image_url": "https://lh3.googleusercontent.com/0CDz6SYYVi_SSc60oXo3nJNR-ogO75bd5NSTvJ-GuA-EmOps0_jqG7nAwZgn_KmMnX38lKJ38qc7HuB4VLpp94dOGrLnAiDgd-OEHQ=s300",
                        "hidden": true,
                        "safelist_request_status": "requested",
                        "image_url": "https://lh3.googleusercontent.com/9i-kApGrXyecmZJxA6oDUbgQ8rHUVluD06YL_keKnqcfWyU3btGpTtTw5xC27hOyOoMdaZwlisg9Uk84nPzUCzkgmNjrfp-H3kr1Mw=s120",
                        "is_subject_to_whitelist": false,
                        "large_image_url": "https://lh3.googleusercontent.com/0CDz6SYYVi_SSc60oXo3nJNR-ogO75bd5NSTvJ-GuA-EmOps0_jqG7nAwZgn_KmMnX38lKJ38qc7HuB4VLpp94dOGrLnAiDgd-OEHQ=s300",
                        "medium_username": null,
                        "name": "BabyWeebits",
                        "only_proxied_transfers": false,
                        "opensea_buyer_fee_basis_points": "0",
                        "opensea_seller_fee_basis_points": "250",
                        "payout_address": "0xac6ed661e4ac736ebbc71afab34ed291ce923e4e",
                        "require_email": false,
                        "short_description": null,
                        "slug": "babyweebits",
                        "telegram_url": null,
                        "twitter_username": "BabyWeebits",
                        "instagram_username": null,
                        "wiki_url": null
                    },
                    "decimals": null,
                    "token_metadata": null
                }
            ],
            "name": "Cute Weebits",
            "description": "Cuteness overloaded!",
            "external_link": "",
            "asset_contract": {
                "collection": {
                    "banner_image_url": null,
                    "chat_url": null,
                    "created_date": "2020-12-02T17:40:53.507540",
                    "default_to_fiat": false,
                    "description": null,
                    "dev_buyer_fee_basis_points": "0",
                    "dev_seller_fee_basis_points": "0",
                    "discord_url": null,
                    "display_data": {
                        "card_display_style": "contain",
                        "images": []
                    },
                    "external_url": null,
                    "featured": false,
                    "featured_image_url": null,
                    "hidden": true,
                    "safelist_request_status": "not_requested",
                    "image_url": null,
                    "is_subject_to_whitelist": false,
                    "large_image_url": null,
                    "medium_username": null,
                    "name": "OpenSea Shared Storefront V2",
                    "only_proxied_transfers": false,
                    "opensea_buyer_fee_basis_points": "0",
                    "opensea_seller_fee_basis_points": "250",
                    "payout_address": null,
                    "require_email": false,
                    "short_description": null,
                    "slug": "opensea-shared-storefront-v2",
                    "telegram_url": null,
                    "twitter_username": null,
                    "instagram_username": null,
                    "wiki_url": null
                },
                "address": "0x495f947276749ce646f68ac8c248420045cb7b5e",
                "asset_contract_type": "semi-fungible",
                "created_date": "2020-12-02T17:40:53.232025",
                "name": "OpenSea Collection",
                "nft_version": null,
                "opensea_version": "2.0.0",
                "owner": 102384,
                "schema_name": "ERC1155",
                "symbol": "OPENSTORE",
                "total_supply": null,
                "description": null,
                "external_link": null,
                "image_url": null,
                "default_to_fiat": false,
                "dev_buyer_fee_basis_points": 0,
                "dev_seller_fee_basis_points": 0,
                "only_proxied_transfers": false,
                "opensea_buyer_fee_basis_points": 0,
                "opensea_seller_fee_basis_points": 250,
                "buyer_fee_basis_points": 0,
                "seller_fee_basis_points": 250,
                "payout_address": null
            },
            "permalink": "https://opensea.io/bundles/cute-weebits-YlA",
            "sell_orders": [
                {
                    "created_date": "2021-05-25T20:20:54.805672",
                    "closing_date": "2021-05-26T20:15:54",
                    "closing_extendable": false,
                    "expiration_time": 1622060154,
                    "listing_time": 1621973950,
                    "order_hash": "0x16f20262ad978dd6faf17927c8ab1e41e888d41fbd96a978b658165153109dd9",
                    "metadata": {
                        "bundle": {
                            "assets": [
                                {
                                    "id": "77993642746362625660084917667317678697710155686795798893749614900365305577473",
                                    "address": "0x495f947276749ce646f68ac8c248420045cb7b5e",
                                    "quantity": "1"
                                },
                                {
                                    "id": "77993642746362625660084917667317678697710155686795798893749615089481305554945",
                                    "address": "0x495f947276749ce646f68ac8c248420045cb7b5e",
                                    "quantity": "1"
                                },
                                {
                                    "id": "77993642746362625660084917667317678697710155686795798893749615131262747410433",
                                    "address": "0x495f947276749ce646f68ac8c248420045cb7b5e",
                                    "quantity": "1"
                                }
                            ],
                            "schemas": [
                                "ERC1155",
                                "ERC1155",
                                "ERC1155"
                            ],
                            "name": "Cute Weebits",
                            "description": "Cuteness overloaded!",
                            "external_link": ""
                        }
                    },
                    "exchange": "0x7be8076f4ea4a4ad08075c2508e481d6c946d12b",
                    "maker": {
                        "user": 822726,
                        "profile_img_url": "https://storage.googleapis.com/opensea-static/opensea-profile/13.png",
                        "address": "0xdc8eb8d2d1babd956136b57b0b9f49b433c019e3",
                        "config": "",
                        "discord_id": ""
                    },
                    "taker": {
                        "user": 1766,
                        "profile_img_url": "https://storage.googleapis.com/opensea-static/opensea-profile/1.png",
                        "address": "0x0000000000000000000000000000000000000000",
                        "config": "",
                        "discord_id": ""
                    },
                    "current_price": "800000000000000000.0000000000",
                    "current_bounty": "8000000000000000",
                    "bounty_multiple": "0.01",
                    "maker_relayer_fee": "250",
                    "taker_relayer_fee": "0",
                    "maker_protocol_fee": "0",
                    "taker_protocol_fee": "0",
                    "maker_referrer_fee": "0",
                    "fee_recipient": {
                        "user": 3585,
                        "profile_img_url": "https://storage.googleapis.com/opensea-static/opensea-profile/28.png",
                        "address": "0x5b3256965e7c3cf26e11fcaf296dfc8807c01073",
                        "config": "verified",
                        "discord_id": ""
                    },
                    "fee_method": 1,
                    "side": 1,
                    "sale_kind": 0,
                    "target": "0xc99f70bfd82fb7c8f8191fdfbfb735606b15e5c5",
                    "how_to_call": 1,
                    "calldata": "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",
                    "replacement_pattern": "0x0000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000ffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffff0000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000ffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffff0000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000ffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffff00000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000",
                    "static_target": "0x0000000000000000000000000000000000000000",
                    "static_extradata": "0x",
                    "payment_token": "0x0000000000000000000000000000000000000000",
                    "payment_token_contract": {
                        "id": 1,
                        "symbol": "ETH",
                        "address": "0x0000000000000000000000000000000000000000",
                        "image_url": "https://storage.opensea.io/files/6f8e2979d428180222796ff4a33ab929.svg",
                        "name": "Ether",
                        "decimals": 18,
                        "eth_price": "1.000000000000000",
                        "usd_price": "2625.730000000000018000"
                    },
                    "base_price": "800000000000000000",
                    "extra": "0",
                    "quantity": "1",
                    "salt": "37913326636668165794476818649859900022697885359509565806137512689503682985831",
                    "v": 27,
                    "r": "0xc5110e0162880a3cc1d118c30d86fa6cc59a7fa50863c28245d58c3fc26bce21",
                    "s": "0x0ff44a9f890d731e1bdaf1766f12d221e0092ddd807675ecc3d8073534204046",
                    "approved_on_chain": false,
                    "cancelled": false,
                    "finalized": false,
                    "marked_invalid": false,
                    "prefixed_hash": "0x7307990d221eff9f8fad99dcf4d6b4d5651e31500cec98e595c9943d76337897"
                }
            ]
        },
        {
            "maker": {
                "user": {
                    "username": "meePIG"
                },
                "profile_img_url": "https://storage.googleapis.com/opensea-static/opensea-profile/5.png",
                "address": "0xf7e31c55c1771f64416ed96fa1a5ba09cae28133",
                "config": "",
                "discord_id": ""
            },
            "slug": "legendary-rare-monster-bundle-AtB",
            "assets": [
                {
                    "id": 25293890,
                    "token_id": "404",
                    "num_sales": 1,
                    "background_color": null,
                    "image_url": "https://lh3.googleusercontent.com/g1oK39xpORz-dbGCeflK1VKYTg064TLiYvVnTLV3Cn3WyRN-gygfH0f0_4BSo3WQzyq-M5-ASP93O6FvyAK63A9xRSjbSC8ix7H4",
                    "image_preview_url": "https://lh3.googleusercontent.com/g1oK39xpORz-dbGCeflK1VKYTg064TLiYvVnTLV3Cn3WyRN-gygfH0f0_4BSo3WQzyq-M5-ASP93O6FvyAK63A9xRSjbSC8ix7H4=s250",
                    "image_thumbnail_url": "https://lh3.googleusercontent.com/g1oK39xpORz-dbGCeflK1VKYTg064TLiYvVnTLV3Cn3WyRN-gygfH0f0_4BSo3WQzyq-M5-ASP93O6FvyAK63A9xRSjbSC8ix7H4=s128",
                    "image_original_url": "https://arweave.net/_1mfNITZ4n4gQjMgULjPHvmqQGrXgsPUZANck5l6Yhg",
                    "animation_url": null,
                    "animation_original_url": null,
                    "name": "Apymon Monsters #404",
                    "description": null,
                    "external_link": "https://apymon.com",
                    "asset_contract": {
                        "address": "0x6e0baaa0d1c11dc160143c0c7213df76acdf4e17",
                        "asset_contract_type": "non-fungible",
                        "created_date": "2021-05-18T16:21:48.758011",
                        "name": "Apymon Monsters",
                        "nft_version": "3.0",
                        "opensea_version": null,
                        "owner": 30104721,
                        "schema_name": "ERC721",
                        "symbol": "APYM",
                        "total_supply": "0",
                        "description": "The NFT built by ERC721, Apymon Monsters, on Ethereum.",
                        "external_link": null,
                        "image_url": "https://lh3.googleusercontent.com/nCcUQe3w8k7omeB6DSrP4Y792JQaRLfqFv6SFzDxab1k44mR7kT9p8d4-m_X6iEfr47RGup5wCdP2s2RS1Y88-KaeElQgyzTs4cc=s120",
                        "default_to_fiat": false,
                        "dev_buyer_fee_basis_points": 0,
                        "dev_seller_fee_basis_points": 0,
                        "only_proxied_transfers": false,
                        "opensea_buyer_fee_basis_points": 0,
                        "opensea_seller_fee_basis_points": 250,
                        "buyer_fee_basis_points": 0,
                        "seller_fee_basis_points": 250,
                        "payout_address": null
                    },
                    "owner": {
                        "user": {
                            "username": "meePIG"
                        },
                        "profile_img_url": "https://storage.googleapis.com/opensea-static/opensea-profile/5.png",
                        "address": "0xf7e31c55c1771f64416ed96fa1a5ba09cae28133",
                        "config": "",
                        "discord_id": ""
                    },
                    "permalink": "https://opensea.io/assets/0x6e0baaa0d1c11dc160143c0c7213df76acdf4e17/404",
                    "collection": {
                        "banner_image_url": "https://lh3.googleusercontent.com/xsxkSFVINW-MV2mnqiv5PN6uFynoq-ev16uvOIgkz73GODzvFeM7wOmBM7OkxGmhv1GHpP-t31VqHcEvfScUfAnfiDT-zGS_Y30C=s2500",
                        "chat_url": null,
                        "created_date": "2021-05-18T16:59:45.948886",
                        "default_to_fiat": false,
                        "description": "The NFT built by ERC721, Apymon Monsters, on Ethereum.",
                        "dev_buyer_fee_basis_points": "0",
                        "dev_seller_fee_basis_points": "0",
                        "discord_url": null,
                        "display_data": {
                            "card_display_style": "contain"
                        },
                        "external_url": null,
                        "featured": false,
                        "featured_image_url": "https://lh3.googleusercontent.com/hybKwm5kYCjE_IIF4DiObNzaHYVOH0Xenx3ye8domy0ssj1SQB7L7j0krdp8dFFiR8ZTznf16HX70btLTblWUqS-wxaFqbAencUTyw=s300",
                        "hidden": true,
                        "safelist_request_status": "not_requested",
                        "image_url": "https://lh3.googleusercontent.com/nCcUQe3w8k7omeB6DSrP4Y792JQaRLfqFv6SFzDxab1k44mR7kT9p8d4-m_X6iEfr47RGup5wCdP2s2RS1Y88-KaeElQgyzTs4cc=s120",
                        "is_subject_to_whitelist": false,
                        "large_image_url": "https://lh3.googleusercontent.com/hybKwm5kYCjE_IIF4DiObNzaHYVOH0Xenx3ye8domy0ssj1SQB7L7j0krdp8dFFiR8ZTznf16HX70btLTblWUqS-wxaFqbAencUTyw=s300",
                        "medium_username": null,
                        "name": "Apymon Monsters",
                        "only_proxied_transfers": false,
                        "opensea_buyer_fee_basis_points": "0",
                        "opensea_seller_fee_basis_points": "250",
                        "payout_address": null,
                        "require_email": false,
                        "short_description": null,
                        "slug": "apymon-monsters",
                        "telegram_url": null,
                        "twitter_username": null,
                        "instagram_username": null,
                        "wiki_url": null
                    },
                    "decimals": 0,
                    "token_metadata": "https://gateway.pinata.cloud/ipfs/QmTQeQgS5Xa5WiDzuGS5RCKe8z74CgfiuA5cADPXLVX7uB/404"
                },
                {
                    "id": 25659809,
                    "token_id": "112122543444638944511622707921156659601731686990296802203830456798572351324161",
                    "num_sales": 0,
                    "background_color": null,
                    "image_url": "https://lh3.googleusercontent.com/iNr5He-mDs5icw8imIin4fzYS77sWX0xjDQNovsYtuksida2dzSqqjbEzNc_nc2L4S6OmlA4VdV1pwBAhh58klREbymYKFvIVLbffQ",
                    "image_preview_url": "https://lh3.googleusercontent.com/iNr5He-mDs5icw8imIin4fzYS77sWX0xjDQNovsYtuksida2dzSqqjbEzNc_nc2L4S6OmlA4VdV1pwBAhh58klREbymYKFvIVLbffQ=s250",
                    "image_thumbnail_url": "https://lh3.googleusercontent.com/iNr5He-mDs5icw8imIin4fzYS77sWX0xjDQNovsYtuksida2dzSqqjbEzNc_nc2L4S6OmlA4VdV1pwBAhh58klREbymYKFvIVLbffQ=s128",
                    "image_original_url": null,
                    "animation_url": "https://storage.opensea.io/files/ab71829afddeae8f6eb80dd93694bba5.mp4",
                    "animation_original_url": "https://storage.opensea.io/files/ab71829afddeae8f6eb80dd93694bba5.mp4",
                    "name": "Apymon Monsters #629",
                    "description": null,
                    "external_link": null,
                    "asset_contract": {
                        "address": "0x495f947276749ce646f68ac8c248420045cb7b5e",
                        "asset_contract_type": "semi-fungible",
                        "created_date": "2020-12-02T17:40:53.232025",
                        "name": "OpenSea Collection",
                        "nft_version": null,
                        "opensea_version": "2.0.0",
                        "owner": 102384,
                        "schema_name": "ERC1155",
                        "symbol": "OPENSTORE",
                        "total_supply": null,
                        "description": null,
                        "external_link": null,
                        "image_url": null,
                        "default_to_fiat": false,
                        "dev_buyer_fee_basis_points": 0,
                        "dev_seller_fee_basis_points": 0,
                        "only_proxied_transfers": false,
                        "opensea_buyer_fee_basis_points": 0,
                        "opensea_seller_fee_basis_points": 250,
                        "buyer_fee_basis_points": 0,
                        "seller_fee_basis_points": 250,
                        "payout_address": null
                    },
                    "owner": {
                        "user": {
                            "username": "NullAddress"
                        },
                        "profile_img_url": "https://storage.googleapis.com/opensea-static/opensea-profile/1.png",
                        "address": "0x0000000000000000000000000000000000000000",
                        "config": "",
                        "discord_id": ""
                    },
                    "permalink": "https://opensea.io/assets/0x495f947276749ce646f68ac8c248420045cb7b5e/112122543444638944511622707921156659601731686990296802203830456798572351324161",
                    "collection": {
                        "banner_image_url": "https://lh3.googleusercontent.com/FOPcASeD6y7uAiRixUDEJpbw3AlPlRo4N1dmpATKbqzScL0Xaiteunz9unHIOyLO7KKgY8SqXzBLfh72VSZXhpeOlJaVkxIJESdZBw=s2500",
                        "chat_url": null,
                        "created_date": "2021-05-25T14:46:28.721872",
                        "default_to_fiat": false,
                        "description": "The NFT built by ERC721, Apymon Monsters, on Ethereum.",
                        "dev_buyer_fee_basis_points": "0",
                        "dev_seller_fee_basis_points": "0",
                        "discord_url": null,
                        "display_data": {
                            "card_display_style": "contain"
                        },
                        "external_url": null,
                        "featured": false,
                        "featured_image_url": null,
                        "hidden": true,
                        "safelist_request_status": "not_requested",
                        "image_url": "https://lh3.googleusercontent.com/nCcUQe3w8k7omeB6DSrP4Y792JQaRLfqFv6SFzDxab1k44mR7kT9p8d4-m_X6iEfr47RGup5wCdP2s2RS1Y88-KaeElQgyzTs4cc=s120",
                        "is_subject_to_whitelist": false,
                        "large_image_url": null,
                        "medium_username": null,
                        "name": "Apymon  Monsters",
                        "only_proxied_transfers": false,
                        "opensea_buyer_fee_basis_points": "0",
                        "opensea_seller_fee_basis_points": "250",
                        "payout_address": null,
                        "require_email": false,
                        "short_description": null,
                        "slug": "colored-boxes",
                        "telegram_url": null,
                        "twitter_username": null,
                        "instagram_username": null,
                        "wiki_url": null
                    },
                    "decimals": null,
                    "token_metadata": null
                }
            ],
            "name": "Legendary & Rare monster bundle",
            "description": null,
            "external_link": "",
            "asset_contract": null,
            "permalink": "https://opensea.io/bundles/legendary-rare-monster-bundle-AtB",
            "sell_orders": [
                {
                    "created_date": "2021-05-25T20:43:22.697445",
                    "closing_date": null,
                    "closing_extendable": false,
                    "expiration_time": 0,
                    "listing_time": 1621975295,
                    "order_hash": "0xc46c383264a79a76b93bedb978d346a19d6757a25541d9f46d5077c68bc77e73",
                    "metadata": {
                        "bundle": {
                            "assets": [
                                {
                                    "id": "112122543444638944511622707921156659601731686990296802203830456798572351324161",
                                    "address": "0x495f947276749ce646f68ac8c248420045cb7b5e",
                                    "quantity": "1"
                                },
                                {
                                    "id": "404",
                                    "address": "0x6e0baaa0d1c11dc160143c0c7213df76acdf4e17"
                                }
                            ],
                            "schemas": [
                                "ERC1155",
                                "ERC721"
                            ],
                            "name": "Legendary & Rare monster bundle",
                            "external_link": ""
                        }
                    },
                    "exchange": "0x7be8076f4ea4a4ad08075c2508e481d6c946d12b",
                    "maker": {
                        "user": 821223,
                        "profile_img_url": "https://storage.googleapis.com/opensea-static/opensea-profile/5.png",
                        "address": "0xf7e31c55c1771f64416ed96fa1a5ba09cae28133",
                        "config": "",
                        "discord_id": ""
                    },
                    "taker": {
                        "user": 1766,
                        "profile_img_url": "https://storage.googleapis.com/opensea-static/opensea-profile/1.png",
                        "address": "0x0000000000000000000000000000000000000000",
                        "config": "",
                        "discord_id": ""
                    },
                    "current_price": "1950000000000000000",
                    "current_bounty": "19500000000000000",
                    "bounty_multiple": "0.01",
                    "maker_relayer_fee": "250",
                    "taker_relayer_fee": "0",
                    "maker_protocol_fee": "0",
                    "taker_protocol_fee": "0",
                    "maker_referrer_fee": "0",
                    "fee_recipient": {
                        "user": 3585,
                        "profile_img_url": "https://storage.googleapis.com/opensea-static/opensea-profile/28.png",
                        "address": "0x5b3256965e7c3cf26e11fcaf296dfc8807c01073",
                        "config": "verified",
                        "discord_id": ""
                    },
                    "fee_method": 1,
                    "side": 1,
                    "sale_kind": 0,
                    "target": "0xc99f70bfd82fb7c8f8191fdfbfb735606b15e5c5",
                    "how_to_call": 1,
                    "calldata": "0x68f0bcaa000000000000000000000000000000000000000000000000000000000000008000000000000000000000000000000000000000000000000000000000000000e0000000000000000000000000000000000000000000000000000000000000014000000000000000000000000000000000000000000000000000000000000001a00000000000000000000000000000000000000000000000000000000000000002000000000000000000000000495f947276749ce646f68ac8c248420045cb7b5e0000000000000000000000006e0baaa0d1c11dc160143c0c7213df76acdf4e17000000000000000000000000000000000000000000000000000000000000000200000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000200000000000000000000000000000000000000000000000000000000000000c400000000000000000000000000000000000000000000000000000000000000640000000000000000000000000000000000000000000000000000000000000128f242432a000000000000000000000000f7e31c55c1771f64416ed96fa1a5ba09cae281330000000000000000000000000000000000000000000000000000000000000000f7e31c55c1771f64416ed96fa1a5ba09cae28133000000000000030000000001000000000000000000000000000000000000000000000000000000000000000100000000000000000000000000000000000000000000000000000000000000a0000000000000000000000000000000000000000000000000000000000000000023b872dd000000000000000000000000f7e31c55c1771f64416ed96fa1a5ba09cae2813300000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000194000000000000000000000000000000000000000000000000",
                    "replacement_pattern": "0x0000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000ffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffff0000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000ffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffff0000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000",
                    "static_target": "0x0000000000000000000000000000000000000000",
                    "static_extradata": "0x",
                    "payment_token": "0x0000000000000000000000000000000000000000",
                    "payment_token_contract": {
                        "id": 1,
                        "symbol": "ETH",
                        "address": "0x0000000000000000000000000000000000000000",
                        "image_url": "https://storage.opensea.io/files/6f8e2979d428180222796ff4a33ab929.svg",
                        "name": "Ether",
                        "decimals": 18,
                        "eth_price": "1.000000000000000",
                        "usd_price": "2625.730000000000018000"
                    },
                    "base_price": "1950000000000000000",
                    "extra": "0",
                    "quantity": "1",
                    "salt": "20867631501396246002071948343419583680935690596008928552728096943539645908941",
                    "v": 28,
                    "r": "0x3f2a342aa31dcf24f0353373d7c8b317aa1cb60c9191aca4d0e7073c989106e9",
                    "s": "0x6b65ba5ab96d0b63eabb8e1a5785587ade76d66ccf1f06234e031484e23711ee",
                    "approved_on_chain": false,
                    "cancelled": false,
                    "finalized": false,
                    "marked_invalid": false,
                    "prefixed_hash": "0x479547cbb3ea322456a7989aa9e28f0e893d43fb5ad7c29fcbb241aae22e1b49"
                }
            ]
        },
        {
            "maker": {
                "user": {
                    "username": null
                },
                "profile_img_url": "https://storage.googleapis.com/opensea-static/opensea-profile/18.png",
                "address": "0xfb59814d60f68d4dd9a502e40267a814e8d33932",
                "config": "",
                "discord_id": ""
            },
            "slug": "polkapets-BdW",
            "assets": [
                {
                    "id": 20979489,
                    "token_id": "9",
                    "num_sales": 8,
                    "background_color": null,
                    "image_url": "https://lh3.googleusercontent.com/dUNYne26LuG7D78l1MiHCkiRbmzhwwBFI547POdcEdM4mIQQyqZ8mGRYM_DUwRMcovp8TUIaGxOH7_VX3q2MsVxIvPGbcCELLXIdVg",
                    "image_preview_url": "https://lh3.googleusercontent.com/dUNYne26LuG7D78l1MiHCkiRbmzhwwBFI547POdcEdM4mIQQyqZ8mGRYM_DUwRMcovp8TUIaGxOH7_VX3q2MsVxIvPGbcCELLXIdVg=s250",
                    "image_thumbnail_url": "https://lh3.googleusercontent.com/dUNYne26LuG7D78l1MiHCkiRbmzhwwBFI547POdcEdM4mIQQyqZ8mGRYM_DUwRMcovp8TUIaGxOH7_VX3q2MsVxIvPGbcCELLXIdVg=s128",
                    "image_original_url": "https://api.globephoto.xyz/images/9.jpg",
                    "animation_url": null,
                    "animation_original_url": null,
                    "name": "Andy Bondly Token",
                    "description": "This piece was created by Thomas Hussung and Nicholas Miller. \n\nThese artists are best known for their Andy Warhol-inspired portraits and bright colors found in their contemporary works. \n\nTo learn more about Thomas Hussung and his work: https://www.artnet.com/artists/thomas-hussung/",
                    "external_link": "https://www.globephotos.com/",
                    "asset_contract": {
                        "address": "0x1f42f3e36f8c61fcbef35e0cfb88bdf9392856ed",
                        "asset_contract_type": "semi-fungible",
                        "created_date": "2021-03-31T23:44:33.261335",
                        "name": "Globe Photo Official Collection",
                        "nft_version": null,
                        "opensea_version": null,
                        "owner": 27984547,
                        "schema_name": "ERC1155",
                        "symbol": "GPC",
                        "total_supply": null,
                        "description": "For over 75 years, Globe Photos has been renowned for its cover of celebrities & entertainment industry & archive of historical figures and events.",
                        "external_link": "https://www.globecorp.co/",
                        "image_url": "https://lh3.googleusercontent.com/VpGeGrScuFY8DGNK1gNvbPhxSG9_OImDw_VOhZ-LiFVuBaJHcAsJAV_CdjLpB_2OyLoUdD5D55_yxOesVfzvT5iJRc1DyzOInSVv=s120",
                        "default_to_fiat": false,
                        "dev_buyer_fee_basis_points": 0,
                        "dev_seller_fee_basis_points": 500,
                        "only_proxied_transfers": false,
                        "opensea_buyer_fee_basis_points": 0,
                        "opensea_seller_fee_basis_points": 250,
                        "buyer_fee_basis_points": 0,
                        "seller_fee_basis_points": 750,
                        "payout_address": "0x3d033c4f0e4a55d791207041c36c4b0971236ace"
                    },
                    "owner": {
                        "user": {
                            "username": "NullAddress"
                        },
                        "profile_img_url": "https://storage.googleapis.com/opensea-static/opensea-profile/1.png",
                        "address": "0x0000000000000000000000000000000000000000",
                        "config": "",
                        "discord_id": ""
                    },
                    "permalink": "https://opensea.io/assets/0x1f42f3e36f8c61fcbef35e0cfb88bdf9392856ed/9",
                    "collection": {
                        "banner_image_url": "https://lh3.googleusercontent.com/PlhC4Oj0gMLy5bAhfKrHkWO4zQJmn3tFkqCHqjNtQqwQZ9hHWcYPscB7NjmAAFDRECIlBBlK80wdIRkHackft_n88yph7uvbDHE8kQ=s2500",
                        "chat_url": null,
                        "created_date": "2021-04-01T01:01:17.457486",
                        "default_to_fiat": false,
                        "description": "For over 75 years, Globe Photos has been renowned for its cover of celebrities & entertainment industry & archive of historical figures and events.",
                        "dev_buyer_fee_basis_points": "0",
                        "dev_seller_fee_basis_points": "500",
                        "discord_url": null,
                        "display_data": {
                            "card_display_style": "contain"
                        },
                        "external_url": "https://www.globecorp.co/",
                        "featured": false,
                        "featured_image_url": "https://lh3.googleusercontent.com/mj_4JHp9gYy9KVAcySHJlOLjNjlFSIYw00H06m24WK4OW05PlBa3W2viuXvFYdxQwh4TqgKBTmvQJRgP7Xdbi9yKlzhUdJ24iVSCWSU=s300",
                        "hidden": false,
                        "safelist_request_status": "approved",
                        "image_url": "https://lh3.googleusercontent.com/VpGeGrScuFY8DGNK1gNvbPhxSG9_OImDw_VOhZ-LiFVuBaJHcAsJAV_CdjLpB_2OyLoUdD5D55_yxOesVfzvT5iJRc1DyzOInSVv=s120",
                        "is_subject_to_whitelist": false,
                        "large_image_url": "https://lh3.googleusercontent.com/mj_4JHp9gYy9KVAcySHJlOLjNjlFSIYw00H06m24WK4OW05PlBa3W2viuXvFYdxQwh4TqgKBTmvQJRgP7Xdbi9yKlzhUdJ24iVSCWSU=s300",
                        "medium_username": null,
                        "name": "Globe Photos Official Collection",
                        "only_proxied_transfers": false,
                        "opensea_buyer_fee_basis_points": "0",
                        "opensea_seller_fee_basis_points": "250",
                        "payout_address": "0x3d033c4f0e4a55d791207041c36c4b0971236ace",
                        "require_email": false,
                        "short_description": null,
                        "slug": "globephoto",
                        "telegram_url": null,
                        "twitter_username": null,
                        "instagram_username": null,
                        "wiki_url": null
                    },
                    "decimals": null,
                    "token_metadata": "https://api.globephoto.xyz/api/item/9"
                },
                {
                    "id": 21027361,
                    "token_id": "1",
                    "num_sales": 57,
                    "background_color": null,
                    "image_url": "https://lh3.googleusercontent.com/35QdqkF61BYXHbjmUsCRmDMiKs5aBnn7H_X5B583jmP7_JldH6ETL141-g74TL0EPOncWtKnZWW3_Nz_Xpft2-NPuyMy3KgyVRW8kA",
                    "image_preview_url": "https://lh3.googleusercontent.com/35QdqkF61BYXHbjmUsCRmDMiKs5aBnn7H_X5B583jmP7_JldH6ETL141-g74TL0EPOncWtKnZWW3_Nz_Xpft2-NPuyMy3KgyVRW8kA=s250",
                    "image_thumbnail_url": "https://lh3.googleusercontent.com/35QdqkF61BYXHbjmUsCRmDMiKs5aBnn7H_X5B583jmP7_JldH6ETL141-g74TL0EPOncWtKnZWW3_Nz_Xpft2-NPuyMy3KgyVRW8kA=s128",
                    "image_original_url": "https://api.ppw.digital/images/MoonBeam.png",
                    "animation_url": null,
                    "animation_original_url": null,
                    "name": "Moonbeam (Moonbeam)",
                    "description": "Personality:\n\nMoonbeam loves building and tinkering with different arts. It's constantly thinking of new ideas and loves to nap in cold places. Loved by the community, Moonbeam brings a smile to everyone's faces with its positive energy. \n\nAbility Desc:\n\nThe PolkaPet starts to compress energy into its forehead and shoots out a powerful white beam of light at its opponent.",
                    "external_link": "https://www.bondly.finance/",
                    "asset_contract": {
                        "address": "0x8cb813bf27dc744fc5fb6ba7515504de45d39e08",
                        "asset_contract_type": "semi-fungible",
                        "created_date": "2021-04-01T19:39:36.438767",
                        "name": "PolkaPets Base Set",
                        "nft_version": null,
                        "opensea_version": null,
                        "owner": 18561537,
                        "schema_name": "ERC1155",
                        "symbol": "PPBS",
                        "total_supply": null,
                        "description": "The Official PolkaPets Trading Card Game Collection",
                        "external_link": "https://www.bondly.finance/",
                        "image_url": "https://lh3.googleusercontent.com/1PD-sO-BokG4bezW7UrlhW8491Blxv6j5ia5ZmAFUWTqfxNNM4f7B9mWr7mh0SuehCHnIH8rvkIA4Ug-JdS7jLlc60weamJf3Ht8MQ=s120",
                        "default_to_fiat": false,
                        "dev_buyer_fee_basis_points": 0,
                        "dev_seller_fee_basis_points": 1000,
                        "only_proxied_transfers": false,
                        "opensea_buyer_fee_basis_points": 0,
                        "opensea_seller_fee_basis_points": 250,
                        "buyer_fee_basis_points": 0,
                        "seller_fee_basis_points": 1250,
                        "payout_address": "0xdf1dcf94d240798442a681f291321b63d1f0afa3"
                    },
                    "owner": {
                        "user": {
                            "username": "NullAddress"
                        },
                        "profile_img_url": "https://storage.googleapis.com/opensea-static/opensea-profile/1.png",
                        "address": "0x0000000000000000000000000000000000000000",
                        "config": "",
                        "discord_id": ""
                    },
                    "permalink": "https://opensea.io/assets/0x8cb813bf27dc744fc5fb6ba7515504de45d39e08/1",
                    "collection": {
                        "banner_image_url": null,
                        "chat_url": null,
                        "created_date": "2021-01-27T02:36:31.308470",
                        "default_to_fiat": false,
                        "description": "The Official PolkaPets Trading Card Game Collection",
                        "dev_buyer_fee_basis_points": "0",
                        "dev_seller_fee_basis_points": "1000",
                        "discord_url": null,
                        "display_data": {
                            "card_display_style": "contain"
                        },
                        "external_url": "https://www.bondly.finance/",
                        "featured": false,
                        "featured_image_url": null,
                        "hidden": false,
                        "safelist_request_status": "verified",
                        "image_url": "https://lh3.googleusercontent.com/1PD-sO-BokG4bezW7UrlhW8491Blxv6j5ia5ZmAFUWTqfxNNM4f7B9mWr7mh0SuehCHnIH8rvkIA4Ug-JdS7jLlc60weamJf3Ht8MQ=s120",
                        "is_subject_to_whitelist": false,
                        "large_image_url": "https://lh3.googleusercontent.com/1PD-sO-BokG4bezW7UrlhW8491Blxv6j5ia5ZmAFUWTqfxNNM4f7B9mWr7mh0SuehCHnIH8rvkIA4Ug-JdS7jLlc60weamJf3Ht8MQ",
                        "medium_username": null,
                        "name": "PolkaPets TCG",
                        "only_proxied_transfers": false,
                        "opensea_buyer_fee_basis_points": "0",
                        "opensea_seller_fee_basis_points": "250",
                        "payout_address": "0xdf1dcf94d240798442a681f291321b63d1f0afa3",
                        "require_email": false,
                        "short_description": null,
                        "slug": "polkapets",
                        "telegram_url": null,
                        "twitter_username": "polkapets",
                        "instagram_username": null,
                        "wiki_url": null
                    },
                    "decimals": null,
                    "token_metadata": "https://api.ppw.digital/api/item/1"
                },
                {
                    "id": 21027362,
                    "token_id": "2",
                    "num_sales": 43,
                    "background_color": null,
                    "image_url": "https://lh3.googleusercontent.com/1I1WUS3nKusJCRBMHIGhLN7dNNKBy3Cmx8lBOpYm1QM3fE-UeM_JKALu3F1J7c2IUFwh2wntcv0e1-yIP2-bqIWcBDAjg1GZ9eiO",
                    "image_preview_url": "https://lh3.googleusercontent.com/1I1WUS3nKusJCRBMHIGhLN7dNNKBy3Cmx8lBOpYm1QM3fE-UeM_JKALu3F1J7c2IUFwh2wntcv0e1-yIP2-bqIWcBDAjg1GZ9eiO=s250",
                    "image_thumbnail_url": "https://lh3.googleusercontent.com/1I1WUS3nKusJCRBMHIGhLN7dNNKBy3Cmx8lBOpYm1QM3fE-UeM_JKALu3F1J7c2IUFwh2wntcv0e1-yIP2-bqIWcBDAjg1GZ9eiO=s128",
                    "image_original_url": "https://api.ppw.digital/images/Darwina.png",
                    "animation_url": null,
                    "animation_original_url": null,
                    "name": "Darwinia (Cross Construct)",
                    "description": "Personality:\n\nDarwinia loves running around and swinging across tree branches. It's quite the prankster, and loves building things out of wood. Playful, chirpy, and extroverted, Darwinia loves to crack jokes. It enjoys being around other PolkaPets and people.\n\nAbility Desc:\n\nHeavy metal emerges from the earth. PolkaPet will be able to use this metal to construct any architecture it wants to.\n\nUtility:\n\nGuaranteed allocation of tokens at listing price\n\nUtility within Bondly’s core product, BSwap\n\nAccess to VIP benefits and behind the scenes sneak peeks of upcoming milestones\n\nGovernance and Voting rights\n\nTreated as an Apostle’s pet and boost mining productivity and efficiency\n\nTreated as a Warrior’s pet and boost fighting power in the coming war gameplay\n\nRecognized as VIP user status\n\nEnjoy benefits provided by ecosystem applications\n\nAirdrop of Darwinia Tokens: RING",
                    "external_link": "https://www.bondly.finance/",
                    "asset_contract": {
                        "address": "0x8cb813bf27dc744fc5fb6ba7515504de45d39e08",
                        "asset_contract_type": "semi-fungible",
                        "created_date": "2021-04-01T19:39:36.438767",
                        "name": "PolkaPets Base Set",
                        "nft_version": null,
                        "opensea_version": null,
                        "owner": 18561537,
                        "schema_name": "ERC1155",
                        "symbol": "PPBS",
                        "total_supply": null,
                        "description": "The Official PolkaPets Trading Card Game Collection",
                        "external_link": "https://www.bondly.finance/",
                        "image_url": "https://lh3.googleusercontent.com/1PD-sO-BokG4bezW7UrlhW8491Blxv6j5ia5ZmAFUWTqfxNNM4f7B9mWr7mh0SuehCHnIH8rvkIA4Ug-JdS7jLlc60weamJf3Ht8MQ=s120",
                        "default_to_fiat": false,
                        "dev_buyer_fee_basis_points": 0,
                        "dev_seller_fee_basis_points": 1000,
                        "only_proxied_transfers": false,
                        "opensea_buyer_fee_basis_points": 0,
                        "opensea_seller_fee_basis_points": 250,
                        "buyer_fee_basis_points": 0,
                        "seller_fee_basis_points": 1250,
                        "payout_address": "0xdf1dcf94d240798442a681f291321b63d1f0afa3"
                    },
                    "owner": {
                        "user": {
                            "username": "NullAddress"
                        },
                        "profile_img_url": "https://storage.googleapis.com/opensea-static/opensea-profile/1.png",
                        "address": "0x0000000000000000000000000000000000000000",
                        "config": "",
                        "discord_id": ""
                    },
                    "permalink": "https://opensea.io/assets/0x8cb813bf27dc744fc5fb6ba7515504de45d39e08/2",
                    "collection": {
                        "banner_image_url": null,
                        "chat_url": null,
                        "created_date": "2021-01-27T02:36:31.308470",
                        "default_to_fiat": false,
                        "description": "The Official PolkaPets Trading Card Game Collection",
                        "dev_buyer_fee_basis_points": "0",
                        "dev_seller_fee_basis_points": "1000",
                        "discord_url": null,
                        "display_data": {
                            "card_display_style": "contain"
                        },
                        "external_url": "https://www.bondly.finance/",
                        "featured": false,
                        "featured_image_url": null,
                        "hidden": false,
                        "safelist_request_status": "verified",
                        "image_url": "https://lh3.googleusercontent.com/1PD-sO-BokG4bezW7UrlhW8491Blxv6j5ia5ZmAFUWTqfxNNM4f7B9mWr7mh0SuehCHnIH8rvkIA4Ug-JdS7jLlc60weamJf3Ht8MQ=s120",
                        "is_subject_to_whitelist": false,
                        "large_image_url": "https://lh3.googleusercontent.com/1PD-sO-BokG4bezW7UrlhW8491Blxv6j5ia5ZmAFUWTqfxNNM4f7B9mWr7mh0SuehCHnIH8rvkIA4Ug-JdS7jLlc60weamJf3Ht8MQ",
                        "medium_username": null,
                        "name": "PolkaPets TCG",
                        "only_proxied_transfers": false,
                        "opensea_buyer_fee_basis_points": "0",
                        "opensea_seller_fee_basis_points": "250",
                        "payout_address": "0xdf1dcf94d240798442a681f291321b63d1f0afa3",
                        "require_email": false,
                        "short_description": null,
                        "slug": "polkapets",
                        "telegram_url": null,
                        "twitter_username": "polkapets",
                        "instagram_username": null,
                        "wiki_url": null
                    },
                    "decimals": null,
                    "token_metadata": "https://api.ppw.digital/api/item/2"
                },
                {
                    "id": 21027364,
                    "token_id": "3",
                    "num_sales": 53,
                    "background_color": null,
                    "image_url": "https://lh3.googleusercontent.com/8lNlfrdwesQ5CHmAlo14mXce2zUcRNQuN-Nv0ywvOp3s5P-EO5zpoT_DvQapgR4ROXGatTbx_eB8cBZ00jE7gU1ici7U3EpGoSafoCs",
                    "image_preview_url": "https://lh3.googleusercontent.com/8lNlfrdwesQ5CHmAlo14mXce2zUcRNQuN-Nv0ywvOp3s5P-EO5zpoT_DvQapgR4ROXGatTbx_eB8cBZ00jE7gU1ici7U3EpGoSafoCs=s250",
                    "image_thumbnail_url": "https://lh3.googleusercontent.com/8lNlfrdwesQ5CHmAlo14mXce2zUcRNQuN-Nv0ywvOp3s5P-EO5zpoT_DvQapgR4ROXGatTbx_eB8cBZ00jE7gU1ici7U3EpGoSafoCs=s128",
                    "image_original_url": "https://api.ppw.digital/images/BondProtect.png",
                    "animation_url": null,
                    "animation_original_url": null,
                    "name": "BondProtect (Multi-hail)",
                    "description": "Personality:\n\nBondProtect is very protective of its loved ones. They feel responsible for the well-being of their community. Valuing safety and security, BondProtect will do everything in its power to protect its home in a calm and collected manner. BondProtect has a slender build and a long wispy tail and wings that allow it to fly as well as swim.\n\nAbility Desc:\n\nPolkaPet unleashes a fierce hail attack that will remain for the rest of the battle.\n\nUtility:\n\nBonus Airdrop of Partner Tokens from Bondly’s NFT Launchpad (Bridge, Kylin, and More)\n\nNFT Staking Rewards (BONDLY + Partner Tokens)\n\nNext-Gen PolkaPets ‘Evolution’ Lottery\n\nLottery Entry for 10 Extra BondSwap Cards to be Airdropped to Holders",
                    "external_link": "https://www.bondly.finance/",
                    "asset_contract": {
                        "address": "0x8cb813bf27dc744fc5fb6ba7515504de45d39e08",
                        "asset_contract_type": "semi-fungible",
                        "created_date": "2021-04-01T19:39:36.438767",
                        "name": "PolkaPets Base Set",
                        "nft_version": null,
                        "opensea_version": null,
                        "owner": 18561537,
                        "schema_name": "ERC1155",
                        "symbol": "PPBS",
                        "total_supply": null,
                        "description": "The Official PolkaPets Trading Card Game Collection",
                        "external_link": "https://www.bondly.finance/",
                        "image_url": "https://lh3.googleusercontent.com/1PD-sO-BokG4bezW7UrlhW8491Blxv6j5ia5ZmAFUWTqfxNNM4f7B9mWr7mh0SuehCHnIH8rvkIA4Ug-JdS7jLlc60weamJf3Ht8MQ=s120",
                        "default_to_fiat": false,
                        "dev_buyer_fee_basis_points": 0,
                        "dev_seller_fee_basis_points": 1000,
                        "only_proxied_transfers": false,
                        "opensea_buyer_fee_basis_points": 0,
                        "opensea_seller_fee_basis_points": 250,
                        "buyer_fee_basis_points": 0,
                        "seller_fee_basis_points": 1250,
                        "payout_address": "0xdf1dcf94d240798442a681f291321b63d1f0afa3"
                    },
                    "owner": {
                        "user": {
                            "username": "NullAddress"
                        },
                        "profile_img_url": "https://storage.googleapis.com/opensea-static/opensea-profile/1.png",
                        "address": "0x0000000000000000000000000000000000000000",
                        "config": "",
                        "discord_id": ""
                    },
                    "permalink": "https://opensea.io/assets/0x8cb813bf27dc744fc5fb6ba7515504de45d39e08/3",
                    "collection": {
                        "banner_image_url": null,
                        "chat_url": null,
                        "created_date": "2021-01-27T02:36:31.308470",
                        "default_to_fiat": false,
                        "description": "The Official PolkaPets Trading Card Game Collection",
                        "dev_buyer_fee_basis_points": "0",
                        "dev_seller_fee_basis_points": "1000",
                        "discord_url": null,
                        "display_data": {
                            "card_display_style": "contain"
                        },
                        "external_url": "https://www.bondly.finance/",
                        "featured": false,
                        "featured_image_url": null,
                        "hidden": false,
                        "safelist_request_status": "verified",
                        "image_url": "https://lh3.googleusercontent.com/1PD-sO-BokG4bezW7UrlhW8491Blxv6j5ia5ZmAFUWTqfxNNM4f7B9mWr7mh0SuehCHnIH8rvkIA4Ug-JdS7jLlc60weamJf3Ht8MQ=s120",
                        "is_subject_to_whitelist": false,
                        "large_image_url": "https://lh3.googleusercontent.com/1PD-sO-BokG4bezW7UrlhW8491Blxv6j5ia5ZmAFUWTqfxNNM4f7B9mWr7mh0SuehCHnIH8rvkIA4Ug-JdS7jLlc60weamJf3Ht8MQ",
                        "medium_username": null,
                        "name": "PolkaPets TCG",
                        "only_proxied_transfers": false,
                        "opensea_buyer_fee_basis_points": "0",
                        "opensea_seller_fee_basis_points": "250",
                        "payout_address": "0xdf1dcf94d240798442a681f291321b63d1f0afa3",
                        "require_email": false,
                        "short_description": null,
                        "slug": "polkapets",
                        "telegram_url": null,
                        "twitter_username": "polkapets",
                        "instagram_username": null,
                        "wiki_url": null
                    },
                    "decimals": null,
                    "token_metadata": "https://api.ppw.digital/api/item/3"
                },
                {
                    "id": 21027366,
                    "token_id": "4",
                    "num_sales": 154,
                    "background_color": null,
                    "image_url": "https://lh3.googleusercontent.com/zy2Iatd7QLyo02eN90MGEhWTuYDL64hSxDRu2DgDqaYjDDgs1ZBCuQGv-vQSGGt8o0CtvOZ2yvnI53DkxVZTXPT-iJhgiYs1eWJ4KQ",
                    "image_preview_url": "https://lh3.googleusercontent.com/zy2Iatd7QLyo02eN90MGEhWTuYDL64hSxDRu2DgDqaYjDDgs1ZBCuQGv-vQSGGt8o0CtvOZ2yvnI53DkxVZTXPT-iJhgiYs1eWJ4KQ=s250",
                    "image_thumbnail_url": "https://lh3.googleusercontent.com/zy2Iatd7QLyo02eN90MGEhWTuYDL64hSxDRu2DgDqaYjDDgs1ZBCuQGv-vQSGGt8o0CtvOZ2yvnI53DkxVZTXPT-iJhgiYs1eWJ4KQ=s128",
                    "image_original_url": "https://api.ppw.digital/images/MantraDAO.png",
                    "animation_url": null,
                    "animation_original_url": null,
                    "name": "MANTRA DAO (Transparency)",
                    "description": "Personality:\n\nMANTRA DAO is reliable and expandable. They are well-rounded when it comes to their skills and they do not hesitate to help when they see someone in need.  MANTRA DAO has the ability to float and is loved by its community.\n\nAbility Desc:\n\nSpecial attack where the PolkaPet can turn invisible and stealthily attack the opponent's weak point.\n\nUtility:\n\nLottery Entry for Next-Gen PolkaPets ‘Evolution’ NFT\n\nLottery Entry for select future MANTRA DAO NFTs to be airdropped to holders\n\nExclusive access and promotions within MANTRA DAO (TBD)\n\nEligibility to be used as collateral for MANTRA DAO lending products (TBD)\n\nReduced fees within Bondly’s core product, BSwap\n\nAccess to VIP benefits and behind the scenes sneak peeks of upcoming milestones\n\nZENDIT launchpad participation in Tier 5(https://medium.com/mantra-dao/presenting-mantra-daos-launchpad-zendit-7949ea82523c)",
                    "external_link": "https://www.bondly.finance/",
                    "asset_contract": {
                        "address": "0x8cb813bf27dc744fc5fb6ba7515504de45d39e08",
                        "asset_contract_type": "semi-fungible",
                        "created_date": "2021-04-01T19:39:36.438767",
                        "name": "PolkaPets Base Set",
                        "nft_version": null,
                        "opensea_version": null,
                        "owner": 18561537,
                        "schema_name": "ERC1155",
                        "symbol": "PPBS",
                        "total_supply": null,
                        "description": "The Official PolkaPets Trading Card Game Collection",
                        "external_link": "https://www.bondly.finance/",
                        "image_url": "https://lh3.googleusercontent.com/1PD-sO-BokG4bezW7UrlhW8491Blxv6j5ia5ZmAFUWTqfxNNM4f7B9mWr7mh0SuehCHnIH8rvkIA4Ug-JdS7jLlc60weamJf3Ht8MQ=s120",
                        "default_to_fiat": false,
                        "dev_buyer_fee_basis_points": 0,
                        "dev_seller_fee_basis_points": 1000,
                        "only_proxied_transfers": false,
                        "opensea_buyer_fee_basis_points": 0,
                        "opensea_seller_fee_basis_points": 250,
                        "buyer_fee_basis_points": 0,
                        "seller_fee_basis_points": 1250,
                        "payout_address": "0xdf1dcf94d240798442a681f291321b63d1f0afa3"
                    },
                    "owner": {
                        "user": {
                            "username": "NullAddress"
                        },
                        "profile_img_url": "https://storage.googleapis.com/opensea-static/opensea-profile/1.png",
                        "address": "0x0000000000000000000000000000000000000000",
                        "config": "",
                        "discord_id": ""
                    },
                    "permalink": "https://opensea.io/assets/0x8cb813bf27dc744fc5fb6ba7515504de45d39e08/4",
                    "collection": {
                        "banner_image_url": null,
                        "chat_url": null,
                        "created_date": "2021-01-27T02:36:31.308470",
                        "default_to_fiat": false,
                        "description": "The Official PolkaPets Trading Card Game Collection",
                        "dev_buyer_fee_basis_points": "0",
                        "dev_seller_fee_basis_points": "1000",
                        "discord_url": null,
                        "display_data": {
                            "card_display_style": "contain"
                        },
                        "external_url": "https://www.bondly.finance/",
                        "featured": false,
                        "featured_image_url": null,
                        "hidden": false,
                        "safelist_request_status": "verified",
                        "image_url": "https://lh3.googleusercontent.com/1PD-sO-BokG4bezW7UrlhW8491Blxv6j5ia5ZmAFUWTqfxNNM4f7B9mWr7mh0SuehCHnIH8rvkIA4Ug-JdS7jLlc60weamJf3Ht8MQ=s120",
                        "is_subject_to_whitelist": false,
                        "large_image_url": "https://lh3.googleusercontent.com/1PD-sO-BokG4bezW7UrlhW8491Blxv6j5ia5ZmAFUWTqfxNNM4f7B9mWr7mh0SuehCHnIH8rvkIA4Ug-JdS7jLlc60weamJf3Ht8MQ",
                        "medium_username": null,
                        "name": "PolkaPets TCG",
                        "only_proxied_transfers": false,
                        "opensea_buyer_fee_basis_points": "0",
                        "opensea_seller_fee_basis_points": "250",
                        "payout_address": "0xdf1dcf94d240798442a681f291321b63d1f0afa3",
                        "require_email": false,
                        "short_description": null,
                        "slug": "polkapets",
                        "telegram_url": null,
                        "twitter_username": "polkapets",
                        "instagram_username": null,
                        "wiki_url": null
                    },
                    "decimals": null,
                    "token_metadata": "https://api.ppw.digital/api/item/4"
                },
                {
                    "id": 21027369,
                    "token_id": "5",
                    "num_sales": 53,
                    "background_color": null,
                    "image_url": "https://lh3.googleusercontent.com/ajgQSStsRH0shCW73-830kfAyPsxIHNAY00Spt7j0uk3QFrzPYlYNex0q6F3W0iW8k8eyXJAp8yNQtvwGaYw7aKGzTdujHAuUzHlVg",
                    "image_preview_url": "https://lh3.googleusercontent.com/ajgQSStsRH0shCW73-830kfAyPsxIHNAY00Spt7j0uk3QFrzPYlYNex0q6F3W0iW8k8eyXJAp8yNQtvwGaYw7aKGzTdujHAuUzHlVg=s250",
                    "image_thumbnail_url": "https://lh3.googleusercontent.com/ajgQSStsRH0shCW73-830kfAyPsxIHNAY00Spt7j0uk3QFrzPYlYNex0q6F3W0iW8k8eyXJAp8yNQtvwGaYw7aKGzTdujHAuUzHlVg=s128",
                    "image_original_url": "https://api.ppw.digital/images/Kylin.png",
                    "animation_url": null,
                    "animation_original_url": null,
                    "name": "Kylin (Flash Fire)",
                    "description": "Personality:\n\nKylin enjoys peaceful environments and loves to meditate. It has an eye for beautiful scenery and is often found in places with a gorgeous landscape.  Artistic and tranquil, Kylin loves to collect flowers and shiny objects.\n\nAbility Desc:\n\nOnce activated, the PolkaPet unleashes a powerful fire generated from its core. This is a high damage attack.\n\nUtility:\n\nGuaranteed free airdrop of 500 KYL; possible future airdrops\n\nVerifiably scarce and limited edition art!\n\nTBD exclusive access and promotions within Kylin Network\n\nAccess to PolkaPets world, the world’s first blockchain-based, collectible monsters game!",
                    "external_link": "https://www.bondly.finance/",
                    "asset_contract": {
                        "address": "0x8cb813bf27dc744fc5fb6ba7515504de45d39e08",
                        "asset_contract_type": "semi-fungible",
                        "created_date": "2021-04-01T19:39:36.438767",
                        "name": "PolkaPets Base Set",
                        "nft_version": null,
                        "opensea_version": null,
                        "owner": 18561537,
                        "schema_name": "ERC1155",
                        "symbol": "PPBS",
                        "total_supply": null,
                        "description": "The Official PolkaPets Trading Card Game Collection",
                        "external_link": "https://www.bondly.finance/",
                        "image_url": "https://lh3.googleusercontent.com/1PD-sO-BokG4bezW7UrlhW8491Blxv6j5ia5ZmAFUWTqfxNNM4f7B9mWr7mh0SuehCHnIH8rvkIA4Ug-JdS7jLlc60weamJf3Ht8MQ=s120",
                        "default_to_fiat": false,
                        "dev_buyer_fee_basis_points": 0,
                        "dev_seller_fee_basis_points": 1000,
                        "only_proxied_transfers": false,
                        "opensea_buyer_fee_basis_points": 0,
                        "opensea_seller_fee_basis_points": 250,
                        "buyer_fee_basis_points": 0,
                        "seller_fee_basis_points": 1250,
                        "payout_address": "0xdf1dcf94d240798442a681f291321b63d1f0afa3"
                    },
                    "owner": {
                        "user": {
                            "username": "NullAddress"
                        },
                        "profile_img_url": "https://storage.googleapis.com/opensea-static/opensea-profile/1.png",
                        "address": "0x0000000000000000000000000000000000000000",
                        "config": "",
                        "discord_id": ""
                    },
                    "permalink": "https://opensea.io/assets/0x8cb813bf27dc744fc5fb6ba7515504de45d39e08/5",
                    "collection": {
                        "banner_image_url": null,
                        "chat_url": null,
                        "created_date": "2021-01-27T02:36:31.308470",
                        "default_to_fiat": false,
                        "description": "The Official PolkaPets Trading Card Game Collection",
                        "dev_buyer_fee_basis_points": "0",
                        "dev_seller_fee_basis_points": "1000",
                        "discord_url": null,
                        "display_data": {
                            "card_display_style": "contain"
                        },
                        "external_url": "https://www.bondly.finance/",
                        "featured": false,
                        "featured_image_url": null,
                        "hidden": false,
                        "safelist_request_status": "verified",
                        "image_url": "https://lh3.googleusercontent.com/1PD-sO-BokG4bezW7UrlhW8491Blxv6j5ia5ZmAFUWTqfxNNM4f7B9mWr7mh0SuehCHnIH8rvkIA4Ug-JdS7jLlc60weamJf3Ht8MQ=s120",
                        "is_subject_to_whitelist": false,
                        "large_image_url": "https://lh3.googleusercontent.com/1PD-sO-BokG4bezW7UrlhW8491Blxv6j5ia5ZmAFUWTqfxNNM4f7B9mWr7mh0SuehCHnIH8rvkIA4Ug-JdS7jLlc60weamJf3Ht8MQ",
                        "medium_username": null,
                        "name": "PolkaPets TCG",
                        "only_proxied_transfers": false,
                        "opensea_buyer_fee_basis_points": "0",
                        "opensea_seller_fee_basis_points": "250",
                        "payout_address": "0xdf1dcf94d240798442a681f291321b63d1f0afa3",
                        "require_email": false,
                        "short_description": null,
                        "slug": "polkapets",
                        "telegram_url": null,
                        "twitter_username": "polkapets",
                        "instagram_username": null,
                        "wiki_url": null
                    },
                    "decimals": null,
                    "token_metadata": "https://api.ppw.digital/api/item/5"
                },
                {
                    "id": 21027371,
                    "token_id": "6",
                    "num_sales": 74,
                    "background_color": null,
                    "image_url": "https://lh3.googleusercontent.com/79RH_aJC3OboNn7ik-Rnq8_kPlUb0hjOkXDMGemblCXteZLChmEjKO9dx9637_A9Tvj1sxS4cjTfEY9-wnjEJlCPUG6O_vymtXb_",
                    "image_preview_url": "https://lh3.googleusercontent.com/79RH_aJC3OboNn7ik-Rnq8_kPlUb0hjOkXDMGemblCXteZLChmEjKO9dx9637_A9Tvj1sxS4cjTfEY9-wnjEJlCPUG6O_vymtXb_=s250",
                    "image_thumbnail_url": "https://lh3.googleusercontent.com/79RH_aJC3OboNn7ik-Rnq8_kPlUb0hjOkXDMGemblCXteZLChmEjKO9dx9637_A9Tvj1sxS4cjTfEY9-wnjEJlCPUG6O_vymtXb_=s128",
                    "image_original_url": "https://api.ppw.digital/images/BSwapA.png",
                    "animation_url": null,
                    "animation_original_url": null,
                    "name": "BondSwap (Ally Swap)",
                    "description": "Personality:\n\nBondSwap is an extremely powerful PolkaPet. They are aggressive by nature and loves a good fight. The fire burning on its forehead and tail keeps it warm and comfortable. \n\nAbility Desc:\n\nThe PolkaPet has the ability to switch between teammates. This is extremely useful when health is running low.\n\nLottery Entry for Next-Gen ‘Evolution’ PolkaPets\n\nLottery Entry for Extra PolkaPets Cards to be Airdropped to Holders\n\nBonus Airdrop of Partner Tokens from Bondly’s NFT Launchpad (Bridge, Kylin, and More)",
                    "external_link": "https://www.bondly.finance/",
                    "asset_contract": {
                        "address": "0x8cb813bf27dc744fc5fb6ba7515504de45d39e08",
                        "asset_contract_type": "semi-fungible",
                        "created_date": "2021-04-01T19:39:36.438767",
                        "name": "PolkaPets Base Set",
                        "nft_version": null,
                        "opensea_version": null,
                        "owner": 18561537,
                        "schema_name": "ERC1155",
                        "symbol": "PPBS",
                        "total_supply": null,
                        "description": "The Official PolkaPets Trading Card Game Collection",
                        "external_link": "https://www.bondly.finance/",
                        "image_url": "https://lh3.googleusercontent.com/1PD-sO-BokG4bezW7UrlhW8491Blxv6j5ia5ZmAFUWTqfxNNM4f7B9mWr7mh0SuehCHnIH8rvkIA4Ug-JdS7jLlc60weamJf3Ht8MQ=s120",
                        "default_to_fiat": false,
                        "dev_buyer_fee_basis_points": 0,
                        "dev_seller_fee_basis_points": 1000,
                        "only_proxied_transfers": false,
                        "opensea_buyer_fee_basis_points": 0,
                        "opensea_seller_fee_basis_points": 250,
                        "buyer_fee_basis_points": 0,
                        "seller_fee_basis_points": 1250,
                        "payout_address": "0xdf1dcf94d240798442a681f291321b63d1f0afa3"
                    },
                    "owner": {
                        "user": {
                            "username": "NullAddress"
                        },
                        "profile_img_url": "https://storage.googleapis.com/opensea-static/opensea-profile/1.png",
                        "address": "0x0000000000000000000000000000000000000000",
                        "config": "",
                        "discord_id": ""
                    },
                    "permalink": "https://opensea.io/assets/0x8cb813bf27dc744fc5fb6ba7515504de45d39e08/6",
                    "collection": {
                        "banner_image_url": null,
                        "chat_url": null,
                        "created_date": "2021-01-27T02:36:31.308470",
                        "default_to_fiat": false,
                        "description": "The Official PolkaPets Trading Card Game Collection",
                        "dev_buyer_fee_basis_points": "0",
                        "dev_seller_fee_basis_points": "1000",
                        "discord_url": null,
                        "display_data": {
                            "card_display_style": "contain"
                        },
                        "external_url": "https://www.bondly.finance/",
                        "featured": false,
                        "featured_image_url": null,
                        "hidden": false,
                        "safelist_request_status": "verified",
                        "image_url": "https://lh3.googleusercontent.com/1PD-sO-BokG4bezW7UrlhW8491Blxv6j5ia5ZmAFUWTqfxNNM4f7B9mWr7mh0SuehCHnIH8rvkIA4Ug-JdS7jLlc60weamJf3Ht8MQ=s120",
                        "is_subject_to_whitelist": false,
                        "large_image_url": "https://lh3.googleusercontent.com/1PD-sO-BokG4bezW7UrlhW8491Blxv6j5ia5ZmAFUWTqfxNNM4f7B9mWr7mh0SuehCHnIH8rvkIA4Ug-JdS7jLlc60weamJf3Ht8MQ",
                        "medium_username": null,
                        "name": "PolkaPets TCG",
                        "only_proxied_transfers": false,
                        "opensea_buyer_fee_basis_points": "0",
                        "opensea_seller_fee_basis_points": "250",
                        "payout_address": "0xdf1dcf94d240798442a681f291321b63d1f0afa3",
                        "require_email": false,
                        "short_description": null,
                        "slug": "polkapets",
                        "telegram_url": null,
                        "twitter_username": "polkapets",
                        "instagram_username": null,
                        "wiki_url": null
                    },
                    "decimals": null,
                    "token_metadata": "https://api.ppw.digital/api/item/6"
                },
                {
                    "id": 21027376,
                    "token_id": "10",
                    "num_sales": 61,
                    "background_color": null,
                    "image_url": "https://lh3.googleusercontent.com/FwgLIyfaCvtPVaQQWP9FM4Lw33QPmkNJVpsSnZbH1gK_jvwbrAowCPZ7vyRLf-jAcDacWB5AGlUclYA8_bT0Z9exgDfqZksMH0K4Mw",
                    "image_preview_url": "https://lh3.googleusercontent.com/FwgLIyfaCvtPVaQQWP9FM4Lw33QPmkNJVpsSnZbH1gK_jvwbrAowCPZ7vyRLf-jAcDacWB5AGlUclYA8_bT0Z9exgDfqZksMH0K4Mw=s250",
                    "image_thumbnail_url": "https://lh3.googleusercontent.com/FwgLIyfaCvtPVaQQWP9FM4Lw33QPmkNJVpsSnZbH1gK_jvwbrAowCPZ7vyRLf-jAcDacWB5AGlUclYA8_bT0Z9exgDfqZksMH0K4Mw=s128",
                    "image_original_url": "https://api.ppw.digital/images/Phala.png",
                    "animation_url": null,
                    "animation_original_url": null,
                    "name": "Phala (Shadow Nexus)",
                    "description": "Personality:\n\nPhala, if you have the chance of finding it, is extremely reliable, yet reserved. This particular PolkaPet loves dark places and digging. Maybe you’ll see it pop its head out from the ground if you’re lucky. They are quick executors and see their projects to the end. \n\nAbility Desc:\n\nCan move around other PolkaPet stealthily without being detected and unleash a surprise attack.\n\nUtility:\n\nPriority access to the first batch of pBridges! Phala’s PolkaPet will reduce your costs when transferring other blockchain assets into Phala\n\nAs a VIP of the Phala community, you will have bonus perks in many Phala community campaigns! This includes MODs, volunteers, TEE test events, testnet events\n\nYou’ll be invited to first-round trials of many Phala-based products! These include Web3 Analytics, pDiem, pBTC/pDOGE/pBTG, Darkpool\n\nYou’ll get airdrops for many future NFTs/tokens built on Phala Network",
                    "external_link": "https://www.bondly.finance/",
                    "asset_contract": {
                        "address": "0x8cb813bf27dc744fc5fb6ba7515504de45d39e08",
                        "asset_contract_type": "semi-fungible",
                        "created_date": "2021-04-01T19:39:36.438767",
                        "name": "PolkaPets Base Set",
                        "nft_version": null,
                        "opensea_version": null,
                        "owner": 18561537,
                        "schema_name": "ERC1155",
                        "symbol": "PPBS",
                        "total_supply": null,
                        "description": "The Official PolkaPets Trading Card Game Collection",
                        "external_link": "https://www.bondly.finance/",
                        "image_url": "https://lh3.googleusercontent.com/1PD-sO-BokG4bezW7UrlhW8491Blxv6j5ia5ZmAFUWTqfxNNM4f7B9mWr7mh0SuehCHnIH8rvkIA4Ug-JdS7jLlc60weamJf3Ht8MQ=s120",
                        "default_to_fiat": false,
                        "dev_buyer_fee_basis_points": 0,
                        "dev_seller_fee_basis_points": 1000,
                        "only_proxied_transfers": false,
                        "opensea_buyer_fee_basis_points": 0,
                        "opensea_seller_fee_basis_points": 250,
                        "buyer_fee_basis_points": 0,
                        "seller_fee_basis_points": 1250,
                        "payout_address": "0xdf1dcf94d240798442a681f291321b63d1f0afa3"
                    },
                    "owner": {
                        "user": {
                            "username": "NullAddress"
                        },
                        "profile_img_url": "https://storage.googleapis.com/opensea-static/opensea-profile/1.png",
                        "address": "0x0000000000000000000000000000000000000000",
                        "config": "",
                        "discord_id": ""
                    },
                    "permalink": "https://opensea.io/assets/0x8cb813bf27dc744fc5fb6ba7515504de45d39e08/10",
                    "collection": {
                        "banner_image_url": null,
                        "chat_url": null,
                        "created_date": "2021-01-27T02:36:31.308470",
                        "default_to_fiat": false,
                        "description": "The Official PolkaPets Trading Card Game Collection",
                        "dev_buyer_fee_basis_points": "0",
                        "dev_seller_fee_basis_points": "1000",
                        "discord_url": null,
                        "display_data": {
                            "card_display_style": "contain"
                        },
                        "external_url": "https://www.bondly.finance/",
                        "featured": false,
                        "featured_image_url": null,
                        "hidden": false,
                        "safelist_request_status": "verified",
                        "image_url": "https://lh3.googleusercontent.com/1PD-sO-BokG4bezW7UrlhW8491Blxv6j5ia5ZmAFUWTqfxNNM4f7B9mWr7mh0SuehCHnIH8rvkIA4Ug-JdS7jLlc60weamJf3Ht8MQ=s120",
                        "is_subject_to_whitelist": false,
                        "large_image_url": "https://lh3.googleusercontent.com/1PD-sO-BokG4bezW7UrlhW8491Blxv6j5ia5ZmAFUWTqfxNNM4f7B9mWr7mh0SuehCHnIH8rvkIA4Ug-JdS7jLlc60weamJf3Ht8MQ",
                        "medium_username": null,
                        "name": "PolkaPets TCG",
                        "only_proxied_transfers": false,
                        "opensea_buyer_fee_basis_points": "0",
                        "opensea_seller_fee_basis_points": "250",
                        "payout_address": "0xdf1dcf94d240798442a681f291321b63d1f0afa3",
                        "require_email": false,
                        "short_description": null,
                        "slug": "polkapets",
                        "telegram_url": null,
                        "twitter_username": "polkapets",
                        "instagram_username": null,
                        "wiki_url": null
                    },
                    "decimals": null,
                    "token_metadata": "https://api.ppw.digital/api/item/10"
                },
                {
                    "id": 21027380,
                    "token_id": "13",
                    "num_sales": 62,
                    "background_color": null,
                    "image_url": "https://lh3.googleusercontent.com/190mR6tQmXKOGZu-E3OuNVBOJgqSn7mrq8Gcl9mplgK05XdlbRGaevzQKI78e7-YN6L9-vuUyzU-NiofO-rswhKn-Bnf-DF4bfny1w",
                    "image_preview_url": "https://lh3.googleusercontent.com/190mR6tQmXKOGZu-E3OuNVBOJgqSn7mrq8Gcl9mplgK05XdlbRGaevzQKI78e7-YN6L9-vuUyzU-NiofO-rswhKn-Bnf-DF4bfny1w=s250",
                    "image_thumbnail_url": "https://lh3.googleusercontent.com/190mR6tQmXKOGZu-E3OuNVBOJgqSn7mrq8Gcl9mplgK05XdlbRGaevzQKI78e7-YN6L9-vuUyzU-NiofO-rswhKn-Bnf-DF4bfny1w=s128",
                    "image_original_url": "https://api.ppw.digital/images/BondDex.png",
                    "animation_url": null,
                    "animation_original_url": null,
                    "name": "BondDex (Adapt)",
                    "description": "Personality:\n\nBondDex is a very cunning PolkaPet. They always figure out the plan of action and move fast to solve problems. They are very fond of puzzles. Calculating and resilient, BondDex can connect things and figure out the right solution. BondDex has sharp spikes on its back to protect itself and uses it to cut down vegetation that stands in its way.   \n\nAbility Desc:\n\nA special psychic attack. Changes element type to be the most effective against the foe.\n\nUtility:\n\nAccess to the Beta of BondDex before it goes live\n\nLottery Entry for Next-Gen ‘Evolution’ PolkaPets\n\nLottery Entry for Extra PolkaPets Cards to be Airdropped to Holders\n\nBonus Airdrop of Partner Tokens from Bondly’s NFT Launchpad (Bridge, Kylin, and More)",
                    "external_link": "https://www.bondly.finance/",
                    "asset_contract": {
                        "address": "0x8cb813bf27dc744fc5fb6ba7515504de45d39e08",
                        "asset_contract_type": "semi-fungible",
                        "created_date": "2021-04-01T19:39:36.438767",
                        "name": "PolkaPets Base Set",
                        "nft_version": null,
                        "opensea_version": null,
                        "owner": 18561537,
                        "schema_name": "ERC1155",
                        "symbol": "PPBS",
                        "total_supply": null,
                        "description": "The Official PolkaPets Trading Card Game Collection",
                        "external_link": "https://www.bondly.finance/",
                        "image_url": "https://lh3.googleusercontent.com/1PD-sO-BokG4bezW7UrlhW8491Blxv6j5ia5ZmAFUWTqfxNNM4f7B9mWr7mh0SuehCHnIH8rvkIA4Ug-JdS7jLlc60weamJf3Ht8MQ=s120",
                        "default_to_fiat": false,
                        "dev_buyer_fee_basis_points": 0,
                        "dev_seller_fee_basis_points": 1000,
                        "only_proxied_transfers": false,
                        "opensea_buyer_fee_basis_points": 0,
                        "opensea_seller_fee_basis_points": 250,
                        "buyer_fee_basis_points": 0,
                        "seller_fee_basis_points": 1250,
                        "payout_address": "0xdf1dcf94d240798442a681f291321b63d1f0afa3"
                    },
                    "owner": {
                        "user": {
                            "username": "NullAddress"
                        },
                        "profile_img_url": "https://storage.googleapis.com/opensea-static/opensea-profile/1.png",
                        "address": "0x0000000000000000000000000000000000000000",
                        "config": "",
                        "discord_id": ""
                    },
                    "permalink": "https://opensea.io/assets/0x8cb813bf27dc744fc5fb6ba7515504de45d39e08/13",
                    "collection": {
                        "banner_image_url": null,
                        "chat_url": null,
                        "created_date": "2021-01-27T02:36:31.308470",
                        "default_to_fiat": false,
                        "description": "The Official PolkaPets Trading Card Game Collection",
                        "dev_buyer_fee_basis_points": "0",
                        "dev_seller_fee_basis_points": "1000",
                        "discord_url": null,
                        "display_data": {
                            "card_display_style": "contain"
                        },
                        "external_url": "https://www.bondly.finance/",
                        "featured": false,
                        "featured_image_url": null,
                        "hidden": false,
                        "safelist_request_status": "verified",
                        "image_url": "https://lh3.googleusercontent.com/1PD-sO-BokG4bezW7UrlhW8491Blxv6j5ia5ZmAFUWTqfxNNM4f7B9mWr7mh0SuehCHnIH8rvkIA4Ug-JdS7jLlc60weamJf3Ht8MQ=s120",
                        "is_subject_to_whitelist": false,
                        "large_image_url": "https://lh3.googleusercontent.com/1PD-sO-BokG4bezW7UrlhW8491Blxv6j5ia5ZmAFUWTqfxNNM4f7B9mWr7mh0SuehCHnIH8rvkIA4Ug-JdS7jLlc60weamJf3Ht8MQ",
                        "medium_username": null,
                        "name": "PolkaPets TCG",
                        "only_proxied_transfers": false,
                        "opensea_buyer_fee_basis_points": "0",
                        "opensea_seller_fee_basis_points": "250",
                        "payout_address": "0xdf1dcf94d240798442a681f291321b63d1f0afa3",
                        "require_email": false,
                        "short_description": null,
                        "slug": "polkapets",
                        "telegram_url": null,
                        "twitter_username": "polkapets",
                        "instagram_username": null,
                        "wiki_url": null
                    },
                    "decimals": null,
                    "token_metadata": "https://api.ppw.digital/api/item/13"
                },
                {
                    "id": 21027382,
                    "token_id": "15",
                    "num_sales": 59,
                    "background_color": null,
                    "image_url": "https://lh3.googleusercontent.com/dOwYRsMVS5tJDGdQwUgBzq-B3rWymjUsg1YssciylTIsbqDqEyQSy5aQEp_xD0upgNzi3J5Lgb-NXKFSoC7iO0GvePKP2okb6Ce5bg",
                    "image_preview_url": "https://lh3.googleusercontent.com/dOwYRsMVS5tJDGdQwUgBzq-B3rWymjUsg1YssciylTIsbqDqEyQSy5aQEp_xD0upgNzi3J5Lgb-NXKFSoC7iO0GvePKP2okb6Ce5bg=s250",
                    "image_thumbnail_url": "https://lh3.googleusercontent.com/dOwYRsMVS5tJDGdQwUgBzq-B3rWymjUsg1YssciylTIsbqDqEyQSy5aQEp_xD0upgNzi3J5Lgb-NXKFSoC7iO0GvePKP2okb6Ce5bg=s128",
                    "image_original_url": "https://api.ppw.digital/images/Crust.png",
                    "animation_url": null,
                    "animation_original_url": null,
                    "name": "Crust (Fire Cloud)",
                    "description": "Personality:\n\nCrust is extremely efficient and fast. They are serious by nature and get right down to business. They pride themselves on being highly motivated and being able to get things done with speed and precision.\n\nAbility Desc:\n\nPolkaPet unleashes a smothering storm of fire upon its opponent.\n\nUtility:\n\nAs we all know, the crypto verse moves incredibly quickly and is backed by huge demand. We understand not everyone will have the opportunity to whitelist or form part of our public sales prior to DEX listing.\n\nWe also believe in the value and fun the NFT space has to offer which is why utility does not just stop at token airdrops!\n\nSpecial badge on Crust Apps\n\nAccess to VIP online and offline events, including airdrops and other special activities\n\nMore utilities will be announced over time!",
                    "external_link": "https://www.bondly.finance/",
                    "asset_contract": {
                        "address": "0x8cb813bf27dc744fc5fb6ba7515504de45d39e08",
                        "asset_contract_type": "semi-fungible",
                        "created_date": "2021-04-01T19:39:36.438767",
                        "name": "PolkaPets Base Set",
                        "nft_version": null,
                        "opensea_version": null,
                        "owner": 18561537,
                        "schema_name": "ERC1155",
                        "symbol": "PPBS",
                        "total_supply": null,
                        "description": "The Official PolkaPets Trading Card Game Collection",
                        "external_link": "https://www.bondly.finance/",
                        "image_url": "https://lh3.googleusercontent.com/1PD-sO-BokG4bezW7UrlhW8491Blxv6j5ia5ZmAFUWTqfxNNM4f7B9mWr7mh0SuehCHnIH8rvkIA4Ug-JdS7jLlc60weamJf3Ht8MQ=s120",
                        "default_to_fiat": false,
                        "dev_buyer_fee_basis_points": 0,
                        "dev_seller_fee_basis_points": 1000,
                        "only_proxied_transfers": false,
                        "opensea_buyer_fee_basis_points": 0,
                        "opensea_seller_fee_basis_points": 250,
                        "buyer_fee_basis_points": 0,
                        "seller_fee_basis_points": 1250,
                        "payout_address": "0xdf1dcf94d240798442a681f291321b63d1f0afa3"
                    },
                    "owner": {
                        "user": {
                            "username": "NullAddress"
                        },
                        "profile_img_url": "https://storage.googleapis.com/opensea-static/opensea-profile/1.png",
                        "address": "0x0000000000000000000000000000000000000000",
                        "config": "",
                        "discord_id": ""
                    },
                    "permalink": "https://opensea.io/assets/0x8cb813bf27dc744fc5fb6ba7515504de45d39e08/15",
                    "collection": {
                        "banner_image_url": null,
                        "chat_url": null,
                        "created_date": "2021-01-27T02:36:31.308470",
                        "default_to_fiat": false,
                        "description": "The Official PolkaPets Trading Card Game Collection",
                        "dev_buyer_fee_basis_points": "0",
                        "dev_seller_fee_basis_points": "1000",
                        "discord_url": null,
                        "display_data": {
                            "card_display_style": "contain"
                        },
                        "external_url": "https://www.bondly.finance/",
                        "featured": false,
                        "featured_image_url": null,
                        "hidden": false,
                        "safelist_request_status": "verified",
                        "image_url": "https://lh3.googleusercontent.com/1PD-sO-BokG4bezW7UrlhW8491Blxv6j5ia5ZmAFUWTqfxNNM4f7B9mWr7mh0SuehCHnIH8rvkIA4Ug-JdS7jLlc60weamJf3Ht8MQ=s120",
                        "is_subject_to_whitelist": false,
                        "large_image_url": "https://lh3.googleusercontent.com/1PD-sO-BokG4bezW7UrlhW8491Blxv6j5ia5ZmAFUWTqfxNNM4f7B9mWr7mh0SuehCHnIH8rvkIA4Ug-JdS7jLlc60weamJf3Ht8MQ",
                        "medium_username": null,
                        "name": "PolkaPets TCG",
                        "only_proxied_transfers": false,
                        "opensea_buyer_fee_basis_points": "0",
                        "opensea_seller_fee_basis_points": "250",
                        "payout_address": "0xdf1dcf94d240798442a681f291321b63d1f0afa3",
                        "require_email": false,
                        "short_description": null,
                        "slug": "polkapets",
                        "telegram_url": null,
                        "twitter_username": "polkapets",
                        "instagram_username": null,
                        "wiki_url": null
                    },
                    "decimals": null,
                    "token_metadata": "https://api.ppw.digital/api/item/15"
                },
                {
                    "id": 21027384,
                    "token_id": "16",
                    "num_sales": 46,
                    "background_color": null,
                    "image_url": "https://lh3.googleusercontent.com/sAqH47xZTvmpRvsQNbv9k5BxzMkxlQWLu8Wn907TXQi10cemmYTbs5bgJur0cr2KVMvt8dZa6eTAwXBhNryM7SWM2naNJXj3gp_K-A",
                    "image_preview_url": "https://lh3.googleusercontent.com/sAqH47xZTvmpRvsQNbv9k5BxzMkxlQWLu8Wn907TXQi10cemmYTbs5bgJur0cr2KVMvt8dZa6eTAwXBhNryM7SWM2naNJXj3gp_K-A=s250",
                    "image_thumbnail_url": "https://lh3.googleusercontent.com/sAqH47xZTvmpRvsQNbv9k5BxzMkxlQWLu8Wn907TXQi10cemmYTbs5bgJur0cr2KVMvt8dZa6eTAwXBhNryM7SWM2naNJXj3gp_K-A=s128",
                    "image_original_url": "https://api.ppw.digital/images/Wing.png",
                    "animation_url": null,
                    "animation_original_url": null,
                    "name": "WING (Flash Gust)",
                    "description": "Personality:\n\nWING loves to glide in high places. It is often found cruising through environments with a lot of wind. Adventurous, thrilling, and extroverted, WING loves to glide into new areas and make friends with the locals. They do not tend to stay in one place for long as they are nomadic and follow where the good weather is.\n\nAbility Desc:\n\nA chilling and sharp gust of wind is generated through Wing's powerful steel wings.\n\nUtility:\n\nFor Wing:  A new sub-community in the Wing ecosystem governed by your NFT\n\nA portion of the proceeds collected from the initial sale will be used to buy back pWING and be pooled into a community treasury.\n\nWing PolkaPet owners will be able to vote on the usage of these funds, whether it be airdropping them, burning them, or setting up yield farms to stake your PolkaPets and earn pWING.\n\nFor Ontology: Link your PolkaPet to your ONT ID and add it to your decentralized identity profile.\n\nEarly access to discuss and give feedback on Ontology's NFT initiatives.\n\nOn Ethereum: Access an exclusive permissioned chat for Wing PolkaPet owners powered by Collab.Land\n\nTokenize your PolkaPet through projects like NFT20.io\n\n..and additional utility on Polkadot!",
                    "external_link": "https://www.bondly.finance/",
                    "asset_contract": {
                        "address": "0x8cb813bf27dc744fc5fb6ba7515504de45d39e08",
                        "asset_contract_type": "semi-fungible",
                        "created_date": "2021-04-01T19:39:36.438767",
                        "name": "PolkaPets Base Set",
                        "nft_version": null,
                        "opensea_version": null,
                        "owner": 18561537,
                        "schema_name": "ERC1155",
                        "symbol": "PPBS",
                        "total_supply": null,
                        "description": "The Official PolkaPets Trading Card Game Collection",
                        "external_link": "https://www.bondly.finance/",
                        "image_url": "https://lh3.googleusercontent.com/1PD-sO-BokG4bezW7UrlhW8491Blxv6j5ia5ZmAFUWTqfxNNM4f7B9mWr7mh0SuehCHnIH8rvkIA4Ug-JdS7jLlc60weamJf3Ht8MQ=s120",
                        "default_to_fiat": false,
                        "dev_buyer_fee_basis_points": 0,
                        "dev_seller_fee_basis_points": 1000,
                        "only_proxied_transfers": false,
                        "opensea_buyer_fee_basis_points": 0,
                        "opensea_seller_fee_basis_points": 250,
                        "buyer_fee_basis_points": 0,
                        "seller_fee_basis_points": 1250,
                        "payout_address": "0xdf1dcf94d240798442a681f291321b63d1f0afa3"
                    },
                    "owner": {
                        "user": {
                            "username": "NullAddress"
                        },
                        "profile_img_url": "https://storage.googleapis.com/opensea-static/opensea-profile/1.png",
                        "address": "0x0000000000000000000000000000000000000000",
                        "config": "",
                        "discord_id": ""
                    },
                    "permalink": "https://opensea.io/assets/0x8cb813bf27dc744fc5fb6ba7515504de45d39e08/16",
                    "collection": {
                        "banner_image_url": null,
                        "chat_url": null,
                        "created_date": "2021-01-27T02:36:31.308470",
                        "default_to_fiat": false,
                        "description": "The Official PolkaPets Trading Card Game Collection",
                        "dev_buyer_fee_basis_points": "0",
                        "dev_seller_fee_basis_points": "1000",
                        "discord_url": null,
                        "display_data": {
                            "card_display_style": "contain"
                        },
                        "external_url": "https://www.bondly.finance/",
                        "featured": false,
                        "featured_image_url": null,
                        "hidden": false,
                        "safelist_request_status": "verified",
                        "image_url": "https://lh3.googleusercontent.com/1PD-sO-BokG4bezW7UrlhW8491Blxv6j5ia5ZmAFUWTqfxNNM4f7B9mWr7mh0SuehCHnIH8rvkIA4Ug-JdS7jLlc60weamJf3Ht8MQ=s120",
                        "is_subject_to_whitelist": false,
                        "large_image_url": "https://lh3.googleusercontent.com/1PD-sO-BokG4bezW7UrlhW8491Blxv6j5ia5ZmAFUWTqfxNNM4f7B9mWr7mh0SuehCHnIH8rvkIA4Ug-JdS7jLlc60weamJf3Ht8MQ",
                        "medium_username": null,
                        "name": "PolkaPets TCG",
                        "only_proxied_transfers": false,
                        "opensea_buyer_fee_basis_points": "0",
                        "opensea_seller_fee_basis_points": "250",
                        "payout_address": "0xdf1dcf94d240798442a681f291321b63d1f0afa3",
                        "require_email": false,
                        "short_description": null,
                        "slug": "polkapets",
                        "telegram_url": null,
                        "twitter_username": "polkapets",
                        "instagram_username": null,
                        "wiki_url": null
                    },
                    "decimals": null,
                    "token_metadata": "https://api.ppw.digital/api/item/16"
                },
                {
                    "id": 21027385,
                    "token_id": "17",
                    "num_sales": 93,
                    "background_color": null,
                    "image_url": "https://lh3.googleusercontent.com/m3Rq5oTOGSy3jl_PIkAbJbZn-OM3-dViczVVz1b6oZjgbo5KU0yqRCi6KSlQvxAM2bJAjfyetBLlBqziltQFpmLhAIVNnbaijS5DYg",
                    "image_preview_url": "https://lh3.googleusercontent.com/m3Rq5oTOGSy3jl_PIkAbJbZn-OM3-dViczVVz1b6oZjgbo5KU0yqRCi6KSlQvxAM2bJAjfyetBLlBqziltQFpmLhAIVNnbaijS5DYg=s250",
                    "image_thumbnail_url": "https://lh3.googleusercontent.com/m3Rq5oTOGSy3jl_PIkAbJbZn-OM3-dViczVVz1b6oZjgbo5KU0yqRCi6KSlQvxAM2bJAjfyetBLlBqziltQFpmLhAIVNnbaijS5DYg=s128",
                    "image_original_url": "https://api.ppw.digital/images/Trustbase.png",
                    "animation_url": null,
                    "animation_original_url": null,
                    "name": "Trust Base (Time Warp)",
                    "description": "Personality:\n\nTrust Base loves a good challenge. It is often found climbing the tallest trees and lifting the heaviest rocks. Adventurous, bold, and competitive, Trust Base has a need to set physical goals for itself. They enjoy working out and building things, so it is no surprise that Trust Base can pack a powerful punch.  They do not bode well in places with empty areas.\n\nAbility Desc:\n\nA concentrated energy is gathered at Trust Base’s palm before charging up and shooting at its opponent. The shot is more powerful than 100 punches.\n\nUtility:\n\nEach NFT includes 1024 airdropped TBE tokens\n\nReceive annual rewards from the TrustBase treasury: 20%\n\nA new generation of BondSwap PolkaPets — ”Evolved” lottery\n\nAs a VIP of the TrustBase community, you will have the opportunity to be invited to participate in various community activities based on TrustBase and developer-related products (such as Tinder Recruitment of TrustBase, CC2 testing, hackathon, developer training camp, etc.)\n\nYou will be invited to participate in the first round of trials of various Web3 network components developed based on Subscript (including but not limited to programming tools, DeFi, Dapp)\n\nYou will get airdrops of NFT/tokens created by many future developers built on TrustBase\n\nBondSwap lottery certificate for 10 additional TrustBase cards airdropped to the holder\n\nDigitally verified limited edition art collection",
                    "external_link": "https://www.bondly.finance/",
                    "asset_contract": {
                        "address": "0x8cb813bf27dc744fc5fb6ba7515504de45d39e08",
                        "asset_contract_type": "semi-fungible",
                        "created_date": "2021-04-01T19:39:36.438767",
                        "name": "PolkaPets Base Set",
                        "nft_version": null,
                        "opensea_version": null,
                        "owner": 18561537,
                        "schema_name": "ERC1155",
                        "symbol": "PPBS",
                        "total_supply": null,
                        "description": "The Official PolkaPets Trading Card Game Collection",
                        "external_link": "https://www.bondly.finance/",
                        "image_url": "https://lh3.googleusercontent.com/1PD-sO-BokG4bezW7UrlhW8491Blxv6j5ia5ZmAFUWTqfxNNM4f7B9mWr7mh0SuehCHnIH8rvkIA4Ug-JdS7jLlc60weamJf3Ht8MQ=s120",
                        "default_to_fiat": false,
                        "dev_buyer_fee_basis_points": 0,
                        "dev_seller_fee_basis_points": 1000,
                        "only_proxied_transfers": false,
                        "opensea_buyer_fee_basis_points": 0,
                        "opensea_seller_fee_basis_points": 250,
                        "buyer_fee_basis_points": 0,
                        "seller_fee_basis_points": 1250,
                        "payout_address": "0xdf1dcf94d240798442a681f291321b63d1f0afa3"
                    },
                    "owner": {
                        "user": {
                            "username": "NullAddress"
                        },
                        "profile_img_url": "https://storage.googleapis.com/opensea-static/opensea-profile/1.png",
                        "address": "0x0000000000000000000000000000000000000000",
                        "config": "",
                        "discord_id": ""
                    },
                    "permalink": "https://opensea.io/assets/0x8cb813bf27dc744fc5fb6ba7515504de45d39e08/17",
                    "collection": {
                        "banner_image_url": null,
                        "chat_url": null,
                        "created_date": "2021-01-27T02:36:31.308470",
                        "default_to_fiat": false,
                        "description": "The Official PolkaPets Trading Card Game Collection",
                        "dev_buyer_fee_basis_points": "0",
                        "dev_seller_fee_basis_points": "1000",
                        "discord_url": null,
                        "display_data": {
                            "card_display_style": "contain"
                        },
                        "external_url": "https://www.bondly.finance/",
                        "featured": false,
                        "featured_image_url": null,
                        "hidden": false,
                        "safelist_request_status": "verified",
                        "image_url": "https://lh3.googleusercontent.com/1PD-sO-BokG4bezW7UrlhW8491Blxv6j5ia5ZmAFUWTqfxNNM4f7B9mWr7mh0SuehCHnIH8rvkIA4Ug-JdS7jLlc60weamJf3Ht8MQ=s120",
                        "is_subject_to_whitelist": false,
                        "large_image_url": "https://lh3.googleusercontent.com/1PD-sO-BokG4bezW7UrlhW8491Blxv6j5ia5ZmAFUWTqfxNNM4f7B9mWr7mh0SuehCHnIH8rvkIA4Ug-JdS7jLlc60weamJf3Ht8MQ",
                        "medium_username": null,
                        "name": "PolkaPets TCG",
                        "only_proxied_transfers": false,
                        "opensea_buyer_fee_basis_points": "0",
                        "opensea_seller_fee_basis_points": "250",
                        "payout_address": "0xdf1dcf94d240798442a681f291321b63d1f0afa3",
                        "require_email": false,
                        "short_description": null,
                        "slug": "polkapets",
                        "telegram_url": null,
                        "twitter_username": "polkapets",
                        "instagram_username": null,
                        "wiki_url": null
                    },
                    "decimals": null,
                    "token_metadata": "https://api.ppw.digital/api/item/17"
                },
                {
                    "id": 21027386,
                    "token_id": "18",
                    "num_sales": 92,
                    "background_color": null,
                    "image_url": "https://lh3.googleusercontent.com/DeD41BVm0ll_YsvAe-MXwCdg-ugX0G45Ci2E4GlB_zLYPQhYAK-E36mCPtvDWJqm2YS1q-3ov2oOPU_PkIeMR4YkDNeOvsLu85_NDyw",
                    "image_preview_url": "https://lh3.googleusercontent.com/DeD41BVm0ll_YsvAe-MXwCdg-ugX0G45Ci2E4GlB_zLYPQhYAK-E36mCPtvDWJqm2YS1q-3ov2oOPU_PkIeMR4YkDNeOvsLu85_NDyw=s250",
                    "image_thumbnail_url": "https://lh3.googleusercontent.com/DeD41BVm0ll_YsvAe-MXwCdg-ugX0G45Ci2E4GlB_zLYPQhYAK-E36mCPtvDWJqm2YS1q-3ov2oOPU_PkIeMR4YkDNeOvsLu85_NDyw=s128",
                    "image_original_url": "https://api.ppw.digital/images/Plasm.png",
                    "animation_url": null,
                    "animation_original_url": null,
                    "name": "Plasm (Double Shock)",
                    "description": "Personality:\n\nPlasm is community driven and fast with high capacity. They are quite powerful and love to eat spicy berries. Despite their strength, Plasm tries to avoid fights when they can. Once angered, their eyes will glow blue with electricity. Plasm loves adventure and does not stay in one place for long.\n\nAbility Desc:\n\nJolts of electricity are targeted at the opponent, giving them a painful shock. \n\nUtility:\n\nYou will own a limited edition Plasm NFT art-card! \n\nTBD exclusive VIP benefits within Plasm Network. \n\nAll holders will be notified about the VIP benefits in time. \n\nBe part of the exclusive PolkaPets world, the world’s first blockchain-based, collectible monsters game, and get extra in-game power.",
                    "external_link": "https://www.bondly.finance/",
                    "asset_contract": {
                        "address": "0x8cb813bf27dc744fc5fb6ba7515504de45d39e08",
                        "asset_contract_type": "semi-fungible",
                        "created_date": "2021-04-01T19:39:36.438767",
                        "name": "PolkaPets Base Set",
                        "nft_version": null,
                        "opensea_version": null,
                        "owner": 18561537,
                        "schema_name": "ERC1155",
                        "symbol": "PPBS",
                        "total_supply": null,
                        "description": "The Official PolkaPets Trading Card Game Collection",
                        "external_link": "https://www.bondly.finance/",
                        "image_url": "https://lh3.googleusercontent.com/1PD-sO-BokG4bezW7UrlhW8491Blxv6j5ia5ZmAFUWTqfxNNM4f7B9mWr7mh0SuehCHnIH8rvkIA4Ug-JdS7jLlc60weamJf3Ht8MQ=s120",
                        "default_to_fiat": false,
                        "dev_buyer_fee_basis_points": 0,
                        "dev_seller_fee_basis_points": 1000,
                        "only_proxied_transfers": false,
                        "opensea_buyer_fee_basis_points": 0,
                        "opensea_seller_fee_basis_points": 250,
                        "buyer_fee_basis_points": 0,
                        "seller_fee_basis_points": 1250,
                        "payout_address": "0xdf1dcf94d240798442a681f291321b63d1f0afa3"
                    },
                    "owner": {
                        "user": {
                            "username": "NullAddress"
                        },
                        "profile_img_url": "https://storage.googleapis.com/opensea-static/opensea-profile/1.png",
                        "address": "0x0000000000000000000000000000000000000000",
                        "config": "",
                        "discord_id": ""
                    },
                    "permalink": "https://opensea.io/assets/0x8cb813bf27dc744fc5fb6ba7515504de45d39e08/18",
                    "collection": {
                        "banner_image_url": null,
                        "chat_url": null,
                        "created_date": "2021-01-27T02:36:31.308470",
                        "default_to_fiat": false,
                        "description": "The Official PolkaPets Trading Card Game Collection",
                        "dev_buyer_fee_basis_points": "0",
                        "dev_seller_fee_basis_points": "1000",
                        "discord_url": null,
                        "display_data": {
                            "card_display_style": "contain"
                        },
                        "external_url": "https://www.bondly.finance/",
                        "featured": false,
                        "featured_image_url": null,
                        "hidden": false,
                        "safelist_request_status": "verified",
                        "image_url": "https://lh3.googleusercontent.com/1PD-sO-BokG4bezW7UrlhW8491Blxv6j5ia5ZmAFUWTqfxNNM4f7B9mWr7mh0SuehCHnIH8rvkIA4Ug-JdS7jLlc60weamJf3Ht8MQ=s120",
                        "is_subject_to_whitelist": false,
                        "large_image_url": "https://lh3.googleusercontent.com/1PD-sO-BokG4bezW7UrlhW8491Blxv6j5ia5ZmAFUWTqfxNNM4f7B9mWr7mh0SuehCHnIH8rvkIA4Ug-JdS7jLlc60weamJf3Ht8MQ",
                        "medium_username": null,
                        "name": "PolkaPets TCG",
                        "only_proxied_transfers": false,
                        "opensea_buyer_fee_basis_points": "0",
                        "opensea_seller_fee_basis_points": "250",
                        "payout_address": "0xdf1dcf94d240798442a681f291321b63d1f0afa3",
                        "require_email": false,
                        "short_description": null,
                        "slug": "polkapets",
                        "telegram_url": null,
                        "twitter_username": "polkapets",
                        "instagram_username": null,
                        "wiki_url": null
                    },
                    "decimals": null,
                    "token_metadata": "https://api.ppw.digital/api/item/18"
                },
                {
                    "id": 21027389,
                    "token_id": "20",
                    "num_sales": 74,
                    "background_color": null,
                    "image_url": "https://lh3.googleusercontent.com/diq3lw4vFWgNgnDaDvSghbr-bOm-3kFoY_meBUHKRfPVZTvqeuu95dTvgreXPPf8WtUcWDUR1H8Sq6Jh7v_mCfkXF6p1k8C4MnoU",
                    "image_preview_url": "https://lh3.googleusercontent.com/diq3lw4vFWgNgnDaDvSghbr-bOm-3kFoY_meBUHKRfPVZTvqeuu95dTvgreXPPf8WtUcWDUR1H8Sq6Jh7v_mCfkXF6p1k8C4MnoU=s250",
                    "image_thumbnail_url": "https://lh3.googleusercontent.com/diq3lw4vFWgNgnDaDvSghbr-bOm-3kFoY_meBUHKRfPVZTvqeuu95dTvgreXPPf8WtUcWDUR1H8Sq6Jh7v_mCfkXF6p1k8C4MnoU=s128",
                    "image_original_url": "https://api.ppw.digital/images/Crab.png",
                    "animation_url": null,
                    "animation_original_url": null,
                    "name": "Crab (Hydrorupt)",
                    "description": "Personality:\n\nCrab is nature loving and enjoys burying itself under dirt and mud to take naps. Its legs allow it to dig fast to hide from predators. Chirpy, peaceful, and innocent, Crab brings a smile to everyone's faces. It prides themselves on being able to build the best sandcastle in town.\n\nAbility Desc:\n\nA tornado of swirling water is aimed at the opponent.\n\nUtility:\n\nUtility within Darwinia's flagship cross-chain game, Evolution Land New Crab Continent: Treated as an Apostle's pet and boost mining productivity and efficiency and Treated as a Warrior's pet and boost fighting power in the coming war gameplay\n\nCrab's Kusama parachain auction PLO Rewards utility: Adding the drop rate of the Mystery NFT Prize\n\nDarwinia ecosystem utility: Recognized as VIP user status, Enjoy benefits provided by ecosystem applications, Use PolkaPet as earliest use cases when bridge open NFT cross-chain transfer\n\nDarwinia Builders Program utility: If you are Web3.0 developers holding Crab NFT, you can enjoy the following utilities: Be selected to join Darwinia Builders Program and enjoy VIP tech guidance from the Darwinia Dev Team",
                    "external_link": "https://www.bondly.finance/",
                    "asset_contract": {
                        "address": "0x8cb813bf27dc744fc5fb6ba7515504de45d39e08",
                        "asset_contract_type": "semi-fungible",
                        "created_date": "2021-04-01T19:39:36.438767",
                        "name": "PolkaPets Base Set",
                        "nft_version": null,
                        "opensea_version": null,
                        "owner": 18561537,
                        "schema_name": "ERC1155",
                        "symbol": "PPBS",
                        "total_supply": null,
                        "description": "The Official PolkaPets Trading Card Game Collection",
                        "external_link": "https://www.bondly.finance/",
                        "image_url": "https://lh3.googleusercontent.com/1PD-sO-BokG4bezW7UrlhW8491Blxv6j5ia5ZmAFUWTqfxNNM4f7B9mWr7mh0SuehCHnIH8rvkIA4Ug-JdS7jLlc60weamJf3Ht8MQ=s120",
                        "default_to_fiat": false,
                        "dev_buyer_fee_basis_points": 0,
                        "dev_seller_fee_basis_points": 1000,
                        "only_proxied_transfers": false,
                        "opensea_buyer_fee_basis_points": 0,
                        "opensea_seller_fee_basis_points": 250,
                        "buyer_fee_basis_points": 0,
                        "seller_fee_basis_points": 1250,
                        "payout_address": "0xdf1dcf94d240798442a681f291321b63d1f0afa3"
                    },
                    "owner": {
                        "user": {
                            "username": "NullAddress"
                        },
                        "profile_img_url": "https://storage.googleapis.com/opensea-static/opensea-profile/1.png",
                        "address": "0x0000000000000000000000000000000000000000",
                        "config": "",
                        "discord_id": ""
                    },
                    "permalink": "https://opensea.io/assets/0x8cb813bf27dc744fc5fb6ba7515504de45d39e08/20",
                    "collection": {
                        "banner_image_url": null,
                        "chat_url": null,
                        "created_date": "2021-01-27T02:36:31.308470",
                        "default_to_fiat": false,
                        "description": "The Official PolkaPets Trading Card Game Collection",
                        "dev_buyer_fee_basis_points": "0",
                        "dev_seller_fee_basis_points": "1000",
                        "discord_url": null,
                        "display_data": {
                            "card_display_style": "contain"
                        },
                        "external_url": "https://www.bondly.finance/",
                        "featured": false,
                        "featured_image_url": null,
                        "hidden": false,
                        "safelist_request_status": "verified",
                        "image_url": "https://lh3.googleusercontent.com/1PD-sO-BokG4bezW7UrlhW8491Blxv6j5ia5ZmAFUWTqfxNNM4f7B9mWr7mh0SuehCHnIH8rvkIA4Ug-JdS7jLlc60weamJf3Ht8MQ=s120",
                        "is_subject_to_whitelist": false,
                        "large_image_url": "https://lh3.googleusercontent.com/1PD-sO-BokG4bezW7UrlhW8491Blxv6j5ia5ZmAFUWTqfxNNM4f7B9mWr7mh0SuehCHnIH8rvkIA4Ug-JdS7jLlc60weamJf3Ht8MQ",
                        "medium_username": null,
                        "name": "PolkaPets TCG",
                        "only_proxied_transfers": false,
                        "opensea_buyer_fee_basis_points": "0",
                        "opensea_seller_fee_basis_points": "250",
                        "payout_address": "0xdf1dcf94d240798442a681f291321b63d1f0afa3",
                        "require_email": false,
                        "short_description": null,
                        "slug": "polkapets",
                        "telegram_url": null,
                        "twitter_username": "polkapets",
                        "instagram_username": null,
                        "wiki_url": null
                    },
                    "decimals": null,
                    "token_metadata": "https://api.ppw.digital/api/item/20"
                },
                {
                    "id": 21027392,
                    "token_id": "21",
                    "num_sales": 81,
                    "background_color": null,
                    "image_url": "https://lh3.googleusercontent.com/b0iYpuWbdZ_GQ3QK2OgaWjmJrNTnMhaoGGXk6tv1Xrvmx-_5FrRgvxRAfJiV9N5ljhykTmWhMAKV8EjedoiE6LSlRt_cekDR4QlpoA",
                    "image_preview_url": "https://lh3.googleusercontent.com/b0iYpuWbdZ_GQ3QK2OgaWjmJrNTnMhaoGGXk6tv1Xrvmx-_5FrRgvxRAfJiV9N5ljhykTmWhMAKV8EjedoiE6LSlRt_cekDR4QlpoA=s250",
                    "image_thumbnail_url": "https://lh3.googleusercontent.com/b0iYpuWbdZ_GQ3QK2OgaWjmJrNTnMhaoGGXk6tv1Xrvmx-_5FrRgvxRAfJiV9N5ljhykTmWhMAKV8EjedoiE6LSlRt_cekDR4QlpoA=s128",
                    "image_original_url": "https://api.ppw.digital/images/Riodefi.png",
                    "animation_url": null,
                    "animation_original_url": null,
                    "name": "RioDeFi (Liquidity Blast)",
                    "description": "Personality:\n\nRio is a fabled PolkaPet that is actually quite intelligent. Rio loves to interact with it's environment and other PolkaPets because the ecosystem is important to them. It can leverage its skills to provide liquidity to the people and PolkaPets in need.\n\nAbility Desc:\n\nA concentrated water bomb is released in a flower-like explosion.\n\nUtility:\n\nLottery Entry for select future RioDeFi NFTs to be airdropped to holders;\n\nLottery entry for 10 extra RioDeFi PolkaPets Cards to be Airdropped to 10 Holders (1 each);\n\nLottery Entry for 100,000 RFUEL to be airdropped to 10 holders (10,000 RFUEL each);\n\nAccess to VIP benefits, Telegram group, and behind-the-scenes sneak peeks of upcoming milestones;\n\nAccess to PolkaPets world, the world’s first blockchain-based, collectible monsters game!",
                    "external_link": "https://www.bondly.finance/",
                    "asset_contract": {
                        "address": "0x8cb813bf27dc744fc5fb6ba7515504de45d39e08",
                        "asset_contract_type": "semi-fungible",
                        "created_date": "2021-04-01T19:39:36.438767",
                        "name": "PolkaPets Base Set",
                        "nft_version": null,
                        "opensea_version": null,
                        "owner": 18561537,
                        "schema_name": "ERC1155",
                        "symbol": "PPBS",
                        "total_supply": null,
                        "description": "The Official PolkaPets Trading Card Game Collection",
                        "external_link": "https://www.bondly.finance/",
                        "image_url": "https://lh3.googleusercontent.com/1PD-sO-BokG4bezW7UrlhW8491Blxv6j5ia5ZmAFUWTqfxNNM4f7B9mWr7mh0SuehCHnIH8rvkIA4Ug-JdS7jLlc60weamJf3Ht8MQ=s120",
                        "default_to_fiat": false,
                        "dev_buyer_fee_basis_points": 0,
                        "dev_seller_fee_basis_points": 1000,
                        "only_proxied_transfers": false,
                        "opensea_buyer_fee_basis_points": 0,
                        "opensea_seller_fee_basis_points": 250,
                        "buyer_fee_basis_points": 0,
                        "seller_fee_basis_points": 1250,
                        "payout_address": "0xdf1dcf94d240798442a681f291321b63d1f0afa3"
                    },
                    "owner": {
                        "user": {
                            "username": "NullAddress"
                        },
                        "profile_img_url": "https://storage.googleapis.com/opensea-static/opensea-profile/1.png",
                        "address": "0x0000000000000000000000000000000000000000",
                        "config": "",
                        "discord_id": ""
                    },
                    "permalink": "https://opensea.io/assets/0x8cb813bf27dc744fc5fb6ba7515504de45d39e08/21",
                    "collection": {
                        "banner_image_url": null,
                        "chat_url": null,
                        "created_date": "2021-01-27T02:36:31.308470",
                        "default_to_fiat": false,
                        "description": "The Official PolkaPets Trading Card Game Collection",
                        "dev_buyer_fee_basis_points": "0",
                        "dev_seller_fee_basis_points": "1000",
                        "discord_url": null,
                        "display_data": {
                            "card_display_style": "contain"
                        },
                        "external_url": "https://www.bondly.finance/",
                        "featured": false,
                        "featured_image_url": null,
                        "hidden": false,
                        "safelist_request_status": "verified",
                        "image_url": "https://lh3.googleusercontent.com/1PD-sO-BokG4bezW7UrlhW8491Blxv6j5ia5ZmAFUWTqfxNNM4f7B9mWr7mh0SuehCHnIH8rvkIA4Ug-JdS7jLlc60weamJf3Ht8MQ=s120",
                        "is_subject_to_whitelist": false,
                        "large_image_url": "https://lh3.googleusercontent.com/1PD-sO-BokG4bezW7UrlhW8491Blxv6j5ia5ZmAFUWTqfxNNM4f7B9mWr7mh0SuehCHnIH8rvkIA4Ug-JdS7jLlc60weamJf3Ht8MQ",
                        "medium_username": null,
                        "name": "PolkaPets TCG",
                        "only_proxied_transfers": false,
                        "opensea_buyer_fee_basis_points": "0",
                        "opensea_seller_fee_basis_points": "250",
                        "payout_address": "0xdf1dcf94d240798442a681f291321b63d1f0afa3",
                        "require_email": false,
                        "short_description": null,
                        "slug": "polkapets",
                        "telegram_url": null,
                        "twitter_username": "polkapets",
                        "instagram_username": null,
                        "wiki_url": null
                    },
                    "decimals": null,
                    "token_metadata": "https://api.ppw.digital/api/item/21"
                },
                {
                    "id": 21027395,
                    "token_id": "23",
                    "num_sales": 151,
                    "background_color": null,
                    "image_url": "https://lh3.googleusercontent.com/M-bJCdKNcjA5CWifH98FBF1lPfp1DOVDNBIpKgl5TNfUuwQGHTRyU4z7Gr9C5URlpXBk0gnkYEhVJph3lWAC_aOQUxT41ajHWScDbQM",
                    "image_preview_url": "https://lh3.googleusercontent.com/M-bJCdKNcjA5CWifH98FBF1lPfp1DOVDNBIpKgl5TNfUuwQGHTRyU4z7Gr9C5URlpXBk0gnkYEhVJph3lWAC_aOQUxT41ajHWScDbQM=s250",
                    "image_thumbnail_url": "https://lh3.googleusercontent.com/M-bJCdKNcjA5CWifH98FBF1lPfp1DOVDNBIpKgl5TNfUuwQGHTRyU4z7Gr9C5URlpXBk0gnkYEhVJph3lWAC_aOQUxT41ajHWScDbQM=s128",
                    "image_original_url": "https://api.ppw.digital/images/Ankr.png",
                    "animation_url": null,
                    "animation_original_url": null,
                    "name": "ANKR (Hydro-sting)",
                    "description": "Personality:\n\nDespite ANKR’s lavish design, it is actually the smallest known PolkaPet. In certain lights ANKR’s body will look like a sea of stars. Little is known about this exotic pet since it resides in the deepest parts of the ocean. They do not bode well outside of a watery habitat.\n\nAbility Desc:\n\nBends water into a dagger-like shape that is aimed at it’s opponent.\n\nUtility:\n\nEnter raffle to win Clubhouse AMA with the Ankr leadership team\n\nFuture airdrops/rewards/giveaways from Ankr\n\nRewards will be announced sporadically\n\nAccess to rewards and incentives from Ankr’s strategic partners\n\nExclusive access to Ankr stealth projects",
                    "external_link": "https://www.bondly.finance/",
                    "asset_contract": {
                        "address": "0x8cb813bf27dc744fc5fb6ba7515504de45d39e08",
                        "asset_contract_type": "semi-fungible",
                        "created_date": "2021-04-01T19:39:36.438767",
                        "name": "PolkaPets Base Set",
                        "nft_version": null,
                        "opensea_version": null,
                        "owner": 18561537,
                        "schema_name": "ERC1155",
                        "symbol": "PPBS",
                        "total_supply": null,
                        "description": "The Official PolkaPets Trading Card Game Collection",
                        "external_link": "https://www.bondly.finance/",
                        "image_url": "https://lh3.googleusercontent.com/1PD-sO-BokG4bezW7UrlhW8491Blxv6j5ia5ZmAFUWTqfxNNM4f7B9mWr7mh0SuehCHnIH8rvkIA4Ug-JdS7jLlc60weamJf3Ht8MQ=s120",
                        "default_to_fiat": false,
                        "dev_buyer_fee_basis_points": 0,
                        "dev_seller_fee_basis_points": 1000,
                        "only_proxied_transfers": false,
                        "opensea_buyer_fee_basis_points": 0,
                        "opensea_seller_fee_basis_points": 250,
                        "buyer_fee_basis_points": 0,
                        "seller_fee_basis_points": 1250,
                        "payout_address": "0xdf1dcf94d240798442a681f291321b63d1f0afa3"
                    },
                    "owner": {
                        "user": {
                            "username": "NullAddress"
                        },
                        "profile_img_url": "https://storage.googleapis.com/opensea-static/opensea-profile/1.png",
                        "address": "0x0000000000000000000000000000000000000000",
                        "config": "",
                        "discord_id": ""
                    },
                    "permalink": "https://opensea.io/assets/0x8cb813bf27dc744fc5fb6ba7515504de45d39e08/23",
                    "collection": {
                        "banner_image_url": null,
                        "chat_url": null,
                        "created_date": "2021-01-27T02:36:31.308470",
                        "default_to_fiat": false,
                        "description": "The Official PolkaPets Trading Card Game Collection",
                        "dev_buyer_fee_basis_points": "0",
                        "dev_seller_fee_basis_points": "1000",
                        "discord_url": null,
                        "display_data": {
                            "card_display_style": "contain"
                        },
                        "external_url": "https://www.bondly.finance/",
                        "featured": false,
                        "featured_image_url": null,
                        "hidden": false,
                        "safelist_request_status": "verified",
                        "image_url": "https://lh3.googleusercontent.com/1PD-sO-BokG4bezW7UrlhW8491Blxv6j5ia5ZmAFUWTqfxNNM4f7B9mWr7mh0SuehCHnIH8rvkIA4Ug-JdS7jLlc60weamJf3Ht8MQ=s120",
                        "is_subject_to_whitelist": false,
                        "large_image_url": "https://lh3.googleusercontent.com/1PD-sO-BokG4bezW7UrlhW8491Blxv6j5ia5ZmAFUWTqfxNNM4f7B9mWr7mh0SuehCHnIH8rvkIA4Ug-JdS7jLlc60weamJf3Ht8MQ",
                        "medium_username": null,
                        "name": "PolkaPets TCG",
                        "only_proxied_transfers": false,
                        "opensea_buyer_fee_basis_points": "0",
                        "opensea_seller_fee_basis_points": "250",
                        "payout_address": "0xdf1dcf94d240798442a681f291321b63d1f0afa3",
                        "require_email": false,
                        "short_description": null,
                        "slug": "polkapets",
                        "telegram_url": null,
                        "twitter_username": "polkapets",
                        "instagram_username": null,
                        "wiki_url": null
                    },
                    "decimals": null,
                    "token_metadata": "https://api.ppw.digital/api/item/23"
                },
                {
                    "id": 21027398,
                    "token_id": "25",
                    "num_sales": 294,
                    "background_color": null,
                    "image_url": "https://lh3.googleusercontent.com/JRd3dADSdqGQKXKgXCBvAm_KiHA0gsfti5GUlPCr1nFTrG_9ItC-oN_xAU2m4yW0-7DFiCHdXg_XvOOigdpfUifvzMVaSss_ATuJYg",
                    "image_preview_url": "https://lh3.googleusercontent.com/JRd3dADSdqGQKXKgXCBvAm_KiHA0gsfti5GUlPCr1nFTrG_9ItC-oN_xAU2m4yW0-7DFiCHdXg_XvOOigdpfUifvzMVaSss_ATuJYg=s250",
                    "image_thumbnail_url": "https://lh3.googleusercontent.com/JRd3dADSdqGQKXKgXCBvAm_KiHA0gsfti5GUlPCr1nFTrG_9ItC-oN_xAU2m4yW0-7DFiCHdXg_XvOOigdpfUifvzMVaSss_ATuJYg=s128",
                    "image_original_url": "https://api.ppw.digital/images/Kusama.png",
                    "animation_url": null,
                    "animation_original_url": null,
                    "name": "Kusama (Shadow Bend)",
                    "description": "Personality:\n\nKusama is extremely reliable and grounded. They are quite powerful and do not hesitate to attack when in danger. Cunning and quick, Kusama tends to fly a lot to familiarize themselves in a new area. They are reliable partners and have a strong foundation. Kusama is hard to spot because of their nature and carefulness. Although they are hard to spot, they have neon pink wings that give them away.  They do not bode well in places with a lot of light.\n\nAbility Desc:\n\nPolkaPet uses surrounding shadows to unleash a dark attack on its opponent.\n\nUtility:\n\nThe NFT badges of Kusama will be displayed across Litentry’s product to mark the owner of these Polkapets\n\nTotal of 800 LIT for rewards (1 LIT per wallet)\n\nUtility within Phala Network core product, pBridges.\n\nPriority access to the first batch of pBridges Phala Network ecosystem utility.\n\nYou'll be invited to first-round trials of many Phala-based products! These include Web3 Analytics, pDiem, pBTC/pDOGE/pBTG, Darkpool...\n\nEarly access to Phala product: beta users to provide early feedback\n\nA chance to win 1 of 100 BondSwap PolkaPet 1st Edition Cards",
                    "external_link": "https://www.bondly.finance/",
                    "asset_contract": {
                        "address": "0x8cb813bf27dc744fc5fb6ba7515504de45d39e08",
                        "asset_contract_type": "semi-fungible",
                        "created_date": "2021-04-01T19:39:36.438767",
                        "name": "PolkaPets Base Set",
                        "nft_version": null,
                        "opensea_version": null,
                        "owner": 18561537,
                        "schema_name": "ERC1155",
                        "symbol": "PPBS",
                        "total_supply": null,
                        "description": "The Official PolkaPets Trading Card Game Collection",
                        "external_link": "https://www.bondly.finance/",
                        "image_url": "https://lh3.googleusercontent.com/1PD-sO-BokG4bezW7UrlhW8491Blxv6j5ia5ZmAFUWTqfxNNM4f7B9mWr7mh0SuehCHnIH8rvkIA4Ug-JdS7jLlc60weamJf3Ht8MQ=s120",
                        "default_to_fiat": false,
                        "dev_buyer_fee_basis_points": 0,
                        "dev_seller_fee_basis_points": 1000,
                        "only_proxied_transfers": false,
                        "opensea_buyer_fee_basis_points": 0,
                        "opensea_seller_fee_basis_points": 250,
                        "buyer_fee_basis_points": 0,
                        "seller_fee_basis_points": 1250,
                        "payout_address": "0xdf1dcf94d240798442a681f291321b63d1f0afa3"
                    },
                    "owner": {
                        "user": {
                            "username": "NullAddress"
                        },
                        "profile_img_url": "https://storage.googleapis.com/opensea-static/opensea-profile/1.png",
                        "address": "0x0000000000000000000000000000000000000000",
                        "config": "",
                        "discord_id": ""
                    },
                    "permalink": "https://opensea.io/assets/0x8cb813bf27dc744fc5fb6ba7515504de45d39e08/25",
                    "collection": {
                        "banner_image_url": null,
                        "chat_url": null,
                        "created_date": "2021-01-27T02:36:31.308470",
                        "default_to_fiat": false,
                        "description": "The Official PolkaPets Trading Card Game Collection",
                        "dev_buyer_fee_basis_points": "0",
                        "dev_seller_fee_basis_points": "1000",
                        "discord_url": null,
                        "display_data": {
                            "card_display_style": "contain"
                        },
                        "external_url": "https://www.bondly.finance/",
                        "featured": false,
                        "featured_image_url": null,
                        "hidden": false,
                        "safelist_request_status": "verified",
                        "image_url": "https://lh3.googleusercontent.com/1PD-sO-BokG4bezW7UrlhW8491Blxv6j5ia5ZmAFUWTqfxNNM4f7B9mWr7mh0SuehCHnIH8rvkIA4Ug-JdS7jLlc60weamJf3Ht8MQ=s120",
                        "is_subject_to_whitelist": false,
                        "large_image_url": "https://lh3.googleusercontent.com/1PD-sO-BokG4bezW7UrlhW8491Blxv6j5ia5ZmAFUWTqfxNNM4f7B9mWr7mh0SuehCHnIH8rvkIA4Ug-JdS7jLlc60weamJf3Ht8MQ",
                        "medium_username": null,
                        "name": "PolkaPets TCG",
                        "only_proxied_transfers": false,
                        "opensea_buyer_fee_basis_points": "0",
                        "opensea_seller_fee_basis_points": "250",
                        "payout_address": "0xdf1dcf94d240798442a681f291321b63d1f0afa3",
                        "require_email": false,
                        "short_description": null,
                        "slug": "polkapets",
                        "telegram_url": null,
                        "twitter_username": "polkapets",
                        "instagram_username": null,
                        "wiki_url": null
                    },
                    "decimals": null,
                    "token_metadata": "https://api.ppw.digital/api/item/25"
                },
                {
                    "id": 21965755,
                    "token_id": "26",
                    "num_sales": 54,
                    "background_color": null,
                    "image_url": "https://lh3.googleusercontent.com/dlV3tZlBDMCOU0e32oyQCAEB5vCwRwtA7TGtp9Gf5eDaISw2N9svum8dT004S65D4dZ_Z9mRen0HUYWcoeoTJF2H0MlH3Xy3pwUeWG8",
                    "image_preview_url": "https://lh3.googleusercontent.com/dlV3tZlBDMCOU0e32oyQCAEB5vCwRwtA7TGtp9Gf5eDaISw2N9svum8dT004S65D4dZ_Z9mRen0HUYWcoeoTJF2H0MlH3Xy3pwUeWG8=s250",
                    "image_thumbnail_url": "https://lh3.googleusercontent.com/dlV3tZlBDMCOU0e32oyQCAEB5vCwRwtA7TGtp9Gf5eDaISw2N9svum8dT004S65D4dZ_Z9mRen0HUYWcoeoTJF2H0MlH3Xy3pwUeWG8=s128",
                    "image_original_url": "https://api.ppw.digital/images/Raze_Walk_in_Shadows_Card_Final_(1).png",
                    "animation_url": null,
                    "animation_original_url": null,
                    "name": "Raze (Walk in Shadows)",
                    "description": "Personality:\n\nRaze is a stealthy fox creature that has the ability to hide itself in a shadowy cloud. Raze loves to run through the dark forest floor and find small crawl spaces to hide itself in. Bold, cheeky, and humorous, Raze loves to joke around with other pets. They do not bode well in places that have wide spaces.\n\nAbility Desc:\n\nRaze can obfuscate itself in a shadowy cloud before unleashing a stealth attack onto its opponent.\n\nUtility:\n\nFuture Raze Program ticket/access\nUnique holding value\nPossible future airdrops/rewards\nThe ability to use the Raze NFT in Raze Network",
                    "external_link": "https://www.bondly.finance/",
                    "asset_contract": {
                        "address": "0x8cb813bf27dc744fc5fb6ba7515504de45d39e08",
                        "asset_contract_type": "semi-fungible",
                        "created_date": "2021-04-01T19:39:36.438767",
                        "name": "PolkaPets Base Set",
                        "nft_version": null,
                        "opensea_version": null,
                        "owner": 18561537,
                        "schema_name": "ERC1155",
                        "symbol": "PPBS",
                        "total_supply": null,
                        "description": "The Official PolkaPets Trading Card Game Collection",
                        "external_link": "https://www.bondly.finance/",
                        "image_url": "https://lh3.googleusercontent.com/1PD-sO-BokG4bezW7UrlhW8491Blxv6j5ia5ZmAFUWTqfxNNM4f7B9mWr7mh0SuehCHnIH8rvkIA4Ug-JdS7jLlc60weamJf3Ht8MQ=s120",
                        "default_to_fiat": false,
                        "dev_buyer_fee_basis_points": 0,
                        "dev_seller_fee_basis_points": 1000,
                        "only_proxied_transfers": false,
                        "opensea_buyer_fee_basis_points": 0,
                        "opensea_seller_fee_basis_points": 250,
                        "buyer_fee_basis_points": 0,
                        "seller_fee_basis_points": 1250,
                        "payout_address": "0xdf1dcf94d240798442a681f291321b63d1f0afa3"
                    },
                    "owner": {
                        "user": {
                            "username": "NullAddress"
                        },
                        "profile_img_url": "https://storage.googleapis.com/opensea-static/opensea-profile/1.png",
                        "address": "0x0000000000000000000000000000000000000000",
                        "config": "",
                        "discord_id": ""
                    },
                    "permalink": "https://opensea.io/assets/0x8cb813bf27dc744fc5fb6ba7515504de45d39e08/26",
                    "collection": {
                        "banner_image_url": null,
                        "chat_url": null,
                        "created_date": "2021-01-27T02:36:31.308470",
                        "default_to_fiat": false,
                        "description": "The Official PolkaPets Trading Card Game Collection",
                        "dev_buyer_fee_basis_points": "0",
                        "dev_seller_fee_basis_points": "1000",
                        "discord_url": null,
                        "display_data": {
                            "card_display_style": "contain"
                        },
                        "external_url": "https://www.bondly.finance/",
                        "featured": false,
                        "featured_image_url": null,
                        "hidden": false,
                        "safelist_request_status": "verified",
                        "image_url": "https://lh3.googleusercontent.com/1PD-sO-BokG4bezW7UrlhW8491Blxv6j5ia5ZmAFUWTqfxNNM4f7B9mWr7mh0SuehCHnIH8rvkIA4Ug-JdS7jLlc60weamJf3Ht8MQ=s120",
                        "is_subject_to_whitelist": false,
                        "large_image_url": "https://lh3.googleusercontent.com/1PD-sO-BokG4bezW7UrlhW8491Blxv6j5ia5ZmAFUWTqfxNNM4f7B9mWr7mh0SuehCHnIH8rvkIA4Ug-JdS7jLlc60weamJf3Ht8MQ",
                        "medium_username": null,
                        "name": "PolkaPets TCG",
                        "only_proxied_transfers": false,
                        "opensea_buyer_fee_basis_points": "0",
                        "opensea_seller_fee_basis_points": "250",
                        "payout_address": "0xdf1dcf94d240798442a681f291321b63d1f0afa3",
                        "require_email": false,
                        "short_description": null,
                        "slug": "polkapets",
                        "telegram_url": null,
                        "twitter_username": "polkapets",
                        "instagram_username": null,
                        "wiki_url": null
                    },
                    "decimals": null,
                    "token_metadata": "https://api.ppw.digital/api/item/26"
                },
                {
                    "id": 21965756,
                    "token_id": "27",
                    "num_sales": 48,
                    "background_color": null,
                    "image_url": "https://lh3.googleusercontent.com/JYM2bUHhqS6iqaqhMltlZa_JdKSAqxuO3Rx_z619BmOCTlvgq7LRZL9Hk8sSedtljI6OlZnTC1FlRhRCFZFAyjJpZiQOdezTT4NP2A",
                    "image_preview_url": "https://lh3.googleusercontent.com/JYM2bUHhqS6iqaqhMltlZa_JdKSAqxuO3Rx_z619BmOCTlvgq7LRZL9Hk8sSedtljI6OlZnTC1FlRhRCFZFAyjJpZiQOdezTT4NP2A=s250",
                    "image_thumbnail_url": "https://lh3.googleusercontent.com/JYM2bUHhqS6iqaqhMltlZa_JdKSAqxuO3Rx_z619BmOCTlvgq7LRZL9Hk8sSedtljI6OlZnTC1FlRhRCFZFAyjJpZiQOdezTT4NP2A=s128",
                    "image_original_url": "https://api.ppw.digital/images/Bifrost_1.png",
                    "animation_url": null,
                    "animation_original_url": null,
                    "name": "Bifrost (High Beam)",
                    "description": "Personality:\n\nBifrost is a powerful unicorn-like creature that has the ability to soar through the skies. Bifrost loves gazing at the starry nights and galloping through gray clouds. Independent, cool, and strong-willed, Bifrost can take on a lot of responsibilities at once. Bifrost also has an unbreakable horn that will allow it to pierce through any obstacles in its way. They do not bode well in places that are too bright.\n\nAbility Desc:\n\nThe opponent is hit with a powerful energy beam.\n\nUtility:\n\nBifrost NFT Airdrop: The prize pool is 2 vETH, the first 100 NFTs, and each NFT airdrops 0.02 vETH.\nNFT Airdrop Method: the first 100 sold NFT, each NFT can get 0.02 vETH airdrop bonus.\nAirdrop Claim: According to the NFT purchase details, Bifrost will directly airdrop the address of the first 100 NFTs after the event is over.\nAirdrop Issuing: after the end of the airdrop, the prize will be issued within 3 working days.\nBefore the Bifrost mainnet goes live, addresses holding a certain number of BNC vouchers will have the opportunity to receive Bifrost Polkapet NFT airdrop as soon as Ethereum connect with Polkadot.\nParticipation in Bifrost priority testing for various products.\nDevelopers with NFT can become Bifrost builders and get Bifrost technical guidance.",
                    "external_link": "https://www.bondly.finance/",
                    "asset_contract": {
                        "address": "0x8cb813bf27dc744fc5fb6ba7515504de45d39e08",
                        "asset_contract_type": "semi-fungible",
                        "created_date": "2021-04-01T19:39:36.438767",
                        "name": "PolkaPets Base Set",
                        "nft_version": null,
                        "opensea_version": null,
                        "owner": 18561537,
                        "schema_name": "ERC1155",
                        "symbol": "PPBS",
                        "total_supply": null,
                        "description": "The Official PolkaPets Trading Card Game Collection",
                        "external_link": "https://www.bondly.finance/",
                        "image_url": "https://lh3.googleusercontent.com/1PD-sO-BokG4bezW7UrlhW8491Blxv6j5ia5ZmAFUWTqfxNNM4f7B9mWr7mh0SuehCHnIH8rvkIA4Ug-JdS7jLlc60weamJf3Ht8MQ=s120",
                        "default_to_fiat": false,
                        "dev_buyer_fee_basis_points": 0,
                        "dev_seller_fee_basis_points": 1000,
                        "only_proxied_transfers": false,
                        "opensea_buyer_fee_basis_points": 0,
                        "opensea_seller_fee_basis_points": 250,
                        "buyer_fee_basis_points": 0,
                        "seller_fee_basis_points": 1250,
                        "payout_address": "0xdf1dcf94d240798442a681f291321b63d1f0afa3"
                    },
                    "owner": {
                        "user": {
                            "username": "NullAddress"
                        },
                        "profile_img_url": "https://storage.googleapis.com/opensea-static/opensea-profile/1.png",
                        "address": "0x0000000000000000000000000000000000000000",
                        "config": "",
                        "discord_id": ""
                    },
                    "permalink": "https://opensea.io/assets/0x8cb813bf27dc744fc5fb6ba7515504de45d39e08/27",
                    "collection": {
                        "banner_image_url": null,
                        "chat_url": null,
                        "created_date": "2021-01-27T02:36:31.308470",
                        "default_to_fiat": false,
                        "description": "The Official PolkaPets Trading Card Game Collection",
                        "dev_buyer_fee_basis_points": "0",
                        "dev_seller_fee_basis_points": "1000",
                        "discord_url": null,
                        "display_data": {
                            "card_display_style": "contain"
                        },
                        "external_url": "https://www.bondly.finance/",
                        "featured": false,
                        "featured_image_url": null,
                        "hidden": false,
                        "safelist_request_status": "verified",
                        "image_url": "https://lh3.googleusercontent.com/1PD-sO-BokG4bezW7UrlhW8491Blxv6j5ia5ZmAFUWTqfxNNM4f7B9mWr7mh0SuehCHnIH8rvkIA4Ug-JdS7jLlc60weamJf3Ht8MQ=s120",
                        "is_subject_to_whitelist": false,
                        "large_image_url": "https://lh3.googleusercontent.com/1PD-sO-BokG4bezW7UrlhW8491Blxv6j5ia5ZmAFUWTqfxNNM4f7B9mWr7mh0SuehCHnIH8rvkIA4Ug-JdS7jLlc60weamJf3Ht8MQ",
                        "medium_username": null,
                        "name": "PolkaPets TCG",
                        "only_proxied_transfers": false,
                        "opensea_buyer_fee_basis_points": "0",
                        "opensea_seller_fee_basis_points": "250",
                        "payout_address": "0xdf1dcf94d240798442a681f291321b63d1f0afa3",
                        "require_email": false,
                        "short_description": null,
                        "slug": "polkapets",
                        "telegram_url": null,
                        "twitter_username": "polkapets",
                        "instagram_username": null,
                        "wiki_url": null
                    },
                    "decimals": null,
                    "token_metadata": "https://api.ppw.digital/api/item/27"
                },
                {
                    "id": 21965759,
                    "token_id": "28",
                    "num_sales": 125,
                    "background_color": null,
                    "image_url": "https://lh3.googleusercontent.com/zAMHldW85UFFkEwkyaBdw4uZRLM7yMwvsizf1NCJ7iMYLjzYNZg7X-8HteobRak7aT4hc_gje23gqe9ptUZtitQHBKJXCuvTo_8w8w",
                    "image_preview_url": "https://lh3.googleusercontent.com/zAMHldW85UFFkEwkyaBdw4uZRLM7yMwvsizf1NCJ7iMYLjzYNZg7X-8HteobRak7aT4hc_gje23gqe9ptUZtitQHBKJXCuvTo_8w8w=s250",
                    "image_thumbnail_url": "https://lh3.googleusercontent.com/zAMHldW85UFFkEwkyaBdw4uZRLM7yMwvsizf1NCJ7iMYLjzYNZg7X-8HteobRak7aT4hc_gje23gqe9ptUZtitQHBKJXCuvTo_8w8w=s128",
                    "image_original_url": "https://api.ppw.digital/images/Polkadot_Synchronize_new.png",
                    "animation_url": null,
                    "animation_original_url": null,
                    "name": "Polkadot (Synchronises)",
                    "description": "Personality:\n\nPolkadot loves to scurry around the forest floor and climb up trees. It enjoys perching on branches and watching other PolkaPets interact. Bubbly, relaxed, and laid-back, Polkadot loves to take its time and appreciate their surrounding environment.\n\nAbility Desc:\n\nThis Polkapet becomes more powerful when working on a team with other Polkapets.\n\nUtility:\n\nThe NFT badges of Polkadot will be displayed across Litentry’s product to mark the owner of these Polkapets\nTotal of 800 LIT for rewards (1 LIT per wallet)\nUtility within Phala Network core product, pBridges.\nPriority access to the first batch of pBridges Phala Network ecosystem utility.\nYou’ll be invited to first-round trials of many Phala-based products! These include Web3 Analytics, pDiem, pBTC/pDOGE/pBTG, Darkpool…\nEarly access to Phala product: beta users to provide early feedback \nA chance to win 1 of 100 BondProtect PolkaPet 1st Edition Cards",
                    "external_link": "https://www.bondly.finance/",
                    "asset_contract": {
                        "address": "0x8cb813bf27dc744fc5fb6ba7515504de45d39e08",
                        "asset_contract_type": "semi-fungible",
                        "created_date": "2021-04-01T19:39:36.438767",
                        "name": "PolkaPets Base Set",
                        "nft_version": null,
                        "opensea_version": null,
                        "owner": 18561537,
                        "schema_name": "ERC1155",
                        "symbol": "PPBS",
                        "total_supply": null,
                        "description": "The Official PolkaPets Trading Card Game Collection",
                        "external_link": "https://www.bondly.finance/",
                        "image_url": "https://lh3.googleusercontent.com/1PD-sO-BokG4bezW7UrlhW8491Blxv6j5ia5ZmAFUWTqfxNNM4f7B9mWr7mh0SuehCHnIH8rvkIA4Ug-JdS7jLlc60weamJf3Ht8MQ=s120",
                        "default_to_fiat": false,
                        "dev_buyer_fee_basis_points": 0,
                        "dev_seller_fee_basis_points": 1000,
                        "only_proxied_transfers": false,
                        "opensea_buyer_fee_basis_points": 0,
                        "opensea_seller_fee_basis_points": 250,
                        "buyer_fee_basis_points": 0,
                        "seller_fee_basis_points": 1250,
                        "payout_address": "0xdf1dcf94d240798442a681f291321b63d1f0afa3"
                    },
                    "owner": {
                        "user": {
                            "username": "NullAddress"
                        },
                        "profile_img_url": "https://storage.googleapis.com/opensea-static/opensea-profile/1.png",
                        "address": "0x0000000000000000000000000000000000000000",
                        "config": "",
                        "discord_id": ""
                    },
                    "permalink": "https://opensea.io/assets/0x8cb813bf27dc744fc5fb6ba7515504de45d39e08/28",
                    "collection": {
                        "banner_image_url": null,
                        "chat_url": null,
                        "created_date": "2021-01-27T02:36:31.308470",
                        "default_to_fiat": false,
                        "description": "The Official PolkaPets Trading Card Game Collection",
                        "dev_buyer_fee_basis_points": "0",
                        "dev_seller_fee_basis_points": "1000",
                        "discord_url": null,
                        "display_data": {
                            "card_display_style": "contain"
                        },
                        "external_url": "https://www.bondly.finance/",
                        "featured": false,
                        "featured_image_url": null,
                        "hidden": false,
                        "safelist_request_status": "verified",
                        "image_url": "https://lh3.googleusercontent.com/1PD-sO-BokG4bezW7UrlhW8491Blxv6j5ia5ZmAFUWTqfxNNM4f7B9mWr7mh0SuehCHnIH8rvkIA4Ug-JdS7jLlc60weamJf3Ht8MQ=s120",
                        "is_subject_to_whitelist": false,
                        "large_image_url": "https://lh3.googleusercontent.com/1PD-sO-BokG4bezW7UrlhW8491Blxv6j5ia5ZmAFUWTqfxNNM4f7B9mWr7mh0SuehCHnIH8rvkIA4Ug-JdS7jLlc60weamJf3Ht8MQ",
                        "medium_username": null,
                        "name": "PolkaPets TCG",
                        "only_proxied_transfers": false,
                        "opensea_buyer_fee_basis_points": "0",
                        "opensea_seller_fee_basis_points": "250",
                        "payout_address": "0xdf1dcf94d240798442a681f291321b63d1f0afa3",
                        "require_email": false,
                        "short_description": null,
                        "slug": "polkapets",
                        "telegram_url": null,
                        "twitter_username": "polkapets",
                        "instagram_username": null,
                        "wiki_url": null
                    },
                    "decimals": null,
                    "token_metadata": "https://api.ppw.digital/api/item/28"
                }
            ],
            "name": "Polkapets",
            "description": "First edition pets !! On the polkadot ecosystem",
            "external_link": "",
            "asset_contract": null,
            "permalink": "https://opensea.io/bundles/polkapets-BdW",
            "sell_orders": [
                {
                    "created_date": "2021-05-25T20:15:59.269270",
                    "closing_date": "2021-05-28T20:15:43",
                    "closing_extendable": false,
                    "expiration_time": 1622232943,
                    "listing_time": 1621973652,
                    "order_hash": "0x8a09de876ba1a00388e7284406b6b91996b1e98bebe73fbaa8cc754b31ce5f78",
                    "metadata": {
                        "bundle": {
                            "assets": [
                                {
                                    "id": "9",
                                    "address": "0x1f42f3e36f8c61fcbef35e0cfb88bdf9392856ed",
                                    "quantity": "1"
                                },
                                {
                                    "id": "1",
                                    "address": "0x8cb813bf27dc744fc5fb6ba7515504de45d39e08",
                                    "quantity": "1"
                                },
                                {
                                    "id": "10",
                                    "address": "0x8cb813bf27dc744fc5fb6ba7515504de45d39e08",
                                    "quantity": "1"
                                },
                                {
                                    "id": "13",
                                    "address": "0x8cb813bf27dc744fc5fb6ba7515504de45d39e08",
                                    "quantity": "1"
                                },
                                {
                                    "id": "15",
                                    "address": "0x8cb813bf27dc744fc5fb6ba7515504de45d39e08",
                                    "quantity": "1"
                                },
                                {
                                    "id": "16",
                                    "address": "0x8cb813bf27dc744fc5fb6ba7515504de45d39e08",
                                    "quantity": "1"
                                },
                                {
                                    "id": "17",
                                    "address": "0x8cb813bf27dc744fc5fb6ba7515504de45d39e08",
                                    "quantity": "1"
                                },
                                {
                                    "id": "18",
                                    "address": "0x8cb813bf27dc744fc5fb6ba7515504de45d39e08",
                                    "quantity": "1"
                                },
                                {
                                    "id": "2",
                                    "address": "0x8cb813bf27dc744fc5fb6ba7515504de45d39e08",
                                    "quantity": "1"
                                },
                                {
                                    "id": "20",
                                    "address": "0x8cb813bf27dc744fc5fb6ba7515504de45d39e08",
                                    "quantity": "1"
                                },
                                {
                                    "id": "21",
                                    "address": "0x8cb813bf27dc744fc5fb6ba7515504de45d39e08",
                                    "quantity": "1"
                                },
                                {
                                    "id": "23",
                                    "address": "0x8cb813bf27dc744fc5fb6ba7515504de45d39e08",
                                    "quantity": "1"
                                },
                                {
                                    "id": "25",
                                    "address": "0x8cb813bf27dc744fc5fb6ba7515504de45d39e08",
                                    "quantity": "1"
                                },
                                {
                                    "id": "26",
                                    "address": "0x8cb813bf27dc744fc5fb6ba7515504de45d39e08",
                                    "quantity": "1"
                                },
                                {
                                    "id": "27",
                                    "address": "0x8cb813bf27dc744fc5fb6ba7515504de45d39e08",
                                    "quantity": "1"
                                },
                                {
                                    "id": "28",
                                    "address": "0x8cb813bf27dc744fc5fb6ba7515504de45d39e08",
                                    "quantity": "1"
                                },
                                {
                                    "id": "3",
                                    "address": "0x8cb813bf27dc744fc5fb6ba7515504de45d39e08",
                                    "quantity": "1"
                                },
                                {
                                    "id": "4",
                                    "address": "0x8cb813bf27dc744fc5fb6ba7515504de45d39e08",
                                    "quantity": "1"
                                },
                                {
                                    "id": "5",
                                    "address": "0x8cb813bf27dc744fc5fb6ba7515504de45d39e08",
                                    "quantity": "1"
                                },
                                {
                                    "id": "6",
                                    "address": "0x8cb813bf27dc744fc5fb6ba7515504de45d39e08",
                                    "quantity": "1"
                                }
                            ],
                            "schemas": [
                                "ERC1155",
                                "ERC1155",
                                "ERC1155",
                                "ERC1155",
                                "ERC1155",
                                "ERC1155",
                                "ERC1155",
                                "ERC1155",
                                "ERC1155",
                                "ERC1155",
                                "ERC1155",
                                "ERC1155",
                                "ERC1155",
                                "ERC1155",
                                "ERC1155",
                                "ERC1155",
                                "ERC1155",
                                "ERC1155",
                                "ERC1155",
                                "ERC1155"
                            ],
                            "name": "Polkapets",
                            "description": "First edition pets !! On the polkadot ecosystem",
                            "external_link": ""
                        }
                    },
                    "exchange": "0x7be8076f4ea4a4ad08075c2508e481d6c946d12b",
                    "maker": {
                        "user": 318343,
                        "profile_img_url": "https://storage.googleapis.com/opensea-static/opensea-profile/18.png",
                        "address": "0xfb59814d60f68d4dd9a502e40267a814e8d33932",
                        "config": "",
                        "discord_id": ""
                    },
                    "taker": {
                        "user": 1766,
                        "profile_img_url": "https://storage.googleapis.com/opensea-static/opensea-profile/1.png",
                        "address": "0x0000000000000000000000000000000000000000",
                        "config": "",
                        "discord_id": ""
                    },
                    "current_price": "4979103933065576488.000000000",
                    "current_bounty": "49791039329133989",
                    "bounty_multiple": "0.01",
                    "maker_relayer_fee": "250",
                    "taker_relayer_fee": "0",
                    "maker_protocol_fee": "0",
                    "taker_protocol_fee": "0",
                    "maker_referrer_fee": "0",
                    "fee_recipient": {
                        "user": 3585,
                        "profile_img_url": "https://storage.googleapis.com/opensea-static/opensea-profile/28.png",
                        "address": "0x5b3256965e7c3cf26e11fcaf296dfc8807c01073",
                        "config": "verified",
                        "discord_id": ""
                    },
                    "fee_method": 1,
                    "side": 1,
                    "sale_kind": 1,
                    "target": "0xc99f70bfd82fb7c8f8191fdfbfb735606b15e5c5",
                    "how_to_call": 1,
                    "calldata": "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",
                    "replacement_pattern": "0x0000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000ffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffff0000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000ffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffff0000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000ffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffff0000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000ffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffff0000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000ffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffff0000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000ffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffff0000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000ffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffff0000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000ffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffff0000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000ffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffff0000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000ffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffff0000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000ffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffff0000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000ffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffff0000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000ffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffff0000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000ffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffff0000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000ffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffff0000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000ffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffff0000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000ffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffff0000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000ffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffff0000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000ffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffff0000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000ffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffff000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000",
                    "static_target": "0x0000000000000000000000000000000000000000",
                    "static_extradata": "0x",
                    "payment_token": "0x0000000000000000000000000000000000000000",
                    "payment_token_contract": {
                        "id": 1,
                        "symbol": "ETH",
                        "address": "0x0000000000000000000000000000000000000000",
                        "image_url": "https://storage.opensea.io/files/6f8e2979d428180222796ff4a33ab929.svg",
                        "name": "Ether",
                        "decimals": 18,
                        "eth_price": "1.000000000000000",
                        "usd_price": "2625.730000000000018000"
                    },
                    "base_price": "5000000000000000000",
                    "extra": "500000000000000000",
                    "quantity": "1",
                    "salt": "22537702446211681674341417378881305727868154604859625654306827594251015825528",
                    "v": 28,
                    "r": "0xd43bd62380441a318fdd68dcf61577d915d01822cef8833fe2fbd102d615a09b",
                    "s": "0x4bd8a74a801f903dee0a51a3ac9799e50ea8e58414f86d3a65fb6c7503ef2f55",
                    "approved_on_chain": false,
                    "cancelled": false,
                    "finalized": false,
                    "marked_invalid": false,
                    "prefixed_hash": "0xc67ce80ca3e39539d342413cb5807501d34b96ad455b0b27cc6fcbaf46fef955"
                }
            ]
        }
    ]
}